// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23F34E65%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23FFFFFF%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:; image/svg+xml,%3csvgxmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000%27%3e%3cpath d=%27M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M2 5l6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10l3 3l6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("fonts/icomoon.eot?ynntp9", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("fonts/icomoon.woff2?ynntp9", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("fonts/icomoon.ttf?ynntp9", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("fonts/icomoon.woff?ynntp9", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("fonts/icomoon.svg?ynntp9", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27%23343a40%27 stroke=%27none%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27%23343a40%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%270.2%27 d=%27M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 512 512%27%3e%3cpath fill=%27%23343a40%27 stroke=%27%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M223.7 130.8L149.1 7.77C147.1 2.949 141.9 0 136.3 0H16.03c-12.95 0-20.53 14.58-13.1 25.18l111.3 158.9C143.9 156.4 181.7 137.3 223.7 130.8zM256 160c-97.25 0-176 78.75-176 176S158.8 512 256 512s176-78.75 176-176S353.3 160 256 160zM348.5 317.3l-37.88 37l8.875 52.25c1.625 9.25-8.25 16.5-16.63 12l-46.88-24.62L209.1 418.5c-8.375 4.5-18.25-2.75-16.63-12l8.875-52.25l-37.88-37C156.6 310.6 160.5 299 169.9 297.6l52.38-7.625L245.7 242.5c2-4.25 6.125-6.375 10.25-6.375S264.2 238.3 266.2 242.5l23.5 47.5l52.38 7.625C351.6 299 355.4 310.6 348.5 317.3zM495.1 0H375.7c-5.621 0-10.83 2.949-13.72 7.77l-73.76 122.1c42 6.5 79.88 25.62 109.5 53.38l111.3-158.9C516.5 14.58 508.9 0 495.1 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27%23343a40%27 stroke=%27none%27 d=%27M3.5 12.5a.5.5 0 0 1-1 0V3.707L1.354 4.854a.5.5 0 1 1-.708-.708l2-1.999.007-.007a.498.498 0 0 1 .7.006l2 2a.5.5 0 1 1-.707.708L3.5 3.707V12.5zm3.5-9a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zM7.5 6a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zm0 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3zm0 3a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27%23343a40%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271%27 d=%27M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27white%27 stroke=%27white%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271%27 d=%27M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27m6 10 3 3 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%280, 0, 0, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23CAD4DB%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10l3 3l6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27%23F61C0D%27 stroke=%27%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.007 2.007 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.007 2.007 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31.4 31.4 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.007 2.007 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A99.788 99.788 0 0 1 7.858 2h.193zM6.4 5.209v4.818l4.157-2.408L6.4 5.209z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27%230077B5%27 stroke=%27%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27white%27%3e%3cpath d=%27M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27%27 stroke-linejoin=%27%27 stroke-width=%272%27 d=%27M6 10l3 3l6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27white%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%235cae48%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27white%27 stroke=%27%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27%23E57F8D%27 stroke=%27none%27 stroke-linecap=%27none%27 stroke-linejoin=%27none%27 stroke-width=%271%27 d=%27M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27%23E57F8D%27 stroke=%27none%27 stroke-linecap=%27none%27 stroke-linejoin=%27none%27 stroke-width=%271%27 d=%27M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27%23343a40%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27%27 stroke-width=%271%27 d=%27M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27%23343a40%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27%27 stroke-width=%271%27 d=%27M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27%2326A7DF%27 stroke=%27none%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M2 1a1 1 0 0 0-1 1v4.586a1 1 0 0 0 .293.707l7 7a1 1 0 0 0 1.414 0l4.586-4.586a1 1 0 0 0 0-1.414l-7-7A1 1 0 0 0 6.586 1zm4 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23F5AE18%27 stroke-linecap=%27%27 stroke-linejoin=%27%27 stroke-width=%271%27 d=%27M2.866 14.85c-.078.444.36.791.746.593l4.39-2.256 4.389 2.256c.386.198.824-.149.746-.592l-.83-4.73 3.522-3.356c.33-.314.16-.888-.282-.95l-4.898-.696L8.465.792a.513.513 0 0 0-.927 0L5.354 5.12l-4.898.696c-.441.062-.612.636-.283.95l3.523 3.356-.83 4.73zm4.905-2.767-3.686 1.894.694-3.957a.56.56 0 0 0-.163-.505L1.71 6.745l4.052-.576a.53.53 0 0 0 .393-.288L8 2.223l1.847 3.658a.53.53 0 0 0 .393.288l4.052.575-2.906 2.77a.56.56 0 0 0-.163.506l.694 3.957-3.686-1.894a.5.5 0 0 0-.461 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27black%27 stroke=%27black%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271%27 d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("../images/bg-chat-now.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_37___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27%23ffd21f%27 stroke=%27%23343a40%27 stroke-linecap=%27%27 stroke-linejoin=%27%27 stroke-width=%270%27 d=%27M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16M7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5m-2.715 5.933a.5.5 0 0 1-.183-.683A4.5 4.5 0 0 1 8 9.5a4.5 4.5 0 0 1 3.898 2.25.5.5 0 0 1-.866.5A3.5 3.5 0 0 0 8 10.5a3.5 3.5 0 0 0-3.032 1.75.5.5 0 0 1-.683.183M10 8c-.552 0-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5S10.552 8 10 8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_38___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27%23ae000b%27 stroke=%27%23343a40%27 stroke-linecap=%27%27 stroke-linejoin=%27%27 stroke-width=%270%27 d=%27M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16M7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5m-2.715 5.933a.5.5 0 0 1-.183-.683A4.5 4.5 0 0 1 8 9.5a4.5 4.5 0 0 1 3.898 2.25.5.5 0 0 1-.866.5A3.5 3.5 0 0 0 8 10.5a3.5 3.5 0 0 0-3.032 1.75.5.5 0 0 1-.683.183M10 8c-.552 0-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5S10.552 8 10 8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_39___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27%23ffd21f%27 stroke=%27%23343a40%27 stroke-linecap=%27%27 stroke-linejoin=%27%27 stroke-width=%270%27 d=%27M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16M7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5m-3 4a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5M10 8c-.552 0-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5S10.552 8 10 8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_40___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27%23f1a200%27 stroke=%27%23343a40%27 stroke-linecap=%27%27 stroke-linejoin=%27%27 stroke-width=%270%27 d=%27M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16M7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5m-3 4a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5M10 8c-.552 0-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5S10.552 8 10 8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_41___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27%23ffd21f%27 stroke=%27%23343a40%27 stroke-linecap=%27%27 stroke-linejoin=%27%27 stroke-width=%270%27 d=%27M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16M7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5M4.285 9.567a.5.5 0 0 1 .683.183A3.5 3.5 0 0 0 8 11.5a3.5 3.5 0 0 0 3.032-1.75.5.5 0 1 1 .866.5A4.5 4.5 0 0 1 8 12.5a4.5 4.5 0 0 1-3.898-2.25.5.5 0 0 1 .183-.683M10 8c-.552 0-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5S10.552 8 10 8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_42___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27%235bae47%27 stroke=%27%23343a40%27 stroke-linecap=%27%27 stroke-linejoin=%27%27 stroke-width=%270%27 d=%27M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16M7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5M4.285 9.567a.5.5 0 0 1 .683.183A3.5 3.5 0 0 0 8 11.5a3.5 3.5 0 0 0 3.032-1.75.5.5 0 1 1 .866.5A4.5 4.5 0 0 1 8 12.5a4.5 4.5 0 0 1-3.898-2.25.5.5 0 0 1 .183-.683M10 8c-.552 0-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5S10.552 8 10 8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_43___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27%23707070%27 stroke=%27%23707070%27 stroke-linecap=%27%27 stroke-linejoin=%27%27 stroke-width=%271%27 d=%27M2.866 14.85c-.078.444.36.791.746.593l4.39-2.256 4.389 2.256c.386.198.824-.149.746-.592l-.83-4.73 3.522-3.356c.33-.314.16-.888-.282-.95l-4.898-.696L8.465.792a.513.513 0 0 0-.927 0L5.354 5.12l-4.898.696c-.441.062-.612.636-.283.95l3.523 3.356-.83 4.73zm4.905-2.767-3.686 1.894.694-3.957a.56.56 0 0 0-.163-.505L1.71 6.745l4.052-.576a.53.53 0 0 0 .393-.288L8 2.223l1.847 3.658a.53.53 0 0 0 .393.288l4.052.575-2.906 2.77a.56.56 0 0 0-.163.506l.694 3.957-3.686-1.894a.5.5 0 0 0-.461 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_44___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27%23FFC107%27 stroke=%27%23FFC107%27 stroke-linecap=%27%27 stroke-linejoin=%27%27 stroke-width=%271%27 d=%27M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_45___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27%23707070%27 stroke=%27%23707070%27 stroke-linecap=%27%27 stroke-linejoin=%27%27 stroke-width=%270%27 d=%27M2.866 14.85c-.078.444.36.791.746.593l4.39-2.256 4.389 2.256c.386.198.824-.149.746-.592l-.83-4.73 3.522-3.356c.33-.314.16-.888-.282-.95l-4.898-.696L8.465.792a.513.513 0 0 0-.927 0L5.354 5.12l-4.898.696c-.441.062-.612.636-.283.95l3.523 3.356-.83 4.73zm4.905-2.767-3.686 1.894.694-3.957a.56.56 0 0 0-.163-.505L1.71 6.745l4.052-.576a.53.53 0 0 0 .393-.288L8 2.223l1.847 3.658a.53.53 0 0 0 .393.288l4.052.575-2.906 2.77a.56.56 0 0 0-.163.506l.694 3.957-3.686-1.894a.5.5 0 0 0-.461 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_46___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27%23FFC107%27 stroke=%27%23FFC107%27 stroke-linecap=%27%27 stroke-linejoin=%27%27 stroke-width=%270%27 d=%27M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Jost:ital,wght@0,100..900;1,100..900&family=Waterfall&display=swap&family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap&family=Arvo:ital,wght@0,400;0,700;1,400;1,700&family=Joan&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___, { hash: "#icomoon" });
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___);
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
var ___CSS_LOADER_URL_REPLACEMENT_39___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_38___);
var ___CSS_LOADER_URL_REPLACEMENT_40___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_39___);
var ___CSS_LOADER_URL_REPLACEMENT_41___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_40___);
var ___CSS_LOADER_URL_REPLACEMENT_42___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_41___);
var ___CSS_LOADER_URL_REPLACEMENT_43___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_42___);
var ___CSS_LOADER_URL_REPLACEMENT_44___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_43___);
var ___CSS_LOADER_URL_REPLACEMENT_45___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_44___);
var ___CSS_LOADER_URL_REPLACEMENT_46___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_45___);
var ___CSS_LOADER_URL_REPLACEMENT_47___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_46___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --bs-purple-rgb: 124, 58, 237;
}
* {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
    font-family: 'Jost', sans-serif;
}
body {
    background: #fff;
    overflow: visible !important;
    padding: 0 !important;
}
body.flex100vh,
body > div#root {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
}
body > div#root ~ .modal-backdrop{display: none !important;}
body {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    background: #f3f3f3;
}
.flex-1 {
    flex: 1 1;
}
a {
    color: #d42941;
}
a:hover {
    color: #bb1b32;
    text-decoration: none;
}
.font-12 {
    font-size: 12px !important;
}
.font-13 {
    font-size: 13px !important;
}
.font-14 {
    font-size: 14px !important;
}
.font-15 {
    font-size: 15px !important;
}
.font-16 {
    font-size: 16px !important;
}
.font-17 {
    font-size: 17px !important;
}
.font-18 {
    font-size: 18px !important;
}
.font-19 {
    font-size: 19px !important;
}
.font-20 {
    font-size: 20px !important;
}
.font-21 {
    font-size: 21px !important;
}
.font-22 {
    font-size: 22px !important;
}
.font-23 {
    font-size: 23px !important;
}
.font-24 {
    font-size: 24px !important;
}
.font-25 {
    font-size: 25px !important;
}
.font-26 {
    font-size: 26px !important;
}
.font-27 {
    font-size: 27px !important;
}
.font-28 {
    font-size: 28px !important;
}
.font-29 {
    font-size: 29px !important;
}
.font-30 {
    font-size: 30px !important;
}
.font-31 {
    font-size: 31px !important;
}
.font-32 {
    font-size: 32px !important;
}
.font-48 {
    font-size: 48px !important;
}
.font-700 {
    font-weight: 700 !important;
}
.font-600 {
    font-weight: 600 !important;
}
.font-500 {
    font-weight: 500 !important;
}
.font-400 {
    font-weight: 400 !important;
}
.font-300 {
    font-weight: 300 !important;
}
.f.input-otp.input-otpont-100 {
    font-weight: 100 !important;
}
.text-burgandi {
    color: #d42941;
}
.text-green {
    color: #5cae48;
}
.text-dark-blue {
    color: #0b3454;
}
.text-light-blue,
.text-sky-blue {
    color: #26a7df;
}
.text-purple {
    color: #51499c;
}
.text-gray-41 {
    color: #414141;
}
.text-gray-84 {
    color: #848484;
}
.text-gray-64 {
    color: #646464;
}
.text-gray-53 {
    color: #535353;
}
.text-gray-4b {
    color: #4b4b4b;
}
.text-orange {
    color: #F05A2A;
}
.line-height-24 {
    line-height: 24px;
}
.line-height-16 {
    line-height: 16px;
}
.line-height-13 {
    line-height: 13px;
}
.top-10 {
    top: 10px !important;
}
.top-20 {
    top: 20px !important;
}
.top-30 {
    top: 30px !important;
}
.top-40 {
    top: 40px !important;
}
.top-50 {
    top: 50px !important;
}
.bottom-10 {
    bottom: 10px !important;
}
.bottom-20 {
    bottom: 20px !important;
}
.bottom-30 {
    bottom: 30px !important;
}
.bottom-40 {
    bottom: 40px !important;
}
.bottom-50 {
    bottom: 50px !important;
}
.right-10 {
    right: 10px !important;
}
.right-20 {
    right: 20px !important;
}
.right-30 {
    right: 30px !important;
}
.right-40 {
    right: 40px !important;
}
.right-50 {
    right: 50px !important;
}
.max-1250 {
  max-width: 1250px;
  width: 90%;
}
.max-1170 {
    max-width: 1170px;
    width: 90%;
}
.max-1140 {
    max-width: 1140px;
    width: 94%;
}
.max-1040 {
    max-width: 1040px;
    width: 94%;
}
.max-1010 {
    max-width: 1010px;
    width: 94%;
}
.max-940 {
    max-width: 940px;
    width: 94%;
}
.max-900 {
    max-width: 900px;
    width: 90%;
}
.max-850 {
    max-width: 850px;
    width: 94%;
}
.max-740 {
    max-width: 740px;
    width: 90%;
}
.max-700 {
    max-width: 700px;
    width: 90%;
}
.max-650 {
    max-width: 650px;
    width: 90%;
}
.max-630 {
    max-width: 630px;
    width: 90%;
}
.max-620 {
    max-width: 620px;
    width: 90%;
}
.max-570 {
    max-width: 570px;
    width: 90%;
}
.max-540 {
    max-width: 540px;
    width: 90%;
}

.max-120 {
    max-width: 120px !important;
    width: 120px;
}
.max-150 {
    max-width: 150px !important;
    width: 150px;
}
.max-167 {
    max-width: 167px !important;
    width: 167px;
}
.max-170 {
    max-width: 170px !important;
    width: 170px;
}
.max-190 {
    max-width: 190px !important;
    width: 190px;
}
.max-200 {
    max-width: 200px !important;
    width: 100% !important;
}
.max-210 {
    max-width: 210px !important;
    width: 210px !important;
}
.max-240 {
    max-width: 240px !important;
    width: 100%;
}
.max-250 {
    max-width: 250px !important;
    width: 100%;
}
.max-300 {
    max-width: 300px !important;
    width: 100%;
}
.max-360 {
    max-width: 360px !important;
    width: 100%;
}
.max-420 {
    max-width: 420px !important;
    width: 90%;
}
.max-470 {
    max-width: 470px !important;
    width: 100%;
}
.max-100per {
    max-width: 100% !important;
    width: 100%;
}
.min-100per {
    min-width: 100% !important;
}
.max-80 {
    max-width: 100% !important;
    width: 80px;
}
.min-wauto {
    min-width: auto !important;
    width: auto;
}

/* login and signup css */
body .bg_side_blue {
    position: relative;
    flex: 1 1;
}
body .bg_side_blue::after {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    content: '';
    background: #0b3454;
    width: 32%;
}

@media (max-width: 767px) {
    body .bg_side_blue::after {
        width: 100%;
    }
}
body .bg_side_blue > .container {
    z-index: 1;
}
.custom_logo {
    padding: 40px 0 0;
}
.custom_logo .img-fluid {
    max-height: 100px;
    width: auto;
}
.leftPaneMain {
    width: 100%;
    flex: 1 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 50px 0;
}
.leftPaneMain h2 {
    font-size: 30px;
    line-height: 35px;
    max-width: 420px;
    text-align: center;
    font-weight: bold;
    margin: 0 0 20px;
}
.leftPaneMain .login_carousel {
    max-width: 460px;
    margin: 0 auto 30px;
    width: 90%;
}
.leftPaneMain .login_carousel .innercover .img img {
    max-width: 320px;
}
.leftPaneMain .login_carousel .innercover h3 {
    font-size: 30px;
    line-height: 35px;
    font-weight: bold;
}
.leftPaneMain .login_carousel .innercover p {
    font-size: 18px;
    line-height: 26px;
}
.leftPaneMain .login_carousel .owl-dots {
    display: flex;
    align-items: center;
    justify-content: center;
}
.leftPaneMain .login_carousel .owl-dots .owl-dot {
    background: #585858 !important;
    opacity: 0.2;
    width: 9px;
    height: 9px;
    margin: 0 4px;
    opacity: 0.2;
    filter: alpha(opacity=20);
    border-radius: 50%;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    -ms-border-radius: 50%;
    -o-border-radius: 50%;
}
.leftPaneMain .login_carousel .owl-dots .owl-dot.active {
    opacity: 0.8;
    filter: alpha(opacity=80);
}

.carousel-item figure {
    padding: 0px;
    margin: 0px 0 30px 0;
    height: 240px;
    display: flex;
    align-items: end;
}
.carousel-item figure img {
    max-width: 250px;
    width: 100%;
}
.carousel-item h4 {
    font-size: 30px;
    line-height: 35px;
    color: #000000;
    padding: 0px;
    margin: 0px auto 20px auto;
    font-weight: 600;
    max-width: unset;
}
.carousel-item p {
    font-size: 16px;
    line-height: 22px;
    color: #000000;
    padding: 0px;
    margin: 0px auto;
    max-width: 400px;
}

.leftPaneFooter {
    padding: 40px 0;
    width: 100%;
}
.leftPaneFooter .copyRight {
    font-size: 14px;
    font-weight: 500;
}
.leftPaneFooter .copyRight span {
    display: block;
    font-size: 13px;
    color: #060606;
    opacity: 0.6;
}
.leftPaneFooter .powerby {
    display: flex;
    flex-direction: column;
    max-width: 127px;
}
.leftPaneFooter .powerby span {
    font-size: 14px;
}
.btn-View-appeal {
    background: #d42941;
    border-radius: 35px;
    -webkit-border-radius: 35px;
    -moz-border-radius: 35px;
    -ms-border-radius: 35px;
    -o-border-radius: 35px;
    color: #fff;
    border: 0;
    height: 50px;
    padding: 5px !important;
    align-items: center;
    margin: 0 auto;
    display: flex;
    transition: all 0.3s ease-in-out;
}
.btn-View-appeal i {
    width: 40px;
    height: 40px;
    background: #fff;
    border-radius: 50%;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    -ms-border-radius: 50%;
    -o-border-radius: 50%;
    margin-right: 10px;
    position: relative;
    transition: all 0.3s ease-in-out;
}
.btn-View-appeal i::before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    margin: auto;
    width: 22px;
    height: 16px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/youtube.svg);
}
.btn-View-appeal span {
    font-size: 16px;
    font-weight: 500;
    margin-right: 20px;
}
.btn-View-appeal:hover {
    background: #e8354e;
}
.btn-View-appeal:hover i {
    background: #000;
}
.btn-View-appeal:hover i::before {
    filter: invert(1) brightness(1);
    -webkit-filter: invert(1) brightness(1);
}
.bg_side_blue .signup {
    flex-direction: column;
    padding-top: 40px;
    background: #0b3454;
    margin-right: -1px;
    display: flex;
    border-radius: 0 18px 18px 80px;
    -webkit-border-radius: 0 18px 18px 80px;
    -moz-border-radius: 0 18px 18px 80px;
    -ms-border-radius: 0 18px 18px 80px;
    -o-border-radius: 0 18px 18px 80px;
}
.bg_side_blue .signup h2 {
    color: #fff;
    font-size: 28px;
}
.bg_side_blue .signup h2:empty,
.bg_side_blue .signup h6:empty {
    display: none;
}
.bg_side_blue .signup > ul.nav {
    display: inline-flex !important;
    border-bottom: 0px solid #000;
    max-width: 496px;
    width: 90%;
    margin: 0 auto;
}
.bg_side_blue .signup > ul.nav li {
    flex: 2 1;
}
.bg_side_blue .signup > ul.nav li button {
    width: 100%;
    border: 0;
    border-radius: 0;
    line-height: 70px;
    padding: 0;
    font-size: 14px;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.5);
    border-bottom: 2px solid #375973;
    background: none !important;
    font-size: 16px !important;
    border-radius: 0;
    -webkit-border-radius: 0;
    -moz-border-radius: 0;
    -ms-border-radius: 0;
    -o-border-radius: 0;
}
.bg_side_blue .signup > ul.nav li button.active {
    color: #fff;
    border-color: #5cae48;
}
.bg_side_blue .signup > .tab-content {
    max-width: 496px;
    width: 90%;
    margin: 0 auto;
}
.bg_side_blue .signup .form-group {
    position: relative;
}
.bg_side_blue .signup .form-label {
    color: #fff;
    font-size: 16px;
}
.bg_side_blue .signup .form-group .viewpassword {
    position: absolute;
    right: 15px;
    bottom: auto;
    top: 14px;
    margin: auto;
    display: flex;
    justify-content: center;
    align-content: center;
    z-index: 2;
}
.bg_side_blue .signup .form-group .form-check-label {
    cursor: pointer;
}
.bg_side_blue .signup .form-group .form-check-label .icon-whatapp {
    width: 20px;
    height: 20px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/whatsapp.svg) no-repeat 0 0;
    display: inline-block;
    margin-right: 5px;
    margin-top: 3px;
}
.bg_side_blue .signup .form-check {
    position: relative;
}
.bg_side_blue .signup .form-check #agreeToUnivariety + .text-danger {
    position: absolute;
    top: calc(100% + 5px);
    left: 0;
}
.bg_side_blue .signup .form-check-label {
    color: #fff;
}
.bg_side_blue .signup .form-check-label[for*='provideUpdatesOnWhatsapp'] {
    display: inline-flex;
    align-content: center;
}
.bg_side_blue .signup .form-check-label[for*='provideUpdatesOnWhatsapp']:before {
    content: '';
    width: 20px;
    height: 20px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/whatsapp.svg) no-repeat 0 0;
    display: inline-block;
    margin: 0 5px 0 0;
}
#provideUpdatesOnWhatsapp {
    vertical-align: top;
    display: inline-block;
    position: static;
    order: -1;
}
.bg_side_blue .signup .email-text {
    color: #ffffff99;
}
.bg_side_blue .signup .btn-completed {
    background: #5cae48;
    color: #fff;
    border-color: #5cae48;
    max-width: 200px;
    width: 100%;
    border-radius: 25px;
    -webkit-border-radius: 25px;
    -moz-border-radius: 25px;
    -ms-border-radius: 25px;
    -o-border-radius: 25px;
}
.bg_side_blue .signup .btn-completed:hover {
    background: #88bb1b;
    color: #fff;
    border-color: #88bb1b;
}
.bg_side_blue .signup .btn-View-appeal {
    background: #fff;
    color: #d42941;
    line-height: 18px;
}
.bg_side_blue .signup .btn-View-appeal i {
    background: #d42941;
}
.bg_side_blue .signup .btn-View-appeal i::before {
    filter: invert(1);
    -webkit-filter: invert(1);
}
.bg_side_blue .signup .btn-View-appeal:hover {
    background: #5cae48;
    color: #fff;
}
.bg_side_blue .signup .btn-View-appeal:hover i {
    background: #fff;
}
.bg_side_blue .signup .btn-View-appeal:hover i::before {
    filter: invert(0);
    -webkit-filter: invert(0);
}
.bg_side_blue .signup .or {
    margin: 0 0 20px;
    text-align: center;
    display: inline-block;
    width: 100%;
    font-size: 18px;
    line-height: 22px;
    color: #fff;
    position: relative;
}
.bg_side_blue .signup .or::after {
    background: #38566e;
    width: 100%;
    height: 1px;
    position: absolute;
    bottom: 11px;
    margin: auto;
    content: '';
    left: 0;
    right: 0;
    max-width: 463px;
}
.bg_side_blue .signup .or b {
    font-weight: 400;
    background: #0b3454;
    position: relative;
    z-index: 2;
    padding: 0 10px;
}
.bg_side_blue .signup .sociallnks {
    text-align: center;
}
.bg_side_blue .signup .sociallnks p {
    font-size: 14px;
    line-height: 17px;
    color: #fff;
    font-family: 'Jost', sans-serif;
    margin: 0;
    font-weight: 400;
}
.bg_side_blue .signup .sociallnks p a {
    color: #a2e609;
    font-weight: 500;
}
.bg_side_blue .signup .sociallnks p a:hover {
    color: #5cae48 !important;
    transition: all 0.3s ease-in-out;
    text-decoration: none;
}
.bg_side_blue .signup .sociallnks ul {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    justify-content: center;
}
.bg_side_blue .signup .sociallnks ul li {
    width: 100px;
    margin: 20px 10px;
}
.bg_side_blue .signup .sociallnks ul li a {
    background: #ffffff;
    box-shadow: 0px 5px 10px #0000001a;
    width: 100%;
    display: flex;
    border-radius: 18px;
    -webkit-border-radius: 18px;
    -moz-border-radius: 18px;
    -ms-border-radius: 18px;
    -o-border-radius: 18px;
    height: 36px;
    justify-content: center;
    align-items: center;
}
.bg_side_blue .signup .leftPaneFooter {
    background: #fff;
    padding: 20px;
    width: auto;
    margin-right: calc(var(--bs-gutter-x) / -1.03);
    margin-left: calc(var(--bs-gutter-x) / -1.02);
}

.login_social_media .or {
    display: block;
    text-align: center;
    font-size: 18px;
    line-height: 24px;
    color: #ffffff;
    position: relative;
    padding-bottom: 4px;
    margin-bottom: 24px;
}
.login_social_media .or:after {
    width: 100%;
    height: 1px;
    background: #1e4d94;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    display: block;
    content: '';
}
.login_social_media .or em {
    font-style: normal;
    padding: 0 15px;
    background: #0d3453;
    font-size: 18px;
    line-height: 24px;
    color: #ffffff;
    position: relative;
    z-index: 99;
}
.login_social_media ul {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 0 20px 0;
    padding: 0px;
    list-style: none;
}
.login_social_media ul li {
    padding: 0 10px;
    width: 100%;
    max-width: 285px;
}
.login_social_media ul li a {
    width: 100%;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 3px;
    padding: 15px 30px;
    color: #fff;
    text-decoration: none;
    font-size: 18px;
    font-weight: 500;
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    -ms-border-radius: 3px;
    -o-border-radius: 3px;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.login_social_media ul li a img {
    filter: brightness(0) invert(1);
    -webkit-filter: brightness(0) invert(1);
}
.login_social_media ul li a.google {
    background-color: #cb4023;
}

.login_social_media ul li a.linkedin {
    background-color: #0077b7;
}

.login_social_media ul li a.keyCloak {
    background-color: #fff;
    color: #0077b7 !important;
}

.login_social_media ul li a.google:hover {
    background-color: #fff;
    color: #cb4023 !important;
}
.login_social_media ul li a.linkedin:hover {
    background-color: #fff;
    color: #0077b7 !important;
}
.login_social_media ul li a.keyCloak:hover {
    background-color: #0077b7;
    color: #fff !important;
}
.login_social_media ul li a:hover img {
    filter: none;
    -webkit-filter: none;
}
.login_social_media label {
    display: block;
    text-align: center;
    font-size: 14px;
    color: #ffffff;
    margin-bottom: 18px;
}
.login_social_media p {
    display: block;
    text-align: center;
    font-size: 14px;
    color: #ffffff;
    padding: 0px;
    margin: 0px;
}
.login_social_media p a {
    color: #a2e609;
}

.cursor-pointer {
    cursor: pointer;
}
.max-1300 {
    max-width: 1300px;
    width: 94%;
}

@media (max-width: 767px) {
    .bg_side_blue .signup {
        padding-top: 0px;
    }
    .bg_side_blue .signup .custom_logo {
        background: #fff;
        padding: 20px;
        margin-right: calc(var(--bs-gutter-x) / -1.03);
        margin-left: calc(var(--bs-gutter-x) / -1.02);
        margin-bottom: 40px;
    }
    .max-1300 {
        width: 100%;
    }
    .bg_side_blue .signup .leftPaneFooter {
        margin-top: auto;
    }
}

.landing_login_page .form-control {
    min-height: 40px;
    border: none;
    border-radius: 6px;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    -ms-border-radius: 6px;
    -o-border-radius: 6px;
    font-weight: 500;
    color: #000;
    font-size: 16px;
    z-index: 1;
    position: relative;
}
.input-otp {
    max-width: 60px;
    width: 100%;
    outline: none;
    box-shadow: none;
    height: 55px;
    border-radius: 6px;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    -ms-border-radius: 6px;
    -o-border-radius: 6px;
}
.password-toggle {
    right: 20px;
    width: 20px;
    cursor: pointer;
    float: right;
    margin: -34px 0 0;
    position: relative;
    z-index: 1;
}
.password-toggle img {
    width: 100%;
}
.landing_login_page #myloginTabContent > .bg {
    position: relative;
    margin-top: 30px;
}
.landing_login_page #myloginTabContent > .bg p {
    width: 100%;
    left: 0;
    right: 0;
    top: 0;
    padding: 10px;
    border-radius: 3px;
    text-align: center;
    font-size: 18px;
    color: #fff;
    font-weight: 500;
    max-width: 380px;
    margin: auto;
}
.landing_login_page #myloginTabContent > .bg.fail-message p {
    background: #e30000;
}
.landing_login_page #myloginTabContent > .bg.success-message p {
    background: #5cae48;
}
.btn-forgotpw {
    color: #fff;
}
.btn-forgotpw a {
    color: #fff;
}
.btn-relogin {
    color: #fff;
}
.form-pop-up {
    max-width: 280px;
}
.form-pop-up .icon {
    width: 70px;
    height: 70px;
    margin: auto auto 15px;
    display: inline-block;
    border-radius: 50%;
}
.form-pop-up h2 {
    font-size: 24px;
    font-weight: 500;
    margin: 0 0 7px;
}
.form-pop-up .icon.success {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/popup-checked.png) no-repeat 0 0 /
        100%;
}
.form-pop-up .icon.sorry {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/popup-cancel.png) no-repeat 0 0 /
        100%;
}
.success {
    color: #32ba7c;
}
.sorry {
    color: #e31e1e;
}
.form-pop-up p {
    margin-bottom: 30px;
}
.form-pop-up button {
    border: 0;
    border-radius: 25px;
    max-width: 120px;
    margin: auto;
    width: 100%;
    padding: 5px;
    text-transform: uppercase;
    font-weight: 500;
    font-size: 14px;
    height: 35px;
    color: #fff;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.form-pop-up button.btn-success {
    background: #32ba7c;
    color: #fff;
}
.form-pop-up button.btn-success:hover {
    background: #3a8c26;
}
.form-pop-up button.btn-sorry {
    background: #e31e1e;
    color: #fff;
}
.form-pop-up button.btn-sorry:hover {
    background: #ad0e0e;
}
/* login and signup css End */

/* Profile Registration Start */

.bg-skyblue-gradient,
.basic-information {
    background: #f3f9ff;
    background: linear-gradient(to bottom, #f3f9ff 0%, #f7fbff 44%, #f0f7ff 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f3f9ff', endColorstr='#f0f7ff',GradientType=0 );
}
.bg-beige-gradient,
.undergraduate-college {
    background: #fffbf2;
    background: linear-gradient(to bottom, #fffbf2 0%, #fef8ea 44%, #fef7e7 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#FFFBF2', endColorstr='#FEF7E7',GradientType=0 );
}
.bg-purple-gradient {
    background: transparent linear-gradient(144deg, #edebff 0%, #f6f5ff 100%) !important;
}
.bg-green-gradient {
    background: transparent linear-gradient(211deg, #fefffd 0%, #ebffe6 76%, #c6ebbe 100%) !important;
}
.bg-pink-gradient {
    background: transparent linear-gradient(145deg, #ffe8eb 0%, #fff8f9 100%) !important;
}
.rightPane.basic-information .rightPaneHeaderWrap {
    background: #f3f9ff;
}
.rightPane.undergraduate-college .rightPaneHeaderWrap {
    background: #fffbf2;
}
.rightPane.bg-purple-gradient .rightPaneHeaderWrap {
    background: #efedff;
}
.bg-green-gradient .rightPaneHeaderWrap {
    background: #f0ffec !important;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.bg-pink-gradient .rightPaneHeaderWrap {
    background: transparent !important;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.green_recom_bg {
    background: transparent linear-gradient(95deg, #5cae48 0%, #27a7df 100%) !important;
    right: 50px !important;
}
.bg_transparant {
    background: transparent !important;
}
.prize_bg {
    background: transparent linear-gradient(94deg, #51499c 0%, #d42941 100%) !important;
}
.laststep_bg {
    background: transparent linear-gradient(101deg, #51499c 0%, #27a7df 100%) !important;
}
.user_name span {
    font-weight: 600;
}
.main-wrap {
    flex: 1 1;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    background-color: #fff;
}
.main-wrap > .row {
    flex: 1 1;
}
.leftPane {
    width: 57.82%;
}
.leftPaneHeaderWrap {
    padding: 25px 0px;
    border-bottom: 1px solid #e2e8ef;
    display: flex;
    justify-content: end;
    position: sticky;
    top: 0;
    background: #fff;
    z-index: 3;
    height: 93px;
}
.leftPaneHeader {
    max-width: 900px;
    width: 96%;
}
.leftPaneHeader .user_name {
    display: none;
}
.leftPaneHeader img {
    height: 100%;
    width: auto;
}
.leftPaneBodyWrap {
    padding: 50px 0;
    display: flex;
    justify-content: end;
}
.leftPaneBody {
    padding: 0 100px;
    max-width: 890px;
    width: 100%;
}
.leftPaneWrap {
    height: 100%;
    display: flex;
    flex-direction: column;
}
.leftPaneWrap .leftPaneBodyWrap {
    flex: 1 1;
}
.leftPaneBody .qs_body {
    height: 100%;
    display: flex;
    flex-direction: column;
}
.leftPaneBody .qs_body .step {
    flex: 1 1;
}
.leftPaneBody .qs_body .steps {
    flex: 1 1;
}
.leftPaneBody .qs_body .form-check-inline {
    min-height: 45px;
    display: inline-flex;
    align-items: center;
    margin-top: 2px;
}
.leftPaneBody .qs_body legend ~ .form-check-inline {
    min-height: 0;
}
.leftPaneBody .qs_body .form-check-inline input {
    margin-right: 5px;
    width: 20px;
    height: 20px;
    transition: all 0.3s ease-in-out;
}
.leftPaneBody .qs_body .form-check-inline .form-check-label {
    margin-top: 2px;
}
.progress_svg {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 2;
    background: white;
    border-radius: 50%;
}
.global {
    position: absolute;
    background: white;
    border-radius: 50%;
    width: 100px;
    height: 100px;
    bottom: -50px;
    right: -50px;
}
.unlock {
    white-space: nowrap;
    display: flex;
    align-items: center;
    background: transparent linear-gradient(96deg, #f05a2a 0%, #f8b018 100%);
    border-radius: 30px 0px 0px 30px;
    height: 40px;
    right: 20px;
    position: absolute;
    bottom: 0;
    top: 0;
    margin: auto;
    z-index: 1;
    -webkit-border-radius: 30px 0px 0px 30px;
    -moz-border-radius: 30px 0px 0px 30px;
    -ms-border-radius: 30px 0px 0px 30px;
    -o-border-radius: 30px 0px 0px 30px;
    width: auto;
    transition: all 0.5s ease-in-out;
    opacity: 0;
    -webkit-transition: all 0.5s ease-in-out;
    -moz-transition: all 0.5s ease-in-out;
    -ms-transition: all 0.5s ease-in-out;
    -o-transition: all 0.5s ease-in-out;
}
.unlock_blue {
    background: transparent linear-gradient(95deg, #27a7df 0%, #51499c 100%) !important;
    border-radius: 30px 0px 0px 30px !important;
}
.unlock .img {
    margin: 0 10px 0 5px;
}
.unlock .img img {
    width: 30px;
    height: 30px;
}
.unlock.prize_bg .img,
.unlock.laststep_bg .img {
    display: flex;
    align-items: end;
    height: 100%;
}
.unlock.unlock_blue .img {
    margin: 0 5px 10px -3px;
}
.unlock.green_recom_bg .img {
    display: flex;
    align-items: end;
    height: 100%;
    padding: 0 0 5px 8px;
}
.unlock.prize_bg .img img {
    width: 62px;
    height: auto;
}
.unlock.laststep_bg .img img {
    width: 48px;
    height: auto;
}
.unlock.green_recom_bg .img img {
    width: 43px;
    height: auto;
}
.unlock.unlock_blue .img img {
    width: 57px;
    height: auto;
}
.unlock.prize_bg .img {
    display: flex;
    align-items: end;
    height: 100%;
}
.unlock.prize_bg .img img {
    width: 62px;
    height: auto;
}
.unlock .text {
    line-height: 18px;
    color: #fff;
    padding-right: 30px;
    font-size: 18px;
    font-weight: 400;
    width: 0;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.progress_svg span {
    position: absolute;
    left: auto;
    right: auto;
    top: 0;
    bottom: 0;
    margin: auto;
    font-size: 25px !important;
    font-weight: 600;
    color: #000 !important;
    line-height: 90px !important;
}
.progress_svg span::after {
    content: '%';
    font-size: 18px !important;
}
.progress_svg .gaugeMeter {
    width: 90px;
    height: 90px;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
}
.global.show .unlock .text {
    width: auto;
}
.global.show .unlock {
    right: 80px;
    opacity: 1;
}
.rightPane {
    width: 42.18%;
    display: flex;
    transition: all 0.5s ease-in-out;
    -webkit-transition: all 0.5s ease-in-out;
    -moz-transition: all 0.5s ease-in-out;
    -ms-transition: all 0.5s ease-in-out;
    -o-transition: all 0.5s ease-in-out;
}
.rightPaneWrap {
    flex: 1 1;
}
.rightPaneHeaderWrap {
    min-height: 93px;
    border-bottom: 1px solid #e4e8ef;
    display: flex;
    align-items: center;
    position: sticky;
    top: 0;
    z-index: 2;
    transition: all 0.5s ease-in-out;
    -webkit-transition: all 0.5s ease-in-out;
    -moz-transition: all 0.5s ease-in-out;
    -ms-transition: all 0.5s ease-in-out;
    -o-transition: all 0.5s ease-in-out;
}
.rightPaneHeader {
    max-width: 600px;
    width: 96%;
    display: flex;
    justify-content: end;
    align-items: center;
}
.rightPaneBodyWrap {
    padding: 50px 60px;
    display: flex;
    position: sticky;
    top: 93px;
}
.rightPaneBody {
    padding: 0;
    width: 100%;
    display: flex;
    justify-content: center;
}
.step {
    display: none;
    flex-direction: column;
}
.step .stepHeader {
    width: 100%;
    margin: 0;
    font-size: 22px;
    font-weight: 600;
    text-transform: uppercase;
    position: relative;
    padding: 0;
}
/* .step .stepHeader::before {content: '';position: absolute;left: 0;bottom: 0;width: 44px;height: 4px;background: #5cae48;border-radius: 5px;}*/
.step_img {
    margin: 0;
}
.step_img img {
    width: inherit;
}
.step p {
    width: 100%;
    margin: 0;
    font-size: 18px;
}
.listed_points {
    margin-top: 20px;
}
.step_header_wrap_link {
    display: none;
}
.listed_points ul {
    margin: 0;
    padding: 0;
    list-style: none;
}
.listed_points ul li {
    position: relative;
    margin-bottom: 15px;
    font-size: 20px;
    font-weight: 400;
    line-height: 22px;
    padding: 0 0 0 10px;
}
.listed_points ul li:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0px;
    width: 3px;
    height: 20px;
    background: #27a7df;
    border-radius: 15px;
}
.listed_points ul.beige-line li:before {
    background: #f8b018 !important;
}
.listed_points ul.purple-line li:before {
    background: #51499c !important;
}
.listed_points ul.orange-line li:before {
    background: #f05a2a !important;
}
.listed_points ul.green-line li:before {
    background: #5cae48 !important;
}
.listed_points ul.pink-line li:before {
    background: #ee4c61 !important;
}
.undergraduate-college .listed_points ul li::before {
    background: #f8b018;
}
.rightPane.basic-information .step_1 {
    display: flex;
}
.rightPane.undergraduate-college .step_2 {
    display: flex;
}
.steps {
    /*height: 0px;opacity: 0;overflow: hidden;*/
    transition: all 1s ease-in-out;
    -webkit-transition: all 1s ease-in-out;
    -moz-transition: all 1s ease-in-out;
    -ms-transition: all 1s ease-in-out;
    -o-transition: all 1s ease-in-out;
}
.steps.showTab {
    height: auto;
    opacity: 1;
}
.action_btns #viewcareersbtn {
    display: none;
}
.steps_questions {
    padding: 0 0 0 0px;
    margin-top: 0px; /* left: -50px; */
    position: relative; /* opacity: 0; */
    transition: all 1s ease-in-out;
    -webkit-transition: all 1s ease-in-out;
    -moz-transition: all 1s ease-in-out;
    -ms-transition: all 1s ease-in-out;
    -o-transition: all 1s ease-in-out;
    max-width: 640px;
}
.steps.showTab .steps_questions {
    /* left: 0px;opacity: 1; */
}
.steps_questions h2 {
    font-size: 22px;
    font-weight: 800; /* margin-left: 50px; */ /* opacity: 0; */
    transition: all 0.3s ease-in-out;
}
.steps.showTab h2 {
    margin-left: 0px;
    opacity: 1;
}
.steps_questions h2 span {
    position: relative;
}
.steps_questions h2 span:before {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 0;
    height: 2px;
    background: #5dae48;
    border-radius: 5px;
    transition: all 0.5s ease-in-out;
    -webkit-transition: all 0.5s ease-in-out;
    -moz-transition: all 0.5s ease-in-out;
    -ms-transition: all 0.5s ease-in-out;
    -o-transition: all 0.5s ease-in-out;
}
.steps_questions h2 span:before {
    width: 100%;
}
.steps_questions .form-control {
    margin-bottom: 0;
}
.steps.showTab h2 {
    opacity: 1;
    margin-left: 0;
}
.question_wrap {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
}
.question_number {
    margin-right: 10px;
    display: none;
}
.question_number span {
    width: 33px;
    height: 33px;
    border: 2px solid #dddddd;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 500;
    color: #000;
}
.question .form-label {
    font-size: 18px;
    font-weight: 500;
    margin-top: 3px;
    margin-bottom: 3px;
}
.question .form-label .info {
    width: 20px;
    height: 20px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #656565;
    border: 1px solid #656565;
    border-radius: 50%;
    font-style: italic;
    font-family: initial;
    font-weight: 600;
    font-size: 12px;
    color: #fff;
}
.question {
    width: 100%;
    position: relative;
}
.main-wrap .form-control {
    max-width: 100%;
    height: 45px;
    border: 1px solid #b5c2cb;
    border-radius: 6px;
    line-height: 30px;
}
.profile_wrap textarea.form-control {
    margin-bottom: 20px;
}
.flex-fill.form-control {
    z-index: inherit;
}
.input-group-text {
    border-color: #b5c2cb;
}
.main-wrap .small-text {
    color: #0b3454;
    font-size: 15px;
}
.main-wrap .form-select {
    max-width: 100%;
    height: 45px;
    border: 1px solid #b5c2cb;
    border-radius: 6px;
}
.form-check-input + label.gap-switch {
    background: #fff;
    padding: 5px;
    border-radius: 25px;
    position: relative;
    width: 100px;
    height: 40px;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    align-items: center;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    border: 2px solid #f34e65;
    color: #f34e65;
}
.form-check-input:checked + label.gap-switch {
    background: #5dae48;
    border-color: #5dae48;
}
.form-check-input + label.gap-switch:before {
    width: 24px;
    height: 24px;
    display: inline-block;
    background: #f34e65;
    border-radius: 50%;
    content: '';
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.form-check-input:checked + label.gap-switch::before {
    transform: translateX(62px);
    -webkit-transform: translateX(62px);
    -moz-transform: translateX(62px);
    -ms-transform: translateX(62px);
    -o-transform: translateX(62px);
    background: #fff;
}
.form-check-input + label.gap-switch:after {
    content: 'NO';
    color: #f34e65;
    flex: 1 1;
    text-align: center;
    font-weight: 500;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.form-check-input:checked + label.gap-switch::after {
    transform: translateX(-30px);
    content: 'YES';
    -webkit-transform: translateX(-30px);
    -moz-transform: translateX(-30px);
    -ms-transform: translateX(-30px);
    -o-transform: translateX(-30px);
    color: #fff;
}
.action_btns {
    max-width: 650px;
    background: #f5faff;
    padding: 20px;
    border-radius: 5px;
    margin: 35px 0 0 0px;
    text-align: center;
}
.form-switch .form-check-input:focus,
.form-switch .form-check-input {
    --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    border: 2px solid #f34e65;
    cursor: pointer;
}
.form-check-input:checked {
    background-color: #29a745;
    border-color: #29a745;
}
.form-switch .form-check-input:checked:focus {
    --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    border: 2px solid #29a745;
}
.action_btns button.nextbtn {
    padding: 0px 30px;
    font-size: 1.5em;
    width: 180px;
    cursor: pointer;
    border: 0px;
    position: relative;
    margin: auto;
    transition: all 0.25s ease;
    background: #0b3454;
    color: #fff;
    overflow: hidden;
    border-radius: 25px;
    height: 45px;
    text-transform: uppercase;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 1px;
}
.load {
    position: absolute;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    background: inherit;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: inherit;
    -webkit-border-radius: inherit;
    -moz-border-radius: inherit;
    -ms-border-radius: inherit;
    -o-border-radius: inherit;
}
.load::after {
    content: '';
    position: absolute;
    border-radius: 50%;
    border: 3px solid #fff;
    width: 30px;
    height: 30px;
    border-left: 3px solid transparent;
    border-bottom: 3px solid transparent;
    animation: loading1 1s ease infinite;
    -webkit-animation: loading1 1s ease infinite;
    z-index: 10;
}
.load::before {
    content: '';
    position: absolute;
    border-radius: 50%;
    border: 3px dashed #fff;
    width: 30px;
    height: 30px;
    border-left: 3px solid transparent;
    border-bottom: 3px solid transparent;
    animation: loading1 2s linear infinite;
    -webkit-animation: loading1 2s linear infinite;
    z-index: 5;
}
@keyframes loading1 {
    0% {
        transform: rotate(0deg);
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -o-transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
        -webkit-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -o-transform: rotate(360deg);
    }
}
.float_horizontal_animate {
    transform: translatex(0px);
    animation: float_horizontal 4s ease-in-out infinite;
    -webkit-animation: float_horizontal 4s ease-in-out infinite;
    -webkit-transform: translatex(0px);
    -moz-transform: translatex(0px);
    -ms-transform: translatex(0px);
    -o-transform: translatex(0px);
}
@keyframes float_horizontal {
    0% {
        transform: translatex(0px);
        -webkit-transform: translatex(0px);
        -moz-transform: translatex(0px);
        -ms-transform: translatex(0px);
        -o-transform: translatex(0px);
    }
    50% {
        transform: translatex(-10px);
        -webkit-transform: translatex(-10px);
        -moz-transform: translatex(-10px);
        -ms-transform: translatex(-10px);
        -o-transform: translatex(-10px);
    }
    100% {
        transform: translatex(0px);
        -webkit-transform: translatex(0px);
        -moz-transform: translatex(0px);
        -ms-transform: translatex(0px);
        -o-transform: translatex(0px);
    }
}
button .loading {
    opacity: 0;
    visibility: hidden;
}
button.activeLoading .loading {
    visibility: visible;
    opacity: 1;
}
.question .form-select.max-100 {
    max-width: 100%;
}
.check_box {
    background: #f5f7f8;
    border-radius: 6px;
    min-height: 48px;
    padding: 12px 20px 10px;
    margin: 20px 0 -35px 0;
    max-width: 640px;
}
.check_box .form-check-input {
    width: 20px;
    height: 20px;
    vertical-align: top;
    display: inline-block;
    margin-top: 0.5px;
    border: 1px solid #0b3454cc;
}
.check_box .form-check-input:checked {
    background-color: #5dae48;
    border-color: #5dae48;
}
.check_box .form-check-input:focus {
    box-shadow: none;
}
.datewrap {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    background: #ffffff;
    border: 1px solid #b5c2cb;
    border-radius: 6px;
    height: 45px;
    position: relative;
    overflow: hidden;
}
.daterangePickerList,
.singledaterangePickerList {
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 0;
    top: 0;
    right: 0;
    margin: auto;
    cursor: pointer;
    opacity: 0;
}
.datewrap .arrow {
    background: #f1f1f1;
    width: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.datewrap .from,
.datewrap .to {
    flex: 1 1;
}
.form-control[type='date'] {
    background: #fff url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/calender.svg) no-repeat right
        10px center;
    text-align: left;
    padding-right: 5px;
    position: relative;
}
.form-control[type='date']::-webkit-calendar-picker-indicator,
.form-control[type='date']::-moz-calendar-picker-indicator {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: auto;
    height: auto;
    color: transparent;
    background: transparent;
}
.form-control.form-date {
    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/calender.svg);
    background-position: center right 15px;
    background-repeat: no-repeat;
}
.form-control.form-search {
    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/search.svg);
    background-size: 14px;
    background-repeat: no-repeat;
    background-position: 13px center;
    padding-left: 34px;
}
.form-control.form-linkedin {
    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/linkedin.svg);
    background-size: 20px;
    background-repeat: no-repeat;
    background-position: 13px center;
    padding-left: 48px;
}
.form-control.form-facebook {
    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/facebook.svg);
    background-size: 20px;
    background-repeat: no-repeat;
    background-position: 13px center;
    padding-left: 48px;
}
.form-control.form-instagram {
    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/instagram.svg);
    background-size: 20px;
    background-repeat: no-repeat;
    background-position: 13px center;
    padding-left: 48px;
}
.form-control.form-twitter {
    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/twitter.svg);
    background-size: 20px;
    background-repeat: no-repeat;
    background-position: 13px center;
    padding-left: 48px;
}
.datepicker {
    max-width: 280px;
    width: 100%;
    padding: 0;
}
.datepicker-years {
    overflow: hidden;
    border-radius: 5px;
}

.react-datepicker-cnt > div,
.react-datepicker-cnt > div > div {
    width: 100%;
}
.react-datepicker-cnt {
    position: relative;
}
.react-datepicker-cnt .form-control.form-date {
    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/calender.svg) !important;
    background-position: center right 15px !important;
    background-repeat: no-repeat;
}
.datepicker .table-condensed {
    width: 100%;
}
.datepicker table tr td span {
    height: auto;
    line-height: 35px;
    border-radius: 25px;
}
.datepicker thead {
    background: #f4faff;
    line-height: 40px;
}
.datepicker table tr td span.active.active {
    background: #5dae48;
}
.prev {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-repeat: no-repeat !important;
    background-position: center !important;
    background-size: 16px 12px !important;
    font-size: 0;
    width: 50px !important;
}
.opacity-0 {
    opacity: 0;
}
.next {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    background-repeat: no-repeat !important;
    background-position: center !important;
    background-size: 16px 12px !important;
    font-size: 0;
    width: 50px !important;
    transform: scaleX(-1);
    -webkit-transform: scaleX(-1);
    -moz-transform: scaleX(-1);
    -ms-transform: scaleX(-1);
    -o-transform: scaleX(-1);
}
.datepicker .datepicker-switch {
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 5px;
}
.form-check.custom-rectbox-radio .form-check-input + label {
    width: 100%;
    height: 45px;
    font-weight: 500;
    border: 1px solid #b9c2cb;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 5px;
    padding: 0 14px;
    position: relative;
    cursor: pointer;
    transition: all 0.3s;
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    -ms-transition: all 0.3s;
    -o-transition: all 0.3s;
}
.form-check.custom-rectbox-radio .form-check-input:checked + label {
    background: #5dae48;
    border: 1px solid #5dae48;
    color: #fff;
}
.custom-rectbox-radio {
    padding: 0;
    margin: 0;
    flex: 1 1;
}
.custom-rectbox-radio:not(:last-child) {
    margin-right: 8px;
}
.radio_parent {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
}
.form-check.custom-rectbox-radio .form-check-input + label:before {
    content: '';
    position: absolute;
    right: 10px;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 24px;
    height: 24px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/male_icon.svg) no-repeat center;
}
.form-check.custom-rectbox-radio .form-check-input + label[for='female']:before {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/female_icon.svg) no-repeat center;
}
.form-check.custom-rectbox-radio .form-check-input:checked + label::before {
    filter: invert(1) brightness(100);
    -webkit-filter: invert(1) brightness(100);
}
.step_header_wrap {
    display: none;
}
.header_container {
    max-width: 1500px;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 25px 0px;
    width: 96%;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
}
.ful-header {
    border-bottom: 1px solid #e2e8ef;
    position: sticky;
    top: 0;
    background: #fff;
    z-index: 1;
}
.header_container .user_name {
    font-size: 20px;
}
.rightSection_header {
    position: relative;
}
.global_wrap {
    position: relative;
    margin-left: auto;
    height: 100%;
    margin-right: 0px;
}
.global_wrap .global {
    right: 0;
    top: 0px;
    bottom: auto;
}
.scholarship_banner {
    background: transparent linear-gradient(262deg, #fffdf8 0%, #fef6e4 76%, #feeccb 100%);
    width: 100%;
    height: 100%;
}
.scholarship_container {
    max-width: 1066px;
    width: 90%;
    margin: auto;
    padding-top: 0px;
}
.scholarship_container h2 {
    font-size: 22px;
    font-weight: 600;
    margin-top: 55px;
}
.scholarship_container h2 span {
    position: relative;
}
.scholarship_container h2 span:before {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 2px;
    background: #5cae48;
    border-radius: 5px;
    transition: all 0.5s ease-in-out;
    -webkit-transition: all 0.5s ease-in-out;
    -moz-transition: all 0.5s ease-in-out;
    -ms-transition: all 0.5s ease-in-out;
    -o-transition: all 0.5s ease-in-out;
}
.scholarship_detail_list {
    margin: 24px 0 20px 0;
    padding: 0;
    list-style: none;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    font-size: 18px;
    font-weight: 500;
    line-height: 22px;
}
.scholarship_detail_list li:not(:last-child) {
    margin-right: 30px;
}
.scholarship_detail_list li {
    position: relative;
    padding-left: 27px;
    margin-bottom: 16px;
}
.scholarship_detail_list li:before {
    content: '';
    position: absolute;
    left: 0;
    top: 2px;
    width: 20px;
    height: 18px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/tick.svg) no-repeat 0 0;
}
.scholarship_detail_carousel_container {
    max-width: 1066px;
    margin: auto;
    width: 90%;
}
.scholarship_detail_carousel {
    width: 100%;
    padding: 40px 0;
}
.joined_offer_wrap {
    position: relative;
    margin-left: 0;
    margin-bottom: 15px;
    display: flex;
}
.joined_offer_wrap:before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
    left: 0;
    right: 0;
    background: #5cae48;
    height: 1px;
}
.joined_label {
    position: relative;
    background: #5cae48;
    border-radius: 16px;
    height: 32px;
    display: flex;
    align-items: center;
    color: #fff;
    font-weight: 400;
    padding: 7px 20px 7px 7px;
    font-size: 14px;
}
.joined_label i {
    width: 20px;
    height: 20px;
    display: inline-block;
    background: #fff;
    border-radius: 50%;
    margin-right: 7px;
    position: relative;
}
.joined_label i:before {
    content: '';
    position: absolute;
    width: 10px;
    height: 5px;
    border-left: 2px solid #5cae48;
    border-bottom: 2px solid #5cae48;
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
    -moz-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    -o-transform: rotate(-45deg);
    left: 5px;
    top: 7px;
}
.joined_label_noline:before {
    display: none !important;
}
.w-65 {
    width: 65%;
}
.offered-univarsity-name {
    font-size: 28px;
    line-height: 32px;
    font-weight: 700;
}
.joined_label.didnt-join {
    background: #0b3454;
}
.joined_label.didnt-join i:before {
    border-left: 2px solid #0b3454;
    border-bottom: 2px solid #0b3454;
}
.joined_offer_wrap.didnt-join:before {
    background: #0b3454;
}
.scholarship_block {
    width: 350px;
}
.card_profiles {
    background: transparent linear-gradient(144deg, #edebff 0%, #f6f5ff 100%);
    border-radius: 6px;
    padding: 1px;
    height: auto;
    max-height: initial;
    min-height: initial;
}
.card_profiles_pink {
    background: transparent linear-gradient(145deg, #ffe8eb 0%, #fff8f9 100%) !important;
}
.card_profiles:first-child {
    margin: 0 0 10px;
}
.card_profiles .card_profiles_univarsity {
    padding: 19px 19px 13px;
    display: flex;
    flex-direction: column;
    flex: 1 1;
}
.card_profiles .card_profiles_univarsity .card_profiles_name {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    align-items: center;
}
.card_profiles .card_profiles_univarsity .card_profiles_name .student_detail {
    flex: 1 1;
}
.card_profiles .card_profiles_univarsity .card_profiles_name > a {
    border-radius: 50%;
    overflow: hidden;
    margin-right: 12px;
    width: 70px;
    height: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.card_profiles .card_profiles_univarsity .card_profiles_name a img {
    width: auto;
    height: 100%;
}
.card_profiles .card_profiles_univarsity .card_profiles_name .student_detail h2 {
    font-size: 22px;
    font-weight: 600;
    display: flex;
    flex-direction: column;
}
.card_profiles .card_profiles_univarsity .card_profiles_name .student_detail h2 a {
    border-radius: 0;
    text-decoration: none;
    color: #000;
}
.card_profiles .card_profiles_univarsity .card_profiles_name .student_detail h2 span {
    font-size: 15px;
    font-weight: 500;
    margin-top: 5px;
    color: #0b3454;
}
.carousel-indicators .dot {
    width: 10px;
    height: 10px;
    background: #0b34541a;
    border-radius: 50%;
    margin: 0 4px;
    padding: 0 !important;
    border: 0;
}
.carousel-indicators .dot.active {
    background: #0b3454b3;
}
.scholarship_block > h3 {
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    margin: 0 0 10px;
}
.scholarship_block > h3 span {
    font-size: 18px;
    font-weight: 600;
    display: block;
}
.scholarship_amt_detail {
    background: #ffffff;
    border-radius: 0px 0px 6px 6px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
    -webkit-border-radius: 0px 0px 6px 6px;
    -moz-border-radius: 0px 0px 6px 6px;
    -ms-border-radius: 0px 0px 6px 6px;
    -o-border-radius: 0px 0px 6px 6px;
}
.scholarship_amt {
    font-size: 24px;
    font-weight: 700;
}
.scholarship_label {
    font-size: 16px;
    font-weight: 500;
    display: flex;
    align-items: center;
}
.scholarship_label i {
    width: 37px;
    height: 25px;
    display: inline-block;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/scholarships-hat.jpg) no-repeat 0 0;
    margin-right: 10px;
}
.univarsity-block {
    display: flex;
    justify-content: center;
    margin-top: 3px;
}
.univarsity-block .univarsity-block-cover {
    display: flex;
    align-items: center;
    max-width: 255px;
    width: 100%;
}
.card_profiles .card_profiles_univarsity .card_profiles_name a img {
    width: auto;
    height: 100%;
}
.univarsity-block .univarsity-block-cover > a {
    width: 67px;
    height: 67px;
    background: #fff;
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
    border: 1px solid #ddd;
    margin-right: 10px;
}
.univarsity-block .univarsity-block-cover > a img {
    width: auto;
    height: 100%;
}
.univarsity-block .univarsity-block-cover h3 {
    flex: 1 1;
    margin: 0;
}
.univarsity-block .univarsity-block-cover h3 p {
    font-size: 16px;
    font-weight: 500;
    margin: 0 0 3px;
}
.univarsity-block .univarsity-block-cover h3 p a {
    text-decoration: none;
    color: #000;
}
.univarsity-block .univarsity-block-cover h3 .course {
    font-size: 15px;
    font-weight: 500;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    align-items: start;
}
.univarsity-block .univarsity-block-cover h3 .course .img-fluid {
    width: 16px;
    margin-right: 7px;
    margin-top: 1px;
}
.univarsity-block .univarsity-block-cover h3 .course span {
    width: calc(100% - 23px);
}
.scholarship_carousel .owl-dots {
    display: flex;
    justify-content: center;
    margin: 15px;
}
.scholarship_carousel .owl-dots .owl-dot {
    width: 8px;
    height: 8px;
    background: #0b34541a;
    border-radius: 50%;
    margin: 0 4px;
}
.scholarship_carousel .owl-dots .owl-dot.active {
    background: #0b3454b3;
}
#skip_pop .modal-dialog {
    max-width: 600px;
    border-radius: 10px;
}
#skip_pop .modal-content {
    border-radius: 10px;
}
#skip_pop .modal-dialog .modal-body {
    padding: 40px 0 0 50px;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    border-radius: 10px;
    min-height: 300px;
}
.img_pop {
    position: relative;
    z-index: 1;
    float: right;
}
#skip_pop .modal-dialog .modal-body h4 {
    font-size: 22px;
    font-weight: 600;
    position: relative;
    text-transform: uppercase;
}
#skip_pop .modal-dialog .modal-body h4::before {
    content: '';
    position: absolute;
    bottom: -17px;
    width: 50px;
    height: 3px;
    background: #5cae48;
    border-radius: 5px;
}
#skip_pop .modal-dialog .modal-body p {
    font-size: 20px;
    line-height: 28px;
    max-width: 318px;
    margin: 40px 0 0;
    font-weight: 500;
}
#skip_pop .img_pop {
    position: relative;
    z-index: 1;
    float: right;
    margin-top: -30px;
    width: 220px;
    text-align: right;
    display: flex;
    align-items: end;
}
#skip_pop .modal-footer {
    background: transparent linear-gradient(261deg, #fdfeff 0%, #eff7ff 16%, #d4ffc9 100%);
    border-radius: 90px 10px 10px 10px;
    -webkit-border-radius: 90px 10px 10px 10px;
    -moz-border-radius: 90px 10px 10px 10px;
    -ms-border-radius: 90px 10px 10px 10px;
    -o-border-radius: 90px 10px 10px 10px;
    opacity: 1;
    display: flex;
    justify-content: start;
    padding-left: 70px;
    border: 0;
    min-height: 90px;
    position: relative;
    bottom: 0;
    left: 0;
    right: 0;
    margin-top: -90px;
}
.btn-goback {
    background: #5cae48;
    border-radius: 31px;
    width: 158px;
    height: 50px;
    color: #fff;
    font-weight: 500;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    text-decoration: none;
    -webkit-border-radius: 31px;
    -moz-border-radius: 31px;
    -ms-border-radius: 31px;
    -o-border-radius: 31px;
}
.btn-goback:hover {
    background: #27970b;
    color: #fff;
}
.btn-later {
    font-size: 14px;
    font-weight: 500;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.btn-later:hover {
    color: #f34e65;
}
.btn-skip {
    margin: 15px;
    font-size: 12px;
    -webkit-text-decoration: navajowhite;
            text-decoration: navajowhite;
    font-weight: 500;
    color: #000;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    background: no-repeat;
    border: 0;
}
.btn-skip:hover {
    color: #d42941;
}
.modal-backdrop.show {
    opacity: 0.8;
}
.multiple_benefits_banner {
    background: transparent linear-gradient(262deg, #fdfeff 0%, #eff7ff 76%, #dbf1ff 100%);
    width: 100%;
    padding-top: 24px;
}
.multiple_benefits_container {
    max-width: 990px;
    margin: auto;
    width: 90%;
}
.multiple_benefits_container h2 {
    font-size: 22px;
    font-weight: 600;
    position: relative;
    margin: 37px 0 25px;
    line-height: 24px;
}
.multiple_benefits_container h2:before {
    content: '';
    position: absolute;
    width: 40px;
    height: 3px;
    background: #5cae48;
    left: 0;
    bottom: -5px;
}
.multiple_benefits_container p {
    font-size: 18px;
    font-weight: 500;
    line-height: 22px;
    max-width: 490px;
}
.multiple_benefits_cards_container {
    max-width: 990px;
    width: 90%;
    margin: auto;
}
.multiple_benefits_cards {
    width: 100%;
    padding: 30px 0;
}
.multiple_benefits_cards_container .card {
    border: 0;
    border-radius: 6px; /* overflow: hidden; */
    height: 100%;
}
.multiple_benefits_cards_container .card.network-card {
    background: #fff7f8;
}
.multiple_benefits_cards_container .card.event-card {
    background: #f9f8ff;
}
.multiple_benefits_cards_container .card .card-header {
    padding: 18px 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 144px;
}
.multiple_benefits_cards_container .card .card-header .title {
    font-size: 20px;
    line-height: 22px;
    flex: 1 1;
    color: #fff;
}
.multiple_benefits_cards_container .card .card-header .card-img {
    width: auto;
}
.multiple_benefits_cards_container .card.network-card .card-header {
    background: #d42941;
}
.multiple_benefits_cards_container .card.event-card .card-header {
    background: #51499c;
}
.multiple_benefits_cards_container .card .card-body {
    padding: 0;
}
.card .card-body .benefits_toggle {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.card.network-card .card-body .benefits_toggle {
    background: #fce4e7;
}
.card.event-card .card-body .benefits_toggle {
    background: #e8e7f0;
}
.multiple_benefits_cards_container .card .card-body .benefits_toggle .btn {
    width: 100%;
    border-radius: 0;
    min-height: 56px;
    display: flex;
    align-items: center;
    padding: 15px 20px 15px 30px;
    font-weight: 500;
    font-size: 18px;
    color: #000;
    border: 0;
    justify-content: space-between;
}
.benefits_toggle .btn:focus {
    box-shadow: none;
}
.benefits_toggle .toggle {
    width: 15px;
    height: 15px;
    position: relative;
}
.benefits_toggle .toggle::before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 15px;
    height: 3px;
    background: #000;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.benefits_toggle .toggle::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 3px;
    height: 15px;
    background: #000;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.benefits_toggle .btn[aria-expanded='true'] .toggle::after {
    transform: rotate(90deg);
    -webkit-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    -o-transform: rotate(90deg);
}
.multiple_benefits_cards_container .card.network-card .card-body .benefits_toggle .btn {
    background: #fce4e7;
}
.benefit-list {
    padding: 0px 30px 26px;
}
.multiple_benefits_cards_container .card .card-body .benefit_form {
    padding: 20px 30px 40px;
}
.benefit-list ul {
    padding: 0;
    margin: 0;
    list-style: none;
    font-size: 18px;
    line-height: 22px;
}
.benefit-list ul li {
    padding-left: 25px;
    position: relative;
    margin-bottom: 10px;
}
.benefit-list ul li:before {
    content: '';
    position: absolute;
    width: 12px;
    height: 6px;
    border-left: 2px solid #000;
    border-bottom: 2px solid #000;
    transform: rotate(-45deg);
    left: 0;
    top: 7px;
    -webkit-transform: rotate(-45deg);
    -moz-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    -o-transform: rotate(-45deg);
}
.video-btn {
    background: #0b3454;
    border-radius: 25px;
    padding: 9px 20px;
    display: inline-flex;
    text-decoration: none;
    color: #fff;
    font-size: 16px;
    font-weight: 500;
    align-items: center;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    border: 0;
    -webkit-border-radius: 25px;
    -moz-border-radius: 25px;
    -ms-border-radius: 25px;
    -o-border-radius: 25px;
}
.video-btn b {
    width: 16px;
    height: 16px;
    background: #fff;
    border-radius: 50%;
    margin: 0 0 0 7px;
    display: inline-block;
    font-size: 0;
    position: relative;
}
.video-btn b::before {
    content: '';
    position: absolute;
    top: 4px;
    left: 5.5px;
    margin: auto;
    width: 0;
    border-top: 4px solid transparent;
    border-bottom: 4px solid transparent;
    border-left: 5px solid #0b3454;
    height: 0;
}
.video-btn:hover {
    color: #fff;
    background: #5bae47;
}
.video-btn:hover b::before {
    border-left: 5px solid #5bae47;
}
.form-label {
    font-size: 16px;
    line-height: 22px;
    font-weight: 500;
    margin: 0 0 4px;
}
.select-option.first-option,
.select-option.second-option {
    position: relative;
}
.select-option.first-option .form-select,
.select-option.second-option .form-select {
    margin-bottom: 20px;
}
.form-check-input:checked ~ .select-option.first-option:after {
    content: '';
    position: absolute;
    bottom: 0;
    border-bottom: 1px solid #00000016;
    width: 208%;
    left: 0;
}
.form-check-input:checked ~ .select-option.second-option:after {
    content: '';
    position: absolute;
    bottom: 0;
    border-bottom: 1px solid #00000016;
    width: 208%;
    right: 0;
}
.benefit_form .form-check {
    margin: 0;
    padding: 0;
}
.benefit_form .form-check .form-check-input[role='switch'] {
    margin-left: 0;
}
.custom_radius_check {
    background: #ffffff;
    border: 1px solid #0b3454;
    border-radius: 25px;
    width: 100%;
    padding: 10px 20px;
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 500;
    justify-content: space-between;
    position: relative;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    -webkit-border-radius: 25px;
    -moz-border-radius: 25px;
    -ms-border-radius: 25px;
    -o-border-radius: 25px;
}
.custom_radius_check i {
    width: 17px;
    height: 12px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/check-tick.svg) no-repeat 0 0;
    filter: invert(76%) sepia(79%) saturate(0%) hue-rotate(131deg) brightness(94%) contrast(96%);
    -webkit-filter: invert(76%) sepia(79%) saturate(0%) hue-rotate(131deg) brightness(94%) contrast(96%);
}
.select-option {
    display: none;
    width: 100%;
    position: relative;
}
.form-check-input:checked ~ .select-option {
    display: inline-block;
}
.select-option .form-select {
    margin-top: 16px;
    border: 1px solid #0b3454;
    border-radius: 6px;
    height: 42px;
}
.form-check-input:checked + .custom_radius_check {
    background: #5cae48;
    border-color: #5cae48;
    color: #fff;
}
.form-check-input:checked + .custom_radius_check i {
    filter: invert(1) brightness(1);
    -webkit-filter: invert(1) brightness(1);
}
.custom_radius_check::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    border-right: 7px solid transparent;
    border-left: 7px solid transparent;
    border-top: 7px solid transparent;
    width: 0;
    margin: auto;
    top: 85%;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    opacity: 0;
}
.form-check-input:checked + .custom_radius_check::after {
    top: 100%;
    border-top: 7px solid #5cae48;
    opacity: 1;
}
.multiple_benefits_cards_container .action_btns {
    max-width: 100%;
    margin: 0;
}
.bg-drop {
    display: none;
}
footer.footer {
    padding: 15px 0;
    border-top: 1px solid #eee;
    background: #fff;
    position: relative;
    height: auto;
}
.modal-open footer.footer{display: none;}
.footer-wrap {
    width: 90%;
    margin: auto;
    max-width: 1500px;
}
.powerby {
    display: flex;
    flex-direction: column;
    width: 139px;
}
.pop-dialog {
    max-width: 700px;
    width: 90%;
    margin: auto;
}
.modal.show .modal-dialog .pop-content {
    background: #ffffff;
    border-radius: 10px;
    width: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
}
.pop-footer {
    background: transparent linear-gradient(261deg, #fdfeff 0%, #eff7ff 16%, #d4ffc9 100%);
    border-radius: 90px 0px 10px 10px;
    opacity: 1;
    padding: 20px 66px;
    margin-left: 10px;
    -webkit-border-radius: 90px 0px 10px 10px;
    -moz-border-radius: 90px 0px 10px 10px;
    -ms-border-radius: 90px 0px 10px 10px;
    -o-border-radius: 90px 0px 10px 10px;
}
.pop-body {
    min-height: 255px;
    padding: 80px 50px 0;
}
.pop-body .img_pop {
    position: absolute;
    right: -38px;
    bottom: 0;
}
.pop-dialog h4 {
    font-size: 22px;
    font-weight: 600;
    position: relative;
    margin: 0 0 35px;
}
.pop-dialog h4::before {
    content: '';
    position: absolute;
    bottom: -12px;
    width: 50px;
    height: 3px;
    background: #5cae48;
    border-radius: 5px;
}
.pop-body p {
    font-size: 18px;
    font-weight: 500;
    line-height: 22px;
}
.pop_step {
    padding: 0;
    margin: 40px 0 0;
    list-style: none;
}
.pop_step li {
    padding: 0 0 30px 53px;
    line-height: 22px;
    position: relative;
    display: flex;
    flex-direction: column;
    font-size: 18px;
    font-weight: 500;
}
.pop_step li b {
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 7px;
}
.pop_step li .completed_li {
    position: absolute;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: #5cae48;
    left: 0;
    top: -7px;
    margin: 0 8px;
}
.pop_step li .completed_li:before {
    content: '';
    position: absolute;
    border-left: 3px solid #fff;
    border-bottom: 3px solid #fff;
    width: 12px;
    height: 7px;
    left: 6px;
    top: 7px;
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
    -moz-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    -o-transform: rotate(-45deg);
}
.pop_step li .edit_li {
    position: absolute;
    width: 40px;
    height: 40px;
    background: #0b3454 url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/blue_edit.png) no-repeat
        center;
    left: 0;
    top: 0;
    border-radius: 50%;
}
.pop_step li.pop_completed::before {
    content: '';
    position: absolute;
    top: 0;
    left: 19px;
    background: #5cae48;
    width: 2px;
    bottom: 0;
    margin: auto;
}
.mentoring_contact i {
    width: 36px;
    height: 36px;
    background: #27a7df;
    display: flex;
    border-radius: 60px;
    align-items: center;
    justify-content: center;
}
.btn-update {
    border: none;
    padding: 10px 30px;
    background: #5cae48;
    border-radius: 25px;
    color: #ffff;
    text-transform: uppercase;
    font-weight: 500;
    font-size: 14px;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.form-control {
    max-width: 100%;
    height: 45px;
    border: 1px solid #b5c2cb;
    border-radius: 6px;
}
textarea.form-control {
    min-height: 60px;
}
.btn-update:hover {
    background: #43992e;
}
.edit_phone .btn-close {
    font-size: 12px;
}
.btn-cancel {
    background: none;
    border: 0;
    padding: 10px 5px;
    border-radius: 25px;
    margin-left: 10px;
    font-weight: 500;
    color: #828282;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.btn-cancel:hover {
    color: #000;
}

@media (max-width: 1199px) {
    /* .global {bottom: -60px;}
 */
    .global.show .unlock {
        white-space: normal;
        width: 310px;
    }
    .global.show .unlock .text {
        line-height: 17px;
        font-size: 16px;
    }
    .cta_add {
        flex-direction: column;
    }
    .cta_add .btn-add {
        margin-bottom: 10px;
    }
}

@media (max-width: 991px) {
    .leftPaneBody {
        padding: 0 50px;
    }
    .rightPaneBodyWrap {
        padding: 50px 40px;
    }
    .action_btns button.nextbtn {
        width: 150px;
    }
    .scholarship_block {
        width: 100%;
    }
    .scholarship_carousel .item {
        display: flex;
        justify-content: space-between;
    }
    .scholarship_carousel .item .card_profiles {
        width: 49%;
        display: flex;
        flex-direction: column;
    }
    .item-wrap {
        display: flex;
        -webkit-box-wrap: wrap;
        -moz-box-wrap: wrap;
        -ms-flex-wrap: wrap;
        -webkit-wrap: wrap;
        flex-wrap: wrap;
        justify-content: space-between;
    }
    .item-wrap .card_profiles {
        width: 49%;
        margin: 0;
    }
}

@media (min-width: 768px) and (max-width: 992.98px) {
    .form-check-input:checked ~ .select-option.first-option::after {
        content: '';
        position: absolute;
        bottom: 0;
        border-bottom: 1px solid #00000016;
        width: 208%;
        left: -10%;
    }
    .form-check-input:checked ~ .select-option.second-option::after {
        content: '';
        position: absolute;
        bottom: 0;
        border-bottom: 1px solid #00000016;
        width: 208%;
        right: -10%;
    }
    .form-check-input:checked ~ .select-option.third-option::after {
        content: '';
        position: absolute;
        bottom: 0;
        border-bottom: 1px solid #00000016;
        width: 208%;
        left: -10%;
    }
    .select-option.third-option .form-select {
        margin-bottom: 20px;
    }
}

@media (max-width: 767px) {
    .leftPane {
        width: 100%;
    }
    .leftPaneBody {
        max-width: 100%;
        padding: 30px;
    }
    .leftPaneBodyWrap {
        padding: 0px 0 50px;
    }
    .rightPane {
        width: 100%;
        box-shadow: 0px -7px 15px #00000026;
        border-radius: 15px 15px 0px 0px;
        padding: 45px 0px 0px 25px;
        cursor: pointer;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 7;
        display: none !important;
    }
    .rightPane.basic-information .rightPaneHeaderWrap {
        display: none;
    }
    .rightPaneBodyWrap {
        padding: 0;
        position: static;
    }
    .rightPane.basic-information {
        background: transparent linear-gradient(254deg, #fdfeff 0%, #eff7ff 76%, #dbf1ff 100%);
    }
    .rightPane.basic-information.undergraduate-college {
        background: transparent linear-gradient(213deg, #fffdf8 0%, #fef6e4 76%, #feeccb 100%) !important;
    }
    .rightPane.basic-information .step_1 {
        width: 100%;
        flex-direction: row;
        justify-content: space-between;
        align-items: end;
    }
    .step_img img {
        width: auto;
        height: 128px;
    }
    .mobile-step-block[aria-expanded='true'] ~ .step_img {
        position: absolute;
        right: 0;
        border: 0;
        opacity: 0.2;
    }
    .textDetail {
        flex: 1 1;
    }
    .action_btns {
        max-width: 90%;
        margin: auto;
        width: 100%;
    }
    .action_btns.social {
        margin: auto;
    }
    .custom-rectbox-radio {
        flex: none;
        width: 130px;
    }
    .step_header_wrap {
        display: none !important;
        -webkit-box-wrap: wrap;
        -moz-box-wrap: wrap;
        -ms-flex-wrap: wrap;
        -webkit-wrap: wrap;
        flex-wrap: wrap;
        justify-content: space-between;
        margin: 0;
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 9;
        background: transparent linear-gradient(254deg, #fdfeff 0%, #eff7ff 76%, #dbf1ff 100%);
        box-shadow: 0px -7px 15px #00000026;
        border-radius: 15px 15px 0px 0px;
        padding: 45px 0px 0px 25px;
        cursor: pointer;
        transition: all 0.1s ease-in-out;
        -webkit-transition: all 0.1s ease-in-out;
        -moz-transition: all 0.1s ease-in-out;
        -ms-transition: all 0.1s ease-in-out;
        -o-transition: all 0.1s ease-in-out;
        align-items: end;
    }
    .step_header_wrap_bg-beige {
        background: transparent linear-gradient(213deg, #fffdf8 0%, #fef6e4 76%, #feeccb 100%) !important;
    }
    .step_header_wrap::before,
    .rightPane::before {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        width: 50px;
        height: 2px;
        background: #727272;
        margin: auto;
        top: 20px;
    }
    .step_header_wrap_img img {
        height: 128px;
    }
    .step_header_wrap_title {
        padding-top: 15px;
        flex: 1 1;
    }
    .steps.showTab > h2 {
        padding: 40px 40px 0;
    }
    .steps_questions {
        /* padding: 0px 40px 40px; */
        margin-top: 30px;
        max-width: 100%;
    }
    .leftPaneHeaderWrap {
        justify-content: center;
        display: flex;
        flex-direction: column;
        height: auto;
    }
    .leftPaneHeader {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 94%;
        margin: auto;
    }
    .leftPaneHeader .user_name {
        display: inline-block;
        font-size: 18px;
    }
    .check_box {
        margin: 20px auto -35px;
        max-width: 680px;
        width: 90%;
    }
    .step_header_wrap_title > h2 {
        font-size: 18px;
        font-weight: 600;
        margin-right: 15px;
    }
    .step_header_wrap_link {
        background: transparent;
        border-radius: 27px;
        color: #0b3454;
        text-decoration: none;
        padding: 3px 20px;
        transition: all 0.3s ease-in-out;
        display: inline-block;
        margin-bottom: 18px;
        font-weight: 500;
        border: 2px solid #0b3454;
        -webkit-transition: all 0.3s ease-in-out;
        -moz-transition: all 0.3s ease-in-out;
        -ms-transition: all 0.3s ease-in-out;
        -o-transition: all 0.3s ease-in-out;
        -webkit-border-radius: 27px;
        -moz-border-radius: 27px;
        -ms-border-radius: 27px;
        -o-border-radius: 27px;
        display: inline-block;
        margin-top: 16px;
    }
    .step_header_wrap_link span {
        transition: all 0.3s ease-in-out;
    }
    .step_header_wrap_link .less {
        font-size: 0;
    }
    .step_header_wrap_link:hover {
        background: #0b3454;
        color: #fff;
    }
    .step_header_wrap.open .step_header_wrap_link {
        margin-bottom: 20px;
    }
    .listed_points:not(.show) {
        height: 0;
        overflow: hidden;
    }
    .listed_points ul li {
        font-size: 16px;
        font-size: 16px;
        margin-bottom: 15px;
        line-height: 19px;
    }
    .listed_points ul li:last-child {
        margin-bottom: 0;
    }
    .mobile-step-block {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        z-index: 9;
    }
    .mobile-step-block[aria-expanded='false'] + .step_header_wrap_title .step_header_wrap_link .more,
    .mobile-step-block[aria-expanded='false'] + .textDetail .step_header_wrap_link .more {
        font-size: 16px;
    }
    .mobile-step-block[aria-expanded='false'] + .step_header_wrap_title .step_header_wrap_link .less,
    .mobile-step-block[aria-expanded='false'] + .textDetail .step_header_wrap_link .less {
        font-size: 0;
    }
    .mobile-step-block[aria-expanded='true'] + .step_header_wrap_title .step_header_wrap_link .more,
    .mobile-step-block[aria-expanded='true'] + .textDetail .step_header_wrap_link .more {
        font-size: 0px;
    }
    .mobile-step-block[aria-expanded='true'] + .step_header_wrap_title .step_header_wrap_link .less,
    .mobile-step-block[aria-expanded='true'] + .textDetail .step_header_wrap_link .less {
        font-size: 16px;
    }
    .step_header_wrap_title .listed_points ul li::before {
        height: 17px;
    }
    .global {
        width: 100%;
        height: 40px;
        position: relative;
        margin-bottom: -26px;
        background: none;
        border-radius: 0;
        margin-top: 25px;
        border-top: 1px solid #e2e8ef;
        bottom: auto;
        right: auto;
    }
    .global .unlock,
    .global.show .unlock {
        width: 100%;
        right: 0;
        bottom: 0;
        border-radius: 0;
        position: static;
        opacity: 1;
    }
    .progress_svg {
        width: 70px;
        height: 70px;
        position: absolute;
        right: 30px;
        top: auto;
        bottom: 0px;
        background: #fff;
        padding: 0;
        border-radius: 50%;
        box-shadow: 0px 0px 10px 0 #d3d3d3;
    }
    .progress_svg .gaugeMeter {
        width: 60px !important;
        height: 60px;
    }
    .progress_svg .gaugeMeter canvas {
        width: 100%;
        height: 100%;
    }
    .progress_svg span {
        line-height: 60px !important;
        font-size: 18px !important;
    }
    .global_wrap {
        width: 100%;
        order: 1;
    }
    .global.show .unlock,
    .global .unlock {
        white-space: normal;
    }
    .global.show .unlock.prize_bg,
    .global .unlock.prize_bg {
        width: auto;
        margin: 0 -2%;
    }
    .global.show .unlock .text,
    .global .unlock .text {
        width: calc(100% - 140px);
    }
    .global .unlock.unlock_blue {
        border-radius: 0 !important;
    }
    .global .unlock .text {
        font-size: 16px;
        font-weight: 500;
    }
    .scholarship_carousel .item {
        display: flex;
        -webkit-box-wrap: wrap;
        -moz-box-wrap: wrap;
        -ms-flex-wrap: wrap;
        -webkit-wrap: wrap;
        flex-wrap: wrap;
        justify-content: space-between;
    }
    .scholarship_block {
        width: 100%;
        margin-top: 15px;
        margin-bottom: 30px;
        position: relative;
        z-index: 0;
    }
    .scholarship_carousel .item .card_profiles {
        width: 48%;
        margin: 0 0 10px;
        display: flex;
        flex-direction: column;
    }
    .scholarship_amt {
        font-size: 18px;
        font-weight: 700;
    }
    .scholarship_amt_detail {
        padding: 20px 15px;
    }
    .bg-drop {
        position: fixed;
        left: 0;
        right: 0;
        top: 100%;
        bottom: 0;
        margin: auto;
        background: rgba(0, 0, 0, 0.7);
        z-index: 6;
        transition: all 0.1s ease-in-out;
        display: block;
        -webkit-transition: all 0.1s ease-in-out;
        -moz-transition: all 0.1s ease-in-out;
        -ms-transition: all 0.1s ease-in-out;
        -o-transition: all 0.1s ease-in-out;
    }
    .bg-drop[aria-expanded='true'] {
        top: 0;
    }
    .mobile-step-block[aria-expanded='true'] ~ .step_header_wrap_img {
        position: absolute;
        right: 0;
        border: 0;
        opacity: 0.2;
    }
    .scholarship_detail_carousel {
        padding: 0;
    }
    .leftPaneHeaderWrap .global.nobadge {
        height: 0;
    }
    .leftPaneHeaderWrap .global.nobadge .progress_svg {
        top: -30px;
    }
    .global_wrap .global.nobadge {
        height: auto;
        border: 0;
    }
    .global_wrap .global.nobadge .progress_svg {
        top: -30px;
    }
    footer {
        margin-bottom: 160px;
    }
    .pop-body .img_pop {
        position: static;
        width: 100%;
        text-align: center;
    }
}

@media (max-width: 575px) {
    div#root > div {
        overflow: hidden;
    }
    .ful-header + .main-wrap {
        padding: 30px;
    }
    .leftPaneBody {
        padding: 30px;
    }
    .listed_points {
        margin-top: 10px;
        margin-right: 15px;
    }
    .leftPaneHeader img {
        width: 130px;
    }
    .header_container img {
        width: 130px;
    }
    .step_header_wrap_title {
        padding-top: 0;
    }
    .steps.showTab > h2 {
        padding: 30px 25px 0;
    }
    .steps_questions {
        /* padding: 0px 25px 30px; */
    }
    .action_btns {
        max-width: 100%;
        margin: 0 auto;
        padding: 10px;
    }
    .step_header_wrap_img img {
        height: 100px;
        animation: none;
        -webkit-animation: none;
    }
    .leftPaneHeader .user_name span {
        font-weight: 600;
        width: 100px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: inline-block;
        vertical-align: top;
    }
    .global .unlock {
        padding: 12px 0;
    }
    .global {
        height: auto;
    }
    .global .unlock {
        height: auto;
    }
    .progress_svg {
        bottom: 10px;
        right: 10px;
    }
    .global_wrap .progress_svg {
        right: 0;
        bottom: 5px;
    }
    .scholarship_carousel .item .card_profiles {
        width: 100%;
        margin: 0 0 10px;
    }
    .scholarship_detail_carousel_container {
        width: 100%;
        overflow: hidden;
    }
    .joined_offer_wrap {
        margin-left: 0;
    }
    .scholarship_block {
        width: 100%;
        margin: auto;
    }
    .scholarship_detail_carousel {
        padding: 0px 0 40px;
    }
    .global_wrap .global {
        top: 0;
        left: 0px;
    }
    .skip_pop .brife {
        flex: 1 1;
    }
    #skip_pop .modal-footer {
        margin: 0;
    }
    #skip_pop .modal-dialog .modal-body {
        padding: 30px 0 0 30px;
    }
    .action_btns .btn-skip {
        margin: 18px 18px 0;
        display: inline-block;
    }
    #skip_pop .img_pop {
        margin-top: 15px;
        text-align: center;
        width: 100%;
        padding-right: 30px;
    }
    .form-check-input:checked ~ .select-option.first-option::after {
        content: '';
        position: absolute;
        bottom: 0;
        border-bottom: 1px solid #00000016;
        width: 208%;
        left: -10%;
    }
    .form-check-input:checked ~ .select-option.second-option::after {
        content: '';
        position: absolute;
        bottom: 0;
        border-bottom: 1px solid #00000016;
        width: 208%;
        right: -10%;
    }
    .form-check-input:checked ~ .select-option.third-option::after {
        content: '';
        position: absolute;
        bottom: 0;
        border-bottom: 1px solid #00000016;
        width: 208%;
        left: -10%;
    }
    .select-option.third-option .form-select {
        margin-bottom: 20px;
    }
    .global.nobadge {
        top: auto;
        bottom: auto;
        height: 20px;
        border: 0;
    }
    .global.nobadge .progress_svg {
        top: -23px;
        bottom: auto;
        right: 0;
    }
    .leftPaneHeaderWrap .global.nobadge .progress_svg {
        right: 10px;
        top: -23px;
    }
    .global.show .unlock.prize_bg,
    .global .unlock.prize_bg,
    .global .unlock.laststep_bg {
        height: 50px;
    }
    .unlock.prize_bg .img,
    .unlock.laststep_bg .img {
        margin-bottom: -20px;
    }
    .leftPaneHeaderWrap .progress_svg {
        top: -22px;
    }
    .global_wrap .global.nobadge .progress_svg {
        top: -23px;
    }
    .global_wrap .global.nobadge {
        padding: 10px;
    }
    .global .unlock.green_recom_bg {
        padding: 7px 0;
    }
    .global .unlock.green_recom_bg .text {
        width: calc(100% - 0px);
        padding: 0 20px 0 0;
    }
    .global .unlock.unlock_blue {
        padding: 0;
    }
    .pop-body {
        padding: 30px 30px 0;
    }
    .edit_phone .btn-close {
        font-size: 12px;
        position: absolute;
        top: 0px;
        right: -10px;
    }
    .step_img img {
        height: auto;
        width: 125px;
    }
    .item-wrap .card_profiles {
        width: 100%;
        margin: 0 0 20px;
    }
    .pop-body .img_pop img {
        width: 100%;
        max-width: 210px;
    }
}

@media (max-width: 400px) {
    .global.show .unlock .text {
        line-height: 16px;
        font-size: 13px;
    }
}
.cta_add {
    display: flex;
    font-size: 16px;
    font-weight: 500;
}
.cta_add .form-check label {
    color: #0b3454;
}
.cta_add .form-check input {
    border: 2px solid #0b3454;
    width: 22px;
    height: 22px;
    border-radius: 40px;
    margin-right: 10px;
}
.cta_add .form-check-input:checked {
    background-color: #27970b;
    border: 0 !important;
}
.cta_add .form-check label {
    padding-top: 3px;
    color: #0b3454;
}
.cta_add .btn-add {
    color: #27a7df;
    padding: 0 30px 0 0;
    text-decoration: none;
    display: flex;
    align-items: center;
}
.cta_add .btn-add:hover {
    color: #5cae48;
}
.cta_add .btn-add i {
    margin-right: 10px;
    margin-top: -4px;
}
.cta_add .btn-add i path {
    fill: #5cae48;
    color: #5cae48;
}
.cta_add .btn-add:focus {
    box-shadow: none;
}
.cta_add .btn-add:focus-visible {
    border: none;
    outline: none;
}
.cta_add .btn-add:hover i img {
    filter: invert(54%) sepia(94%) saturate(312%) hue-rotate(63deg) brightness(93%) contrast(83%);
    -webkit-filter: invert(54%) sepia(94%) saturate(312%) hue-rotate(63deg) brightness(93%) contrast(83%);
}
.btn-delete {
    padding: 0;
    width: 18px;
    height: 18px;
    position: absolute;
    right: 100%;
    top: 15px;
    opacity: 0.4;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    background: transparent
        url(${___CSS_LOADER_URL_REPLACEMENT_4___})
        0 0 / 18px auto no-repeat;
}
.btn-delete:hover {
    opacity: 1;
}
.form-label ~ .btn-delete {
    top: 45px;
}
.section {
    position: relative;
    padding-right: 20px;
}
.section + .section {
    margin-top: 60px;
}
.section:first-child {
    margin-top: 20px;
}
.section .btn-delete {
    top: 35px;
    bottom: 0;
    margin: auto;
    right: -60px;
}
.section::after {
    content: '';
    position: absolute;
    right: -2px;
    top: 23px;
    bottom: 0;
    width: 1px;
    height: calc(100% - 23px);
    background: #e2e8ef;
}

@media (max-width: 767px) {
    .cta_add {
        display: block;
    }
    .cta_add .btn-add {
        margin-bottom: 10px;
    }
    .section {
        width: calc(100% - 25px);
    }
    .section .btn-delete {
        right: -50px;
    }
}
.font-18 {
    font-size: 18px;
}
.mentoring_contact {
    border: 1px solid #b5c1cb;
    border-radius: 6px;
}
.mentoring_contact p {
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: 500;
}
.mentoring_contact p i {
    width: 36px;
    height: 36px;
    background: #27a7df;
    display: flex;
    border-radius: 60px;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
}
.mentoring_contact p i img {
    /* height: auto; */
}
.card_achievements {
    text-align: center;
}
.card_achievements .card_profiles_name {
    display: block !important;
}
.card_achievements .card_profiles_univarsity .card_profiles_name > a {
    margin: 0 auto;
    margin-bottom: -47px;
    width: 80px;
    height: 80px;
    position: relative;
    overflow: inherit; /* z-index: 9999; */
}
.card_achievements .scholarship_amt {
    margin: 0 auto;
    margin-top: 30px;
    font-size: 18px;
}
.card_achievements .card_profiles_univarsity .card_profiles_name > a span {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/badge.svg) no-repeat center;
    position: absolute;
    left: 50%;
    bottom: 0;
    width: 20px;
    height: 28px;
    margin-left: -10px;
    bottom: -15px;
}
.card_achievements .card_profiles_univarsity .card_profiles_name > a img {
    border-radius: 50%;
}
.profile_picture_qr {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    min-height: 242px;
    border-radius: 10px;
    overflow: hidden;
}
.profile_picture_qr .or {
    width: 2px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}
.profile_picture_qr .profile_picture_section {
    background: #d42941;
    flex: 1 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 15px;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    position: relative;
}
.profile_picture_qr .profile_picture_section:hover {
    background: #bd1f35;
}
.profile_picture_qr .profile_picture_section .block {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    cursor: pointer;
    z-index: 1;
}
.profile_picture_qr .qr_section {
    flex: 1 1;
    background: #cffed2;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.profile_picture_qr .or span {
    background: #fff;
    width: 42px;
    height: 42px;
    border-radius: 50%;
    position: absolute;
    left: -21px;
    bottom: 0;
    top: 0;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    font-weight: 500;
    text-transform: uppercase;
}
.profile_picture_qr .or::after {
    display: none;
}
.profile_picture_edit {
    border: 2px dashed #ffffff;
    border-radius: 74px;
    width: 145px;
    height: 145px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 0 0 5px #d42941 inset;
    position: relative;
}
.profile_picture_edit:before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 100%;
    background: #fff;
    border-radius: 50%;
    z-index: 0;
}
.profile_picture_edit img {
    width: 100%;
    position: relative;
}
.profile_picture_edit .image-edit {
    position: absolute;
    top: 5px;
    right: 5px;
    width: 32px;
    height: 32px;
    background: #5cae48;
    border: 3px solid #fff;
    border-radius: 50%;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.profile_picture_edit .image-edit:before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 2px;
    height: 12px;
    background: #fff;
    margin: auto;
}
.profile_picture_edit .image-edit:after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 12px;
    height: 2px;
    background: #fff;
    margin: auto;
}
.profile_picture_edit .image-edit:hover {
    background: #669f34;
}
.profile_picture_edit_btn {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    text-align: center;
}
.profile_picture_edit_btn label {
    background: #ffe3e3;
    border: 2px solid #ffffff;
    border-radius: 60px;
    font-size: 12px;
    font-weight: 500;
    width: 140px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.profile_picture_section:hover .profile_picture_edit_btn label {
    background: #f7b3b3;
    border: 2px solid#F7B3B3;
}
.profile_picture_edit_btn span {
    font-size: 14px;
    color: #fff;
    line-height: 18px;
}
.profile_picture_qr .qr_section p {
    font-size: 16px;
    margin: 8px 0 0;
    font-weight: 500;
}
.whatapp_text i {
    width: 20px;
    height: 20px;
    margin-right: 5px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/whatsapp.svg) no-repeat 0 0;
}
.whatapp_text {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    font-size: 16px;
    font-weight: 600;
    align-items: center;
}
.desclamier {
    font-size: 14px;
    font-style: italic;
    margin: 10px 0 20px;
}

@media (min-width: 768px) and (max-width: 992.98px) {
    .profile_picture_qr {
        flex-direction: column;
    }
    .profile_picture_qr .profile_picture_section {
        padding: 30px;
    }
    .profile_picture_qr .qr_section {
        padding: 30px;
    }
    .profile_picture_qr .or {
        width: 100%;
    }
    .profile_picture_qr .or span {
        left: 0;
        right: 0;
    }
}

@media (max-width: 575px) {
    .profile_picture_qr {
        flex-direction: column;
    }
    .profile_picture_qr .profile_picture_section {
        padding: 30px;
    }
    .profile_picture_qr .qr_section {
        padding: 30px;
    }
    .profile_picture_qr .or {
        width: 100%;
    }
    .profile_picture_qr .or span {
        left: 0;
        right: 0;
    }
    .btn-delete {
        right: -20px;
    }
}

.success_popup {
    max-width: 700px;
}
.success_popup .img_pop {
    position: absolute;
    right: -40px;
    bottom: 0;
}
.success_popup .modal-content {
    min-height: 380px;
    border-radius: 10px;
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    -ms-border-radius: 10px;
    -o-border-radius: 10px;
}
.success_popup .modal-body {
    display: flex;
    align-items: center;
    padding-left: 60px;
}
.success_popup .brife {
    margin-top: -30px;
    max-width: 320px;
}
.success_popup .modal-body h4::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0px;
    width: 50px;
    height: 3px;
    background: #5cae48;
    border-radius: 15px;
}
.success_popup .modal-body h4 {
    position: relative;
    padding-bottom: 10px;
    margin-bottom: 20px;
}
.success_popup .modal-footer {
    background: transparent linear-gradient(261deg, #fdfeff 0%, #eff7ff 16%, #d4ffc9 100%);
    border-radius: 90px 10px 10px 10px;
    opacity: 1;
    display: flex;
    justify-content: start;
    padding-left: 70px;
    border: 0;
    min-height: 90px;
    position: relative;
    bottom: 0;
    left: 0;
    right: 0;
    margin-top: -90px;
    -webkit-border-radius: 90px 10px 10px 10px;
    -moz-border-radius: 90px 10px 10px 10px;
    -ms-border-radius: 90px 10px 10px 10px;
    -o-border-radius: 90px 10px 10px 10px;
}
.file {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
}
.file > input[type='file'] {
    display: none;
}
.file > label {
    font-size: 1rem;
    font-weight: 300;
    cursor: pointer;
    outline: 0;
    -webkit-user-select: none;
            user-select: none;
    border-radius: 6px;
    padding-right: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    border: 1px dotted #8499a9;
    min-height: 60px;
    padding: 0;
    font-weight: 400;
    color: #0b3454;
}
.file > label span {
    padding-left: 5px;
    text-decoration: underline;
    color: #27a7df;
    font-weight: 400;
}
.file > label:hover {
    border-color: hsl(0, 0%, 21%);
}
.file > label:active {
    background-color: hsl(0, 0%, 96%);
}
.file > label > i {
    padding-right: 15px;
}
.file--upload > label {
}
.file--upload > label:hover {
    border-color: hsl(204, 86%, 53%);
    background-color: hsl(204, 86%, 96%);
}
.file--upload > label:active {
    background-color: hsl(204, 86%, 91%);
}
.file--uploading > label {
    color: hsl(48, 100%, 67%);
    border-color: hsl(48, 100%, 67%);
}
.file--uploading > label > i {
    animation: pulse 5s infinite;
    -webkit-animation: pulse 5s infinite;
}
.file--uploading > label:hover {
    border-color: hsl(48, 100%, 67%);
    background-color: hsl(48, 100%, 96%);
}
.file--uploading > label:active {
    background-color: hsl(48, 100%, 91%);
}
form-control.is-valid,
.was-validated .form-control:valid {
    background-image: none;
}
.was-validated .form-select:valid:not([multiple]):not([size]) {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
.form-select.is-valid,
.was-validated .form-select:valid {
    color: #000;
}
.question .form-select.customSelect {
    border: 1px solid #b5c2cb;
    border-radius: 6px;
    background-color: #fff;
    display: flex;
    align-items: center;
    cursor: pointer;
}
.customChoose {
    background: #ffffff;
    box-shadow: 0px 10px 20px #efefef;
    border: 1px solid #b5c1cb;
    border-radius: 6px;
    overflow: hidden;
    position: absolute;
    width: 100%;
    top: 150%;
    z-index: -1;
    opacity: 0;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.question .customChoose .form-control {
    border-width: 0 0 1px 0;
    border-radius: 0;
}
.customChoose.open {
    opacity: 1;
    z-index: 1;
    top: 102%;
}
.customChooseoptions {
    margin: 20px 0 20px;
    padding: 0 15px;
    list-style: none;
    max-height: 160px;
    overflow: auto;
    line-height: 16px;
    scrollbar-width: 4px;
}
.customChooseoptions::-webkit-scrollbar {
    width: 4px;
}
.customChooseoptions::-moz-scrollbar {
    width: 4px;
}
.customChooseoptions::-webkit-scrollbar-track {
    background: #eee;
}
.customChooseoptions::-webkit-scrollbar-thumb {
    background-color: #666;
    border-radius: 20px;
    border: 2px solid #eee;
}
.customChooseoptions li {
    cursor: pointer;
    font-weight: 500;
    font-size: 16px;
}
.customChooseoptions li:hover {
    color: #5cae48;
}
.customChooseoptions li:not(:last-child) {
    margin-bottom: 12px;
}
.customInputSearch + .customChoose.open,
.customInputSearch:focus + .customChoose {
    opacity: 1;
    top: 102%;
    z-index: 1;
}
.input-group-customSelect {
    width: 33.3%;
}
.input-group .customSelect {
    border-radius: 6px 0 0 6px !important;
}
.input-group-customSelect:not(:first-child) label {
    border-radius: 0 !important;
}
.form-select.CurrencySelect.customSelect ~ .customChoose {
    width: 168px;
    border-radius: 6px !important;
}
#login_pop .signup,
#sociallogin,
.bg_side_blue .signup {
    background: #0b3454;
    margin-right: -1px;
    border-radius: 0px 18px 18px 80px;
}
#login_pop .signup h1 {
    font-family: 'Jost', sans-serif;
    color: #fff;
}
#login_pop .signup:before {
    display: none;
}
#login_pop .signup .title {
    position: relative;
}
#login_pop .innercover {
    max-width: 385px;
    width: 90%;
    margin: auto;
    padding: 0 20px;
}
#login_pop .innercover .img {
    display: flex;
    height: auto;
    align-items: flex-end;
    margin-bottom: 37px;
    justify-content: center;
}
.innercover .img img {
    max-width: 200px;
}
.icon.icon-correct::before {
    content: '';
    width: 13px;
    height: 7px;
    border-left: 2px solid #98bbdf;
    border-bottom: 2px solid #98bbdf;
    display: inline-block;
    transform: rotate(-40deg);
    margin: 7px 3px 0 0;
    vertical-align: top;
    -webkit-transform: rotate(-40deg);
    -moz-transform: rotate(-40deg);
    -ms-transform: rotate(-40deg);
    -o-transform: rotate(-40deg);
}
.signup form .form-check-label {
    cursor: pointer;
}
.form-group label[onclick] {
    transition: all 0.3s ease-in-out;
}
.form-group.form-control-email::before {
    width: 16px;
    height: 12px;
    content: '';
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/form-email.svg) no-repeat 0 center;
    position: absolute;
    top: 15px;
    bottom: auto;
    margin: auto;
    left: 16px;
    z-index: 2;
}
.form-group.form-control-password::before {
    width: 12px;
    height: 16px;
    content: '';
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/form-lock.svg) no-repeat 0 center;
    position: absolute;
    top: 15px;
    bottom: auto;
    margin: auto;
    left: 19px;
    z-index: 2;
}
/* .form-group.form-control-mobile::before {width: 9px;height: 16px;content: '';background: url(../images/form-cell-phone.svg) no-repeat 0 center;position: absolute;top: 15px;bottom: auto;margin: auto;left: 16px;z-index: 2;} */
.form-group label[onclick]:hover,
.signup form .form-check-label[for='exampleCheck1']:hover,
.signup a:hover {
    color: #5cae48 !important;
    transition: all 0.3s ease-in-out;
    text-decoration: none;
}
form a:hover {
    text-decoration: none;
}
.form-group label[onclick]:hover {
    color: #5cae48 !important;
}
.signup form .form-check-input:not(#exampleCheck1):checked + label.form-check-label {
    background: #217aff !important;
    border-color: #217aff !important;
    color: #fff;
}
.signup form .form-check-input:checked + label .icon.icon-correct::before {
    border-color: #fff !important;
}
.signup form .form-control {
    min-height: 40px;
    border: none;
    border-radius: 6px;
    font-weight: 500;
    color: #000;
    font-family: 'Jost', sans-serif;
    font-size: 16px;
    z-index: 1;
    position: relative;
}
.signup #existing-user form .form-control {
    padding-left: 50px;
}
.signup #existing-user form .form-control#ShopLoginFormModel_email {
    background: #fff url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/form-email.svg) no-repeat 16px
        center;
}
.email-text {
    color: #ffffff99;
}
.signup #existing-user form .form-control#ShopLoginFormModel_password,
.signup #existing-user form .form-control#ShopSignupFormModel_password {
    background: #fff url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/form-lock.svg) no-repeat 19px
        center;
}
.signup #existing-user form .form-control#ShopSignupFormModel_first_name,
.signup form .form-group {
    position: relative;
}
.signup form .form-group .viewpassword {
    position: absolute;
    right: 15px;
    bottom: auto;
    top: 14px;
    margin: auto;
    display: flex;
    justify-content: center;
    align-content: center;
    z-index: 2;
}
.signup form .form-control + .viewpassword::before {
    content: '';
    width: 0%;
    height: 2px;
    background: #022d6d;
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
    transform: rotate(45deg);
    transition: all 0.3s ease-in-out;
}
.signup form .form-control[type='text'] + .viewpassword::before {
    width: 100%;
    transition: all 0.3s ease-in-out;
}
.signup form .form-check-input {
    width: 1em;
    height: 1em;
    margin-top: 0.25em;
    vertical-align: top;
    background-color: #fff;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    border: 1px solid rgba(0, 0, 0, 0.25);
    appearance: none;
    -webkit-print-color-adjust: exact;
    color-adjust: exact;
    transition: background-color 0.15s ease-in-out, background-position 0.15s ease-in-out, border-color 0.15s ease-in-out,
        box-shadow 0.15s ease-in-out;
    -webkit-transition: background-color 0.15s ease-in-out, background-position 0.15s ease-in-out, border-color 0.15s ease-in-out,
        box-shadow 0.15s ease-in-out;
    -moz-transition: background-color 0.15s ease-in-out, background-position 0.15s ease-in-out, border-color 0.15s ease-in-out,
        box-shadow 0.15s ease-in-out;
    -ms-transition: background-color 0.15s ease-in-out, background-position 0.15s ease-in-out, border-color 0.15s ease-in-out,
        box-shadow 0.15s ease-in-out;
    -o-transition: background-color 0.15s ease-in-out, background-position 0.15s ease-in-out, border-color 0.15s ease-in-out,
        box-shadow 0.15s ease-in-out;
}
.signup form .form-check .form-check-input {
    float: left;
    margin-left: -1.5em;
}
.signup form .form-check-input[type='checkbox'] {
    border-radius: 0.25em;
}
.signup form .form-check-input:checked {
    background-color: #7fb507;
    border-color: #7fb507;
}
.signup form .form-check-input:checked[type='checkbox'] {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.signup .owl-dots .owl-dot {
    box-shadow: 0 0 0 0;
}
.signup .owl-theme .owl-dots .owl-dot.active span,
.signup .owl-theme .owl-dots .owl-dot:hover span {
    background: #585858;
    opacity: 0.8;
}
.login-footer {
    margin: 50px 0;
}
.login-footer p {
    font-size: 12px;
    font-weight: 600;
    margin: 0;
    position: relative;
}
.login-footer p::after {
    background: #c5c5c5;
    width: 100%;
    height: 1px;
    position: absolute;
    bottom: 7px;
    margin: auto;
    content: '';
    left: 0;
    right: 0;
}
.login-footer p b {
    font-size: 12px;
    font-weight: 600;
    margin: 0;
    position: relative;
    z-index: 2;
    background: #fff;
    padding-right: 15px;
}
.login-footer > span {
    color: #060606;
    font-size: 12px;
    line-height: 16px;
    opacity: 0.6;
}
.signup .or {
    margin: 0 0 20px;
    text-align: center;
    display: inline-block;
    width: 100%;
    font-size: 18px;
    line-height: 22px;
    color: #fff;
    position: relative;
}
#existing-user.active ~ div .btn-signin {
    display: none;
}
.input-otp {
    max-width: 60px;
    width: 100%;
    outline: none;
    box-shadow: none;
}
#new-user.active ~ div .btn-signup {
    display: none;
}
#new-user .nav-pills .nav-link {
    background: #fff;
    width: 100%;
}
#new-user .nav-pills .nav-link.active {
    background: #217aff;
}
#new-user ul.nav-pills li {
    width: 30%;
}
#new-user .nav-pills .nav-link.active .icon.icon-correct::before {
    border-color: #fff !important;
}
#pills-others.active + div {
    display: none;
}
.or::after {
    background: #38566e;
    width: 100%;
    height: 1px;
    position: absolute;
    bottom: 7px;
    margin: auto;
    content: '';
    left: 0;
    right: 0;
    max-width: 463px;
}
.signup .or b {
    font-weight: 400;
    font-family: 'Jost', sans-serif;
    background: #0b3454;
    position: relative;
    z-index: 2;
    padding: 0 10px;
}
.sociallnks {
    text-align: center;
}
.sociallnks p {
    font-size: 14px;
    line-height: 17px;
    color: #fff;
    font-family: 'Jost', sans-serif;
    margin: 0;
    font-weight: 400;
}
.sociallnks p a {
    color: #a2e609;
    font-weight: 500;
}
.sociallnks p a:hover {
    text-decoration: none;
}
.sociallinks ul {
    list-style: none;
}
.sociallnks ul {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    justify-content: center;
}
.sociallnks ul li a {
    background: #ffffff;
    box-shadow: 0px 5px 10px #0000001a;
    border-radius: 18px;
    width: 100%;
    display: flex;
    height: 36px;
    justify-content: center;
    align-items: center;
}
.sociallnks ul li {
    width: 100px;
    margin: 20px 10px;
}
.signup form .gendar-radio-button + label {
    float: left;
    padding: 0.5em 1em;
    cursor: pointer;
    border: 1px solid #28608f;
    margin-right: -1px;
    color: #000;
    background-color: #ffffff;
    width: 100%;
    border-radius: 6px;
    min-height: 40px;
    display: flex;
    align-items: center;
    border: none;
}
.signup form .error .error-valid-text {
    color: #fff !important;
    margin-top: 3px;
}
.signup form .error .form-control {
    background-color: #f7d7d7 !important;
    border: 1px solid #fd7373;
}
.signup form .gendar-radio-button + label:first-of-type {
}
.signup form .gendar-radio-button + label:last-of-type {
}
.signup form .gendar-radio-button:checked + label {
    background-color: #1074e9;
    color: #fff;
}
.btn-access {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
}
#new-user .progress {
    height: 6px;
    background: #051c3e;
}
#new-user a#but_add {
    cursor: pointer;
}
#myloginTab {
    display: flex;
}
#myloginTab li {
    flex: 2 1;
}
#myloginTab li button {
    width: 100%;
    border: 0;
    border-radius: 0;
    line-height: 70px;
    padding: 0;
    font-size: 14px;
    font-weight: 500;
    font-family: 'Jost', sans-serif;
    background: #04243c;
    color: rgba(255, 255, 255, 0.5);
}
#myloginTab li button.active {
    background: #0b3454;
    color: #fff;
}
.daterangepicker .calendar-table th {
    background-image: none;
}
.daterangepicker .calendar-table .next span {
    transform: rotate(130deg);
    -webkit-transform: rotate(130deg);
}
.page_loader {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(0, 0, 0, 0.8);
    z-index: 999999999;
}
.page_loader .sr-only {
    font-size: 0;
}
.page_loader .spinner-border {
    border-color: #fff #fff #fff transparent;
    width: 100px;
    height: 100px;
    border-width: 10px;
}
.css-b62m3t-container .css-t3ipsp-control,
.css-b62m3t-container,
.css-13cymwt-control {
    height: 43px !important;
    border: 0 !important;
    flex: 1 1;
}
div.css-9kqgro-control,
div.css-xpesdl-control,
div.css-9kqgro-control {
    min-height: 38px !important;
    margin-top: 1px;
    margin-right: 1px;
}
div.css-1fdsijx-ValueContainer {
    padding: 0;
}
div.css-3w2yfm-ValueContainer {
    display: inline-block;
    overflow: hidden;
    padding-left: 8px;
    text-overflow: ellipsis;
    white-space: nowrap;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow-x: auto;
    scrollbar-width: thin;
}
div.css-3w2yfm-ValueContainer::-webkit-scrollbar {
    height: 3px;
}
div.css-3w2yfm-ValueContainer::-moz-scrollbar {
    height: 3px;
}
div.css-3w2yfm-ValueContainer::-webkit-scrollbar-track {
    background: #ccc;
}
div.css-3w2yfm-ValueContainer::-webkit-scrollbar-thumb {
    background-color: #666;
    border-radius: 20px;
    border: 2px solid #666;
}
div.css-1p3m7a8-multiValue {
    display: inline-flex;
}
.delete-sticky {
    position: sticky;
    top: 147px;
    right: 0;
    text-align: right;
    cursor: pointer;
}
.blue-tick {
    color: blue;
}
/* Profile Registration End */

/* Alumni Dashboard Start */
@font-face {
    font-family: 'icomoon';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
    src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('embedded-opentype'), url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('truetype'), url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format('woff'),
        url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format('svg');
    font-weight: normal;
    font-style: normal;
    font-display: block;
}
[class^='icon-'],
[class*=' icon-'] {
    font-family: 'icomoon' !important;
    speak: never;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
.icon-add-user:before {
    content: '\\e900';
}
.icon-notification:before {
    content: '\\e901';
}
.icon-book:before {
    content: '\\e902';
}
.icon-box:before {
    content: '\\e903';
}
.icon-brife-case:before {
    content: '\\e904';
}
.icon-calendar:before {
    content: '\\e905';
}
.icon-calender-time:before {
    content: '\\e906';
}
.icon-chat:before {
    content: '\\e907';
}
.icon-chat-invert:before {
    content: '\\e908';
}
.icon-check:before {
    content: '\\e909';
}
.icon-check-list:before {
    content: '\\e90a';
}
.icon-clipboard:before {
    content: '\\e90b';
}
.icon-correct:before {
    content: '\\e90c';
}
.icon-correct-invert:before {
    content: '\\e90d';
}
.icon-cross:before {
    content: '\\e90e';
}
.icon-dashboard:before {
    content: '\\e90f';
}
.icon-down-arrow:before {
    content: '\\e910';
}
.icon-down-arrow-invert:before {
    content: '\\e911';
}
.icon-edit:before {
    content: '\\e912';
}
.icon-edit-pencil:before {
    content: '\\e913';
}
.icon-mail:before {
    content: '\\e914';
}
.icon-filter:before {
    content: '\\e915';
}
.icon-folder:before {
    content: '\\e916';
}
.icon-goal:before {
    content: '\\e917';
}
.icon-headphones:before {
    content: '\\e918';
}
.icon-heart:before {
    content: '\\e919';
}
.icon-info:before {
    content: '\\e91a';
}
.icon-insert-picture-icon:before {
    content: '\\e91b';
}
.icon-insert-picture-square:before {
    content: '\\e91c';
}
.icon-invert-cross:before {
    content: '\\e91d';
}
.icon-invert-down-arrow:before {
    content: '\\e91e';
}
.icon-invert-play:before {
    content: '\\e91f';
}
.icon-key:before {
    content: '\\e920';
}
.icon-laptop:before {
    content: '\\e921';
}
.icon-left-arrow:before {
    content: '\\e922';
}
.icon-like:before {
    content: '\\e923';
}
.icon-location-pin:before {
    content: '\\e924';
}
.icon-lock:before {
    content: '\\e925';
}
.icon-log-in:before {
    content: '\\e926';
}
.icon-multiple-users:before {
    content: '\\e927';
}
.icon-pdf:before {
    content: '\\e928';
}
.icon-pdf-upload:before {
    content: '\\e929';
}
.icon-profit-report:before {
    content: '\\e92a';
}
.icon-qualified:before {
    content: '\\e92b';
}
.icon-question:before {
    content: '\\e92c';
}
.icon-ribbon:before {
    content: '\\e92d';
}
.icon-ribbon-invert:before {
    content: '\\e92e';
}
.icon-right-arrow:before {
    content: '\\e92f';
}
.icon-rupee:before {
    content: '\\e930';
}
.icon-rupee-invert:before {
    content: '\\e931';
}
.icon-search:before {
    content: '\\e932';
}
.icon-setting:before {
    content: '\\e933';
}
.icon-share:before {
    content: '\\e934';
}
.icon-shuttle:before {
    content: '\\e935';
}
.icon-shuttle-invert:before {
    content: '\\e936';
}
.icon-sound:before {
    content: '\\e937';
}
.icon-speak:before {
    content: '\\e938';
}
.icon-star:before {
    content: '\\e939';
}
.icon-study:before {
    content: '\\e93a';
}
.icon-switch:before {
    content: '\\e93b';
}
.icon-university:before {
    content: '\\e93c';
}
.icon-up-arrow:before {
    content: '\\e93d';
}
.icon-upload:before {
    content: '\\e93e';
}
.icon-upload-big-arrow:before {
    content: '\\e93f';
}
.icon-user-invert:before {
    content: '\\e940';
}
.icon-user:before {
    content: '\\e941';
}
.icon-varified:before {
    content: '\\e942';
}
.icon-video-camera:before {
    content: '\\e943';
}
.icon-view:before {
    content: '\\e944';
}
.icon-world:before {
    content: '\\e945';
}
.icon-hat:before {
    content: '';
}
.custom-header {
    min-height: 85px;
    overflow: hidden;
}
.custom-header:hover {
    overflow: visible;
}
header {
    position: relative;
    z-index: 99;
    background: #fff;
}
.univarsity_logo {
    display: flex;
    align-items: center;
    padding: 0;
    width: auto;
}
.univarsity_logo .logo img {
    max-height: 70px;
    width: auto;
    max-width: 170px;
}
.profileSection {
    display: flex;
}
.manager_profile .profileSection {
    margin: 0 0 0 20px;
    padding: 0 0 0 20px;
    border-left: 1px solid #e1dede;
    display: none;
}
.profileNamePosition .position {
    background: #d6ffcc;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 500;
    text-align: center;
    line-height: 20px;
    height: 20px;
    -webkit-border-radius: 12px;
    -moz-border-radius: 12px;
    -ms-border-radius: 12px;
    -o-border-radius: 12px;
}
.profileNamePosition {
    margin-left: 10px;
}
.profileNamePosition .name {
    font-weight: 500;
    font-size: 16px;
}
.search {
    max-width: 400px;
    padding: 0;
    background: #f1f1f1;
    border-radius: 20px;
    height: 40px;
    -webkit-border-radius: 20px;
    -moz-border-radius: 20px;
    -ms-border-radius: 20px;
    -o-border-radius: 20px;
}
.headerRightSide {
    padding: 0;
    display: flex;
    width: auto;
    z-index: 1;
}
.headerRightSide > ul li:not(:last-child) {
    margin-right: 20px;
}
.headerRightSide > ul li {
    display: flex;
    align-items: center;
    justify-content: right;
}
.headerRightSide > ul li div.username > label {
    overflow: hidden;
    border-radius: 50%;
}
.userimg {
    font-size: 34px;
    color: #0b3454;
}
.headerRightSide > ul li .username {
    margin-right: 18px;
}
.headerRightSide > ul li div.username > i {
    top: 15px;
    right: -14px;
    font-size: 9px;
    cursor: pointer;
}
.headerRightSide > ul li div.username:hover > i {
    color: #5cae48;
}
.headerRightSide > ul li div.username:hover {
    overflow: visible;
}
.headerRightSide > ul li a {
    cursor: pointer;
}
.headerRightSide > ul li a.mail {
    position: relative;
}
.headerRightSide > ul li a.mail .count {
    position: absolute;
    background: #5cae48;
    border-radius: 50%;
    color: #fff;
    font-size: 12px;
    width: 17px;
    height: 17px;
    display: flex;
    align-items: center;
    justify-content: center;
    top: -10px;
    right: -10px;
}
.headerRightSide > ul li a.invite {
    background: #5cae48;
    border-radius: 25px;
    height: 35px;
    padding: 0 10px;
    display: flex;
    align-items: center;
    text-decoration: none;
    color: #fff;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.headerRightSide > ul li a.invite:hover {
    background: #408e2d;
    color: #fff;
}
.headerRightSide > ul li a:hover,
.username:hover .userimg {
    color: #5cae48;
}
.headerRightSide .user-dropdown ul li a b {
    font-size: 12px;
    color: #5cae48;
}
.userimg {
    cursor: pointer;
    vertical-align: bottom;
}
.search .form-control {
    border: 0;
    background: none;
    height: 38px;
    border-radius: 20px;
}
.search .form-control::placeholder {
    color: rgba(0, 0, 0, 0.8);
    opacity: 1;
    font-size: 16px;
    font-weight: 400;
}
.search .form-control:-ms-input-placeholder {
    color: #000;
}
.search .form-control::-ms-input-placeholder {
    color: #000;
}
.form-control:focus,
.search .btn-search:focus {
    box-shadow: none;
}
.form-control:focus-visible,
.search .btn-search:focus-visible {
    outline: none;
}
.search .btn-search {
    font-size: 13px;
    padding: 0;
    width: 28px;
    height: 28px;
    padding: 0;
    position: absolute;
    right: 7px;
    top: 7px;
}
.search .btn-search:hover {
    color: #26a7df;
}
.search > form,
.search > div {
    position: relative;
}
.search > form input:focus,
.search > div input:focus {
    box-shadow: none;
    background: #fff;
}
.search > form input:focus + .btn-search,
.search > div input:focus + .btn-search {
    color: #000;
}
.user-dropdown {
    background: #ffffff;
    box-shadow: 0px 3px 6px #0000001a;
    border: 1px solid #d2d2d2;
    border-radius: 6px;
    top: 80px;
    right: -17px;
    z-index: 1;
    width: 150px;
    opacity: 0;
    position: absolute;
    transition: all 0.3s ease-in-out;
}
.username:hover div.user-dropdown {
    opacity: 1;
    top: 50px;
}
.username:hover div.user-dropdown::before {
    width: 20px;
    height: 20px;
    content: '';
    position: absolute;
    top: -20px;
    right: 6px;
}
.username:not(:hover) div.user-dropdown ul li a {
    pointer-events: none;
}
.user-dropdown ul {
    padding: 15px;
    margin: 0;
}
.headerRightSide * {
    transition: all 0.3s ease-in-out;
}
.headerRightSide .user-dropdown ul li a {
    color: #000;
    text-decoration: none;
    font-weight: 500;
    font-size: 14px;
}
.headerRightSide .user-dropdown ul li a .message_count {
    font-size: 12px;
    width: 17px;
    height: 17px;
    background: #5cae48;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    color: #fff;
}
.headerRightSide .user-dropdown ul li a:hover {
    color: #5cae48;
}
.headerRightSide .user-dropdown ul li:not(:last-child) {
    margin: 0 0 15px 0;
}
.headerRightSide > ul {
    display: flex;
    align-items: center;
    list-style: none;
    margin: 0;
    padding: 0;
}
.calender {
    width: 20px;
    height: 21px;
    display: inline-block;
    text-decoration: none;
    color: #0b3454;
    font-size: 20px;
}
.mail {
    width: 18px;
    display: inline-block;
    color: #0b3454;
    font-size: 18px;
    text-decoration: none;
}
.notification {
    width: 20px;
    height: 21px;
    display: inline-block;
    font-size: 20px;
    color: #0b3454;
    text-decoration: none;
}
.mobileonly {
    display: none;
}
.btn-search-toggle {
    display: none;
}
.main {
    position: relative;
}
.main.dashboard::before {
    content: '';
    width: 50%;
    height: 100%;
    background: #f3f3f3;
    position: absolute;
}
.mainContainer {
    position: relative;
    background: #fff;
}
.sideBar * {
    transition: all 0.3s ease-in-out;
}
.sideBar {
    width: 80px;
    position: relative;
    z-index: 1;
}
.sideBar ul {
    background: #f3f3f3;
    box-shadow: 8px 10px 10px 0px #e8e8e8;
    border-right: 1px solid #dbdbdb;
    list-style: none;
    padding: 36px 0 0 0;
    margin: 0;
    height: 100%;
    width: 80px;
}
.sideBar ul:hover {
    width: 260px;
}
.sideBar ul li a {
    width: 100%;
    float: left;
    display: flex;
    align-items: center;
    color: #000;
    text-decoration: none;
    cursor: pointer;
}
.sideBar ul li a > b {
    width: 60px;
    height: 60px;
    border-radius: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto 0;
    max-width: 60px;
    font-size: 25px;
    position: relative;
}
.sideBar ul li:not(.active) a > b::after {
    position: absolute;
    width: 0%;
    height: 0%;
    content: '';
    background: transparent;
    border-radius: 50%;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    transition: all 0.3s ease-in-out;
}
.sideBar ul li:not(.active) a > b::before {
    position: relative;
    z-index: 2;
}
.sideBar ul li:not(.active) a:hover > b::after {
    width: 100%;
    height: 100%;
}
.sideBar ul li:hover a > b {
    color: #26a7df;
}
.sideBar ul li.active a > b {
    background: #26a7df;
    color: #fff;
}
.sideBar ul li a span {
    padding: 0 0 0 13px;
    font-size: 18px;
    line-height: 22px;
    width: 0;
    overflow: hidden;
}
.sideBar ul:hover li a span {
    width: 199px;
}
.sideBar ul li a span b {
    width: 175px;
    display: flex;
    align-items: center;
    font-weight: 400;
}
.pageContent {
    padding-left: 50px;
}
.btn-green {
    background: #5cae48;
    height: 40px;
    padding: 0 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    text-decoration: none;
    font-size: 16px;
    line-height: 16px;
    font-weight: 500;
    position: relative;
    overflow: hidden;
    border: 0;
    border-radius: 27px;
    -webkit-border-radius: 27px;
    -moz-border-radius: 27px;
    -ms-border-radius: 27px;
    -o-border-radius: 27px;
}
.btn-green:hover {
    color: #eeffea;
}
.btn-green .icon-question.circle {
    border-radius: 50%;
    border: 2px solid #fff;
    padding: 2px;
    font-size: 12px;
    width: 22px;
    height: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 4px;
}
.btn-green:focus-visible {
    background: #5cae48;
}
.welcome-title h1 {
    font-size: 35px;
    font-weight: 600;
    margin: 0 0 5px;
}
.welcome-title p {
    font-size: 18px;
    margin: 0;
}
.footer {
    padding: 20px 40px 40px;
    border-top: 0px solid #dedede;
    display: flex;
    justify-content: space-between;
    font-size: 14px !important;
}
.powerby {
    display: flex;
    flex-direction: column;
}
.milestone {
    background: #fff;
    box-shadow: 0px 3px 6px #0000001a;
    border: 1px solid #d2d2d2;
    border-radius: 6px;
    height: 100%;
    position: relative;
    padding: 30px;
    text-align: center;
    display: flex;
    flex-direction: column;
}
.milestone .icon {
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    top: -33px;
    background: #d42941;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
}
.milestone .icon span {
    font-size: 32px;
    color: #fff;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.milestone .icon span:before {
    color: #fff;
}
.milestone .count {
    font-size: 22px;
    font-weight: 600;
    text-align: left;
}
.milestone .count {
    font-size: 22px;
    font-weight: 600;
    position: absolute;
    left: 15px;
    top: 12px;
}
.milestone .btn,
.activity-btn {
    height: 40px;
    text-align: center;
    margin: auto;
    display: inline-block;
    padding: 0 25px;
    border-radius: 25px;
    line-height: 36px;
    overflow: hidden;
    position: relative;
}
.milestone .btn span,
.btn-green span,
.activity-btn span {
    position: relative;
}
.activity-btn {
    min-width: 140px;
}
.btn-complete-now {
    background: #0b3454;
    color: #fff;
}
.btn-complete-now::before {
    position: absolute;
    content: '';
    left: 0;
    top: 0;
    bottom: 0;
    width: 0;
    background: #185584;
    transition: all 0.3s ease-in-out;
}
.btn-complete-now:hover::before {
    width: 100%;
    transition: all 0.3s ease-in-out;
}
.btn-complete-now:hover {
    color: #fff;
}
.btn-completed {
    background: #5cae48;
    color: #fff;
}
.btn-green::before {
    position: absolute;
    content: '';
    left: 0;
    top: 0;
    bottom: 0;
    width: 0;
    background: #398227;
    transition: all 0.3s ease-in-out;
}
.btn-green:hover::before {
    width: 100%;
    transition: all 0.3s ease-in-out;
}
.btn-completed:hover {
    color: #d7f7cf;
}
.btn-completed .icon-correct {
    font-size: 12px;
}
.milestone .count {
    font-size: 22px;
    font-weight: 600;
    position: absolute;
    left: 15px;
    top: 12px;
}
.milestone h3 {
    text-align: center;
    width: calc(100% - 34px);
    margin: 10px auto 0;
    font-size: 20px;
    font-weight: 600;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 25px;
}
.milestone .progress-status {
    padding: 0;
    display: flex;
    text-align: center;
    list-style: none;
    justify-content: center;
    align-items: center;
    margin: 16px 0 0;
}
.milestone .progress-status li {
    width: 40px;
    height: 3px;
    background: #dedede;
    display: inline-block;
    margin: 0 7px;
}
.milestone .progress-status li.completed {
    background: #5cae48;
}
.activities_status {
    font-size: 16px;
    font-weight: 600;
    text-align: center;
    margin-bottom: 20px;
    cursor: pointer;
    padding: 15px 0 0 0;
}
.sticky-notification {
    background: #0b3454;
    box-shadow: 0px 5px 10px #0b345463;
    border-radius: 6px;
    max-width: 840px;
    margin: auto auto 50px;
    position: relative;
    height: 100px;
    align-items: flex-end;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    -ms-border-radius: 6px;
    -o-border-radius: 6px;
}
.sticky-notification .btn-close {
    color: #fff;
    opacity: 1;
    font-size: 9px;
    position: absolute;
    top: 10px;
    right: 10px;
    text-decoration: none;
}
.sticky-notification .imgplace {
    padding-left: 5px;
}
.sticky-notification .notification-detail {
    flex: 1 1;
    height: 100%;
    justify-content: space-around;
}
.sticky-notification .notification-detail p {
    margin: 0;
    color: #fff;
    max-width: 315px;
}
.imglink {
    max-width: 299px;
    width: 100%;
}
.imglink .imgplace {
    display: none;
}
.sticky-notification .notification-detail .links {
    max-width: 299px;
    display: flex;
    justify-content: space-between;
    width: 100%;
}
.btn-message {
    background: #fff;
    padding: 0 25px;
    line-height: 38px;
    text-decoration: none;
    border-radius: 25px;
    color: #000;
    transition: all 0.3s ease-in-out;
    position: relative;
    overflow: hidden;
}
.btn-message span {
    position: relative;
}
.btn-message::before {
    width: 0;
    height: 100%;
    content: '';
    background: #a4a4a4;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    transition: all 0.3s ease-in-out;
}
.btn-message:hover::before {
    width: 100%;
}
.btn-message:hover {
    color: #fff;
}
#dashboard-pills-tab.nav-pills .nav-link {
    width: 175px;
    border-radius: 25px;
    border: 2px solid #7d7d7d;
    color: #414141;
}
#dashboard-pills-tab.nav-pills .nav-item:not(:last-child) {
    margin-right: 15px;
}
#dashboard-pills-tab.nav-pills .nav-link.active {
    background: #5cae48;
    border-color: #5cae48;
    color: #fff;
}
.expandOption {
    text-align: right;
    margin: 10px 0 20px;
}
.expandOption .btn-expand {
    font-size: 16px;
    font-weight: 500;
    color: #147ad6;
}
.expandOption .btn-expand .colapse {
    display: none;
}
.expandOption .btn-collapse .expand {
    display: none;
}
.dashboardAccordion .accordion-item:not(:last-child) {
    margin-bottom: 20px;
}
.dashboardAccordion .accordion-item {
    border: 1px solid #d2d2d2;
    border-radius: 6px;
}
.dashboardAccordion .accordion-item .accordion-button {
    background-color: transparent;
    font-size: 22px;
    font-weight: 600;
    color: #000;
    box-shadow: none;
    padding: 20px 13px 20px 30px;
}
.dashboardAccordion .accordion-item .accordion-button.text-burgandi {
    color: #d42941;
}
.dashboardAccordion .accordion-item .accordion-button span {
    font-size: 19px;
    margin-left: 40px;
    color: #0b3454;
}
.dashboardAccordion .accordion-item .accordion-button::after {
    content: '';
    background-color: #fff;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
    background-repeat: no-repeat;
    background-position: center;
    background-size: 20px 20px;
    width: 20px;
    height: 20px;
}
.dashboardAccordion .accordion-item .accordion-body {
    padding: 10px 30px 30px;
}
.dashboardAccordion h3 {
    font-size: 22px;
    font-weight: 600;
    margin: 0;
}
.orange {
    background-color: #ff9f40;
}
.dark-blue {
    background-color: #147ad6;
}
.lite-red {
    background-color: #ff6384;
}
.gold {
    background-color: #ffcd56;
}
.cyan {
    background-color: #4bc0c0;
}
.pink {
    background-color: #e86bc2;
}
.yellow {
    background-color: #f9ff54;
    border: 1px solid #f0f64b;
}
.sky-blue {
    background-color: #79d2de;
}
.bg-red {
    background: #d52941; /* background:#b92940*/
}
.bg-gray {
    background: #f8f8f8;
}
.bg-lighter-blue {
    background: #f2f9ff;
}
.radius-10 {
    border-radius: 10px;
}
.custom-border-84 {
    width: 24px;
    height: 24px;
    border-width: 2px;
    border-color: #848484;
}
.custom-border-84.form-check-input:checked {
    background-color: #848484 !important;
    border-color: #848484 !important;
    box-shadow: inset 0 0 0 4px #fff;
    background-image: none !important;
}
.custom-border-84-20 {
    width: 20px;
    height: 20px;
    border-width: 2px;
    border-color: #848484;
}
.custom-border-84-20.form-check-input:checked {
    background-color: #848484 !important;
    border-color: #848484 !important;
    box-shadow: inset 0 0 0 4px #fff;
    background-image: none !important;
}
.custom-border-white.form-check-input {
    width: 18px;
    height: 18px;
}
.custom-border-white.form-check-input:checked {
    background-color: #707070 !important;
    border-color: #707070 !important;
    box-shadow: inset 0 0 0 4px #fff;
    background-image: none !important;
}
.blue-strip > div:nth-child(2n) {
    background: #f2f9ff;
}
.graph-result-list ul {
    margin: 20px auto 0;
    padding: 0;
    list-style: none;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    max-width: 317px;
}
.graph-result-list ul li {
    min-width: auto;
    display: flex;
    align-items: center;
    margin: 0 11px 10px 0;
}
.graph-result-list ul li .color {
    width: 16px;
    height: 16px;
    display: inline-block;
    margin: 0 11px 0 0;
    border-radius: 2px;
}
.graph-result-list.oneLine ul,
.graph-result-list.rightPaneColor ul {
    max-width: initial;
}
.graph-result-list.oneLine ul li:last-child,
.graph-result-list.rightPaneColor ul li:last-child {
    margin-right: 0;
}
.onboardingLaunchGraph ul,
.triangleGraph ul {
    padding: 0;
    margin: 0;
    text-align: right;
    list-style: none;
}
.onboardingLaunchGraph ul li,
.triangleGraph ul li {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
}
.onboardingLaunchGraph ul li div,
.triangleGraph ul li div {
    width: 100%;
    text-align: center;
    height: 65px;
    margin-bottom: 2px;
    display: flex;
    max-width: 380px;
    justify-content: center;
}
.onboardingLaunchGraph ul li div span,
.triangleGraph ul li div span {
    display: flex;
    justify-content: center;
    height: 100%;
    align-items: center;
    color: #fff;
    font-weight: 500;
    font-size: 16px;
    position: relative;
}
.onboardingLaunchGraph ul li div span:before,
.triangleGraph ul li div span:before {
    content: '';
    width: 0;
    height: 0;
    position: absolute;
    left: 0;
    bottom: 0;
    border-width: 34px 10px 34px 10px;
    border-style: solid solid solid solid;
    border-color: transparent white white transparent;
}
.onboardingLaunchGraph ul li div span::before,
.triangleGraph ul li div span::before {
    transform: scaleX(-1);
    -webkit-transform: scaleX(-1);
    -moz-transform: scaleX(-1);
    -ms-transform: scaleX(-1);
    -o-transform: scaleX(-1);
}
.onboardingLaunchGraph ul li div span:after,
.triangleGraph ul li div span:after {
    content: '';
    width: 0;
    height: 0;
    position: absolute;
    right: 0;
    bottom: 0;
    border-width: 34px 10px 34px 10px;
    border-style: solid solid solid solid;
    border-color: transparent white white transparent;
}
.onboardingLaunchGraph ul li:nth-child(1) div span,
.triangleGraph ul li:nth-child(1) div span {
    width: 100%;
    background: #ff9f40;
}
.onboardingLaunchGraph ul li:nth-child(2) div span,
.triangleGraph ul li:nth-child(2) div span {
    width: calc(100% - 40px);
    margin: 0 20px;
    background: #147ad6;
}
.onboardingLaunchGraph ul li:nth-child(3) div span,
.triangleGraph ul li:nth-child(3) div span {
    width: calc(100% - 80px);
    margin: 0 40px;
    background: #4bc0c0;
}
.onboardingLaunchGraph ul li:nth-child(4) div span,
.triangleGraph ul li:nth-child(4) div span {
    width: calc(100% - 60px);
    margin: 0 60px;
    background: #ff6384;
}
.onboardingLaunchGraph ul li:nth-child(5) div span,
.triangleGraph ul li:nth-child(5) div span {
    width: calc(100% - 160px);
    margin: 0 60px;
    background: #ffcd56;
}
.onboardingLaunchGraph ul li:nth-child(6) div span,
.triangleGraph ul li:nth-child(6) div span {
    width: calc(100% - 200px);
    margin: 0 60px;
    background: #e86bc2;
}
.onboardingLaunchGraph ul li label,
.triangleGraph ul li label {
    font-size: 16px;
    font-weight: 600;
    margin-left: 40px;
    white-space: nowrap;
    position: absolute;
    right: 0;
}
.blue-container {
    background: #26a7df url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/bulb.jpg) no-repeat right
        20px bottom 20px;
    border-radius: 6px;
    padding: 25px 30px;
    color: #fff;
    height: 100%;
}
.onboarding {
    max-width: 120px;
    height: 35px;
    border-radius: 25px;
    font-size: 16px;
    line-height: 16px;
    margin-bottom: 25px;
    border: 2px solid #7d7d7d;
}
.highlight-text {
    text-align: center;
    margin: 20px 0 0;
    font-size: 16px;
    font-weight: 500;
}
.dashboardAccordion .blue-container h3 {
    font-size: 20px;
    font-weight: 500;
}
.blue-container ul {
    margin: 0;
    padding: 0;
    list-style: none;
}
.blue-container ul li {
    margin-bottom: 25px !important;
}
.blue-container ul li {
    position: relative;
    padding: 0 0 0 19px;
}
.blue-container ul li:before {
    content: '';
    width: 3px;
    height: 14px;
    background: #fff;
    position: absolute;
    left: 0;
    top: 6px;
    display: inline-block;
    border-radius: 55px;
}
.blue-container ul li p {
    margin: 0;
}
.actionableInsights {
    max-width: 350px;
}
#milestoneProgress-collapseThree .graph-result-list ul,
#tasksAssessmentsProgress-collapseFour .graph-result-list ul {
    max-width: initial;
}
.milestoneProgressGraph {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    justify-content: space-between;
}
.milestoneGraph {
    min-height: 260px;
    width: 16%;
}
.milestoneGraph .progress {
    width: 30%;
    height: auto;
}
.dashboardAccordion .milestoneGraph h3 {
    font-size: 16px;
    margin: 0 0 10px;
}
#milestoneProgress-collapseThree .graph-result-list ul li:last-child {
    margin-right: 0;
}
#tasksAssessmentsProgress-collapseFour .graph-result-list ul li:last-child {
    margin-right: 0;
}
.status_progress {
    max-width: 260px;
    height: 40px;
    width: 260px;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    overflow: hidden;
    border-radius: 3px;
}
.status_progress > div {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
}
.tablesection {
}
.tablesection > .table {
    border: 1px solid #d2d2d2;
    border-radius: 6px;
    overflow: auto;
    padding: 0px;
}
.tablesection > .table thead {
    background: #0b3454;
    color: #fff;
}
.tablesection > .table > .table {
    margin: 0;
}
.tablesection > .table > .table tr:last-child {
    border-color: transparent;
}
.tablesection > .table > .table tr th + th,
.tablesection > .table > .table tr td {
    text-align: center;
    vertical-align: middle;
}
.alumni_directory_details .tablesection > .table > .table tr th + th,
.alumni_directory_details .tablesection > .table > .table tr td {
    text-align: left;
    font-weight: 500;
}
.tablesection > .table > .table > tbody th {
    font-weight: 500;
}
#tasksAssessmentsProgress-headingFour .tablesection > .table > .table tr td:last-child {
    width: 260px;
}
.tablesection > .table > .table th,
.tablesection > .table > .table td {
    vertical-align: middle;
    padding: 15px 25px;
}
.tablesection > .table > .table thead tr th {
    text-transform: uppercase;
    font-weight: 500;
    height: 57px;
}
.tablesection > .table > .table td a {
    color: #147ad6;
}
.tablesection > .table > .table td a:hover {
    color: #0b3454;
}
.tablesection > .table > .table td a.btn-border {
    color: #fff;
}
.tablesection > .table > .table td a.btn-border:hover {
    color: #fff;
}
.btn-border-gray {
    border-radius: 25px !important;
    padding: 0 25px;
    line-height: 32px;
    border: 2px solid #7d7d7d;
    height: 35px;
    display: inline-flex;
    text-decoration: none;
    color: #000;
    transition: all 0.3s ease-in-out;
    position: relative;
    overflow: hidden;
    justify-content: center;
    align-items: center;
    background: #fff;
    -webkit-border-radius: 25px !important;
    -moz-border-radius: 25px !important;
    -ms-border-radius: 25px !important;
    -o-border-radius: 25px !important;
}
.btn-border-gray::before {
    width: 0;
    height: 100%;
    content: '';
    background: #0b3454;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    transition: all 0.3s ease-in-out;
}
.btn-border-gray:hover::before {
    width: 100%;
}
.btn-border-gray:hover {
    color: #fff;
    background: #0b3454;
    border: 2px solid #0b3454;
}
.btn-border-gray span {
    position: relative;
}
.btn-border-gray-de {
    border-radius: 25px;
    padding: 0 25px;
    line-height: 32px;
    border: 2px solid #dedede;
    height: 35px;
    display: inline-flex;
    text-decoration: none;
    color: #0b3454;
    transition: all 0.3s ease-in-out;
    position: relative;
    overflow: hidden;
    justify-content: center;
    align-items: center;
    background: #fff;
}
.btn-border-gray-de::before {
    width: 0;
    height: 100%;
    content: '';
    background: #0b3454;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    transition: all 0.3s ease-in-out;
}
.btn-border-gray-de:hover::before {
    width: 100%;
}
.btn-border-gray-de:hover {
    color: #fff;
    background: #0b3454;
    border: 2px solid #0b3454;
}
.btn-border-gray-de i,
.btn-border-gray-de:hover i {
    color: #0b3454;
}
.btn-border-gray-de:hover i {
    color: #fff;
}
.btn-border-gray-de span {
    position: relative;
}
.btn-border-gray.disabled {
    opacity: 0.5;
    pointer-events: none;
}
.btn-white-border {
    padding: 0 25px;
    height: 35px;
    line-height: 30px;
    text-align: center;
    display: inline-block;
    border: 2px solid #fff;
    border-radius: 25px;
    text-decoration: none;
    color: #fff;
    margin-top: 10px;
    transition: all 0.3s ease-in-out;
    position: relative;
    overflow: hidden;
}
.btn-white-border::before {
    width: 0;
    height: 100%;
    content: '';
    background: #fff;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    transition: all 0.3s ease-in-out;
}
.btn-white-border:hover::before {
    width: 100%;
}
.btn-white-border:hover {
    background: #fff;
    color: #000;
}
.btn-white {
    padding: 0 25px;
    height: 35px;
    line-height: 35px;
    text-align: center;
    display: inline-block;
    border-radius: 35px;
    text-decoration: none;
    color: #000;
    background: #fff;
    margin-top: 10px;
    transition: all 0.3s ease-in-out;
    position: relative;
    overflow: hidden;
}
.btn-white::before {
    width: 0;
    height: 100%;
    content: '';
    background: #0b3454;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    transition: all 0.3s ease-in-out;
}
.btn-white:hover::before {
    width: 100%;
}
.btn-white:hover {
    color: #fff;
}
.btn-white span,
.btn-white-border span,
.btn-border span {
    position: relative;
}
.shortList ul {
    padding: 0;
    margin: 0 0 24px 0;
    list-style: none;
}
.shortList ul li {
    display: flex;
    justify-content: space-between;
    padding: 15px 0 15px 44px;
    position: relative;
}
.shortList ul li:not(:last-child) {
    border-bottom: 1px solid #d2d2d2;
}
.shortList ul li span {
    font-weight: 500;
}
.shortList ul li span:before {
    content: '';
    width: 24px;
    height: 24px;
    background: url(https://ap-south-1.console.aws.amazon.com/s3/object/media.univariety.com?region=ap-south-1&bucketType=general&prefix=userreactapp/style-images/flag.svg)
        no-repeat 0 0;
    position: absolute;
    left: 0;
    top: 15px;
}
.horizontalProgress .progress {
    height: 35px;
    border-radius: 4px;
    position: relative;
    background: #d8e7f2;
    margin-bottom: 28px;
}
.horizontalProgress .progress .progress-bar {
    border-radius: 4px;
    text-align: right;
    padding: 0 25px;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0.32px;
}
.horizontalProgress .progress label {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    padding-right: 20px;
    font-size: 16px;
    color: #000;
    font-weight: 500;
}
.verticle-progress .progress {
    width: 59px;
    display: flex;
    height: 177px;
    align-items: flex-end;
    margin: 0 10px;
}
.verticle-progress .progress .progress-bar {
    width: 100%;
    border-radius: 4px;
    justify-content: flex-end;
    padding-bottom: 7px;
    font-size: 16px;
    font-weight: 500;
}
.verticle-progress {
    margin-bottom: 15px;
}
.thinVerticleProgress {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 926px;
    max-width: 926px;
}
.thinVerticleProgress .verticleProgress {
    width: 28px;
    display: flex;
    justify-content: space-between;
    min-height: 510px;
    position: relative;
    flex-direction: column;
}
.thinVerticleProgress .verticleProgress .caption {
    position: relative;
    white-space: nowrap;
    text-align: right;
    flex: 1 1;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
}
.thinVerticleProgress .verticleProgress .caption span {
    position: absolute;
    transform: rotate(-90deg);
    top: 15px;
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: flex-end;
    height: 28px;
    align-items: center;
}
.thinVerticleProgress .verticleProgress .graphContainer {
    display: flex;
    justify-content: space-between;
}
.thinVerticleProgress .verticleProgress .graphContainer .progress {
    width: 11px;
    height: 177px;
    display: flex;
    align-items: flex-end;
}
.thinVerticleProgress .verticleProgress .graphContainer .progress .progress-bar {
    width: 100%;
    border-radius: 4px;
}
.width-97 {
    width: 97px;
}
.width-59 {
    width: 59px;
}
.width-56 {
    width: 56px;
}
.width-43 {
    width: 43px;
}
.height-30 {
    height: 30px !important;
}
.height-32 {
    height: 32px !important;
}
.height-35 {
    height: 35px !important;
}
.height-40 {
    height: 40px !important;
}
.height-85 {
    height: 85px !important;
}
.height-125 {
    height: 125px !important;
}
.height-217 {
    height: 217px !important;
}
.paddings-67 {
    padding-left: 67px;
}
.horizontalScrol {
    overflow-x: auto;
    padding-bottom: 30px;
}
.horizontalScrol::-webkit-scrollbar {
    height: 3px;
}
.horizontalScrol::-moz-scrollbar {
    height: 3px;
}
.horizontalScrol::-webkit-scrollbar-track {
    background: #eee;
}
.horizontalScrol::-webkit-scrollbar-thumb {
    background-color: #666;
    border-radius: 20px;
    border: 2px solid #666;
}
.bigVerticalProgress {
    display: flex;
    justify-content: start;
}
.bigVerticalProgress .graphContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
}
.bigVerticalProgress .graphContainer .progress {
    width: 100%;
    height: 177px;
    align-items: flex-end;
}
.bigVerticalProgress .graphContainer .progress .progress-bar {
    border-radius: 4px;
    width: 100%;
    justify-content: flex-end;
    padding-bottom: 0px;
    font-size: 16px;
    font-weight: 500;
}
.bigVerticalProgress .verticleProgress {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 97px;
}
.bigVerticalProgress .verticleProgress:not(:last-child) {
    margin-right: 43px;
}
.bigVerticalProgress .verticleProgress .caption {
    text-align: center;
}
.event {
    background: #ffffff;
    border: 1px solid #d2d2d2;
    border-radius: 6px;
    padding: 20px;
    margin-bottom: 14px;
}
.eventDetails {
    display: flex;
    align-items: flex-start;
}
.eventDetails .datedetail > div:not(.time) {
    width: 80px;
    height: 80px;
    background: #51499c;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-right: 20px;
}
.eventDetails .datedetail.Fair > div:not(.time) {
    background: #0b3454;
}
.eventDetails .date {
    font-size: 35px;
    font-weight: 600;
    line-height: 30px;
    color: #fff;
}
.eventDetails .month {
    color: #fff;
    font-weight: 500;
    line-height: 16px;
}
.eventType .badge {
    padding: 0 20px;
    height: 25px;
    background: #0b3454;
    border-radius: 25px;
    line-height: 20px;
    font-size: 14px;
    font-weight: 400;
    line-height: 25px;
}
.eventType h2 {
    font-size: 18px;
    margin: 12px 0 10px;
}
.hostby {
    border-top: 1px solid #dedede;
    width: 100%;
    padding: 12px 0 0 0;
    display: flex;
    align-items: center;
}
.eventType {
    flex: 1 1;
    padding: 0 5% 0 0;
}
.hostNamePosition p {
    margin: 0;
}
.hostImg {
    margin-right: 14px;
}
.dashboardAccordion .hostNamePosition h3 {
    font-size: 16px;
}
.participants {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}
.participants label {
    width: 100%;
    text-align: center;
    font-size: 16px;
    font-weight: 500;
}
.participantsnumber {
    width: 100%;
    display: flex;
    background: #f6f6f6;
    border-radius: 6px;
    padding: 11px 7px;
    margin: 5px 0 20px;
}
.participantsnumber > div {
    width: 50%;
    text-align: center;
    font-size: 16px;
    font-weight: 500;
}
.participantsnumber > div.participantsnumberuniversity {
    border-right: 1px solid #000;
}
.event a {
    color: #147ad6;
}
.event a:hover {
    color: #000;
}
.alumni_directory_details a {
    text-decoration: underline;
}
.alumni_directory_details a:hover {
    text-decoration: none;
}
.white-block {
    background: #ffffff;
    box-shadow: 0px 3px 6px #0000001a;
    border: 1px solid #d2d2d2;
    border-radius: 6px;
    opacity: 1;
    padding: 30px;
}
.white-block-notopborderradius {
    border-radius: 0 0 6px 6px;
    border-top: 0;
}
.alumni_directory_details ul.orderlist {
    list-style: none;
    padding: 0;
}
.alumni_directory_details ul.orderlist li:not(:last-child) {
    margin-bottom: 20px;
}
.alumni_directory_details ul.orderlist li {
    display: flex;
    justify-content: space-between;
    position: relative;
    padding-left: 0px;
}
.alumni_directory_details ul.orderlist li .btn-border {
    margin: 0;
    color: #fff;
    text-decoration: none;
    max-width: 154px;
    width: 100%;
    font-size: 14px;
    height: 32px;
    padding: 0 15px;
    line-height: 32px;
    font-weight: 400;
}
.alumni_directory_details ul.orderlist li p {
    margin: 3px 0 0;
    font-weight: 500;
    color: #414141;
}
.alumni_directory_details ul.orderlist li:before {
    content: '';
    width: 3px;
    height: 20px;
    background: #5cae48;
    position: absolute;
    top: 6px;
    left: 0;
    display: none;
}
.alumni_directory_details ul.orderlist.arrow li:before {
    top: 3px;
}
.alumni_directory_details ul.orderlist.arrow li {
    margin-top: 28px;
}
.gray-radius-box {
    background: #fff;
    border: 2px solid #e8e8e8;
    border-radius: 6px;
    opacity: 1;
}
.mapChart .btn-border-gray[aria-expanded='true'] {
    display: none;
}
.alumni_directory_details ul.orderlist.arrow li a {
    display: flex;
    justify-content: space-between;
    text-decoration: none;
    color: #000;
    align-items: center;
}
.alumni_directory_details ul.orderlist.arrow li a i {
    transition: all 0.2s ease-in-out;
}
.alumni_directory_details ul.orderlist.arrow li a:hover i {
    transform: translateX(3px);
}
.mapChart .accordion-item {
    border: 0;
}
.mapChart .accordion-body {
    padding: 0;
}
.mapChart .accordion-body .mapSection {
    padding: 250px 0;
    position: relative;
}
.mapChart .accordion-body .mapSection iframe {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    margin: auto;
}
.mapChart .bigVerticalProgress .graphContainer .progress .progress-bar {
    border-radius: 4px 4px 0 0 !important;
}
.mapChart .progress {
    border-radius: 0;
}
.map-Search {
    position: absolute;
    z-index: 1;
    top: 30px;
    left: 30px;
    max-width: 414px;
    width: 100%;
    height: 50px;
    background: #ffffff;
    box-shadow: 0px 0px 20px #0000001a;
    border-radius: 6px;
    opacity: 1;
}
.map-Search .btn-search {
    background: #0b3454;
    border-radius: 0px 6px 6px 0px;
    opacity: 1;
    color: #fff;
}
.presentCareer .bigVerticalProgress .graphContainer .progress {
    border-radius: 0;
}
.presentCareer .bigVerticalProgress .graphContainer .progress .progress-bar {
    border-radius: 0;
}
.presentCareer .bigVerticalProgress .graphContainer .progress .progress-bar:first-child {
    border-radius: 4px 4px 0 0;
}
.number-bg {
    width: 32px;
    height: 32px;
    background: #51499c;
    border-radius: 50%;
    text-align: center;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
}
.custom-border-gray {
    border-color: #dedede !important;
}
.custom-border-gray-848484 {
    border-color: #848484 !important;
}
.school_notification {
    padding: 0;
    margin: 0;
    list-style: none;
}
.school_notification li:not(:last-child) {
    border-bottom: 1px solid #dedede;
}
.school_notification li {
    padding: 30px 0;
    display: flex;
    justify-content: space-between;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    align-items: center;
}
.school_notification li .detail {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
}
.icon-checked {
    position: relative;
    width: 14px;
    height: 11px;
    display: inline-block;
}
.icon-checked::before,
.icon-checked::after {
    content: '';
    position: absolute;
    border-left: 2px solid #b1b1b1;
    border-bottom: 2px solid #b1b1b1;
    width: 12px;
    height: 6px;
    left: 0;
    top: 0;
    transform: rotate(-40deg);
}
.unread .icon-checked::before,
.unread .icon-checked::after {
    border-color: #26a7df;
}
.icon-checked::after {
    top: 5px;
}
.btn-close-small {
    width: 12px;
    height: 12px;
    padding: 0 !important;
    position: absolute;
    top: 25px;
    right: 25px;
    z-index: 9;
}
.input-otp {
    max-width: 80px;
    height: 60px;
    width: 100%;
    border-radius: 10px;
    border: 1px solid #848484;
    margin: 0 5px;
}
.btn-edit {
    background: #ffffff;
    border: 1px solid #e1e1e1;
    border-radius: 27px;
    opacity: 1;
    padding: 0 15px;
    margin-left: 20px;
    font-size: 14px;
    line-height: 12px;
    height: 30px;
    display: flex;
    align-items: center;
}
.profilePicSection {
    width: 200px;
    height: 200px;
    border: 1px dashed #707070;
    border-radius: 50%;
    margin: auto;
    padding: 14px;
}
.profileImg {
    background: #e3e3e3;
    width: 100%;
    height: 100%;
    border-radius: 50%;
}
.profileImg.icon-user {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 145px;
    color: #fff;
}
.editProfilePicSection {
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
}
.editprofileImg:after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 172px;
    height: 172px;
    border: 2px solid #0b3454;
    margin: auto;
    border-radius: 50%;
    box-shadow: 0 0 0 100px rgba(255, 255, 255, 0.5);
}
.small-thumb > .thumb + .thumb {
    margin-left: -30px;
}
.small-thumb {
    display: flex;
}
.thumb {
    width: 60px;
    display: inline-block;
    height: 60px;
    background: #fff;
    border-radius: 50%;
    padding: 3px;
}
#GaugeMeter_1 {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 113px;
    position: relative;
    flex-direction: column;
}
.percentage-score span {
    line-height: 20px !important;
    color: #000 !important;
    font-weight: 500;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    z-index: 2;
}
.percentage-score span::after {
    content: ' %';
    font-size: 14px;
    line-height: 14px;
    margin-left: 3px;
}
#GaugeMeter_1 canvas {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    margin: auto;
}
.percentage-score b {
    line-height: 23px !important;
    position: relative;
    z-index: 2;
    font-size: 12px;
    font-weight: 500;
    font-style: italic;
}
.alumni_directory_details .custom-border {
    border-right: 1px solid #e8e8e8;
}
.slideRange {
    appearance: none;
    width: 100%;
    height: 5px;
    border-radius: 5px;
    background: #d3d3d3;
    outline: none;
    opacity: 0.7;
    transition: opacity 0.2s;
}
.slideRange::-webkit-slider-thumb {
    appearance: none;
    width: 14px;
    height: 14px;
    border: 0;
    background: #5cae48;
    cursor: pointer;
    border-radius: 50%;
}
.slideRange::-moz-range-thumb {
    width: 14px;
    height: 14px;
    border: 0;
    background: #5cae48;
    cursor: pointer;
}
.slideRange::-ms-thumb {
    width: 14px;
    height: 14px;
    border: 0;
    background: #5cae48;
    cursor: pointer;
    border-radius: 50%;
}
.slideRange::-webkit-range-progress {
    background-color: #5cae48;
    height: 5px;
    border-radius: 5px;
}
input[type='range'].slideRange::-moz-range-progress {
    background-color: #5cae48;
    height: 5px;
    border-radius: 5px;
}
input[type='range'].slideRange::-ms-fill-lower {
    background-color: #5cae48;
    height: 5px;
    border-radius: 5px;
}
.basicInformation {
    padding: 30px 20px 40px 0;
}
.basicInformation .phone_number {
    line-height: 18px;
}
.profile_container {
    background: #ffffff;
    box-shadow: 0px 3px 6px #0000001a;
    border: 1px solid #d2d2d2;
    border-radius: 6px;
    overflow: hidden;
}
.location-pin {
    background: url(https://ap-south-1.console.aws.amazon.com/s3/object/media.univariety.com?region=ap-south-1&bucketType=general&prefix=userreactapp/style-images/pointer.png)
        no-repeat 0 0;
    width: 12px;
    display: inline-block;
    height: 16px;
    margin-top: 9px;
    vertical-align: top;
    margin-right: 5px;
}
.btn:hover .location-pin {
    filter: invert(1);
    -webkit-filter: invert(1);
}
.contactrow .country-code {
    width: 85px;
    border-radius: 0.25rem 0 0 0.25rem;
    border-right: 0 !important;
}
.contactrow #PhoneNumber {
    width: calc(100% - 85px);
    border-radius: 0 0.25rem 0.25rem 0;
}
.contactrow {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
}
.profilenameclass .profilename {
    line-height: 24px;
}
.profilenameclass .class {
    line-height: 18px;
}
#profile_progress {
    display: flex;
    align-items: center;
    width: 65px;
    margin-right: 14px;
}
#profile_progress img {
    border: 2px solid #fff;
    border-radius: 50%;
    width: 100%;
}
.profileLinks {
    display: none;
}
.profile_videos {
    height: 100%;
    background: #00000033;
    padding: 35px 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.profile_video_block {
    border: 4px solid #00000066;
    border-radius: 6px;
    max-width: 300px;
    width: 100%;
    position: relative;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    overflow: hidden;
}
.profile_video_block:hover {
    border-color: #010000;
}
.profile_video_number {
    font-size: 16px;
    line-height: 16px;
    margin-top: 15px;
    color: #fff;
}
.profile_video_block .video_thumb_title {
    text-align: center;
    position: absolute;
    bottom: -4px;
    background: #000000;
    border-radius: 6px 6px 0px 0px;
    height: 45px;
    width: 280px;
    margin: auto;
    left: 0;
    right: 0;
    font-size: 16px;
    font-weight: 500;
    color: #fff;
    line-height: 45px;
    -webkit-border-radius: 6px 6px 0px 0px;
    -moz-border-radius: 6px 6px 0px 0px;
    -ms-border-radius: 6px 6px 0px 0px;
    -o-border-radius: 6px 6px 0px 0px;
}
.profile_video_block:hover .video_thumb_title {
    color: #5cae48;
}
.profile_video_block .icon-invert-play {
    position: absolute;
    color: #000;
    font-size: 41px;
    width: 41px;
    height: 41px;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    margin: auto;
    background: #fff;
    border-radius: 50%;
    z-index: 9;
}
.profile_video_block:hover .icon-invert-play {
    color: #5cae48;
}
.profile_videos_empty {
    max-width: 282px;
    width: 90%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
}
.profile_videos_empty p {
    margin: 0 0 30px;
    color: #fff;
    text-align: center;
    font-size: 15px;
    line-height: 18px;
}
.profile_videos_empty span {
    margin-bottom: 10px;
}
.profile_videos_empty .btn-white-border {
    margin: 0;
    height: 40px;
    font-weight: 500;
}
.video_thumb img {
    transition: all 0.5s ease-in-out;
    -webkit-transition: all 0.5s ease-in-out;
    -moz-transition: all 0.5s ease-in-out;
    -ms-transition: all 0.5s ease-in-out;
    -o-transition: all 0.5s ease-in-out;
}
.profile_video_block:hover img {
    transform: scale(1.1);
    -webkit-transform: scale(1.1);
    -moz-transform: scale(1.1);
    -ms-transform: scale(1.1);
    -o-transform: scale(1.1);
}
.meter {
    background: #ffffff;
    border: 1px solid #dedede;
    border-radius: 18px;
    opacity: 1;
    padding: 5px 15px;
    transition: all 0.3s ease-in-out;
    margin-right: 5px;
    letter-spacing: 0.32px;
}
.meter:hover {
    box-shadow: 0px 0px 20px #00000033;
}
.meter:not(:last-child) {
    margin-bottom: 5px;
}
.custom_breadcrumb {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    padding: 0 0;
    margin-bottom: 0;
    list-style: none;
}
.custom_breadcrumb-item {
    padding-right: 0.5rem;
}
.custom_breadcrumb-item:not(.active)::after {
    float: right;
    padding-left: 0.5rem;
    color: #d42941;
    content: var(--bs-breadcrumb-divider, '/');
}
.custom_breadcrumb-item.active {
    color: #000;
}
.search-icon {
    padding-left: 40px;
    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/search.svg);
    background-size: 16px;
    background-repeat: no-repeat;
    background-position: 13px 13px;
}
.minus-marginx-30 {
    margin-left: -30px;
    margin-right: -30px;
}
.minus-paddingx-30 {
    padding-left: 30px;
    padding-right: 30px;
}
.padding-30 {
    padding: 30px;
}
.p-40 {
    padding: 40px;
}
.modal-content.copywriting {
    padding: 40px;
}
.copywritecontainer {
    overflow: auto;
    max-height: 565px;
    scrollbar-width: thin;
}
.copywriting .modal-header {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    margin-bottom: 25px;
    padding-bottom: 20px;
}
.copywriting .modal-header h5.modal-title {
    font-size: 28px;
    font-weight: 600;
    margin-bottom: 5px;
    line-height: 35px;
}
.copywriting .modal-header .sub-head {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 16px;
    color: #0b3454;
}
.copywriting .modal-header .sub-head span {
    position: relative;
}
.copywriting .modal-header .sub-head span:not(:first-child):before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 5px;
    height: 5px;
    background: #000;
    border-radius: 50%;
}
.copywriting .modal-header .sub-head span:not(:first-child) {
    margin-left: 15px;
    padding-left: 20px;
}
.btn-download {
    background: #ffffff;
    border: 1px solid #dedede;
    border-radius: 18px;
    opacity: 1;
    font-size: 14px;
    font-weight: 500;
    font-family: 'Jost', sans-serif;
    padding: 0 20px;
    height: 32px;
    display: flex;
    align-items: center;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    color: #0b3454;
}
.btn-download:hover {
    background: #dedede;
}
.btn-download span {
    width: 13px;
    height: 13px;
    display: inline-block;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/download.svg) no-repeat 0 0;
    margin-right: 5px;
}
.copywritecontainer h4 {
    font-size: 16px;
    font-weight: 600;
}
.copywritecontainer p {
    font-size: 16px;
    line-height: 23px;
    margin-bottom: 30px;
}
.copywritecontainer p:last-child {
    margin-bottom: 0px;
}
.copywritecontainer p a {
    color: #000;
}
.copywritecontainer p a:hover {
    color: #333;
    text-decoration: none;
}
.copywritecontainer ul {
    list-style: none;
    padding: 0;
    margin: 0 0 30px 19px;
}
.copywritecontainer ul li {
    position: relative;
    padding: 0 0 0 12px;
    font-size: 16px;
    line-height: 23px;
}
.copywritecontainer ul li:before {
    content: '';
    position: absolute;
    left: 0;
    top: 12px;
    width: 5px;
    height: 2px;
    background: black;
}
.modal-content.viewRequests {
    padding: 30px 40px;
}
.modal-content.viewRequests .modal-header h5.modal-title {
    font-size: 24px;
    font-weight: 600;
}
.modal-content.viewRequests .modal-header {
    border: 0;
    padding: 0;
}
.profileRow:not(:last-child) {
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.profileRow {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    justify-content: space-between;
}
.profile_link {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    margin-top: 10px;
}
.profileLeftSide {
    flex: 1 1;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
}
.profileLeftSide .profileImg {
    width: 60px;
    height: 60px;
    margin-right: 10px;
}
.profileLeftSide .profileLeftSideDetail {
    flex: 1 1;
}
.profileLeftSide .profileLeftSideDetail h3 {
    font-size: 16px;
    margin-bottom: 0;
}
.profileLeftSide .profileLeftSideDetail h3 span {
    font-size: 14px;
    font-style: italic;
}
.profileLeftSide .profileLeftSideDetail .profileUniversity {
    font-size: 14px;
    color: #646464;
    font-style: italic;
    font-weight: 500;
}
.profileLeftSide .profileLeftSideDetail p {
    margin: 0;
    font-size: 16px;
    font-weight: 500;
}
.profileLeftSide .profileLeftSideDetail .profileUniversity span {
    color: #000;
}
.profile_link .btn-border {
    width: 70px;
    margin: 0;
}
.alumni_college {
    background: #ffffff;
    border: 1px solid #d2d2d2;
    border-radius: 6px;
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: column;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    -ms-border-radius: 6px;
    -o-border-radius: 6px;
}
.alumni_college_yr {
    position: absolute;
    background: #0b3454;
    border-radius: 0px 6px 0px 15px;
    color: #fff;
    height: 25px;
    font-size: 14px;
    padding: 0 14px;
    top: -1px;
    right: -1px;
    line-height: 24px;
}
.alumni_college > div:not(.alumni_college_yr) {
    /* padding: 15px; */
}
.alumni_college_bottom {
    background: #f2f9ff;
    border-radius: 0px 0px 6px 6px;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    flex: 1 1;
    padding: 5px 15px 15px;
}
.alumni_college_top {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    align-items: center;
    padding: 15px 15px 8px;
}
.alumni_college_top p {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
}
.alumni_college_profileimg {
    margin-right: 20px;
}
.alumni_college_bottom label {
    color: #d52941;
    font-size: 13px;
    font-weight: 500;
}
.CollegeLabel {
    flex: 1 1;
}
.courseLabel {
    margin-right: 37px;
    max-width: 120px;
    width: 100%;
}
.alumni_college_bottom label + div {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    align-items: center;
    font-size: 16px;
    font-weight: 500;
    line-height: 18px;
}
.alumni_college_bottom label + div span {
    font-size: 16px;
    font-weight: 500;
}
.alumni_college_bottom label + div span.alumni_university {
    flex: 1 1;
    margin-right: 7px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
.video_block,
.uni_profiles .video_block,
.underGraduate-detail .video_block {
    background: #ffffff;
    border: 1px solid #d2d2d2;
    border-radius: 6px;
    overflow: hidden;
    text-decoration: none;
    position: relative;
    display: inline-block;
    color: #000;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    padding: 0;
}
.icon-invert-play {
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.uni_profiles .video_block:hover,
.uni_profiles .video_block:hover .icon-invert-play,
.video_block:hover,
.video_block:hover .icon-invert-play {
    color: #5cae48;
    background: none;
}
.video_block_name {
    background: #ffffff;
    border-radius: 6px 6px 0px 0px;
    opacity: 1;
    display: flex;
    justify-content: space-between;
    padding: 0px 20px;
    margin: -26px 11px 0;
    position: relative;
    align-items: center;
    height: 78px;
}
.uni_profiles .video_block:hover .video_block_img img,
.video_block:hover .video_block_img img {
    transform: scale(1.1);
    -webkit-transform: scale(1.1);
    -moz-transform: scale(1.1);
    -ms-transform: scale(1.1);
    -o-transform: scale(1.1);
}
.uni_profiles .video_block_img {
    overflow: hidden;
    display: inline-block;
}
.uni_profiles .video_block_img img,
.video_block_img img {
    border-radius: 6px 6px 0 0;
    transition: all 0.5s ease-in-out;
    -webkit-transition: all 0.5s ease-in-out;
    -moz-transition: all 0.5s ease-in-out;
    -ms-transition: all 0.5s ease-in-out;
    -o-transition: all 0.5s ease-in-out;
}
.uni_profiles .video_block_name .icon-invert-play,
.video_block_name .icon-invert-play {
    font-size: 30px;
    color: #0b3454;
}
.uni_profiles .video_block_name label,
.video_block_name label {
    font-size: 18px;
    font-weight: 600;
    margin-right: 15px;
    line-height: 22px;
}
.uni_profiles .video_block .video-btn,
.video_block .video-btn {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
}
#video_pop button.btn-close {
    position: absolute;
    top: 10px;
    right: 10px;
    background-color: #fff !important;
    opacity: 1;
    z-index: 999;
    background-size: 40%;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    padding: 0;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
#video_pop button.btn-close:hover {
    background-color: #5cae48 !important;
}
#video_pop button.btn-close span {
    display: none;
}
.profile-detail {
    padding: 0;
    margin: 10px 0 0;
    list-style: none;
    color: #fff;
    font-size: 16px;
    font-weight: 500;
}
.profile-detail li {
    border-left: 4px solid #fff;
    padding-left: 7px;
}
.profile-detail li:not(:last-child) {
    margin-bottom: 20px;
}
.bullet ul {
    margin: 0;
    padding: 0;
    list-style: none;
    color: #fff;
}
.bullet ul li:not(:last-child) {
    margin-bottom: 20px;
}
.bullet ul li div.bullet_bg {
    display: flex;
    align-items: start;
}
.bullet ul li b {
    width: 120px;
    height: 41px;
    display: flex;
    align-items: center;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/bullet-bg.jpg);
    padding-left: 17px;
    font-size: 14px;
    font-weight: 500;
    line-height: 16px;
    margin-right: 10px;
}
.bullet ul li {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
}
.bullet ul li div.bullet_brife {
    flex: 1 1;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    align-items: center;
    justify-content: start;
}
.bullet ul li div span {
    width: auto;
    position: relative;
    line-height: 20px;
}
.bullet ul li div span.highlight {
    width: auto;
    position: relative;
}
.bullet ul li div span.highlight::after {
    content: '';
    position: absolute;
    right: 0;
    top: 3px;
    width: 16px;
    height: 25px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/subtraction.svg);
    filter: brightness(0) invert(1);
    display: none;
}
.bullet ul li div i.highlight {
    width: 16px;
    height: 25px;
    display: inline-block;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/subtraction.svg);
    margin-left: 5px;
    margin-top: 1px;
    filter: brightness(0) invert(1);
    vertical-align: top;
}
.skillnactivityDetail {
    max-width: 400px;
    width: 100%;
}
.skillnactivityDetail h3 {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 20px;
}
.skillnactivityDetail > div {
    padding: 30px;
    background: transparent linear-gradient(180deg, #ffffff 0%, #f8f8f8 100%);
    border: 1px solid #e1e1e1;
    border-radius: 6px;
}
.skillnactivityDetail > div.skillDetail {
    margin-bottom: 20px;
}
.skillnactivityDetail h4 {
    color: #d42941;
    font-size: 14px;
    font-weight: 500;
    margin: 30px 0 5px;
}
.skillnactivityDetail .skillinterest {
    font-size: 16px;
    font-weight: 500;
}
.recentActivitycontainer {
    max-height: 325px;
    overflow-y: auto;
    scrollbar-width: thin;
}
.recentActivitycontainer::-webkit-scrollbar {
    width: 8px;
}
.recentActivitycontainer::-webkit-scrollbar-track {
    background: #f0f0f0;
}
.recentActivitycontainer::-webkit-scrollbar-thumb {
    background: #cdcdcd;
}
.recentActivitycontainer ul {
    list-style: none;
    padding: 0;
    margin: 0;
}
.recentActivitycontainer ul li {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
}
.recentActivitycontainer ul li:not(:last-child) {
    margin-bottom: 20px;
}
.recentActivitycontainer ul li .detail span {
    display: block;
    letter-spacing: 0.28px;
    color: #0b3454;
    font-size: 14px;
    line-height: 20px;
}
.recentActivitycontainer ul li .detail {
    flex: 1 1;
    font-size: 16px;
    line-height: 20px;
    padding-top: 4px;
}
.recentActivitycontainer ul li i {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #0b3454;
    margin-right: 10px;
    background: #ffffff;
    border: 1px solid #0b34541a;
}
.year_section ul li > i {
    background: #d1f1ff;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
    font-size: 19px;
    position: relative;
    z-index: 1;
}
#alumniProfileTab {
    border: 0;
    flex-wrap: nowrap;
    height: 44px;
}
#alumniProfileTab .nav-item:not(:last-child) {
    margin-right: 10px;
}
#alumniProfileTab .nav-item .nav-link {
    background: #ffffff;
    border: 2px solid #7d7d7d;
    border-radius: 20px;
    width: 180px;
    height: 40px;
    padding: 0;
    font-size: 16px;
    font-weight: 500;
    color: #414141;
}
#alumniProfileTab .nav-item .nav-link.active {
    background: #0b3454;
    border-color: #0b3454;
    color: #fff;
}
.yearNumber {
    position: relative;
}
.yearNumber label {
    background: #26a7df;
    border-radius: 6px;
    height: 32px;
    width: 90px;
    text-align: center;
    line-height: 32px;
    color: #fff;
    font-size: 16px;
    font-weight: 600;
}
.year_section ul {
    list-style: none;
    padding: 20px 0 50px 20px;
    margin: 0;
    position: relative;
}
.year_section ul::before {
    content: '';
    position: absolute;
    width: 2px;
    height: 50px;
    background: #d1f1ff;
    left: 43px;
    top: 0;
    z-index: 0;
}
.year_section:not(:last-child) ul::after {
    content: '';
    position: absolute;
    width: 2px;
    height: 50px;
    background: #d1f1ff;
    left: 43px;
    bottom: 0;
    z-index: 0;
}
.year_section ul li:not(:last-child) {
    margin-bottom: 30px;
}
.year_section ul li {
    display: flex;
    position: relative;
}
.year_section ul li::before {
    content: '';
    position: absolute;
    width: 2px;
    height: calc(100% + 30px);
    background: #d1f1ff;
    left: 23px;
    top: 0;
    z-index: 1;
}
.year_section ul li .brife {
    display: flex;
    align-items: start;
    flex-wrap: wrap;
    flex-direction: column;
    justify-content: center;
    flex: 1 1;
}
.year_section ul li .brife p {
    margin: 0;
    line-height: 23px;
    font-size: 16px;
}
.year_section ul li > i.icon-hat::before {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/hat.svg);
    width: 24px;
    height: 23px;
    background-size: 100%;
}
.year_section ul li .brife .offer {
    position: relative;
    padding-left: 40px;
}
.year_section ul li .brife .offer::before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 2px;
    margin: auto;
    left: 0;
}
.year_section:last-child ul li:last-child:before {
    opacity: 0;
}
.year_section ul li .brife .offer.joined::before {
    background: #5cae48;
}
.year_section ul li .brife .offer.dintjoined::before {
    background: #d52941;
}
.year_section ul li .brife .offer.joined {
    color: #5cae48;
}
.year_section ul li .brife .offer.dintjoined {
    color: #d52941;
}
.year_section ul li .brife .offer span {
    position: relative;
    background: #fff;
    padding-left: 7px;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    align-items: center;
    font-size: 16px;
    font-weight: 600;
}
.year_section ul li .brife .offer span i {
    font-size: 16px;
    margin-right: 7px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
}
.year_section ul li .brife .offer span i.icon-correct-invert {
    color: #5cae48;
}
.year_section ul li .brife .offer span i.icon-cross {
    width: 16px;
    height: 16px;
    background: #d42941;
    border-radius: 50%;
    font-size: 6px;
    color: #fff;
}
.achievementsBlocks {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
}
.achievementsBlocks .icon {
    width: 38px;
    margin-right: 14px;
}
.achievementsBlocksDetails {
    flex: 1 1;
}
.achievementsBlocksDetails h2 {
    font-size: 18px;
    font-weight: 500;
    margin: 11px 0 25px;
}
.achievementsBlocks:not(:last-child) {
    padding-bottom: 30px;
    margin-bottom: 35px;
    border-bottom: 2px solid #e1e1e1;
}
.achievementsBlocksDetails h2 a {
    color: #147ad6;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.28px;
    text-decoration: underline;
}
.achievementsBlocksDetails h2 a:hover {
    text-decoration: none;
    color: #0b3454;
}
.achievementsBlocksDetailsection .blockrow:not(:last-child) {
    margin-bottom: 21px;
}
.achievementsBlocksDetailsection .blockrow {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
}
.achievementsBlocksDetailsection .blockrow label {
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    width: 130px;
}
.achievementsBlocksDetailsection .blockrow .colon {
    margin: 0 30px;
    line-height: 16px;
}
.achievementsBlocksDetailsection .blockrow .brife {
    flex: 1 1;
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
    letter-spacing: 0.32px;
    max-width: 305px;
}
.achievementsBlocksDetailsection .blockrow .brife a {
    text-decoration: underline;
    color: #147ad6;
}
.achievementsBlocksDetailsection .blockrow .brife a:hover {
    text-decoration: none;
    color: #0b3454;
}
.contributionsSection > div:not(:last-child) {
    margin-bottom: 40px;
}
.alumnislider .video_block_name label {
    font-size: 16px;
}
.alumnislider .album_contblk h3 {
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    -webkit-box-orient: vertical;
}
.contributionsSection > div:not(:last-child) {
    margin-bottom: 40px;
}
.seactionheader {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
    flex-wrap: wrap;
}
.countnbtn {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.seactionheader h3 {
    font-size: 24px;
    margin: 0;
}
.countnbtn .count {
    margin-right: 20px;
    font-style: italic;
    font-size: 14px;
    color: #0b3454;
}
.custom-btns a {
    display: inline-block;
    color: #0b3454;
    text-decoration: none;
}
.custom-btns a:hover {
    color: #d42941;
}
.jobsandInternshipslist .act_lst > .row.postedrow > div:last-child,
.jobsandInternshipslist .act_lst.actlst_listed > .row > div:last-child {
    width: auto;
}
.nolisting {
    background: #fff;
    border: 1px solid #d2d2d2;
    border-radius: 6px;
    padding: 30px;
    text-align: center;
}
.selected_univarsity {
    background: #f8f8f8;
    padding: 20px;
    border-radius: 7px;
    position: relative;
}
.selected-form-label {
    background: #ffffff;
    border-radius: 7px;
    width: 100%;
    height: 50px;
    padding: 0 20px;
    font-size: 16px;
    display: flex;
    align-items: center;
    font-weight: 600;
}
.selected_univarsity .btn-cross {
    position: absolute;
    top: 22px;
    right: -20px;
    font-size: 8px;
    color: #0b345480;
}
.dashboard.innerpage {
    display: flex;
    align-items: center;
}
.dashboard.innerpage .label {
    margin-right: 15px;
    font-weight: 500;
}
.uni_connect_sec {
    border: 1px solid #d2d2d2;
    border-radius: 6px;
    padding: 10px 20px 10px 10px;
}
.logo-icon {
    width: 50px;
    height: 50px;
    border: 1px solid #e3e2e2;
    border-radius: 50%;
    margin-right: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.selected-prodile-invite > div {
    background: #fff;
    box-shadow: 0px 1px 1px #f1f1f1;
    border: 1px solid #dedede;
    border-radius: 7px;
    padding: 10px 20px;
    margin-top: 5px;
    position: relative;
}
.selected-prodile-invite p.font-16 {
    line-height: 16px;
}
.selected-prodile-invite p.font-14 {
    line-height: 14px;
}
.selected-prodile-invite a {
    text-decoration: none;
    color: #000;
}
.selected-prodile-invite a:hover {
    color: #5cae48;
}
.selected-prodile-invite a[class*='icon'] {
    color: #535353;
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
    right: 15px;
    height: 16px;
    width: 16px;
}
.selected-prodile-invite a[class*='icon']:hover {
    color: #000;
}

@media (min-width: 992px) {
    body::before {
        position: fixed;
        top: 0;
        bottom: auto;
        right: 0;
        left: 0;
        margin: auto;
        content: '';
        background: rgba(0, 0, 0, 0.8);
        width: 100%;
        height: 0;
        opacity: 0;
        z-index: 1;
        transition: unset;
    }
    .mouseHover::before {
        height: 100%;
        opacity: 1;
        z-index: 1;
        transition: unset;
    }
    body.mouseHover::before {
        z-index: 9;
    }
    nav.custom-nav.offcanvas.offcanvas-start {
        background: #0b3454;
        height: 70px;
        position: static;
        visibility: visible !important;
        transform: translateX(0);
        width: 100%;
        padding: 0;
        -webkit-transform: translateX(0);
        -moz-transform: translateX(0);
        -ms-transform: translateX(0);
        -o-transform: translateX(0);
    }
    nav.custom-nav.offcanvas.offcanvas-start ~ .offcanvas-backdrop.show {
        display: none;
    }
    .custom-nav > ul {
        max-width: 1155px;
        margin: 0 auto;
        position: relative;
        z-index: 2;
        width: 94%;
    }
    .custom-nav > ul > li > a.nav-link {
        color: #fff;
        position: relative;
        z-index: -1;
    }
    .custom-nav > ul li.nav-item a.nav-link::before {
        content: '';
        width: 0;
        height: 5px;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        background: #5cae48;
        margin: auto;
        transition: all 0.3s ease-in-out;
    }
    .custom-nav > ul li.nav-item:hover a.nav-link::before,
    .custom-nav > ul li.nav-item.active a.nav-link::before {
        width: 100%;
    }
    .custom-nav > ul li.nav-item a.nav-link {
        color: #fff;
        text-transform: uppercase;
        font-size: 14px;
        font-weight: 500;
        line-height: 54px;
    }
    .custom-nav > ul li.nav-item:hover a.nav-link {
        color: #26a7df;
    }
    .custom-nav > ul > li > ul {
        position: absolute;
        background: #ffffff;
        box-shadow: 0px 3px 6px #0000001a;
        border: 1px solid #d2d2d2;
        border-radius: 6px;
        padding: 20px 30px;
        width: max-content;
        list-style: none;
        left: -20px;
    }
    .custom-nav > ul > li > ul {
        display: block !important;
        z-index: -1;
        opacity: 0;
        top: 100px;
        transition: all 0.3s ease-in-out;
    }
    .custom-nav > ul > li:hover > ul {
        top: 55px;
        opacity: 1;
    }
    .custom-nav > ul > li {
        overflow: hidden;
        margin: 0;
    }
    .custom-nav > ul > li:hover {
        overflow: visible;
    }
    .custom-nav > ul > li:last-child > ul {
        right: -10px;
        left: auto;
    }
    .custom-nav > ul > li:hover > ul > li:not(:last-child) {
        margin-bottom: 8px;
    }
    .custom-nav > ul > li:hover > ul > li > a {
        color: #000;
        text-decoration: none;
        font-size: 16px;
        font-weight: 500;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0;
        background: none;
    }
    .custom-nav > ul > li:hover > ul > li > a:hover,
    .custom-nav > ul > li:hover > ul > li > ul li a:hover {
        color: #26a7df;
    }
    .custom-nav > ul > li:hover > ul > li > a.gray-effect {
        color: #8c8c8c;
        cursor: default;
    }
    .custom-nav > ul > li:hover > ul > li > ul {
        display: block;
        position: absolute;
        left: 80%;
        top: -16px;
        width: 250px;
        padding: 0;
        z-index: -1;
        transition: all 0.3s ease-in-out;
        opacity: 0;
        background: #ffffff;
        box-shadow: 0px 3px 6px #0000001a;
        border: 1px solid #d2d2d2;
        border-radius: 6px;
        padding: 10px 20px;
        -webkit-transition: all 0.3s ease-in-out;
        -moz-transition: all 0.3s ease-in-out;
        -ms-transition: all 0.3s ease-in-out;
        -o-transition: all 0.3s ease-in-out;
    }
    .custom-nav > ul > li:hover > ul > li {
        position: relative;
    }
    .custom-nav > ul > li:hover > ul > li:hover > ul {
        left: 105%;
        opacity: 1;
    }
    .custom-nav > ul > li:hover > ul > li > ul > li > a {
        padding: 5px 15px;
        display: block;
        color: #000;
        text-decoration: none;
        font-size: 16px;
        font-weight: 500;
    }
    .custom-nav > ul > li:hover > ul > li > ul li {
        list-style: none;
    }
    .custom-nav > ul > li:hover > ul > li > a .icon.icon-arrow-right {
        border-top: 2px solid #000;
        border-right: 2px solid #000;
        width: 10px;
        height: 10px;
        transform: rotate(45deg);
        margin-right: 2px;
    }
    .custom-nav > ul > li:hover > ul > li:hover {
        overflow: visible;
    }
}

@media (max-width: 1199px) {
    .search {
        width: 30%;
    }
    .skillnactivityDetail {
        max-width: 305px;
        width: 100%;
    }
}

@media (max-width: 1140px) {
    .onboardingLaunchGraph ul li div,
    .triangleGraph ul li div {
        width: 65%;
    }
}

@media (max-width: 991px) {
    .mobileonly {
        display: block;
    }
    .custom-nav {
        width: 300px !important;
        background: #0b3454;
        padding: 0;
        overflow-y: auto;
    }
    .manager_profile .profileSection {
        display: none;
    }
    .logo {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .logo .btn-offcanvas {
        border: 0;
        background: none;
        font-size: 0;
        margin-right: 15px;
    }
    .btn-offcanvas .navbar-toggler-icon::before {
        font-size: 0;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-end;
        background: none;
        border: 0;
        content: '';
        width: 100%;
        height: 3px;
        background: #000;
        transition: all 0.3s ease-in-out;
    }
    .btn-offcanvas .navbar-toggler-icon::after {
        font-size: 0;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-end;
        background: none;
        border: 0;
        content: '';
        width: 70%;
        height: 3px;
        background: #000;
        transition: all 0.3s ease-in-out;
    }
    .btn-offcanvas .navbar-toggler-icon {
        width: 20px;
        height: 20px;
        justify-content: space-between;
        flex-direction: column;
        display: flex;
    }
    .btn-offcanvas .navbar-toggler-icon b {
        height: 3px;
        width: 85%;
        background: #000;
        transition: all 0.3s ease-in-out;
    }
    body[style*='overflow:hidden'] .btn-offcanvas .navbar-toggler-icon b {
        transform: scale(0);
    }
    body[style*='overflow:hidden'] .btn-offcanvas span.navbar-toggler-icon::before {
        transform: translateY(10px) rotate(135deg);
        -moz-transform: translateY(10px) rotate(135deg);
        -webkit-transform: translateY(10px) rotate(135deg);
        transition: all 0.3s ease-in-out;
        width: 100%;
        height: 3px !important;
    }
    body[style*='overflow:hidden'] .btn-offcanvas span.navbar-toggler-icon::after {
        transform: translateY(-7px) rotate(-135deg);
        -moz-transform: translateY(-7px) rotate(-135deg);
        -webkit-transform: translateY(-7px) rotate(-135deg);
        transition: all 0.3s ease-in-out;
        width: 100%;
        height: 3px !important;
    }
     header .offcanvas ~ .modal{z-index: 99999;}
    #custom-nav {
        margin: 0 !important;
        padding: 10px 0 0;
        width: 100%;
    }
    #custom-nav > li.mobileonly {
        background: #fff;
        padding: 0;
        margin-bottom: 15px;
    }
    #custom-nav > li {
        padding: 0 20px;
    }
    #custom-nav > li .nav-link {
        display: flex;
        justify-content: space-between;
        color: #fff;
        align-items: center;
        font-size: 14px;
        font-weight: 500;
        text-transform: uppercase;
    }
    #custom-nav > li .nav-link .icon {
        display: none;
    }
    #custom-nav > li.mobileonly ul {
        padding: 0;
        list-style: none;
        margin-top: 0px;
    }
    #custom-nav > li.mobileonly ul li a {
        width: 100%;
        padding: 10px 0 10px 33px;
        font-size: 16px;
        color: #000;
        font-weight: 500;
        text-decoration: none;
        display: block;
        height: auto;
        background-position: center left;
        cursor: pointer;
    }
    #custom-nav > li.mobileonly ul li:not(:first-child) {
        border-top: 1px solid #e3e3e3;
    }
    #custom-nav > li.mobileonly .profileSection {
        margin-bottom: 17px;
    }
    #custom-nav > li.mobileonly .btn-close {
        margin: 0;
        opacity: 1;
        position: absolute;
        right: 12px;
        top: 8px;
        background-size: 12px auto;
    }
    #custom-nav > li .nav-link.nav-invite {
        justify-content: start;
        background: #5cae48;
        border-radius: 25px;
        padding: 10px 15px 10px 10px;
        width: auto;
    }
    #custom-nav > li .nav-link.nav-invite:hover {
        color: #ffff;
        background: #408e2d;
    }
    .headerRightSide > ul > li:not(:last-child) {
        margin-right: 30px;
        display: none;
    }
    .search {
        max-width: 275px;
        padding: 0;
        background: #f1f1f1;
        border-radius: 20px;
        height: 40px;
        margin-left: auto;
        margin-right: 30px;
        width: 100%;
    }
    #custom-nav > li > ul {
        list-style: none;
        padding: 0 0 0 10px;
    }
    #custom-nav > li > ul > li a {
        font-size: 16px;
        color: #fff;
        text-decoration: none;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    #custom-nav > li > ul > li a.gray-effect {
        cursor: default;
        color: #335168;
    }
    #custom-nav li a {
        width: 100%;
        display: block;
    }
    #custom-nav > li > ul > li:not(:last-child) {
        margin-bottom: 0px;
    }
    #custom-nav > li .nav-link:hover {
        color: #5cae48;
    }
    #custom-nav > li > ul > li a:hover {
        color: #5cae48;
    }
    #custom-nav > li > ul > li ul {
        list-style: none;
        padding: 0 0 0 15px;
    }
    .custom-nav > ul > li > ul > li > a .icon.icon-arrow-right {
        border-top: 2px solid #fff;
        border-right: 2px solid #fff;
        width: 8px;
        height: 8px;
        transform: rotate(135deg);
        margin-right: 2px;
    }
    .sideBar {
        width: 100%;
        overflow-y: auto;
    }
    .sideBar::-webkit-scrollbar {
        display: none;
    }
    .sideBar {
        -ms-overflow-style: none;
        scrollbar-width: none;
    }
    .mainContainer {
        background: none;
        flex-direction: column;
    }
    .sideBar ul {
        width: auto;
        border-right: 0;
        padding: 11px 0 0;
        background: none;
        height: 70px;
        box-shadow: none;
        display: flex;
    }
    .sideBar ul li {
        display: inline-block;
    }
    .main:before {
        width: 100%;
        height: 70px;
        box-shadow: 8px 10px 10px 0px #e8e8e8;
        border-bottom: 1px solid #dbdbdb;
    }
    .pageContent {
        padding: 0;
    }
    .sideBar ul li a > b {
        width: 45px;
        height: 45px;
    }
    .sideBar ul li a span {
        width: auto;
    }
    .sideBar ul:hover {
        width: auto;
    }
    .sideBar ul li a span b {
        width: auto;
        white-space: nowrap;
    }
    .sideBar ul li:not(:last-child) {
        margin-right: 30px;
    }
    .sideBar ul:hover li a span {
        width: auto;
    }
    .footer {
        padding: 20px 0;
    }
    .onboardingLaunchGraph ul li label,
    .triangleGraph ul li label {
        font-size: 14px;
    }
    .onboardingLaunchGraph ul li div span::before,
    .triangleGraph ul li div span::before {
        border-width: 17px 10px 17px 10px;
    }
    .onboardingLaunchGraph ul li div span::after,
    .triangleGraph ul li div span::after {
        border-width: 17px 10px 17px 10px;
    }
    .onboardingLaunchGraph ul li div span,
    .triangleGraph ul li div span {
        font-size: 12px;
    }
    .onboardingLaunchGraph ul li div,
    .triangleGraph ul li div {
        width: 65%;
        height: 35px;
    }
    .dashboardAccordion .accordion-item .accordion-body {
        padding: 0 13px 20px;
    }
    #dashboard-pills-tab {
        flex-wrap: inherit;
        overflow: auto;
        -ms-overflow-style: none;
        scrollbar-width: none;
    }
    #dashboard-pills-tab::-webkit-scrollbar {
        display: none;
    }
    .alumni_directory_details .bigVerticalProgress {
        max-width: 990px;
        width: max-content;
    }
    .alumni_directory_details .bigVerticalProgress .verticleProgress {
        margin: 0 1% 20px;
    }
    .alumni_directory_details .tablesection > .table > .table {
        max-width: 990px;
        width: 990px;
    }
    .icn_details > .flex-1 {
        float: left;
        margin: 0 0 15px;
        width: calc(100% - 70px);
    }
    .input-otp {
        max-width: 50px;
    }
}

@media (max-width: 800px) {
    .sticky-notification .notification-detail {
        flex-direction: column;
        align-items: flex-start !important;
        padding-left: 15px;
        justify-content: center;
    }
    .sticky-notification .notification-detail p {
        max-width: 100%;
        margin-bottom: 10px;
    }
    .sticky-notification {
        height: 130px;
    }
}

@media (min-width: 768px) and (max-width: 991px) {
    .dashboardAccordion .accordion-item .accordion-button {
        padding: 20px 13px;
    }
    .dashboardAccordion .accordion-item .accordion-button span {
        margin: 0 10px;
    }
    .participantsnumber > div {
        display: flex;
        flex-direction: column;
    }
    .courseLabel {
        margin-right: 0;
    }
    .alumni_college_bottom {
        flex-direction: column;
    }
    .btn .btn-green {
        line-height: 14px;
    }
}

@media (min-width: 768px) and (max-width: 890px) {
    .achievementsBlocksDetailsection .blockrow {
        flex-direction: column;
    }
    .achievementsBlocksDetailsection .blockrow .colon {
        display: none;
    }
    .achievementsBlocksDetailsection .blockrow label::after {
        content: ' :';
    }
    .achievementsBlocksDetailsection .blockrow label {
        width: 100%;
    }
}

@media (max-width: 767px) {
    .btn-search-toggle {
        font-size: 13px;
        padding: 0;
        width: 40px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        text-decoration: none;
        color: #0b3454;
    }
    .search {
        position: absolute;
        right: 50px;
        top: 24px;
        width: 40px;
        transition: all 0.3s ease-in-out;
    }
    .search form,
    .search > div {
        display: none !important;
    }
    .search.open {
        width: 260px;
        border: 1px solid #c8c8c8;
    }
    .search.open form,
    .search.open > div {
        display: flex !important;
    }
    .search.open .btn-search-toggle {
        display: none;
    }
    .dashboard {
        position: fixed;
        z-index: 9;
        height: 80px;
        background: #fff;
        bottom: 0;
        right: 0;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0px 4px 7px #92929259;
        border-top: 1px solid #dbdbdb;
    }
    .dashboard .booksessionEnroll {
        margin: 5px 0 0;
    }
    .dashboard.smart-scroll.scrolled-down {
        transition: all 0.3s ease-in-out;
        bottom: 0;
        -webkit-transition: all 0.3s ease-in-out;
        -moz-transition: all 0.3s ease-in-out;
        -ms-transition: all 0.3s ease-in-out;
        -o-transition: all 0.3s ease-in-out;
    }
    .dashboard.smart-scroll.scrolled-up {
        bottom: 0;
        transition: all 0.3s ease-in-out;
        -webkit-transition: all 0.3s ease-in-out;
        -moz-transition: all 0.3s ease-in-out;
        -ms-transition: all 0.3s ease-in-out;
        -o-transition: all 0.3s ease-in-out;
    }
    .dashboard.innerpage {
        padding: 0 15px;
        justify-content: center;
    }
    .footer {
        flex-direction: column;
        text-align: center;
        padding: 20px;
        margin: 0 0;
    }
    .powerby {
        margin-top: 15px;
    }
    .powerby img {
        max-width: 139px;
        margin: auto;
    }
    .welcome-title h1,
    .welcome-title p {
        text-align: left;
    }
    .highlight-text {
        margin: 20px 0;
    }
    .blue-container {
        max-width: initial;
        margin: 0 -13px 0;
        width: auto;
        border-radius: 0 0 5px 5px;
        padding: 25px !important;
    }
    .dashboardAccordion .accordion-item .accordion-body {
        padding: 0 13px 0px;
    }
    .dashboardAccordion .accordion-item {
        box-shadow: 0px 3px 6px #0000001a;
    }
    .dashboardAccordion .accordion-item .accordion-button {
        padding: 20px 13px 20px;
    }
    .dashboardAccordion .accordion-item .accordion-button[aria-expanded='true'] {
        padding: 20px 13px 5px !important;
    }
    .bigVerticalProgress {
        margin: 0 -1%;
        justify-content: flex-start;
    }
    .bigVerticalProgress .verticleProgress {
        width: 18%;
        margin: 0 1% 20px;
    }
    .participants {
        align-items: flex-start;
    }
    .participants label {
        text-align: left;
    }
    #pills-student .accordion-item .accordion-body > .row > div.col-md-6:first-child {
        margin-bottom: 25px;
    }
    #pills-student .accordion-item .accordion-body > .row.pt-3 {
        padding-top: 0 !important;
    }
    .school_notification li .check {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        width: 100%;
        margin-top: 15px;
    }
    .school_notification li .check span {
        margin-right: 5px;
    }
    .alumni_directory_details .custom-border {
        border-right: 0;
        border-bottom: 1px solid #e8e8e8;
        padding-bottom: 25px;
        margin-bottom: 20px;
    }
    .profileRow {
        flex-direction: column;
    }
    .courseLabel {
        margin-right: 0;
    }
    .alumni_college_bottom {
        flex-direction: column;
    }
    .profile_videos {
        margin: 0 -19px;
    }
    .skillnactivityDetail {
        max-width: 100%;
    }
}

@media (max-width: 575px) {
    .search {
        right: 38px;
    }
    .overlaystick.aos-animate {
        position: fixed;
        left: 0;
        bottom: 0;
        right: 0;
        top: 0;
        background: rgba(0, 0, 0, 0.7);
        z-index: 9;
        display: flex;
        align-items: flex-end;
    }
    .overlaystick.aos-animate .sticky-notification {
        border-radius: 60px 60px 0 0 / 60px 60px 0 0;
        height: 231px;
        left: 0;
        right: 0;
        margin: 0;
        width: 100%;
    }
    .overlaystick.aos-animate .sticky-notification > .imgplace {
        display: none;
    }
    .overlaystick.aos-animate .sticky-notification .notification-detail {
        padding: 20px 20px 0;
        justify-content: flex-end;
    }
    .overlaystick.aos-animate .sticky-notification .notification-detail p {
        text-align: center;
        max-width: 100%;
        margin: 0 auto 20px;
    }
    .imglink {
        max-width: 100%;
        display: flex;
        justify-content: space-around;
    }
    .imglink .imgplace {
        display: block;
    }
    .sticky-notification .notification-detail .links {
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: center;
    }
    .sticky-notification .notification-detail .links .btn-green {
        margin-bottom: 13px;
    }
    .sticky-notification .notification-detail .links a {
        max-width: 190px;
        width: 100%;
    }
    .overlaystick.aos-animate .sticky-notification .btn-close {
        left: 0;
        right: 0;
        width: 40px;
        height: 40px;
        margin: auto;
        border: 2px solid #fff;
        border-radius: 50%;
        background: none;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        top: -75px;
    }
    .dashboardAccordion .accordion-item .accordion-button {
        padding: 20px 13px;
    }
    .dashboardAccordion .accordion-item .accordion-button span {
        margin: 0 10px;
    }
    .onboardingLaunchGraph ul li label,
    .onboardingLaunchGraph ul li label {
        font-size: 14px;
    }
    .onboardingLaunchGraph ul li div span::before,
    .onboardingLaunchGraph ul li div span::before {
        border-width: 17px 10px 17px 10px;
    }
    .onboardingLaunchGraph ul li div span::after {
        border-width: 17px 10px 17px 10px;
    }
    .onboardingLaunchGraph ul li div span {
        font-size: 12px;
    }
    .onboardingLaunchGraph ul li div {
        width: 65%;
        height: 35px;
    }
    .dashboardAccordion .accordion-item .accordion-body {
        padding: 0 13px;
    }
    .milestoneProgressGraph {
        justify-content: center;
        margin: 0 -5px;
    }
    .milestoneGraph {
        width: 29%;
        margin: 0px 5px 30px;
    }
    .bigVerticalProgress .verticleProgress {
        width: 23%;
    }
    .white-block {
        padding: 15px;
    }
    .profile_radiorow > .icon-cross {
        right: -18px;
        padding: 5px;
    }
    .btn-white-border {
        padding: 0 15px;
    }
    .courseLabel {
        margin-right: 20px;
    }
    .alumni_college_bottom {
        flex-direction: row;
    }
    .achievementsBlocksDetailsection .blockrow {
        flex-direction: column;
    }
    .achievementsBlocksDetailsection .blockrow .colon {
        display: none;
    }
    .achievementsBlocksDetailsection .blockrow label::after {
        content: ' :';
    }
    .achievementsBlocksDetailsection .blockrow label {
        width: 100%;
    }
    .selected_univarsity .btn-cross {
        top: 8px;
        right: 8px;
    }
}

@media (max-width: 480px) {
    .sticky-notification {
        height: 210px;
        flex-direction: row-reverse;
    }
    .sticky-notification .notification-detail .links {
        flex-direction: column;
        align-items: flex-start;
    }
    .sticky-notification .notification-detail .links .btn-green {
        margin-bottom: 15px;
    }
    .eventDetails {
        flex-direction: column;
        align-items: center;
    }
    .eventType {
        flex: 0 1;
        width: 100%;
        flex-basis: 100%;
        margin: 20px 0;
        padding: 0;
        flex-direction: column;
        display: flex;
        align-items: center;
    }
    .eventDetails .datedetail {
        margin: 0;
    }
    .hostby {
        flex-direction: column;
        padding-top: 20px;
    }
    .hostImg {
        margin: 0 0 14px;
    }
    .hostNamePosition {
        text-align: center;
    }
    .participants {
        align-items: center;
    }
    .eventType h2 {
        text-align: center;
        margin-bottom: 20px;
    }
}

.overlaystick.hide {
    display: none;
}
.btn-verify {
    background: linear-gradient(to right, #185584 50%, #0d3453 50%);
    color: #fff;
    width: 140px;
    height: 40px;
    line-height: 38px;
    padding: 0 25px;
    text-decoration: none;
    border-radius: 25px;
    text-align: center;
    background-size: 200% 100%;
    transition: all 0.5s;
    background-position: right bottom;
    border: 1px solid #0d3453;
    font-size: 16px;
    font-weight: 400;
    -webkit-transition: all 0.5s;
    -moz-transition: all 0.5s;
    -ms-transition: all 0.5s;
    -o-transition: all 0.5s;
}
.btn-border {
    background: linear-gradient(to right, #185584 50%, #0d3453 50%);
    color: #fff;
    width: max-content;
    height: 40px;
    line-height: 38px;
    padding: 0 25px;
    text-decoration: none;
    border-radius: 25px;
    text-align: center;
    background-size: 200% 100%;
    transition: all 0.5s;
    background-position: right bottom;
    border: 1px solid #0d3453;
    font-size: 16px;
    font-weight: 500;
    display: flex;
    margin: 0 auto;
    justify-content: center;
    align-items: center;
}
.btn-border:hover,
.btn-verify:hover {
    background-position: left bottom;
    color: #fff;
    background-size: 201% 100%;
}
.icn_details .btn-green {
    width: 140px;
}
.icn_details .btn-green span {
    font-weight: 500;
    font-size: 16px;
}
.icn_details .btn-green span.icon-correct::before {
    font-size: 13px;
}
a.dashb_arr {
    width: 40px;
    height: 40px;
    background: #f1f1f1;
    border-radius: 50%;
    position: relative;
    display: inline-block;
}
a.dashb_left::before {
    content: '';
    width: 8px;
    height: 8px;
    background: transparent;
    display: inline-block;
    position: absolute;
    left: 17px;
    top: 0;
    bottom: 0;
    right: auto;
    margin: auto;
    border-top: 1.5px solid #000;
    border-right: 1.5px solid #000;
    transform: rotate(-135deg);
    -webkit-transform: rotate(-135deg);
    -moz-transform: rotate(-135deg);
    -ms-transform: rotate(-135deg);
    -o-transform: rotate(-135deg);
}
a.dashb_right::before {
    content: '';
    width: 8px;
    height: 8px;
    background: transparent;
    display: inline-block;
    position: absolute;
    left: 15px;
    top: 0;
    bottom: 0;
    right: auto;
    margin: auto;
    border-top: 1.5px solid #000;
    border-right: 1.5px solid #000;
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
    -moz-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    -o-transform: rotate(45deg);
}
.iconsec {
    height: 50px;
    width: 50px;
    background: #d42941;
    border-radius: 50%;
}
.iconsec > b {
    color: #fff;
    font-size: 23px;
}
.icn_details {
    background: #ffffff;
    box-shadow: 0px 3px 6px #0000001a;
    border: 1px solid #d2d2d2;
    border-radius: 6px;
    padding: 25px 30px;
}
.iconsec_title {
    font-weight: 500;
    font-size: 18px;
    color: #000;
    margin: 0 0 8px;
}
.iconsec_cont {
    font-weight: 400;
    font-size: 16px;
    color: #000;
    display: none;
    margin: 0 0 8px;
}
.iconsec_link {
    text-decoration: underline;
    color: #147ad6;
    font-size: 14px;
}
.iconsec_link:hover {
    text-decoration: none;
}
.iconsec_link .readmore {
    display: block;
}
.iconsec_link .readless {
    display: none;
}
.iconsec_link.active .readmore {
    display: none;
}
.iconsec_link.active .readless {
    display: block;
}
.profile_setup {
    width: 100%;
    max-width: 682px;
}
.profile_setup_help {
    width: 100%;
    max-width: 304px;
    height: auto;
    background: transparent linear-gradient(180deg, #ffffff 0%, #f8f8f8 100%) 0% 0% no-repeat padding-box;
    border: 1px solid #e1e1e1;
    border-radius: 6px;
    padding: 30px;
    text-align: center;
}
.profile_setup > div:not(:last-child) {
    margin: 0 0 15px;
}
.container.my-5.profile_setup_cont {
    max-width: 100%;
}
.profile_setup_help > p:first-child {
    width: 100%;
    margin: auto;
    text-align: center;
    max-width: 190px;
}
.custom-nav > ul li.nav-item a.nav-link.dropdown-toggle::after {
    margin-left: 17px;
    vertical-align: middle;
    border-top: 7px solid;
    border-right: 5px solid transparent;
    border-left: 5px solid transparent;
}
.activities_status_hovercont ol {
    margin: 0 0 0 20px;
    padding: 0 10px 0 0;
    text-align: left;
}
.activities_status_hovercont ol li {
    line-height: 18px;
}
.activities_status_hovercont ol li:not(:last-child) {
    margin: 0 0 8px 0;
}
.activities_status_hovercont {
    background: #fff;
    border: 1px solid #d2d2d2;
    border-radius: 6px;
    padding: 20px;
    width: 270px;
    height: 165px;
    position: absolute;
    top: -30px;
    left: 0;
    right: 0;
    margin: auto;
    box-shadow: 0px 3px 6px #0000001a;
    display: none;
}
.activities_status_hovercont::after {
    position: absolute;
    content: '';
    width: 23px;
    height: 18px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/hover_after.png) left top no-repeat;
    bottom: -18px;
}
.activities_status_hovercont > div {
    height: 125px;
    overflow-y: scroll;
    scrollbar-width: thin;
    font-size: 14px;
    font-weight: 400;
}
.activities_status:hover .activities_status_hovercont {
    display: block;
    color: #000;
}
.activities_status:hover {
    color: #26a7df;
}
.activities_status_hovercont > div::-webkit-scrollbar {
    scrollbar-width: thin;
}
.profile_setup > div.icn_details:first-child .iconsec_cont {
    display: block;
}
.dashboardAccordion .accordion-item .accordion-button:hover {
    box-shadow: 0px 0px 5px #0000001a;
    background: #fafafa;
    border-radius: 5px;
}
.dashboardAccordion .accordion-item .accordion-button[aria-expanded='true']:hover {
    box-shadow: unset;
    background: transparent;
    border-radius: 5px;
}
.float_horizontal_animate {
    transform: translatex(0px);
    animation: float_horizontal 4s ease-in-out infinite;
    -webkit-animation: float_horizontal 4s ease-in-out infinite;
    -webkit-transform: translatex(0px);
    -moz-transform: translatex(0px);
    -ms-transform: translatex(0px);
    -o-transform: translatex(0px);
}

@keyframes float_horizontal {
    0% {
        transform: translatex(0px);
        -webkit-transform: translatex(0px);
        -moz-transform: translatex(0px);
        -ms-transform: translatex(0px);
        -o-transform: translatex(0px);
    }
    50% {
        transform: translatex(-10px);
        -webkit-transform: translatex(-10px);
        -moz-transform: translatex(-10px);
        -ms-transform: translatex(-10px);
        -o-transform: translatex(-10px);
    }
    100% {
        transform: translatex(0px);
        -webkit-transform: translatex(0px);
        -moz-transform: translatex(0px);
        -ms-transform: translatex(0px);
        -o-transform: translatex(0px);
    }
}

@media (max-width: 1080px) {
    .profile_setup_cont .profile_setup_help {
        width: 274px;
    }
    .profile_setup_cont .profile_setup {
        width: calc(100% - 300px);
    }
}

@media (max-width: 767px) {
    .icn_details {
        display: block !important;
    }
    .iconsec {
        float: left;
    }
    .icn_details > .flex-1 {
        float: left;
        margin: 0 0 15px;
        width: calc(100% - 70px);
    }
    .btn-verify,
    .icn_details .btn-green {
        display: flex;
        clear: both;
        margin: 0 auto 0 !important;
        float: none;
        text-align: center;
        justify-content: center;
    }
    .profile_setup_cont .row > .profile_setup {
        width: 100%;
        margin: 0 0 30px 0;
    }
    .profile_setup_cont .row > .profile_setup_help {
        width: 100%;
        border-radius: 0;
        border-left: 0 solid #fff;
        border-right: 0 solid #fff;
        border-bottom: 0 solid #fff;
    }
    .max-1140.profile_container {
        width: 100%;
    }
    .profile_container .sideBar {
        width: 94%;
        margin: auto;
    }
    .profile_container .pageContent > div:first-child {
        width: 94%;
        margin: auto;
        padding-top: 35px !important;
    }
    .profile_container .pageContent > div:first-child .welcome-title {
        width: 100%;
    }
    .profile_container .container.profile_setup_cont {
        width: 100%;
        margin: 25px auto 25px !important;
    }
    .profile_setup_cont .row > .profile_setup {
        width: 94%;
        margin: 0 auto 30px auto;
    }
    .profile_container .footer {
        margin: 0;
    }
    .dashboard .btn-green {
        order: 1;
        margin: 0 15px;
    }
    .dashboard .dashb_left {
        order: 0;
        margin: 0 !important;
    }
    .dashboard .dashb_right {
        order: 2;
    }
    .profile_container .welcome-title h1 {
        font-size: 30px;
    }
    .profile_setup_help > p:first-child {
        width: 100%;
    }
    .profile_setup_help {
        margin-top: 30px;
        max-width: 100%;
        margin-bottom: 25px;
    }
    .milestoneSection .white-block {
        padding: 15px;
    }
}

@media (max-width: 575px) {
    .profile_container .container.profile_setup_cont {
        margin: 25px auto 0 !important;
    }
    .icn_details {
        display: flex !important;
        flex-direction: column;
        justify-content: center !important;
        align-items: center;
    }
    .icn_details > .flex-1 {
        width: 100%;
    }
    .iconsec_title {
        margin: 20px 0 10px;
        text-align: left;
    }
    .iconsec_link,
    .iconsec_cont {
        text-align: center;
    }
    .minus-paddingx-30 {
        padding-left: 15px;
        padding-right: 15px;
    }
    .padding-30 {
        padding: 15px;
    }
    .copywriting .modal-header > div:first-child {
        flex-direction: column;
        align-items: start !important;
        margin-bottom: 20px;
    }
    .modal-content.viewRequests {
        padding: 15px 20px;
    }
}

@media (max-width: 380px) {
    .bullet ul li div span {
        margin-top: -4px;
    }
}
.sideBar li a > b:first-child,
.headerRightSide > ul > li > a,
.pageContent > .container > .row > div .milestone > .icon > span,
.milestone > .icon > span,
.icn_details .iconsec > b,
.user-dropdown ul li a b,
.swingtag .swingicon {
    animation-name: bounceIn;
    transform-origin: center bottom;
    animation-duration: 1s;
    animation-fill-mode: both;
    animation-iteration-count: 1;
}
.sideBar li:hover a > b:first-child,
.headerRightSide > ul > li:hover > a,
.pageContent > .container > .row > div:hover .milestone > .icon > span,
.milestone:hover > .icon > span,
.icn_details:hover .iconsec > b,
.user-dropdown ul li a:hover b,
.swingtag:hover .swingicon {
    transform-origin: top center;
    animation-name: swing;
}
.sideBar li.active:hover a > b:first-child,
.headerRightSide > ul li a.invite {
    animation-name: unset;
}

@keyframes swing {
    20% {
        transform: rotate3d(0, 0, 1, 15deg);
    }
    40% {
        transform: rotate3d(0, 0, 1, -10deg);
    }
    60% {
        transform: rotate3d(0, 0, 1, 5deg);
    }
    80% {
        transform: rotate3d(0, 0, 1, -5deg);
    }
    100% {
        transform: rotate3d(0, 0, 1, 0deg);
    }
}
.tooltip-inner {
    background: #0b3454;
    border: 1px solid #0b3454;
}
.bs-tooltip-top .tooltip-arrow::before {
    border-top-color: #0b3454;
}
a.text-burgandi:hover {
    color: #d42941;
}
.welcome-title + .dashboard {
    margin-left: 100px;
}
.custom-nav > ul li.nav-item a.nav-link.dropdown-toggle.dashboardnav::after,
.interestsPreferences_sidebar,
.achievements_sidebar {
    display: none;
}
.profile_setup .btn-verify {
    padding: 0 15px;
}
.alumni-directory-block .icon-right-arrow:hover {
    color: #0b3454;
}
.aldir_scroll > .row > .aldir_box {
    width: 212px;
    height: 133px;
    padding: 0;
}
.aldir_scroll > .row > .aldir_box:not(:last-child) {
    margin-right: 20px;
}
.aldir_box .number {
    padding: 10px 12px 0 20px;
}
.aldir_box .number + div > div.font-16 {
    color: #0b3454;
    line-height: 18px;
    padding: 8px 0 0 18px;
}
.aldir_box .alumni-directory-img {
    margin-right: 10px;
    display: flex;
    align-items: flex-end;
}
.aldir_box .alumni-directory-block {
    justify-content: space-between;
    flex-direction: row;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
}
.aldir_box .alumni-directory-block.active {
    background: linear-gradient(-30deg, #fff, #41edff);
}
.aldir_box .alumni-directory-block > div {
    width: 100%;
}
.aldir_box .number + div > div.font-16.min94 {
    min-width: 94px;
}
.aldir_scroll > .row {
    width: max-content;
    margin: 0;
}
.profile_pic .profile_picedt {
    height: 24px;
    width: 24px;
    background: #5cae48;
    border-radius: 50%;
    text-align: center;
    top: 0px;
    right: -4px;
}
.phone_number.max-135 {
    max-width: 135px;
}
.btn-white-border.verifynow {
    padding: 0 20px;
    height: 30px;
    line-height: 26px;
    border: 2px solid #e1e1e1;
}
.btn-white.locbtn:hover .text-dark-blue {
    color: #fff;
}
.btn-white.locbtn {
    line-height: 14px;
}
.locbtncol {
    justify-content: flex-end;
    align-items: center;
}
.height-40 {
    height: 40px !important;
    line-height: 40px;
}
.height-45 {
    height: 45px !important;
    line-height: 45px;
}
.height-28 {
    height: 28px !important;
}
.height-36 {
    height: 36px !important;
}
.line-height-18 {
    line-height: 18px;
}
.line-height-26 {
    line-height: 26px;
}
.text-gray-e1 {
    color: #e1e1e1;
}
.text-gray-98 {
    color: #989898;
}
.text-black {
    color: #000;
}
.font-35 {
    font-size: 35px;
}
.me5 {
    margin-right: 5px;
}
.me10 {
    margin-right: 10px;
}
.mb-10 {
    margin-bottom: 10px !important;
}
.mb-20 {
    margin-bottom: 20px;
}
.mt-20 {
    margin-top: 20px;
}
.mt-30 {
    margin-top: 30px;
}
.mb-30 {
    margin-bottom: 30px;
}
.mt-38 {
    margin-top: 38px;
}
.mt-39 {
    margin-top: 39px;
}
.mt-40 {
    margin-top: 40px;
}
.mb-40 {
    margin-bottom: 40px;
}
.mt-43 {
    margin-top: 43px;
}
.mt-42 {
    margin-top: 42px;
}
.ps-20 {
    padding-left: 20px;
}
.xscroll {
    width: 100%;
    overflow-x: auto;
    scrollbar-width: thin;
    position: relative;
    z-index: 8;
}
.max-400 {
    max-width: 400px !important;
    width: 90% !important;
}
.max-464 {
    max-width: 464px !important;
    width: 90%;
}
.max-480 {
    max-width: 480px !important;
    width: 90%;
}
.border-lightgray {
    background: #f3f3f3;
    height: 1px;
    width: 100%;
    display: block;
}
.border-gray-e2 {
    background: #e2e2e2;
    height: 1px;
    width: 100%;
    display: block;
}
.border-gray-dc {
    background: #dcdcdc;
    height: 1px;
    width: 100%;
    display: block;
}
.border-radius-6 {
    border-radius: 6px;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    -ms-border-radius: 6px;
    -o-border-radius: 6px;
}
.w-max-content {
    width: max-content !important;
}
.bg-skyblue {
    background: #26a7df;
}
.bg-purple {
    background: #51499c;
}
.btn-darkblue {
    background: #0b3454;
    border-radius: 27px;
    height: 40px;
    padding: 0 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    text-decoration: none;
    font-size: 16px;
    line-height: 16px;
    font-weight: 500;
    position: relative;
    overflow: hidden;
    border: 0;
}
.btn-darkblue:hover{
    background-color: #0b3454;
    color: #fff;
}

.btn-green-msg:hover,
.btn-pink-msg:hover {
    color: #fff;
}
.btn-darkblue span,
.btn-green-msg span,
.btn-pink-msg span {
    position: relative;
}
.btn-darkblue::before {
    position: absolute;
    content: '';
    left: 0;
    top: 0;
    bottom: 0;
    width: 0;
    background: #08273f;
    transition: all 0.3s ease-in-out;
}
.btn-darkblue:hover::before,
.btn-green-msg:hover::before,
.btn-pink-msg:hover::before {
    width: 100%;
    transition: all 0.3s ease-in-out;
}
.btn-icon-bg,
.circle-effect {
    background: #fff;
    position: relative;
}
.btn-icon-bg:hover,
.circle-effect:hover,
.btn-icon-bg:hover span,
.listblk_icon:hover > span.icon,
.album_shareblk > a.btn.btnicon:hover span.icon {
    color: #fff;
}
.btn-icon-bg span,
.circle-effect span {
    position: relative;
}
.btn-icon-bg::before {
    position: absolute;
    content: '';
    left: 0;
    top: 0;
    bottom: 0;
    width: 0;
    background: #08273f;
    transition: all 0.3s ease-in-out;
}
.btn-icon-bg:hover img {
    filter: brightness(0) invert(1);
    -webkit-filter: brightness(0) invert(1);
}
.circle-effect::before {
    position: absolute;
    content: '';
    left: 0;
    top: 0;
    bottom: 0;
    width: 0;
    background: #08273f;
    transition: all 0.3s ease-in-out;
    right: 0;
    width: 0;
    height: 0;
    margin: auto;
    border-radius: 50%;
}
.btn-icon-bg:hover::before {
    width: 100%;
    transition: all 0.3s ease-in-out;
}
.circle-effect:hover::before {
    width: 100%;
    transition: all 0.3s ease-in-out;
    height: 100%;
}
.btn-green-msg {
    background: #5cae48;
    border-radius: 4px;
    padding: 0 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    text-decoration: none;
    font-size: 16px;
    line-height: 16px;
    font-weight: 500;
    position: relative;
    overflow: hidden;
    border: 0;
}
.btn-green-msg::before {
    position: absolute;
    content: '';
    left: 0;
    top: 0;
    bottom: 0;
    width: 0;
    background: #398227;
    transition: all 0.3s ease-in-out;
}
.btn-pink-msg {
    background: #e37070;
    border-radius: 4px;
    padding: 0 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    text-decoration: none;
    font-size: 16px;
    line-height: 16px;
    font-weight: 500;
    position: relative;
    overflow: hidden;
    border: 0;
}
.btn-pink-msg::before {
    position: absolute;
    content: '';
    left: 0;
    top: 0;
    bottom: 0;
    width: 0;
    background: #d55151;
    transition: all 0.3s ease-in-out;
}
.btn-dark-blue {
    /* width: 150px; */
    text-align: center;
    padding: 0 20px;
    border: 1px solid #0b3454;
    border-radius: 27px;
    background: linear-gradient(to right, #08273f 50%, #0b3454 50%);
    background-size: 201% 100%;
    transition: all 0.5s;
    background-position: right bottom;
}
.btn-greenm {
    width: 150px;
    text-align: center;
    padding: 0 20px;
    border: 1px solid #5cae48;
    border-radius: 27px;
    background: linear-gradient(to right, #398227 50%, #5cae48 50%);
    background-size: 201% 100%;
    transition: all 0.5s;
    background-position: right bottom;
    -webkit-transition: all 0.5s;
    -moz-transition: all 0.5s;
    -ms-transition: all 0.5s;
    -o-transition: all 0.5s;
}
.btn-dark-blue:hover,
.btn-greenm:hover {
    background-position: left bottom;
    background-size: 201% 100%;
}
.btn-greenm.btnverified {
    width: 104px;
    text-align: center;
    padding: 0 20px;
    border: 1px solid #5cae48;
    border-radius: 27px;
    background: linear-gradient(to right, #398227 50%, #5cae48 50%);
    background-size: 200% 100%;
    transition: all 0.5s;
    background-position: right bottom;
    height: 30px;
    line-height: 30px;
    color: #fff;
    text-decoration: none;
    font-size: 13px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
}
.btn-greenm.btnverified:hover {
    background-position: left bottom;
    background-size: 201% 100%;
    color: #fff;
}
.btn-red.btnverified {
    background: #0000001a;
    border: 2px solid #ffffff99;
    border-radius: 20px;
    font-size: 12px;
    padding: 0 12px;
    height: 30px;
    width: 99px;
    display: flex;
    align-items: center;
    text-decoration: none;
    color: #fff;
    justify-content: center;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.btn-red.btnverified:hover {
    background: #fff;
    color: #000;
}
.btn-red.btnverified:hover .icon-varified {
    color: #000 !important;
}
.polartabsec {
    padding: 18px 25px;
    margin: 0;
    background: #f2f9ff;
}
.polartabsec ul {
    border-bottom: 0 solid #fff;
    width: max-content;
}
.polartabsec ul li {
    background: transparent;
    border: 0px solid #7d7d7d;
    border-radius: 20px;
    height: 40px;
    padding: 0;
}
.polartabsec ul li .nav-link {
    color: #414141;
    font-size: 16px;
    font-weight: 500;
    height: 40px;
    line-height: 38px;
    background: #fff;
    border: 2px solid #7d7d7d;
    padding: 0 23px;
    border-radius: 20px;
}
.polartabsec ul li .nav-link.active,
.polartabsec ul li .nav-link:hover {
    color: #fff;
    border: 2px solid #5cae48;
    background: #5cae48;
}
.polartabsec ul li:not(:last-child) {
    margin: 0 10px 0 0;
}
.ji_filtersec .icon-filter {
    font-size: 15px;
    color: #000;
    margin: -3px 5px 0 0;
}
.fiterItem {
    padding: 0;
    border: 1px solid rgba(0, 0, 0, 0.125);
    border-radius: 6px;
    overflow: hidden;
}
.filterHeader {
    background: transparent;
    border-radius: 0;
    padding: 0;
    border: 0px solid rgba(0, 0, 0, 0.125);
}
.filterHeader button span.toggle {
    width: 10px;
    height: 10px;
    margin-left: 10px;
    position: relative;
}
.filterHeader button span.toggle::before {
    width: 10px;
    height: 10px;
    background: transparent;
    border-left: 2px solid #000;
    border-top: 2px solid #000;
    transform: rotate(45deg);
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    content: '';
    transition: all 0.3s ease-in-out;
    -webkit-transform: rotate(45deg);
    -moz-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    -o-transform: rotate(45deg);
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.filterHeader button.collapsed span.toggle::before {
    transform: rotate(225deg);
    -webkit-transform: rotate(225deg);
    -moz-transform: rotate(225deg);
    -ms-transform: rotate(225deg);
    -o-transform: rotate(225deg);
}
.scrollMe {
    max-height: 215px;
    margin-bottom: 0px;
    overflow-y: auto;
    scrollbar-width: thin;
}
.scrollMe::-webkit-scrollbar {
    width: 4px;
}
.scrollMe::-moz-scrollbar {
    width: 4px;
}
.scrollMe::-webkit-scrollbar-track {
    background: #eee;
}
.scrollMe::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 20px;
    border: 2px solid #666;
}
.fiterItem .form-check:not(:last-child) {
    margin-bottom: 10px;
}
.fiterItem .form-check .form-check-input {
    width: 20px;
    height: 20px; /* margin-left: -20px; */
    border: 1px solid #bacfde;
}
.fiterItem label {
    cursor: pointer;
    padding-top: 3px !important;
}
.fiterItem .card {
    border-radius: 0;
    border: 0px solid #fff;
    padding: 0px 20px 20px;
}
.fiterItem .form-check {
    display: flex;
}
.filterHeader button {
    background: #fff;
    border-radius: 0;
    padding: 0;
    border: 0px solid rgba(0, 0, 0, 0.125);
    padding: 15px 20px;
}
.filterHeader button.collapsed {
    border-bottom: 0px solid rgba(0, 0, 0, 0.125);
}
.filterSearchblk {
    margin: 0px;
    padding: 0 18px;
}
.filterSearchblk .filterSearch input {
    background: #f3f3f3;
    border: 0 solid #fff;
    border-radius: 6px;
    color: #000;
    height: 36px;
    line-height: 36px;
    margin: 0 4px 2px;
}
.filterSearchblk .filterSearch button {
    position: absolute;
    right: 14px;
    width: 14px;
    height: 14px;
    font-size: 14px;
    top: 9px;
    padding: 0;
    color: #414141;
}
.ji_filtersec {
    width: 100%;
    max-width: 320px;
}
form.minmaxlb .form-label {
    color: #535353;
    font-size: 14px;
    font-weight: 500;
    font-style: italic;
}
form.minmaxlb button {
    max-width: 91px;
    background: #0b3454;
    padding: 0;
    height: 36px;
    line-height: 36px;
    color: #fff;
    border-radius: 18px;
}
.fiterItem .card .form-check-input:checked,
form.lstCustForm .form-check-input:checked {
    background-color: #5cae48;
    border-color: #5cae48 !important;
}
.form-check-input:focus {
    box-shadow: 0 0 0 0 rgba(13, 110, 253, 0.25);
}
.act_lst {
    border: 1px solid #d2d2d2;
    padding: 40px 25px 25px 25px;
    border-radius: 6px;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    -ms-border-radius: 6px;
    -o-border-radius: 6px;
}
.act_lst > .row > div:last-child {
    width: 255px;
}
.act_lst > .row.postedrow > div:last-child,
.act_lst.actlst_listed > .row > div:last-child {
    width: 150px;
}
.list_badge {
    position: absolute;
    width: 90px;
    height: 25px;
    line-height: 25px;
    color: #fff;
    background: #d42941;
    text-align: center;
    border-radius: 6px 0px 10px 0px;
    left: 0;
    top: 0;
}
.exp_loc > a.btn {
    display: inline-flex;
    align-items: center;
    border: 1px solid #dedede;
    height: 32px;
    line-height: 32px;
    padding: 0 16px;
    border-radius: 18px;
    font-size: 14px;
    font-weight: 500;
    color: #0b3454;
    margin-bottom: 10px;
    background: #fff;
    overflow: hidden;
}
.exp_loc > a.btn:not(:last-child) {
    margin-right: 5px;
}
.exp_loc > a .btn > img {
    margin: -3px 8px 0 0;
}
.exp_loc > a.btn > span.icon,
.exp_loc > a.btn > img {
    margin: -3px 8px 0 0;
}
.person_detls {
    margin-top: 10px;
}
.listblk_icon {
    border: 1px solid #dedede;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
}
.listblk_icon > span.icon,
.album_shareblk > a.btn.btnicon span.icon {
    color: rgba(11, 52, 84, 0.4);
}
.act_lst > .row > div:last-child .btn-green {
    width: 150px;
}
.act_lst .btn-green {
    padding: 0 20px;
}
.load_more_btn {
    display: block;
    margin: 30px auto 0;
    width: 80%;
    max-width: 318px;
    height: 50px;
    line-height: 48px;
    border: 1px solid #e1e1e1;
    border-radius: 25px;
    text-align: center;
    text-decoration: none;
    font-size: 18px;
    font-weight: 500;
    color: #535353;
    background: linear-gradient(to right, #fff 50%, #fff 50%);
    background-size: 200% 100%;
    transition: all 0.5s;
    background-position: right bottom;
    -webkit-transition: all 0.5s;
    -moz-transition: all 0.5s;
    -ms-transition: all 0.5s;
    -o-transition: all 0.5s;
}
.load_more_btn:hover {
    background-position: left bottom;
    background-size: 201% 100%;
    color: #d42941;
}
.load_more_btn img {
    margin: 0 15px 0 0;
}
.no_listed_items_blk > div {
    text-align: center;
    border: 1px solid #d2d2d2;
    border-radius: 6px;
    padding: 40px;
}
.JobInternshipForm {
    width: 94%;
    max-width: 670px;
    display: none;
}
.JobInternshipForm h2 {
    border-bottom: 1px solid rgba(125, 125, 125, 0.3);
    padding: 0 0 10px;
    margin: 0 0 40px;
}
form.lstCustForm .form-select,
form.lstCustForm input.form-control {
    border: 1px solid #848484;
    height: 45px;
}
form.lstCustForm textarea.form-control {
    border: 1px solid #848484;
}
form.lstCustForm .form-check .form-check-input {
    width: 24px;
    height: 24px;
    margin-left: -20px;
    border: 2px solid #848484;
}
form.lstCustForm .form-check:not(:last-child) {
    margin: 0 40px 5px 0;
}
form.lstCustForm .btn-greenm,
.btn-greenm252 {
    min-width: 252px;
}
form.lstCustForm label span {
    font-size: 14px;
    color: #848484;
    font-weight: 400;
    font-style: italic;
    display: inline-block;
    padding: 0 0 0 20px;
}
form.lstCustForm .inputfile_parent label span.uploadlabel {
    font-size: 16px;
    color: #414141;
    font-weight: 400;
    display: inline-block;
    padding: 0 0 0 8px;
    font-style: normal;
}
form.lstCustForm label span.icon {
    font-style: unset;
    color: #414141;
}
.fileclose {
    height: 12px;
    line-height: 10px;
    width: 12px;
    text-align: center;
    background: #959595;
    border-radius: 50%;
    color: #fff;
    font-size: 12px;
    cursor: pointer;
    display: none;
    margin-left: 6px;
    justify-content: center;
    align-items: center;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    -ms-border-radius: 50%;
    -o-border-radius: 50%;
}
.fileclose span {
    font-size: 6px;
    display: block;
    margin: 0 0 0px 1px;
}
.fileicon {
    display: none;
    margin-right: 6px;
}
.docselect {
    display: none;
    align-items: center;
    width: max-content;
}
.docselect.docseladdbg {
    background: #f8f8f8;
    display: flex;
    padding: 7px 12px;
    margin: 10px 0 0 0;
    border-radius: 6px;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    -ms-border-radius: 6px;
    -o-border-radius: 6px;
}
.inputfile::file-selector-button {
    font: inherit;
    display: none;
}
.inputfile_parent label {
    color: #f1e5e6;
    background-color: #f3f3f3;
    border: 1px dashed #848484;
    border-radius: 6px;
    height: 60px;
    line-height: 60px;
    max-width: 100%;
    font-size: 1.25rem;
    font-weight: 500;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
    display: inline-block;
    overflow: hidden;
    padding: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.albmform .inputfile_parent label {
    height: 80px;
    line-height: 80px;
}
.inputfile_parent label span {
    font-size: 16px;
    color: #414141;
    font-weight: 500;
    font-style: unset;
    float: none;
    padding: 0 0 0 10px;
}
.inputfile_parent {
    position: relative;
    height: auto;
}
.inputfile_parent.profile .docselect {
    display: none;
}
.inputfile_parent.profile.select + p {
    display: none;
}
.inputfile_parent.profile label {
    background-color: #fff;
    border: 1px dashed #a8c5dd;
    border-radius: 6px;
    height: 40px;
    line-height: 40px;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    -ms-border-radius: 6px;
    -o-border-radius: 6px;
}
.inputfile_parent.profile.select .docseladdbg {
    display: flex;
    background: #eaeaea;
}
.inputfile_parent.profile.pop-up label {
    background: #f3f3f3;
    border: 1px dashed #848484;
    border-radius: 6px;
    opacity: 1;
    height: 45px;
    line-height: 45px;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    -ms-border-radius: 6px;
    -o-border-radius: 6px;
}
.album_imgblk img {
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 190px;
}
.album_blk {
    border: 1px solid #d2d2d2;
    border-radius: 6px;
    height: 100%;
}
.album_badge {
    background: #d42941;
    padding: 0 20px;
    height: 32px;
    line-height: 32px;
    border-radius: 6px 0 15px 0;
    top: 0;
    left: 0;
}
.album_imgblk {
    border-radius: 6px 6px 0 0;
    overflow: hidden;
    min-height: 190px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.album_contblk {
    background: #fff;
    border-radius: 6px;
    width: calc(100% - 20px);
    margin: -40px auto 0;
    position: relative;
    padding: 20px 20px 15px;
}
.album_contblk h3 {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
.album_shareblk {
    width: 60px;
    padding: 0 0 0 20px;
}
.album_shareblk > span,
.album_shareblk > a.btn.btnicon {
    width: 40px;
    display: flex;
    height: 40px;
    line-height: 38px;
    border: 1px solid #dedede;
    border-radius: 50%;
    justify-content: center;
    align-items: center;
}
.album_shareblk > span:not(:last-child),
.album_shareblk > a.btn:not(:last-child) {
    margin: 0 0 5px;
}
.albumblk_footer {
    background: #f2f9ff;
    padding: 13px 30px;
    border-radius: 0 0 6px 6px;
}
.albumblk_footer img {
    margin: 0 6px 0 0;
}
.album_blk_parent {
    margin: 0 0 20px 0;
}
.album_imgvdo {
    right: 10px;
    top: 10px;
}
.Wrdrow {
    width: calc(100% - 60px);
}
.lstperdetails {
    width: calc(100% - 40px);
}
.image_tn {
    margin: 0 0 5px 0;
}
.image_tn > a {
    width: 63px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 16px;
    color: #e1e1e1;
    font-size: 13px;
    text-decoration: none;
}
.image_tn > a img.gallicon {
    width: 14px;
    height: auto;
    margin: 0 3px 0 0;
}
img.custimg {
    width: auto;
    display: block;
    margin: 0 auto;
}
.icon_bluecir {
    background: #d1f1ff;
    height: 40px;
    width: 40px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.EventsBlk .btn-border-gray {
    color: #414141;
    min-width: 110px;
    padding: 0 12px;
}
.EventsBlk .btn-border-gray.text-gray-41:hover {
    color: #fff;
}
.album_contblk.eventsbox {
    padding: 20px 8px 15px 20px;
}
.lightboxcontainer {
    width: 100%;
    text-align: left;
}
.lightboxleft {
    width: 40%;
    float: left;
}
.lightboxright {
    width: 60%;
    float: left;
}
.lightboxright iframe {
    min-height: 390px;
}
.divtext {
    margin: 36px;
}
#html5lightbox-watermark,
.html5-nav-showcontrol {
    display: none !important;
}
.html5-image {
    padding: 0 !important;
}
#html5-lightbox-box,
.html5-elem-wrap,
.html5lightbox-video iframe {
    width: 600px !important;
    height: 400px !important;
}
.html5-prev-inside .mh-icon-left,
.html5-next-inside .mh-icon-right {
    position: relative;
}
.html5-next-inside .mh-icon-right::after {
    position: absolute;
    width: 12px;
    height: 12px;
    border-top: 2px solid #fff;
    border-right: 2px solid #fff;
    content: '';
    transform: rotate(45deg);
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    -webkit-transform: rotate(45deg);
    -moz-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    -o-transform: rotate(45deg);
}
.html5-prev-inside .mh-icon-left::after {
    position: absolute;
    width: 12px;
    height: 12px;
    border-top: 2px solid #fff;
    border-right: 2px solid #fff;
    content: '';
    transform: rotate(-135deg);
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    -webkit-transform: rotate(-135deg);
    -moz-transform: rotate(-135deg);
    -ms-transform: rotate(-135deg);
    -o-transform: rotate(-135deg);
}
.html5gallery-title-0 {
    top: 360px !important;
}
.html5gallery-title-text-0 {
    color: #333 !important;
    background-color: transparent !important;
    text-align: center !important;
    font-size: 18px !important;
    filter: progid: DXImageTransform.Microsoft.gradient(enabled=false) !important;
}
.html5gallery-play-0,
.html5gallery-pause-0,
.html5gallery-lightbox-0 {
    top: 8px !important;
}
.skills_input_selected > span {
    padding: 6px 15px;
    border: 1px solid #dedede;
    border-radius: 7px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
}
.profile_radiorow > .icon-cross {
    position: absolute;
    font-size: 8px;
    color: #0b345480;
    right: -17px;
    top: 19px;
    cursor: pointer;
}
.msg_title .form-check-input:focus,
.msg_title.msg_heading_row form select:focus {
    box-shadow: unset;
}
.w-h-32 {
    width: 32px;
    height: auto;
}
.w-h-90 {
    width: 90px;
    height: auto;
}
.dropdowncheck span {
    padding: 5px 12px;
    border: 1px solid #dedede;
    border-radius: 7px;
    font-size: 14px;
    font-weight: 400;
    width: max-content;
    margin: 0 10px 0 0;
}
.text-gray-f3 {
    color: #f3f3f3;
}
.albumadd {
    background: #f3f3f3;
    border-radius: 6px;
    padding: 12px 16px 12px 12px;
    margin-bottom: 10px;
}
.albumadd img {
    border-radius: 6px;
}
.albumadd > div textarea.form-control {
    border: 1px solid #d9d9d9;
    min-height: 112px;
}
.albumadd .addvdo i {
    color: #000;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    margin: auto;
    width: 30px;
    height: 30px;
    filter: invert(100%);
    background: #fff;
    border-radius: 50%;
    -webkit-filter: invert(100%);
}
.list_badge.thumbbadge {
    width: 108px;
    height: 32px;
    line-height: 32px;
    border-radius: 6px 0px 15px 0px;
}
.albumadd .dropdown-menu li a:hover {
    color: #5cae48;
    background-color: transparent;
}
.albumadd .dropdown-menu {
    transform: unset !important;
    top: 22px !important;
    right: -2px !important;
    left: auto !important;
    padding: 10px 15px;
    width: 108px;
    height: 92px;
    max-width: 108px;
}
.albumadd .dropdown-menu .dropdown-item {
    padding: 2px 0;
    font-weight: 400;
    color: #000000;
    font-size: 14px;
}
.gallimg_update.modal-dialog {
    max-width: 700px;
    width: 94%;
}
.gallimg_update .editprofileImg::after {
    display: none;
}
.gallimg_update .editprofileImg {
    max-width: 370px;
}
.profiles_blk > div > div {
    border: 1px solid #d2d2d2;
    border-radius: 6px;
}
.profiles_contsec {
    padding: 0 20px 20px;
    text-align: center;
}
.profiles_blk img {
    border-radius: 6px 6px 0 0;
    width: 100%;
    height: auto;
}
.profiles_contsec .btn-green {
    line-height: 14px;
}
.uni_profiles_sec {
    border: 1px solid #d2d2d2;
    border-radius: 6px;
    padding: 20px 30px 20px 20px;
}
.uni_profiles_100 .uni_profiles_sec {
    border: 0px solid #d2d2d2;
    border-radius: 0;
    padding: 0;
}
textarea.graybg-textarea,
textarea.graybg-textarea:focus {
    background: #f3f3f3;
    border: 1px solid #dddddd;
    border-radius: 5px;
    color: #414141;
    font-size: 16px;
    font-weight: 500;
}
.btn-green.disable {
    border-radius: 25px;
    padding: 0 25px;
    line-height: 32px;
    border: 2px solid #cbcbcb;
    height: 35px;
    display: inline-flex;
    text-decoration: none;
    color: #bcbcbc;
    transition: all 0.3s ease-in-out;
    position: relative;
    overflow: hidden;
    justify-content: center;
    align-items: center;
    background: #fff;
}
.btn-green.disable::before {
    width: 0;
    height: 100%;
    content: '';
    background: #fff;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    transition: all 0.3s ease-in-out;
}
.btn-green.disable:hover::before {
    width: 100%;
}
.btn-green.disable:hover {
    color: #bcbcbc;
    background: #fff;
}
.btn-green.disable span {
    position: relative;
}
.polartabsec ul.msgtabs li button.nav-link {
    padding: 0 18px;
}
.newmsg .ji_filtersec {
    background: #f8f8f8;
    padding: 25px 30px 30px;
}
.newmsg .filterSearch input {
    border-radius: 18px;
    border: 1px solid #e1e1e1;
    padding-left: 37px;
    color: #000000;
    height: 35px;
}
.newmsg .filterSearch .btn.icon-search {
    left: 11px;
    top: 13px;
    padding: 0;
    font-size: 14px;
    color: #414141;
    font-weight: 400;
    z-index: 1;
}
.dotted-blue-border {
    height: 1px;
    width: 100%;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/dotted_border_bg.png) left top
        repeat-x;
}
.newmsg .ji_filtersec ul {
    list-style: none;
    padding: 0;
}
.newmsg .ji_filtersec ul li {
    margin: 0 0 20px;
}
.newmsg .ji_filtersec ul li a {
    color: #0b3454;
    font-weight: 500;
    font-size: 16px;
    text-decoration: none;
    width: 100%;
    display: inline-block;
}
.newmsg .ji_filtersec ul li.active a {
    color: #5cae48;
}
.msgtabcont {
    padding: 25px;
}
.msgtabcont.msgwrapext {
    padding: 25px 10px 25px 25px;
}
.msgtabcont .msgbox {
    border: 1px solid #dedede;
    border-radius: 6px;
    padding: 20px 0px 90px;
    min-height: 470px;
}
.msgtabcont .msgbox.msgboxconvo {
    padding: 5px 0px 90px;
}
.msgbox .filterSearch input {
    height: 45px;
    line-height: 45px;
    border: 1px solid #848484;
    border-radius: 23px;
    font-size: 16px;
    color: #666666;
}
.newmsg .msgbox .filterSearch .btn.icon-search {
    top: 14px;
}
.search_btmshadow {
    background: transparent linear-gradient(180deg, #f2f2f2 0%, #ffffff 100%) 0% 0% no-repeat padding-box;
    height: 20px;
    width: 100%;
}
.msgbox_send {
    width: 100%;
    height: 60px;
    background: #f3f3f3;
    left: 0;
    bottom: 0;
    border-radius: 0 0 6px 6px;
    padding: 5px;
}
.msgbox_send input {
    height: 50px;
    line-height: 50px;
    font-size: 16px;
    font-weight: 500;
    color: #414141;
    padding-right: 80px;
}
.btn-complete-now.msgsendbtn span {
    font-size: 14px;
    font-weight: 600;
    position: relative;
}
.btn-complete-now.msgsendbtn {
    top: 5px;
    right: 5px;
    position: absolute;
    z-index: 1;
}
.search_sugg {
    background: #fff;
    position: absolute;
    height: auto;
    width: 100%;
    top: auto;
    border: 1px solid #dedede;
    border-radius: 20px;
    box-shadow: 0px 10px 20px #0000001a;
    padding: 25px;
    transition: all 0.5s ease-in-out;
    z-index: 9;
    display: none;
    -webkit-border-radius: 20px;
    -moz-border-radius: 20px;
    -ms-border-radius: 20px;
    -o-border-radius: 20px;
}
.msgbox .filterSearch input.open + .search_sugg {
    display: block;
}
.msgbox .uni_profiles_sec {
    padding: 20px 45px 20px 20px;
}
.msgbox .uni_profiles_sec .icon-invert-cross {
    color: #a9a9a9;
    right: 20px;
    top: 0;
    bottom: 0;
    margin: auto;
    height: 16px;
    width: 16px;
}
.search_ttlblk .uni_profiles_sec {
    padding: 0;
    border: 0 solid #fff;
}
.msgbox .search_cont {
    height: 280px;
    overflow-y: auto;
    scrollbar-width: thin;
}
.msg_popup_cont {
    background: #f8f8f8;
    border-radius: 10px;
    margin: 60px 0 0 0;
    padding: 70px 30px 25px;
    position: relative;
}
.msg_popup_cont > img {
    width: 90px;
    height: auto;
    left: 0;
    right: 0;
    margin: 0 auto;
    top: -50px;
    border: 6px solid #fff;
    box-sizing: content-box;
}
.msg_popup_modal .modal-body {
    padding: 30px;
}
.alumni-switch-container.msg-switch {
    background: #fff;
    border: 1px solid #b9b9b9;
    width: 342px;
}
.alumni-switch-container.msg-switch .switch > a {
    color: #000;
}
.alumni-switch-container.msg-switch .switch > a.active {
    color: #fff;
}
.alumni-switch-container.msg-switch .switch > span {
    background: #5cae48;
}
.msg_name {
    width: max-content;
    background: #f3f3f3;
    padding: 16px 20px;
    border-radius: 6px;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    -ms-border-radius: 6px;
    -o-border-radius: 6px;
}
.msg_area {
    background: #f3f3f3;
    border-radius: 6px;
    padding: 20px 20px;
    max-width: 620px;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    -ms-border-radius: 6px;
    -o-border-radius: 6px;
}
.msg_title .icon-star {
    color: #dedede;
}
.msg_title .icon-star.selected {
    color: #f8b018;
}

/* conversation */
.profile_person {
    display: flex;
    flex-direction: column;
    align-items: end;
}
.profile_person p {
    background: #2296c9;
    padding: 11px 20px;
    border-radius: 10px 10px 0px 10px;
    color: #fff;
    max-width: 456px;
    line-height: 20px;
    margin-bottom: 10px;
}
.profile_person p.accepted {
    background: #5cae48;
    border-radius: 6px;
    max-width: 150px;
    width: 100%;
    text-align: center;
}
.profile_person p.reject {
    background: #a00;
    border-radius: 6px;
    max-width: 150px;
    width: 100%;
    text-align: center;
}
.profile_person p.date {
    background: none;
    color: #848484;
    font-size: 14px;
    font-weight: 500;
    padding: 0;
}
.profile_person p + p.date {
    margin-top: -10px;
}
.non-profile_person {
    display: flex;
    flex-direction: column;
    align-items: start;
}
.non-profile_person p {
    background: #413a7d;
    padding: 11px 20px;
    border-radius: 10px 10px 10px 0px;
    color: #fff;
    max-width: 456px;
    line-height: 20px;
    margin-bottom: 10px;
}
.non-profile_person p.accepted {
    background: #5cae48;
    border-radius: 6px;
}
.non-profile_person p.reject {
    background: #a00;
    border-radius: 6px;
}
.non-profile_person p.date {
    background: none;
    color: #848484;
    font-size: 14px;
    font-weight: 500;
    padding: 0;
}
.non-profile_person p + p.date {
    margin-top: -10px;
}
.university_ttl > span.unicon {
    width: 32px;
    height: 32px;
    display: inline-block;
    color: #fff;
    text-align: center;
    line-height: 32px;
    border-radius: 50%;
    margin: 0 5px 0 0;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    -ms-border-radius: 50%;
    -o-border-radius: 50%;
}
.university_ttl {
    max-width: 180px;
    min-width: 180px;
}
.msg_title .form-check .form-check-input {
    width: 20px;
    height: 20px;
    border: 2px solid #848484;
}
.msg_title .form-check-input:checked {
    background-color: #0b3454;
    border-color: #0b3454;
    background-size: 18px auto;
}
.convo_btns a.btn {
    height: 30px;
    width: 180px;
    background: #f3f3f3;
    border-radius: 6px;
    padding: 0 10px;
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 500;
    color: #000;
    justify-content: flex-start;
    text-align: left;
}
.msg_title.msg_title_row {
    border: 1px solid #dedede;
    border-radius: 6px;
    margin-bottom: 10px;
    min-height: 80px;
}
.msg_title_row_wrapper .msg_title.msg_title_row:last-child {
    margin-bottom: 0;
}
.msg_title_row_wrapper {
    max-height: 264px;
    overflow-y: auto;
    margin-bottom: 10px;
    scrollbar-width: thin;
    padding-right: 15px;
}
.extmar {
    margin-right: 15px !important;
}
.msg_lt_rt a.btn {
    background: #f3f3f3;
    height: 36px;
    width: 36px;
    display: inline-block;
    line-height: 36px;
    text-align: center;
    border-radius: 6px;
    padding: 0;
    font-size: 14px;
    font-weight: 800;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    -ms-border-radius: 6px;
    -o-border-radius: 6px;
}
.msg_lt_rt a.btn.msg_lt i {
    margin-left: -2px;
}
.msg_lt_rt a.btn.msg_rt i {
    margin-right: -2px;
}
.msg_title.msg_heading_row .btn-complete-now {
    height: 36px;
    text-align: center;
    margin: auto;
    display: inline-block;
    padding: 0 20px;
    border-radius: 25px;
    line-height: 32px;
    overflow: hidden;
    position: relative;
    font-size: 14px;
    font-weight: 500;
    -webkit-border-radius: 25px;
    -moz-border-radius: 25px;
    -ms-border-radius: 25px;
    -o-border-radius: 25px;
}
.msg_title.msg_heading_row .btn-complete-now span {
    position: relative;
}
.msg_title.msg_heading_row form select {
    border: 2px solid #7d7d7d;
    border-radius: 18px;
    height: 36px;
    min-width: 170px;
    max-width: 170px;
    -webkit-border-radius: 18px;
    -moz-border-radius: 18px;
    -ms-border-radius: 18px;
    -o-border-radius: 18px;
}
.send_msg_text {
    width: max-content;
}
.send_msg_text > a {
    width: 150px;
    height: 70px;
    background: #5cae48;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    color: #fff;
    text-decoration: none;
    font-size: 16px;
    line-height: 23px;
    font-weight: 500;
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    -ms-border-radius: 10px;
    -o-border-radius: 10px;
}
.send_msg_text > a:not(:last-child) {
    margin-right: 10px;
}
.uniprof_btnmbl_align.paddings-67 {
    padding-left: 20px;
}
.welcome_pg {
    padding-left: 50px;
    padding-right: 50px;
}
.cpw_bg {
    padding: 40px;
    background: #f8f8f8;
    border-radius: 8px;
    margin: 0 0 30px 0;
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    -ms-border-radius: 8px;
    -o-border-radius: 8px;
}
.cpw_bg > div {
    width: 94%;
    max-width: 385px;
    margin: 0 auto;
}
.icon-green-right {
    width: 48px;
    height: 48px;
    background: #3bb54a;
    border-radius: 50%;
    margin: auto auto 25px;
    position: relative;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    -ms-border-radius: 50%;
    -o-border-radius: 50%;
}
.icon-green-right:after {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    width: 23px;
    height: 13px;
    border-left: 5px solid #fff;
    border-bottom: 5px solid #fff;
    content: '';
    transform: rotate(-45deg);
    top: -7px;
    -webkit-transform: rotate(-45deg);
    -moz-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    -o-transform: rotate(-45deg);
}

@media (min-width: 1600px) {
    #html5-lightbox-box,
    .html5-elem-wrap,
    .html5lightbox-video iframe {
        width: 1000px !important;
        height: 667px !important;
    }
}

@media (min-width: 768px) {
    .mobileFilter.mobileonly,
    .btn-filter.mobileonly {
        display: none;
    }
    .welcome-title + .dashboard.actdashboard {
        min-width: 292px;
    }
    .school_notification li div.check.notifychk {
        width: 100px;
        text-align: right;
        margin-left: 30px;
    }
}

@media (max-width: 1180px) {
    .msgacpign {
        width: 100% !important;
        align-items: start !important;
        flex-direction: column;
        margin-left: 74px;
    }
    .msgacpign > .flex-column {
        flex-direction: row !important;
        order: 2;
        margin: 8px 0 0 0;
    }
    .msgacpign > .flex-column a.mb-2 {
        margin-bottom: 0 !important;
    }
    .university_ttl {
        max-width: unset;
        min-width: unset;
        width: calc(100% - 85px);
        margin-right: 0 !important;
    }
    .msg_title_txt {
        width: calc(100% - 80px);
        max-width: unset !important;
        margin-left: 74px;
        margin-right: 0 !important;
    }
    .msg_title.msg_title_row {
        padding-top: 20px !important;
        padding-bottom: 20px !important;
    }
    .msgtabcont .msgbox.msgboxconvo .search_ttlblk {
        padding-top: 15px;
        padding-bottom: 15px;
    }
    .msg_title_row_wrapper {
        max-height: 514px;
    }
}

@media (max-width: 1150px) {
    .aldir_scroll {
        width: 100%;
        overflow-x: auto;
        scrollbar-width: thin;
    }
    .aldir_scroll::-webkit-scrollbar {
        height: 4px;
    }
    .aldir_scroll::-moz-scrollbar {
        height: 4px;
    }
    .aldir_scroll::-webkit-scrollbar-track {
        background: #e372848f;
    }
    .aldir_scroll::-webkit-scrollbar-thumb {
        background-color: #ccc;
        border-radius: 20px;
        border: 2px solid #810d20;
    }
}

@media (max-width: 1080px) {
    .act_lst > .row > .flex-1 {
        width: 100%;
        flex: unset;
        padding-right: 0 !important;
    }
    .act_lst > .row > div:last-child {
        width: 100%;
        padding: 15px 0 0 0;
        text-align: left !important;
    }
    .act_lst > .row.postedrow > div:last-child {
        width: 100%;
        padding: 5px 0 0 0;
    }
    .act_lst.actlst_listed > .row > div:last-child {
        width: 100%;
        padding: 10px 0 0 0;
    }
    .act_lst .postedtxt {
        margin-bottom: 5px !important;
    }
    .ji_filtersec {
        max-width: 275px;
    }
    .act_lst.actlst_listed .btn-green {
        margin-bottom: 5px;
    }
    .act_lst > .row,
    .act_lst > .row > div:last-child > div {
        justify-content: start !important;
    }
    .welcome-title + .dashboard {
        margin-left: 30px;
    }
    ul.school_notification li.read .check {
        width: 100%;
        text-align: right;
    }
}

@media (min-width: 768px) and (max-width: 1080px) {
    .school_notification li div.check.notifychk {
        width: 100px;
        text-align: right;
        margin-left: 30px;
    }
}

@media (min-width: 992px) and (max-width: 1160px) {
    .album_contblk .btn-green {
        height: 34px;
        padding: 0 15px;
        line-height: 34px;
    }
    .album_contblk {
        padding: 20px 15px 15px;
    }
    .album_shareblk > span img {
        max-width: 14px;
        height: auto;
    }
    .album_shareblk > span img.vimg {
        max-width: unset;
        max-height: 16px;
        width: auto;
    }
}

@media (max-width: 1024px) {
    .welcome-title h1,
    .notificationSection h3.font-35 {
        font-size: 30px;
    }
}

@media (min-width: 768px) and (max-width: 1180px) {
    .dashboard.actdashboard .ms-4.me-3.dashb_arr.dashb_left {
        margin-left: 10px !important;
        margin-right: 10px !important;
    }
}

@media (max-width: 1024px) {
    .msg_title_row_wrapper {
        max-height: 530px;
    }
}

@media (min-width: 768px) and (max-width: 1024px) {
    .profile_setup .icn_details .iconsec + .flex-1 {
        width: calc(100% - 80px);
        flex: unset;
        margin: 0 0 15px 0px;
        -webkit-box-flex: unset;
        -moz-box-flex: unset;
        -webkit-flex: unset;
        -ms-flex: unset;
    }
    .profile_setup .icn_details .activity-btn {
        margin: auto !important;
        display: block;
        min-width: 140px;
        max-width: max-content;
    }
}

@media (max-width: 991px) {
    .tabw-100 {
        width: 100% !important;
        max-width: unset !important;
    }
    .msg_title.msg_heading_row form {
        width: 100%;
        padding-top: 10px;
    }
    .selallarr {
        width: max-content !important;
        position: static;
        right: 0px;
        top: 0;
        margin-left: auto;
    }
}

@media (max-width: 900px) {
    .convo_btns {
        width: 100%;
        padding-left: 74px;
    }
}

@media (max-width: 800px) {
    .lightboxleft,
    .lightboxright {
        width: 100%;
    }
    .divtext {
        margin: 12px;
    }
    .uni_profiles_sec.profiles_sec_brk {
        -webkit-box-wrap: wrap;
        -moz-box-wrap: wrap;
        -ms-flex-wrap: wrap;
        -webkit-wrap: wrap;
        flex-wrap: wrap;
    }
    .uniprof_btnmbl_align.paddings-67 {
        width: 100%;
        padding-left: 67px;
    }
}

@media (min-width: 768px) and (max-width: 991px) {
    .no_listed_items_blk .max-470 {
        max-width: unset !important;
        width: 300px;
    }
    .no_listed_items_blk > div {
        padding: 30px;
    }
    .footer {
        padding: 20px 40px;
    }
    header {
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    }
}

@media (min-width: 768px) and (max-width: 800px) {
    .uniprof_btnmbl_align a:first-child {
        margin-bottom: 10px;
    }
}

@media (max-width: 767px) {
    .activity-btn {
        margin: auto !important;
        display: block;
        min-width: 140px;
        max-width: max-content;
    }
    .filters {
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        width: 100%;
        bottom: 0;
        background: #fff;
        z-index: 99;
        max-width: 100%;
        overflow-x: scroll;
        padding: 40px 20px;
        display: block !important;
        transform: translate3d(0, 0, 0);
        transition: all 0.3s ease-in-out;
        height: 100%;
    }
    .filters.show {
        transform: translate3d(0, -100%, 0);
        transition: all 0.3s ease-in-out;
    }
    .filters .btn-filter {
        position: absolute;
        right: 25px;
        font-size: 0;
        background: none;
        border: 0;
        width: 20px;
        height: 20px;
        top: 25px;
    }
    .filters .btn-filter::before {
        transform: translateY(10px) rotate(135deg);
        -moz-transform: translateY(10px) rotate(135deg);
        -webkit-transform: translateY(-5px) rotate(135deg);
        transition: all 0.3s ease-in-out;
        width: 18px;
        height: 2px;
        content: '';
        background: #000;
        position: absolute;
        border-radius: 5px;
    }
    .filters .btn-filter::after {
        transform: translateY(-5px) rotate(-135deg);
        -moz-transform: translateY(-5px) rotate(-135deg);
        -webkit-transform: translateY(-5px) rotate(-135deg);
        transition: all 0.3s ease-in-out;
        width: 18px;
        height: 2px;
        content: '';
        background: #000;
        position: absolute;
        border-radius: 5px;
    }
    .filters #accordionFilters {
        margin-bottom: 30px;
    }
    .filters > h3 {
        display: flex !important;
        align-items: center;
        justify-content: space-between;
    }
    .mobileFilter .btn-filter {
        border: 0;
        background-color: transparent;
        padding-right: 0px;
        padding-left: 0;
        cursor: pointer;
    }
    .filters {
        max-width: 100%;
        width: 100%;
    }
    .ji_filtersec {
        max-width: unset;
    }
    .JobInternshipForm {
        padding: 0;
        width: 90%;
    }
    .JobInternshipForm > .col-12 {
        padding: 0;
    }
    #html5-lightbox-box,
    .html5-elem-wrap,
    .html5lightbox-video iframe {
        width: 450px !important;
        height: 300px !important;
    }
    .container.max-1140,
    .max-1140 {
        width: 100%;
        padding: 0;
    }
    header .container.max-1140 {
        max-width: 1140px;
        width: 94%;
        padding-right: var(--bs-gutter-x, 0.75rem);
        padding-left: var(--bs-gutter-x, 0.75rem);
    }
    footer .max-1140 {
        padding: 20px 0px;
        width: 90%;
        align-items: center;
    }
    .milestoneSection > .container > .row,
    .notificationSection > .container > .row {
        margin: 0;
    }
    .milestoneSection > .container > .row > .col-md-12,
    .notificationSection > .container > .row > .col-md-12 {
        padding: 0;
    }
    .white-block {
        box-shadow: unset;
        border: 0px solid #d2d2d2;
        border-radius: 0px;
    }
    .welcome-title + .dashboard {
        margin-left: auto;
    }
    .dashboard.innerpage > a.btn {
        margin-top: 0 !important;
    }
    header {
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    }
    .font-35 {
        font-size: 24px;
        line-height: 28px;
    }
    .welcome-title h1,
    .notificationSection h3.font-35 {
        font-size: 24px;
    }
    #alumni_directory .container.max-1140 {
        padding: 0 20px;
    }
    .phone_number.max-135 {
        max-width: unset;
        flex: 1 1;
    }
    .modal-dialog.modal-dialog-centered {
        align-items: flex-start;
        margin-top: 25px;
    }
    .polarcontsec {
        margin-top: 20px;
        padding: 0;
    }
    .page_ttl_row,
    .m-w-90,
    .max-1010.m-w-90,
    .m-w-90.plr0 {
        padding-left: 0 !important;
        padding-right: 0 !important;
        width: 90%;
        margin: auto !important;
    }
    .milestoneSection .white-block.m-w-90-parent {
        padding: 0;
    }
    .msgtabcont.polarcontsec {
        padding: 20px 0 0 0;
        width: 90%;
        margin: auto !important;
        flex: unset;
        -webkit-box-flex: unset;
        -moz-box-flex: unset;
        -webkit-flex: unset;
        -ms-flex: unset;
    }
    form.lstCustForm .form-check:not(:last-child) {
        margin: 0 25px 8px 0;
    }
    .profile_radiorow > .icon-cross {
        right: 12px;
        top: 12px;
        background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/trash.svg) no-repeat 0 0;
        width: 16px;
        height: 16px;
    }
    .profile_radiorow > .icon-cross::before {
        display: none;
    }
    .max-630 {
        max-width: 100%;
        width: 90%;
    }
    .page_ttl_row > .mx-sm-1 {
        margin-right: 0 !important;
        margin-left: 0 !important;
    }
    .welcome_pg {
        padding-left: 0;
        padding-right: 0;
    }
    .msg_title_row_wrapper {
        scrollbar-width: none;
        padding-right: 0;
    }
    .extmar {
        margin-right: 0px !important;
    }
    .msgtabcont.polarcontsec.msgwrapext {
        padding: 20px 0 0 0;
    }
}

@media (max-width: 575px) {
    .btn-verify {
        line-height: 40px;
    }
    .cpw_bg {
        padding: 20px;
    }
    .JobInternshipForm h2 {
        margin: 0 0 30px;
    }
    .btn-border:hover,
    .btn-verify:hover {
        background-size: 200% 100%;
    }
    .polartabsec {
        padding: 18px 0;
    }
    .polartabsec .xscroll {
        width: 95%;
        margin-left: 5%;
    }
    .polartabsec + div {
        padding-bottom: 30px !important;
    }
    .polartabsec + div.newmsg {
        padding: 0 !important;
    }
    .act_lst {
        padding: 40px 15px 15px 15px;
        text-align: left;
    }
    .exp_loc,
    .act_lst > .row > div:last-child > div {
        justify-content: flex-start !important;
    }
    .person_detls {
        justify-content: flex-start;
        margin-top: 5px;
    }
    .act_lst > .row > div:last-child {
        text-align: left !important;
    }
    .lstperdetails {
        width: 100%;
    }
    .listblk_icon {
        margin-bottom: 10px;
        width: 34px;
        height: 34px;
    }
    .act_lst.actlst_listed .btn-green,
    .act_lst .btn-green,
    .act_lst .btn-dark-blue {
        height: 34px !important;
        line-height: 34px;
    }
    .listblk_icon .listblk_icon_bm {
        width: 10px;
        height: auto;
    }
    .listblk_icon .listblk_icon_sh {
        width: 14px;
        height: auto;
    }
    .load_more_btn {
        height: 40px;
        line-height: 38px;
    }
    .docselect {
        width: 100%;
    }
    .docselect .inputfile {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        flex: 1 1;
    }
    .album_shareblk {
        width: 100%;
        padding: 20px 0 0 0px;
        display: flex;
        justify-content: start;
    }
    .album_shareblk > span:not(:last-child) {
        margin: 0 5px 5px 0;
    }
    .EventsBlk .album_shareblk {
        width: 60px;
        padding: 0px 0 0 20px;
    }
    .justify-content-start.mContCenter {
        justify-content: flex-start !important;
    }
    .d-flex.mflexcol {
        flex-direction: column;
        align-items: flex-start !important;
    }
    .d-flex.mflexcol.btnview {
        flex-direction: row;
    }
    .d-flex.mflexcol.btnview > span {
        margin-left: 10px;
    }
    .alumni_directory_details ul.orderlist li {
        flex-wrap: wrap;
    }
    .alumni_directory_details ul.orderlist li p {
        margin: 3px 0 5px;
        width: 100%;
    }
    .mscroll {
        width: 100%;
        overflow-x: auto;
        scrollbar-width: thin;
    }
    .mscroll > div {
        width: max-content;
    }
    .graph-result-list {
        width: 100%;
    }
    .mjcstart {
        justify-content: flex-start !important;
    }
    .mjcstart select:last-child {
        margin-left: 5px;
    }
    .map-Search {
        max-width: 260px;
    }
    .locbtncol {
        justify-content: flex-start;
        align-items: flex-start;
        margin: 0 0 10px;
    }
    .phone_number.max-135 {
        max-width: unset;
        flex: unset;
        width: unset;
    }
    .phone_number.contemail {
        max-width: unset;
        flex: unset;
        width: unset;
        margin: 10px 0 0;
    }
    .albumadd {
        position: relative;
    }
    .albumadd > .flex-1 {
        flex: unset;
        width: 100%;
        margin: 15px 0 0 !important;
    }
    .albumadd .albm_edit_settings {
        position: absolute !important;
        right: 15px;
        top: 15px;
    }
    form.lstCustForm .btn-greenm,
    .btn-greenm252 {
        min-width: unset;
        width: auto;
        line-height: 15px;
        justify-content: center;
        align-items: center;
        display: flex !important;
        max-width: 252px;
    }
    .font-24 {
        font-size: 20px !important;
    }
    .btn-green {
        font-size: 14px;
        line-height: 14px;
    }
    .album_contblk,
    .album_contblk.eventsbox {
        padding: 12px 15px 15px 15px;
    }
    .EventsBlk .btn-border-gray {
        min-width: 92px;
        padding: 0 8px;
    }
    .btn-green.max-170 {
        max-width: unset !important;
        width: unset;
        min-width: 110px;
    }
    .uniprof_btnmbl_align .btn-darkblue {
        font-size: 14px;
    }
    .search_cont.px-4 {
        padding-left: 12px !important;
        padding-right: 12px !important;
    }
    .msgbox .uni_profiles_sec .icon-invert-cross {
        right: 12px;
    }
    .msgbox .uni_profiles_sec {
        padding: 5px 35px 5px 15px;
    }
    .search_ttlblk .uni_profiles_sec {
        padding: 0px 15px 5px;
    }
    .msg_area {
        -webkit-box-wrap: wrap;
        -moz-box-wrap: wrap;
        -ms-flex-wrap: wrap;
        -webkit-wrap: wrap;
        flex-wrap: wrap;
    }
    .msg_area .flex-1 {
        flex: unset;
        -webkit-box-flex: unset;
        -moz-box-flex: unset;
        -webkit-flex: unset;
        -ms-flex: unset;
        width: 100%;
        margin: 0 0 12px 0 !important;
    }
    .msg_area .flex-column {
        flex-direction: row !important;
        width: 100%;
        justify-content: end;
    }
    .msg_area .flex-column a:first-child {
        margin-right: 5px;
    }
    .msg_title_txt,
    .msgacpign {
        width: 100%;
        margin-left: 0px;
    }
    .convo_btns {
        padding-left: 0;
    }
    form.lstCustForm label span {
        padding: 0 0 0 0px;
        width: 100%;
    }
    form.lstCustForm .inputfile_parent label span {
        width: unset;
    }
}

@media (max-width: 479px) {
    #html5-lightbox-box,
    .html5-elem-wrap,
    .html5lightbox-video iframe {
        width: 300px !important;
        height: 200px !important;
    }
    .uniprof_btnmbl_align .btn-green.height-40 {
        height: 34px !important;
        line-height: 34px;
        padding: 0 13px;
    }
    .uniprof_btnmbl_align .btn-darkblue {
        height: 34px !important;
        padding: 0 13px;
        line-height: 14px;
    }
    .alumni-switch-container.msg-switch {
        width: 290px;
    }
    .alumni-switch-container.msg-switch .switch > a {
        font-size: 14px !important;
    }
}

@media (max-width: 350px) {
    .m-max-105 {
        max-width: 105px;
    }
}

.sideBar-btn {
    width: 48px;
    height: 48px;
    background: #414141;
    border-radius: 0 5px 5px 0;
    border: 0;
    left: 100%;
    top: 180px;
}
.customOffcanvas {
    width: 250px;
    background: #414141;
    border-color: #414141;
}
.sideBar-btn .navbar-toggler-icon {
    width: 20px;
    height: 30px;
    font-size: 0;
}
.sideBar-btn .navbar-toggler-icon::after,
.sideBar-btn .navbar-toggler-icon::before,
.sideBar-btn .navbar-toggler-icon b {
    background-color: #b3b3b3;
    border-radius: 5px;
    content: '';
    display: block;
    height: 2px;
    margin: 6px 0;
    transition: all 0.2s ease-in-out;
    font-size: 0;
}
.offcanvas[aria-modal='true'] .sideBar-btn .navbar-toggler-icon::before {
    transform: translateY(10px) rotate(135deg);
    -moz-transform: translateY(10px) rotate(135deg);
    -webkit-transform: translateY(10px) rotate(135deg);
    width: 20px;
    height: 3px;
    -ms-transform: translateY(10px) rotate(135deg);
    -o-transform: translateY(10px) rotate(135deg);
}
.offcanvas[aria-modal='true'] .sideBar-btn .navbar-toggler-icon b {
    transform: scale(0);
    -ms-transform: scale(0);
    -o-transform: scale(0);
}
.offcanvas[aria-modal='true'] .sideBar-btn .navbar-toggler-icon::after {
    transform: translateY(-7px) rotate(-135deg);
    -moz-transform: translateY(-7px) rotate(-135deg);
    -webkit-transform: translateY(-7px) rotate(-135deg);
    width: 20px;
    height: 3px;
    -ms-transform: translateY(-7px) rotate(-135deg);
    -o-transform: translateY(-7px) rotate(-135deg);
}
.offcanvas.offcanvas-start:not(.show) ~ div.offcanvas-backdrop {
    display: none;
}
.offcanvas-body > ul > li:not(:last-child) {
    border-bottom: 1px solid #545454;
}
.offcanvas-body > ul > li > a {
    display: flex;
    align-items: center;
    padding: 15px 0;
    color: #fff;
    justify-content: space-between;
    font-size: 16px;
}
.offcanvas-body > ul > li > a .icon {
    font-size: 12px;
    transform: rotate(90deg);
    transition: all 0.3s ease-in-out;
    -webkit-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    -o-transform: rotate(90deg);
}
.offcanvas-body > ul > li > a[aria-expanded='true'] .icon {
    transform: rotate(270deg);
    transition: all 0.3s ease-in-out;
    -webkit-transform: rotate(270deg);
    -moz-transform: rotate(270deg);
    -ms-transform: rotate(270deg);
    -o-transform: rotate(270deg);
}
.offcanvas-body > ul > li ul {
    margin-bottom: 20px;
    list-style: none;
    margin-left: 0;
    padding: 0 0 0 10px;
}
.offcanvas-body > ul > li ul a {
    font-size: 14px;
    color: #fff;
}
.offcanvas-body a:hover,
.offcanvas-body a:focus {
    color: #fff;
}
.offcanvas-body {
    -ms-overflow-style: none;
    scrollbar-width: none;
}
.offcanvas-body::-webkit-scrollbar {
    display: none;
}
.tooltip-inner {
    background: #0b3454;
    border: 1px solid #0b3454;
}
.bs-tooltip-top .tooltip-arrow::before {
    border-top-color: #0b3454;
}
.alumni-switch-container {
    background: rgba(0, 0, 0, 0.3);
    border-radius: 20px;
    width: 261px;
    height: 40px;
}
.alumni-switch-container .switch {
    width: 100%;
    height: 40px;
}
.alumni-switch-container .switch label {
    flex: 1 1;
    color: #fff;
    text-align: center;
    height: 100%;
    cursor: pointer;
    position: relative;
    opacity: 0.6;
}
.switch {
    position: relative;
}
.switch > span {
    width: 50%;
    height: 40px;
    background: #fafcff;
    content: '';
    border-radius: 20px;
    position: absolute;
}
.alumni-switch-container * {
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.alumni-switch-container .form-check-input[id*='shortlistCheck']:checked ~ div.switch::before {
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.alumni-switch-container .form-check-input[id*='finalizeCheck']:checked ~ div.switch::before {
    transform: translateX(100%);
    transition: all 0.3s ease-in-out;
    -webkit-transform: translateX(100%);
    -moz-transform: translateX(100%);
    -ms-transform: translateX(100%);
    -o-transform: translateX(100%);
}
.alumni-switch-container .form-check-input[id*='shortlistCheck']:checked ~ div.switch label[for*='shortlistCheck'] {
    color: #0b3454;
    opacity: 1;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.alumni-switch-container .form-check-input[id*='finalizeCheck']:checked ~ div.switch label[for*='finalizeCheck'] {
    color: #0b3454;
    opacity: 1;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.alumni-switch-container .switch > a {
    width: 50%;
    color: rgba(255, 255, 255, 0.6);
    text-decoration: none;
    position: relative;
    z-index: 1;
}
.alumni-switch-container .switch > a.active {
    color: #0b3454;
}
.alumni-switch-container .switch > a.btn-allCampuses.active + span {
    transform: translateX(100%);
    -webkit-transform: translateX(100%);
    -moz-transform: translateX(100%);
    -ms-transform: translateX(100%);
    -o-transform: translateX(100%);
}
.aldir_scroll {
    display: none;
}
.aldir_scroll.active {
    display: block;
}
.load_more_btn img {
    animation: spin 4s infinite linear;
    -webkit-animation: spin 4s infinite linear;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -o-transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
        -webkit-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -o-transform: rotate(360deg);
    }
}
.filterChecked .selected {
    background: #ffffff;
    box-shadow: 0px 1px 1px #f1f1f1;
    border: 1px solid #dedede;
    border-radius: 7px;
    opacity: 1;
    margin: 3px;
    padding: 0px 10px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.btn-back * {
    transition: all 0.3s ease-in-out;
}
.btn-back {
    text-decoration: none;
    display: flex;
    align-items: center;
}
.btn-back:hover span {
    text-decoration: underline;
}
.btn-back:hover .icon-left-arrow {
    transform: translateX(-5px);
}
.calendar_status {
    display: none;
}
.fc-header-toolbar {
    background: #f2f9ff;
    padding: 20px 30px;
}
.fc-toolbar-chunk:first-child > div {
    display: flex;
    align-items: center;
}
.fc-theme-standard td,
.fc-theme-standard th {
    position: relative;
}
.fc-toolbar-chunk:first-child > div .fc-toolbar-title {
    margin: 3px 10px 0;
    font-size: 18px;
    font-weight: 600;
}
.fc-toolbar-chunk:first-child > div .fc-button {
    background: none;
    border: 0;
    color: #000;
    padding: 0;
}
.fc-toolbar-chunk:first-child > div .fc-button.fc-button-primary:focus {
    box-shadow: none;
}
.fc-toolbar-chunk:first-child > div .fc-button.fc-button-primary:not(:disabled):active,
.fc .fc-button-primary:not(:disabled).fc-button-active {
    color: #000;
    color: var(--fc-button-text-color, #fff);
    background-color: transparent;
    background-color: var(--fc-button-active-bg-color, transparent);
    border-color: transparent;
    border-color: var(--fc-button-active-border-color, transparent);
}
.fc-toolbar-chunk:last-child > div.fc-button-group {
    max-width: 312px;
    width: 312px;
    background: #fff;
    border: 1px solid #b9b9b9;
    border-radius: 20px;
    opacity: 1;
}
.fc-toolbar-chunk:last-child > div.fc-button-group .fc-button {
    background: #fff;
    font-size: 16px;
    color: #000;
    text-transform: capitalize;
    font-weight: 500;
    border: 0;
    border-radius: 20px;
    position: relative;
    z-index: 1;
}
.fc-toolbar-chunk:last-child > div.fc-button-group .fc-button.fc-button-active {
    background: #5cae48;
    color: #fff;
    border: 0;
    position: relative;
    z-index: 2;
}
.fc-toolbar-chunk:last-child > div.fc-button-group .fc-button:focus {
    outline: none;
    box-shadow: none;
}
.fc-view {
    padding: 10px 30px 30px;
}
.calendar_filter {
    display: none;
}
.fc-col-header .fc-scrollgrid-sync-inner {
    height: 50px;
    padding: 7px 15px;
    text-align: left;
}
.fc-col-header .fc-scrollgrid-sync-inner .fc-col-header-cell-cushion {
    font-size: 14px;
    text-decoration: none;
    font-weight: 500;
    text-transform: uppercase;
    padding: 0;
    color: #000;
}
.fc div.fc-daygrid-day-top {
    flex-direction: row;
}
.fc a.fc-daygrid-day-number {
    padding: 18px;
    text-decoration: none;
    color: #000;
    font-size: 14px;
    font-weight: 500;
}
.fc-direction-ltr .fc-daygrid-week-number {
    display: none;
}
.fc .fc-bg-event.bluesection {
    background: #f2f9ff;
    opacity: 1;
}
.fc-scrollgrid-sync-inner.eventHas {
    background: #f2f9ff;
    opacity: 1;
    border-left: 2px solid #26a7df;
}
.fc .fc-bg-event.bluesection .fc-event-title {
    margin-top: 44px;
    padding-left: 8px;
    font-weight: 500;
}
.fc-scrollgrid-sync-inner.eventHas {
    background: #f2f9ff;
    border-left: 2px solid #26a7df;
    max-height: 100%;
    box-sizing: border-box;
    max-width: 100%;
    height: 100%;
    width: 100%;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    margin: auto;
    position: absolute !important;
}
.fc .fc-daygrid-body-balanced div.fc-daygrid-day-events {
    left: 10px;
}
.fc .fc-daygrid-event {
    color: #0b3454;
}
.fc-daygrid-dot-event div.fc-event-title {
    font-size: 13px;
    font-weight: 400;
}
.fc-direction-ltr .fc-daygrid-event div.fc-event-time {
    font-size: 13px;
    font-weight: 400;
    padding-right: 3px;
}
.fc .fc-daygrid-event-harness a.bluesection div {
    color: #000;
}
.fc-daygrid-block-event .fc-event-title {
    font-size: 12px;
}
.fc-media-screen .fc-timegrid-event {
    background: #f2f9ff;
    border-color: #26a7df;
    border-width: 0 0 0 2px;
    border-radius: 0;
    box-shadow: none !important;
}
.fc-direction-ltr .fc-timegrid-col-events {
    margin: 0;
}
div.fc-daygrid-event-dot {
    border: calc(var(--fc-daygrid-event-dot-width, 8px) / 2.5) solid var(--fc-event-border-color, #26a7df);
}
.fc .fc-timeGridWeek-view .fc-bg-event.bluesection .fc-event-title {
    margin: 6px 0 0;
}
.fc .fc-timeGridWeek-view .fc-v-event .fc-event-main-frame {
    color: #000;
}
.fc-direction-ltr .fc-timegrid-col-events {
    margin: 0;
}
.share_option {
    padding: 0;
    margin: 0 -9px;
    display: flex;
}
.share_option li {
    list-style: none;
    width: 206px;
    margin: 0 5px 10px;
}
.share_option li a {
    width: 100%;
    height: 45px;
    display: flex;
    border-radius: 6px;
    padding: 8px 15px;
    font-size: 16px;
    color: #fff;
    text-decoration: none;
    align-items: center;
    transition: all 0.3s ease-in-out;
}
.share_option li a.wa {
    color: #000;
}
.share_option li a:hover {
    transform: translateY(-3px);
}
.fc-timeGridDay-view .fc-v-event .fc-event-main-frame {
    color: #000;
    padding: 5px 10px;
}
.fc .fc-timegrid-axis-cushion {
    display: flex;
    align-items: center;
    text-decoration: none;
    color: #000;
    font-weight: 500;
}
.fc-direction-ltr div.fc-timegrid-col-events {
    margin: 0;
}
.share_option li a img {
    width: 28px;
}
.fb {
    background-color: #3d5a96;
}
.tw {
    background-color: #2aa3ef;
}
.in {
    background-color: #017ab7;
}
.wa {
    background: #41c452;
}
.mobilesidebar .accordion-button {
    max-width: 155px;
    background: none;
    color: #5cae48;
    display: flex;
    justify-content: space-between;
}
.mobilesidebar .accordion-button:not(.collapsed) {
    background: none;
    box-shadow: none;
}
.mobilesidebar .accordion-button:focus {
    outline: 0;
    box-shadow: none;
}
.paddingx-30 {
    padding-left: 6%;
    padding-right: 6%;
}
#accordionSideMenu .accordion-item {
    border: 0;
    background: none;
    border-bottom: 1px solid #eee;
}
#accordionSideMenu .accordion-button {
    font-size: 16px;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
}
#accordionSideMenu .accordion-button:not(.collapsed) {
    color: #5cae48;
    background-color: #fff;
    box-shadow: none;
}
.sideMenu .accordion-button:focus {
    box-shadow: none;
}
.sideMenu .accordion-button span {
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.sideMenu .accordion-button::after {
    display: none;
}
.sideMenu .accordion-button:not(.collapsed) span[class*='icon'] {
    transform: rotate(-180deg);
    -webkit-transform: rotate(-180deg);
    -moz-transform: rotate(-180deg);
    -ms-transform: rotate(-180deg);
    -o-transform: rotate(-180deg);
}
.toggleSearch {
    width: 33px;
    height: 33px;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    border-radius: 50%;
    background: #fff;
    border: 1px solid #e1e1e1;
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    color: #414141;
    font-size: 14px;
    right: 0;
}
.mobilesidebar .filterSearch {
    transform: translateX(100%);
    transition: all 0.3s ease-in-out;
}
.mobilesidebar .open .filterSearch {
    transform: translateX(0px);
}
.needs-validation.was-validated .form-control:invalid,
.login_wrap .login_form form.was-validated .form-group .form-control:invalid,
.needs-validation.was-validated .form-select:invalid {
    border-color: #e55355;
    box-shadow: 0px 0px 10px #e55355 !important;
}
.needs-validation .form-control {
    position: relative;
}
.needs-validation .invalid-feedback {
    display: none;
    width: 100%;
    margin-top: 0;
    font-size: 0.875em;
    color: #fff;
    background: #d86465;
    padding: 5px 15px 5px;
    border-radius: 4px;
    position: relative;
    font-size: 13px;
    font-style: italic;
}
.needs-validation .invalid-feedback::before {
    position: absolute;
    content: '';
    width: 10px;
    height: 10px;
    border-bottom: 7px solid #d86465;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    top: -10px;
    left: 20px;
}

@media (min-width: 630px) and (max-width: 767px) {
    .fc .fc-daygrid-body-balanced div.fc-daygrid-day-events {
        left: 10px;
        bottom: 13px;
    }
    .fc .fc-bg-event.bluesection .fc-event-title {
        margin-top: 40px;
        padding-left: 8px;
        font-weight: 500;
        white-space: nowrap;
        max-width: 100px;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .fc-v-event .fc-event-title {
        white-space: nowrap;
        max-width: 100px;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .fc .fc-timegrid-axis-cushion {
        display: flex;
        align-items: center;
        text-decoration: none;
        color: #000;
        font-weight: 500;
    }
}

@media (max-width: 767px) {
    .fc-header-toolbar {
        padding: 20px 0px;
    }
    .fc-header-toolbar > div {
        width: 90%;
        margin: auto;
        text-align: center;
    }
    .fc-view {
        padding: 10px 0px 30px;
        width: 90%;
        margin: auto;
    }
}

@media (max-width: 629px) {
    .share_option {
        justify-content: center;
    }
    .fc-toolbar-chunk {
        width: 100%;
    }
    .fc-toolbar-chunk:first-child > div {
        justify-content: center;
        margin-bottom: 15px;
    }
    .fc .fc-toolbar {
        -webkit-box-wrap: wrap;
        -moz-box-wrap: wrap;
        -ms-flex-wrap: wrap;
        -webkit-wrap: wrap;
        flex-wrap: wrap;
    }
    .fc-toolbar-chunk:last-child > div.fc-button-group {
        width: 100%;
    }
    .fc a.fc-daygrid-day-number {
        padding: 8px;
        font-size: 12px;
    }
    .fc .fc-bg-event.bluesection .fc-event-title {
        margin-top: 30px;
        padding-left: 0px;
        font-weight: 500;
    }
    .fc-col-header .fc-scrollgrid-sync-inner {
        padding: 5px;
        height: 40px;
    }
    .fc .fc-daygrid-body-balanced .fc-daygrid-day-events {
        left: 0 !important;
        bottom: 0;
        font-size: 12px;
    }
    .fc .fc-bg-event.bluesection .fc-event-title {
        margin-top: 14px;
        padding-left: 0px;
        font-weight: 500;
        font-size: 11px;
        max-width: 36px;
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .fc-direction-ltr .fc-timegrid-col-events {
        margin: 0;
    }
    .fc-timegrid-event {
        border-radius: 0;
        background: #f2f9ff;
        border-left-color: #26a7df;
        border-width: 0 0 0 2px;
        padding: 5px 12px;
        color: #000 !important;
    }
    .fc-v-event .fc-event-main-frame {
        color: #000;
    }
    .fc .fc-timegrid-axis-cushion {
        max-width: 60px;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        text-decoration: none;
        color: #000;
        font-weight: 500;
    }
}

@media (max-width: 480px) {
    .fc-col-header .fc-scrollgrid-sync-inner .fc-col-header-cell-cushion {
        font-size: 12px;
    }
    .fc .fc-timegrid-axis-cushion {
        font-size: 16px;
    }
    .fc a.fc-daygrid-day-number {
        padding: 5px;
        font-size: 12px;
    }
    .fc .fc-daygrid-more-link {
        white-space: nowrap;
    }
    .fc-media-screen .fc-timegrid-event {
        padding: 3px;
    }
}

@media (max-width: 400px) {
    .courseLabel {
        margin-right: 0;
    }
    .alumni_college_bottom {
        flex-direction: column;
    }
}

.modal.show .modal-dialog {
    margin-left: auto;
    margin-right: auto;
}
#html5box-html5-lightbox {
    display: flex;
    justify-content: center;
    align-items: center;
    height: calc(100% - 97px);
}
#html5-lightbox-box {
    margin: auto !important;
}
.html5-elem-data-box {
    position: fixed !important;
    top: 15px;
    left: 0;
    right: 0;
    background: none !important;
    color: #fff !important;
    height: auto;
}
#html5box-html5-lightbox .html5-text {
    color: #fff;
    text-align: center;
    margin: 0 !important;
    height: auto;
}
#html5box-html5-lightbox .html5-text .html5-title {
    display: flex;
    flex-direction: column-reverse;
    justify-content: flex-start;
    height: auto;
    align-items: center;
    color: #fff;
    font-weight: 500;
}
#html5box-html5-lightbox .html5-text .html5-title .html5-playpause {
    display: none !important;
}
.html5-nav-thumb.video img {
    position: relative;
}
.html5-nav-thumb.video:before {
    content: '\\e91f';
    font-family: 'icomoon' !important;
    speak: never;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    position: absolute;
    z-index: 1;
    position: absolute;
    left: 0;
    right: 0 !important;
    bottom: 0;
    top: 0 !important;
    margin: auto;
    color: #fff;
    font-size: 25px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
}
.html5-nav-thumb.video {
    position: relative;
}
.no-background-img {
    background-image: none !important;
}
.customselect_parnt .custom-select {
    position: relative;
    width: max-content;
    flex: unset;
    min-width: 109px;
}
.customselect_parnt .custom-select select {
    display: none;
}
.customselect_parnt .select-selected {
    background-color: DodgerBlue;
}
.customselect_parnt .select-selected:after {
    position: absolute;
    content: '';
    top: 14px;
    right: 10px;
    width: 0;
    height: 0;
    border: 6px solid transparent;
    border-color: #fff transparent transparent transparent;
}
.customselect_parnt .select-selected.select-arrow-active:after {
    border-color: transparent transparent #fff transparent;
    top: 7px;
}
.customselect_parnt .select-selected {
    color: #414141;
    padding: 0px 30px 0 14px;
    border: 2px solid #7d7d7d;
    border-color: #7d7d7d;
    cursor: pointer;
    border-radius: 18px;
    height: 32px;
    width: max-content;
    transition: all 0.3s ease-in-out;
    background: #fff;
    font-size: 14px;
    font-weight: 500;
    line-height: 32px;
    min-width: 65px;
    box-sizing: initial;
    border-radius: 18px;
}
.customselect_parnt .select-selected::after {
    position: absolute;
    content: '';
    top: 10px;
    right: 12px;
    width: 10px;
    height: 10px;
    border: unset;
    border-top: 2px solid #7d7d7d;
    border-right: 2px solid #7d7d7d;
    transform: rotate(135deg);
    transition: all 0.2s ease-in-out;
    -webkit-transition: all 0.2s ease-in-out;
    -moz-transition: all 0.2s ease-in-out;
    -ms-transition: all 0.2s ease-in-out;
    -o-transition: all 0.2s ease-in-out;
    -webkit-transform: rotate(135deg);
    -moz-transform: rotate(135deg);
    -ms-transform: rotate(135deg);
    -o-transform: rotate(135deg);
}
.customselect_parnt .select-selected.select-arrow-active::after {
    border: unset;
    top: 15px;
    border-top: 2px solid #7d7d7d;
    border-right: 2px solid #7d7d7d;
    transform: rotate(-45deg);
    width: 10px;
    height: 10px;
    right: 12px;
    -webkit-transform: rotate(-45deg);
    -moz-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    -o-transform: rotate(-45deg);
}
.customselect_parnt .select-items div {
    color: #000000;
    padding: 3px 16px;
    border: 0px solid transparent;
    border-color: transparent transparent rgba(0, 0, 0, 0.1) transparent;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
}
.customselect_parnt .select-items div:first-child {
    margin-top: 10px;
}
.customselect_parnt .select-items div:last-child {
    margin-bottom: 10px;
}
.customselect_parnt .select-items {
    position: absolute;
    background-color: #fff;
    top: 100%;
    left: 0;
    right: 0;
    z-index: 99;
    border: 1px solid #dedede;
    border-radius: 18px;
    box-shadow: 0px 10px 20px #0000001a;
    width: 145px;
    -webkit-border-radius: 18px;
    -moz-border-radius: 18px;
    -ms-border-radius: 18px;
    -o-border-radius: 18px;
}
.customselect_parnt .select-hide {
    display: none;
}
.customselect_parnt .select-items div:hover,
.customselect_parnt .same-as-selected {
    background-color: rgba(0, 0, 0, 0.1);
}
.needs-validation.was-validated.contfwrap .form-control:invalid,
.login_wrap .login_form form.was-validated.contfwrap .form-group .form-control:invalid,
.needs-validation.was-validated.contfwrap .form-select:invalid {
    border-color: #e55355;
    box-shadow: 0px 0px 5px #e553554d !important;
}
.needs-validation.contfwrap .invalid-feedback {
    color: #d42941;
    background: transparent;
    padding: 3px 0 0;
    border-radius: unset;
    font-size: 14px;
    font-style: unset;
}
.needs-validation.contfwrap .invalid-feedback::before {
    display: none;
}
.btn-response-msg {
    background: #26a7df;
    line-height: 23px;
    padding: 0;
    max-width: 150px;
    width: 76px !important;
    color: #fff;
    font-weight: 500;
}
.btn-response-msg:hover,
.btn-response-msg.open {
    background: #0b3454;
    color: #fff;
}
.response-cover {
    position: absolute;
    top: 54px;
    background: #0b3454;
    padding: 10px;
    border-radius: 5px;
    z-index: -1;
    left: -31px;
    width: 138px;
    opacity: 0;
    transition: all 0.3s ease-in-out;
    border: 1px solid #0b3454;
    box-shadow: 0px 3px 6px #0000001a;
}
.btn-response-msg.open + div.response-cover {
    opacity: 1;
    z-index: 1;
    top: 39px;
}
.response-cover:before {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid #0b3454;
    left: 0;
    right: 0;
    margin: auto;
    top: -6px;
}
.btn-response-msg:focus {
    box-shadow: none;
}
.tooltip.show {
    opacity: 1;
}
.tooltip-response > div:not(.tooltip-arrow) {
    padding-top: 8px;
    padding-bottom: 8px;
}
.universities_list_wrap {
    overflow: auto;
    max-height: 375px;
    padding: 3px 3px;
}
.universities_list_wrap ul {
    padding: 0;
    margin: 0;
    list-style: none;
}
.universities_list_wrap ul li {
    display: flex;
    align-items: center;
}
.universities_list_wrap ul li .logo_college {
    width: 60px;
    background: #fff;
    padding: 10px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 60px;
    box-shadow: 0 0 3px 0px #ccc;
    margin-right: 15px;
}
.universities_list_wrap ul li .logo_college img {
    width: auto;
    height: 100%;
}
.universities_list_wrap ul li:not(:last-child) {
    margin-bottom: 15px;
}
.universities_list_wrap ul li span {
    font-size: 18px;
    font-weight: 500;
}
.universities_list_wrap::-webkit-scrollbar {
    width: 7px;
}
.universities_list_wrap::-moz-scrollbar {
    width: 7px;
}
.universities_list_wrap::-webkit-scrollbar-track {
    background: #eee;
}
.universities_list_wrap::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 20px;
    border: 2px solid #eee;
}
.view_new_message_wrap {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    justify-content: end;
    margin: 0;
}
.view_new_message_wrap .form-select {
    border: 2px solid #7d7d7d;
    border-radius: 25px;
    height: 36px;
    min-width: 150px;
    max-width: 150px;
    margin-right: 10px;
    padding-top: 0;
    padding-bottom: 0;
    font-size: 16px;
    font-weight: 500;
    line-height: 32px;
    min-width: 55px;
    box-sizing: initial;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}
.view_new_message_wrap .btn-green-msg {
    border-radius: 25px;
}
.msg_title.msg_heading_row .btn-complete-now:hover span {
    color: #fff;
}
.alumni_message {
    background: transparent;
    padding: 0;
    font-size: 14px;
    border-radius: 25px;
    line-height: 22px;
    margin: 3px 0 0;
    color: #d42941;
    text-transform: uppercase;
    font-weight: 500;
}
.student_message {
    background: transparent;
    padding: 0;
    font-size: 14px;
    border-radius: 25px;
    line-height: 22px;
    color: #c38400;
    text-transform: uppercase;
    font-weight: 500;
    margin: 3px 0 0;
}
.school_message {
    background: transparent;
    padding: 0;
    font-size: 14px;
    border-radius: 25px;
    line-height: 22px;
    color: #26a7df;
    text-transform: uppercase;
    font-weight: 500;
    margin: 3px 0 0;
}
.msg_title_row .university_ttl span[class*='message'] {
    display: block;
    font-size: 14px !important;
    color: #000;
    line-height: 16px;
}
.mgs_sender {
    flex-direction: column;
    align-items: end;
}

@media (max-width: 1180px) {
    .mgs_sender {
        flex-direction: row;
    }
    .mgs_sender > span[class*='_message'] {
        margin-left: 10px;
        margin-top: -1px;
    }
}

@media (max-width: 650px) {
    .view_new_message_wrap {
        margin-top: 14px;
    }
}

@media (max-width: 575px) {
    .university_ttl {
        width: 100%;
        margin-right: 0 !important;
    }
}

@media (max-width: 400px) {
    .view_new_message_wrap .form-select {
        width: calc(100% - 201px);
        max-width: initial;
        min-width: initial;
    }
}
.user_id {
    position: absolute;
    bottom: -25px;
    right: 10px;
    color: #fff;
    font-size: 14px;
    background: #5cae48;
    font-weight: 500;
    padding: 0 15px;
    border-radius: 10px 10px 0 0;
    white-space: nowrap;
}
header > .container {
    position: relative;
}

/* New css 10012023 */
.alumni-directory-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
}
.alumni-directory-header_search {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    align-items: center;
}
.alumni-directorySearch {
    background: #fff;
    width: 365px;
    height: 40px;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    border-radius: 25px;
    overflow: hidden;
    position: relative;
}
.alumni-directorySearch .form-control {
    flex: 1 1;
    border: 0;
    padding-left: 0;
}
.alumni-directorySearch .btn.icon-search {
    font-size: 12px;
    padding: 0 10px 0 20px;
}
.alumni-directorySearch .btn-search-cross {
    position: absolute;
    right: 13px;
    top: 0;
    bottom: 0;
    margin: auto;
    display: flex;
    align-items: center;
    color: #000;
    font-weight: 100 !important;
}
.alumni-directorySearch .btn-cross {
    width: 14px;
    height: 14px;
    position: absolute;
    right: -15px;
    top: 0;
    bottom: 0;
    margin: auto;
    transform: rotate(0deg);
    opacity: 0;
    transition: all 0.5s ease-in-out;
}
.alumni-directorySearch .btn-cross:before {
    content: '';
    position: absolute;
    width: 14px;
    height: 2px;
    left: 0;
    bottom: 0;
    right: 0;
    top: 0;
    margin: auto;
    background: #000;
    border-radius: 5px;
}
.alumni-directorySearch .btn-cross:after {
    content: '';
    position: absolute;
    width: 2px;
    height: 14px;
    left: 0;
    bottom: 0;
    right: 0;
    top: 0;
    margin: auto;
    background: #000;
    border-radius: 5px;
}
.alumni-directorySearch .form-control:valid + .btn-cross {
    opacity: 1;
    right: 15px;
    transform: rotate(135deg);
}
.alumni_directory_filter {
    padding: 30px 0;
    padding-right: var(--bs-gutter-x, 0.75rem);
    padding-left: var(--bs-gutter-x, 0.75rem);
}
.alumni_directory_filter .ji_filtersec {
    width: 100%;
    max-width: 100%;
}
.alumni_directory_filter .fiterItem {
    width: 220px;
    margin: 0 5px;
    box-shadow: 0px 10px 25px #00000008;
}
.alumni_directory_filter .fiterItem.key {
    border-color: #5cae48;
}
.alumni_directory_filter .filterGroup {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    align-items: start;
    margin: 0 -5px;
}
.alumni_directory_filter .filterSearchblk {
    background: #fff;
    padding: 0 14px 10px;
}
.alumni_directory_filter .filterSearchblk .filterSearch input {
    margin: 0;
}
.alumni_directory_filter .filterHeader button {
    transition: all 0.3s ease-in-out;
    padding: 15px 15px;
}
.alumni_directory_filter .filterHeader button:not([aria-expanded='false']) {
    padding-bottom: 8px;
}
.alumni_directory_filter .fiterItem .card {
    padding: 0px 15px 15px;
}
.alumni_directory_filter .scrollMe {
    max-height: 122px;
    min-height: 122px;
    overflow-x: hidden;
}
.alumni_directory_filter .fiterItem .form-check:not(:last-child) {
    margin-bottom: 4px;
}
.additionalfilter_count {
    display: none;
}
.btn-md-filter {
    text-decoration: none;
    transform: rotate(90deg);
    color: #000;
    font-size: 20px;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.btn-md-filter:hover {
    color: #000;
}
.btn-md-filter[aria-expanded='true'] {
    transform: rotate(270deg);
    -webkit-transform: rotate(270deg);
    -moz-transform: rotate(270deg);
    -ms-transform: rotate(270deg);
    -o-transform: rotate(270deg);
}
.additionalfilter_wrap {
    width: 100%;
    padding: 0 5px;
}
.alumni_directory_filter .filterGroup > div {
    order: 1;
}
.alumni_directory_filter .filterGroup > div:nth-child(5) ~ div {
    order: 3;
}
.alumni_directory_filter .filterGroup > div:nth-child(5) ~ div.additionalfilter_wrap {
    order: 2;
}
.alumni_directory_filter .filterGroup > div:nth-child(5) ~ div.additionalfilter_wrap.last {
    order: 9;
}
.alumni_directory_filter .fiterItem.campus {
    width: 450px;
}
.showProfiles_wrap {
    background: #fff;
    border: 1px solid #d2d2d2;
    border-radius: 6px;
    box-shadow: 0px 10px 25px #00000008;
    width: calc(100% - 10px);
    margin: 0 5px;
    padding: 17px 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.showProfiles_left {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    align-items: center;
}
.showProfiles_left h3 {
    margin: 0 30px 0 0;
    font-size: 18px;
    line-height: 20px;
    font-weight: 600;
}
.showProfiles_left .form-check-label {
    font-size: 16px;
}
.showProfiles_left .form-check-input {
    width: 20px;
    height: 20px;
    vertical-align: top;
    margin-top: -2px;
    margin-right: 10px;
}
.showProfiles_left .form-check.form-check-inline {
    display: inline-flex;
    align-items: center;
}
.showProfiles_left .check_list {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    align-items: center;
}
.showProfiles_left .form-check-input:checked {
    background-color: #5cae48;
    border-color: #5cae48;
}
.showProfiles_right .icon {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/subtraction.svg);
    width: 16px;
    height: 25px;
    margin-right: 8px;
}
.showProfiles_right {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    align-items: center;
}
.showProfiles_right .title {
    font-size: 14px;
    letter-spacing: -0.35px;
}
.alumni-bucket {
    background: #fff;
    border: 1px solid #d2d2d2;
    border-radius: 6px;
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
}
.alumni-bucket .block-link {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    margin: auto;
    z-index: 1;
}
.alumni_img {
    width: 60px;
    margin-right: 10px;
    height: 60px;
    background: #f1f1f1;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
}
.alumni_img img {
    width: auto;
    height: 100%;
    border-radius: 50%;
}
.alumni_img.no_pic {
    align-items: end;
}
.alumni_img.no_pic img {
    width: auto;
    height: auto;
}
.alumni_name_brife h3 {
    font-size: 18px;
    margin: 0;
}
.class_year {
    color: #6a6868;
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
}
.alumni_directory_details .btn-viewcompus {
    font-size: 13px;
    color: #1452ce;
    font-weight: 500;
    line-height: 18px;
    position: relative;
    z-index: 2;
    text-decoration: none;
}
.alumni_directory_details .btn-viewcompus:hover {
    color: #0b3454;
    text-decoration: underline;
}
.alumni_directory_details a.btn-send {
    padding: 0 20px;
    line-height: 36px;
    text-decoration: none;
    background: #5cae48;
    border-radius: 25px;
    height: 36px;
    display: inline-flex;
    color: #fff;
    align-items: center;
    transition: all 0.3s ease-in-out;
    position: relative;
    z-index: 2;
}
.alumni_directory_details a.btn-send:hover {
    background: #40862f;
}
.alumni_directory_details a.btn-send span {
    display: none;
}
.icon-alumni-send {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/send_alumni_profile.svg) no-repeat 0
        0 / 100%;
    width: 19px;
    height: 19px;
    margin-right: 0;
    margin-left: 0;
}
.alumni_univarsity_details {
    background: #f9f9f9;
    border-radius: 0px 0px 5px 5px;
    opacity: 1;
    display: flex;
    flex: 1 1;
    padding: 10px 20px 15px;
    position: relative;
}
.alumni_univarsity_details .alumni_univarsity_details_inner_cover {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    width: 100%;
}
.alumni_univarsity_details .alumni_univarsity_details_inner_cover .alumni_univarsity_logo {
    width: 64px;
    margin-right: 10px;
    margin-top: 6px;
    height: 64px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.alumni_univarsity_details .alumni_univarsity_details_inner_cover .alumni_univarsity_logo img {
    width: 100%;
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
    object-fit: contain;
}
.alumni_univarsity_details .alumni_univarsity_details_inner_cover .alumni_univarsity_logo img[src*='no_img.png'] {
    max-width: 35px;
}
.alumni_univarsity_details .alumni_univarsity_details_inner_cover .alumni_univarsity_brife {
    width: calc(100% - 75px);
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.alumni_directory_details a.alumni_name_link {
    color: #000;
    text-decoration: none;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    width: 100%;
    display: inline-block;
}
.alumni_directory_details a.alumni_name_link:hover {
    color: #1452ce;
}
.alumni_class_link {
    padding: 15px 20px;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
}

.alumni_class_link .send_link .btn-monitor {
    width: 35px;
    height: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #a1a1a1;
    border-radius: 50%;
    text-decoration: none;
    color: #666;
    transition: all 0.3s ease-in-out;
}   
.alumni_class_link .send_link .btn-monitor:hover{
    background-color: #5cae48;
    border-color: #5cae48;
    color: #fff;
}
.alumni_name_detail {
    width: calc(100% - 64px);
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
}
.alumni_name_brife {
    display: flex;
    flex-direction: column;
    width: calc(100% - 70px);
    justify-content: center;
}
.alumni_education {
    color: #4d4d4d;
    font-size: 13px;
    font-weight: 500;
    line-height: 18px;
}
.current-roles-count {
    display: inline-flex;
    align-items: center;
    margin-left: 6px;
    padding: 2px 10px;
    border-radius: 999px;
    background: #e5f4df;
    color: #5a9a48;
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    white-space: nowrap;
    vertical-align: middle;
}
.current-roles-count--above {
    margin-left: 0;
}
.current-companies-card {
    width: 100%;
    background: transparent;
    padding: 0;
    margin-bottom: 16px;
}
.current-companies-card__top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 10px;
}
.current-companies-card__label {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    color: #5cae48;
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
}
.current-companies-card__count {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 22px;
    height: 22px;
    padding: 0 7px;
    border-radius: 999px;
    background: #e5f4df;
    color: #3c8f32;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0;
}
.current-companies-card__nav {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    color: #6b7280;
    font-size: 14px;
    font-weight: 500;
}
.current-companies-card__nav button {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 1px solid #d9dde3;
    background: #fff;
    color: #4b5563;
    line-height: 1;
    font-size: 18px;
    padding: 0 0 2px;
}
.current-companies-card__body {
    display: flex;
    align-items: center;
    gap: 14px;
    border: 1px solid #e6e8ee;
    border-radius: 12px;
    background: #fff;
    padding: 14px 16px;
}
.current-companies-card__logo {
    width: 72px;
    height: 72px;
    flex: 0 0 72px;
}
.current-companies-card__name {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    color: #1a1a1a;
    font-size: 20px;
    line-height: 26px;
    font-weight: 700;
}
.current-companies-card__primary {
    display: inline-flex;
    align-items: center;
    padding: 1px 8px;
    border-radius: 999px;
    background: #eef3ff;
    color: #3d6fd8;
    font-size: 12px;
    font-weight: 600;
    line-height: 18px;
}
.current-companies-card .alumni_profile_college_subject.current-companies-card__role {
    width: -moz-fit-content;
    width: fit-content;
    max-width: 100%;
    justify-content: flex-start;
    margin-top: 6px;
}
.current-companies-card .alumni_profile_college_subject.current-companies-card__role span {
    width: auto;
}
.current-companies-card__since {
    color: #8a8f98;
    font-size: 13px;
    line-height: 18px;
    margin-top: 4px;
}
.alumni_univarsity_name {
    font-size: 16px;
    font-weight: 500;
    line-height: 18px;
    margin-bottom: 3px; /* word-break: break-sall; */
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
.alumni_univarsity_name .icon-subtraction {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/subtraction.svg) no-repeat 0 0 / 100%;
    width: 12px;
    height: 20px;
    margin-left: 3px;
    display: inline-block;
    vertical-align: top;
}
.alumni_univarsity_name span:empty ~ .icon-subtraction {
    display: none;
}
.alumni_univarsity_subject {
    color: #0b3454;
    font-size: 14px;
    line-height: 16px;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
}
.alumni_univarsity_subject span {
    flex: 1 1;
}
.alumni_univarsity_subject i {
    width: 16px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/subject_setting.svg) no-repeat 0 0 /
        100%;
    height: 16px;
    margin-right: 7px;
}
.filter_result ul {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
}
.filter_result_title {
    margin-bottom: 18px;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 10px;
}
.filter_result_title .filter_result {
    flex: 1 1;
}
.filter_result ul li {
    background: #e9f6fc;
    border-radius: 25px;
    padding: 9px 23px;
    margin-top: 6px;
    margin-bottom: 6px;
}
.filter_result ul li:not(:last-child) {
    margin-right: 10px;
}
.filter_result ul li:last-child {
    background: no-repeat;
    padding: 9px 0;
}
.filter_result ul li span {
    margin-right: 10px;
}
.filter_result ul li .btn-cross {
    font-size: 10px;
    color: #000;
    text-decoration: none;
}
.filter_result ul li .btn-cross:hover {
    color: #105271;
}
.alumni_count {
    font-size: 18px;
    font-weight: 500;
    line-height: 20px;
    margin: 18px 0 0;
}
.btn-additionalfilter {
    text-decoration: none;
    font-size: 14px;
    color: #1452ce;
    font-weight: 500;
    display: inline-flex;
    align-items: center;
    transition: all 0.3s ease-in-out;
}
.btn-additionalfilter span {
    text-decoration: underline;
    margin-right: 10px;
}
.btn-additionalfilter .icon-right-arrow {
    transform: rotate(90deg);
    transition: all 0.3s ease-in-out;
}
.btn-additionalfilter[aria-expanded='true'] .icon-right-arrow {
    transform: rotate(270deg);
}
.btn-additionalfilter:hover {
    color: #0b3454;
}
.btn-additionalfilter:hover span {
    text-decoration: none;
}
.alumni_directory_filter .filters-head h3 {
    display: flex;
    margin: 0;
    align-items: center;
}
.alumni_directory_filter .filters-head h3 .icon-filter + span {
    flex: 1 1;
}
.alumni_directory_filter .filters-head h3[aria-expanded='true'] i {
    transform: rotate(270deg);
}
.alumni_directory_details .load_more_btn {
    text-decoration: none;
    text-transform: uppercase;
    display: flex;
    justify-content: center;
    align-items: center;
}
.alumni_directory_details .load_more_btn:hover {
    background: #0b3454;
    color: #fff;
    border-color: #0b3454;
}
.alumni_directory_details .load_more_btn img {
    -webkit-animation: none;
}
.alumni_directory_details .load_more_btn:hover img {
    filter: invert(1) brightness(100);
}
.tooltip-viewcompus .tooltip-arrow::before {
    display: none;
}
.alumni_profile_brife_wrap {
    border-bottom: 1px solid #e7e7e7;
}
.alumni_profile_brife {
    padding: 40px 0;
}
.alumni_profile_brife .btn-back {
    color: #000;
    font-size: 14px;
    line-height: 16px;
    font-weight: 500;
}
.alumni_profile_brife .btn-back .icon-right-arrow {
    transform: scaleX(-1);
    margin-right: 7px;
    font-size: 12px;
}
.alumni_profile_brife .btn-back:hover {
    color: #0b3454;
}
.alumni_profile_name_college_other_detail_wrap {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
}
.alumni_profile_image_name_other_detail {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    padding: 0 20px 0 0;
    position: relative;
    width: 48%;
}
.alumni_profile_image_name_other_detail:after {
    content: '';
    width: 1px;
    height: 85%;
    background: #d4d4d4;
    position: absolute;
    right: 0;
    top: 0;
}
.alumni_profile_image {
    width: 110px;
    height: 110px;
    background: #f1f1f1;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    margin-right: 20px;
}
.alumni_profile_image img {
    width: auto;
    height: 100%;
}
.alumni_profile_image.no_pic {
    align-items: end;
}
.alumni_profile_image.no_pic img {
    height: 80%;
}
.alumni_profile_name_other_detail {
    width: calc(100% - 130px);
}
.alumni_profile_name_other_detail h2 {
    font-size: 26px;
    line-height: 18px;
    font-weight: 600;
    word-break: break-all;
    line-height: 28px;
}
.alumni_profile_name_other_detail .alumni_profile_location {
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 15px;
}
.alumni_profile_class_college {
    position: relative;
    padding: 0 0 0 20px;
    margin-bottom: 13px;
}
.alumni_profile_class_college:before {
    content: '';
    position: absolute;
    left: 6px;
    top: 0;
    bottom: 0;
    width: 3px;
    height: 100%;
    background: #d52941;
    border-radius: 5px;
}
.alumni_profile_class_college .alumni_profile_class {
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0.32px;
    line-height: 18px;
    margin-bottom: 5px;
}
.alumni_profile_class_college .alumni_profile_college {
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0.32px;
    line-height: 18px;
}
.alumni_profile_college_phone {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
}
.alumni_profile_college_phone .verifyLink {
    font-size: 16px;
    font-weight: 500;
}
.verifiedLink {
    color: #5cae48;
    text-decoration: none;
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 16px;
}
.alumni_profile_name_other_detail .btn-send {
    width: auto;
    height: 40px;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    background: #5cae48;
    border-radius: 25pc;
    color: #fff;
    text-decoration: none;
    align-items: center;
    padding: 0 25px;
    font-size: 16px;
    font-weight: 500;
    transition: all 0.3s ease-in-out;
}
.alumni_profile_name_other_detail .btn-send .icon-send {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/send_alumni_profile.svg) no-repeat 0
        0 / 100%;
    width: 19px;
    height: 19px;
    margin-right: 10px;
    position: relative;
    transition: all 0.3s ease-in-out;
    left: 0;
}
.alumni_profile_name_other_detail .btn-send:hover {
    background: #2fa612;
}
.alumni_profile_name_other_detail .btn-send:hover .icon-send {
    left: 3px;
}
.alumni_profile_college_name_other_detail_wrap {
    flex: 1 1;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    padding: 0 0 0 40px;
}
.alumni_profile_college_name_other_detail_wrap .alumni_profile_college_logo {
    width: 100px;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    border: 1px solid #d2d2d2;
    margin-right: 18px;
}
.alumni_profile_college_name_other_detail_wrap .alumni_profile_college_logo img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
}
.alumni_profile_college_name_other_detail_wrap .alumni_profile_college_logo img[src*='college_icon'] {
    width: 40px;
}
.alumni_profile_college_name_other_detail_wrap .alumni_profile_college_logo img[src*='no_img'] {
    width: auto;
}
.alumni_profile_college_name_other_detail_wrap .alumni_profile_college_name_other_detail {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    align-items: start;
    width: calc(100% - 120px);
}
.alumni_profile_brife_tab {
    margin-bottom: 20px;
}
.alumni_profile_status {
    list-style: none;
    margin: 0;
    padding: 0;
}
.alumni_profile_status li {
    margin-bottom: 16px;
    width: 176px;
    position: relative;
    padding-left: 16px;
}
.alumni_profile_status li .title {
    letter-spacing: 0.32px;
    color: #000000;
    font-size: 16px;
}
.alumni_profile_status li p {
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: 0.32px;
}
.alumni_profile_status li .alumni_profile_name_other_detail{
    display: flex;
}

.alumni_profile_status li:before {
    content: '';
    width: 3px;
    height: 17px;
    position: absolute;
    left: 0;
    top: 4px;
    background: #d52941;
    border-radius: 5px;
}
.alumni_profile_college_joined {
    color: #5cae48;
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
    margin-bottom: 5px;
}
.alumni_profile_college_name_detail {
    width: calc(100% - 176px);
    padding-right: 50px;
}
.alumni_profile_college_name_other_detail_wrap .alumni_profile_college_name_detail h3 {
    font-size: 20px;
    line-height: 26px;
    font-weight: 600;
}
.alumni_profile_college_subject {
    min-height: 30px;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6px 15px;
    background: #e5f1fb;
    border-radius: 18px;
    font-size: 16px;
    line-height: 20px;
    font-weight: 600;
    color: #0b3454;
    -webkit-border-radius: 18px;
    -moz-border-radius: 18px;
    -ms-border-radius: 18px;
    -o-border-radius: 18px;
    max-width: 100%;
}
.alumni_profile_college_subject span {
    white-space: normal;
    word-break: break-word;
    width: calc(100% - 20px);
}
.alumni_profile_college_subject .icon {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/course_alumni_profile.svg);
    width: 16px;
    height: 16px;
    margin-right: 8px;
    min-width: 16px;
}
.alumni_profile_detail {
    padding: 30px 0;
}
.alumni_profile_brife_tab .nav {
    justify-content: center;
}
.alumni_profile_brife_tab .nav-item:not(:last-child) {
    margin-right: 10px;
}
.alumni_profile_brife_tab .nav-pills .nav-link {
    min-width: 100px;
    height: 40px;
    white-space: nowrap;
    border: 2px solid #7d7d7d;
    border-radius: 25px;
    background: #fff;
    color: #000;
    padding: 0 20px;
}
.alumni_profile_brife_tab .nav-pills .nav-link.active,
.alumni_profile_brife_tab .nav-pills .nav-link:hover {
    background: #0b3454;
    border-color: #0b3454;
    color: #fff;
}
.underGraduate-detail .main_title,
.blockHeader {
    font-size: 22px;
    color: #000;
    width: auto;
    margin: -40px -40px 25px;
    border-radius: 6px 6px 0px 0px;
    padding: 20px 40px;
    line-height: 22px;
    border-bottom: 1px solid #f5f5f5;
}
.blockHeader .title span {
    font-weight: 600;
}
.graduateRow .college_detail_wrap .college_detail h3 {
    font-size: 20px;
    font-weight: 600;
    margin: 0 0 2px;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.college_name_scholarship .college_name a {
    color: #000;
    text-decoration: none;
}
/* AGS-362 @dt 2nd.Aug,2K23 @by RG */

/* .graduateRow .college_detail_wrap:hover h3 {text-decoration: underline;color: #1452ce;} */
.graduateRow .college_detail_wrap .college_detail h3 .icon-subtraction {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/subtraction.svg) no-repeat 0 0 / 100%;
    width: 16px;
    height: 25px;
    margin-left: 3px;
    display: inline-block;
    vertical-align: top;
}
.graduateRow .college_detail_wrap .college_detail p {
    font-size: 16px;
    color: #414141;
    margin: 0 0 5px;
}
.graduateRow {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    position: relative;
}
.graduateRow:not(:last-child) {
    border-bottom: 2px solid #e5e5e5;
    margin-bottom: 28px;
    padding-bottom: 28px;
}
.underGraduate-detail,
.postGraduate-detail {
    box-shadow: 0px 10px 25px #00000008;
    border-radius: 6px;
    background: #fff;
    padding: 40px;
}
.graduateRow .college_detail_wrap {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    width: calc(100% - 265px);
    padding-right: 40px;
    position: relative;
    align-items: center;
}
.graduateRow .college_detail_wrap > a {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
}
.graduateRow .college_detail_wrap:after {
    content: '';
    position: absolute;
    top: 13px;
    right: 0;
    width: 2px;
    height: 63px;
    background: #d1d1d1;
}
.graduateRow .offer {
    width: 265px;
    display: flex;
    flex-direction: column;
    align-items: end;
    justify-content: center;
}
.graduateRow .college_detail_wrap .college_detail {
    flex: 1 1;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
}
.graduateRow .college_detail_wrap .college_detail .college_logo {
    margin-right: 20px;
    width: 150px;
    height: 95px;
    border: 1px solid #d5d5d5;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.graduateRow .college_detail_wrap .college_detail .college_logo img[src*="no_university_img"]{width:50px}
.college_name_scholarship {
    flex: 1 1;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
}
.college_name_scholarship .college_name {
    width: calc(100% - 100px);
    display: flex;
    flex-direction: column;
    align-items: start;
}
.graduateRow .college_detail_wrap .college_detail .college_logo .logo_link {
    padding: 10px;
    display: inline-block;
    width: 100%;
    height: 100%;
}
.graduateRow .college_detail_wrap .scholarship {
    display: flex;
    flex-direction: column;
    text-align: center;
    line-height: 20px;
}
.graduateRow .college_detail_wrap .scholarship .scholarship_label {
    font-weight: 500;
    color: #8a8a8a;
}
.graduateRow .college_detail_wrap .scholarship .scholarship_amt {
    font-weight: 600;
    white-space: nowrap;
}
.graduateRow .offer > a,
.graduateRow .offer a.joindeLink {
    padding: 0 20px;
    text-decoration: none;
    height: 37px;
    background: #5cae48;
    color: #fff;
    border-radius: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 10px;
    transition: all 0.3s ease-in-out;
}
.graduateRow .offer > a:hover,
.graduateRow .offer a.joindeLink:hover {
    background: #3e9329;
}
.graduateRow .offer > a i,
.graduateRow .offer a.joindeLink i {
    margin-right: 10px;
}
.graduateRow .offer > a:hover {
    background: #3b8d27;
}
.graduateRow .offer .got_offer {
    font-weight: 500;
    font-size: 16px;
    margin-bottom: 5px;
}
.graduateRow .offer .got_offer i {
    margin-right: 10px;
    font-size: 20px;
    color: #5cae48;
}
.graduateRow .offer .offerLink {
    color: #1452ce;
}
.graduateRow .offer .offerLink:hover {
    color: #0b3454;
}
.graduateRow .offer .offer_joined i {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/hat_alumni.svg);
    width: 23px;
    height: 17px;
    margin-right: 10px;
}
.graduateRow .offer .offer_joined {
    display: flex;
    align-items: center;
}
.graduateRow.edit .college_detail_wrap {
    width: calc(100% - 350px);
}
.graduateRow .offer.offer_edit {
    flex-direction: row;
    align-items: center;
    width: 350px;
    justify-content: end;
}
.graduateRow .offer.offer_edit .edit_section,
.edit_section {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-left: 20px;
    align-items: center;
}
.edit_section_inner {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}
.graduateRow .offer .edit_link,
.edit_section .edit_link {
    width: 52px;
    height: 30px;
    background: #eaf4fc;
    border-radius: 20px;
    transition: all 0.3s ease-in-out;
    position: relative;
}
.graduateRow .offer .edit_link:hover,
.edit_section .edit_link:hover {
    background-color: #0b3454;
}
.graduateRow .offer .edit_link:before,
.edit_section .edit_link::before {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    margin: auto;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/draw.svg) no-repeat center / 18px
        auto;
}
.graduateRow .offer .edit_link:hover:before,
.edit_section .edit_link:hover::before {
    filter: invert(99%) sepia(1%) saturate(2%) hue-rotate(228deg) brightness(110%) contrast(100%);
}
.graduateRow .offer .del_link,
.edit_section .del_link,
.del_link {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/delete.svg);
    width: 14px;
    height: 16px;
    margin-left: 10px;
    opacity: 0.5;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.graduateRow .offer .del_link:hover,
.edit_section .del_link:hover,
.del_link:hover {
    opacity: 1;
}
.graduateRow .offer .offer_existing_links {
    display: flex;
    flex-direction: column;
    align-items: end;
}
.form-group .del_link {
    position: absolute;
    top: 15px;
    right: -20px;
}
.graduation-title {
    font-size: 22px;
    font-weight: 400;
    margin: -15px 0 20px;
}
.graduation-title span {
    font-weight: 600;
}
.graduation_carousel_wrap {
    margin-top: 20px;
    box-shadow: 0px 10px 25px #00000008;
    border-radius: 6px;
    background: #fff;
    padding: 40px;
}
.graduation_carousel_wrap .card_profiles:first-child {
    margin-bottom: 18px;
}
.graduation_carousel_wrap .seactionheader {
    margin: -10px 0 27px;
}
.graduation_carousel_wrap .seactionheader h3 {
    font-size: 22px;
    font-weight: 400;
}
.graduation_carousel_wrap .seactionheader h3 span {
    font-weight: 600;
}
.owl-item .card_profiles {
    border: 1px solid #d2d2d2;
    padding: 20px;
    border-radius: 6px;
    flex-direction: column !important;
    display: flex;
    justify-content: space-between;
    height: 100%;
    position: relative;
    background: #fff;
    max-height: 240px;
    min-height: 240px;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    -ms-border-radius: 6px;
    -o-border-radius: 6px;
    overflow-y: auto;
}
.card_profiles::-webkit-scrollbar {
    width: 4px;
}
.card_profiles::-moz-scrollbar {
    width: 4px;
}
.card_profiles::-webkit-scrollbar-track {
    background: #ccc;
}
.card_profiles::-webkit-scrollbar-thumb {
    background-color: #666;
    border-radius: 20px;
    border: 2px solid #666;
}
.card_profiles .alumni-Profile-button-rounded {
    position: absolute;
    right: 20px;
    padding: 0 20px;
}
.card_profiles .alumni-Profile-button-rounded:hover,
.card_profiles .alumni-Profile-button-rounded:focus {
    background: #40952c;
    color: #fff;
    background-color: #40952c;
    border-color: 0;
    box-shadow: none;
}
.card_profiles figure.student {
    width: 90px;
    height: 90px;
    overflow: hidden;
    border-radius: 200px;
    margin-right: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.card_profiles figure.student img {
    border-radius: 200px;
}
.student_details {
    width: calc(100% - 110px);
}
.card_profiles .student_details figure img {
}
.card_profiles .student_details h2 {
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 15px;
    width: 65%;
    margin-top: 010px;
}
.card_profiles .student_details h2 a {
    color: #000;
    text-decoration: none;
    white-space: nowrap;
    width: 100%;
    text-overflow: ellipsis;
    display: inline-block;
    overflow: hidden;
}
.card_profiles .student_details h2 a:hover {
    text-decoration: underline;
    color: #1452ce;
}
.card_profiles .student_details h2 span {
    display: block;
    font-size: 16px;
    color: #6a6868;
    font-weight: 500;
}
.card_profiles .student_details .sub_details {
    display: flex;
    flex-grow: 1 !important;
}
.card_profiles .student_details .sub_details_workExp {
    align-items: center;
    position: relative;
    padding-bottom: 5px;
}
.card_profiles .student_details .sub_details_achivements figure {
    background: #0b3454 !important;
}
.card_profiles .student_details .sub_details_workExp figure {
    border: 0 !important;
    border-radius: 100px !important;
    min-width: 50px !important;
    height: 50px !important;
    width: 50px !important;
    background-color: #d52941;
}
.card_profiles .student_details .sub_details_workExp figure img {
    width: 45%;
    height: auto;
}
.card_profiles .student_details .sub_details_workExp figure.bg_white {
    background-color: #fff !important;
    border: 1px solid #d2d2d2 !important;
}
.card_profiles .student_details .sub_details_workExp figure.bg_white img {
    width: 80%;
}
.card_profiles .student_details .sub_details_workExp:after {
    position: absolute;
    width: 83%;
    height: 1px;
    content: '';
    background: #c1c1c1;
    bottom: 0;
    right: 0;
}
.card_profiles .student_details .sub_details_workExp1:after {
    display: none;
}
.card_profiles .student_details .sub_details h3 {
    margin-bottom: 0;
    min-width: 43px;
    justify-content: center;
}
.card_profiles .student_details .sub_details figure {
    border: 1px solid #d2d2d2;
    border-radius: 100px;
    min-width: 80px;
    height: 80px;
    overflow: hidden;
    margin-right: 10px;
    margin-bottom: 0;
    width: 80px;
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.card_profiles .student_details .sub_details p {
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 5px;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    max-height: 43px;
    overflow: hidden;
    line-height: 18px;
}
.card_profiles .student_details .sub_details a {
    color: #000;
    text-decoration: none;
}
.card_profiles .student_details .sub_details a:hover {
    text-decoration: underline;
    color: #1452ce;
}
.card_profiles .student_details .sub_details p.title,
.card_profiles .student_details .sub_details p.green-title {
    color: #5cae48;
    font-size: 14px;
    margin-bottom: 10px;
}
.card_profiles .student_details .sub_details span {
    color: #333333;
    font-size: 14px;
    margin-bottom: 15px;
    font-weight: 400;
}
.card_profiles .student_details .sub_details span.course {
    color: #0b3454;
    font-size: 16px;
    font-weight: 400;
    display: flex;
    align-items: center;
    margin-bottom: 0;
}
.card_profiles .student_details .sub_details span.course img {
    margin-right: 6px;
    width: 16px;
}
.card_profiles .action_btns {
    margin-top: 20px;
    border-top: 1px solid #d2d2d2;
    padding-top: 20px;
    display: flex;
    justify-content: center !important;
    width: 100%;
}
.card_profiles .action_btns .btn-outline-primary {
    margin-right: 10px;
    border: 2px solid #5bae47;
    border-radius: 50px;
    padding: 7px 20px;
    color: #5bae47;
}
.card_profiles .action_btns .btn-outline-primary:hover img {
    filter: brightness(0) invert(1);
    -webkit-filter: brightness(0) invert(1);
}
.card_profiles .action_btns .btn-outline-primary:hover {
    border: 2px solid #418d2e;
    background-color: #418d2e;
    color: #fff;
}
.card_profiles .action_btns .btn-secondary {
    border-radius: 50px;
    padding: 7px 20px;
    color: #fff;
    background: #0b3454;
}
.card_profiles .action_btns .btn-secondary:hover {
    background: #26a7df;
    border: 1px solid #26a7df;
}
.card_profiles .btn-send {
    width: 123px;
    height: 40px;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    background: #5cae48;
    border-radius: 25pc;
    color: #fff;
    text-decoration: none;
    align-items: center;
    padding: 0 25px;
    font-size: 16px;
    font-weight: 500;
    transition: all 0.3s ease-in-out;
}
.card_profiles .btn-send {
    color: #fff;
    font-size: 16px;
    font-weight: 500;
    position: absolute;
    top: 20px;
    right: 20px;
}
.card_profiles .btn-send .icon-send {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/send_alumni_profile.svg) no-repeat 0
        0 / 100%;
    width: 19px;
    height: 19px;
    margin-right: 10px;
    position: relative;
    transition: all 0.3s ease-in-out;
    left: 0;
}
.card_profiles .btn-send:hover .icon-send {
    left: 3px;
}
.card_profiles .btn-send:hover {
    background: #3b8d27;
}
.workExperience-detail {
    box-shadow: 0px 10px 25px #00000008;
    border-radius: 6px;
    background: #fff;
    padding: 40px;
}
.workExperience-detail .workExperience-title {
    font-size: 22px;
    font-weight: 400;
    margin: -15px 0 30px;
}
.workExperience-detail .workExperience-title span {
    font-weight: 600;
}
.work-block {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    align-items: center;
    position: relative;
}
.work-block .work-detail {
    flex: 1 1;
    display: flex;
    flex-direction: column;
}
.work-block .icon {
    width: 55px;
    height: 55px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 26px;
    margin-right: 20px;
    background: #d52941;
    border-radius: 50%;
    color: #fff;
}
.work-block .icon.workex-logo {
    border-radius: 0;
}
.work-block .icon.workex-logo img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
}
.work-block .work-detail p {
    font-size: 20px;
    line-height: 24px;
    margin: 0 0 5px;
    font-weight: 500;
}
.work-block .work-detail span {
    font-size: 16px;
    color: #6d6b6b;
    line-height: 16px;
    font-weight: 500;
}
.achievements-block {
    box-shadow: 0px 10px 25px #00000008;
    border-radius: 6px;
    background: #fff;
    padding: 30px;
    display: flex;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    -ms-border-radius: 6px;
    -o-border-radius: 6px;
    position: relative;
}
.achievements-block:not(:last-child) {
    border-bottom: 1px solid #f5f5f5;
}
.achievements-icon-block {
    padding: 0 55px 0 30px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-width: 185px;
    max-width: 185px;
    align-items: center;
    text-align: center;
    border-right: 1px solid #cecece;
    margin-right: 30px;
}
.achievements-icon-block .icon {
    width: 60px;
    height: 60px;
    background: #0b3454;
    border-radius: 50%;
    margin-bottom: 8px;
    position: relative;
}
.achievements-icon-block .icon.icon-medal:before {
    content: '';
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/exam_ico.svg);
    width: 26px;
    height: 36px;
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    top: 0;
    margin: auto;
}
.achievements-icon-block .icon.icon-grade:before {
    content: '';
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/exam_ico.svg);
    width: 25px;
    height: 31px;
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    top: 0;
    margin: auto;
}
.achievements-icon-block .icon.icon-publication:before {
    content: '';
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/publication_ico.svg);
    width: 29px;
    height: 31px;
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    top: 0;
    margin: auto;
}
.achievements-icon-block .icon.icon-promotion:before {
    content: '';
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/promotion_ico.svg);
    width: 32px;
    height: 37px;
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    top: 0;
    margin: auto;
}
.achievements-icon-block .icon.icon-course-completion:before {
    content: '';
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/course_ico.svg);
    width: 31px;
    height: 37px;
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    top: 0;
    margin: auto;
}
.achievements-icon-block .icon.icon-social-service:before {
    content: '';
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/social_ico.svg);
    width: 36px;
    height: 36px;
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    top: 0;
    margin: auto;
}
.achievements-icon-block .icon.icon-scholarship:before {
    content: '';
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/scholarship_ico.svg);
    width: 39px;
    height: 28px;
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    top: 0;
    margin: auto;
}
.achievements-icon-block .icon.icon-others:before {
    content: '';
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/others_ico.svg);
    width: 32px;
    height: 32px;
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    top: 0;
    margin: auto;
}
.achievements-icon-block .achievements-title {
    font-size: 18px;
    font-weight: 600;
}
.achievements-icon-block .achievements-year {
    font-size: 18px;
    line-height: 22px;
    color: #414141;
}
.achievements-block-detail h3 {
    font-size: 22px;
    font-weight: 400;
    margin-bottom: 0px;
}
.achievements-block-detail h3 span {
    font-weight: 600;
}
.achievements-block-detail p {
    font-size: 16px;
    line-height: 24px;
    margin: 0;
}
.achievements-block-detail {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
}
.hide {
    display: none;
}
.achievements-block-detail p.show .hide {
    display: inline;
}
.achievements-block-detail p.show .btn-readmore {
    font-size: 0;
}
.achievements-block-detail p.show .btn-readmore:before {
    content: 'Read Less';
    font-size: 16px;
}
.achievements-block-detail p .btn-readmore {
    color: #1452ce;
    transition: all 0.3s ease-in-out;
}
.achievements-block-detail p .btn-readmore:hover {
    color: #1046b3;
}
.achievements-block-detail .url-link {
    color: #1452ce;
    transition: all 0.3s ease-in-out;
}
.achievements-block-detail .url-link:hover {
    color: #1046b3;
}
.achievements-list {
    box-shadow: 0px 10px 25px #00000008;
    border-radius: 6px;
    background: #fff;
}
.achievements-block-title {
    padding: 20px 40px;
    border-bottom: 1px solid #f5f5f5;
    border-radius: 6px 6px 0 0;
}
.achievements-block-title .title {
    font-size: 22px;
}
.achievements-block-title .title span {
    font-weight: 600;
}
.btn-add-section {
    background: #fff;
    border: 1px solid #0b3454;
    border-radius: 19px;
    height: 37px;
    display: flex;
    padding: 0 20px;
    align-items: center;
    text-decoration: none;
    font-weight: 500;
    font-size: 14px;
    color: #0b3454;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.btn-add-section i {
    position: relative;
    width: 11px;
    height: 110px;
    margin-right: 10px;
}
.btn-add-section i:before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    background: #0b3454;
    width: 2px;
    height: 10px;
}
.btn-add-section i:after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    background: #0b3454;
    width: 10px;
    height: 2px;
}
.btn-add-section:hover {
    background: #0b3454;
    color: #fff;
}
.btn-add-section:hover i:before,
.btn-add-section:hover i:after {
    background: #fff;
}
.contributions-block {
    box-shadow: 0px 10px 25px #00000008;
    border-radius: 6px;
    background: #fff;
    padding: 40px;
}
.contributions-block:not(:last-child) {
    margin-bottom: 20px;
}
.contributions-block .act_lst:not(:last-child) {
    margin-bottom: 20px;
}
.contributions-block .seactionheader {
    margin: -10px 0 20px;
}
.contributions-block h3 {
    font-size: 22px;
    font-weight: 600;
}
.contributions-block .circle-effect::before {
    background: #6c8598;
}
.contributions-block .list_badge {
    color: #d52941;
    background: no-repeat;
    position: static;
    text-transform: uppercase;
}
.contributions-block .act_lst {
    padding: 25px 25px 25px 25px;
}
.contributions-block .video_block_name label {
    font-size: 16px;
}
.skills-block {
    box-shadow: 0px 10px 25px #00000008;
    border-radius: 6px;
    background: #fff;
    padding: 40px;
    position: relative;
}
.skills-block:first-child {
    padding-bottom: 20px;
}
.skills-block.EntranceExam-skills-block {
    padding-bottom: 33px;
}
.skills-block:not(:last-child) {
    margin-bottom: 20px;
}
.skills-block h2 {
    font-size: 22px;
    font-weight: 400;
    margin-bottom: 15px;
    margin: -10px 0 25px;
}
.skills-block h2 span {
    font-weight: 600;
}
.skills-block-detail {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
}
.skills-block-detail .meter {
    margin: 0 12px 20px 0;
    border: 1px solid #c7c7c7;
    padding: 10px 30px;
    border-radius: 50px;
    font-size: 20px;
    font-weight: 500;
    align-items: center;
}
.skills-block-detail .meter img {
    width: 50px;
}
.skills-block-title {
    margin-top: -30px;
    margin-bottom: 20px;
}
.preferences-block {
    box-shadow: 0px 10px 25px #00000008;
    border-radius: 6px;
    background: #fff;
    padding: 40px;
}
.preferences-block:not(:last-child) {
    margin-bottom: 20px;
}
.preferences-block.EntranceExam-skills-block {
    padding-bottom: 33px;
}
.preferences-block h2 {
    font-size: 22px;
    font-weight: 400;
    margin-bottom: 15px;
    margin: -10px 0 25px;
}
.preferences-block h2 span {
    font-weight: 600;
}
.preferences-block-detail {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
}
.preferences-block-detail .meter {
    margin: 0 12px 20px 0;
    border: 1px solid #c7c7c7;
    padding: 10px 30px;
    border-radius: 50px;
    font-size: 20px;
    font-weight: 500;
    align-items: center;
}
.preferences-block-detail .meter img {
    width: 50px;
}
.preferences-block-title {
    margin-top: -30px;
    margin-bottom: 20px;
}
.interested-block .icon {
    width: 55px;
    height: 55px;
    border-radius: 50%;
    background: #0b3454;
    position: relative;
    margin-right: 20px;
}
.interested-block .icon.icon-bulb::before {
    content: '';
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/bulb.svg) no-repeat 0 0 / 34px auto;
    width: 34px;
    height: 36px;
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    top: 0;
    margin: auto;
}
.interested-block .icon.icon-note::before {
    content: '';
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/publication_ico.svg);
    width: 29px;
    height: 31px;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
}
.interested-block {
    display: flex;
    align-items: center;
}
.interested-block .interested-topics {
    font-size: 20px;
    flex: 1 1;
    line-height: 22px;
}
.interested-block .interested-topics span {
    font-weight: 500;
}
.graduationslider .meter {
    padding: 10px 30px;
    display: inline-flex;
    flex-wrap: wrap;
    align-items: center;
    border-radius: 50px;
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 10px;
}
.profile-item {
    text-align: center;
    width: 196px;
    height: 210px;
    display: flex;
    flex-direction: column;
    padding-top: 10px;
}
.owl-item:not(:last-child) .profile-item {
    border-right: 1px solid #d2d2d2;
}
.profile-item-img {
    text-align: center;
    display: flex;
    justify-content: center;
    margin-bottom: 11px;
}
.profile-item-name-class h3 {
    font-size: 16px;
    font-weight: 600;
    margin: 0 0 4px;
}
.profile-item-name-class p {
    margin: 0 0 11px;
    font-size: 14px;
    font-style: italic;
    color: #535353;
}
.profile-item-name-class .subject {
    color: #0b3454;
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    position: relative;
    padding-top: 10px;
}
.profile-item-name-class .subject:before {
    content: '';
    width: 30px;
    height: 2px;
    background: #5cae48;
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    top: 0;
}
.profile-item-name-class .btn-viewcompus {
    font-size: 13px;
    color: #1452ce;
    font-weight: 500;
    line-height: 18px;
    position: relative;
    z-index: 2;
    text-decoration: none;
}
.profile-item-name-class .btn-viewcompus:hover {
    color: #0b3454;
    text-decoration: underline;
}
.psychology-item {
    text-align: center;
    width: 245px;
    height: 196px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-top: 10px;
}
.owl-item:not(:last-child) .psychology-item {
    border-right: 1px solid #d2d2d2;
}
.popularCollegesslider .owl-item.active + .owl-item.active + .owl-item.active + .owl-item.active .psychology-item {
    border-right: 0px solid #d2d2d2;
}
.psychology-item-img {
    text-align: center;
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
    height: 90px;
    align-items: center;
}
.psychology-item-name h3 {
    font-size: 16px;
    font-weight: 600;
    margin: 0 0 5px;
    line-height: 17px;
}
.psychology-item-name p {
    font-size: 14px;
    font-style: italic;
    font-weight: 500;
    line-height: 20px;
}
.alumni_directory_details .btn-working {
    font-size: 13px;
    color: #1452ce;
    font-weight: 500;
    line-height: 18px;
    position: relative;
    z-index: 2;
    text-decoration: none;
}
.alumni_directory_details .btn-working:hover {
    color: #0b3454;
    text-decoration: underline;
}
.tooltip-viewcompus .tooltip-inner {
    background: #3b3b3b;
    border-color: #3b3b3b;
}
.tooltip-working .tooltip-inner {
    display: flex;
    flex-direction: column;
    padding: 15px;
    background: #3b3b3b;
    border-color: #3b3b3b;
}
.tooltip-working .tooltip-inner .logo {
    position: relative;
    font-size: 20px;
}
.tooltip-working .tooltip-inner span.logo + span {
    font-size: 16px;
}
.tooltip-working.bs-tooltip-top .tooltip-arrow::before {
    border-top-color: #3b3b3b;
}
.tooltip-working.bs-tooltip-bottom .tooltip-arrow::before {
    border-bottom-color: #3b3b3b;
}
.tooltip-working.bs-tooltip-end .tooltip-arrow::before {
    border-right-color: #3b3b3b;
}
.tooltip-working.bs-tooltip-start .tooltip-arrow::before {
    border-left-color: #3b3b3b;
}
.alumni_name_brife > div {
    align-items: center;
}
.alumni_name_brife > div .sep {
    margin: 0 6px;
    color: #1452ce;
}
.custom_badge {
    display: inline-block;
    border: 1px solid #dedede;
    height: 32px;
    line-height: 32px;
    padding: 0 16px;
    border-radius: 18px;
    font-size: 14px;
    font-weight: 500;
    color: #0b3454;
    margin: 0 5px 10px 0;
    background: #fff;
    overflow: hidden;
}
.custom_badge .icon {
    margin-right: 5px;
}
.delete_confirm .icon-cross {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 1px solid red;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #e94e58;
}
.delete_confirm .del_text {
    margin: 20px 0 10px;
    text-align: center;
    max-width: 240px;
    font-size: 28px;
    line-height: 36px;
    font-weight: 500;
    width: 100%;
}
.delete_confirm .btn-delete {
    background: #d52941;
    border-radius: 31px;
    border: 0;
    height: 36px;
    color: #fff;
    padding: 0 20px;
    font-weight: 600;
    font-size: 14px;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.delete_confirm .btn-delete:hover {
    background: #a0182b;
}
.selected_options ul {
    display: flex;
    list-style: none;
    margin: 0;
    padding: 0;
}
.selected_options ul li {
    background: #f7fbff;
    border: 1px solid #0b34544d;
    border-radius: 18px;
    height: 35px;
    display: flex;
    align-items: center;
    padding: 0 18px;
    margin: 12px 12px 6px 0;
    font-size: 16px;
    font-weight: 500;
}
.selected_options ul li .icon-cross {
    font-size: 9px;
    margin: 2px 0 0 10px;
    text-decoration: none;
    color: #000;
}
.selected_options ul li .icon-cross:hover {
    text-decoration: none;
    color: #333;
}
.question .form-select.w-90 {
    width: 90px !important;
    max-width: 90px;
}
.custom_row_title {
    margin-bottom: 10px;
    font-weight: 400;
    font-size: 20px;
}
.custom_row_title span {
    font-weight: 600;
}
.custom_row_block .program {
    font-size: 20px;
}
.custom_row_block .program span {
    font-weight: 500;
}
.program-time-interest {
    color: #414141;
    font-size: 16px;
    line-height: 20px;
}
.custom_row_block {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    width: 100%;
}
.custom_row_block .icon {
    width: 55px;
    height: 55px;
    border-radius: 50%;
    background: #0b3454;
    margin-right: 15px;
    position: relative;
}
.custom_row_block .icon.icon-hat:before {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/hat_alumni.svg) no-repeat 0 0 /26px;
    width: 26px;
    height: 20px;
    display: inline-block;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    position: absolute;
    filter: invert(1);
    -webkit-filter: invert(1);
}
.custom_row_block .icon + div {
    width: calc(100% - 70px);
}
.custom_row {
    width: 100%;
    border-top: 1px solid #dbdbdb;
    padding-top: 20px;
}
.custom_row:not(:last-child) {
    padding-bottom: 20px;
}
.radius_block {
    background: #ffffff;
    border: 1px solid #c7c7c7;
    border-radius: 30px;
    height: 60px;
    padding: 0 30px;
    display: flex;
    align-items: center;
    font-size: 20px;
    line-height: 20px;
    font-weight: 500;
}
.radius_block span {
    margin-right: 30px;
}
.radius_block i {
    font-size: 24px;
}
.radius_block i.gray {
    color: #8599a9;
}
.radius_block i.green {
    color: #5dae48;
}
.universities_block {
    background: #ffffff;
    border: 1px solid #c7c7c7;
    border-radius: 30px;
    height: 60px;
    padding: 0 8px;
    display: flex;
    align-items: center;
    font-size: 20px;
    line-height: 26px;
    font-weight: 500;
    -webkit-border-radius: 30px;
    -moz-border-radius: 30px;
    -ms-border-radius: 30px;
    -o-border-radius: 30px;
}
.universities_block .logo {
    width: auto;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 15px;
    border-radius: 50%;
    overflow: hidden;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    -ms-border-radius: 50%;
    -o-border-radius: 50%;
}
.universities_block span {
    font-size: 20px;
    margin-right: 15px;
    line-height: 20px;
}
.logo.no_logo {
    width: 40px;
    border: 1px solid #cad6df;
}
.edit_section {
    font-size: 0;
}
.edit_section_toggle,
.custom-btns a.edit_section_toggle {
    display: none;
    width: 20px;
    height: 20px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
    background-repeat: no-repeat;
    background-position: center;
    background-size: 20px 20px;
    border: 0;
    background-color: transparent;
}

@media (min-width: 768px) {
    .fiterItem .accordion-collapse {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
}
}
@media (max-width: 1199px) {
    .alumni_profile_college_name_other_detail_wrap {
        padding: 0 0 0 50px;
    }
}

@media (max-width: 1130px) {
    .alumni_profile_brife_tab {
        overflow: auto;
        scrollbar-width: thin;
        padding-bottom: 10px;
        margin-bottom: 10px;
    }
    .alumni_profile_brife_tab::-webkit-scrollbar {
        height: 4px;
    }
    .alumni_profile_brife_tab::-moz-scrollbar {
        height: 4px;
    }
    .alumni_profile_brife_tab::-webkit-scrollbar-track {
        background: #ccc;
    }
    .alumni_profile_brife_tab::-webkit-scrollbar-thumb {
        background-color: #666;
        border-radius: 20px;
        border: 2px solid #666;
    }
    .alumni_profile_brife_tab .nav {
        justify-content: start;
        flex-wrap: nowrap;
    }
}

@media (max-width: 1099px) {
    .alumni_profile_college_name_other_detail_wrap {
        padding: 0 0 0 30px;
    }
    .alumni_profile_image_name_other_detail {
        padding: 0 30px;
        width: 45%;
    }
    .alumni_profile_college_name_other_detail_wrap .alumni_profile_college_name_other_detail {
        flex-direction: column;
    }
    .alumni_profile_college_name_detail {
        padding: 0 0 21px;
    }
    .alumni_profile_status {
        display: flex;
        -webkit-box-wrap: wrap;
        -moz-box-wrap: wrap;
        -ms-flex-wrap: wrap;
        -webkit-wrap: wrap;
        flex-wrap: wrap;
    }
    .alumni_profile_status li {
        margin-right: 16px;
    }
    .alumni_profile_name_other_detail h2 {
        line-height: 30px;
    }
    .college_name_scholarship .college_name {
        width: 100%;
        margin-bottom: 10px;
    }
}

@media (max-width: 1035px) {
    .college_name_scholarship {
        flex-direction: column;
        align-items: start;
    }
    .graduateRow .college_detail_wrap .scholarship {
        margin-top: 10px;
    }
    .graduateRow .offer {
        justify-content: start;
        padding-top: 13px;
    }
}

@media (min-width: 992px) and (max-width: 1150px) {
    .filter_result_title {
        flex-direction: column;
    }
    .alumni_count {
        text-align: right;
    }
    .alumni_class_link {
        flex-direction: column;
    }
    .alumni_class_link .send_link {
        padding: 10px 0 0 70px;
    }
}

@media (max-width: 991px) {
    .alumni-directorySearch {
        width: 230px;
    }
    .alumni_profile_name_college_other_detail_wrap {
        flex-direction: column;
    }
    .alumni_profile_image_name_other_detail {
        width: 100%;
        padding-bottom: 45px;
        margin-bottom: 45px;
    }
    .alumni_profile_image_name_other_detail::after {
        content: '';
        width: 100%;
        height: 1px;
        background: #d4d4d4;
        position: absolute;
        right: auto;
        top: auto;
        bottom: 0;
        left: 0;
    }
    .alumni_profile_college_name_other_detail_wrap {
        padding: 0;
    }
    .alumni_profile_college_name_other_detail_wrap .alumni_profile_college_name_other_detail {
        flex-direction: row;
    }
    .alumni_profile_brife_tab .nav-item:not(:last-child) {
        margin-right: 7px;
    }
    .card_profiles {
        overflow: visible;
        max-height: initial;
    }
}

@media (max-width: 950px) {
    .showProfiles_left {
        flex-direction: column;
        align-items: start;
        flex: 1 1;
    }
    .showProfiles_left h3 {
        margin: 0 0 10px;
    }
}

@media (max-width: 875px) {
    .graduateRow {
        flex-direction: column;
    }
    .graduateRow .college_detail_wrap {
        width: 100%;
    }
    .graduateRow .offer {
        width: 100%;
    }
    .college_name_scholarship {
        flex-direction: row;
        align-items: start;
    }
    .graduateRow .college_detail_wrap {
        width: 100%;
        padding: 0 0 20px;
        margin-bottom: 20px;
    }
    .graduateRow .college_detail_wrap::after {
        top: auto;
        right: 0;
        width: 75px;
        height: 2px;
        bottom: 0;
    }
    .graduateRow .offer {
        padding: 0;
        align-items: start;
    }
    .graduateRow .college_detail_wrap::after {
        right: auto;
        bottom: 0;
        left: 0;
    }
    .graduateRow.edit .college_detail_wrap {
        width: 100%;
    }
    .graduateRow .offer.offer_edit {
        flex-direction: row;
        align-items: center;
        width: 100%;
        justify-content: start;
    }
    .graduateRow .offer .offer_existing_links {
        align-items: start;
    }
}

@media (max-width: 820px) {
    .graduation_carousel_wrap {
        padding: 20px;
    }
    .graduationslider .meter {
        padding: 10px 15px;
        margin: 15px 0 10px 0px;
        font-size: 16px;
    }
    .postGraduate-detail {
        padding: 0;
        background: none;
        box-shadow: none;
        border: 1px solid #d2d2d2;
        overflow: hidden;
    }
    .postGraduate-detail .graduateRow {
        padding: 20px;
        background: #fff;
    }
    .graduation-title {
        margin: 0;
        background: #eff8ff;
        border-radius: 6px 6px 0px 0px;
        padding: 20px;
        text-align: center;
        line-height: 22px;
    }
    .graduation_carousel_wrap .seactionheader {
        margin: 0 0 15px;
        flex-direction: column;
        align-items: inherit;
    }
    .graduation_carousel_wrap .seactionheader .countnbtn {
        width: 100%;
        margin-top: 13px;
        justify-content: space-between;
    }
    .graduation_carousel_wrap .seactionheader h3 {
        width: auto;
        margin: -20px -20px 0;
        background: #eff8ff;
        border-radius: 6px 6px 0px 0px;
        padding: 20px;
        text-align: center;
        line-height: 22px;
    }
    .workExperience-detail .workExperience-title {
        width: auto;
        margin: 0;
        background: #eff8ff;
        border-radius: 6px 6px 0px 0px;
        padding: 20px;
        text-align: center;
        line-height: 22px;
    }
    .workExperience-detail {
        padding: 0px;
        overflow: hidden;
    }
    .workExperienceRow {
        padding: 25px;
    }
    .skills-block-title {
        margin: 0 0 20px;
        width: auto;
        margin: -40px -40px 20px;
        background: #eff8ff;
        border-radius: 6px 6px 0px 0px;
        padding: 20px;
        text-align: center;
        line-height: 22px;
    }
    .skills-block-title h2 {
        background: no-repeat;
        padding: 0;
        text-align: left;
    }
    .preferences-block {
        padding: 30px;
    }
    .preferences-block-title {
        width: auto;
        margin: -30px -30px 0px;
        background: #eff8ff;
        border-radius: 6px 6px 0px 0px;
        padding: 20px;
        line-height: 22px;
    }
    .custom_row:first-child {
        border: 0;
    }
    .achievements-block-title {
        background: #eff8ff;
    }
    .underGraduate-detail .main_title,
    .blockHeader {
        background: #eff8ff;
    }
    .graduateRow {
        background: #fff;
    }
    .postGraduate-detail .blockHeader {
        margin: 0;
    }
    .workExperience-detail .blockHeader {
        margin: 0;
    }
}

@media (min-width: 767px) {
    .nolisting_wrap .nolisting {
        max-width: 850px;
        margin: auto;
        border: 0;
        display: flex;
        -webkit-box-wrap: wrap;
        -moz-box-wrap: wrap;
        -ms-flex-wrap: wrap;
        -webkit-wrap: wrap;
        flex-wrap: wrap;
        text-align: left;
        padding-bottom: 10px;
    }
    .nolisting_text {
        flex: 1 1;
        display: flex;
        flex-direction: column;
        align-items: start;
    }
    .nolisting_icon {
        margin-right: 40px;
    }
}

@media (max-width: 767px) {
    .alumni_directory_filter {
        padding: 18px 0;
        padding-right: var(--bs-gutter-x, 0.75rem);
        padding-left: var(--bs-gutter-x, 0.75rem);
    }
    .alumni-directory-header_search {
        flex-direction: column;
        align-items: start;
    }
    .alumni-directory-header_search h2 {
        margin-bottom: 15px !important;
    }
    .alumni-directory-header {
        align-items: end;
    }
    .filter_result_title {
        flex-direction: column;
    }
    .filter_result_title .filter_result {
        display: none;
    }
    .alumni_count {
        text-align: right;
        margin: 0;
    }
    .alumni_directory_filter .fiterItem {
        width: 170px;
        margin: 0 !important;
        box-shadow: none;
        border: 0;
        border-radius: 0;
        border-bottom: 1px solid #e6e6e6 !important;
    }
    .alumni_directory_filter .filters {
        padding: 0;
        display: flex !important;
        flex-direction: column;
    }
    .alumni_directory_filter .filters > div:first-child {
        padding: 15px 20px;
        border-bottom: 1px solid #dbdbdb;
    }
    .alumni_directory_filter .filters-head {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .alumni_directory_filter .filters #accordionFilters {
        flex: 1 1;
        margin: 0;
        position: relative;
    }
    .alumni_directory_filter .filters #accordionFilters::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        width: 170px;
        background: #f5f5f5;
    }
    .alumni_directory_filter .filters > #accordionFilters > .filterGroup.mt-3 {
        margin: 0 !important;
        flex-direction: column;
        height: 100%;
        position: relative;
    }
    .alumni_directory_filter .fiterItem .filterHeader > div {
        border-radius: 0;
    }
    .alumni_directory_filter .fiterItem .filterHeader > div button {
        background: #f5f5f5;
        border-radius: 0;
        padding: 10px;
        color: #000;
    }
    .alumni_directory_filter .fiterItem .filterHeader > div button .toggle {
        display: none;
    }
    .alumni_directory_filter .fiterItem .filterHeader > div button .font-18.font-600 {
        font-size: 16px !important;
        font-weight: 500 !important;
    }
    .additionalfilter_wrap {
        width: 170px;
        padding: 0;
        margin: 0 !important;
    }
    .btn-additionalfilter {
        display: none !important;
    }
    .additionalfilter_wrap > #additionalfilter {
        display: block !important;
    }
    .alumni_directory_filter .fiterItem .filterHeader + div {
        position: absolute;
        right: 0;
        top: 0;
        padding: 0;
        bottom: 0;
        width: calc(100% - 170px);
        padding: 15px;
        overflow: auto;
        background: #fff;
    }
    .alumni_directory_filter .filterGroup {
        margin: 0 !important;
    }
    .alumni_directory_filter .filterGroup.mt-3 {
        margin: 0 !important;
        display: flex;
        flex-direction: column;
        height: 100%;
    }
    .filter_close_apply {
        background: #ffffff;
        border-top: 1px solid #e9e9e9;
        padding: 15px 20px;
        justify-content: center;
        align-items: center;
    }
    .filter_close_apply > a.btn-filter-apply {
        padding: 8px 30px;
        background: #5cae48;
        border-radius: 3px;
        text-decoration: none;
        color: #fff;
        margin: 0 15px;
        font-weight: 500;
        text-transform: uppercase;
        transition: all 0.3s ease-in-out;
    }
    .filter_close_apply > a.btn-filter-apply:hover {
        background: #448e32;
        color: #fff;
    }
    .filter_close_apply > a.btn-filter-close {
        text-decoration: none;
        text-transform: uppercase;
        color: #979797;
        font-weight: 500;
        transition: all 0.3s ease-in-out;
        margin: 0 15px;
    }
    .filter_close_apply > a.btn-filter-close:hover {
        color: #666262;
    }
    .alumni_directory_filter .showProfiles_right {
        margin-left: 12px;
    }
    .alumni_directory_filter .filterSearchblk {
        background: #fff;
        padding: 0 0 10px;
    }
    .alumni_directory_filter .fiterItem .card {
        padding: 0px 0px 15px;
    }
    .alumni_directory_filter .fiterItem .filterHeader > div button[aria-expanded='true'] {
        pointer-events: none;
        color: #1452ce;
    }
    .alumni_directory_filter .scrollMe {
        max-height: initial;
        min-height: initial;
    }
    .additionalfilter_count {
        display: block;
        letter-spacing: 2px;
    }
    .additionalfilter_count:before {
        content: '(';
    }
    .additionalfilter_count:after {
        content: ')';
    }
    .alumni_directory_filter .mobileFilter .btn-filter .icon-filter + span {
        flex: 1 1;
        text-align: left;
    }
    .alumni_directory_filter .mobileFilter .btn-filter .icon-filter + span + span {
        display: flex;
        -webkit-box-wrap: wrap;
        -moz-box-wrap: wrap;
        -ms-flex-wrap: wrap;
        -webkit-wrap: wrap;
        flex-wrap: wrap;
        align-items: center;
        color: #b92940;
        font-size: 14px;
    }
    .alumni_directory_filter .mobileFilter .btn-filter {
        display: flex;
        align-items: center;
    }
    .alumni_directory_filter .mobileFilter .btn-filter .icon-filter + span + span .icon-right-arrow {
        font-size: 15px;
        transform: rotate(270deg);
        margin-left: 10px;
        color: #000;
        transition: all 0.3s ease-in-out;
    }
    .alumni_directory_filter .mobileFilter .btn-filter[aria-expanded='false'] .icon-right-arrow {
        transform: rotate(90deg) !important;
    }
    #filter_collapse h3 {
        pointer-events: none;
    }
    .alumni_directory_filter {
        background: #f3f3f3;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 99;
        box-shadow: 0 0 5px 0px #cacaca;
    }
    .alumni_directory_filter .filters.show {
        transform: translate3d(0, 100%, 0);
    }
    .alumni_profile_image_name_other_detail {
        width: 100%;
        padding-bottom: 30px;
        margin-bottom: 30px;
    }
    .alumni_profile_college_name_other_detail_wrap .alumni_profile_college_name_other_detail {
        flex-direction: column;
    }
    .nolisting_wrap .nolisting {
        border: 0;
        padding: 20px 0 10px;
    }
    .nolisting_text {
        text-align: center;
        justify-content: center;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .edit_section {
        position: absolute;
        right: 20px;
        top: 5px;
    }
    .countnbtn .edit_section {
        position: relative;
        left: auto;
        right: auto;
        top: 0;
        margin-left: 5px;
    }
    .skills-block .edit_section {
        top: 22px;
    }
    .edit_section .edit_section_toggle {
        display: inline-block;
    }
    .custom-btns a.edit_section_toggle {
        display: inline-block;
    }
    .edit_section .edit_section_inner {
        position: absolute;
        top: 50px;
        right: 0;
        background: #fff;
        box-shadow: 0px 0px 5px #57555533;
        display: flex;
        flex-direction: column;
        width: 100px;
        border-radius: 6px;
        overflow: hidden;
        opacity: 0;
        z-index: -1;
        transition: all 0.3s ease-in-out;
        -webkit-transition: all 0.3s ease-in-out;
        -moz-transition: all 0.3s ease-in-out;
        -ms-transition: all 0.3s ease-in-out;
        -o-transition: all 0.3s ease-in-out;
    }
    .edit_section.open .edit_section_inner {
        top: 30px;
        opacity: 1;
        z-index: 9;
    }
    .edit_section .edit_section_inner a {
        width: 100% !important;
        border-radius: 0 !important;
        padding: 0 0 0 30px;
        font-size: 14px;
        text-decoration: none;
        color: #000;
        line-height: 33px;
        height: 35px !important;
        background: #fff !important;
        position: relative;
        opacity: 1;
        margin: 0 !important;
        -webkit-border-radius: 0 !important;
        -moz-border-radius: 0 !important;
        -ms-border-radius: 0 !important;
        -o-border-radius: 0 !important;
        opacity: 1 !important;
    }
    .edit_section .edit_section_inner a:hover {
        color: #fff;
        background-color: #0b3454 !important;
    }
    .edit_section .edit_section_inner a.edit_link:before {
        width: 16px;
        height: 16px;
        margin: 0;
        background-size: 14px;
        left: 7px;
        top: 8px;
    }
    .edit_section .edit_section_inner a:first-child {
        border-bottom: 1px solid #eee;
    }
    .edit_section .edit_section_inner a.del_link:before {
        content: '';
        background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/delete.svg) no-repeat center /
            14px auto;
        width: 14px;
        height: 16px;
        position: absolute;
        left: 8px;
        top: 8px;
    }
    .edit_section .edit_section_inner a.del_link:hover {
        background: #0b3454;
        color: #fff;
    }
    .edit_section .edit_section_inner a.del_link:hover:before {
        filter: invert(92%) sepia(100%) saturate(0%) hue-rotate(202deg) brightness(106%) contrast(106%);
        -webkit-filter: invert(92%) sepia(100%) saturate(0%) hue-rotate(202deg) brightness(106%) contrast(106%);
    }
    .graduateRow .college_detail_wrap .scholarship {
        margin-right: 60px;
    }
    .achievements-block-detail .edit_section {
        top: 4px;
        right: 0;
    }
    .achievements-block-detail {
        padding-right: 25px;
    }
    .postGraduate-detail .graduateRow .offer.offer_edit .edit_section {
        top: 20px;
    }
    .work-block .edit_section {
        right: 0;
    }
    .work-block .work-detail {
        padding-right: 24px;
    }
    .directory_wrap {
        position: fixed;
        width: 100%;
        height: 100%;
        top: 100%;
        bottom: auto;
        left: 0;
        right: 0;
        margin: auto;
        background: white;
        display: flex;
        flex-direction: column;
        transition: all 0.3s ease-in-out;
        -webkit-transition: all 0.3s ease-in-out;
        -moz-transition: all 0.3s ease-in-out;
        -ms-transition: all 0.3s ease-in-out;
        -o-transition: all 0.3s ease-in-out;
    }
    .directory_wrap.open {
        top: 0;
        bottom: 0;
    }
}

@media (min-width: 575px) and (max-width: 767px) {
    .filter_result_title {
        flex-direction: column;
    }
    .alumni_count {
        text-align: right;
    }
    .alumni_class_link {
        flex-direction: column;
    }
    .alumni_class_link .send_link {
        padding: 10px 0 0 70px;
    }
}

@media (max-width: 575px) {
    .alumni-directory-header {
        flex-direction: column;
    }
    .alumni-directory-header_search {
        flex-direction: row;
        width: 100%;
        margin-bottom: 20px;
        justify-content: space-between;
        overflow: hidden;
        align-items: center;
    }
    .alumni-directory-header_search h2 {
        margin-bottom: 0 !important;
    }
    .alumni-directorySearch-wrap {
        position: relative;
    }
    .alumni-directorySearch-wrap .alumni-directorySearch {
        position: absolute;
        right: -230px;
        transition: all 0.3s ease-in-out;
    }
    .alumni-directorySearch-wrap.show .alumni-directorySearch {
        right: 0;
    }
    .btn-alumniSearchToggle.icon-search {
        width: 40px;
        height: 40px;
        background: #fff;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        text-decoration: none;
        color: #000;
        font-size: 12px;
    }
    .alumni-directorySearch .form-control + .btn-cross {
        opacity: 1;
        right: 15px;
        transform: rotate(135deg);
    }
    .alumni-switch-container {
        margin: auto;
    }
    .alumni-directorySearch .form-control {
        padding-right: 40px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
    .alumni_profile_image_name_other_detail {
        padding: 0 0 20px;
        margin-bottom: 20px;
    }
    .alumni_profile_college_name_other_detail .alumni_profile_other_detail {
        margin: 0 0 0 -98px;
        width: calc(100% + 98px);
    }
    .alumni_profile_status li {
        width: 47%;
        margin-bottom: 0;
    }
    .alumni_profile_status li:last-child {
        margin-right: 0;
    }
    .alumni_profile_image {
        width: 80px;
        height: 80px;
    }
    .alumni_profile_name_other_detail h2 {
        line-height: 30px;
        font-size: 24px;
    }
    .alumni_profile_college_name_other_detail_wrap .alumni_profile_college_logo {
        width: 80px;
        height: 80px;
    }
    .alumni_profile_college_name_other_detail_wrap .alumni_profile_college_name_other_detail {
        flex-direction: row;
    }
    .alumni_profile_brife {
        padding: 20px 0 10px;
    }
    /*.graduateRow .college_detail_wrap .college_detail {  flex-direction: column;align-items: center;}*/
    .graduateRow .college_detail_wrap .college_detail {
        padding-right: 25px;
    }
    .graduateRow {
        margin-left: -20px;
        margin-right: -20px;
        width: auto;
        padding: 5px 20px;
    }
    .graduateRow .college_detail_wrap .college_detail .college_logo {
        margin: 0 10px 10px 0;
        width: 70px;
        height: 70px;
        border-radius: 50%;
    }
    .graduateRow .college_name_scholarship {
        flex-direction: column;
        align-items: start;
        justify-content: start;
        text-align: left;
        width: calc(100% - 80px);
    }
    .graduateRow .college_detail_wrap .college_detail h3 {
        font-size: 19px;
        line-height: 20px;
    }
    .alumni_profile_college_subject {
        padding: 0 15px;
        font-size: 15px;
        width: 100%;
    }
    .graduateRow .college_detail_wrap .scholarship {
        flex-direction: row;
    }
    .graduateRow .college_detail_wrap .scholarship .scholarship_label {
        margin-right: 7px;
    }
    .graduateRow .college_detail_wrap::after {
        right: 0;
        bottom: 0;
        left: 0;
        margin: auto;
        width: 100%;
        height: 1px;
    }
    .graduateRow .offer {
        align-items: center;
        flex-direction: row;
        justify-content: center;
    }
    .graduateRow:not(:last-child) {
        margin-bottom: 15px;
        padding-bottom: 20px;
    }
    .graduateRow .college_detail_wrap .college_detail .college_logo img[src*="no_university_img"]{width:38px}
    .underGraduate-detail {
        padding: 20px;
        box-shadow: none;
    }
    .workExperience-detail {
        padding: 0px;
    }
    .workExperienceRow {
        padding: 20px 20px 30px;
    }
    .achievements-block {
        flex-direction: column;
    }
    .achievements-icon-block {
        border-right: 0;
        margin: 0 0 18px;
        padding: 0 0 18px;
        border-bottom: 1px solid #cecece;
    }
    .achievements-block-detail {
        text-align: center;
    }
    .achievements-block-detail h3 {
        margin: 0;
    }
    .contributions-block .seactionheader {
        margin: 0px 0 20px;
        flex-direction: column;
        align-items: inherit;
    }
    .contributions-block .seactionheader > h3 {
        width: auto;
        margin: -20px -20px 0;
        background: #eff8ff;
        border-radius: 6px 6px 0px 0px;
        padding: 20px;
        text-align: center;
        line-height: 22px;
    }
    .contributions-block .seactionheader .countnbtn {
        width: 100%;
        margin-top: 10px;
        align-items: center;
        justify-content: space-between;
        position: relative;
    }
    .contributions-block .seactionheader .countnbtn .custom-btns {
        padding-right: 0;
    }
    .contributions-block .seactionheader .countnbtn .custom-btns .edit_section {
        right: 0;
        top: 0px;
    }
    .contributions-block {
        padding: 20px;
    }
    .skills-block {
        padding: 20px;
    }
    .skills-block:first-child {
        padding-bottom: 5px;
    }
    .skills-block.EntranceExam-skills-block {
        padding-bottom: 25px;
    }
    .skills-block h2 {
        margin: 0 0 20px;
        width: auto;
        margin: -20px -20px 20px;
        background: #eff8ff;
        border-radius: 6px 6px 0px 0px;
        padding: 20px;
        text-align: center;
        line-height: 22px;
    }
    .skills-block-detail .meter {
        font-size: 18px;
        align-items: center;
        padding: 10px 20px;
        line-height: 18px;
    }
    .card_profiles figure.student {
        position: absolute;
        left: 15px;
        top: 15px;
    }
    .card_profiles .student_details h2 {
        margin: 0 0 10px 90px;
    }
    .card_profiles .btn-send {
        position: static;
        margin-left: 90px;
    }
    .card_profiles .student_details .sub_details {
        margin-top: 15px;
    }
    .card_profiles .student_details .sub_details span.course {
        line-height: 15px;
    }
    .contributions-block .act_lst {
        padding: 15px;
    }
    .contributions-block .act_lst .postedtxt {
        text-align: left;
        position: absolute;
        top: 15px;
        white-space: nowrap;
        right: 15px;
    }
    .graduateRow .offer > a {
        margin: 0 10px 0 0;
    }
    .graduateRow .offer div.got_offer {
        margin-right: 10px;
        width: 50%;
        align-items: center;
        display: flex;
        margin-bottom: 0 !important;
        text-align: left;
        flex: none;
        justify-content: center;
        line-height: 18px;
    }
    .graduateRow .offer .offer_joined {
        align-items: start;
        width: 50%;
        align-items: center;
        display: flex;
        margin-bottom: 0 !important;
        line-height: 16px;
    }
    .graduateRow .offer .offer_joined:only-child {
        width: auto;
    }
    .graduateRow .offer .offer_joined i {
        margin-right: 8px;
    }
    .contributions-block .act_lst > .row > div:last-child .btn-green {
        width: 135px;
    }
    .contributions-block .act_lst .btn-dark-blue {
        width: 135px;
    }
    .contributions-block .listblk_icon {
        margin-bottom: 0;
        width: 34px;
        height: 34px;
    }
    .contributions-block .act_lst .postedrow > div:last-child {
        width: 100% !important;
        display: flex;
        flex-direction: row-reverse;
        align-items: center;
        border-top: 1px solid #d1d1d1;
        padding-top: 10px;
        margin-top: 8px;
    }
    .act_lst > .row.postedrow > div:last-child > div:first-child {
        width: calc(100% - 190px);
        margin: 0 0 0 15px;
        align-items: center;
    }
    .alumni_class_link {
        align-items: center;
    }
    .filter_result_title {
        margin-bottom: 12px;
    }
    .contributions-block .album_shareblk {
        padding: 5px 0 0 0px;
    }
    .profile-item,
    .psychology-item {
        width: 100%;
        border: 0 !important;
    }
    .skills-block-title {
        margin: 0 0 20px;
        width: auto;
        margin: -20px -20px 20px;
        background: #eff8ff;
        border-radius: 6px 6px 0px 0px;
        padding: 20px;
        text-align: center;
        line-height: 22px;
    }
    .skills-block-title h2 {
        padding: 0;
        text-align: left;
    }
    #edit_Higher_Education .question {
        padding-right: 20px;
    }
    #job_Preferences .question {
        padding-right: 20px;
    }
    .underGraduate-detail .main_title,
    .blockHeader {
        margin: -20px -20px 30px;
        padding: 20px;
    }
    .graduateRow .offer .offer_existing_links {
        width: 100%;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }
    .graduateRow .offer .got_offer {
        margin-right: 10px;
    }
    .graduateRow .offer a.joindeLink {
        margin: 0 10px 0 0;
    }
    .powerby {
        margin: auto;
    }
    .graduateRow .offer.offer_edit .edit_section {
        top: 10px;
    }
    .postGraduate-detail .graduateRow {
        margin: 0;
    }
    .alumni_profile_college_name_detail {
        width: 100%;
    }
}

@media (max-width: 480px) {
    .card_profiles.card_profiles_pg > div {
        flex-direction: column;
        display: flex;
    }
}

@media (max-width: 400px) {
    .graduateRow .offer.offer_edit {
        flex-direction: column;
        align-items: start;
    }
    .graduateRow .offer.offer_edit .edit_section {
        margin: 0;
    }
}
input[type='search']::-webkit-search-decoration,
input[type='search']::-webkit-search-cancel-button,
input[type='search']::-webkit-search-results-button,
input[type='search']::-webkit-search-results-decoration {
    appearance: none;
    -webkit-appearance: none;
}
header + .relevantAlumniMatch {
    display: none;
}
.relevantAlumniMatch {
    background: transparent linear-gradient(93deg, #fff7f8 0%, #ffe6ea 100%);
    box-shadow: 0px 10px 20px #ffebee;
    border: 1px solid #fdd3da;
    border-radius: 8px;
    padding: 15px 20px;
    margin-bottom: 20px;
    position: relative;
}
.relevantAlumniMatch p {
    font-size: 20px;
    margin: 0;
    font-weight: 500;
    line-height: 22px;
}
.relevantAlumniMatch .btn-complete-now {
    border: 1px solid #d42941;
    border-radius: 25px;
    width: 160px;
    height: 40px;
    background: #fff;
    color: #000;
    font-size: 16px;
    line-height: 16px;
    font-weight: 500;
    margin-right: 23px;
    transition: all 0.3s ease-in-out;
}
.relevantAlumniMatch .btn-complete-now:before {
    display: none;
}
.relevantAlumniMatch .btn-complete-now:hover {
    background: #d42941;
    color: #fff;
}
.relevantAlumniMatch .btn-close {
    font-size: 10px;
}

@media (max-width: 767px) {
    .relevantAlumniMatch .btn-close {
        font-size: 10px;
        position: absolute;
        top: 13px;
        right: 10px;
    }
}
.pencil-edit {
    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/draw.svg);
    background-repeat: no-repeat;
    background-position: center;
    background-size: 17px;
    width: 17px;
    height: 17px;
    display: inline-block;
}
.alumni_profile_image_name_other_detail .pencil-edit {
    position: absolute;
    right: 30px;
    top: 10px;
}
.verifynow {
    border: 2px solid #d52941;
    padding: 2px 14px;
    border-radius: 25px;
    text-decoration: none;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.3s ease-in-out;
    height: 30px;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    -webkit-border-radius: 25px;
    -moz-border-radius: 25px;
    -ms-border-radius: 25px;
    -o-border-radius: 25px;
}
.verifynow:hover {
    background: #d52941;
    color: #fff;
}
.alumni_profile_image_name_other_detail .btnverified {
    background: #5cae48;
    border: 0;
    padding: 0 22px;
    width: auto;
    font-size: 14px;
}
.alumni_profile_image_name_other_detail .btnverified:hover {
    background: #439130;
    color: #fff;
}
.alumni_profile_image_name_other_detail .btnverified:hover .icon-varified {
    color: #fff !important;
}
.btn-back-dismiss {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
    background-repeat: no-repeat;
    background-position: center;
    background-size: 50px 32px;
    width: 20px;
    height: 15px;
    margin: 5px 5px 0 0px;
}
#delete_confirm_pop {
    z-index: 9999;
}
.modal.show ~ .modal.show ~ .modal-backdrop {
    z-index: 9998;
    opacity: 0.7;
}

/* css 11042023 */
.landing_login_page .carousel button {
    background: no-repeat;
}
.landing_login_page .carousel button span {
    filter: invert(1);
    -webkit-filter: invert(1);
}
.landing_login_page #myloginTab {
    border: 0;
    display: flex;
    justify-content: center;
    max-width: 496px;
    width: 90%;
}
.landing_login_page #myloginTab .nav-item button {
    line-height: 70px;
    width: 100%;
    background: none;
    border: 0;
    color: rgba(255, 255, 255, 0.5);
    border-bottom: 2px solid #375973;
}
.landing_login_page #myloginTab .nav-item {
    max-width: 200px;
    width: 100%;
}
.landing_login_page #myloginTab .nav-item button.active {
    color: #fff;
    border-color: #5cae48;
}
.landing_login_page #myloginTabContent {
    max-width: 496px;
    width: 90%;
    margin: 0 auto;
}
.landing_login_page .form-control {
    min-height: 40px;
    border: none;
    border-radius: 6px;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    -ms-border-radius: 6px;
    -o-border-radius: 6px;
    font-weight: 500;
    color: #000;
    font-size: 16px;
    z-index: 1;
    position: relative;
}
.landing_login_page .action_btns {
    padding: 0;
    margin: 0;
    background: none;
}
.landing_login_page .action_btns .btn-login,
.btn-setPassWord {
    background: #5cae48;
    color: #fff;
    border-color: #5cae48;
    max-width: 200px;
    width: 100%;
    border-radius: 25px;
    -webkit-border-radius: 25px;
    -moz-border-radius: 25px;
    -ms-border-radius: 25px;
    -o-border-radius: 25px;
}
.landing_login_page .action_btns .btn-login:hover,
.btn-setPassWord:hover {
    background: #88bb1b;
    color: #fff;
    border-color: #88bb1b;
}
.landing_login_page .carousel-indicators button {
    border: 0;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #333 !important;
    opacity: 0.5;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    -ms-border-radius: 50%;
    -o-border-radius: 50%;
}
.landing_login_page .carousel-indicators button.active {
    opacity: 1;
}
.landing_login_page .form-select {
    border-radius: 6px;
}
.form-select#mobileCountryCode {
    width: 125px;
    height: 45px;
    font-size: 16px;
    font-weight: 500;
}
.footer {
    position: relative;
    bottom: 0;
    width: 100%;
    height: 60px;
}
.headerRightSide > ul li .user_id {
    position: static;
    border-radius: 5px 5px 0 0;
    width: 100%;
    padding: 7px 15px;
    text-align: right;
    background: #eee;
    color: #000;
}
.headerRightSide span.userimg {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
}
.headerRightSide span.userimg img {
    width: auto;
    height: 100%;
}
.headerRightSide span.userimg.icon-user-invert img {
    display: none;
}
.username:hover div.user-dropdown::before {
    width: 0;
    height: 0;
    content: '';
    position: absolute;
    top: -5px;
    right: 10px;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid #d2d2d2;
}
.newmsg > .containerinnercover {
    width: calc(100% - 320px);
}
.containerinnercover div.css-13cymwt-control {
    height: auto !important;
    border: 1px solid #eaeaea !important;
}
.containerinnercover div.css-1fdsijx-ValueContainer {
    height: auto !important;
    border: 1px solid #eaeaea;
    border-radius: 5px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    -ms-border-radius: 5px;
    -o-border-radius: 5px;
}
.containerinnercover div.css-b62m3t-container {
    height: auto !important;
    border: 1px solid #eaeaea;
}
.containerinnercover .css-b62m3t-container .css-t3ipsp-control {
    height: auto !important;
}
.containerinnercover div.css-1p3m7a8-multiValue {
    background: #f7f7f7;
    border-radius: 5px;
}
.containerinnercover .university_ttl img {
    width: 40px;
}
.containerinnercover .university_ttl {
    width: inherit;
    max-width: inherit;
    padding: 5px 10px;
    border-radius: 3px;
}
.containerinnercover .css-qbdosj-Input {
    min-height: 45px;
}
.containerinnercover div[class*='-placeholder'] {
    padding-left: 15px;
}
.containerinnercover.singleOption div[class*='-singleValue'] {
    padding-left: 15px;
}
.containerinnercover.singleOption div[data-value] {
    padding-left: 15px;
}
.containerinnercover.singleOption div[data-value] input {
    min-height: 50px;
}
.student_profile {
    position: relative;
}
.student_profile .pencil-edit {
    position: absolute;
    top: 12px;
    right: 0;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.student_profile .pencil-edit:hover {
    opacity: 1;
}
.student_profile .alumni_profile_image_name_other_detail:after {
    opacity: 0;
}
.student_profile .alumni_profile_class_college::before {
    background: #f8b018;
    left: 0;
}
.student_profile .alumni_profile_image_name_other_detail {
    width: 100%;
}
.student_profile_details {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    align-items: start;
}
.student_profile_details .alumni_profile_class_college {
    margin-right: 70px;
    padding-left: 17px;
    margin-bottom: 25px;
}
.student_profile_details .verifiedLink {
    margin-left: 20px;
}
.student_profile .school_other_details {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    list-style: none;
    margin: 0;
    padding: 0;
}
.student_profile .school_other_details li {
    display: flex;
    flex-direction: column;
    position: relative;
    padding-left: 10px;
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 10px;
}
.student_profile .school_other_details li:not(:last-child) {
    margin-right: 70px;
}
.student_profile .school_other_details li:before {
    content: '';
    position: absolute;
    left: 0;
    top: 3px;
    bottom: 0;
    width: 3px;
    height: 17px;
    background: #f8b018;
    border-radius: 5px;
}
.alumni_profile_name_other_detail .btn-send {
    width: auto;
    height: 40px;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    background: #5cae48;
    border-radius: 25pc;
    color: #fff;
    text-decoration: none;
    align-items: center;
    padding: 0 25px;
    font-size: 16px;
    font-weight: 500;
    transition: all 0.3s ease-in-out;
}
.alumni_profile_name_other_detail .btn-send .icon-send {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/send_alumni_profile.svg) no-repeat 0
        0 / 100%;
    width: 19px;
    height: 19px;
    margin-right: 10px;
    position: relative;
    transition: all 0.3s ease-in-out;
    left: 0;
}
.alumni_profile_name_other_detail .btn-send:hover {
    background: #2fa612;
}
.alumni_profile_name_other_detail .btn-send:hover .icon-send {
    left: 3px;
}
.edit-profile-image .imgUpload {
    position: absolute;
    top: -100px;
    left: 0;
    right: 0;
    margin: auto;
    width: 90px;
    height: 30px;
    background: #0b3454;
    border-radius: 3px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.5 ease-in-out;
    -webkit-transition: all 0.5s ease-in-out;
    -moz-transition: all 0.5s ease-in-out;
    -ms-transition: all 0.5s ease-in-out;
    -o-transition: all 0.5s ease-in-out;
}
.edit-profile-image .imgUpload i {
    margin-left: 5px;
}
.edit-profile-image:hover span.imgUpload {
    top: 40px;
}

/*tab 31032023*/
.tab-white-block {
    box-shadow: 0px 10px 25px #00000008;
    border-radius: 6px;
    background: #fff;
    padding: 44px;
    position: relative;
}
.customRow:not(:last-child) {
    margin-bottom: 30px;
    padding-bottom: 30px;
    border-bottom: 1px solid #dbdbdb;
}
.customRow-header {
    display: flex;
    align-items: center;
}
.customRow-header .icon {
    width: 47px;
    height: 47px;
    border-radius: 50%;
    background-color: #f8b018;
    margin-right: 10px;
}
.customRow-header .icon:before {
    display: none;
}
.icon.icon-book {
    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/open-book.svg);
    background-position: center;
    background-repeat: no-repeat;
}
.icon.icon-book-white {
    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/open-book-white.svg);
    background-position: center;
    background-repeat: no-repeat;
}
.icon.icon-global {
    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/world.svg);
    background-position: center;
    background-repeat: no-repeat;
}
.icon.icon-university-college {
    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/college.svg);
    background-position: center;
    background-repeat: no-repeat;
}
.icon.icon-book {
    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/open-book.svg);
    background-position: center;
    background-repeat: no-repeat;
}
.icon.icon-global {
    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/world.svg);
    background-position: center;
    background-repeat: no-repeat;
}
.icon.icon-father {
    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/father.svg);
    background-position: center;
    background-repeat: no-repeat;
}
.icon.icon-mother {
    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/mother.svg);
    background-position: center;
    background-repeat: no-repeat;
}
.icon.icon-guardian {
    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/guardian.svg);
    background-position: center;
    background-repeat: no-repeat;
}
.icon.icon-college {
    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/edu-college.svg);
    background-position: center;
    background-repeat: no-repeat;
}
.icon.icon-school {
    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/school-bag.svg);
    background-position: center;
    background-repeat: no-repeat;
}
.icon.icon-exam-note {
    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/exam-note.svg);
    background-position: center;
    background-repeat: no-repeat;
}
.icon.icon-aboutMe {
    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/about-me.svg);
    background-position: center;
    background-repeat: no-repeat;
}
.icon.icon-achievements {
    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/trophy.svg);
    background-position: center;
    background-repeat: no-repeat;
}
.icon.icon-books {
    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/book.svg);
    background-position: center;
    background-repeat: no-repeat;
}
.icon.icon-activities {
    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/target.svg);
    background-position: center;
    background-repeat: no-repeat;
}
.customRow-detail {
    padding: 0 0 0 58px;
}
.tab-white-block .pencil-edit {
    background-color: #bee0fb;
    width: 37px;
    height: 37px;
    border-radius: 19px;
    opacity: 0.5;
    position: absolute;
    top: 20px;
    right: 20px;
    transition: all 0.5s ease-in-out;
    -webkit-transition: all 0.5s ease-in-out;
    -moz-transition: all 0.5s ease-in-out;
    -ms-transition: all 0.5s ease-in-out;
    -o-transition: all 0.5s ease-in-out;
}
.tab-white-block .pencil-edit:hover {
    opacity: 1;
}
.curriculars-item {
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 10px 25px #00000008;
    border-radius: 6px;
    position: relative;
}
.curriculars-item:not(:last-child) {
    margin-bottom: 10px;
}
.curriculars-header .customRow-header {
    padding: 20px 20px 20px 40px;
    cursor: pointer;
    transition: all 0.5s ease-in-out;
    -webkit-transition: all 0.5s ease-in-out;
    -moz-transition: all 0.5s ease-in-out;
    -ms-transition: all 0.5s ease-in-out;
    -o-transition: all 0.5s ease-in-out;
}
.customRow-header-title {
    width: calc(100% - 110px);
}
.curriculars-body {
    padding: 0px 20px 20px 40px;
}
.curriculars-header .customRow-header[aria-expanded='true'] {
    padding-bottom: 10px;
}
.curriculars-header .pencil-edit {
    background-color: #bee0fb;
    width: 37px;
    height: 37px;
    border-radius: 19px;
    opacity: 0.5;
    position: absolute;
    top: 25px;
    right: 60px;
    transition: all 0.5s ease-in-out;
    -webkit-transition: all 0.5s ease-in-out;
    -moz-transition: all 0.5s ease-in-out;
    -ms-transition: all 0.5s ease-in-out;
    -o-transition: all 0.5s ease-in-out;
}
.curriculars-header .pencil-edit:hover {
    opacity: 1;
}
tr:nth-child(even) {
    background: #f1f1f170;
}
.curriculars_table th div {
    padding: 8px 20px;
    background-color: #f1f1f1;
    font-size: 16px;
    font-weight: 400;
}
.curriculars_table thead th:first-child div {
    border-radius: 5px 0px 0px 5px;
}
.curriculars_table thead th:last-child div {
    border-radius: 0px 5px 5px 0px;
}
.curriculars_table tbody th {
    padding: 20px;
    font-size: 18px;
    font-weight: 500;
}
.curriculars_table td {
    padding: 20px;
}
.curriculars-header .customRow-header i {
    position: absolute;
    width: 16px;
    height: 16px;
    right: 30px;
    top: 36px;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.curriculars-header .customRow-header[aria-expanded='true'] i:before {
    transform: rotate(90deg);
    -webkit-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    -o-transform: rotate(90deg);
}
.curriculars-header .customRow-header i:before {
    content: '';
    width: 2px;
    height: 16px;
    background: #0d4466;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    margin: auto;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.curriculars-header .customRow-header i:after {
    content: '';
    width: 16px;
    height: 2px;
    background: #0d4466;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    margin: auto;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.book-wrap {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
}
.book-wrap .book-detial {
    width: calc(100% - 80px);
    margin-left: 15px;
}
.book-wrap .book-img img {
    box-shadow: 0 0 3px 1px #ccc;
}
.lineHeight-26 {
    line-height: 26px;
}

@media (max-width: 767px) {
    .newmsg > .containerinnercover {
        width: 100%;
    }
}

@media (max-width: 575px) {
    .tab-white-block {
        padding: 24px;
    }
    .curriculars-header .customRow-header {
        padding: 24px 20px 24px 24px;
    }
    .curriculars-body {
        padding: 0px 20px 20px 24px;
    }
    .curriculars-body .customRow-detail {
        padding: 0;
    }
    .curriculars-header .pencil-edit {
        top: 25px;
    }
    .curriculars-header .customRow-header i {
        top: 35px;
    }
}

header .search .form-inline {
    border-radius: 20px;
    border: 1px solid #f1f1f1;
}
header .search .form-inline .css-b62m3t-container {
    border-radius: 20px;
}
header .search .form-inline .css-b62m3t-container .css-13cymwt-control {
    border-radius: 20px;
}
header .search .form-inline .css-b62m3t-container .css-t3ipsp-control {
    border-radius: 20px;
}
header .search .form-inline .css-b62m3t-container input {
    padding: 0 15px !important;
    font-size: 16px !important;
}
header .search .form-inline .css-b62m3t-container .css-1jqq78o-placeholder {
    padding: 0 15px;
    font-size: 16px;
}
header .search .form-inline .css-t3ipsp-control .css-1jqq78o-placeholder {
    display: none;
}
header .search .form-inline .css-b62m3t-container .css-qbdosj-Input,
header .search .form-inline .css-b62m3t-container .css-166bipr-Input {
    display: flex !important;
}
header .search .form-inline div * {
    display: block;
    line-height: 40px;
}
header .search .form-inline div[aria-hidden='true'] {
    display: none;
}
header .search .form-inline div.css-t3ipsp-control > div {
    margin: 0;
    padding: 0;
}
header .search .form-inline div[class*='-control'] > div {
    padding: 0;
}
header .search .form-inline div[data-value] {
    margin: 0;
    padding: 0;
}
header .search .form-inline #react-select-2-placeholder {
    line-height: 43px;
}
header .search .form-inline .css-t3ipsp-control #react-select-2-placeholder {
    display: none;
}
header .search .form-inline .css-t3ipsp-control input {
    height: 45px;
}
.lstCustForm .css-b62m3t-container {
    border-radius: 5px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    -ms-border-radius: 5px;
    -o-border-radius: 5px;
}
.lstCustForm .select__value-container {
    -webkit-box-flex-wrap: nowrap;
    flex-wrap: nowrap;
}
.lstCustForm .css-b62m3t-container .css-13cymwt-control {
    border-radius: 5px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    -ms-border-radius: 5px;
    -o-border-radius: 5px;
    border: 1px solid #848484 !important;
}
.lstCustForm .css-b62m3t-container .css-t3ipsp-control {
    border-radius: 5px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    -ms-border-radius: 5px;
    -o-border-radius: 5px;
    border: 1px solid #848484 !important;
}

.lstCustForm div[class*='-singleValue']{margin-left: 20px;}

.lstCustForm .css-b62m3t-container input {
    padding: 0 15px !important;
    font-size: 16px !important;
}
.lstCustForm .css-b62m3t-container .css-1jqq78o-placeholder {
    padding: 0 15px;
    font-size: 16px;
}
.lstCustForm .css-b62m3t-container .css-qbdosj-Input,
.lstCustForm .css-b62m3t-container div[data-value] {
    display: flex !important;
}
.lstCustForm .css-b62m3t-container .css-qbdosj-Input,
.lstCustForm .css-b62m3t-container .css-166bipr-Input {
    display: flex !important;
}
.lstCustForm .css-b62m3t-container div[data-value] {
    display: flex;
}
.attendee_dtl .table thead th {
    background: #f1f1f1;
    font-size: 14px;
    font-weight: 500;
    height: 40px;
    border: 0;
}
.attendee_dtl .table thead th:first-child {
    border-radius: 6px 0 0 6px;
}
.attendee_dtl .table thead th:last-child {
    border-radius: 0 6px 6px 0;
}
.table-responsive.attendee_dtl table td:first-child,
.table-responsive.attendee_dtl > table th:first-child {
    padding-left: 20px;
}
.table-responsive.attendee_dtl table td {
    padding-top: 15px;
    padding-bottom: 15px;
    font-size: 14px;
    font-weight: 500;
    vertical-align: middle;
}
.table-responsive.attendee_dtl table .btn {
    line-height: 15px;
    display: flex;
    align-items: center;
    padding: 0 20px !important;
    margin: 0 5px 0 0;
}
.table-responsive.attendee_dtl table td.active {
    width: 315px;
}
.table-responsive.attendee_dtl table td.engagement {
    width: 245px;
}
.table-responsive.attendee_dtl > table .university-name {
    width: 175px;
}
.table-responsive.attendee_dtl > table td.sentDeliveredOpened {
    width: 365px;
}
.table-responsive.attendee_dtl a.tablink {
    color: #0b3454;
    display: flex;
    align-items: center;
    text-decoration: none;
    line-height: 18px;
}
.table-responsive.attendee_dtl a.tablink:hover {
    color: #4c4f51;
}
.table-responsive.attendee_dtl a.btn-gray-border:hover {
    color: #fff;
}
.table-responsive.attendee_dtl > table td.deliveryStatus {
    width: 205px;
}
.table_cus_badge {
    background: #fef7e8;
    border-radius: 20px;
    height: 36px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: #000;
    font-weight: 500;
    padding: 0 15px;
    margin: 3px;
    min-width: 65px;
}
.tab-ul {
    padding: 0;
    line-height: 22px;
    list-style: none;
    margin: 0 13px 0 0;
}
.attendee_dtl input[type='checkbox'] {
    width: 18px;
    height: 18px;
    display: inline-block;
}
.aldir_scroll {
    width: 100%;
    overflow-x: auto;
    scrollbar-width: thin;
    scrollbar-color: #fb9aa7 #780011;
    padding: 0;
}
.aldir_scroll::-webkit-scrollbar {
    height: 4px;
}
.aldir_scroll::-moz-scrollbar {
    height: 4px;
}
.aldir_scroll::-webkit-scrollbar-track {
    background: #780011 !important;
}
.aldir_scroll::-webkit-scrollbar-thumb {
    background-color: #fb9aa7;
    border-radius: 20px;
    border: 1px solid #780011 !important;
    -webkit-border-radius: 20px;
    -moz-border-radius: 20px;
    -ms-border-radius: 20px;
    -o-border-radius: 20px;
}
.css-1n6sfyn-MenuList::-webkit-scrollbar {
    width: 4px;
}
.css-1n6sfyn-MenuList::-moz-scrollbar {
    width: 4px;
}
.css-1n6sfyn-MenuList::-webkit-scrollbar-track {
    background: #ccc !important;
}
.css-1n6sfyn-MenuList::-webkit-scrollbar-thumb {
    background-color: #fff;
    border-radius: 20px;
    border: 1px solid #ccc !important;
    -webkit-border-radius: 20px;
    -moz-border-radius: 20px;
    -ms-border-radius: 20px;
    -o-border-radius: 20px;
}
.fitergroup .show .accordion-body {
    border-radius: 0 6px 6px 6px;
}
.fitergroup .accordion-body {
    background: #f1f1f1;
    border-radius: 6px;
}
.fitergroup .form-select {
    height: 45px;
}
.btn-grpfiter {
    border: 0px solid #e1e1e1;
    border-radius: 20px;
    height: 40px;
    padding: 0 25px;
    font-size: 14px;
    font-weight: 500;
    background: #f1f1f1;
    position: relative;
}
.btn-grpfiter[aria-expanded='true'] {
    border-radius: 20px 20px 0 0;
    transition: all 0.3s ease-in-out;
}
.btn-grpfiter::before {
    content: '';
    position: absolute;
    bottom: -20px;
    left: 0;
    right: 0;
    background: #f1f1f1;
    height: 10px;
    transition: all 0.3s ease-in-out;
    opacity: 0;
}
.btn-grpfiter[aria-expanded='true']::before {
    bottom: -10px;
    opacity: 1;
}
/* .btn-grpfiter ~ div .form-control {max-height: 38px;background-size: 14px;background-repeat: no-repeat;background-position: 13px center;padding-left: 34px;height: 40px;border-radius: 25px;-webkit-border-radius: 25px;-moz-border-radius: 25px;-ms-border-radius: 25px;-o-border-radius: 25px;} */
.btn-grpfiter ~ div .form-control {
    border-color: #dee2c6;
}
/* background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/search.svg); */

@media (max-width: 480px) {
    .vertical-input-group {
        flex-direction: column;
    }
    .vertical-input-group.input-group .form-select,
    .vertical-input-group .form-control {
        width: 100%;
    }
    .vertical-input-group.input-group
        > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
        margin-left: 0px;
        margin-top: -1px;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }
    .vertical-input-group.has-validation.input-group > .dropdown-toggle:nth-last-child(n + 4),
    .vertical-input-group.has-validation > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu) {
        border-top-right-radius: 6px;
        border-bottom-right-radius: 0;
        border-top-left-radius: 6px;
        border-bottom-left-radius: 0;
    }
    .vertical-input-group.has-validation.input-group > .form-select:nth-last-child(2) {
        border-top-right-radius: 0;
        border-bottom-right-radius: 6px !important;
        border-top-left-radius: 0;
        border-bottom-left-radius: 6px !important;
    }
}
.custom-input-group[style*='grid'] {
    border: 1px solid #cccccc;
    border-radius: 6px;
    display: flex !important;
    height: auto !important;
}
.custom-input-group[style*='grid'] .basic-multi-select{height: auto !important;min-height: 43px;}
.custom-input-group[style*='grid'] .border {
    border: 0 !important;
    border-radius: 5px 0px 0 5px;
}
.custom-input-group[style*='grid'] .css-nozp1o-control {
    border: none !important;
    height: 43px;
    border-radius: 0 5px 5px 0;
    overflow: visible;
}
.custom-input-group[style*='grid'] .select__control{height: auto;padding: 5px;}
.custom-input-group[style*='grid'] .css-oorrsa-IndicatorsContainer{height: auto;}
.custom-input-group[style*='grid'] .select__indicators{height: auto;}

select#rangeOption ~ .form-control[type*='date'] {
    background-image: none;
}
.modal-dialog .modal-content .modal-header .btn-close {
    background-color: none;
    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/close.svg);
    width: 15px;
    padding: 0;
    font-size: 12px;
    margin-right: 10px;
    color: #000000;
    opacity: 2;
}
.modal-dialog .modal-content .modal-header .btn-close::before {
    display: none;
}
.top20 {
    top: 20px;
}
.top40 {
    top: 40px;
}
.right20 {
    right: 20px;
}
.z1 {
    z-index: 1;
}
.z2 {
    z-index: 2;
}
.z3 {
    z-index: 3;
}
.z4 {
    z-index: 4;
}
.z5 {
    z-index: 5;
}
.z6 {
    z-index: 6;
}
.z7 {
    z-index: 7;
}
.z8 {
    z-index: 8;
}
.z9 {
    z-index: 9;
}
.radius-20 {
    border-radius: 20px;
    -webkit-border-radius: 20px;
    -moz-border-radius: 20px;
    -ms-border-radius: 20px;
    -o-border-radius: 20px;
}
.radius-15 {
    border-radius: 15px;
    -webkit-border-radius: 15px;
    -moz-border-radius: 15px;
    -ms-border-radius: 15px;
    -o-border-radius: 15px;
}
.radius-10 {
    border-radius: 10px;
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    -ms-border-radius: 10px;
    -o-border-radius: 10px;
}
.radius-5 {
    border-radius: 5px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    -ms-border-radius: 5px;
    -o-border-radius: 5px;
}
/* Alumni Dashboard End */

.tooltip .tooltip-inner {
    background-color: #5a6268;
    color: #fff;
    font-size: 16px;
    padding: 10px;
}
.tooltip .tooltip-arrow {
    border-color: #5a6268;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
input[type='number'] {
    -moz-appearance: textfield;
}
.social-block {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    border-radius: 6px;
    height: 48px;
    padding: 0 20px;
    line-height: 38px;
    font-size: 18px;
    font-weight: 600;
    color: #fff;
    cursor: pointer;
}
form.lstCustForm label.social-block span {
    color: #fff;
    font-style: normal;
    font-size: 18px;
    font-weight: 600;
    color: #fff;
    padding-left: 0;
}
.social-block.fb {
    background: #3456a2;
}
.social-block.tw {
    background: #00a1f9;
}
.social-block.linkedin {
    background: #0077b5;
}
.social-block.fb img {
    margin-top: -4px;
}
.social-check label {
    width: 24px;
    height: 24px;
    background: rgba(0, 0, 0, 0.3);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0px;
    color: #fff;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
}
.social-check input:checked + label {
    background: #5cae48;
    border-color: #5cae48;
    font-size: 11px;
}
.toggle-switch-parent {
    width: 380px;
    margin-right: 30px;
}
.masRow {
    display: flex;
    flex-wrap: wrap;
}
.masRow:not(:last-child) {
    margin-bottom: 20px;
}
.form-check-input-parent {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    flex: 1 1;
}
.form-check-input-parent .form-control {
    max-width: 80px;
    width: 80px;
}
.form-check-input-parent .btn-customize:not(:checked) ~ .form-control {
    background-color: #f2f2f2 !important;
    border-color: #dfdfdf !important;
    pointer-events: none;
}
.socialist-label {
    font-size: 20px;
    font-weight: 500;
    flex: 1 1;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    line-height: 22px;
}
.socialist-block {
    background: #f3f3f3;
    border-radius: 6px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 5px 20px;
    height: 40px;
    width: 320px;
}
.sociallist-detail ul {
    display: flex;
    align-items: center;
    list-style: none;
    font-size: 14px;
    padding: 0;
    margin: 0;
}
.sociallist-detail ul li {
    position: relative;
}
.sociallist-detail ul li:not(:first-child):before {
    content: '';
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: #000;
    position: absolute;
    margin: auto;
    opacity: 0.3;
    top: 0;
    bottom: 0;
    left: -3px;
}
.sociallist-detail ul li:not(:first-child) {
    padding: 0 0 0 15px;
    margin: 0 0 0 15px;
}
.socialist {
    padding: 20px;
    border: 1px solid #eee;
    border-radius: 6px;
}
.socialist:not(:last-child) {
    margin-bottom: 10px;
}
.postdetail {
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
}
.postdetail .poston {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    font-size: 13px;
    opacity: 0.8;
    line-height: 17px;
}
.text-gray-68 {
    color: #686868;
}
.row_parent {
    padding: 15px 35px 20px !important;
    margin: -20px -25px 20px !important;
}
.row_parent:nth-child(even) {
    background: #f2f6fa;
}
.row_parent:last-child {
    margin-bottom: -25px !important;
}
form.lstCustForm .form-select,
form.lstCustForm input.form-control {
    border: 1px solid #848484;
    height: 45px;
}
form.lstCustForm textarea.form-control {
    border: 1px solid #848484;
}
form.lstCustForm .form-check .form-check-input {
    width: 24px;
    height: 24px;
    margin-left: 0px;
    border: 2px solid #848484;
}
form.lstCustForm .form-check:not(:last-child) {
    margin: 0 40px 5px 0;
}
form.lstCustForm .btn-greenm,
.btn-greenm252 {
    min-width: 252px;
}
form.lstCustForm label span {
    font-size: 14px;
    color: #848484;
    font-weight: 400;
    font-style: italic;
    float: right;
    display: inline-block;
    padding: 0 0 0 20px;
}
form.lstCustForm .inputfile_parent label span.uploadlabel {
    font-size: 16px;
    color: #414141;
    font-weight: 400;
    float: right;
    display: inline-block;
    padding: 0 0 0 8px;
    font-style: normal;
}
form.lstCustForm label span.icon {
    font-style: unset;
    color: #414141;
}
.fileclose {
    height: 12px;
    line-height: 10px;
    width: 12px;
    text-align: center;
    background: #959595;
    border-radius: 50%;
    color: #fff;
    font-size: 12px;
    cursor: pointer;
    display: none;
    margin-left: 6px;
    justify-content: center;
    align-items: center;
}
.fileclose span {
    font-size: 6px;
    display: block;
    margin: 0 0 0px 1px;
}
.fileicon {
    display: none;
    margin-right: 6px;
}
.docselect {
    display: none;
    align-items: center;
    width: max-content;
}
.docselect.docseladdbg {
    background: #f8f8f8;
    display: flex;
    padding: 7px 12px;
    margin: 10px 0 0 0;
    border-radius: 6px;
}
.inputfile::file-selector-button {
    font: inherit;
    display: none;
}
.inputfile_parent label {
    color: #f1e5e6;
    background-color: #f3f3f3;
    border: 1px dashed #848484;
    border-radius: 6px;
    height: 60px;
    line-height: 60px;
    max-width: 100%;
    font-size: 1.25rem;
    font-weight: 500;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
    display: inline-block;
    overflow: hidden;
    padding: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.albmform .inputfile_parent label {
    height: 80px;
    line-height: 80px;
}
.inputfile_parent label span {
    font-size: 16px;
    color: #414141;
    font-weight: 500;
    font-style: unset;
    float: none;
    padding: 0 0 0 10px;
}
.inputfile_parent {
    position: relative;
    height: auto;
}
.inputfile_parent.profile .docselect {
    display: none;
}
.inputfile_parent.profile.select + p {
    display: none;
}
.inputfile_parent.profile label {
    background-color: #fff;
    border: 1px dashed #a8c5dd;
    border-radius: 6px;
    height: 40px;
    line-height: 40px;
}
.inputfile_parent.profile.select .docseladdbg {
    display: flex;
    background: #eaeaea;
}
.inputfile_parent.profile.pop-up label {
    background: #f3f3f3 0% 0% no-repeat padding-box;
    border: 1px dashed #848484;
    border-radius: 6px;
    opacity: 1;
    height: 45px;
    line-height: 45px;
}
.newmsg .ji_filtersec {
    background: #e6ebee;
    padding: 25px 30px 30px;
    margin-top: -1px;
}
.newmsg .filterSearch input {
    border-radius: 18px;
    border: 1px solid #e1e1e1;
    padding-left: 47px;
    color: #000000;
}
.newmsg .filterSearch .btn.icon-search {
    left: 20px;
    top: 10px;
    padding: 0;
    font-size: 14px;
    color: #414141;
    font-weight: 400;
}
.newmsg .filterSearch .btn.icon-search:hover {
    color: #0b3454;
}
.dotted-blue-border {
    height: 1px;
    width: 100%;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/dotted_border_bg.png) left top
        repeat-x;
}
.newmsg .ji_filtersec ul {
    list-style: none;
    padding: 0;
}
.newmsg .ji_filtersec ul li {
    margin: 0 0 20px;
}
.newmsg .ji_filtersec ul li a {
    color: #0b3454;
    font-weight: 400;
    font-size: 16px;
    text-decoration: none;
    width: 100%;
    display: inline-block;
}
.newmsg .ji_filtersec ul li.active a,
.newmsg .ji_filtersec ul li a:hover {
    color: #5cae48;
}
.msgtabcont {
    padding: 25px;
}
.msgtabcont.msgwrapext {
    padding: 25px 10px 25px 25px;
}
.msgtabcont .msgbox {
    border: 1px solid #dedede;
    border-radius: 6px;
    padding: 20px 0px 90px;
    min-height: 490px;
    max-height: 490px;
}
.msgtabcont .msgbox.msgboxconvo {
    padding: 5px 0px 60px;
    display: flex;
    flex-direction: column;
}
.mgs-links {
    display: flex;
    padding: 0 0 8px;
    width: 291px;
}
.mgs-links .btn {
    background: #d4edf9 0% 0% no-repeat padding-box;
    border: 1px solid #93d3ef;
    border-radius: 18px;
    font-size: 14px;
    color: #000;
    transition: all 0.3s ease-in-out;
    height: 36px;
}
.mgs-links .btn:first-child {
    margin-right: 10px;
}
.mgs-links .btn:hover {
    background: #93d3ef;
    color: #0e2d39;
}
.mgs-links .btn:focus {
    box-shadow: none;
}
.mgs-links .btn:focus-visible {
    outline: none;
}
.search-form-control {
    background: #fff url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/search.svg) no-repeat left 13px
        top 14px / 16px auto;
    border: 1px solid #d4d4d4;
    border-radius: 23px;
    opacity: 1;
    padding: 6px 10px 6px 43px;
    height: 45px;
}
.msgbox .filterSearch input {
    height: 45px;
    line-height: 45px;
    border: 1px solid #848484;
    border-radius: 23px;
    font-size: 16px;
    color: #666666;
}
.msgbox .filterSearch input:focus {
    border-color: #86b7fe;
}
.msgbox .filterSearch input:focus-visible {
    border-color: #86b7fe;
}
.msgbox .filterSearch input:focus-within {
    border-color: #86b7fe;
}
.newmsg .msgbox .filterSearch .btn.icon-search {
    top: 15px;
}
.msgbox .filterSearch input:focus-visible {
    border-color: #86b7fe;
}
.search_btmshadow {
    background: transparent linear-gradient(180deg, #f2f2f2 0%, #ffffff 100%) 0%0% no-repeat padding-box;
    height: 20px;
    width: 100%;
}
.msgbox_send {
    width: 100%;
    height: 60px;
    background: #f3f3f3;
    left: 0;
    bottom: 0;
    border-radius: 0 0 6px 6px;
    padding: 5px;
}
.msgbox_send input {
    height: 50px;
    line-height: 50px;
    font-size: 16px;
    font-weight: 500;
    color: #414141;
}
.btn-complete-now.msgsendbtn span {
    font-size: 14px;
    font-weight: 600;
    position: relative;
}
.btn-complete-now.msgsendbtn {
    top: 5px;
    right: 5px;
    position: absolute;
    max-width: 70px;
    width: 100%;
}
.peerprofile {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 60px;
    height: 60px;
    background: #f4f4f4;
    border-radius: 50%;
    margin: 0 10px 0 0;
    overflow: hidden;
}
.peerprofile img[src*='dummy_male.svg'] {
    margin-top: auto;
    width: auto;
    height: 85%;
}
.customCheckBox {
    width: 20px;
    height: 20px;
    border-width: 2px;
}
.customCheckBox:checked {
    background-color: #0b3454;
    border-color: #0b3454;
}
.customCheckBox:checked[type='checkbox'] {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.lite-blue {
    background-color: #e9f6fc;
}
.height-80 {
    height: 80px !important;
}
.min-h-420 {
    min-height: 420px;
}
.min-h-280 {
    min-height: 280px;
}
.radius-6 {
    border-radius: 6px !important;
}
.broadcast_submit .btn {
    background: #fff;
    box-shadow: 1px 1px 1px #0b34541a;
    border: 1px solid #0b34544d;
    border-radius: 25px;
    margin: 5px;
    font-size: 16px;
    transition: all 0.3s ease-in-out;
    padding: 0 25px;
    height: 50px;
}
.broadcast_submit .btn:hover {
    background: #5cae48;
    color: #fff;
    border-color: #5cae48;
}
.broadcast_submit .btn-publish {
    background: #5cae48;
    width: 200px;
    color: #fff;
}
.broadcast_submit .btn-publish:hover {
    background: #4c9649;
}
.card.twitter {
    border-color: #1da1f3;
    overflow: hidden;
}
.card.twitter .card-header {
    background: #1da1f3;
    color: #fff;
}
.card.facebook {
    border-color: #3456a2;
    overflow: hidden;
}
.card.facebook .card-header {
    background: #3456a2;
    color: #fff;
}
.card.instagram {
    border-color: #f84e44;
    overflow: hidden;
}
.card.instagram .card-header {
    color: #fff;
    background: rgb(171,16,128);
    background: linear-gradient(208deg, rgba(171,16,128,1) 0%, rgba(254,83,64,1) 70%, rgba(255,213,84,1) 100%);
}
.card.linkedin {
    border-color: #0077b5;
    overflow: hidden;
}
.card.linkedin .card-header {
    background: #0077b5;
    color: #fff;
}
.icon-star.circle-img {
    position: absolute;
    bottom: -3px;
    right: -3px;
    background: #5cae48;
    border-radius: 50%;
    color: #fff;
    font-size: 7px;
    padding: 4px;
}
.filter-custom-select {
    width: 100%;
    height: 45px;
    border: 1px solid #dee2e6;
    border-radius: 6px;
    background-color: #fff;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
    background-repeat: no-repeat;
    background-position: center right 10px;
    background-size: 12px 12px;
    padding-right: 30px;
}
.dropdown-wrap {
    overflow-x: hidden;
    max-height: 250px;
}
.dropdown-wrap label input {
    margin-right: 5px;
    width: 18px;
    height: 18px;
}
.filter-custom-select.dashboard-filter {
    width: 150px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-left: 10px;
    /* border: 2px solid #7d7d7d; */
    border: 1px solid #b5c2cb;
    /* height: 35px; */
    height: 45px;
    border-radius: 25px;
}
.alumni-directory-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
}
.alumni-directory-header_search {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    align-items: center;
}
.alumni-directorySearch {
    background: #ffffff;
    width: 365px;
    height: 40px;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    border-radius: 25px;
    overflow: hidden;
    position: relative;
}
.alumni-directorySearch .form-control {
    flex: 1 1;
    border: 0;
    padding-left: 0;
}
.alumni-directorySearch .btn.icon-search {
    font-size: 12px;
    padding: 0 10px 0 20px;
}
.alumni-directorySearch .btn-search-cross {
    position: absolute;
    right: 13px;
    top: 0;
    bottom: 0;
    margin: auto;
    display: flex;
    align-items: center;
    color: #000;
    font-weight: 100 !important;
}
.alumni-directorySearch .btn-cross {
    width: 14px;
    height: 14px;
    position: absolute;
    right: -15px;
    top: 0;
    bottom: 0;
    margin: auto;
    transform: rotate(0deg);
    opacity: 0;
    transition: all 0.5s ease-in-out;
}
.alumni-directorySearch .btn-cross:before {
    content: '';
    position: absolute;
    width: 14px;
    height: 2px;
    left: 0;
    bottom: 0;
    right: 0;
    top: 0;
    margin: auto;
    background: #000;
    border-radius: 5px;
}
.alumni-directorySearch .btn-cross:after {
    content: '';
    position: absolute;
    width: 2px;
    height: 14px;
    left: 0;
    bottom: 0;
    right: 0;
    top: 0;
    margin: auto;
    background: #000;
    border-radius: 5px;
}
.alumni-directorySearch .form-control:valid + .btn-cross {
    opacity: 1;
    right: 15px;
    transform: rotate(135deg);
}
.alumni_directory_filter {
    padding: 30px 0;
    padding-right: var(--bs-gutter-x, 0.75rem);
    padding-left: var(--bs-gutter-x, 0.75rem);
}
.alumni_directory_filter .ji_filtersec {
    width: 100%;
    max-width: 100%;
}
.alumni_directory_filter .fiterItem {
    width: 220px;
    margin: 0 5px;
    box-shadow: 0px 10px 25px #00000008;
}
.alumni_directory_filter .fiterItem.key {
    border-color: #5cae48;
}
.alumni_directory_filter .filterGroup {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    align-items: start;
    margin: 0 -5px;
}
.alumni_directory_filter .filterSearchblk {
    background: #fff;
    padding: 0 14px 10px;
}
.alumni_directory_filter .filterSearchblk .filterSearch input {
    margin: 0;
}
.alumni_directory_filter .filterHeader button {
    transition: all 0.3s ease-in-out;
    padding: 15px 15px;
}
.alumni_directory_filter .filterHeader button:not([aria-expanded='false']) {
    padding-bottom: 8px;
}
.alumni_directory_filter .fiterItem .card {
    padding: 0px 15px 15px;
}
.alumni_directory_filter .scrollMe {
    max-height: 122px;
    min-height: 122px;
    overflow-x: hidden;
}
.alumni_directory_filter .fiterItem .form-check:not(:last-child) {
    margin-bottom: 4px;
}
.additionalfilter_count {
    display: none;
}
.btn-md-filter {
    text-decoration: none;
    transform: rotate(90deg);
    color: #000;
    font-size: 20px;
    transition: all 0.3s ease-in-out;
}
.btn-md-filter:hover {
    color: #000;
}
.btn-md-filter[aria-expanded='true'] {
    transform: rotate(270deg);
}
.additionalfilter_wrap {
    width: 100%;
    padding: 0 5px;
}
.alumni_directory_filter .fiterItem.campus {
    width: 450px;
}
.showProfiles_wrap {
    background: #fff;
    border: 1px solid #d2d2d2;
    border-radius: 6px;
    box-shadow: 0px 10px 25px #00000008;
    width: calc(100% - 10px);
    margin: 0 5px;
    padding: 17px 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.showProfiles_left {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    align-items: center;
}
.showProfiles_left h3 {
    margin: 0 30px 0 0;
    font-size: 18px;
    line-height: 20px;
    font-weight: 600;
}
.showProfiles_left .form-check-label {
    font-size: 16px;
}
.showProfiles_left .form-check-input {
    width: 20px;
    height: 20px;
    vertical-align: top;
    margin-top: -2px;
    margin-right: 10px;
}
.showProfiles_left .form-check.form-check-inline {
    display: inline-flex;
    align-items: center;
}
.showProfiles_left .check_list {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    align-items: center;
}
.showProfiles_left .form-check-input:checked {
    background-color: #5cae48;
    border-color: #5cae48;
}
.showProfiles_right .icon {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/subtraction.svg);
    width: 16px;
    height: 25px;
    margin-right: 8px;
}
.showProfiles_right {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}
.showProfiles_right .title {
    font-size: 14px;
    letter-spacing: -0.35px;
}
.alumni-bucket {
    background: #ffffff;
    border: 1px solid #d2d2d2;
    border-radius: 6px;
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
}
.alumni-bucket .block-link {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    margin: auto;
    z-index: 1;
}
.alumni_img {
    width: 60px;
    margin-right: 10px;
    height: 60px;
    background: #f1f1f1;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.alumni_img img {
    width: auto;
    height: 100%;
}
.alumni_img.no_pic {
    align-items: end;
}
.alumni_img.no_pic img {
    width: auto;
    height: auto;
}
.alumni_name_brife h3 {
    font-size: 18px;
    margin: 0;
}
.class_year {
    color: #6a6868;
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
}
.alumni_directory_details .btn-viewcompus {
    font-size: 13px;
    color: #1452ce;
    font-weight: 500;
    line-height: 18px;
    position: relative;
    z-index: 2;
    text-decoration: none;
}
.alumni_directory_details .btn-viewcompus:hover {
    color: #0b3454;
    text-decoration: underline;
}
.alumni_directory_details a.btn-send {
    padding: 0 20px;
    line-height: 36px;
    text-decoration: none;
    background: #5cae48;
    border-radius: 25px;
    height: 36px;
    display: inline-flex;
    color: #fff;
    align-items: center;
    transition: all 0.3s ease-in-out;
    position: relative;
    z-index: 2;
}
.alumni_directory_details a.btn-send:hover {
    background: #40862f;
}
.icon-alumni-send {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/send_alumni_profile.svg) no-repeat 0
        0 / 100%;
    width: 19px;
    height: 19px;
    margin-right: 8px;
    margin-left: -3px;
}
/* .alumni_univarsity_details {background: #F9F9F9 ;border-radius: 0px 0px 5px 5px;opacity: 1;display: flex;justify-content: center;-webkit-box-flex: 1;-moz-box-flex: 1;-webkit-flex: 1;-ms-flex: 1;flex: 1;padding: 11px;position:relative}
.alumni_univarsity_details .alumni_univarsity_details_inner_cover {max-width: 260px;width: 90%;display: flex;flex-wrap: wrap;}
.alumni_univarsity_details .alumni_univarsity_details_inner_cover .alumni_univarsity_logo {width: 64px;margin-right: 10px;padding-top: 6px;}
.alumni_univarsity_details .alumni_univarsity_details_inner_cover .alumni_univarsity_logo img {width: 100%;border-radius: 50%;}
.alumni_univarsity_details .alumni_univarsity_details_inner_cover .alumni_univarsity_brife {width: calc(100% - 75px);} */
.alumni_directory_details a.alumni_name_link {
    color: #000;
    text-decoration: none;
}
.alumni_directory_details a.alumni_name_link:hover {
    color: #1452ce;
}
.alumni_class_link {
    padding: 15px 20px;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
}
.alumni_education {
    color: #4d4d4d;
    font-size: 13px;
    font-weight: 500;
    line-height: 18px;
}
.alumni_univarsity_name {
    font-size: 19px;
    font-weight: 500;
    line-height: 20px;
    margin-bottom: 3px;
}
.alumni_univarsity_name .icon-subtraction {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/subtraction.svg) no-repeat 0 0 / 100%;
    width: 12px;
    height: 20px;
    margin-left: 3px;
    display: inline-block;
    vertical-align: top;
}
.alumni_univarsity_subject {
    color: #0b3454;
    font-size: 14px;
    line-height: 16px;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
}
.alumni_univarsity_subject span {
    flex: 1 1;
}
.alumni_univarsity_subject i {
    width: 16px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/subject_setting.svg) no-repeat 0 0 /
        100%;
    height: 16px;
    margin-right: 7px;
}
.filter_result ul {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
}
.filter_result_title {
    margin-bottom: 18px;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 10px;
}
.filter_result_title .filter_result {
    flex: 1 1;
}
.filter_result ul li {
    background: #e9f6fc;
    border-radius: 25px;
    padding: 9px 23px;
    margin-top: 6px;
    margin-bottom: 6px;
}
.filter_result ul li:not(:last-child) {
    margin-right: 10px;
}
.filter_result ul li:last-child {
    background: no-repeat;
    padding: 9px 0;
}
.filter_result ul li span {
    margin-right: 10px;
}
.filter_result ul li .btn-cross {
    font-size: 10px;
    color: #000;
    text-decoration: none;
}
.filter_result ul li .btn-cross:hover {
    color: #105271;
}
.alumni_count {
    font-size: 18px;
    font-weight: 500;
    line-height: 20px;
    margin: 18px 0 0;
}
.btn-additionalfilter {
    text-decoration: none;
    font-size: 14px;
    color: #1452ce;
    font-weight: 500;
    display: inline-flex;
    align-items: center;
    transition: all 0.3s ease-in-out;
}
.btn-additionalfilter span {
    text-decoration: underline;
    margin-right: 10px;
}
.btn-additionalfilter .icon-right-arrow {
    transform: rotate(90deg);
    transition: all 0.3s ease-in-out;
}
.btn-additionalfilter[aria-expanded='true'] .icon-right-arrow {
    transform: rotate(270deg);
}
.btn-additionalfilter:hover {
    color: #0b3454;
}
.btn-additionalfilter:hover span {
    text-decoration: none;
}
.alumni_directory_filter .filters-head h3 {
    display: flex;
    margin: 0;
    align-items: center;
}
.alumni_directory_filter .filters-head h3 .icon-filter + span {
    flex: 1 1;
}
.alumni_directory_filter .filters-head h3[aria-expanded='true'] i {
    transform: rotate(270deg);
}
.alumni_directory_details .load_more_btn {
    text-decoration: none;
    text-transform: uppercase;
    display: flex;
    justify-content: center;
    align-items: center;
}
.alumni_directory_details .load_more_btn:hover {
    background: #0b3454;
    color: #fff;
    border-color: #0b3454;
}
.alumni_directory_details .load_more_btn img {
    -webkit-animation: none;
}
.alumni_directory_details .load_more_btn:hover img {
    filter: invert(1) brightness(100);
}
.tooltip-viewcompus .tooltip-arrow::before {
    display: none;
}
.alumni_profile_brife_wrap {
    border-bottom: 1px solid #e7e7e7;
}
.alumni_profile_brife {
    padding: 40px 0;
}
.alumni_profile_brife .btn-back {
    color: #000;
    font-size: 14px;
    line-height: 16px;
    font-weight: 500;
}
.alumni_profile_brife .btn-back .icon-right-arrow {
    transform: scaleX(-1);
    margin-right: 7px;
    font-size: 12px;
}
.alumni_profile_brife .btn-back:hover {
    color: #0b3454;
}
.alumni_profile_name_college_other_detail_wrap {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
}
.alumni_profile_image_name_other_detail {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    padding: 0 20px 0 0;
    position: relative;
    width: 48%;
}
.alumni_profile_image_name_other_detail:after {
    content: '';
    width: 1px;
    height: 100%;
    background: #d4d4d4;
    position: absolute;
    right: 0;
    top: 0;
}
.alumni_profile_image {
    width: 110px;
    height: 110px;
    background: #f1f1f1;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    margin-right: 20px;
}
.alumni_profile_image img {
    width: auto;
    height: 100%;
}
.alumni_profile_image.no_pic {
    align-items: end;
}
.alumni_profile_image.no_pic img {
    height: 80%;
}
.alumni_profile_name_other_detail {
    width: calc(100% - 130px);
}
.alumni_profile_name_other_detail h2 {
    font-size: 26px;
    line-height: 18px;
    font-weight: 600;
    word-break: break-all;
    line-height: 28px;
}
.alumni_profile_name_other_detail .alumni_profile_location {
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 15px;
}
.alumni_profile_class_college {
    position: relative;
    padding: 0 0 0 20px;
    margin-bottom: 13px;
}
.alumni_profile_class_college:before {
    content: '';
    position: absolute;
    left: 6px;
    top: 0;
    bottom: 0;
    width: 3px;
    height: 100%;
    background: #d52941;
    border-radius: 5px;
}
.alumni_profile_class_college .alumni_profile_class {
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0.32px;
    line-height: 18px;
    margin-bottom: 5px;
}
.alumni_profile_class_college .alumni_profile_college {
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0.32px;
    line-height: 18px;
}
.alumni_profile_college_phone {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
}
.alumni_profile_college_phone .verifyLink {
    font-size: 16px;
    font-weight: 500;
}
.verifiedLink {
    color: #5cae48;
    text-decoration: none;
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 16px;
}
.alumni_profile_name_other_detail .btn-send {
    width: auto;
    height: 40px;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    background: #5cae48;
    border-radius: 25pc;
    color: #fff;
    text-decoration: none;
    align-items: center;
    padding: 0 25px;
    font-size: 16px;
    font-weight: 500;
    transition: all 0.3s ease-in-out;
}
.alumni_profile_name_other_detail .btn-send .icon-send {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/send_alumni_profile.svg) no-repeat 0
        0 / 100%;
    width: 19px;
    height: 19px;
    margin-right: 10px;
    position: relative;
    transition: all 0.3s ease-in-out;
    left: 0;
}
.alumni_profile_name_other_detail .btn-send:hover {
    background: #2fa612;
}
.alumni_profile_name_other_detail .btn-send:hover .icon-send {
    left: 3px;
}
.alumni_profile_brife_tab {
    margin-bottom: 20px;
}
.alumni_profile_status {
    list-style: none;
    margin: 0;
    padding: 0;
}
.alumni_profile_status li {
    margin-bottom: 16px;
    width: 176px;
    position: relative;
    padding-left: 16px;
}
.alumni_profile_status li .title {
    letter-spacing: 0.32px;
    color: #000000;
    font-size: 16px;
}
.alumni_profile_status li p {
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: 0.32px;
}
.alumni_profile_status li:before {
    content: '';
    width: 3px;
    height: 17px;
    position: absolute;
    left: 0;
    top: 4px;
    background: #d52941;
    border-radius: 5px;
}
.alumni_profile_college_joined {
    color: #5cae48;
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
    margin-bottom: 5px;
}

.alumni_profile_college_name_other_detail_wrap .alumni_profile_college_name_detail h3 {
    font-size: 20px;
    line-height: 26px;
    font-weight: 600;
}
.alumni_profile_college_subject {
    min-height: 30px;
    height: auto;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 6px 15px;
    background: #e5f1fb;
    border-radius: 18px;
    font-size: 16px;
    line-height: 20px;
    font-weight: 600;
    color: #0b3454;
}

.underGraduate-detail .main_title,
.blockHeader {
    font-size: 22px;
    color: #000;
    width: auto;
    margin: -40px -40px 25px;
    border-radius: 6px 6px 0px 0px;
    padding: 20px 40px;
    line-height: 22px;
    border-bottom: 1px solid #f5f5f5;
}
.blockHeader .title span {
    font-weight: 600;
}
.graduateRow .college_detail_wrap .college_detail h3 {
    font-size: 20px;
    font-weight: 600;
    margin: 0 0 2px;
    transition: all 0.3s ease-in-out;
}
.graduateRow .college_detail_wrap:hover h3 {
    text-decoration: underline;
    color: #1452ce;
}
.graduateRow .college_detail_wrap .college_detail h3 .icon-subtraction {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/subtraction.svg) no-repeat 0 0 / 100%;
    width: 16px;
    height: 25px;
    margin-left: 3px;
    display: inline-block;
    vertical-align: top;
}
.graduateRow .college_detail_wrap .college_detail p {
    font-size: 16px;
    color: #414141;
    margin: 0 0 5px;
}
.graduateRow {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    position: relative;
}
.graduateRow:not(:last-child) {
    border-bottom: 2px solid #e5e5e5;
    margin-bottom: 28px;
    padding-bottom: 28px;
}
.underGraduate-detail,
.postGraduate-detail {
    box-shadow: 0px 10px 25px #00000008;
    border-radius: 6px;
    background: #fff;
    padding: 40px;
}
.graduateRow .college_detail_wrap {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    width: calc(100% - 265px);
    padding-right: 40px;
    position: relative;
    align-items: center;
}
.graduateRow .college_detail_wrap > a {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
}
.graduateRow .college_detail_wrap:after {
    content: '';
    position: absolute;
    top: 13px;
    right: 0;
    width: 2px;
    height: 63px;
    background: #d1d1d1;
}
.graduateRow .offer {
    width: 265px;
    display: flex;
    flex-direction: column;
    align-items: end;
    justify-content: center;
}
.graduateRow .college_detail_wrap .college_detail {
    flex: 1 1;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
}
.graduateRow .college_detail_wrap .college_detail .college_logo {
    margin-right: 20px;
    width: 150px;
    height: 95px;
    border: 1px solid #d5d5d5;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.college_name_scholarship {
    flex: 1 1;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
}
.college_name_scholarship .college_name {
    width: calc(100% - 100px);
}
.graduateRow .college_detail_wrap .college_detail .college_logo .logo_link {
    padding: 10px;
    display: inline-block;
    width: 100%;
    height: 100%;
}
.graduateRow .college_detail_wrap .college_detail .college_logo .logo_link img {
    width: 100%;
    height: 100%;
}
.graduateRow .college_detail_wrap .scholarship {
    display: flex;
    flex-direction: column;
    text-align: center;
    line-height: 20px;
}
.graduateRow .college_detail_wrap .scholarship .scholarship_label {
    font-weight: 500;
    color: #8a8a8a;
}
.graduateRow .college_detail_wrap .scholarship .scholarship_amt {
    font-weight: 600;
    white-space: nowrap;
}
.graduateRow .offer > a,
.graduateRow .offer a.joindeLink {
    padding: 0 20px;
    text-decoration: none;
    height: 37px;
    background: #5cae48;
    color: #fff;
    border-radius: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 10px;
    transition: all 0.3s ease-in-out;
}
.graduateRow .offer > a:hover,
.graduateRow .offer a.joindeLink:hover {
    background: #3e9329;
}
.graduateRow .offer > a i,
.graduateRow .offer a.joindeLink i {
    margin-right: 10px;
}
.graduateRow .offer > a:hover {
    background: #3b8d27;
}
.graduateRow .offer .got_offer {
    font-weight: 500;
    font-size: 16px;
    margin-bottom: 5px;
}
.graduateRow .offer .got_offer i {
    margin-right: 10px;
    font-size: 20px;
    color: #5cae48;
}
.graduateRow .offer .offerLink {
    color: #1452ce;
}
.graduateRow .offer .offerLink:hover {
    color: #0b3454;
}
.graduateRow .offer .offer_joined i {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/hat_alumni.svg);
    width: 23px;
    height: 17px;
    margin-right: 10px;
}
.graduateRow .offer .offer_joined {
    display: flex;
    align-items: center;
}
.graduateRow.edit .college_detail_wrap {
    width: calc(100% - 350px);
}
.graduateRow .offer.offer_edit {
    flex-direction: row;
    align-items: center;
    width: 350px;
    justify-content: end;
}
.graduateRow .offer.offer_edit .edit_section,
.edit_section {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-left: 20px;
    align-items: center;
}
.edit_section_inner {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}
.graduateRow .offer .edit_link,
.edit_section .edit_link {
    width: 52px;
    height: 30px;
    background: #eaf4fc;
    border-radius: 20px;
    transition: all 0.3s ease-in-out;
    position: relative;
}
.graduateRow .offer .edit_link:hover,
.edit_section .edit_link:hover {
    background-color: #0b3454;
}
.graduateRow .offer .edit_link:before,
.edit_section .edit_link::before {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    margin: auto;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/draw.svg) no-repeat center / 18px
        auto;
}
.graduateRow .offer .edit_link:hover:before,
.edit_section .edit_link:hover::before {
    filter: invert(99%) sepia(1%) saturate(2%) hue-rotate(228deg) brightness(110%) contrast(100%);
}
.graduateRow .offer .del_link,
.edit_section .del_link,
.del_link {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/delete.svg);
    width: 14px;
    height: 16px;
    margin-left: 10px;
    opacity: 0.5;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.graduateRow .offer .del_link:hover,
.edit_section .del_link:hover,
.del_link:hover {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/delete_dark.svg);
    opacity: 1;
}
.graduateRow .offer .offer_existing_links {
    display: flex;
    flex-direction: column;
    align-items: end;
}
.form-group .del_link {
    position: absolute;
    top: 15px;
    right: -20px;
}
.graduation-title {
    font-size: 22px;
    font-weight: 400;
    margin: -15px 0 20px;
}
.graduation-title span {
    font-weight: 600;
}
.graduation_carousel_wrap {
    margin-top: 20px;
    box-shadow: 0px 10px 25px #00000008;
    border-radius: 6px;
    background: #fff;
    padding: 40px;
}
.graduation_carousel_wrap .card_profiles:first-child {
    margin-bottom: 18px;
}
.graduation_carousel_wrap .seactionheader {
    margin: -10px 0 27px;
}
.graduation_carousel_wrap .seactionheader h3 {
    font-size: 22px;
    font-weight: 400;
}
.graduation_carousel_wrap .seactionheader h3 span {
    font-weight: 600;
}
.card_profiles {
    border: 1px solid #d2d2d2;
    padding: 20px;
    border-radius: 6px;
    flex-direction: column !important;
    display: flex;
    justify-content: space-between;
    height: 100%;
    position: relative;
    background: #fff;
    max-height: 240px;
    min-height: 240px;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    -ms-border-radius: 6px;
    -o-border-radius: 6px;
    overflow-y: auto;
}
.card_profiles::-webkit-scrollbar {
    width: 4px;
}
.card_profiles::-moz-scrollbar {
    width: 4px;
}
.card_profiles::-webkit-scrollbar-track {
    background: #ccc;
}
.card_profiles::-webkit-scrollbar-thumb {
    background-color: #666;
    border-radius: 20px;
    border: 2px solid #666;
}
.card_profiles .alumni-Profile-button-rounded {
    position: absolute;
    right: 20px;
    padding: 0 20px;
}
.card_profiles .alumni-Profile-button-rounded:hover,
.card_profiles .alumni-Profile-button-rounded:focus {
    background: #40952c;
    color: #fff;
    background-color: #40952c;
    border-color: 0;
    box-shadow: none;
}
.card_profiles figure.student {
    width: 90px;
    height: 90px;
    overflow: hidden;
    border-radius: 200px;
    margin-right: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.card_profiles figure.student img {
    border-radius: 200px;
}
.student_details {
    width: calc(100% - 110px);
}
.card_profiles .student_details figure img {
}
.card_profiles .student_details h2 {
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 15px;
    width: 65%;
    margin-top: 010px;
}
.card_profiles .student_details h2 a {
    color: #000;
    text-decoration: none;
    white-space: nowrap;
    width: 100%;
    text-overflow: ellipsis;
    display: inline-block;
    overflow: hidden;
}
.card_profiles .student_details h2 a:hover {
    text-decoration: underline;
    color: #1452ce;
}
.card_profiles .student_details h2 span {
    display: block;
    font-size: 16px;
    color: #6a6868;
    font-weight: 500;
}
.card_profiles .student_details .sub_details {
    display: flex;
    flex-grow: 1 !important;
}
.card_profiles .student_details .sub_details_workExp {
    align-items: center;
    position: relative;
    padding-bottom: 5px;
}
.card_profiles .student_details .sub_details_achivements figure {
    background: #0b3454 !important;
}
.card_profiles .student_details .sub_details_workExp figure {
    border: 0 !important;
    border-radius: 100px !important;
    min-width: 50px !important;
    height: 50px !important;
    width: 50px !important;
    background-color: #d52941;
}
.card_profiles .student_details .sub_details_workExp figure img {
    width: 45%;
    height: auto;
}
.card_profiles .student_details .sub_details_workExp figure.bg_white {
    background-color: #fff !important;
    border: 1px solid #d2d2d2 !important;
}
.card_profiles .student_details .sub_details_workExp figure.bg_white img {
    width: 80%;
}
.card_profiles .student_details .sub_details_workExp:after {
    position: absolute;
    width: 83%;
    height: 1px;
    content: '';
    background: #c1c1c1;
    bottom: 0;
    right: 0; /* padding-bottom: 20px; */
}
.card_profiles .student_details .sub_details_workExp1:after {
    display: none;
}
.card_profiles .student_details .sub_details h3 {
    margin-bottom: 0;
    min-width: 43px;
    justify-content: center;
}
.card_profiles .student_details .sub_details figure {
    border: 1px solid #d2d2d2;
    border-radius: 100px;
    min-width: 80px;
    height: 80px;
    overflow: hidden;
    margin-right: 10px;
    margin-bottom: 0;
    width: 80px;
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.card_profiles .student_details .sub_details p {
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 5px;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    max-height: 43px;
    overflow: hidden;
    line-height: 18px;
}
.card_profiles .student_details .sub_details a {
    color: #000;
    text-decoration: none;
}
.card_profiles .student_details .sub_details a:hover {
    text-decoration: underline;
    color: #1452ce;
}
.card_profiles .student_details .sub_details p.title,
.card_profiles .student_details .sub_details p.green-title {
    color: #5cae48;
    font-size: 14px;
    margin-bottom: 10px;
}
.card_profiles .student_details .sub_details span {
    color: #333333;
    font-size: 14px;
    margin-bottom: 15px;
    font-weight: 400;
}
.card_profiles .student_details .sub_details span.course {
    color: #0b3454;
    font-size: 16px;
    font-weight: 400;
    display: flex;
    align-items: center;
    margin-bottom: 0;
}
.card_profiles .student_details .sub_details span.course img {
    margin-right: 6px;
    width: 16px;
}
.card_profiles .action_btns {
    margin-top: 20px;
    border-top: 1px solid #d2d2d2;
    padding-top: 20px;
    display: flex;
    justify-content: center !important;
    width: 100%;
}
.card_profiles .action_btns .btn-outline-primary {
    margin-right: 10px;
    border: 2px solid #5bae47;
    border-radius: 50px;
    padding: 7px 20px;
    color: #5bae47;
}
.card_profiles .action_btns .btn-outline-primary:hover img {
    filter: brightness(0) invert(1);
}
.card_profiles .action_btns .btn-outline-primary:hover {
    border: 2px solid #418d2e;
    background-color: #418d2e;
    color: #fff;
}
.card_profiles .action_btns .btn-secondary {
    border-radius: 50px;
    padding: 7px 20px;
    color: #fff;
    background: #0b3454;
}
.card_profiles .action_btns .btn-secondary:hover {
    background: #26a7df;
    border: 1px solid #26a7df;
}
.card_profiles .btn-send {
    width: 123px;
    height: 40px;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    background: #5cae48;
    border-radius: 25pc;
    color: #fff;
    text-decoration: none;
    align-items: center;
    padding: 0 25px;
    font-size: 16px;
    font-weight: 500;
    transition: all 0.3s ease-in-out;
}
.card_profiles .btn-send {
    color: #fff;
    font-size: 16px;
    font-weight: 500;
    position: absolute;
    top: 20px;
    right: 20px;
}
.card_profiles .btn-send .icon-send {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/send_alumni_profile.svg) no-repeat 0
        0 / 100%;
    width: 19px;
    height: 19px;
    margin-right: 10px;
    position: relative;
    transition: all 0.3s ease-in-out;
    left: 0;
}
.card_profiles .btn-send:hover .icon-send {
    left: 3px;
}
.card_profiles .btn-send:hover {
    background: #3b8d27;
}
.workExperience-detail {
    box-shadow: 0px 10px 25px #00000008;
    border-radius: 6px;
    background: #fff;
    padding: 40px;
}
.workExperience-detail .workExperience-title {
    font-size: 22px;
    font-weight: 400;
    margin: -15px 0 30px;
}
.workExperience-detail .workExperience-title span {
    font-weight: 600;
}
.work-block {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    align-items: center;
    position: relative;
}
.work-block .work-detail {
    flex: 1 1;
    display: flex;
    flex-direction: column;
}
.work-block .icon {
    width: 55px;
    height: 55px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 26px;
    margin-right: 20px;
    background: #d52941;
    border-radius: 50%;
    color: #fff;
}
.work-block .icon.workex-logo {
    border-radius: 0;
}
.work-block .icon.workex-logo img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
}
.work-block .work-detail p {
    font-size: 20px;
    line-height: 24px;
    margin: 0 0 5px;
    font-weight: 500;
}
.work-block .work-detail span {
    font-size: 16px;
    color: #6d6b6b;
    line-height: 16px;
    font-weight: 500;
}
.achievements-block {
    box-shadow: 0px 10px 25px #00000008;
    border-radius: 6px;
    background: #fff;
    padding: 30px;
    display: flex;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    -ms-border-radius: 6px;
    -o-border-radius: 6px;
    position: relative;
}
.achievements-block:not(:last-child) {
    border-bottom: 1px solid #f5f5f5;
}
.achievements-icon-block {
    padding: 0 55px 0 30px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-width: 185px;
    max-width: 185px;
    align-items: center;
    text-align: center;
    border-right: 1px solid #cecece;
    margin-right: 30px;
}
.achievements-icon-block .icon {
    width: 60px;
    height: 60px;
    background: #0b3454;
    border-radius: 50%;
    margin-bottom: 8px;
    position: relative;
}
.achievements-icon-block .icon.icon-medal:before {
    content: '';
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/exam_ico.svg);
    width: 26px;
    height: 36px;
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    top: 0;
    margin: auto;
}
.achievements-icon-block .icon.icon-grade:before {
    content: '';
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/exam_ico.svg);
    width: 25px;
    height: 31px;
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    top: 0;
    margin: auto;
}
.achievements-icon-block .icon.icon-publication:before {
    content: '';
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/publication_ico.svg);
    width: 29px;
    height: 31px;
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    top: 0;
    margin: auto;
}
.achievements-icon-block .icon.icon-promotion:before {
    content: '';
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/promotion_ico.svg);
    width: 32px;
    height: 37px;
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    top: 0;
    margin: auto;
}
.achievements-icon-block .icon.icon-course-completion:before {
    content: '';
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/course_ico.svg);
    width: 31px;
    height: 37px;
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    top: 0;
    margin: auto;
}
.achievements-icon-block .icon.icon-social-service:before {
    content: '';
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/social_ico.svg);
    width: 36px;
    height: 36px;
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    top: 0;
    margin: auto;
}
.achievements-icon-block .icon.icon-scholarship:before {
    content: '';
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/scholarship_ico.svg);
    width: 39px;
    height: 28px;
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    top: 0;
    margin: auto;
}
.achievements-icon-block .icon.icon-others:before {
    content: '';
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/others_ico.svg);
    width: 32px;
    height: 32px;
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    top: 0;
    margin: auto;
}
.achievements-icon-block .achievements-title {
    font-size: 18px;
    font-weight: 600;
}
.achievements-icon-block .achievements-year {
    font-size: 18px;
    line-height: 22px;
    color: #414141;
}
.achievements-block-detail h3 {
    font-size: 22px;
    font-weight: 400;
    margin-bottom: 0px;
}
.achievements-block-detail h3 span {
    font-weight: 600;
}
.achievements-block-detail p {
    font-size: 16px;
    line-height: 24px;
    margin: 0;
}
.achievements-block-detail {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
}
.hide {
    display: none;
}
.achievements-block-detail p.show .hide {
    display: inline;
}
.achievements-block-detail p.show .btn-readmore {
    font-size: 0;
}
.achievements-block-detail p.show .btn-readmore:before {
    content: 'Read Less';
    font-size: 16px;
}
.achievements-block-detail p .btn-readmore {
    color: #1452ce;
    transition: all 0.3s ease-in-out;
}
.achievements-block-detail p .btn-readmore:hover {
    color: #1046b3;
}
.achievements-block-detail .url-link {
    color: #1452ce;
    transition: all 0.3s ease-in-out;
}
.achievements-block-detail .url-link:hover {
    color: #1046b3;
}
.achievements-list {
    box-shadow: 0px 10px 25px #00000008;
    border-radius: 6px;
    background: #fff;
}
.achievements-block-title {
    padding: 20px 40px;
    border-bottom: 1px solid #f5f5f5;
    border-radius: 6px 6px 0 0;
}
.achievements-block-title .title {
    font-size: 22px;
}
.achievements-block-title .title span {
    font-weight: 600;
}
.btn-add-section {
    background: #ffffff;
    border: 1px solid #0b3454;
    border-radius: 19px;
    height: 37px;
    display: flex;
    padding: 0 20px;
    align-items: center;
    text-decoration: none;
    font-weight: 500;
    font-size: 14px;
    color: #0b3454;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.btn-add-section i {
    position: relative;
    width: 11px;
    height: 110px;
    margin-right: 10px;
}
.btn-add-section i:before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    background: #0b3454;
    width: 2px;
    height: 10px;
}
.btn-add-section i:after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    background: #0b3454;
    width: 10px;
    height: 2px;
}
.btn-add-section:hover {
    background: #0b3454;
    color: #fff;
}
.btn-add-section:hover i:before,
.btn-add-section:hover i:after {
    background: #fff;
}
.contributions-block {
    box-shadow: 0px 10px 25px #00000008;
    border-radius: 6px;
    background: #fff;
    padding: 40px;
}
.contributions-block:not(:last-child) {
    margin-bottom: 20px;
}
.contributions-block .act_lst:not(:last-child) {
    margin-bottom: 20px;
}
.contributions-block .seactionheader {
    margin: -10px 0 20px;
}
.contributions-block h3 {
    font-size: 22px;
    font-weight: 600;
}
.contributions-block .circle-effect::before {
    background: #6c8598;
}
.contributions-block .list_badge {
    color: #d52941;
    background: no-repeat;
    position: static;
    text-transform: uppercase;
}
.contributions-block .act_lst {
    padding: 25px 25px 25px 25px;
}
.contributions-block .video_block_name label {
    font-size: 16px;
}
.skills-block {
    box-shadow: 0px 10px 25px #00000008;
    border-radius: 6px;
    background: #fff;
    padding: 40px;
    position: relative;
}
.skills-block:first-child {
    padding-bottom: 20px;
}
.skills-block.EntranceExam-skills-block {
    padding-bottom: 33px;
}
.skills-block:not(:last-child) {
    margin-bottom: 20px;
}
.skills-block h2 {
    font-size: 22px;
    font-weight: 400;
    margin-bottom: 15px;
    margin: -10px 0 25px;
}
.skills-block h2 span {
    font-weight: 600;
}
.skills-block-detail {
    display: flex;
    flex-wrap: wrap;
}
.skills-block-detail .meter {
    margin: 0 12px 20px 0;
    border: 1px solid #c7c7c7;
    padding: 10px 30px;
    border-radius: 50px;
    font-size: 20px;
    font-weight: 500;
    align-items: center;
}
.skills-block-detail .meter img {
    width: 50px;
}
.skills-block-title {
    margin-top: -30px;
    margin-bottom: 20px;
}
.preferences-block {
    box-shadow: 0px 10px 25px #00000008;
    border-radius: 6px;
    background: #fff;
    padding: 40px;
}
.preferences-block:not(:last-child) {
    margin-bottom: 20px;
}
.preferences-block.EntranceExam-skills-block {
    padding-bottom: 33px;
}
.preferences-block h2 {
    font-size: 22px;
    font-weight: 400;
    margin-bottom: 15px;
    margin: -10px 0 25px;
}
.preferences-block h2 span {
    font-weight: 600;
}
.preferences-block-detail {
    display: flex;
    flex-wrap: wrap;
}
.preferences-block-detail .meter {
    margin: 0 12px 20px 0;
    border: 1px solid #c7c7c7;
    padding: 10px 30px;
    border-radius: 50px;
    font-size: 20px;
    font-weight: 500;
    align-items: center;
}
.preferences-block-detail .meter img {
    width: 50px;
}
.preferences-block-title {
    margin-top: -30px;
    margin-bottom: 20px;
}
.interested-block .icon {
    width: 55px;
    height: 55px;
    border-radius: 50%;
    background: #0b3454;
    position: relative;
    margin-right: 20px;
}
.interested-block .icon.icon-bulb::before {
    content: '';
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/bulb.svg) no-repeat 0 0 / 34px auto;
    width: 34px;
    height: 36px;
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    top: 0;
    margin: auto;
}
.interested-block .icon.icon-note::before {
    content: '';
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/publication_ico.svg);
    width: 29px;
    height: 31px;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
}
.interested-block {
    display: flex;
    align-items: center;
}
.interested-block .interested-topics {
    font-size: 20px;
    flex: 1 1;
    line-height: 22px;
}
.interested-block .interested-topics span {
    font-weight: 500;
}
.graduationslider .meter {
    padding: 10px 30px;
    display: inline-flex;
    flex-wrap: wrap;
    align-items: center;
    border-radius: 50px;
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 10px;
}
.profile-item {
    text-align: center;
    width: 196px;
    height: 210px;
    display: flex;
    flex-direction: column;
    padding-top: 10px;
}
.owl-item:not(:last-child) .profile-item {
    border-right: 1px solid #d2d2d2;
}
.profile-item-img {
    text-align: center;
    display: flex;
    justify-content: center;
    margin-bottom: 11px;
}
.profile-item-name-class h3 {
    font-size: 16px;
    font-weight: 600;
    margin: 0 0 4px;
}
.profile-item-name-class p {
    margin: 0 0 11px;
    font-size: 14px;
    font-style: italic;
    color: #535353;
}
.profile-item-name-class .subject {
    color: #0b3454;
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    position: relative;
    padding-top: 10px;
}
.profile-item-name-class .subject:before {
    content: '';
    width: 30px;
    height: 2px;
    background: #5cae48;
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    top: 0;
}
.profile-item-name-class .btn-viewcompus {
    font-size: 13px;
    color: #1452ce;
    font-weight: 500;
    line-height: 18px;
    position: relative;
    z-index: 2;
    text-decoration: none;
}
.profile-item-name-class .btn-viewcompus:hover {
    color: #0b3454;
    text-decoration: underline;
}
.psychology-item {
    text-align: center;
    width: 245px;
    height: 196px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-top: 10px;
}
.owl-item:not(:last-child) .psychology-item {
    border-right: 1px solid #d2d2d2;
}
.popularCollegesslider .owl-item.active + .owl-item.active + .owl-item.active + .owl-item.active .psychology-item {
    border-right: 0px solid #d2d2d2;
}
.psychology-item-img {
    text-align: center;
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
    height: 90px;
    align-items: center;
}
.psychology-item-name h3 {
    font-size: 16px;
    font-weight: 600;
    margin: 0 0 5px;
    line-height: 17px;
}
.psychology-item-name p {
    font-size: 14px;
    font-style: italic;
    font-weight: 500;
    line-height: 20px;
}
.alumni_directory_details .btn-working {
    font-size: 13px;
    color: #1452ce;
    font-weight: 500;
    line-height: 18px;
    position: relative;
    z-index: 2;
    text-decoration: none;
}
.alumni_directory_details .btn-working:hover {
    color: #0b3454;
    text-decoration: underline;
}
.tooltip-viewcompus .tooltip-inner {
    background: #3b3b3b;
    border-color: #3b3b3b;
}
.tooltip-working .tooltip-inner {
    display: flex;
    flex-direction: column;
    padding: 15px;
    background: #3b3b3b;
    border-color: #3b3b3b;
}
.tooltip-working .tooltip-inner .logo {
    position: relative;
    font-size: 20px;
}
.tooltip-working .tooltip-inner span.logo + span {
    font-size: 16px;
}
.tooltip-working.bs-tooltip-top .tooltip-arrow::before {
    border-top-color: #3b3b3b;
}
.tooltip-working.bs-tooltip-bottom .tooltip-arrow::before {
    border-bottom-color: #3b3b3b;
}
.tooltip-working.bs-tooltip-end .tooltip-arrow::before {
    border-right-color: #3b3b3b;
}
.tooltip-working.bs-tooltip-start .tooltip-arrow::before {
    border-left-color: #3b3b3b;
}
.alumni_name_brife > div {
    align-items: center;
}
.alumni_name_brife > div .sep {
    margin: 0 6px;
    color: #1452ce;
}
.custom_badge {
    display: inline-block;
    border: 1px solid #dedede;
    height: 32px;
    line-height: 32px;
    padding: 0 16px;
    border-radius: 18px;
    font-size: 14px;
    font-weight: 500;
    color: #0b3454;
    margin: 0 5px 10px 0;
    background: #fff;
    overflow: hidden;
}
.custom_badge .icon {
    margin-right: 5px;
}
.delete_confirm .icon-cross {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 1px solid red;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #e94e58;
}
.delete_confirm .del_text {
    margin: 20px 0 10px;
    text-align: center;
    max-width: 240px;
    font-size: 28px;
    line-height: 36px;
    font-weight: 500;
    width: 100%;
}
.delete_confirm .btn-delete {
    background: #d52941;
    border-radius: 31px;
    border: 0;
    height: 36px;
    color: #fff;
    padding: 0 20px;
    font-weight: 600;
    font-size: 14px;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.delete_confirm .btn-delete:hover {
    background: #a0182b;
}
.selected_options ul {
    display: flex;
    list-style: none;
    margin: 0;
    padding: 0;
}
.selected_options ul li {
    background: #f7fbff;
    border: 1px solid #0b34544d;
    border-radius: 18px;
    height: 35px;
    display: flex;
    align-items: center;
    padding: 0 18px;
    margin: 12px 12px 6px 0;
    font-size: 16px;
    font-weight: 500;
}
.selected_options ul li .icon-cross {
    font-size: 9px;
    margin: 2px 0 0 10px;
    text-decoration: none;
    color: #000;
}
.selected_options ul li .icon-cross:hover {
    text-decoration: none;
    color: #333;
}
.question .form-select.w-90 {
    width: 90px !important;
    max-width: 90px;
}
.custom_row_title {
    margin-bottom: 10px;
    font-weight: 400;
    font-size: 20px;
}
.custom_row_title span {
    font-weight: 600;
}
.custom_row_block .program {
    font-size: 20px;
}
.custom_row_block .program span {
    font-weight: 500;
}
.program-time-interest {
    color: #414141;
    font-size: 16px;
    line-height: 20px;
}
.custom_row_block {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
}
.custom_row_block .icon {
    width: 55px;
    height: 55px;
    border-radius: 50%;
    background: #0b3454;
    margin-right: 15px;
    position: relative;
}
.custom_row_block .icon.icon-hat:before {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/hat_alumni.svg) no-repeat 0 0 /26px;
    width: 26px;
    height: 20px;
    display: inline-block;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    position: absolute;
    filter: invert(1);
    -webkit-filter: invert(1);
}
.custom_row_block .icon + div {
    width: calc(100% - 70px);
}
.custom_row {
    width: 100%;
    border-top: 1px solid #dbdbdb;
    padding-top: 20px;
}
.custom_row:not(:last-child) {
    padding-bottom: 20px;
}
.radius_block {
    background: #ffffff;
    border: 1px solid #c7c7c7;
    border-radius: 30px;
    height: 60px;
    padding: 0 30px;
    display: flex;
    align-items: center;
    font-size: 20px;
    line-height: 20px;
    font-weight: 500;
}
.radius_block span {
    margin-right: 30px;
}
.radius_block i {
    font-size: 24px;
}
.radius_block i.gray {
    color: #8599a9;
}
.radius_block i.green {
    color: #5dae48;
    background-color: transparent !important;
}
.radius_block.yes {
    background: #5dae48;
    border-color: #5dae48;
    color: #fff;
}
.radius_block.yes span {
    margin: 0 20px;
}
.radius_block.no {
    background: #c7c7c7;
    color: #333;
}
.radius_block.no span {
    margin: 0 20px;
}
.universities_block {
    background: #ffffff;
    border: 1px solid #c7c7c7;
    border-radius: 30px;
    height: 60px;
    padding: 0 8px;
    display: flex;
    align-items: center;
    font-size: 20px;
    line-height: 26px;
    font-weight: 500;
    -webkit-border-radius: 30px;
    -moz-border-radius: 30px;
    -ms-border-radius: 30px;
    -o-border-radius: 30px;
}
.universities_block .logo {
    width: auto;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 15px;
    border-radius: 50%;
    overflow: hidden;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    -ms-border-radius: 50%;
    -o-border-radius: 50%;
}
.universities_block span {
    font-size: 20px;
    margin-right: 15px;
    line-height: 20px;
}
.logo.no_logo {
    width: 40px;
    border: 1px solid #cad6df;
}
.edit_section {
    font-size: 0;
}
.edit_section_toggle,
.custom-btns a.edit_section_toggle {
    display: none;
    width: 20px;
    height: 20px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
    background-repeat: no-repeat;
    background-position: center;
    background-size: 20px 20px;
}

@media (max-width: 1199px) {
    .alumni_profile_college_name_other_detail_wrap {
        padding: 0 0 0 50px;
    }
}

@media (max-width: 1130px) {
    .alumni_profile_brife_tab {
        overflow: auto;
        scrollbar-width: thin;
        padding-bottom: 10px;
        margin-bottom: 10px;
    }
    .alumni_profile_brife_tab::-webkit-scrollbar {
        height: 4px;
    }
    .alumni_profile_brife_tab::-moz-scrollbar {
        height: 4px;
    }
    .alumni_profile_brife_tab::-webkit-scrollbar-track {
        background: #ccc;
    }
    .alumni_profile_brife_tab::-webkit-scrollbar-thumb {
        background-color: #666;
        border-radius: 20px;
        border: 2px solid #666;
    }
    .alumni_profile_brife_tab .nav {
        justify-content: start;
        flex-wrap: nowrap;
    }
}

@media (max-width: 1099px) {
    .alumni_profile_college_name_other_detail_wrap {
        padding: 0 0 0 30px;
    }
    .alumni_profile_image_name_other_detail {
        padding: 0 30px;
        width: 45%;
    }
    .alumni_profile_college_name_other_detail_wrap .alumni_profile_college_name_other_detail {
        flex-direction: column;
    }
    .alumni_profile_college_name_detail {
        padding: 0 0 21px;
    }
    .alumni_profile_status {
        display: flex;
        -webkit-box-wrap: wrap;
        -moz-box-wrap: wrap;
        -ms-flex-wrap: wrap;
        -webkit-wrap: wrap;
        flex-wrap: wrap;
    }
    .alumni_profile_status li {
        margin-right: 16px;
    }
    .alumni_profile_name_other_detail h2 {
        line-height: 30px;
    }
    .college_name_scholarship .college_name {
        width: 100%;
        margin-bottom: 10px;
    }
}
@media (max-width: 1035px) {
    .college_name_scholarship {
        flex-direction: column;
        align-items: start;
    }
    .graduateRow .college_detail_wrap .scholarship {
        margin-top: 10px;
    }
    .graduateRow .offer {
        justify-content: start;
        padding-top: 13px;
    }
}

@media (min-width: 992px) and (max-width: 1150px) {
    .filter_result_title {
        flex-direction: column;
    }
    .alumni_count {
        text-align: right;
    }
    .alumni_class_link {
        flex-direction: column;
    }
    .alumni_class_link .send_link {
        padding: 10px 0 0 70px;
    }
}

@media (max-width: 991px) {
    .alumni-directorySearch {
        width: 230px;
    }
    .alumni_profile_name_college_other_detail_wrap {
        flex-direction: column;
    }
    .alumni_profile_image_name_other_detail {
        width: 100%;
        padding-bottom: 45px;
        margin-bottom: 45px;
    }
    .alumni_profile_image_name_other_detail::after {
        content: '';
        width: 100%;
        height: 1px;
        background: #d4d4d4;
        position: absolute;
        right: auto;
        top: auto;
        bottom: 0;
        left: 0;
    }
    .alumni_profile_college_name_other_detail_wrap {
        padding: 0;
    }
    .alumni_profile_college_name_other_detail_wrap .alumni_profile_college_name_other_detail {
        flex-direction: row;
    }
    .alumni_profile_brife_tab .nav-item:not(:last-child) {
        margin-right: 7px;
    }
    .card_profiles {
        overflow: visible;
        max-height: initial;
    }
}

@media (max-width: 950px) {
    .showProfiles_left {
        flex-direction: column;
        align-items: start;
        flex: 1 1;
    }
    .showProfiles_left h3 {
        margin: 0 0 10px;
    }
}

@media (max-width: 875px) {
    .graduateRow {
        flex-direction: column;
    }
    .graduateRow .college_detail_wrap {
        width: 100%;
    }
    .graduateRow .offer {
        width: 100%;
    }
    .college_name_scholarship {
        flex-direction: row;
        align-items: start;
    }
    .graduateRow .college_detail_wrap {
        width: 100%;
        padding: 0 0 20px;
        margin-bottom: 20px;
    }
    .graduateRow .college_detail_wrap::after {
        top: auto;
        right: 0;
        width: 75px;
        height: 2px;
        bottom: 0;
    }
    .graduateRow .offer {
        padding: 0;
        align-items: start;
    }
    .graduateRow .college_detail_wrap::after {
        right: auto;
        bottom: 0;
        left: 0;
    }
    .graduateRow.edit .college_detail_wrap {
        width: 100%;
    }
    .graduateRow .offer.offer_edit {
        flex-direction: row;
        align-items: center;
        width: 100%;
        justify-content: start;
    }
    .graduateRow .offer .offer_existing_links {
        align-items: start;
    }
}

@media (max-width: 820px) {
    .graduation_carousel_wrap {
        padding: 20px;
    }
    .graduationslider .meter {
        padding: 10px 15px;
        margin: 15px 0 10px 0px;
        font-size: 16px;
    }
    .postGraduate-detail {
        padding: 0;
        background: none;
        box-shadow: none;
        border: 1px solid #d2d2d2;
        overflow: hidden;
    }
    .postGraduate-detail .graduateRow {
        padding: 20px;
        background: #fff;
    }
    .graduation-title {
        margin: 0;
        background: #eff8ff;
        border-radius: 6px 6px 0px 0px;
        padding: 20px;
        text-align: center;
        line-height: 22px;
    }
    .graduation_carousel_wrap .seactionheader {
        margin: 0 0 15px;
        flex-direction: column;
        align-items: inherit;
    }
    .graduation_carousel_wrap .seactionheader .countnbtn {
        width: 100%;
        margin-top: 13px;
        justify-content: space-between;
    }
    .graduation_carousel_wrap .seactionheader h3 {
        width: auto;
        margin: -20px -20px 0;
        background: #eff8ff;
        border-radius: 6px 6px 0px 0px;
        padding: 20px;
        text-align: center;
        line-height: 22px;
    }
    .workExperience-detail .workExperience-title {
        width: auto;
        margin: 0;
        background: #eff8ff;
        border-radius: 6px 6px 0px 0px;
        padding: 20px;
        text-align: center;
        line-height: 22px;
    }
    .workExperience-detail {
        padding: 0px;
        overflow: hidden;
    }
    .workExperienceRow {
        padding: 25px;
    }
    .skills-block-title {
        margin: 0 0 20px;
        width: auto;
        margin: -40px -40px 20px;
        background: #eff8ff;
        border-radius: 6px 6px 0px 0px;
        padding: 20px;
        text-align: center;
        line-height: 22px;
    }
    .skills-block-title h2 {
        background: no-repeat;
        padding: 0;
        text-align: left;
    }
    .preferences-block {
        padding: 30px;
    }
    .preferences-block-title {
        width: auto;
        margin: -30px -30px 0px;
        background: #eff8ff;
        border-radius: 6px 6px 0px 0px;
        padding: 20px;
        line-height: 22px;
    }
    .custom_row:first-child {
        border: 0;
    }
    .achievements-block-title {
        background: #eff8ff;
    }
    .underGraduate-detail .main_title,
    .blockHeader {
        background: #eff8ff;
    }
    .graduateRow {
        background: #fff;
    }
    .postGraduate-detail .blockHeader {
        margin: 0;
    }
    .workExperience-detail .blockHeader {
        margin: 0;
    }
}

@media (min-width: 767px) {
    .nolisting_wrap .nolisting {
        max-width: 850px;
        margin: auto;
        border: 0;
        display: flex;
        flex-wrap: wrap;
        text-align: left;
        padding-bottom: 10px;
    }
    .nolisting_text {
        flex: 1 1;
        display: flex;
        flex-direction: column;
        align-items: start;
    }
    .nolisting_icon {
        margin-right: 40px;
    }
}

@media (max-width: 767px) {
    .alumni_directory_filter {
        padding: 18px 0;
        padding-right: var(--bs-gutter-x, 0.75rem);
        padding-left: var(--bs-gutter-x, 0.75rem);
    }
    .alumni-directory-header_search {
        flex-direction: column;
        align-items: start;
    }
    .alumni-directory-header_search h2 {
        margin-bottom: 15px !important;
    }
    .alumni-directory-header {
        align-items: end;
    }
    .filter_result_title {
        flex-direction: column;
    }
    .filter_result_title .filter_result {
        display: none;
    }
    .alumni_count {
        text-align: right;
        margin: 0;
    }
    .alumni_directory_filter .fiterItem {
        width: 170px;
        margin: 0 !important;
        box-shadow: none;
        border: 0;
        border-radius: 0;
        border-bottom: 1px solid #e6e6e6 !important;
        min-height: 45px;
    }
    .alumni_directory_filter .filters {
        padding: 0;
        display: flex !important;
        flex-direction: column;
    }
    .alumni_directory_filter .filters > div:first-child {
        padding: 15px 20px;
        border-bottom: 1px solid #dbdbdb;
    }
    .alumni_directory_filter .filters-head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: auto;
        padding: 0 15px;
        box-shadow: 0px 0px 3px 0px #ccc;
        position: relative;
        z-index: 1;
    }
    .alumni_directory_filter .filters-head + #accordionFilters {
        flex: 1 1;
        position: relative;
        background: #f5f5f5;
    }
    .alumni_directory_filter .filters #accordionFilters {
        flex: 1 1;
        margin: 0;
        position: relative;
    }
    .alumni_directory_filter .filters #accordionFilters::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        width: 170px;
        background: #f5f5f5;
    }
    .alumni_directory_filter .filters > #accordionFilters > .filterGroup.mt-3 {
        margin: 0 !important;
        flex-direction: column;
        height: 100%;
        position: relative;
    }
    .alumni_directory_filter .fiterItem .filterHeader > div {
        border-radius: 0;
    }
    .alumni_directory_filter .fiterItem .filterHeader > div button {
        background: #f5f5f5;
        border-radius: 0;
        padding: 10px;
        color: #000;
    }
    .alumni_directory_filter .fiterItem .filterHeader > div button .toggle {
        display: none;
    }
    .alumni_directory_filter .fiterItem .filterHeader > div button .font-18.font-600 {
        font-size: 16px !important;
        font-weight: 500 !important;
    }
    .additionalfilter_wrap {
        width: 170px;
        padding: 0;
        margin: 0 !important;
    }
    /* .btn-additionalfilter {display: none;} */
    .additionalfilter_wrap > #additionalfilter {
        display: block !important;
    }
    .alumni_directory_filter .fiterItem .filterHeader + div {
        position: absolute;
        right: 0;
        top: 0;
        padding: 0;
        bottom: 0;
        width: calc(100% - 170px);
        padding: 15px;
        overflow: auto;
        background: #fff;
    }
    .alumni_directory_filter .filterGroup {
        margin: 0 !important;
    }
    .alumni_directory_filter .filterGroup.mt-3 {
        margin: 0 !important;
        display: flex;
        flex-direction: column;
        height: 100%;
    }
    .filter_close_apply {
        background: #ffffff;
        border-top: 1px solid #e9e9e9;
        padding: 15px 20px;
        justify-content: center;
        align-items: center;
    }
    .filter_close_apply > a.btn-filter-apply {
        padding: 8px 30px;
        background: #5cae48;
        border-radius: 3px;
        text-decoration: none;
        color: #fff;
        margin: 0 15px;
        font-weight: 500;
        text-transform: uppercase;
        transition: all 0.3s ease-in-out;
    }
    .filter_close_apply > a.btn-filter-apply:hover {
        background: #448e32;
        color: #fff;
    }
    .filter_close_apply > a.btn-filter-close {
        text-decoration: none;
        text-transform: uppercase;
        color: #979797;
        font-weight: 500;
        transition: all 0.3s ease-in-out;
        margin: 0 15px;
    }
    .filter_close_apply > a.btn-filter-close:hover {
        color: #666262;
    }
    .alumni_directory_filter .showProfiles_right {
        margin-left: 12px;
    }
    .alumni_directory_filter .filterSearchblk {
        background: #fff;
        padding: 0 0 10px;
    }
    .alumni_directory_filter .fiterItem .card {
        padding: 0px 0px 15px;
    }
    .alumni_directory_filter .fiterItem .filterHeader > div button[aria-expanded='true'] {
        pointer-events: none;
        color: #1452ce;
    }
    .alumni_directory_filter .scrollMe {
        max-height: initial;
        min-height: initial;
    }
    .additionalfilter_count {
        display: block;
        letter-spacing: 2px;
    }
    .additionalfilter_count:before {
        content: '(';
    }
    .additionalfilter_count:after {
        content: ')';
    }
    .alumni_directory_filter .mobileFilter .btn-filter .icon-filter + span {
        flex: 1 1;
        text-align: left;
    }
    .alumni_directory_filter .mobileFilter .btn-filter .icon-filter + span + span {
        display: flex;
        -webkit-box-wrap: wrap;
        -moz-box-wrap: wrap;
        -ms-flex-wrap: wrap;
        -webkit-wrap: wrap;
        flex-wrap: wrap;
        align-items: center;
        color: #b92940;
        font-size: 14px;
    }
    .alumni_directory_filter .mobileFilter .btn-filter {
        display: flex;
        align-items: center;
    }
    .alumni_directory_filter .mobileFilter .btn-filter .icon-filter + span + span .icon-right-arrow {
        font-size: 15px;
        transform: rotate(270deg);
        margin-left: 10px;
        color: #000;
        transition: all 0.3s ease-in-out;
    }
    .alumni_directory_filter .mobileFilter .btn-filter[aria-expanded='false'] .icon-right-arrow {
        transform: rotate(90deg) !important;
    }
    #filter_collapse h3 {
        pointer-events: none;
    }
    .alumni_directory_filter {
        background: #f3f3f3;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 99;
        box-shadow: 0 0 5px 0px #cacaca;
    }
    .alumni_directory_filter .filters.show {
        transform: translate3d(0, 100%, 0);
    }
    .alumni_profile_image_name_other_detail {
        width: 100%;
        padding-bottom: 30px;
        margin-bottom: 30px;
    }
    .alumni_profile_college_name_other_detail_wrap .alumni_profile_college_name_other_detail {
        flex-direction: column;
    }
    .nolisting_wrap .nolisting {
        border: 0;
        padding: 20px 0 10px;
    }
    .nolisting_text {
        text-align: center;
        justify-content: center;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .edit_section {
        position: absolute;
        right: 20px;
        top: 5px;
    }
    .countnbtn .edit_section {
        position: relative;
        left: auto;
        right: auto;
        top: 0;
        margin-left: 5px;
    }
    .skills-block .edit_section {
        top: 22px;
    }
    .edit_section .edit_section_toggle {
        display: inline-block;
    }
    .custom-btns a.edit_section_toggle {
        display: inline-block;
    }
    .edit_section .edit_section_inner {
        position: absolute;
        top: 50px;
        right: 0;
        background: #fff;
        box-shadow: 0px 0px 5px #57555533;
        display: flex;
        flex-direction: column;
        width: 100px;
        border-radius: 6px;
        overflow: hidden;
        opacity: 0;
        z-index: -1;
        transition: all 0.3s ease-in-out;
        -webkit-transition: all 0.3s ease-in-out;
        -moz-transition: all 0.3s ease-in-out;
        -ms-transition: all 0.3s ease-in-out;
        -o-transition: all 0.3s ease-in-out;
    }
    .edit_section.open .edit_section_inner {
        top: 30px;
        opacity: 1;
        z-index: 9;
    }
    .edit_section .edit_section_inner a {
        width: 100% !important;
        border-radius: 0 !important;
        padding: 0 0 0 30px;
        font-size: 14px;
        text-decoration: none;
        color: #000;
        line-height: 33px;
        height: 35px !important;
        background: #fff !important;
        position: relative;
        opacity: 1;
        margin: 0 !important;
        -webkit-border-radius: 0 !important;
        -moz-border-radius: 0 !important;
        -ms-border-radius: 0 !important;
        -o-border-radius: 0 !important;
        opacity: 1 !important;
    }
    .edit_section .edit_section_inner a:hover {
        color: #fff;
        background-color: #0b3454 !important;
    }
    .edit_section .edit_section_inner a.edit_link:before {
        width: 16px;
        height: 16px;
        margin: 0;
        background-size: 14px;
        left: 7px;
        top: 8px;
    }
    .edit_section .edit_section_inner a:first-child {
        border-bottom: 1px solid #eee;
    }
    .edit_section .edit_section_inner a.del_link:before {
        content: '';
        background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/delete.svg) no-repeat center /
            14px auto;
        width: 14px;
        height: 16px;
        position: absolute;
        left: 8px;
        top: 8px;
    }
    .edit_section .edit_section_inner a.del_link:hover {
        background: #0b3454;
        color: #fff;
    }
    .edit_section .edit_section_inner a.del_link:hover:before {
        filter: invert(92%) sepia(100%) saturate(0%) hue-rotate(202deg) brightness(106%) contrast(106%);
        -webkit-filter: invert(92%) sepia(100%) saturate(0%) hue-rotate(202deg) brightness(106%) contrast(106%);
    }
    .graduateRow .college_detail_wrap .scholarship {
        margin-right: 60px;
    }
    .achievements-block-detail .edit_section {
        top: 4px;
        right: 0;
    }
    .achievements-block-detail {
        padding-right: 25px;
    }
    .postGraduate-detail .graduateRow .offer.offer_edit .edit_section {
        top: 20px;
    }
    .work-block .edit_section {
        right: 0;
    }
    .work-block .work-detail {
        padding-right: 24px;
    }
    .directory_wrap {
        position: fixed;
        width: 100%;
        height: 100%;
        top: 100%;
        bottom: auto;
        left: 0;
        right: 0;
        margin: auto;
        background: white;
        display: flex;
        flex-direction: column;
        transition: all 0.3s ease-in-out;
        -webkit-transition: all 0.3s ease-in-out;
        -moz-transition: all 0.3s ease-in-out;
        -ms-transition: all 0.3s ease-in-out;
        -o-transition: all 0.3s ease-in-out;
    }
    .directory_wrap.open {
        top: 0;
        bottom: 0;
    }
}

@media (min-width: 575px) and (max-width: 767px) {
    .filter_result_title {
        flex-direction: column;
    }
    .alumni_count {
        text-align: right;
    }
    .alumni_class_link {
        flex-direction: column;
    }
    .alumni_class_link .send_link {
        padding: 10px 0 0 70px;
    }
}

@media (max-width: 575px) {
    .alumni-directory-header {
        flex-direction: column;
    }
    .alumni-directory-header_search {
        flex-direction: row;
        width: 100%;
        margin-bottom: 20px;
        justify-content: space-between;
        overflow: hidden;
        align-items: center;
    }
    .alumni-directory-header_search h2 {
        margin-bottom: 0 !important;
    }
    .alumni-directorySearch-wrap {
        position: relative;
    }
    .alumni-directorySearch-wrap .alumni-directorySearch {
        position: absolute;
        right: -230px;
        transition: all 0.3s ease-in-out;
    }
    .alumni-directorySearch-wrap.show .alumni-directorySearch {
        right: 0;
    }
    .btn-alumniSearchToggle.icon-search {
        width: 40px;
        height: 40px;
        background: #fff;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        text-decoration: none;
        color: #000;
        font-size: 12px;
    }
    .alumni-directorySearch .form-control + .btn-cross {
        opacity: 1;
        right: 15px;
        transform: rotate(135deg);
    }
    .alumni-switch-container {
        margin: auto;
    }
    .alumni-directorySearch .form-control {
        padding-right: 40px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
    .alumni_profile_image_name_other_detail {
        padding: 0 0 20px;
        margin-bottom: 20px;
    }
    .alumni_profile_college_name_other_detail .alumni_profile_other_detail {
        margin: 0 0 0 -98px;
    }
    .alumni_profile_status li {
        width: 47%;
        margin-bottom: 0;
    }
    .alumni_profile_status li:last-child {
        margin-right: 0;
    }
    .alumni_profile_image {
        width: 80px;
        height: 80px;
    }
    .alumni_profile_name_other_detail h2 {
        line-height: 30px;
        font-size: 24px;
    }
    .alumni_profile_college_name_other_detail_wrap .alumni_profile_college_logo {
        width: 80px;
        height: 80px;
    }
    .alumni_profile_brife {
        padding: 20px 0 10px;
    }
    /*.graduateRow .college_detail_wrap .college_detail {  flex-direction: column;align-items: center;}*/
    .graduateRow .college_detail_wrap .college_detail {
        padding-right: 25px;
    }
    .graduateRow {
        margin-left: -20px;
        margin-right: -20px;
        width: auto;
        padding: 5px 20px;
    }
    .graduateRow .college_detail_wrap .college_detail .college_logo {
        margin: 0 10px 10px 0;
        width: 70px;
        height: 70px;
        border-radius: 50%;
    }
    .graduateRow .college_name_scholarship {
        flex-direction: column;
        align-items: start;
        justify-content: start;
        text-align: left;
        width: calc(100% - 80px);
    }
    .graduateRow .college_detail_wrap .college_detail h3 {
        font-size: 19px;
        line-height: 20px;
    }
    .alumni_profile_college_subject {
        padding: 0 15px;
        font-size: 15px;
    }
    .graduateRow .college_detail_wrap .scholarship {
        flex-direction: row;
    }
    .graduateRow .college_detail_wrap .scholarship .scholarship_label {
        margin-right: 7px;
    }
    .graduateRow .college_detail_wrap::after {
        right: 0;
        bottom: 0;
        left: 0;
        margin: auto;
        width: 100%;
        height: 1px;
    }
    .graduateRow .offer {
        align-items: center;
        flex-direction: row;
        justify-content: center;
    }
    .graduateRow:not(:last-child) {
        margin-bottom: 15px;
        padding-bottom: 20px;
    }
    .underGraduate-detail {
        padding: 20px;
        box-shadow: none;
    }
    .workExperience-detail {
        padding: 0px;
    }
    .workExperienceRow {
        padding: 20px 20px 30px;
    }
    .achievements-block {
        flex-direction: column;
    }
    .achievements-icon-block {
        border-right: 0;
        margin: 0 0 18px;
        padding: 0 0 18px;
        border-bottom: 1px solid #cecece;
    }
    .achievements-block-detail {
        text-align: center;
    }
    .achievements-block-detail h3 {
        margin: 0;
    }
    .contributions-block .seactionheader {
        margin: 0px 0 20px;
        flex-direction: column;
        align-items: inherit;
    }
    .contributions-block .seactionheader > h3 {
        width: auto;
        margin: -20px -20px 0;
        background: #eff8ff;
        border-radius: 6px 6px 0px 0px;
        padding: 20px;
        text-align: center;
        line-height: 22px;
    }
    .contributions-block .seactionheader .countnbtn {
        width: 100%;
        margin-top: 10px;
        align-items: center;
        justify-content: space-between;
        position: relative;
    }
    .contributions-block .seactionheader .countnbtn .custom-btns {
        padding-right: 0;
    }
    .contributions-block .seactionheader .countnbtn .custom-btns .edit_section {
        right: 0;
        top: 0px;
    }
    .contributions-block {
        padding: 20px;
    }
    .skills-block {
        padding: 20px;
    }
    .skills-block:first-child {
        padding-bottom: 5px;
    }
    .skills-block.EntranceExam-skills-block {
        padding-bottom: 25px;
    }
    .skills-block h2 {
        margin: 0 0 20px;
        width: auto;
        margin: -20px -20px 20px;
        background: #eff8ff;
        border-radius: 6px 6px 0px 0px;
        padding: 20px;
        text-align: center;
        line-height: 22px;
    }
    .skills-block-detail .meter {
        font-size: 18px;
        align-items: center;
        padding: 10px 20px;
        line-height: 18px;
    }
    .card_profiles figure.student {
        position: absolute;
        left: 15px;
        top: 15px;
    }
    .card_profiles .student_details h2 {
        margin: 0 0 10px 90px;
    }
    .card_profiles .btn-send {
        position: static;
        margin-left: 90px;
    }
    .card_profiles .student_details .sub_details {
        margin-top: 15px;
    }
    .card_profiles .student_details .sub_details span.course {
        line-height: 15px;
    }
    .contributions-block .act_lst {
        padding: 15px;
    }
    .contributions-block .act_lst .postedtxt {
        text-align: left;
        position: absolute;
        top: 15px;
        white-space: nowrap;
        right: 15px;
    }
    .graduateRow .offer > a {
        margin: 0 10px 0 0;
    }
    .graduateRow .offer div.got_offer {
        margin-right: 15px;
        width: calc(100% - 173px);
        align-items: center;
        display: flex;
        margin-bottom: 0 !important;
        text-align: left;
        flex: 1 1;
        justify-content: center;
        line-height: 18px;
    }
    .graduateRow .offer .offer_joined {
        align-items: start;
        width: 158px;
        align-items: center;
        display: flex;
        margin-bottom: 0 !important;
        line-height: 16px;
    }
    .graduateRow .offer .offer_joined i {
        margin-right: 8px;
    }
    .contributions-block .act_lst > .row > div:last-child .btn-green {
        width: 135px;
    }
    .contributions-block .act_lst .btn-dark-blue {
        width: 135px;
    }
    .contributions-block .listblk_icon {
        margin-bottom: 0;
        width: 34px;
        height: 34px;
    }
    .contributions-block .act_lst .postedrow > div:last-child {
        width: 100% !important;
        display: flex;
        flex-direction: row-reverse;
        align-items: center;
        border-top: 1px solid #d1d1d1;
        padding-top: 10px;
        margin-top: 8px;
    }
    .act_lst > .row.postedrow > div:last-child > div:first-child {
        width: calc(100% - 190px);
        margin: 0 0 0 15px;
        align-items: center;
    }
    .alumni_class_link {
        align-items: center;
    }
    .filter_result_title {
        margin-bottom: 12px;
    }
    .contributions-block .album_shareblk {
        padding: 5px 0 0 0px;
    }
    .profile-item,
    .psychology-item {
        width: 100%;
        border: 0 !important;
    }
    /*.user_id {	bottom: 0;}*/
    .skills-block-title {
        margin: 0 0 20px;
        width: auto;
        margin: -20px -20px 20px;
        background: #eff8ff;
        border-radius: 6px 6px 0px 0px;
        padding: 20px;
        text-align: center;
        line-height: 22px;
    }
    .skills-block-title h2 {
        padding: 0;
        text-align: left;
    }
    #edit_Higher_Education .question {
        padding-right: 20px;
    }
    #job_Preferences .question {
        padding-right: 20px;
    }
    .underGraduate-detail .main_title,
    .blockHeader {
        margin: -20px -20px 30px;
        padding: 20px;
    }
    .graduateRow .offer .offer_existing_links {
        width: 100%;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }
    .graduateRow .offer .got_offer {
        margin-right: 10px;
    }
    .graduateRow .offer a.joindeLink {
        margin: 0 10px 0 0;
    }
    .powerby {
        margin: auto;
    }
    .graduateRow .offer.offer_edit .edit_section {
        top: 10px;
    }
    .postGraduate-detail .graduateRow {
        margin: 0;
    }
    .alumni_profile_college_name_detail {
        width: 100%;
    }
}

@media (max-width: 480px) {
    .card_profiles.card_profiles_pg > div {
        flex-direction: column;
        display: flex;
    }
}

@media (max-width: 400px) {
    .graduateRow .offer.offer_edit {
        flex-direction: column;
        align-items: start;
    }
    .graduateRow .offer.offer_edit .edit_section {
        margin: 0;
    }
}

input[type='search']::-webkit-search-decoration,
input[type='search']::-webkit-search-cancel-button,
input[type='search']::-webkit-search-results-button,
input[type='search']::-webkit-search-results-decoration {
    -webkit-appearance: none;
}
header + .relevantAlumniMatch {
    display: none;
}
.relevantAlumniMatch {
    background: transparent linear-gradient(93deg, #fff7f8 0%, #ffe6ea 100%);
    box-shadow: 0px 10px 20px #ffebee;
    border: 1px solid #fdd3da;
    border-radius: 8px;
    padding: 15px 20px;
    margin-bottom: 20px;
    position: relative;
}
.relevantAlumniMatch p {
    font-size: 20px;
    margin: 0;
    font-weight: 500;
    line-height: 22px;
}
.relevantAlumniMatch .btn-complete-now {
    border: 1px solid #d42941;
    border-radius: 25px;
    width: 160px;
    height: 40px;
    background: #fff;
    color: #000;
    font-size: 16px;
    line-height: 16px;
    font-weight: 500;
    margin-right: 23px;
    transition: all 0.3s ease-in-out;
}
.relevantAlumniMatch .btn-complete-now:before {
    display: none;
}
.relevantAlumniMatch .btn-complete-now:hover {
    background: #d42941;
    color: #fff;
}
.relevantAlumniMatch .btn-close {
    font-size: 10px;
}

@media (max-width: 767px) {
    .relevantAlumniMatch .btn-close {
        font-size: 10px;
        position: absolute;
        top: 13px;
        right: 10px;
    }
}
.pencil-edit {
    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/draw.svg);
    background-repeat: no-repeat;
    background-position: center;
    background-size: 17px;
    width: 17px;
    height: 17px;
    display: inline-block;
}
.alumni_profile_image_name_other_detail .pencil-edit {
    position: absolute;
    right: 30px;
    top: 10px;
}
.verifynow {
    border: 2px solid #d52941;
    padding: 2px 14px;
    border-radius: 25px;
    text-decoration: none;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.3s ease-in-out;
    height: 30px;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    -webkit-border-radius: 25px;
    -moz-border-radius: 25px;
    -ms-border-radius: 25px;
    -o-border-radius: 25px;
}
.verifynow:hover {
    background: #d52941;
    color: #fff;
}
.alumni_profile_image_name_other_detail .btnverified {
    background: #5cae48;
    border: 0;
    padding: 0 22px;
    width: auto;
    font-size: 14px;
}
.alumni_profile_image_name_other_detail .btnverified:hover {
    background: #439130;
    color: #fff;
}
.alumni_profile_image_name_other_detail .btnverified:hover .icon-varified {
    color: #fff !important;
}
.btn-back-dismiss {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
    background-repeat: no-repeat;
    background-position: center;
    background-size: 50px 32px;
    width: 20px;
    height: 15px;
    margin: 5px 5px 0 0px;
}
#delete_confirm_pop {
    z-index: 9999;
}
.modal.show ~ .modal.show ~ .modal-backdrop {
    z-index: 9998;
    opacity: 0.7;
}
.headerRightSide > ul li .user_id {
    position: static;
    border-radius: 5px 5px 0 0;
    width: 100%;
    padding: 7px 15px;
    text-align: right;
    background: #eee;
    color: #000;
}
.username:hover div.user-dropdown::before {
    width: 0;
    height: 0;
    content: '';
    position: absolute;
    top: -5px;
    right: 10px;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid #d2d2d2;
}
/* New css */
.modal-dialog .modal-content .modal-header .btn-close {
    background-color: none;
    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/close.svg);
    width: 15px;
    padding: 0;
    font-size: 12px;
    margin-right: 10px;
    color: #000000;
    opacity: 2;
}
.modal-dialog .modal-content .modal-header .btn-close::before {
    display: none;
}
.icon-plus {
    position: relative;
    width: 20px;
    height: 20px;
}
.icon-plus::before,
.icon-plus::after {
    content: '';
    position: absolute;
    bottom: 0;
    top: 0;
    left: 0;
    right: 0;
    margin: auto;
    width: 2px;
    height: 10px;
    background: #fff;
}
.icon-plus::after {
    transform: rotate(90deg);
}
.icon-medal {
    width: 16px;
    height: 16px;
    display: inline-block;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
    background-size: cover;
}
.icon-dollor {
    width: 20px;
    height: 20px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/dollor.svg) no-repeat 0 0 / 100%;
    display: inline-block;
}
.icon-note {
    width: 16px;
    height: 20px;
    display: inline-block;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/document.svg) no-repeat 0 0 / 100%;
}
.top20 {
    top: 20px;
}
.top40 {
    top: 40px;
}
.right20 {
    right: 20px;
}
.z1 {
    z-index: 1;
}
.z2 {
    z-index: 2;
}
.z3 {
    z-index: 3;
}
.z4 {
    z-index: 4;
}
.z5 {
    z-index: 5;
}
.z6 {
    z-index: 6;
}
.z7 {
    z-index: 7;
}
.z8 {
    z-index: 8;
}
.z9 {
    z-index: 9;
}
.radius-25 {
    border-radius: 25px;
    -webkit-border-radius: 25px;
    -moz-border-radius: 25px;
    -ms-border-radius: 25px;
    -o-border-radius: 25px;
}
.radius-20 {
    border-radius: 20px;
    -webkit-border-radius: 20px;
    -moz-border-radius: 20px;
    -ms-border-radius: 20px;
    -o-border-radius: 20px;
}
.radius-15 {
    border-radius: 15px;
    -webkit-border-radius: 15px;
    -moz-border-radius: 15px;
    -ms-border-radius: 15px;
    -o-border-radius: 15px;
}
.radius-10 {
    border-radius: 10px;
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    -ms-border-radius: 10px;
    -o-border-radius: 10px;
}
.radius-5 {
    border-radius: 5px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    -ms-border-radius: 5px;
    -o-border-radius: 5px;
}
.skill-range .progress {
    height: 20px;
    max-width: 800px;
    width: 90%;
    border-radius: 25px;
}
.skill-range .progress .progress-bar {
    border-radius: 25px;
}
.green {
    background: #5cae48 !important;
}
#skillvideoslider {
    padding: 0 30px;
}
.owl-theme#skillvideoslider .owl-nav [class*='owl-'] {
    position: absolute;
    top: 37%;
    width: 10px;
    height: 10px;
    border-top: 2px solid #000;
    border-right: 2px solid #000;
    border-radius: 0;
    transform: rotate(45deg);
    font-size: 0;
}
.owl-theme#skillvideoslider .owl-nav [class*='owl-']:hover {
    background-color: transparent;
}
.owl-theme#skillvideoslider .owl-nav .owl-prev {
    left: 0;
    transform: scaleX(-1) rotate(45deg);
}
.owl-theme#skillvideoslider .owl-nav .owl-next {
    right: 0;
}
.owl-theme#skillvideoslider .owl-dots .owl-dot span {
    width: 16px;
    height: 16px;
    background: #fff;
    border: 1px solid #c2c2c2;
    margin: 0px 5px;
}
.owl-theme#skillvideoslider .owl-dots .owl-dot.active span,
.owl-theme#skillvideoslider .owl-dots .owl-dot:hover span {
    background: #fff;
    border: 0;
    box-shadow: 0 0 0 5px #0b3454 inset;
}
.small-line {
    position: relative;
}
.small-line:before {
    position: absolute;
    content: '';
    width: 40px;
    height: 2px;
    background: #2680eb 0% 0% no-repeat padding-box;
    border-radius: 100px;
    border-radius: 100px;
    bottom: -5px;
}
.benefitsBox {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
}
.benefitsBox li {
    width: 49%;
    border-radius: 10px;
    opacity: 1;
    min-height: 80px;
    margin-bottom: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    padding: 15px 30px;
}
.beige {
    background: #f6ebdf;
}
.lightGreen {
    background: #daf3e5;
}
.lime {
    background: #e4f7cd;
}
.lightsky {
    background: #d3f1f7;
}
ul.green-right {
    list-style: none;
    margin: 0 0 20px;
    padding: 0;
}
ul.green-right li {
    position: relative;
    padding-left: 30px;
    font-size: 16px;
    margin: 0 0 18px;
    font-family: 'Jost', sans-serif;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    justify-content: space-between;
}
ul.green-correct li:last-child {
    margin: 0;
}
ul.green-right li .rupee {
    line-height: 22px;
}
ul.green-right li::before {
    content: '';
    width: 18px;
    height: 16px;
    display: inline-block;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/15-checked.svg);
    position: absolute;
    left: 0px;
    top: 3px;
}
.btn-play {
    bottom: 20px;
    left: 20px;
    background: #fff;
    border-radius: 25px;
    width: 120px;
    height: 40px;
    padding: 8px;
    display: flex;
    align-items: center;
    z-index: 2;
    transition: all 0.3s ease-in-out;
    font-size: 16px;
    text-transform: uppercase;
    color: #000;
}
.btn-play .play-icon {
    width: 24px;
    height: 24px;
    position: relative;
    left: auto;
    right: auto;
    bottom: auto;
    top: auto;
    margin: auto;
    background: #000;
    display: inline-block;
    margin: 0 8px 0 0;
}
.btn-play .play-icon:after {
    border-left: 6px solid #fff;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    left: 10px;
    right: auto;
}
.video-btn:hover .btn-play {
    background: #5cae48;
    color: #fff;
}
.video-btn:hover .btn-play .play-icon {
    background: #fff;
}
.video-btn:hover .btn-play .play-icon:after {
    border-left: 6px solid #5cae48;
}
.play-icon {
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    margin: auto;
    width: 40px;
    height: 40px;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 50%;
    z-index: 2;
}
.play-icon::after {
    content: '';
    width: 0;
    height: 0;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border-top: 7px solid transparent;
    border-bottom: 7px solid transparent;
    border-left: 10px solid #fff;
    margin: auto;
}
.video-btn:hover img {
    transform: scale(1.1);
    transition: all 0.3s ease-in-out;
}
.video-btn:hover img {
    transform: scale(1.1);
    transition: all 0.3s ease-in-out;
}
.imgplace .video-btn:hover img {
    transform: scale(1.1);
    transition: all 0.3s ease-in-out;
}
.btn-submit {
    max-width: 200px;
    height: 45px;
    width: 100%;
    border: 0;
    border-radius: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    font-weight: 500;
    background: #5cae48;
    color: #fff;
    transition: all 0.5s ease-in-out;
    -webkit-transition: all 0.5s ease-in-out;
    -moz-transition: all 0.5s ease-in-out;
    -ms-transition: all 0.5s ease-in-out;
    -o-transition: all 0.5s ease-in-out;
    -webkit-border-radius: 25px;
    -moz-border-radius: 25px;
    -ms-border-radius: 25px;
    -o-border-radius: 25px;
    text-decoration: none;
}
.btn-submit:hover {
    background: #88bb1b;
    color: #fff;
    border-color: #88bb1b;
}
.info {
    background: #edf6fb;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 15px;
    font-family: sans;
    font-size: 30px;
    font-weight: 600;
    color: rgba(11, 52, 84, 0.8);
}
.rightcustomborder {
    padding: 0 30px 0 0;
    border-right: 1px solid #e3e3e3;
}
.s_no label {
    width: 32px;
    height: 32px;
    background: #0b3454;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
}
.s_no label {
    width: 32px;
    height: 32px;
    background: #0b3454;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
}
.skillBlock .form-check-input[type='radio'] + label {
    background: #ffffff 0% 0% no-repeat padding-box;
    border: 1px solid #0b345440;
    border-radius: 6px;
    opacity: 1;
    padding: 10px;
    height: 100%;
    width: 100%;
    cursor: pointer;
    text-align: center;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    -ms-border-radius: 6px;
    -o-border-radius: 6px;
}
.skillBlock .form-check-input[type='radio']:checked + label {
    background: #0b3454;
    border: 1px solid #0b3454 !important;
    color: #fff;
}
/* alumni_statistics starts */
.alumni_statistics .filters {
    position: static;
    padding-top: 0;
    padding-bottom: 0;
}
.alumni_statistics .filters .additionalfilters {
    font-size: 14px;
    text-transform: uppercase;
    text-decoration: underline;
    color: #26a7df;
    font-weight: 500;
}
.alumni_statistics .filters .apply_filters {
    font-size: 20px;
    font-weight: 600;
    text-transform: uppercase;
    background-color: #5bae47;
    border: 0;
    border-radius: 100px;
    padding: 10px 40px;
    width: 170px;
}
.alumni_statistics .filters .apply_filters:hover {
    background-color: #198754;
}
.alumni_statistics .filters .additionalfilters:hover {
    color: #5bae47;
}
.alumni_statistics .filters .form-search {
    background: url('https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/search.svg') no-repeat 15px;
    padding-left: 40px !important;
    background-size: 16px;
    max-width: 100%;
}
.alumni_statistics .filters .accordion-button {
    background: none;
    box-shadow: none;
    font-size: 24px;
    font-weight: 500;
    color: #000;
    padding: 25px;
    border-bottom: 1px solid #e6eaed;
}
.alumni_statistics .filters .accordion-item:last-of-type .accordion-button.collapsed {
    border-bottom: 0;
}
.alumni_statistics .filters .text-bg-primary {
    width: 40px;
    height: 40px;
    font-size: 16px;
    display: flex;
    align-items: center;
    background-color: #0b3454 !important;
    position: absolute;
    padding: 0;
    margin: 0;
    justify-content: center;
    font-weight: 400;
    right: 70px;
    top: 20px;
}
.alumni_statistics .filters .accordion-button img {
    margin-right: 10px;
}
.alumni_statistics .filters .accordion-body {
    padding: 30px;
}
.alumni_statistics .selected_filters {
    margin-bottom: 20px;
}
.alumni_statistics .selected_filters p {
    background-color: #e9f6fc !important;
    padding: 10px 15px;
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 14px;
    margin-right: 10px;
    margin-bottom: 0;
    color: #000;
}
.alumni_statistics .selected_filters .clearfilters {
    color: #d42941;
    text-transform: uppercase;
    font-weight: 500;
    font-size: 14px;
    padding: 6px;
}
.alumni_statistics .selected_filters .clearfilters:hover {
    text-decoration: none;
}
.alumni_statistics .selected_filters p a {
    margin-left: 15px;
}
.alumni_statistics .selected_filters p a img {
    margin-top: -3px;
    width: 9px;
}
.alumni_statistics .filters .form-control,
.alumni_statistics .filters .form-select {
    min-height: 50px;
    padding: 0 20px;
    border-radius: 5px;
    line-height: 48px; /* display: flex; */ /* align-items: center; */
}
.accordion-body .form-control:focus {
    box-shadow: 0px 0px 20px #00000033;
}
.accordion-body .form-select:focus {
    box-shadow: 0px 0px 20px #00000033;
}
.alumni_statistics .filters .form-check {
    margin-bottom: 0;
    display: flex;
    align-items: center;
}
.alumni_statistics .filters .form-check-label {
    padding-top: 5px;
}
.alumni_statistics .filters .form-check-input {
    width: 20px;
    height: 20px;
    margin-right: 10px;
}
.form-check-input:checked {
    background-color: #0b3454;
    border-color: #0b3454;
}
.alumni_statistics .card_custom .alumni_presence {
    padding: 0 30px 40px;
}
.alumni_statistics .card_custom .card-header {
    background: transparent;
    border-bottom: none;
    font-size: 22px;
    text-transform: uppercase;
    font-weight: 600;
    padding: 30px 30px;
}
.alumni_statistics .card_custom .card-header select {
    border-radius: 200px;
    height: 40px;
    border: 1px solid #8499a9;
    font-weight: 500;
    font-size: 16px;
    width: auto;
    max-width: 180px;
    padding-left: 15px;
    -webkit-border-radius: 200px;
    -moz-border-radius: 200px;
    -ms-border-radius: 200px;
    -o-border-radius: 200px;
}
.alumni_statistics .card_custom .top-countries,
.alumni_statistics .card_custom .top-careers {
    min-height: 415px;
}
.alumni_statistics .card_custom .card-header p span img {
    margin-top: -7px !important;
}
/* Top Countries */
.alumni_statistics .top-countries .progress {
    height: 40px;
    background-color: rgba(0, 0, 0, 0.06);
}
.alumni_statistics .top-countries .progress-bar.countries {
    background-color: #26a7df;
}
.alumni_statistics .top-countries .exclude_india {
    font-size: 18px;
    font-weight: 500;
}
.alumni_statistics .top-countries .caountryname {
    line-height: 15px;
}
.alumni_statistics .top-careers .progress-bar.countries {
    background-color: #51499c;
}
/* Top Countries */
.alumni_statistics .top-colleges {
}
.alumni_statistics .top-colleges .slider {
    padding: 0px 70px;
}
.alumni_statistics .filters .accordion-item {
    border: 1px solid #d2d2d2;
}
.alumni_statistics .filters .accordion-header {
    position: relative;
}
.alumni_statistics .top-colleges .carousel-control-prev,
.alumni_statistics .top-colleges .carousel-control-next {
    width: auto;
}
.alumni_statistics .top-colleges .slider .colleges {
    border: 1px solid #d2d2d2 !important;
    display: flex;
    align-items: center !important;
    border-radius: 6px;
    line-height: 18px;
    padding-right: 20px;
}
.alumni_statistics .top-colleges .slider .colleges:not(:last-child) {
    margin-bottom: 10px;
}
.alumni_statistics .top-colleges .slider .colleges img {
    width: 65px;
}
.alumni_statistics .top-colleges .nav-link {
    font-size: 18px;
    color: #0b3454;
    border: 1px solid #8499a9;
    display: flex;
    align-items: center !important;
    border-radius: 100px;
    padding: 15px 30px;
}
.alumni_statistics .top-colleges .nav-item {
    margin-right: 10px;
    white-space: nowrap;
}
.alumni_statistics .top-colleges .nav-item:last-child {
    margin-right: 0px;
}
.alumni_statistics .top-colleges .nav-link.active {
    color: #fff;
    background: #0b3454;
}
.alumni_statistics .top-colleges .nav-link.active {
    color: #fff;
    background: #0b3454;
}
.alumni_statistics .top-colleges .carousel-item {
    min-height: 380px;
}
.owl-theme.college-slider .owl-nav button {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto !important;
    width: 50px;
    height: 50px;
    background: transparent url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/arrow-left.svg) no-repeat
        0 0;
    border-radius: 50%;
    font-size: 0;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    -ms-border-radius: 50%;
    -o-border-radius: 50%;
}
.owl-theme.college-slider .owl-nav button:hover {
    background: transparent url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/arrow-left.svg) no-repeat
        0 0;
}
.owl-theme.college-slider .owl-nav button.owl-prev {
    left: 0;
}
.owl-theme.college-slider .owl-nav button.owl-next {
    right: 0;
    transform: scaleX(-1);
    -webkit-transform: scaleX(-1);
    -moz-transform: scaleX(-1);
    -ms-transform: scaleX(-1);
    -o-transform: scaleX(-1);
}
.alumni_statistics .alumni_presence .progress-bar-vertical {
    width: 80px;
    min-height: 200px;
    display: flex;
    align-items: flex-end;
    margin-right: 20px;
    float: left;
    margin: 0 auto;
    border-radius: 6px 6px 0 0;
}
.alumni_statistics .alumni_presence .progress-bar-vertical .prestigiouscolor {
    background: #26a7df;
}
.alumni_statistics .alumni_presence .progress-bar-vertical .nonprestigiouscolor {
    background: #51499c;
}
.alumni_statistics .alumni_presence .progress-bar-vertical {
    position: relative;
}
.alumni_statistics .alumni_presence .progress-bar-vertical span {
    position: absolute;
    top: 0;
    width: 100%;
    text-align: center;
    font-size: 18px;
    font-weight: 600;
}
.alumni_statistics .alumni_presence .progress-bar-vertical .progress-bar {
    width: 100%;
    height: 0;
    transition: height 0.6s ease;
}
.alumni_statistics .alumni_presence .prestigious {
    border-top: 1px solid #e2e2e2;
    margin-bottom: 0;
    padding: 5px;
    min-width: 140px;
    text-align: center;
    font-size: 18px;
    font-weight: 500;
}
.alumni_statistics .alumni_presence p.prestigiousnumber {
    text-align: center;
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 10px;
}
.alumni_statistics .alumni_presence .stats {
    position: relative;
}
.alumni_statistics .alumni_presence .stats:after {
    content: 'vs';
    position: absolute;
    top: 45%;
    font-size: 20px;
    left: 47%;
}
.alumni_statistics .card_profiles {
    min-height: max-content;
    max-height: max-content;
}
.guidance_videos {
}
.guidance_videos .videos_list {
    text-decoration: none;
}
.guidance_videos .videos_list figure {
    max-height: 180px;
    overflow: hidden;
    position: relative;
    border-radius: 4px;
    border: 2px solid #000;
}
.guidance_videos .videos_list figure:before {
    content: '';
    display: block;
    width: 100%;
    position: absolute;
    height: 100%;
    background: #00000050;
}
.guidance_videos .videos_list figure img {
    transition: all 0.3s ease;
}
.guidance_videos .videos_list:hover figure img {
    transform: scale(1.05);
}
.guidance_videos .videos_list figure:after {
    content: '';
    position: absolute;
    background: url('https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/play_video.svg') no-repeat;
    left: 50%;
    width: 56px;
    height: 56px;
    margin-left: -28px;
    top: 50%;
    margin-top: -25px;
}
.guidance_videos .videos_list figure img {
    width: 100%;
}
.guidance_videos .videos_list p {
    text-align: center;
    font-size: 20px;
    color: #000;
    text-decoration: none;
    font-weight: 500;
    line-height: 29px;
}
.guidance_video_popup {
    border-radius: 0;
    background: #000;
    position: relative;
}
.guidance_video_popup .btn-close {
    position: absolute;
    right: 0;
    top: -30px;
    color: #fff;
    filter: brightness(0) invert(1);
    opacity: 01;
}
.w-10 {
    width: 10%;
}
.bg-darker-blue {
    background-color: #0b3454;
}
.profileContainer {
    background: #ffffff;
    box-shadow: 0px 3px 6px #0000001a;
    border: 1px solid #d2d2d2;
    border-radius: 6px;
    overflow: hidden;
}
.profilenameclass .profilename {
    line-height: 24px;
}
.profilenameclass .univarsity-school {
    border-left: 4px solid #fff;
    padding-left: 7px;
}
.alumni_profile_college_name_other_detail_wrap .phone_number label {
    width: 140px;
    margin-right: 20px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/path-72031.svg) no-repeat 0 0;
    height: 40px;
    padding-left: 13px;
    display: flex;
    align-items: center;
    font-weight: 500;
}
.btn-white-border.verifynow {
    height: 30px;
    line-height: 25px;
}
.alumni_profile_college_name_other_detail_wrap .phone_number {
    align-items: center;
}
.profilenameclass .class {
    line-height: 18px;
}
.alumni_profile_brife_wrap.myProfile {
    border-top: 1px solid #264a66;
}
.myProfile .alumni_profile_college_name_other_detail_wrap .verifynow {
    background: #fff;
    border: 2px solid #224764;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 30px;
    color: #224764;
}
.myProfile .alumni_profile_college_name_other_detail_wrap .verifynow:hover {
    background: #224764;
    color: #fff;
}
.days .white-block {
    background: #ffffff 0% 0% no-repeat padding-box;
    border: 1px solid #dedede;
    border-radius: 18px;
    height: 35px;
    padding: 0 20px;
    display: flex;
    align-items: center;
    margin: 0 10px 10px 0;
}
.customselect_parnt > .form-select {
    border-radius: 25px;
    margin-right: 10px;
    border: 2px solid #7d7d7d;
    height: 36px;
    display: flex;
    align-items: center;
    line-height: 18px;
}
.customselect_parnt button {
    height: 36px;
}
.icon-download {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/download.svg) no-repeat 0 0 / 100%;
    width: 17px;
    height: 16px;
    display: inline-block;
}
.mailSetting .icon-download {
    filter: invert(16%) sepia(71%) saturate(697%) hue-rotate(167deg) brightness(92%) contrast(99%);
    -webkit-filter: invert(16%) sepia(71%) saturate(697%) hue-rotate(167deg) brightness(92%) contrast(99%);
}
.mailSetting .icon-download:hover {
    filter: invert(53%) sepia(75%) saturate(353%) hue-rotate(62deg) brightness(97%) contrast(89%);
    -webkit-filter: invert(53%) sepia(75%) saturate(353%) hue-rotate(62deg) brightness(97%) contrast(89%);
}
/*.gray_badge .badge {background: #F1F1F1 0% 0% no-repeat padding-box;border-radius: 100px;height: 28px;padding: 0 15px;display: inline-flex;justify-content: center;align-items: center;font-size: 14px;color: #000;font-weight: 400;margin-bottom: 5px;}*/
.gray_badge .badge {
    background: #f1f1f1;
    border-radius: 100px;
    height: 28px;
    padding: 0 15px;
    display: inline-block;
    font-size: 14px;
    color: #000;
    font-weight: 400;
    margin-bottom: 5px;
    max-width: 108px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    text-align: center;
    line-height: 28px;
}
.tooltip-white .tooltip-inner {
    background: #fff !important;
    box-shadow: 0px 3px 6px #0000001a;
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-width: 230px;
    width: 100%;
    border: none;
    text-align: left;
}
.tooltip-white .tooltip-inner p, .tooltip-white .tooltip-inner{color: #000 !important;}
.tooltip-white .tooltip-inner .badge {
    background: #f1f1f1 0% 0% no-repeat padding-box;
    border-radius: 100px;
    height: 28px;
    padding: 0 15px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: #000;
    font-weight: 400;
    text-align: left;
}
.tooltip-white .tooltip-inner .badge:not(:last-child) {
    margin-bottom: 5px;
}
.tooltip-white .tooltip-arrow::before {
    border-top-color: #fff;
}

.attendee_dtl .table > thead th {
    background: #f1f1f1;
    font-size: 14px;
    font-weight: 500;
    height: 40px;
    border: 0;
}
.attendee_dtl .table > thead th:first-child {
    border-radius: 6px 0 0 6px;
}
.attendee_dtl .table > thead th:last-child {
    border-radius: 0 6px 6px 0;
}
.attendee_dtl .table.lite-blue-header > thead th{background-color: #F2F9FF;}
.table-responsive.attendee_dtl > table td:first-child,
.table-responsive.attendee_dtl > table th:first-child {
    padding-left: 20px;
}
.table-responsive.attendee_dtl > table td {
    padding-top: 15px;
    padding-bottom: 15px;
    font-size: 14px;
    vertical-align: middle;
    background-color: #fff;
}
.table-responsive.attendee_dtl > table .btn {
    line-height: 15px;
    display: flex;
    align-items: center;
    padding: 0 20px !important;
    margin: 0 5px 0 0;
}
.table-responsive.attendee_dtl > table td.active {
    width: 315px;
}
.table-responsive.attendee_dtl > table td.engagement {
    width: 245px;
}
.table-responsive.attendee_dtl > table .university-name {
    width: 175px;
}
.table-responsive.attendee_dtl > table td.sentDeliveredOpened {
    width: 365px;
}
.table-responsive.attendee_dtl a.tablink {
    color: #0b3454;
    display: flex;
    align-items: center;
    text-decoration: none;
    line-height: 18px;
}
.table-responsive.attendee_dtl a.tablink:hover {
    color: #5cae48;
}
.table-responsive.attendee_dtl a.btn-gray-border:hover {
    color: #fff;
}
.table-responsive.attendee_dtl > table td.deliveryStatus {
    width: 205px;
}
.input-group-select select.form-select {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
}
.empty-notification .profile-selection-notification {
    z-index: 9;
    left: 0;
    max-width: 1012px;
    margin: auto;
    width: 1012px;
    right: 0;
    position: absolute;
    top: 50px;
}
.table-responsive .icon-like.dislike {
    width: 15px;
    height: 15px;
    transform: scale(-1) translateY(-3px);
    display: inline-block;
}
.table_cus_badge {
    background: #fef7e8;
    border-radius: 20px;
    height: 36px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: #000;
    font-weight: 500;
    padding: 0 15px;
    margin: 3px;
    min-width: 65px;
}
.tab-ul {
    padding: 0;
    line-height: 22px;
    list-style: none;
    margin: 0 13px 0 0;
}
.tab-ul a {
    color: #000;
}
.tab-ul a:hover {
    color: #414141;
}
.custom-btn a {
    margin: 0 2px;
    text-decoration: none;
    color: #000;
    font-size: 12px;
}
.active-status {
    background: #ffffff 0% 0% no-repeat padding-box;
    border: 1px solid #d2d2d2;
    border-radius: 20px;
    width: 120px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.attendee_dtl a.icon-cross {
    text-decoration: none;
}
.attendee_dtl a.icon-cross:hover {
    color: #666 !important;
}
.attendee_dtl .form-check-input,
.ActiveListings_present .form-check-input {
    width: 20px;
    height: 20px;
    border-width: 2px;
}
.attendee_dtl .form-check-input:checked,
.ActiveListings_present .form-check-input:checked {
    background-color: #0b3454;
    border-color: #0b3454;
}
.icon-sort-arrow {
    font-size: 6px;
    color: #7f7f7f;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}
.icon-sort-arrow .icon-invert-down-arrow {
    transform: scaleY(-1);
}
.labelItem {
    color: #000;
    text-decoration: none;
    display: flex;
    align-items: center;
}
.text-center .labelItem {
    justify-content: center;
}
.labelItem:hover {
    color: #153d5b;
}
.labelItem .icon-sort {
    margin-left: 5px;
    width: 17px;
    height: 17px;
    display: inline-block;
    position: relative;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
}
.labelItem .icon-sort::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    background: #f1f1f1;
    width: 12px;
    height: 2px;
    margin: auto;
    transform: rotate(-45deg);
    left: -2.5px;
    display: none;
}
.fitergroup .show .accordion-body {
    border-radius: 0 6px 6px 6px;
}
.fitergroup .accordion-body {
    background: #f1f1f1;
    border-radius: 6px;
}
.fitergroup .input-group .css-b62m3t-container {
    height: 38px !important;
}
.fitergroup .input-group .css-b62m3t-container div[class*='-control'] {
    height: 38px !important;
}
.fitergroup .input-group-text {
    border-color: #848484;
}
.btn-grpfiter {
    border: 0px solid #e1e1e1;
    border-radius: 20px;
    height: 40px;
    padding: 0 25px;
    font-size: 14px;
    font-weight: 500;
    background: #f1f1f1;
    position: relative;
}
.btn-grpfiter[aria-expanded='true'] {
    border-radius: 20px 20px 0 0;
    transition: all 0.3s ease-in-out;
}
.btn-grpfiter::before {
    content: '';
    position: absolute;
    bottom: -20px;
    left: 0;
    right: 0;
    background: #f1f1f1;
    height: 10px;
    transition: all 0.3s ease-in-out;
    opacity: 0;
}
.btn-grpfiter[aria-expanded='true']::before {
    bottom: -10px;
    opacity: 1;
}
.mailSetting {
    position: relative;
}
.mailSetting .setting-dropdown {
    position: absolute;
    top: 30px;
    right: 10px;
    background: white;
    padding: 15px 20px;
    box-shadow: 0 0 3px 0px #ccc;
    border-radius: 6px;
    z-index: 1;
    border: 1px solid #ccc;
    text-align: right;
    display: none;
}
.mailSetting .setting-dropdown.open {
    display: block;
}
.mailSetting .setting-dropdown ul {
    padding: 0;
    margin: 0;
    list-style: none;
}
.mailSetting .setting-dropdown ul a {
    text-decoration: none;
    color: #000;
}
.mailSetting .setting-dropdown ul li:not(:last-child) {
    margin-bottom: 5px;
}

td a {
    color: #0b3454;
    opacity: 1;
    text-decoration: none;
}
td a:hover {
    color: #5cae48;
    opacity: 1;
}
.btn-conview,
.link {
    color: #0d6efd;
    text-decoration: underline;
}
.btn-conview:hover,
.link:hover {
    color: #5cae48;
    opacity: 1;
}
.tooltip-setting .tooltip-inner {
    background: #ffffff;
    color: #515151;
    border: 1px solid #cecfcf;
    box-shadow: 0px 5px 10px #00000033;
    padding: 15px 12px;
}
.tooltip.tooltip-setting .show {
    opacity: 2;
}
.tooltip-setting .bs-tooltip-top .tooltip-arrow::before {
    top: -1px;
    border-width: 0.4rem 0.4rem 0;
    border-top-color: #fff;
}
.tooltip-setting .bs-tooltip-bottom .tooltip-arrow::before {
    bottom: -1px;
    border-width: 0 0.4rem 0.4rem;
    border-bottom-color: #fff;
}
.tooltip-setting .tooltip-inner ul {
    padding: 0;
    margin: 0;
    text-align: left;
    list-style: none;
    line-height: 24px;
}
.tooltip-setting .tooltip-inner ul a {
    font-size: 14px;
    color: #000;
    text-decoration: none;
    padding: 0;
    border: none;
    font-weight: 500;
}
.bs-tooltip-auto.tooltip-setting[data-popper-placement^='top'] .tooltip-arrow::before,
.bs-tooltip-top.tooltip-setting .tooltip-arrow::before {
    border-top-color: #fff;
}
.tooltip-html {
}
.tooltip-html .tooltip-inner {
    background: #ffffff !important;
    color: #515151;
    border: 1px solid #cecfcf;
    box-shadow: 0px 5px 10px #00000033;
    padding: 15px 15px;
    max-width: 300px;
    line-height: 20px;
}
.tooltip.tooltip-html .show {
    opacity: 2;
}
.tooltip-html .bs-tooltip-top .tooltip-arrow::before {
    top: -1px;
    border-width: 0.4rem 0.4rem 0;
    border-top-color: #fff;
}
.tooltip-html .bs-tooltip-bottom .tooltip-arrow::before {
    bottom: -1px;
    border-width: 0 0.4rem 0.4rem;
    border-bottom-color: #fff;
}
.tooltip-html .tooltip-inner ul {
    padding: 0;
    margin: 0;
    text-align: left;
    list-style: none;
    line-height: 24px;
}
.tooltip-html .tooltip-inner ul a {
    font-size: 14px;
    color: #000;
    text-decoration: none;
}
.bs-tooltip-auto.tooltip-html[data-popper-placement^='top'] .tooltip-arrow::before,
.bs-tooltip-top.tooltip-html .tooltip-arrow::before {
    border-top-color: #fff;
}
.tooltip-html .tooltip-inner ul li {
    white-space: wrap;
}
.tooltip-html .tooltip-inner ul li:not(:last-child) {
    margin: 0 0 8px;
}
.tooltip-html .tooltip-inner ul li b {
    margin-right: 5px;
    font-weight: 500;
    color: #000;
}
.tooltip-html .tooltip-inner ol,
.tooltip-html .tooltip-inner p {
    padding: 0 0 0 20px;
    margin: 0;
    text-align: left;
    font-weight: 500;
    color: #000;
}
.datewrap {
    display: flex;
    flex-wrap: wrap;
    background: #ffffff 0% 0% no-repeat padding-box;
    border: 1px solid #848484;
    border-radius: 6px;
    height: 40px;
    position: relative;
    overflow: hidden;
}
#config-demo,
.singledaterangePickerList,
.daterangePickerList {
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 0;
    top: 0;
    right: 0;
    margin: auto;
    cursor: pointer;
    opacity: 0;
}
.datewrap .arrow {
    background: #f1f1f1 0% 0% no-repeat padding-box;
    width: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
}
/*.datewrap .arrow span {background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='1' d='M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z'/%3e%3c/svg%3e");font-size: 0;width: 25px;height: 25px;}*/
.datewrap .arrow span {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/arrow.svg) no-repeat center;
    font-size: 0;
    width: 25px;
    height: 25px;
}
.datewrap .from,
.datewrap .to {
    flex: 1 1;
}
.datewrap .form-control {
    height: 100% !important;
    border: 0 !important;
    background: #fff url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/calendar.svg) no-repeat 10px
        center;
    padding-left: 40px;
}
.fitergroup .accordion-body .form-select,
.fitergroup .accordion-body .form-control,
.tab-pane .fullViewMobile .form-select,
.tab-pane .fullViewMobile .form-control {
    height: 40px;
    border: 1px solid #848484;
}
.fitergroup .accordion-body .form-select.selected,
.fitergroup .accordion-body .form-control.selected {
    background-color: #b6dbac;
    border-color: #8baa83;
}
.form-control.form-search {
    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/search.svg);
    background-size: 14px;
    background-repeat: no-repeat;
    background-position: 13px center;
    padding-left: 34px;
}
.search.alumniSearch {
    max-width: 350px;
    width: 100%;
    background: #fff;
    border: 1px solid #7d7d7d;
    border-radius: 20px;
}
.search.alumniSearch .btn-search {
    right: auto;
    left: 7px;
    top: 6px;
}
.search.alumniSearch .form-control {
    padding-left: 40px;
}
.search.alumniSearch > div input:focus {
    box-shadow: none;
    background: transparent;
}
.search-100 .search.alumniSearch {
    max-width: 280px;
}
.singlelinename {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 125px;
}
.tablink img[width='30'] {
    width: 30px;
    min-width: 30px;
}
.icon-star.circle-img {
    position: absolute;
    bottom: -3px;
    right: -3px;
    background: #5cae48;
    border-radius: 50%;
    color: #fff;
    font-size: 7px;
    padding: 4px;
}
.table-responsive.attendee_dtl td a > i {
    width: 30px;
    height: 30px;
    font-size: 30px;
    background-position: center;
}
.table-responsive.attendee_dtl td a > i img {
    vertical-align: top;
}
.course-list-row span {
    vertical-align: top;
    margin-right: 4px;
}
.course-list-row i {
    margin-top: 0px;
}
.filterresult ul {
    margin: 0;
    padding: 10px 0 15px;
    display: flex;
    flex-wrap: wrap;
    list-style: none;
}
.filterresult ul:empty {
    display: none;
}
.filterresult ul li:not(:last-child) {
    margin-right: 10px;
}
.filterresult ul li {
    margin-bottom: 5px;
}
.filterresult ul li a {
    background: #c8edff;
    border-radius: 20px;
    min-height: 32px;
    padding: 5px 20px;
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #000;
    text-decoration: none;
}
.filterresult ul li a i {
    margin-left: 8px;
    font-size: 9px;
}
.filterresult ul li.clear a {
    background: none;
    color: #d42941;
    text-decoration: underline;
}
.filterresult ul li.clear a:hover {
    color: #0b3454;
    text-decoration: none;
}
.filterresult {
    padding: 0;
    border-bottom: 1px solid #e5eaed;
    margin-bottom: 20px;
}
.pagination_custom {
    max-width: 751px;
    margin: auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    margin-top: 15px;
}
.pagination_custom .pagination_custom_inner {
    flex: 1 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 20px;
}
.pagination_custom .pagination_custom_inner ul {
    padding: 0;
    margin: 0 20px;
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    flex: 1 1;
    justify-content: center;
    align-items: center;
}
.pagination_custom .pagination_custom_inner ul li:not(:last-child) {
    margin-right: 0;
}
.pagination_custom .pagination_custom_inner ul li {
    width: 30px;
    text-align: center;
    margin: 0 10px;
}
.pagination_custom a,
.pagination_custom .pagination_custom_inner ul li a {
    text-decoration: none;
    font-size: 16px;
    color: #0b3454;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
}
.pagination_custom .pagination_custom_inner ul li.current a {
    background: #0b3454;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
}
.summary-blocks {
    width: 1140px;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    margin-bottom: 15px;
}
.summary-blocks .block {
    width: calc(20.19% - 1%);
    border-radius: 4px;
    display: flex;
    align-items: center;
    padding: 32px 20px;
}
.summary-blocks .block {
    background: #fff;
}
.summary-blocks .block:not(:last-child) {
    margin-right: 1%;
}
.summary-blocks .block .icon {
    margin-right: 15px;
}
.summary-blocks .block .block-detail .number {
    font-size: 26px;
    line-height: 30px;
    font-weight: 600;
}
.summary-blocks .block .block-detail .block-detail-title {
    font-size: 15px;
    line-height: 18px;
    font-weight: 500;
}
.summary-blocks .block.totalAlumni .block-detail {
    color: #d42941;
}
.summary-blocks .block.uptoDate .block-detail {
    color: #0b3454;
}
.summary-blocks .block.due .block-detail {
    color: #26a7df;
}
.summary-blocks .block.smartApplyLeads .block-detail {
    color: #403a81;
}
.summary-blocks .block.smartApplyRegd .block-detail {
    color: #6962a7;
}
.x-scroll {
    overflow-x: auto;
    scrollbar-width: thin;
}
.x-scroll::-webkit-scrollbar {
    height: 4px;
}
.x-scroll::-webkit-scrollbar-track {
    background: #f1f1f1;
}
.x-scroll::-webkit-scrollbar-thumb {
    background: #888;
}
.x-scroll::-webkit-scrollbar-thumb:hover {
    background: #555;
}
.blue-badge {
    background: #68c2e9;
    font-weight: 500;
    border: 1px solid #68c2e9;
    border-radius: 6px;
    padding: 0 15px;
    height: 26px;
    display: inline-block;
    line-height: 26px;
    color: #fff !important;
    margin-bottom: 5px;
    font-size: 12px;
    text-transform: uppercase;
}
.sticky_table_3_columns th:first-child {
    position: sticky;
    left: 0;
    z-index: 3;
}
.sticky_table_3_columns th:nth-child(2) {
    position: sticky;
    left: 140px;
    z-index: 3;
}
.sticky_table_3_columns th:nth-child(3) {
    position: sticky;
    left: calc(140px + 250px);
    z-index: 3;
}
.sticky_table_3_columns td:first-child {
    position: sticky;
    left: 0;
    z-index: 3;
}
.sticky_table_3_columns td:nth-child(2) {
    position: sticky;
    left: 140px;
    z-index: 3;
}
.sticky_table_3_columns td:nth-child(3) {
    position: sticky;
    left: calc(140px + 250px);
    z-index: 3;
}
.sticky_table_3_columns th:nth-child(3)::before,
.sticky_table_3_columns td:nth-child(3)::before {
    content: '';
    width: 30px;
    position: absolute;
    right: 0px;
    bottom: 0;
    top: 0;
    background: transparent linear-gradient(270deg, #000000 0%, #00000000 100%);
    opacity: 0.05;
}
.sticky_table_3_columns td::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: -1px;
    height: 0;
    border-bottom: 1px solid #dee2e6;
}
.sticky_table_3_columns_noaction th:first-child {
    position: sticky;
    left: 0;
    z-index: 3;
}
.sticky_table_3_columns_noaction th:nth-child(2) {
    position: sticky;
    left: 250px;
    z-index: 3;
}
.sticky_table_3_columns_noaction th:nth-child(3) {
    position: sticky;
    left: calc(250px + 180px);
    z-index: 3;
}
.sticky_table_3_columns_noaction td:first-child {
    position: sticky;
    left: 0;
    z-index: 3;
}
.sticky_table_3_columns_noaction td:nth-child(2) {
    position: sticky;
    left: 250px;
    z-index: 3;
}
.sticky_table_3_columns_noaction td:nth-child(3) {
    position: sticky;
    left: calc(250px + 180px);
    z-index: 3;
}
.sticky_table_3_columns_noaction th:nth-child(3)::before,
.sticky_table_3_columns_noaction td:nth-child(3)::before {
    content: '';
    width: 30px;
    position: absolute;
    right: 0px;
    bottom: 0;
    top: 0;
    background: transparent linear-gradient(270deg, #000000 0%, #00000000 100%);
    opacity: 0.05;
}
.sticky_table_3_columns_noaction td::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: -1px;
    height: 0;
    border-bottom: 1px solid #dee2e6;
}
.sticky_table_4_columns th:first-child {
    position: sticky;
    left: 0;
    z-index: 3;
}
.sticky_table_4_columns th:nth-child(2) {
    position: sticky;
    left: 150px;
    z-index: 3;
}
.sticky_table_4_columns th:nth-child(3) {
    position: sticky;
    left: calc(150px + 225px);
    z-index: 3;
}
.sticky_table_4_columns th:nth-child(4) {
    position: sticky;
    left: calc(150px + 225px + 180px);
    z-index: 3;
}
.sticky_table_4_columns td:first-child {
    position: sticky;
    left: 0;
    z-index: 3;
}
.sticky_table_4_columns td:nth-child(2) {
    position: sticky;
    left: 150px;
    z-index: 3;
}
.sticky_table_4_columns td:nth-child(3) {
    position: sticky;
    left: calc(150px + 225px);
    z-index: 3;
}
.sticky_table_4_columns td:nth-child(4) {
    position: sticky;
    left: calc(150px + 225px + 180px);
    z-index: 3;
}
.sticky_table_4_columns th:nth-child(4)::before,
.sticky_table_4_columns td:nth-child(4)::before {
    content: '';
    width: 30px;
    position: absolute;
    right: 0px;
    bottom: 0;
    top: 0;
    background: transparent linear-gradient(270deg, #000000 0%, #00000000 100%);
    opacity: 0.05;
}
.sticky_table_4_columns td::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: -1px;
    height: 0;
    border-bottom: 1px solid #dee2e6;
}
.w-2300 {
    width: 2300px;
}
.w-2000 {
    width: 2000px;
}
.w-1780 {
    width: 1780px;
}
.w-90 {
    width: 90px;
}
.max-1140 {
    max-width: 1140px;
    width: 94%;
}
.max-1040 {
    max-width: 1040px;
    width: 94%;
}
.max-1010 {
    max-width: 1010px;
    width: 94%;
}
.max-950 {
    max-width: 950px;
}
.max-940 {
    max-width: 940px;
    width: 94%;
}
.max-900 {
    max-width: 900px;
    width: 94%;
}
.max-850 {
    max-width: 850px;
    width: 94%;
}
.max-800 {
    max-width: 800px;
    width: 94%;
}
.max-740 {
    max-width: 740px;
    width: 90%;
}
.max-750 {
    max-width: 750px;
    width: 90%;
}
.max-780 {
    max-width: 780px;
    width: 90%;
}
.max-700 {
    max-width: 700px !important;
    width: 90%;
}
.max-600 {
    max-width: 600px;
    width: 90%;
}
.max-620 {
    max-width: 620px;
    width: 90%;
}
.max-630 {
    max-width: 630px;
    width: 90%;
}
.max-540 {
    max-width: 540px;
    width: 90%;
}
.bg-gray-f2 {
    background: #f2f2f2;
}
.customselect_parnt > .form-select {
    border-radius: 25px;
    margin-right: 10px;
    border: 2px solid #7d7d7d;
    height: 36px;
    display: flex;
    align-items: center;
    line-height: 18px;
}
.customselect_parnt button {
    height: 36px;
}
.icon-download {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/download.svg) no-repeat 0 0 / 100%;
    width: 17px;
    height: 16px;
    display: inline-block;
}
.mailSetting .icon-download {
    filter: invert(16%) sepia(71%) saturate(697%) hue-rotate(167deg) brightness(92%) contrast(99%);
    -webkit-filter: invert(16%) sepia(71%) saturate(697%) hue-rotate(167deg) brightness(92%) contrast(99%);
}
.mailSetting .icon-download:hover {
    filter: invert(53%) sepia(75%) saturate(353%) hue-rotate(62deg) brightness(97%) contrast(89%);
    -webkit-filter: invert(53%) sepia(75%) saturate(353%) hue-rotate(62deg) brightness(97%) contrast(89%);
}
.gray_badge .badge {
    background: #f1f1f1;
    border-radius: 100px;
    height: 28px;
    padding: 0 15px;
    display: inline-block;
    font-size: 14px;
    color: #000;
    font-weight: 400;
    margin-bottom: 0px;
    max-width: 108px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    text-align: center;
    line-height: 28px;
}
.custom-btn a {
    margin: 0 2px;
    text-decoration: none;
    color: #212529;
}
.custom-btn a:hover {
    color: #868686;
}
.modal .form-control {
    min-height: 40px;
    font-weight: 500;
    color: #000;
    font-size: 16px;
}
.modal .form-label {
    font-weight: 500;
    font-size: 16px;
}
::placeholder {
    color: #939ba2;
}
.btn-log {
    background: #0b3454;
    padding: 0 16px;
    height: 40px;
    display: inline-flex;
    border-radius: 4px;
    color: #fff;
    text-decoration: none;
    line-height: 35px;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    align-items: center;
    font-size: 14px;
}
.btn-log:hover {
    color: #fff;
    background: #155282;
}
.btn-green {
    background: #5cae48;
    color: #fff;
    border-color: #5cae48;
    padding: 0 25px;
    height: 40px;
}
.btn-green:hover {
    color: #fff;
    background: #367127;
    border-color: #367127;
}
.btn-green {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    text-decoration: none;
    font-size: 16px;
    line-height: 16px;
    font-weight: 500;
    position: relative;
    overflow: hidden;
    border: 0;
}
.btn-green span {
    position: relative;
}
.btn-completed::before,
.btn-green::before {
    position: absolute;
    content: '';
    left: 0;
    top: 0;
    bottom: 0;
    width: 0;
    background: #398227;
    transition: all 0.3s ease-in-out;
}
.btn-completed:hover::before,
.btn-green:hover::before,
.btn-liteblue:hover::before,
.btn-invite:hover::before {
    width: 100%;
    transition: all 0.3s ease-in-out;
}
.form-last-sent {
    height: 40px;
    display: flex;
    align-items: center;
    background: #eef6ff;
    border-radius: 5px;
    padding: 5px 15px;
}
.form-last-sent a {
    margin-right: 5px;
    color: #007bff;
}
.filterSection .form-label {
    font-weight: 500 !important;
    margin: 0 0 3px;
}
.form-check .form-check-input {
    width: 20px;
    height: 20px;
    vertical-align: top;
    display: inline-block;
    position: static;
    margin-right: 8px;
    margin-left: 0;
    margin-top: 0;
}
.form-check {
    display: flex;
    align-items: center;
    padding: 0;
}
.form-check .form-check-label {
    display: flex;
    align-items: center;
    line-height: 16px;
    margin: 0;
}
.form-check-input:checked {
    background-color: #29a745;
    border-color: #29a745;
}
.datepicker .datepicker-switch:hover,
.datepicker .prev:hover,
.datepicker .next:hover,
.datepicker tfoot tr th:hover {
    background: #eef5ff;
}
.datepicker {
    padding: 0;
    z-index: 9999;
}
.datepicker td,
.datepicker th {
    padding: 7px;
}
.datepicker-days thead {
    background: #eef5ff;
    font-weight: 500;
}
.datepicker-days thead th {
    font-weight: 500;
}
.datepicker-days thead th:hover {
    background: #007bff;
    color: #fff;
}
.datepicker-months,
.datepicker-days {
    overflow: hidden;
    background: #eef5ff;
    border-radius: 3px;
}
.datepicker-months tbody,
.datepicker-days tbody {
    background: #fff;
}
.form-date {
    background: #fff url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/calender.svg) no-repeat right
        10px center;
    padding-right: 40px;
}
.modal-backdrop {
    z-index: 1090;
}
.modal {
    z-index: 1091;
}
.modal-backdrop ~ .tooltip {
    z-index: 1099;
}
.half-gray {
    position: relative;
}
.half-gray:before {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    top: 0;
    width: 50.5%;
    background: #f3f3f3;
    border-radius: 6px 0px 0px 6px;
}
.half-gray > div {
    position: relative;
}
.messages {
    flex: 1 1;
    display: flex;
    flex-direction: column;
}
.leftUser {
    align-items: end;
}
.leftUser p {
    background: #2296c9;
    border-radius: 10px 10px 0px 10px;
    padding: 7px 20px;
    color: #fff;
    margin-bottom: 10px;
}
.rightUser {
    align-items: start;
}
.rightUser p {
    background: #413a7d;
    border-radius: 10px 10px 10px 0px;
    opacity: 1;
    padding: 7px 20px;
    color: #fff;
    margin-bottom: 10px;
}
.conversation .userimg {
    display: flex;
    align-items: start;
    vertical-align: top;
}
.conversation {
    height: 310px;
    overflow-y: scroll;
    overflow-x: hidden;
    margin-right: -8px;
}
.conversation {
    overflow-y: scroll;
    scrollbar-width: thin;
}
.conversation::-webkit-scrollbar {
    width: 1px;
}
.conversation::-webkit-scrollbar-track {
    background: #f1f1f1;
}
.conversation::-webkit-scrollbar-thumb {
    background: #888;
}
.conversation::-webkit-scrollbar-thumb:hover {
    background: #555;
}
.conversation .row {
    position: relative;
}
.messages.rightUser .form-check-input {
    position: absolute;
    left: 12px;
    top: 9px;
}
.messages.leftUser .form-check-input {
    position: absolute;
    left: 12px;
    top: 9px;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}
.messages .form-check-input:focus {
    box-shadow: none;
}
.conversation div[class*='col'] {
    position: static;
}
.conversation.gap div[class*='col'] > div {
    padding: 0 20px;
}
.half-gray .modal-footer {
    background: #fff;
    padding: 20px;
}
.modal-footer .btn-good-qa {
    margin: auto;
    color: #fff;
    background-color: #28a745;
    border-color: #28a745;
    box-shadow: none;
    padding: 10px 25px;
    border-radius: 3px;
    text-transform: uppercase;
    font-weight: 500;
}
.modal-footer .btn-good-qa:hover {
    background-color: #218838;
    border-color: #1e7e34;
}
.fitergroup .form-label {
    font-weight: 500;
    margin: 0 0 3px;
}
.fitergroup .form-last-sent {
    border: 1px solid #bfcfe1;
}
.custom_litezoom:before {
    content: '';
    position: absolute;
    top: 100%;
    left: 10px;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 6px solid #fff;
}
.album_imgvdo {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
}
.image_tn:first-child {
    margin-right: 5px;
}
.image_tn {
    margin-bottom: 3px;
}
.table-responsive.attendee_dtl td .custom_litezoom a {
    font-size: 14px;
    font-weight: 400;
    line-height: 25px;
    text-decoration: none !important;
    color: #000;
    font-weight: 500;
    display: flex;
    align-items: center;
    border: 1px solid #cecece;
    border-radius: 26px;
    -webkit-border-radius: 26px;
    -moz-border-radius: 26px;
    -ms-border-radius: 26px;
    -o-border-radius: 26px;
    padding: 0 10px;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    width: auto;
    background: none;
}
.custom_litezoom a:hover {
    color: #0b3454;
}
.table-responsive.attendee_dtl td .custom_litezoom a .icon-phone {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/image.svg) no-repeat 0 0;
    width: 16px;
    height: 15px;
    margin-right: 7px;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.table-responsive.attendee_dtl td .custom_litezoom a .icon-video {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/video-camera.svg) no-repeat 0 0;
    width: 16px;
    height: 9px;
    margin-right: 7px;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.custom_litezoom a:hover {
    background: #0c9ccc;
    border-color: #0c9ccc;
    color: #fff;
}
.custom_litezoom a:hover i {
    filter: brightness(0) invert(1);
    -webkit-filter: brightness(0) invert(1);
}
.table .view-list {
    text-align: center;
    font-size: 14px;
    color: #0c9ccc;
    font-weight: 500;
}
.table .view-list:hover {
    color: #007bff;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.table td b {
    font-weight: 500;
}

/* multi select start */
.select2-container {
    display: block;
}
.select2-container *:focus {
    outline: 0;
}
.input-group .select2-container--bootstrap4 {
    flex-grow: 1;
}
.input-group-prepend ~ .select2-container--bootstrap4 .select2-selection {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
}
.input-group > .select2-container--bootstrap4:not(:last-child) .select2-selection {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}
.select2-container--bootstrap4 .select2-selection {
    width: 100%;
    background-color: #fff;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    -moz-transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
    -ms-transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
    -o-transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
}
.btn-update {
    background: #0b3454;
    padding: 3px 20px;
    border-radius: 25px;
    color: #fff;
    text-decoration: none !important;
    font-weight: 500;
    height: 32px;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    display: flex;
    align-items: center;
    justify-content: center;
}
.btn-update:hover {
    color: #fff;
    background: #0060aa;
}
.btn-create {
    background: #28a745;
    padding: 3px 20px;
    border-radius: 25px;
    color: #fff;
    text-decoration: none !important;
    font-weight: 500;
    height: 32px;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    display: flex;
    align-items: center;
    justify-content: center;
}
.btn-create:hover {
    color: #fff;
    background: #10842a;
}
.alumni_profile_brife .btn-back .icon-left-arrow {
    transform: scaleX(-1);
    margin-left: 7px;
    font-size: 12px;
    -webkit-transform: scaleX(-1);
    -moz-transform: scaleX(-1);
    -ms-transform: scaleX(-1);
    -o-transform: scaleX(-1);
}
.copylink > a {
    width: 100px;
    height: 40px;
    display: inline-flex;
    background: #5cae48;
    justify-content: center;
    align-items: center;
    color: #fff;
    border-radius: 3px;
    margin-right: 5px;
    text-decoration: none;
}
.copylink > a.invite:hover {
    background: #408e2d;
    color: #fff;
}
.icon.copy {
    position: relative;
    cursor: pointer;
    width: 18px;
    display: inline-block;
    height: 18px;
}
.icon.copy:before {
    content: '';
    width: 12px;
    height: 17px;
    position: absolute;
    top: 0;
    left: 0;
    border: 1px solid #a6a6a6;
    border-radius: 2px;
    background: #fff;
}
.icon.copy:after {
    content: '';
    width: 12px;
    height: 17px;
    position: absolute;
    top: 3px;
    left: 3px;
    border: 1px solid #a6a6a6;
    border-radius: 2px;
    background: #fff;
}
.alumni_profile_image_wrap {
    width: 110px;
    height: 110px;
    background: #f1f1f1;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 20px;
    position: relative;
}
.alumni_profile_image_wrap .alumni_profile_image {
    margin: 0;
}
.alumni_profile_image_wrap .pencil-edit {
    position: absolute;
    top: 0;
    right: 0;
    background-color: #5cae48;
    padding: 2px;
    border-radius: 50%;
    background-size: 12px auto;
    width: 30px;
    height: 30px;
    transition: all 0.3s ease-in-out;
}
.alumni_profile_image_wrap .pencil-edit:hover {
    background-color: #72bb60;
}
.modal .form-control[name*='countryCode'] {
    width: 65px !important;
}
.modal .btn-verify {
    display: block;
    height: 25px;
    line-height: 25px;
    padding: 0 15px !important;
    width: auto;
    font-size: 12px;
    text-transform: uppercase;
    text-align: center;
    font-weight: 500;
}
.modal .form-label a.icon.icon-cross {
    background: red;
    color: #fff;
    font-size: 8px;
    padding: 4px;
    border-radius: 50%;
    margin: 0;
}

@media (prefers-reduced-motion: reduce) {
    .select2-container--bootstrap4 .select2-selection {
        transition: none;
    }
}

.select2-container {
    width: 100%;
}
.select2-container .select2-search--inline .select2-search__field {
    width: 100% !important;
}
.select2-container--bootstrap4.select2-container--focus .select2-selection {
    border-color: #80bdff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.select2-container--bootstrap4.select2-container--focus.select2-container--open .select2-selection {
    border-bottom: none;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
}
.select2-container--bootstrap4.select2-container--open.select2-container--above .select2-selection {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
}
.select2-container--bootstrap4.select2-container--open.select2-container--below .select2-selection {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
}
.select2-container--bootstrap4.select2-container--disabled .select2-selection,
.select2-container--bootstrap4.select2-container--disabled.select2-container--focus .select2-selection {
    cursor: not-allowed;
    background-color: #e9ecef;
    border-color: #ced4da;
    box-shadow: none;
}
.select2-container--bootstrap4.select2-container--disabled .select2-search__field,
.select2-container--bootstrap4.select2-container--disabled.select2-container--focus .select2-search__field {
    background-color: transparent;
}
select.is-invalid ~ .select2-container--bootstrap4 .select2-selection,
form.was-validated select:invalid ~ .select2-container--bootstrap4 .select2-selection {
    border-color: #dc3545;
}
select.is-valid ~ .select2-container--bootstrap4 .select2-selection,
form.was-validated select:valid ~ .select2-container--bootstrap4 .select2-selection {
    border-color: #28a745;
}
.select2-container--bootstrap4 .select2-search {
    width: 100%;
}
.select2-container--bootstrap4 .select2-dropdown {
    border-color: #ced4da;
    border-radius: 0;
}
.select2-container--bootstrap4 .select2-dropdown.select2-dropdown--below {
    border-top: none;
    border-bottom-right-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
}
.select2-container--bootstrap4 .select2-dropdown.select2-dropdown--above {
    border-top: 1px solid #ced4da;
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
}
.select2-container--bootstrap4 .select2-dropdown .select2-results__option[aria-selected='true'] {
    color: #212529;
    background-color: #f2f2f2;
}
.select2-container--bootstrap4 .select2-results__option[role='group'] {
    padding: 0;
}
.select2-container--bootstrap4 .select2-results__option[role='group'] .select2-results__options--nested .select2-results__option {
    padding-left: 1em;
}
.select2-container--bootstrap4 .select2-results__option {
    padding: 8px 15px 8px 35px;
    position: relative;
}
.select2-container--bootstrap4 .select2-results__option:before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 10px;
    width: 15px;
    height: 15px;
    border: 1px solid #868686;
    margin: auto;
    border-radius: 3px;
}
.select2-container--bootstrap4 .select2-results__option--highlighted,
.select2-container--bootstrap4 .select2-results__option--highlighted.select2-results__option[aria-selected='true'] {
    color: #fff;
    background-color: #007bff;
}
.select2-container--bootstrap4 .select2-results__option[aria-selected='true']::before {
    border: 1px solid #868686;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
    background-repeat: no-repeat;
    background-position: center;
    background-size: 15px 15px;
}
.select2-container--bootstrap4 .select2-results__option--highlighted.select2-results__option[aria-selected='false']::before {
    border: 1px solid #fff;
}
.select2-container--bootstrap4 .select2-results__option--highlighted.select2-results__option[aria-selected='true']::before {
    border: 1px solid #fff;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
    background-repeat: no-repeat;
    background-position: center;
    background-size: 15px 15px;
}
.select2-container--bootstrap4 .select2-results > .select2-results__options {
    max-height: 15em;
    overflow-y: auto;
}
.select2-container--bootstrap4 .select2-results__group {
    display: list-item;
    padding: 6px;
    color: #6c757d;
}
.select2-container--bootstrap4 .select2-selection__clear {
    float: right;
    width: 0.9em;
    height: 0.9em;
    padding-left: 0.15em;
    margin-top: 0.7em;
    margin-right: 0.3em;
    line-height: 0.75em;
    color: #f8f9fa;
    background-color: #c8c8c8;
    border-radius: 100%;
}
.select2-container--bootstrap4 .select2-selection__clear:hover {
    background-color: #afafaf;
}
.select2-container--bootstrap4 .select2-selection--single {
    height: calc(1.5em + 0.75rem + 2px) !important;
}
.select2-container--bootstrap4 .select2-selection--single .select2-selection__placeholder {
    line-height: calc(1.5em + 0.75rem);
    color: #6c757d;
}
.select2-container--bootstrap4 .select2-selection--single .select2-selection__arrow {
    position: absolute;
    top: 50%;
    right: 3px;
    width: 20px;
}
.select2-container--bootstrap4 .select2-selection--single .select2-selection__arrow b {
    position: absolute;
    top: 60%;
    left: 50%;
    width: 0;
    height: 0;
    margin-top: -2px;
    margin-left: -4px;
    border-color: #343a40 transparent transparent transparent;
    border-style: solid;
    border-width: 5px 4px 0;
}
.select2-container--bootstrap4 .select2-selection--single .select2-selection__rendered {
    padding-left: 0.75rem;
    line-height: calc(1.5em + 0.75rem);
    color: #495057;
}
.select2-search--dropdown .select2-search__field {
    padding: 0.375rem 0.75rem;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
}
.select2-results__message {
    color: #6c757d;
}
.select2-container--bootstrap4 .select2-selection--multiple {
    min-height: calc(1.5em + 0.75rem + 2px) !important;
}
.select2-container--bootstrap4 .select2-selection--multiple .select2-selection__rendered {
    box-sizing: border-box;
    width: 100%;
    padding: 0 0.375rem;
    margin: 0;
    list-style: none;
}
.select2-container--bootstrap4 .select2-selection--multiple .select2-selection__choice {
    float: none;
    padding: 0;
    padding-right: 0.75rem;
    margin-top: 7px;
    margin-right: 0.375rem;
    color: #495057;
    cursor: pointer;
    border: 1px solid #bdc6d0;
    border-radius: 0.2rem;
    display: inline-block;
}
.select2-container--bootstrap4 .select2-selection--multiple .select2-search__field {
    color: #495057;
}
.select2-container--bootstrap4 .select2-selection--multiple .select2-selection__choice + .select2-search {
    width: 0;
    display: none;
}
.select2-container--bootstrap4 .select2-selection--multiple .select2-selection__choice__remove {
    float: left;
    padding-right: 3px;
    padding-left: 3px;
    margin-right: 1px;
    margin-left: 3px;
    font-weight: 700;
    color: #bdc6d0;
}
.select2-container--bootstrap4 .select2-selection--multiple .select2-selection__choice__remove:hover {
    color: #343a40;
    display: none;
}
.select2-container--bootstrap4 .select2-selection--multiple .select2-selection__clear {
    position: absolute !important;
    top: 0;
    right: 0.7em;
    float: none;
    margin-right: 0;
}
.select2-container--bootstrap4.select2-container--disabled .select2-selection--multiple .select2-selection__choice {
    padding: 0 5px;
    cursor: not-allowed;
}
.select2-container--bootstrap4.select2-container--disabled
    .select2-selection--multiple
    .select2-selection__choice
    .select2-selection__choice__remove {
    display: none;
}
.select-option .select2-container--bootstrap4 .select2-selection--multiple .select2-selection__rendered {
    height: 42px;
}
.select-option .select2-container--bootstrap4 .select2-selection {
    border: 1px solid #0b3454;
    height: 42px;
    border-radius: 6px;
}
.select-option .select2-container--bootstrap4.select2-container--focus .select2-selection {
    border-color: #0b3454;
    box-shadow: 0 0 0 0 rgba(0, 123, 255, 0.25);
}
.select2-container .select2-search--inline .select2-search__field {
    margin: 0 !important;
    padding: 5px 10px !important;
}
.select2-container--bootstrap4 .select2-selection {
    border: 1px solid #0b34544d !important;
    border-radius: 6px !important;
    height: 45px !important;
    font-weight: 500 !important;
    display: flex;
    align-items: center;
}
.select2-container--bootstrap4 .select2-selection--multiple .select2-selection__clear {
    margin: auto;
    top: 0;
    bottom: 0;
}
.select2-container--bootstrap4 .select2-selection {
    display: flex !important;
    align-items: center;
}
.select2-container--bootstrap4 .select2-selection--multiple .select2-search__field {
    margin: 0;
}
.select2-container--bootstrap4 .select2-selection--multiple .select2-selection__choice {
    margin: 2px 4px 2px 0 !important;
}
.select2-container--bootstrap4 .select2-selection--multiple .select2-search__field {
    color: #495057;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
    background-repeat: no-repeat;
    background-position: right 0.75rem center;
    background-size: 16px 12px;
}
.custom-select-multi .select2-container--bootstrap4 .select2-selection {
    height: 45px;
    border-color: #b5c2cb;
    box-shadow: none;
}
.custom-select-multi .select2-container--bootstrap4 .select2-selection .select2-search__field {
    margin: 0;
    height: 43px;
    width: 100% !important;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
    background-repeat: no-repeat;
    background-position: right 0.75rem center;
    background-size: 16px 12px;
}
.section-edit .select2-container--bootstrap4 .select2-selection {
    height: 55px !important;
    border-radius: 3px !important;
}
/* multi select end*/

.card_form .custom-border-84-20 {
    border: 1px solid #0b345480;
    border-radius: 5px;
    width: 20px;
    height: 20px;
    margin: 0 10px 0 0;
    position: static;
}
.card_form .custom-border-84-20:checked[type='radio'] {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___}) !important;
    background-color: #5cae48 !important;
    border-color: #5cae48 !important;
    box-shadow: none;
}
.inputfile_parent label {
    height: 80px;
    line-height: 60px;
}
.action_btns {
    background: #f5faff;
    border-radius: 6px;
    padding: 18px;
    min-height: 80px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
}
.action_btns .btn-submit {
    background: #29a745;
    height: 45px;
    border-radius: 25px;
    min-width: 180px;
    font-size: 16px;
    font-weight: 500;
    margin: 0 10px;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    text-decoration: none;
}
.action_btns .btn-submit:hover {
    background: #1b9737;
}
.action_btns .btn-cancel {
    width: auto;
    height: auto;
    background: none;
    font-size: 12px;
    text-transform: uppercase;
    color: #00000098;
    font-weight: 600;
    margin: 0 10px;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.action_btns .btn-cancel:hover {
    color: #000;
}
.action_btns .btn-viewsummary {
    background: #0b3454;
    height: 45px;
    border-radius: 25px;
    min-width: 180px;
    font-size: 16px;
    font-weight: 500;
    margin: 0 10px;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    color: #fff;
}
.action_btns .btn-viewsummary:hover {
    background: #0c8db6;
}
.form-switch .form-check-input {
    width: 60px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
    background-position: left center;
    border-radius: 2em;
    transition: background-position 0.15s ease-in-out;
    height: 28px;
}
.form-switch .form-check-input:checked {
    background-position: right center;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
}
.alumni_profile_brife_tab.student_profile_brife_tab {
    margin-bottom: 5px;
    overflow: auto;
    padding-bottom: 20px;
}
.alumni_profile_brife_tab.student_profile_brife_tab {
    margin-bottom: 5px;
    overflow: auto;
    padding-bottom: 20px;
    scrollbar-width: thin;
}
.alumni_profile_brife_tab.student_profile_brife_tab .nav {
    justify-content: center;
    width: max-content;
}
.alumni_profile_brife_tab::-webkit-scrollbar {
    height: 4px;
}
.alumni_profile_brife_tab::-webkit-scrollbar-track {
    background: #ccc;
}
.alumni_profile_brife_tab::-webkit-scrollbar-thumb {
    background-color: #eee;
    border-radius: 2px;
    border: 1px solid #ccc;
}
.tab-pane-tab {
    border: 0;
}
.tab-pane-tab .nav-item .nav-link {
    border: 1px solid #a9abae;
    padding: 0 20px;
    border-radius: 25px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 130px;
    color: #374050;
}
.tab-pane-tab .nav-item:not(:last-child) {
    margin-right: 10px;
}
.tab-pane-tab .nav-item .nav-link.active,
.tab-pane-tab .nav-item:hover .nav-link {
    border: 1px solid #5cae48;
    background: #5cae48;
    color: #fff;
}
.modal .icon.icon-cross.btn-delete {
    position: absolute;
    right: 20px;
    top: 20px;
    border-radius: 50%;
    background: #d42941;
    font-size: 8px;
    padding: 5px;
    width: 20px;
    height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
}
.custom-switch {
    padding: 0;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
}
.custom-switch label {
    background: #fff;
    padding: 5px;
    border-radius: 25px;
    position: relative;
    width: 100px;
    height: 40px;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    align-items: center;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    border: 2px solid #f34e65;
    color: #f34e65;
}
.custom-switch input + label::before {
    width: 24px;
    height: 24px;
    display: inline-block;
    background: #f34e65;
    border-radius: 50%;
    content: '';
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.custom-switch input + label::after {
    content: 'NO';
    color: #f34e65;
    flex: 1 1;
    text-align: center;
    font-weight: 500;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.custom-switch input:checked + label {
    background: #5dae48;
    border-color: #5dae48;
}
.custom-switch input:checked + label::before {
    transform: translateX(62px);
    -webkit-transform: translateX(62px);
    -moz-transform: translateX(62px);
    -ms-transform: translateX(62px);
    -o-transform: translateX(62px);
    background: #fff;
}
.custom-switch input:checked + label::after {
    transform: translateX(-30px);
    content: 'YES';
    -webkit-transform: translateX(-30px);
    -moz-transform: translateX(-30px);
    -ms-transform: translateX(-30px);
    -o-transform: translateX(-30px);
    color: #fff;
}

@media (max-width: 991px) {
    div.table-responsive table.sticky_table_3_columns td,
    div.table-responsive table.sticky_table_3_columns th {
        position: static;
    }
    div.table-responsive table.sticky_table_3_columns_noaction td,
    div.table-responsive table.sticky_table_3_columns_noaction th {
        position: static;
    }
    div.table-responsive table.sticky_table_4_columns td,
    div.table-responsive table.sticky_table_4_columns th {
        position: static;
    }
}

@media (min-width: 767px) {
    .table-responsive.attendee_dtl.sticky-table > table td:first-child,
    .table-responsive.attendee_dtl.sticky-table > table th:first-child {
        position: sticky;
        left: 0;
        z-index: 2;
    }
    .table-responsive.attendee_dtl.sticky-table > table td:nth-child(2),
    .table-responsive.attendee_dtl.sticky-table > table th:nth-child(2) {
        position: sticky;
        left: 232px;
        z-index: 2;
    }
    .table-responsive.attendee_dtl.sticky-table > table td:first-child:before,
    .table-responsive.attendee_dtl.sticky-table > table td:nth-child(2):before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        margin: auto;
        background: #fff;
    }
    .table-responsive.attendee_dtl.sticky-table > table td:first-child div,
    .table-responsive.attendee_dtl.sticky-table > table td:nth-child(2) div {
        z-index: 1;
        position: relative;
    }
    .table-responsive.attendee_dtl.sticky-table > table th:nth-child(2)::after,
    .table-responsive.attendee_dtl.sticky-table > table td:nth-child(2)::after {
        content: '';
        background: transparent linear-gradient(270deg, #ffffff 0%, #000000 100%) 0% 0% no-repeat padding-box;
        opacity: 0.1;
        width: 30px;
        position: absolute;
        right: -30px;
        bottom: 0;
        top: 0;
    }
    .table-responsive.attendee_dtl.sticky-table > table td:nth-child(3),
    .table-responsive.attendee_dtl.sticky-table > table th:nth-child(3) {
        padding-left: 30px;
        width: 150px;
    }
    .table-responsive.sticky-table {
        overflow-x: scroll;
        scrollbar-width: thin;
    }
    .table-responsive.sticky-table::-webkit-scrollbar {
        height: 4px;
    }
    .table-responsive.sticky-table::-webkit-scrollbar-track {
        background: #f1f1f1;
    }
    .table-responsive.sticky-table::-webkit-scrollbar-thumb {
        background: #888;
    }
    .table-responsive.sticky-table::-webkit-scrollbar-thumb:hover {
        background: #555;
    }
}

@media (max-width: 1138px) {
    .alumni_statistics .horizontalScrol {
        overflow-x: auto;
        padding-bottom: 15px;
    }
    .alumni_statistics .horizontalScrol::-webkit-scrollbar {
        height: 3px;
    }
    .alumni_statistics .horizontalScrol::-moz-scrollbar {
        height: 3px;
    }
    .alumni_statistics .horizontalScrol::-webkit-scrollbar-track {
        background: #eee;
    }
    .alumni_statistics .horizontalScrol::-webkit-scrollbar-thumb {
        background-color: #666;
        border-radius: 20px;
        border: 2px solid #666;
    }
    .alumni_statistics .top-colleges .nav {
        flex-wrap: nowrap;
        justify-content: start !important;
    }
}

@media (max-width: 800px) {
    .alumni_statistics .top-colleges .slider {
        padding: 0;
    }
    .half-gray:before {
        display: none;
    }
}

@media (max-width: 575px) {
    .alumni_statistics .top-countries .caountryname,
    .alumni_statistics .top-countries .career {
        width: 100% !important;
        margin-bottom: 5px;
    }
    .alumni_statistics .top-countries .flex-grow-1 {
        width: calc(100% - 50px);
    }
    .alumni_statistics .top-countries .w-10 {
        width: 50px;
    }
    .alumni_statistics .card_profiles .action_btns {
        justify-content: start !important;
        flex-wrap: wrap;
    }
    .alumni_statistics .card_profiles .action_btns .btn-outline-primary {
        margin-bottom: 10px;
    }
    .alumni_statistics .card_profiles figure.student {
        width: 50px;
        height: 50px;
        left: 20px;
    }
    .alumni_statistics .card_profiles .student_details h2 {
        margin: 0 0 10px 60px;
    }
    .alumni_statistics .card_profiles .student_details .sub_details figure {
        min-width: 50px;
        height: 50px;
        width: 50px;
    }
    .univarsity_logo .logo img {
        max-width: 150px;
    }
}

@media (max-width: 480px) {
    .alumni_profile_college_name_other_detail_wrap .phone_number {
        width: 100%;
        margin-bottom: 10px;
    }
}

.single-column ~ .btn-delete {
    left: 50%;
    right: auto;
}
.single-column + .col-sm-6 ~ .btn-delete {
    left: 100%;
}

@media (max-width: 575px) {
    .single-column ~ .btn-delete {
        left: 100%;
    }
}

.menu-label-child {
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 5px;
    color: #26a7df;
}

.infinite-scroll-component {
    overflow-y: auto !important;
    overflow-x: hidden !important;
}
.form-select.assessment-select {
    width: 100%;
    max-width: 287px;
    border-radius: 25px;
    margin-right: 10px;
}

.mobile-select {
    display: none;
}

@media (max-width: 800px) {
    .headerRightSide .form-select.assessment-select {
        display: none;
    }
    .mobile-select {
        display: block;
        padding: 15px 4% 15px;
        background: #0b3454;
    }
    .mobile-select .form-select.assessment-select {
        width: 100%;
        max-width: 100%;
    }
}

/* broadcast form */

.responses_section {
    margin-top: 10px;
}
.responses_list {
    background: #f3f3f3 0% 0% no-repeat padding-box;
    border-radius: 6px;
    margin-bottom: 5px;
    height: 56px;
    display: flex;
    align-items: center;
    padding: 0 20px;
}
.responses_list .responses {
    width: 255px;
}
.responses_section .btn {
    margin-top: 20px;
}
.responses_section .btn:focus {
    box-shadow: none;
}
.responses_section .btn:focus-visible {
    outline: none;
}
.responses_list select {
    border: 2px solid #7d7d7d;
    border-radius: 18px;
    width: 130px;
    height: 36px;
    -o-appearance: none;
    appearance: none;
    background-color: #fff;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
    background-repeat: no-repeat;
    background-position: right 0.75rem center;
    background-size: 16px 12px;
    padding: 0 12px;
}
.uploaded-list {
    background: #ffffff 0% 0% no-repeat padding-box;
    border: 1px solid #d1d1d1;
    border-radius: 6px;
    margin-bottom: 5px;
    height: 50px;
    display: flex;
    align-items: center;
    padding: 10px 20px;
    position: relative;
}
.file-type {
    width: 22px;
    margin-right: 10px;
}
.file-type img {
    width: 100%;
}
.uploaded-list label {
    font-size: 16px;
    font-weight: 400;
}
.uploaded-list .btn-close {
    width: 8px;
    height: 10px;
    padding: 0;
    position: absolute;
    right: -20px;
    top: 0;
    bottom: 0;
    margin: auto;
    opacity: 0.4;
}
.customselect_parnt .custom-select {
    position: relative;
    width: max-content;
    flex: unset;
    min-width: 109px;
}
.customselect_parnt .custom-select select {
    display: none; /*hide original SELECT element: */
}
.customselect_parnt .select-selected {
    background-color: DodgerBlue;
}
.customselect_parnt .select-selected:after {
    position: absolute;
    content: '';
    top: 14px;
    right: 10px;
    width: 0;
    height: 0;
    border: 6px solid transparent;
    border-color: #fff transparent transparent transparent;
}
.customselect_parnt .select-selected.select-arrow-active:after {
    border-color: transparent transparent #fff transparent;
    top: 7px;
}
.customselect_parnt .select-selected {
    color: #414141;
    padding: 0px 40px 0 14px;
    border: 2px solid #7d7d7d;
    border-color: #7d7d7d;
    cursor: pointer;
    border-radius: 18px;
    height: 32px;
    width: max-content;
    transition: all 0.3s ease-in-out;
    background: #fff;
    font-size: 14px;
    font-weight: 500;
    line-height: 32px;
    min-width: 55px;
    box-sizing: initial;
    border-radius: 18px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    max-width: 55px;
}
.customselect_parnt .select-selected::after {
    position: absolute;
    content: '';
    top: 12px;
    right: 20px;
    width: 8px;
    height: 8px;
    border: unset;
    border-top: 2px solid #414141;
    border-right: 2px solid #414141;
    transform: rotate(135deg);
    transition: all 0.2s ease-in-out;
}
.customselect_parnt .select-selected.select-arrow-active::after {
    border: unset;
    top: 15px;
    border-top: 2px solid #7d7d7d;
    border-right: 2px solid #7d7d7d;
    transform: rotate(-45deg);
    width: 10px;
    height: 10px;
    right: 12px;
}
.customselect_parnt .select-items div {
    color: #000000;
    padding: 3px 16px;
    border: 0px solid transparent;
    border-color: transparent transparent rgba(0, 0, 0, 0.1) transparent;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
}
.customselect_parnt .select-items div:first-child {
    margin-top: 10px;
}
.customselect_parnt .select-items div:last-child {
    margin-bottom: 10px;
}
.customselect_parnt .select-items {
    position: absolute;
    background-color: #fff;
    top: 100%;
    left: 0;
    right: 0;
    z-index: 99;
    border: 1px solid #dedede;
    border-radius: 18px;
    box-shadow: 0px 10px 20px #0000001a;
    width: 145px;
}
.customselect_parnt .select-hide {
    display: none;
}
.customselect_parnt .select-items div:hover,
.customselect_parnt .same-as-selected {
    background-color: rgba(0, 0, 0, 0.1);
}
.send_msg_text {
    width: max-content;
}
.send_msg_text > a {
    width: 150px;
    height: 70px;
    background: #5cae48;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    color: #fff;
    text-decoration: none;
    font-size: 16px;
    line-height: 23px;
    font-weight: 500;
}
.send_msg_text > a:not(:last-child) {
    margin-right: 10px;
}
.uniprof_btnmbl_align.paddings-67 {
    padding-left: 20px;
}
.welcome_pg {
    padding-left: 50px;
    padding-right: 50px;
}
.cpw_bg {
    padding: 40px;
    background: #f8f8f8;
    border-radius: 8px;
    margin: 0 0 30px 0;
}
.cpw_bg > div {
    width: 94%;
    max-width: 385px;
    margin: 0 auto;
}
.icon-green-right {
    width: 48px;
    height: 48px;
    background: #3bb54a;
    border-radius: 50%;
    margin: auto auto 25px;
    position: relative;
}
.icon-green-right:after {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    width: 23px;
    height: 13px;
    border-left: 5px solid #fff;
    border-bottom: 5px solid #fff;
    content: '';
    transform: rotate(-45deg);
    top: -7px;
}
.searchrw {
    position: relative;
    background: #f1f1f1;
    padding: 30px;
    border-radius: 6px;
}
.searchrw .btn.icon-search {
    position: absolute;
    padding: 0;
    left: 15px;
    top: 0;
    bottom: 0;
    margin: auto;
}
form.lstCustForm .searchrw input.form-control {
    border: 1px solid #e1e1e1;
    border-radius: 20px;
    padding: 0 0 0 50px;
}
.search_sugg .chkboxal {
    position: relative;
    padding-right: 35px;
}
.search_sugg .chkboxal .form-check {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    left: auto;
    margin: auto;
}
form.lstCustForm .search_sugg .chkboxal .form-check .form-check-input {
    width: 20px;
    height: 20px;
    margin-left: 0;
}
select {
    cursor: pointer;
}

@media (max-width: 575px) {
    form.lstCustForm .inputfile_parent label span.uploadlabel {
        line-height: 18px;
        white-space: normal;
    }
    .uploaded-list label {
        line-height: 16px;
    }
}

.lstCustForm .ql-toolbar.ql-snow {
    border-radius: 5px 5px 0 0;
    -webkit-border-radius: 5px 5px 0 0;
    -moz-border-radius: 5px 5px 0 0;
    -ms-border-radius: 5px 5px 0 0;
    -o-border-radius: 5px 5px 0 0;
}
.lstCustForm .ql-container.ql-snow {
    border-radius: 0 0 5px 5px;
    -webkit-border-radius: 0 0 5px 5px;
    -moz-border-radius: 0 0 5px 5px;
    -ms-border-radius: 0 0 5px 5px;
    -o-border-radius: 0 0 5px 5px;
    min-height: 250px;
}
.lstCustForm .ql-container.ql-snow .ql-editor {
    min-height: 250px;
}

h2.title::after {
    content: '';
    width: 40px;
    height: 2px;
    background: #2680eb;
    position: absolute;
    bottom: 0;
    left: 0;
}
h2.title.text-center::after {
    right: 0;
    margin: auto;
}

.btn-takeTest {
    border: 2px solid #0b3454;
    height: 40px;
    border-radius: 25px;
    padding: 0 25px;
    display: flex;
    align-items: center;
    text-decoration: none;
    font-weight: 500;
    color: #0b3454;
    background: #fff;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.btn-takeTest:hover {
    background: #0b3454;
    color: #fff;
}

.select-search-group .form-select {
    border-top-left-radius: 25px !important;
    border-bottom-left-radius: 25px !important;
    padding-left: 20px;
}

.package-wrap {
    margin: 20px auto 0px auto;
    display: inline-flex;
    flex-wrap: wrap;
    width: 100%;
}
.package-list-type {
    display: flex;
    border-bottom: 1px solid #dfe1e4;
    border-right: 1px solid #dfe1e4;
    border-radius: 0 0 6px 0;
    position: relative;
    width: calc(100% - 300px);
    overflow: auto;
}
.package-list-type {
    overflow-x: auto;
    scrollbar-width: thin;
}
.package-list-type::-webkit-scrollbar {
    height: 5px;
}
.package-list-type::-webkit-scrollbar-track {
    background: #ccc;
}
.package-list-type::-webkit-scrollbar-thumb {
    background-color: #333;
    border-radius: 2px;
    border: 1px solid #ccc;
}

.package-list-title {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 600;
    height: 50px;
}
.package-list-title label {
    margin-right: 10px;
}
.package-list .package-list-title + ul {
    margin-top: 0;
}
.package-list ul {
    list-style: none;
    margin: 50px 0 0 0;
    padding: 0px 0 10px;
    background: #fff;
    border-radius: 6px 0px 0px 6px;
    border: 1px solid #dfe1e4;
    border-right: none;
}
.package-list ul li {
    padding: 0 40px;
    font-size: 16px;
    font-weight: 500;
    line-height: 23px;
    height: 60px;
    display: flex;
    align-items: center;
}
.package-list ul li span {
    line-height: 20px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}
.package-list ul li:nth-child(even) {
    background: #f6f8fa;
}
.package-type {
    flex: 1 1;
    min-width: 178px;
    position: relative;
}
.package-type ul {
    margin: 0;
    padding: 0;
    list-style: none;
}
.package-list {
    width: 300px;
}
.package-type ul li {
    display: flex;
    justify-content: center;
    align-items: center;
}
.package-type-header {
    border-radius: 6px 6px 0px 0px;
    opacity: 1;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-weight: 500;
    font-size: 20px;
}
.package-type-header.starter {
    background: transparent linear-gradient(270deg, #168abc 0%, #25a1d6 34%, #2596c7 66%, #228aaa 100%);
}
.package-type-header.bronze {
    background: transparent linear-gradient(270deg, #a96b4d 0%, #d7a169 34%, #d7a068 66%, #8f4c2e 100%);
}
.package-type-header.sliver {
    background: transparent linear-gradient(270deg, #858585 0%, #9598a0 34%, #b3b6bd 66%, #828280 100%);
}
.package-type-header.gold {
    background: transparent linear-gradient(270deg, #d0b211 0%, #d9c246 34%, #d8c63d 66%, #c8993f 100%);
}
.package-type-header.defaultHeader {
    border: 1px solid #dfe1e4;
    height: 51px;
    color: #000;
    font-size: 16px;
}
.package-type-body {
    border-left: 1px solid #dfe1e4;
    border-right: 1px solid #dfe1e4;
    padding: 1px 0 10px;
    background-color: #fff;
}
.package-type:not(:last-child) {
    margin-right: 10px;
}
.package-type ul li {
    height: 60px;
}
.package-type ul li:nth-child(even) {
    background: #f6f8fa;
}
.package-type-body .form-check-input {
    position: static;
    margin: 0;
    width: 23px;
    height: 23px;
    border: 1px solid #0b345480;
    border-radius: 4px;
    opacity: 1;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
    background-size: 21px;
}
.package-type-body .form-check-input:checked {
    background-color: #29a745;
    border-color: #29a745;
}

.package-type:last-child {
    border-radius: 0 0 10px 0;
    overflow: hidden;
}
.package-list-type:before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    border: 0;
    height: calc(100% - 50px);
    background: white;
    border-radius: 0 0 6px;
    top: 50px;
}

.package-wrap .slimScrollDiv {
    flex: auto;
    height: auto !important;
    overflow: visible !important;
}
.package-wrap .slimScrollDiv .package-list-type {
    width: 100% !important;
    height: 100% !important;
}
.slimScrollWrapper {
    position: sticky;
    bottom: 20px;
}

@media (max-width: 575px) {
    .package-list {
        width: 150px;
    }
    .package-list ul li {
        padding: 0 15px;
    }
    .package-list-type {
        width: calc(100% - 150px);
    }
}

.option ul {
    list-style: none;
    margin: 11px 0;
    text-align: left;
    border: 1px solid #ccc;
    padding: 10px;
    border-radius: 5px;
    font-size: 14px;
    line-height: 18px;
    position: relative;
}
.option ul li:not(:last-child) {
    margin-bottom: 7px;
}
.option ul:before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    top: -6px;
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid #ccc;
}
.option ul a {
    font-size: 14px;
}

.icon-reset {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/reset.svg);
    width: 15px;
    height: 15px;
    display: inline-block;
    transform: scaleX(-1);
    -webkit-transform: scaleX(-1);
    -moz-transform: scaleX(-1);
    -ms-transform: scaleX(-1);
    -o-transform: scaleX(-1);
}
.btn-reset {
    display: flex;
    align-items: center;
    color: #0b3454;
    opacity: 0.8;
    padding-left: 0;
    padding-right: 0;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.btn-reset .icon-reset {
    margin-right: 5px;
}
.btn-reset:hover {
    opacity: 1;
}

.match-list {
    padding: 0;
    margin: 0;
    list-style: none;
}
.match-list li {
    position: relative;
    padding-left: 10px;
}
.match-list li::before {
    content: '';
    width: 6px;
    height: 6px;
    background: #0a3454;
    border-radius: 50%;
    position: absolute;
    left: 0;
    top: 7px;
    opacity: 0.3;
}
.match-list li a {
    color: #0b3454;
}
.match-list li a:hover {
    color: #5cae48;
}
.show-more-btn {
    border: none;
    background: none;
    color: #099af3;
}
.show-more-btn:hover {
    color: #5cae48;
}
fieldset .form-check-inline {
    min-height: 45px;
    display: inline-flex;
    align-items: center;
    margin-top: 2px;
}
fieldset .form-check-inline input {
    margin-right: 5px;
    width: 20px;
    height: 20px;
    transition: all 0.3s ease-in-out;
}
fieldset .form-check-inline .form-check-label {
    margin-top: 2px;
}
.swal2-container {
    z-index: 99999;
}

.btn-modal {
    position: absolute;
    right: 20px;
    top: 20px;
    width: 13px;
    height: 13px;
    padding: 0;
    background-size: 100%;
    z-index: 9;
}

.green-tick {
    padding: 0;
    margin: 0 0 20px;
    list-style: none;
}
.green-tick li {
    position: relative;
    padding: 0 0 0 20px;
}
.green-tick li:not(:last-child) {
    margin-bottom: 10px;
}
.green-tick li:before {
    content: '';
    position: absolute;
    width: 12px;
    height: 7px;
    border-left: 3px solid #5cae48;
    border-bottom: 3px solid #5cae48;
    top: 8px;
    left: 0;
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
    -moz-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    -o-transform: rotate(-45deg);
}

/* new csss for uei */
.alumni-networks-block {
    border: 1px solid #c8c8c8;
    border-radius: 10px;
    background: white;
    padding: 30px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-shadow: 0 10px 12px 0px #ccc;
    height: 100%;
    text-align: center;
}

.alumni-networks-form .alumni-networks-block {
    background: #ffffff;
    box-shadow: 0px 3px 6px #0000001a;
    border: 1px solid #d2d2d2;
    border-radius: 6px;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    -ms-border-radius: 6px;
    -o-border-radius: 6px;
}

.alumni-networks-block img {
    margin-bottom: 30px;
}

.alumni-networks-block h4 {
    margin-bottom: 20px;
    color: #0b3454;
    font-size: 20px;
    font-weight: 500;
}

.alumni-networks-block-wrap {
    position: relative;
}

.alumni-networks-block-wrap:before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    background: #51499c;
    height: 170px;
}

.alumni-networks-block-wrap.alumni-networks-form:before {
    height: 300px;
}

.alumni-networks-header h1 {
    color: #fff;
    font-size: 36px;
    font-weight: 600;
    line-height: 37px;
    margin-bottom: 20px;
}

.alumni-networks-header p {
    color: #fff;
    font-size: 20px;
}

.alumni-networks-block .btn-green {
    width: 180px;
    height: 45px;
    font-size: 16px;
}
.center-block {
    margin-left: auto;
    margin-right: auto;
    display: block;
}

label[for='agreeToUnivariety'] {
    order: 1;
}

/* new css 05022024 */

/* milestone */
.welcome-title h1 {
    font-size: 35px;
    font-weight: 600;
    margin: 0 0 5px;
}
.welcome-title p {
    font-size: 18px;
    margin: 0;
}

.milestone {
    background: #fff;
    box-shadow: 0px 3px 6px #0000001a;
    border: 1px solid #d2d2d2;
    border-radius: 6px;
    height: 100%;
    position: relative;
    padding: 20px 20px 30px;
    text-align: center;
}
.milestone .icon {
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    top: -33px;
    background: #d42941;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
}
.milestone .icon span {
    font-size: 25px;
    color: #fff;
    transition: all 0.3s ease-in-out;
}
span.icon-gear-hat {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/knowledge-management.svg) no-repeat 0
        0 / 100%;
    width: 28px;
    height: 28px;
    filter: invert(1);
    transform: scaleX(-1);
    -webkit-transform: scaleX(-1);
    -moz-transform: scaleX(-1);
    -ms-transform: scaleX(-1);
    -o-transform: scaleX(-1);
    -webkit-filter: invert(1);
}
.milestone .icon span:before {
    color: #fff;
}
.milestone .count {
    font-size: 22px;
    font-weight: 600;
    text-align: left;
}
.milestone .btn {
    height: 40px;
    text-align: center;
    margin: auto;
    display: inline-block;
    padding: 0 25px;
    border-radius: 25px;
    line-height: 36px;
    overflow: hidden;
    position: relative;
}
.milestone .btn span,
.btn-green span,
.btn-liteblue span,
.btn-invite span {
    position: relative;
}

.milestone h3 {
    text-align: center;
    max-width: 162px;
    margin: auto;
    font-size: 20px;
    font-weight: 600;
}
.milestone .count {
    font-size: 22px;
    font-weight: 600;
}
.milestone h3 {
    text-align: center;
    max-width: 162px;
    margin: auto;
    font-size: 20px;
    font-weight: 600;
}
.milestone .progress-status {
    padding: 0;
    display: flex;
    text-align: center;
    list-style: none;
    justify-content: center;
    align-items: center;
    margin: 20px 0 0;
}
.milestone .progress-status li {
    width: 40px;
    height: 3px;
    background: #dedede;
    display: inline-block;
    margin: 0 3px;
}
.milestone .progress-status li.completed {
    background: #5cae48;
}
.activities_status {
    font-size: 16px;
    font-weight: 600;
    text-align: center;
    margin-bottom: 20px;
    cursor: pointer;
    padding: 15px 0 0 0;
}

.activities_status_hovercont ol {
    margin: 0 0 0 20px;
    padding: 0 10px 0 0;
    text-align: left;
}
.activities_status_hovercont ol li {
    line-height: 18px;
}
.activities_status_hovercont ol li:not(:last-child) {
    margin: 0 0 8px 0;
}
.activities_status_hovercont {
    background: #fff;
    border: 1px solid #d2d2d2;
    border-radius: 6px;
    padding: 20px;
    width: 270px;
    height: 165px;
    position: absolute;
    top: -30px;
    left: 0;
    right: 0;
    margin: auto;
    box-shadow: 0px 3px 6px #0000001a;
    display: none;
}
.activities_status_hovercont::after {
    position: absolute;
    content: '';
    width: 23px;
    height: 18px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/hover_after.png) left top no-repeat;
    bottom: -18px;
}
.activities_status_hovercont > div {
    height: 125px;
    max-height: 125px;
    font-size: 14px;
    font-weight: 400;
}
.activities_status:hover .activities_status_hovercont {
    display: block;
    color: #000;
}
.activities_status:hover {
    color: #26a7df;
}
.slimScrollDiv .slimScrollBar {
    width: 4px !important;
    background: #dedede !important;
    opacity: 1 !important;
    right: 0 !important;
}
.slimScrollDiv .slimScrollRail {
    display: block !important;
    width: 1px !important;
    right: 1px !important;
    opacity: 1 !important;
    background: #676767 !important;
    left: auto !important;
}

.activities_status_hovercont > div::-webkit-scrollbar {
    scrollbar-width: thin;
}

.btn-verify {
    background: linear-gradient(to right, #185584 50%, #0d3453 50%);
    color: #fff;
    width: 140px;
    height: 40px;
    line-height: 38px;
    padding: 0 25px;
    text-decoration: none;
    border-radius: 25px;
    text-align: center;
    background-size: 200% 100%;
    transition: all 0.5s;
    background-position: right bottom;
    border: 1px solid #0d3453;
    font-size: 16px;
    font-weight: 500;
}
.btn-border {
    background: linear-gradient(to right, #185584 50%, #0d3453 50%);
    color: #fff;
    width: max-content;
    height: 40px;
    line-height: 38px;
    padding: 0 25px;
    text-decoration: none;
    border-radius: 25px;
    text-align: center;
    background-size: 200% 100%;
    transition: all 0.5s;
    background-position: right bottom;
    border: 1px solid #0d3453;
    font-size: 16px;
    font-weight: 500;
    display: block;
    margin: 0 auto;
}
.btn-border:hover,
.btn-verify:hover {
    background-position: left bottom;
    color: #fff;
    background-size: 201% 100%;
}

.icn_details .btn-green {
    width: 140px;
}
.icn_details .btn-green span {
    font-weight: 500;
    font-size: 16px;
}
.icn_details .btn-green span.icon-correct::before {
    font-size: 13px;
}
a.dashb_arr {
    width: 40px;
    height: 40px;
    background: #f1f1f1;
    border-radius: 50%;
    position: relative;
    display: inline-block;
}
a.dashb_left::before {
    content: '';
    width: 8px;
    height: 8px;
    background: transparent;
    display: inline-block;
    position: absolute;
    left: 17px;
    top: 0;
    bottom: 0;
    right: auto;
    margin: auto;
    border-top: 1.5px solid #000;
    border-right: 1.5px solid #000;
    transform: rotate(-135deg);
}
a.dashb_right::before {
    content: '';
    width: 8px;
    height: 8px;
    background: transparent;
    display: inline-block;
    position: absolute;
    left: 15px;
    top: 0;
    bottom: 0;
    right: auto;
    margin: auto;
    border-top: 1.5px solid #000;
    border-right: 1.5px solid #000;
    transform: rotate(45deg);
}
.iconsec {
    height: 50px;
    width: 50px;
    background: #d42941;
    border-radius: 50%;
}
.iconsec > b {
    color: #fff;
    font-size: 23px;
}
.icn_details {
    background: #ffffff;
    box-shadow: 0px 3px 6px #0000001a;
    border: 1px solid #d2d2d2;
    border-radius: 6px;
    padding: 25px 30px;
}
.iconsec_title {
    font-weight: 500;
    font-size: 18px;
    color: #000;
    margin: 0;
}
.iconsec_cont {
    font-weight: 400;
    font-size: 16px;
    color: #000;
    display: none;
    margin: 0 0 8px;
}
.iconsec_link {
    text-decoration: underline;
    color: #147ad6;
    font-size: 14px;
}
.iconsec_link:hover {
    text-decoration: none;
}
.iconsec_link .readmore {
    display: block;
}
.iconsec_link .readless {
    display: none;
}
.iconsec_link.active .readmore {
    display: none;
}
.iconsec_link.active .readless {
    display: block;
}
.profile_setup_cont .row > .profile_setup {
    width: calc(100% - 330px);
}
.profile_setup_cont .row > .profile_setup_help {
    width: 304px;
    height: auto;
    background: transparent linear-gradient(180deg, #ffffff 0%, #f8f8f8 100%);
    border: 1px solid #e1e1e1;
    border-radius: 6px;
    padding: 30px;
    text-align: center;
}
.profile_setup > div:not(:last-child) {
    margin: 0 0 15px;
}
.container.profile_setup_cont {
    max-width: 100%;
}
.profile_setup_help > p:first-child {
    width: 190px;
    margin: auto;
    text-align: center;
}
.custom-nav > ul li.nav-item a.nav-link.dropdown-toggle::after {
    margin-left: 17px;
    vertical-align: middle;
    border-top: 7px solid;
    border-right: 5px solid transparent;
    border-left: 5px solid transparent;
}
.activities_status_hovercont ol {
    margin: 0 0 0 20px;
    padding: 0 10px 0 0;
    text-align: left;
}
.activities_status_hovercont ol li {
    line-height: 18px;
}
.activities_status_hovercont ol li:not(:last-child) {
    margin: 0 0 8px 0;
}
.activities_status_hovercont {
    background: #fff;
    border: 1px solid #d2d2d2;
    border-radius: 6px;
    padding: 20px;
    width: 270px;
    height: 165px;
    position: absolute;
    top: -30px;
    left: 0;
    right: 0;
    margin: auto;
    box-shadow: 0px 3px 6px #0000001a;
    display: none;
}
/*.activities_status_hovercont::after { position: absolute; content: ""; width: 15px; height: 15px; background: #fff; border-right: 1px solid #d2d2d2; transform: rotate(45deg); bottom: -8px; border-bottom: 1px solid #d2d2d2; box-shadow: 0px 3px 6px #0000001A; }*/
.activities_status_hovercont::after {
    position: absolute;
    content: '';
    width: 23px;
    height: 18px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/hover_after.png) left top no-repeat;
    bottom: -18px;
}
.activities_status_hovercont > div {
    height: 125px;
    max-height: 125px;
    font-size: 14px;
    font-weight: 400;
}
.activities_status:hover .activities_status_hovercont {
    display: block;
    color: #000;
}
.activities_status:hover {
    color: #26a7df;
}
.slimScrollDiv .slimScrollBar {
    width: 4px !important;
    background: #dedede !important;
    opacity: 1 !important;
    right: 0 !important;
}
.slimScrollDiv .slimScrollRail {
    display: block !important;
    width: 1px !important;
    right: 1px !important;
    opacity: 1 !important;
    background: #676767 !important;
    left: auto !important;
}

.activities_status_hovercont > div::-webkit-scrollbar {
    scrollbar-width: thin;
}

.profile_setup > div.icn_details:first-child .iconsec_cont {
    display: block;
}
#dashboard-pills-tabContent .accordion-item .accordion-button:hover {
    box-shadow: 0px 0px 5px #0000001a;
    background: #fafafa;
    border-radius: 5px;
}
#dashboard-pills-tabContent .accordion-item .accordion-button[aria-expanded='true']:hover {
    box-shadow: unset;
    background: transparent;
    border-radius: 5px;
}
.float_horizontal_animate {
    transform: translatex(0px);
    animation: float_horizontal 4s ease-in-out infinite;
}

.profilePicSection {
    width: 200px;
    height: 200px;
    border: 1px dashed #707070;
    border-radius: 50%;
    margin: auto;
    padding: 14px;
}
.profilePicSection .profileImg {
    background: #e3e3e3;
    width: 100%;
    height: 100%;
    border-radius: 50%;
}
.profileImg.icon-user {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 145px;
    color: #fff;
}
.editProfilePicSection {
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
}
.editprofileImg::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 172px;
    height: 172px;
    border: 2px solid #0b3454;
    margin: auto;
    border-radius: 50%;
    box-shadow: 0 0 0 100px rgba(255, 255, 255, 0.5);
}

.slideRange {
    -webkit-appearance: none;
    width: 100%;
    height: 5px;
    border-radius: 5px;
    background: #d3d3d3;
    outline: none;
    opacity: 0.7;
    transition: opacity 0.2s;
}
.slideRange::-webkit-slider-thumb {
    appearance: none;
    width: 14px;
    height: 14px;
    border: 0;
    background: #5cae48;
    cursor: pointer;
    border-radius: 50%;
}
.slideRange::-moz-range-thumb {
    width: 14px;
    height: 14px;
    border: 0;
    background: #5cae48;
    cursor: pointer;
}
.slideRange::-ms-thumb {
    width: 14px;
    height: 14px;
    border: 0;
    background: #5cae48;
    cursor: pointer;
    border-radius: 50%;
}
/** Chrome*/
.slideRange::-webkit-range-progress {
    background-color: #5cae48;
    height: 5px;
    border-radius: 5px;
}
/** FF*/
input[type='range'].slideRange::-moz-range-progress {
    background-color: #5cae48;
    height: 5px;
    border-radius: 5px;
}
/* IE*/
input[type='range'].slideRange::-ms-fill-lower {
    background-color: #5cae48;
    height: 5px;
    border-radius: 5px;
}

@keyframes float_horizontal {
    0% {
        transform: translatex(0px);
    }
    50% {
        transform: translatex(-10px);
    }
    100% {
        transform: translatex(0px);
    }
}

@media (max-width: 767px) {
    .icn_details {
        display: block !important;
    }
    .iconsec {
        float: left;
    }
    .icn_details > .flex-1 {
        float: left;
        margin: 0 0 15px;
        width: calc(100% - 70px);
    }
    .btn-verify,
    .icn_details .btn-green {
        display: flex;
        clear: both;
        margin: 0 auto 0 !important;
        float: none;
        text-align: center;
        justify-content: center;
    }
    .profile_setup_cont .row > .profile_setup {
        width: 100%;
        margin: 0 0 30px 0;
    }
    .profile_setup_cont .row > .profile_setup_help {
        width: 100%;
        border-radius: 0;
        border-left: 0 solid #fff;
        border-right: 0 solid #fff;
        border-bottom: 0 solid #fff;
    }
    .max-1140.profile_container {
        width: 100%;
    }
    .profile_container .sideBar {
        width: 94%;
        margin: auto;
    }
    .profile_container .pageContent > div:first-child {
        width: 94%;
        margin: auto;
        padding-top: 35px !important;
    }
    .profile_container .pageContent > div:first-child .welcome-title {
        width: 100%;
    }
    .profile_container .container.profile_setup_cont {
        width: 100%;
        margin: 25px auto 25px !important;
    }
    .profile_setup_cont .row > .profile_setup {
        width: 94%;
        margin: 0 auto 30px auto;
    }
    .profile_container .footer {
        margin: 0;
    }
    .dashboard .btn-green {
        order: 1;
        margin: 0 5px !important;
    }
    .dashboard .dashb_left {
        order: 0;
        margin: 0 !important;
    }
    .dashboard .dashb_right {
        order: 2;
    }
    .profile_container .welcome-title h1 {
        font-size: 30px;
    }
    .profile_setup_help > p:first-child {
        width: 100%;
    }
}

/* milestone */

/* form start */

/*form tab css*/
/* .polartabsec {
    padding: 18px 40px;
    margin: 0;
    background: #f2f9ff;
    margin: 0 -40px;
} */
.xscroll {
    width: 100%;
    overflow-x: auto;
    scrollbar-width: thin;
    position: relative;
    z-index: 8;
}
.polartabsec ul,
ul.horizontal-tab {
    border-bottom: 0 solid #fff;
    width: max-content;
}
.polartabsec ul li,
ul.horizontal-tab li {
    background: transparent;
    border: 0px solid #7d7d7d;
    border-radius: 20px;
    height: 40px;
    padding: 0;
}
.polartabsec ul li:not(:last-child),
ul.horizontal-tab li:not(:last-child) {
    margin: 0 10px 0 0;
}
.polartabsec ul li button.nav-link,
ul.horizontal-tab li button.nav-link {
    color: #414141;
    font-size: 16px;
    font-weight: 500;
    height: 40px;
    line-height: 38px;
    background: #fff;
    border: 2px solid #7d7d7d;
    padding: 0 23px;
    border-radius: 20px;
    display: flex;
    align-items: center;
    -webkit-border-radius: 20px;
    -moz-border-radius: 20px;
    -ms-border-radius: 20px;
    -o-border-radius: 20px;
}
.polartabsec ul li button.nav-link:focus-visible,
ul.horizontal-tab li button.nav-link:focus-visible {
    outline: none;
}
.polartabsec ul li button.nav-link.active,
.polartabsec ul li button.nav-link:hover,
ul.horizontal-tab li button.nav-link.active,
ul.horizontal-tab li button.nav-link:hover {
    color: #fff;
}
.polartabsec ul li button.nav-link.active,
.polartabsec ul li button.nav-link:hover,
ul.horizontal-tab li button.nav-link.active,
ul.horizontal-tab li button.nav-link:hover {
    color: #fff;
    border: 2px solid #5cae48;
    background: #5cae48;
}
.polartabsec ul.social-integrations li button.nav-link.active,
.polartabsec ul.social-integrations li button.nav-link:hover {
    color: #fff;
    border: 2px solid #0b3454;
    background: #0b3454;
}
.polartabsec ul li button.nav-link i {
    width: 20px;
    height: 20px;
    display: inline-block;
    border-radius: 4px;
    margin-right: 6px;
}
.polartabsec ul li button.nav-link i.facebook {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/tab-facebook.svg) no-repeat 0 0;
}
.polartabsec ul li button.nav-link i.linkedin {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/tab-linkedin.svg) no-repeat 0 0;
}
.polartabsec ul li button.nav-link i.instagram {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/tab-instagram.png) no-repeat 0 0;
}

.JobInternshipForm {
    width: 94%;
    max-width: 670px;
    display: none;
}
.JobInternshipForm h2 {
    border-bottom: 1px solid rgba(125, 125, 125, 0.3);
    padding: 0 0 10px;
    margin: 0 0 40px;
}
form.lstCustForm .form-select,
form.lstCustForm input.form-control {
    border: 1px solid #848484;
    height: 45px;
}
form.lstCustForm textarea.form-control {
    border: 1px solid #848484;
}
form.lstCustForm .form-check .form-check-input {
    width: 24px;
    height: 24px;
    margin-left: 0px;
    border: 2px solid #848484;
}
form.lstCustForm .form-check:not(:last-child) {
    margin: 0 40px 5px 0;
}
form.lstCustForm .btn-greenm,
.btn-greenm252 {
    min-width: 252px;
}
form.lstCustForm label span {
    font-size: 14px;
    color: #848484;
    font-weight: 400;
    font-style: italic;
    float: right;
    display: inline-block;
    padding: 0 0 0 20px;
}
form.lstCustForm .inputfile_parent label span.uploadlabel {
    font-size: 16px;
    color: #414141;
    font-weight: 400;
    float: right;
    display: inline-block;
    padding: 0 0 0 8px;
    font-style: normal;
}
form.lstCustForm label span.icon {
    font-style: unset;
    color: #414141;
}
.fileclose {
    height: 12px;
    line-height: 10px;
    width: 12px;
    text-align: center;
    background: #959595;
    border-radius: 50%;
    color: #fff;
    font-size: 12px;
    cursor: pointer;
    display: none;
    margin-left: 6px;
    justify-content: center;
    align-items: center;
}
.fileclose span {
    font-size: 6px;
    display: block;
    margin: 0 0 0px 1px;
}
.fileicon {
    display: none;
    margin-right: 6px;
}
.docselect {
    display: none;
    align-items: center;
    width: max-content;
}
.docselect.docseladdbg {
    background: #f8f8f8;
    display: flex;
    padding: 7px 12px;
    margin: 10px 0 0 0;
    border-radius: 6px;
}
.inputfile::file-selector-button {
    font: inherit;
    display: none;
}
.inputfile_parent label {
    color: #f1e5e6;
    background-color: #f3f3f300;
    border: 1px dashed #848484;
    border-radius: 6px;
    height: 60px;
    line-height: 60px;
    max-width: 100%;
    font-size: 1.25rem;
    font-weight: 500;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
    display: inline-block;
    overflow: hidden;
    padding: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.albmform .inputfile_parent label {
    height: 80px;
    line-height: 80px;
}
.inputfile_parent label span {
    font-size: 16px;
    color: #414141;
    font-weight: 500;
    font-style: unset;
    float: none;
    padding: 0 0 0 10px;
}
.inputfile_parent {
    position: relative;
    height: auto;
}
.inputfile_parent.profile .docselect {
    display: none;
}
.inputfile_parent.profile.select + p {
    display: none;
}
.inputfile_parent.profile label {
    background-color: #fff;
    border: 1px dashed #a8c5dd;
    border-radius: 6px;
    height: 40px;
    line-height: 40px;
}
.inputfile_parent.profile.select .docseladdbg {
    display: flex;
    background: #eaeaea;
}
.inputfile_parent.profile.pop-up label {
    background: #f3f3f3;
    border: 1px dashed #848484;
    border-radius: 6px;
    opacity: 1;
    height: 45px;
    line-height: 45px;
}

form.lstCustForm .form-select {
    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/select-arrow.svg);
    background-size: 12px;
}
form.lstCustForm .form-select,
form.lstCustForm input.form-control {
    border: 1px solid #0b34544d;
    height: 45px;
}
.form-control[class*='_Link'] {
    padding-left: 50px;
}
#youtubeLink {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
    background-repeat: no-repeat;
    background-position: left 0.75rem center;
    background-size: 20px 20px;
}
#facebookLink {
    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/facebook_input.svg);
    background-repeat: no-repeat;
    background-position: left 0.75rem center;
    background-size: 20px 20px;
}
#linkedinLink {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
    background-repeat: no-repeat;
    background-position: left 0.75rem center;
    background-size: 20px 20px;
}

.uploaded-list-logo {
    background: #ffffff;
    border: 1px solid #b5c1cb;
    border-radius: 6px;
    padding: 14px 7px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
}
.uploaded-list-logo img {
    width: 100%;
}
.uploaded-list-logo .btn-close {
    box-sizing: content-box;
    width: 1em;
    height: 1em;
    padding: 0.25em 0.25em;
    color: #000;
    background: #0b3454
        url(${___CSS_LOADER_URL_REPLACEMENT_25___})
        center/ 10px auto no-repeat;
    border: 0;
    border-radius: 50%;
    opacity: 1;
    position: absolute;
    top: -10px;
    right: -10px;
}

.form-check-input + label.gap-switch {
    background: #fff;
    padding: 5px;
    border-radius: 25px;
    position: relative;
    width: 100px;
    height: 40px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    border: 2px solid #f34e65;
    color: #f34e65;
}
.form-check-input:checked + label.gap-switch {
    background: #5dae48;
    border-color: #5dae48;
}
.form-check-input + label.gap-switch:before {
    width: 24px;
    height: 24px;
    display: inline-block;
    background: #f34e65;
    border-radius: 50%;
    content: '';
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.form-check-input:checked + label.gap-switch::before {
    transform: translateX(62px);
    -webkit-transform: translateX(62px);
    -moz-transform: translateX(62px);
    -ms-transform: translateX(62px);
    -o-transform: translateX(62px);
    background: #fff;
}
.form-check-input + label.gap-switch:after {
    content: 'NO';
    color: #f34e65;
    flex: 1 1;
    text-align: center;
    font-weight: 500;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.form-check-input:checked + label.gap-switch::after {
    transform: translateX(-30px);
    content: 'YES';
    -webkit-transform: translateX(-30px);
    -moz-transform: translateX(-30px);
    -ms-transform: translateX(-30px);
    -o-transform: translateX(-30px);
    color: #fff;
}

.action_btns {
    max-width: 100%;
    background: #f5faff;
    padding: 20px;
    border-radius: 5px;
    margin: 35px 0 0 0px;
    text-align: center;
}
.action_btns button.nextbtn {
    padding: 0px 30px;
    font-size: 1.5em;
    width: 180px;
    cursor: pointer;
    border: 0px;
    position: relative;
    margin: auto;
    transition: all 0.25s ease;
    background: #0b3454;
    color: #fff;
    overflow: hidden;
    border-radius: 25px;
    height: 45px;
    text-transform: uppercase;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 1px;
}
.action_btns .btn-skip {
    font-size: 16px;
    display: inline-block;
}
.btn-skip {
    margin: 15px;
    font-size: 12px;
    text-decoration: none;
    font-weight: 500;
    color: #00000070;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.btn-skip:hover {
    color: #d42941;
}

.right-vertical-info {
    position: absolute;
    top: 0;
    bottom: 0;
    left: calc(100% + 10px);
    margin: auto;
    font-size: 20px;
    height: 21px;
    color: #27a7df;
}

.cta_add .btn-add {
    color: #27a7df;
    padding: 0 30px 0 0;
    text-decoration: none;
    display: flex;
    align-items: center;
}
.cta_add .btn-add:hover {
    color: #5cae48;
}
.cta_add .btn-add i {
    margin-right: 10px;
    margin-top: -4px;
}
.cta_add .btn-add i path {
    fill: #5cae48;
    color: #5cae48;
}
.cta_add .btn-add:focus {
    box-shadow: none;
}
.cta_add .btn-add:focus-visible {
    border: none;
    outline: none;
}
.cta_add .btn-add:hover i img {
    filter: invert(54%) sepia(94%) saturate(312%) hue-rotate(63deg) brightness(93%) contrast(83%);
}

.profilePicSection {
    width: 200px;
    height: 200px;
    border: 1px dashed #707070;
    border-radius: 50%;
    margin: auto;
    padding: 14px;
}
.profilePicSection .profileImg {
    background: #e3e3e3;
    width: 100%;
    height: 100%;
    border-radius: 50%;
}
.profilePicSection.institute_logo {
    max-width: 300px;
    width: 100%;
    border-radius: 10px;
    height: 100%;
    min-height: 100px;
    border: 2px solid #0b3454;
    display: flex;
    padding: 5px;
}
.profilePicSection.institute_logo .profileImg.add_new_logo {
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 30px;
    color: #666;
    flex: 1 1;
    height: auto;
    cursor: pointer;
}
.profilePicSection .profileImg.added_new_logo {
    border-radius: 0;
    background: none;
    flex: 1 1;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
}
.profileImg.icon-user {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 145px;
    color: #fff;
}
.editProfilePicSection {
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
}
.editprofileImg::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 172px;
    height: 172px;
    border: 2px solid #0b3454;
    margin: auto;
    border-radius: 50%;
    box-shadow: 0 0 0 100px rgba(255, 255, 255, 0.5);
}

.slideRange {
    -webkit-appearance: none;
    width: 100%;
    height: 5px;
    border-radius: 5px;
    background: #d3d3d3;
    outline: none;
    opacity: 0.7;
    transition: opacity 0.2s;
}
.slideRange::-webkit-slider-thumb {
    appearance: none;
    width: 14px;
    height: 14px;
    border: 0;
    background: #5cae48;
    cursor: pointer;
    border-radius: 50%;
}
.slideRange::-moz-range-thumb {
    width: 14px;
    height: 14px;
    border: 0;
    background: #5cae48;
    cursor: pointer;
}
.slideRange::-ms-thumb {
    width: 14px;
    height: 14px;
    border: 0;
    background: #5cae48;
    cursor: pointer;
    border-radius: 50%;
}
/** Chrome*/
.slideRange::-webkit-range-progress {
    background-color: #5cae48;
    height: 5px;
    border-radius: 5px;
}
/** FF*/
input[type='range'].slideRange::-moz-range-progress {
    background-color: #5cae48;
    height: 5px;
    border-radius: 5px;
}
/* IE*/
input[type='range'].slideRange::-ms-fill-lower {
    background-color: #5cae48;
    height: 5px;
    border-radius: 5px;
}
.emptyevent {
    border: 1px solid #d2d2d2;
    border-radius: 6px;
}
.radio-box * {
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.radio-box {
    background: #ffffff;
    border: 1px solid #0b34544d;
    border-radius: 6px;
    padding: 11px 15px;
    min-width: 124px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
}
form.lstCustForm .radio-box span {
    padding: 0;
    font-size: 16px;
    font-style: normal;
    color: #000;
    font-weight: 500;
    float: none;
}
.radio-box i {
    margin-left: 8px;
    background: #ffffff;
    border: 1px solid #b5c1cb;
    opacity: 1;
    width: 18px;
    height: 18px;
    position: relative;
    border-radius: 50%;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    -ms-border-radius: 50%;
    -o-border-radius: 50%;
}
.radio-box i:before {
    content: '';
    position: absolute;
    width: 9px;
    height: 5px;
    border-left: 2px solid #b5c1cb;
    border-bottom: 2px solid #b5c1cb;
    transform: rotate(-45deg);
    left: 3px;
    top: 5px;
    -webkit-transform: rotate(-45deg);
    -moz-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    -o-transform: rotate(-45deg);
}
.form-check-input:checked + .radio-box {
    background: #5cae48;
    border-color: #5cae48;
}
.form-check-input:checked + .radio-box span {
    color: #fff;
}
.form-check-input:checked + .radio-box i {
    border-color: #fff;
    background: #5cae48;
}
.form-check-input:checked + .radio-box i:before {
    border-color: #fff;
}

.form-check.custom-rectbox-radio .form-check-input + label {
    width: 100%;
    height: 45px;
    font-weight: 500;
    border: 1px solid #0b3454;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 5px;
    padding: 0 14px;
    position: relative;
    cursor: pointer;
    transition: all 0.3s;
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    -ms-transition: all 0.3s;
    -o-transition: all 0.3s;
}
.form-check.custom-rectbox-radio .form-check-input + label span {
    color: #000;
    font-style: normal;
    font-weight: 500;
}
.form-check.custom-rectbox-radio .form-check-input:checked + label {
    background: #5dae48;
    border: 1px solid #5dae48;
    color: #fff;
}
.custom-rectbox-radio {
    padding: 0;
    margin: 0;
    flex: 1 1;
}
.custom-rectbox-radio:not(:last-child) {
    margin-right: 8px;
}
.radio_parent {
    display: flex;
    flex-wrap: wrap;
}
.form-check.custom-rectbox-radio .form-check-input + label:before {
    content: '';
    position: absolute;
    right: 10px;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 24px;
    height: 24px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/male_icon.svg) no-repeat center;
}
.form-check.custom-rectbox-radio .form-check-input + label[for='female']:before {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/female_icon.svg) no-repeat center;
}
.form-check.custom-rectbox-radio .form-check-input:checked + label::before {
    filter: invert(1) brightness(100);
    -webkit-filter: invert(1) brightness(100);
}
.form-check.custom-rectbox-radio .form-check-input:checked + label span {
    color: #fff;
}
form.lstCustForm hr {
    border: 1px solid #7c8795;
}
.form-control.form-search {
    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/search.svg);
    background-size: 14px;
    background-repeat: no-repeat;
    background-position: 13px center;
    padding-left: 34px;
}

.form-title {
    border-bottom: 2px solid #dbdbdb;
    padding-bottom: 10px;
    font-size: 24px;
    font-weight: 700;
    margin: 10px 0 0;
}
.form-title span {
    position: relative;
}
.form-title span:before {
    content: '';
    position: absolute;
    bottom: -9px;
    left: 0;
    right: 0;
    background: #5cae48;
    height: 2px;
}

.datepicker .datepicker-switch:hover,
.datepicker .prev:hover,
.datepicker .next:hover,
.datepicker tfoot tr th:hover {
    background: #eef5ff;
}
.datepicker {
    padding: 0;
    z-index: 9999;
}
.datepicker td,
.datepicker th {
    padding: 7px;
}
.datepicker-days thead {
    background: #eef5ff;
    font-weight: 500;
}
.datepicker-days thead th {
    font-weight: 500;
}
.datepicker-days thead th:hover {
    background: #007bff;
    color: #fff;
}
.datepicker-months,
.datepicker-days {
    overflow: hidden;
    background: #eef5ff;
    border-radius: 3px;
}
.datepicker-months tbody,
.datepicker-days tbody {
    background: #fff;
}
.form-date {
    background: #fff url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/calender.svg) no-repeat right
        10px center;
    padding-right: 40px;
}

@media (max-width: 991px) {
}

@media (max-width: 575px) {
    .polartabsec {
        padding: 18px 20px;
        margin: 0 -20px;
    }
}

.tooltip-white .tooltip-inner {
    background: #fff;
    box-shadow: 0px 3px 6px #0000001a;
    padding: 10px 15px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-width: 230px;
    width: 100%;
}
.tooltip-white .tooltip-inner .badge {
    background: #f1f1f1;
    border-radius: 100px;
    height: 28px;
    padding: 0 15px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: #000;
    font-weight: 400;
}
.tooltip-white .tooltip-inner .badge:not(:last-child) {
    margin-bottom: 5px;
}
.tooltip-white .tooltip-arrow::before {
    border-top-color: #fff;
}
.tooltip-white .tooltip-inner ol {
    padding: 0;
    margin: 0;
    color: #000;
    list-style: none;
}

/* form End */

/* filter table */

.attendee_dtl .table > thead th {
    background: #f1f1f1;
    font-size: 16px;
    font-weight: 500;
    height: 40px;
    border: 0;
}
.attendee_dtl .table > thead tr:nth-child(2) th {
    background: #e1e1e1;
}
.attendee_dtl .table > thead th:first-child {
    border-radius: 6px 0 0 6px;
}
.attendee_dtl .table > thead th:last-child {
    border-radius: 0 6px 6px 0;
}

.table-responsive::-webkit-scrollbar {
    height: 4px;
}
.table-responsive::-webkit-scrollbar-track {
    background: #ccc;
}
.table-responsive::-webkit-scrollbar-thumb {
    background-color: #333;
    border-radius: 2px;
    border: 1px solid #ccc;
}
.table-responsive.attendee_dtl > table td:first-child,
.table-responsive.attendee_dtl > table th:first-child {
    padding-left: 20px;
}
.table-responsive.attendee_dtl > table td {
    padding-top: 15px;
    padding-bottom: 15px;
    font-size: 16px;
    vertical-align: middle;
}
.table-responsive.attendee_dtl > table td[valign='top'] {
    vertical-align: top;
}
.table-responsive.attendee_dtl > table .btn {
    line-height: 15px;
    display: flex;
    align-items: center;
    padding: 0 20px !important;
    margin: 0 5px 0 0;
}
.table-responsive.attendee_dtl > table td.active {
    width: 315px;
}
.table-responsive.attendee_dtl > table td.engagement {
    width: 245px;
}
.table-responsive.attendee_dtl > table .university-name {
    width: 175px;
}
.table-responsive.attendee_dtl > table td.sentDeliveredOpened {
    width: 365px;
}
.table-responsive.attendee_dtl a.tablink {
    color: #0b3454;
    display: flex;
    align-items: center;
    text-decoration: none;
    line-height: 18px;
}
.table-responsive.attendee_dtl a.tablink:hover {
    color: #4c4f51;
}
.table-responsive.attendee_dtl a.tablink.blue-link {
    color: #27a7df  ;
}
.table-responsive.attendee_dtl a.tablink.blue-link:hover {
    color: #000;
    text-decoration: underline;
}
.table-responsive.attendee_dtl a.btn-gray-border:hover {
    color: #fff;
}
.table-responsive.attendee_dtl > table td.deliveryStatus {
    width: 205px;
}
.table-responsive td {
    position: relative;
}

/* .table-responsive.attendee_dtl.withborder > table tr:not(:first-child) td {box-shadow: 4px 0px 1px 0px #B9B9B9;} */

.input-group-select select.form-select {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
}
.empty-notification .profile-selection-notification {
    z-index: 9;
    left: 0;
    max-width: 1012px;
    margin: auto;
    width: 1012px;
    right: 0;
    position: absolute;
    top: 50px;
}
.table-responsive .icon-like.dislike {
    width: 15px;
    height: 15px;
    transform: scale(-1) translateY(-3px);
    display: inline-block;
}

.table_cus_badge {
    background: #fef7e8;
    border-radius: 20px;
    height: 36px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: #000;
    font-weight: 500;
    padding: 0 15px;
    margin: 3px;
    min-width: 65px;
}
.tab-ul {
    padding: 0;
    line-height: 22px;
    list-style: none;
    margin: 0 13px 0 0;
}
.tab-ul a {
    color: #000;
}
.tab-ul a:hover {
    color: #414141;
}
.custom-btn a {
    margin: 0 2px;
    text-decoration: none;
    color: #000;
    font-size: 12px;
}
.active-status {
    background: #ffffff;
    border: 1px solid #d2d2d2;
    border-radius: 20px;
    width: 120px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.attendee_dtl a.icon-cross {
    text-decoration: none;
}
.attendee_dtl a.icon-cross:hover {
    color: #666 !important;
}

.attendee_dtl .form-check-input,
.ActiveListings_present .form-check-input {
    width: 20px;
    height: 20px;
    border-width: 2px;
}
.attendee_dtl .form-check-input:checked,
.ActiveListings_present .form-check-input:checked {
    background-color: #0b3454;
    border-color: #0b3454;
}

.icon-sort-arrow {
    font-size: 6px;
    color: #7f7f7f;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}
.icon-sort-arrow .icon-invert-down-arrow {
    transform: scaleY(-1);
}

.labelItem {
    color: #000;
    text-decoration: none;
    display: flex;
    align-items: center;
}
.text-center .labelItem {
    justify-content: center;
}
.labelItem:hover {
    color: #153d5b;
}
.labelItem .icon-sort {
    margin-left: 5px;
    width: 17px;
    height: 17px;
    display: inline-block;
    position: relative;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
}
.labelItem .icon-sort::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    background: #f1f1f1;
    width: 12px;
    height: 2px;
    margin: auto;
    transform: rotate(-45deg);
    left: -2.5px;
    display: none;
}

.fitergroup .show .accordion-body {
    border-radius: 0 6px 6px 6px;
}
.fitergroup .accordion-body {
    background: #f1f1f1;
    border-radius: 6px;
}
.btn-grpfiter {
    border: 0px solid #e1e1e1;
    border-radius: 20px;
    height: 40px;
    padding: 0 25px;
    font-size: 14px;
    font-weight: 500;
    background: #f1f1f1;
    position: relative;
}
.btn-grpfiter[aria-expanded='true'] {
    border-radius: 20px 20px 0 0;
    transition: all 0.3s ease-in-out;
}
.btn-grpfiter::before {
    content: '';
    position: absolute;
    bottom: -20px;
    left: 0;
    right: 0;
    background: #f1f1f1;
    height: 10px;
    transition: all 0.3s ease-in-out;
    opacity: 0;
}
.btn-grpfiter[aria-expanded='true']::before {
    bottom: -10px;
    opacity: 1;
}

.mailSetting {
    position: relative;
}
.mailSetting .setting-dropdown {
    position: absolute;
    top: 30px;
    right: 10px;
    background: white;
    padding: 15px 20px;
    box-shadow: 0 0 3px 0px #ccc;
    border-radius: 6px;
    z-index: 1;
    border: 1px solid #ccc;
    text-align: right;
    display: none;
}
.mailSetting .setting-dropdown.open {
    display: block;
}
.mailSetting .setting-dropdown ul {
    padding: 0;
    margin: 0;
    list-style: none;
}
.mailSetting .setting-dropdown ul a {
    text-decoration: none;
    color: #000;
}
.mailSetting .setting-dropdown ul li:not(:last-child) {
    margin-bottom: 5px;
}

td a {
    color: #0b3454;
    opacity: 1;
    text-decoration: none;
}
td a:hover {
    color: #5cae48;
    opacity: 1;
}

.btn-conview,
.link {
    color: #0d6efd;
    text-decoration: underline;
}
.btn-conview:hover,
.link:hover {
    color: #5cae48;
    opacity: 1;
}

.tooltip-setting .tooltip-inner {
    background: #ffffff;
    color: #515151;
    border: 1px solid #cecfcf;
    box-shadow: 0px 5px 10px #00000033;
    padding: 15px 12px;
}
.tooltip.tooltip-setting .show {
    opacity: 2;
}
.tooltip-setting .bs-tooltip-top .tooltip-arrow::before {
    top: -1px;
    border-width: 0.4rem 0.4rem 0;
    border-top-color: #fff;
}
.tooltip-setting .bs-tooltip-bottom .tooltip-arrow::before {
    bottom: -1px;
    border-width: 0 0.4rem 0.4rem;
    border-bottom-color: #fff;
}
.tooltip-setting .tooltip-inner ul {
    padding: 0;
    margin: 0;
    text-align: left;
    list-style: none;
    line-height: 24px;
}
.tooltip-setting .tooltip-inner ul a {
    font-size: 14px;
    color: #000;
    text-decoration: none;
    padding: 0;
    border: none;
    font-weight: 500;
    background: none;
    transition: none;
    -webkit-transition: none;
    -moz-transition: none;
    -ms-transition: none;
    -o-transition: none;
}
.bs-tooltip-auto.tooltip-setting[data-popper-placement^='top'] .tooltip-arrow::before,
.bs-tooltip-top.tooltip-setting .tooltip-arrow::before {
    border-top-color: #fff;
}

.tooltip-html {
}
.tooltip-html .tooltip-inner {
    background: #ffffff;
    color: #515151;
    border: 1px solid #cecfcf;
    box-shadow: 0px 5px 10px #00000033;
    padding: 15px 15px;
    max-width: 300px;
    line-height: 20px;
}
.tooltip.tooltip-html .show {
    opacity: 2;
}
.tooltip-html .bs-tooltip-top .tooltip-arrow::before {
    top: -1px;
    border-width: 0.4rem 0.4rem 0;
    border-top-color: #fff;
}
.tooltip-html .bs-tooltip-bottom .tooltip-arrow::before {
    bottom: -1px;
    border-width: 0 0.4rem 0.4rem;
    border-bottom-color: #fff;
}
.tooltip-html .tooltip-inner h6 {
    text-align: left;
}
.tooltip-html .tooltip-inner ul {
    padding: 0;
    margin: 0;
    text-align: left;
    list-style: none;
    line-height: 24px;
}
.tooltip-html .tooltip-inner ul a {
    font-size: 14px;
    color: #000;
    text-decoration: none;
}
.bs-tooltip-auto.tooltip-html[data-popper-placement^='top'] .tooltip-arrow::before,
.bs-tooltip-top.tooltip-html .tooltip-arrow::before {
    border-top-color: #fff;
}
.tooltip-html .tooltip-inner ul li {
    white-space: wrap;
}
.tooltip-html .tooltip-inner ul li:not(:last-child) {
    margin: 0 0 8px;
}
.tooltip-html .tooltip-inner ul li b {
    margin-right: 5px;
    font-weight: 500;
    color: #000;
}
.tooltip-html .tooltip-inner ol {
    padding: 0 0 0 20px;
    margin: 0 0 6px;
    text-align: left;
    font-weight: 500;
    color: #000;
}
.tooltip-html .tooltip-inner ol li {
    list-style: decimal;
}
.tooltip-html .tooltip-inner p {
    padding: 0 0 0 20px;
    margin: 0;
    text-align: left;
    font-weight: 500;
    color: #000;
}

.datewrap {
    display: flex;
    flex-wrap: wrap;
    background: #ffffff;
    border: 1px solid #848484;
    border-radius: 6px;
    height: 40px;
    position: relative;
    overflow: hidden;
}
#config-demo,
.singledaterangePickerList,
.daterangePickerList {
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 0;
    top: 0;
    right: 0;
    margin: auto;
    cursor: pointer;
    opacity: 0;
}
.datewrap .arrow {
    background: #f1f1f1;
    width: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
}
/*.datewrap .arrow span {background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='1' d='M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z'/%3e%3c/svg%3e");font-size: 0;width: 25px;height: 25px;}*/
.datewrap .arrow span {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/arrow.svg) no-repeat center;
    font-size: 0;
    width: 25px;
    height: 25px;
}
.datewrap .from,
.datewrap .to {
    flex: 1 1;
}
.datewrap .form-control {
    height: 100% !important;
    border: 0 !important;
    background: #fff url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/calendar.svg) no-repeat 10px
        center;
    padding-left: 40px;
}
.fitergroup .accordion-body .form-select,
.fitergroup .accordion-body .form-control,
.tab-pane .fullViewMobile .form-select,
.tab-pane .fullViewMobile .form-control {
    height: 40px;
    border: 1px solid #848484;
}
.form-control.form-search {
    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/search.svg);
    background-size: 14px;
    background-repeat: no-repeat;
    background-position: 13px center;
    padding-left: 34px;
}

.search.alumniSearch {
    max-width: 350px;
    width: 100%;
    background: #fff;
    border: 1px solid #7d7d7d;
    border-radius: 20px;
}
.search.alumniSearch .btn-search {
    right: auto;
    left: 7px;
    top: 6px;
}
.search.alumniSearch .form-control {
    padding-left: 40px;
}
.search-100 .search.alumniSearch {
    max-width: 280px;
}

.singlelinename {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 125px;
}
.tablink img[width='30'] {
    width: 30px;
    min-width: 30px;
}
.tablink .icon-subtraction {
    position: absolute;
    bottom: -3px;
    right: -3px;
    width: 16px;
    height: 15px;
}
.tablink .icon-subtraction::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 15px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/subtraction-white-star.svg) no-repeat
        0 0 / 100%;
    z-index: 2;
}
.tablink .icon-subtraction::after {
    content: '';
    position: absolute;
    width: 66%;
    height: 65%;
    background: #fff;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
}
.icon-star.circle-img {
    position: absolute;
    bottom: -3px;
    right: -3px;
    background: #5cae48;
    border-radius: 50%;
    color: #fff;
    font-size: 7px;
    padding: 4px;
}

.table-responsive.attendee_dtl td a > i {
    width: 40px;
    height: 40px;
    font-size: 30px;
    background-position: center;
}
.table-responsive.attendee_dtl td a > i img {
    vertical-align: top;
}
.course-list-row span {
    vertical-align: top;
    margin-right: 4px;
}
.course-list-row i {
    margin-top: 0px;
}

.filterresult ul {
    margin: 0;
    padding: 0;
    display: flex;
    flex-wrap: wrap;
    list-style: none;
}
.filterresult ul li:not(:last-child) {
    margin-right: 10px;
}
.filterresult ul li {
    margin-bottom: 5px;
}
.filterresult ul li a {
    background: #e9f6fc;
    border-radius: 20px;
    min-height: 32px;
    padding: 5px 20px;
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #000;
    text-decoration: none;
}
.filterresult ul li a i {
    margin-left: 8px;
    font-size: 9px;
}
.filterresult ul li.clear a {
    background: none;
    color: #d42941;
    text-decoration: underline;
}
.filterresult ul li.clear a:hover {
    color: #0b3454;
    text-decoration: none;
}
.filterresult {
    padding: 10px 0 15px;
    border-bottom: 1px solid #e5eaed;
    margin-bottom: 20px;
}
.pagination_custom {
    max-width: 751px;
    margin: auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    margin-top: 15px;
}
.pagination_custom .pagination_custom_inner {
    flex: 1 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 20px;
}
.pagination_custom .pagination_custom_inner ul {
    padding: 0;
    margin: 0 20px;
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    flex: 1 1;
    justify-content: center;
    align-items: center;
}
.pagination_custom .pagination_custom_inner ul li:not(:last-child) {
    margin-right: 0;
}
.pagination_custom .pagination_custom_inner ul li {
    width: 30px;
    text-align: center;
    margin: 0 10px;
}
.pagination_custom a,
.pagination_custom .pagination_custom_inner ul li a {
    text-decoration: none;
    font-size: 16px;
    color: #0b3454;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
}
.pagination_custom .pagination_custom_inner ul li.current a {
    background: #0b3454;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
}

.summary-blocks {
    width: 1140px;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    margin-bottom: 15px;
}
.summary-blocks .block {
    width: calc(20.19% - 1%);
    border-radius: 4px;
    display: flex;
    align-items: center;
    padding: 32px 20px;
}
.summary-blocks .block {
    background: #fff;
}

.summary-blocks .block:not(:last-child) {
    margin-right: 1%;
}
.summary-blocks .block .icon {
    margin-right: 15px;
}
.summary-blocks .block .block-detail .number {
    font-size: 26px;
    line-height: 30px;
    font-weight: 600;
}
.summary-blocks .block .block-detail .block-detail-title {
    font-size: 15px;
    line-height: 18px;
    font-weight: 500;
}
.summary-blocks .block.totalAlumni .block-detail {
    color: #d42941;
}
.summary-blocks .block.uptoDate .block-detail {
    color: #0b3454;
}
.summary-blocks .block.due .block-detail {
    color: #26a7df;
}
.summary-blocks .block.smartApplyLeads .block-detail {
    color: #403a81;
}
.summary-blocks .block.smartApplyRegd .block-detail {
    color: #6962a7;
}

.x-scroll {
    overflow-x: auto;
    scrollbar-width: thin;
}
.x-scroll::-webkit-scrollbar {
    height: 4px;
}
.x-scroll::-webkit-scrollbar-track {
    background: #f1f1f1;
}
.x-scroll::-webkit-scrollbar-thumb {
    background: #888;
}
.x-scroll::-webkit-scrollbar-thumb:hover {
    background: #555;
}

.x-scroll-big {
    overflow-x: auto;
}
.x-scroll-big::-webkit-scrollbar {
    height: 15px;
}
.x-scroll-big::-webkit-scrollbar-track {
    background: #ccc;
}
.x-scroll-big::-webkit-scrollbar-thumb {
    background: #666;
}
.x-scroll-big::-webkit-scrollbar-thumb:hover {
    background: #555;
}

.blue-badge {
    background: #68c2e9;
    font-weight: 500;
    border: 1px solid #68c2e9;
    border-radius: 6px;
    padding: 0 15px;
    height: 26px;
    display: inline-block;
    line-height: 26px;
    color: #fff !important;
    margin-bottom: 5px;
    font-size: 12px;
    text-transform: uppercase;
}

.sticky_table_3_columns th:first-child {
    position: sticky;
    left: 0;
    z-index: 3;
}
.sticky_table_3_columns th:nth-child(2) {
    position: sticky;
    left: 140px;
    z-index: 3;
}
.sticky_table_3_columns th:nth-child(3) {
    position: sticky;
    left: calc(140px + 250px);
    z-index: 3;
}

.sticky_table_3_columns td:first-child {
    position: sticky;
    left: 0;
    z-index: 3;
}
.sticky_table_3_columns td:nth-child(2) {
    position: sticky;
    left: 140px;
    z-index: 3;
}
.sticky_table_3_columns td:nth-child(3) {
    position: sticky;
    left: calc(140px + 250px);
    z-index: 3;
}
.sticky_table_3_columns th:nth-child(3)::before,
.sticky_table_3_columns td:nth-child(3)::before {
    content: '';
    width: 30px;
    position: absolute;
    right: 0px;
    bottom: 0;
    top: 0;
    background: transparent linear-gradient(270deg, #000000 0%, #00000000 100%);
    opacity: 0.05;
}
.sticky_table_3_columns td::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: -1px;
    height: 0;
    border-bottom: 1px solid #dee2e6;
}

.sticky_table_3_columns_noaction th:first-child {
    position: sticky;
    left: 0;
    z-index: 3;
}
.sticky_table_3_columns_noaction th:nth-child(2) {
    position: sticky;
    left: 250px;
    z-index: 3;
}
.sticky_table_3_columns_noaction th:nth-child(3) {
    position: sticky;
    left: calc(250px + 180px);
    z-index: 3;
}

.sticky_table_3_columns_noaction td:first-child {
    position: sticky;
    left: 0;
    z-index: 3;
}
.sticky_table_3_columns_noaction td:nth-child(2) {
    position: sticky;
    left: 250px;
    z-index: 3;
}
.sticky_table_3_columns_noaction td:nth-child(3) {
    position: sticky;
    left: calc(250px + 180px);
    z-index: 3;
}
.sticky_table_3_columns_noaction th:nth-child(3)::before,
.sticky_table_3_columns_noaction td:nth-child(3)::before {
    content: '';
    width: 30px;
    position: absolute;
    right: 0px;
    bottom: 0;
    top: 0;
    background: transparent linear-gradient(270deg, #000000 0%, #00000000 100%);
    opacity: 0.05;
}
.sticky_table_3_columns_noaction td::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: -1px;
    height: 0;
    border-bottom: 1px solid #dee2e6;
}

.sticky_table_4_columns th:first-child {
    position: sticky;
    left: 0;
    z-index: 3;
}
.sticky_table_4_columns th:nth-child(2) {
    position: sticky;
    left: 150px;
    z-index: 3;
}
.sticky_table_4_columns th:nth-child(3) {
    position: sticky;
    left: calc(150px + 225px);
    z-index: 3;
}
.sticky_table_4_columns th:nth-child(4) {
    position: sticky;
    left: calc(150px + 225px + 180px);
    z-index: 3;
}

.sticky_table_4_columns td:first-child {
    position: sticky;
    left: 0;
    z-index: 3;
}
.sticky_table_4_columns td:nth-child(2) {
    position: sticky;
    left: 150px;
    z-index: 3;
}
.sticky_table_4_columns td:nth-child(3) {
    position: sticky;
    left: calc(150px + 225px);
    z-index: 3;
}
.sticky_table_4_columns td:nth-child(4) {
    position: sticky;
    left: calc(150px + 225px + 180px);
    z-index: 3;
}
.sticky_table_4_columns th:nth-child(4)::before,
.sticky_table_4_columns td:nth-child(4)::before {
    content: '';
    width: 30px;
    position: absolute;
    right: 0px;
    bottom: 0;
    top: 0;
    background: transparent linear-gradient(270deg, #000000 0%, #00000000 100%);
    opacity: 0.05;
}
.sticky_table_4_columns td::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: -1px;
    height: 0;
    border-bottom: 1px solid #dee2e6;
}

.customselect_parnt > .form-select {
    border-radius: 25px;
    margin-right: 10px;
    border: 2px solid #7d7d7d;
    height: 36px;
    display: flex;
    align-items: center;
    line-height: 18px;
}
.customselect_parnt button {
    height: 36px;
}
.icon-download {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/download.svg) no-repeat 0 0 / 100%;
    width: 17px;
    height: 16px;
    display: inline-block;
}
.mailSetting .icon-download {
    filter: invert(16%) sepia(71%) saturate(697%) hue-rotate(167deg) brightness(92%) contrast(99%);
    -webkit-filter: invert(16%) sepia(71%) saturate(697%) hue-rotate(167deg) brightness(92%) contrast(99%);
}
.mailSetting .icon-download:hover {
    filter: invert(53%) sepia(75%) saturate(353%) hue-rotate(62deg) brightness(97%) contrast(89%);
    -webkit-filter: invert(53%) sepia(75%) saturate(353%) hue-rotate(62deg) brightness(97%) contrast(89%);
}
.gray_badge .badge {
    background: #f1f1f1;
    border-radius: 100px;
    height: 28px;
    padding: 0 15px;
    display: inline-block;
    font-size: 14px;
    color: #000;
    font-weight: 400;
    margin-bottom: 5px;
    max-width: 108px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    text-align: center;
    line-height: 28px;
}

.custom-btn a {
    margin: 0 2px;
    text-decoration: none;
    color: #212529;
}
.custom-btn a:hover {
    color: #868686;
}

@media (max-width: 991px) {
    div.table-responsive table.sticky_table_3_columns td,
    div.table-responsive table.sticky_table_3_columns th {
        position: static;
    }
    div.table-responsive table.sticky_table_3_columns_noaction td,
    div.table-responsive table.sticky_table_3_columns_noaction th {
        position: static;
    }
    div.table-responsive table.sticky_table_4_columns td,
    div.table-responsive table.sticky_table_4_columns th {
        position: static;
    }
}

@media (min-width: 767px) {
    .table-responsive.attendee_dtl.sticky-table > table td:first-child,
    .table-responsive.attendee_dtl.sticky-table > table th:first-child {
        position: sticky;
        left: 0;
        z-index: 2;
    }
    .table-responsive.attendee_dtl.sticky-table > table td:nth-child(2),
    .table-responsive.attendee_dtl.sticky-table > table th:nth-child(2) {
        position: sticky;
        left: 232px;
        z-index: 2;
    }
    .table-responsive.attendee_dtl.sticky-table > table td:first-child:before,
    .table-responsive.attendee_dtl.sticky-table > table td:nth-child(2):before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        margin: auto;
        background: #fff;
    }
    .table-responsive.attendee_dtl.sticky-table > table td:first-child div,
    .table-responsive.attendee_dtl.sticky-table > table td:nth-child(2) div {
        z-index: 1;
        position: relative;
    }
    .table-responsive.attendee_dtl.sticky-table > table th:nth-child(2)::after,
    .table-responsive.attendee_dtl.sticky-table > table td:nth-child(2)::after {
        content: '';
        background: transparent linear-gradient(270deg, #ffffff 0%, #000000 100%);
        opacity: 0.1;
        width: 30px;
        position: absolute;
        right: -30px;
        bottom: 0;
        top: 0;
    }
    .table-responsive.attendee_dtl.sticky-table > table td:nth-child(3),
    .table-responsive.attendee_dtl.sticky-table > table th:nth-child(3) {
        padding-left: 30px;
        width: 150px;
    }

    .table-responsive.sticky-table {
        overflow-x: scroll;
        scrollbar-width: thin;
    }
    .table-responsive.sticky-table::-webkit-scrollbar {
        height: 4px;
    }
    .table-responsive.sticky-table::-webkit-scrollbar-track {
        background: #f1f1f1;
    }
    .table-responsive.sticky-table::-webkit-scrollbar-thumb {
        background: #888;
    }
    .table-responsive.sticky-table::-webkit-scrollbar-thumb:hover {
        background: #555;
    }
}

/* filter table end */

.package-wrap {
    margin: 20px auto 40px auto;
    display: inline-flex;
    flex-wrap: wrap;
    width: 100%;
    max-width: 800px;
}
.package-list-type {
    display: flex;
    flex: 1 1;
    border-bottom: 1px solid #dfe1e4;
    border-right: 1px solid #dfe1e4;
    border-radius: 0 0 6px 0;
    position: relative;
}

.package-list-title {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 600;
    height: 50px;
}
.package-list-title label {
    margin-right: 10px;
}
.package-list .package-list-title + ul {
    margin-top: 0;
}
.package-list ul {
    list-style: none;
    margin: 50px 0 0 0;
    padding: 0px 0 10px;
    background: #fff;
    border-radius: 6px 0px 0px 6px;
    border: 1px solid #dfe1e4;
    border-right: none;
}
.package-list ul li {
    padding: 0 40px;
    font-size: 16px;
    font-weight: 500;
    line-height: 23px;
    height: 60px;
    display: flex;
    align-items: center;
}
.package-list ul li span {
    line-height: 20px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}
.package-list ul li:nth-child(even) {
    background: #f6f8fa;
}
.package-type {
    flex: 1 1;
    min-width: 178px;
    position: relative;
}
.package-type ul {
    margin: 0;
    padding: 0;
    list-style: none;
}
.package-list {
    flex: 1 1;
}
.package-type ul li {
    display: flex;
    justify-content: center;
    align-items: center;
}
.package-type-header {
    border-radius: 6px 6px 0px 0px;
    opacity: 1;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-weight: 500;
    font-size: 20px;
}
.package-type-header.starter {
    background: transparent linear-gradient(270deg, #168abc 0%, #25a1d6 34%, #2596c7 66%, #228aaa 100%);
}
.package-type-header.bronze {
    background: transparent linear-gradient(270deg, #a96b4d 0%, #d7a169 34%, #d7a068 66%, #8f4c2e 100%);
}
.package-type-header.sliver {
    background: transparent linear-gradient(270deg, #858585 0%, #9598a0 34%, #b3b6bd 66%, #828280 100%);
}
.package-type-header.gold {
    background: transparent linear-gradient(270deg, #d0b211 0%, #d9c246 34%, #d8c63d 66%, #c8993f 100%);
}
.package-type-header.defaultHeader {
    border: 1px solid #dfe1e4;
    height: 51px;
    color: #000;
    font-size: 16px;
}
.package-type-body {
    border-left: 1px solid #dfe1e4;
    border-right: 1px solid #dfe1e4;
    padding: 1px 0 10px;
    background-color: #fff;
}
.package-type:not(:last-child) {
    margin-right: 10px;
}
.package-type ul li {
    height: 60px;
}
.package-type ul li:nth-child(even) {
    background: #f6f8fa;
}
.package-type-body .form-check-input {
    position: static;
    margin: 0;
    width: 23px;
    height: 23px;
    border: 1px solid #0b345480;
    border-radius: 4px;
    opacity: 1;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
    background-size: 21px;
}
.package-type-body .form-check-input:checked {
    background-color: #29a745;
    border-color: #29a745;
}

.package-type:last-child {
    border-radius: 0 0 10px 0;
    overflow: hidden;
}
.package-list-type:before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    border: 0;
    height: calc(100% - 50px);
    background: white;
    border-radius: 0 0 6px;
    top: 50px;
}

.package-wrap .slimScrollDiv {
    flex: auto;
    height: auto !important;
    overflow: visible !important;
}
.package-wrap .slimScrollDiv .package-list-type {
    width: 100% !important;
    height: 100% !important;
}
.slimScrollWrapper {
    position: sticky;
    bottom: 20px;
}

/* Bulk Imports  */

.bulk_imports_header {
    border-bottom: 1px solid #c1ccd4;
}
.steps_flow {
    margin: auto;
    padding: 0;
    display: flex;
    align-items: center;
    position: relative;
}
.polartabsec .steps_flow li {
    height: auto;
    position: relative;
}
.polartabsec .steps_flow li:not(:last-child) {
    margin-right: 254px;
}
.polartabsec .steps_flow li a {
    text-decoration: none;
    color: #000;
    font-size: 18px;
}
.polartabsec .steps_flow li.active a {
    font-weight: 500;
}
.steps_flow:before {
    content: '';
    position: absolute;
    left: 20px;
    bottom: -20px;
    right: 20px;
    border-bottom: 3px solid #5cae48;
    margin: auto;
}
.polartabsec .steps_flow li:before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: -30px;
    background: #ffffff;
    border: 2px solid #0b345433;
    opacity: 1;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    margin: auto;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    -ms-border-radius: 50%;
    -o-border-radius: 50%;
}
.polartabsec .steps_flow li.active:before {
    background: #0db35c;
    border: 1px solid #0db35c;
    margin: auto;
    box-shadow: 0 0 0 5px #fff inset;
}
.polartabsec .steps_flow li.completed::before {
    background-color: #0db35c;
    border: 1px solid #0db35c;
    margin: auto;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
}

.import-title {
    text-align: center;
    margin-top: 30px;
}
.import-title h3 {
    font-size: 24px;
    font-weight: 500;
    margin: 0 0 5px;
}
.import-title p {
    font-size: 16px;
    margin-bottom: 5px;
}

.import-block * {
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.import-block {
    background: #ffffff;
    border: 1px solid #d2d2d2;
    border-radius: 6px;
    position: relative;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    overflow: hidden;
}
.import-block .icon {
    position: absolute;
    background: #0b3454;
    border-radius: 0px 4px 0px 72px;
    width: 78px;
    height: 78px;
    top: 0;
    right: 0;
}
.import-block .icon::before {
    filter: brightness(0) invert(1);
    -webkit-filter: brightness(0) invert(1);
}
.import-block-detail {
    padding: 20px 30px 30px;
}
.icon.icon_user::before {
    content: '';
    position: absolute;
    right: 14px;
    top: 14px;
    width: 30px;
    height: 30px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/selet-user.svg);
}
.icon.icon_display::before {
    content: '';
    position: absolute;
    right: 14px;
    top: 14px;
    width: 30px;
    height: 30px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/display-user.svg);
}
.import-block-detail h4 {
    font-size: 24px;
    font-weight: 500;
    margin: 0 0 15px;
}
.import-block-detail ul {
    margin: 0;
    padding: 0;
    max-width: 420px;
}
.import-block-detail ul li:not(:last-child) {
    margin-bottom: 18px;
}
.import-block-detail ul li {
    position: relative;
    padding: 0 0 0 18px;
    line-height: 20px;
}
.import-block-detail ul li:before {
    content: '';
    position: absolute;
    top: 3px;
    left: 0;
    background: #27a7df;
    width: 3px;
    height: 85%;
    border-radius: 5px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    -ms-border-radius: 5px;
    -o-border-radius: 5px;
}
.import-block-select {
    background: #f2f9ff;
    width: 100%;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    font-weight: 600;
    color: #0b345490;
    text-transform: uppercase;
    cursor: pointer;
}
.import-block-select i {
    width: 26px;
    height: 26px;
    border-radius: 5px;
    border: 1px solid #d2d2d2;
    background: #fff;
    margin-right: 10px;
    transition: all 0.5s ease-in-out;
    -webkit-transition: all 0.5s ease-in-out;
    -moz-transition: all 0.5s ease-in-out;
    -ms-transition: all 0.5s ease-in-out;
    -o-transition: all 0.5s ease-in-out;
    position: relative;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    -ms-border-radius: 5px;
    -o-border-radius: 5px;
}

.inputfile_parent label.height-80 {
    height: 80px;
}
.inputfile_parent label.height-80 span {
    font-weight: 400;
}
.inputfile_parent label .text-skyblue {
    color: #27a7df;
}

.form-check-input:checked + div {
    border: 2px solid #5cae48;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.form-check-input:checked + div .icon {
    background: #f2f9ff;
}
.form-check-input:checked + div .icon:before {
    filter: brightness(1) invert(0);
    -webkit-filter: brightness(1) invert(0);
}
.form-check-input:checked + div .import-block-select {
    background: #5cae48;
    color: #fff;
}
.form-check-input:checked + div .import-block-select i {
    border-color: #fff;
    background-color: #fff;
}
.form-check-input:checked + div .import-block-select i::before {
    content: '';
    position: absolute;
    border-width: 0px 0px 3px 3px;
    border-style: solid;
    border-color: #5cae48;
    width: 14px;
    height: 7px;
    transform: rotate(-45deg);
    left: 6px;
    top: 7px;
    -webkit-transform: rotate(-45deg);
    -moz-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    -o-transform: rotate(-45deg);
}
td .form-check-input:checked + div {
    border: none;
}

.upload_disclaimer {
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    color: #0b3454;
    opacity: 0.8;
    padding: 14px 0;
}

.form-check-tick .form-check-input {
    width: 26px;
    height: 26px;
    margin-right: 8px;
    margin-top: 0;
}
.form-check-tick {
    display: flex;
    align-items: center;
}
.form-check-tick .form-check-input:checked {
    background-color: #5cae48;
    border-color: #5cae48;
}

.map-card-wrap {
    display: flex;
    flex-wrap: nowrap;
    padding-bottom: 20px;
}
.map-card {
    border: 1px solid #dbdcdd;
    border-radius: 6px;
    width: 257px;
    min-width: 257px;
    overflow: hidden;
}
.map-card:not(:last-child) {
    margin-right: 10px;
}
.map-column {
    background: #f2f9ff;
    padding: 10px 15px 20px;
}
.map-title {
    color: #68696a;
    font-weight: 500;
    font-size: 14px;
}
.skip_column {
    height: 45px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.skip_column .skip-link {
    color: #0b3454;
}
.column-list {
    padding: 0;
    margin: 0;
}
.column-list li {
    min-height: 45px;
    display: flex;
    align-items: center;
    padding: 0 15px;
}
.column-list-title {
    background: #f5f7f8;
    font-weight: 500;
}
.column-list li ~ li:not(:last-child) {
    border-bottom: 1px solid #ebebeb;
}

.modal-header .icon-correct {
    width: 50px;
    height: 50px;
    background: #5cae48;
    border-radius: 50%;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 25px;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    -ms-border-radius: 50%;
    -o-border-radius: 50%;
}

@media (max-width: 575px) {
    .polartabsec .steps_flow li:not(:last-child) {
        margin-right: 145px;
    }
    .inputfile_parent label.height-80 span.uploadlabel {
        text-overflow: ellipsis;
        width: calc(100% - 75px);
        overflow: hidden;
    }
}
/* Bulk Imports end */

/* Manage Integrations */
.twoColSection.tab-content > .active {
    display: flex;
    width: 100%;
}
.tab-inner {
    width: 100%;
}
.tab-inner > .row {
    height: 100%;
}
.twoColSection .nav {
    flex-direction: column;
    padding-top: 5px;
}
.twoColSection .nav .nav-item {
    padding-right: 5px;
}
.twoColSection .nav .nav-item .nav-link {
    width: 100%;
    border-radius: 0;
    text-align: left;
    color: #2b4e6a;
    font-weight: 500;
}
.twoColSection .nav .nav-item .nav-link.active {
    color: #5cae48;
    background: #fff;
}

.api-host {
    display: flex;
    margin-top: 24px;
    background: #fffae5;
    padding: 15px;
    border-radius: 6px;
    margin-bottom: 20px;
    border: 2px dashed #f1ecd6;
    align-items: center;
}
.api-host label {
    background: #fff;
    padding: 10px 15px;
    border-radius: 6px 0px 0 6px;
    font-weight: 500;
    position: relative;
    margin-right: 30px;
}
.api-host label:after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 100%;
    border-top: 22.5px solid transparent;
    border-bottom: 22.5px solid transparent;
    border-left: 15px solid #fff;
    height: 0;
    width: 0;
}
.api-url {
    font-size: 18px;
    font-weight: 500;
    color: #0b3454;
    width: calc(100% - 171px);
    display: flex;
    align-items: center;
}
.api-url .icon-copy {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/copy.svg) no-repeat 0 0 / 100%;
    width: 26px;
    height: 26px;
    filter: invert(88%) sepia(7%) saturate(264%) hue-rotate(125deg) brightness(78%) contrast(91%);
    cursor: pointer;
    -webkit-filter: invert(88%) sepia(7%) saturate(264%) hue-rotate(125deg) brightness(78%) contrast(91%);
}
.api-url span {
    width: calc(100% - 26px);
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}
.badge.enabled,
.badge.success {
    background: #caf3c1;
    color: #000;
    border-radius: 25px;
    padding: 10px 30px;
    font-weight: 500;
    font-size: 16px;
}
.badge.unauthorized {
    background: #fdebc5;
    color: #000;
    border-radius: 25px;
    padding: 10px 30px;
    font-weight: 500;
    font-size: 16px;
}
.badge.serverError {
    background: #fedddd;
    color: #000;
    border-radius: 25px;
    padding: 10px 30px;
    font-weight: 500;
    font-size: 16px;
}
.access-key {
    color: #4b6a81;
    font-weight: 500;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    align-items: center;
}
.access-key .icon-copy {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/copy.svg) no-repeat 0 0 / 100%;
    width: 26px;
    height: 26px;
    filter: invert(72%) sepia(25%) saturate(4663%) hue-rotate(167deg) brightness(94%) contrast(88%);
    cursor: pointer;
    -webkit-filter: invert(72%) sepia(25%) saturate(4663%) hue-rotate(167deg) brightness(94%) contrast(88%);
}
.client-ip {
    color: #0b3454;
    font-weight: 500;
}
.filterSearch .refresh-wrap {
    margin-left: auto;
}

.data-preview-wrap {
    border-radius: 6px;
    border: 1px solid #e1e1e1;
    overflow: hidden;
}
.data-preview-wrap .card_custom .alumni_presence {
    padding: 0 30px 40px;
}
.data-preview-wrap .card_custom .card-header {
    background: transparent;
    border-bottom: none;
    font-size: 22px;
    text-transform: uppercase;
    font-weight: 600;
    padding: 25px;
}
.data-preview-wrap .card_custom .card-header select {
    border-radius: 200px;
    height: 40px;
    border: 1px solid #8499a9;
    font-weight: 500;
    font-size: 16px;
    width: auto;
    max-width: 180px;
    padding-left: 15px;
    -webkit-border-radius: 200px;
    -moz-border-radius: 200px;
    -ms-border-radius: 200px;
    -o-border-radius: 200px;
}
.data-preview-wrap .card_custom .card-header p span img {
    margin-top: -7px !important;
}
.data-preview-wrap .top-countries .progress {
    height: 40px;
    background-color: rgba(0, 0, 0, 0.06);
}
.data-preview-wrap .top-countries .progress-bar.countries {
    background-color: #26a7df;
}
.data-preview-wrap .top-countries .exclude_india {
    font-size: 18px;
    font-weight: 500;
}
.data-preview-wrap .top-countries .caountryname {
    line-height: 15px;
}
.data-preview-wrap .top-careers .progress-bar.countries {
    background-color: #51499c;
}
.data-preview-wrap .top-countries-title {
    width: 100px;
}
.data-preview-wrap .top-countries-title + div {
    width: calc(100% - 150px);
}
.data-preview-wrap .percent-progress {
    width: 50px;
}
.switch_option label {
    cursor: pointer;
}
.switch_option .form-switch .form-check-input {
    width: 60px;
    height: 30px;
    margin: 0 10px 0 0;
    background-color: #c1ccd4;
    border-color: #c1ccd4;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
}
.switch_option .form-switch {
    padding: 0;
    align-items: center;
    display: flex;
}
.switch_option .form-switch .form-check-input:checked {
    background-color: #5cae48;
    border-color: #5cae48;
}
.switch_option .form-switch .form-check-input:focus {
    box-shadow: none;
    outline: none;
}

.override_setting {
    border-top: 1px solid rgb(233, 246, 252);
}
.override_setting ul {
    padding: 0;
    margin: 0;
    list-style: none;
}
.override_setting ul li:last-child {
    padding-top: 15px;
}
.override_setting ul li:not(:last-child) {
    border-bottom: 1px solid #ccc;
    padding: 15px 0;
}
.override_setting .form-check .form-check-input {
    width: 20px;
    height: 20px;
    margin: 0 7px 0 0;
}
.override_setting .form-check {
    display: flex;
    align-items: center;
    padding: 0;
}
.override_setting .form-check-input:checked {
    background-color: #fff;
    border-color: #5cae48;
}
.override_setting .form-check-input:checked[type='radio'] {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
}

@media (max-width: 767px) {
    .twoColSection .nav {
        flex-direction: row;
        flex-wrap: nowrap;
        overflow: auto;
        white-space: nowrap;
        padding: 7px 0;
        height: 100%;
    }
    .twoColSection .nav .nav-item {
        padding-right: 0;
        display: flex;
        align-items: center;
    }
    .twoColSection .nav .nav-item .nav-link {
        border-radius: 4px;
    }
    .tab-inner > .row {
        height: auto;
    }
}

@media (max-width: 575px) {
    .filterSearch .refresh-wrap {
        width: 100%;
        order: -1;
        margin-bottom: 15px;
        text-align: right;
        display: flex;
        justify-content: end;
    }
}

/* Manage Integrations */

/* manage-widgets-wrap */
.manage-widgets-wrap ul {
    padding: 0;
    margin: 0;
    list-style: none;
}
.manage-widgets-wrap ul li {
    background: #ffffff;
    border: 1px solid #eaeaea;
    border-radius: 4px;
    padding: 10px;
}
.manage-widgets-wrap ul li:not(:last-child) {
    margin-bottom: 5px;
}
.manage-widgets-wrap {
    margin-top: 25px;
}

.manage-widgets-wrap .form-check-tick .form-check-input {
    width: 22px;
    height: 22px;
}
.manage-widgets-wrap span[role="log"] ~ div{min-height: 45px;}
.btn.btn-widgets-edit {
    background: #ffffff;
    border: 2px solid #0b3454;
    border-radius: 15px;
    height: 28px;
    line-height: 25px;
    padding: 0 20px;
    text-decoration: none;
    text-transform: uppercase;
    font-weight: 600;
    font-size: 12px;
    color: #0b3454;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.btn.btn-widgets-edit:hover {
    background: #0b3454;
    color: #fff;
}

.btn.btn-priview {
    background: #ffffff;
    border: 2px solid #5cae48;
    border-radius: 15px;
    height: 28px;
    line-height: 25px;
    padding: 0 20px;
    text-decoration: none;
    text-transform: uppercase;
    font-weight: 600;
    font-size: 12px;
    color: #5cae48;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.btn.btn-priview:hover {
    background: #5cae48;
    color: #fff;
}

.btn.btn-configure {
    background: #0b3454;
    border: 2px solid #0b3454;
    border-radius: 15px;
    height: 28px;
    line-height: 25px;
    padding: 0 20px;
    text-decoration: none;
    text-transform: uppercase;
    font-weight: 600;
    font-size: 12px;
    color: #fff;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.btn.btn-configure:hover {
    background: #5cae48;
    border: 2px solid #5cae48;
    color: #fff;
}
/* manage-widgets-wrap */

/* authorized_accounts */
.authorized_accounts {
    margin-top: 35px;
}
.authorized_accounts_block {
    background: #ffffff;
    height: 100%;
    border: 1px solid #d2d2d2;
    border-radius: 6px;
    opacity: 1;
    display: flex;
    flex-direction: column;
    position: relative;
    padding: 20px;
}
.authorized_accounts_status {
    border-radius: 0px 5px 0px 6px;
    opacity: 1;
    width: 108px;
    height: 24px;
    position: absolute;
    right: 0;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 500;
}
.authorized_accounts_status i {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin-right: 5px;
}
.authorized_accounts_status.active {
    background: #d6ffcc;
    color: #136000;
}
.authorized_accounts_status.active i {
    background: #5cae48;
    border: 3px solid #f4fff2;
}
.authorized_accounts_status.deactive {
    background: #f3f3f3;
    color: #303030;
}
.authorized_accounts_status.deactive i {
    background: #737373;
    border: 3px solid #ffffff;
}
.authorized_accounts_profile_img {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 5px;
}
.authorized_accounts_profile_img img {
    width: auto;
    height: 100%;
}
.authorized_accounts_profile_img.logo {
    border: 1px solid #d5d5d5;
    padding: 3px;
}
.authorized_accounts_detail h3 {
    font-size: 20px;
    color: #0b3454;
    margin: 0;
}
.authorized_accounts_detail p {
    font-size: 14px;
}
.authorized_accounts_block > a {
    width: 110px;
    border-radius: 23px;
    height: 36px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.authorized_accounts_block a.btn-disconnect {
    background: #ffffff;
    border: 2px solid #e1697a;
    color: #d42941;
}
.authorized_accounts_block a.btn-disconnect:hover {
    background: #e1697a;
    color: #fff;
}
.authorized_accounts_block a.btn-authorize {
    background: #ffffff;
    border: 2px solid #547187;
    color: #0b3454;
}
.authorized_accounts_block a.btn-authorize:hover {
    background: #547187;
    color: #fff;
}

.authorized_accounts_block.new_account a {
    background: #f2f9ff;
    width: 100%;
    height: 100%;
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    padding: 20px;
}
.authorized_accounts_block.new_account {
    position: relative;
    border: none;
    padding: 0;
}
.authorized_accounts_block.new_account a .plus {
    background: #f2f9ff;
    width: 70px;
    height: 70px;
    border: 1px solid #acb0b5;
    border-radius: 50%;
    margin-bottom: 15px;
    position: relative;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.authorized_accounts_block.new_account a .plus:before {
    content: '';
    position: absolute;
    width: 40px;
    height: 2px;
    background: #acb0b5;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.authorized_accounts_block.new_account a .plus:after {
    content: '';
    position: absolute;
    width: 2px;
    height: 40px;
    background: #acb0b5;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.authorized_accounts_block.new_account a span {
    width: 110px;
    border-radius: 23px;
    height: 36px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    background: #5cae48;
    color: #fff;
}

.authorized_accounts_block.new_account a:hover {
    background: #5cae48;
}
.authorized_accounts_block.new_account a:hover .plus {
    background: none;
    border-color: #fff;
}
.authorized_accounts_block.new_account a:hover .plus:before {
    background: #fff;
}
.authorized_accounts_block.new_account a:hover .plus:after {
    background: #fff;
}
.authorized_accounts_block.new_account a:hover span {
    background: #fff;
    color: #5cae48;
}

/* authorized_accounts */

/* alumni directory */

.aldir_scroll > .row > .aldir_box {
    width: 212px;
    height: 133px;
    padding: 0;
}
.aldir_scroll > .row > .aldir_box:not(:last-child) {
    margin-right: 20px;
}
.aldir_box .number {
    padding: 10px 12px 0 20px;
}
.aldir_box .number + div > div.font-16 {
    color: #0b3454;
    line-height: 18px;
    padding: 8px 0 0 18px;
}
.aldir_box .alumni-directory-img {
    margin-right: 10px;
    display: flex;
    align-items: flex-end;
}
.aldir_box .alumni-directory-block {
    justify-content: space-between;
    flex-direction: row;
    display: flex;
    flex-wrap: wrap;
    overflow: hidden;
}
.aldir_box .alumni-directory-block > div {
    width: 100%;
}
.aldir_box .number + div > div.font-16.min94 {
    min-width: 94px;
}
.aldir_scroll > .row {
    width: max-content;
    margin: 0;
}

.fiterItem {
    padding: 0;
    border: 1px solid rgba(0, 0, 0, 0.125);
    border-radius: 6px;
    overflow: hidden;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    -ms-border-radius: 6px;
    -o-border-radius: 6px;
}
.filterHeader {
    background: transparent;
    border-radius: 0;
    padding: 0;
    border: 0px solid rgba(0, 0, 0, 0.125);
}
.filterHeader button span.toggle {
    width: 10px;
    height: 10px;
    margin-left: 10px;
    position: relative;
}
.filterHeader button span.toggle::before {
    width: 10px;
    height: 10px;
    background: transparent;
    border-left: 2px solid #000;
    border-top: 2px solid #000;
    transform: rotate(45deg);
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    content: '';
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.filterHeader button.collapsed span.toggle::before {
    transform: rotate(225deg);
    -webkit-transform: rotate(225deg);
    -moz-transform: rotate(225deg);
    -ms-transform: rotate(225deg);
    -o-transform: rotate(225deg);
}

.scrollMe {
    max-height: 215px;
    margin-bottom: 0px;
    overflow-y: auto;
    scrollbar-width: thin;
}
.scrollMe::-webkit-scrollbar {
    width: 4px;
}
.scrollMe::-moz-scrollbar {
    width: 4px;
}
.scrollMe::-webkit-scrollbar-track {
    background: #eee;
}
.scrollMe::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 20px;
    border: 2px solid #666;
}

.fiterItem .form-check:not(:last-child) {
    margin-bottom: 10px;
}
.fiterItem .form-check .form-check-input {
    width: 20px;
    height: 20px; /* margin-left: -20px; */
    border: 1px solid #bacfde;
}
.fiterItem label {
    cursor: pointer;
    padding-top: 3px !important;
}
.fiterItem .card {
    border-radius: 0;
    border: 0px solid #fff;
    padding: 0px 20px 20px;
}
.filterHeader button {
    background: #fff;
    border-radius: 0;
    padding: 0;
    border: 0px solid rgba(0, 0, 0, 0.125);
    padding: 15px 20px;
}
.filterHeader button.collapsed {
    border-bottom: 0px solid rgba(0, 0, 0, 0.125);
}
.filterSearchblk {
    margin: 0px;
    padding: 0 18px;
}
.filterSearchblk .filterSearch input {
    background: #f3f3f3;
    border: 0 solid #fff;
    border-radius: 6px;
    color: #000;
    height: 36px;
    line-height: 36px;
    margin: 0 4px 2px;
}
.filterSearchblk .filterSearch button {
    position: absolute;
    right: 14px;
    width: 14px;
    height: 14px;
    font-size: 14px;
    top: 9px;
    padding: 0;
    color: #414141;
}
.ji_filtersec {
    width: 100%;
    max-width: 320px;
}
form.minmaxlb .form-label {
    color: #535353;
    font-size: 14px;
    font-weight: 500;
    font-style: italic;
}
form.minmaxlb button {
    max-width: 91px;
    background: #0b3454;
    padding: 0;
    height: 36px;
    line-height: 36px;
    color: #fff;
    border-radius: 18px;
}
.fiterItem .card .form-check-input:checked,
form.lstCustForm .form-check-input:checked {
    background-color: #5cae48;
    border-color: #5cae48 !important;
}
.form-check-input:focus {
    box-shadow: 0 0 0 0 rgba(13, 110, 253, 0.25);
}

.alumni-directory-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
}
.alumni-directory-header_search {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    align-items: center;
}
.alumni-directorySearch {
    background: #ffffff;
    width: 365px;
    height: 40px;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    border-radius: 25px;
    overflow: hidden;
    position: relative;
}
.alumni-directorySearch .form-control {
    flex: 1 1;
    border: 0;
    padding-left: 0;
}
.alumni-directorySearch .btn.icon-search {
    font-size: 12px;
    padding: 0 10px 0 20px;
}

.alumni-directory-header .btn-white {
    background: #ffffff;
    border-radius: 20px;
    padding: 0 20px;
    line-height: 40px;
    text-decoration: none;
    color: #000000;
    font-weight: 400;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.alumni-directory-header .btn-white:hover {
    background: #882130;
    color: #fff;
}

.alumni-directorySearch .btn-search-cross {
    position: absolute;
    right: 13px;
    top: 0;
    bottom: 0;
    margin: auto;
    display: flex;
    align-items: center;
    color: #000;
    font-weight: 100 !important;
}
.alumni-directorySearch .btn-cross {
    width: 14px;
    height: 14px;
    position: absolute;
    right: -15px;
    top: 0;
    bottom: 0;
    margin: auto;
    transform: rotate(0deg);
    opacity: 0;
    transition: all 0.5s ease-in-out;
}
.alumni-directorySearch .btn-cross:before {
    content: '';
    position: absolute;
    width: 14px;
    height: 2px;
    left: 0;
    bottom: 0;
    right: 0;
    top: 0;
    margin: auto;
    background: #000;
    border-radius: 5px;
}
.alumni-directorySearch .btn-cross:after {
    content: '';
    position: absolute;
    width: 2px;
    height: 14px;
    left: 0;
    bottom: 0;
    right: 0;
    top: 0;
    margin: auto;
    background: #000;
    border-radius: 5px;
}
.alumni-directorySearch .form-control:valid + .btn-cross {
    opacity: 1;
    right: 15px;
    transform: rotate(135deg);
}

.alumni_directory_filter {
    padding: 30px 0;
    padding-right: var(--bs-gutter-x, 0.75rem);
    padding-left: var(--bs-gutter-x, 0.75rem);
}
.alumni_directory_filter .ji_filtersec {
    width: 100%;
    max-width: 100%;
}
.alumni_directory_filter .fiterItem {
    width: calc(33.3% - 10px);
    margin: 0 5px;
    box-shadow: 0px 10px 25px #00000008;
}
.alumni_directory_filter .fiterItem.w-20 {
    width: calc(20% - 10px);
}
.alumni_directory_filter .fiterItem.width-25 {
    width: calc(25% - 10px);
}
.alumni_directory_filter .fiterItem.w-40 {
    width: calc(40% - 10px);
}
.alumni_directory_filter #additionalfilter .fiterItem {
    width: 28%;
}
.alumni_directory_filter #additionalfilter .fiterItem.w-20 {
    width: calc(20% - 10px);
}
.alumni_directory_filter #additionalfilter .fiterItem.width-25 {
    width: calc(25% - 10px);
}
.alumni_directory_filter #additionalfilter .fiterItem.width-50 {
    width: calc(50% - 10px);
}
.alumni_directory_filter #additionalfilter .fiterItem.w-40 {
    width: calc(40% - 10px);
}
.alumni_directory_filter #additionalfilter .fiterItem.campus {
    width: 41%;
}
.filterItemWrap .fiterItem {
    width: 190px;
}
.alumni_directory_filter .fiterItem.key {
    border-color: #5cae48;
}
.alumni_directory_filter .filterGroup {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    align-items: start;
    margin: 0 -5px;
}
.alumni_directory_filter .filterSearchblk {
    background: #fff;
    padding: 0 14px 10px;
}
.alumni_directory_filter .filterSearchblk .filterSearch input {
    margin: 0;
}
.filters-head {
    position: relative;
}
.filterItemWrap {
    position: absolute;
    top: -10px;
    left: 90px;
    display: flex;
    z-index: 1;
    align-items: start;
}
.alumni_directory_filter .filterItemWrap .filterHeader button {
    padding: 7px 15px;
}
.alumni_directory_filter .filterHeader button {
    transition: all 0.3s ease-in-out;
    padding: 15px 15px;
}
.alumni_directory_filter .filterHeader button:not([aria-expanded='false']) {
    padding-bottom: 8px;
}
.alumni_directory_filter .fiterItem .card {
    padding: 0px 15px 15px;
}
.alumni_directory_filter .scrollMe {
    max-height: 122px;
    min-height: 122px;
    overflow-x: hidden;
}
.alumni_directory_filter .fiterItem .form-check {
    display: flex;
}
.alumni_directory_filter .fiterItem .form-check:not(:last-child) {
    margin-bottom: 4px;
}
.additionalfilter_count {
    display: block;
    letter-spacing: 2px;
    flex: 1 1;
    padding: 0 5px;
}
.additionalfilter_count:before {
    content: '(';
}
.additionalfilter_count:after {
    content: ')';
}
.btn-md-filter {
    text-decoration: none;
    transform: rotate(90deg);
    color: #000;
    font-size: 20px;
    transition: all 0.3s ease-in-out;
}
.btn-md-filter:hover {
    color: #000;
}
.btn-md-filter[aria-expanded='true'] {
    transform: rotate(270deg);
}
.additionalfilter_wrap {
    width: 100%;
    padding: 0 5px;
}
.alumni_directory_filter .fiterItem.campus {
    width: 450px;
}

.showProfiles_wrap {
    background: #fff;
    border: 1px solid #d2d2d2;
    border-radius: 6px;
    box-shadow: 0px 10px 25px #00000008;
    width: calc(100% - 10px);
    margin: 0 5px;
    padding: 17px 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.showProfiles_left {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    align-items: center;
}
.showProfiles_left h3 {
    margin: 0 30px 0 0;
    font-size: 18px;
    line-height: 20px;
    font-weight: 600;
}
.showProfiles_left .form-check-label {
    font-size: 16px;
}
.showProfiles_left .form-check-input {
    width: 20px;
    height: 20px;
    vertical-align: top;
    margin-top: -2px;
    margin-right: 10px;
}
.showProfiles_left .form-check.form-check-inline {
    display: inline-flex;
    align-items: center;
}
.showProfiles_left .check_list {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    align-items: center;
}
.showProfiles_left .form-check-input:checked {
    background-color: #5cae48;
    border-color: #5cae48;
}
.showProfiles_right .icon {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/subtraction.svg);
    width: 16px;
    height: 25px;
    margin-right: 8px;
}
.showProfiles_right {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}
.showProfiles_right .title {
    font-size: 14px;
    letter-spacing: -0.35px;
    height: auto;
}

.alumni-bucket {
    background: #ffffff;
    border: 1px solid #d2d2d2;
    border-radius: 6px;
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
}
.alumni-bucket .form-check {
    position: absolute;
    left: 6px;
    top: 6px;
    cursor: pointer;
    z-index: 1;
}
.alumni-bucket .block-link {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    margin: auto;
    z-index: 1;
}
.alumni_img {
    width: 60px;
    margin-right: 10px;
    height: 60px;
    background: #f1f1f1;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.alumni_img img {
    width: auto;
    height: 100%;
}
.alumni_img.no_pic {
    align-items: end;
}
.alumni_img.no_pic img {
    width: auto;
    height: auto;
}
.alumni_name_brife h3 {
    font-size: 18px;
    margin: 0 0 3px;
}
.class_year {
    color: #6a6868;
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
}
.alumni_directory_details .btn-viewcompus {
    font-size: 13px;
    color: #1452ce;
    font-weight: 500;
    line-height: 18px;
    position: relative;
    z-index: 2;
    text-decoration: none;
}
.alumni_directory_details .btn-viewcompus:hover {
    color: #0b3454;
    text-decoration: underline;
}
.alumni_directory_details a.btn-send {
    padding: 0 20px;
    line-height: 36px;
    text-decoration: none;
    background: #5cae48;
    border-radius: 25px;
    height: 36px;
    display: inline-flex;
    color: #fff;
    align-items: center;
    transition: all 0.3s ease-in-out;
    position: relative;
    z-index: 2;
}
.alumni_directory_details a.btn-send:hover {
    background: #40862f;
}
.icon-alumni-send {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/send_alumni_profile.svg) no-repeat 0
        0 / 100%;
    width: 19px;
    height: 19px;
    margin-right: 8px;
    margin-left: -3px;
}
.alumni_univarsity_details {
    background: #f9f9f9;
    border-radius: 0px 0px 5px 5px;
    opacity: 1;
    display: flex;
    justify-content: center;
    flex: 1 1;
    padding: 15px 20px;
    position: relative;
}
.alumni_univarsity_details .alumni_univarsity_details_inner_cover {
    width: 100%;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    align-items: start;
}
.alumni_univarsity_details .alumni_univarsity_details_inner_cover .alumni_univarsity_logo {
    width: 64px;
    margin-right: 10px;
    padding: 6px;
    background: #fff;
    border-radius: 50%;
    border: 1px solid #d2d2d2;
    height: 64px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.alumni_univarsity_details .alumni_univarsity_details_inner_cover .alumni_univarsity_logo.icon-brife-case {
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #dc3545;
    border: 1px solid #dc3545;
}
.alumni_univarsity_details .alumni_univarsity_details_inner_cover .alumni_univarsity_logo img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
}
.alumni_univarsity_details .alumni_univarsity_details_inner_cover .alumni_univarsity_brife {
    width: calc(100% - 75px);
}
.alumni_directory_details a.alumni_name_link {
    color: #000;
    text-decoration: none;
    font-size: 18px;
    line-height: 18px;
}
.alumni_directory_details a.alumni_name_link:hover {
    color: #666;
}
.alumni_directory_details .alumni_campus {
    color: #6a6868;
    font-size: 14px;
    font-weight: 500;
}

.btn-pushwebsite {
    background: #5cae48;
    border-radius: 20px;
    margin-top: 15px;
    display: inline-flex;
    height: 40px;
    padding: 0 20px;
    align-items: center;
    text-decoration: none;
    color: #fff;
    font-weight: 500;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.btn-pushwebsite i {
    margin-right: 10px;
    width: 20px;
    height: 20px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/web.svg) no-repeat center;
}
.btn-pushwebsite:hover {
    background: #3d842b;
    color: #fff;
}

.alumni_directory_details .alumni_course {
    display: flex;
    margin-top: 8px;
}
.alumni_directory_details .alumni_course i {
    width: 24px;
    height: 24px;
    margin-right: 5px;
}
.alumni_directory_details .alumni_course i.study {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/student-book.svg) no-repeat center /
        100%;
}
.alumni_directory_details .alumni_course span {
    font-size: 16px;
    font-weight: 600;
}
.alumni_class_link {
    padding: 15px 20px;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    align-items: center;
}
.alumni_name_detail {
    flex: 1 1;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
}
.alumni_class_link .modal {background: rgba(0, 0, 0, 0.8);}
.alumni_name_brife {
    display: flex;
    flex-direction: column;
    flex: 1 1;
    justify-content: center;
}
.alumni_education {
    color: #4d4d4d;
    font-size: 13px;
    font-weight: 500;
    line-height: 18px;
    margin-bottom: 3px;
}
.alumni_univarsity_name {
    font-size: 19px;
    font-weight: 600;
    line-height: 20px;
    margin-bottom: 4px;
}
.alumni_univarsity_name .icon-subtraction {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/subtraction.svg) no-repeat 0 0 / 100%;
    width: 12px;
    height: 20px;
    margin-left: 3px;
    display: inline-block;
    vertical-align: top;
}
.alumni_univarsity_subject {
    color: #0b3454;
    font-size: 14px;
    line-height: 16px;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
}
.alumni_univarsity_subject span {
    flex: 1 1;
}
.alumni_univarsity_subject i {
    width: 16px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/subject_setting.svg) no-repeat 0 0 /
        100%;
    height: 16px;
    margin-right: 7px;
}
.alumni_univarsity_subject i.icon-brifecase {
    width: 16px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/briefcase.svg) no-repeat 0 0 / 100%;
    height: 16px;
    margin-right: 7px;
}

.alumni_name_brife h3 a {
    color: #000;
    text-decoration: none;
    font-size: 18px;
    line-height: 18px;
    word-break: break-all;
    overflow: hidden;
text-overflow: ellipsis;
display: -webkit-box;
-webkit-line-clamp: 1;
-webkit-box-orient: vertical;
}
.alumni_name_brife .alumni_campus {
    color: #6a6868;
    font-size: 14px;
    font-weight: 500;
}
.alumni_name_brife .alumni_course {
    display: flex;
    margin-top: 8px;
}
.alumni_name_brife .alumni_course i {
    width: 24px;
    height: 24px;
    margin-right: 5px;
}
.alumni_name_brife .alumni_course i.study {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/student-book.svg) no-repeat center /
        100%;
}
.alumni_name_brife .alumni_course span {
    font-size: 16px;
    font-weight: 600;
}

.filter_result ul {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
}
.filter_result_title {
    margin-bottom: 18px;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 10px;
}
.filter_result_title .filter_result {
    flex: 1 1;
}
.filter_result ul li {
    background: #e9f6fc;
    border-radius: 25px;
    padding: 9px 23px;
    margin-top: 6px;
    margin-bottom: 6px;
}
.filter_result ul li:not(:last-child) {
    margin-right: 10px;
}
.filter_result ul li:last-child {
    background: no-repeat;
    padding: 9px 0;
}
.filter_result ul li span {
    margin-right: 10px;
}
.filter_result ul li .btn-cross {
    font-size: 10px;
    color: #000;
    text-decoration: none;
}
.filter_result ul li .btn-cross:hover {
    color: #105271;
}
.alumni_count {
    font-size: 18px;
    font-weight: 500;
    line-height: 20px;
    margin: 18px 0 0;
}

.btn-additionalfilter {
    text-decoration: none;
    font-size: 14px;
    color: #1452ce;
    font-weight: 500;
    display: inline-flex;
    align-items: center;
    transition: all 0.3s ease-in-out;
}
.btn-additionalfilter span {
    text-decoration: underline;
    margin-right: 10px;
}
.btn-additionalfilter .icon-right-arrow {
    transform: rotate(90deg);
    transition: all 0.3s ease-in-out;
}
.btn-additionalfilter[aria-expanded='true'] .icon-right-arrow {
    transform: rotate(270deg);
}
.btn-additionalfilter:hover {
    color: #0b3454;
}
.btn-additionalfilter:hover span {
    text-decoration: none;
}

.alumni_directory_filter .filters-head h3 {
    display: flex;
    margin: 0;
    align-items: center;
}
.alumni_directory_filter .filters-head h3 .icon-filter + span {
    flex: 1 1;
}
.alumni_directory_filter .filters-head h3[aria-expanded='true'] i {
    transform: rotate(270deg);
}

.alumni_directory_details .load_more_btn {
    text-decoration: none;
    text-transform: uppercase;
    display: flex;
    justify-content: center;
    align-items: center;
}
.alumni_directory_details .load_more_btn:hover {
    background: #0b3454;
    color: #fff;
    border-color: #0b3454;
}

.alumni_directory_details .load_more_btn img {
    animation: none;
    -webkit-animation: none;
    margin-right: 10px;
}
.alumni_directory_details .load_more_btn:hover img {
    filter: invert(1) brightness(100);
}
.tooltip-viewcompus .tooltip-arrow::before {
    display: none;
}
.alumni_directory_details .load_more_btn {
    text-decoration: none;
    text-transform: uppercase;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #cccc;
    padding: 10px 25px;
    border-radius: 25px;
    transition: all 0.3s ease-in-out;
    max-width: 250px;
    width: 100%;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.alumni_directory_details .load_more_btn:hover {
    background: #0b3454;
    color: #fff;
    border-color: #0b3454;
}

/* .alumni_profile_brife_wrap {border-bottom: 1px solid #E7E7E7;}
.alumni_profile_brife {padding: 40px 0;}
.alumni_profile_brife .btn-back {color: #000;font-size: 14px;line-height: 16px;font-weight: 500;text-decoration: none;}
.alumni_profile_brife .btn-back .icon-right-arrow {transform: scaleX(-1);margin-right: 7px;font-size: 12px;}
.alumni_profile_brife .btn-back:hover {color: #0b3454;}

.alumni_profile_name_college_other_detail_wrap {display: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex;-webkit-box-wrap: wrap;-moz-box-wrap: wrap;-ms-flex-wrap: wrap;-webkit-wrap: wrap;flex-wrap: wrap;}
.alumni_profile_image_name_other_detail {display: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex;-webkit-box-wrap: wrap;-moz-box-wrap: wrap;-ms-flex-wrap: wrap;-webkit-wrap: wrap;flex-wrap: wrap;padding: 0 45px 0 0;position: relative;width: 45%;}
.alumni_profile_image_name_other_detail:after {content: '';width: 1px;height: 100%;background: #D4D4D4;position: absolute;right: 0;top: 0;}
.alumni_profile_image {width: 110px;height: 110px;background: #F1F1F1;border-radius: 50%;display: flex;align-items: center;justify-content: center;overflow: hidden;margin-right: 20px;}
.alumni_profile_image img {width: auto;height: 100%;}
.alumni_profile_image.no_pic {align-items: end;}
.alumni_profile_image.no_pic img {height: 80%;}

.alumni_profile_name_other_detail {-webkit-box-flex: 1;-moz-box-flex: 1;-webkit-flex: 1;-ms-flex: 1;flex: 1;}
.alumni_profile_name_other_detail h2 {font-size: 30px;line-height: 18px;font-weight: 600;word-break: break-all;line-height: 35px;}
.alumni_profile_name_other_detail .alumni_profile_location {font-size: 14px;font-weight: 500;margin-bottom: 15px;}
.alumni_profile_class_college {position: relative;padding: 0 0 0 20px;margin-bottom: 13px;}
.alumni_profile_class_college:before {content: '';position: absolute;left: 6px;top: 0;bottom: 0;width: 3px;height: 100%;background: #D52941;border-radius: 5px;}
.alumni_profile_class_college .alumni_profile_class {font-size: 16px;font-weight: 500;letter-spacing: 0.32px;line-height: 18px;margin-bottom: 5px;}
.alumni_profile_class_college .alumni_profile_college {font-size: 16px;font-weight: 500;letter-spacing: 0.32px;line-height: 18px;}

.alumni_profile_college_phone {display: flex;flex-wrap: wrap;justify-content: space-between;align-items: center;}
.alumni_profile_college_phone .verifyLink {font-size: 16px;font-weight: 500;}
.verifiedLink {color: #5cae48;text-decoration: none;display: flex;align-items: center;font-weight: 400;font-size: 16px;}

.alumni_profile_name_other_detail .btn-send {width: 123px;height: 40px;display: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex;-webkit-box-wrap: wrap;-moz-box-wrap: wrap;-ms-flex-wrap: wrap;-webkit-wrap: wrap;flex-wrap: wrap;background: #5CAE48;border-radius: 25pc;color: #fff;text-decoration: none;align-items: center;padding: 0 25px;font-size: 16px;font-weight: 500;transition:all 0.3s ease-in-out;}
.alumni_profile_name_other_detail .btn-send .icon-send {background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/send_alumni_profile.svg) no-repeat 0 0 / 100%;width: 19px;height: 19px;margin-right: 10px;position:relative;transition:all 0.3s ease-in-out;left:0;}
.alumni_profile_name_other_detail .btn-send:hover{background:#2FA612}
.alumni_profile_name_other_detail .btn-send:hover .icon-send {left:3px}

.alumni_profile_college_name_other_detail_wrap {-webkit-box-flex: 1;-moz-box-flex: 1;-webkit-flex: 1;-ms-flex: 1;flex: 1;display: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex;-webkit-box-wrap: wrap;-moz-box-wrap: wrap;-ms-flex-wrap: wrap;-webkit-wrap: wrap;flex-wrap: wrap;padding: 0 0 0 80px;}
.alumni_profile_college_name_other_detail_wrap .alumni_profile_college_logo {width: 100px;height: 100px;display: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex;align-items: center;justify-content: center;border-radius: 50%;border: 1px solid #D2D2D2;margin-right: 18px;}
.alumni_profile_college_name_other_detail_wrap .alumni_profile_college_logo img {width: 70%;}
.alumni_profile_college_name_other_detail_wrap .alumni_profile_college_logo img[src*="college_icon"] {	width: 40px;	}
.alumni_profile_college_name_other_detail_wrap .alumni_profile_college_name_other_detail {-webkit-box-flex: 1;-moz-box-flex: 1;-webkit-flex: 1;-ms-flex: 1;flex: 1;display: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex;-webkit-box-wrap: wrap;-moz-box-wrap: wrap;-ms-flex-wrap: wrap;-webkit-wrap: wrap;flex-wrap: wrap;align-items: start;}

.alumni_profile_brife_tab {margin-bottom: 20px;width: 100%;}
.alumni_profile_status {list-style: none;margin: 0;padding: 0;}
.alumni_profile_status li {margin-bottom: 16px;width: 176px;position: relative;padding-left: 16px;}
.alumni_profile_status li .title {letter-spacing: 0.32px;color: #000000;font-size: 16px;}
.alumni_profile_status li p {font-size: 16px;font-weight: 600;line-height: 20px;letter-spacing: 0.32px;}
.alumni_profile_status li:before {content: '';width: 3px;height: 17px;position: absolute;left: 0;top: 4px;background: #d52941;border-radius: 5px;}

.alumni_profile_college_joined {color: #5CAE48;font-size: 14px;font-weight: 500;line-height: 18px;margin-bottom: 5px;}
.alumni_profile_college_name_detail {-webkit-box-flex: 1;-moz-box-flex: 1;-webkit-flex: 1;-ms-flex: 1;flex: 1;padding-right: 50px;}
.alumni_profile_college_name_other_detail_wrap .alumni_profile_college_name_detail h3 {font-size: 20px;line-height: 26px;font-weight: 600;}
.alumni_profile_college_subject {height: 30px;display: inline-flex;align-items: center;justify-content: center;padding: 0 15px;background: #E5F1FB;border-radius: 25px;font-size: 16px;line-height: 16px;font-weight: 600;color:#0B3454;max-width: 280px;width: auto;}
.alumni_profile_college_subject .icon {background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/course_alumni_profile.svg);width: 15px;height: 15px;margin-right: 8px;}
.alumni_profile_college_subject span{text-overflow: ellipsis;overflow: hidden;white-space: nowrap;width: calc(100% - 23px);}
.alumni_profile_brife_links {width: 100%;padding-left: 129px;margin-top: 20px;display: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex;align-items: center;}
.alumni_profile_brife_links > a { height: 40px; padding: 0 20px; border-radius: 25px; display: inline-flex; align-items: center; margin-right: 6px; text-decoration: none; transition:all 0.3s ease-in-out ; -webkit-transition:all 0.3s ease-in-out ; -moz-transition:all 0.3s ease-in-out ; -ms-transition:all 0.3s ease-in-out ; -o-transition:all 0.3s ease-in-out ; }
.alumni_profile_brife_links > a i {margin-right: 5px;}
.alumni_profile_brife_links > a.btn-send{background: #5CAE48;color: #fff;}
.alumni_profile_brife_links > a.btn-send:hover{background: #2FA612;}
.alumni_profile_brife_links > a.btn-send i.icon-send {background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/send_alumni_profile.svg) no-repeat 0 0 / 100%;width: 19px;height: 19px;margin-right: 10px;position: relative;transition: all 0.3s ease-in-out;left: 0;-webkit-transition: all 0.3s ease-in-out;-moz-transition: all 0.3s ease-in-out;-ms-transition: all 0.3s ease-in-out;-o-transition: all 0.3s ease-in-out;}
.alumni_profile_brife_links .btn-send:hover .icon-send {left: 3px;}

.alumni_profile_brife_links > a.btn-push-web {background: #27A7DF;color: #fff;}
.alumni_profile_brife_links > a.btn-push-web:hover{background: #078DC8;}
.alumni_profile_brife_links > a.btn-push-web i.icon-globe {background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/web.svg) no-repeat 0 0 / 100%;width: 19px;height: 19px;margin-right: 10px;position: relative;transition: all 0.3s ease-in-out;left: 0;-webkit-transition: all 0.3s ease-in-out;-moz-transition: all 0.3s ease-in-out;-ms-transition: all 0.3s ease-in-out;-o-transition: all 0.3s ease-in-out;}
.alumni_profile_brife_links .btn-push-web:hover .icon-globe {left: 3px;}

.alumni_profile_brife_links > a.btn-mark {background: #fff;border: 2px solid #0b3454;color: #0b3454;}
.alumni_profile_brife_links > a.btn-mark:hover {background: #0b3454;color: #fff;}

.alumni_profile_detail {padding: 30px 0;}
.alumni_profile_brife_tab .nav {justify-content: center;}
.alumni_profile_brife_tab .nav-item:not(:last-child) {margin-right: 10px;}
.alumni_profile_brife_tab .nav-pills .nav-link {min-width: 100px;height: 40px;white-space: nowrap;border: 2px solid #7D7D7D;border-radius: 25px;background: #fff;color: #000;padding: 0 20px;}
.alumni_profile_brife_tab .nav-pills .nav-link.active, .alumni_profile_brife_tab .nav-pills .nav-link:hover {background: #0B3454;border-color: #0B3454;color: #fff;} */

.underGraduate-detail .main_title,
.blockHeader {
    font-size: 22px;
    color: #000;
    width: auto;
    margin: -40px -40px 25px;
    border-radius: 6px 6px 0px 0px;
    padding: 20px 40px;
    line-height: 22px;
    border-bottom: 1px solid #f5f5f5;
}
.blockHeader .title span {
    font-weight: 600;
}
.graduateRow .college_detail_wrap .college_detail h3 {
    font-size: 20px;
    font-weight: 600;
    margin: 0 0 2px;
    transition: all 0.3s ease-in-out;
}
.graduateRow .college_detail_wrap:hover h3 {
    text-decoration: underline;
    color: #1452ce;
}
.graduateRow .college_detail_wrap .college_detail h3 .icon-subtraction {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/subtraction.svg) no-repeat 0 0 / 100%;
    width: 16px;
    height: 25px;
    margin-left: 3px;
    display: inline-block;
    vertical-align: top;
}
.graduateRow .college_detail_wrap .college_detail p {
    font-size: 16px;
    color: #414141;
    margin: 0 0 5px;
}
.graduateRow {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    position: relative;
}
.graduateRow:not(:last-child) {
    border-bottom: 2px solid #e5e5e5;
    margin-bottom: 28px;
    padding-bottom: 28px;
}
.underGraduate-detail,
.postGraduate-detail {
    box-shadow: 0px 10px 25px #00000008;
    border-radius: 6px;
    background: #fff;
    padding: 40px;
}
.graduateRow .college_detail_wrap {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    width: calc(100% - 265px);
    padding-right: 40px;
    position: relative;
    align-items: center;
}
.graduateRow .college_detail_wrap > a {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
}
.graduateRow .college_detail_wrap:after {
    content: '';
    position: absolute;
    top: 13px;
    right: 0;
    width: 2px;
    height: 63px;
    background: #d1d1d1;
}
.graduateRow .offer {
    width: 265px;
    display: flex;
    flex-direction: column;
    align-items: end;
    justify-content: center;
}
.graduateRow .college_detail_wrap .college_detail {
    flex: 1 1;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
}
.graduateRow .college_detail_wrap .college_detail .college_logo {
    margin-right: 20px;
    width: 150px;
    height: 95px;
    border: 1px solid #d5d5d5;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.college_name_scholarship {
    flex: 1 1;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
}
.college_name_scholarship .college_name {
    width: calc(100% - 180px);
}
.graduateRow .college_detail_wrap .college_detail .college_logo .logo_link {
    padding: 10px;
    display: inline-flex;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
}
.graduateRow .college_detail_wrap .college_detail .college_logo .logo_link img {
    width: auto;
    height: auto;
    max-width: 100%;
}
.graduateRow .college_detail_wrap .scholarship {
    display: flex;
    flex-direction: column;
    text-align: center;
    line-height: 20px;
}
.graduateRow .college_detail_wrap .scholarship .scholarship_label {
    font-weight: 500;
    color: #8a8a8a;
}
.graduateRow .college_detail_wrap .scholarship .scholarship_amt {
    font-weight: 600;
    white-space: nowrap;
}
.graduateRow .offer > a,
.graduateRow .offer a.joindeLink {
    padding: 0 20px;
    text-decoration: none;
    height: 37px;
    background: #5cae48;
    color: #fff;
    border-radius: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 10px;
    transition: all 0.3s ease-in-out;
}
.graduateRow .offer > a:hover,
.graduateRow .offer a.joindeLink:hover {
    background: #3e9329;
}
.graduateRow .offer > a i,
.graduateRow .offer a.joindeLink i {
    margin-right: 10px;
}
.graduateRow .offer > a:hover {
    background: #3b8d27;
}
.graduateRow .offer .got_offer {
    font-weight: 500;
    font-size: 16px;
    margin-bottom: 5px;
}
.graduateRow .offer .got_offer i {
    margin-right: 10px;
    font-size: 20px;
    color: #5cae48;
}
.graduateRow .offer .offerLink {
    color: #1452ce;
}
.graduateRow .offer .offerLink:hover {
    color: #0b3454;
}
.graduateRow .offer .offer_joined i {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/hat_alumni.svg);
    width: 23px;
    height: 17px;
    margin-right: 10px;
}
.graduateRow .offer .offer_joined {
    display: flex;
    align-items: center;
}

.graduateRow.edit .college_detail_wrap {
    width: calc(100% - 350px);
}
.graduateRow .offer.offer_edit {
    flex-direction: row;
    align-items: center;
    width: 350px;
    justify-content: end;
}
.graduateRow .offer.offer_edit .edit_section,
.edit_section {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-left: 20px;
    align-items: center;
}
.edit_section_inner {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}
.graduateRow .offer .edit_link,
.edit_section .edit_link {
    width: 52px;
    height: 30px;
    background: #eaf4fc;
    border-radius: 20px;
    transition: all 0.3s ease-in-out;
    position: relative;
}
.graduateRow .offer .edit_link:hover,
.edit_section .edit_link:hover {
    background-color: #0b3454;
}
.graduateRow .offer .edit_link:before,
.edit_section .edit_link::before {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    margin: auto;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/draw.svg) no-repeat center / 18px
        auto;
}
.graduateRow .offer .edit_link:hover:before,
.edit_section .edit_link:hover::before {
    filter: invert(99%) sepia(1%) saturate(2%) hue-rotate(228deg) brightness(110%) contrast(100%);
}
.graduateRow .offer .del_link,
.edit_section .del_link,
.del_link {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/delete.svg);
    width: 14px;
    height: 16px;
    margin-left: 10px;
    opacity: 0.5;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.graduateRow .offer .del_link:hover,
.edit_section .del_link:hover,
.del_link:hover {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/delete_dark.svg);
    opacity: 1;
}
.graduateRow .offer .offer_existing_links {
    display: flex;
    flex-direction: column;
    align-items: end;
}
.form-group .del_link {
    position: absolute;
    top: 15px;
    right: -20px;
}

.graduation-title {
    font-size: 22px;
    font-weight: 400;
    margin: -15px 0 20px;
}
.graduation-title span {
    font-weight: 600;
}

.graduation_carousel_wrap {
    margin-top: 20px;
    box-shadow: 0px 10px 25px #00000008;
    border-radius: 6px;
    background: #fff;
    padding: 40px;
}
.graduation_carousel_wrap .card_profiles:first-child {
    margin-bottom: 18px;
}
.graduation_carousel_wrap .seactionheader {
    margin: -10px 0 27px;
}
.graduation_carousel_wrap .seactionheader h3 {
    font-size: 22px;
    font-weight: 400;
}
.graduation_carousel_wrap .seactionheader h3 span {
    font-weight: 600;
}
.card_profiles {
    border: 1px solid #d2d2d2;
    padding: 20px;
    border-radius: 6px;
    flex-direction: column !important;
    display: flex;
    justify-content: space-between;
    height: 100%;
    position: relative;
    background: #fff;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    -ms-border-radius: 6px;
    -o-border-radius: 6px;
    overflow-y: auto;
}
.card_profiles::-webkit-scrollbar {
    width: 4px;
}
.card_profiles::-moz-scrollbar {
    width: 4px;
}
.card_profiles::-webkit-scrollbar-track {
    background: #ccc;
}
.card_profiles::-webkit-scrollbar-thumb {
    background-color: #666;
    border-radius: 20px;
    border: 2px solid #666;
}
.card_profiles .alumni-Profile-button-rounded {
    position: absolute;
    right: 20px;
    padding: 0 20px;
}
.card_profiles .alumni-Profile-button-rounded:hover,
.card_profiles .alumni-Profile-button-rounded:focus {
    background: #40952c;
    color: #fff;
    background-color: #40952c;
    border-color: 0;
    box-shadow: none;
}
.card_profiles figure.student {
    width: 90px;
    height: 90px;
    overflow: hidden;
    border-radius: 200px;
    margin-right: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.card_profiles figure.student img {
    border-radius: 200px;
}
.student_details {
    flex: 1 1;
}
.card_profiles .student_details figure img {
}
.card_profiles .student_details h2 {
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 15px;
    width: 65%;
    margin-top: 010px;
}
.card_profiles .student_details h2 a {
    color: #000;
    text-decoration: none;
    white-space: nowrap;
    width: 100%;
    text-overflow: ellipsis;
    display: inline-block;
    overflow: hidden;
}
.card_profiles .student_details h2 a:hover {
    text-decoration: underline;
    color: #1452ce;
}
.card_profiles .student_details h2 span {
    display: block;
    font-size: 16px;
    color: #6a6868;
    font-weight: 500;
}
.card_profiles .student_details .sub_details {
    display: flex;
    flex-grow: 1 !important;
}
.card_profiles .student_details .sub_details_workExp {
    align-items: center;
    position: relative;
    padding-bottom: 5px;
}
.card_profiles .student_details .sub_details_achivements figure {
    background: #0b3454 !important;
}
.card_profiles .student_details .sub_details_workExp figure {
    border: 0 !important;
    border-radius: 100px !important;
    min-width: 50px !important;
    height: 50px !important;
    width: 50px !important;
    background-color: #d52941;
}
.card_profiles .student_details .sub_details_workExp figure img {
    width: 45%;
    height: auto;
}
.card_profiles .student_details .sub_details_workExp figure.bg_white {
    background-color: #fff !important;
    border: 1px solid #d2d2d2 !important;
}
.card_profiles .student_details .sub_details_workExp figure.bg_white img {
    width: 80%;
}
.card_profiles .student_details .sub_details_workExp:after {
    position: absolute;
    width: 83%;
    height: 1px;
    content: '';
    background: #c1c1c1;
    bottom: 0;
    right: 0; /* padding-bottom: 20px; */
}
.card_profiles .student_details .sub_details_workExp1:after {
    display: none;
}
.card_profiles .student_details .sub_details h3 {
    margin-bottom: 0;
    min-width: 43px;
    justify-content: center;
}
.card_profiles .student_details .sub_details figure {
    border: 1px solid #d2d2d2;
    border-radius: 100px;
    min-width: 80px;
    height: 80px;
    overflow: hidden;
    margin-right: 10px;
    margin-bottom: 0;
    width: 80px;
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.card_profiles .student_details .sub_details p {
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 5px;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    max-height: 43px;
    overflow: hidden;
    line-height: 18px;
}
.card_profiles .student_details .sub_details a {
    color: #000;
    text-decoration: none;
}
.card_profiles .student_details .sub_details a:hover {
    text-decoration: underline;
    color: #1452ce;
}
.card_profiles .student_details .sub_details p.title,
.card_profiles .student_details .sub_details p.green-title {
    color: #5cae48;
    font-size: 14px;
    margin-bottom: 10px;
}
.card_profiles .student_details .sub_details span {
    color: #333333;
    font-size: 14px;
    margin-bottom: 15px;
    font-weight: 400;
}
.card_profiles .student_details .sub_details span.course {
    color: #0b3454;
    font-size: 16px;
    font-weight: 400;
    display: flex;
    align-items: center;
    margin-bottom: 0;
}
.card_profiles .student_details .sub_details span.course img {
    margin-right: 6px;
    width: 16px;
}
.card_profiles .action_btns {
    margin-top: 20px;
    border-top: 1px solid #d2d2d2;
    padding-top: 20px;
    display: flex;
    justify-content: center !important;
    width: 100%;
}
.card_profiles .action_btns .btn-outline-primary {
    margin-right: 10px;
    border: 2px solid #5bae47;
    border-radius: 50px;
    padding: 7px 20px;
    color: #5bae47;
}
.card_profiles .action_btns .btn-outline-primary:hover img {
    filter: brightness(0) invert(1);
}
.card_profiles .action_btns .btn-outline-primary:hover {
    border: 2px solid #418d2e;
    background-color: #418d2e;
    color: #fff;
}
.card_profiles .action_btns .btn-secondary {
    border-radius: 50px;
    padding: 7px 20px;
    color: #fff;
    background: #0b3454;
}
.card_profiles .action_btns .btn-secondary:hover {
    background: #26a7df;
    border: 1px solid #26a7df;
}
.card_profiles .btn-send {
    width: 123px;
    height: 40px;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    background: #5cae48;
    border-radius: 25pc;
    color: #fff;
    text-decoration: none;
    align-items: center;
    padding: 0 25px;
    font-size: 16px;
    font-weight: 500;
    transition: all 0.3s ease-in-out;
}
.card_profiles .btn-send {
    color: #fff;
    font-size: 16px;
    font-weight: 500;
    position: absolute;
    top: 20px;
    right: 20px;
}
.card_profiles .btn-send .icon-send {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/send_alumni_profile.svg) no-repeat 0
        0 / 100%;
    width: 19px;
    height: 19px;
    margin-right: 10px;
    position: relative;
    transition: all 0.3s ease-in-out;
    left: 0;
}
.card_profiles .btn-send:hover .icon-send {
    left: 3px;
}
.card_profiles .btn-send:hover {
    background: #3b8d27;
}

.workExperience-detail {
    box-shadow: 0px 10px 25px #00000008;
    border-radius: 6px;
    background: #fff;
    padding: 40px;
}
.workExperience-detail .workExperience-title {
    font-size: 22px;
    font-weight: 400;
    margin: -15px 0 30px;
}
.workExperience-detail .workExperience-title span {
    font-weight: 600;
}
.work-block {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    align-items: center;
    position: relative;
}
.work-block .work-detail {
    flex: 1 1;
    display: flex;
    flex-direction: column;
}
.work-block .icon {
    width: 55px;
    height: 55px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 26px;
    margin-right: 20px;
    background: #d52941;
    border-radius: 50%;
    color: #fff;
}
.work-block .icon.workex-logo {
    border-radius: 0;
}
.work-block .icon.workex-logo img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
}
.work-block .work-detail p {
    font-size: 20px;
    line-height: 24px;
    margin: 0 0 5px;
    font-weight: 500;
}
.work-block .work-detail span {
    font-size: 16px;
    color: #6d6b6b;
    line-height: 16px;
    font-weight: 500;
}

.achievements-block {
    box-shadow: 0px 10px 25px #00000008;
    border-radius: 6px;
    background: #fff;
    padding: 30px;
    display: flex;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    -ms-border-radius: 6px;
    -o-border-radius: 6px;
    position: relative;
}
.achievements-block:not(:last-child) {
    border-bottom: 1px solid #f5f5f5;
}
.achievements-icon-block {
    padding: 0 55px 0 30px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-width: 185px;
    max-width: 185px;
    align-items: center;
    text-align: center;
    border-right: 1px solid #cecece;
    margin-right: 30px;
}
.achievements-icon-block .icon {
    width: 60px;
    height: 60px;
    background: #0b3454;
    border-radius: 50%;
    margin-bottom: 8px;
    position: relative;
}
.achievements-icon-block .icon.icon-medal:before {
    content: '';
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/exam_ico.svg);
    width: 26px;
    height: 36px;
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    top: 0;
    margin: auto;
}
.achievements-icon-block .icon.icon-grade:before {
    content: '';
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/exam_ico.svg);
    width: 25px;
    height: 31px;
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    top: 0;
    margin: auto;
}
.achievements-icon-block .icon.icon-publication:before, .achievements-icon-block .icon.icon-certificate:before {
    content: '';
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/publication_ico.svg);
    width: 29px;
    height: 31px;
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    top: 0;
    margin: auto;
}
.achievements-icon-block .icon.icon-promotion:before {
    content: '';
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/promotion_ico.svg);
    width: 32px;
    height: 37px;
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    top: 0;
    margin: auto;
}
.achievements-icon-block .icon.icon-course-completion:before {
    content: '';
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/course_ico.svg);
    width: 31px;
    height: 37px;
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    top: 0;
    margin: auto;
}
.achievements-icon-block .icon.icon-social-service:before {
    content: '';
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/social_ico.svg);
    width: 36px;
    height: 36px;
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    top: 0;
    margin: auto;
}
.achievements-icon-block .icon.icon-scholarship:before {
    content: '';
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/scholarship_ico.svg);
    width: 39px;
    height: 28px;
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    top: 0;
    margin: auto;
}
.achievements-icon-block .icon.icon-others:before {
    content: '';
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/others_ico.svg);
    width: 32px;
    height: 32px;
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    top: 0;
    margin: auto;
}
.achievements-icon-block .achievements-title {
    font-size: 18px;
    font-weight: 600;
}
.achievements-icon-block .achievements-year {
    font-size: 18px;
    line-height: 22px;
    color: #414141;
}
.achievements-block-detail h3 {
    font-size: 22px;
    font-weight: 400;
    margin-bottom: 0px;
}
.achievements-block-detail h3 span {
    font-weight: 600;
}
.achievements-block-detail p {
    font-size: 16px;
    line-height: 24px;
    margin: 0;
}
.achievements-block-detail {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
}
.hide {
    display: none;
}
.achievements-block-detail p.show .hide {
    display: inline;
}
.achievements-block-detail p.show .btn-readmore {
    font-size: 0;
}
.achievements-block-detail p.show .btn-readmore:before {
    content: 'Read Less';
    font-size: 16px;
}
.achievements-block-detail p .btn-readmore {
    color: #1452ce;
    transition: all 0.3s ease-in-out;
}
.achievements-block-detail p .btn-readmore:hover {
    color: #1046b3;
}
.achievements-block-detail .url-link {
    color: #1452ce;
    transition: all 0.3s ease-in-out;
}
.achievements-block-detail .url-link:hover {
    color: #1046b3;
}

.achievements-list {
    box-shadow: 0px 10px 25px #00000008;
    border-radius: 6px;
    background: #fff;
}
.achievements-block-title {
    padding: 20px 40px;
    border-bottom: 1px solid #f5f5f5;
    border-radius: 6px 6px 0 0;
}
.achievements-block-title .title {
    font-size: 22px;
}
.achievements-block-title .title span {
    font-weight: 600;
}

.btn-add-section {
    background: #ffffff;
    border: 1px solid #0b3454;
    border-radius: 19px;
    height: 37px;
    display: flex;
    padding: 0 20px;
    align-items: center;
    text-decoration: none;
    font-weight: 500;
    font-size: 14px;
    color: #0b3454;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.btn-add-section i {
    position: relative;
    width: 11px;
    height: 110px;
    margin-right: 10px;
}
.btn-add-section i:before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    background: #0b3454;
    width: 2px;
    height: 10px;
}
.btn-add-section i:after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    background: #0b3454;
    width: 10px;
    height: 2px;
}
.btn-add-section:hover {
    background: #0b3454;
    color: #fff;
}
.btn-add-section:hover i:before,
.btn-add-section:hover i:after {
    background: #fff;
}

.contributions-block {
    box-shadow: 0px 10px 25px #00000008;
    border-radius: 6px;
    background: #fff;
    padding: 40px;
}
.contributions-block:not(:last-child) {
    margin-bottom: 20px;
}
.contributions-block .act_lst:not(:last-child) {
    margin-bottom: 20px;
}
.contributions-block .seactionheader {
    margin: -10px 0 20px;
}
.contributions-block h3 {
    font-size: 22px;
    font-weight: 600;
}
.contributions-block .circle-effect::before {
    background: #6c8598;
}
.circle-effect::before {
    position: absolute;
    content: '';
    left: 0;
    top: 0;
    bottom: 0;
    width: 0;
    background: #08273f;
    transition: all 0.3s ease-in-out;
    right: 0;
    width: 0;
    height: 0;
    margin: auto;
    border-radius: 50%;
}
.circle-effect:hover::before {
    width: 100%;
    transition: all 0.3s ease-in-out;
    height: 100%;
}
.contributions-block .list_badge {
    color: #d52941;
    background: no-repeat;
    position: static;
    text-transform: uppercase;
}
.contributions-block .act_lst {
    padding: 25px 25px 25px 25px;
}
.contributions-block .video_block_name label {
    font-size: 16px;
}

.act_lst {
    border: 1px solid #d2d2d2;
    padding: 40px 25px 25px 25px;
    border-radius: 6px;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    -ms-border-radius: 6px;
    -o-border-radius: 6px;
}
.act_lst > .row > div:last-child {
    width: 255px;
}
.act_lst > .row.postedrow > div:last-child,
.act_lst.actlst_listed > .row > div:last-child {
    width: 150px;
}
.list_badge {
    position: absolute;
    width: auto;
    height: 25px;
    line-height: 25px;
    color: #fff;
    background: #d42941;
    text-align: center;
    border-radius: 6px 0px 10px 0px;
    left: 0;
    top: 0;
    -webkit-border-radius: 6px 0px 10px 0px;
    -moz-border-radius: 6px 0px 10px 0px;
    -ms-border-radius: 6px 0px 10px 0px;
    -o-border-radius: 6px 0px 10px 0px;
    padding: 0 10px;
}
.exp_loc > a.btn {
    display: inline-block;
    border: 1px solid #dedede;
    height: 32px;
    line-height: 32px;
    padding: 0 16px;
    border-radius: 18px;
    font-size: 14px;
    font-weight: 500;
    color: #0b3454;
    margin-bottom: 10px;
    background: #fff;
    overflow: hidden;
    -webkit-border-radius: 18px;
    -moz-border-radius: 18px;
    -ms-border-radius: 18px;
    -o-border-radius: 18px;
}
.exp_loc > a.btn:not(:last-child) {
    margin-right: 5px;
}
.exp_loc > a .btn > img {
    margin: -3px 8px 0 0;
}
.exp_loc > a.btn > span.icon,
.exp_loc > a.btn > img {
    margin: -3px 8px 0 0;
}
.person_detls {
    margin-top: 10px;
}

.listblk_icon {
    position: relative;
    border: 1px solid #dedede;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
}
.listblk_icon > span.icon,
.album_shareblk > a.btn.btnicon span.icon {
    color: rgba(11, 52, 84, 0.4);
    margin: 0;
}
.act_lst > .row > div:last-child .btn-green {
    width: 150px;
}
.act_lst .btn-green {
    padding: 0 20px;
}

.seactionheader {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
    flex-wrap: wrap;
}
.countnbtn {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.seactionheader h3 {
    font-size: 24px;
    margin: 0;
}
.countnbtn .count {
    margin-right: 20px;
    font-style: italic;
    font-size: 14px;
    color: #0b3454;
}
.custom-btns a {
    display: inline-block;
    color: #0b3454;
    text-decoration: none;
}
.custom-btns a:hover {
    color: #d42941;
}

.album_imgblk img {
    width: 100%;
    height: auto;
}
.album_blk {
    border: 1px solid #d2d2d2;
    border-radius: 6px;
}
.album_badge {
    background: #d42941;
    padding: 0 20px;
    height: 32px;
    line-height: 32px;
    border-radius: 6px 0 15px 0;
}
.album_imgblk {
    border-radius: 6px 6px 0 0;
    overflow: hidden;
}
.album_contblk {
    background: #fff;
    border-radius: 6px;
    width: calc(100% - 20px);
    margin: -40px auto 0;
    position: relative;
    padding: 20px 20px 15px;
}

.album_shareblk > span,
.album_shareblk > a.btn.btnicon {
    width: 40px;
    display: flex;
    height: 40px;
    line-height: 38px;
    border: 1px solid #dedede;
    border-radius: 50%;
    justify-content: center;
    align-items: center;
    padding: 0;
}
.album_shareblk > span:not(:last-child),
.album_shareblk > a.btn:not(:last-child) {
    margin: 0 0 5px;
}
.albumblk_footer {
    background: #f2f9ff;
    padding: 13px 30px;
    border-radius: 0 0 6px 6px;
}
.albumblk_footer img {
    margin: 0 6px 0 0;
}
.album_blk_parent {
    margin: 0 0 20px 0;
}
.album_imgvdo {
    right: 10px;
    top: 10px;
}
.image_tn {
    margin: 0 0 5px 0;
}
.image_tn > a {
    width: 63px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 16px;
    color: #e1e1e1;
    font-size: 13px;
    text-decoration: none;
}
.image_tn > a img.gallicon {
    width: 14px;
    height: auto;
    margin: 0 3px 0 0;
}
img.custimg {
    width: auto;
    display: block;
    margin: 0 auto;
}
.custom_litezoom:before {
    content: '';
    position: absolute;
    top: 100%;
    left: 10px;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 6px solid #fff;
}
.album_imgvdo {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
}
.image_tn:first-child {
    margin-right: 5px;
}
.image_tn {
    margin-bottom: 3px;
}
.table-responsive.attendee_dtl td .custom_litezoom a {
    font-size: 14px;
    font-weight: 400;
    line-height: 25px;
    text-decoration: none !important;
    color: #000;
    font-weight: 500;
    display: flex;
    align-items: center;
    border: 1px solid #cecece;
    border-radius: 26px;
    -webkit-border-radius: 26px;
    -moz-border-radius: 26px;
    -ms-border-radius: 26px;
    -o-border-radius: 26px;
    padding: 0 10px;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    width: auto;
    background: none;
}
.custom_litezoom a:hover {
    color: #0b3454;
}
.table-responsive.attendee_dtl td .custom_litezoom a .icon-phone {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/image.svg) no-repeat 0 0;
    width: 16px;
    height: 15px;
    margin-right: 7px;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.table-responsive.attendee_dtl td .custom_litezoom a .icon-video {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/video-camera.svg) no-repeat 0 0;
    width: 16px;
    height: 9px;
    margin-right: 7px;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.custom_litezoom a:hover {
    background: #0c9ccc;
    border-color: #0c9ccc;
    color: #fff;
}
.custom_litezoom a:hover i {
    filter: brightness(0) invert(1);
    -webkit-filter: brightness(0) invert(1);
}

.skills-block {
    box-shadow: 0px 10px 25px #00000008;
    border-radius: 6px;
    background: #fff;
    padding: 40px;
    position: relative;
}
.skills-block:first-child {
    padding-bottom: 20px;
}
.skills-block.EntranceExam-skills-block {
    padding-bottom: 33px;
}
.skills-block:not(:last-child) {
    margin-bottom: 20px;
}
.skills-block h2 {
    font-size: 22px;
    font-weight: 400;
    margin-bottom: 15px;
    margin: -10px 0 25px;
}
.skills-block h2 span {
    font-weight: 600;
}
.skills-block-detail {
    display: flex;
    flex-wrap: wrap;
}
.skills-block-detail .meter {
    margin: 0 12px 20px 0;
    border: 1px solid #c7c7c7;
    padding: 10px 30px;
    border-radius: 50px;
    font-size: 20px;
    font-weight: 500;
    align-items: center;
    height: 55px;
}
.skills-block-detail .meter img {
    width: 50px;
}
.skills-block-title {
    margin-top: -30px;
    margin-bottom: 20px;
}

.preferences-block {
    box-shadow: 0px 10px 25px #00000008;
    border-radius: 6px;
    background: #fff;
    padding: 40px;
}
.preferences-block:not(:last-child) {
    margin-bottom: 20px;
}
.preferences-block.EntranceExam-skills-block {
    padding-bottom: 33px;
}
.preferences-block h2 {
    font-size: 22px;
    font-weight: 400;
    margin-bottom: 15px;
    margin: -10px 0 25px;
}
.preferences-block h2 span {
    font-weight: 600;
}
.preferences-block-detail {
    display: flex;
    flex-wrap: wrap;
}
.preferences-block-detail .meter {
    margin: 0 12px 20px 0;
    border: 1px solid #c7c7c7;
    padding: 10px 30px;
    border-radius: 50px;
    font-size: 20px;
    font-weight: 500;
    align-items: center;
}
.preferences-block-detail .meter img {
    width: 50px;
}
.preferences-block-title {
    margin-top: -30px;
    margin-bottom: 20px;
}

.interested-block .icon {
    width: 55px;
    height: 55px;
    border-radius: 50%;
    background: #0b3454;
    position: relative;
    margin-right: 20px;
}
.interested-block .icon.icon-bulb::before {
    content: '';
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/bulb.svg) no-repeat 0 0 / 34px auto;
    width: 34px;
    height: 36px;
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    top: 0;
    margin: auto;
}
.interested-block .icon.icon-note::before {
    content: '';
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/publication_ico.svg);
    width: 29px;
    height: 31px;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
}
.interested-block {
    display: flex;
    align-items: center;
}
.interested-block .interested-topics {
    font-size: 20px;
    flex: 1 1;
    line-height: 22px;
}
.interested-block .interested-topics span {
    font-weight: 500;
}
.meter {
    background: #ffffff;
    border: 1px solid #dedede;
    border-radius: 18px;
    opacity: 1;
    padding: 5px 15px;
    transition: all 0.3s ease-in-out;
    margin-right: 5px;
    letter-spacing: 0.32px;
}
.meter:hover {
    box-shadow: 0px 0px 20px #00000033;
}
.meter:not(:last-child) {
    margin-bottom: 5px;
}
.graduationslider .meter {
    padding: 10px 30px;
    display: inline-flex;
    flex-wrap: wrap;
    align-items: center;
    border-radius: 50px;
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 10px;
}

.profile-item {
    text-align: center;
    width: 196px;
    height: 210px;
    display: flex;
    flex-direction: column;
    padding-top: 10px;
}
.owl-item:not(:last-child) .profile-item {
    border-right: 1px solid #d2d2d2;
}
.profile-item-img {
    text-align: center;
    display: flex;
    justify-content: center;
    margin-bottom: 11px;
}
.profile-item-name-class h3 {
    font-size: 16px;
    font-weight: 600;
    margin: 0 0 4px;
}
.profile-item-name-class p {
    margin: 0 0 11px;
    font-size: 14px;
    font-style: italic;
    color: #535353;
}
.profile-item-name-class .subject {
    color: #0b3454;
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    position: relative;
    padding-top: 10px;
}
.profile-item-name-class .subject:before {
    content: '';
    width: 30px;
    height: 2px;
    background: #5cae48;
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    top: 0;
}
.profile-item-name-class .btn-viewcompus {
    font-size: 13px;
    color: #1452ce;
    font-weight: 500;
    line-height: 18px;
    position: relative;
    z-index: 2;
    text-decoration: none;
}
.profile-item-name-class .btn-viewcompus:hover {
    color: #0b3454;
    text-decoration: underline;
}

.psychology-item {
    text-align: center;
    width: 245px;
    height: 196px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-top: 10px;
}
.owl-item:not(:last-child) .psychology-item {
    border-right: 1px solid #d2d2d2;
}
.popularCollegesslider .owl-item.active + .owl-item.active + .owl-item.active + .owl-item.active .psychology-item {
    border-right: 0px solid #d2d2d2;
}
.psychology-item-img {
    text-align: center;
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
    height: 90px;
    align-items: center;
}
.psychology-item-name h3 {
    font-size: 16px;
    font-weight: 600;
    margin: 0 0 5px;
    line-height: 17px;
}
.psychology-item-name p {
    font-size: 14px;
    font-style: italic;
    font-weight: 500;
    line-height: 20px;
}

.alumni_directory_details .btn-working {
    font-size: 13px;
    color: #1452ce;
    font-weight: 500;
    line-height: 18px;
    position: relative;
    z-index: 2;
    text-decoration: none;
}
.alumni_directory_details .btn-working:hover {
    color: #0b3454;
    text-decoration: underline;
}

.tooltip-viewcompus .tooltip-inner {
    background: #3b3b3b;
    border-color: #3b3b3b;
}
.tooltip-working .tooltip-inner {
    display: flex;
    flex-direction: column;
    padding: 15px;
    background: #3b3b3b;
    border-color: #3b3b3b;
}
.tooltip-working .tooltip-inner .logo {
    position: relative;
    font-size: 20px;
}
.tooltip-working .tooltip-inner span.logo + span {
    font-size: 16px;
}
.tooltip-working.bs-tooltip-top .tooltip-arrow::before {
    border-top-color: #3b3b3b;
}
.tooltip-working.bs-tooltip-bottom .tooltip-arrow::before {
    border-bottom-color: #3b3b3b;
}
.tooltip-working.bs-tooltip-end .tooltip-arrow::before {
    border-right-color: #3b3b3b;
}
.tooltip-working.bs-tooltip-start .tooltip-arrow::before {
    border-left-color: #3b3b3b;
}

.alumni_name_brife > div {
    align-items: center;
}
.alumni_name_brife > div .sep {
    margin: 0 6px;
    color: #1452ce;
}

.custom_badge {
    display: inline-block;
    border: 1px solid #dedede;
    height: 32px;
    line-height: 32px;
    padding: 0 16px;
    border-radius: 18px;
    font-size: 14px;
    font-weight: 500;
    color: #0b3454;
    margin: 0 5px 10px 0;
    background: #fff;
    overflow: hidden;
}
.custom_badge .icon {
    margin-right: 5px;
}

.delete_confirm .icon-cross {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 1px solid red;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #e94e58;
}
.delete_confirm .del_text {
    margin: 20px 0 10px;
    text-align: center;
    max-width: 240px;
    font-size: 28px;
    line-height: 36px;
    font-weight: 500;
    width: 100%;
}
.delete_confirm .btn-delete {
    background: #d52941;
    border-radius: 31px;
    border: 0;
    height: 36px;
    color: #fff;
    padding: 0 20px;
    font-weight: 600;
    font-size: 14px;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.delete_confirm .btn-delete:hover {
    background: #a0182b;
}

.selected_options ul {
    display: flex;
    list-style: none;
    margin: 0;
    padding: 0;
}
.selected_options ul li {
    background: #f7fbff;
    border: 1px solid #0b34544d;
    border-radius: 18px;
    height: 35px;
    display: flex;
    align-items: center;
    padding: 0 18px;
    margin: 12px 12px 6px 0;
    font-size: 16px;
    font-weight: 500;
}
.selected_options ul li .icon-cross {
    font-size: 9px;
    margin: 2px 0 0 10px;
    text-decoration: none;
    color: #000;
}
.selected_options ul li .icon-cross:hover {
    text-decoration: none;
    color: #333;
}

.question .form-select.w-90 {
    width: 90px !important;
    max-width: 90px;
}

.custom_row_title {
    margin-bottom: 10px;
    font-weight: 400;
    font-size: 20px;
}
.custom_row_title span {
    font-weight: 600;
}
.custom_row_block .program {
    font-size: 20px;
}
.custom_row_block .program span {
    font-weight: 500;
}
.program-time-interest {
    color: #414141;
    font-size: 16px;
    line-height: 20px;
}
.custom_row_block {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
}
.custom_row_block .icon {
    width: 55px;
    height: 55px;
    border-radius: 50%;
    background: #0b3454;
    margin-right: 15px;
    position: relative;
}
.custom_row_block .icon.icon-hat:before {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/hat_alumni.svg) no-repeat 0 0 /26px;
    width: 26px;
    height: 20px;
    display: inline-block;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    position: absolute;
    filter: invert(1);
    -webkit-filter: invert(1);
}
.custom_row_block .icon + div {
    width: calc(100% - 70px);
}
.custom_row {
    width: 100%;
    border-top: 1px solid #dbdbdb;
    padding-top: 20px;
}
.custom_row:not(:last-child) {
    padding-bottom: 20px;
}

.radius_block {
    background: #ffffff;
    border: 1px solid #c7c7c7;
    border-radius: 30px;
    height: 60px;
    padding: 0 30px;
    display: flex;
    align-items: center;
    font-size: 20px;
    line-height: 20px;
    font-weight: 500;
}
.radius_block span {
    margin-right: 30px;
}
.radius_block i {
    font-size: 24px;
}
.radius_block i.gray {
    color: #8599a9;
}
.radius_block i.green {
    color: #5dae48;
}

.radius_block.yes {
    background: #5dae48;
    border-color: #5dae48;
    color: #fff;
}
.radius_block.yes span {
    margin: 0 20px;
}

.radius_block.no {
    background: #c7c7c7;
    color: #333;
}
.radius_block.no span {
    margin: 0 20px;
}

.universities_block {
    background: #ffffff;
    border: 1px solid #c7c7c7;
    border-radius: 30px;
    height: 60px;
    padding: 0 8px;
    display: flex;
    align-items: center;
    font-size: 20px;
    line-height: 26px;
    font-weight: 500;
    -webkit-border-radius: 30px;
    -moz-border-radius: 30px;
    -ms-border-radius: 30px;
    -o-border-radius: 30px;
}
.universities_block .logo {
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 15px;
    border-radius: 50%;
    overflow: hidden;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    -ms-border-radius: 50%;
    -o-border-radius: 50%;
    border: 1px solid #ccc;
}
.universities_block .logo img {
	width: auto;
	height: 100%;
}
.universities_block span {
    font-size: 20px;
    margin-right: 15px;
    line-height: 20px;
}
.logo.no_logo {
    width: 40px;
    border: 1px solid #cad6df;
}
.edit_section {
    font-size: 0;
}
.edit_section_toggle,
.custom-btns a.edit_section_toggle {
    display: none;
    width: 20px;
    height: 20px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
    background-repeat: no-repeat;
    background-position: center;
    background-size: 20px 20px;
}

.video_block {
    background: #ffffff;
    border: 1px solid #d2d2d2;
    border-radius: 6px;
    overflow: hidden;
    text-decoration: none;
    position: relative;
    display: inline-block;
    color: #000;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.icon-invert-play {
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.video_block:hover,
.video_block:hover .icon-invert-play {
    color: #5cae48;
}
.video_block_name {
    background: #ffffff;
    border-radius: 6px 6px 0px 0px;
    opacity: 1;
    display: flex;
    justify-content: space-between;
    padding: 0px 20px;
    margin: -26px 11px 0;
    position: relative;
    align-items: center;
    height: 78px;
}
.video_block:hover .video_block_img img {
    transform: scale(1.1);
}
.video_block_img {
    overflow: hidden;
    display: inline-block;
}
.video_block_img img {
    border-radius: 6px 6px 0 0;
    transition: all 0.5s ease-in-out;
}
.video_block_name .icon-invert-play {
    font-size: 30px;
    color: #0b3454;
}
.video_block_name label {
    font-size: 18px;
    font-weight: 600;
    margin-right: 15px;
    line-height: 22px;
}
.video_block .video-btn {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
}
#video_pop button.btn-close {
    position: absolute;
    top: 10px;
    right: 10px;
    background-color: #fff !important;
    opacity: 1;
    z-index: 999;
    background-size: 40%;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    padding: 0;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
#video_pop button.btn-close:hover {
    background-color: #5cae48 !important;
}
#video_pop button.btn-close span {
    display: none;
}

.half-gray {
    position: relative;
}
.half-gray:before {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    top: 0;
    width: 50.5%;
    background: #f3f3f3;
    border-radius: 6px 0px 0px 6px;
}
.half-gray > div {
    position: relative;
}

.messages {
    flex: 1 1;
    display: flex;
    flex-direction: column;
}
.leftUser {
    align-items: end;
}
.leftUser p {
    background: #2296c9;
    border-radius: 10px 10px 0px 10px;
    padding: 7px 20px;
    color: #fff;
    margin-bottom: 10px;
}
.rightUser {
    align-items: start;
}
.rightUser p {
    background: #413a7d;
    border-radius: 10px 10px 10px 0px;
    opacity: 1;
    padding: 7px 20px;
    color: #fff;
    margin-bottom: 10px;
}
.conversation .userimg {
    display: flex;
    align-items: start;
    vertical-align: top;
}
.conversation {
    height: 310px;
    overflow-y: scroll;
    overflow-x: hidden;
    margin-right: -8px;
}

.conversation {
    overflow-y: scroll;
    scrollbar-width: thin;
}
.conversation::-webkit-scrollbar {
    width: 4px;
}
.conversation::-webkit-scrollbar-track {
    background: #f1f1f1;
}
.conversation::-webkit-scrollbar-thumb {
    background: #888;
}
.conversation::-webkit-scrollbar-thumb:hover {
    background: #555;
}

@media (max-width: 1199px) {
    .alumni_profile_name_college_other_detail_wrap.directory-detail .alumni_profile_image_name_other_detail {
        padding-right: 30px;
    }
    .alumni_profile_name_college_other_detail_wrap.directory-detail .alumni_profile_college_name_other_detail_wrap {
        padding-left: 30px;
    }
    .alumni_profile_name_college_other_detail_wrap.directory-detail
        .alumni_profile_college_name_other_detail_wrap
        .alumni_profile_college_name_other_detail {
        flex-direction: column;
    }
    .alumni_profile_name_college_other_detail_wrap.directory-detail
        .alumni_profile_college_name_other_detail_wrap
        .alumni_profile_college_name_other_detail
        .alumni_profile_college_name_detail {
        padding: 0 0 20px;
    }
    .alumni_profile_name_college_other_detail_wrap.directory-detail
        .alumni_profile_college_name_other_detail_wrap
        .alumni_profile_college_name_other_detail
        .alumni_profile_other_detail {
        width: 100%;
    }
    .alumni_profile_name_college_other_detail_wrap.directory-detail
        .alumni_profile_college_name_other_detail_wrap
        .alumni_profile_college_name_other_detail
        .alumni_profile_other_detail
        .alumni_profile_status {
        display: flex;
        -webkit-box-wrap: wrap;
        -moz-box-wrap: wrap;
        -ms-flex-wrap: wrap;
        -webkit-wrap: wrap;
        flex-wrap: wrap;
    }
    .alumni_profile_name_college_other_detail_wrap.directory-detail
        .alumni_profile_college_name_other_detail_wrap
        .alumni_profile_college_name_other_detail
        .alumni_profile_other_detail
        .alumni_profile_status
        li {
        width: 100%;
    }
    .alumni_profile_name_college_other_detail_wrap.directory-detail
        .alumni_profile_college_name_other_detail_wrap
        .alumni_profile_college_name_other_detail
        .alumni_profile_other_detail
        .alumni_profile_status
        li
        p {
        margin: 0;
    }
}

@media (max-width: 1150px) {
    .aldir_scroll {
        width: 100%;
        overflow-x: auto;
        scrollbar-width: thin;
    }
    .aldir_scroll::-webkit-scrollbar {
        height: 4px;
    }
    .aldir_scroll::-moz-scrollbar {
        height: 4px;
    }
    .aldir_scroll::-webkit-scrollbar-track {
        background: #e372848f;
    }
    .aldir_scroll::-webkit-scrollbar-thumb {
        background-color: #ccc;
        border-radius: 20px;
        border: 2px solid #810d20;
    }
}

@media (max-width: 1130px) {
    .alumni_profile_brife_tab {
        overflow: auto;
        scrollbar-width: thin;
        padding-bottom: 10px;
        margin-bottom: 10px;
    }
    .alumni_profile_brife_tab::-webkit-scrollbar {
        height: 4px;
    }
    .alumni_profile_brife_tab::-moz-scrollbar {
        height: 4px;
    }
    .alumni_profile_brife_tab::-webkit-scrollbar-track {
        background: #ccc;
    }
    .alumni_profile_brife_tab::-webkit-scrollbar-thumb {
        background-color: #666;
        border-radius: 20px;
        border: 2px solid #666;
    }
    .alumni_profile_brife_tab .nav {
        justify-content: start;
        flex-wrap: nowrap;
    }
}

@media (max-width: 991px) {
    .alumni-directorySearch {
        width: 230px;
    }
}

@media (max-width: 875px) {
    .graduateRow {
        flex-direction: column;
    }
    .graduateRow .college_detail_wrap {
        width: 100%;
    }
    .graduateRow .offer {
        width: 100%;
    }
    .college_name_scholarship {
        flex-direction: row;
        align-items: start;
    }
    .graduateRow .college_detail_wrap {
        width: 100%;
        padding: 0 0 20px;
        margin-bottom: 20px;
    }
    .graduateRow .college_detail_wrap::after {
        top: auto;
        right: 0;
        width: 75px;
        height: 2px;
        bottom: 0;
    }
    .graduateRow .offer {
        padding: 0;
        align-items: start;
    }
    .graduateRow .college_detail_wrap::after {
        right: auto;
        bottom: 0;
        left: 0;
    }

    .graduateRow.edit .college_detail_wrap {
        width: 100%;
    }
    .graduateRow .offer.offer_edit {
        flex-direction: row;
        align-items: center;
        width: 100%;
        justify-content: start;
    }
    .graduateRow .offer .offer_existing_links {
        align-items: start;
    }
}

@media (max-width: 820px) {
    .graduation_carousel_wrap {
        padding: 20px;
    }
    .graduationslider .meter {
        padding: 10px 15px;
        margin: 15px 0 10px 0px;
        font-size: 16px;
    }
    .postGraduate-detail {
        padding: 0;
        background: none;
        box-shadow: none;
        border: 1px solid #d2d2d2;
        overflow: hidden;
    }
    .postGraduate-detail .graduateRow {
        padding: 20px;
        background: #fff;
    }
    .graduation-title {
        margin: 0;
        background: #eff8ff;
        border-radius: 6px 6px 0px 0px;
        padding: 20px;
        text-align: center;
        line-height: 22px;
    }
    .graduation_carousel_wrap .seactionheader {
        margin: 0 0 15px;
        flex-direction: column;
        align-items: inherit;
    }
    .graduation_carousel_wrap .seactionheader .countnbtn {
        width: 100%;
        margin-top: 13px;
        justify-content: space-between;
    }
    .graduation_carousel_wrap .seactionheader h3 {
        width: auto;
        margin: -20px -20px 0;
        background: #eff8ff;
        border-radius: 6px 6px 0px 0px;
        padding: 20px;
        text-align: center;
        line-height: 22px;
    }
    .workExperience-detail .workExperience-title {
        width: auto;
        margin: 0;
        background: #eff8ff;
        border-radius: 6px 6px 0px 0px;
        padding: 20px;
        text-align: center;
        line-height: 22px;
    }
    .workExperience-detail {
        padding: 0px;
        overflow: hidden;
    }
    .workExperienceRow {
        padding: 25px;
    }
    .skills-block-title {
        margin: 0 0 20px;
        width: auto;
        margin: -40px -40px 20px;
        background: #eff8ff;
        border-radius: 6px 6px 0px 0px;
        padding: 20px;
        text-align: center;
        line-height: 22px;
    }
    .skills-block-title h2 {
        background: no-repeat;
        padding: 0;
        text-align: left;
    }
    .preferences-block {
        padding: 30px;
    }
    .preferences-block-title {
        width: auto;
        margin: -30px -30px 0px;
        background: #eff8ff;
        border-radius: 6px 6px 0px 0px;
        padding: 20px;
        line-height: 22px;
    }
    .custom_row:first-child {
        border: 0;
    }
    .achievements-block-title {
        background: #eff8ff;
    }
    .underGraduate-detail .main_title,
    .blockHeader {
        background: #eff8ff;
    }
    .graduateRow {
        background: #fff;
    }
    .postGraduate-detail .blockHeader {
        margin: 0;
    }
    .workExperience-detail .blockHeader {
        margin: 0;
    }
}

@media (min-width: 767px) and (max-width: 1099px) {
    .alumni_directory_filter .fiterItem.w-20 {
        width: calc(33.33% - 10px);
    }
    .alumni_directory_filter .fiterItem.w-40 {
        width: calc(50% - 10px);
    }
    .alumni_directory_filter #additionalfilter .fiterItem.w-20 {
        width: calc(33.3% - 10px);
    }
    .alumni_directory_filter .fiterItem.width-25 {
        width: calc(33.3% - 10px);
    }
    .alumni_directory_filter .fiterItem.width-50 {
        width: calc(50% - 10px);
    }
    .alumni_directory_filter #additionalfilter .fiterItem.w-40 {
        width: calc(33.3% - 10px);
    }
}

@media (max-width: 767px) {
    .filters {
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        width: 100%;
        bottom: 0;
        background: #fff;
        z-index: 99;
        max-width: 100%;
        overflow-x: scroll;
        padding: 40px 20px;
        display: block !important;
        transform: translate3d(0, 0, 0);
        transition: all 0.3s ease-in-out;
        height: 100%;
    }
    .filters.show {
        transform: translate3d(0, -100%, 0);
        transition: all 0.3s ease-in-out;
    }
    .filters .btn-filter {
        position: absolute;
        right: 25px;
        font-size: 0;
        background: none;
        border: 0;
        width: 20px;
        height: 20px;
        top: 25px;
    }
    .filters .btn-filter::before {
        transform: translateY(10px) rotate(135deg);
        -moz-transform: translateY(10px) rotate(135deg);
        -webkit-transform: translateY(-5px) rotate(135deg);
        transition: all 0.3s ease-in-out;
        width: 18px;
        height: 2px;
        content: '';
        background: #000;
        position: absolute;
        border-radius: 5px;
    }
    .filters .btn-filter::after {
        transform: translateY(-5px) rotate(-135deg);
        -moz-transform: translateY(-5px) rotate(-135deg);
        -webkit-transform: translateY(-5px) rotate(-135deg);
        transition: all 0.3s ease-in-out;
        width: 18px;
        height: 2px;
        content: '';
        background: #000;
        position: absolute;
        border-radius: 5px;
    }
    .filters #accordionFilters {
        margin-bottom: 30px;
    }
    .filters > h3 {
        display: flex !important;
        align-items: center;
        justify-content: space-between;
    }
    /* .mobileFilter .btn-filter {border: 0;background: url(../images/filter.svg) no-repeat center right;padding-right: 0px;padding-left: 0;cursor: pointer;} */
    .mobileFilter .btn-filter {
        border: 0;
        padding-right: 0px;
        padding-left: 0;
        cursor: pointer;
    }
    .filters {
        max-width: 100%;
        width: 100%;
    }
    .ji_filtersec {
        max-width: unset;
    }
    
    .alumni_directory_filter {
        padding: 18px 0;
        padding-right: var(--bs-gutter-x, 0.75rem);
        padding-left: var(--bs-gutter-x, 0.75rem);
    }
    body[style*='overflow: hidden'] .alumni_directory_filter{display: none;}
    .alumni-directory-header_search {
        flex-direction: column;
        align-items: start;
    }
    .alumni-directory-header_search:has(.alumni-reset-wrap){
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
    }
    .alumni-directory-header_search h2 {
        margin-bottom: 15px !important;
    }
    .alumni-directory-header {
        align-items: end;
    }
    .filter_result_title {
        flex-direction: column;
    }
    .filter_result_title .filter_result {
        display: none;
    }
    .alumni_count {
        text-align: right;
        margin: 0;
    }
    .alumni_directory_filter .fiterItem {
        width: 170px !important;
        margin: 0 !important;
        box-shadow: none;
        border: 0;
        border-radius: 0;
        border-bottom: 1px solid #e6e6e6 !important;
    }
    .alumni_directory_filter .filters {
        padding: 0;
        display: flex !important;
        flex-direction: column;
    }
    .alumni_directory_filter .filters > div:first-child {
        padding: 15px 20px;
        border-bottom: 1px solid #dbdbdb;
    }
    .alumni_directory_filter .filters-head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: auto;
        padding: 0 15px;
        box-shadow: 0px 0px 3px 0px #ccc;
        position: relative;
        z-index: 1;
    }
    .alumni_directory_filter .filters-head + #accordionFilters {
        /* flex: 1 1; */
        height: calc(100% - 175px);
        position: relative;
        background: #f5f5f5;
    }
    .alumni_directory_filter .filters #accordionFilters {
        flex: 1 1;
        margin: 0;
        position: relative;
    }
    .alumni_directory_filter .filters #accordionFilters::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        width: 170px;
        background: #f5f5f5;
    }
    .alumni_directory_filter .filters > #accordionFilters > .filterGroup.mt-3 {
        margin: 0 !important;
        flex-direction: column;
        height: 100%;
        position: relative;
    }
    .filterItemWrap {
        display: none;
    }
    .additionalfilter_count {
        padding: 0;
        flex: none;
    }
    .alumni_directory_filter .filterHeader button .font-16.font-600 {
        font-size: 14px !important;
    }
    .alumni_directory_filter .fiterItem .filterHeader > div {
        border-radius: 0;
    }
    .alumni_directory_filter .fiterItem .filterHeader > div button {
        background: #f5f5f5;
        border-radius: 0;
        padding: 10px;
        color: #000;
    }
    .alumni_directory_filter .fiterItem .filterHeader > div button .toggle {
        display: none;
    }
    .alumni_directory_filter .fiterItem .filterHeader > div button .font-18.font-600 {
        font-size: 16px !important;
        font-weight: 500 !important;
    }
    .additionalfilter_wrap {
        width: 170px;
        padding: 0;
        margin: 0 !important;
    }
    .btn-additionalfilter {
        display: none;
    }
    .additionalfilter_wrap > #additionalfilter {
        display: block !important;
    }
    .alumni_directory_filter #additionalfilter .fiterItem,
    .alumni_directory_filter #additionalfilter .fiterItem.campus {
        width: 100%;
    }
    .additionalfilter_wrap>#additionalfilter .filterGroup {
        flex-wrap: nowrap;
        flex-direction: column;
    }
    .alumni_directory_filter .fiterItem .filterHeader + div {
        position: absolute;
        right: 0;
        top: 0;
        padding: 0;
        bottom: 0;
        width: calc(100% - 170px);
        padding: 15px;
        overflow: auto;
    }
    .alumni_directory_filter .filterGroup {
        margin: 0 !important;
    }
    .alumni_directory_filter .filterGroup.mt-3 {
        margin: 0 !important;flex-wrap: nowrap;overflow-y: auto;width: 170px;
    }
    .filter_close_apply {
        background: #ffffff;
        border-top: 1px solid #e9e9e9;
        padding: 15px 20px;
        justify-content: center;
        align-items: center;
    }
    .filter_close_apply > a.btn-filter-apply {
        padding: 8px 30px;
        background: #5cae48;
        border-radius: 3px;
        text-decoration: none;
        color: #fff;
        margin: 0 15px;
        font-weight: 500;
        text-transform: uppercase;
        transition: all 0.3s ease-in-out;
    }
    .filter_close_apply > a.btn-filter-apply:hover {
        background: #448e32;
        color: #fff;
    }
    .filter_close_apply > a.btn-filter-close {
        text-decoration: none;
        text-transform: uppercase;
        color: #979797;
        font-weight: 500;
        transition: all 0.3s ease-in-out;
        margin: 0 15px;
    }
    .filter_close_apply > a.btn-filter-close:hover {
        color: #666262;
    }
    .alumni_directory_filter .showProfiles_right {
        margin-left: 12px;
    }
    .alumni_directory_filter .filterSearchblk {
        background: #fff;
        padding: 0 0 10px;
    }
    .alumni_directory_filter .fiterItem .card {
        padding: 0px 0px 15px;
    }
    .alumni_directory_filter .fiterItem .filterHeader > div button[aria-expanded='true'] {
        pointer-events: none;
        color: #1452ce;
    }
    .alumni_directory_filter .scrollMe {
        max-height: initial;
        min-height: initial;
    }

    .alumni_directory_filter .mobileFilter .btn-filter .icon-filter + span {
        flex: 1 1;
        text-align: left;
    }
    .alumni_directory_filter .mobileFilter .btn-filter .icon-filter + span + span {
        display: flex;
        -webkit-box-wrap: wrap;
        -moz-box-wrap: wrap;
        -ms-flex-wrap: wrap;
        -webkit-wrap: wrap;
        flex-wrap: wrap;
        align-items: center;
        color: #b92940;
        font-size: 14px;
    }
    .alumni_directory_filter .mobileFilter .btn-filter {
        display: flex;
        align-items: center;
    }
    .alumni_directory_filter .mobileFilter .btn-filter .icon-filter + span + span .icon-right-arrow {
        font-size: 15px;
        transform: rotate(270deg);
        margin-left: 10px;
        color: #000;
        transition: all 0.3s ease-in-out;
    }
    .alumni_directory_filter .mobileFilter .btn-filter[aria-expanded='false'] .icon-right-arrow {
        transform: rotate(90deg) !important;
    }
    #filter_collapse h3 {
        pointer-events: none;
        margin: 20px 0 0 0;
    }
    .alumni_directory_filter {
        background: #f3f3f3;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 99;
        box-shadow: 0 0 5px 0px #cacaca;
    }
    .alumni_directory_filter .filters.show {
        transform: translate3d(0, 100%, 0);
    }
    .alumni_profile_image_name_other_detail {
        width: 100%;
        padding-bottom: 30px;
        margin-bottom: 30px;
    }
    .alumni_profile_college_name_other_detail_wrap .alumni_profile_college_name_other_detail {
        flex-direction: column;
    }
    .nolisting_wrap .nolisting {
        border: 0;
        padding: 20px 0 10px;
    }
    .nolisting_text {
        text-align: center;
        justify-content: center;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .edit_section {
        position: absolute;
        right: 20px;
        top: 5px;
    }
    .countnbtn .edit_section {
        position: relative;
        left: auto;
        right: auto;
        top: 0;
        margin-left: 5px;
    }
    .skills-block .edit_section {
        top: 22px;
    }
    .edit_section .edit_section_toggle {
        display: inline-block;
    }
    .custom-btns a.edit_section_toggle {
        display: inline-block;
    }
    .edit_section .edit_section_inner {
        position: absolute;
        top: 50px;
        right: 0;
        background: #fff;
        box-shadow: 0px 0px 5px #57555533;
        display: flex;
        flex-direction: column;
        width: 100px;
        border-radius: 6px;
        overflow: hidden;
        opacity: 0;
        z-index: -1;
        transition: all 0.3s ease-in-out;
        -webkit-transition: all 0.3s ease-in-out;
        -moz-transition: all 0.3s ease-in-out;
        -ms-transition: all 0.3s ease-in-out;
        -o-transition: all 0.3s ease-in-out;
    }
    .edit_section.open .edit_section_inner {
        top: 30px;
        opacity: 1;
        z-index: 9;
    }
    .edit_section .edit_section_inner a {
        width: 100% !important;
        border-radius: 0 !important;
        padding: 0 0 0 30px;
        font-size: 14px;
        text-decoration: none;
        color: #000;
        line-height: 33px;
        height: 35px !important;
        background: #fff !important;
        position: relative;
        opacity: 1;
        margin: 0 !important;
        -webkit-border-radius: 0 !important;
        -moz-border-radius: 0 !important;
        -ms-border-radius: 0 !important;
        -o-border-radius: 0 !important;
        opacity: 1 !important;
    }
    .edit_section .edit_section_inner a:hover {
        color: #fff;
        background-color: #0b3454 !important;
    }
    .edit_section .edit_section_inner a.edit_link:before {
        width: 16px;
        height: 16px;
        margin: 0;
        background-size: 14px;
        left: 7px;
        top: 8px;
    }
    .edit_section .edit_section_inner a:first-child {
        border-bottom: 1px solid #eee;
    }
    .edit_section .edit_section_inner a.del_link:before {
        content: '';
        background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/delete.svg) no-repeat center /
            14px auto;
        width: 14px;
        height: 16px;
        position: absolute;
        left: 8px;
        top: 8px;
    }
    .edit_section .edit_section_inner a.del_link:hover {
        background: #0b3454;
        color: #fff;
    }
    .edit_section .edit_section_inner a.del_link:hover:before {
        filter: invert(92%) sepia(100%) saturate(0%) hue-rotate(202deg) brightness(106%) contrast(106%);
        -webkit-filter: invert(92%) sepia(100%) saturate(0%) hue-rotate(202deg) brightness(106%) contrast(106%);
    }
    .graduateRow .college_detail_wrap .scholarship {
        margin-right: 60px;
    }
    .achievements-block-detail .edit_section {
        top: 4px;
        right: 0;
    }
    .achievements-block-detail {
        padding-right: 25px;
    }
    .postGraduate-detail .graduateRow .offer.offer_edit .edit_section {
        top: 20px;
    }
    .work-block .edit_section {
        right: 0;
    }
    .work-block .work-detail {
        padding-right: 24px;
    }

    .alumni_profile_name_college_other_detail_wrap.directory-detail .alumni_profile_image_name_other_detail {
        padding: 0;
        margin: 0;
        order: 1;
    }
    .alumni_profile_name_college_other_detail_wrap.directory-detail .alumni_profile_image_name_other_detail:after {
        opacity: 0;
    }
    .alumni_profile_name_college_other_detail_wrap.directory-detail .alumni_profile_college_name_other_detail_wrap {
        padding: 0;
        order: 3;
    }
    .alumni_profile_name_college_other_detail_wrap.directory-detail .alumni_profile_brife_links {
        order: 2;
        border-bottom: 1px solid #dbdbdbcc;
        margin-bottom: 30px;
        padding-bottom: 30px;
        flex-wrap: wrap;
    }
    .alumni_profile_brife_links > a {
        margin-bottom: 10px;
    }
}

@media (min-width: 575px) and (max-width: 767px) {
    .filter_result_title {
        flex-direction: column;
    }
    .alumni_count {
        text-align: right;
    }
    .alumni_class_link {
        flex-direction: column;
        align-items: start;
    }
    .alumni_class_link .send_link {
        padding: 0px 0 0 70px;
    }
    .alumni_name_detail {
        width: 100%;
    }
}

.alumni-reset-wrap .btn-white-border{height:40px}

@media (max-width: 575px) {
    .alumni-directory-header {
        flex-direction: column;
    }
    .alumni-directory-header_search {
        flex-direction: row;
        width: 100%;
        margin-bottom: 20px;
        justify-content: space-between;
        overflow: hidden;
        align-items: center;
    }
    .alumni-directory-header_search h2 {
        margin-bottom: 0 !important;
    }
    .alumni-directorySearch-wrap {
        position: relative;
    }
    .alumni-reset-wrap {display:none}
    .alumni-reset-wrap.show {display: block;position: absolute;top: 66px;right: 29px;}
    .alumni-reset-wrap .btn-white-border{height:auto}
    .alumni-directorySearch-wrap .alumni-directorySearch {
        position: absolute;
        right: -230px;
        transition: all 0.3s ease-in-out;
    }
    .alumni-directorySearch-wrap.show .alumni-directorySearch {
        right: 0;
    }
    .btn-alumniSearchToggle.icon-search {
        width: 40px;
        height: 40px;
        background: #fff;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        text-decoration: none;
        color: #000;
        font-size: 12px;
    }
    .alumni-directorySearch .form-control + .btn-cross {
        opacity: 1;
        right: 15px;
        transform: rotate(135deg);
    }
    .alumni-switch-container {
        margin: auto;
    }
    .alumni-directorySearch .form-control {
        padding-right: 40px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
    .alumni_profile_image_name_other_detail {
        padding: 0 0 20px;
        margin-bottom: 20px;
    }
    .alumni_profile_college_name_other_detail .alumni_profile_other_detail {
        margin: 0 0 0 -98px;
    }
    .alumni_profile_status li {
        width: 47%;
        margin-bottom: 0;
    }
    .alumni_profile_status li:last-child {
        margin-right: 0;
    }
    .alumni_profile_image_wrap{
        width: 80px;
        height: 80px;
    }
    .alumni_profile_image_wrap .pencil-edit {
        top: -5px;
        right: -5px;
    }
    .alumni_profile_image {
        width: 80px;
        height: 80px;
    }
    .alumni_profile_name_other_detail h2 {
        line-height: 30px;
        font-size: 24px;
        width: calc(100% - 50px);
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
    }
    .alumni_profile_college_name_other_detail_wrap .alumni_profile_college_logo {
        width: 80px;
        height: 80px;
    }
    .alumni_profile_brife {
        padding: 20px 0 10px;
    }
    /*.graduateRow .college_detail_wrap .college_detail {  flex-direction: column;align-items: center;}*/
    .graduateRow .college_detail_wrap .college_detail {
        padding-right: 0px;
        width: 100%;
    }
    .graduateRow {
        margin-left: -20px;
        margin-right: -20px;
        width: auto;
        padding: 5px 20px;
    }
    .graduateRow .college_detail_wrap .college_detail .college_logo {
        margin: 0 10px 10px 0;
        width: 70px;
        height: 70px;
        border-radius: 50%;
    }
    .graduateRow .college_name_scholarship {
        flex-direction: column;
        align-items: start;
        justify-content: start;
        text-align: left;
        width: calc(100% - 80px);
    }
    .graduateRow .college_name_scholarship .college_name {
        width: calc(100% - 20px);
    }
    .graduateRow .college_detail_wrap .college_detail h3 {
        font-size: 19px;
        line-height: 20px;
        word-break: break-word;
    }
    .alumni_profile_college_subject {
        padding: 0 15px;
        font-size: 15px;
    }
    .graduateRow .college_detail_wrap .scholarship {
        flex-direction: row;
    }
    .graduateRow .college_detail_wrap .scholarship .scholarship_label {
        margin-right: 7px;
    }
    .graduateRow .college_detail_wrap::after {
        right: 0;
        bottom: 0;
        left: 0;
        margin: auto;
        width: 100%;
        height: 1px;
    }
    .graduateRow .offer {
        align-items: center;
        flex-direction: row;
        justify-content: center;
    }
    .graduateRow:not(:last-child) {
        margin-bottom: 15px;
        padding-bottom: 20px;
    }
    .underGraduate-detail {
        padding: 20px;
        box-shadow: none;
    }
    .workExperience-detail {
        padding: 0px;
    }
    .workExperienceRow {
        padding: 20px 20px 30px;
    }

    .achievements-block {
        flex-direction: column;
        align-items: center;
    }
    .achievements-icon-block {
        border-right: 0;
        margin: 0 0 18px;
        padding: 0 0 18px;
        border-bottom: 1px solid #cecece;
    }
    .achievements-block-detail {
        text-align: center;
    }
    .achievements-block-detail h3 {
        margin: 0;
    }
    .contributions-block .seactionheader {
        margin: 0px 0 20px;
        flex-direction: column;
        align-items: inherit;
    }
    .contributions-block .seactionheader > h3 {
        width: auto;
        margin: -20px -20px 0;
        background: #eff8ff;
        border-radius: 6px 6px 0px 0px;
        padding: 20px;
        text-align: center;
        line-height: 22px;
    }
    .contributions-block .seactionheader .countnbtn {
        width: 100%;
        margin-top: 10px;
        align-items: center;
        justify-content: space-between;
        position: relative;
    }
    .contributions-block .seactionheader .countnbtn .custom-btns {
        padding-right: 0;
    }
    .contributions-block .seactionheader .countnbtn .custom-btns .edit_section {
        right: 0;
        top: 0px;
    }
    .contributions-block {
        padding: 20px;
    }
    .skills-block {
        padding: 20px;
    }
    .skills-block:first-child {
        padding-bottom: 5px;
    }
    .skills-block.EntranceExam-skills-block {
        padding-bottom: 25px;
    }
    .skills-block h2 {
        margin: 0 0 20px;
        width: auto;
        margin: -20px -20px 20px;
        background: #eff8ff;
        border-radius: 6px 6px 0px 0px;
        padding: 20px;
        text-align: center;
        line-height: 22px;
    }
    .skills-block-detail .meter {
        font-size: 18px;
        align-items: center;
        padding: 10px 20px;
        line-height: 18px;
    }
    .card_profiles figure.student {
        position: absolute;
        left: 15px;
        top: 15px;
    }
    .card_profiles .student_details h2 {
        margin: 0 0 10px 90px;
    }
    .card_profiles .btn-send {
        position: static;
        margin-left: 90px;
    }
    .card_profiles .student_details .sub_details {
        margin-top: 15px;
    }
    .card_profiles .student_details .sub_details span.course {
        line-height: 15px;
    }
    .contributions-block .act_lst {
        padding: 15px;
    }
    .contributions-block .act_lst .postedtxt {
        text-align: left;
        position: absolute;
        top: 15px;
        white-space: nowrap;
        right: 15px;
    }
    .graduateRow .offer > a {
        margin: 0 10px 0 0;
    }
    .graduateRow .offer div.got_offer {
        margin-right: 15px;
        width: calc(100% - 173px);
        align-items: center;
        display: flex;
        margin-bottom: 0 !important;
        text-align: left;
        flex: 1 1;
        justify-content: center;
        line-height: 18px;
    }
    .graduateRow .offer .offer_joined {
        align-items: start;
        width: 158px;
        align-items: center;
        display: flex;
        margin-bottom: 0 !important;
        line-height: 16px;
    }
    .graduateRow .offer .offer_joined i {
        margin-right: 8px;
    }
    .contributions-block .act_lst > .row > div:last-child .btn-green {
        width: 135px;
    }
    .contributions-block .act_lst .btn-dark-blue {
        width: 135px;
    }
    /* .contributions-block  .listblk_icon {margin-bottom: 0;width: 34px;height: 34px;} */
    .contributions-block .act_lst .postedrow > div:last-child {
        width: 100% !important;
        display: flex;
        flex-direction: row-reverse;
        align-items: center;
        border-top: 1px solid #d1d1d1;
        padding-top: 10px;
        margin-top: 8px;
    }
    .act_lst > .row.postedrow > div:last-child > div:first-child {
        width: calc(100% - 190px);
        margin: 0 0 0 15px;
        align-items: center;
    }
    .alumni_class_link {
        align-items: center;
    }
    .filter_result_title {
        margin-bottom: 12px;
    }
    .contributions-block .album_shareblk {
        padding: 5px 0 0 0px;
    }
    .profile-item,
    .psychology-item {
        width: 100%;
        border: 0 !important;
    }
    .skills-block-title {
        margin: 0 0 20px;
        width: auto;
        margin: -20px -20px 20px;
        background: #eff8ff;
        border-radius: 6px 6px 0px 0px;
        padding: 20px;
        text-align: center;
        line-height: 22px;
    }
    .skills-block-title h2 {
        padding: 0;
        text-align: left;
    }
    #edit_Higher_Education .question {
        padding-right: 20px;
    }
    #job_Preferences .question {
        padding-right: 20px;
    }
    .underGraduate-detail .main_title,
    .blockHeader {
        margin: -20px -20px 30px;
        padding: 20px;
    }
    .graduateRow .offer .offer_existing_links {
        width: 100%;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }
    .graduateRow .offer .got_offer {
        margin-right: 10px;
    }
    .graduateRow .offer a.joindeLink {
        margin: 0 10px 0 0;
    }
    .powerby {
        margin: auto;
    }
    .graduateRow .offer.offer_edit .edit_section {
        top: 10px;
    }
    .postGraduate-detail .graduateRow {
        margin: 0;
    }
    .alumni_profile_college_name_detail {
        width: 100%;
        min-height: 100px;
    }
    .alumni_profile_name_college_other_detail_wrap {
        padding-bottom: 20px;
    }
    .alumni_profile_name_college_other_detail_wrap.directory-detail .alumni_profile_brife_links {
        padding: 0 0 17px;
        margin-top: 5px;
    }
    .alumni_profile_brife_links > a {
        padding: 0 15px;
    }
    .alumni_profile_name_college_other_detail_wrap.directory-detail
        .alumni_profile_college_name_other_detail_wrap
        .alumni_profile_college_name_other_detail
        .alumni_profile_other_detail {
        width: calc(100% + 98px);
    }
    .alumni_profile_name_college_other_detail_wrap.directory-detail
        .alumni_profile_college_name_other_detail_wrap
        .alumni_profile_college_name_other_detail
        .alumni_profile_other_detail
        .alumni_profile_status
        li {
        margin-bottom: 15px;
    }
    .leftUser {
        padding-left: 55px;
    }
    .rightUser {
        padding-right: 55px;
    }
    .half-gray:before {
        display: none;
    }

    .universities_block span, .radius_block span, .skills-block-detail span {
        flex: 1 1;
        font-size: 15px;
        line-height: 16px;
    }
}
/* alumni directory */

/* alumni connect */

.univariety_main_banner_container {
    position: relative;
}
.univariety_main_banner_container img {
    position: relative;
    vertical-align: top;
}
.main_banner_text {
    position: absolute;
    top: 22%;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    max-width: 48%;
    text-align: center;
    color: #fff;
}
.banner_title {
    font-size: 3.3vw;
    color: #fff;
    font-weight: 600;
    margin-bottom: 35px;
    line-height: 3vw;
}
.banner_sub_title {
    font-size: 1.33vw;
    line-height: 30px;
    margin-bottom: 40px;
    color: #fac75d;
}
.btn-watch {
    width: 180px;
    height: 50px;
    border: 1px solid #5cae48;
    text-decoration: none;
    border-radius: 5px;
    background: #5cae48;
    font-size: 16px;
    font-weight: 600;
    color: #fff;
    text-transform: uppercase;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.btn-watch:hover {
    background: #fff;
    text-decoration: none;
    border-color: #fff;
    color: #5cae48;
}
.btn-watch i {
    width: 22px;
    height: 22px;
    background: #fff;
    border-radius: 50%;
    margin-right: 10px;
    position: relative;
}
.btn-watch i:before {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-left: 7px solid #5cae48;
    top: 5.7px;
    left: 9px;
}
.btn-watch:hover i {
    background: #5cae48;
}
.btn-watch:hover i:before {
    border-left-color: #fff;
}

.univariety_alumni_members {
    background: #fff;
}
.univariety_alumni_members_container {
    padding: 80px 0;
    max-width: 1140px;
    width: 90%;
    margin: auto;
}
.univariety_alumni_members_container_title {
    font-size: 32px;
    color: #003457;
    font-weight: bold;
    margin-bottom: 0;
    line-height: 64px;
    text-align: center;
}
.univariety_alumni_members_container_title b {
    font-weight: 600;
}
.univariety_alumni_members_container_sub_title {
    font-size: 20px;
    color: #000;
    font-weight: 100;
    line-height: 26px;
    text-align: center;
    margin-bottom: 30px;
}
.alumni_members_callout {
    display: flex;
    justify-content: space-between;
    text-align: center;
    width: 1140px;
}
.alumni_members_callout .number {
    font-size: 48px;
    font-weight: 600;
    color: #074da2;
}
.alumni_members_callout p {
    font-size: 24px;
    font-weight: 500;
    color: #000;
    margin: 0;
}

#video_pop button.close {
    border: none;
    position: absolute;
    top: 10px;
    right: 10px;
    background: #fff;
    opacity: 1;
    padding: 1px 5px;
    border-radius: 1px;
    z-index: 9;
    height: 24px;
    display: flex;
    align-items: start;
    justify-content: center;
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 1;
    color: #000;
    text-shadow: 0 1px 0 #fff;
}
#video_pop button.close span {
    line-height: 20px;
    vertical-align: top;
    margin: -1px 0 0;
}

.univariety_message_spotlight_container div[class*='univariety_'] {
    padding: 50px 60px;
}
.univariety_message_spotlight_container {
    max-width: 1150px;
    width: 100%;
    margin: auto;
    position: relative;
}
.univariety_message_spotlight {
    background: #f5faff;
    position: relative;
}
.univariety_message_spotlight:before {
    content: '';
    right: 0;
    bottom: 0;
    top: 0;
    background: #e8f6fc;
    position: absolute;
    width: 42%;
}
.univariety_spotlight {
    background: #e8f6fc;
}
.video_wrap {
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 5px 15px #0000000d;
    border-radius: 10px;
    padding: 20px;
}
.univariety_spotlight .spotlight_block {
    background: #fff 0% 0% no-repeat padding-box;
    box-shadow: 0px 5px 15px #0000000d;
    border-radius: 10px;
    padding: 20px;
}
.univariety_message_spotlight_container div[class*='univariety_'] h2 {
    text-align: center;
    margin-bottom: 40px;
    position: relative;
    font-size: 24px;
    font-weight: 600;
}
.univariety_message_spotlight_container div[class*='univariety_'] h2:before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: -13px;
    width: 50px;
    height: 3px;
    margin: auto;
}
.univariety_message_spotlight_container div.univariety_message h2:before {
    background: #5cae48;
}
.univariety_message_spotlight_container div.univariety_spotlight h2:before {
    background: #d42941;
}
.univariety_message_spotlight_container .owl-theme .owl-dots .owl-dot span {
    background: #fff;
    width: 12px;
    height: 12px;
}
.univariety_message_spotlight_container .owl-theme .owl-dots .owl-dot.active span,
.owl-theme .owl-dots .owl-dot:hover span {
    background: #003457;
}

.btn-play {
    position: relative;
    display: inline-block;
}
.btn-play:before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 62px;
    height: 62px;
    background-color: #5cae48;
    margin: auto;
    border-radius: 50%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_29___});
    background-repeat: no-repeat;
    background-position: 14px 12px;
    background-size: 40px;
}

.alumni_network_count {
    overflow-y: hidden;
    overflow-x: auto;
    scrollbar-width: thin;
    padding-bottom: 8px;
}
.alumni_network_count::-webkit-scrollbar {
    height: 4px;
}
.alumni_network_count::-moz-scrollbar {
    height: 4px;
}
.alumni_network_count::-webkit-scrollbar-track {
    background: #ccc;
}
.alumni_network_count::-webkit-scrollbar-thumb {
    background-color: #666;
    border-radius: 20px;
    border: 2px solid #666;
}
.alumni_network_count ul {
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
}
.alumni_network_count li {
    background: #ffffff;
    box-shadow: 0px 3px 6px #0000001a;
    border: 1px solid #0034571a;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px;
    width: 220px;
    min-width: 220px;
    text-align: center;
}
.alumni_network_count li b {
    color: #5cae48;
    font-size: 45px;
}
.alumni_network_count li:not(:last-child) {
    margin-right: 10px;
}
.alumni_network_count li p {
    margin: 0 !important;
    text-align: center;
    font-size: 18px;
    line-height: 20px;
    font-weight: 500;
}
.alumni_network_count li .icon {
    width: 42px;
    height: 42px;
    margin-bottom: 10px;
}
.alumni_network_count li .icon.hat {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/graduation-cap.svg) no-repeat 0 0;
    width: 48px;
}
.alumni_network_count li .icon.brifecase {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/career.svg) no-repeat 0 0;
    width: 42px;
}
.alumni_network_count li .icon.building {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/office-building.svg) no-repeat 0 0;
    width: 42px;
}
.alumni_network_count li .icon.global {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/union.svg) no-repeat 0 0;
    width: 42px;
}
.alumni_network_count li .icon.college {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/school.svg) no-repeat 0 0;
    width: 42px;
}

@media (max-width: 991px) {
    .univariety_message_spotlight::before {
        display: none;
    }
}

@media (max-width: 575px) {
    .univariety_message_spotlight_container div[class*='univariety_'] {
        padding: 40px 40px;
    }
}

.view_pw .btn {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 15px;
    width: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.view_pw .btn img {
    width: 20px;
}
.form-control[type='password'] + .btn .fview_icn {
    display: none;
}
.form-control[type='text'] + .btn .fview_strike_icn {
    display: none;
}

.login_signup_tab .form-check-input.agree-check + .form-check-label {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    flex: 1 1;
    align-items: center;
}
.login_signup_tab .form-check-input.agree-check + .form-check-label .social_whatapp {
    width: 17px;
    height: 17px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/whatsapp.svg) no-repeat center / 100%;
    margin-right: 6px;
}
.login_signup_tab .form-check-input.agree-check + .form-check-label span {
    flex: 1 1;
    color: #fff;
    font-size: 14px;
    padding: 0;
    line-height: 18px;
}

.login_signup_tab .nav .nav-item {
    flex: 1 1;
    text-align: center;
    display: flex;
    justify-content: center;
    border-bottom: 3px solid #3c5d76;
}
.login_signup_tab .nav .nav-item .nav-link {
    width: 100%;
    background: transparent;
    font-size: 18px;
    font-weight: 500;
    padding: 0 0 15px;
    position: relative;
    color: #fff;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.login_signup_tab .nav .nav-item .nav-link.active {
    font-weight: 600;
}
.login_signup_tab .nav .nav-item .nav-link:before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: -4px;
    margin: auto;
    width: 0;
    height: 5px;
    background: #5cae48;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.login_signup_tab .nav .nav-item .nav-link.active:before {
    width: 100%;
}

.email_icon .form-control {
    padding-left: 50px;
}
.password_icon .form-control {
    padding-left: 50px;
}
.email_icon:before {
    content: '';
    background-color: #fff0;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_30___});
    background-repeat: no-repeat;
    background-position: center;
    background-size: 26px;
    position: absolute;
    left: 10px;
    top: 0;
    width: 26px;
    height: 24px;
    margin: auto;
    bottom: 0;
}
.password_icon::before {
    content: '';
    background-color: #fff0;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_31___});
    background-repeat: no-repeat;
    background-position: center;
    background-size: 30px;
    position: absolute;
    left: 12px;
    top: 0;
    width: 21px;
    height: 30px;
    margin: auto;
    bottom: 0;
}

.filter-switch-wrap {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 40px;
    display: flex;
    align-items: center;
}
.filter-switch .form-check-input {
    cursor: pointer;
    margin: 0 10px;
    width: 60px !important;
    height: 30px !important;
    background-color: #5cae48;
    border: none !important;
    background-size: 24px;
    background-position: right 4px center;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
}
.filter-switch .form-check-input:checked {
    background-position: left 4px center;
}
.filter-switch .form-check-input:focus {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
}
.filter-switch label {
    font-weight: 500;
    cursor: pointer;
}
.filter-switch .form-check-input + label {
    color: #474747;
    order: -1;
    font-weight: 400;
}
.filter-switch .form-check-input + label + label {
    color: #5cae48;
    font-weight: 600;
}
.filter-switch .form-check-input:checked + label {
    color: #5cae48;
    font-weight: 600;
}
.filter-switch .form-check-input:checked + label + label {
    color: #474747;
    font-weight: 400;
}

a.btn-clear {
    color: #d42941;
    font-weight: 500;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
a.btn-clear:hover {
    color: #0b3454;
}

.alumni-bucket .alumni_education a {
    color: #0a70be;
    font-weight: 500;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.alumni-bucket .alumni_education a:hover {
    color: #5cae48;
    text-decoration: none;
}

.alumni_univarsity_details.working {
    background: transparent linear-gradient(180deg, #eefaff 0%, #e5f7ff 100%) 0% 0% no-repeat padding-box;
}
.alumni_univarsity_details.pursuing {
    background: transparent linear-gradient(180deg, #fff7e6 0%, #fff6e3 100%) 0% 0% no-repeat padding-box;
}
.alumni_univarsity_details.examtaken {
    background: transparent linear-gradient(180deg, #fff0eb 0%, #fce1d8 100%) 0% 0% no-repeat padding-box;
}
.alumni_univarsity_details.homemaker {
    background: transparent linear-gradient(180deg, #f6f6f6 0%, #f8f8f8 100%) 0% 0% no-repeat padding-box;
}
.alumni_univarsity_details.break {
    background: transparent linear-gradient(180deg, #f1efff 0%, #f7f6ff 100%) 0% 0% no-repeat padding-box;
}
.tooltip.show.tooltip-white {
    opacity: 1;
}
@media (max-width: 767px) {
    .alumni_directory_filter .filters-head {
        -webkit-box-wrap: wrap;
        -moz-box-wrap: wrap;
        -ms-flex-wrap: wrap;
        -webkit-wrap: wrap;
        flex-wrap: wrap;
    }
    .filters-head .filter-switch-wrap {
        position: static;
        margin: 15px -20px 0px -20px;
        border-top: 1px solid #dbdbdb;
        width: calc(100% + 40px);
        padding: 12px 15px;
        display: flex;
        justify-content: center;
    }
}

/* Setting button dropdown in admin menu */
td:last-child .dropdown-menu {
    right: 0;
    left: auto;
}

/* alumni marketing css */
.offcanvas {
    z-index: 10509;
}

.verticalScrol {
    max-height: 360px;
    overflow: auto;
}
.verticalScrol::-webkit-scrollbar {
    width: 3px;
}
.verticalScrol::-webkit-scrollbar-track {
    background: #ccc;
}
.verticalScrol::-webkit-scrollbar-thumb {
    background: #666;
}
.verticalScrol::-webkit-scrollbar-thumb:hover {
    background: #999;
}
.collegelist {
    list-style: none;
    padding: 0;
    margin: 0;
}
.collegelist li {
    display: flex;
    align-items: center;
}
.collegelist li i {
    margin-right: 15px;
    width: 85px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.collegelist li:not(:last-child) {
    border-bottom: 1px solid #e9e9e9;
    padding-bottom: 15px;
    margin-bottom: 15px;
}
.collegelist li p {
    margin: 0;
    font-size: 16px;
    font-weight: 500;
}

.verticalScrol .accordion-item {
    border: none;
}
.verticalScrol .accordion-item .accordion-button:not(.collapsed) {
    background-color: transparent;
}
.verticalScrol .accordion-item .accordion-button {
    font-size: 18px;
    font-weight: 600;
    color: #000;
    padding-left: 0;
    padding-right: 0;
    box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.125);
}
.verticalScrol .accordion-item .accordion-button:focus {
    box-shadow: none;
    outline: none;
}

.horizontallist {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    padding: 0;
    margin: 0;
    list-style: none;
}
.horizontallist li {
    position: relative;
    margin: 0 15px 5px 0;
    padding-left: 12px;
}
.horizontallist li:before {
    content: '';
    position: absolute;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: black;
    left: 0;
    top: 11px;
}
.verticalScrol .accordion-body {
    padding-left: 0;
    padding-right: 0;
}

.option ul {
    list-style: none;
    margin: 11px 0;
    text-align: left;
    border: 1px solid #ccc;
    padding: 10px;
    border-radius: 5px;
    font-size: 14px;
    line-height: 18px;
    position: relative;
}
.option ul li:not(:last-child) {
    margin-bottom: 7px;
}
.option ul:before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    top: -6px;
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid #ccc;
}

.view-all-wrap {
    padding: 30px;
    margin: 50px -30px -30px;
    border-top: 1px solid #d4d4d4;
}

.btn-green[disabled] {
    background: #e2e2e2;
    border-radius: 20px;
    color: #a29d9d;
    text-decoration: none;
    opacity: 1;
}
.btn-green img {
    filter: brightness(0) invert(1);
    -webkit-filter: brightness(0) invert(1);
}
tr:hover .btn-green[disabled] {
    background: #333;
    color: #fff;
}
.btn-green[disabled]:hover {
    background: #333;
    color: #fff;
}

.icon-sort-arrow .up-arrow {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_32___});
    width: 15px;
    height: 15px;
    margin-right: -3px;
}
.icon-sort-arrow .down-arrow {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_33___});
    width: 15px;
    height: 15px;
    margin-left: -3px;
}

.radio-box * {
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.radio-box {
    background: #ffffff;
    border: 1px solid #0b34544d;
    border-radius: 6px;
    padding: 11px 15px;
    min-width: 124px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
}
.radio-box span {
    padding: 0;
    font-size: 16px;
    font-style: normal;
    color: #000;
    font-weight: 500;
    float: none;
}
.radio-box i {
    margin-left: 8px;
    background: #ffffff;
    border: 1px solid #b5c1cb;
    opacity: 1;
    width: 18px;
    height: 18px;
    position: relative;
    border-radius: 50%;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    -ms-border-radius: 50%;
    -o-border-radius: 50%;
}
.radio-box i:before {
    content: '';
    position: absolute;
    width: 9px;
    height: 5px;
    border-left: 2px solid #b5c1cb;
    border-bottom: 2px solid #b5c1cb;
    transform: rotate(-45deg);
    left: 3px;
    top: 5px;
    -webkit-transform: rotate(-45deg);
    -moz-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    -o-transform: rotate(-45deg);
}
.form-check-input + .radio-box span {
    flex: 1 1;
}
.form-check-input:checked + .radio-box {
    background: #5cae48;
    border-color: #5cae48;
}
.form-check-input:checked + .radio-box span {
    color: #fff;
}
.form-check-input:checked + .radio-box i {
    border-color: #fff;
    background: #5cae48;
}
.form-check-input:checked + .radio-box i:before {
    border-color: #fff;
}

.action_btns {
    max-width: 100%;
    background: #f5faff;
    padding: 20px;
    border-radius: 5px;
    margin: 35px 0 0 0px;
    text-align: center;
}
.action_btns button.nextbtn {
    padding: 0px 30px;
    font-size: 1.5em;
    cursor: pointer;
    border: 0px;
    position: relative;
    margin: auto;
    transition: all 0.25s ease;
    background: #0b3454;
    color: #fff;
    overflow: hidden;
    border-radius: 25px;
    height: 45px;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 1px;
}
.action_btns .btn-skip {
    font-size: 16px;
    display: inline-block;
}
.btn-skip {
    margin: 15px;
    font-size: 12px;
    text-decoration: none;
    font-weight: 500;
    color: #00000070;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}

.btn-skip:hover {
    color: #d42941;
}
.radius-6 {
    border-radius: 6px;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    -ms-border-radius: 6px;
    -o-border-radius: 6px;
}

.disableOpacity {
    opacity: 0;
    cursor: default !important;
}

.hrBg {
    border-color: #e9e9e9;
    background-color: #e9e9e9;
    opacity: 1;
}

.max-568 {
    max-width: 568px;
}

.new-btn-delete {
    width: 125px;
    display: flex;
    font-size: 16px;
    font-weight: 500;
    color: #c30000;
    align-items: center;
}
.new-btn-delete i {
    margin-right: 7px;
    display: flex;
    align-items: center;
}
.new-btn-delete img {
    opacity: 0.8;
}
.new-btn-delete:hover {
    color: #890000;
}
.new-btn-delete:hover img {
    opacity: 1;
}

.profile_section {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    align-items: center;
    position: relative;
}
.profile_section::after {
    content: '';
    position: absolute;
    background-color: #c4c4c4;
    width: 1px;
    height: 40px;
    top: 0;
    bottom: 0;
    right: 10px;
    margin: auto;
}
.profile_section .profile_section_img {
    width: 60px;
    margin-right: 15px;
}
.profile_section .profile_section_name {
    font-size: 22px;
    font-weight: 600;
    color: #0b3454;
    max-width: 150px;
    line-height: 24px;
    padding-right: 30px;
    margin-right: 10px;
}

.contact_detail {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
}
.contact_detail div {
    display: flex;
    align-items: center;
}
.contact_detail div:not(:last-child) {
    margin-bottom: 3px;
}
.contact_detail div i {
    width: 20px;
    height: 20px;
    display: inline-block;
    margin-right: 7px;
    background-position: center;
    background-size: 20px;
}
.contact_detail div a {
    color: #0b3454;
    text-decoration: none;
    font-weight: 500;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.contact_detail div a:hover {
    color: #1c5785;
}
.contact_detail div.phone i {
    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/phone_icon.svg);
}
.contact_detail div.email i {
    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/email_icon.svg);
}

.lead_items b {
    font-weight: 500;
    color: #0b3454;
}
.custom-bottom-liteblue {
    border-bottom: 3px solid #f2f9ff;
}
.custom-bottom-litegray {
    border-bottom: 3px solid #e5eaed;
}

@media (max-width: 523px) {
    .profile_section {
        padding-bottom: 30px;
        margin-bottom: 10px;
    }
    .profile_section::after {
        width: 80px;
        height: 1px;
        left: 0;
        bottom: 3px;
        top: auto;
        right: auto;
    }
}

/* Bulk Imports  */

.bulk_imports_header {
    border-bottom: 1px solid #c1ccd4;
}
.steps_flow {
    margin: auto;
    padding: 0;
    display: flex;
    align-items: center;
    position: relative;
    list-style: none;
}
.polartabsec .steps_flow li {
    height: auto;
    position: relative;
}
.polartabsec .steps_flow li:not(:last-child) {
    margin-right: 254px;
}
.polartabsec .steps_flow li a {
    text-decoration: none;
    color: #000;
    font-size: 18px;
}
.polartabsec .steps_flow li.active a {
    font-weight: 500;
}
.steps_flow:before {
    content: '';
    position: absolute;
    left: 20px;
    bottom: -20px;
    right: 20px;
    border-bottom: 3px solid #5cae48;
    margin: auto;
}
.polartabsec .steps_flow li:before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: -30px;
    background: #ffffff;
    border: 2px solid #0b345433;
    opacity: 1;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    margin: auto;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    -ms-border-radius: 50%;
    -o-border-radius: 50%;
}
.polartabsec .steps_flow li.active:before {
    background: #0db35c;
    border: 1px solid #0db35c;
    margin: auto;
    box-shadow: 0 0 0 5px #fff inset;
}
.polartabsec .steps_flow li.completed::before {
    background-color: #0db35c;
    border: 1px solid #0db35c;
    margin: auto;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
}

.import-title {
    text-align: center;
    margin-top: 30px;
}
.import-title h3 {
    font-size: 24px;
    font-weight: 500;
    margin: 0 0 5px;
}
.import-title p {
    font-size: 16px;
    margin-bottom: 5px;
}

.import-block * {
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.import-block {
    background: #ffffff;
    border: 1px solid #d2d2d2;
    border-radius: 6px;
    position: relative;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    overflow: hidden;
    height: 100%;
    display: flex;
    flex-direction: column;
}
.import-block .icon {
    position: absolute;
    background: #0b3454;
    border-radius: 0px 4px 0px 72px;
    width: 78px;
    height: 78px;
    top: 0;
    right: 0;
}
.import-block .icon::before {
    filter: brightness(0) invert(1);
    -webkit-filter: brightness(0) invert(1);
}
.import-block-detail {
    padding: 20px 30px 30px;
    flex: 1 1;
}
.icon.icon_user::before {
    content: '';
    position: absolute;
    right: 14px;
    top: 14px;
    width: 30px;
    height: 30px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/selet-user.svg);
}
.icon.icon_display::before {
    content: '';
    position: absolute;
    right: 14px;
    top: 14px;
    width: 30px;
    height: 30px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/display-user.svg);
}
.import-block-detail h4 {
    font-size: 24px;
    font-weight: 500;
    margin: 0 0 15px;
}
.import-block-detail ul {
    margin: 0;
    padding: 0;
    max-width: 420px;
    list-style: none;
}
.import-block-detail ul li:not(:last-child) {
    margin-bottom: 18px;
}
.import-block-detail ul li {
    position: relative;
    padding: 0 0 0 18px;
    line-height: 20px;
}
.import-block-detail ul li:before {
    content: '';
    position: absolute;
    top: 3px;
    left: 0;
    background: #27a7df;
    width: 3px;
    height: 85%;
    border-radius: 5px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    -ms-border-radius: 5px;
    -o-border-radius: 5px;
}
.import-block-select {
    background: #f2f9ff;
    width: 100%;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    font-weight: 600;
    color: #0b345490;
    text-transform: uppercase;
    cursor: pointer;
}
.import-block-select i {
    width: 26px;
    height: 26px;
    border-radius: 5px;
    border: 1px solid #d2d2d2;
    background: #fff;
    margin-right: 10px;
    transition: all 0.5s ease-in-out;
    -webkit-transition: all 0.5s ease-in-out;
    -moz-transition: all 0.5s ease-in-out;
    -ms-transition: all 0.5s ease-in-out;
    -o-transition: all 0.5s ease-in-out;
    position: relative;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    -ms-border-radius: 5px;
    -o-border-radius: 5px;
}

.inputfile_parent label.height-80 {
    height: 80px;
}
.inputfile_parent label.height-80 span {
    font-weight: 400;
}
.inputfile_parent label .text-skyblue {
    color: #27a7df;
}

.form-check-input:checked + div {
    border: 1px solid #5cae48;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.form-check-input:checked + div .icon {
    background: #f2f9ff;
}
.form-check-input:checked + div .icon:before {
    filter: brightness(1) invert(0);
    -webkit-filter: brightness(1) invert(0);
}
.form-check-input:checked + div .import-block-select {
    background: #5cae48;
    color: #fff;
}
.form-check-input:checked + div .import-block-select i {
    border-color: #fff;
    background-color: #fff;
}
.form-check-input:checked + div .import-block-select i::before {
    content: '';
    position: absolute;
    border-width: 0px 0px 3px 3px;
    border-style: solid;
    border-color: #5cae48;
    width: 14px;
    height: 7px;
    transform: rotate(-45deg);
    left: 6px;
    top: 7px;
    -webkit-transform: rotate(-45deg);
    -moz-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    -o-transform: rotate(-45deg);
}

.upload_disclaimer {
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    color: #0b3454;
    opacity: 0.8;
    padding: 14px 0;
}

.form-check-tick .form-check-input {
    width: 26px;
    height: 26px;
    margin-right: 8px;
    margin-top: 0;
}
.form-check-tick {
    display: flex;
    align-items: center;
}
.form-check-tick .form-check-input:checked {
    background-color: #5cae48;
    border-color: #5cae48;
}

.map-card-wrap {
    display: flex;
    flex-wrap: nowrap;
    padding-bottom: 20px;
}
.map-card {
    border: 1px solid #dbdcdd;
    border-radius: 6px;
    width: 257px;
    min-width: 257px;
    overflow: hidden;
}
.map-card:not(:last-child) {
    margin-right: 10px;
}
.map-column {
    background: #f2f9ff;
    padding: 10px 15px 20px;
}
.map-title {
    color: #68696a;
    font-weight: 500;
    font-size: 14px;
}
.skip_column {
    height: 45px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.skip_column .skip-link {
    color: #0b3454;
}
.column-list {
    padding: 0;
    margin: 0;
}
.column-list li {
    min-height: 45px;
    display: flex;
    align-items: center;
    padding: 0 15px;
}
.column-list-title {
    background: #f5f7f8;
    font-weight: 500;
}
.column-list li ~ li:not(:last-child) {
    border-bottom: 1px solid #ebebeb;
}

.modal-header .icon-correct {
    width: 50px;
    height: 50px;
    background: #5cae48;
    border-radius: 50%;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 25px;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    -ms-border-radius: 50%;
    -o-border-radius: 50%;
}

.x-scroll-big {
    overflow-x: auto;
}
.x-scroll-big::-webkit-scrollbar {
    height: 15px;
}
.x-scroll-big::-webkit-scrollbar-track {
    background: #ccc;
}
.x-scroll-big::-webkit-scrollbar-thumb {
    background: #666;
}
.x-scroll-big::-webkit-scrollbar-thumb:hover {
    background: #555;
}

.p-40 {
    padding: 40px;
}

.btn-disable {
    background: #e2e2e2;
    border-radius: 25px;
    height: 35px;
    color: #000;
    font-weight: 400;
    pointer-events: none;
}
.btn.btn-disable:hover {
    background: #666;
    color: #ffff;
}

.custom_step {
    background: #ffffff;
    border: 2px solid #5cae48;
    opacity: 1;
    border-radius: 5px 0px 0px 5px;
    width: 90px;
    display: flex;
    align-items: center;
    height: 40px;
    justify-content: center;
    color: #5cae48;
    font-weight: 500;
    position: relative;
    margin-right: 20px;
}
.custom_step:after {
    position: absolute;
    content: '';
    width: 28.3px;
    height: 28.3px;
    border-top: 2px solid #5cae48;
    border-right: 2px solid #5cae48;
    transform: rotate(45deg);
    right: -16px;
    background: #fff;
    top: 0;
    bottom: 0;
    margin: auto;
    -webkit-transform: rotate(45deg);
    -moz-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    -o-transform: rotate(45deg);
}

.custom-tool {
    position: absolute;
    padding: 10px;
    background: #d6ffcc;
    font-size: 16px;
    line-height: 16px;
    font-weight: 400;
    white-space: nowrap;
    border-radius: 5px;
    top: 0;
    bottom: 0;
    margin: auto;
    height: 40px;
    display: flex;
    align-items: center;
    left: calc(100% + 20px);
    padding: 0 20px;
}
.custom-tool:before {
    content: '';
    position: absolute;
    border-top: 8px solid transparent;
    border-bottom: 8px solid transparent;
    border-right: 8px solid #d6ffcc;
    right: 100%;
}

.upload_section {
    background: #ffffff;
    border: 1px dashed #0b345480;
    border-radius: 6px;
    padding: 20px;
    position: relative;
}
.upload_section .cloud-wrap {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    align-items: center;
}
.upload_section .cloud-wrap .cloud-img {
    margin-right: 15px;
}
.upload_section .btn-upload {
    width: 170px;
}
.upload_section .cloud-wrap .cloud-text {
    flex: 1 1;
    line-height: 18px;
}
.form-check-input {
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.upload_section u {
    color: #27a7df;
}

div.ck.ck-editor {
    min-height: 200px;
    display: flex;
    flex-direction: column;
}
div.ck.ck-editor .ck-editor__main {
    flex: 1 1;
    display: flex;
}
div.ck.ck-editor .ck-editor__main .ck-editor__editable_inline {
    display: block;
    width: 100%;
    border-radius: 0px 0px 6px 6px;
}
div.ck.ck-editor .ck-editor__main .ck-editor__editable_inline a {
    color: #0c4cbb;
    text-decoration: none;
}
div.ck.ck-editor .ck-reset_all .ck-sticky-panel__content .ck-toolbar {
    border-radius: 6px 6px 0 0;
}
.post-control ~ div.ck.ck-editor {
    min-height: 300px;
}

.circle-tick {
    width: 36px;
    height: 36px;
    display: flex;
    background: #5cae48;
    border-radius: 50%;
    margin-right: 12px;
    position: relative;
}
.circle-tick:before {
    content: '';
    position: absolute;
    width: 16px;
    height: 8px;
    border-left: 3px solid #fff;
    border-bottom: 3px solid #fff;
    top: 12px;
    left: 10px;
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
    -moz-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    -o-transform: rotate(-45deg);
}

@media (max-width: 575px) {
    .polartabsec .steps_flow li:not(:last-child) {
        margin-right: 145px;
    }
    .inputfile_parent label.height-80 span.uploadlabel {
        text-overflow: ellipsis;
        width: calc(100% - 75px);
        overflow: hidden;
    }
    .custom-tool {
        display: none;
    }
}
/* Bulk Imports end */

/* social media post start */

.social_wrap ul {
    padding: 0;
    margin: 20px 0 0;
    list-style: none;
}
.social_wrap ul li {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    padding: 20px 0;
}
.social_wrap ul li:not(:last-child) {
    border-bottom: 1px solid #e5eaed;
}
.social_wrap ul li .post-view {
    width: calc(100% - 450px);
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    align-items: center;
    margin-right: 90px;
}
.social_wrap ul li .post-view .post-name {
    width: 100%;
    display: flex;
    align-items: center;
    margin-right: 90px;
}
.social_wrap ul li .post-view .post-name .social-logo {
    margin-right: 15px;
    width: 50px;
    height: 50px;
    overflow: hidden;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.social_wrap ul li .post-view .post-name .social-logo img{
    width: auto;
    height: 100%;
    max-width: inherit !important;
}
.social_wrap ul li .post-view .post-title {
    font-weight: 500;
    width: calc(100% - 65px);
}
.social_wrap ul li .post-view .post-title p{
    display: inline;
}
.social_wrap ul li .post-detail {
    display: flex;
    align-items: center;
    margin-left: auto;
}
.social_wrap ul li .post-detail .post-detail-date {
    line-height: 16px;
    text-align: right;
    font-size: 14px;
    font-weight: 600;
    margin-right: 20px;
}
.social_wrap ul li .post-detail .post-detail-date span {
    font-size: 16px;
    font-weight: 400;
    font-style: italic;
}

.postOption {
    background: #fffae5;
    border: 1px dashed #e3dec8;
    border-radius: 6px;
    padding: 25px;
}
.postOption ul {
    margin: 0;
    padding: 0;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    list-style: none;
    justify-content: space-between;
}
.postOption ul li {
    height: 50px;
    width: 48%;
    border-radius: 5px;
}
.postOption ul li label {
    width: 100%;
    height: 100%;
    border-radius: 6px;
    padding: 0 18px;
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: 500;
    color: #fff;
    cursor: pointer;
    position: relative;
}
.postOption ul li label b {
    position: absolute;
    width: 25px;
    height: 25px;
    border-radius: 25px;
    -webkit-border-radius: 25px;
    -moz-border-radius: 25px;
    -ms-border-radius: 25px;
    -o-border-radius: 25px;
    background: rgba(0, 0, 0, 0.5);
    top: 0;
    bottom: 0;
    right: 15px;
    margin: auto;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.postOption ul li label[for='facebook'] {
    background-color: #3456a2;
}
.postOption ul li label[for='Twitter'] {
    background-color: #01a1f9;
}
.postOption ul li label[for='linkedin'] {
    background-color: #0077b7;
}
.postOption ul li label[for='instagram'] {
    background: rgb(171,16,128);
    background: linear-gradient(208deg, rgba(171,16,128,1) 0%, rgba(254,83,64,1) 70%, rgba(255,213,84,1) 100%);
}
.postOption ul li label i {
    width: 25px;
    height: 25px;
    margin-right: 10px;
    background-size: 100%;
    background-position: center;
}
.postOption ul li label[for='facebook'] i {
    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/facebook-white.svg);
}
.postOption ul li label[for='Twitter'] i {
    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/x-twtter.svg);
    background-size: 33px;
}
.postOption ul li label[for='linkedin'] i {
    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/linkedin.svg);
    background-size: 27px;
    background-color: #fff;
}
.postOption ul li label[for='instagram'] i {
    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/instagram.svg);
    background-size: 33px;
}
.postOption ul li input:checked ~ label b {
    background-color: #ffffff;
}
.postOption ul li input:checked ~ label b::before {
    content: '';
    width: 14px;
    height: 7px;
    position: absolute;
    border-left: 3px solid #5cae48;
    border-bottom: 3px solid #5cae48;
    left: 6px;
    top: 8px;
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
    -moz-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    -o-transform: rotate(-45deg);
}

.post-preview {
    background: #f2f4f7;
    padding: 25px;
    border-radius: 5px;
    margin-top: 28px;
    height: calc(100% - 28px);
    display: flex;
    flex-direction: column;
}
.post-preview h2 {
    font-size: 22px;
    text-align: center;
    font-weight: 500;
}
.post-preview-data {
    background: #ffff;
    padding: 25px;
    border-radius: 5px;
    flex: 1 1;
}
.post-preview-data a {
    color: #0c4cbb;
}

@media (max-width: 991px) {
    .social_wrap ul li .post-view .post-name {
        margin-right: 30px;
    }
    .social_wrap ul li .post-view {
        margin-right: 30px;
    }
}

@media (max-width: 767px) {
    .social_wrap ul li .post-view {
        margin-right: 0px;
        width: 100%;
    }
    .social_wrap ul li .post-detail {
        width: 100%;
        margin-top: 10px;
        justify-content: end;
    }
}

@media (max-width: 575px) {
    .postOption {
        padding: 10px;
    }
    .postOption ul li {
        width: 48.5%;
    }
    .postOption ul li label {
        padding: 0 10px;
        font-size: 15px;
    }
    .postOption ul li label i {
        margin-right: 0;
    }
}

@media (max-width: 480px) {
    .social_wrap ul li .post-view {
        flex-direction: column;
        align-items: start;
    }
    .social_wrap ul li .post-view .post-name {
        margin-right: 0;
        margin-bottom: 10px;
    }
    .social_wrap ul li .post-detail {
        justify-content: start;
        flex-direction: row-reverse;
    }
    .social_wrap ul li .post-detail .post-detail-date {
        margin: 0 0 0 10px;
        text-align: left;
    }
}

/* social media post End */

/* manage-widgets-wrap */
.manage-widgets-wrap ul {
    padding: 0;
    margin: 0;
    list-style: none;
}
.manage-widgets-wrap ul li {
    background: #ffffff;
    border: 1px solid #eaeaea;
    border-radius: 4px;
    padding: 10px;
}
.manage-widgets-wrap ul li:not(:last-child) {
    margin-bottom: 5px;
}
.manage-widgets-wrap {
    margin-top: 25px;
}

.manage-widgets-wrap .form-check-tick .form-check-input {
    width: 22px;
    height: 22px;
}

.btn.btn-widgets-edit {
    background: #ffffff;
    border: 2px solid #0b3454;
    border-radius: 15px;
    height: 28px;
    line-height: 25px;
    padding: 0 20px;
    text-decoration: none;
    text-transform: uppercase;
    font-weight: 600;
    font-size: 12px;
    color: #0b3454;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.btn.btn-widgets-edit:hover {
    background: #0b3454;
    color: #fff;
}

.btn.btn-priview {
    background: #ffffff;
    border: 2px solid #5cae48;
    border-radius: 15px;
    height: 28px;
    line-height: 25px;
    padding: 0 20px;
    text-decoration: none;
    text-transform: uppercase;
    font-weight: 600;
    font-size: 12px;
    color: #5cae48;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.btn.btn-priview:hover {
    background: #5cae48;
    color: #fff;
}

.btn.btn-configure {
    background: #0b3454;
    border: 2px solid #0b3454;
    border-radius: 15px;
    height: 28px;
    line-height: 25px;
    padding: 0 20px;
    text-decoration: none;
    text-transform: uppercase;
    font-weight: 600;
    font-size: 12px;
    color: #fff;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.btn.btn-configure:hover {
    background: #5cae48;
    border: 2px solid #5cae48;
    color: #fff;
}
/* manage-widgets-wrap */

.alumni-spotlight {
    background: #f2f4f7;
    border-radius: 5px;
    overflow: hidden;
    box-shadow: 0 0 8px 0px #aeaeae;
}
.alumni-spotlight a {
    text-decoration: none;
}
.alumni-spotlight > .bg-white {
    padding: 20px;
    display: flex;
    justify-content: center;
}
.alumni-card-wrap {
    padding: 50px 0 80px;
}
.alumni-card-wrap .alumni-card-slider {
    max-width: 350px;
    width: 90%;
    margin: auto;
    background: #ffffff;
    box-shadow: 0px 5px 15px #0000000d;
    border-radius: 10px;
    position: relative;
}
.alumni-card-wrap .alumni-card-slider:before {
    content: '';
    position: absolute;
    background: #d42941;
    left: 0;
    right: 0;
    margin: auto;
    height: 75px;
    border-radius: 10px 10px 200px 200px / 10px 10px 40px 40px;
}
.alumni-card-wrap .alumni-card-slider .alumni-card {
    padding: 25px 40px;
}
.alumni-card-wrap .alumni-card-slider .alumni-card .alumni-detail {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    border-bottom: 1px solid #0b345425;
    padding-bottom: 15px;
    margin-bottom: 15px;
}
.alumni-card-wrap .alumni-card-slider .alumni-card .alumni-logo {
    width: 100%;
    margin: auto;
    text-align: center;
}
.alumni-card-wrap .alumni-card-slider .alumni-card .alumni-logo img {
    max-width: 200px;
    width: auto;
    min-height: 40px;
    max-height: 120px;
}
.alumni-img-wrap {
    display: flex;
    justify-content: center;
    width: 90px;
    height: 90px;
    border-radius: 50%;
    position: relative;
    margin-bottom: 18px;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    -ms-border-radius: 50%;
    -o-border-radius: 50%;
}
.alumni-img-wrap .alumni-img {
    width: 100%;
    height: 100%;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    justify-content: center;
    overflow: hidden;
    border-radius: 50%;
}
.alumni-img-wrap .alumni-img img {
    width: auto;
    max-width: -moz-fit-content;
    max-width: fit-content;
    height: 100%;
}
.alumni-card-wrap .alumni-card-slider .owl-dots {
    position: absolute;
    left: 0;
    right: 0;
    top: calc(100% + 10px);
}
.alumni-card-wrap .alumni-card-slider .owl-dots .owl-dot span {
    background: #ffffff;
    border: 1px solid #00345767;
    width: 14px;
    height: 14px;
    margin: 5px;
}
.alumni-card-wrap .alumni-card-slider .owl-dots .owl-dot.active span {
    background: #003457;
    border: 1px solid #003457;
}

.alumni-img-wrap label {
    position: absolute;
    top: 0;
    right: 0;
}
.alumni-detail label {
    background: #ffffff;
    border: 1px solid #a8acaf;
    opacity: 1;
    width: 27px;
    height: 27px;
    border-radius: 50%;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.alumni-detail label:hover {
    background: #a8acaf;
}
.alumni-detail label .pencil-edit {
    background-size: 13px;
    filter: invert(61%) sepia(65%) saturate(7465%) hue-rotate(205deg) brightness(103%) contrast(101%);
    -webkit-filter: invert(61%) sepia(65%) saturate(7465%) hue-rotate(205deg) brightness(103%) contrast(101%);
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.alumni-detail label:hover .pencil-edit {
    background-size: 13px;
    filter: invert(100%) sepia(100%) saturate(20%) hue-rotate(333deg) brightness(104%) contrast(107%);
    -webkit-filter: invert(100%) sepia(100%) saturate(20%) hue-rotate(333deg) brightness(104%) contrast(107%);
}
.alumni-card-wrap .alumni-card-slider .alumni-card .alumni-detail h3 {
    font-size: 24px;
    font-weight: 600;
}
.alumni-card-wrap .alumni-card-slider .alumni-card .alumni-detail h4 {
    font-size: 16px;
}

.template-block {
    background: #f8f8f8;
    border: 1px solid #d5d5d5;
    border-radius: 6px;
    opacity: 1;
    padding: 10px;
    position: relative;
    overflow: hidden;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    -ms-border-radius: 6px;
    -o-border-radius: 6px;
    height: 100%;
}
.template-block-image {
    position: relative;
    overflow: hidden;
    border-radius: 6px;
}
.template-block-name {
    font-size: 16px;
    font-weight: 500;
    text-align: center;
    line-height: 18px;
    padding: 20px 20px 10px;
}
.overview-block {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    overflow: hidden;
}
.template-block:hover .overview-block {
    top: 0;
}
.overview-block .btn-choose {
    background: #5cae48;
    border-radius: 27px;
    width: 170px;
    height: 40px;
    color: #fff;
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 0 10px -200%;
    font-weight: 500;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.dropdown-container {
    position: relative;
    width: 100%;
    max-width: 400px;
    margin: 0 auto;
  }
  
  .suggestions-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    background-color: #ffffff;
    border: 1px solid #ccc;
    border-radius: 4px;
    z-index: 1000;
    max-height: 200px;
    overflow-y: auto;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  }
  
  .suggestion-item {
    padding: 10px;
    cursor: pointer;
    transition: background-color 0.2s;
  }
  
  .suggestion-item:hover {
    background-color: #f0f0f0;
  }
  
  .loading {
    margin-top: 5px;
    color: #fff;
    font-size: 14px;
  }
  .dropdown-container {
    position: relative;
    width: 100%;
    max-width: 400px;
    margin: 20px auto;
}

.suggestions-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    background-color: #ffffff;
    border: 1px solid #ccc;
    border-radius: 4px;
    z-index: 1000;
    max-height: 200px;
    overflow-y: auto;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.suggestion-item {
    padding: 10px;
    cursor: pointer;
    transition: background-color 0.2s;
}

.suggestion-item:hover {
    background-color: #f0f0f0; /* Optional: Add hover effect */
}

.loading {
    margin-top: 5px;
    color: #999;
    font-size: 14px;
}
.overview-block .btn-choose:hover {
    background: #3e892b;
}
.template-block .overview-block:hover .btn-choose {
    margin-left: 0;
}
.overview-block .btn-preview {
    background: #fff;
    border-radius: 27px;
    width: 170px;
    height: 40px;
    color: #000;
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 -200% 0 0;
    font-weight: 500;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.overview-block .btn-preview:hover {
    background: #5cae48;
    color: #fff;
}
.template-block .overview-block:hover .btn-preview {
    margin-right: 0;
}

.gray-gradient {
    background: transparent linear-gradient(180deg, #ffffff 0%, #f5f5f5 100%);
}
.border-d2d2d2 {
    border: 1px solid #d2d2d2;
}
.alumni-card-wrap .alumni-card-slider i.curve {
    content: '';
    position: absolute;
    background: #d42941;
    left: 0;
    right: 0;
    margin: auto;
    height: 75px;
    border-radius: 10px 10px 200px 200px / 10px 10px 40px 40px;
    top:0
}
.alumni_profile_name_other_detail .btn-send .icon-web {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/web.svg) no-repeat 0 0 / 100%;
    width: 19px;
    height: 19px;
    margin-right: 8px;
    position: relative;
    left: 0;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.alumni_profile_brife_links {
    width: 100%;
    padding-left: 129px;
    margin-top: 20px;
    display: flex;
    align-items: center;
}
.alumni_profile_brife_links a {
    height: 40px;
    padding: 0 20px;
    border-radius: 25px;
    display: inline-flex;
    align-items: center;
    margin-right: 6px;
    text-decoration: none;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}

.alumni_profile_brife_links a i {
    margin-right: 5px;
}
.alumni_profile_brife_links a.btn-send {
    background: #5cae48;
    color: #fff;
}
.alumni_profile_brife_links a.btn-send:hover {
    background: #2fa612;
}
.alumni_profile_brife_links a.btn-send i.icon-send {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/send_alumni_profile.svg) no-repeat 0
        0 / 100%;
    width: 19px;
    height: 19px;
    margin-right: 10px;
    position: relative;
    transition: all 0.3s ease-in-out;
    left: 0;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.alumni_profile_brife_links a.btn-send i.icon-web {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/web.svg) no-repeat 0 0 / 100%;
    width: 19px;
    height: 19px;
    margin-right: 10px;
    position: relative;
    transition: all 0.3s ease-in-out;
    left: 0;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.alumni_profile_brife_links .btn-send:hover .icon-send {
    left: 3px;
}

.alumni_profile_brife_links a.btn-push-web {
    background: #27a7df;
    color: #fff;
}
.alumni_profile_brife_links a.btn-push-web:hover {
    background: #078dc8;
}
.alumni_profile_brife_links a.btn-push-web i.icon-globe {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/web.svg) no-repeat 0 0 / 100%;
    width: 19px;
    height: 19px;
    margin-right: 10px;
    position: relative;
    transition: all 0.3s ease-in-out;
    left: 0;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.alumni_profile_brife_links .btn-push-web:hover .icon-globe {
    left: 3px;
}

.alumni_profile_brife_links a.btn-mark {
    background: #fff;
    border: 2px solid #0b3454;
    color: #0b3454;
}
.alumni_profile_brife_links a.btn-mark:hover {
    background: #0b3454;
    color: #fff;
}

.listed-points {
    padding: 0;
    margin: 4px 0 0;
    list-style: none;
}
.listed-points li {
    margin-bottom: 0;
    padding-left: 12px;
    line-height: 20px;
    font-weight: 500;
}
.listed-points li:before {
    width: 5px;
    height: 5px;
    background: #000;
    top: 8px;
}

.top-48 {
    top: 48px;
}
.z-1 {
    z-index: 1;
}
.z-0 {
    z-index: 0;
}

.more_action {
    padding: 0;
    margin: 0;
    list-style: none;
    width: 150px;
}
.more_action a {
    padding: 0;
    color: #000;
    margin: 0;
    height: auto;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    text-decoration: none;
}
.more_action a:hover {
    color: #5cae48;
}
.more_action li:not(:last-child) {
    margin-bottom: 5px;
}

.btn-moreaction {
    background: #ffffff;
    border: 2px solid #7d7d7d;
    color: #000;
    height: 40px;
    padding: 0 20px;
    padding-right: 20px;
    padding-left: 20px;
    border-radius: 25px;
    display: inline-flex;
    align-items: center;
    margin-right: 6px;
    text-decoration: none;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.btn-moreaction:hover {
    background: #7d7d7d;
    color: #fff;
}
.alumni_profile_brife_links a[aria-expanded='true'] {
    background-color: #7d7d7d;
    color: #fff;
}
.btn-moreaction .dot {
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    margin-left: 7px;
}
.btn-moreaction .dot:before,
.btn-moreaction .dot:after,
.btn-moreaction i {
    content: '';
    width: 3px;
    height: 3px;
    background: #333;
    border-radius: 50%;
    margin: 1px 0;
}
.btn-moreaction:hover .dot:before,
.btn-moreaction:hover .dot:after,
.btn-moreaction:hover i {
    background: #fff;
}
.alumni_profile_brife_links a[aria-expanded='true'] .dot::before,
.alumni_profile_brife_links a[aria-expanded='true'] .dot::after,
.alumni_profile_brife_links a[aria-expanded='true'] i {
    background: #fff;
}

.graduateRow .offer .got_offer i.icon-like.dislike {
    transform: scale(-1) translateY(-5px);
    display: inline-block;
    color: #e10000;
    vertical-align: top;
}
.workExperienceRow .offer {
    border-left: 1px solid #d1d1d1;
    min-height: 63px;
    display: flex;
    align-items: center;
    margin-left: 30px;
    padding-left: 25px;
}
.workExperienceRow .offer i {
    margin-right: 10px;
}
.workExperienceRow .offer i.icon-like {
    color: #5cae48;
}
.workExperienceRow .offer i.icon-like.dislike {
    transform: scale(-1) translateY(-8px);
    display: inline-block;
    vertical-align: top;
    color: #919191;
}

.no-after:after,
.no-before:before {
    content: none;
    display: none;
}

.card_profiles.auto_height {
    max-height: inherit;
    min-height: 0;
}

@media (max-width: 991px) {
    .alumni_profile_name_college_other_detail_wrap.directory-detail .alumni_profile_image_name_other_detail {
        padding: 0;
        margin: 0;
        order: 1;
    }
    .alumni_profile_name_college_other_detail_wrap.directory-detail .alumni_profile_image_name_other_detail:after {
        opacity: 0;
    }
    .alumni_profile_name_college_other_detail_wrap.directory-detail .alumni_profile_college_name_other_detail_wrap {
        padding: 0;
        order: 3;
    }
    .alumni_profile_name_college_other_detail_wrap.directory-detail .alumni_profile_brife_links {
        order: 2;
        border-bottom: 1px solid #dbdbdbcc;
        margin-bottom: 30px;
        padding-bottom: 30px;
        flex-wrap: wrap;
    }
    .alumni_profile_brife_links > a {
        margin-bottom: 10px;
    }
}

@media (max-width: 575px) {
    .alumni_profile_name_college_other_detail_wrap.directory-detail .alumni_profile_brife_links {
        padding-left: 0;
    }
    .workExperienceRow .offer {
        border-left: 0px solid #d1d1d1;
        min-height: 0;
        margin-left: 50px;
        padding-left: 25px;
    }
}

.campus-activities-blue-section {
    background: #f2f9ff;
    border-radius: 6px;
    padding: 25px 35px;
}
.campus-activities-detail {
    display: flex;
    align-items: center;
}
.campus-activities-label {
    margin-right: 10px;
}
.campus-activities-block {
    background: #ffffff;
    border: 1px solid #7cb0d8;
    border-radius: 15px;
    height: 30px;
    padding: 0 20px;
    font-weight: 500;
    line-height: 28px;
}

.campus-activities-card {
    background: #ffffff;
    border: 1px solid #d5d5d5;
    border-radius: 6px;
    opacity: 1;
    padding: 18px;
    height: 100%;
    display: flex;
    flex-direction: column;
}
.tag-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: auto;
}
.tag {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
    background-repeat: no-repeat;
    background-position: center;
    background-size: 17px;
    width: 17px;
    height: 17px;
    display: block;
    margin-right: 5px;
}
.tag-wrap span {
    color: #414141;
}

.activities-card-title {
    font-size: 18px;
    font-weight: 500;
    border-bottom: 1px solid #e9e9e9;
    padding-bottom: 7px;
}

.campus-activities-edit {
    background: #f2f4f7;
    padding: 30px;
    border-radius: 6px;
    margin-top: 34px;
    height: calc(100% - 80px);
}
.campus-activities-edit .title {
    text-align: center;
    font-weight: 500;
    margin-bottom: 20px;
    font-size: 24px;
}
.campus-activities-edit .campus-activities-card {
    height: auto;
}

.campus-activities-edit label {
    margin-left: 5px;
    background: #ffffff;
    border: 1px solid #a8acaf;
    opacity: 1;
    width: 27px;
    height: 27px;
    border-radius: 50%;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.campus-activities-edit label:hover {
    background: #a8acaf;
}
.campus-activities-edit label .pencil-edit {
    background-size: 13px;
    filter: invert(61%) sepia(65%) saturate(7465%) hue-rotate(205deg) brightness(103%) contrast(101%);
    -webkit-filter: invert(61%) sepia(65%) saturate(7465%) hue-rotate(205deg) brightness(103%) contrast(101%);
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.campus-activities-edit label:hover .pencil-edit {
    background-size: 13px;
    filter: invert(100%) sepia(100%) saturate(20%) hue-rotate(333deg) brightness(104%) contrast(107%);
    -webkit-filter: invert(100%) sepia(100%) saturate(20%) hue-rotate(333deg) brightness(104%) contrast(107%);
}
.campus-activities-card-img {
    position: relative;
}
.campus-activities-card-img label {
    position: absolute;
    right: 5px;
    top: 5px;
}

.school_detail_left_pane {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
}
.school_profile_img {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background: #f1f1f1;
    display: flex;
    justify-content: center;
    align-items: end;
    margin-right: 15px;
}
.school_profile_img img {
    width: auto;
    height: 100%;
}
.school_profile_img.nopic img {
    height: 80%;
}

.school_profile_name_other_detail {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    flex-direction: column;
    width: calc(100% - 95px);
    justify-content: center;
}
.school_profile_college {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    align-items: center;
}
.school_profile_college_logo {
    width: 43px;
    height: 43px;
    padding: 5px;
    border: 1px solid #d2d2d2;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    margin-right: 5px;
}
.school_profile_college_logo img {
    width: 100%;
}
.school_profile_college_name {
    width: calc(100% - 48px);
    line-height: 16px;
    font-size: 14px;
    font-weight: 500;
}
.school_profile_name_other_detail h5 {
    font-size: 16px;
    margin: 0 0 5px;
}

.student_profile_status {
    list-style: none;
    margin: 0;
    padding: 0;
}
.student_profile_status li {
    margin-bottom: 16px;
    position: relative;
    padding-left: 16px;
}
.student_profile_status li .title {
    letter-spacing: 0.32px;
    color: #000000;
    font-size: 16px;
    line-height: 20px;
    display: inline-block;
}
.student_profile_status li p {
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: 0.32px;
}
.student_profile_status li:before {
    content: '';
    width: 3px;
    height: 17px;
    position: absolute;
    left: 0;
    top: 4px;
    background: #0b3454;
    border-radius: 5px;
}

.student_profile_status li .listed-points {
    padding: 0;
    margin: 4px 0 0;
    list-style: none;
}
.student_profile_status li .listed-points li {
    margin-bottom: 0;
    padding-left: 12px;
    line-height: 20px;
    font-weight: 500;
}
.student_profile_status li .listed-points li:before {
    width: 5px;
    height: 5px;
    background: #000;
    top: 8px;
}
.successful_journey * {
    position: relative;
}
.successful_journey {
    position: relative;
}
.successful_journey::before {
    content: '';
    background: transparent linear-gradient(180deg, #0b3454 0%, #ffffff 100%) 0% 0% no-repeat padding-box;
    border-radius: 4px 4px 0px 0px;
    opacity: 1;
    height: 320px;
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 0;
}
.successful_journey h3 {
    margin: 30px 0 25px;
    text-align: center;
    font-size: 16px;
    position: relative;
}
.successful_journey h3::before {
    content: '';
    position: absolute;
    width: 50px;
    height: 2px;
    background-color: #f1ac18;
    left: 0;
    right: 0;
    margin: auto;
    top: calc(100% + 7px);
}
.successful_journey h4 {
    color: #fff;
    margin: 20px 0 5px;
}
.successful_journey p {
    color: #fff;
    margin: 0px 0 5px;
    font-size: 16px;
}

@media (max-width: 991px) {
    .campus-activities-edit {
        height: auto;
        margin: 0;
    }
    .campus-activities-edit .campus-activities-card {
        max-width: 305px;
        margin: auto;
    }
}
@media (max-width: 575px) {
    .campus-activities-blue-section {
        padding: 20px 22px;
    }
}

.share-social-media {
    background: #fffae5;
    border: 1px dashed #e3dec8;
    border-radius: 6px;
    opacity: 1;
    margin-bottom: 20px;
}
.api-link {
    padding: 20px;
    border-bottom: 1px dashed #e3dec8;
}
.share-platform {
    padding: 20px;
}
.api-link-title {
    padding: 8px 10px 8px 20px;
    background: white;
    border-radius: 6px 0 0 6px;
    position: relative;
    margin-right: 15px;
}
.api-link-title:before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 100%;
    border-top: 20px solid transparent;
    border-bottom: 20px solid transparent;
    border-left: 10px solid white;
    width: 0;
    height: 0;
    margin: auto;
}
.link-url span {
    width: calc(100% - 29px);
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.link-url {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: start;
    max-width: 368px;
}
.link-url i {
    width: 21px;
    height: 21px;
    position: relative;
    display: inline-block;
    cursor: pointer;
    margin-left: 8px;
}
.link-url i:before {
    width: 13px;
    height: 17px;
    border-radius: 4px 0 0 0;
    border-top: 2px solid #0b3454;
    content: '';
    position: absolute;
    background: #fffae5;
    border-left: 2px solid #0b3454;
}
.link-url i:after {
    width: 16px;
    height: 21px;
    border-radius: 4px;
    border: 2px solid #0b3454;
    content: '';
    position: absolute;
    background: #fffae5;
    top: 4px;
    left: 4px;
}
.share-platform button {
    border: 0;
    background: transparent;
    width: 150px;
    height: 48px;
    border-radius: 6px;
    font-size: 18px;
    font-weight: 500;
    color: #fff;
    display: flex;
    align-items: center;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.share-platform button i img {
    vertical-align: top;
}
.share-platform button.btn-facebook {
    background-color: #3456a2;
    padding: 0 0 0 10px;
}
.share-platform button.btn-facebook:hover {
    background-color: #173371;
}
.share-platform button.btn-twitter {
    background-color: #01a1f9;
    padding: 0 0 0 6px;
}
.share-platform button.btn-twitter:hover {
    background-color: #1ca7f3;
}
.share-platform button.btn-linkedin {
    background-color: #0077b5;
    padding: 0 0 0 14px;
}
.share-platform button.btn-linkedin:hover {
    background-color: #004fb5;
}
.share-platform button.btn-linkedin i {
    filter: brightness(0) invert(1);
    display: flex;
    align-items: center;
    margin-right: 8px;
}

.alumni-directory .btn-refresh {
    border-radius: 25px;
    padding: 0 25px;
    background: #d82a2a;
    border: 2px solid #ffffff;
    height: 40px;
    color: #fff;
    display: flex;
    align-items: center;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.alumni-directory .btn-refresh i {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/refresh-page-option.svg) no-repeat
        center / 16px;
    width: 16px;
    height: 16px;
    margin-right: 8px;
    filter: brightness(0) invert(1);
    -webkit-filter: brightness(0) invert(1);
}
.alumni-directory .btn-refresh:hover {
    background: #fff;
    color: #d82a2a;
}
.alumni-directory .btn-refresh:hover i {
    filter: invert(31%) sepia(19%) saturate(7466%) hue-rotate(343deg) brightness(87%) contrast(95%);
    -webkit-filter: invert(31%) sepia(19%) saturate(7466%) hue-rotate(343deg) brightness(87%) contrast(95%);
}
.icon-down-arrow.left-arrow {
    transform: rotate(90deg);
    -webkit-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    -o-transform: rotate(90deg);
}
.icon-down-arrow.right-arrow {
    transform: rotate(-90deg);
    -webkit-transform: rotate(-90deg);
    -moz-transform: rotate(-90deg);
    -ms-transform: rotate(-90deg);
    -o-transform: rotate(-90deg);
}

.academic_detail {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    align-items: center;
}
.academic_detail .academic_logo {
    border: 1px solid #d2d2d2;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    margin-right: 10px;
}
.academic_detail .academic_name {
    font-size: 18px;
    font-weight: 500;
    line-height: 22px;
    width: calc(100% - 70px);
}

.border-0B3454 {
    border: 1px solid #0b3454;
}

.mail_alumni_wrap {
    background: transparent linear-gradient(179deg, #0b3454 0%, #c4c4c8 100%) 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 4px #0000000d;
    border-radius: 4px 4px 0px 0px;
    opacity: 1;
    color: #fff;
    margin-top: 20px;
}
.mail_alumni {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
}
.mail_alumni .mail_alumni_profile_img {
    width: 110px;
    height: 110px;
    border-radius: 50%;
    border: 2px solid #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 20px;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    -ms-border-radius: 50%;
    -o-border-radius: 50%;
}
.mail_alumni .mail_alumni_profile_img img {
    width: 100%;
}
.mail_alumni .mail_alumni_profile_detail h2 {
    font-size: 28px;
    margin: 0;
}
.mail_alumni .mail_alumni_profile_detail p {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
}
.mail_alumni .mail_alumni_profile_detail .icon-location-pin {
    margin-right: 3px;
}
.mail_alumni .mail_alumni_profile_detail ul {
    padding: 0 0 0 10px;
    list-style: none;
    line-height: 18px;
    position: relative;
    margin: 0;
}
.mail_alumni .mail_alumni_profile_detail ul:before {
    content: '';
    position: absolute;
    width: 3px;
    height: 100%;
    background: #fff;
    border-radius: 5px;
    top: 0;
    left: 0;
}
.compose_message p:last-child {
    margin: 0;
}

.alumni_univarsity_share {
    padding: 15px 20px;
}
.view_link {
    padding: 0 0 15px;
    text-align: center;
    display: flex;
    justify-content: center;
    border-bottom: 1px solid #d2d2d2;
    margin-bottom: 15px;
}
.alumni_univarsity_share .icon-mail {
    font-size: 0;
    width: 18px;
    height: 16px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/email_icon.svg) no-repeat center /
        100%;
}
.alumni_univarsity_share .icon-whatsapp {
    font-size: 0;
    width: 25px;
    height: 25px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/whatsapp.svg) no-repeat 0 0 / 100%;
}
.alumni_univarsity_share .icon-link {
    font-size: 0;
    width: 20px;
    height: 16px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/link.svg) no-repeat center / 100%;
}
.alumni_univarsity_share .icon-download {
    font-size: 0;
    width: 16px;
    height: 17px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/download_2.svg) no-repeat center /
        100%;
}
.alumni_univarsity_share a {
    margin: 0 15px;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    position: relative;
}
.alumni_univarsity_share a:hover {
    transform: translateY(-3px);
    -webkit-transform: translateY(-3px);
    -moz-transform: translateY(-3px);
    -ms-transform: translateY(-3px);
    -o-transform: translateY(-3px);
}

@media (max-width: 575px) {
    .mail_alumni .mail_alumni_profile_img {
        width: 70px;
        height: 70px;
    }
    .mail_alumni_profile_detail {
        width: calc(100% - 90px);
    }
    .mail_alumni .mail_alumni_profile_detail h2 {
        font-size: 26px;
        margin: 0 0 4px;
        line-height: 26px;
    }
}

.collateral-documents-wrap {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    margin-left: -10px;
    margin-right: -10px;
}
.documents-block {
    margin: 0 10px 20px;
    border: 1px solid #d5d5d5;
    border-radius: 6px;
    width: calc(20% - 20px);
    padding: 10px;
    display: flex;
    flex-direction: column;
}
.documents-block-image img {
    width: 100%;
}
.documents-block .alumni_univarsity_share {
    padding: 0;
}

.collateral-video-block {
    border: 1px solid #d5d5d5;
    border-radius: 6px;
    padding: 10px;
    height: 100%;
}
.video-block-image .video-btn {
    display: inline-block;
    width: 100%;
    position: relative;
    overflow: hidden;
    border-radius: 6px;
    vertical-align: top;
}
.video-block-image .video-btn .img-fluid {
    width: 100%;
}
.video-block-image .video-btn i {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    color: #fff;
    font-size: 35px;
    width: 35px;
    height: 35px;
}
.video-block-image .video-btn .time-line {
    position: absolute;
    right: 10px;
    bottom: 10px;
    background: #000000 0% 0% no-repeat padding-box;
    border-radius: 4px;
    color: #fff;
    font-size: 12px;
    padding: 0px 10px;
    height: 24px;
    display: flex;
    align-items: center;
}
.collateral-video-block .alumni_univarsity_share {
    padding: 0;
}

.pt-38 {
    padding-top: 38px;
}
.speaker-img-wrap {
    position: absolute;
    width: 60px;
    height: 60px;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.speaker-img {
    position: absolute;
    width: 60px;
    height: 60px;
    border: 3px solid #fff;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
}
.speaker-img img {
    width: auto;
    height: 100%;
}
.speaker-img-wrap label {
    position: absolute;
    top: -5px;
    right: -5px;
}
.album_contblk h3 {
    min-height: 49px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
.album_blk label.img-edit {
    position: absolute;
    top: 15px;
    right: 15px;
}

.btn-preview {
    background: #ffffff;
    border: 2px solid #7d7d7d;
    border-radius: 27px;
    height: 45px;
    color: #7d7d7d;
    font-weight: 500;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.btn-preview:hover {
    background-color: #7d7d7d;
    color: #fff;
}

.text-blue-0C4CBB {
    color: #0c4cbb;
}
.text-blue-0C4CBB:hover {
    color: #5cae48;
}

.upload_section input {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    width: 100%;
    opacity: 0;
    z-index: 1;
    background: red;
    cursor: pointer;
}

.alumni-img-wrap label {
    position: absolute;
    top: 0;
    right: 0;
}
.album_blk label {
    background: #ffffff;
    border: 1px solid #a8acaf;
    opacity: 1;
    width: 27px;
    height: 27px;
    border-radius: 50%;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.album_blk label:hover {
    background: #a8acaf;
}
.album_blk label .pencil-edit {
    background-size: 13px;
    filter: invert(61%) sepia(65%) saturate(7465%) hue-rotate(205deg) brightness(103%) contrast(101%);
    -webkit-filter: invert(61%) sepia(65%) saturate(7465%) hue-rotate(205deg) brightness(103%) contrast(101%);
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.album_blk label:hover .pencil-edit {
    background-size: 13px;
    filter: invert(100%) sepia(100%) saturate(20%) hue-rotate(333deg) brightness(104%) contrast(107%);
    -webkit-filter: invert(100%) sepia(100%) saturate(20%) hue-rotate(333deg) brightness(104%) contrast(107%);
}

.line-height-21 {
    line-height: 21px;
}

.promote-alumni-wrap {
    background: #f2f4f7;
    padding: 60px 0;
    margin-bottom: 44px;
}
.promote-share-it ul {
    list-style: none;
    padding: 0;
    margin: 0;
    max-width: 234px;
}
.promote-share-it ul li:not(:last-child) {
    margin-bottom: 10px;
}
.promote-share-it ul a {
    background: #ffffff;
    border: 1px solid #b6c8d8;
    border-radius: 20px;
    width: 100%;
    display: flex;
    height: 40px;
    align-items: center;
    text-decoration: none;
    color: #0b3454;
    font-size: 16px;
    font-weight: 500;
    padding: 0 19px 0 25px;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.promote-share-it ul a:hover {
    background: #b6c8d8;
}

.promote-share-it ul a i {
    width: 20px;
    height: 20px;
    margin-right: 12px;
}
.promote-share-it ul a i.mail {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/email.svg) no-repeat center / 100%;
    filter: invert(14%) sepia(69%) saturate(1363%) hue-rotate(182deg) brightness(90%) contrast(95%);
    -webkit-filter: invert(14%) sepia(69%) saturate(1363%) hue-rotate(182deg) brightness(90%) contrast(95%);
}
.promote-share-it ul a i.whatsapp {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/whatsapp.svg) no-repeat center / 100%;
}
.promote-share-it ul a i.link {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/link.svg) no-repeat center / 100%;
}
.promote-share-it ul a i.calender {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/blue-calender.svg) no-repeat center /
        100%;
}
.promote-share-it ul a span {
    flex: 1 1;
}

.promote-share-it ul a b.icon-double-arrow {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/double-right-arrows.svg) no-repeat
        center / 100%;
    width: 11px;
    height: 11px;
}
.promote-share-it ul a b.icon-copy {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/green-copy.svg) no-repeat center /
        100%;
    width: 15px;
    height: 15px;
}
.promote-share-it ul a b.icon-add {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/add-green.svg) no-repeat center /
        100%;
    width: 13px;
    height: 13px;
}

.promote-share-it ul a:hover b {
    filter: invert(0%) brightness(0%);
    -webkit-filter: invert(0%) brightness(0%);
}

.connect-block {
    background: #ffffff 0% 0% no-repeat padding-box;
    border: 1px solid #d9d9d9;
    border-radius: 6px;
    height: 100%;
    display: flex;
    flex-direction: column;
}
.connect-block-top {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    padding: 15px;
    border-bottom: 1px solid #d9d9d9;
    align-items: center;
    flex: 1 1;
}
.connect-block-top .icon {
    margin-right: 12px;
}
.connect-block-top .icon.calender {
    width: 31px;
    height: 30px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/google-calender.svg) no-repeat center /
        100%;
}
.connect-block-top .icon.office {
    width: 26px;
    height: 32px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/office.svg) no-repeat center / 100%;
}
.connect-block-top .icon.outlook {
    width: 33px;
    height: 31px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/outlook.svg) no-repeat center / 100%;
}
.connect-block-top .icon.icloud {
    width: 36px;
    height: 24px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/icloud-black.svg) no-repeat center /
        100%;
}
.connect-block-bottom {
    padding: 15px;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    justify-content: center;
}
.existing-calender h6 {
    font-size: 16px;
    margin: 0 0 3px;
}
.existing-calender span {
    font-size: 12px;
    line-height: 14px;
}
.existing-calender {
    flex: 1 1;
    display: flex;
    flex-direction: column;
}
.connect-block-bottom a {
    max-width: 120px;
    text-decoration: none;
}

@media (max-width: 1099px) {
    .documents-block {
        width: calc(25% - 20px);
    }
    .alumni_univarsity_share a {
        margin: 0 10px;
    }
}
@media (min-width: 767px) {
    .pt-md-38 {
        padding-top: 38px;
    }
}
@media (max-width: 767px) {
    .documents-block {
        width: calc(33.33% - 20px);
    }
}

@media (max-width: 575px) {
    .collateral-documents-wrap {
        margin-left: -5px;
        margin-right: -5px;
    }
    .documents-block {
        width: calc(50% - 10px);
        margin: 0 5px 10px;
    }
    .polartabsec + div.p-0 {
        padding-bottom: 0px !important;
    }
    .alumni_univarsity_share a {
        margin: 0 7px;
    }
}
.student-pref .edit_section + .custom_row {
    border-top: none;
}

.quill.editor {
    min-height: 330px;
    display: flex;
    flex-direction: column;
}
.quill.editor .ql-toolbar.ql-snow {
    border-radius: 6px 6px 0 0;
}
.quill.editor .ql-container.ql-snow {
    flex: 1 1;
    font-size: 16px;
}
.quill.editor .ql-container.ql-snow p {
    margin-bottom: 15px;
}

.btn-clearBtn {
    background: #cd0000;
    height: 40px;
    padding: 0 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    text-decoration: none;
    font-size: 16px;
    line-height: 16px;
    font-weight: 500;
    position: relative;
    overflow: hidden;
    border: 0;
    border-radius: 27px;
    -webkit-border-radius: 27px;
    -moz-border-radius: 27px;
    -ms-border-radius: 27px;
    -o-border-radius: 27px;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.btn-clearBtn:hover {
    background: #a30000;
    color: #fff;
}
.btn-clearBtn i {
    padding: 0;
    width: 18px;
    height: 18px;
    filter: invert(1);
    -webkit-filter: invert(1);
    margin-right: 5px;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    background: transparent
        url(${___CSS_LOADER_URL_REPLACEMENT_4___})
        0 0 / 18px auto no-repeat;
}

/* css30042024  */

.circle-right {
    position: relative;
    width: 48px;
    height: 48px;
    margin: auto;
    background: #5cae48;
    border-radius: 50%;
}
.circle-right:before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 20px;
    height: 12px;
    border-left: 5px solid #fff;
    border-bottom: 5px solid #fff;
    transform: rotate(-45deg);
}

.college_blk {
    background: #ffffff;
    border: 1px solid #d2d2d2;
    border-radius: 6px;
    opacity: 1;
    overflow: hidden;
}
.college_blk .collegeName {
    padding: 18px 20px;
    position: relative;
}
.college_blk .collegeName h3 {
    font-size: 18px;
    font-weight: 600;
    line-height: 23px;
    margin-bottom: 8px;
}
.college_blk .collegeName i {
    color: #26a7df;
    font-size: 16px;
}
.college_detail_price i.icon-book {
    color: #f05a2a;
}
.college_blk .collegeName .tick {
    font-style: italic;
    color: #0b3454;
}
.college_blk .college_detail {
    background: #0b3454;
    padding: 20px;
    color: #fff;
}
.college_blk:not(:last-child) {
    margin-bottom: 23px;
}
.college_detail_price_deadline {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
}
.college_detail_price_deadline > div {
    width: 50%;
    margin-bottom: 20px;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
}
.college_detail_price_deadline > div .icon {
    width: 40px;
    height: 40px;
    background: #fff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #db852b;
    box-shadow: 0px 3px 6px #00000029;
}
/* .college_detail_price_deadline > div .icon .icon-dollor { width: 16px; height: 23px; background: url(../images/mask-group-133.svg) no-repeat 0 0; filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%); -webkit-filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%); } */

.college_detail_price_deadline > div .icon .icon-dollor {
    width: 11px;
    height: 20px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/dolar.svg) no-repeat 0 0;
    filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);
    -webkit-filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);
}
.college_detail_price_deadline > div .icon .icon-canadian-dollar {
    width: 18px;
    height: 18px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/canadian-dollar.svg) no-repeat 0 0;
    filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);
    -webkit-filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);
}
.college_detail_price_deadline > div .icon .icon-yen-symbol {
    width: 12px;
    height: 16px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/yen-symbol.svg) no-repeat 0 0;
    filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);
    -webkit-filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);
}
.college_detail_price_deadline > div .icon .icon-australian-dollar {
    width: 17px;
    height: 15px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/australian-dollar.svg) no-repeat 0 0;
    filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);
    -webkit-filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);
}
.college_detail_price_deadline > div .icon .icon-euro {
    width: 12px;
    height: 15px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/euro.svg) no-repeat 0 0;
    filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);
    -webkit-filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);
}
.college_detail_price_deadline > div .icon .icon-franc {
    width: 11px;
    height: 13px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/franc.svg) no-repeat 0 0;
    filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);
    -webkit-filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);
}
.college_detail_price_deadline > div .icon .icon-great-britain-pound {
    width: 10px;
    height: 14px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/great-britain-pound.svg) no-repeat 0
        0;
    filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);
    -webkit-filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);
}
.college_detail_price_deadline > div .icon .icon-hong-kong-dollar {
    width: 20px;
    height: 12px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/hong-kong-dollar.svg) no-repeat 0 0;
    filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);
    -webkit-filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);
}
.college_detail_price_deadline > div .icon .icon-malaysian-ringgit {
    width: 15px;
    height: 12px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/malaysian-ringgit.svg) no-repeat 0 0;
    filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);
    -webkit-filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);
}
.college_detail_price_deadline > div .icon .icon-new-zealand-dollar {
    width: 21px;
    height: 11px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/new-zealand-dollar.svg) no-repeat 0 0;
    filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);
    -webkit-filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);
}
.college_detail_price_deadline > div .icon .icon-rupee-indian {
    width: 11px;
    height: 17px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/rupee-indian.svg) no-repeat 0 0;
    filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);
    -webkit-filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);
}
.college_detail_price_deadline > div .icon .icon-singapore-dollar {
    width: 18px;
    height: 18px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/singapore-dollar.svg) no-repeat 0 0;
    filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);
    -webkit-filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);
}
.college_detail_price_deadline > div .icon .icon-united-arab-emirates-dirham {
    width: 16px;
    height: 9px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/united-arab-emirates-dirham.svg)
        no-repeat 0 0;
    filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);
    -webkit-filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);
}
.college_detail_price_deadline > div .icon .icon-open-book,
.icon-open-book {
    width: 18px;
    height: 15px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/open-book.svg) no-repeat 0 0;
    filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);
    -webkit-filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);
    background-size: cover;
}
.college_detail_price_deadline > div .icon + div {
    line-height: 19px;
}

.college_blk_left {
    flex: 1 1;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
}
.college_blk_right {
    display: flex;
    align-items: end;
}
.college_blk_right .icon-down-arrow {
    display: none;
}
.college_blk_right .btn-green:after {
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    border: 0;
}
.college_blk .collegeName .college_blk_left .college_detail_price i.icon-book {
    color: #d97d1d;
}
.college_blk .collegeName .college_blk_left .icon-hat {
    filter: invert(57%) sepia(68%) saturate(1168%) hue-rotate(165deg) brightness(90%) contrast(92%);
    -webkit-filter: invert(57%) sepia(68%) saturate(1168%) hue-rotate(165deg) brightness(90%) contrast(92%);
    vertical-align: top;
    margin-top: 2px;
}
.college_blk_right .toggle-link {
    position: relative;
}
.college_blk_right .toggle-link a + i {
    position: absolute;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 0px solid #368124;
    left: 0;
    right: 0;
    margin: auto;
    width: 0;
    height: 0;
    top: 100%;
    transition: all 0.3s ease-in-out;
}
.college_blk_right .toggle-link a[aria-expanded='true'] + i {
    border-top: 7px solid #368124;
}

.listed-subject {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.listed-subject ul {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}
.listed-subject ul li {
    background: #ffffff;
    border-radius: 20px;
    padding: 7px 20px;
    color: #000;
    font-size: 15px;
    font-weight: 500;
    margin: 0 5px 5px 0;
}
.listed-subject .cut-off {
    margin: 0 5px 5px 5px;
    font-size: 14px;
    font-style: italic;
}

.select-toggle {
    position: absolute;
    top: 10px;
    right: 10px;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
}
.select-toggle > a {
    width: 20px;
    height: 20px;
    background: #0d345333;
    border-radius: 50%;
    position: relative;
}
.select-toggle .btn-add-toggle {
    margin-right: 10px;
}
.select-toggle .btn-add-toggle:before {
    content: '';
    position: absolute;
    width: 10px;
    height: 2px;
    background: #fff;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    margin: auto;
    border-radius: 10px;
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    -ms-border-radius: 10px;
    -o-border-radius: 10px;
}
.select-toggle .btn-add-toggle:after {
    content: '';
    position: absolute;
    width: 2px;
    height: 10px;
    background: #fff;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    margin: auto;
    border-radius: 10px;
}
.select-toggle > a.btn-select-toggle::before {
    content: '';
    position: absolute;
    width: 10px;
    height: 5px;
    border-left: 2px solid #fff;
    border-bottom: 2px solid #fff;
    left: 5px;
    top: 7px;
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
    -moz-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    -o-transform: rotate(-45deg);
}

.college_blk .college {
    background: #fff;
    padding: 10px 20px;
    border-radius: 6px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    transition: all 0.3s ease-in-out;
}
.college_blk .college:hover {
    box-shadow: 0px 0px 6px #0000001a;
}
.college_blk .college:not(:last-child) {
    margin-bottom: 5px;
}
.college_blk .icon-anchor {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/maximize.svg);
    width: 13px;
    height: 13px;
    display: inline-block;
    transition: all 0.3s ease-in-out;
}
.college_blk .college:hover .icon-anchor {
    filter: invert(66%) sepia(20%) saturate(1333%) hue-rotate(63deg) brightness(87%) contrast(80%);
    webkit-filter: invert(66%) sepia(20%) saturate(1333%) hue-rotate(63deg) brightness(87%) contrast(80%);
}
.college_blk .college .college-brife {
    flex: 1 1;
    margin-right: 20px;
    color: #000;
}
.college_blk .collegeName i.icon-medal {
    filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);
    -webkit-filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);
}

.college_detail .btn-viewdetail {
    max-width: 220px;
    background: #fff;
    width: 90%;
    margin: 18px auto auto; /*border: 2px solid #7D7D7D;*/
    border-radius: 20px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease-in-out;
}
.college_detail .btn-viewdetail:hover {
    background: #5cae48;
    color: #fff;
}

.deadlines-list .college_detail {
    background: #fff;
    padding-top: 0;
}
.deadlines-list .college_blk .college {
    background: #153d5b;
}
.deadlines-list .college_blk .college .college-brife {
    color: #fff;
}
.deadlines-list .college_detail .btn-viewdetail {
    background: #5cae48;
    color: #fff;
}
.deadlines-list .college_detail .btn-viewdetail:hover {
    background: #398227;
}

.toggle-link a.btn-green[aria-expanded='true']::before {
    width: 100%;
    transition: all 0.3s ease-in-out;
}
.toggle-link a.btn-green[aria-expanded='true'] span.icon-down-arrow {
    transform: rotate(180deg);
}
.toggle-link a.btn-green span.icon-down-arrow {
    transition: all 0.3s ease-in-out;
}

.btn.btn-accordion[aria-expanded='true'] {
    transform: rotate(180deg);
}
.btn.btn-accordion {
    transition: all 0.3s ease-in-out;
}
.college_blk .collegeName > .toggle-link.round-toggle {
    position: absolute;
    top: 0;
    right: 20px;
    bottom: 0;
    margin: auto !important;
    width: 48px !important;
    height: 48px;
}
.college_blk .collegeName > .toggle-link .btn.btn-accordion {
    border: 2px solid #0b345433;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    position: static;
}
.colondetailRow {
    display: flex;
    flex-wrap: wrap;
}
.colondetailRowLabel {
    width: 140px;
    font-size: 14px;
}
.colondetailRow .colon {
    margin: 0 20px;
}
.colondetailRowBrife {
    font-weight: 600;
}
.colondetailRow:not(:last-child) {
    margin-bottom: 15px;
}
.colondetail {
    margin: 5px 0;
}

.college-brife a {
    color: #0b3454;
    text-decoration: none;
    transition: all 0.3s ease-in-out;
}
.college-brife a:hover {
    color: #414141;
}

.btn-reset {
    box-shadow: 0px 0px 0px #0b34541a;
    border: 0px solid #b5c1cb;
    border-radius: 25px;
    width: 70px;
    height: 32px;
    line-height: 30px;
    padding: 0;
    font-size: 15px;
    font-weight: 500;
    background: none;
}
.btn-reset:hover {
    background: none;
    color: #0b3454;
}
.btn-reset i {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/arrow-circle.svg);
    width: 12px;
    height: 14px;
    display: inline-block;
    margin-right: 5px;
}

.compareCollegeswrap {
    background: #fff;
    border-radius: 5px;
    padding: 40px 30px 10px 5%;
}
.tabular-data {
    position: relative;
}
.heading {
    height: 99px;
}
.collegeBlock {
    background: #fff;
    border-radius: 5px;
    overflow: hidden;
    border: 1px solid #ececec;
}
.tabular-data .content {
    min-height: 60px;
    display: flex;
    width: 100%;
    align-items: center;
}
.tabular-data .collegeBlock .content {
    justify-content: center;
}
.tabular-data .mobile-scroll .content span {
    padding: 0 25px;
    font-family: 'Jost', sans-serif !important;
    font-size: 16px;
    text-align: center;
}
.tabular-data div:not(.mobile-scroll) .content span {
    font-weight: 500;
    font-family: 'Jost', sans-serif;
    font-size: 16px;
}
.tabular-data .collegeBlock .content:nth-child(2n + 1) {
    background: #f6f6f6;
}
.tabular-data .collegeBlock .content:not(:last-child) {
    border-bottom: 1px solid #ececec;
}
.collegeBlock .heading {
    border-bottom: 1px solid #ececec;
    position: relative;
    background: #0b3454;
    color: #fff;
    padding: 25px 12px 0;
}
.collegeBlock .heading .icon.icon-checked {
    width: 15px;
    height: 15px;
    position: absolute;
    background: #fff;
    border-radius: 50%;
    left: 12px;
    top: 28px;
    display: none;
}
.icon.icon-checked {
    width: 15px;
    height: 15px;
    position: absolute;
    background: #fff;
    border-radius: 50%;
    left: 12px;
    top: 28px;
    display: none;
}
.collegeBlock .heading .compare_add {
    width: 15px;
    height: 15px;
    display: inline-block;
    background: #fff;
    border-radius: 50%;
    margin-top: 3px;
    position: relative;
}
.collegeBlock .heading .compare_add:before {
    content: '';
    position: absolute;
    width: 9px;
    height: 5px;
    border-left: 2px solid #0b3454;
    border-bottom: 2px solid #0b3454;
    transform: rotate(-45deg);
    top: 4px;
    left: 3px;
    -webkit-transform: rotate(-45deg);
    -moz-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    -o-transform: rotate(-45deg);
}
.collegeBlock .heading .btn-close-small {
    width: 10px;
    height: 10px;
    padding: 0 !important;
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 9;
    opacity: 1;
}
.collegeBlock .close.closetag {
    position: absolute;
    top: 0px;
    right: 7px;
}
.collegeBlock .close.closetag i {
    color: #fff;
}
.tabular-data .content.admChanceDiv[style*='block'] {
    display: flex !important;
}
.tabular-data .content.ranking {
    flex-direction: column;
    align-items: self-start;
    justify-content: center;
}
.tabular-data .collegeBlock .content.ranking {
    align-items: center;
}
.tabular-data .collegeBlock .content a {
    background: #e6e6e6;
    padding: 8px 20px;
    border-radius: 25px;
    color: #185094;
    text-decoration: none;
    min-width: 110px;
    width: 100%;
    display: inline-block;
    transition: all 0.3s ease-in-out;
    font-weight: 500;
    font-family: 'Jost', sans-serif;
}
.tabular-data .collegeBlock .content a:hover {
    background: #185094;
    color: #fff;
}
.collegeBlock h6 span {
    font-size: 20px;
    font-weight: 500;
}
.collegeBlock .heading h6 i {
    font-size: 16px;
}
.compare_add.added i {
    color: #f4ad17;
}
#checkChanceBlockDiv {
    display: none !important;
}
.btn-load {
    border: 1px solid #e1e1e1;
    background: #f8f8f8;
    border-radius: 3px;
    font-size: 16px;
    color: #414141;
}
.blue-text {
    color: #2680eb;
}

.btn-play {
    color: #0b3454 !important;
}
.btn-play:hover {
    color: #5cae48 !important;
    opacity: 1 !important;
}

@media (max-width: 1199px) {
    .mobile-scroll {
        overflow: auto;
    }
    .mobile-scroll > .row {
        width: 730px;
    }
    .college_blk .collegeName .toggle-link {
        width: 100%;
        margin-top: 15px;
        order: 1;
    }
}

@media (max-width: 575px) {
    .tabular-data div:not(.mobile-scroll) .content span {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
}

/* .pagination_custom */

.pagination-div .pagination {
    list-style: none;
    height: 31.5px;
    /* width: 31.5px; */
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 2px;
    cursor: pointer;
}

.pagination-div .active div {
    background-color: #5cae48;
    color: #fff;
    border-radius: 50%;
}

.pagination-div .page-item {
    list-style: none;
    padding: 0;
    margin: 0 5px;
}
.pagination-div .page-item div {
    height: 31.5px;
    width: 31.5px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.pagination-div .previous button {
    width: 32px;
    height: 32px;
    background: #a3a3a3;
    border-radius: 50%;
    margin: 0 5px;
    position: relative;
    border: none;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    -ms-border-radius: 50%;
    -o-border-radius: 50%;
}
.pagination-div .previous button:before {
    content: '';
    position: absolute;
    width: 8px;
    height: 8px;
    border-top: 3px solid #fff;
    border-right: 3px solid #fff;
    transform: rotate(-135deg);
    top: 12px;
    left: 13px;
    -webkit-transform: rotate(-135deg);
    -moz-transform: rotate(-135deg);
    -ms-transform: rotate(-135deg);
    -o-transform: rotate(-135deg);
}
.pagination-div .next button {
    width: 32px !important;
    height: 32px;
    background: #a3a3a3;
    border-radius: 50%;
    margin: 0 5px;
    position: relative;
    border: none;
}
.pagination-div .next button:before {
    content: '';
    position: absolute;
    width: 8px;
    height: 8px;
    border-top: 3px solid #fff;
    border-right: 3px solid #fff;
    transform: rotate(-135deg);
    top: 12px;
    left: 13px;
    -webkit-transform: rotate(-135deg);
    -moz-transform: rotate(-135deg);
    -ms-transform: rotate(-135deg);
    -o-transform: rotate(-135deg);
}
.heading-search .custom-select {
    border: 1px solid #e6e6e6 !important;
    border-radius: 4px;
    height: 45px !important;
}
.heading-search .custom-select div[class*='singleValue'],
.heading-search .custom-select div[id*='placeholder'] {
    padding-left: 5px;
}

.search_college i {
    position: absolute;
    right: -22px;
    top: 18px;
    font-size: 12px;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    cursor: pointer;
}
.search_college {
    overflow: hidden;
}
.search_college .form-control:valid ~ i {
    right: 15px;
}
.search_college .form-search {
    padding: 0 30px 0 35px !important;
}
.icon-loan {
    width: 20px;
    height: 24px;
    display: inline-block;
    background-image: url('https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/loan.svg');
}

.btn-holder {
    width: 181px;
}

/* manage-widget css */

.bg-blue-164F88 {
    background-color: #164f88;
}
.bg-blue-083461 {
    background-color: #083461;
}
.bg-gray-F2F4F7 {
    background-color: #f2f4f7;
}
.bg-gray-EFEFEF {
    background-color: #efefef;
}
.bg-yellow-FFFAE5 {
    background-color: #fffae5;
}
.text-yellow {
    color: #f5ae18 !important;
}
.cursor-pointer {
    cursor: pointer;
}
.white-filter {
    filter: brightness(0) invert(1);
    -webkit-filter: brightness(0) invert(1);
}

.form-control.form-search.form-gray-search {
    background-color: #f2f4f7;
    border: none;
    color: #000;
}
.form-control.form-search.form-gray-search::placeholder {
    color: #000;
}
.opacity-7 {
    opacity: 0.7;
}

.guiding_alumni_block {
    background: #ffffff;
    border: 1px solid #dcdcdc;
    border-radius: 4px;
    opacity: 1;
    padding: 20px;
    max-width: 270px;
    transition: all 0.7s ease-in-out;
    -webkit-transition: all 0.7s ease-in-out;
    -moz-transition: all 0.7s ease-in-out;
    -ms-transition: all 0.7s ease-in-out;
    -o-transition: all 0.7s ease-in-out;
}
.active .guiding_alumni_block {
    transform: translatey(0%);
    -webkit-transform: translatey(0%);
    -moz-transform: translatey(0%);
    -ms-transform: translatey(0%);
    -o-transform: translatey(0%);
}
.guiding_alumni_block .guiding_alumni_top {
    display: flex;
    flex-direction: column;
    align-items: center;
    border-bottom: 1px solid #e2e2e2;
    padding-bottom: 12px;
}
.guiding_alumni_profile_img_wrap {
    position: relative;
    width: 80px;
    height: 80px;
    margin-bottom: 8px;
}
.guiding_alumni_profile_img_wrap .guiding_alumni_profile_img {
    margin: 0;
}
.guiding_alumni_profile_img_wrap label {
    background: #27a7df;
    border: 1px solid #fff;
    opacity: 1;
    width: 27px;
    height: 27px;
    border-radius: 50%;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    position: absolute;
    right: 0;
    bottom: 0;
}
.guiding_alumni_profile_img_wrap label .pencil-edit {
    filter: brightness(0) invert(1);
    width: 13px;
    height: 13px;
    background-size: 100%;
    -webkit-filter: brightness(0) invert(1);
}
.guiding_alumni_block .guiding_alumni_top .guiding_alumni_profile_img {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    overflow: hidden;
    margin-bottom: 8px;
}
.guiding_alumni_block .guiding_alumni_top .guiding_alumni_profile_name {
    font-size: 20px;
    line-height: 26px;
    font-weight: 600;
    color: #0b3454;
    text-align: center;
}

.guiding_alumni_college_cource {
    padding-top: 14px;
}
.guiding_alumni_college_cource ul {
    padding: 0;
    margin: 0;
    list-style: none;
    font-size: 14px;
}
.guiding_alumni_college_cource ul li:not(:last-child) {
    margin-bottom: 12px;
}
.guiding_alumni_college_cource ul li {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    color: #000;
    font-weight: 500;
}
.guiding_alumni_college_cource ul li i{width: 24px;height: 24px;margin-right: 8px;padding-top: 2px;}
.guiding_alumni_college_cource ul li i.college {
    width: 24px;
    height: 24px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/small-school.svg) no-repeat center;
    margin-right: 8px;
}
.guiding_alumni_college_cource ul li i.brifecase {
    width: 24px;
    height: 24px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/small-brifecase.svg) no-repeat center;
    margin-right: 8px;
}
.guiding_alumni_college_cource ul li i.tool {
    width: 24px;
    height: 24px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/tool.svg) no-repeat center;
    margin-right: 8px;
}
.guiding_alumni_college_cource ul li i.cap {
    width: 24px;
    height: 24px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/graduation-cap.svg) no-repeat center /
        100% !important;
    margin-right: 8px;
}
.guiding_alumni_college_cource ul li i.star {
    width: 24px;
    height: 24px;
    background-color: #fff;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
    background-repeat: no-repeat;
    background-position: center;
    background-size: 18px 18px !important;
    margin-right: 8px;
}
.guiding_alumni_college_cource ul li i.badge {
    width: 24px;
    height: 24px;
    background-color: transparent;
    background-image: url("https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/medal.svg");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 21px !important;
    margin-right: 8px;
    display: block;
}
.guiding_alumni_college_cource ul li i {
    font-size: 18px;
    background-size: 20px !important;
}
.guiding_alumni_college_cource ul li span {
    width: calc(100% - 32px);
    text-align: left;
    font-size: 14px;
    line-height: 17px;
    vertical-align: top;
    margin: 4px 0 0;
}
.guiding_alumni_college_cource ul li span b {
    display: block;
    font-weight: 400;
}

#WidgetsAlumniCarousel .guiding_alumni_block {
    transform: translatey(-150%);
    -webkit-transform: translatey(-150%);
    -moz-transform: translatey(-150%);
    -ms-transform: translatey(-150%);
    -o-transform: translatey(-150%);
}
#WidgetsAlumniCarousel .active .guiding_alumni_block {
    transform: translatey(0%);
    -webkit-transform: translatey(0%);
    -moz-transform: translatey(0%);
    -ms-transform: translatey(0%);
    -o-transform: translatey(0%);
}
#WidgetsAlumniCarousel .bg-white {
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
#WidgetsAlumniCarousel .owl-nav {
    width: 57.5%;
    display: flex;
    justify-content: space-around;
    margin-top: 25px;
    margin-left: auto;
}
#WidgetsAlumniCarousel.owl-carousel .owl-nav button {
    border-radius: 25px;
    padding: 0 25px !important;
    line-height: 32px;
    border: 2px solid #7d7d7d;
    height: 40px;
    display: inline-flex;
    text-decoration: none;
    color: #000;
    transition: all 0.3s ease-in-out;
    position: relative;
    overflow: hidden;
    justify-content: center;
    align-items: center;
    background: #fff;
}
#WidgetsAlumniCarousel.owl-carousel .owl-nav button:hover {
    background: #7d7d7d;
    color: #fff;
}
#WidgetsAlumniCarousel.owl-carousel .owl-nav button span {
    font-size: 28px;
    display: inline-block;
    line-height: 0;
    vertical-align: top;
    margin: -4px 0 0;
}
#WidgetsAlumniCarousel.owl-carousel .owl-nav button.owl-prev:after {
    content: 'Previous Profile';
    margin-left: 7px;
}
#WidgetsAlumniCarousel.owl-carousel .owl-nav button.owl-next:before {
    content: 'Next Profile';
    margin-right: 7px;
}
#WidgetsAlumniCarousel .owl-dots {
    display: none;
}

.owl-carousel .owl-stage {
    display: flex;
}
.owl-carousel .owl-stage .item {
    height: 100%;
}

.embed-wrap hr {
    border-bottom: 1px dashed #201a00;
    background: none;
}

.fourcardslider .owl-nav,
.twocardslider .owl-nav {
    text-align: left;
    display: flex;
}
.fourcardslider .owl-nav button,
.twocardslider .owl-nav button {
    width: 40px;
    height: 40px;
    background: #fff !important;
    font-size: 20px !important;
    display: flex !important;
    align-items: center;
    justify-content: center;
}
.fourcardslider .owl-nav button span,
.twocardslider .owl-nav button span {
    font-size: 40px !important;
    margin: -7px 0 0;
    vertical-align: top;
}
.owl-theme.fourcardslider .owl-nav,
.owl-theme.twocardslider .owl-nav [class*='owl-']:hover {
    color: #0b3454;
}

.icon-eye {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/eye.svg) no-repeat 0 0 / 100%;
    width: 32px;
    height: 20px;
    display: block;
}
.icon-eye-black {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/eye.svg) no-repeat 0 0 / 100%;
    width: 32px;
    height: 20px;
    display: block;
    filter: brightness(0) invert(0);
    -webkit-filter: brightness(0) invert(0);
}

.ratio20 {
    width: 20px;
    height: 20px;
}

.navdotnone .owl-nav,
.navdotnone .owl-dots {
    display: none !important;
}
.btn-border-add {
    border-radius: 25px;
    padding: 0 25px !important;
    line-height: 32px;
    border: 1px solid #c1c1c1;
    height: 40px;
    display: inline-flex;
    text-decoration: none;
    color: #27a7df;
    transition: all 0.3s ease-in-out;
    position: relative;
    overflow: hidden;
    justify-content: center;
    align-items: center;
    background: #fff;
}
.btn-border-add i {
    display: flex;
}
.btn-border-add:hover {
    background-color: #27a7df;
    border: 1px solid #27a7df;
    color: #fff;
}
.btn-border-add:hover i {
    filter: brightness(0) invert(1);
    -webkit-filter: brightness(0) invert(1);
}
a.text-skyblue {
    color: #27a7df;
}
a.text-skyblue:hover {
    color: #0b3454;
}

.Vertical-graph-block {
    background: #ffffff 0% 0% no-repeat padding-box;
    border: 1px solid #dcdcdc;
    border-radius: 6px;
    padding: 30px;
    width: 100%;
    max-width: 400px;
}
.Vertical-graph-block.max-450 {
    max-width: 450px;
}
.Vertical-graph-block h2 {
    text-align: center;
    font-size: 24px;
    color: #000;
    font-weight: 600;
    margin-bottom: 20px;
    display: flex;
    align-content: center;
    justify-content: center;
}
.Vertical-graph-block h2 .pencil-edit {
    filter: invert(53%) sepia(95%) saturate(1016%) hue-rotate(165deg) brightness(94%) contrast(86%);
    -webkit-filter: invert(53%) sepia(95%) saturate(1016%) hue-rotate(165deg) brightness(94%) contrast(86%);
}
.Vertical-graph-block h2 a {
    margin-left: 8px;
}
.Vertical-graph-block .bigVerticalProgress {
    justify-content: center;
}
.Vertical-graph-block .bigVerticalProgress .verticleProgress {
    padding: 0 8px;
    width: auto;
    margin: 0;
}
.Vertical-graph-block .bigVerticalProgress .graphContainer .progress {
    width: 40px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    position: relative;
    overflow: visible;
    border-radius: 0;
    -webkit-border-radius: 0;
    -moz-border-radius: 0;
    -ms-border-radius: 0;
    -o-border-radius: 0;
}
.Vertical-graph-block .bigVerticalProgress .graphContainer .progress.lite-blue {
    background-color: #def3fc;
}
.Vertical-graph-block .bigVerticalProgress .graphContainer .progress.lite-blue .progress-bar {
    border-radius: 0;
    -webkit-border-radius: 0;
    -moz-border-radius: 0;
    -ms-border-radius: 0;
    -o-border-radius: 0;
    background-color: #27a7df;
}
.Vertical-graph-block .bigVerticalProgress .graphContainer .progress.lite-red {
    background-color: #fff2f4;
}
.Vertical-graph-block .bigVerticalProgress .graphContainer .progress.lite-red .progress-bar {
    border-radius: 0;
    -webkit-border-radius: 0;
    -moz-border-radius: 0;
    -ms-border-radius: 0;
    -o-border-radius: 0;
    background-color: #d42941;
}
.Vertical-graph-block .bigVerticalProgress .graphContainer .progress .progresstext {
    position: absolute;
    bottom: 100%;
    left: 0;
    right: 0;
    margin: auto;
    text-align: center;
}

.Vertical-graph-block .HorizontalProgress {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
}
.Vertical-graph-block .HorizontalProgress .graphContainer {
    flex: 1 1;
    padding-right: 30px;
    position: relative;
}
.Vertical-graph-block .HorizontalProgress .caption {
    width: 90px;
    text-align: right;
    margin-right: 10px;
    line-height: 16px;
}
.Vertical-graph-block .HorizontalProgress:not(:last-child) {
    margin-bottom: 10px;
}
.Vertical-graph-block .HorizontalProgress .graphContainer .progress {
    height: 40px;
    border-radius: 0;
}
.Vertical-graph-block .HorizontalProgress .graphContainer .progress.lite-orange {
    background-color: #fff4dc;
}
.Vertical-graph-block .HorizontalProgress .graphContainer .progress.lite-orange .progress-bar {
    background-color: #f5ae18;
}
.Vertical-graph-block .HorizontalProgress .graphContainer .progress .progresstext {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
    right: -10px;
    line-height: 40px;
    font-weight: 500;
    font-size: 16px;
}

.btn-trash-right {
    position: absolute;
    top: 13px;
    right: -18px;
    width: 15px;
    height: 15px;
    background-position: center;
    background-size: 15px;
}

.top-college-wrap {
    max-width: 850px;
    width: 96%;
    margin: auto;
    text-align: center;
}
.top-college-wrap .nav {
    background: #164f88;
    border-radius: 6px;
    max-width: 720px;
    margin: auto;
    justify-content: space-between;
}
.top-college-wrap .nav button {
    height: 50px;
    color: #fff;
}
.top-college-wrap .nav button.active {
    background: #f5ae18;
    color: #000;
}
.logo-block {
    background: #ffffff 0% 0% no-repeat padding-box;
    border: 1px solid #c8c8c8;
    border-radius: 6px;
    padding: 20px;
    width: 158px;
    height: 100%;
}
.logo-block .logo-img {
    margin-bottom: 10px;
    display: flex;
    align-items: end;
    justify-content: center;
}
.logo-block .logo-img img {
    width: auto;
}

.top-college-wrap .top-colleges-slider .owl-nav {
    margin-top: 0;
}
.top-college-wrap .top-colleges-slider .owl-nav button {
    position: absolute;
    top: 0;
    bottom: 0;
    background: #fff;
    width: 40px;
    height: 40px;
    border-radius: 3px;
    border: none;
    margin: auto;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
}
.top-college-wrap .top-colleges-slider .owl-nav button:hover {
    background-color: #000;
}
.top-college-wrap .top-colleges-slider .owl-nav button span {
    font-size: 40px;
    vertical-align: top;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 34px;
    margin: -5px 0 0;
}
.top-college-wrap .top-colleges-slider .owl-nav button.owl-prev {
    left: -60px;
}
.top-college-wrap .top-colleges-slider .owl-nav button.owl-next {
    right: -60px;
}
.top-college-wrap .top-colleges-slider .owl-nav button.disabled {
    opacity: 0.3;
}

.max-500 {
    width: 96%;
    max-width: 500px;
}

.btn-skyblue {
    height: 30px;
    background: #27a7df;
    margin: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    border-radius: 25px;
    font-weight: 500 !important;
    cursor: pointer;
    border: 0;
    padding: 5px 20px;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    text-decoration: none !important;
}
.btn-skyblue:hover {
    background-color: #0b3454;
    color: #fff;
}

.modal .colleges-list {
    max-height: 340px;
    overflow: auto;
}
.modal .colleges-list ul {
    margin: 0;
    padding: 0;
}
.modal .colleges-list ul li {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
}
.modal .colleges-list ul li:not(:last-child) {
    margin-bottom: 15px;
    padding-bottom: 15px;
    border-bottom: 1px solid #ccc;
}
.modal .colleges-list ul li .logoImg {
    width: 90px;
    margin-right: 15px;
}
.modal .colleges-list ul li .logoName {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: calc(100% - 105px);
}
.modal .colleges-list ul li .logoName p {
    margin: 0;
    font-size: 18px;
    font-weight: 500;
}
.modal .colleges-list ul li .logoName span {
    font-style: italic;
}
.modal .colleges-list ul li .logoImg.w-150 {
    width: 150px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
}
.modal .colleges-list ul li .logoImg + div {
    display: flex;
    align-items: center;
}
.modal .colleges-list ul li .logoImg + div p {
    margin: 0;
}

.leftPaneTab {
    max-width: 280px;
    text-align: left;
}
.leftPaneTab .nav-link {
    text-align: left;
    background: #164f88;
    border-radius: 6px;
    min-height: 76px;
    color: #fff;
    padding: 20px;
    line-height: 18px;
    position: relative;
}
.leftPaneTab .nav-link::before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: calc(100% - 15px);
    border-top: 15px solid transparent;
    border-bottom: 15px solid transparent;
    border-left: 13px solid transparent;
    width: 0;
    height: 0;
    margin: auto;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.leftPaneTab .nav-link:not(:last-child) {
    margin-bottom: 10px;
}
.leftPaneTab .nav-link.active {
    background: #27a7df;
}
.leftPaneTab .nav-link.active::before {
    border-left: 13px solid #27a7df;
    left: 100%;
}

.testimonial_block {
    background: #164f88;
    border-radius: 6px;
    padding: 30px;
    color: #fff;
}
.testimonial_block .testimonial_img_brife {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    border-bottom: 1px solid #3a7ab9;
    margin-bottom: 15px;
}
.testimonial_block .testimonial_img_brife .testimonial_img_wrap {
    position: relative;
    width: 80px;
    height: 80px;
    margin-right: 20px;
}
.testimonial_block .testimonial_img_brife .testimonial_img_wrap .testimonial_img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    overflow: hidden;
}
.testimonial_block .testimonial_img_brife .testimonial_img_wrap label {
    background: #27a7df;
    border: 1px solid #fff;
    opacity: 1;
    width: 27px;
    height: 27px;
    border-radius: 50%;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    position: absolute;
    right: 0;
    bottom: 0;
}
.testimonial_block .testimonial_img_brife .testimonial_img_wrap label .pencil-edit {
    filter: brightness(0) invert(1);
    width: 13px;
    height: 13px;
    background-size: 100%;
    -webkit-filter: brightness(0) invert(1);
}
.testimonial_block .testimonial_img_brife .testimonial_brife {
    width: calc(100% - 100px);
}
.testimonial_block label {
    margin-left: 4px;
    cursor: pointer;
}
.testimonial_block .pencil-edit {
    filter: brightness(0) invert(1);
    -webkit-filter: brightness(0) invert(1);
}
.testimonial_detail p:first-child::before {
    content: '';
    display: inline-block;
    width: 27px;
    height: 20px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/quote.svg) no-repeat 0 0;
    margin-right: 10px;
    position: relative;
    top: 5px;
}

.directory-stats-wrap {
    background: #fff;
    width: 100%;
    padding: 30px;
    border-radius: 5px;
}
.directory-stats-wrap ul {
    padding: 0;
    margin: 0;
    list-style: none;
}
.directory-stats-wrap ul li {
    position: relative;
    padding: 20px 20px 20px 41px;
    background: #f2f4f7;
    min-height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 4px;
}
.directory-stats-wrap ul li:before {
    content: '';
    width: 10px;
    height: 24px;
    border-left: 4px dotted #bdbdbd;
    border-right: 4px dotted #bdbdbd;
    position: absolute;
    left: 17px;
    top: 0;
    margin: auto;
    bottom: 0;
}
.directory-stats-wrap ul li:not(:last-child) {
    margin-bottom: 10px;
}
.directory-stats-wrap ul li .stats-name-detail span {
    font-size: 18px;
    color: #214764;
    margin-right: 6px;
    line-height: 22px;
}
.directory-stats-wrap ul li .stats-name-detail b {
    color: #5cae48;
    font-size: 22px;
}
.directory-stats-wrap ul li .stats-name-detail {
    display: flex;
    align-items: center;
}
.del-directory-item {
    background: #ffdfe4;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    margin-left: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.del-directory-item i {
    width: 14px;
    height: 14px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/trash.svg) no-repeat center / 100%;
    opacity: 0.8;
}

.alumni_network {
    background: #fff;
}
.alumni_network .sub-title {
    font-size: 40px;
    font-weight: 500;
    color: #2d2d2d;
    text-align: center;
    line-height: 50px;
    margin: 0;
}
.alumni_network_count {
    overflow-y: hidden;
    overflow-x: auto;
    scrollbar-width: thin;
    padding-bottom: 8px;
}
.alumni_network_count::-webkit-scrollbar {
    height: 4px;
}
.alumni_network_count::-moz-scrollbar {
    height: 4px;
}
.alumni_network_count::-webkit-scrollbar-track {
    background: #ccc;
}
.alumni_network_count::-webkit-scrollbar-thumb {
    background-color: #666;
    border-radius: 20px;
    border: 2px solid #666;
}
.alumni_network_count ul {
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
    justify-content: start;
}
.alumni_network_count li {
    background: #ffffff;
    box-shadow: 0px 3px 6px #0000001a;
    border: 1px solid #0034571a;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px 20px;
    width: 220px;
    min-width: 220px;
    text-align: center;
}
.alumni_network_count li b {
    color: #5cae48;
    font-size: 45px;
    line-height: 60px;
}
.alumni_network_count li:not(:last-child) {
    margin-right: 10px;
}
.alumni_network_count li p {
    margin: 7px 0 0 !important;
    text-align: center;
    font-size: 18px;
    line-height: 20px;
    font-weight: 500;
    opacity: 1;
    color: #0b3454;
    padding: 0;
}

.btn-video-del {
    background: #fff;
    width: auto;
    height: auto;
    border-radius: 25px;
    margin-left: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    z-index: 1;
    padding: 6px 15px;
    top: 10px;
    right: 10px;
    color: #000;
    text-decoration: none !important;
    border: 2px solid transparent;
}
.btn-video-del i {
    width: 14px;
    height: 14px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/trash.svg) no-repeat center / 100%;
    margin-right: 4px;
}
.btn-video-del:hover {
    background: #c90000;
    border: 2px solid #fff;
    color: #fff;
}
.btn-video-del:hover i {
    filter: brightness(0) invert(1);
    -webkit-filter: brightness(0) invert(1);
}
.nav-pills.slider-tab {
    width: max-content;
}
.nav-pills.slider-tab .nav-item:not(:last-child) {
    margin-right: 10px;
}
.nav-pills.slider-tab .nav-link {
    padding: 7px 20px;
    border: 1px solid #a4b3be;
    border-radius: 25px;
    -webkit-border-radius: 25px;
    -moz-border-radius: 25px;
    -ms-border-radius: 25px;
    -o-border-radius: 25px;
    color: #0b3454;
    position: relative;
}
.nav-pills.slider-tab .nav-link:before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: calc(100% - 8px);
    margin: auto;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 8px solid transparent;
    width: 0;
    height: 0;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.nav-pills.slider-tab .nav-link.active {
    background: #0b3454;
    border-color: #0b3454;
    color: #fff;
}
.nav-pills.slider-tab .nav-link.active:before {
    bottom: 100%;
    border-bottom-color: #0b3454;
}
.slider-tab .btn-add {
    padding: 7px 15px 7px 10px;
    border: 1px solid #a4b3be;
    border-radius: 25px;
    -webkit-border-radius: 25px;
    -moz-border-radius: 25px;
    -ms-border-radius: 25px;
    -o-border-radius: 25px;
    color: #0b3454;
    background: #fff;
}
.slider-tab .btn-add i {
    filter: invert(13%) sepia(330%) saturate(6748%) hue-rotate(188deg) brightness(50%) contrast(91%);
    -webkit-filter: invert(13%) sepia(330%) saturate(6748%) hue-rotate(188deg) brightness(50%) contrast(91%);
}
.slider-tab .btn-add:hover {
    background: #0b3454;
    border: 1px solid #0b3454;
    color: #fff;
}
.slider-tab .btn-add:hover i {
    filter: brightness(0) invert(1);
    -webkit-filter: brightness(0) invert(1);
}
.univariety_main_banner {
    padding: 0;
}
.univariety_main_banner_container {
    position: relative;
}
.univariety_main_banner_container img {
    position: relative;
    vertical-align: top;
}
.main_banner_text {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    max-width: 48%;
    text-align: center;
    color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.banner_title {
    font-size: 60px;
    color: #fff;
    font-weight: 600;
    line-height: 70px;
    max-width: 760px;
    margin: 0 0 20px;
}
.max-1140 .banner_title {
    font-size: 46px;
    line-height: 50px;
}
.banner_sub_title {
    font-size: 24px;
    line-height: 30px;
    margin-bottom: 40px;
    color: #fff;
}
.btn-watch {
    width: 175px;
    height: 50px;
    border: 1px solid #5cae48;
    text-decoration: none !important;
    border-radius: 5px;
    background: #5cae48;
    font-size: 16px;
    font-weight: 500;
    color: #fff;
    text-transform: uppercase;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.btn-watch:hover {
    background: #fff;
    border-color: #fff;
    color: #27377b;
}
.btn-watch i {
    width: 22px;
    height: 22px;
    background: #fff;
    border-radius: 50%;
    margin-right: 10px;
    position: relative;
}
.btn-watch i::before {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-left: 7px solid #5cae48;
    top: 6px;
    left: 9px;
}
.btn-watch:hover i {
    background: #28377c;
}
.btn-watch:hover i:before {
    border-left-color: #fff;
}

.preview-slider#alumni-card-slider .owl-dots {
    display: none;
}
.preview-slider#alumni-card-slider .owl-nav {
    display: block !important;
}
.preview-slider#alumni-card-slider .owl-nav button {
    background: #fff;
    width: 40px;
    height: 50px;
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto !important;
    border-radius: 0 6px 6px 0;
    font-size: 0;
}
.preview-slider#alumni-card-slider .owl-nav button::before {
    content: '';
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    background-size: 24px;
    background-repeat: no-repeat;
    background-position: left 5px center;
}
.preview-slider#alumni-card-slider .owl-nav button.owl-prev {
    left: 0;
}
.preview-slider#alumni-card-slider .owl-nav button.owl-next {
    right: 0;
    transform: scaleX(-1);
}

@media (max-width: 991px) {
    .Vertical-graph-block .bigVerticalProgress {
        max-width: max-content;
        width: max-content;
    }
    .top-college-wrap .top-colleges-slider .owl-nav {
        margin-top: 10px;
        display: flex;
        justify-content: center;
    }
    .top-college-wrap .top-colleges-slider .owl-nav button {
        position: static;
        margin: 5px;
    }
    .banner_title {
        font-size: 34px;
        line-height: 36px;
    }
    .banner_sub_title {
        font-size: 20px;
        line-height: 22px;
        margin-bottom: 20px;
    }
}

@media (max-width: 767px) {
    #WidgetsAlumniCarousel .owl-nav {
        width: 100%;
        justify-content: center;
    }
    .guiding_alumni_block {
        transform: translatey(0%);
        -webkit-transform: translatey(0%);
        -moz-transform: translatey(0%);
        -ms-transform: translatey(0%);
        -o-transform: translatey(0%);
    }
    .top-college-wrap .nav {
        width: max-content;
    }
    .leftPaneTab {
        max-width: 100%;
        overflow-x: auto;
        overflow-y: hidden;
        padding-bottom: 20px;
    }
    .leftPaneTab .nav-link {
        max-width: 280px;
    }
    .leftPaneTab .nav {
        width: max-content;
    }
    .leftPaneTab .nav-link:not(:last-child) {
        margin: 0 10px 0 0;
    }
    .leftPaneTab .nav-link::before {
        position: absolute;
        top: calc(100% - 0px);
        bottom: auto;
        border-top: 15px solid transparent;
        border-bottom: 15px solid transparent;
        border-left: 15px solid transparent;
        width: 0;
        height: 0;
        margin: auto;
        left: 0;
        right: 0;
        border-right: 15px solid transparent;
    }
    .leftPaneTab .nav-link.active::before {
        border-left: 13px solid transparent;
        top: 100%;
        border-top: 13px solid #27a7df;
        left: 0;
    }
    .banner_title {
        font-size: 50px;
        line-height: 59px;
    }
    .banner_sub_title {
        font-size: 24px;
        line-height: 30px;
        margin-bottom: 20px;
    }
}

@media (max-width: 575px) {
    #WidgetsAlumniCarousel.owl-carousel .owl-nav button {
        padding: 0 15px !important;
    }
    #WidgetsAlumniCarousel.owl-carousel .owl-nav button span {
        display: none;
    }
    .position-static-for-mobile {
        position: static !important;
    }
    .directory-stats-wrap {
        padding: 10px;
    }
    .main_banner_text {
        max-width: 90%;
    }
    .banner_title {
        font-size: 50px;
        line-height: 59px;
    }
    .banner_sub_title {
        font-size: 24px;
        line-height: 30px;
        margin-bottom: 20px;
    }
}

.lstCustForm .custom-input-wrap .select__value-container {
    flex-wrap: wrap;
    height: auto;
    max-height: 141px;
    overflow: auto;
}

input[type='date']::-webkit-calendar-picker-indicator {
    background: transparent;
    bottom: 0;
    color: transparent;
    cursor: pointer;
    height: auto;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: auto;
}

/* Alumni QA */

.bg-liteblue-F2F9FF {
    background-color: #f2f9ff;
}

.chat-tab .nav-link {
    background: #ffffff;
    border: 1px solid #0b345459;
    border-radius: 25px;
    opacity: 1;
    padding: 10px 30px;
    color: #0b3454;
}
.chat-tab .nav-item:not(:last-child) {
    margin-right: 10px;
}
.chat-tab .nav-link.active {
    background: #0b3454;
    color: #fff;
}

.alumni-chat-img {
    position: absolute;
    bottom: -114px;
    right: 0;
    max-width: 240px;
}

.header-title .icon_message {
    width: 35px;
    height: 35px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/chat.svg) no-repeat 0 0 / 35px;
    margin-right: 10px;
}

.alumni_chat_profile_list {
    min-width: 300px;
    width: 100%;
}
.alumni_chat_profile_list .heading {
    font-size: 18px;
    font-weight: 500;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    align-items: center;
    padding: 18px 0;
    border-bottom: 1px solid #d6d6d6;
    height: auto;
}
.alumni_chat_profile_list .heading .icon_message {
    width: 30px;
    height: 30px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/chat.svg) no-repeat 0 0 / 30px;
    margin-right: 10px;
}
.alumni_chat_profile_list ul {
    padding: 0;
    margin: 0;
    list-style: none;
    overflow-x: hidden;
    overflow-y: auto;
    max-height: 500px;
}
.alumni_chat_profile_list ul::-webkit-scrollbar {
    width: 4px;
}
.alumni_chat_profile_list ul::-webkit-scrollbar-track {
    background: #f1f1f1;
}
.alumni_chat_profile_list ul::-webkit-scrollbar-thumb {
    background: #888;
}
.alumni_chat_profile_list ul::-webkit-scrollbar-thumb:hover {
    background: #555;
}
.alumni_chat_profile_list ul li {
    padding: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.alumni_chat_profile_list ul li.unread {
    background: #f3f9ff;
}
.alumni_chat_profile_list ul li:not(:last-child) {
    border-bottom: 1px solid #d6d6d6;
}
.alumni_chat_profile_list ul li a {
    display: flex;
    align-items: center;
    text-decoration: none;
    color: #000000;
    font-size: 18px;
    font-weight: 500;
    line-height: 22px;
}
.alumni_chat_profile_list ul li a .img-alumni {
    border-radius: 50%;
    margin-right: 10px;
    overflow: hidden;
    width: 60px;
}
.alumni_chat_profile_list ul li a .alumni-name-batch {
    display: flex;
    flex-direction: column;
}
.alumni_chat_profile_list ul li a .alumni-name-batch .alumni-batch {
    color: #6a6868;
    font-size: 14px;
}
.alumni_chat_profile_list ul li a .alumni-name-batch .alumni-message {
    font-size: 14px;
    font-weight: 500;
    color: #6a6868;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    width: 100%;
    max-width: 165px;
}
.alumni_chat_profile_list ul li a.del-alumni {
    background: #ffdfe4;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-left: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.alumni_chat_profile_list ul li a.del-alumni i {
    width: 18px;
    height: 18px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/trash.svg) no-repeat center / 100%;
    opacity: 0.8;
}
.text-student {
    color: #c38400;
}
.text-school {
    color: #26a7df;
}
.text-alumni {
    color: #d42941;
}

.alumni_chat_block {
    background: #f2f9ff
        url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/question_marks_background.png);
    padding: 0px;
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 565px;
}
.alumni_chat_to {
    padding: 30px 30px 0;
}
.alumni_chat_to label {
    font-weight: 500;
    font-size: 18px;
}
/* .sent_too_wrap .sent_too {background: #FFFFFF;border: 1px solid #0B345459;border-radius: 25px;opacity: 1;padding: 0 18px;height: 35px;display: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex;align-items: center;} */
.sent_too_wrap .sent_too {
    background: #ffffff;
    border: 1px solid #0b345459;
    border-radius: 25px;
    opacity: 1;
    padding: 0 18px;
    height: 35px;
    display: flex;
    align-items: center;
}
.count-unread {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background: #5cae48;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: 12px;
    font-weight: 500;
}
.blue-block {
    background: transparent linear-gradient(104deg, #0062af 0%, #175381 100%) 0% 0% no-repeat padding-box;
    padding: 24px 30px;
    color: #fff;
    font-size: 18px;
    line-height: 22px;
    position: relative;
}
.blue-block:after {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
}
.blue-block p:last-child {
    margin: 0;
}
.blue-block ol {
    padding: 0 0 0 21px;
}
.blue-block ol:last-child {
    margin: 0;
}
.justify-content-end .blue-block {
    margin-right: 8px;
    border-radius: 6px 6px 0px 6px;
    -webkit-border-radius: 6px 6px 0px 6px;
    -moz-border-radius: 6px 6px 0px 6px;
    -ms-border-radius: 6px 6px 0px 6px;
    -o-border-radius: 6px 6px 0px 6px;
}
.justify-content-end .blue-block:after {
    right: -8px;
    bottom: 0px;
    border-left: 5px solid #175381;
    border-bottom: 5px solid #175381;
    border-top: 5px solid transparent;
    border-right: 5px solid transparent;
}
.justify-content-start .blue-block {
    margin-left: 8px;
    border-radius: 6px 6px 6px 0px;
    -webkit-border-radius: 6px 6px 6px 0px;
    -moz-border-radius: 6px 6px 6px 0px;
    -ms-border-radius: 6px 6px 6px 0px;
    -o-border-radius: 6px 6px 6px 0px;
}
.justify-content-start .blue-block:after {
    left: -8px;
    bottom: 0px;
    border-left: 5px solid transparent;
    border-bottom: 5px solid #0161ac;
    border-top: 5px solid transparent;
    border-right: 5px solid #0161ad;
}
.blue-block:has(.univarietyAI) {
    background: linear-gradient(90deg, #e9102e 16%, #043254 100%);
    color: #ffffff;
    color:#fff;
}
.blue-block:has(.univarietyAI):after {
    border-bottom: 5px solid #e9102e;
    border-right: 5px solid #e9102e;
}
.justify-content-end .blue-block:has(.univarietyAI):after {
    border-left: 5px solid #063254;
    border-bottom: 5px solid #063254;
    border-top: 5px solid transparent;
    border-right: 5px solid transparent;
}
.univarietyAI {
    margin-top: 10px;
    font-size: 13px;
    color: #fff;
    font-style: italic;
}
.univarietyAI b{
    font-weight: 500;
}

.messages:has(.univarietyAI) > div {
    background: linear-gradient(90deg, #e9102e 16%, #043254 100%);
    color: #ffffff;
    color:#fff;
    border-radius: 10px 10px 10px 0px;
    padding: 10px 20px;
    margin-bottom: 10px;
}

.messages:has(.univarietyAI) p{
    background-color: transparent;
    border-radius: 0;
    padding: 0;
}

.alumni_chat_conversation_send .form-control {
    background: #ffffff 0% 0% no-repeat padding-box;
    border: 1px solid #0b345459;
    border-radius: 10px;
    opacity: 1;
}
.alumni_chat_conversation_block {
    max-height: 395px;
    overflow-y: auto;
    overflow-x: hidden;
    min-height: 395px;
    padding: 0 30px;
}
.alumni_chat_conversation_send {
    padding: 0px 30px 30px 30px;
}
.get_started {
    text-align: center;
}
.get_started .get_started_like {
    width: 54px;
    height: 62px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/star-like.svg) no-repeat 0 0;
    margin-bottom: 20px;
}
.get_started h3 {
    font-size: 28px;
    font-weight: 600;
}

.liteblue-border-block {
    background: #fff;
    padding: 24px 30px;
    color: #000;
    font-size: 18px;
    line-height: 22px;
    position: relative;
    border: 1px solid #afdafb;
}
.liteblue-border-block::after {
    content: '';
    position: absolute;
    width: 15px;
    height: 15px;
    background: #fff;
}
.justify-content-end .liteblue-border-block {
    margin-right: 8px;
    border-radius: 6px 6px 0px 6px;
    -webkit-border-radius: 6px 6px 0px 6px;
    -moz-border-radius: 6px 6px 0px 6px;
    -ms-border-radius: 6px 6px 0px 6px;
    -o-border-radius: 6px 6px 0px 6px;
}
.justify-content-end .liteblue-border-block::after {
    right: -8px;
    bottom: -1px;
    border-left: 1px solid #fff;
    border-bottom: 1px solid #afdafb;
    border-top: 1px solid #fff;
    border-right: 1px solid #afdafb;
    transform: skew(44deg);
    -webkit-transform: skew(44deg);
    -moz-transform: skew(44deg);
    -ms-transform: skew(44deg);
    -o-transform: skew(44deg);
}
.justify-content-start .liteblue-border-block {
    margin-left: 8px;
    border-radius: 6px 6px 6px 0px;
    -webkit-border-radius: 6px 6px 6px 0px;
    -moz-border-radius: 6px 6px 6px 0px;
    -ms-border-radius: 6px 6px 6px 0px;
    -o-border-radius: 6px 6px 6px 0px;
}
.justify-content-start .liteblue-border-block::after {
    left: -8px;
    bottom: -1px;
    border-left: 1px solid #afdafb;
    border-bottom: 1px solid #afdafb;
    border-top: 1px solid #fff;
    border-right: 1px solid #fff;
    transform: skew(44deg);
    -webkit-transform: skew(-44deg);
    -moz-transform: skew(44deg);
    -ms-transform: skew(44deg);
    -o-transform: skew(44deg);
}
.liteblue-border-block p:last-child {
    margin: 0;
}
.liteblue-border-block ol {
    padding: 0 0 0 21px;
}
.liteblue-border-block ol:last-child {
    margin: 0;
}

.get_started_prompt a, .get_started_prompt button { display: inline-block; background: #f1feff; border: 1px solid #9dc3e9; border-radius: 25px; opacity: 1; padding: 8px 30px; text-decoration: none; font-size: 18px; color: #0B3454; transition:all 0.3s ease-in-out ; -webkit-transition:all 0.3s ease-in-out ; -moz-transition:all 0.3s ease-in-out ; -ms-transition:all 0.3s ease-in-out ; -o-transition:all 0.3s ease-in-out ; -webkit-border-radius:; -moz-border-radius:; -ms-border-radius:; -o-border-radius:; }
.get_started_prompt a:hover,.get_started_prompt button:hover {background: #bae8ff;color: #000;}

.get_started_prompt a.highlight, .get_started_prompt button.highlight {background: #fff1d1;border-color: #ffbf00;color: #895900;}
.get_started_prompt a.highlight:hover, .get_started_prompt button.highlight:hover{background: #ffbf00;border-color: #ffbf00;color: #000;}

.chat_now {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_37___}) no-repeat center / cover;
    padding: 15px;
    border-radius: 5px;
    margin: 20px 30px 0 30px;
}
.chat_now + .alumni_chat_conversation_block {
    max-height: 285px;
    min-height: 285px;
}

.alumni_chat_conversation_header {
    padding: 16px 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #d4e1ee;
    position: relative;
}
.alumni_chat_conversation_header > i {
    position: absolute;
    left: 0;
    bottom: 0;
    top: 0;
    height: 17px;
    margin: auto;
    width: 30px;
    text-align: center;
    cursor: pointer;
}
.alumni-user-leftpane {
    display: flex;
    align-items: center;
}
.alumni-user-leftpane .img-alumni {
    margin-right: 10px;
}
.alumni-user-leftpane .alumni-name-batch {
    display: flex;
    flex-direction: column;
}
.alumni-user-leftpane img {
    width: 50px;
    height: 50px;
}
.alumni-user-leftpane .alumni-name-batch .alumni-name {
    font-size: 18px;
    line-height: 22px;
    color: #000;
    font-weight: 500;
}
.alumni-message {
    color: #6a6868;
    font-size: 14px;
}
.mark-star label {
    background: #f3ac19;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.mark-star label .icon-star {
    font-size: 13px;
}
.mark-star input:checked ~ label,
.mark-star.selected input ~ label {
    background: #5cae48;
}

.btn-alumni-guidance {
    background: #d52941;
    box-shadow: 0px 3px 14px #ab162b96;
    border-radius: 32px;
    position: fixed;
    right: 25px;
    bottom: 25px;
    color: #fff;
    text-decoration: none;
    width: 163px;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    align-items: center;
    padding: 12px 20px;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.btn-alumni-guidance i {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/light-bulb.svg) no-repeat 0 0;
    width: 35px;
    height: 39px;
    margin-right: 5px;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.btn-alumni-guidance span {
    flex: 1 1;
    line-height: 16px;
}
.btn-alumni-guidance:hover {
    background: #fec458;
}
.btn-alumni-guidance:hover i {
    filter: invert(24%) sepia(29%) saturate(5786%) hue-rotate(333deg) brightness(93%) contrast(95%);
    -webkit-filter: invert(24%) sepia(29%) saturate(5786%) hue-rotate(333deg) brightness(93%) contrast(95%);
}

.post-block {
    background: #ffffff;
    border: 1px solid #d2d2d2;
    border-radius: 6px;
    opacity: 1;
    padding: 30px;
}
.post-block:not(:last-child) {
    margin-bottom: 20px;
}
.post-block .post-img {
    margin-top: 20px;
    border-radius: 50%;
    width: 60px;
    height: 60px;
    overflow: hidden;
}
.post-block .post-img img {
    width: auto;
    height: 100%;
}
.post-block .brife {
    margin: 0;
    max-width: 700px;
} /*overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;*/
.post-head {
    background: #ffecc5 0% 0% no-repeat padding-box;
    border-radius: 4px;
    display: inline-block;
    font-size: 12px;
    padding: 4px 10px;
    font-weight: 500;
    margin-bottom: 5px;
}
.post-alumni-name {
    font-size: 18px;
    font-weight: 600;
}
.post-alumni-batch {
    color: #6a6868;
    font-size: 14px;
    font-weight: 500;
}

.answered_wrap .post-head {
    background: #bdf6af;
}
.answered_wrap .post-img {
    margin: 0;
    width: 40px;
    height: 40px;
}
.answered_wrap p {
    margin: 0;
}

.more-answer {
    margin-left: 55px;
    color: #26a7df;
}
.more-answer:hover {
    margin-left: 55px;
    color: #0b8ac2;
}
.tags-wrap {
    max-width: 745px;
}
.tags-wrap span {
    background: #fee9bd;
    border-radius: 15px;
    padding: 5px 18px;
    font-size: 14px;
    margin-bottom: 5px;
    font-weight: 500;
}
.tags-wrap span:not(:last-child) {
    margin-right: 5px;
}
.tags-wrap span + span {
    background: #c2e9fe;
}
.tags-wrap span + span + span {
    background: #fed7dc;
}
.tags-wrap span + span + span + span {
    background: #f8bef6;
}
.tags-wrap span + span + span + span + span {
    background: #e5d8ff;
}

.video_block_img .icon-invert-play {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    font-size: 50px;
    color: white;
    z-index: 9;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0.9;
}

.btn-gray-edit {
    background: #ffffff;
    border: 1px solid #d1d1d1;
    border-radius: 18px;
    padding: 8px 18px;
    display: flex;
    align-items: center;
    color: #26a7df;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.btn-gray-edit:hover {
    background: #0b3454;
    border-color: #0b3454;
}
.btn-gray-edit i {
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.btn-gray-edit:hover .pencil-edit {
    filter: brightness(0) invert(1);
    -webkit-filter: brightness(0) invert(1);
}

.mark-flag .icon-flag {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/black-flag.svg) no-repeat 0 0 / 20px;
    width: 20px;
    height: 20px;
    margin-right: 5px;
}
.mark-flag label {
    cursor: pointer;
    display: flex;
}
.mark-flag input:checked ~ label .icon-flag {
    filter: invert(50%) sepia(99%) saturate(3201%) hue-rotate(71deg) brightness(96%) contrast(103%);
    -webkit-filter: invert(50%) sepia(99%) saturate(3201%) hue-rotate(71deg) brightness(96%) contrast(103%);
}
.mark-flag input:checked ~ label span {
    font-weight: 500;
    color: #5cae48;
}
.horizontal-divider {
    border-left: 1px solid #d2d2d2;
    margin: 0 3px;
}

.conversation-badge {
    background: #ffffff;
    border: 1px solid #c5c5c5f2;
    opacity: 1;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    color: #4a7394;
    font-size: 22px;
}

@media (max-width: 767px) {
    .alumni_chat_block {
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        z-index: 99;
        min-height: 0;
    }
    .alumni_chat_conversation_block {
        flex: 0 1;
        flex-basis: calc(100% - 183px);
        min-height: initial;
        max-height: initial;
    }
    .get_started h3{
        font-size: 20px;
    }
    .get_started_prompt a, .get_started_prompt button{
        font-size: 15px;
    }
}

@media (max-width: 575px) {
    .alumni-chat-img {
        position: absolute;
        bottom: -28px;
        right: 0;
        max-width: 130px;
    }
    .post-block {
        padding: 20px;
    }
}

@media (max-width: 480px) {
    .post-brife-answer {
        margin-left: -77px;
    }
}

/* widget 13062024 css */

.filter-white {
    filter: brightness(0) invert(1);
    -webkit-filter: brightness(0) invert(1);
}

.left-100 {
    left: 100%;
}
nav .new {
    font-size: 14px;
    background: #5cae48;
    padding: 0 10px;
    border-radius: 25px;
    color: #fff;
    margin-left: 5px;
}

.filter-toggle-wrap {
    position: absolute;
    top: -10px;
    right: 30px;
}
.filter-toggle-wrap a {
    background: #ffffff;
    border: 1px solid #b4b4b4;
    border-radius: 20px;
    padding: 7px 25px;
    text-decoration: none;
    display: inline-block;
    color: #474747;
    margin: 0 2px;
}
.filter-toggle-wrap a.active {
    background: #5cae48;
    color: #fff;
    border-color: #5cae48;
}

.filter-sort {
    position: absolute;
    right: 40px;
    top: 13px;
    display: flex;
    align-items: center;
    font-size: 14px;
}
.filter-sort .double-arrow {
    display: flex;
    flex-direction: column;
    margin-left: 10px;
}
.filter-sort .double-arrow:before {
    content: '';
    width: 0;
    height: 0;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-bottom: 4px solid #949494;
    margin-bottom: 1px;
}
.filter-sort .double-arrow:after {
    content: '';
    width: 0;
    height: 0;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 4px solid #949494;
}

.verify_massrecruiter {
    margin: -6px 0 0 70px;
    display: flex;
    width: calc(100% - 70px);
}
.verify_massrecruiter ul {
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    color: #0b3454;
}
.verify_massrecruiter ul li {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    align-items: center;
}
.verify_massrecruiter ul li i {
    margin-right: 5px;
}
.verify_massrecruiter ul .verify {
    width: 19px;
    height: 24px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/green-verified.svg) no-repeat 0 0 /
        100%;
    display: inline-block;
}
.verify_massrecruiter ul .massrecruiter {
    width: 23px;
    height: 23px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/search-user.svg) no-repeat 0 0 / 100%;
    display: inline-block;
}
.verify_massrecruiter ul li:not(:last-child) {
    border-right: 1px solid #dedcdc;
    padding-right: 10px;
    margin-right: 10px;
}
.confirmRecruiter {
    background: #ffffff;
    border: 2px solid #474747;
    border-radius: 18px;
    padding: 3px 15px;
}

.alumni_univarsity_subject i.icon-brifecase {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/small-brifecase.svg) no-repeat 0 0 /
        100%;
    filter: brightness(0) invert(0);
    -webkit-filter: brightness(0) invert(0);
}

.report-block-list ul.verticleListDesktop li {
    width: 100%;
    padding: 0;
}
.report-block-list ul li:not(:last-child) {
    margin-bottom: 5px;
}
.report-block-list ul li span {
    width: calc(100% - 22px);
    line-height: 18px;
}
.report-block-list ul li i.lite-dark-blue {
    background: #256298;
}

.queriesStatsVerticleReport-col.single-progress .progress {
    width: 100%;
    background-color: #f1f1f160;
}
.queriesStatsVerticleReport-col.single-progress .progress .progress-bar::before {
    bottom: calc(100% + 2px);
    color: black;
    font-size: 20px;
    font-weight: 500;
}
.mint-green {
    background-color: #4bc0c0;
}
.lite-dark-blue {
    background-color: #256298;
}
.dark-yellow {
    background-color: #efd17d;
}
.queriesStatsVerticleReport-col .dark-blue {
    background-color: #0b3454;
}
.queriesStatsVerticleReport-col .lite-blue {
    background-color: #26a7df;
}
.queriesStatsVerticleReport-col.single-progress.w-78 {
    width: 78px;
}
.queriesStatsVerticleReport .queriesStatsVerticleReport-col.single-progress.w-78 .progress-wrap {
    height: 275px;
}
.queriesStatsVerticleReport-col.single-progress.w-78:not(:last-child) {
    margin-right: 12px;
}

.verticalslant {
    padding: 40px 0 0 12px;
    margin: 0;
    text-orientation: mixed;
    transform: rotate(180deg);
    -webkit-transform: rotate(180deg);
    -moz-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    -o-transform: rotate(180deg);
    white-space: nowrap;
    writing-mode: vertical-rl;
    -webkit-writing-mode: vertical-rl;
    -ms-writing-mode: vertical-rl;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    font-weight: 500;
}

.message_spotlight h2 {
    text-align: center;
    position: relative;
    margin: 0 0 50px;
    font-size: 26px;
}
.message_spotlight h2:before {
    content: '';
    position: absolute;
    top: calc(100% + 12px);
    left: 0;
    right: 0;
    margin: auto;
    width: 60px;
    height: 3px;
    background: #d42941;
}
.message_spotlight .message_university_block h2:before {
    background: #5cae48;
}
.alumni_spotlight_block .alumni-card-wrap .alumni-card-slider .alumni-card {
    padding-top: 0;
}

.x-scroll {
    overflow-y: hidden;
    overflow-x: auto;
    scrollbar-width: thin;
    padding-bottom: 10px;
    margin-bottom: 10px;
}
.x-scroll::-webkit-scrollbar {
    height: 4px;
}
.x-scroll::-moz-scrollbar {
    height: 4px;
}
.x-scroll::-webkit-scrollbar-track {
    background: #ccc;
}
.x-scroll::-webkit-scrollbar-thumb {
    background-color: #666;
    border-radius: 20px;
    border: 2px solid #666;
}
.welcome .custom_tab .nav {
    margin: 0;
    min-width: 950px;
    border-bottom: 2px solid #e4edf4;
    display: flex;
    justify-content: space-between;
}
.welcome .custom_tab .nav .nav-item {
    border: 0;
    margin: 0;
}
.welcome .custom_tab .nav .nav-item .nav-link {
    box-shadow: none;
    border: 0 !important;
    margin: 0;
    overflow: visible;
    background: none;
    font-size: 20px;
    font-weight: 600;
    padding: 23px;
    position: relative;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    cursor: pointer;
    white-space: nowrap;
    color: #000;
}
.welcome .custom_tab .nav .nav-item .nav-link.active {
    color: #5cae48;
}
.welcome .custom_tab .nav .nav-item .nav-link:hover {
    color: #000;
}
.welcome .custom_tab .nav .nav-item .nav-link::before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: -4px;
    width: 0;
    background: #5cae48;
    height: 5px;
    border-radius: 0;
    margin: auto;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.welcome .custom_tab .nav .nav-item .nav-link::after {
    display: none;
}
.welcome .custom_tab .nav .nav-item .nav-link.active:before {
    width: 100%;
}
.welcome .custom_tab .tab-content {
    background: none;
    padding: 40px 0 0;
    border: none;
}
.welcome .custom_tab .nav-tabs > li.active > a:focus,
.welcome .nav-tabs > li > a:hover {
    background: none;
}
.custom_tab .row {
    display: flex;
    align-items: center;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
}
.custom_tab .vc_row {
    display: flex;
}
.flex-row-reverse {
    flex-direction: row-reverse;
}
.custom_tab {
    margin-top: 30px;
}
.custom_tab h3 {
    font-size: 32px;
    line-height: 32px;
    font-weight: 500;
    color: #000 !important;
    margin: 0 0 28px;
    text-transform: capitalize;
    position: relative;
    padding-bottom: 0;
}
.checked-list {
    padding: 0;
    margin: 0 0 30px;
    list-style: none;
    font-size: 18px;
    line-height: 26px;
}
.checked-list li:not(:last-child) {
    margin-bottom: 24px;
}
.checked-list li {
    padding: 0 0 0 26px;
    position: relative;
    color: #000;
    font-size: 18px;
    line-height: 26px;
}
.checked-list li:before {
    content: '';
    position: absolute;
    left: 0;
    top: 5px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/check.svg) no-repeat 0 0;
    width: 16px;
    height: 16px;
}
.btn-signUp {
    background: #5cae48;
    opacity: 1;
    width: 140px;
    height: 40px;
    line-height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 18px;
    font-weight: 500;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    position: relative;
    border-radius: 25px;
    overflow: hidden;
    border: 2px solid #5cae48;
    text-transform: capitalize;
    -webkit-border-radius: 25px;
    -moz-border-radius: 25px;
    -ms-border-radius: 25px;
    -o-border-radius: 25px;
    text-decoration: none;
}
.btn-signUp:hover {
    background: #fff;
    color: #0b3454;
    text-decoration: none !important;
    border-color: #0b3454;
}

.threecardslider .item {
    padding: 4px;
}
.gray-box {
    box-shadow: 0px 2px 3px #0000001a;
    border: 1px solid #0034571a;
    border-radius: 10px;
    padding: 30px;
    overflow: hidden;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.gray-box > div {
    position: relative;
}
.gray-box:before {
    content: '';
    height: 80px;
    background: #f0f0f0;
    position: absolute;
    left: -10px;
    right: -10px;
    top: -10px;
    transform: skewY(1deg);
    -webkit-transform: skewY(1deg);
    -moz-transform: skewY(1deg);
    -ms-transform: skewY(1deg);
    -o-transform: skewY(1deg);
}
.gray-box-img-wrap {
    width: 80px;
    height: 80px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/star-graph.svg) no-repeat center /
        100%;
    margin-bottom: 20px;
    padding: 10px;
}
.gray-box-img-wrap .gray-box-img {
    width: 100%;
    height: 100%;
    overflow: hidden;
    border: 2px solid #fff;
    border-radius: 50%;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    -ms-border-radius: 50%;
    -o-border-radius: 50%;
}
.gray-box .brife {
    text-align: center;
    line-height: 20px;
    position: relative;
}
.gray-box-post-date {
    position: relative;
    margin-top: 15px;
    padding-top: 15px;
    text-align: center;
    font-size: 14px;
}
.gray-box-post-date:before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: -1px;
    width: 50px;
    height: 3px;
    background: #53a132;
    margin: auto;
}

.threecardslider.owl-theme .owl-dots {
    display: none;
}
/* .threecardslider.owl-theme .owl-nav {display: block !important;margin: 0;} */
.threecardslider.owl-theme .owl-nav button {
    background: #fff;
    width: 36px;
    height: 36px;
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto !important;
    border: 1px solid #0b34544d;
    border-radius: 10px;
    font-size: 0;
}
.threecardslider.owl-theme .owl-nav button::before {
    content: '';
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    background-size: 18px;
    background-repeat: no-repeat;
    background-position: left 7px center;
}
.threecardslider.owl-theme .owl-nav button.owl-prev {
    left: -50px;
}
.threecardslider.owl-theme .owl-nav button.owl-next {
    right: -50px;
    transform: scaleX(-1);
}

.btn-blue .icon-play {
    width: 18px;
    height: 18px;
    background: #fff;
    border-radius: 50%;
    margin-right: 5px;
    position: relative;
}
.btn-blue .icon-play:before {
    content: '';
    width: 0;
    height: 0;
    border-top: 4px solid transparent;
    border-bottom: 5px solid transparent;
    border-left: 5px solid #26a7df;
    margin: auto;
    position: absolute;
    left: 8px;
    top: 5px;
}

.job-box {
    border: 1px solid #c3d4e2;
    border-radius: 6px;
    overflow: hidden;
    height: 100%;
    display: flex;
    flex-direction: column;
}
.btn-border-gray:hover img[src*='icon'] {
    filter: brightness(0) invert(1);
}

.merchandise-block {
    width: 100%;
    height: 350px;
    border-radius: 6px;
    overflow: hidden;
    position: relative;
    background: #d0cecf;
}
.merchandise-block.gold {
    background-color: #ffcd56;
}
.product-name-price {
    position: absolute;
    left: 3px;
    right: 3px;
    bottom: 3px;
    margin: auto;
    background: #fff;
    padding: 15px;
    border-radius: 6px;
    text-align: center;
}

.offer-block {
    background: #ffffff;
    border: 1px solid #d2d2d2;
    border-radius: 6px;
    overflow: hidden;
    margin-left: 2px;
}
.offer-block .brand-logo {
    height: 118px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 20px;
}
.coupon_offer {
    padding: 20px;
    background: #f4faff;
}
.givingBackSchool {
    background-color: #f4f4f4;
}
.alumni-block {
    box-shadow: 0px 20px 40px #88949b29;
    border-radius: 4px;
    padding: 50px;
}
.alumni-block:not(:last-child) {
    margin-bottom: 40px;
}
.alumni-block.monitor {
    background: #fff;
}
.alumni-block.careerTalk {
    background: #fff;
}
.alumni-block h3 {
    font-size: 32px;
    font-weight: 600;
    line-height: 50px;
    color: #2d2d2d;
    margin: 0 0 5px;
}
.givingBackSchool .alumni-block p {
    font-size: 18px;
    line-height: 28px;
    color: #000;
    margin: 0 0 20px !important;
    text-align: left;
    opacity: 1;
    margin-bottom: 20px;
}
.btn-interested {
    background: #5cae48;
    opacity: 1;
    width: auto;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 18px;
    font-weight: 500;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    position: relative;
    overflow: hidden;
    border: 2px solid #5cae48;
    text-transform: capitalize;
    border-radius: 4px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    -ms-border-radius: 4px;
    -o-border-radius: 4px;
    padding: 0 28px;
    text-decoration: none;
}
.btn-interested:hover {
    background: #fff;
    color: #0b3454;
    text-decoration: none !important;
    border-color: #0b3454;
}

.icon-selected-user {
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/selected-user.svg) no-repeat 0 0;
    width: 31px;
    height: 27px;
    display: inline-block;
}
.block-header {
    width: 100%;
    display: inline-block;
    padding: 17px 30px;
    border-bottom: 1px solid #d5d3d3;
}
.block-custom-tab {
    margin-top: 50px;
    margin-left: 40px;
}
.btn-border-lite-blue {
    border: 1px solid #26a7df;
    border-radius: 6px;
    opacity: 1;
    display: flex;
    align-items: center;
    height: 40px;
    color: #26a7df;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.btn-border-lite-blue .icon-note {
    filter: invert(72%) sepia(36.1%) saturate(530%) hue-rotate(165deg) brightness(93%) contrast(87%);
    -webkit-filter: invert(72%) sepia(36.1%) saturate(530%) hue-rotate(165deg) brightness(93%) contrast(87%);
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.btn-border-lite-blue i img {
    filter: invert(51%) sepia(93%) saturate(720%) hue-rotate(165deg) brightness(94%) contrast(85%);
}
.btn.btn-border-lite-blue:hover {
    background: #26a7df;
    color: #fff;
}
.btn-border-lite-blue:hover .icon-note,
.btn-border-lite-blue:hover i img {
    filter: brightness(0) invert(1);
    -webkit-filter: brightness(0) invert(1);
}
.block-custom-tab .nav-item:not(:last-child) {
    margin-right: 20px;
}
.block-custom-tab .nav-item .nav-link {
    padding: 0 0 6px;
    background: none;
    color: #000000;
    font-weight: 500;
    position: relative;
}
.block-custom-tab .nav-item .nav-link.active {
    color: #5cae48;
    font-weight: 600;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.block-custom-tab .nav {
    justify-content: center;
}
.block-custom-tab .nav.custom-sub-tab {
    justify-content: start;
}

.block-custom-tab .nav-item .nav-link:before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    border-bottom: 2px solid #5cae48;
    width: 0;
    opacity: 0;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.block-custom-tab .nav-item .nav-link.active:before {
    width: 100%;
    opacity: 1;
}

.custom-sub-tab .nav-link {
    width: 175px;
    border-radius: 0;
    font-size: 16px;
    font-weight: 500;
    text-align: left;
    color: #000;
    border-left: 4px solid #fff;
    border-radius: 6px 0 0 6px;
    padding: 15px 20px;
}
.custom-sub-tab .nav-link.active {
    background: #f2f4f7;
    color: #000;
    border-color: #5cae48;
}

.btn-green .icon-question.circle {
    border-radius: 50%;
    border: 2px solid #fff;
    padding: 2px;
    font-size: 12px;
    width: 22px;
    height: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 4px;
}

.listed-border {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    align-items: center;
    background: #ffffff;
    border: 1px solid #dde4ee;
    border-radius: 6px;
    min-height: 50px;
    padding: 10px 20px;
}
.listed-border:not(.disabled) {
    background-color: #26a7df;
    border-color: #26a7df;
    color: #fff;
}
.listed-border:not(.disabled) .tick:before {
    border-color: #fff;
}
.listed-border.disabled {
    opacity: 0.4;
}
.listed-border.disabled .note-wrap {
    display: none;
}
.listed-border .tick:before {
    content: '';
    position: absolute;
    width: 15px;
    height: 7px;
    border-left: 3px solid #000;
    border-bottom: 3px solid #000;
    transform: rotate(-40deg);
    -webkit-transform: rotate(-40deg);
    -moz-transform: rotate(-40deg);
    -ms-transform: rotate(-40deg);
    -o-transform: rotate(-40deg);
}
.listed-border .tick {
    position: relative;
    width: 15px;
    height: 11px;
}
.listed-border p {
    margin: 0 16px;
    width: calc(100% - 78px);
    flex: 1 1;
}
.listed-border.red {
    background-color: #c10101;
    border-color: #c10101;
    color: #fff;
}
.listed-border.red .tick:before {
    border-color: #fff;
}
.listed-border.red .note-wrap {
    background: #9b0e0e;
}
.note-wrap {
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #0a6e9a;
    border-radius: 50%;
}
.note-wrap .icon-note {
    width: 12px;
    height: 15px;
    background-size: 100%;
    filter: brightness(0) invert(1);
    -webkit-filter: brightness(0) invert(1);
}
.blue-link {
    color: #1664bc;
}
.blue-link:hover {
    color: #5cae48;
}

.meter-wrap {
    width: 40px;
    height: 40px;
    padding: 3px;
    background: #fff;
    border-radius: 50%;
    position: relative;
}
.meter-icon {
    border-top: 10px solid #f2c32f;
    border-left: 10px solid #e03f4f;
    border-right: 10px solid #1ea56b;
    border-radius: 50%;
    position: absolute;
    left: 2px;
    right: 2px;
    top: 2px;
    bottom: 2px;
    border-bottom: 10px solid transparent;
}
.meter-icon:before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 7px;
    height: 7px;
    background: #000;
    border-radius: 50%;
}
.pointer-pin {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
}
.meter-icon .pointer-pin:after {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    border-top: 2px solid transparent;
    border-bottom: 2px solid transparent;
    border-right: 13px solid #000;
    left: -7px;
    top: 5.7px;
}

.meter-title{font-size: 10px;font-weight: 600;text-align: center; margin-top: 1px;width:35px;text-align: center;}

.meter-wrap.positive .meter-icon .pointer-pin {
    transform: rotate(175deg);
    -webkit-transform: rotate(175deg);
    -moz-transform: rotate(175deg);
    -ms-transform: rotate(175deg);
    -o-transform: rotate(175deg);
}
.meter-wrap.neutral .meter-icon .pointer-pin {
    transform: rotate(90deg);
    -webkit-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    -o-transform: rotate(90deg);
}
.icon-open-folder {
    width: 17px;
    height: 17px;
    display: inline-block;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/open-folder.svg) no-repeat center /
        100%;
}

.disabled-text {
    color: #000;
    opacity: 0.4;
    font-weight: 500;
}

@media (min-width: 575px) and (max-width: 1150px) {
    .verify_massrecruiter {
        margin: 0px 0 0 70px;
    }
    .verify_massrecruiter .confirmRecruiter {
        margin-top: 10px;
    }
    .verify_massrecruiter ul li {
        margin-top: 5px;
        margin-bottom: 5px;
    }
}

@media (max-width: 1139px) {
    .threecardslider.owl-theme .owl-nav button {
        position: relative;
        margin: 0 4px !important;
        left: auto !important;
        top: auto;
        bottom: auto;
        right: auto !important;
    }
}

@media (min-width: 991px) {
    .half-pink::after {
        position: absolute;
        content: '';
        top: 0;
        bottom: 0;
        right: 0;
        background: #ffeff1;
        width: 40%;
    }
}

@media (max-width: 991px) {
    .report-block-list ul.verticleListDesktop li {
        width: auto;
        padding-right: 15px;
    }
    .report-block-list ul li span {
        white-space: nowrap;
    }
}

@media (min-width: 768px) {
    .alumni_directory_filter #additionalfilter .fiterItem.col4 {
        width: 24.1%;
    }
}
@media (max-width: 767px) {
    .filter-toggle-wrap {
        top: 10px;
    }
    .filter-toggle-wrap a {
        padding: 4px 15px;
    }
    .report-block-list ul.verticleListTabMobile li {
        width: 100%;
    }
    .block-custom-tab {
        margin-left: 0;
    }
    .block-custom-tab .nav.custom-sub-tab {
        justify-content: center;
        margin-top: 30px;
    }
    .custom-sub-tab .nav-link {
        border-top: 4px solid white;
        border-radius: 6px 6px 0px 0;
        border-left: none;
        text-align: center;
        width: auto;
        white-space: nowrap;
    }
}

@media (max-width: 575px) {
    .verify_massrecruiter {
        width: 100%;
    }
    .block-header {
        padding: 17px 17px;
    }
    .block-custom-tab .nav.custom-sub-tab {
        justify-content: start;
        overflow: auto;
        flex-wrap: nowrap;
        width: 100%;
        padding: 0 5px;
    }
}

.message_date label {
    color: #919191;
    cursor: pointer;
}
.message_date label.dislike {
    transform: scale(-1) translateY(0px);
    display: inline-block;
    vertical-align: top;
    color: #919191;
}
.message_date input:checked + label[for='like'],
.message_date input:checked + label.like {
    color: #5cae48;
}
.message_date input:checked + label[for='dislike'],
.message_date input:checked + label.dislike {
    color: #333;
}
.updateadditionalinformation .custom-multi-select {
    border: 1px solid #e5e5e5 !important;
    border-radius: 6px;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    -ms-border-radius: 6px;
    -o-border-radius: 6px;
    height: auto !important;
}
.updateadditionalinformation .custom-multi-select > div{
    height: auto !important;
}
.updateadditionalinformation .custom-multi-select div.css-3w2yfm-ValueContainer {
    overflow: visible;
    white-space: normal;
    overflow-x: visible;
}
.updateadditionalinformation .custom-multi-select .css-b62m3t-container .css-t3ipsp-control,
.updateadditionalinformation .custom-multi-select .select__control,
.updateadditionalinformation .custom-multi-select .css-13cymwt-control {
    height: auto !important;
}
.updateadditionalinformation .custom-multi-select .css-b62m3t-container div[data-value] {
    display: inline-flex !important ;
  }
.logoImg.cls_top_companies img {
    max-height: 58px;
}
.logoImg img[src*='building.svg'] {
    width: 40px;
    height: auto;
}

.iframe-preview {
    max-width: 1366px;
    margin: 0 auto;
    padding: 0;
    height: 100%;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.iframe-preview.iframe-mobile {
    max-width: 400px;
}

/* Custom Scrollbar using CSS */
.iframe-preview {
    overflow-y: scroll;
}

/* scrollbar width */
.iframe-preview::-webkit-scrollbar {
    width: 5px;
}

/* scrollbar track */
.iframe-preview::-webkit-scrollbar-track {
    background: #eee;
}

/* scrollbar handle */
.iframe-preview::-webkit-scrollbar-thumb {
    border-radius: 1rem;
    background-color: #333;
}

.togglelinks {
    margin: auto;
    background: #ffffff 0% 0% no-repeat padding-box;
    border-radius: 4px;
    max-width: 320px;
    width: 100%;
    height: 50px;
    display: flex;
    overflow: hidden;
    border: 1px solid #0b3454;
}
.togglelinks a {
    flex: 1 1;
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    color: #0b3454;
    font-size: 16px;
    font-weight: 600;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.togglelinks a.btn-desktop i {
    width: 24px;
    height: 21px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/desktop-monitor.svg);
    margin-right: 10px;
}
.togglelinks a.btn-mobile i {
    width: 14px;
    height: 24px;
    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/dark-smartphone.svg);
    margin-right: 10px;
}
.togglelinks a.active {
    background: #0b3454;
    color: #fff;
}
.togglelinks a.active i,
.togglelinks a:hover i {
    filter: invert(1) brightness(170%);
}
.togglelinks a:hover {
    background: #294a64;
    color: #fff;
}
.tooltip-inner {
    background: #0b3454 !important;
    border: 1px solid #0b3454;
    font-size: 14px !important;
}
.bs-tooltip-top .tooltip-arrow::before {
    border-top-color: #0b3454;
}
.eventslink_willingness {
    color: white !important;
}
.form-select[disabled] {
    pointer-events: none;
    background-image: none !important;
}
.icon-yellow {
    filter: invert(62%) sepia(61%) saturate(610%) hue-rotate(0deg) brightness(104%) contrast(92%);
    -webkit-filter: invert(62%) sepia(61%) saturate(610%) hue-rotate(0deg) brightness(104%) contrast(92%);
}

.form-grid-section+.form-grid-section {
    margin-top: 30px;
}

.form-grid-section {
    padding: 25px;
    background: #f1f1f1;
    border-radius: 18px;
}

.form-grid-section .btn-delete {
    top: 0;
    bottom: 0;
    margin: auto;
}

.shake-err {
    animation: shake 0.2s ease-in-out 0s 2;
    color: #FF0000;
}

@keyframes shake {
    0% {
        transform: translateX(0.2rem);
    }

    25% {
        transform: translateX(0.5rem);
    }

    75% {
        transform: translateX(-0.5rem);
    }

    100% {
        transform: translateX(0rem);
    }
}

.upload_section.drag-over {
    border: 2px dashed #007bff;
    /* Blue border to indicate drag over */
    background-color: #f0f8ff;
    /* Light blue background color */
    cursor: default;
    /* Cursor set to default or as needed */
}

.cloud-text span {
    font-weight: bold;
    /* Make the "Drop here" text bold for emphasis */
}
.sd_formsec label:empty {
	display: none;
}

body:not(.modal-open) .modal-backdrop.show{display: none !important;}


.college-type ~ div.college-type-option {
    display: none;
}

.college-type:checked ~ div.college-type-option {
    display: flex;
}
.card.linkedin .card-header img {
    filter: brightness(00) invert(1);
    border-radius: 0 !important;
    width: 22px;
    margin-right: 10px;
    vertical-align: top;
}
.form-select{border: 1px solid #b5c2cb;height: 45px;}


.referred-college-logo img {max-height: 90px;max-width: 200px;}
.referral-progress-card {  }
.profileimg-name { padding: 20px; background: #0B3454; border-radius: 8px 8px 0 0; -webkit-border-radius: 8px 8px 0 0; -moz-border-radius: 8px 8px 0 0; -ms-border-radius: 8px 8px 0 0; -o-border-radius: 8px 8px 0 0; display: flex; flex-direction: column; align-items: center;}
.referral-profile-detail {background: #FFFFFF;border: 1px solid #A8ACAF;border-radius: 0 0 8px 8px;-webkit-border-radius: 0 0 8px 8px;-moz-border-radius: 0 0 8px 8px;-ms-border-radius: 0 0 8px 8px;-o-border-radius: 0 0 8px 8px;padding:25px ;}
.referral-profile-detail ul{padding: 0;margin: 0;list-style: none;}
.referral-profile-detail ul li:not(:last-child){margin-bottom: 15px;}
.referral-profile-detail ul li{ display: flex;}
.referral-profile-detail ul li i {width: 25px;height: 25px; display: flex;margin-right: 15px;margin-top: 2px;}
.referral-profile-detail ul li i.hand-share{background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/deal.svg) no-repeat top center;}
.referral-profile-detail ul li i.mobile{background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/mobile.svg) no-repeat top center;}
.referral-profile-detail ul li i.email{background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/mail.svg) no-repeat top center;}
.referral-profile-detail ul li i.referred {background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/referred-on.svg) no-repeat top center;}
.referral-profile-detail ul li div{width: calc(100% - 40px);line-height: 18px;word-wrap: anywhere;}
.referral-profile-detail ul li a{color: #358CEF; text-decoration: none;}
.referral-profile-detail ul li a:hover{color: #0B3454;}
.profileimg-name .img { display: flex; justify-content: center; align-items: center; border-radius: 50%; overflow: hidden; margin-top: -60px; width: 90px; height: 90px; box-shadow: 0 0 1px 0px #6f6f6f; -webkit-border-radius: 50%; -moz-border-radius: 50%; -ms-border-radius: 50%; -o-border-radius: 50%;}
.profileimg-name .img img {width: auto;height: 100%;}
.profileimg-name .profile-name {color: #fff;margin-top: 8px;font-size: 20px;font-weight: 600;}

.referral-progress-track {background: #F9FCFF;border: 2px solid #0B345436;border-radius: 20px;opacity: 1;}
.referral-progress-track ul{padding: 0;margin: 0;list-style: none;}
.referral-progress-track ul li{ display: flex;align-items: center;}
.referral-progress-track ul li:not(:last-child){margin-bottom: 50px;}
.referral-progress-track ul li .icon{width: 37px;min-width: 37px; display: flex;align-items: center;justify-content: center;}
.referral-progress-track ul li .dot{ width: 26px; height: 26px;margin: 0 20px; position: relative; display: flex;align-items: center;justify-content: center;}
.referral-progress-track ul li .dot i{width: 20px; height: 20px;border: 2px solid #6B6868; border-radius:50% ; -webkit-border-radius:50% ; -moz-border-radius:50% ; -ms-border-radius:50% ; -o-border-radius:50% ;background-color: #fff;}
.referral-progress-track ul li:not(:last-child) .dot::after {content: '';position: absolute;left: 0;right: 0;margin: auto;border-right: 2px dashed #6B6868;height: calc(100% + 50px);top: 100%;width: 0;}
.referral-progress-track ul li:not(.completed) img {filter: invert(46%) sepia(0%) saturate(14%) hue-rotate(6deg) brightness(91%) contrast(96%);-webkit-filter: invert(46%) sepia(0%) saturate(14%) hue-rotate(6deg) brightness(91%) contrast(96%);}
.referral-progress-track ul li.completed .dot i{background: #5CAE48;border-color:#5CAE48;width: 26px;height: 26px;}
.referral-progress-track ul li.completed .dot i::before { content: ''; position: absolute; border-left: 3px solid #fff; border-bottom: 3px solid #fff; width: 13px; height: 7px; top: 8px; left: 6px; transform: rotate(-45deg); -webkit-transform: rotate(-45deg); -moz-transform: rotate(-45deg); -ms-transform: rotate(-45deg); -o-transform: rotate(-45deg);}
.referral-progress-track ul li.completed .dot::after{border-right: 2px solid #5CAE48;}
.referral-progress-track ul li.completed .track-label .font-16{font-weight: 600;}
.icon.workex-logo {border: 1px solid #ccc;padding: 10px;background: none;}


table.row, div[contenteditable] table {    margin: auto;}

table.row>*  {padding:inherit}

table.row tr, table.row td, div[contenteditable] table tr, div[contenteditable] table td{display: block;}

.edit-controls i{font-size: 24px;cursor: pointer;}

.edit-controls .icon-disable {
    position: relative;
    border: 1px solid #ccc;
    border-radius: 50%;
    padding: 5px;
    width: 35px;
    height: 35px;
}

.edit-controls button{
    border: none;padding: 0;background-color: transparent;
}

.edit-controls .icon-disable:before {
    content: '';
    position: absolute;
    width: 24px;
    height: 2px;
    background: #585555;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
    -moz-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    -o-transform: rotate(45deg);
}

div.custom-multi-select div[class*="css"] {
    height: auto !important;
    white-space: normal;
}

.lstCustForm div.custom-multi-select div[class*="-control"] {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border: 1px solid #b5c2cb !important;
}

.dual-search{ display: flex;flex: 1 1;}

@media (max-width: 575px) {
    .dual-search{order: -1;flex-basis: 100%; margin-bottom: 10px;} 
}

.icon-plus.circle {border: 2px solid #fff;border-radius: 50%;margin-right: 7px;width: 18px;height: 18px;}
.icon-plus.circle::before, .icon-plus.circle::after  {height: 8px;}


div.owl-carousel.cardslider .owl-nav {
  margin: 5px 0 0 45px;
  text-align: left;display: flex;
  
}

div.owl-carousel.cardslider .owl-nav button {
  background: #0b3454;
  padding: 2px 15px !important;
  border-radius: 25px;
  margin: 2px;
  line-height: 17px;display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}
div.owl-carousel.cardslider .owl-nav button span {display: flex;
	margin: -2px 0 0;
}

.nav-item.disabled{
    cursor: not-allowed !important
}
/* new contribution tab design */
.block-custom-tab .video_block {background: #ffffff;border: 1px solid #d2d2d2;border-radius: 6px;overflow: hidden;text-decoration: none;position: relative;display: inline-block;color: #000;transition: all 0.3s ease-in-out;-webkit-transition: all 0.3s ease-in-out;-moz-transition: all 0.3s ease-in-out;-ms-transition: all 0.3s ease-in-out;-o-transition: all 0.3s ease-in-out;padding: 0;}

.block-custom-tab  .video_block:hover{background-color: #fff;}
.block-custom-tab  .video_block:hover,
.block-custom-tab  .video_block:hover .icon-invert-play {
color: #5cae48;
}
/* end contribution tab new*/
.custom-alret {
    padding: 10px 25px;
    box-shadow: 0 0 4px 3px #ccc;
    border-radius: 45px;
    margin-bottom: 25px;
}

button.btn-close.w-20 {
    width: 14px;
    padding: 0;
}

.loaderNew {width: 50px;aspect-ratio: 1;display: grid;border: 4px solid #0000;border-radius: 50%;border-right-color: #25b09b;animation: l15 1s infinite linear;}
.loaderNew::before,.loaderNew::after {content: "";grid-area: 1/1;margin: 2px;border: inherit;border-radius: 50%;animation: l15 2s infinite;}
.loaderNew::after {margin: 8px;animation-duration: 3s;}

@keyframes l15 {
    100% {
        transform: rotate(1turn)
    }
}

.widget-list:not(:last-child) {border-bottom: 1px solid #e5e5e5;}
.manage-widgets-wrap .icon-down-arrow{transition: all 0.3s ease-in-out;}
.manage-widgets-wrap .icon-down-arrow[aria-expanded="true"]{transform: rotate(180deg);}


/* New css add 03022025 */

.social-platform-wrap {width: max-content;min-width: 100%;}
.social-platform-wrap ul {list-style: none;padding: 0;margin: 0;display: flex;}
.social-platform-wrap ul li {background: #FFFFFF;border: 1px solid #D2D2D2;border-radius: 6px;width: 275px;height: 156px;position: relative;padding: 20px;display: flex;flex-direction: column;align-items: center;}
.social-platform-wrap ul li:not(:last-child){margin-right: 13px;}
.social-platform-wrap ul li .form-input-check { position: absolute; top: 20px; left: 20px; width: 20px; height: 20px; border: 1px solid #888F95; appearance: none; border-radius: 4px; transition: all 0.3s ease-in-out; -webkit-transition: all 0.3s ease-in-out; -moz-transition: all 0.3s ease-in-out; -ms-transition: all 0.3s ease-in-out; -o-transition: all 0.3s ease-in-out; -webkit-border-radius: 4px; -moz-border-radius: 4px; -ms-border-radius: 4px; -o-border-radius: 4px;cursor: pointer;}
.social-platform-wrap ul li .form-input-check:checked{background-color: #5CAE48;border-color: #5CAE48;background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});}

.social-platform-wrap ul li label {font-size: 18px;font-weight: 600;margin-bottom: 7px;}
.share-copy {position: absolute;bottom: 20px;right: 20px;display: flex;}
.share-link {background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/share-icon.svg) no-repeat 0 0;width: 22px;height: 24px;margin-right: 20px;}
.copy-link{background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/copy-icon.svg) no-repeat 0 0;width: 22px;height: 24px;}
.share-copy a:hover{ filter: invert(54%) sepia(40%) saturate(590%) hue-rotate(62deg) brightness(101%) contrast(94%); -webkit-filter: invert(54%) sepia(40%) saturate(590%) hue-rotate(62deg) brightness(101%) contrast(94%); }

.form-check .form-check-input[disabled]:checked {	background-color: #606060;	border-color: #626262;}
.form-captcha {width: 100%;height: 45px;border: 1px solid #D2D2D2;display: flex;align-items: center;justify-content: center;border-radius: 4px;-webkit-border-radius: 4px;-moz-border-radius: 4px;-ms-border-radius: 4px;-o-border-radius: 4px;}

/* ai chat */

.btn-chat-ai { background: #5cae48; position: fixed; bottom: 40px; right: 40px; padding: 10px 20px; border-radius: 25px; text-decoration: none; color: #fff; display: flex; align-items: center; font-size: 18px; text-decoration: none; transition:all 0.3s ease-in-out ; -webkit-transition:all 0.3s ease-in-out ; -moz-transition:all 0.3s ease-in-out ; -ms-transition:all 0.3s ease-in-out ; -o-transition:all 0.3s ease-in-out ; }
.btn-chat-ai i {  margin-right: 7px;}
.btn-chat-ai:hover{color: #fff;background-color: #0b3454;}

.ai-chat-wrap {height: 100vh;padding: 0;}
.ai-chat-wrap .ai-chat {height: 100%;max-width: 1140px;width: 96%;margin: auto;border-radius: 10px;}
.ai-chat-wrap .ai-chat .alumni_chat_block {background: none;min-height: inherit;}
.ai-chat-wrap .ai-chat .alumni_chat_block_header {padding: 20px 0;background: transparent;border-radius: 10px 10px 0px 0px;border-bottom: 1px solid #efefef;-webkit-border-radius: 10px 10px 0px 0px;-moz-border-radius: 10px 10px 0px 0px;-ms-border-radius: 10px 10px 0px 0px;-o-border-radius: 10px 10px 0px 0px;position: relative;overflow: hidden;}
.ai-chat-wrap .ai-chat .alumni_chat_conversation_send {padding: 30px 0;background: transparent;border-radius: 0px 0 10px 10px;border-top: 1px solid #efefef;-webkit-border-radius: 0px 0 10px 10px;-moz-border-radius: 0px 0 10px 10px;-ms-border-radius: 0px 0 10px 10px;-o-border-radius: 0px 0 10px 10px;}
.alumni_chat_block_header i.icon-chat-invert {position: absolute;top: 0;right: 20px;font-size: 140px;width: 140px;color: #e1e1e1;}
.ai-img { width: 70px; height: 70px;display: flex; align-items: end; background: #ededed; justify-content: center; border-radius: 50%; overflow: hidden; -webkit-border-radius: 50%; -moz-border-radius: 50%; -ms-border-radius: 50%; -o-border-radius: 50%;}
i.icon-compose-mail {background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/message-compose.svg) no-repeat 0 0;width: 40px;height: 40px;display: flex;margin: 0;padding: 0;}

.ai-chat .get_started {flex-direction: column-reverse;overflow: auto;}
.coversation-block{flex-direction: column-reverse;overflow: auto;}
.ai-chat .icon-turn-off {width: 15px;height: 15px;border-left: 2px solid #555;border-bottom: 2px solid #555;border-right: 2px solid #555;border-radius: 50%;border-top: 3px solid transparent;position: relative;top: -20px;right: 5px;text-decoration: none;transition: all 0.3s ease-in-out;-webkit-transition: all 0.3s ease-in-out;-moz-transition: all 0.3s ease-in-out;-ms-transition: all 0.3s ease-in-out;-o-transition: all 0.3s ease-in-out;}
.ai-chat .icon-turn-off:before {content: '';position: absolute;left: 0;right: 0;top: auto;width: 2px;height: 8px;bottom: 5px;background: #555;margin: auto;transition: all 0.3s ease-in-out;-webkit-transition: all 0.3s ease-in-out;-moz-transition: all 0.3s ease-in-out;-ms-transition: all 0.3s ease-in-out;-o-transition: all 0.3s ease-in-out;}

.ai-chat .icon-turn-off:hover{border-left: 2px solid #f0555f;border-bottom: 2px solid #f0555f;border-right: 2px solid #f0555f;}
.ai-chat .icon-turn-off:hover:before {background: #f0555f;}

.justify-content-end .date {text-align: right;}
.user-chat .ai-img {  width: 60px; height: 60px;font-size: 48px;  color: #979797;}

.rating-emoji label { background-repeat: no-repeat; background-position: center; background-size: 30px; margin-right: 10px; width: 30px; height: 30px; cursor: pointer; transition:all 0.3s ease-in-out ; -webkit-transition:all 0.3s ease-in-out ; -moz-transition:all 0.3s ease-in-out ; -ms-transition:all 0.3s ease-in-out ; -o-transition:all 0.3s ease-in-out ; background-color: #000; border: 1px solid #af8d09; border-radius: 50%; -webkit-border-radius: 50%; -moz-border-radius: 50%; -ms-border-radius: 50%; -o-border-radius: 50%; }
.rating-emoji .sad{background-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});}
input[name="rating"]:checked + .sad{background-color: #fff;border: 1px solid #ae000b;background-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});}

.rating-emoji .neutral{background-image: url(${___CSS_LOADER_URL_REPLACEMENT_40___});}
input[name="rating"]:checked + .neutral{background-color: #fff;border: 1px solid #f1a200;background-image: url(${___CSS_LOADER_URL_REPLACEMENT_41___});}

.rating-emoji .happy{background-image: url(${___CSS_LOADER_URL_REPLACEMENT_42___});}
input[name="rating"]:checked + .happy{background-color: #fff;border: 1px solid #5bae47;background-image: url(${___CSS_LOADER_URL_REPLACEMENT_43___});}

ul.feed-back-list {padding: 5px 0 0;margin: 0;list-style: none;max-width: 500px;}
ul.feed-back-list li:not(:last-child) {margin-bottom: 10px;}
ul.feed-back-list li{background: #f7f7f7;border-radius: 50px;-webkit-border-radius: 50px;-moz-border-radius: 50px;-ms-border-radius: 50px;-o-border-radius: 50px;padding: 12px 25px;border: 1px solid #ccc;line-height: 18px;font-size: 16px;}

@media (max-width:767px){
.ai-chat-wrap{padding: 0;}
.ai-chat-wrap .ai-chat{ width: 100%; border-radius:0 ; -webkit-border-radius:0 ; -moz-border-radius:0 ; -ms-border-radius:0 ; -o-border-radius:0 ; }
.ai-chat-wrap .ai-chat .alumni_chat_block_header {padding: 15px;border-radius: 0;-webkit-border-radius: 0;-moz-border-radius: 0;-ms-border-radius: 0;-o-border-radius: 0;}
.ai-img {width: 55px;height: 55px;}
.ai-chat-wrap .ai-chat .alumni_chat_conversation_send {padding: 30px 15px 15px;border-radius: 0;-webkit-border-radius: 0;-moz-border-radius: 0;-ms-border-radius: 0;-o-border-radius: 0;}
.get_started_prompt a {	padding: 6px 20px;	font-size: 16px;}
ul.feed-back-list li{ border-radius: 5px; -webkit-border-radius: 5px; -moz-border-radius: 5px; -ms-border-radius: 5px; -o-border-radius: 5px; padding: 10px; }
}

.college-type ~ div.college-type-option {display: none;}
.college-type:checked ~ div.college-type-option {display: flex;}

/* .max-min-250{min-width: 250px;max-width: 250px;} */

.TopperSlider .nav {justify-content: center;}
.TopperSlider .nav .nav-item:not(:last-child){margin-right: 20px;}
.TopperSlider .nav .nav-link {background: transparent;border: 1px solid #206EAA;position: relative;color: #fff;white-space: nowrap;}
.TopperSlider .nav .nav-link::before { content: ''; position: absolute; bottom: 0; left: 0; right: 0; border-left: 7px solid transparent; border-right: 7px solid transparent; border-top: 7px solid #4096d9; width: 0; height: 0; margin: auto; opacity: 0; transition:all 0.3s ease-in-out ; -webkit-transition:all 0.3s ease-in-out ; -moz-transition:all 0.3s ease-in-out ; -ms-transition:all 0.3s ease-in-out ; -o-transition:all 0.3s ease-in-out ; }
.TopperSlider .nav .nav-link.active{background-color: #4096D9;border: 1px solid #4096D9;}
.TopperSlider .nav .nav-link.active:before{bottom: -8px;opacity: 1;}

.TopperSlider .scroll{overflow-x: auto;overflow-y: hidden;}
.TopperSlider .scroll::-webkit-scrollbar {width: 4px;}
.TopperSlider .scroll::-webkit-scrollbar-track {background: #f1f1f1;}
.TopperSlider .scroll::-webkit-scrollbar-thumb {background: #888;}
.TopperSlider .scroll::-webkit-scrollbar-thumb:hover {background: #555;} 


@media (min-width:768px){
.TopperSlider.vertical-style { display: flex;-webkit-box-wrap: wrap;-moz-box-wrap: wrap;-ms-flex-wrap: wrap;-webkit-wrap: wrap;flex-wrap: wrap;}
.TopperSlider.vertical-style .scroll {width: 160px;margin-right: 20px;}
.TopperSlider.vertical-style .tab-content {width: calc(100% - 180px);}
.TopperSlider.vertical-style .nav{margin-top: 10px;width: 100%;}
.TopperSlider.vertical-style .nav .nav-item{width: 100%;}
.TopperSlider.vertical-style .nav .nav-item:not(:last-child) {	margin: 0 0 20px;}
.TopperSlider.vertical-style .nav .nav-link{width: calc(100% - 15px);padding: 14px 25px;}
.TopperSlider.vertical-style .nav .nav-link::before {bottom: 0;left: auto;right: -15px;top: 0;border-left: 7px solid #4096d9;border-right: 7px solid transparent;border-top: 7px solid transparent;border-bottom: 7px solid transparent;}
.TopperSlider.vertical-style .threecardslider.owl-theme .owl-nav button{position: relative;margin: 0 5px !important;left: auto;right: auto;}
}

@media (max-width:767px){
.TopperSlider .nav {justify-content: start;flex-wrap: nowrap;}
}

.card-wrap{ display: flex;flex-direction: column;height: 100%;}
.card-wrap .card-title {font-size: 18px;font-weight: 500;text-align: center;}
.card-wrap .card-detail {background: #F5F5F5 ;border-radius: 12px;padding: 14px;flex: 1 1;}
.card-wrap .card-detail .post-img{margin-bottom: 7px;}
.noScrollBarScroll {max-height: 315px;overflow-y: auto;min-height: 315px;scrollbar-width: none;}
.noScrollBarScroll .scroll::-webkit-scrollbar {width: 0px;}

.canvas { display: flex;-webkit-box-wrap: wrap;-moz-box-wrap: wrap;-ms-flex-wrap: wrap;-webkit-wrap: wrap;flex-wrap: wrap;}
.canvas-edit-tools {background: #0B3454; display: flex;-webkit-box-wrap: wrap;-moz-box-wrap: wrap;-ms-flex-wrap: wrap;-webkit-wrap: wrap;}

.canvas-edit-tools ul {padding: 0;margin: 0;list-style: none;width: 75px;}
.canvas-edit-tools ul li { display: flex;justify-content: center;align-items: center;color: #fff;border-bottom: 1px solid #236CA5;}
.canvas-edit-tools ul li a{ padding: 20px; display: flex; -webkit-box-wrap: wrap; -moz-box-wrap: wrap; -ms-flex-wrap: wrap; -webkit-wrap: wrap; flex-wrap: wrap; justify-content: center; align-items: center; text-decoration: none; color: #85C5F8; min-height: 75px; width: 100%; transition:all 0.3s ease-in-out ; -webkit-transition:all 0.3s ease-in-out ; -moz-transition:all 0.3s ease-in-out ; -ms-transition:all 0.3s ease-in-out ; -o-transition:all 0.3s ease-in-out ; }
.canvas-edit-tools ul li a i{ transition:all 0.3s ease-in-out ; -webkit-transition:all 0.3s ease-in-out ; -moz-transition:all 0.3s ease-in-out ; -ms-transition:all 0.3s ease-in-out ; -o-transition:all 0.3s ease-in-out ; }
.canvas-edit-tools ul li a:hover, .canvas-edit-tools ul li a.active{background-color: #236CA5;color: #fff;}
.canvas-edit-tools ul li a:hover i, .canvas-edit-tools ul li a.active i{ filter:brightness(0) invert(1) ; -webkit-filter:brightness(0) invert(1) ; }
.canvas-main {flex: 1 1;background: #F5F5F5; display: flex;flex-direction: column;}

.icon-resize {width: 22px;height: 22px;background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/maximize.svg) no-repeat center;}
.icon-picture {width: 22px;height: 22px;background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/gallery.svg) no-repeat center;}
.icon-text {width: 22px;height: 22px;background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/text.svg) no-repeat center;}

.icon-original{width: 48px;height: 61px;background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/orginal.svg) no-repeat center;}
.icon-instagram-story{width: 37px;height: 69px;background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/instagramstory.svg) no-repeat center;}
.icon-youtube-thumbnail{width: 87px;height: 50px;background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/outubethumbnail.svg) no-repeat center;}
.icon-facebook-profile{width: 62px;height: 62px;background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/facebookprofile.svg) no-repeat center;}
.icon-banner{width: 87px;height: 17px;background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/banner.svg) no-repeat center;}
.icon-large-rectangle{width: 92px;height: 36px;background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/largerectangle.svg) no-repeat center;}

.canvas-edit-tools-options {border-left: 1px solid #236CA5;height: 100%;width: 0;transition: all 0.3s ease-in-out;-webkit-transition: all 0.3s ease-in-out;-moz-transition: all 0.3s ease-in-out;-ms-transition: all 0.3s ease-in-out;-o-transition: all 0.3s ease-in-out;overflow: hidden;}
.canvas-edit-tools-options ul {display: none;-webkit-box-wrap: wrap;-moz-box-wrap: wrap;-ms-flex-wrap: wrap;-webkit-wrap: wrap;flex-wrap: wrap;width: auto;width: 300px;padding: 10px 5px;justify-content: center;}
.canvas-edit-tools-options ul li {margin: 5px;border: none;}
.canvas-edit-tools-options ul li a {width: 130px;height: 100%;min-height: 130px; flex-direction: column;border-radius: 5px;background: #0D3E64;padding: 10px;flex-wrap: nowrap;  text-align: center;}
.canvas-edit-tools-options ul li a:hover{background-color: #fff;color: #0B3454;}
.canvas-edit-tools-options ul li a:hover i{ filter:none; -webkit-filter:none; }
.canvas-edit {background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/border-graph.svg) no-repeat 0 0 / 100%;padding: 10px;max-width: 360px;width: 100%; display: flex;justify-content: center;align-items: center;height: 357px;}
.open  .canvas-edit-tools-options {width: 300px;}
.open .canvas-edit-tools-options ul { display: flex;}

.icon-wrap { display: flex;justify-content: center;align-items: center;height: 70px;margin-bottom: 5px;}

.scale {background: #0B3454; display: flex;justify-content: center;align-items: center;height: 40px;}
.scale a { border: 1px solid #408AC2; width: 20px; height: 20px; position: relative; margin: 0 10px; border-radius: 50%; -webkit-border-radius: 50%; -moz-border-radius: 50%; -ms-border-radius: 50%; -o-border-radius: 50%; transition:all 0.3s ease-in-out ; -webkit-transition:all 0.3s ease-in-out ; -moz-transition:all 0.3s ease-in-out ; -ms-transition:all 0.3s ease-in-out ; -o-transition:all 0.3s ease-in-out ; }
.scale a::before{ content: ''; position: absolute; width: 10px; height: 2px; background: #408AC2; left: 0; right: 0; top: 0; bottom: 0; margin: auto; transition:all 0.3s ease-in-out ; -webkit-transition:all 0.3s ease-in-out ; -moz-transition:all 0.3s ease-in-out ; -ms-transition:all 0.3s ease-in-out ; -o-transition:all 0.3s ease-in-out ; }
.scale a::after{ content: ''; position: absolute; width: 10px; height: 2px; background: #408AC2; left: 0; right: 0; top: 0; bottom: 0; margin: auto; transition:all 0.3s ease-in-out ; -webkit-transition:all 0.3s ease-in-out ; -moz-transition:all 0.3s ease-in-out ; -ms-transition:all 0.3s ease-in-out ; -o-transition:all 0.3s ease-in-out ; }
.scale a.btn-plus::after{ transform:rotate(90deg) ; -webkit-transform:rotate(90deg) ; -moz-transform:rotate(90deg) ; -ms-transform:rotate(90deg) ; -o-transform:rotate(90deg) ; }
.scale a:hover{background: #408AC2;}
.scale a:hover::before, .scale a:hover::after{background: #fff;}

.scale .range {width: 180px;}
.scale .range .progress {height: 2px;border-radius: 5px;background: #074D83;overflow: visible;}
.scale .range .progress .progress-bar {background: #fff;position: relative;overflow: visible;}
.scale .range .progress .progress-bar:after {content: '';position: absolute;background: #0b3454;width: 12px;height: 12px;border: 2px solid #fff;right: -6px;border-radius: 50%;}

.canvas-main .icon-picture {width: 90px;height: 90px;background-size: 100%;filter: brightness(0) invert(0);opacity: 0.5;margin-bottom: 15px;}

.btn.btn-open {background: #F5F5F5;border: 1px solid #6B6868;padding: 3px 30px 5px;border-radius: 25px;font-weight: 500;transition:all 0.3s ease-in-out ;-webkit-transition:all 0.3s ease-in-out ;-moz-transition:all 0.3s ease-in-out ;-ms-transition:all 0.3s ease-in-out ;-o-transition:all 0.3s ease-in-out ;}
.btn.btn-open:hover{background: #6B6868;color: #fff;}

.canvas-photos-library {	width: 300px;}
.canvas-photos-library > div{padding: 12px;}
.canvas-photos-library > div:first-child{border-bottom: 1px solid #236CA5;}
.search-photos .form-control {	border: none;	height: 40px;}
.canvas-photos-library .link{color: #6AABDD;text-decoration: none;}
.canvas-photos-library .link:hover{color: #fff;}
.canvas-text {padding: 15px;height: 100%;width: 300px;} 
.text-block {background: #fff;border-radius: 8px;padding: 15px;}
.height-90 {height: 90px;}
.color-wrap {background: #FFFFFF;border-radius: 4px;padding: 10px; display: flex;}
.color-wrap label {margin-right: 8px;font-weight: 600;}
.color-wrap input {border: none;width: 22px;height: 22px;border-radius: 5px;}

.text-color-236CA5{color: #236CA5;}
.btn-back-text {background: transparent;border: 2px solid #fff;border-radius: 25px;height: 40px;color: #fff;transition:all 0.3s ease-in-out ;-webkit-transition:all 0.3s ease-in-out ;-moz-transition:all 0.3s ease-in-out ;-ms-transition:all 0.3s ease-in-out ;-o-transition:all 0.3s ease-in-out ;}
.btn-back-text:hover{background: #fff;color: #000;}

.color-field { display: flex; -webkit-box-wrap: wrap; -moz-box-wrap: wrap; -ms-flex-wrap: wrap; -webkit-wrap: wrap; flex-wrap: wrap; background: #FFFFFF 0% 0% no-repeat padding-box; border: 1px solid #D2D2D2; border-radius: 4px; padding: 6px; -webkit-border-radius: 4px; -moz-border-radius: 4px; -ms-border-radius: 4px; -o-border-radius: 4px; }
.color-field label {margin-right: 8px;margin-left: 5px;}
.color-field input { border: none; outline: none; appearance: none; box-shadow: none; border-radius: 4px; -webkit-border-radius: 4px; -moz-border-radius: 4px; -ms-border-radius: 4px; -o-border-radius: 4px;}

.profile-poster-wrapper {background: transparent linear-gradient(117deg, #00805F 0%, #FDB813 60%, #A6CE3A 100%) 0% 0% no-repeat padding-box;padding: 30px 30px;min-width: 1092px;max-width: 1200px;}
.profile-poster {background: #FFFFFF;border-radius: 40px 40px 0 0;padding: 2%;display: flex;-webkit-box-wrap: wrap;-moz-box-wrap: wrap;-ms-flex-wrap: wrap;-webkit-wrap: wrap;flex-wrap: wrap;position: relative;overflow: hidden;min-height: 605px;}

.profile-poster-curve {content: '';background: #00805f;position: absolute;bottom: 0;top: 394px;left: -123px;width: 537px;height: 537px;border-radius: 50%;}
.profile-poster-left {width: 25%; display: flex;flex-direction: column;align-items: center;padding-top: 20px;position: relative;}
.alumni-cards-curve-first {position: absolute;background: #00805f;border-radius: 50%;width: 190%;height: 28%;left: -44%;right: 0;margin: auto;top: -3%;z-index: 1;}
.alumni-cards-curve-second {position: absolute;background: #c8c32a;border-radius: 50%;width: 190%;height: 28%;left: -43%;right: 0;margin: auto;top: -2%;z-index: 0;transform: rotate(2deg);}
.profile-poster-left .powerby {flex-direction: revert;margin-top: 15px;color: #fff;}
.profile-poster-left .powerby span {margin-right: 5px;}
.college-logo {margin-bottom: 20px;}
.community-title {margin-bottom: 20px;font-size: 32px;font-weight: 600;color: #008060;width: 90%;text-align: center;line-height: 35px;}
.scan-wrap {background: #fff;padding: 18px;max-width: 185px;text-align: center;}
.scan-heading {font-size: 12px;line-height: 17px;letter-spacing: 6.01px;color: #000000;margin-bottom: 12px;}
.profile-poster-right {width: 75%;padding: 50px 0 0;}
.profile-poster-right h3{font-size: 20px;font-weight: 600;margin-bottom: 0px;text-align: center;}

.profile-poster-alumni {display: flex;flex-wrap: wrap;-webkit-box-wrap: wrap;-moz-box-wrap: wrap;-ms-flex-wrap: wrap;-webkit-wrap: wrap;margin-bottom: 50px;justify-content: center;}

.profile-poster-right h3[contenteditable] {border: 2px dashed #000;position: relative;padding: 3px 7px;}
.profile-poster-right h3:focus-visible {outline: none;}
.profile-poster-right h3[contenteditable]::before {content: "\\e912";font-family: "icomoon" !important;font-style: normal;font-weight: normal;font-variant: normal;text-transform: none;line-height: 1;position: absolute;top: -23px;right: -23px;}
.alumni-cards {width: 23.4%;border: 1px solid rgba(195, 195, 195, 0.35);border-radius: 12px;opacity: 1;display: flex;flex-direction: column;align-items: center;padding: 2% 10px;position: relative;min-height: 275px;background-color: #ffffff; }
.alumni-cards .alumni-img {width: 80px;height: 80px;display: flex;justify-content: center;overflow: hidden;border-radius: 50%;background-color: #f0f0f0; z-index: 2;position: relative;}
.alumni-cards .alumni-img img {min-width: 100%;min-height: 100%;max-height: 100%;object-fit: cover; }
.alumni-cards h4 {color: #FDB813;font-size: 15px;margin: 10px 0 0;min-height: 20px; text-align: center;}
.alumni-cards .batch {font-size: 13px;min-height: 16px;}
.alumni-cards .batch + i {width: 59px;height: 1px;background: linear-gradient(90deg, #A6CE3A 0%, #00805F 57%, #FDB813 100%);margin: 10px 0;}
.alumni-cards > div {min-height: 20px;}
.alumni-cards:not(:last-child) {margin-right: 14px;}
.alumni-cards {width: 23.4%;background: #FFF;border: 1px solid #C3C3C359;border-radius: 12px;opacity: 1;display: flex;flex-wrap: wrap;-webkit-box-wrap: wrap;-moz-box-wrap: wrap;-ms-flex-wrap: wrap;-webkit-wrap: wrap;flex-direction: column;align-items: center;padding: 2% 10px;position: relative;}
.alumni-cards > div{position: relative;}
.alumni-cards h4 {color: #FDB813;font-size: 15px;margin: 10px 0 0;}
.alumni-cards > div.batch {font-size: 13px;}

.alumni-cards .divider {width: 59px;height: 0.720733642578125px;background: transparent linear-gradient(90deg, #A6CE3A 0%, #00805F 57%, #FDB813 100%) 0% 0% no-repeat padding-box;margin: 10px 0;}
.alumni-University-list {text-align: center;font-size: 14px;}
.alumni-University-list .heading {color: #000;}
.alumni-University-list .brife {color: #A6CE3A;font-size: 14px;font-weight: 600;}
.alumni-University-list:not(:last-child) {margin-bottom: 10px;}
.alumni-companies-list {display: flex;justify-content: center;}
.company-block { border: 1px solid #00805F5C; border-radius: 6px; opacity: 1; overflow: hidden; display: flex; align-items: center; justify-content: center; height: 65px; padding: 0 10px; -webkit-border-radius: 6px; -moz-border-radius: 6px; -ms-border-radius: 6px; -o-border-radius: 6px;}
.company-block:not(:last-child) {margin-right: 7px;}
.company-block img {max-width: 90px;height: auto;}

.leaders-poster {max-width: 1080px;background: #0164A7 ;position: relative;overflow: hidden;}
.leaders-poster-container{background-color: #fff;border-radius: 98px 0px 0px 0px;}

.leaders-poster .college-logo {position: absolute;top: 7%;left: 9%;z-index: 2;margin: 0;width: 18.5%;}
.leaders-poster .college-logo img{max-height: 80px;}
.leaders-poster-alumni {position: absolute;left: 13.5%;top: 29%;z-index: 1;background: #C79757;padding: 10.8%;border-radius: 50%;overflow: hidden;display: flex;justify-content: center;align-items: center;}
.leaders-poster-alumni img {position: absolute;top: 0;bottom: 0;margin: auto;width: auto;height: 100%;}
.leaders-poster-alumni-detail {position: absolute;left: 40%;top: 35%;width: 49%;}
.leaders-poster-alumni-name {color: #0064A7;font-size: 50px;font-weight: 700;line-height: 55px;padding-left: 3%;}
.leaders-poster-alumni-batch-school {font-size: 30px;font-weight: 500;padding-left: 3%;}
.curve-line {margin: 10px 0 40px;}
.pursuing {padding-left:3%;position: relative;}
.pursuing:not(.alumni_univarsity_details) i {position: absolute;width: 6px;height: 40px;background: #C79757;left: 0%;top: 4%;}
.pursuing-logo{width: 30px;height: 30px;display: flex;align-items: center;justify-content: center;}
.pursuing-logo img{max-width: 30px;max-height: 30px;}
.pursuing-title {font-size: 35px;margin-bottom: 20px;}
.pursuing-title span {font-weight: 600;}
.expertise {position: absolute;top: 79%;left: 12%;font-size: 1.6vw;width: 60%;line-height: 2.1vw;}
.expertise strong {display: block;}
.expertise i {position: absolute;width: 6px;height: 40px;background: #C79757;left: -4%;top: -34%;}
.max-540{max-width: 540px;}
.max-540 .leaders-poster-alumni-name{font-size: 24px;line-height: 26px;}
.max-540 .leaders-poster-alumni-batch-school {	font-size: 16px;}
.max-540 .pursuing-title {font-size: 20px;margin-bottom: 5px;}
.max-540 .pursuing i {width: 2px;height: 20px;left: 0%;top: 4%;}
.max-540 .expertise i {width: 3px;height: 30px;left: -6%;top: -34%;}
.max-540 .expertise {font-size: 20px;line-height: 24px;}
.max-540 .curve-line {	margin: 0px 0 20px;}

.max-430{max-width: 430px;}
.min-430{min-width: 430px;}
.max-430 .leaders-poster-alumni {	left: 12.5%;}
.max-430 .leaders-poster-alumni-detail {left: 37%;top: 32%;}
.max-430 .leaders-poster-alumni-name{font-size: 20px;  line-height: 22px;}
.max-430 .leaders-poster-alumni-batch-school {	font-size: 13px;}
.max-430 .pursuing-title {font-size: 18px;margin-bottom: 5px;}
.max-430 .pursuing-title.font-13{line-height: 14px;}
.max-430 .pursuing i {width: 2px;height: 20px;left: 0%;top: 4%;}
.max-430 .expertise i {width: 3px;height: 30px;left: -6%;top: -34%;}
.max-430 .expertise {font-size: 17px;line-height: 20px;}
.max-430 .curve-line {	margin: 0px 0 5px;}

.new_facebook .leaders-poster-alumni {top: 25%;}
.new_facebook .leaders-poster-alumni-detail {left: 37%;top: 29%;}
.new_facebook .pursuingWrap {position: absolute;top: 45.5%;left: 13%;width: 75%;}
.new_facebook .expertise {background: #f5f5f5;left: 4.8%;width: calc(100% - 9.4%);padding: 4% 5%;text-align: center;top: auto;bottom: 15%;}
.new_facebook .powerby { display: flex;align-items: center;flex-direction: row;width: auto;bottom: 7%;position: absolute;justify-content: center;width: 100%;}

.new_facebook.poster-3 .leaders-poster-alumni{left: 6%;padding: 15%;}
.new_facebook.poster-3 .powerby {bottom: 4%;}
.max-430 .leaders-poster.poster-3.new_facebook .leaders-poster-alumni-detail {left: 40%;top: 34%;}
.max-430 .leaders-poster.poster-3.new_facebook .leaders-poster-alumni-detail .leaders-poster-alumni-name{font-weight: 600;}
.max-430 .leaders-poster.poster-3.new_facebook .leaders-poster-alumni-detail .leaders-poster-alumni-batch-school i {background: #bbbbbb;height: 2px;margin: 10px 0 0 0;}
.max-430 .leaders-poster.poster-3.new_facebook .pursuingWrap {top: 50%;left: 32%;width: 62%;}
.max-430 .leaders-poster.poster-3.new_facebook .pursuing i {width: 2px;height: 17px;left: 2%;border-radius: 0;}
.max-430 .leaders-poster.poster-3.new_facebook .expertise{    background: transparent;text-align: left;max-width: 50%;padding: 0;}

.alumni-card-wrap .alumni-card-slider.new_facebook {max-width: 430px;min-height: 537px;overflow: hidden;}
.alumni-card-wrap .alumni-card-slider.new_facebook i.curve {height: 195px;border-radius: 50%;width: 130%;left: -15%;right: 0;margin: auto;top: -45px;}
.alumni-card-wrap .alumni-card-slider.new_facebook .alumni-img-wrap {margin: 30px 0;max-width: 180px;width: 100%;height: 180px;}

.leaders-poster.preview {max-width: 710px;margin: 0 auto;}
.leaders-poster.preview .college-logo {top: 10%;left: 10%;width: 20%;}
.leaders-poster.preview .college-logo img {max-height: 100px;}
.leaders-poster.preview .leaders-poster-alumni{top:26%}
.leaders-poster.preview .leaders-poster-alumni-name {font-size: 36px;line-height: 40px;}
.leaders-poster.preview .curve-line {margin: 10px 0 20px;}
.leaders-poster.preview .pursuing-title.font-13{font-size: 18px !important;line-height: 20px;}
.leaders-poster.preview .leaders-poster-alumni-detail {top: 28%;}
.leaders-poster.preview .leaders-poster-alumni-batch-school {font-size: 20px;}
.leaders-poster.preview  .expertise {font-size: 1.3vw;line-height: 1.8vw;}

.social-post-tab {overflow: auto;padding: 15px;flex-wrap: nowrap;}
.social-post-tab::-webkit-scrollbar {height: 3px;}
.social-post-tab::-webkit-scrollbar-track {background: #ccc;}
.social-post-tab::-webkit-scrollbar-thumb {background: #666;}
.social-post-tab::-webkit-scrollbar-thumb:hover {background: #999;} 
.social-post-tab .nav-item:not(:last-child){margin-right:10px}
.social-post-tab .nav-item .nav-link{border-radius:25px;padding:12px 25px;background-color: transparent;color: #000;display: flex; align-items: center;}
.social-post-tab .nav-item .nav-link i{margin-right: 10px;}

.social-post-tab .nav-item .nav-link.popular{border: 1px solid #F1AC18;}
.social-post-tab .nav-item .nav-link.popular i{background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/tab-effect.svg);width: 17px;height: 17px; }
.social-post-tab .nav-item .nav-link.facebook{border: 1px solid #1877F2;}
.social-post-tab .nav-item .nav-link.facebook i{background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/tab-facebook.svg);width: 22px;height: 22px;}
.social-post-tab .nav-item .nav-link.instagram{border: 1px solid #E30085;}
.social-post-tab .nav-item .nav-link.instagram i{background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/tab-instagram.svg);width: 20px;height: 20px;}
.social-post-tab .nav-item .nav-link.youtube{border: 1px solid #FF0000;}
.social-post-tab .nav-item .nav-link.youtube i{background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/tab-youtube.svg);width: 27px;height: 19px;}
.social-post-tab .nav-item .nav-link.twitter{border: 1px solid #000000;}
.social-post-tab .nav-item .nav-link.twitter i{background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/tab-twitter.svg);width: 17px;height: 17px;}
.social-post-tab .nav-item .nav-link.email{border: 1px solid #D82A2A;}
.social-post-tab .nav-item .nav-link.email i{background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/tab-email.svg);width: 26px;height: 15px;}

.social-post-tab .nav-item .nav-link:not(.active, :hover) {background: #0B3454;color:#fff;border-color: #0B3454;}
.social-post-tab .nav-item .nav-link:not(.active, :hover) i {filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(288deg) brightness(102%) contrast(150%);-webkit-filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(288deg) brightness(102%) contrast(150%);}
.social-post-tab .nav-item .nav-link.popular:not(.active, :hover) i, .social-post-tab .nav-item .nav-link.instagram:not(.active, :hover) i {filter: brightness(0)invert(1);-webkit-filter: brightness(0)invert(1);}

.social-post-template-block {background: #E8E8E8;border-radius: 12px;padding: 30px 40px;height: 100%;text-align: center;position: relative;overflow: hidden;}
.social-post-template-block::before{ content: ''; position: absolute; left: 0; right:0; top: 0; width: 100%; height: 0; margin: auto; transition:all 0.3s ease-in-out ; -webkit-transition:all 0.3s ease-in-out ; -moz-transition:all 0.3s ease-in-out ; -ms-transition:all 0.3s ease-in-out ; -o-transition:all 0.3s ease-in-out ;background: rgba(0, 0, 0, .6); }
.social-post-template-block:hover::before{height: 100%;}
.social-post-template-block .template-block-icon {height: 125px;display: flex;justify-content: center;align-items: end;margin: 0 0 20px;}
.social-post-template-block h3 {font-size: 18px;margin: 0 0 5px;}
.social-post-template-block p {margin: 0;}
.social-post-template-block a {position: absolute;left: 0;right: 0;top: 100%;bottom: auto;margin: auto;width: 150px;height: 40px;background: #fff;display: flex;justify-content: center;align-items: center;text-decoration: none;border-radius: 25px;color: #000;transition:all 0.3s ease-in-out ;-webkit-transition:all 0.3s ease-in-out ;-moz-transition:all 0.3s ease-in-out ;-ms-transition:all 0.3s ease-in-out ;-o-transition:all 0.3s ease-in-out ;opacity: 0;}
.social-post-template-block a:hover{background: #5cae48;color: #fff;}
.social-post-template-block:hover a{opacity: 1;top: 0;  bottom: 0;}

.btn-verticle-popup {position: fixed;z-index: 9;top: 270px;width: 40px;right: 0;display: flex;flex-direction: column;padding: 20px 0px;border-radius: 0 10px 10px 0;-webkit-border-radius: 0 10px 10px 0;-moz-border-radius: 0 10px 10px 0;-ms-border-radius: 0 10px 10px 0;-o-border-radius: 0 10px 10px 0;text-decoration: none;margin: 2px 0px;writing-mode: vertical-rl;text-orientation: mixed;transform: rotate(180deg);-webkit-transform: rotate(180deg);-moz-transform: rotate(180deg);-ms-transform: rotate(180deg);-o-transform: rotate(180deg);white-space: nowrap;writing-mode: vertical-rl;	align-items: center;border: 0;background-color: #0B3454;color: #ffffff;line-height: 40px;font-weight: 600;transition: all 0.3s ease-in-out;-webkit-transition: all 0.3s ease-in-out;-moz-transition: all 0.3s ease-in-out;-ms-transition: all 0.3s ease-in-out;-o-transition: all 0.3s ease-in-out;}
.btn-verticle-popup:hover{background-color: #398227;}

.btn-horizontal-popup { position: fixed; bottom: 0; right: 30px; padding: 8px 20px; font-weight: 600; border: 0; border-radius: 7px 7px 0 0px; background: #0B3454; color: #fff; -webkit-border-radius: 7px 7px 0 0px; -moz-border-radius: 7px 7px 0 0px; -ms-border-radius: 7px 7px 0 0px; -o-border-radius: 7px 7px 0 0px;}
.btn-horizontal-popup:hover{background-color: #398227;}

.blue-filter{ filter: invert(26%) sepia(99%) saturate(7494%) hue-rotate(215deg) brightness(84%) contrast(91%); -webkit-filter: invert(26%) sepia(99%) saturate(7494%) hue-rotate(215deg) brightness(84%) contrast(91%); }
.offer_joined i {background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/hat_alumni.svg);width: 23px;height: 17px;margin-right: 0;}

.qr-wrap {background: #0B3454;border-radius: 12px;padding: 35px;margin-bottom: 25px;}
.icon-write-review {background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/write-review.svg);width: 36px;height: 36px;display: flex;}

.review {display: flex;flex-wrap: wrap;-webkit-box-wrap: wrap;-moz-box-wrap: wrap;-ms-flex-wrap: wrap;-webkit-wrap: wrap;flex-direction: row-reverse;}
.review label {background-image: url(${___CSS_LOADER_URL_REPLACEMENT_44___});background-repeat: no-repeat;background-position: center;background-size: 100%;width: 16px;height: 16px;margin-right: 3px;cursor: pointer;position: relative;} 

.review input:checked ~ label {background-image: url(${___CSS_LOADER_URL_REPLACEMENT_45___});}
.google-review-ui *{font-family: "Open Sans", sans-serif;}
.google-review-ui h2 {border-bottom: 1px solid #E4E4E4;padding-bottom: 20px;font-weight: 700;}
.google-review-ui .review label {width: 60px;height: 60px;margin-right: 30px;background-image: url(${___CSS_LOADER_URL_REPLACEMENT_46___});}
.google-review-ui .review input:checked ~ label {background-image: url(${___CSS_LOADER_URL_REPLACEMENT_47___});}
.profile-section-detail{line-height: 28px;}
.icon-camera {background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/icon-camera.svg) no-repeat 0 0;width: 20px;height: 20px;display: block;}
.google-review-ui .btn-border-gray{color: #0C4CBB;}
.google-review-ui .btn-border-gray:hover{color: #fff;}
.google-review-ui .btn-border-gray:hover i{ filter: brightness(0) invert(1) ; -webkit-filter: brightness(0) invert(1) ; }

td .review{flex-direction: row;}
.review i {background-image: url(${___CSS_LOADER_URL_REPLACEMENT_44___});background-repeat: no-repeat;background-position: center;background-size: 100%;width: 16px;height: 16px;margin-right: 3px;cursor: pointer;position: relative;} 
.review i:before {content: '';position: absolute;width: 18px;height: 18px;left: 0;top: 0;bottom: 0;background-image: url(${___CSS_LOADER_URL_REPLACEMENT_47___});background-repeat: no-repeat;background-size: 16px;opacity: 0;}

.review.poor i:first-child{background: none;}
.review.poor i:first-child::before {opacity: 1;}
.review.poor.half i:nth-child(2)::before{width: 8px;opacity: 1;}
.review.average i:first-child, .review.average i:nth-child(2){background: none;}
.review.average i:first-child::before, .review.average i:nth-child(2)::before {opacity: 1;}
.review.average.half i:nth-child(3)::before {width: 8px;opacity: 1;}
.review.good i:first-child, .review.good i:nth-child(2), .review.good i:nth-child(3){background: none;}
.review.good i:first-child::before, .review.good i:nth-child(2)::before, .review.good i:nth-child(3)::before {opacity: 1;}
.review.good.half i:nth-child(4)::before {width: 8px;opacity: 1;}
.review.very-good i:first-child, .review.very-good i:nth-child(2), .review.very-good i:nth-child(3), .review.very-good i:nth-child(4){background: none;}
.review.very-good i:first-child::before, .review.very-good i:nth-child(2)::before, .review.very-good i:nth-child(3)::before, .review.very-good i:nth-child(4)::before {opacity: 1;}
.review.very-good.half i:nth-child(5)::before {width: 8px;opacity: 1;}

.review.excellent i:first-child, .review.excellent i:nth-child(2), .review.excellent i:nth-child(3), .review.excellent i:nth-child(4), .review.excellent i:nth-child(5){background: none;}
.review.excellent i:first-child::before, .review.excellent i:nth-child(2)::before, .review.excellent i:nth-child(3)::before, .review.excellent i:nth-child(4)::before, .review.excellent i:nth-child(5)::before {opacity: 1;}

@media (max-width:767px){
.google-review-ui .review label {width: 40px;height: 40px;margin-right: 10px;}
}

@media (max-width:480px){
.leaders-poster .college-logo {width: 14.5%;}
.leaders-poster-alumni {padding: 9%;}
.max-430 .leaders-poster-alumni-name {font-size: 16px;line-height: 18px;}
.max-430 .leaders-poster-alumni-batch-school {font-size: 11px;}
.max-430 .pursuing-title {font-size: 14px;margin-bottom: 5px;}
.max-430 .expertise {font-size: 13px;line-height: 16px;}
}

@media (max-width: 400px) {
.max-430 .leaders-poster-alumni {top: 27%;}
.leaders-poster-alumni {padding: 8%;}
.max-430 .leaders-poster-alumni-detail {left: 32%;top: 28%;width: 52%;}
.max-430 .leaders-poster-alumni-name {font-size: 14px;line-height: 16px;}
.max-430 .leaders-poster-alumni-batch-school {font-size: 11px;line-height: 13px;}
.max-430 .expertise {font-size: 9px;line-height: 13px;}
.max-430 .curve-line {margin: 0;}
.max-430 .pursuing-title {font-size: 14px;margin-bottom: 0;}
}

.w-300{width: 300px;}


.poster-3 *{z-index: 3;}
i.slant {position: absolute;background: #2c256a;width: 210%;height: 240%;left: 0;top: 0;z-index: 1;transform: rotate(22deg);}
i.bottom-strip {background: #1c1555;height: 16%;position: absolute;left: 0;bottom: 0;width: 100%;z-index: 2;}
.leaders-poster.poster-3 .college-logo {top: 7%;left: 4%;width: 34%;}
.badge-template {position: absolute;top: 0;right: 40px;max-width: 100px;}
.max-430 .leaders-poster.poster-3 .expertise {font-size: 15px;line-height: 16px;position: absolute;bottom: 17px;left: 20px;width: 100%;max-width: 280px;top: auto;}
.max-430 .leaders-poster.poster-3 .leaders-poster-alumni-batch-school {margin-bottom: 5%;}
.poster-powerby{bottom: 13px;right: 15px;}
.max-430 .leaders-poster.poster-3 .leaders-poster-alumni-detail {left: 36%;top: 30%;width: 60%;}
.max-430 .leaders-poster.poster-3 .pursuing i {width: 7px;height: 7px;left: 0%;top: 8%;border-radius: 50%;background: #ffc221;}
.max-430 .leaders-poster.poster-3 .pursuing{padding-left: 6%;position: relative;}
.max-430 .leaders-poster.poster-3 .leaders-poster-alumni-batch-school i {display: inline-block;background: rgb(255,255,255);background: linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(46,36,101,1) 100%);height: 1px;width: 55px;vertical-align: top;margin: 10px 0 0 10px;}

.web-sertificate{min-width: 484px;margin:0 auto;position: relative;}
.web-sertificate > div{position: absolute;}
.web-sertificate .certificate-holder-name {top: 44%;left: 0;right: 0;text-align: center;font-size: 28px;font-weight: 600;}
.web-sertificate .certificate-holder-school {top: 56%;left: 0;right: 0;text-align: center;font-size: 12px;font-weight: 500;}
.web-sertificate .presenting {top: 63%;left: 0;right: 0;text-align: center;font-size: 16px;font-weight: 500;}
.web-sertificate .presenting .title {color: #828080;font-size: 13px;}
.web-sertificate .presenting .incontext {font-size: 13px;font-weight: 600;}
.web-sertificate .presenting .date {font-size: 13px;}

.web-sertificate.preview {max-width: 710px;margin:0 auto;position: relative;}
.web-sertificate > div{position: absolute;}
.web-sertificate.preview .certificate-holder-name {top: 44%;left: 0;right: 0;text-align: center;font-size: 42px;font-weight: 600;}
.web-sertificate.preview .certificate-holder-school {top: 56%;left: 0;right: 0;text-align: center;font-size: 16px;font-weight: 500;}
.web-sertificate.preview .presenting {top: 63%;left: 0;right: 0;text-align: center;font-size: 16px;font-weight: 500;}
.web-sertificate.preview .presenting .title {color: #828080;}
.web-sertificate.preview .presenting .incontext {font-size: 17px;font-weight: 600;}
.web-sertificate.preview .presenting .date {font-size: 14px;}

.alumniMembershipCardWrap {width: 484px;background: #FFFFFF 0% 0% no-repeat padding-box;border-radius: 17px;padding: 10px;}
.alumniMembershipCard{display: flex;flex-wrap: wrap;-webkit-box-wrap: wrap;-moz-box-wrap: wrap;-ms-flex-wrap: wrap;-webkit-wrap: wrap; position: relative;border-radius: 17px;overflow: hidden;}
.alumniMembershipCard i{width: 100%;position: absolute;height: 100%;left: 0;top: 0;z-index: 0;}
.alumniMembershipCard i.white-strip {width: 0;left: auto;right: -2px;border-width: 0 27px 350px 0px;border-color: transparent #fff transparent transparent;top: 0;bottom: 0;border-style: solid;}
.alumniMembershipCard-leftPane {width: 70%;position: relative;background: #053E6C;}
.alumniMembershipCardWrap .card-title-wrap {padding: 5% 8%;}
.alumniMembershipCardWrap .cardTitle .title {font-size: 45px;color: #fff;line-height: 45px;}
.alumniMembershipCardWrap .cardTitle .sub {font-size: 14px;color: #fff;font-weight: 600;letter-spacing: 10px;border-bottom: 2px solid #fff;margin-bottom: 20px;padding-bottom: 10px;}
.alumniMembershipCardWrap .card-title-wrap .school {font-size: 18px;font-weight: 600;color: #fff;}

.alumniMembershipCard-rightPane {width: 30%;position: relative;display: flex;flex-direction: column;justify-content: space-between;align-items: center;}
.alumniMembershipCardWrap .blueshade-strip {background: #1166A8;padding: 4% 8%;}
.alumniMembershipCardWrap .blueshade-strip .cardUser {font-size: 18px;font-weight: 600;color: #fff;}
.alumniMembershipCardWrap .blueshade-strip .cardUserBatch {font-size: 14px;font-weight: 600;color: #fff;}
.alumniMembershipCardWrap .validityWrap{padding: 4% 8%;}
.alumniMembershipCardWrap .validityWrap .cardNumber {font-size: 20px;color: #fff;letter-spacing: 5px;}
.alumniMembershipCardWrap .validity {font-size: 14px;color: #fff;font-weight: 600;}

.alumniMembershipCardWrap.preview {width: 637px;}
.alumniMembershipCardWrap.preview .cardTitle .title {font-size: 70px;color: #fff;line-height: 75px;}
.alumniMembershipCardWrap.preview .cardTitle .sub {font-size: 30px;color: #fff;font-weight: 600;letter-spacing: 10px;border-bottom: 2px solid #fff;margin-bottom: 20px;padding-bottom: 10px;}
.alumniMembershipCardWrap.preview .card-title-wrap .school {font-size: 30px;font-weight: 600;color: #fff;}
.alumniMembershipCardWrap.preview .blueshade-strip .cardUser {font-size: 22px;font-weight: 600;color: #fff;}
.alumniMembershipCardWrap.preview .blueshade-strip .cardUserBatch {font-size: 18px;font-weight: 600;color: #fff;}
.alumniMembershipCardWrap.preview .validityWrap .cardNumber {font-size: 30px;color: #fff;letter-spacing: 5px;}
.alumniMembershipCardWrap.preview .validity {font-size: 16px;color: #fff;font-weight: 600;}


.journey-poster{min-width: 484px;max-width: 484px;}
.journey-poster .top-title{font-size: 18px;}
.journey-poster .img-placehlder{position: relative;z-index: 0;}
.journey-poster .blue-wrap{background-color: #354b9c;padding: 15px;position: relative;z-index: 2;}
.journey-poster .profileWrap {display: flex;align-items: end;max-width: 385px;margin: auto;margin-top: -35px;}
.journey-poster .profileWrap .pro-picture {width: 100px;height: 100px;display: flex;align-items: center;justify-content: center;border-radius: 50%;overflow: hidden;border: 2px solid #fff;margin-right: 30px;}
.journey-poster .profileWrap h2 {font-size: 24px;font-weight: 700;width: calc(100% - 200px);color: #fff;}
.journey-poster ul.journey li .content-wrap {flex: 1 1;display: flex;flex-wrap: wrap;-webkit-box-wrap: wrap;-moz-box-wrap: wrap;-ms-flex-wrap: wrap;-webkit-wrap: wrap;flex-direction: column;padding: 12px;font-weight: 500;word-break: break-word;}
.journey-poster:not(.preview) ul.journey li .content-wrap {font-size: 14px;}
.journey-poster .white-content-wrap .white-wrap {z-index: 2;  background: #fff;max-width: 600px;width: 90%;margin: 0 auto;padding: 15px;border: 1px solid #e3e3e3;}
.journey-poster .white-content-wrap h3 {color: #3aae6f;font-weight: 600;font-size: 20px;margin-bottom: 15px;}
.journey-poster .white-content-wrap .white-wrap ul.dots li{display: flex;flex-wrap: wrap;-webkit-box-wrap: wrap;-moz-box-wrap: wrap;-ms-flex-wrap: wrap;-webkit-wrap: wrap;font-size: 14px;}
.journey-poster .white-content-wrap .white-wrap ul.dots li:not(:last-child){margin-bottom: 10px;}
.journey-poster .white-content-wrap .white-wrap ul.dots li .dot{width: 8px;background-color: #3aae6f;height: 8px;border-radius: 50%;margin-right: 11px;margin-top: 7px;vertical-align: top;}
.journey-poster .white-content-wrap .white-wrap ul.dots li span{flex:1 1}
.journey-poster .white-content-wrap {position: relative;padding-bottom: 30px;}

.journey-poster.preview{min-width: 730px;max-width: 730px;margin: 0 auto;}
.journey-poster.preview .top-title{font-size: 24px;}
.journey-poster.preview  .blue-wrap{padding: 30px;}
.journey-poster.preview .profileWrap {display: flex;align-items: end;max-width: 450px;margin: auto;margin-top: -71px;}
.journey-poster.preview .profileWrap .pro-picture {width: 170px;height: 170px;display: flex;align-items: center;justify-content: center;border-radius: 50%;overflow: hidden;border: 2px solid #fff;margin-right: 30px;}
.journey-poster.preview .profileWrap h2 {font-size: 37px;font-weight: 700;width: calc(100% - 200px);color: #fff;}
.journey-poster.preview .white-content-wrap {padding-bottom: 60px;}
.journey-poster .white-content-wrap > i{position: absolute;left: 0;right: 0;top: 0;height: 80px;background-color: #354b9c;z-index: 0;}
.journey-poster.preview .white-content-wrap .white-wrap{padding: 40px;}
.journey-poster .white-content-wrap .white-wrap:not(:last-child){margin-bottom: 15px;}
.journey-poster .white-content-wrap .white-wrap ul {padding: 0;margin: 0;list-style: none;}
.journey-poster .white-content-wrap .white-wrap ul.journey {display: flex;flex-wrap: wrap;-webkit-box-wrap: wrap;-moz-box-wrap: wrap;-ms-flex-wrap: wrap;-webkit-wrap: wrap;}
.journey-poster .white-content-wrap .white-wrap ul.journey li {display: flex;  flex-direction: column;  text-align: center;flex:1 1}
.journey-poster ul.journey li .number {  color: #3aae6f;  font-weight: 500;  padding: 8px;}
.journey-poster ul.journey li .line {width: 100%;height: 3px;background: #3aae6f;position: relative;}
.journey-poster ul.journey li .dot{position: absolute;left: 0;right: 0;margin: auto;width: 14px;height: 14px;background-color: #fff;border: 2px solid #3aae6f;border-radius: 50%;top: 0;bottom: 0;margin: auto;}
.journey-poster.preview ul.journey li .content-wrap {padding: 15px 5px;}
.journey-poster ul.journey li .logo {  margin-top: auto;}
.journey-poster ul.journey li .logo img{max-width: 100%;}
.journey-poster.preview .white-content-wrap h3 {font-size: 24px;}
.journey-poster.preview .white-content-wrap .white-wrap ul.dots li{font-size: 16px;}

.ratio-16{width: 16px;height: 16px;}
.icon-down-arrow{transition: all 0.3s ease-in-out;}
.icon-down-arrow[aria-expanded="true"]{transform: rotate(180deg);}
.border-d52941{border: 1px solid #d52941;}

.height-20 {height: 20px !important;}
.bg-blue-0d3453{background-color: #0d3453;}
.bg-gray-f5f5f5{background-color: #f5f5f5;}
.bg-gray-E6E6E6{background-color: #E6E6E6;}
.dash-border{border-bottom: 2px dashed #ccc;opacity: 1;background-color: transparent;}
.min-h-80{min-height: 80px;}
.min-h-0{min-height: 0px !important;}
.btn-gray-de { background: #D2D2D2 ; border: 1px solid #D2D2D2; border-radius: 25px; padding: 8px 18px; display: flex; align-items: center; color: #000; transition:all 0.3s ease-in-out ; -webkit-transition:all 0.3s ease-in-out ; -moz-transition:all 0.3s ease-in-out ; -ms-transition:all 0.3s ease-in-out ; -o-transition:all 0.3s ease-in-out ;}
.btn-gray-de:hover {background: #0b3454;border-color: #0b3454;color: #fff;}

.lastTRLineRemove tr:last-child{border-color: transparent !important;} 
.work-block .work-detail .icon-hat{background: url(https://ags-images-bucket.s3.ap-south-1.amazonaws.com/images/hat.svg);background-size: auto;width: 24px;height: 23px;background-size: 100%;display: flex;}
.alumni_img_link .icon-star.circle-img {bottom: 0px;right: 3px;}
.alumni_univarsity_name .icon-hat{background: url(https://ags-images-bucket.s3.ap-south-1.amazonaws.com/images/hat.svg);background-size: auto;width: 24px;height: 23px;background-size: 100%;display: flex;}
.fiterItem .form-check .form-check-input[name='Passout_Name'] + label {overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 1;-webkit-box-orient: vertical;}


.bg-green{background-color: #5cae48;}
td:first-child .mailSetting .setting-dropdown{left: 0; right: auto;}

tr:nth-last-child(-n + 4) .mailSetting .setting-dropdown {top: auto;bottom: calc(100% + 10px);white-space: nowrap;right: 0;}
tr:nth-child(-n + 4) .mailSetting .setting-dropdown {top:100%;bottom:auto;}

.width-cal-191{width: calc(100% - 191px);}
.personalisedBookingLink .singleline-ellipsis { text-overflow: ellipsis;white-space: nowrap;overflow: hidden;width: calc(100% - 30px);display: inline-block;max-width: 515px;}

ul.message_counselling_wrap {padding: 0;margin: 0;list-style: none;}
ul.message_counselling_wrap li{padding: 13px 0;}
ul.message_counselling_wrap li:not(:last-child) {border-bottom: 1px solid #ccc;}
ul.message_counselling_wrap li .icon-user-invert{font-size: 50px;}
.message_counselling{position: relative;}
.message_counselling > div {max-height: 220px;overflow-y: auto;scrollbar-width: 6px;}
.message_counselling > div::-webkit-scrollbar {width: 6px;}
.message_counselling > div::-moz-scrollbar {width: 6px;}
.message_counselling > div::-webkit-scrollbar-track {background: #eee;}
.message_counselling > div::-webkit-scrollbar-thumb {background-color: #666;border-radius: 20px;border: 2px solid #eee;}


.message_counselling:before {content: '';position: absolute;border-top: 10px solid transparent;border-bottom: 10px solid transparent;border-right: 15px solid #f2f2f2;top: 47px;right: 100%;}
.test-status {top: 0;right: 0;padding: 5px 15px;border-radius: 0 5px 0 15px;font-weight: 500;}
@media (max-width: 767px) {
.width-cal-191{width: 100%;}
.message_counselling:before {    top: auto;    right: auto;    bottom: 99%;    transform: rotate(90deg);    left: 20px;}
}

.messagewrap .ql-toolbar {border-radius: 5px 5px  0 0;}
.messagewrap .ql-container {border-radius: 0 0 5px 5px;height: 180px;}
.messagewrap.textarea-cnt .ql-container {height: auto;min-height: 180px;}
.table .disabled {color: #666 !important;pointer-events: none;} 
.nl-container table {margin: auto;}

.blue-block:has(.univarietyAI) {
    background: linear-gradient(90deg, #e9102e 16%, #043254 100%);
    color: #ffffff;
    color:#fff;
}
.blue-block:has(.univarietyAI):after {
    border-bottom: 5px solid #e9102e;
    border-right: 5px solid #e9102e;
}
.univarietyAI {
    margin-top: 10px;
    font-size: 13px;
    color: #fff;
    font-style: italic;
}
.univarietyAI b{
    font-weight: 500;
}

.counsellor-img-placeholder{width: 70px;height: 70px;background-color: #eee;border-radius: 50%;overflow: hidden;}
.counsellor-img-placeholder img{width: auto;height: 100%;}
.calendly-inline-widget iframe{position: absolute;}
.session-not-found{min-height: 500px;}
.session-not-found i{font-size: 4rem;color: #ab0000;line-height: 4rem;margin-bottom: 20px;}
.copy-line {width: calc(100% - 15px);text-overflow: ellipsis; overflow: hidden;}

.messages:has(.univarietyAI) > div {
    background: linear-gradient(90deg, #e9102e 16%, #043254 100%);
    color: #ffffff;
    color:#fff;
    border-radius: 10px 10px 10px 0px;
    padding: 10px 20px;
    margin-bottom: 10px;
}
.justify-content-end .blue-block:has(.univarietyAI):after {
    border-left: 5px solid #063254;
    border-bottom: 5px solid #063254;
    border-top: 5px solid transparent;
    border-right: 5px solid transparent;
}

.messages.leftUser:has(.univarietyAI) > div{
    border-radius: 10px 10px 0px 10px;
}

/* ========================================
   LOADER STYLES - Full Screen Overlay
   ======================================== */

   .loader-container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    backdrop-filter: blur(2px);
    -webkit-backdrop-filter: blur(2px);
}

.loader-container .text-center {
    background-color: #ffffff;
    padding: 40px;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    animation: slideUp 0.3s ease-out;
}

.loader-container .spinner-border {
    width: 3rem;
    height: 3rem;
    border-width: 0.3em;
    animation: spin 1s linear infinite;
}

.loader-container .spinner-border-sm {
    width: 1.5rem;
    height: 1.5rem;
    border-width: 0.2em;
}

.loader-container p {
    color: #333333;
    font-weight: 500;
    font-size: 14px;
    margin-top: 15px;
    margin-bottom: 0;
}

/* Animations */
@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

@keyframes slideUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Disabled state styles */
button:disabled,
input:disabled {
    opacity: 0.6 !important;
    cursor: not-allowed !important;
}

.filter-disabled,
[style*="pointerEvents: none"] {
    pointer-events: none;
    opacity: 0.6;
}


.messages:has(.univarietyAI) p{
    background-color: transparent;
    border-radius: 0;
    padding: 0;
}

/* 21072025 */

.bg-blue-e5f1fb{
  background-color: #E5F1FB;
}

.ratio-112{
  width: 112px;
  height: 112px;
}

.no-after::after{
  content: none;
}
.new-meter-wrap{
    position: relative;
    width: 110px;
    margin: auto;
    background: #E8ECF180;
    height: 110px;
    border-radius: 50%;
    padding: 10px;
}
.new-meter {
    position: relative;
    width: 100%;
    margin: auto;
}

/* .new-meter > img{
  transform: scaleX(-1);
} */

.new-meter-pointer {
    position: absolute;
    width: 12px;
    height: 12px;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    margin: auto auto 0;
    transition: all 0.3s ease-in-out;
}

.new-meter-pointer img {
    position: absolute;
    width: 100%;
    left: 0;
    right: 0;
    bottom: 0;
}

.circle-graph {
    position: relative;
    width: 110px;
    margin: auto;
}

.circle-graph span.text {
    position: absolute;
    left: 0;
    right: 0;
    height: 20px;
    width: 35px;
    top: 0;
    bottom: 0;
    margin: auto;
    font-weight: 600;
}

.circle-graph span.text-green{color: #5BAE47;}
.circle-graph span.text-yellow{color: #F8B018;}
.circle-graph span.text-blue{color: #0D3453;}

.persona-grd {background: transparent linear-gradient(51deg, #6F0010 0%, #052C4A 100%) 0% 0% no-repeat padding-box;border-radius: 16px;opacity: 1;height: 205px;}
.persona-grd-text{flex: 1 1;}
.persona-grd-text h5{font-size: 28px;}
.persona-grd-text p{font-size: 18px;}

.bg-green-e8ffe2{background-color: #E8FFE2;}
.bg-green-5bae47{background-color: #5bae47;}
.bg-pink-ffeef0{background-color: #FFEEF0;}
.bg-red-d42941{background-color: #D42941;}
.bg-gray-e5e6e5{background-color: #E5E6E5 ;}
.bg-gray-919191{background-color: #919191;}
.bg-yellow-f8b018{background-color: #f8b018;}
.bg-orange{background-color: #f05a2a;}


.text-green-5bae47{color: #5bae47;}
.text-yellow-f8b018{color: #F8B018;}

.max-150{max-width: 150px;}
.height-20{height: 20px;}
.progress-bar{overflow: visible;}
.progress-bar b{padding-left: 10px;position: absolute;left: 100%;color: #000;font-weight: 500;}


.bg-green-5CAE4814 {background-color: #5CAE4814;}

.line {position: relative;}
.line:before {content: '';position: absolute;left: 0;right: 0;top: 0;bottom: 0;background: #D4D4D4;width: 1px;margin: auto;}
.bg-gray-E6E6E6.text-gray-41 img {filter: brightness(0.4) invert(0);}
.fade.modal.show{background-color: #0008;}

.notenoughdata ~ div, .notenoughdata ~ h5, .notenoughdata ~ p {opacity: 0.3;}

.group-login .react-select__option{color: #000;}
.group-login .react-select__option.react-select__option--is-focused{color: #003b68;}
.group-login .react-select__menu .css-1n6sfyn-MenuList{scrollbar-width: 10px;}
.group-login .react-select__menu .css-1n6sfyn-MenuList::-webkit-scrollbar {width: 6px;}
.group-login .react-select__menu .css-1n6sfyn-MenuList::-moz-scrollbar {width: 6px;}
.group-login .react-select__menu .css-1n6sfyn-MenuList::-webkit-scrollbar-track {background: #eee;}
.group-login .react-select__menu .css-1n6sfyn-MenuList::-webkit-scrollbar-thumb {background-color: #666;border-radius: 20px;border: 2px solid #eee;}
img.img-fluid[src*='vishwakarma-university-vu-logo'] {
    width: 150px;
}


.skill-wrap {

}

.skill-wrap .skill-range {
    margin-bottom: 30px;
}

.select-skill input {
    display: none;
}

.skill {
    background: #FFFFFF ;
    border: 1px solid #C1DDFD;
    border-radius: 10px;
    transition: all 0.3s ease-in-out;
    height: 100%;
    position: relative;
    text-decoration: none;
    cursor: pointer;
}

.skill .icon {
    display: flex;
    align-items: center;
}

.select-skill input:checked+label.skill {
    background: #2680EB;
    border-color: #2680EB;
    color: #fff;
    transition: all 0.3s ease-in-out;
}

.select-skill input:checked+label.skill .icon {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: 2px solid #fff;
    position: relative;
}

.select-skill input:checked+label.skill .icon::before {
    content: '';
    width: 13px;
    height: 7px;
    border-left: 2px solid #fff;
    border-bottom: 2px solid #fff;
    display: inline-block;
    transform: rotate(-40deg);
    margin: 7px 3px 0 0;
    left: 7px;
    top: 2px;
    right: 0;
    position: absolute;
    background: none
}

.select-skill-container .select {
    margin: 0 1% 2%;
    width: 23%;
    text-align: left;
    min-height: 100px;
}

.select-skill-container .select.completed label.skill {
    background: #fff;
    border-color: #E5E5E5;
    pointer-events: none;
}

.status {
    background: #B2DB56 ;
    border-radius: 10px 0px;
    padding: 0 15px;
    position: absolute;
    top: -1px;
    left: -1px;
    height: 23px;
    line-height: 23px;
    display: none;
    text-transform: capitalize;
}

.select-skill-container .select.completed label.skill .status {
    display: block;
}

.select-skill-container .select .icon {
    width: 36px;
    height: 36px;
}


.skill-range .progress {
    height: 20px;
    max-width: 800px;
    width: 90%;
    border-radius: 25px;
}

.skill-range .progress .progress-bar {
    border-radius: 25px;
    height: 100%;
    border: 0;
}

.skillBlock {
    padding: 40px;
}

.sticky-select-skill-result {
    padding: 36px 50px;
    background: #ffffff;
    margin-bottom: 50px;
    position: sticky;
    bottom: 0;
    z-index: 1;
    border-radius: 6px;
    box-shadow: 0 0 10px 0px #99999947;
}

.sticky-select-skill-result .interested {
    justify-content: center;
    align-items: end;
}

.sticky-select-skill-result .interested .skill {
    background: #0d3453;
    color: #fff;
    border: 0;
    height: 54px;
    padding: 0 15px;
}

.sticky-select-skill-result .interested .plus {
    width: 10px;
    height: 10px;
    position: relative;
    font-size: 0;
    margin: 21px 20px;
}

.sticky-select-skill-result .interested .plus::before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 10px;
    height: 2px;
    background: #000;
}

.sticky-select-skill-result .interested .plus::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 2px;
    height: 10px;
    background: #000;
}

.sticky-select-skill-result .interested .equalto::before,
.sticky-select-skill-result .interested .equalto::after {
  content: "";
  width: 10px;
  height: 2px;
  background: #414141;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 1px 0;
  display: inline-block;
}
.sticky-select-skill-result .interested .equalto {
  width: 10px;
  height: 10px;
  position: relative;
  font-size: 0;
  display: flex;
  flex-wrap: wrap;
  margin: 21px 20px;
}

.sticky-select-skill-result .interested .icon-checked {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: 2px solid #fff;
    position: relative;
    margin-left: 20px;
}

.sticky-select-skill-result .interested .icon-checked::before {
    top: 8px;
    left: 6px;
    width: 15px;
    height: 8px;
    border-left: 3px solid #fff;
    border-bottom: 3px solid #fff;
}

.sticky-select-skill-result .interested .icon-checked::after {
   display: none;
}
/* for recruiter directory program list */
i.plus-minus-toggle {
    width: 20px;
    height: 20px;
    margin-right: 8px;
    position: relative;
    border: 1px solid #bacfde;
    border-radius: 5px;
}

i.plus-minus-toggle::before, i.plus-minus-toggle::after{
  content: '';
  position: absolute;
  width: 12px;
  height: 2px;
  background-color: #bacfde;
  left: 0;right: 0;
  top: 0;bottom: 0;
  margin: auto;
  transition: all 0.3s ease-in-out;

}

i.plus-minus-toggle::after{
  transform: rotate(90deg);
}

[aria-expanded="true"] i.plus-minus-toggle::after{
  transform: rotate(180deg);
}

/* for recruiter directory program list */
i.plus-minus-toggle {
    width: 20px;
    height: 20px;
    margin-right: 8px;
    position: relative;
    border: 1px solid #bacfde;
    border-radius: 5px;
}

i.plus-minus-toggle::before, i.plus-minus-toggle::after{
  content: '';
  position: absolute;
  width: 12px;
  height: 2px;
  background-color: #bacfde;
  left: 0;right: 0;
  top: 0;bottom: 0;
  margin: auto;
  transition: all 0.3s ease-in-out;

}

i.plus-minus-toggle::after{
  transform: rotate(90deg);
}

[aria-expanded="true"] i.plus-minus-toggle::after{
  transform: rotate(180deg);
}
.verify_massrecruiter {margin: -6px 0 0 70px; display: flex;width: calc(100% - 70px);}
.verify_massrecruiter ul {padding: 0;margin: 0;list-style: none;display: flex;-webkit-box-wrap: wrap;-moz-box-wrap: wrap;-ms-flex-wrap: wrap;-webkit-wrap: wrap;flex-wrap: wrap;color: #0B3454;}
.verify_massrecruiter ul li {display: flex;-webkit-box-wrap: wrap;-moz-box-wrap: wrap;-ms-flex-wrap: wrap;-webkit-wrap: wrap;flex-wrap: wrap;align-items: center;}
.verify_massrecruiter ul li i{margin-right: 5px;}
.verify_massrecruiter ul .verify {width: 19px;height: 24px;background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/green-verified.svg) no-repeat 0 0 / 100%;display: inline-block;}
.verify_massrecruiter ul .massrecruiter {width: 23px;height: 23px;background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/search-user.svg) no-repeat 0 0 / 100%;display: inline-block;}
.verify_massrecruiter ul .hand {width: 13px;height: 24px;background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/hand.svg) no-repeat 0 0 / 11px 24px;display: inline-block;}
.verify_massrecruiter ul li:not(:last-child) {border-right: 1px solid #DEDCDC;padding-right: 10px;margin-right: 10px;}
.form-check .form-check-input {width: 20px;height: 20px;vertical-align: top;display: inline-block;position: static;margin-right: 8px;margin-left: 0;margin-top: 0;border: 1px solid #0B34544D;}
.form-check .form-check-input:checked {background-color: #5CAE48;	border-color: #5CAE48;}

.form-check {display: flex;align-items: center;padding: 0;}
.form-check .form-check-label {display: flex;align-items: center;line-height: 16px;margin: 0;}
.form-check-input:checked {background-color: #29A745;border-color: #29A745;}

.leaders-poster-templete-3.ratio-484{min-width: 484px;max-width: 484px;}
.leaders-poster-templete-3 .background-color {position: absolute;left: 3%;right: 3%;margin: auto;bottom: 0;top: 3%;border-radius: 10% 5% 0 0 / 10% 5% 0 0;}
.leaders-poster-templete-3 .background-color div{border-radius: 0 0 0 10% / 0 0 0 45%;font-size: 1rem;}
.leaders-poster-templete-3 .college-logo {top: 7%;left: 7%;width: 55%;max-height: 60px;}
.leaders-poster-templete-3 .college-logo img {height: 100%;width: auto;max-height: 80px;}
.leaders-poster-templete-3 .leaders-poster-title {top: 25%;font-size: 2.1rem;font-weight: 700;}
.leaders-poster-templete-3 .leaders-poster-title div {border-bottom: 1px solid #EE7936;padding: 0 1%;}
.leaders-poster-templete-3 .leaders-poster-templete-3-alumni {position: absolute;left: 7%;top: 34%;width: 33.5%;}
.leaders-poster-templete-3 .leaders-poster-alumni-detail {position: absolute;left: 45%;top: 46%;width: 49%;}
.leaders-poster-templete-3 .leaders-poster-alumni-name {color: #EE7936;font-size: 2rem;font-weight: 700;line-height: 2rem;padding-left: 3%;}
.leaders-poster-templete-3 .leaders-poster-alumni-batch-school {font-size: 1rem;font-weight: 700;padding-left: 3%;line-height: 1.2rem;padding-top: 2%;}
.leaders-poster-templete-3 .footer-text {padding: 0% 10% 10%;font-size: 1rem;}
.leaders-poster-templete-3 .powerby {width: 15%;bottom: 15%;right: 5%;position: absolute;font-size: 0.6rem;}
.leaders-poster-templete-3 .footer-text .powerby img {max-width: 100%;}
.leaders-poster-templete-3 span.slant-line {position: absolute;left: 0;top: -11%;background: #ee7936;width: 49%;height: 4%;transform: rotate(-5deg);}

.btn-gold-f1ac18 {background-color: #F1AC18;color: #fff;transition: all 0.3s ease-in-out;}
.btn-gold-f1ac18:hover {background-color: #c78800;}
.icon-hand-rupee {  background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/hand-rupee.svg);  width: 20px;  height: 20px;  display: inline-block;  background-size: 100%;}
.icon-alumni {  background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/icon-alumni.svg);  width: 30px;  height: 30px;  display: inline-block;  background-size: 100%;}
.icon-listed-search {  background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/list-search.svg);  width: 30px;  height: 30px;  display: inline-block;  background-size: 100%;}
.icon-black-bulb {background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/green-blub.svg) no-repeat 0 0 / 28px auto;width: 28px;height: 28px;filter: brightness(0) invert(0);}
.listed-insights { display: flex;flex-wrap: wrap;-webkit-box-wrap: wrap;-moz-box-wrap: wrap;-ms-flex-wrap: wrap;-webkit-wrap: wrap;width: 729px;}
.listed-insights .icon-holder {height: 35px;width: 100%; display: flex;align-items: end;justify-content: end;}
.listed-insights-block {background: #0B3454;border-radius: 6px;padding: 10px;flex: 1 1;color: #fff;}
.listed-insights-block:not(:last-child) {margin-right: 13px;}

@media (min-width: 768px) {
.rightPaneOfFilter{flex: none;width: calc(100% - 361px);}
}

.interestedCandidates { max-height: 530px; padding-right: 10px;}
.interestedCandidate-block:not(:last-child){margin-bottom: 10px;}
.interestedCandidate-img{width: 90px;height: 90px;border-radius: 50%;overflow: hidden; display: flex;justify-items: center;align-items: center;  }
.interestedCandidate-img img{width: 100%;height: 100%;object-fit: cover;}

.leaders-poster-templete-4.ratio-484{min-width: 484px;max-width: 484px;}
.leaders-poster-templete-4 .college-logo {margin: 0;width: 100%;text-align: center;position: absolute;top: 5%;height: 12%;}
.leaders-poster-templete-4 .college-logo img {max-width: 260px;height: 100%;}
.leaders-poster-templete-4  .background-color {position: absolute;width: 100%;height: calc(100% - 17.6%);top: 17.6%;border-radius: 30% 0% 0 0 / 30% 0% 0 0;}
.leaders-poster-templete-4 .leaders-poster-title {top: 21%;font-size: 1.5rem;font-weight: 700;}
.leaders-poster-templete-4 .leaders-poster-title div {border-bottom: 2px solid #B94EB9;padding: 0 13%;color: #fff;}
.leaders-poster-templete-4-alumni {position: absolute;top: 32%;width: 28%;left: 5%;height: 28%;border-radius: 50%;overflow: hidden;}
.leaders-poster-templete-4-alumni img {width: 100%;height: 100%;object-fit: cover;}
.leaders-poster-templete-4 .leaders-poster-alumni-detail {position: absolute;left: 37%;top: 37.5%;width: 60%;}
.leaders-poster-templete-4 .leaders-poster-alumni-name {color: #ffffff;font-size: 1.5rem;font-weight: 600;line-height: 2rem;padding-left: 0;}
.leaders-poster-templete-4 .leaders-poster-alumni-batch-school {font-size: 1rem;font-weight: 500;padding-left: 0;line-height: 1.5rem;padding-top: 0;color: #ffffff;}
.leaders-poster-templete-4 .leaders-poster-alumni-detail i.line {width: 18%;height: 3px;background: #fff;display: block;margin-top: 5%;}
.leaders-poster-templete-4 .job-list {display: flex;flex-wrap: wrap;position: absolute;left: 24%;top: 62%;width: calc(100% - 24%);align-items: center;}
.leaders-poster-templete-4 .logo-job-list {width: 50px;background: #fff;border-radius: 50%;position: relative;margin-right: 4%;height: 50px;display: flex;flex-wrap: wrap;justify-content: center;align-items: center;overflow: hidden;}
.leaders-poster-templete-4 .logo-job-list img {width: 90%;height: auto;}
.leaders-poster-templete-4 .job-list-name {color: #fff;line-height: 1.4rem;font-weight: 500;font-size: 1.1rem;}
.leaders-poster-templete-4 .footer-text {border-radius: 0 14% 0 0 / 0 25% 0 0;padding: 4% 0 0 6%;height: 20%;}
.leaders-poster-templete-4 .footer-text .left-text{width: 66%;}
.leaders-poster-templete-4 .footer-text .left-text h6{color: #fff;font-size: 1.1rem;}
.leaders-poster-templete-4 .footer-text .left-text p{color: #fff;font-size: 1rem;line-height: 1.2rem;}
.leaders-poster-templete-4 .powerby {position: absolute;bottom: 0;right: 0;background: #953795;border-radius: 50% 0 0 0 / 100% 0 0 0;padding: 5% 3% 3% 10%;width: 33%;font-size: 0.8rem;}
.leaders-poster-templete-4 .powerby img {width: 100%;}

.leaders-poster-templete-5.ratio-484{min-width: 484px;max-width: 484px;}
.leaders-poster-templete-5 .college-logo {margin: 0;text-align: center;position: absolute;top: 2%;max-width: 200px;left: 3%;height: 13%;}
.leaders-poster-templete-5 .college-logo img {max-width: 100%;height: 100%;object-fit: contain;}
.leaders-poster-templete-5 .leaders-poster-title {right: 0;top: 0;width: 55%;height: 20.8%;border-radius: 0px 0px 0px 541px;padding: 4% 8% 0 15%;color: #fff;font-size: 2rem;font-weight: 600;text-align: right;line-height: 2rem;}
.leaders-poster-templete-5 .leaders-poster-alumni-detail {position: absolute;right: 0;top: 18%;width: 83%;height: 26.5%;mix-blend-mode: multiply;border-radius: 483px 0px 0px 0px;padding: 8.5% 7% 5% 34%;left: auto;}
.leaders-poster-templete-5 .leaders-poster-alumni-name {color: #ffffff;font-size: 2rem;font-weight: 600;line-height: 2rem;padding-left: 0;}
.leaders-poster-templete-5 .leaders-poster-alumni-batch-school {font-size: 1.2rem;font-weight: 400;padding-left: 0;color: #fff;margin-top: 2%;}
.leaders-poster-templete-5-alumni {position: absolute;left: 0;bottom: 55.5%;width: 45%;}
.leaders-poster-templete-5 .listed-points {position: absolute;top: 44.5%;margin: 0;padding: 5% 4% 6% 6%;}
.leaders-poster-templete-5 .listed-points ul {list-style: none;padding: 0;margin: 0;}
.leaders-poster-templete-5 .listed-points li { display: flex;flex-wrap: wrap;-webkit-box-wrap: wrap;-moz-box-wrap: wrap;-ms-flex-wrap: wrap;-webkit-wrap: wrap;padding: 1px 0 0 3%;}
.leaders-poster-templete-5 .listed-points li:not(:last-child) {margin-bottom: 4.5%;}
.leaders-poster-templete-5 .listed-points li .college{flex: 1 1;margin-right: 7%;}
.leaders-poster-templete-5 .listed-points li .college-name-logo {width: 11.6%; display: flex;justify-content: center;}
.leaders-poster-templete-5 .footer-text .powerby {flex-direction: row;justify-content: center;font-size: 0.8rem;align-items: center;margin: 2%;}
.leaders-poster-templete-5 .footer-text .powerby span {margin-right: 10px;}
.leaders-poster-templete-5 .footer-text hr {width: 80%;margin: 1% auto 2%;}
.leaders-poster-templete-5 .footer-text .powerby img {width: 94px;margin: 0;}
.leaders-poster-templete-5 .left-text {text-align: center;margin-top: 2%;}
.leaders-poster-templete-5 .left-text p{margin: 0;}

.leaders-poster-templete-6.ratio-484{min-width: 484px;max-width: 484px;}
.leaders-poster-templete-6 .college-logo {margin: 0;text-align: center;position: absolute;top: 2%;max-width: 200px;left: 3%;}
.leaders-poster-templete-6 .college-logo img {max-width: 100%;}
.leaders-poster-templete-6 .leaders-poster-title {right: 0;top: 0;width: 72.5%;height: 16.2%;border-radius: 0px 0px 0px 541px;padding: 4% 4% 0 4%;color: #fff;font-size: 1.4rem;font-weight: 600;text-align: right;line-height: 2rem;}
.leaders-poster-templete-6 .leaders-poster-alumni-detail {position: absolute;left: auto;top: 11%;width: 67%;right: 3%;}
.leaders-poster-templete-6 .leaders-poster-alumni-name {color: #ffffff;font-size: 1.5rem;font-weight: 600;line-height: 1.8rem;padding-left: 0;margin-bottom: 1%;}
.leaders-poster-templete-6 .leaders-poster-alumni-batch-school {font-size: 0.9rem;font-weight: 400;padding-left: 0;line-height: 1.1rem;}
.leaders-poster-templete-6 .listed-points {position: absolute;top: 30%;margin: 0;padding: 6% 4% 6% 6%;width: 75.5%;right: 0;height: calc(100% - 30%);border-radius: 10% 0px 0px 0px;}
.leaders-poster-templete-6 .listed-points ul {list-style: none;padding: 0;margin: 0;}
.leaders-poster-templete-6 .listed-points li { display: flex;flex-wrap: wrap;-webkit-box-wrap: wrap;-moz-box-wrap: wrap;-ms-flex-wrap: wrap;-webkit-wrap: wrap;padding: 1px 0 0 3%;align-items: start;}
.leaders-poster-templete-6 .listed-points li:not(:last-child) {margin-bottom: 5%;}
.leaders-poster-templete-6 .listed-points li .college{flex: 1 1;margin-right: 7%;}
.leaders-poster-templete-6 .listed-points li .college-name-logo {width: 28%; display: flex;justify-content: center;}
.leaders-poster-templete-6  .background-color {position: absolute;width: 83%;height: calc(100% - 13.5%);top: 13.5%;mix-blend-mode: multiply;border-radius: 48% 0px 0px 0px;right: 0;}
.leaders-poster-templete-6-alumni {position: absolute;left: 0;bottom: 20%;width: 40.5%;}
.leaders-poster-templete-6 .footer-text {height: 17.7%;}
.leaders-poster-templete-6 .footer-text .slant-line {position: absolute;left: -2%;right: 0;height: 100%;width: 150%;transform: rotate(4deg);bottom: 10%;}
.leaders-poster-templete-6 h6{color: #fff;font-size: 1rem;font-weight: 500;margin-bottom: 4%;}
.leaders-poster-templete-6 p{color: #fff;font-size: 1rem;margin-bottom: 2%;}
.leaders-poster-templete-6 .footer-text .powerby {width: 19%;font-size: 0.7rem;position: absolute;bottom: 12%;right: 2%;}
.leaders-poster-templete-6 .footer-text .powerby img {max-width: 100%;}
.top-left-sticker {left: -42px;top: 2px;padding: 1px 45px;transform: rotate(-26deg);color: #fff;font-weight: 500;}
.y-scroll {overflow-x: hidden;overflow-y: auto;}

.bg-grd-blue-619ECE-0B3454{background: #619ECE;background: linear-gradient(134deg,rgba(97, 158, 206, 1) 0%, rgba(11, 52, 84, 1) 43%, rgba(11, 52, 84, 1) 100%);}

.vertical-progress-list {width: max-content;min-width: 100%;}
.vertical-progress-list ul {padding: 0;margin: 0;list-style: none; display: flex;flex-wrap: wrap;-webkit-box-wrap: wrap;-moz-box-wrap: wrap;-ms-flex-wrap: wrap;-webkit-wrap: wrap;}
.vertical-progress-list ul li {width: 34px;}
.vertical-progress-list ul li:not(:last-child) {margin-right: 11px;}
.vertical-progress-list ul li .progress {height: 223px;align-items: end;border-radius: 4px 4px 0 0;overflow: visible;}
.vertical-progress-list ul li .progress div {border-radius: 4px 4px 0 0;position: relative;}
.vertical-progress-list ul li .progress div::before {content: attr(aria-valuenow);position: absolute;bottom: 100%;color: #0b3454;text-align: center;  width: 100%;  font-weight: 500;}
.blue-color-filter{filter: brightness(0) saturate(100%) invert(16%) sepia(92%) saturate(584%) hue-rotate(167deg) brightness(94%) contrast(98%);}

.ratio-32{width: 32px !important;height: 32px !important;}
.recentActivitySummaryInsight{list-style: none;margin: 0;padding: 0;display: flex;flex-wrap: wrap;text-align: center;min-width: 100%;width: max-content;}
.recentActivitySummaryInsight li {flex: 1 1;position: relative;}
.recentActivitySummaryInsight li:not(:last-child){margin-right: 15px;padding-right: 15px;}
.recentActivitySummaryInsight li:not(:last-child)::before{content: '';position: absolute;right: 0;bottom: 0;width: 1px;height: 65%;background: #E8E8E8;}

.impersonate-login{width: 50px;height: 50px;left: 20px;}
.impersonate-login > div{max-width: 220px;width: 220px;opacity: 0;transition: opacity 0.3s ease-in-out;position: absolute;bottom: 0px;left: 0;background: #fff;border: 1px solid #ccc;padding: 10px;border-radius: 6px;box-shadow: 0 0 10px 0px #99999947;}
.impersonate-login:hover > div{opacity: 1;left: 0;bottom: 100%;}
.impersonate-action-disabled{cursor: not-allowed !important; opacity: 0.4 !important;}
button[disabled] {cursor: not-allowed !important; opacity: 0.4 !important;}

.ratio-90{width: 90px !important;height: 90px !important;}

.btn-profile-toggle{right: 23px;top:17px}
.btn-profile-toggle[aria-expanded='true'] + .listed-border {  border-radius: 6px 6px 0 0;}
.listed-body{border-radius: 0 0 6px 6px;}
.listed-body.yellow{background-color: #ffff00;}
.listed-body.orange{background-color: #eba500;}
.listed-body.orange p{color: #fff;}

.custom-radio-0B34544D{display: flex;align-items: center;}
.custom-radio-0B34544D input {width: 20px;height: 20px;margin-right: 8px;}
.custom-radio-0B34544D label{margin-top: 3px;}
.custom-radio-0B34544D input:checked {background-color: #5CAE48;border-color: #5CAE48;}

.tooltip.tooltip-white{opacity: 1;}
.tooltip-white .tooltip-inner {background: #fff;box-shadow: none;padding: 20px;display: flex;flex-direction: column;justify-content: center;align-items: center;max-width: 230px;width: 100%;border: none;color: #000;border: 1px solid #d4d4d4;opacity: 1;}

.tooltip.tooltip-white .tooltip-arrow::before {width: 10px;height: 10px;background: #ffffff;transform: rotate(45deg);left: 2px;border-left: 1px solid #d4d4d4;border-right: 1px solid #d4d4d4;border-top: 1px solid #d4d4d4;border-bottom: 1px solid #d4d4d4;}
.tooltip.tooltip-white.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before{border-left: 1px solid #d4d4d4;border-right: 0px solid #d4d4d4;border-top: 0px solid #d4d4d4;border-bottom: 1px solid #d4d4d4;}
.tooltip.tooltip-white.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {border-left: 0px solid #d4d4d4;border-right: 1px solid #d4d4d4;border-top: 0px solid #d4d4d4;border-bottom: 1px solid #d4d4d4;left: auto;transform: translatey(-5px) rotate(45deg);}
.tooltip.tooltip-white.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {border-left: 0px solid #d4d4d4;border-right: 1px solid #d4d4d4;border-top: 1px solid #d4d4d4;border-bottom: 0px solid #d4d4d4;transform: translateX(-8px) rotate(45deg);}

.profile_picture_qr_display {display: flex;-webkit-box-wrap: wrap;-moz-box-wrap: wrap;-ms-flex-wrap: wrap;-webkit-wrap: wrap;flex-wrap: wrap;justify-content: space-between;}
.profile_picture_qr_display .qr_section {	max-width: 300px;	width: 100%;display: flex;}
.profile_picture_qr_display .profile_picture_edit {border: 2px dashed #bbb;box-shadow: none;width: 120px;height: 120px;}
.profile_picture_qr_display .profile_picture_edit .image-edit {position: absolute;top: auto;right: 0;bottom: 0;background-color: #27A7DF;}
.profile_picture_qr_display .profile_picture_edit .image-edit:hover{background-color: #1C95CA;}
.profile_picture_qr_display .profile_picture_edit::before {content: '';position: absolute;left: 0;right: 0;top: 0;bottom: 0;margin: auto;width: 100%;background: #f6faff;border-radius: 50%;z-index: 0;}
.profile_picture_qr_display .profile_picture_edit img {width: 60px;position: relative;}
.profile_picture_qr_display .or {width: 1px;position: relative;display: flex;align-items: center;justify-content: center;position: relative;background-color: #99999999;height: auto;z-index: 0;}
.profile_picture_qr_display .or span{background-color: #fff;color: #A2A2A2;padding: 5px;}
.profile_picture_qr_display .qr_section .whatapp_text {display: flex;flex-direction: column;margin-left: 5px;align-items: center;justify-content: center;text-align: center;color: #fff;font-weight: 400;}

@media only screen and (min-width: 768px) and (max-width: 1138px)  {
.profile_picture_qr_display {flex-direction: column;align-items: center;}
.profile_picture_qr_display .or {	margin: 10px auto;}
.profile_picture_qr_display .or {  margin: 25px auto;  height: 1px;  width: 120px;  border: none;}
.profile_picture_qr_display .or::after{display: none;}
}

@media only screen and (max-width: 497px)  {
.profile_picture_qr_display {flex-direction: column;align-items: center;}
.profile_picture_qr_display .or {	margin: 10px auto;}
.profile_picture_qr_display .or {  margin: 25px auto;  height: 1px;  width: 120px;  border: none;}
.profile_picture_qr_display .or::after{display: none;}
}

.step_img .alumni-bucket{max-width: 268px;}
.step_img .font-style{font-family: "Waterfall", cursive;}
.step_img .missing .alumni-bucket .font-style {position: absolute;font-size: 38px;font-weight: 600;top: 40%;left: 89%;line-height: 32px;transform: rotate(-20deg);}
.step_img .missing .alumni-bucket::after {content: '';position: absolute;width: 70px;height: 70px;background: url('https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/u-turn-arrow.svg') no-repeat 0 0 / contain;top: 83%;left: calc(100% + 10px);}
.step_img .full-info .alumni-bucket {margin-left: 23%;}
.step_img .full-info .alumni-bucket .font-style {position: absolute;font-size: 38px;font-weight: 600;top: 97%;left: 15%;line-height: 32px;transform: rotate(-10deg);}
.header-highlight {background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/gray-hightlight.svg) no-repeat 0 0 / cover;white-space: nowrap;padding: 16px 38px;display: inline-block;}

@media only screen and (max-width: 991px)  {
.step_img .missing .alumni-bucket .font-style {top: -31%;left: 51%;line-height: 32px;transform: rotate(-13deg);}
.step_img .full-info .alumni-bucket .font-style {position: absolute;font-size: 33px;font-weight: 600;top: -15%;left: -31%;line-height: 32px;transform: rotate(-10deg);}
.step_img .missing .alumni-bucket::after {content: '';position: absolute;width: 40px;height: 70px;top: 90%;left: calc(90%);transform: rotate(3deg);}
}

.impact-flow{padding: 0;margin: 0;}
.impact-flow li{list-style: none;position: relative;display: flex;-webkit-box-wrap: wrap;-moz-box-wrap: wrap;-ms-flex-wrap: wrap;-webkit-wrap: wrap;flex-wrap: wrap;}
.impact-flow li:not(:last-child){margin-bottom: 20px;}
.impact-flow .icon-wrapper{margin-right: 20px;position: relative;}
.impact-flow .icon-wrapper:before, .impact-flow .icon-wrapper:after {  content: '';  width: 2px;  background: #0B345447;  position: absolute;  left: 0;  right: 0;  margin: auto;  z-index: 0;}
.impact-flow .icon-wrapper:before{height: 24px;top: 0;}
.impact-flow .icon-wrapper:after{height: calc(100% - 80px + 20px);top: 80px;}
.impact-flow li:first-child .icon-wrapper:before {display: none;}
.impact-flow li:last-child .icon-wrapper:after {display: none;}
.impact-flow .icon{width: 50px;height: 50px;border: 2px solid #0B345447;border-radius: 50%;display: flex;justify-content: center;align-items: center;font-size: 24px;margin-top: 24px;box-shadow: 0 0 0px 5px #fff;position: relative;z-index: 1;background-color: #fff;}
.impact-flow .impact-flow-detail {  width: calc(100% - 70px);  border: 1px solid #0B34544D;  border-radius: 6px;}
.impact-flow .impact-flow-detail.border-success {border-color: rgb(92 174 72) !important;}

.min-mt-1 {margin-top: -8px;display: inline-block;}

@media only screen and (max-width: 600px)  {
.impact-flow .icon-wrapper {margin-right: 10px;margin-left: 5px;}
.impact-flow .icon {width: 40px;height: 40px;font-size: 22px;}
.impact-flow .impact-flow-detail {  width: calc(100% - 55px); }
}

.icon-blue-copy{background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/blue-copy.svg) no-repeat center / 100%;width: 20px;height: 24px;}
.bg_congratulations {background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/bg-graph-congrats.png) repeat-x top left / cover;}
.bg-lite-purple-e8e6fd{background-color: #E8E6FD;}
.border-color-0B34541A{border-color: #0B34541A !important;}

.btn-send {display: flex;-webkit-box-wrap: wrap;-moz-box-wrap: wrap;-ms-flex-wrap: wrap;-webkit-wrap: wrap;flex-wrap: wrap;background: #5CAE48;border-radius: 25pc;color: #fff;text-decoration: none;align-items: center;font-size: 16px;font-weight: 500;transition: all 0.3s ease-in-out;}
.btn-send {color: #fff;font-size: 16px;font-weight: 500;}
.btn-send .icon-send {background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/send_alumni_profile.svg) no-repeat 0 0 / 100%;width: 19px;height: 19px;position: relative;transition: all 0.3s ease-in-out;left: 0;}
.btn-send:hover .icon-send {left: 3px;}
.btn-send:hover {	background: #3B8D27;}

.btn-warning-f1ac18 {background-color: #F1E0BA;transition: all 0.3s ease-in-out;}
.btn-warning-f1ac18:hover {background-color: #c78800;color: #fff;}

.filter-b-0{filter: brightness(0);}
.filter-8c630c{filter: brightness(0) saturate(100%) invert(32%) sepia(73%) saturate(866%) hue-rotate(13deg) brightness(101%) contrast(91%);}
.filter-51499c{filter: brightness(0) saturate(100%) invert(26%) sepia(53%) saturate(1275%) hue-rotate(217deg) brightness(94%) contrast(84%);}
.ratio-40{width: 40px !important;height: 40px !important;}
i.icon-tick {width: 16px;height: 8px;border-left: 3px solid #5cae48;border-bottom: 3px solid #5cae48;transform: rotate(-50deg) translate(4px, 0);}

.form.needs-validation:has(.alumni-social-links) div[class*='col']{position: relative;}
.form.needs-validation:has(.alumni-social-links) .text-danger{position: absolute;top:calc(100% - 7px);left: 0;z-index: 1;left: 8px;}
.form.needs-validation:has(.alumni-social-links) .agree-to-univariety{position: relative;}
.form.needs-validation:has(.alumni-social-links) .agree-to-univariety .text-danger{left: 8px;}

.text-linkedin{color:#0b63bd}
.text-facebook{color:#0862f7}
.text-instagram{background: #833AB4;background: linear-gradient(45deg, #405de6, #5851db, #833ab4, #c13584, #e1306c, #fd1d1d);-webkit-background-clip: text;-webkit-text-fill-color: transparent;}
.text-twiter{color:#1DA1F2}

@media only screen and (max-width: 600px)  {
.joined_offer_wrap .joined_label{height: auto;border-radius: 25px;padding: 7px 20px 7px 10px;}
.joined_label i {}
}

.bg-gray-f5 {
    background: #f5f5f5;
}

.sticky-actions {
    position: sticky;
    bottom: 0;
    background: #fff;
    padding: 10px 0;
    display: flex;
    justify-content: center;
    gap: 20px;
}
.rich-text-content img {
  max-width: 100%;
  height: auto;
  display: block;
}

/* ============================================
   Outreach Dashboard Styles
   ============================================ */

.outreach-stat-card {
    background: #fff;
    border: 1px solid #D2D2D2;
    border-radius: 6px;
    padding: 16px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.06);
    transition: box-shadow 0.2s ease;
}

.outreach-stat-card:hover {
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
}

.outreach-panel {
    background: #fff;
    border: 1px solid #DCDCDC;
    border-radius: 6px;
    padding: 20px;
}

.outreach-purpose-item {
    background: #F9F9F9;
    border-radius: 4px;
    padding: 8px 12px;
}

.outreach-progress-bar {
    display: flex;
    border-radius: 4px;
    overflow: hidden;
}

.outreach-table thead th {
    border-bottom: 2px solid #ECECEC;
    padding: 10px 12px;
    white-space: nowrap;
}

.outreach-table tbody td {
    padding: 10px 12px;
    border-bottom: 1px solid #F3F3F3;
    vertical-align: middle;
}

.outreach-table tbody tr:hover {
    background-color: #F9FBFC;
}

.outreach-table-scroll {
    max-height: 380px;
    overflow-y: auto;
}

.outreach-upload-zone {
    border: 2px dashed #D2D2D2;
    border-radius: 8px;
    padding: 40px 20px;
    transition: border-color 0.2s ease, background 0.2s ease;
    cursor: pointer;
}

.outreach-upload-zone.active,
.outreach-upload-zone:hover {
    border-color: #26A7DF;
    background: #F0F9FF;
}

.modal-backdrop-custom {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1050;
}

.modal-content-custom {
    background: #fff;
    border-radius: 8px;
    padding: 24px;
    width: 100%;
    max-width: 560px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
}

.text-gray-64 {
    color: #646464 !important;
}
.custom-shadow {box-shadow: 0 0 4px 2px #cccccc82;}
.w-1140{width: 1140px}
.w-1070{width: 1070px}
.hover-item {transition: all 0.3s ease-in-out;}
.hover-item:hover {background-color: #f1f5f9;}
.alumni-table th, .alumni-table td {padding: 16px 30px;}
.alumni-table tbody tr:hover td {background-color: #f3f7f3;cursor: pointer;}
.upload-zone {border: 2px dashed #c8d6e5;border-radius: 12px;background: #fafcff;padding: 2.5rem 1.5rem;text-align: center;cursor: pointer;transition: border-color 0.2s, background 0.2s;}
.upload-zone:hover {border-color: #90aac8;background: #f3f7fb;}
.upload-icon-wrap {width: 56px;height: 56px;background: #eef2f7;border-radius: 50%;display: flex;align-items: center;justify-content: center;margin: 0 auto 1rem;}
.upload-icon-wrap i {font-size: 1.6rem;color: #8fa8c8;}
.upload-zone .upload-title {font-size: 0.95rem;font-weight: 600;color: #1a1a2e;margin-bottom: 0.25rem;}
.upload-zone .upload-sub {font-size: 0.8rem;color: #90a4ae;margin-bottom: 1.25rem;}
.btn-browse {font-size: 0.85rem;font-weight: 500;color: #37474f;background: #fff;border: 1.5px solid #c8d6e5;border-radius: 8px;padding: 0.4rem 1.25rem;transition: background 0.15s, border-color 0.15s;}
.btn-browse:hover {background: #f0f4f8;border-color: #90aac8;color: #1a1a2e;}
.link-gray{color: #90a4ae;text-decoration: none;transition: color 0.2s;}
.link-gray:hover {color: #2e8a59;}
.bg-lite-purple-faf5ff{background-color: #faf5ff;}
.border-purple-9812fa{border:1px solid #9812fa ;}
.outreach-wrap ul{padding: 0;margin: 0;list-style: none;position: relative;}
.outreach-wrap ul::before{content: '';position: absolute;left: 7px;top: 0;width: 4px;height: 100%;background: #e5e7eb;}
.outreach-wrap ul li{position: relative;padding-left: 40px;}
.outreach-wrap ul li:not(:last-child){margin-bottom: 30px;}
.outreach-wrap ul li .dot {position: absolute;left: 0;top: 35px;width: 16px;height: 16px;background: #ffffff;border-radius: 50%;box-shadow: 0px 0 4px 0px #d7d7d7;border: 4px solid #ffffff;}
.outreach-wrap ul li .dot.green-dot{background-color: #1d6b4f;}
.outreach-wrap ul li .dot.purple-dot{background-color: #9333ea;}
.outreach-wrap ul li .dot.orange-dot{background-color: #d97706;}
.outreach-wrap ul li .dot.red-dot{background-color: #dc2626;}
.outreach-wrap ul li .dot.blue-dot{background-color: #2563eb;}
.alumniinformation .nav-link {background: none;padding: 0 0 3px;border-bottom: 1px solid #0d6efd;border-radius: 0;}
.alumniinformation .nav-link.active {display: none;}
.business-directory-tab .nav-item:not(:last-child) {margin-right: 30px;}
.business-directory-tab .nav-link {background: none;padding: 0 0 3px;border-bottom: 4px solid transparent;border-radius: 0;font-size: 20px;font-weight: 400;color: #4D4D4D;}
.business-directory-tab .nav-link.active {background-color: transparent;font-weight: 500;color: #0C4CBB;border-bottom: 4px solid #0d6efd;}
.tablink .bi-check-circle-fill{top:-7px;right: -5px;}
.alumniDetailPic {width: 100px;height: 100px;}
.alumniDetailPic.ratio-60{width: 60px;height: 60px;}
.alumniDetailPic img {width: auto;height: 100%;}

.list-switch-tab .nav-item:not(:last-child) {margin-right: 8px;}
.list-switch-tab .nav-item .nav-link {background: #f5f5f5;border-radius: 25px;font-size: 16px;font-weight: 400;color: #0B3454;height: 40px;padding: 5px 15px;}
.list-switch-tab .nav-item .nav-link.active {background: #0b3454;color: #fff;}

.bg-blue-eff8ff{background-color: #EFF8FF;}

.job-tab{border: none;}
.job-tab .nav-item:not(:last-child) {margin-right: 5px;}
.job-tab .nav-link {background: none;border-width: 1px 1px 0;border-color: #707070;color: #5F5C5C;transition: all 0.3s ease-in-out;}
.job-tab .nav-link.active {background-color: #5CAE48;color: #fff;border-color: #5CAE48;}


.onhoverautoheight:not(:hover) div[class*='-MultiValueGeneric']{white-space: nowrap;  overflow: hidden;  text-overflow: ellipsis;width: 70px;}
.onhoverautoheight:not(:hover) div[class*='-multiValue']:nth-child(2) ~ div[class*='-multiValue']{display: none;} 

/* ========================================
   LOADER STYLES - Full Screen Overlay
   ======================================== */

.loader-container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    backdrop-filter: blur(2px);
    -webkit-backdrop-filter: blur(2px);
}

.loader-container .text-center {
    background-color: #ffffff;
    padding: 40px;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    animation: slideUp 0.3s ease-out;
}

.loader-container .spinner-border {
    width: 3rem;
    height: 3rem;
    border-width: 0.3em;
    animation: spin 1s linear infinite;
}

.loader-container .spinner-border-sm {
    width: 1.5rem;
    height: 1.5rem;
    border-width: 0.2em;
}

.loader-container p {
    color: #333333;
    font-weight: 500;
    font-size: 14px;
    margin-top: 15px;
    margin-bottom: 0;
}

/* Animations */
@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

@keyframes slideUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Disabled state styles */
button:disabled,
input:disabled {
    opacity: 0.6 !important;
    cursor: not-allowed !important;
}

.filter-disabled,
[style*="pointerEvents: none"] {
    pointer-events: none;
    opacity: 0.6;
}

.live-dot { width: 8px; height: 8px; border-radius: 99px; background: #5CAE48; box-shadow: 0 0 8px #5CAE48; display: inline-block; animation: pulse 1.5s infinite; }
@keyframes pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.4; } }
@keyframes fadeIn { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: translateY(0); } }

.lasttr-noborder tr:last-child td {border: 0;}
.qa-card{background: white;border: 1px solid var(--bs-secondary-border-subtle);border-radius: 6px;padding: 20px;display: flex;align-items: center;gap: 16px;cursor: pointer;transition: all 0.2s;text-decoration: none;color: inherit;}
.qa-card:hover {border-color: var(--bs-primary-border-subtle) ;background-color: var(--bs-primary-bg-subtle) ;transform: translateY(-2px);box-shadow: var(--shadow-md);}
.border-tab .nav-link{border: 1px solid #E5E7EB;background-color: #fff;color: #374151;}

.min-wd-767{min-width: 767px;}
.timeline-dot li{position: relative;}
.timeline-dot li:not(:last-child)::before {content: '';position: absolute;left: 12px;top: 24px;background-color: #bfdbfe;width: 1px;height: 100%;}

.timeline-dot-circle {background: #eff6ff;border: 1px solid #bfdbfe;width: 26px;height: 26px;font-size: 12px;position: relative;}
.demographics-body .form-control {border: 1px solid #b5c2cb !important;min-height: 45px;}

.border-bs-purple { border-color: rgba(var(--bs-purple-rgb), var(--bs-border-opacity)) !important;}
.bg-purple-f5f3ff {background-color: #f5f3ff;}
.bg-bs-purple {background: rgba(124, 58, 237, var(--bs-bg-opacity)) !important;}
tbody tr:nth-last-child(-n + 4) .smart-actions{top:auto;bottom:100%;}
table tr:nth-child(-n + 4) .smart-actions{top:100%;bottom:auto;}

#vibrancyDashboardAccordion {}
#vibrancyDashboardAccordion .accordion-item {border: 1px solid #c5d0e6;border-radius: 10px;box-shadow: 0px 0 3px 1px #3333331a;}

#vibrancyDashboardAccordion .accordion-item .accordion-button[aria-expanded="true"]{background-color:transparent;border-bottom: 1px solid #ececec;}
#vibrancyDashboardAccordion .accordion-item .accordion-button span{background-color: #d6d6d6 !important;color: #443636 !important;padding: 6px 10px;}
#vibrancyDashboardAccordion .accordion-item .accordion-button::after {background-color: transparent;}
/* .accordion-item:has(#vibrancyPointsHeading .accordion-button[aria-expanded="true"]){background-color: #fff6f0 !important;} */
.accordion-item:has(#vibrancyPointsHeading .accordion-button[aria-expanded="true"]) .accordion-button{color: #ea580c !important;border-color: #ffd9cf;}
.accordion-item:has(#vibrancyPointsHeading .accordion-button[aria-expanded="true"]) .accordion-button span{background-color: #ea580c !important;color: #fff !important;}

/* .accordion-item:has(#dataCoverageHeading .accordion-button[aria-expanded="true"]){background-color: rgba(14,165,233,0.09) !important;} */
.accordion-item:has(#dataCoverageHeading .accordion-button[aria-expanded="true"]) .accordion-button{color: #0284c7 !important;border-color: #a8e1ff;}
.accordion-item:has(#dataCoverageHeading .accordion-button[aria-expanded="true"]) .accordion-button span{background-color: #0284c7 !important;color: #ffffff !important;}

/* .accordion-item:has(#outreachStatsHeading .accordion-button[aria-expanded="true"]){background-color: rgb(209, 250, 229) !important;} */
.accordion-item:has(#outreachStatsHeading .accordion-button[aria-expanded="true"]) .accordion-button{color: #0f9d58 !important;border-color: #aadfc5;}
.accordion-item:has(#outreachStatsHeading .accordion-button[aria-expanded="true"]) .accordion-button span{background-color: #0f9d58 !important;color: #fff !important;}

/* .accordion-item:has(#activityStatsHeading .accordion-button[aria-expanded="true"]) {background-color: rgba(124,58,237,0.08) !important;} */
.accordion-item:has(#activityStatsHeading .accordion-button[aria-expanded="true"]) .accordion-button{color: #7c3aed !important;border-color: #dfccff;}
.accordion-item:has(#activityStatsHeading .accordion-button[aria-expanded="true"]) .accordion-button span{background-color: #7c3aed !important;color: #fff !important;}

@media (min-width: 768px) {
.right-md-border{border-right: 1px solid #e5e7eb !important;}
}
@media (max-width: 768px) {
.right-md-border{border-bottom: 1px solid #e5e7eb !important;}
}


/* Adaptive org/company logos: square JPEG vs circular/transparent-corner logos */
.alumni_univarsity_logo.logo-shape-pending,
.alumni_profile_college_logo.logo-shape-pending,
.work-block .icon.workex-logo.logo-shape-pending {
    border-radius: 8px;
    border: 1px solid #e5e5e5;
    background: #fff;
    overflow: hidden;
}

.alumni_univarsity_logo.logo-shape-square,
.alumni_profile_college_logo.logo-shape-square,
.work-block .icon.workex-logo.logo-shape-square {
    border-radius: 8px !important;
    border: 1px solid #e5e5e5 !important;
    background: #fff !important;
    overflow: hidden;
    padding: 4px !important;
}

.alumni_univarsity_logo.logo-shape-square img,
.alumni_profile_college_logo.logo-shape-square img,
.work-block .icon.workex-logo.logo-shape-square img {
    border-radius: 0 !important;
    width: 100% !important;
    height: 100% !important;
    max-width: 100% !important;
    max-height: 100% !important;
    object-fit: contain !important;
}

.alumni_univarsity_logo.logo-shape-circle,
.alumni_profile_college_logo.logo-shape-circle,
.work-block .icon.workex-logo.logo-shape-circle {
    border-radius: 50% !important;
    border: 1px solid #d2d2d2 !important;
    background: #fff !important;
    overflow: hidden;
    padding: 4px !important;
}

.alumni_univarsity_logo.logo-shape-circle img,
.alumni_profile_college_logo.logo-shape-circle img,
.work-block .icon.workex-logo.logo-shape-circle img {
    border-radius: 50% !important;
    width: 100% !important;
    height: 100% !important;
    max-width: 100% !important;
    max-height: 100% !important;
    object-fit: contain !important;
}
/* ========================================
   FACT LOADER - directory search overlay
   ======================================== */
   .uv-loader-overlay {
    position: fixed;
    inset: 0;
    z-index: 9999;
    backdrop-filter: blur(2px);
    -webkit-backdrop-filter: blur(2px);
}

.uv-loader-card {
    --uv-navy: #51499c;
    --uv-ink: #1f2430;
    --uv-ink-soft: #6b7280;
    box-shadow: 0 20px 50px rgba(15, 30, 45, .25);
    width: min(480px, calc(100vw - 40px));
    animation: slideUp 0.3s ease-out;
}

.uv-logo-loader {
    width: 56px;
    height: 74px;
    margin: 0 auto 16px;
}
.uv-logo-loader svg {
    width: 56px;
    height: 74px;
    max-width: 56px;
    max-height: 74px;
    display: block;
    overflow: visible;
}
.uv-logo-stripe {
    opacity: 0;
    animation: uv-logo-in 2.4s cubic-bezier(.4,0,.2,1) infinite;
    animation-delay: calc(var(--i) * 0.13s);
}
@keyframes uv-logo-in {
    0%   { opacity: 0; transform: translate(-16px, 11px); }
    16%  { opacity: 1; transform: translate(0, 0); }
    70%  { opacity: 1; transform: translate(0, 0); }
    85%  { opacity: 0; transform: translate(0, 0); }
    100% { opacity: 0; transform: translate(-16px, 11px); }
}
@media (prefers-reduced-motion: reduce) {
    .uv-logo-stripe {
        animation: uv-logo-pulse 2.4s ease-in-out infinite;
        transform: none;
    }
    @keyframes uv-logo-pulse {
        0%, 100% { opacity: 1; } 50% { opacity: .45; }
    }
}

.uv-loader-status {
    font-size: 14px;
    color: var(--uv-ink-soft);
}

.uv-fact-icon {
    width: 34px;
    height: 34px;
    margin: 0 auto 14px;
    color: var(--uv-navy);
    opacity: .85;
    transition: opacity .4s ease, transform .4s ease;
}
.uv-fact-icon.is-fading { opacity: 0; transform: translateY(4px); }
.uv-fact-icon svg { width: 100%; height: 100%; display: block; }

.uv-fact { min-height: 72px; }
.uv-fact-text {
    font-size: 15.5px;
    line-height: 1.55;
    color: var(--uv-ink);
    opacity: 1;
    transition: opacity .4s ease;
}
.uv-fact-text.is-fading { opacity: 0; }
.uv-fact-text .uv-punch { color: var(--uv-navy); font-weight: 600; }

.uv-fact-dots span {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #d4dbe3;
    transition: background .3s;
}
.uv-fact-dots span.is-active { background: var(--uv-navy); }

@media (prefers-reduced-motion: reduce) {
    .uv-fact-text, .uv-fact-icon { transition: none; }
}

/* ===== Directory filters head: result count + layout ===== */
.filters-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 8px 12px;
}

.filters-head-left {
    display: inline-flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    min-width: 0;
}

.filters-head-left h3 {
    display: inline-flex !important;
    align-items: center;
    margin: 0;
    width: auto !important;
    flex: 0 0 auto !important;
}

.filters-head-left h3 .icon-filter + span {
    flex: 0 0 auto !important;
}

.filters-head-right {
    display: inline-flex;
    align-items: center;
    gap: 12px;
    margin-left: auto;
}

.filters-head-toggle {
    cursor: pointer;
    transition: transform 0.3s ease-in-out;
}

.filters-head-toggle[aria-expanded='true'] {
    transform: rotate(270deg);
}

.filters-head-toggle[aria-expanded='false'] {
    transform: rotate(90deg);
}

/* Result count chip — green accent (not red/alert) */
.directory-result-count {
    --drc-green: #1a9f5c;
    --drc-green-soft: #eefaf3;
    --drc-ink: #1a2332;
    --drc-muted: #5c6570;

    position: relative;
    display: inline-flex;
    align-items: center;
    gap: 10px;
    margin: 0;
    padding: 7px 16px 7px 10px;
    min-height: 38px;
    border-radius: 12px;
    background: linear-gradient(135deg, #ffffff 0%, var(--drc-green-soft) 100%);
    border: 1px solid rgba(26, 159, 92, 0.2);
    box-shadow:
        0 1px 2px rgba(26, 35, 50, 0.04),
        0 4px 12px rgba(26, 159, 92, 0.08);
    color: var(--drc-ink);
    white-space: nowrap;
    line-height: 1.15;
    animation: directory-result-count-in 0.35s ease-out;
}

.directory-result-count::before {
    content: '';
    width: 3px;
    align-self: stretch;
    min-height: 22px;
    border-radius: 3px;
    background: linear-gradient(180deg, #3ecf8e 0%, var(--drc-green) 100%);
    flex-shrink: 0;
}

.directory-result-count__body {
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 1px;
    min-width: 0;
}

.directory-result-count__row {
    display: inline-flex;
    align-items: baseline;
    gap: 6px;
}

.directory-result-count__num {
    font-size: 20px;
    font-weight: 700;
    letter-spacing: -0.03em;
    color: var(--drc-green);
    font-variant-numeric: tabular-nums;
    transition: color 0.2s ease;
}

.directory-result-count__label {
    font-size: 12px;
    font-weight: 600;
    color: var(--drc-muted);
    letter-spacing: 0.02em;
    text-transform: lowercase;
}

.directory-result-count.is-loading {
    background: linear-gradient(90deg, #f7f8fa 0%, #eefaf3 50%, #f7f8fa 100%);
    background-size: 200% 100%;
    animation: directory-result-count-shimmer 1.2s ease-in-out infinite;
    box-shadow: none;
}

.directory-result-count.is-loading::before {
    opacity: 0.35;
}

.directory-result-count.is-loading .directory-result-count__label {
    color: #8a939e;
    font-size: 12px;
    font-weight: 500;
    text-transform: none;
}

@keyframes directory-result-count-in {
    from {
        opacity: 0;
        transform: translateY(4px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes directory-result-count-shimmer {
    0% {
        background-position: 100% 0;
    }
    100% {
        background-position: -100% 0;
    }
}

@media (max-width: 767px) {
    .directory-result-count {
        padding: 5px 12px 5px 8px;
        min-height: 32px;
        border-radius: 10px;
        gap: 8px;
    }

    .directory-result-count__num {
        font-size: 16px;
    }

    .directory-result-count__label {
        font-size: 11px;
    }
}

/* Country filter — same Top Countries / divider structure as form SelectControl optgroups */
.alumni_directory_filter .directory-filter-optgroup-label {
    font-size: 14px;
    font-weight: 600;
    color: #212529;
    padding: 6px 0 4px;
    margin-bottom: 2px;
    line-height: 1.2;
}
.alumni_directory_filter .directory-filter-optgroup-divider {
    font-weight: 400;
    font-size: 12px;
    color: #6c757d;
    letter-spacing: 1px;
    padding-top: 8px;
    margin-top: 4px;
    border-top: 1px solid #dee2e6;
    overflow: hidden;
    white-space: nowrap;
}
.alumni_directory_filter .directory-filter-country-groups .form-check:first-of-type {
    margin-top: 0;
}
.alumni_directory_filter .fiterItem .form-check:not(:last-child) {
    margin-bottom: 4px;
}
/* Show Profiles — keep boolean filters on one row (desktop) */
@media (min-width: 951px) {
    .showProfiles_left {
        flex-wrap: nowrap;
        flex: 1 1;
        min-width: 0;
    }

    .showProfiles_left .check_list-single-row {
        flex-wrap: nowrap;
        flex: 1 1;
        min-width: 0;
        overflow-x: auto;
        scrollbar-width: thin;
        gap: 4px 12px;
    }

    .showProfiles_left .check_list-single-row .form-check.form-check-inline {
        flex-shrink: 0;
        margin-right: 0;
    }

    .showProfiles_left .check_list-single-row .form-check-label {
        white-space: nowrap;
    }
}

.form-switch .form-check-input {width: 60px;background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});background-position: left center;border-radius: 2em;transition: background-position .15s ease-in-out;height: 28px;border: 1px solid #ccc;}
.form-switch .form-check-input:checked {background-position: right center;background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});}

/* Entrepreneur Directory cards — prototype HTML layout in revamp_style */
.ent-dir-revenue-filter {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    margin: 0;
}

.ent-dir-revenue-filter__label {
    font-size: 14px;
    font-weight: 500;
    color: #1a2332;
    white-space: nowrap;
}

.ent-dir-revenue-filter .form-select {
    min-width: 140px;
    width: auto;
    height: 38px;
    padding: 6px 32px 6px 12px;
    font-size: 14px;
    font-weight: 500;
    border-radius: 8px;
}

.ent-dir-card {
    overflow: hidden;
    box-shadow: 0 1px 4px rgba(18, 38, 58, 0.06);
    border-color: #d9e3ec !important;
}

.ent-dir-card__head {
    padding: 16px 16px 14px;
    background: #fff;
}

.ent-dir-card__photo {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    overflow: hidden;
    display: block;
    background: #cdeafc;
}

.ent-dir-card__photo img,
.ent-dir-card__photo > div {
    width: 48px !important;
    height: 48px !important;
    object-fit: cover;
    border-radius: 50%;
    font-size: 0.9rem !important;
}

.ent-dir-card__name {
    font-size: 16px;
    font-weight: 600;
    line-height: 1.3;
    margin: 0;
}

.ent-dir-card__name a {
    color: #12263a;
    text-decoration: none;
}

.ent-dir-card__name a:hover {
    color: #0b5ed7;
}

.ent-dir-card__program {
    font-size: 13px;
    color: #5b6b7a;
    line-height: 1.35;
}

.ent-dir-card__location {
    font-size: 13px;
    color: #5b6b7a;
    margin-top: 2px;
}

.ent-dir-pill {
    position: absolute;
    top: 0;
    right: 0;
    font: 700 10px Nunito, sans-serif;
    letter-spacing: 0.03em;
    line-height: 1;
    padding: 4px 10px;
    border-radius: 14px;
    white-space: nowrap;
}

.ent-dir-pill--first-gen {
    background: rgb(240, 180, 41);
    color: rgb(92, 61, 0);
}

.ent-dir-pill--family {
    background: rgb(219, 228, 236);
    color: rgb(61, 82, 102);
}

.ent-dir-card__company {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 14px 16px;
    background: #e8f4fc;
    min-height: 84px;
}

.ent-dir-card__logo,
.ent-dir-card__logo img {
    width: 48px;
    height: 48px;
    object-fit: contain;
    flex-shrink: 0;
}

.ent-dir-card__logo.logo-shape-icon {
    padding: 8px !important;
}

.ent-dir-card__company-name {
    font-size: 15px;
    font-weight: 600;
    color: #12263a;
    line-height: 1.3;
}

.ent-dir-card__meta {
    font-size: 13px;
    color: #5b6b7a;
    margin-top: 4px;
    line-height: 1.4;
}

.ent-dir-card__revenue {
    padding: 10px 16px 14px;
    background: #e8f4fc;
}

.ent-dir-revenue-badge {
    display: inline-block;
    font-size: 12px;
    font-weight: 600;
    color: #0b5ed7;
    background: #d6ebfa;
    border-radius: 999px;
    padding: 4px 10px;
}

.ent-dir-revenue-badge--empty {
    color: #6c757d;
    background: #e9ecef;
    font-weight: 500;
}

/* ==========================================================================
   Custom Reports (internal admin) — Ability Markers shell
   Prefix: .cr-*  |  Do not add a separate CSS file for this module
   ========================================================================== */
.cr-page {
    --cr-navy: #1a2744;
    --cr-navy-2: #243356;
    --cr-gold: #b8860b;
    --cr-orange: #e77817;
    --cr-red: #c0392b;
    --cr-green: #1e7e34;
    --cr-bg: #f6f7fb;
    --cr-border: #e6e8ef;
    --cr-muted: #6b7280;
    --cr-text: #2b3247;
    background: var(--cr-bg);
    color: var(--cr-text);
    padding: 22px 20px 60px;
    min-height: calc(100vh - 140px);
}

.cr-page-head {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 12px;
    margin-bottom: 18px;
}

.cr-page-head h1 {
    font-size: 24px;
    font-weight: 600;
    margin: 0;
    color: var(--cr-navy);
}

.cr-page-head p {
    color: var(--cr-muted);
    font-size: 13px;
    margin: 4px 0 0;
}

.cr-page-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
}

.cr-layout {
    display: grid;
    grid-template-columns: 240px 1fr;
    gap: 20px;
    align-items: start;
}

.cr-side-nav {
    background: #fff;
    border: 1px solid var(--cr-border);
    border-radius: 8px;
    padding: 8px 0;
    position: sticky;
    top: 12px;
}

.cr-side-grp {
    padding: 10px 16px 6px;
    font-size: 11px;
    color: var(--cr-muted);
    font-weight: 700;
    letter-spacing: 0.6px;
    text-transform: uppercase;
}

.cr-side-link {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 16px;
    color: var(--cr-text);
    text-decoration: none;
    font-weight: 500;
    font-size: 13.5px;
    border-left: 3px solid transparent;
}

.cr-side-link i {
    color: var(--cr-muted);
    font-size: 15px;
    width: 18px;
    text-align: center;
}

.cr-side-link:hover {
    background: #f2f4f9;
    color: var(--cr-navy);
}

.cr-side-link.active {
    background: #eef2fb;
    border-left-color: var(--cr-navy);
    color: var(--cr-navy);
    font-weight: 600;
}

.cr-side-link.active i {
    color: var(--cr-navy);
}

.cr-side-count {
    margin-left: auto;
    background: #eef2fb;
    color: var(--cr-navy);
    border-radius: 10px;
    padding: 1px 8px;
    font-size: 11px;
    font-weight: 600;
}

.cr-rpt {
    background: #fff;
    border: 1px solid var(--cr-border);
    border-radius: 8px;
    overflow: hidden;
}

.cr-rpt-head {
    padding: 18px 20px;
    border-bottom: 1px solid var(--cr-border);
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 14px;
    flex-wrap: wrap;
}

.cr-rpt-head h2 {
    font-size: 19px;
    font-weight: 600;
    margin: 0;
    color: var(--cr-navy);
}

.cr-rpt-head h2 i {
    color: var(--cr-muted);
}

.cr-rpt-desc {
    color: var(--cr-muted);
    font-size: 12.5px;
    margin: 4px 0 0;
    max-width: 720px;
}

.cr-rpt-actions {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
}

.cr-btn {
    border-radius: 6px;
    padding: 7px 14px;
    font-weight: 500;
    font-size: 13.5px;
    display: inline-flex;
    align-items: center;
    line-height: 1.3;
    cursor: pointer;
}

.cr-btn-sm {
    padding: 6px 12px;
    font-size: 13px;
}

.cr-icon-btn {
    padding: 6px 8px;
}

.cr-btn-navy {
    background: var(--cr-navy);
    color: #fff;
    border: 1px solid var(--cr-navy);
}

.cr-btn-navy:hover {
    background: var(--cr-navy-2);
    color: #fff;
}

.cr-btn:disabled {
    opacity: 0.45;
    cursor: not-allowed;
}

.cr-btn-navy:disabled:hover {
    background: var(--cr-navy);
    color: #fff;
}

.cr-btn-outline {
    background: #fff;
    color: var(--cr-navy);
    border: 1px solid var(--cr-navy);
}

.cr-btn-outline:hover {
    background: var(--cr-navy);
    color: #fff;
}

.cr-btn-ghost {
    background: #fff;
    border: 1px solid var(--cr-border);
    color: var(--cr-text);
}

.cr-btn-ghost:hover {
    background: #f2f4f9;
}

.cr-filter-bar {
    padding: 14px 20px;
    background: #fbfbfd;
    border-bottom: 1px solid var(--cr-border);
}

.cr-filter-row {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    align-items: center;
}

.cr-search {
    position: relative;
    flex: 1 1;
    min-width: 240px;
    max-width: 360px;
}

.cr-search i {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: var(--cr-muted);
}

.cr-search input {
    padding: 0 12px 0 34px;
    height: 36px;
    font-size: 13px;
    border: 1px solid var(--cr-border);
    border-radius: 6px;
    width: 100%;
    background: #fff;
}

.cr-pill {
    background: #fff;
    border: 1px solid var(--cr-border);
    border-radius: 20px;
    padding: 6px 12px;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 12.5px;
    font-weight: 500;
    color: var(--cr-text);
    cursor: pointer;
}

.cr-pill i {
    font-size: 10px;
    color: var(--cr-muted);
}

.cr-more {
    background: none;
    border: none;
    color: var(--cr-navy);
    font-weight: 600;
    font-size: 12.5px;
    padding: 6px 4px;
    cursor: pointer;
}

.cr-more:hover {
    text-decoration: underline;
}

.cr-more-wrap {
    position: relative;
}

.cr-more-menu {
    position: absolute;
    z-index: 6;
    top: calc(100% + 6px);
    left: 0;
    min-width: 200px;
    padding: 8px;
    display: flex;
    flex-direction: column;
    gap: 6px;
    background: #fff;
    border: 1px solid var(--cr-border);
    border-radius: 8px;
    box-shadow: 0 8px 24px rgba(16, 24, 40, 0.08);
}

.cr-chip button,
.cr-pill button {
    border: 0;
    background: transparent;
    padding: 0;
    color: inherit;
    line-height: 1;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font: inherit;
    cursor: pointer;
}

.cr-pill.has-value,
.cr-chip.has-value {
    border-color: var(--cr-navy);
    background: #eef3fb;
}

.cr-filter-menu {
    position: relative;
}

.cr-filter-drop {
    position: absolute;
    z-index: 8;
    top: calc(100% + 6px);
    left: 0;
    min-width: 220px;
    max-height: 240px;
    overflow: auto;
    padding: 6px;
    background: #fff;
    border: 1px solid var(--cr-border);
    border-radius: 8px;
    box-shadow: 0 8px 24px rgba(16, 24, 40, 0.08);
}

.cr-filter-drop .cr-filter-search {
    position: sticky;
    top: -6px;
    z-index: 1;
    display: flex;
    align-items: center;
    gap: 6px;
    margin: -6px -6px 6px;
    padding: 8px;
    background: #fff;
    border-bottom: 1px solid var(--cr-border);
    cursor: default;
}

.cr-filter-drop .cr-filter-search:hover {
    background: #fff;
}

.cr-filter-drop .cr-filter-search input {
    width: 100%;
    border: 1px solid var(--cr-border);
    border-radius: 6px;
    padding: 4px 8px;
    font-size: 12.5px;
    font-weight: 500;
}

.cr-filter-drop label {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 8px;
    font-size: 12.5px;
    font-weight: 500;
    cursor: pointer;
}

.cr-filter-drop label:hover {
    background: #f4f6fb;
}

.cr-marker-strip {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    padding: 10px 20px;
    background: #fbfbfd;
    border-bottom: 1px solid var(--cr-border);
    align-items: center;
}

.cr-strip-label {
    font-size: 11.5px;
    color: var(--cr-muted);
    text-transform: uppercase;
    letter-spacing: 0.5px;
    font-weight: 700;
    margin-right: 4px;
}

.cr-chip {
    background: #fff;
    border: 1px solid var(--cr-border);
    border-radius: 16px;
    padding: 5px 12px;
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
    color: var(--cr-text);
    display: inline-flex;
    align-items: center;
    gap: 4px;
}

.cr-chip:hover {
    border-color: var(--cr-navy);
}

.cr-chip.on {
    background: var(--cr-navy);
    color: #fff;
    border-color: var(--cr-navy);
}

.cr-chip-add {
    border-style: dashed;
    color: var(--cr-navy);
}

.cr-rpt-body {
    padding: 14px 20px 20px;
}

.cr-toolbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6px 0 12px;
    flex-wrap: wrap;
    gap: 10px;
}

.cr-count {
    font-size: 13px;
    color: var(--cr-muted);
}

.cr-count strong {
    color: var(--cr-text);
}

.cr-static-note {
    font-size: 11.5px;
    color: var(--cr-muted);
}

.cr-sort {
    display: flex;
    gap: 8px;
    align-items: center;
    font-size: 12.5px;
    color: var(--cr-muted);
}

.cr-sort select {
    border: 1px solid var(--cr-border);
    border-radius: 6px;
    padding: 5px 8px;
    font-size: 12.5px;
    background: #fff;
}

.cr-table {
    width: 100%;
    font-size: 13px;
    border-collapse: separate;
    border-spacing: 0;
}

.cr-table thead th {
    background: #f5f6fa;
    color: var(--cr-navy);
    font-weight: 600;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    padding: 11px 12px;
    border-bottom: 1px solid var(--cr-border);
    text-align: left;
    white-space: nowrap;
}

.cr-table tbody td {
    padding: 14px 12px;
    border-bottom: 1px solid #f0f2f7;
    vertical-align: middle;
}

.cr-table tbody tr:hover {
    background: #fafbfe;
}

.cr-alum {
    display: flex;
    align-items: center;
    gap: 10px;
}

.cr-avatar {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    color: var(--cr-navy);
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 14px;
    flex-shrink: 0;
}

.cr-alum-name {
    font-weight: 600;
    color: var(--cr-navy);
    font-size: 13.5px;
}

.cr-alum-sub {
    color: var(--cr-muted);
    font-size: 12px;
    font-style: italic;
}

.cr-tags {
    display: flex;
    flex-wrap: wrap;
    max-width: 280px;
    gap: 4px;
}

.cr-tag {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 11px;
    font-weight: 600;
    line-height: 1.5;
    background: #eef2fb;
    color: var(--cr-navy);
    border: 1px solid #d5deef;
}

.cr-tag-more {
    position: relative;
    cursor: help;
    background: #f3f4f6;
    color: #374151;
    border-color: #e5e7eb;
}

.cr-tag-tip {
    display: none;
    position: absolute;
    z-index: 6;
    left: 0;
    top: calc(100% + 6px);
    width: max-content;
    max-width: 280px;
    padding: 8px 10px;
    border-radius: 6px;
    background: #1f2937;
    color: #fff;
    font-weight: 500;
    line-height: 1.4;
    white-space: normal;
}

.cr-tag-more:hover .cr-tag-tip,
.cr-tag-more:focus .cr-tag-tip {
    display: block;
}

.cr-tag-navy {
    background: #eef2fb;
    color: var(--cr-navy);
}

.cr-tag-custom {
    background: #f1eafd;
    color: #6a3fbf;
    border-color: #d9c8f5;
    font-size: 9.5px;
    margin-left: 4px;
}

.cr-action {
    background: transparent;
    border: none;
    color: var(--cr-muted);
    font-size: 18px;
    padding: 2px 6px;
    cursor: pointer;
}

.cr-action:hover {
    color: var(--cr-navy);
}

.cr-action-wrap {
    position: relative;
    display: inline-block;
}

.cr-action-menu {
    position: absolute;
    right: 0;
    top: calc(100% + 4px);
    background: #fff;
    border: 1px solid var(--cr-border);
    border-radius: 8px;
    width: 248px;
    z-index: 40;
    padding: 6px 0;
    text-align: left;
}

.cr-action-sect {
    padding: 5px 14px 2px;
    font-size: 10px;
    color: var(--cr-muted);
    text-transform: uppercase;
    letter-spacing: 0.6px;
    font-weight: 700;
}

.cr-action-div {
    border-top: 1px solid var(--cr-border);
    margin: 5px 0;
}

.cr-action-item {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 8px 14px;
    background: none;
    border: none;
    color: var(--cr-text);
    font-size: 12.5px;
    text-align: left;
    cursor: pointer;
}

.cr-action-item i {
    color: var(--cr-muted);
    width: 18px;
    margin-right: 8px;
    font-size: 14px;
}

.cr-action-item:hover {
    background: #f4f6fb;
    color: var(--cr-navy);
}

.cr-action-item:hover i {
    color: var(--cr-navy);
}

.cr-rpt-body .table-responsive {
    overflow: visible;
}

.cr-soon {
    text-align: center;
    padding: 56px 24px;
    color: var(--cr-muted);
}

.cr-soon i {
    font-size: 28px;
    color: var(--cr-navy);
    display: block;
    margin-bottom: 10px;
}

.cr-soon h3 {
    color: var(--cr-navy);
    font-size: 18px;
    font-weight: 600;
    margin: 0 0 8px;
}

.cr-soon p {
    max-width: 460px;
    margin: 0 auto 16px;
    font-size: 13px;
}

.cr-pill.active {
    background: #eef2fb;
    border-color: var(--cr-navy);
    color: var(--cr-navy);
}

.cr-badge {
    background: var(--cr-navy);
    color: #fff;
    border-radius: 10px;
    padding: 0 6px;
    font-size: 10.5px;
    margin-left: 2px;
}

.cr-filter-row-sub {
    margin-top: 10px;
}

.cr-tag-gold {
    background: #fdf6e3;
    color: #b8860b;
    border-color: #f2e2b0;
}

.cr-tag-green {
    background: #e7f5ec;
    color: #1e7e34;
    border-color: #c3e2ce;
}

.cr-tag-orange {
    background: #fff1e3;
    color: #e77817;
    border-color: #fbd6b0;
}

.cr-tag-purple {
    background: #f1eafd;
    color: #6a3fbf;
    border-color: #d9c8f5;
}

.cr-tag-grey {
    background: #eef0f4;
    color: #2b3247;
    border-color: #dde0e8;
}

.cr-tag-red {
    background: #fbe9e7;
    color: #c0392b;
    border-color: #f2c2bc;
}

.cr-lapsed {
    display: inline-block;
    background: #fbe9e7;
    color: #c0392b;
    border: 1px solid #f2c2bc;
    padding: 1px 6px;
    border-radius: 3px;
    font-size: 10px;
    font-weight: 600;
    margin-left: 6px;
    vertical-align: middle;
}

.cr-prev {
    color: var(--cr-muted);
    font-size: 11.5px;
    font-style: italic;
    margin-top: 2px;
}

.cr-blank {
    color: #c0c4cf;
    font-size: 14px;
    padding-left: 6px;
}

.cr-footnote {
    padding: 10px 0 4px;
    margin-top: 8px;
    background: #fefaf1;
    border: 1px solid #f2e2b0;
    border-radius: 6px;
    font-size: 11.5px;
    color: #7a5a10;
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 10px 14px;
}

.cr-pager {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 6px;
    padding: 14px 0 4px;
}

.cr-pager span {
    padding: 5px 10px;
    border: 1px solid var(--cr-border);
    border-radius: 4px;
    color: var(--cr-text);
    font-size: 12.5px;
}

.cr-pager span.current {
    background: var(--cr-navy);
    color: #fff;
    border-color: var(--cr-navy);
    font-weight: 600;
}

.cr-scroll-status {
    text-align: center;
    color: var(--cr-muted);
    font-size: 12.5px;
    padding: 8px 0 2px;
    min-height: 28px;
}

.cr-campus-search {
    min-width: 280px;
    max-width: 420px;
    flex: 1 1 280px;
}

.cr-campus-search .cr-campus__container {
    height: auto !important;
    border: 0 !important;
    flex: 1 1 280px !important;
    min-width: 280px;
    max-width: 420px;
}

.cr-campus-search .cr-campus__control {
    min-height: 36px !important;
    height: 36px !important;
    border: 1px solid #98a2b3 !important;
    border-radius: 6px !important;
    background: #fff !important;
    box-shadow: none !important;
}

.cr-campus-search .cr-campus__control--is-focused {
    border-color: var(--cr-navy) !important;
    box-shadow: 0 0 0 3px rgba(26, 39, 68, 0.12) !important;
}

.cr-campus-search .cr-campus__placeholder,
.cr-campus-search .cr-campus__single-value {
    color: #2b3247;
    font-size: 13px;
}

.cr-campus-search .cr-campus__placeholder {
    color: #667085;
}

.cr-suggest-item {
    display: block;
    width: 100%;
    text-align: left;
    border: 0;
    background: transparent;
    padding: 6px 8px;
    font-size: 12.5px;
    font-weight: 500;
    color: var(--cr-text);
    cursor: pointer;
    border-radius: 4px;
}

.cr-suggest-item:hover {
    background: #f4f6fb;
}

.cr-suggest {
    min-width: 260px;
}

.cr-status-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    display: inline-block;
    margin-right: 6px;
    vertical-align: middle;
}

.cr-status-dot.ok {
    background: var(--cr-green);
}

.cr-status-dot.warn {
    background: var(--cr-orange);
}

.cr-status-dot.err {
    background: var(--cr-red);
}

.cr-drawer-backdrop,
.cr-modal-backdrop {
    position: fixed;
    inset: 0;
    background: rgba(20, 25, 40, 0.35);
    z-index: 1050;
}

.cr-modal-backdrop {
    z-index: 1070;
}

.cr-drawer {
    position: fixed;
    top: 0;
    right: 0;
    width: 520px;
    max-width: 95vw;
    height: 100vh;
    background: #fff;
    box-shadow: -8px 0 24px rgba(0, 0, 0, 0.08);
    z-index: 1060;
    display: flex;
    flex-direction: column;
}

.cr-drawer-head,
.cr-modal-head {
    padding: 16px 20px;
    border-bottom: 1px solid var(--cr-border);
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 12px;
}

.cr-drawer-head h5,
.cr-modal-head h5 {
    margin: 0;
    font-size: 17px;
    font-weight: 600;
    color: var(--cr-navy);
}

.cr-drawer-head p {
    margin: 2px 0 0;
    font-size: 12px;
    color: var(--cr-muted);
}

.cr-drawer-tabs {
    display: flex;
    border-bottom: 1px solid var(--cr-border);
    padding: 0 12px;
    background: #fafbfe;
}

.cr-drawer-tabs button {
    background: none;
    border: none;
    padding: 12px 14px;
    font-size: 13px;
    font-weight: 600;
    color: var(--cr-muted);
    border-bottom: 2px solid transparent;
}

.cr-drawer-tabs button.active {
    color: var(--cr-navy);
    border-bottom-color: var(--cr-navy);
}

.cr-drawer-body {
    padding: 16px 20px;
    overflow-y: auto;
    flex: 1 1;
}

.cr-drawer-foot,
.cr-modal-foot {
    padding: 12px 20px;
    border-top: 1px solid var(--cr-border);
    background: #fafbfe;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.cr-link {
    background: none;
    border: none;
    color: var(--cr-navy);
    font-weight: 600;
    font-size: 13px;
    padding: 0;
}

.cr-picker {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 14px;
}

.cr-picker-col {
    border: 1px solid var(--cr-border);
    border-radius: 6px;
    background: #fff;
    display: flex;
    flex-direction: column;
    min-height: 340px;
}

.cr-picker-col h6 {
    margin: 0;
    padding: 10px 12px;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: var(--cr-muted);
    border-bottom: 1px solid var(--cr-border);
    background: #fbfbfd;
}

.cr-picker-search {
    padding: 8px 12px;
    border-bottom: 1px solid var(--cr-border);
}

.cr-picker-search input {
    border: 1px solid var(--cr-border);
    border-radius: 5px;
    padding: 6px 8px;
    font-size: 12.5px;
    width: 100%;
}

.cr-picker-list {
    overflow-y: auto;
    padding: 4px 0;
    max-height: 360px;
}

.cr-picker-group {
    padding: 6px 12px 2px;
    font-size: 10.5px;
    color: var(--cr-muted);
    text-transform: uppercase;
    letter-spacing: 0.5px;
    font-weight: 700;
}

.cr-picker-item,
button.cr-picker-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 12px;
    font-size: 12.5px;
    cursor: pointer;
    margin: 0 6px;
    border-radius: 4px;
}

button.cr-picker-item {
    width: calc(100% - 12px);
    border: 0;
    background: transparent;
    text-align: left;
    font: inherit;
    color: inherit;
}

.cr-picker-item:hover {
    background: #f2f4f9;
}

.cr-picker-item i {
    color: var(--cr-navy);
}

.cr-chosen {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 10px;
    font-size: 12.5px;
    border: 1px solid var(--cr-border);
    border-radius: 5px;
    margin: 4px 8px;
    background: #fff;
}

.cr-chosen-name {
    flex: 1 1;
    font-weight: 500;
}

.cr-chosen i {
    color: var(--cr-muted);
}

.cr-drawer .cr-pill-switch {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    min-height: auto;
    padding-left: 2.4em;
    margin: 0;
}

.cr-drawer .cr-pill-switch .form-check-input {
    width: 1.85em;
    height: 1em;
    margin-top: 0;
    margin-left: -2.4em;
    background-color: #d1d5db;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
    background-position: left center;
    border: none;
    cursor: pointer;
    flex-shrink: 0;
    box-shadow: none;
}

.cr-drawer .cr-pill-switch .form-check-input:checked {
    background-color: #2f6bff;
    background-position: right center;
    border-color: #2f6bff;
}

.cr-drawer .cr-pill-switch .form-check-input:focus {
    box-shadow: none;
    border-color: transparent;
}

.cr-drawer .cr-pill-switch span {
    font-size: 10.5px;
    color: var(--cr-muted);
    font-weight: 500;
    flex: none;
    line-height: 1;
}

.cr-hint {
    font-size: 11.5px;
    color: var(--cr-muted);
    margin-top: 10px;
}

.cr-cf-head {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 12px;
    margin-bottom: 14px;
}

.cr-cf-title {
    font-weight: 600;
    font-size: 14px;
    color: var(--cr-navy);
}

.cr-empty {
    text-align: center;
    padding: 26px 12px;
    color: var(--cr-muted);
    border: 1px dashed var(--cr-border);
    border-radius: 6px;
    font-size: 13px;
}

.cr-empty i {
    display: block;
    font-size: 22px;
    margin-bottom: 8px;
}

.cr-cf-row {
    border: 1px solid var(--cr-border);
    border-radius: 6px;
    padding: 10px 12px;
    margin-bottom: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;
}

.cr-cf-name {
    font-weight: 500;
}

.cr-type {
    font-size: 11px;
    color: var(--cr-muted);
    text-transform: uppercase;
    letter-spacing: 0.5px;
    background: #eef2fb;
    padding: 2px 8px;
    border-radius: 10px;
    font-weight: 600;
}

.cr-modal {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 560px;
    max-width: calc(100vw - 32px);
    max-height: calc(100vh - 40px);
    overflow: auto;
    background: #fff;
    border-radius: 8px;
    z-index: 1080;
    box-shadow: 0 16px 40px rgba(20, 25, 40, 0.18);
}

.cr-modal-body {
    padding: 16px 20px;
}

.cr-label {
    font-size: 12.5px;
    font-weight: 600;
    color: var(--cr-text);
    margin-bottom: 4px;
    display: block;
}

.cr-req {
    color: var(--cr-red);
}

.cr-purpose {
    border: 1px solid var(--cr-border);
    border-radius: 6px;
    padding: 12px 14px;
    margin-bottom: 8px;
    cursor: pointer;
    background: #fff;
    display: flex;
    gap: 10px;
    align-items: flex-start;
}

.cr-purpose:hover {
    border-color: var(--cr-navy);
}

.cr-purpose.selected {
    border-color: var(--cr-navy);
    background: #eef2fb;
    box-shadow: inset 3px 0 0 var(--cr-navy);
}

.cr-purpose input {
    margin-top: 3px;
    flex-shrink: 0;
}

.cr-purpose strong {
    display: block;
    color: var(--cr-navy);
    font-size: 13.5px;
}

.cr-purpose small {
    display: block;
    font-size: 12px;
    color: var(--cr-muted);
    margin-top: 2px;
}

.cr-scores {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    padding: 12px 14px;
    background: #fafbfe;
    border: 1px solid var(--cr-border);
    border-radius: 6px;
}

.cr-scores label {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    font-size: 12.5px;
    cursor: pointer;
    padding: 6px 8px;
    border-radius: 4px;
    margin: 0;
}

.cr-scores label:hover {
    background: #eef2fb;
}

.cr-score-name {
    font-weight: 500;
    display: block;
}

.cr-score-hint {
    font-size: 10.5px;
    color: var(--cr-muted);
    display: block;
}

.cr-upload-note {
    margin: 0 0 12px;
    border: 1px solid #f3d19c;
    background: #fff8eb;
    border-radius: 8px;
    padding: 12px 14px;
    font-size: 13px;
    color: var(--cr-text);
}

.cr-upload-note.ok {
    border-color: #b7e0c2;
    background: #f3fbf5;
}

.cr-upload-note.error {
    border-color: #f3c1c1;
    background: #fff5f5;
}

.cr-upload-note-head {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    align-items: flex-start;
}

.cr-upload-note-head button {
    border: 0;
    background: transparent;
    color: var(--cr-navy);
    font-weight: 600;
    cursor: pointer;
    padding: 0;
}

.cr-upload-note ul {
    margin: 8px 0 0;
    padding-left: 18px;
}

.cr-upload-note li {
    margin: 4px 0;
}

.cr-error {
    color: var(--cr-red);
    font-size: 11.5px;
    margin-top: 8px;
}

.cr-callout {
    background: #fefaf1;
    border: 1px solid #f2e2b0;
    border-left: 3px solid var(--cr-gold);
    color: #7a5a10;
    padding: 10px 12px;
    border-radius: 6px;
    font-size: 12.5px;
}

@media (max-width: 900px) {
    .cr-layout {
        grid-template-columns: 1fr;
    }

    .cr-side-nav {
        position: static;
        display: flex;
        overflow-x: auto;
        padding: 6px;
    }

    .cr-side-grp {
        display: none;
    }

    .cr-side-link {
        border-left: none;
        border-bottom: 3px solid transparent;
        white-space: nowrap;
    }

    .cr-side-link.active {
        border-left: none;
        border-bottom-color: var(--cr-navy);
    }

    .cr-picker,
    .cr-scores {
        grid-template-columns: 1fr;
    }
}
`, "",{"version":3,"sources":["webpack://./src/styles/css/revamp_style.css"],"names":[],"mappings":"AACA;IACI,6BAA6B;AACjC;AACA;IACI,UAAU;IACV,SAAS;IACT,sBAAsB;IACtB,+BAA+B;AACnC;AACA;IACI,gBAAgB;IAChB,4BAA4B;IAC5B,qBAAqB;AACzB;AACA;;IAMI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;AACrB;AACA,kCAAkC,wBAAwB,CAAC;AAC3D;IAKI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IAKI,SAAO;AACX;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;IACd,qBAAqB;AACzB;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;;IAEI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,sBAAsB;AAC1B;AACA;EACE,iBAAiB;EACjB,UAAU;AACZ;AACA;IACI,iBAAiB;IACjB,UAAU;AACd;AACA;IACI,iBAAiB;IACjB,UAAU;AACd;AACA;IACI,iBAAiB;IACjB,UAAU;AACd;AACA;IACI,iBAAiB;IACjB,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,2BAA2B;IAC3B,YAAY;AAChB;AACA;IACI,2BAA2B;IAC3B,YAAY;AAChB;AACA;IACI,2BAA2B;IAC3B,YAAY;AAChB;AACA;IACI,2BAA2B;IAC3B,YAAY;AAChB;AACA;IACI,2BAA2B;IAC3B,YAAY;AAChB;AACA;IACI,2BAA2B;IAC3B,sBAAsB;AAC1B;AACA;IACI,2BAA2B;IAC3B,uBAAuB;AAC3B;AACA;IACI,2BAA2B;IAC3B,WAAW;AACf;AACA;IACI,2BAA2B;IAC3B,WAAW;AACf;AACA;IACI,2BAA2B;IAC3B,WAAW;AACf;AACA;IACI,2BAA2B;IAC3B,WAAW;AACf;AACA;IACI,2BAA2B;IAC3B,UAAU;AACd;AACA;IACI,2BAA2B;IAC3B,WAAW;AACf;AACA;IACI,0BAA0B;IAC1B,WAAW;AACf;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;IAC1B,WAAW;AACf;AACA;IACI,0BAA0B;IAC1B,WAAW;AACf;;AAEA,yBAAyB;AACzB;IACI,kBAAkB;IAKlB,SAAO;AACX;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,SAAS;IACT,WAAW;IACX,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI;QACI,WAAW;IACf;AACJ;AACA;IACI,UAAU;AACd;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;IACjB,WAAW;AACf;AACA;IACI,WAAW;IAKX,SAAO;IAKP,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,UAAU;AACd;AACA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,iBAAiB;AACrB;AACA;IAKI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,8BAA8B;IAC9B,YAAY;IACZ,UAAU;IACV,WAAW;IACX,aAAa;IACb,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;AACzB;AACA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,oBAAoB;IACpB,aAAa;IAKb,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,YAAY;IACZ,0BAA0B;IAC1B,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,eAAe;IACf,cAAc;IACd,YAAY;AAChB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;IACtB,WAAW;IACX,SAAS;IACT,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IAKd,aAAa;IAKb,gCAAgC;AACpC;AACA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAKlB,gCAAgC;AACpC;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,SAAS;IACT,MAAM;IACN,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,+GAA+G;AACnH;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,+BAA+B;IAC/B,uCAAuC;AAC3C;AACA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAKlB,aAAa;IACb,+BAA+B;IAC/B,uCAAuC;IACvC,oCAAoC;IACpC,mCAAmC;IACnC,kCAAkC;AACtC;AACA;IACI,WAAW;IACX,eAAe;AACnB;AACA;;IAEI,aAAa;AACjB;AACA;IACI,+BAA+B;IAC/B,6BAA6B;IAC7B,gBAAgB;IAChB,UAAU;IACV,cAAc;AAClB;AACA;IAKI,SAAO;AACX;AACA;IACI,WAAW;IACX,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,+BAA+B;IAC/B,gCAAgC;IAChC,2BAA2B;IAC3B,0BAA0B;IAC1B,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,qBAAqB;AACzB;AACA;IACI,gBAAgB;IAChB,UAAU;IACV,cAAc;AAClB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,YAAY;IAKZ,aAAa;IACb,uBAAuB;IACvB,qBAAqB;IACrB,UAAU;AACd;AACA;IACI,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,8HAA8H;IAC9H,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,OAAO;AACX;AACA;IACI,WAAW;AACf;AACA;IACI,oBAAoB;IACpB,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,8HAA8H;IAC9H,qBAAqB;IACrB,iBAAiB;AACrB;AACA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;IAChB,SAAS;AACb;AACA;IACI,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,qBAAqB;IACrB,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,qBAAqB;AACzB;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,iBAAiB;IACjB,yBAAyB;AAC7B;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,gBAAgB;AACpB;AACA;IACI,iBAAiB;IACjB,yBAAyB;AAC7B;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,OAAO;IACP,QAAQ;IACR,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,eAAe;AACnB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,+BAA+B;IAC/B,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,yBAAyB;IAKzB,gCAAgC;IAChC,qBAAqB;AACzB;AACA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;IAKT,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,uBAAuB;AAC3B;AACA;IACI,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,mBAAmB;IACnB,kCAAkC;IAClC,WAAW;IAKX,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;IACtB,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,aAAa;IACb,WAAW;IACX,8CAA8C;IAC9C,6CAA6C;AACjD;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,cAAc;IACd,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,WAAW;AACf;AACA;IAKI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;IAKZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,+BAA+B;IAC/B,uCAAuC;AAC3C;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;AAC7B;AACA;IACI,sBAAsB;IACtB,yBAAyB;AAC7B;AACA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;AACA;IACI,YAAY;IACZ,oBAAoB;AACxB;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,YAAY;IACZ,WAAW;AACf;AACA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;AACA;IACI,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI;QACI,gBAAgB;IACpB;IACA;QACI,gBAAgB;QAChB,aAAa;QACb,8CAA8C;QAC9C,6CAA6C;QAC7C,mBAAmB;IACvB;IACA;QACI,WAAW;IACf;IACA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,UAAU;IACV,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,WAAW;IACX,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,OAAO;IACP,QAAQ;IACR,MAAM;IACN,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,qBAAqB;IACrB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI;YACQ;AACZ;AACA;IACI;YACQ;AACZ;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,SAAS;IACT,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,WAAW;IACX,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,mBAAmB;AACvB;AACA,6BAA6B;;AAE7B,+BAA+B;;AAE/B;;IAEI,mBAAmB;IAGnB,6EAA6E;IAC7E,mHAAmH;AACvH;AACA;;IAEI,mBAAmB;IAGnB,6EAA6E;IAC7E,mHAAmH;AACvH;AACA;IACI,oFAAoF;AACxF;AACA;IACI,iGAAiG;AACrG;AACA;IACI,oFAAoF;AACxF;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,8BAA8B;IAC9B,2CAA2C;AAC/C;AACA;IACI,kCAAkC;IAClC,2CAA2C;AAC/C;AACA;IACI,mFAAmF;IACnF,sBAAsB;AAC1B;AACA;IACI,kCAAkC;AACtC;AACA;IACI,mFAAmF;AACvF;AACA;IACI,oFAAoF;AACxF;AACA;IACI,gBAAgB;AACpB;AACA;IAKI,SAAO;IASP,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;AAC1B;AACA;IAKI,SAAO;AACX;AACA;IACI,aAAa;AACjB;AACA;IACI,iBAAiB;IACjB,gCAAgC;IAKhC,aAAa;IACb,oBAAoB;IACpB,gBAAgB;IAChB,MAAM;IACN,gBAAgB;IAChB,UAAU;IACV,YAAY;AAChB;AACA;IACI,gBAAgB;IAChB,UAAU;AACd;AACA;IACI,aAAa;AACjB;AACA;IACI,YAAY;IACZ,WAAW;AACf;AACA;IACI,eAAe;IAKf,aAAa;IACb,oBAAoB;AACxB;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;AACA;IAKI,SAAO;AACX;AACA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;AACA;IAKI,SAAO;AACX;AACA;IAKI,SAAO;AACX;AACA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,aAAa;AACjB;AACA;IACI,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,gCAAgC;AACpC;AACA;IACI,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,UAAU;IACV,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,YAAY;AAChB;AACA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,wEAAwE;IACxE,gCAAgC;IAChC,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,MAAM;IACN,YAAY;IACZ,UAAU;IACV,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;IACnC,WAAW;IACX,gCAAgC;IAChC,UAAU;IACV,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,mFAAmF;IACnF,2CAA2C;AAC/C;AACA;IACI,oBAAoB;AACxB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;;IAMI,aAAa;IACb,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,uBAAuB;AAC3B;AACA;IAKI,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,oBAAoB;AACxB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IAKI,aAAa;IACb,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,iBAAiB;IACjB,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,QAAQ;IACR,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,MAAM;IACN,SAAS;IACT,YAAY;IACZ,0BAA0B;IAC1B,gBAAgB;IAChB,sBAAsB;IACtB,4BAA4B;AAChC;AACA;IACI,YAAY;IACZ,0BAA0B;AAC9B;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,SAAS;IACT,MAAM;IACN,YAAY;IAKZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;IACX,UAAU;AACd;AACA;IACI,aAAa;IAKb,aAAa;IACb,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IAKI,SAAO;AACX;AACA;IACI,gBAAgB;IAChB,gCAAgC;IAKhC,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,MAAM;IACN,UAAU;IACV,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,gBAAgB;IAChB,UAAU;IAKV,aAAa;IACb,oBAAoB;IACpB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAKlB,aAAa;IACb,gBAAgB;IAChB,SAAS;AACb;AACA;IACI,UAAU;IACV,WAAW;IAKX,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;AACd;AACA,gJAAgJ;AAChJ;IACI,SAAS;AACb;AACA;IACI,cAAc;AAClB;AACA;IACI,WAAW;IACX,SAAS;IACT,eAAe;AACnB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;AACjB;AACA;IACI,SAAS;IACT,UAAU;IACV,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,8BAA8B;AAClC;AACA;IACI,8BAA8B;AAClC;AACA;IACI,8BAA8B;AAClC;AACA;IACI,8BAA8B;AAClC;AACA;IACI,8BAA8B;AAClC;AACA;IACI,mBAAmB;AACvB;AACA;IAKI,aAAa;AACjB;AACA;IAKI,aAAa;AACjB;AACA;IACI,2CAA2C;IAC3C,8BAA8B;IAC9B,sCAAsC;IACtC,mCAAmC;IACnC,kCAAkC;IAClC,iCAAiC;AACrC;AACA;IACI,YAAY;IACZ,UAAU;AACd;AACA;IACI,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,eAAe,EAAE,iBAAiB;IAClC,kBAAkB,EAAE,gBAAgB;IACpC,8BAA8B;IAC9B,sCAAsC;IACtC,mCAAmC;IACnC,kCAAkC;IAClC,iCAAiC;IACjC,gBAAgB;AACpB;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,eAAe;IACf,gBAAgB,EAAE,uBAAuB,EAAE,gBAAgB;IAC3D,gCAAgC;AACpC;AACA;IACI,gBAAgB;IAChB,UAAU;AACd;AACA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,QAAQ;IACR,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,WAAW;AACf;AACA;IACI,gBAAgB;AACpB;AACA;IACI,UAAU;IACV,cAAc;AAClB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,aAAa;AACjB;AACA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAKlB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;IACf,WAAW;AACf;AACA;IACI,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,cAAc;IACd,eAAe;AACnB;AACA;IACI,eAAe;IACf,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IAKZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,eAAe;IACf,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;IACnC,yBAAyB;IACzB,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,2BAA2B;IAC3B,mCAAmC;IACnC,gCAAgC;IAChC,+BAA+B;IAC/B,8BAA8B;IAC9B,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,cAAc;IAKd,SAAO;IACP,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,4BAA4B;IAC5B,cAAc;IACd,oCAAoC;IACpC,iCAAiC;IACjC,gCAAgC;IAChC,+BAA+B;IAC/B,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;AACtB;AACA;;IAEI,4DAA6K;IAC7K,yBAAyB;IACzB,eAAe;AACnB;AACA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,4DAA6K;IAC7K,yBAAyB;AAC7B;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,0BAA0B;IAC1B,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,mBAAmB;IAKnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,8BAA8B;IAC9B,2BAA2B;IAC3B,0BAA0B;IAC1B,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,oCAAoC;IACpC,oCAAoC;IACpC,4CAA4C;IAC5C,WAAW;AACf;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,oCAAoC;IACpC,sCAAsC;IACtC,8CAA8C;IAC9C,UAAU;AACd;AACA;IACI;QACI,uBAAuB;QACvB,+BAA+B;QAC/B,4BAA4B;QAC5B,2BAA2B;QAC3B,0BAA0B;IAC9B;IACA;QACI,yBAAyB;QACzB,iCAAiC;QACjC,8BAA8B;QAC9B,6BAA6B;QAC7B,4BAA4B;IAChC;AACJ;AACA;IACI,0BAA0B;IAC1B,mDAAmD;IACnD,2DAA2D;IAC3D,kCAAkC;IAClC,+BAA+B;IAC/B,8BAA8B;IAC9B,6BAA6B;AACjC;AACA;IACI;QACI,0BAA0B;QAC1B,kCAAkC;QAClC,+BAA+B;QAC/B,8BAA8B;QAC9B,6BAA6B;IACjC;IACA;QACI,4BAA4B;QAC5B,oCAAoC;QACpC,iCAAiC;QACjC,gCAAgC;QAChC,+BAA+B;IACnC;IACA;QACI,0BAA0B;QAC1B,kCAAkC;QAClC,+BAA+B;QAC/B,8BAA8B;QAC9B,6BAA6B;IACjC;AACJ;AACA;IACI,UAAU;IACV,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,UAAU;AACd;AACA;IACI,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,sBAAsB;IACtB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,qBAAqB;IACrB,iBAAiB;IACjB,2BAA2B;AAC/B;AACA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,gBAAgB;AACpB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;AACpB;AACA;;IAEI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,MAAM;IACN,QAAQ;IACR,YAAY;IACZ,eAAe;IACf,UAAU;AACd;AACA;IACI,mBAAmB;IACnB,WAAW;IAKX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;;IAMI,SAAO;AACX;AACA;IACI;mBACe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;;IAEI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;AAC3B;AACA;IACI,sHAAsH;IACtH,sCAAsC;IACtC,4BAA4B;AAChC;AACA;IACI,oHAAoH;IACpH,qBAAqB;IACrB,4BAA4B;IAC5B,gCAAgC;IAChC,kBAAkB;AACtB;AACA;IACI,sHAAsH;IACtH,qBAAqB;IACrB,4BAA4B;IAC5B,gCAAgC;IAChC,kBAAkB;AACtB;AACA;IACI,sHAAsH;IACtH,qBAAqB;IACrB,4BAA4B;IAC5B,gCAAgC;IAChC,kBAAkB;AACtB;AACA;IACI,uHAAuH;IACvH,qBAAqB;IACrB,4BAA4B;IAC5B,gCAAgC;IAChC,kBAAkB;AACtB;AACA;IACI,qHAAqH;IACrH,qBAAqB;IACrB,4BAA4B;IAC5B,gCAAgC;IAChC,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;;IAEI,WAAW;AACf;AACA;IACI,kBAAkB;AACtB;AACA;IACI,iIAAiI;IACjI,iDAAiD;IACjD,4BAA4B;AAChC;AACA;IACI,WAAW;AACf;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,yDAA0V;IAC1V,uCAAuC;IACvC,sCAAsC;IACtC,qCAAqC;IACrC,YAAY;IACZ,sBAAsB;AAC1B;AACA;IACI,UAAU;AACd;AACA;IACI,yDAA2V;IAC3V,uCAAuC;IACvC,sCAAsC;IACtC,qCAAqC;IACrC,YAAY;IACZ,sBAAsB;IACtB,qBAAqB;IACrB,6BAA6B;IAC7B,0BAA0B;IAC1B,yBAAyB;IACzB,wBAAwB;AAC5B;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;IAKzB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,4BAA4B;IAC5B,yBAAyB;IACzB,wBAAwB;IACxB,uBAAuB;AAC3B;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;AACf;AACA;IACI,UAAU;IACV,SAAS;IAKT,SAAO;AACX;AACA;IACI,iBAAiB;AACrB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,MAAM;IACN,SAAS;IACT,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kIAAkI;AACtI;AACA;IACI,oIAAoI;AACxI;AACA;IACI,iCAAiC;IACjC,yCAAyC;AAC7C;AACA;IACI,aAAa;AACjB;AACA;IACI,iBAAiB;IACjB,YAAY;IAKZ,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,UAAU;IACV,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,gCAAgC;IAChC,gBAAgB;IAChB,MAAM;IACN,gBAAgB;IAChB,UAAU;AACd;AACA;IACI,eAAe;AACnB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,QAAQ;IACR,QAAQ;IACR,YAAY;AAChB;AACA;IACI,sFAAsF;IACtF,WAAW;IACX,YAAY;AAChB;AACA;IACI,iBAAiB;IACjB,UAAU;IACV,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,qBAAqB;IACrB,UAAU;IACV,gBAAgB;IAKhB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,0HAA0H;AAC9H;AACA;IACI,iBAAiB;IACjB,YAAY;IACZ,UAAU;AACd;AACA;IACI,WAAW;IACX,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IAKnB,aAAa;AACjB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,YAAY;IACZ,OAAO;IACP,QAAQ;IACR,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IAKZ,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,8BAA8B;IAC9B,gCAAgC;IAChC,yBAAyB;IACzB,iCAAiC;IACjC,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;IAC5B,SAAS;IACT,QAAQ;AACZ;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,UAAU;AACd;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,8BAA8B;IAC9B,gCAAgC;AACpC;AACA;IACI,mBAAmB;AACvB;AACA;IACI,YAAY;AAChB;AACA;IACI,yEAAyE;IACzE,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,oFAAoF;AACxF;AACA;IACI,gBAAgB;AACpB;AACA;IACI,uBAAuB;IAKvB,aAAa;IACb,sBAAsB;IAKtB,SAAO;AACX;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;AACA;IAKI,SAAO;AACX;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,YAAY;IAKZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,eAAe;IACf,gBAAgB;IAKhB,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,WAAW;AACf;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;AACA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,aAAa;IACb,qBAAqB;IACrB,SAAS;AACb;AACA;IACI,qBAAqB;AACzB;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,8BAA8B;IAK9B,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;IACb,sCAAsC;IACtC,mCAAmC;IACnC,kCAAkC;IAClC,iCAAiC;AACrC;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;IAKhB,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,sIAAsI;IACtI,kBAAkB;AACtB;AACA;IAKI,aAAa;IACb,uBAAuB;IACvB,eAAe;AACnB;AACA;IAKI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAKhB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IAKI,SAAO;IACP,SAAS;AACb;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,qBAAqB;IACrB,WAAW;AACf;AACA;IACI,eAAe;IACf,gBAAgB;IAKhB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,YAAY;AAChB;AACA;IACI,UAAU;IACV,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,aAAa;AACjB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,sBAAsB;IAKtB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;AAChB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,sFAAsF;IACtF,kCAAkC;IAClC,0CAA0C;IAC1C,uCAAuC;IACvC,sCAAsC;IACtC,qCAAqC;IACrC,UAAU;IAKV,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,iBAAiB;AACrB;AACA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;IACnC,qBAAqB;IACrB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,cAAc;AAClB;AACA;IACI,YAAY;IACZ,eAAe;IACf,oCAA4B;YAA5B,4BAA4B;IAC5B,gBAAgB;IAChB,WAAW;IACX,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;IACnC,qBAAqB;IACrB,SAAS;AACb;AACA;IACI,cAAc;AAClB;AACA;IACI,YAAY;AAChB;AACA;IACI,sFAAsF;IACtF,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,YAAY;IACZ,UAAU;AACd;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,OAAO;IACP,YAAY;AAChB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,UAAU;IACV,YAAY;AAChB;AACA;IACI,WAAW;IACX,eAAe;AACnB;AACA;IACI,SAAS;IACT,kBAAkB,EAAE,sBAAsB;IAC1C,YAAY;AAChB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAKlB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,SAAO;IACP,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,UAAU;AACd;AACA;IACI,2CAA2C;AAC/C;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAKhB,aAAa;IACb,mBAAmB;IACnB,4BAA4B;IAC5B,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,SAAS;IACT,8BAA8B;AAClC;AACA;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,YAAY;IACZ,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,wBAAwB;IACxB,gCAAgC;IAChC,6BAA6B;IAC7B,4BAA4B;IAC5B,2BAA2B;AAC/B;AACA;IACI,mBAAmB;AACvB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,2BAA2B;IAC3B,6BAA6B;IAC7B,yBAAyB;IACzB,OAAO;IACP,QAAQ;IACR,iCAAiC;IACjC,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;AAChC;AACA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,qBAAqB;IACrB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;IACnC,SAAS;IACT,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,QAAQ;IACR,iCAAiC;IACjC,oCAAoC;IACpC,8BAA8B;IAC9B,SAAS;AACb;AACA;IACI,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,8BAA8B;AAClC;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;AACnB;AACA;;IAEI,kBAAkB;AACtB;AACA;;IAEI,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,kCAAkC;IAClC,WAAW;IACX,OAAO;AACX;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,kCAAkC;IAClC,WAAW;IACX,QAAQ;AACZ;AACA;IACI,SAAS;IACT,UAAU;AACd;AACA;IACI,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAKlB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,8BAA8B;IAC9B,kBAAkB;IAClB,eAAe;IACf,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;IACnC,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,YAAY;IACZ,gIAAgI;IAChI,4FAA4F;IAC5F,oGAAoG;AACxG;AACA;IACI,aAAa;IACb,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;AACf;AACA;IACI,+BAA+B;IAC/B,uCAAuC;AAC3C;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,mCAAmC;IACnC,kCAAkC;IAClC,iCAAiC;IACjC,QAAQ;IACR,YAAY;IACZ,QAAQ;IACR,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;IACnC,UAAU;AACd;AACA;IACI,SAAS;IACT,6BAA6B;IAC7B,UAAU;AACd;AACA;IACI,eAAe;IACf,SAAS;AACb;AACA;IACI,aAAa;AACjB;AACA;IACI,eAAe;IACf,0BAA0B;IAC1B,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;AAChB;AACA,0BAA0B,aAAa,CAAC;AACxC;IACI,UAAU;IACV,YAAY;IACZ,iBAAiB;AACrB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;AACA;IACI,gBAAgB;IAChB,UAAU;IACV,YAAY;AAChB;AACA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IAKX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,sFAAsF;IACtF,iCAAiC;IACjC,UAAU;IACV,kBAAkB;IAClB,iBAAiB;IACjB,yCAAyC;IACzC,sCAAsC;IACtC,qCAAqC;IACrC,oCAAoC;AACxC;AACA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;AACb;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,UAAU;IACV,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAKlB,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,OAAO;IACP,SAAS;IACT,aAAa;AACjB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,2BAA2B;IAC3B,6BAA6B;IAC7B,WAAW;IACX,WAAW;IACX,SAAS;IACT,QAAQ;IACR,yBAAyB;IACzB,iCAAiC;IACjC,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;AAChC;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ;cACU;IACV,OAAO;IACP,MAAM;IACN,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,UAAU;IACV,mBAAmB;IACnB,UAAU;IACV,SAAS;IACT,YAAY;AAChB;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,eAAe;IACf,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;AACtB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,SAAS;IACT,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,WAAW;AACf;;AAEA;IACI;EACF;IACE;QACI,mBAAmB;QACnB,YAAY;IAChB;IACA;QACI,iBAAiB;QACjB,eAAe;IACnB;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,YAAY;IAChB;IACA;QACI,WAAW;IACf;IACA;QAKI,aAAa;QACb,8BAA8B;IAClC;IACA;QACI,UAAU;QAKV,aAAa;QACb,sBAAsB;IAC1B;IACA;QAKI,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,mBAAmB;QACnB,kBAAkB;QAClB,eAAe;QACf,8BAA8B;IAClC;IACA;QACI,UAAU;QACV,SAAS;IACb;AACJ;;AAEA;IACI;QACI,WAAW;QACX,kBAAkB;QAClB,SAAS;QACT,kCAAkC;QAClC,WAAW;QACX,UAAU;IACd;IACA;QACI,WAAW;QACX,kBAAkB;QAClB,SAAS;QACT,kCAAkC;QAClC,WAAW;QACX,WAAW;IACf;IACA;QACI,WAAW;QACX,kBAAkB;QAClB,SAAS;QACT,kCAAkC;QAClC,WAAW;QACX,UAAU;IACd;IACA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,WAAW;IACf;IACA;QACI,eAAe;QACf,aAAa;IACjB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,WAAW;QACX,mCAAmC;QACnC,gCAAgC;QAChC,0BAA0B;QAC1B,eAAe;QACf,eAAe;QACf,SAAS;QACT,OAAO;QACP,QAAQ;QACR,UAAU;QACV,wBAAwB;IAC5B;IACA;QACI,aAAa;IACjB;IACA;QACI,UAAU;QACV,gBAAgB;IACpB;IACA;QACI,sFAAsF;IAC1F;IACA;QACI,iGAAiG;IACrG;IACA;QACI,WAAW;QACX,mBAAmB;QACnB,8BAA8B;QAC9B,gBAAgB;IACpB;IACA;QACI,WAAW;QACX,aAAa;IACjB;IACA;QACI,kBAAkB;QAClB,QAAQ;QACR,SAAS;QACT,YAAY;IAChB;IACA;QAKI,SAAO;IACX;IACA;QACI,cAAc;QACd,YAAY;QACZ,WAAW;IACf;IACA;QACI,YAAY;IAChB;IACA;QACI,UAAU;QACV,YAAY;IAChB;IACA;QACI,wBAAwB;QACxB,sBAAsB;QACtB,mBAAmB;QACnB,mBAAmB;QACnB,kBAAkB;QAClB,eAAe;QACf,8BAA8B;QAC9B,SAAS;QACT,eAAe;QACf,OAAO;QACP,QAAQ;QACR,SAAS;QACT,UAAU;QACV,sFAAsF;QACtF,mCAAmC;QACnC,gCAAgC;QAChC,0BAA0B;QAC1B,eAAe;QACf,gCAAgC;QAChC,wCAAwC;QACxC,qCAAqC;QACrC,oCAAoC;QACpC,mCAAmC;QACnC,gBAAgB;IACpB;IACA;QACI,iGAAiG;IACrG;IACA;;QAEI,WAAW;QACX,kBAAkB;QAClB,OAAO;QACP,QAAQ;QACR,WAAW;QACX,WAAW;QACX,mBAAmB;QACnB,YAAY;QACZ,SAAS;IACb;IACA;QACI,aAAa;IACjB;IACA;QACI,iBAAiB;QAKjB,SAAO;IACX;IACA;QACI,oBAAoB;IACxB;IACA;QACI,4BAA4B;QAC5B,gBAAgB;QAChB,eAAe;IACnB;IACA;QACI,uBAAuB;QAKvB,aAAa;QACb,sBAAsB;QACtB,YAAY;IAChB;IACA;QAKI,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;QACnB,UAAU;QACV,YAAY;IAChB;IACA;QACI,qBAAqB;QACrB,eAAe;IACnB;IACA;QACI,uBAAuB;QACvB,gBAAgB;QAChB,UAAU;IACd;IACA;QACI,eAAe;QACf,gBAAgB;QAChB,kBAAkB;IACtB;IACA;QACI,uBAAuB;QACvB,mBAAmB;QACnB,cAAc;QACd,qBAAqB;QACrB,iBAAiB;QACjB,gCAAgC;QAChC,qBAAqB;QACrB,mBAAmB;QACnB,gBAAgB;QAChB,yBAAyB;QACzB,wCAAwC;QACxC,qCAAqC;QACrC,oCAAoC;QACpC,mCAAmC;QACnC,2BAA2B;QAC3B,wBAAwB;QACxB,uBAAuB;QACvB,sBAAsB;QACtB,qBAAqB;QACrB,gBAAgB;IACpB;IACA;QACI,gCAAgC;IACpC;IACA;QACI,YAAY;IAChB;IACA;QACI,mBAAmB;QACnB,WAAW;IACf;IACA;QACI,mBAAmB;IACvB;IACA;QACI,SAAS;QACT,gBAAgB;IACpB;IACA;QACI,eAAe;QACf,eAAe;QACf,mBAAmB;QACnB,iBAAiB;IACrB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,kBAAkB;QAClB,OAAO;QACP,QAAQ;QACR,MAAM;QACN,SAAS;QACT,UAAU;IACd;IACA;;QAEI,eAAe;IACnB;IACA;;QAEI,YAAY;IAChB;IACA;;QAEI,cAAc;IAClB;IACA;;QAEI,eAAe;IACnB;IACA;QACI,YAAY;IAChB;IACA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,oBAAoB;QACpB,gBAAgB;QAChB,gBAAgB;QAChB,gBAAgB;QAChB,6BAA6B;QAC7B,YAAY;QACZ,WAAW;IACf;IACA;;QAEI,WAAW;QACX,QAAQ;QACR,SAAS;QACT,gBAAgB;QAChB,gBAAgB;QAChB,UAAU;IACd;IACA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,WAAW;QACX,SAAS;QACT,WAAW;QACX,gBAAgB;QAChB,UAAU;QACV,kBAAkB;QAClB,kCAAkC;IACtC;IACA;QACI,sBAAsB;QACtB,YAAY;IAChB;IACA;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,4BAA4B;QAC5B,0BAA0B;IAC9B;IACA;QACI,WAAW;QACX,QAAQ;IACZ;IACA;;QAEI,mBAAmB;IACvB;IACA;;QAEI,WAAW;QACX,aAAa;IACjB;IACA;;QAEI,yBAAyB;IAC7B;IACA;QACI,2BAA2B;IAC/B;IACA;QACI,eAAe;QACf,gBAAgB;IACpB;IACA;QAKI,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,mBAAmB;QACnB,kBAAkB;QAClB,eAAe;QACf,8BAA8B;IAClC;IACA;QACI,WAAW;QACX,gBAAgB;QAChB,mBAAmB;QACnB,kBAAkB;QAClB,UAAU;IACd;IACA;QACI,UAAU;QACV,gBAAgB;QAKhB,aAAa;QACb,sBAAsB;IAC1B;IACA;QACI,eAAe;QACf,gBAAgB;IACpB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,eAAe;QACf,OAAO;QACP,QAAQ;QACR,SAAS;QACT,SAAS;QACT,YAAY;QACZ,8BAA8B;QAC9B,UAAU;QACV,gCAAgC;QAChC,cAAc;QACd,wCAAwC;QACxC,qCAAqC;QACrC,oCAAoC;QACpC,mCAAmC;IACvC;IACA;QACI,MAAM;IACV;IACA;QACI,kBAAkB;QAClB,QAAQ;QACR,SAAS;QACT,YAAY;IAChB;IACA;QACI,UAAU;IACd;IACA;QACI,SAAS;IACb;IACA;QACI,UAAU;IACd;IACA;QACI,YAAY;QACZ,SAAS;IACb;IACA;QACI,UAAU;IACd;IACA;QACI,oBAAoB;IACxB;IACA;QACI,gBAAgB;QAChB,WAAW;QACX,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;IACA;QACI,aAAa;IACjB;IACA;QACI,aAAa;IACjB;IACA;QACI,gBAAgB;QAChB,kBAAkB;IACtB;IACA;QACI,YAAY;IAChB;IACA;QACI,YAAY;IAChB;IACA;QACI,cAAc;IAClB;IACA;QACI,oBAAoB;IACxB;IACA;QACI,4BAA4B;IAChC;IACA;QACI,eAAe;QACf,cAAc;QACd,aAAa;IACjB;IACA;QACI,aAAa;QACb,eAAe;QACf,uBAAuB;IAC3B;IACA;QACI,gBAAgB;QAChB,YAAY;QACZ,gBAAgB;QAChB,uBAAuB;QACvB,mBAAmB;QACnB,qBAAqB;QACrB,mBAAmB;IACvB;IACA;QACI,eAAe;IACnB;IACA;QACI,YAAY;IAChB;IACA;QACI,YAAY;IAChB;IACA;QACI,YAAY;QACZ,WAAW;IACf;IACA;QACI,QAAQ;QACR,WAAW;IACf;IACA;QACI,WAAW;QACX,gBAAgB;IACpB;IACA;QACI,WAAW;QACX,gBAAgB;IACpB;IACA;QACI,cAAc;IAClB;IACA;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,MAAM;QACN,SAAS;IACb;IACA;QAKI,SAAO;IACX;IACA;QACI,SAAS;IACb;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,mBAAmB;QACnB,qBAAqB;IACzB;IACA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,WAAW;QACX,mBAAmB;IACvB;IACA;QACI,WAAW;QACX,kBAAkB;QAClB,SAAS;QACT,kCAAkC;QAClC,WAAW;QACX,UAAU;IACd;IACA;QACI,WAAW;QACX,kBAAkB;QAClB,SAAS;QACT,kCAAkC;QAClC,WAAW;QACX,WAAW;IACf;IACA;QACI,WAAW;QACX,kBAAkB;QAClB,SAAS;QACT,kCAAkC;QAClC,WAAW;QACX,UAAU;IACd;IACA;QACI,mBAAmB;IACvB;IACA;QACI,SAAS;QACT,YAAY;QACZ,YAAY;QACZ,SAAS;IACb;IACA;QACI,UAAU;QACV,YAAY;QACZ,QAAQ;IACZ;IACA;QACI,WAAW;QACX,UAAU;IACd;IACA;;;QAGI,YAAY;IAChB;IACA;;QAEI,oBAAoB;IACxB;IACA;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;IACA;QACI,aAAa;IACjB;IACA;QACI,cAAc;IAClB;IACA;QACI,uBAAuB;QACvB,mBAAmB;IACvB;IACA;QACI,UAAU;IACd;IACA;QACI,oBAAoB;IACxB;IACA;QACI,eAAe;QACf,kBAAkB;QAClB,QAAQ;QACR,YAAY;IAChB;IACA;QACI,YAAY;QACZ,YAAY;IAChB;IACA;QACI,WAAW;QACX,gBAAgB;IACpB;IACA;QACI,WAAW;QACX,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,eAAe;IACnB;AACJ;AACA;IAKI,aAAa;IACb,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,cAAc;AAClB;AACA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,yBAAyB;IACzB,oBAAoB;AACxB;AACA;IACI,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,cAAc;IACd,mBAAmB;IACnB,qBAAqB;IAKrB,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,cAAc;AAClB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,aAAa;AACjB;AACA;IACI,6FAA6F;IAC7F,qGAAqG;AACzG;AACA;IACI,UAAU;IACV,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,YAAY;IACZ,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;IACnC;;iCAE6B;AACjC;AACA;IACI,UAAU;AACd;AACA;IACI,SAAS;AACb;AACA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,SAAS;IACT,SAAS;IACT,YAAY;IACZ,YAAY;AAChB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,SAAS;IACT,UAAU;IACV,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI;QACI,cAAc;IAClB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,YAAY;IAChB;AACJ;AACA;IACI,eAAe;AACnB;AACA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;AACA;IAKI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IAKnB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,cAAc;IACd,oBAAoB;IACpB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB,EAAE,mBAAmB;AAC1C;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,8HAA8H;IAC9H,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;AACjB;AACA;IACI,kBAAkB;AACtB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,UAAU;IACV,kBAAkB;IAKlB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;AACA;IACI,mBAAmB;IAKnB,SAAO;IAKP,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;IACnC,kBAAkB;AACtB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,YAAY;IACZ,eAAe;IACf,UAAU;AACd;AACA;IAKI,SAAO;IACP,mBAAmB;IAKnB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,MAAM;IACN,YAAY;IAKZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;AACA;IACI,aAAa;AACjB;AACA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,YAAY;IACZ,aAAa;IAKb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mCAAmC;IACnC,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAKhB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,YAAY;IAKZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,mBAAmB;IACnB,wBAAwB;AAC5B;AACA;IACI,eAAe;IACf,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,8HAA8H;AAClI;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI;QACI,sBAAsB;IAC1B;IACA;QACI,aAAa;IACjB;IACA;QACI,aAAa;IACjB;IACA;QACI,WAAW;IACf;IACA;QACI,OAAO;QACP,QAAQ;IACZ;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;IACA;QACI,aAAa;IACjB;IACA;QACI,aAAa;IACjB;IACA;QACI,WAAW;IACf;IACA;QACI,OAAO;QACP,QAAQ;IACZ;IACA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;AACb;AACA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,WAAW;IACX,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;AACvB;AACA;IACI,sFAAsF;IACtF,kCAAkC;IAClC,UAAU;IAKV,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,iBAAiB;IACjB,0CAA0C;IAC1C,uCAAuC;IACvC,sCAAsC;IACtC,qCAAqC;AACzC;AACA;IACI,kBAAkB;IAKlB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,aAAa;AACjB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,UAAU;IACV,yBAAiB;YAAjB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IAKnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,0BAA0B;IAC1B,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,iBAAiB;IACjB,0BAA0B;IAC1B,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,6BAA6B;AACjC;AACA;IACI,iCAAiC;AACrC;AACA;IACI,mBAAmB;AACvB;AACA;AACA;AACA;IACI,gCAAgC;IAChC,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,yBAAyB;IACzB,gCAAgC;AACpC;AACA;IACI,4BAA4B;IAC5B,oCAAoC;AACxC;AACA;IACI,gCAAgC;IAChC,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;;IAEI,sBAAsB;AAC1B;AACA;IACI,yDAAiP;AACrP;AACA;;IAEI,WAAW;AACf;AACA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IAKtB,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,iCAAiC;IACjC,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;IACX,UAAU;IACV,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,uBAAuB;IACvB,gBAAgB;AACpB;AACA;IACI,UAAU;IACV,UAAU;IACV,SAAS;AACb;AACA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,oBAAoB;AACxB;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,gBAAgB;AACpB;AACA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,cAAc;AAClB;AACA;IACI,mBAAmB;AACvB;AACA;;IAEI,UAAU;IACV,SAAS;IACT,UAAU;AACd;AACA;IACI,YAAY;AAChB;AACA;IACI,qCAAqC;AACzC;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,YAAY;IACZ,6BAA6B;AACjC;AACA;;;IAGI,mBAAmB;IACnB,kBAAkB;IAClB,iCAAiC;AACrC;AACA;IACI,+BAA+B;IAC/B,WAAW;AACf;AACA;IACI,aAAa;AACjB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,UAAU;IACV,YAAY;IACZ,eAAe;AACnB;AACA;IACI,aAAa;IACb,YAAY;IACZ,qBAAqB;IACrB,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,WAAW;IACX,WAAW;IACX,8BAA8B;IAC9B,gCAAgC;IAChC,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,iCAAiC;IACjC,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;AAChC;AACA;IACI,eAAe;AACnB;AACA;IAKI,gCAAgC;AACpC;AACA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;IACX,qIAAqI;IACrI,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,UAAU;AACd;AACA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;IACX,oIAAoI;IACpI,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,UAAU;AACd;AACA,kOAAkO;AAClO;;;IAGI,yBAAyB;IAKzB,gCAAgC;IAChC,qBAAqB;AACzB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,8BAA8B;IAC9B,gCAAgC;IAChC,WAAW;AACf;AACA;IACI,6BAA6B;AACjC;AACA;IACI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,+BAA+B;IAC/B,eAAe;IACf,UAAU;IACV,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI;cACU;AACd;AACA;IACI,gBAAgB;AACpB;AACA;;IAEI;cACU;AACd;AACA;;IAEI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,qBAAqB;IACrB,UAAU;AACd;AACA;IACI,WAAW;IACX,SAAS;IACT,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,YAAY;IACZ,wBAAwB;IAKxB,gCAAgC;AACpC;AACA;IACI,WAAW;IAKX,gCAAgC;AACpC;AACA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;IAC3B,wBAAwB;IACxB,qCAAqC;IAGrC,gBAAgB;IAChB,iCAAiC;IACjC,mBAAmB;IACnB;oCACgC;IAChC;oCACgC;IAChC;oCACgC;IAChC;oCACgC;IAChC;oCACgC;AACpC;AACA;IACI,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,yDAA+O;AACnP;AACA;IACI,mBAAmB;AACvB;AACA;;IAEI,mBAAmB;IACnB,YAAY;AAChB;AACA;IACI,cAAc;AAClB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,OAAO;IACP,QAAQ;AACZ;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,YAAY;AAChB;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,aAAa;AACjB;AACA;IACI,eAAe;IACf,WAAW;IACX,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,aAAa;AACjB;AACA;IACI,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,mBAAmB;AACvB;AACA;IACI,UAAU;AACd;AACA;IACI,6BAA6B;AACjC;AACA;IACI,aAAa;AACjB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,OAAO;IACP,QAAQ;IACR,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,eAAe;AACnB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,+BAA+B;IAC/B,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;IAKT,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,uBAAuB;AAC3B;AACA;IACI,mBAAmB;IACnB,kCAAkC;IAClC,mBAAmB;IACnB,WAAW;IAKX,aAAa;IACb,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAKhB,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;AACA;IACI,sBAAsB;IACtB,eAAe;AACnB;AACA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;AACA;AACA;AACA;AACA;AACA;IACI,yBAAyB;IACzB,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;IACR,YAAY;AAChB;AACA;IACI,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,eAAe;AACnB;AACA;IAKI,aAAa;AACjB;AACA;IACI,SAAO;AACX;AACA;IACI,WAAW;IACX,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,+BAA+B;IAC/B,mBAAmB;IACnB,+BAA+B;AACnC;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,yBAAyB;IACzB,iCAAiC;AACrC;AACA;IACI,eAAe;IACf,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,YAAY;IAKZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;AACtB;AACA;IACI,YAAY;AAChB;AACA;IACI,wCAAwC;IACxC,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;AACA;;;IAGI,uBAAuB;IACvB,oBAAoB;IACpB,SAAO;AACX;AACA;;;IAGI,2BAA2B;IAC3B,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,UAAU;AACd;AACA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;IAChB,qBAAqB;AACzB;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,gBAAgB;AACpB;AACA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,oBAAoB;AACxB;AACA;IACI,gBAAgB;IAChB,UAAU;IACV,QAAQ;IACR,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,WAAW;AACf;AACA,6BAA6B;;AAE7B,2BAA2B;AAC3B;IACI,sBAAsB;IACtB,4CAAoC;IACpC;;8DAEyD;IACzD,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;;IAEI,iCAAiC;IACjC,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,oBAAoB;IACpB,cAAc;IACd,mCAAmC;IACnC,kCAAkC;AACtC;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;AACpB;AACA;IAKI,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,gBAAgB;AACpB;AACA;IAKI,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;AACjB;AACA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,UAAU;IACV,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,UAAU;IAKV,aAAa;IACb,WAAW;IACX,UAAU;AACd;AACA;IACI,kBAAkB;AACtB;AACA;IAKI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,cAAc;AAClB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,SAAS;IACT,YAAY;IACZ,cAAc;IACd,eAAe;AACnB;AACA;IACI,cAAc;AAClB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,eAAe;AACnB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,WAAW;IACX,YAAY;IAKZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,YAAY;AAChB;AACA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;IACX,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;;IAEI,cAAc;AAClB;AACA;IACI,eAAe;IACf,cAAc;AAClB;AACA;IACI,eAAe;IACf,sBAAsB;AAC1B;AACA;IACI,SAAS;IACT,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,UAAU;IACV,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;;IAEI,gBAAgB;AACpB;AACA;;IAEI,aAAa;AACjB;AACA;IACI,eAAe;IACf,UAAU;IACV,WAAW;IACX,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,QAAQ;AACZ;AACA;IACI,cAAc;AAClB;AACA;;IAEI,kBAAkB;AACtB;AACA;;IAEI,gBAAgB;IAChB,gBAAgB;AACpB;AACA;;IAEI,WAAW;AACf;AACA;IACI,mBAAmB;IACnB,iCAAiC;IACjC,yBAAyB;IACzB,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,UAAU;IACV,kBAAkB;IAKlB,gCAAgC;AACpC;AACA;IACI,UAAU;IACV,SAAS;AACb;AACA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,UAAU;AACd;AACA;IACI,oBAAoB;AACxB;AACA;IACI,aAAa;IACb,SAAS;AACb;AACA;IAKI,gCAAgC;AACpC;AACA;IACI,WAAW;IACX,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,cAAc;AAClB;AACA;IACI,kBAAkB;AACtB;AACA;IAKI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;AACA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,eAAe;AACnB;AACA;IACI,WAAW;IACX,qBAAqB;IACrB,cAAc;IACd,eAAe;IACf,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,qBAAqB;AACzB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IAKI,gCAAgC;AACpC;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,mBAAmB;IACnB,qCAAqC;IACrC,+BAA+B;IAC/B,gBAAgB;IAChB,mBAAmB;IACnB,SAAS;IACT,YAAY;IACZ,WAAW;AACf;AACA;IACI,YAAY;AAChB;AACA;IACI,WAAW;IACX,WAAW;IAKX,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,qBAAqB;IACrB,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IAKnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,uBAAuB;IACvB,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;IACR,YAAY;IAKZ,gCAAgC;AACpC;AACA;IACI,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,QAAQ;IACR,gBAAgB;AACpB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;IAKZ,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,YAAY;IACZ,eAAe;IAKf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT,mBAAmB;IACnB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;IACZ,eAAe;IACf,WAAW;IACX,YAAY;IAKZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,eAAe;IACf,SAAS;AACb;AACA;IACI,uBAAuB;IACvB,6BAA6B;IAK7B,aAAa;IACb,8BAA8B;IAC9B,0BAA0B;AAC9B;AACA;IAKI,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,gBAAgB;IAChB,iCAAiC;IACjC,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAKlB,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,UAAU;IACV,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAKlB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,eAAe;IACf,WAAW;IACX,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,WAAW;AACf;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,SAAS;AACb;AACA;;IAEI,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;IACrB,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;;;IAGI,kBAAkB;AACtB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,OAAO;IACP,MAAM;IACN,SAAS;IACT,QAAQ;IACR,mBAAmB;IAKnB,gCAAgC;AACpC;AACA;IACI,WAAW;IAKX,gCAAgC;AACpC;AACA;IACI,WAAW;AACf;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,OAAO;IACP,MAAM;IACN,SAAS;IACT,QAAQ;IACR,mBAAmB;IAKnB,gCAAgC;AACpC;AACA;IACI,WAAW;IAKX,gCAAgC;AACpC;AACA;IACI,cAAc;AAClB;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,SAAS;AACb;AACA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAKhB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,UAAU;IAKV,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,qBAAqB;IACrB,aAAa;AACjB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,qBAAqB;IACrB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,UAAU;IACV,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,qBAAqB;AACzB;AACA;IACI,iBAAiB;AACrB;AACA;IAKI,SAAO;IACP,YAAY;IACZ,6BAA6B;AACjC;AACA;IACI,SAAS;IACT,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,aAAa;AACjB;AACA;IACI,gBAAgB;IAKhB,aAAa;IACb,8BAA8B;IAC9B,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,mBAAmB;IACnB,WAAW;IAKX,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,SAAS;IAKT,gCAAgC;AACpC;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;AAClB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;AACf;AACA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;AACA;IACI,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,4BAA4B;AAChC;AACA;IACI,cAAc;AAClB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,WAAW;IACX,sBAAsB;IACtB,yDAAiP;IACjP,4BAA4B;IAC5B,2BAA2B;IAC3B,0BAA0B;IAC1B,WAAW;IACX,YAAY;AAChB;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;AACb;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,mBAAmB,EAAE,sBAAsB;AAC/C;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,qBAAqB;AACzB;AACA;IACI,oCAAoC;IACpC,gCAAgC;IAChC,gCAAgC;IAChC,iCAAiC;AACrC;AACA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,qBAAqB;AACzB;AACA;IACI,oCAAoC;IACpC,gCAAgC;IAChC,gCAAgC;IAChC,iCAAiC;AACrC;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,oCAAoC;IACpC,gCAAgC;IAChC,gCAAgC;IAChC,iCAAiC;AACrC;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAKhB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;IAKf,aAAa;IACb,mBAAmB;IACnB,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;;IAEI,kBAAkB;AACtB;AACA;;IAEI,eAAe;AACnB;AACA;;IAEI,UAAU;IACV,SAAS;IACT,iBAAiB;IACjB,gBAAgB;AACpB;AACA;;IAMI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;AACtB;AACA;;IAEI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAKlB,aAAa;IACb,gBAAgB;IAChB,uBAAuB;AAC3B;AACA;;IAMI,aAAa;IACb,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;AACA;;IAEI,WAAW;IACX,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,iCAAiC;IACjC,qCAAqC;IACrC,iDAAiD;AACrD;AACA;;IAEI,qBAAqB;IACrB,6BAA6B;IAC7B,0BAA0B;IAC1B,yBAAyB;IACzB,wBAAwB;AAC5B;AACA;;IAEI,WAAW;IACX,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,iCAAiC;IACjC,qCAAqC;IACrC,iDAAiD;AACrD;AACA;;IAEI,WAAW;IACX,mBAAmB;AACvB;AACA;;IAEI,wBAAwB;IACxB,cAAc;IACd,mBAAmB;AACvB;AACA;;IAEI,wBAAwB;IACxB,cAAc;IACd,mBAAmB;AACvB;AACA;;IAEI,wBAAwB;IACxB,cAAc;IACd,mBAAmB;AACvB;AACA;;IAEI,yBAAyB;IACzB,cAAc;IACd,mBAAmB;AACvB;AACA;;IAEI,yBAAyB;IACzB,cAAc;IACd,mBAAmB;AACvB;AACA;;IAEI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;AACZ;AACA;IACI;wBACoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;AACA;IACI,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;AAC7B;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,SAAS;IACT,UAAU;IACV,gBAAgB;AACpB;AACA;IACI,8BAA8B;AAClC;AACA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,qBAAqB;IACrB,mBAAmB;AACvB;AACA;IACI,SAAS;AACb;AACA;IACI,gBAAgB;AACpB;AACA;;IAEI,kBAAkB;AACtB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,8BAA8B;AAClC;AACA;IACI,iBAAiB;IACjB,UAAU;AACd;AACA;IACI,UAAU;IACV,YAAY;AAChB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,YAAY;IACZ,YAAY;IAKZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IAKI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;AACf;AACA;AACA;AACA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,YAAY;AAChB;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,SAAS;AACb;AACA;IACI,yBAAyB;AAC7B;AACA;;IAEI,kBAAkB;IAClB,sBAAsB;AAC1B;AACA;;IAEI,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,YAAY;AAChB;AACA;;IAEI,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,8BAA8B;IAC9B,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,oBAAoB;IACpB,qBAAqB;IACrB,WAAW;IAKX,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,sCAAsC;IACtC,mCAAmC;IACnC,kCAAkC;IAClC,iCAAiC;AACrC;AACA;IACI,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,SAAS;IAKT,gCAAgC;AACpC;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;IACX,mBAAmB;IACnB,yBAAyB;AAC7B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,oBAAoB;IACpB,qBAAqB;IACrB,cAAc;IAKd,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,SAAS;IAKT,gCAAgC;AACpC;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;IACX,mBAAmB;IACnB,yBAAyB;AAC7B;AACA;;IAEI,cAAc;AAClB;AACA;IACI,WAAW;AACf;AACA;IACI,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,oBAAoB;AACxB;AACA;IACI,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,sBAAsB;IACtB,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;IACX,gBAAgB;IAKhB,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,SAAS;IAKT,gCAAgC;AACpC;AACA;IACI,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAKhB,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,SAAS;IAKT,gCAAgC;AACpC;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;;;IAGI,kBAAkB;AACtB;AACA;IACI,UAAU;IACV,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IAKI,aAAa;IACb,8BAA8B;IAC9B,yBAAyB;IACzB,kBAAkB;AACtB;AACA;IACI,gCAAgC;AACpC;AACA;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ;qBACiB;IACjB,kBAAkB;IAClB,OAAO;IACP,SAAS;AACb;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,SAAS;IAKT,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,WAAW;IAKX,aAAa;IACb,aAAa;IACb,qBAAqB;IACrB,cAAc;AAClB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,mBAAmB;AACvB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,8BAA8B;IAC9B,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,WAAW;IAKX,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IAKjB,SAAO;IAKP,aAAa;IACb,uBAAuB;IACvB,2BAA2B;AAC/B;AACA;IACI,kBAAkB;IAKlB,yBAAyB;IACzB,SAAS;IACT,WAAW;IACX,gBAAgB;IAKhB,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;AACvB;AACA;IAKI,aAAa;IACb,8BAA8B;AAClC;AACA;IACI,WAAW;IACX,aAAa;IAKb,aAAa;IACb,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,oBAAoB;AACxB;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,gBAAgB;AACpB;AACA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IAKI,aAAa;IACb,sBAAsB;AAC1B;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,aAAa;IACb,qBAAqB;AACzB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;AACA;IAKI,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAKlB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;AACf;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,6BAA6B;IAC7B,WAAW;IACX,mBAAmB;IAKnB,aAAa;IACb,mBAAmB;AACvB;AACA;IAKI,SAAO;IACP,iBAAiB;AACrB;AACA;IACI,SAAS;AACb;AACA;IACI,kBAAkB;AACtB;AACA;IACI,eAAe;AACnB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,WAAW;IAKX,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,UAAU;IACV,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,4BAA4B;AAChC;AACA;IACI,cAAc;AAClB;AACA;IACI,WAAW;AACf;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,qBAAqB;AACzB;AACA;IACI,mBAAmB;IACnB,iCAAiC;IACjC,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;IACV,aAAa;AACjB;AACA;IACI,0BAA0B;IAC1B,aAAa;AACjB;AACA;IACI,gBAAgB;IAChB,UAAU;AACd;AACA;IACI,mBAAmB;AACvB;AACA;IAKI,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,SAAS;IACT,WAAW;IACX,qBAAqB;IACrB,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,WAAW;IACX,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,aAAa;AACjB;AACA;IACI,QAAQ;AACZ;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,aAAa;AACjB;AACA;IAKI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,WAAW;IACX,mBAAmB;AACvB;AACA;IAKI,gCAAgC;AACpC;AACA;IAKI,0BAA0B;AAC9B;AACA;IACI,SAAS;AACb;AACA;IACI,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,QAAQ;IACR,SAAS;IACT,YAAY;AAChB;AACA;IACI,qCAAqC;AACzC;AACA;IACI,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kCAAkC;IAClC,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,mBAAmB;IACnB,8BAA8B;IAC9B,UAAU;IACV,WAAW;AACf;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IAKf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;AACf;AACA;IACI,gCAAgC;AACpC;AACA;IACI,gCAAgC;AACpC;AACA;IACI,UAAU;IACV,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,gCAAgC;AACpC;AACA;IACI,eAAe;IAKf,aAAa;IACb,8BAA8B;IAC9B,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;AAC3B;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,qBAAqB;AACzB;AACA;;IAEI,WAAW;IACX,kBAAkB;IAClB,8BAA8B;IAC9B,gCAAgC;IAChC,WAAW;IACX,WAAW;IACX,OAAO;IACP,MAAM;IAKN,yBAAyB;AAC7B;AACA;;IAEI,qBAAqB;AACzB;AACA;IACI,QAAQ;AACZ;AACA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,UAAU;AACd;AACA;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;AACjB;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,UAAU;IACV,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,YAAY;IAKZ,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,aAAa;IACb,0BAA0B;IAC1B,kBAAkB;IAClB,YAAY;IACZ,aAAa;AACjB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;AACA;IAKI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,gBAAgB;IAKhB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,gDAAgD;AACpD;AACA;IACI,kBAAkB;AACtB;AACA;IAKI,aAAa;AACjB;AACA;IACI,WAAW;IACX,qBAAqB;IACrB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;AAChB;AACA;IAKI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,sBAAsB;AAC1B;AACA;IACI,4BAA4B;IAC5B,sBAAsB;IACtB,gBAAgB;IAKhB,aAAa;IACb,qBAAqB;IACrB,uBAAuB;IACvB,UAAU;AACd;AACA;IACI,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,SAAS;IACT,QAAQ;IACR,YAAY;AAChB;AACA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,+BAA+B;AACnC;AACA;IAEI,gBAAgB;IAChB,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,YAAY;IAEZ,wBAAwB;AAC5B;AACA;IAEI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,mBAAmB;IACnB,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IACZ,SAAS;IACT,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,SAAS;IACT,mBAAmB;IACnB,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,yBAAyB;IACzB,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,yBAAyB;IACzB,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,yBAAyB;IACzB,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,iBAAiB;AACrB;AACA;IACI,mBAAmB;IACnB,iCAAiC;IACjC,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI;qBACiB;IACjB,WAAW;IACX,qBAAqB;IACrB,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,iBAAiB;IACjB,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,kCAAkC;IAClC,0BAA0B;AAC9B;AACA;IACI,wBAAwB;IACxB,kCAAkC;AACtC;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IAKI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,aAAa;AACjB;AACA;IACI,YAAY;IACZ,qBAAqB;IACrB,eAAe;IAKf,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;IACnC,gBAAgB;AACpB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,OAAO;IACP,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,sCAAsC;IACtC,mCAAmC;IACnC,kCAAkC;IAClC,iCAAiC;AACrC;AACA;IACI,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,WAAW;IACX,YAAY;IACZ,OAAO;IACP,QAAQ;IACR,SAAS;IACT,MAAM;IACN,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,UAAU;IAKV,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,SAAS;IACT,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,qBAAqB;IACrB,6BAA6B;IAC7B,0BAA0B;IAC1B,yBAAyB;IACzB,wBAAwB;AAC5B;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,UAAU;IACV,iBAAiB;IAKjB,gCAAgC;IAChC,iBAAiB;IACjB,sBAAsB;AAC1B;AACA;IACI,kCAAkC;AACtC;AACA;IACI,kBAAkB;AACtB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,YAAY;IACZ,oBAAoB;IACpB,cAAc;IACd,0CAA0C;AAC9C;AACA;IACI,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,oHAAoH;IACpH,qBAAqB;IACrB,4BAA4B;IAC5B,8BAA8B;AAClC;AACA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,cAAc;IACd,iBAAiB;IACjB,qBAAqB;AACzB;AACA;IACI,2CAA2C;IAC3C,mBAAmB;IACnB,oBAAoB;AACxB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,SAAS;IACT,YAAY;IACZ,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,+BAA+B;IAC/B,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;IACnC,cAAc;AAClB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,8HAA8H;IAC9H,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;IACX,qBAAqB;AACzB;AACA;IACI,gBAAgB;IAChB,UAAU;IACV,qBAAqB;AACzB;AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,UAAU;IACV,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,SAAS;IACT,UAAU;AACd;AACA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,2CAA2C;AAC/C;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,8BAA8B;AAClC;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;AACA;IAKI,SAAO;IAKP,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;AACA;IAKI,SAAO;AACX;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;IACX,SAAS;AACb;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;AACzB;AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,+BAA+B;IAC/B,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe;IACf,SAAS;IACT,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,8BAA8B;IAK9B,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IAKf,SAAO;IACP,sBAAsB;AAC1B;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;AACA;IAKI,SAAO;AACX;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;AACf;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IAKI,SAAO;IACP,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;AAChC;AACA;;;IAGI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;IACnC,UAAU;AACd;AACA;IACI,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;;;;IAII,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,8BAA8B;IAC9B,UAAU;IAKV,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;AAChB;AACA;;IAEI,qBAAqB;IACrB,6BAA6B;IAC7B,0BAA0B;IAC1B,yBAAyB;IACzB,wBAAwB;AAC5B;AACA;IACI,gBAAgB;IAChB,qBAAqB;AACzB;AACA;;IAEI,0BAA0B;IAC1B,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;;IAEI,eAAe;IACf,cAAc;AAClB;AACA;;IAEI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;AACrB;AACA;;IAEI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,iCAAiC;IACjC,UAAU;IACV,YAAY;IACZ,oBAAoB;IACpB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,aAAa;AACjB;AACA;IACI,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,2BAA2B;IAC3B,iBAAiB;AACrB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,iHAAiH;IACjH,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;AACA;IAKI,SAAO;IAKP,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,mHAAmH;IACnH,+BAA+B;IAC/B,aAAa;AACjB;AACA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,mHAAmH;IACnH,gBAAgB;IAChB,eAAe;IACf,+BAA+B;IAC/B,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,yEAAyE;IACzE,yBAAyB;IACzB,kBAAkB;AACtB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;AACzB;AACA;IACI,UAAU;AACd;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,sBAAsB;IACtB,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;AACA;IAKI,SAAO;IACP,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,2BAA2B;AAC/B;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,SAAS;IACT,iBAAiB;IACjB,YAAY;AAChB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;AACf;AACA;IACI,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,SAAS;IACT,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,UAAU;IACV,MAAM;IACN,UAAU;AACd;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,UAAU;IACV,SAAS;IACT,UAAU;AACd;AACA;IACI,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,yBAAyB;IACzB,mBAAmB;IACnB,UAAU;IACV,MAAM;IACN,UAAU;AACd;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,uBAAuB;IAKvB,SAAO;AACX;AACA;IACI,SAAS;IACT,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,2GAA2G;IAC3G,WAAW;IACX,YAAY;IACZ,qBAAqB;AACzB;AACA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,OAAO;AACX;AACA;IACI,UAAU;AACd;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IAKjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;AACA;IACI,cAAc;AAClB;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,WAAW;AACf;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,WAAW;IACX,kBAAkB;AACtB;AACA;IAKI,SAAO;AACX;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gCAAgC;AACpC;AACA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,0BAA0B;AAC9B;AACA;IACI,qBAAqB;IACrB,cAAc;AAClB;AACA;IACI,mBAAmB;AACvB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;AAChB;AACA;IACI,cAAc;IACd,iBAAiB;AACrB;AACA;IAKI,SAAO;IACP,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;AACpB;AACA;IACI,0BAA0B;IAC1B,cAAc;AAClB;AACA;IACI,qBAAqB;IACrB,cAAc;AAClB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,qBAAqB;IACrB,oBAAoB;IACpB,4BAA4B;AAChC;AACA;IACI,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,SAAS;AACb;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;AACA;IACI,qBAAqB;IACrB,cAAc;IACd,qBAAqB;AACzB;AACA;IACI,cAAc;AAClB;AACA;;IAEI,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,4BAA4B;AAChC;AACA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,qBAAqB;IACrB,WAAW;AACf;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,WAAW;AACf;AACA;IACI,WAAW;AACf;;AAEA;IACI;QACI,eAAe;QACf,MAAM;QACN,YAAY;QACZ,QAAQ;QACR,OAAO;QACP,YAAY;QACZ,WAAW;QACX,8BAA8B;QAC9B,WAAW;QACX,SAAS;QACT,UAAU;QACV,UAAU;QACV,iBAAiB;IACrB;IACA;QACI,YAAY;QACZ,UAAU;QACV,UAAU;QACV,iBAAiB;IACrB;IACA;QACI,UAAU;IACd;IACA;QACI,mBAAmB;QACnB,YAAY;QACZ,gBAAgB;QAChB,8BAA8B;QAC9B,wBAAwB;QACxB,WAAW;QACX,UAAU;QACV,gCAAgC;QAChC,6BAA6B;QAC7B,4BAA4B;QAC5B,2BAA2B;IAC/B;IACA;QACI,aAAa;IACjB;IACA;QACI,iBAAiB;QACjB,cAAc;QACd,kBAAkB;QAClB,UAAU;QACV,UAAU;IACd;IACA;QACI,WAAW;QACX,kBAAkB;QAClB,WAAW;IACf;IACA;QACI,WAAW;QACX,QAAQ;QACR,WAAW;QACX,kBAAkB;QAClB,SAAS;QACT,OAAO;QACP,QAAQ;QACR,mBAAmB;QACnB,YAAY;QAKZ,gCAAgC;IACpC;IACA;;QAEI,WAAW;IACf;IACA;QACI,WAAW;QACX,yBAAyB;QACzB,eAAe;QACf,gBAAgB;QAChB,iBAAiB;IACrB;IACA;QACI,cAAc;IAClB;IACA;QACI,kBAAkB;QAClB,mBAAmB;QACnB,iCAAiC;QACjC,yBAAyB;QACzB,kBAAkB;QAClB,kBAAkB;QAClB,kBAAkB;QAClB,gBAAgB;QAChB,WAAW;IACf;IACA;QACI,yBAAyB;QACzB,WAAW;QACX,UAAU;QACV,UAAU;QAKV,gCAAgC;IACpC;IACA;QACI,SAAS;QACT,UAAU;IACd;IACA;QACI,gBAAgB;QAChB,SAAS;IACb;IACA;QACI,iBAAiB;IACrB;IACA;QACI,YAAY;QACZ,UAAU;IACd;IACA;QACI,kBAAkB;IACtB;IACA;QACI,WAAW;QACX,qBAAqB;QACrB,eAAe;QACf,gBAAgB;QAKhB,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;QACnB,UAAU;QACV,gBAAgB;IACpB;IACA;;QAEI,cAAc;IAClB;IACA;QACI,cAAc;QACd,eAAe;IACnB;IACA;QACI,cAAc;QACd,kBAAkB;QAClB,SAAS;QACT,UAAU;QACV,YAAY;QACZ,UAAU;QACV,WAAW;QACX,gCAAgC;QAChC,UAAU;QACV,mBAAmB;QACnB,iCAAiC;QACjC,yBAAyB;QACzB,kBAAkB;QAClB,kBAAkB;QAClB,wCAAwC;QACxC,qCAAqC;QACrC,oCAAoC;QACpC,mCAAmC;IACvC;IACA;QACI,kBAAkB;IACtB;IACA;QACI,UAAU;QACV,UAAU;IACd;IACA;QACI,iBAAiB;QACjB,cAAc;QACd,WAAW;QACX,qBAAqB;QACrB,eAAe;QACf,gBAAgB;IACpB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,0BAA0B;QAC1B,4BAA4B;QAC5B,WAAW;QACX,YAAY;QAKZ,wBAAwB;QACxB,iBAAiB;IACrB;IACA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,gBAAgB;QAChB,WAAW;IACf;AACJ;;AAEA;IACI;;QAEI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,cAAc;IAClB;IACA;QACI,uBAAuB;QACvB,mBAAmB;QACnB,UAAU;QACV,gBAAgB;IACpB;IACA;QACI,aAAa;IACjB;IACA;QAKI,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;IACvB;IACA;QACI,SAAS;QACT,gBAAgB;QAChB,YAAY;QACZ,kBAAkB;IACtB;IACA;QACI,YAAY;QAKZ,aAAa;QACb,sBAAsB;QACtB,8BAA8B;QAC9B,qBAAqB;QACrB,gBAAgB;QAChB,SAAS;QACT,WAAW;QACX,WAAW;QACX,WAAW;QACX,gBAAgB;QAKhB,gCAAgC;IACpC;IACA;QACI,YAAY;QAKZ,aAAa;QACb,sBAAsB;QACtB,8BAA8B;QAC9B,qBAAqB;QACrB,gBAAgB;QAChB,SAAS;QACT,WAAW;QACX,UAAU;QACV,WAAW;QACX,gBAAgB;QAKhB,gCAAgC;IACpC;IACA;QACI,WAAW;QACX,YAAY;QACZ,8BAA8B;QAC9B,sBAAsB;QAKtB,aAAa;IACjB;IACA;QACI,WAAW;QACX,UAAU;QACV,gBAAgB;QAKhB,gCAAgC;IACpC;IACA;QAKI,mBAAmB;IACvB;IACA;QACI,0CAA0C;QAC1C,+CAA+C;QAC/C,kDAAkD;QAKlD,gCAAgC;QAChC,WAAW;QACX,sBAAsB;IAC1B;IACA;QACI,2CAA2C;QAC3C,gDAAgD;QAChD,mDAAmD;QAKnD,gCAAgC;QAChC,WAAW;QACX,sBAAsB;IAC1B;KACC,2BAA2B,cAAc,CAAC;IAC3C;QACI,oBAAoB;QACpB,iBAAiB;QACjB,WAAW;IACf;IACA;QACI,gBAAgB;QAChB,UAAU;QACV,mBAAmB;IACvB;IACA;QACI,eAAe;IACnB;IACA;QAKI,aAAa;QACb,8BAA8B;QAC9B,WAAW;QACX,mBAAmB;QACnB,eAAe;QACf,gBAAgB;QAChB,yBAAyB;IAC7B;IACA;QACI,aAAa;IACjB;IACA;QACI,UAAU;QACV,gBAAgB;QAChB,eAAe;IACnB;IACA;QACI,WAAW;QACX,yBAAyB;QACzB,eAAe;QACf,WAAW;QACX,gBAAgB;QAChB,qBAAqB;QACrB,cAAc;QACd,YAAY;QACZ,gCAAgC;QAChC,eAAe;IACnB;IACA;QACI,6BAA6B;IACjC;IACA;QACI,mBAAmB;IACvB;IACA;QACI,SAAS;QACT,UAAU;QACV,kBAAkB;QAClB,WAAW;QACX,QAAQ;QACR,0BAA0B;IAC9B;IACA;QACI,sBAAsB;QACtB,mBAAmB;QACnB,mBAAmB;QACnB,4BAA4B;QAC5B,WAAW;IACf;IACA;QACI,YAAY;QACZ,mBAAmB;IACvB;IACA;QACI,kBAAkB;QAClB,aAAa;IACjB;IACA;QACI,gBAAgB;QAChB,UAAU;QACV,mBAAmB;QACnB,mBAAmB;QACnB,YAAY;QACZ,iBAAiB;QACjB,kBAAkB;QAClB,WAAW;IACf;IACA;QACI,gBAAgB;QAChB,mBAAmB;IACvB;IACA;QACI,eAAe;QACf,WAAW;QACX,qBAAqB;QAKrB,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;IACvB;IACA;QACI,eAAe;QACf,cAAc;IAClB;IACA;QACI,WAAW;QACX,cAAc;IAClB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,cAAc;IAClB;IACA;QACI,cAAc;IAClB;IACA;QACI,gBAAgB;QAChB,mBAAmB;IACvB;IACA;QACI,0BAA0B;QAC1B,4BAA4B;QAC5B,UAAU;QACV,WAAW;QAKX,yBAAyB;QACzB,iBAAiB;IACrB;IACA;QACI,WAAW;QACX,gBAAgB;IACpB;IACA;QACI,aAAa;IACjB;IACA;QACI,wBAAwB;QACxB,qBAAqB;IACzB;IACA;QACI,gBAAgB;QAChB,sBAAsB;IAC1B;IACA;QACI,WAAW;QACX,eAAe;QACf,iBAAiB;QACjB,gBAAgB;QAChB,YAAY;QACZ,gBAAgB;QAKhB,aAAa;IACjB;IACA;QACI,qBAAqB;IACzB;IACA;QACI,WAAW;QACX,YAAY;QACZ,qCAAqC;QACrC,gCAAgC;IACpC;IACA;QACI,UAAU;IACd;IACA;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,WAAW;IACf;IACA;QACI,WAAW;IACf;IACA;QACI,WAAW;QACX,mBAAmB;IACvB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,WAAW;IACf;IACA;QACI,eAAe;IACnB;IACA;;QAEI,eAAe;IACnB;IACA;;QAEI,iCAAiC;IACrC;IACA;;QAEI,iCAAiC;IACrC;IACA;;QAEI,eAAe;IACnB;IACA;;QAEI,UAAU;QACV,YAAY;IAChB;IACA;QACI,oBAAoB;IACxB;IACA;QACI,kBAAkB;QAClB,cAAc;QACd,wBAAwB;QACxB,qBAAqB;IACzB;IACA;QACI,aAAa;IACjB;IACA;QACI,gBAAgB;QAChB,kBAAkB;IACtB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,gBAAgB;QAChB,YAAY;IAChB;IACA;QACI,WAAW;QACX,gBAAgB;QAChB,wBAAwB;IAC5B;IACA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,kCAAkC;QAClC,kBAAkB;QAClB,uBAAuB;IAC3B;IACA;QACI,eAAe;QACf,mBAAmB;IACvB;IACA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;IACA;QACI,cAAc;IAClB;IACA;QAKI,aAAa;QACb,sBAAsB;IAC1B;IACA;QACI,eAAe;IACnB;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;IACA;QACI,aAAa;IACjB;IACA;QACI,aAAa;IACjB;IACA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,eAAe;QACf,UAAU;QACV,WAAW;QACX,YAAY;QAKZ,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,qBAAqB;QACrB,cAAc;IAClB;IACA;QACI,kBAAkB;QAClB,WAAW;QACX,SAAS;QACT,WAAW;QAKX,gCAAgC;IACpC;IACA;;QAEI,wBAAwB;IAC5B;IACA;QACI,YAAY;QACZ,yBAAyB;IAC7B;IACA;;QAMI,wBAAwB;IAC5B;IACA;QACI,aAAa;IACjB;IACA;QACI,eAAe;QACf,UAAU;QACV,YAAY;QACZ,gBAAgB;QAChB,SAAS;QACT,QAAQ;QACR,WAAW;QAKX,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,iCAAiC;QACjC,6BAA6B;IACjC;IACA;QACI,eAAe;IACnB;IACA;QACI,gCAAgC;QAChC,SAAS;QACT,wCAAwC;QACxC,qCAAqC;QACrC,oCAAoC;QACpC,mCAAmC;IACvC;IACA;QACI,SAAS;QACT,gCAAgC;QAChC,wCAAwC;QACxC,qCAAqC;QACrC,oCAAoC;QACpC,mCAAmC;IACvC;IACA;QACI,eAAe;QACf,uBAAuB;IAC3B;IACA;QACI,sBAAsB;QACtB,kBAAkB;QAClB,aAAa;QACb,WAAW;IACf;IACA;QACI,gBAAgB;IACpB;IACA;QACI,gBAAgB;QAChB,YAAY;IAChB;IACA;;QAEI,gBAAgB;IACpB;IACA;QACI,cAAc;IAClB;IACA;QACI,kBAAkB;QAClB,iBAAiB;QACjB,WAAW;QACX,0BAA0B;QAC1B,wBAAwB;IAC5B;IACA;QACI,mBAAmB;IACvB;IACA;QACI,iCAAiC;IACrC;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,iCAAiC;IACrC;IACA;QACI,aAAa;QACb,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,iBAAiB;IACrB;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,gBAAgB;IACpB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,yBAAyB;IAC7B;IACA;QAKI,aAAa;QACb,yBAAyB;QACzB,mBAAmB;QACnB,WAAW;QACX,gBAAgB;IACpB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,eAAe;QACf,gCAAgC;QAChC,oBAAoB;QACpB,mBAAmB;IACvB;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,eAAe;IACnB;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,WAAW;IACf;IACA;QACI,eAAe;QACf,OAAO;QACP,SAAS;QACT,QAAQ;QACR,MAAM;QACN,8BAA8B;QAC9B,UAAU;QACV,aAAa;QACb,qBAAqB;IACzB;IACA;QACI,4CAA4C;QAC5C,aAAa;QACb,OAAO;QACP,QAAQ;QACR,SAAS;QACT,WAAW;IACf;IACA;QACI,aAAa;IACjB;IACA;QACI,oBAAoB;QACpB,yBAAyB;IAC7B;IACA;QACI,kBAAkB;QAClB,eAAe;QACf,mBAAmB;IACvB;IACA;QACI,eAAe;QAKf,aAAa;QACb,6BAA6B;IACjC;IACA;QACI,cAAc;IAClB;IACA;QAKI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,kBAAkB;IACtB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,gBAAgB;QAChB,WAAW;IACf;IACA;QACI,OAAO;QACP,QAAQ;QACR,WAAW;QACX,YAAY;QACZ,YAAY;QACZ,sBAAsB;QACtB,kBAAkB;QAClB,gBAAgB;QAKhB,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,eAAe;QACf,UAAU;IACd;IACA;QACI,kBAAkB;IACtB;IACA;QACI,cAAc;IAClB;IACA;;QAEI,eAAe;IACnB;IACA;;QAEI,iCAAiC;IACrC;IACA;QACI,iCAAiC;IACrC;IACA;QACI,eAAe;IACnB;IACA;QACI,UAAU;QACV,YAAY;IAChB;IACA;QACI,eAAe;IACnB;IACA;QACI,uBAAuB;QACvB,cAAc;IAClB;IACA;QACI,UAAU;QACV,oBAAoB;IACxB;IACA;QACI,UAAU;IACd;IACA;QACI,aAAa;IACjB;IACA;QACI,YAAY;QACZ,YAAY;IAChB;IACA;QACI,eAAe;IACnB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,aAAa;IACjB;IACA;QACI,aAAa;IACjB;IACA;QACI,WAAW;IACf;IACA;QACI,QAAQ;QACR,UAAU;IACd;AACJ;;AAEA;IACI;QACI,aAAa;QACb,2BAA2B;IAC/B;IACA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;IACA;QACI,mBAAmB;IACvB;IACA;QACI,sBAAsB;QACtB,mBAAmB;IACvB;IACA;QACI,SAAO;QACP,WAAW;QACX,gBAAgB;QAChB,cAAc;QACd,UAAU;QACV,sBAAsB;QAKtB,aAAa;QACb,mBAAmB;IACvB;IACA;QACI,SAAS;IACb;IACA;QACI,sBAAsB;QACtB,iBAAiB;IACrB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;AACJ;;AAEA;IACI,aAAa;AACjB;AACA;IACI,+DAA+D;IAC/D,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,0BAA0B;IAC1B,oBAAoB;IACpB,iCAAiC;IACjC,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,yBAAyB;IACzB,wBAAwB;IACxB,uBAAuB;AAC3B;AACA;IACI,+DAA+D;IAC/D,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,0BAA0B;IAC1B,oBAAoB;IACpB,iCAAiC;IACjC,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,cAAc;IACd,uBAAuB;IACvB,mBAAmB;AACvB;AACA;;IAEI,gCAAgC;IAChC,WAAW;IACX,0BAA0B;AAC9B;AACA;IACI,YAAY;AAChB;AACA;IACI,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,UAAU;IACV,WAAW;IACX,uBAAuB;IACvB,qBAAqB;IACrB,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,SAAS;IACT,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,8BAA8B;IAC9B,0BAA0B;IAC1B,kCAAkC;IAClC,+BAA+B;IAC/B,8BAA8B;IAC9B,6BAA6B;AACjC;AACA;IACI,WAAW;IACX,UAAU;IACV,WAAW;IACX,uBAAuB;IACvB,qBAAqB;IACrB,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,SAAS;IACT,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,8BAA8B;IAC9B,wBAAwB;IACxB,gCAAgC;IAChC,6BAA6B;IAC7B,4BAA4B;IAC5B,2BAA2B;AAC/B;AACA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,iCAAiC;IACjC,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,aAAa;IACb,eAAe;AACnB;AACA;IACI,0BAA0B;IAC1B,cAAc;IACd,eAAe;AACnB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,cAAc;AAClB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,cAAc;AAClB;AACA;IACI,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,qGAAqG;IACrG,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,qBAAqB;IACrB,mCAAmC;IACnC,kCAAkC;AACtC;AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,iCAAiC;IACjC,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,sIAAsI;IACtI,aAAa;AACjB;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,WAAW;AACf;AACA;IACI,cAAc;AAClB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,cAAc;AAClB;AACA;IACI,iCAAiC;IACjC,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,uBAAuB;IACvB,kBAAkB;AACtB;AACA;IACI,0BAA0B;IAC1B,mDAAmD;IACnD,2DAA2D;IAC3D,kCAAkC;IAClC,+BAA+B;IAC/B,8BAA8B;IAC9B,6BAA6B;AACjC;;AAEA;IACI;QACI,0BAA0B;QAC1B,kCAAkC;QAClC,+BAA+B;QAC/B,8BAA8B;QAC9B,6BAA6B;IACjC;IACA;QACI,4BAA4B;QAC5B,oCAAoC;QACpC,iCAAiC;QACjC,gCAAgC;QAChC,+BAA+B;IACnC;IACA;QACI,0BAA0B;QAC1B,kCAAkC;QAClC,+BAA+B;QAC/B,8BAA8B;QAC9B,6BAA6B;IACjC;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,yBAAyB;IAC7B;IACA;QACI,WAAW;IACf;IACA;QACI,WAAW;QACX,gBAAgB;QAChB,wBAAwB;IAC5B;IACA;;QAMI,aAAa;QACb,WAAW;QACX,2BAA2B;QAC3B,WAAW;QACX,kBAAkB;QAClB,uBAAuB;IAC3B;IACA;QACI,WAAW;QACX,kBAAkB;IACtB;IACA;QACI,WAAW;QACX,gBAAgB;QAChB,yBAAyB;QACzB,0BAA0B;QAC1B,2BAA2B;IAC/B;IACA;QACI,WAAW;IACf;IACA;QACI,UAAU;QACV,YAAY;IAChB;IACA;QACI,UAAU;QACV,YAAY;QACZ,4BAA4B;IAChC;IACA;QACI,WAAW;IACf;IACA;QACI,WAAW;QACX,iCAAiC;IACrC;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;IACA;QACI,SAAS;IACb;IACA;QACI,QAAQ;QACR,cAAc;IAClB;IACA;QACI,QAAQ;QACR,oBAAoB;IACxB;IACA;QACI,QAAQ;IACZ;IACA;QACI,eAAe;IACnB;IACA;QACI,WAAW;IACf;IACA;QACI,gBAAgB;QAChB,eAAe;QACf,mBAAmB;IACvB;IACA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,8BAA8B;IAClC;IACA;QACI,wBAAwB;QACxB,sBAAsB;QACtB,kCAAkC;QAClC,mBAAmB;IACvB;IACA;QACI,WAAW;IACf;IACA;QACI,mBAAmB;QACnB,gBAAgB;IACpB;IACA;;QAEI,kBAAkB;IACtB;IACA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;IACA;QACI,aAAa;IACjB;IACA;QACI,sBAAsB;QACtB,6BAA6B;QAC7B,mBAAmB;IACvB;IACA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;AACA;;;;;;;IAQI,wBAAwB;IAGxB,+BAA+B;IAE/B,sBAAsB;IAEtB,yBAAyB;IAEzB,4BAA4B;AAChC;AACA;;;;;;;IASI,4BAA4B;IAE5B,qBAAqB;AACzB;AACA;;IAGI,qBAAqB;AACzB;;AAEA;IACI;QAEI,mCAAmC;IACvC;IACA;QAEI,oCAAoC;IACxC;IACA;QAEI,kCAAkC;IACtC;IACA;QAEI,mCAAmC;IACvC;IACA;QAEI,kCAAkC;IACtC;AACJ;AACA;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,cAAc;AAClB;AACA;IACI,kBAAkB;AACtB;AACA;;;IAGI,aAAa;AACjB;AACA;IACI,eAAe;AACnB;AACA;IACI,cAAc;AAClB;AACA;IACI,YAAY;IACZ,aAAa;IACb,UAAU;AACd;AACA;IACI,kBAAkB;AACtB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,cAAc;IACd,iBAAiB;IACjB,qBAAqB;AACzB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,qBAAqB;AACzB;AACA;IACI,8BAA8B;IAC9B,mBAAmB;IAKnB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,kDAAkD;AACtD;AACA;IACI,WAAW;AACf;AACA;IACI,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,SAAS;AACb;AACA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,WAAW;AACf;AACA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,yBAAyB;AAC7B;AACA;IACI,WAAW;AACf;AACA;IACI,iBAAiB;AACrB;AACA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;AACA;IACI,uBAAuB;IACvB,iBAAiB;AACrB;AACA;IACI,uBAAuB;IACvB,iBAAiB;AACrB;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,WAAW;AACf;AACA;IACI,eAAe;AACnB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,8BAA8B;AAClC;AACA;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,2BAA2B;IAC3B,qBAAqB;AACzB;AACA;IACI,2BAA2B;IAC3B,UAAU;AACd;AACA;IACI,2BAA2B;IAC3B,UAAU;AACd;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;AACzB;AACA;IACI,6BAA6B;AACjC;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IAKf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;AACb;AACA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;;IAEI,WAAW;AACf;AACA;;;IAGI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,OAAO;IACP,MAAM;IACN,SAAS;IACT,QAAQ;IACR,mBAAmB;IAKnB,gCAAgC;AACpC;AACA;;;IAGI,WAAW;IAKX,gCAAgC;AACpC;AACA;;IAEI,gBAAgB;IAChB,kBAAkB;AACtB;AACA;;;;;IAKI,WAAW;AACf;AACA;;IAEI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,OAAO;IACP,MAAM;IACN,SAAS;IACT,QAAQ;IACR,mBAAmB;IAKnB,gCAAgC;AACpC;AACA;IACI,+BAA+B;IAC/B,uCAAuC;AAC3C;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,OAAO;IACP,MAAM;IACN,SAAS;IACT,QAAQ;IACR,mBAAmB;IAKnB,gCAAgC;IAChC,QAAQ;IACR,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,WAAW;IAKX,gCAAgC;AACpC;AACA;IACI,WAAW;IAKX,gCAAgC;IAChC,YAAY;AAChB;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IAKf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;AACb;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,OAAO;IACP,MAAM;IACN,SAAS;IACT,QAAQ;IACR,mBAAmB;IAKnB,gCAAgC;AACpC;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IAKf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;AACb;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,OAAO;IACP,MAAM;IACN,SAAS;IACT,QAAQ;IACR,mBAAmB;IAKnB,gCAAgC;AACpC;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,+DAA+D;IAC/D,0BAA0B;IAC1B,oBAAoB;IACpB,iCAAiC;AACrC;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,+DAA+D;IAC/D,0BAA0B;IAC1B,oBAAoB;IACpB,iCAAiC;IACjC,4BAA4B;IAC5B,yBAAyB;IACzB,wBAAwB;IACxB,uBAAuB;AAC3B;AACA;;IAEI,gCAAgC;IAChC,0BAA0B;AAC9B;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,+DAA+D;IAC/D,0BAA0B;IAC1B,oBAAoB;IACpB,iCAAiC;IACjC,YAAY;IACZ,iBAAiB;IACjB,WAAW;IACX,qBAAqB;IACrB,eAAe;IAKf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,gCAAgC;IAChC,0BAA0B;IAC1B,WAAW;AACf;AACA;IACI,qBAAqB;IACrB,2BAA2B;IAC3B,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;IACX,uBAAuB;IACvB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,mBAAmB;AACvB;AACA;IACI,2BAA2B;IAC3B,kBAAkB;AACtB;AACA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,UAAU;AACd;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;IACf,mBAAmB;AACvB;AACA;;IAEI,WAAW;IACX,yBAAyB;IACzB,mBAAmB;AACvB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,WAAW;IACX,oBAAoB;AACxB;AACA;IACI,UAAU;IACV,sCAAsC;IACtC,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,UAAU;IACV,sCAAsC;AAC1C;AACA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,2BAA2B;IAC3B,0BAA0B;IAC1B,wBAAwB;IACxB,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,gCAAgC;IAChC,gCAAgC;IAChC,6BAA6B;IAC7B,4BAA4B;IAC5B,2BAA2B;IAC3B,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,yBAAyB;IACzB,iCAAiC;IACjC,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;AAChC;AACA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;AACzB;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,gBAAgB;AACpB;AACA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,YAAY,EAAE,wBAAwB;IACtC,yBAAyB;AAC7B;AACA;IACI,eAAe;IACf,2BAA2B;AAC/B;AACA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,sBAAsB;AAC1B;AACA;IAKI,aAAa;AACjB;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,sCAAsC;IACtC,kBAAkB;AACtB;AACA;IACI,6CAA6C;AACjD;AACA;IACI,WAAW;IACX,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,eAAe;IACf,QAAQ;IACR,UAAU;IACV,cAAc;AAClB;AACA;IACI,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,iBAAiB;IACjB,WAAW;IACX,mBAAmB;AACvB;AACA;;IAEI,yBAAyB;IACzB,gCAAgC;AACpC;AACA;IACI,4CAA4C;AAChD;AACA;IACI,yBAAyB;IACzB,4BAA4B;IAC5B,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;AACzB;AACA;IACI,YAAY;AAChB;AACA;;IAEI,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,+BAA+B;IAC/B,OAAO;IACP,MAAM;AACV;AACA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,oBAAoB;AACxB;AACA;;IAEI,oBAAoB;AACxB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;AACA;;IAEI,4BAA4B;AAChC;AACA;IACI,YAAY;AAChB;AACA;IACI,eAAe;AACnB;AACA;IACI,cAAc;IACd,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yDAAyD;IACzD,0BAA0B;IAC1B,oBAAoB;IACpB,iCAAiC;IACjC,4BAA4B;IAC5B,yBAAyB;IACzB,wBAAwB;IACxB,uBAAuB;AAC3B;AACA;IACI,gCAAgC;IAChC,0BAA0B;IAC1B,cAAc;AAClB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;AACjB;AACA;IACI,UAAU;IACV,gBAAgB;IAChB,aAAa;AACjB;AACA;IACI,iDAAiD;IACjD,iBAAiB;IACjB,gBAAgB;AACpB;AACA;;IAEI,yBAAyB;IACzB,YAAY;AAChB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;AAC7B;AACA;IACI,oBAAoB;AACxB;AACA;;IAEI,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;AACzB;AACA;IACI,cAAc;IACd,cAAc;IACd,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,aAAa;AACjB;AACA;IACI,cAAc;IACd,yBAAyB;IACzB,0BAA0B;IAC1B,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,qBAAqB;IACrB,gBAAgB;IAChB,UAAU;IACV,WAAW;IAKX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,sBAAsB;IACtB,0BAA0B;IAC1B,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;AACzB;AACA;IAKI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,0BAA0B;IAC1B,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,iBAAiB;IACjB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,2BAA2B;IAC3B,MAAM;IACN,OAAO;AACX;AACA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,wBAAwB;IACxB,oBAAoB;IACpB,kBAAkB;IAClB,uBAAuB;AAC3B;AACA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;AAChC;AACA;IACI,WAAW;IACX,mBAAmB;AACvB;AACA;;IAEI,WAAW;IAKX,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;;IAEI,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,0BAA0B;AAC9B;AACA;IACI,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,SAAS;AACb;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,YAAY;IAKZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,cAAc;IACd,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAKlB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,WAAW;AACf;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,UAAU;IACV,WAAW;AACf;AACA;IACI,UAAU;IACV,WAAW;AACf;AACA;IACI,iBAAiB;AACrB;AACA;IACI,YAAY;AAChB;AACA;;IAEI,wBAAwB;AAC5B;AACA;IACI,qBAAqB;AACzB;AACA;;;IAGI,uBAAuB;IACvB,wBAAwB;AAC5B;AACA;;IAEI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,0BAA0B;IAC1B,4BAA4B;IAC5B,WAAW;IACX,wBAAwB;IACxB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,YAAY;IACZ,gCAAgC;IAChC,6BAA6B;IAC7B,4BAA4B;IAC5B,2BAA2B;AAC/B;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,0BAA0B;IAC1B,4BAA4B;IAC5B,WAAW;IACX,0BAA0B;IAC1B,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,YAAY;IACZ,kCAAkC;IAClC,+BAA+B;IAC/B,8BAA8B;IAC9B,6BAA6B;AACjC;AACA;IACI,qBAAqB;AACzB;AACA;IACI,sBAAsB;IACtB,wCAAwC;IACxC,6BAA6B;IAC7B,0BAA0B;IAC1B,6EAA6E;AACjF;AACA;;;IAGI,mBAAmB;AACvB;AACA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,SAAS;IACT,eAAe;AACnB;AACA;;IAEI,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,4BAA4B;IAC5B,mBAAmB;AACvB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,yBAAyB;IACzB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,OAAO;IACP,QAAQ;IACR,SAAS;IACT,MAAM;IACN,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,gBAAgB;IAChB,kBAAkB;IAClB,4BAA4B;AAChC;AACA;IACI,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,+BAA+B;AACnC;AACA;IACI,cAAc;IACd,6BAA6B;AACjC;AACA;IACI,2BAA2B;IAC3B,oBAAoB;IACpB,sBAAsB;IACtB,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,UAAU;AACd;AACA;IACI,aAAa;AACjB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;AACA;IACI,oBAAoB;IACpB,kBAAkB;AACtB;AACA;IACI,0BAA0B;IAC1B,WAAW;IACX,YAAY;AAChB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,4BAA4B;AAChC;AACA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,UAAU;AACd;AACA;;IAEI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,oBAAoB;IACpB,qBAAqB;IACrB,cAAc;IAKd,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,SAAS;IAKT,gCAAgC;AACpC;AACA;IACI,WAAW;AACf;AACA;IACI,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,YAAY;AAChB;AACA;IACI,UAAU;IACV,SAAS;IACT,UAAU;IACV,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,UAAU;AACd;AACA;IACI,WAAW;IACX,WAAW;IACX;gBACY;AAChB;AACA;IACI,gBAAgB;IAChB,UAAU;AACd;AACA;IACI,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,qBAAqB;IACrB,WAAW;IACX,qBAAqB;AACzB;AACA;IACI,cAAc;AAClB;AACA;IACI,aAAa;AACjB;AACA;IACI,4BAA4B;AAChC;AACA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;AACrB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,cAAc;AAClB;AACA;IACI,SAAS;AACb;AACA;IACI,qGAAqG;IACrG,YAAY;IACZ,WAAW;AACf;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,OAAO;IACP,SAAS;IACT,0BAA0B;IAC1B,YAAY;AAChB;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,QAAQ;IACR,UAAU;IACV,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,SAAS;IACT,yBAAyB;IACzB,mBAAmB;IACnB,mCAAmC;IACnC,aAAa;IACb,gCAAgC;IAChC,UAAU;IACV,aAAa;IACb,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,cAAc;AAClB;AACA;IACI,4BAA4B;AAChC;AACA;IACI,cAAc;IACd,WAAW;IACX,MAAM;IACN,SAAS;IACT,YAAY;IACZ,YAAY;IACZ,WAAW;AACf;AACA;IACI,UAAU;IACV,oBAAoB;AACxB;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,qBAAqB;AACzB;AACA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IACZ,OAAO;IACP,QAAQ;IACR,cAAc;IACd,UAAU;IACV,sBAAsB;IACtB,uBAAuB;AAC3B;AACA;IACI,aAAa;AACjB;AACA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;AAChB;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;AACzB;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;AACzB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;;AAEA,iBAAiB;AACjB;IAKI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,iCAAiC;IACjC,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,UAAU;AACd;AACA;IACI,iBAAiB;AACrB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,iCAAiC;IACjC,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,UAAU;AACd;AACA;IACI,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;AACzB;AACA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;AAC7B;AACA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,0BAA0B;AAC9B;AACA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IAKf,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;AACpB;AACA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;IACrB,mBAAmB;AACvB;AACA;IACI,6BAA6B;AACjC;AACA;IACI,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;AACzB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;IACrB,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;AACzB;AACA;IACI,UAAU;IACV,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;AACzB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,6BAA6B;IAC7B,WAAW;IACX,yBAAyB;IACzB,SAAS;IACT,iCAAiC;IACjC,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;AAChC;;AAEA;IACI;;;QAGI,wBAAwB;QACxB,wBAAwB;IAC5B;AACJ;;AAEA;IACI;;QAEI,aAAa;IACjB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,YAAY;QACZ,iBAAiB;QACjB,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,6BAA6B;QAC7B,sBAAsB;QACtB,iBAAiB;IACrB;IACA;QACI,8BAA8B;QAC9B,QAAQ;QACR,iBAAiB;IACrB;IACA;QACI,2BAA2B;IAC/B;IACA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,wBAAwB;QACxB,0BAA0B;IAC9B;IACA;QACI,wBAAwB;QACxB,2BAA2B;QAC3B,iBAAiB;QACjB,0BAA0B;IAC9B;IACA;QACI,4BAA4B;QAC5B,+BAA+B;IACnC;IACA;QACI,iBAAiB;QACjB,oBAAoB;IACxB;IACA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,gBAAgB;QAChB,qBAAqB;IACzB;IACA;QACI,WAAW;IACf;IACA;QACI,WAAW;IACf;IACA;QACI,qBAAqB;IACzB;IACA;QACI,sBAAsB;QACtB,mBAAmB;QACnB,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,WAAW;QACX,WAAW;QACX,2BAA2B;IAC/B;IACA;QACI,WAAW;QACX,mBAAmB;QACnB,2BAA2B;IAC/B;IACA;QACI,WAAW;QACX,kBAAkB;IACtB;IACA;QACI,WAAW;QACX,mBAAmB;IACvB;IACA;QACI,6BAA6B;IACjC;IACA;QACI,gBAAgB;IACpB;IACA;QACI,kBAAkB;IACtB;IACA;;QAEI,iCAAiC;IACrC;IACA;QACI,iBAAiB;IACrB;IACA;QACI,WAAW;QACX,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,iBAAiB;QACjB,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,eAAe;QACf,YAAY;IAChB;IACA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,WAAW;IACf;AACJ;;AAEA;IACI;;QAEI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,4BAA4B;QAC5B,6BAA6B;IACjC;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,wBAAwB;QACxB,WAAW;QACX,oBAAoB;QACpB,uBAAuB;QACvB,oBAAoB;QACpB,mBAAmB;QACnB,eAAe;IACnB;IACA;QACI,uBAAuB;QACvB,cAAc;QACd,gBAAgB;QAChB,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,2BAA2B;IAC/B;IACA;QACI,WAAW;QACX,iBAAiB;IACrB;IACA;QACI,6BAA6B;QAC7B,gBAAgB;QAChB,UAAU;QACV,MAAM;QACN,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,kBAAkB;IACtB;AACJ;;AAEA;IACI;;QAEI,WAAW;IACf;IACA;QACI,YAAY;IAChB;IACA;QACI,sBAAsB;QACtB,mBAAmB;QACnB,mBAAmB;QACnB,kBAAkB;QAClB,eAAe;IACnB;IACA;QACI,WAAW;QACX,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,2BAA2B;QAC3B,YAAY;IAChB;IACA;QACI,aAAa;IACjB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,wCAAwC;IAC5C;AACJ;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,uBAAuB;QACvB,cAAc;QACd,gBAAgB;QAChB,sBAAsB;IAC1B;IACA;QACI,eAAe;QACf,OAAO;QACP,QAAQ;QACR,MAAM;QACN,WAAW;QACX,SAAS;QACT,gBAAgB;QAChB,WAAW;QACX,eAAe;QACf,kBAAkB;QAClB,kBAAkB;QAClB,yBAAyB;QAKzB,+BAA+B;QAK/B,gCAAgC;QAChC,YAAY;IAChB;IACA;QAKI,mCAAmC;QAKnC,gCAAgC;IACpC;IACA;QACI,kBAAkB;QAClB,WAAW;QACX,YAAY;QACZ,gBAAgB;QAChB,SAAS;QACT,WAAW;QACX,YAAY;QACZ,SAAS;IACb;IACA;QACI,0CAA0C;QAC1C,+CAA+C;QAC/C,kDAAkD;QAKlD,gCAAgC;QAChC,WAAW;QACX,WAAW;QACX,WAAW;QACX,gBAAgB;QAChB,kBAAkB;QAClB,kBAAkB;IACtB;IACA;QACI,2CAA2C;QAC3C,gDAAgD;QAChD,mDAAmD;QAKnD,gCAAgC;QAChC,WAAW;QACX,WAAW;QACX,WAAW;QACX,gBAAgB;QAChB,kBAAkB;QAClB,kBAAkB;IACtB;IACA;QACI,mBAAmB;IACvB;IACA;QAKI,wBAAwB;QACxB,mBAAmB;QACnB,8BAA8B;IAClC;IACA;QACI,SAAS;QACT,6BAA6B;QAC7B,kBAAkB;QAClB,eAAe;QACf,eAAe;IACnB;IACA;QACI,eAAe;QACf,WAAW;IACf;IACA;QACI,gBAAgB;IACpB;IACA;QACI,UAAU;QACV,UAAU;IACd;IACA;QACI,UAAU;IACd;IACA;;;QAGI,uBAAuB;QACvB,wBAAwB;IAC5B;IACA;;QAEI,WAAW;QACX,UAAU;IACd;IACA;QACI,iBAAiB;QACjB,UAAU;QACV,0CAA0C;QAC1C,yCAAyC;IAC7C;IACA;QACI,iBAAiB;QACjB,UAAU;QACV,mBAAmB;IACvB;IACA;;QAEI,SAAS;IACb;IACA;;QAEI,UAAU;IACd;IACA;QACI,iBAAiB;QACjB,yBAAyB;QACzB,kBAAkB;IACtB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,wCAAwC;IAC5C;IACA;QACI,eAAe;QACf,iBAAiB;IACrB;IACA;;QAEI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,gBAAgB;QAKhB,SAAO;IACX;IACA;QACI,uBAAuB;QACvB,gBAAgB;IACpB;IACA;QACI,gBAAgB;QAChB,UAAU;IACd;IACA;;;;QAII,0BAA0B;QAC1B,2BAA2B;QAC3B,UAAU;QACV,uBAAuB;IAC3B;IACA;QACI,UAAU;IACd;IACA;QACI,mBAAmB;QACnB,UAAU;QACV,uBAAuB;QACvB,WAAW;QACX,uBAAuB;QACvB,oBAAoB;QACpB,mBAAmB;QACnB,eAAe;IACnB;IACA;QACI,oBAAoB;IACxB;IACA;QACI,WAAW;QACX,SAAS;QACT,2HAA2H;QAC3H,WAAW;QACX,YAAY;IAChB;IACA;QACI,aAAa;IACjB;IACA;QACI,eAAe;QACf,UAAU;IACd;IACA;QACI,0BAA0B;QAC1B,yBAAyB;IAC7B;IACA;QACI,eAAe;QACf,gBAAgB;IACpB;IACA;QACI,qBAAqB;QACrB,gBAAgB;IACpB;IACA;QACI,4BAA4B;IAChC;IACA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;IACA;QACI,aAAa;IACjB;IACA;QACI,gBAAgB;IACpB;IACA;;QAEI,0BAA0B;IAC9B;IACA;QACI,eAAe;IACnB;IACA;QACI,UAAU;QACV,eAAe;IACnB;IACA;QACI,+BAA+B;IACnC;IACA;QACI,qBAAqB;IACzB;IACA;QACI,4BAA4B;QAC5B,gBAAgB;IACpB;IACA;;QAEI,sCAAsC;IAC1C;IACA;QACI,2BAA2B;QAC3B,eAAe;IACnB;IACA;QACI,2BAA2B;IAC/B;IACA;QACI,WAAW;IACf;IACA;QACI,mBAAmB;QACnB,WAAW;QACX,YAAY;IAChB;IACA;;;QAGI,uBAAuB;QACvB,iBAAiB;IACrB;IACA;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,YAAY;QACZ,iBAAiB;IACrB;IACA;QACI,WAAW;IACf;IACA;QACI,uBAAuB;QACvB,gBAAgB;QAChB,mBAAmB;QAKnB,SAAO;IACX;IACA;QACI,WAAW;QACX,qBAAqB;QAKrB,aAAa;QACb,sBAAsB;IAC1B;IACA;QACI,mBAAmB;IACvB;IACA;QACI,WAAW;QACX,qBAAqB;IACzB;IACA;QACI,sCAAsC;IAC1C;IACA;QACI,sBAAsB;QACtB,kCAAkC;IACtC;IACA;QACI,mBAAmB;IACvB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,eAAe;IACnB;IACA;QACI,iBAAiB;QACjB,WAAW;IACf;IACA;QACI,WAAW;QACX,gBAAgB;QAChB,qBAAqB;IACzB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,WAAW;IACf;IACA;QACI,sCAAsC;IAC1C;IACA;QACI,gBAAgB;IACpB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,2BAA2B;QAC3B,uBAAuB;QACvB,gBAAgB;IACpB;IACA;QACI,gBAAgB;QAKhB,WAAW;QACX,YAAY;IAChB;IACA;QACI,gBAAgB;QAKhB,WAAW;QACX,YAAY;QACZ,gBAAgB;IACpB;IACA;QACI,kBAAkB;IACtB;IACA;QAKI,WAAW;QACX,WAAW;QACX,2BAA2B;IAC/B;IACA;QACI,6BAA6B;QAC7B,WAAW;QACX,SAAS;IACb;IACA;;QAEI,gBAAgB;QAChB,WAAW;QACX,iBAAiB;QACjB,uBAAuB;QACvB,mBAAmB;QACnB,wBAAwB;QACxB,gBAAgB;IACpB;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,eAAe;QACf,iBAAiB;IACrB;IACA;;QAEI,4BAA4B;IAChC;IACA;QACI,eAAe;QACf,cAAc;IAClB;IACA;QACI,2BAA2B;QAC3B,YAAY;QACZ,gBAAgB;IACpB;IACA;QACI,eAAe;IACnB;IACA;QACI,6BAA6B;QAC7B,8BAA8B;IAClC;IACA;QACI,WAAW;IACf;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,qBAAqB;IACzB;IACA;QACI,sBAAsB;QACtB,mBAAmB;QACnB,mBAAmB;QACnB,kBAAkB;QAClB,eAAe;IACnB;IACA;QACI,WAAW;QACX,uBAAuB;QACvB,oBAAoB;QACpB,mBAAmB;QACnB,eAAe;QACf,WAAW;QACX,6BAA6B;IACjC;IACA;QACI,8BAA8B;QAC9B,WAAW;QACX,oBAAoB;IACxB;IACA;QACI,iBAAiB;IACrB;IACA;;QAEI,WAAW;QACX,gBAAgB;IACpB;IACA;QACI,eAAe;IACnB;IACA;QACI,kBAAkB;QAClB,WAAW;IACf;IACA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;;;QAGI,uBAAuB;QACvB,wBAAwB;IAC5B;IACA;QACI,uBAAuB;QACvB,iBAAiB;QACjB,eAAe;IACnB;IACA;QACI,uBAAuB;QACvB,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,YAAY;IAChB;IACA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,0BAA0B;IAC1B,SAAS;IACT,UAAU;IACV,UAAU;AACd;AACA;IACI,YAAY;IACZ,mBAAmB;IACnB,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;AAChB;AACA;;;IAGI,yBAAyB;IAKzB,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,WAAW;IACX,aAAa;IAGb,gCAAgC;IAChC,YAAY;AAChB;AACA;IACI,0CAA0C;IAC1C,+CAA+C;IAC/C,kDAAkD;IAClD,WAAW;IACX,WAAW;IACX,8CAA8C;IAC9C,6CAA6C;AACjD;AACA;IAGI,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,2CAA2C;IAC3C,gDAAgD;IAChD,mDAAmD;IACnD,WAAW;IACX,WAAW;IACX,+CAA+C;IAC/C,8CAA8C;AAClD;AACA;IACI,aAAa;AACjB;AACA;IACI,gCAAgC;AACpC;AACA;IAKI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,8BAA8B;IAC9B,eAAe;AACnB;AACA;IACI,eAAe;IACf,wBAAwB;IAKxB,gCAAgC;IAChC,gCAAgC;IAChC,6BAA6B;IAC7B,4BAA4B;IAC5B,2BAA2B;AAC/B;AACA;IACI,yBAAyB;IAKzB,gCAAgC;IAChC,iCAAiC;IACjC,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;AAChC;AACA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,WAAW;AACf;AACA;;IAEI,WAAW;AACf;AACA;IACI,wBAAwB;IACxB,qBAAqB;AACzB;AACA;IACI,aAAa;AACjB;AACA;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;IACZ,YAAY;AAChB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IAKI,SAAO;IACP,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,2BAA2B;IAC3B,gCAAgC;IAChC,mCAAmC;IACnC,gCAAgC;IAChC,+BAA+B;IAC/B,8BAA8B;AAClC;AACA;IACI,cAAc;IACd,UAAU;IACV,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,cAAc;IACd,UAAU;IACV,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,UAAU;IACV,+BAA+B;IAC/B,qBAAqB;IACrB,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,cAAc;AAClB;AACA;IACI,2BAA2B;IAC3B,mCAAmC;IACnC,gCAAgC;IAChC,+BAA+B;IAC/B,8BAA8B;AAClC;AACA;IACI,aAAa;AACjB;AACA;IACI,cAAc;AAClB;AACA;IACI,kCAAkC;IAClC,0CAA0C;AAC9C;;AAEA;IACI;QACI,uBAAuB;QACvB,+BAA+B;QAC/B,4BAA4B;QAC5B,2BAA2B;QAC3B,0BAA0B;IAC9B;IACA;QACI,yBAAyB;QACzB,iCAAiC;QACjC,8BAA8B;QAC9B,6BAA6B;QAC7B,4BAA4B;IAChC;AACJ;AACA;IACI,mBAAmB;IACnB,+BAA+B;IAC/B,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,iBAAiB;IAKjB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IAKI,gCAAgC;AACpC;AACA;IACI,qBAAqB;IAKrB,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,0BAA0B;AAC9B;AACA;IAKI,2BAA2B;AAC/B;AACA;IACI,aAAa;AACjB;AACA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IAKI,aAAa;IACb,mBAAmB;AACvB;AACA;;IAEI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,SAAS;IACT,WAAW;IACX,UAAU;AACd;AACA;IACI,gBAAgB;AACpB;AACA;;IAEI,WAAW;IACX,wCAAwC;IACxC,6BAA6B;IAC7B,+DAA+D;IAC/D,yBAAyB;IACzB,+DAA+D;AACnE;AACA;IACI,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,0BAA0B;IAC1B,gBAAgB;IAChB,SAAS;IACT,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,SAAS;IACT,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,aAAa;AACjB;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,qBAAqB;IACrB,gBAAgB;IAChB,yBAAyB;IACzB,UAAU;IACV,WAAW;AACf;AACA;IACI,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,qBAAqB;IACrB,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,aAAa;AACjB;AACA;IACI,mBAAmB;IACnB,UAAU;AACd;AACA;IACI,mBAAmB;IACnB,UAAU;IACV,8BAA8B;AAClC;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;IACf,YAAY;IACZ,WAAW;IACX,OAAO;IACP,QAAQ;IACR,SAAS;IACT,MAAM;IACN,YAAY;IACZ,6BAA6B;AACjC;AACA;IACI,UAAU;AACd;AACA;IACI,cAAc;AAClB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,WAAW;AACf;AACA;IACI,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,uBAAuB;IACvB,gBAAgB;IAChB,2BAA2B;AAC/B;AACA;IACI,SAAS;AACb;AACA;IACI,sGAAsG;AAC1G;AACA;IACI,eAAe;AACnB;AACA;IACI,WAAW;AACf;AACA;IACI,SAAS;AACb;AACA;IACI,UAAU;IACV,cAAc;IAKd,aAAa;AACjB;AACA;IACI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IAKZ,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,WAAW;IACX,qBAAqB;IACrB,mBAAmB;IAKnB,gCAAgC;AACpC;AACA;IACI,WAAW;AACf;AACA;IAKI,2BAA2B;AAC/B;AACA;IACI,WAAW;IACX,iBAAiB;AACrB;AACA;IAKI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,SAAS;AACb;AACA;IACI,WAAW;AACf;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IAKd,aAAa;IACb,8BAA8B;AAClC;AACA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,UAAU;IACV,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,SAAS;IACT,gBAAgB;IAChB,6BAA6B;AACjC;AACA;IACI,eAAe;IACf,gBAAgB;IAKhB,aAAa;IACb,8BAA8B;AAClC;AACA;IACI,cAAc;IACd,sBAAsB;IACtB,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,aAAa;AACjB;AACA;IACI,0BAA0B;IAC1B,kCAAkC;IAClC,+BAA+B;IAC/B,8BAA8B;IAC9B,6BAA6B;AACjC;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,QAAQ;IACR,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IAKzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,cAAc;IACd,eAAe;IACf,QAAQ;AACZ;AACA;IAKI,2BAA2B;IAK3B,gCAAgC;AACpC;AACA;IAKI,0BAA0B;AAC9B;AACA;;;IAGI,qBAAqB;IACrB,2CAA2C;AAC/C;AACA;IACI,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,kCAAkC;IAClC,mCAAmC;IACnC,UAAU;IACV,UAAU;AACd;;AAEA;IACI;QACI,UAAU;QACV,YAAY;IAChB;IACA;QACI,gBAAgB;QAChB,iBAAiB;QACjB,gBAAgB;QAChB,mBAAmB;QACnB,gBAAgB;QAChB,gBAAgB;QAChB,uBAAuB;IAC3B;IACA;QACI,mBAAmB;QACnB,gBAAgB;QAChB,gBAAgB;QAChB,uBAAuB;IAC3B;IACA;QAKI,aAAa;QACb,mBAAmB;QACnB,qBAAqB;QACrB,WAAW;QACX,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;IACA;QACI,UAAU;QACV,YAAY;QACZ,kBAAkB;IACtB;IACA;QACI,sBAAsB;QACtB,UAAU;QACV,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,WAAW;IACf;IACA;QACI,uBAAuB;QACvB,mBAAmB;IACvB;IACA;QACI,sBAAsB;QACtB,mBAAmB;QACnB,mBAAmB;QACnB,kBAAkB;QAClB,eAAe;IACnB;IACA;QACI,WAAW;IACf;IACA;QACI,YAAY;QACZ,eAAe;IACnB;IACA;QACI,gBAAgB;QAChB,iBAAiB;QACjB,gBAAgB;IACpB;IACA;QACI,YAAY;QACZ,YAAY;IAChB;IACA;QACI,kBAAkB;QAClB,SAAS;QACT,eAAe;IACnB;IACA;QACI,gBAAgB;QAChB,iBAAiB;QACjB,gBAAgB;QAChB,eAAe;QACf,eAAe;QACf,WAAW;QACX,mBAAmB;QACnB,gBAAgB;QAChB,uBAAuB;IAC3B;IACA;QACI,SAAS;IACb;IACA;QACI,gBAAgB;QAChB,mBAAmB;QACnB,0BAA0B;QAC1B,uBAAuB;QACvB,iBAAiB;QACjB,sBAAsB;IAC1B;IACA;QACI,WAAW;IACf;IACA;QACI,eAAe;QACf,cAAc;QAKd,aAAa;QACb,mBAAmB;QACnB,qBAAqB;QACrB,WAAW;QACX,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,YAAY;QACZ,eAAe;IACnB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;IACA;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IAKI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;AAC7B;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,0BAA0B;IAC1B,SAAS;IACT,OAAO;IACP,QAAQ;IACR,2BAA2B;IAC3B,sBAAsB;IACtB,YAAY;AAChB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,oBAAoB;IACpB,YAAY;AAChB;AACA;IAKI,aAAa;IACb,8BAA8B;IAC9B,2BAA2B;IAC3B,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,iCAAiC;IACjC,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,oBAAoB;IACpB,cAAc;IACd,mCAAmC;IACnC,kCAAkC;IAClC,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,OAAO;IACP,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,kBAAkB;IAKlB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,iCAAiC;AACrC;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,aAAa;AACjB;AACA;IACI,4BAA4B;AAChC;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;IACX,QAAQ;IACR,SAAS;IACT,6BAA6B;IAC7B,sDAAsD;AAC1D;AACA;IACI,sDAAsD;IACtD,QAAQ;AACZ;AACA;IACI,cAAc;IACd,wBAAwB;IACxB,yBAAyB;IACzB,qBAAqB;IACrB,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,gCAAgC;IAChC,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,aAAa;IACb,6BAA6B;IAC7B,+BAA+B;IAC/B,yBAAyB;IACzB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;IACnC,iCAAiC;IACjC,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;AAChC;AACA;IACI,aAAa;IACb,SAAS;IACT,6BAA6B;IAC7B,+BAA+B;IAC/B,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,iCAAiC;IACjC,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;AAChC;AACA;IACI,cAAc;IACd,iBAAiB;IACjB,6BAA6B;IAC7B,oEAAoE;IACpE,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,mCAAmC;IACnC,YAAY;IACZ,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,aAAa;AACjB;AACA;;IAEI,oCAAoC;AACxC;AACA;;;IAGI,qBAAqB;IACrB,4CAA4C;AAChD;AACA;IACI,cAAc;IACd,uBAAuB;IACvB,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,aAAa;AACjB;AACA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,UAAU;IACV,gBAAgB;IAChB,sBAAsB;IACtB,WAAW;IACX,gBAAgB;AACpB;AACA;;IAEI,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,UAAU;IACV,gCAAgC;IAChC,yBAAyB;IACzB,iCAAiC;AACrC;AACA;IACI,UAAU;IACV,UAAU;IACV,SAAS;AACb;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,kCAAkC;IAClC,mCAAmC;IACnC,gCAAgC;IAChC,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,SAAS;AACb;AACA;IACI,gBAAgB;AACpB;AACA;IACI,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,UAAU;IACV,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,4BAA4B;IAC5B,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,gBAAgB;AACpB;AACA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,SAAS;AACb;AACA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,WAAW;AACf;AACA;IACI,uBAAuB;IACvB,UAAU;IACV,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,gBAAgB;AACpB;AACA;IACI,uBAAuB;IACvB,UAAU;IACV,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,uBAAuB;IACvB,UAAU;IACV,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,cAAc;IACd,0BAA0B;IAC1B,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI;QACI,mBAAmB;IACvB;IACA;QACI,iBAAiB;QACjB,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,yBAAyB;QACzB,kBAAkB;QAClB,kBAAkB;IACtB;AACJ;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,4BAA4B;IAC5B,mBAAmB;AACvB;AACA;IACI,kBAAkB;AACtB;;AAEA,qBAAqB;AACrB;IAKI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,YAAY;IACZ,YAAY;IAKZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IAKI,SAAO;IACP,SAAS;IACT,eAAe;AACnB;AACA;IACI,eAAe;IACf,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,MAAM;IACN,SAAS;IACT,YAAY;IAKZ,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,2BAA2B;AAC/B;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,MAAM;IACN,SAAS;IACT,YAAY;IACZ,uBAAuB;IACvB,UAAU;IACV,gCAAgC;AACpC;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,OAAO;IACP,SAAS;IACT,QAAQ;IACR,MAAM;IACN,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,OAAO;IACP,SAAS;IACT,QAAQ;IACR,MAAM;IACN,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,UAAU;IACV,WAAW;IACX,yBAAyB;AAC7B;AACA;IACI,eAAe;IACf,0CAA0C;IAC1C,yCAAyC;AAC7C;AACA;IACI,WAAW;IACX,eAAe;AACnB;AACA;IACI,YAAY;IACZ,aAAa;IACb,mCAAmC;AACvC;AACA;IACI,qBAAqB;AACzB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,oBAAoB;AACxB;AACA;IACI,SAAS;AACb;AACA;IACI,gCAAgC;IAChC,kBAAkB;AACtB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,aAAa;AACjB;AACA;IACI,qBAAqB;IACrB,wBAAwB;IACxB,WAAW;IACX,eAAe;IACf,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,WAAW;AACf;AACA;IACI,yBAAyB;IACzB,iCAAiC;IACjC,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;AAChC;AACA;IACI,WAAW;IACX,cAAc;AAClB;AACA;IACI,QAAQ;AACZ;AACA;IACI,QAAQ;AACZ;AACA;IACI,QAAQ;AACZ;AACA;IACI,QAAQ;AACZ;AACA;IACI,YAAY;AAChB;AACA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,mCAAmC;IACnC,wBAAwB;IACxB,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,oBAAoB;IACpB,mBAAmB;AACvB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,mHAAmH;IACnH,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,uBAAuB;AAC3B;AACA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,SAAS;IACT,MAAM;IACN,YAAY;IACZ,UAAU;AACd;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAKlB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,eAAe;IACf,SAAS;AACb;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,qBAAqB;AACzB;AACA;IACI,cAAc;IACd,0BAA0B;AAC9B;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,oBAAoB;IACpB,WAAW;IACX,mBAAmB;IACnB,gCAAgC;IAChC,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,mBAAmB;AACvB;AACA;IACI,aAAa;AACjB;AACA;IACI;gBACY;IACZ,WAAW;IACX,YAAY;IACZ,eAAe;IACf,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,8BAA8B;IAC9B,UAAU;IACV,aAAa;IAKb,SAAO;IACP,uBAAuB;IACvB,kBAAkB;AACtB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,WAAW;AACf;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,eAAe;AACnB;AACA;IACI,wBAAwB;IAKxB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,qBAAqB;IACrB,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,qBAAqB;AACzB;AACA;IACI,cAAc;AAClB;AACA;IACI,kBAAkB;IAKlB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,gCAAgC;AACpC;AACA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;AACf;AACA;IACI,wBAAwB;IAKxB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,wBAAwB;IACxB,uBAAuB;AAC3B;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,cAAc;AAClB;AACA;IACI,WAAW;IACX,uBAAuB;IACvB,UAAU;IACV,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;AACA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;AAC7B;AACA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;IACd,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,QAAQ;IACR,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,uBAAkB;IAAlB,kBAAkB;IAClB,eAAe;IACf,2BAA2B;IAC3B,eAAe;AACnB;AACA;IACI,WAAW;AACf;AACA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB,EAAE,4BAA4B;IAChD,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;AAChC;AACA;IACI,wIAAwI;IACxI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;AACvB;AACA;IACI,aAAa;AACjB;AACA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IAKjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;AACA;IAKI,SAAO;AACX;AACA;IACI,WAAW;IACX;YACQ;IACR,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;IAKT,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,mBAAmB;IAKnB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,8BAA8B;IAC9B,gBAAgB;AACpB;AACA;IAKI,SAAO;AACX;AACA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,qBAAqB;IACrB,cAAc;AAClB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,WAAW;IACX,qBAAqB;AACzB;AACA;IACI,cAAc;AAClB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,gCAAgC;AACpC;AACA;IACI,0BAA0B;IAC1B,kBAAkB;AACtB;AACA;IACI,wBAAwB;IACxB,gCAAgC;AACpC;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,cAAc;AAClB;AACA;IACI,qBAAqB;AACzB;AACA;IAKI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;AACA;IACI,SAAO;AACX;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,qBAAqB;AACzB;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,iCAAiC;AACrC;AACA;IACI,aAAa;AACjB;AACA;IACI,gCAAgC;AACpC;AACA;IACI,eAAe;AACnB;AACA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,cAAc;AAClB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,WAAW;IACX,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,MAAM;AACV;AACA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;AACf;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,MAAM;IACN,SAAS;IACT,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;AACrB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IAKZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,gCAAgC;AACpC;AACA;IACI;gBACY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gCAAgC;IAChC,OAAO;AACX;AACA;IACI,mBAAmB;AACvB;AACA;IACI,SAAS;AACb;AACA;IAKI,SAAO;IAKP,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,aAAa;IAKb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,YAAY;AAChB;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,yBAAyB;AAC7B;AACA;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;AACA;IACI,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,sBAAsB;IACtB,cAAc;IACd,eAAe;AACnB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;AAC1B;AACA;IAKI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,YAAY;IAKZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;IACtB,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,wBAAwB;AAC5B;AACA;IACI,6HAA6H;IAC7H,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,eAAe;AACnB;AACA;;IAEI,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;AACf;AACA;;IAEI,eAAe;IACf,WAAW;IACX,WAAW;IACX,wBAAwB;IACxB,8BAA8B;IAC9B,kBAAkB;IAClB,iBAAiB;IACjB,gCAAgC;AACpC;AACA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,WAAW;IACX,qBAAqB;AACzB;AACA,oCAAoC;;AAEpC,4FAA4F;AAC5F;IACI,wIAAwI;IACxI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,cAAc;IACd,eAAe;AACnB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,gCAAgC;IAChC,mBAAmB;IACnB,oBAAoB;AACxB;AACA;;IAEI,mCAAmC;IACnC,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;AACjB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,YAAY;AAChB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,YAAY;IAKZ,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,uBAAuB;AAC3B;AACA;IAKI,SAAO;IAKP,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAKlB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA,8FAA8F,UAAU;AACxG;IAKI,SAAO;IAKP,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,qBAAqB;IACrB,WAAW;IACX,YAAY;AAChB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;AACA;;IAEI,eAAe;IACf,qBAAqB;IACrB,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IAKnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gCAAgC;AACpC;AACA;;IAEI,mBAAmB;AACvB;AACA;;IAEI,kBAAkB;AACtB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,kHAAkH;IAClH,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;AACA;IAKI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,oBAAoB;AACxB;AACA;;IAEI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;;IAEI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,gCAAgC;IAChC,kBAAkB;AACtB;AACA;;IAEI,yBAAyB;AAC7B;AACA;;IAEI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,SAAS;IACT,MAAM;IACN,YAAY;IACZ;YACQ;AACZ;AACA;;IAEI,6FAA6F;AACjG;AACA;;;IAGI,8GAA8G;IAC9G,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;;;IAGI,UAAU;AACd;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,YAAY;AAChB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;AACxB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,mCAAmC;IACnC,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;AACjB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,iCAAiC;IACjC,aAAa;IACb,8BAA8B;IAC9B,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,gBAAgB;AACpB;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,gBAAgB;AACpB;AACA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB;AACA;;IAEI,mBAAmB;IACnB,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,yBAAyB;AAC7B;AACA;AACA;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,UAAU;IACV,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,qBAAqB;IACrB,mBAAmB;IACnB,WAAW;IACX,uBAAuB;IACvB,qBAAqB;IACrB,gBAAgB;AACpB;AACA;IACI,0BAA0B;IAC1B,cAAc;AAClB;AACA;IACI,cAAc;IACd,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,8BAA8B;AAClC;AACA;IACI,oBAAoB;IACpB,+BAA+B;IAC/B,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,yBAAyB;AAC7B;AACA;IACI,UAAU;IACV,YAAY;AAChB;AACA;IACI,iCAAiC;IACjC,oCAAoC;AACxC;AACA;IACI,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,SAAS;IACT,QAAQ;AACZ;AACA;IACI,aAAa;AACjB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,uBAAuB;AAC3B;AACA;IACI,yBAAyB;IACzB,oBAAoB;IACpB,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;IACvB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,qBAAqB;AACzB;AACA;IACI,0BAA0B;IAC1B,cAAc;AAClB;AACA;;IAEI,cAAc;IACd,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,iBAAiB;IACjB,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,6BAA6B;IAC7B,iBAAiB;IACjB,aAAa;IACb,kCAAkC;IAClC,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,+BAA+B;IAC/B,uCAAuC;AAC3C;AACA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,WAAW;AACf;AACA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;AACA;IACI,YAAY;IACZ,YAAY;IAKZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,gCAAgC;AACpC;AACA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;AACA;IACI;gBACY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gCAAgC;IAChC,OAAO;AACX;AACA;IACI,SAAS;AACb;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mCAAmC;IACnC,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;AACjB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;AACxB;AACA;IACI,gBAAgB;AACpB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IAKI,SAAO;IACP,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,YAAY;IAKZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,YAAY;AAChB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,mCAAmC;IACnC,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IAKb,aAAa;IACb,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,kBAAkB;AACtB;AACA;IACI,gCAAgC;AACpC;AACA;IACI,sBAAsB;IAKtB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,+BAA+B;IAC/B,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,gHAAgH;IAChH,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,QAAQ;IACR,MAAM;IACN,YAAY;AAChB;AACA;IACI,WAAW;IACX,gHAAgH;IAChH,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,QAAQ;IACR,MAAM;IACN,YAAY;AAChB;AACA;IACI,WAAW;IACX,uHAAuH;IACvH,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,QAAQ;IACR,MAAM;IACN,YAAY;AAChB;AACA;IACI,WAAW;IACX,qHAAqH;IACrH,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,QAAQ;IACR,MAAM;IACN,YAAY;AAChB;AACA;IACI,WAAW;IACX,kHAAkH;IAClH,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,QAAQ;IACR,MAAM;IACN,YAAY;AAChB;AACA;IACI,WAAW;IACX,kHAAkH;IAClH,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,QAAQ;IACR,MAAM;IACN,YAAY;AAChB;AACA;IACI,WAAW;IACX,uHAAuH;IACvH,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,QAAQ;IACR,MAAM;IACN,YAAY;AAChB;AACA;IACI,WAAW;IACX,kHAAkH;IAClH,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,QAAQ;IACR,MAAM;IACN,YAAY;AAChB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,SAAS;AACb;AACA;IAKI,SAAO;IAKP,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;AACtB;AACA;IACI,aAAa;AACjB;AACA;IACI,eAAe;AACnB;AACA;IACI,YAAY;AAChB;AACA;IACI,oBAAoB;IACpB,eAAe;AACnB;AACA;IACI,cAAc;IACd,gCAAgC;AACpC;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;IACd,gCAAgC;AACpC;AACA;IACI,cAAc;AAClB;AACA;IACI,mCAAmC;IACnC,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,0BAA0B;AAC9B;AACA;IACI,eAAe;AACnB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,YAAY;IACZ,mBAAmB;IACnB,UAAU;IACV,YAAY;AAChB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,WAAW;AACf;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;;IAEI,gBAAgB;AACpB;AACA;IACI,mCAAmC;IACnC,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;AACjB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,yBAAyB;AAC7B;AACA;IACI,4BAA4B;AAChC;AACA;IACI,eAAe;AACnB;AACA;IACI,mCAAmC;IACnC,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;AACxB;AACA;IACI,gBAAgB;AACpB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,WAAW;AACf;AACA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,mCAAmC;IACnC,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;AACjB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;AACxB;AACA;IACI,gBAAgB;AACpB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,WAAW;AACf;AACA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,sIAAsI;IACtI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,QAAQ;IACR,MAAM;IACN,YAAY;AAChB;AACA;IACI,WAAW;IACX,uHAAuH;IACvH,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,YAAY;AAChB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,SAAO;IACP,iBAAiB;AACrB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,iBAAiB;AACrB;AACA;IACI,+BAA+B;AACnC;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,MAAM;AACV;AACA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,qBAAqB;AACzB;AACA;IACI,cAAc;IACd,0BAA0B;AAC9B;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,iBAAiB;AACrB;AACA;IACI,+BAA+B;AACnC;AACA;IACI,+BAA+B;AACnC;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,qBAAqB;AACzB;AACA;IACI,cAAc;IACd,0BAA0B;AAC9B;AACA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,qBAAqB;AACzB;AACA;IACI,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,4BAA4B;AAChC;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,cAAc;AAClB;AACA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;IACT,YAAY;IACZ,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;AACA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,uBAAuB;IACvB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,oBAAoB;IACpB,qBAAqB;IACrB,WAAW;AACf;AACA;IACI,qBAAqB;IACrB,WAAW;AACf;AACA;IACI,sBAAsB;IACtB,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,WAAW;AACf;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,sIAAsI;IACtI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;AAC7B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,WAAW;IACX,6BAA6B;IAC7B,iBAAiB;AACrB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,eAAe;AACnB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;AACzB;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,yBAAyB;AAC7B;AACA;IACI,YAAY;AAChB;AACA;;IAEI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,0DAAmW;IACnW,4BAA4B;IAC5B,2BAA2B;IAC3B,0BAA0B;IAC1B,SAAS;IACT,6BAA6B;AACjC;;AAEA;IACI;IACA,aAAa;IACb,eAAe;IACf,sBAAsB;AAC1B;AACA;AACA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,qBAAqB;QACrB,oBAAoB;QACpB,mBAAmB;IACvB;IACA;QACI,WAAW;IACf;IACA;QACI,WAAW;IACf;IACA;QACI,gBAAgB;IACpB;IACA;QACI,sBAAsB;QACtB,mBAAmB;QACnB,sBAAsB;IAC1B;IACA;QACI,sBAAsB;QACtB,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,mBAAmB;IACvB;IACA;QACI,eAAe;QACf,UAAU;IACd;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,iBAAiB;IACrB;IACA;QAKI,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,mBAAmB;QACnB,kBAAkB;QAClB,eAAe;IACnB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,WAAW;QACX,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,kBAAkB;IACtB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,sBAAsB;QACtB,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;IACA;QACI,iBAAiB;IACrB;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,WAAW;QACX,oBAAoB;QACpB,mBAAmB;IACvB;IACA;QACI,WAAW;QACX,WAAW;QACX,WAAW;QACX,mBAAmB;QACnB,kBAAkB;QAClB,WAAW;QACX,SAAS;QACT,SAAS;QACT,OAAO;IACX;IACA;QACI,UAAU;IACd;IACA;QACI,mBAAmB;IACvB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,kBAAkB;QAKlB,SAAO;IACX;IACA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;IACA;QACI,WAAW;IACf;IACA;QACI,WAAW;IACf;IACA;QACI,mBAAmB;QACnB,kBAAkB;IACtB;IACA;QACI,WAAW;QACX,iBAAiB;QACjB,mBAAmB;IACvB;IACA;QACI,SAAS;QACT,QAAQ;QACR,WAAW;QACX,WAAW;QACX,SAAS;IACb;IACA;QACI,UAAU;QACV,kBAAkB;IACtB;IACA;QACI,WAAW;QACX,SAAS;QACT,OAAO;IACX;IACA;QACI,WAAW;IACf;IACA;QACI,mBAAmB;QACnB,mBAAmB;QACnB,WAAW;QACX,sBAAsB;IAC1B;IACA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;IACA;QACI,kBAAkB;QAClB,uBAAuB;QACvB,eAAe;IACnB;IACA;QACI,UAAU;QACV,gBAAgB;QAChB,gBAAgB;QAChB,yBAAyB;QACzB,gBAAgB;IACpB;IACA;QACI,aAAa;QACb,gBAAgB;IACpB;IACA;QACI,SAAS;QACT,mBAAmB;QACnB,8BAA8B;QAC9B,aAAa;QACb,kBAAkB;QAClB,iBAAiB;IACrB;IACA;QACI,gBAAgB;QAChB,sBAAsB;QACtB,oBAAoB;IACxB;IACA;QACI,WAAW;QACX,gBAAgB;QAChB,8BAA8B;IAClC;IACA;QACI,WAAW;QACX,qBAAqB;QACrB,mBAAmB;QACnB,8BAA8B;QAC9B,aAAa;QACb,kBAAkB;QAClB,iBAAiB;IACrB;IACA;QACI,WAAW;QACX,SAAS;QACT,mBAAmB;QACnB,8BAA8B;QAC9B,aAAa;QACb,kBAAkB;QAClB,iBAAiB;IACrB;IACA;QACI,YAAY;QACZ,gBAAgB;IACpB;IACA;QACI,aAAa;IACjB;IACA;QACI,gBAAgB;QAChB,WAAW;QACX,wBAAwB;QACxB,mBAAmB;QACnB,8BAA8B;QAC9B,aAAa;QACb,kBAAkB;QAClB,iBAAiB;IACrB;IACA;QACI,qBAAqB;QACrB,UAAU;QACV,gBAAgB;IACpB;IACA;QACI,aAAa;IACjB;IACA;QACI,WAAW;QACX,uBAAuB;QACvB,mBAAmB;QACnB,8BAA8B;QAC9B,aAAa;QACb,iBAAiB;IACrB;IACA;QACI,SAAS;IACb;IACA;QACI,mBAAmB;IACvB;IACA;;QAEI,mBAAmB;IACvB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,SAAS;IACb;IACA;QACI,SAAS;IACb;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,YAAY;QACZ,SAAS;QAKT,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,mBAAmB;QACnB,kBAAkB;QAClB,eAAe;QACf,gBAAgB;QAChB,oBAAoB;IACxB;IACA;QACI,SAAO;QACP,aAAa;QACb,sBAAsB;QACtB,kBAAkB;IACtB;IACA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,0CAA0C;QAC1C,yCAAyC;IAC7C;IACA;QACI,sBAAsB;QACtB,kBAAkB;IACtB;IACA;QACI,8BAA8B;IAClC;IACA;QACI,gBAAgB;IACpB;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,aAAa;IACjB;IACA;QACI,iBAAiB;QACjB,SAAS;IACb;IACA;QACI,YAAY;QACZ,oBAAoB;QACpB,gBAAgB;QAChB,SAAS;QACT,gBAAgB;QAChB,2CAA2C;IAC/C;IACA;QACI,UAAU;QACV,wBAAwB;QACxB,sBAAsB;IAC1B;IACA;QACI,kBAAkB;QAClB,gCAAgC;IACpC;IACA;QACI,aAAa;QACb,mBAAmB;QACnB,8BAA8B;IAClC;IACA;QAKI,SAAO;QACP,SAAS;QACT,kBAAkB;IACtB;IACA;QACI,WAAW;QACX,kBAAkB;QAClB,OAAO;QACP,MAAM;QACN,SAAS;QACT,YAAY;QACZ,YAAY;QACZ,mBAAmB;IACvB;IACA;QACI,oBAAoB;QACpB,sBAAsB;QACtB,YAAY;QACZ,kBAAkB;IACtB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,mBAAmB;QACnB,gBAAgB;QAChB,aAAa;QACb,WAAW;IACf;IACA;QACI,aAAa;IACjB;IACA;QACI,0BAA0B;QAC1B,2BAA2B;IAC/B;IACA;QACI,YAAY;QACZ,UAAU;QACV,oBAAoB;IACxB;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,yBAAyB;IAC7B;IACA;QACI,kBAAkB;QAClB,QAAQ;QACR,MAAM;QACN,UAAU;QACV,SAAS;QACT,yBAAyB;QACzB,aAAa;QACb,cAAc;QACd,gBAAgB;IACpB;IACA;QACI,oBAAoB;IACxB;IACA;QACI,oBAAoB;QACpB,aAAa;QACb,sBAAsB;QACtB,YAAY;IAChB;IACA;QACI,mBAAmB;QACnB,6BAA6B;QAC7B,kBAAkB;QAClB,uBAAuB;QACvB,mBAAmB;IACvB;IACA;QACI,iBAAiB;QACjB,mBAAmB;QACnB,kBAAkB;QAClB,qBAAqB;QACrB,WAAW;QACX,cAAc;QACd,gBAAgB;QAChB,yBAAyB;QACzB,gCAAgC;IACpC;IACA;QACI,mBAAmB;QACnB,WAAW;IACf;IACA;QACI,qBAAqB;QACrB,yBAAyB;QACzB,cAAc;QACd,gBAAgB;QAChB,gCAAgC;QAChC,cAAc;IAClB;IACA;QACI,cAAc;IAClB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,gBAAgB;QAChB,iBAAiB;IACrB;IACA;QACI,qBAAqB;IACzB;IACA;QACI,oBAAoB;QACpB,cAAc;IAClB;IACA;QACI,mBAAmB;QACnB,mBAAmB;IACvB;IACA;QACI,cAAc;QACd,mBAAmB;IACvB;IACA;QACI,YAAY;IAChB;IACA;QACI,YAAY;IAChB;IACA;QAKI,SAAO;QACP,gBAAgB;IACpB;IACA;QAKI,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,mBAAmB;QACnB,kBAAkB;QAClB,eAAe;QACf,mBAAmB;QACnB,cAAc;QACd,eAAe;IACnB;IACA;QACI,aAAa;QACb,mBAAmB;IACvB;IACA;QACI,eAAe;QACf,yBAAyB;QACzB,iBAAiB;QACjB,WAAW;QACX,gCAAgC;IACpC;IACA;QACI,mCAAmC;IACvC;IACA;QACI,oBAAoB;IACxB;IACA;QACI,mBAAmB;QACnB,eAAe;QACf,SAAS;QACT,OAAO;QACP,QAAQ;QACR,WAAW;QACX,+BAA+B;IACnC;IACA;QAKI,kCAAkC;IACtC;IACA;QACI,WAAW;QACX,oBAAoB;QACpB,mBAAmB;IACvB;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,SAAS;QACT,oBAAoB;IACxB;IACA;QACI,kBAAkB;QAClB,uBAAuB;QACvB,aAAa;QACb,sBAAsB;QACtB,mBAAmB;IACvB;IACA;QACI,kBAAkB;QAClB,WAAW;QACX,QAAQ;IACZ;IACA;QACI,kBAAkB;QAClB,UAAU;QACV,WAAW;QACX,MAAM;QACN,gBAAgB;IACpB;IACA;QACI,SAAS;IACb;IACA;QACI,qBAAqB;IACzB;IACA;QACI,qBAAqB;IACzB;IACA;QACI,kBAAkB;QAClB,SAAS;QACT,QAAQ;QACR,gBAAgB;QAChB,iCAAiC;QACjC,aAAa;QACb,sBAAsB;QACtB,YAAY;QACZ,kBAAkB;QAClB,gBAAgB;QAChB,UAAU;QACV,WAAW;QACX,gCAAgC;QAChC,wCAAwC;QACxC,qCAAqC;QACrC,oCAAoC;QACpC,mCAAmC;IACvC;IACA;QACI,SAAS;QACT,UAAU;QACV,UAAU;IACd;IACA;QACI,sBAAsB;QACtB,2BAA2B;QAC3B,mBAAmB;QACnB,eAAe;QACf,qBAAqB;QACrB,WAAW;QACX,iBAAiB;QACjB,uBAAuB;QACvB,2BAA2B;QAC3B,kBAAkB;QAClB,UAAU;QACV,oBAAoB;QACpB,mCAAmC;QACnC,gCAAgC;QAChC,+BAA+B;QAC/B,8BAA8B;QAC9B,qBAAqB;IACzB;IACA;QACI,WAAW;QACX,oCAAoC;IACxC;IACA;QACI,WAAW;QACX,YAAY;QACZ,SAAS;QACT,qBAAqB;QACrB,SAAS;QACT,QAAQ;IACZ;IACA;QACI,6BAA6B;IACjC;IACA;QACI,WAAW;QACX;qBACa;QACb,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,SAAS;QACT,QAAQ;IACZ;IACA;QACI,mBAAmB;QACnB,WAAW;IACf;IACA;QACI,+FAA+F;QAC/F,uGAAuG;IAC3G;IACA;QACI,kBAAkB;IACtB;IACA;QACI,QAAQ;QACR,QAAQ;IACZ;IACA;QACI,mBAAmB;IACvB;IACA;QACI,SAAS;IACb;IACA;QACI,QAAQ;IACZ;IACA;QACI,mBAAmB;IACvB;IACA;QACI,eAAe;QACf,WAAW;QACX,YAAY;QACZ,SAAS;QACT,YAAY;QACZ,OAAO;QACP,QAAQ;QACR,YAAY;QACZ,iBAAiB;QACjB,aAAa;QACb,sBAAsB;QACtB,gCAAgC;QAChC,wCAAwC;QACxC,qCAAqC;QACrC,oCAAoC;QACpC,mCAAmC;IACvC;IACA;QACI,MAAM;QACN,SAAS;IACb;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;IACA;QACI,iBAAiB;IACrB;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;IACA;QACI,mBAAmB;QACnB,WAAW;QACX,mBAAmB;QACnB,8BAA8B;QAC9B,gBAAgB;QAChB,mBAAmB;IACvB;IACA;QACI,2BAA2B;IAC/B;IACA;QACI,kBAAkB;IACtB;IACA;QACI,kBAAkB;QAClB,aAAa;QACb,gCAAgC;IACpC;IACA;QACI,QAAQ;IACZ;IACA;QACI,WAAW;QACX,YAAY;QACZ,gBAAgB;QAChB,kBAAkB;QAClB,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,qBAAqB;QACrB,WAAW;QACX,eAAe;IACnB;IACA;QACI,UAAU;QACV,WAAW;QACX,yBAAyB;IAC7B;IACA;QACI,YAAY;IAChB;IACA;QACI,mBAAmB;QACnB,mBAAmB;QACnB,uBAAuB;QACvB,gBAAgB;IACpB;IACA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;IACA;QACI,mBAAmB;QACnB,wBAAwB;IAC5B;IACA;QACI,UAAU;QACV,gBAAgB;IACpB;IACA;QACI,eAAe;IACnB;IACA;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,iBAAiB;QACjB,eAAe;IACnB;IACA;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,oBAAoB;IACxB;IACA,oGAAoG;IACpG;QACI,mBAAmB;IACvB;IACA;QACI,kBAAkB;QAClB,mBAAmB;QACnB,WAAW;QACX,iBAAiB;IACrB;IACA;QACI,qBAAqB;QACrB,WAAW;QACX,YAAY;QACZ,kBAAkB;IACtB;IACA;QACI,sBAAsB;QACtB,kBAAkB;QAClB,sBAAsB;QACtB,gBAAgB;QAChB,wBAAwB;IAC5B;IACA;QACI,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,eAAe;QACf,eAAe;QACf,WAAW;IACf;IACA;QACI,mBAAmB;IACvB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,QAAQ;QACR,SAAS;QACT,OAAO;QACP,YAAY;QACZ,WAAW;QACX,WAAW;IACf;IACA;QACI,mBAAmB;QACnB,mBAAmB;QACnB,uBAAuB;IAC3B;IACA;QACI,mBAAmB;QACnB,oBAAoB;IACxB;IACA,8FAA8F,UAAU;IACxG;QACI,aAAa;QACb,gBAAgB;IACpB;IACA;QACI,YAAY;IAChB;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,gCAAgC;IACpC;IACA;QACI,kBAAkB;IACtB;IACA;QACI,SAAS;IACb;IACA;QACI,kBAAkB;QAClB,sBAAsB;QACtB,oBAAoB;IACxB;IACA;QACI,WAAW;QACX,qBAAqB;QACrB,mBAAmB;QACnB,8BAA8B;QAC9B,aAAa;QACb,kBAAkB;QAClB,iBAAiB;IACrB;IACA;QACI,WAAW;QACX,gBAAgB;QAChB,mBAAmB;QACnB,8BAA8B;QAC9B,kBAAkB;IACtB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,QAAQ;QACR,QAAQ;IACZ;IACA;QACI,aAAa;IACjB;IACA;QACI,aAAa;IACjB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,oBAAoB;IACxB;IACA;QACI,gBAAgB;QAChB,WAAW;QACX,wBAAwB;QACxB,mBAAmB;QACnB,8BAA8B;QAC9B,aAAa;QACb,kBAAkB;QAClB,iBAAiB;IACrB;IACA;QACI,eAAe;QACf,mBAAmB;QACnB,kBAAkB;QAClB,iBAAiB;IACrB;IACA;QACI,kBAAkB;QAClB,UAAU;QACV,SAAS;IACb;IACA;QACI,qBAAqB;IACzB;IACA;QACI,gBAAgB;QAChB,iBAAiB;IACrB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,aAAa;IACjB;IACA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,SAAS;QACT,mBAAmB;QACnB,WAAW;IACf;IACA;QACI,kBAAkB;IACtB;IACA;QACI,kBAAkB;QAClB,UAAU;QACV,mBAAmB;QACnB,aAAa;QACb,2BAA2B;QAC3B,gBAAgB;QAChB,UAAU;QACV,uBAAuB;QACvB,iBAAiB;IACrB;IACA;QACI,kBAAkB;QAClB,UAAU;QACV,mBAAmB;QACnB,aAAa;QACb,2BAA2B;QAC3B,iBAAiB;IACrB;IACA;QACI,WAAW;IACf;IACA;QACI,iBAAiB;IACrB;IACA;QACI,YAAY;IAChB;IACA;QACI,YAAY;IAChB;IACA;QACI,gBAAgB;QAChB,WAAW;QACX,YAAY;IAChB;IACA;QACI,sBAAsB;QACtB,aAAa;QACb,2BAA2B;QAC3B,mBAAmB;QACnB,6BAA6B;QAC7B,iBAAiB;QACjB,eAAe;IACnB;IACA;QACI,yBAAyB;QACzB,kBAAkB;QAClB,mBAAmB;IACvB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,oBAAoB;IACxB;IACA;;QAEI,WAAW;QACX,oBAAoB;IACxB;IACA;QACI,gBAAgB;QAChB,WAAW;QACX,wBAAwB;QACxB,mBAAmB;QACnB,8BAA8B;QAC9B,aAAa;QACb,kBAAkB;QAClB,iBAAiB;IACrB;IACA;QACI,UAAU;QACV,gBAAgB;IACpB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,mBAAmB;IACvB;IACA;;QAEI,wBAAwB;QACxB,aAAa;IACjB;IACA;QACI,WAAW;QACX,mBAAmB;QACnB,mBAAmB;QACnB,uBAAuB;IAC3B;IACA;QACI,kBAAkB;IACtB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,YAAY;IAChB;IACA;QACI,SAAS;IACb;IACA;QACI,SAAS;IACb;IACA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,kBAAkB;IACtB;IACA;QACI,SAAS;IACb;AACJ;AACA;;;;IAII,gBAAgB;IAChB,wBAAwB;AAC5B;AACA;IACI,aAAa;AACjB;AACA;IACI,wEAAwE;IACxE,iCAAiC;IACjC,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,SAAS;IACT,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,gCAAgC;AACpC;AACA;IACI,aAAa;AACjB;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,eAAe;AACnB;;AAEA;IACI;QACI,eAAe;QACf,kBAAkB;QAClB,SAAS;QACT,WAAW;IACf;AACJ;AACA;IACI,kHAAkH;IAClH,4BAA4B;IAC5B,2BAA2B;IAC3B,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,qBAAqB;AACzB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;AACb;AACA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;IACnB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,YAAY;IACZ,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;IACnC,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,WAAW;IACX,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,0DAAsX;IACtX,4BAA4B;IAC5B,2BAA2B;IAC3B,0BAA0B;IAC1B,WAAW;IACX,YAAY;IACZ,qBAAqB;AACzB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA,iBAAiB;AACjB;IACI,qBAAqB;AACzB;AACA;IACI,iBAAiB;IACjB,yBAAyB;AAC7B;AACA;IACI,SAAS;IACT,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,UAAU;AACd;AACA;IACI,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,SAAS;IACT,+BAA+B;IAC/B,gCAAgC;AACpC;AACA;IACI,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,WAAW;IACX,qBAAqB;AACzB;AACA;IACI,gBAAgB;IAChB,UAAU;IACV,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,UAAU;IACV,kBAAkB;AACtB;AACA;IACI,UAAU;IACV,SAAS;IACT,gBAAgB;AACpB;AACA;;IAEI,mBAAmB;IACnB,WAAW;IACX,qBAAqB;IACrB,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;;IAEI,mBAAmB;IACnB,WAAW;IACX,qBAAqB;AACzB;AACA;IACI,SAAS;IACT,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;IAC3B,YAAY;IACZ,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;AACzB;AACA;IACI,UAAU;AACd;AACA;IACI,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;AAChB;AACA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,aAAa;AACjB;AACA;IACI,QAAQ;IACR,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,kCAAkC;IAClC,mCAAmC;IACnC,gCAAgC;AACpC;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,uBAAuB;IACvB,oCAAoC;AACxC;AACA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;AACzB;AACA;IACI,uBAAuB;IACvB,yBAAyB;AAC7B;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,WAAW;AACf;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,mBAAmB;IACnB,OAAO;AACX;AACA;IACI,WAAW;AACf;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,iBAAiB;AACrB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,SAAS;IACT,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IAKZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,gCAAgC;AACpC;AACA;IACI;gBACY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gCAAgC;IAChC,OAAO;AACX;AACA;IACI,mBAAmB;AACvB;AACA;IACI,SAAS;AACb;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IAKX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,+BAA+B;IAC/B,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,gBAAgB;AACpB;AACA;IACI,SAAS;AACb;;AAEA,eAAe;AACf;IACI,mCAAmC;IACnC,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,gCAAgC;AACpC;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;AACtB;AACA;IACI,aAAa;AACjB;AACA;IACI,uHAAuH;IACvH,2BAA2B;IAC3B,4BAA4B;AAChC;AACA;IACI,6HAA6H;IAC7H,2BAA2B;IAC3B,4BAA4B;AAChC;AACA;IACI,mHAAmH;IACnH,2BAA2B;IAC3B,4BAA4B;AAChC;AACA;IACI,qHAAqH;IACrH,2BAA2B;IAC3B,4BAA4B;AAChC;AACA;IACI,uHAAuH;IACvH,2BAA2B;IAC3B,4BAA4B;AAChC;AACA;IACI,mHAAmH;IACnH,2BAA2B;IAC3B,4BAA4B;AAChC;AACA;IACI,oHAAoH;IACpH,2BAA2B;IAC3B,4BAA4B;AAChC;AACA;IACI,oHAAoH;IACpH,2BAA2B;IAC3B,4BAA4B;AAChC;AACA;IACI,sHAAsH;IACtH,2BAA2B;IAC3B,4BAA4B;AAChC;AACA;IACI,yHAAyH;IACzH,2BAA2B;IAC3B,4BAA4B;AAChC;AACA;IACI,wHAAwH;IACxH,2BAA2B;IAC3B,4BAA4B;AAChC;AACA;IACI,uHAAuH;IACvH,2BAA2B;IAC3B,4BAA4B;AAChC;AACA;IACI,sHAAsH;IACtH,2BAA2B;IAC3B,4BAA4B;AAChC;AACA;IACI,oHAAoH;IACpH,2BAA2B;IAC3B,4BAA4B;AAChC;AACA;IACI,kHAAkH;IAClH,2BAA2B;IAC3B,4BAA4B;AAChC;AACA;IACI,oHAAoH;IACpH,2BAA2B;IAC3B,4BAA4B;AAChC;AACA;IACI,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,UAAU;AACd;AACA;IACI,+CAA+C;IAC/C,mCAAmC;IACnC,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,4BAA4B;IAC5B,eAAe;IACf,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,oBAAoB;AACxB;AACA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,UAAU;AACd;AACA;IACI,qBAAqB;AACzB;AACA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,8BAA8B;AAClC;AACA;IACI,8BAA8B;AAClC;AACA;IACI,aAAa;IACb,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,SAAS;IACT,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,wBAAwB;IACxB,gCAAgC;IAChC,6BAA6B;IAC7B,4BAA4B;IAC5B,2BAA2B;AAC/B;AACA;IACI,WAAW;IACX,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,SAAS;IACT,MAAM;IACN,YAAY;IACZ,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,WAAW;IACX,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,SAAS;IACT,MAAM;IACN,YAAY;IACZ,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,wBAAwB;IACxB,iBAAiB;AACrB;AACA;IACI,4BAA4B;AAChC;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;IACA;QACI,4BAA4B;IAChC;IACA;QACI,2BAA2B;IAC/B;IACA;QACI,UAAU;IACd;IACA;QACI,SAAS;IACb;IACA;QACI,SAAS;IACb;AACJ;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,0BAA0B;IAC1B,0BAA0B;AAC9B;AACA;IACI,eAAe;IACf,eAAe;AACnB;AACA;IACI,aAAa;AACjB;AACA;;IAMI,wBAAwB;AAC5B;AACA;IACI,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,aAAa;AACjB;AACA;IACI,SAAS;IACT,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,SAAS;IACT,UAAU;AACd;AACA;IACI,iBAAiB;AACrB;AACA;IACI,aAAa;AACjB;AACA;IACI,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;AACzB;AACA;IACI,6BAA6B;IAG7B,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,oCAAoC;AACxC;AACA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,oCAAoC;AACxC;;AAEA,wCAAwC,iBAAiB,CAAC;;AAE1D;IACI,0BAA0B;IAC1B,0BAA0B;AAC9B;AACA;IACI,eAAe;IACf,eAAe;AACnB;AACA;;IAMI,wBAAwB;AAC5B;AACA;;IAMI,wBAAwB;AAC5B;AACA;IAKI,aAAa;AACjB;AACA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,SAAS;AACb;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;AAC9B;AACA;;IAEI,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;AAC1B;AACA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,0BAA0B;IAC1B,iBAAiB;AACrB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,iBAAiB;AACrB;AACA;IACI,cAAc;AAClB;AACA;IACI,WAAW;AACf;AACA;IACI,YAAY;AAChB;AACA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,eAAe;AACnB;AACA;IACI,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,qBAAqB;IACrB,gCAAgC;IAChC,UAAU;AACd;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,8BAA8B;AAClC;AACA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,oCAAoC;IACpC,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,iCAAiC;IACjC,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,4BAA4B;AAChC;AACA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,YAAY;AAChB;AACA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,4BAA4B;IAC5B,gCAAgC;AACpC;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,OAAO;IACP,QAAQ;IACR,mBAAmB;IACnB,YAAY;IACZ,gCAAgC;IAChC,UAAU;AACd;AACA;IACI,aAAa;IACb,UAAU;AACd;AACA,sSAAsS;AACtS;IACI,qBAAqB;AACzB;AACA,0HAA0H;;AAE1H;IACI;QACI,sBAAsB;IAC1B;IACA;;QAEI,WAAW;IACf;IACA;;QAEI,gBAAgB;QAChB,gBAAgB;QAChB,yBAAyB;QACzB,4BAA4B;QAC5B,0BAA0B;QAC1B,6BAA6B;IACjC;IACA;;QAEI,4BAA4B;QAC5B,6BAA6B;QAC7B,2BAA2B;QAC3B,4BAA4B;IAChC;IACA;QACI,0BAA0B;QAC1B,0CAA0C;QAC1C,yBAAyB;QACzB,yCAAyC;IAC7C;AACJ;AACA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,wBAAwB;IACxB,uBAAuB;AAC3B;AACA,uDAAuD,uBAAuB,CAAC,gBAAgB,CAAC;AAChG;IACI,oBAAoB;IACpB,4BAA4B;AAChC;AACA;IACI,uBAAuB;IACvB,YAAY;IACZ,0BAA0B;IAC1B,iBAAiB;AACrB;AACA,oDAAoD,YAAY,CAAC,YAAY,CAAC;AAC9E,mEAAmE,YAAY,CAAC;AAChF,uDAAuD,YAAY,CAAC;;AAEpE;IACI,sBAAsB;AAC1B;AACA;IACI,sBAAsB;IACtB,mHAAmH;IACnH,WAAW;IACX,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,UAAU;AACd;AACA;IACI,aAAa;AACjB;AACA;IACI,SAAS;AACb;AACA;IACI,SAAS;AACb;AACA;IACI,WAAW;AACf;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;AACzB;AACA,yBAAyB;;AAEzB;IACI,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,aAAa;AACjB;AACA;IACI,qBAAqB;AACzB;AACA;;IAEI,wBAAwB;IACxB,SAAS;AACb;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,eAAe;AACnB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,eAAe;AACnB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,WAAW;IACX,eAAe;IAKf,gCAAgC;AACpC;AACA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,eAAe;AACnB;AACA;IACI,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,eAAe;AACnB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,SAAO;AACX;AACA;IACI,eAAe;IACf,WAAW;AACf;AACA;IACI,oCAAoC;IACpC,gCAAgC;IAChC,oBAAoB;AACxB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAO;IACP,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,iBAAiB;AACrB;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;IACZ,YAAY;AAChB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,UAAU;IACV,SAAS;AACb;AACA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,MAAM;IACN,SAAS;IACT,UAAU;AACd;AACA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,yBAAyB;IACzB,eAAe;AACnB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,eAAe;IACf,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,cAAc;AAClB;AACA;IACI,kCAAkC;IAClC,mCAAmC;AACvC;AACA;IACI,mBAAmB;AACvB;AACA;IACI,+BAA+B;AACnC;AACA;;IAEI,yBAAyB;IACzB,YAAY;AAChB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;AAC7B;AACA;IACI,oBAAoB;AACxB;AACA;;IAEI,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;IACrB,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,cAAc;IACd,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,aAAa;AACjB;AACA;IACI,cAAc;IACd,yBAAyB;IACzB,0BAA0B;IAC1B,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,qBAAqB;IACrB,gBAAgB;IAChB,UAAU;IACV,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,sBAAsB;IACtB,0BAA0B;IAC1B,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,+CAA+C;IAC/C,0BAA0B;IAC1B,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,UAAU;IACV,SAAS;IACT,UAAU;IACV,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,cAAc;AAClB;AACA;IACI,WAAW;IACX,WAAW;IACX;gBACY;AAChB;AACA;IACI,gBAAgB;IAChB,UAAU;AACd;AACA;IACI,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,qBAAqB;IACrB,WAAW;IACX,qBAAqB;AACzB;AACA;;IAEI,cAAc;AAClB;AACA;IACI,aAAa;AACjB;AACA;IACI,4BAA4B;AAChC;AACA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,qBAAqB;IACrB,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,+CAA+C;IAC/C,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,WAAW;IAKX,gCAAgC;IAChC,YAAY;AAChB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;AACjB;AACA;IACI;4BACwB;IACxB,yBAAyB;IACzB,mBAAmB;IACnB,UAAU;IACV,0BAA0B;IAC1B,YAAY;AAChB;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,cAAc;AAClB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,SAAS;AACb;AACA;IACI,qBAAqB;AACzB;AACA;IACI,oGAAoG;IACpG,YAAY;IACZ,WAAW;AACf;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,OAAO;IACP,SAAS;IACT,0BAA0B;IAC1B,YAAY;AAChB;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,QAAQ;IACR,UAAU;IACV,kBAAkB;IAClB,eAAe;IACf,WAAW;AACf;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,WAAW;AACf;AACA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,yDAA+O;AACnP;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,6BAA6B;AACjC;AACA;IACI,gBAAgB;IAChB,iCAAiC;IACjC,2BAA2B;IAC3B,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,gCAAgC;IAChC,eAAe;IACf,YAAY;AAChB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,qBAAqB;AACzB;AACA;IACI,mBAAmB;IACnB,YAAY;IACZ,WAAW;AACf;AACA;IACI,mBAAmB;AACvB;AACA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,2BAA2B;IAC3B,0GAA0G;AAC9G;AACA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,YAAY;AAChB;AACA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,yDAAiR;IACjR,4BAA4B;IAC5B,sCAAsC;IACtC,0BAA0B;IAC1B,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,iBAAiB;IACjB,WAAW;IACX,YAAY;AAChB;AACA;IACI,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;IAClB,+BAA+B;IAC/B,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;AACvB;AACA;IAKI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IAKZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IAKI,SAAO;IACP,SAAS;IACT,eAAe;AACnB;AACA;IACI,eAAe;IACf,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,MAAM;IACN,SAAS;IACT,YAAY;IAKZ,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,2BAA2B;AAC/B;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,MAAM;IACN,SAAS;IACT,YAAY;IACZ,uBAAuB;IACvB,UAAU;IACV,gCAAgC;AACpC;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,OAAO;IACP,SAAS;IACT,QAAQ;IACR,MAAM;IACN,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,OAAO;IACP,SAAS;IACT,QAAQ;IACR,MAAM;IACN,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,UAAU;IACV,WAAW;IACX,yBAAyB;AAC7B;AACA;IACI,eAAe;IACf,0CAA0C;IAC1C,yCAAyC;AAC7C;AACA;IACI,WAAW;IACX,eAAe;AACnB;AACA;IACI,YAAY;IACZ,aAAa;IACb,mCAAmC;AACvC;AACA;IACI,qBAAqB;AACzB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,oBAAoB;AACxB;AACA;IACI,SAAS;AACb;AACA;IACI,gCAAgC;IAChC,kBAAkB;AACtB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,aAAa;AACjB;AACA;IACI,qBAAqB;IACrB,wBAAwB;IACxB,WAAW;IACX,eAAe;IACf,gCAAgC;AACpC;AACA;IACI,WAAW;AACf;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,cAAc;AAClB;AACA;IACI,YAAY;AAChB;AACA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,mCAAmC;IACnC,wBAAwB;IACxB,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,oBAAoB;IACpB,mBAAmB;AACvB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,mHAAmH;IACnH,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,uBAAuB;AAC3B;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,SAAS;IACT,MAAM;IACN,YAAY;IACZ,UAAU;AACd;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAKlB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,eAAe;IACf,SAAS;AACb;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,qBAAqB;AACzB;AACA;IACI,cAAc;IACd,0BAA0B;AAC9B;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,oBAAoB;IACpB,WAAW;IACX,mBAAmB;IACnB,gCAAgC;IAChC,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,mBAAmB;AACvB;AACA;IACI;gBACY;IACZ,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;AACrB;AACA;;;;wHAIwH;AACxH;IACI,WAAW;IACX,qBAAqB;AACzB;AACA;IACI,cAAc;AAClB;AACA;IACI,kBAAkB;IAKlB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,wIAAwI;IACxI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IAKjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;AACA;IAKI,SAAO;AACX;AACA;IACI,WAAW;IACX;YACQ;IACR,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;IAKT,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,mBAAmB;IAKnB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,8BAA8B;IAC9B,gBAAgB;AACpB;AACA;IAKI,SAAO;AACX;AACA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,qBAAqB;IACrB,cAAc;AAClB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,WAAW;IACX,qBAAqB;AACzB;AACA;IACI,cAAc;AAClB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,gCAAgC;AACpC;AACA;IACI,0BAA0B;IAC1B,kBAAkB;AACtB;AACA;IACI,wBAAwB;IACxB,gCAAgC;AACpC;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,cAAc;AAClB;AACA;IACI,qBAAqB;AACzB;AACA;IAKI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;AACA;IACI,SAAO;AACX;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,qBAAqB;AACzB;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,iCAAiC;AACrC;AACA;IACI,aAAa;AACjB;AACA;IACI,gCAAgC;AACpC;AACA;IACI,eAAe;AACnB;AACA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,cAAc;AAClB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,WAAW;IACX,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,MAAM;AACV;AACA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;AACf;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,MAAM;IACN,SAAS;IACT,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IAKZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,gCAAgC;AACpC;AACA;IACI;gBACY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gCAAgC;IAChC,OAAO;AACX;AACA;IACI,mBAAmB;AACvB;AACA;IACI,SAAS;AACb;AACA;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;AACA;IACI,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,sBAAsB;IACtB,cAAc;IACd,eAAe;AACnB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;IAEI,eAAe;IACf,WAAW;IACX,WAAW;IACX,wBAAwB;IACxB,8BAA8B;IAC9B,kBAAkB;IAClB,iBAAiB;IACjB,gCAAgC;AACpC;AACA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gCAAgC;AACpC;AACA;IACI,0BAA0B;IAC1B,cAAc;AAClB;AACA;IACI,wIAAwI;IACxI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,cAAc;IACd,eAAe;AACnB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,gCAAgC;IAChC,mBAAmB;IACnB,oBAAoB;AACxB;AACA;;IAEI,mCAAmC;IACnC,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;AACjB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,YAAY;AAChB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,YAAY;IAKZ,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,uBAAuB;AAC3B;AACA;IAKI,SAAO;IAKP,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAKlB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IAKI,SAAO;IAKP,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;AACvB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,aAAa;IACb,qBAAqB;IACrB,WAAW;IACX,YAAY;AAChB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;AACA;;IAEI,eAAe;IACf,qBAAqB;IACrB,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IAKnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gCAAgC;AACpC;AACA;;IAEI,mBAAmB;AACvB;AACA;;IAEI,kBAAkB;AACtB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,kHAAkH;IAClH,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;AACA;IAKI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,oBAAoB;AACxB;AACA;;IAEI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;;IAEI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,gCAAgC;IAChC,kBAAkB;AACtB;AACA;;IAEI,yBAAyB;AAC7B;AACA;;IAEI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,SAAS;IACT,MAAM;IACN,YAAY;IACZ;YACQ;AACZ;AACA;;IAEI,6FAA6F;AACjG;AACA;;;IAGI,8GAA8G;IAC9G,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;;;IAGI,mHAAmH;IACnH,UAAU;AACd;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,YAAY;AAChB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;AACxB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,mCAAmC;IACnC,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;AACjB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,iCAAiC;IACjC,aAAa;IACb,8BAA8B;IAC9B,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,gBAAgB;AACpB;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,gBAAgB;AACpB;AACA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB;AACA;;IAEI,mBAAmB;IACnB,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,yBAAyB;AAC7B;AACA;AACA;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,UAAU;IACV,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,qBAAqB;IACrB,mBAAmB;IACnB,WAAW;IACX,uBAAuB;IACvB,qBAAqB;IACrB,gBAAgB;AACpB;AACA;IACI,0BAA0B;IAC1B,cAAc;AAClB;AACA;IACI,cAAc;IACd,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,8BAA8B;AAClC;AACA;IACI,oBAAoB;IACpB,+BAA+B;IAC/B,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,yBAAyB;AAC7B;AACA;IACI,UAAU;IACV,YAAY;AAChB;AACA;IACI,iCAAiC;IACjC,oCAAoC;AACxC;AACA;IACI,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,SAAS;IACT,QAAQ,EAAE,0BAA0B;AACxC;AACA;IACI,aAAa;AACjB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,uBAAuB;AAC3B;AACA;IACI,yBAAyB;IACzB,oBAAoB;IACpB,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;IACvB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,qBAAqB;AACzB;AACA;IACI,0BAA0B;IAC1B,cAAc;AAClB;AACA;;IAEI,cAAc;IACd,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,iBAAiB;IACjB,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,6BAA6B;IAC7B,iBAAiB;IACjB,aAAa;IACb,kCAAkC;IAClC,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,+BAA+B;AACnC;AACA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,WAAW;AACf;AACA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;AACA;IACI,YAAY;IACZ,YAAY;IAKZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,gCAAgC;AACpC;AACA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;AACA;IACI;gBACY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gCAAgC;IAChC,OAAO;AACX;AACA;IACI,SAAS;AACb;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mCAAmC;IACnC,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;AACjB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;AACxB;AACA;IACI,gBAAgB;AACpB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IAKI,SAAO;IACP,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,YAAY;IAKZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,YAAY;AAChB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,mCAAmC;IACnC,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IAKb,aAAa;IACb,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,kBAAkB;AACtB;AACA;IACI,gCAAgC;AACpC;AACA;IACI,sBAAsB;IAKtB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,+BAA+B;IAC/B,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,gHAAgH;IAChH,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,QAAQ;IACR,MAAM;IACN,YAAY;AAChB;AACA;IACI,WAAW;IACX,gHAAgH;IAChH,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,QAAQ;IACR,MAAM;IACN,YAAY;AAChB;AACA;IACI,WAAW;IACX,uHAAuH;IACvH,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,QAAQ;IACR,MAAM;IACN,YAAY;AAChB;AACA;IACI,WAAW;IACX,qHAAqH;IACrH,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,QAAQ;IACR,MAAM;IACN,YAAY;AAChB;AACA;IACI,WAAW;IACX,kHAAkH;IAClH,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,QAAQ;IACR,MAAM;IACN,YAAY;AAChB;AACA;IACI,WAAW;IACX,kHAAkH;IAClH,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,QAAQ;IACR,MAAM;IACN,YAAY;AAChB;AACA;IACI,WAAW;IACX,uHAAuH;IACvH,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,QAAQ;IACR,MAAM;IACN,YAAY;AAChB;AACA;IACI,WAAW;IACX,kHAAkH;IAClH,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,QAAQ;IACR,MAAM;IACN,YAAY;AAChB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,SAAS;AACb;AACA;IAKI,SAAO;IAKP,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;AACtB;AACA;IACI,aAAa;AACjB;AACA;IACI,eAAe;AACnB;AACA;IACI,YAAY;AAChB;AACA;IACI,oBAAoB;IACpB,eAAe;AACnB;AACA;IACI,cAAc;IACd,gCAAgC;AACpC;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;IACd,gCAAgC;AACpC;AACA;IACI,cAAc;AAClB;AACA;IACI,mCAAmC;IACnC,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,0BAA0B;AAC9B;AACA;IACI,eAAe;AACnB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,YAAY;IACZ,mBAAmB;IACnB,UAAU;IACV,YAAY;AAChB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,WAAW;AACf;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;;IAEI,gBAAgB;AACpB;AACA;IACI,mCAAmC;IACnC,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;AACjB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,yBAAyB;AAC7B;AACA;IACI,4BAA4B;AAChC;AACA;IACI,eAAe;AACnB;AACA;IACI,mCAAmC;IACnC,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;AACxB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,eAAe;AACnB;AACA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,WAAW;AACf;AACA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,mCAAmC;IACnC,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;AACjB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;AACxB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,eAAe;AACnB;AACA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,WAAW;AACf;AACA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,sIAAsI;IACtI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,QAAQ;IACR,MAAM;IACN,YAAY;AAChB;AACA;IACI,WAAW;IACX,uHAAuH;IACvH,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,YAAY;AAChB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,SAAO;IACP,iBAAiB;AACrB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,iBAAiB;AACrB;AACA;IACI,+BAA+B;AACnC;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,MAAM;AACV;AACA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,qBAAqB;AACzB;AACA;IACI,cAAc;IACd,0BAA0B;AAC9B;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,iBAAiB;AACrB;AACA;IACI,+BAA+B;AACnC;AACA;IACI,+BAA+B;AACnC;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,qBAAqB;AACzB;AACA;IACI,cAAc;IACd,0BAA0B;AAC9B;AACA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,qBAAqB;AACzB;AACA;IACI,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,4BAA4B;AAChC;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,cAAc;AAClB;AACA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;IACT,YAAY;IACZ,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;AACA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,uBAAuB;IACvB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,oBAAoB;IACpB,qBAAqB;IACrB,WAAW;AACf;AACA;IACI,qBAAqB;IACrB,WAAW;AACf;AACA;IACI,sBAAsB;IACtB,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,eAAe;IACf,WAAW;AACf;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,sIAAsI;IACtI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;AAC7B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,WAAW;IACX,6BAA6B;IAC7B,iBAAiB;AACrB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,eAAe;AACnB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;IACd,wCAAwC;AAC5C;AACA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;AACf;AACA;IACI,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;AACzB;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,yBAAyB;AAC7B;AACA;IACI,YAAY;AAChB;AACA;;IAEI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,0DAAmW;IACnW,4BAA4B;IAC5B,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,qBAAqB;QACrB,oBAAoB;QACpB,mBAAmB;IACvB;IACA;QACI,WAAW;IACf;IACA;QACI,WAAW;IACf;IACA;QACI,gBAAgB;IACpB;IACA;QACI,sBAAsB;QACtB,mBAAmB;QACnB,sBAAsB;IAC1B;IACA;QACI,sBAAsB;QACtB,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,mBAAmB;IACvB;IACA;QACI,eAAe;QACf,UAAU;IACd;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,iBAAiB;IACrB;IACA;QAKI,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,mBAAmB;QACnB,kBAAkB;QAClB,eAAe;IACnB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,WAAW;QACX,mBAAmB;IACvB;AACJ;AACA;IACI;QACI,sBAAsB;QACtB,kBAAkB;IACtB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,sBAAsB;QACtB,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;IACA;QACI,iBAAiB;IACrB;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,WAAW;QACX,oBAAoB;QACpB,mBAAmB;IACvB;IACA;QACI,WAAW;QACX,WAAW;QACX,WAAW;QACX,mBAAmB;QACnB,kBAAkB;QAClB,WAAW;QACX,SAAS;QACT,SAAS;QACT,OAAO;IACX;IACA;QACI,UAAU;IACd;IACA;QACI,mBAAmB;IACvB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,kBAAkB;QAKlB,SAAO;IACX;IACA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;IACA;QACI,WAAW;IACf;IACA;QACI,WAAW;IACf;IACA;QACI,mBAAmB;QACnB,kBAAkB;IACtB;IACA;QACI,WAAW;QACX,iBAAiB;QACjB,mBAAmB;IACvB;IACA;QACI,SAAS;QACT,QAAQ;QACR,WAAW;QACX,WAAW;QACX,SAAS;IACb;IACA;QACI,UAAU;QACV,kBAAkB;IACtB;IACA;QACI,WAAW;QACX,SAAS;QACT,OAAO;IACX;IACA;QACI,WAAW;IACf;IACA;QACI,mBAAmB;QACnB,mBAAmB;QACnB,WAAW;QACX,sBAAsB;IAC1B;IACA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;IACA;QACI,kBAAkB;QAClB,uBAAuB;QACvB,eAAe;IACnB;IACA;QACI,UAAU;QACV,gBAAgB;QAChB,gBAAgB;QAChB,yBAAyB;QACzB,gBAAgB;IACpB;IACA;QACI,aAAa;QACb,gBAAgB;IACpB;IACA;QACI,SAAS;QACT,mBAAmB;QACnB,8BAA8B;QAC9B,aAAa;QACb,kBAAkB;QAClB,iBAAiB;IACrB;IACA;QACI,gBAAgB;QAChB,sBAAsB;QACtB,oBAAoB;IACxB;IACA;QACI,WAAW;QACX,gBAAgB;QAChB,8BAA8B;IAClC;IACA;QACI,WAAW;QACX,qBAAqB;QACrB,mBAAmB;QACnB,8BAA8B;QAC9B,aAAa;QACb,kBAAkB;QAClB,iBAAiB;IACrB;IACA;QACI,WAAW;QACX,SAAS;QACT,mBAAmB;QACnB,8BAA8B;QAC9B,aAAa;QACb,kBAAkB;QAClB,iBAAiB;IACrB;IACA;QACI,YAAY;QACZ,gBAAgB;IACpB;IACA;QACI,aAAa;IACjB;IACA;QACI,gBAAgB;QAChB,WAAW;QACX,wBAAwB;QACxB,mBAAmB;QACnB,8BAA8B;QAC9B,aAAa;QACb,kBAAkB;QAClB,iBAAiB;IACrB;IACA;QACI,qBAAqB;QACrB,UAAU;QACV,gBAAgB;IACpB;IACA;QACI,aAAa;IACjB;IACA;QACI,WAAW;QACX,uBAAuB;QACvB,mBAAmB;QACnB,8BAA8B;QAC9B,aAAa;QACb,iBAAiB;IACrB;IACA;QACI,SAAS;IACb;IACA;QACI,mBAAmB;IACvB;IACA;;QAEI,mBAAmB;IACvB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,SAAS;IACb;IACA;QACI,SAAS;IACb;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,YAAY;QACZ,SAAS;QACT,aAAa;QACb,eAAe;QACf,gBAAgB;QAChB,oBAAoB;IACxB;IACA;QACI,SAAO;QACP,aAAa;QACb,sBAAsB;QACtB,kBAAkB;IACtB;IACA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,0CAA0C;QAC1C,yCAAyC;IAC7C;IACA;QACI,sBAAsB;QACtB,kBAAkB;IACtB;IACA;QACI,8BAA8B;IAClC;IACA;QACI,gBAAgB;IACpB;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,aAAa;IACjB;IACA;QACI,iBAAiB;QACjB,SAAS;IACb;IACA;QACI,YAAY;QACZ,oBAAoB;QACpB,gBAAgB;QAChB,SAAS;QACT,gBAAgB;QAChB,2CAA2C;QAC3C,gBAAgB;IACpB;IACA;QACI,UAAU;QACV,wBAAwB;QACxB,sBAAsB;IAC1B;IACA;QACI,kBAAkB;QAClB,gCAAgC;IACpC;IACA;QACI,aAAa;QACb,mBAAmB;QACnB,8BAA8B;QAC9B,YAAY;QACZ,eAAe;QACf,gCAAgC;QAChC,kBAAkB;QAClB,UAAU;IACd;IACA;QACI,SAAS;QACT,kBAAkB;QAClB,mBAAmB;IACvB;IACA;QAKI,SAAO;QACP,SAAS;QACT,kBAAkB;IACtB;IACA;QACI,WAAW;QACX,kBAAkB;QAClB,OAAO;QACP,MAAM;QACN,SAAS;QACT,YAAY;QACZ,YAAY;QACZ,mBAAmB;IACvB;IACA;QACI,oBAAoB;QACpB,sBAAsB;QACtB,YAAY;QACZ,kBAAkB;IACtB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,mBAAmB;QACnB,gBAAgB;QAChB,aAAa;QACb,WAAW;IACf;IACA;QACI,aAAa;IACjB;IACA;QACI,0BAA0B;QAC1B,2BAA2B;IAC/B;IACA;QACI,YAAY;QACZ,UAAU;QACV,oBAAoB;IACxB;IACA,2CAA2C;IAC3C;QACI,yBAAyB;IAC7B;IACA;QACI,kBAAkB;QAClB,QAAQ;QACR,MAAM;QACN,UAAU;QACV,SAAS;QACT,yBAAyB;QACzB,aAAa;QACb,cAAc;QACd,gBAAgB;IACpB;IACA;QACI,oBAAoB;IACxB;IACA;QACI,oBAAoB;QACpB,aAAa;QACb,sBAAsB;QACtB,YAAY;IAChB;IACA;QACI,mBAAmB;QACnB,6BAA6B;QAC7B,kBAAkB;QAClB,uBAAuB;QACvB,mBAAmB;IACvB;IACA;QACI,iBAAiB;QACjB,mBAAmB;QACnB,kBAAkB;QAClB,qBAAqB;QACrB,WAAW;QACX,cAAc;QACd,gBAAgB;QAChB,yBAAyB;QACzB,gCAAgC;IACpC;IACA;QACI,mBAAmB;QACnB,WAAW;IACf;IACA;QACI,qBAAqB;QACrB,yBAAyB;QACzB,cAAc;QACd,gBAAgB;QAChB,gCAAgC;QAChC,cAAc;IAClB;IACA;QACI,cAAc;IAClB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,gBAAgB;QAChB,iBAAiB;IACrB;IACA;QACI,qBAAqB;IACzB;IACA;QACI,oBAAoB;QACpB,cAAc;IAClB;IACA;QACI,mBAAmB;QACnB,mBAAmB;IACvB;IACA;QACI,cAAc;QACd,mBAAmB;IACvB;IACA;QACI,YAAY;IAChB;IACA;QACI,YAAY;IAChB;IACA;QAKI,SAAO;QACP,gBAAgB;IACpB;IACA;QAKI,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,mBAAmB;QACnB,kBAAkB;QAClB,eAAe;QACf,mBAAmB;QACnB,cAAc;QACd,eAAe;IACnB;IACA;QACI,aAAa;QACb,mBAAmB;IACvB;IACA;QACI,eAAe;QACf,yBAAyB;QACzB,iBAAiB;QACjB,WAAW;QACX,gCAAgC;IACpC;IACA;QACI,mCAAmC;IACvC;IACA;QACI,oBAAoB;IACxB;IACA;QACI,mBAAmB;QACnB,eAAe;QACf,SAAS;QACT,OAAO;QACP,QAAQ;QACR,WAAW;QACX,+BAA+B;IACnC;IACA;QAKI,kCAAkC;IACtC;IACA;QACI,WAAW;QACX,oBAAoB;QACpB,mBAAmB;IACvB;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,SAAS;QACT,oBAAoB;IACxB;IACA;QACI,kBAAkB;QAClB,uBAAuB;QACvB,aAAa;QACb,sBAAsB;QACtB,mBAAmB;IACvB;IACA;QACI,kBAAkB;QAClB,WAAW;QACX,QAAQ;IACZ;IACA;QACI,kBAAkB;QAClB,UAAU;QACV,WAAW;QACX,MAAM;QACN,gBAAgB;IACpB;IACA;QACI,SAAS;IACb;IACA;QACI,qBAAqB;IACzB;IACA;QACI,qBAAqB;IACzB;IACA;QACI,kBAAkB;QAClB,SAAS;QACT,QAAQ;QACR,gBAAgB;QAChB,iCAAiC;QACjC,aAAa;QACb,sBAAsB;QACtB,YAAY;QACZ,kBAAkB;QAClB,gBAAgB;QAChB,UAAU;QACV,WAAW;QACX,gCAAgC;QAChC,wCAAwC;QACxC,qCAAqC;QACrC,oCAAoC;QACpC,mCAAmC;IACvC;IACA;QACI,SAAS;QACT,UAAU;QACV,UAAU;IACd;IACA;QACI,sBAAsB;QACtB,2BAA2B;QAC3B,mBAAmB;QACnB,eAAe;QACf,qBAAqB;QACrB,WAAW;QACX,iBAAiB;QACjB,uBAAuB;QACvB,2BAA2B;QAC3B,kBAAkB;QAClB,UAAU;QACV,oBAAoB;QACpB,mCAAmC;QACnC,gCAAgC;QAChC,+BAA+B;QAC/B,8BAA8B;QAC9B,qBAAqB;IACzB;IACA;QACI,WAAW;QACX,oCAAoC;IACxC;IACA;QACI,WAAW;QACX,YAAY;QACZ,SAAS;QACT,qBAAqB;QACrB,SAAS;QACT,QAAQ;IACZ;IACA;QACI,6BAA6B;IACjC;IACA;QACI,WAAW;QACX;qBACa;QACb,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,SAAS;QACT,QAAQ;IACZ;IACA;QACI,mBAAmB;QACnB,WAAW;IACf;IACA;QACI,+FAA+F;QAC/F,uGAAuG;IAC3G;IACA;QACI,kBAAkB;IACtB;IACA;QACI,QAAQ;QACR,QAAQ;IACZ;IACA;QACI,mBAAmB;IACvB;IACA;QACI,SAAS;IACb;IACA;QACI,QAAQ;IACZ;IACA;QACI,mBAAmB;IACvB;IACA;QACI,eAAe;QACf,WAAW;QACX,YAAY;QACZ,SAAS;QACT,YAAY;QACZ,OAAO;QACP,QAAQ;QACR,YAAY;QACZ,iBAAiB;QACjB,aAAa;QACb,sBAAsB;QACtB,gCAAgC;QAChC,wCAAwC;QACxC,qCAAqC;QACrC,oCAAoC;QACpC,mCAAmC;IACvC;IACA;QACI,MAAM;QACN,SAAS;IACb;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;IACA;QACI,iBAAiB;IACrB;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;IACA;QACI,mBAAmB;QACnB,WAAW;QACX,mBAAmB;QACnB,8BAA8B;QAC9B,gBAAgB;QAChB,mBAAmB;IACvB;IACA;QACI,2BAA2B;IAC/B;IACA;QACI,kBAAkB;IACtB;IACA;QACI,kBAAkB;QAClB,aAAa;QACb,gCAAgC;IACpC;IACA;QACI,QAAQ;IACZ;IACA;QACI,WAAW;QACX,YAAY;QACZ,gBAAgB;QAChB,kBAAkB;QAClB,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,qBAAqB;QACrB,WAAW;QACX,eAAe;IACnB;IACA;QACI,UAAU;QACV,WAAW;QACX,yBAAyB;IAC7B;IACA;QACI,YAAY;IAChB;IACA;QACI,mBAAmB;QACnB,mBAAmB;QACnB,uBAAuB;QACvB,gBAAgB;IACpB;IACA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,UAAU;QACV,gBAAgB;IACpB;IACA;QACI,eAAe;IACnB;IACA;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,iBAAiB;QACjB,eAAe;IACnB;IACA;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,oBAAoB;IACxB;IACA,oGAAoG;IACpG;QACI,mBAAmB;IACvB;IACA;QACI,kBAAkB;QAClB,mBAAmB;QACnB,WAAW;QACX,iBAAiB;IACrB;IACA;QACI,qBAAqB;QACrB,WAAW;QACX,YAAY;QACZ,kBAAkB;IACtB;IACA;QACI,sBAAsB;QACtB,kBAAkB;QAClB,sBAAsB;QACtB,gBAAgB;QAChB,wBAAwB;IAC5B;IACA;QACI,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,eAAe;QACf,eAAe;IACnB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,QAAQ;QACR,SAAS;QACT,OAAO;QACP,YAAY;QACZ,WAAW;QACX,WAAW;IACf;IACA;QACI,mBAAmB;QACnB,mBAAmB;QACnB,uBAAuB;IAC3B;IACA;QACI,mBAAmB;QACnB,oBAAoB;IACxB;IACA;QACI,aAAa;QACb,gBAAgB;IACpB;IACA;QACI,YAAY;IAChB;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,gCAAgC;IACpC;IACA;QACI,kBAAkB;IACtB;IACA;QACI,SAAS;IACb;IACA;QACI,kBAAkB;QAClB,sBAAsB;QACtB,oBAAoB;IACxB;IACA;QACI,WAAW;QACX,qBAAqB;QACrB,mBAAmB;QACnB,8BAA8B;QAC9B,aAAa;QACb,kBAAkB;QAClB,iBAAiB;IACrB;IACA;QACI,WAAW;QACX,gBAAgB;QAChB,mBAAmB;QACnB,8BAA8B;QAC9B,kBAAkB;IACtB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,QAAQ;QACR,QAAQ;IACZ;IACA;QACI,aAAa;IACjB;IACA;QACI,aAAa;IACjB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,oBAAoB;IACxB;IACA;QACI,gBAAgB;QAChB,WAAW;QACX,wBAAwB;QACxB,mBAAmB;QACnB,8BAA8B;QAC9B,aAAa;QACb,kBAAkB;QAClB,iBAAiB;IACrB;IACA;QACI,eAAe;QACf,mBAAmB;QACnB,kBAAkB;QAClB,iBAAiB;IACrB;IACA;QACI,kBAAkB;QAClB,UAAU;QACV,SAAS;IACb;IACA;QACI,qBAAqB;IACzB;IACA;QACI,gBAAgB;QAChB,iBAAiB;IACrB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,aAAa;IACjB;IACA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,SAAS;QACT,mBAAmB;QACnB,WAAW;IACf;IACA;QACI,kBAAkB;IACtB;IACA;QACI,kBAAkB;QAClB,yBAAyB;QACzB,mBAAmB;QACnB,aAAa;QACb,2BAA2B;QAC3B,gBAAgB;QAChB,SAAO;QACP,uBAAuB;QACvB,iBAAiB;IACrB;IACA;QACI,kBAAkB;QAClB,YAAY;QACZ,mBAAmB;QACnB,aAAa;QACb,2BAA2B;QAC3B,iBAAiB;IACrB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,YAAY;IAChB;IACA;QACI,YAAY;IAChB;IACA;QACI,gBAAgB;QAChB,WAAW;QACX,YAAY;IAChB;IACA;QACI,sBAAsB;QACtB,aAAa;QACb,2BAA2B;QAC3B,mBAAmB;QACnB,6BAA6B;QAC7B,iBAAiB;QACjB,eAAe;IACnB;IACA;QACI,yBAAyB;QACzB,kBAAkB;QAClB,mBAAmB;IACvB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,oBAAoB;IACxB;IACA;;QAEI,WAAW;QACX,oBAAoB;IACxB;IACA,yBAAyB;IACzB;QACI,gBAAgB;QAChB,WAAW;QACX,wBAAwB;QACxB,mBAAmB;QACnB,8BAA8B;QAC9B,aAAa;QACb,kBAAkB;QAClB,iBAAiB;IACrB;IACA;QACI,UAAU;QACV,gBAAgB;IACpB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,mBAAmB;IACvB;IACA;;QAEI,wBAAwB;QACxB,aAAa;IACjB;IACA;QACI,WAAW;QACX,mBAAmB;QACnB,mBAAmB;QACnB,uBAAuB;IAC3B;IACA;QACI,kBAAkB;IACtB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,YAAY;IAChB;IACA;QACI,SAAS;IACb;IACA;QACI,SAAS;IACb;IACA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,kBAAkB;IACtB;IACA;QACI,SAAS;IACb;AACJ;;AAEA;;;;IAII,wBAAwB;AAC5B;AACA;IACI,aAAa;AACjB;AACA;IACI,wEAAwE;IACxE,iCAAiC;IACjC,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,SAAS;IACT,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,gCAAgC;AACpC;AACA;IACI,aAAa;AACjB;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,eAAe;AACnB;;AAEA;IACI;QACI,eAAe;QACf,kBAAkB;QAClB,SAAS;QACT,WAAW;IACf;AACJ;AACA;IACI,kHAAkH;IAClH,4BAA4B;IAC5B,2BAA2B;IAC3B,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,qBAAqB;AACzB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;AACb;AACA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;IACnB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,YAAY;IACZ,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;IACnC,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,WAAW;IACX,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,0DAAsX;IACtX,4BAA4B;IAC5B,2BAA2B;IAC3B,0BAA0B;IAC1B,WAAW;IACX,YAAY;IACZ,qBAAqB;AACzB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;IACb,YAAY;AAChB;AACA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,QAAQ;IACR,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,kCAAkC;IAClC,mCAAmC;IACnC,gCAAgC;AACpC;AACA,YAAY;AACZ;IACI,sBAAsB;IACtB,mHAAmH;IACnH,WAAW;IACX,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,UAAU;AACd;AACA;IACI,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;AACA;;IAEI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,MAAM;IACN,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,0DAAk4B;IACl4B,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,YAAY;IACZ,mIAAmI;IACnI,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,qIAAqI;AACzI;AACA;IACI,SAAS;AACb;AACA;IACI,SAAS;AACb;AACA;IACI,WAAW;AACf;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;AACzB;AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,8BAA8B;AAClC;AACA;IACI,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,0BAA0B;IAC1B,4BAA4B;IAC5B,gBAAgB;IAChB,wBAAwB;IACxB,YAAY;AAChB;AACA;IACI,6BAA6B;AACjC;AACA;IACI,OAAO;IACP,mCAAmC;AACvC;AACA;IACI,QAAQ;AACZ;AACA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;AACnB;AACA;;IAEI,gBAAgB;IAChB,SAAS;IACT,mCAAmC;AACvC;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,WAAW;IACX,+CAA+C;IAC/C,oBAAoB;IACpB,oBAAoB;IACpB,YAAY;AAChB;AACA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,aAAa;IACb,8BAA8B;IAC9B,eAAe;AACnB;AACA;IACI,UAAU;IACV,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,+BAA+B;IAK/B,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,8BAA8B;AAClC;AACA;IACI,SAAS;AACb;AACA;IACI,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,kHAAkH;IAClH,kBAAkB;IAClB,SAAS;IACT,QAAQ;AACZ;AACA;IACI,YAAY;IACZ,UAAU;IACV,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,gCAAgC;IAChC,eAAe;IACf,yBAAyB;IACzB,WAAW;AACf;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,qBAAqB;IACrB,iBAAiB;AACrB;AACA;IACI,2BAA2B;IAC3B,iCAAiC;IACjC,oCAAoC;IACpC,UAAU;IACV,WAAW;AACf;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,gBAAgB;AACpB;AACA;IACI,8BAA8B;AAClC;AACA;IACI,OAAO;IACP,QAAQ;IACR,SAAS;IACT,MAAM;IACN,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,WAAW;IACX,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;IACR,iCAAiC;IACjC,oCAAoC;IACpC,4BAA4B;IAC5B,YAAY;AAChB;AACA;IACI,qBAAqB;IACrB,gCAAgC;AACpC;AACA;IACI,qBAAqB;IACrB,gCAAgC;AACpC;AACA;IACI,qBAAqB;IACrB,gCAAgC;AACpC;AACA;IACI,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,SAAS;IACT,mBAAmB;IAKnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;IACnC,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;AACzB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,qBAAqB;AACzB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,4BAA4B;AAChC;AACA;IACI,mBAAmB;IACnB,+BAA+B;AACnC;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,+CAA+C;IAC/C,2BAA2B;IAC3B,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,YAAY;IACZ,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;AACzB;AACA;IACI,mBAAmB;IACnB,oCAAoC;IACpC,WAAW;AACf;AACA,6BAA6B;AAC7B;IACI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,yBAAyB;IACzB,0BAA0B;IAC1B,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,yBAAyB;IACzB,SAAS;IACT,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,cAAc;AAClB;AACA;IACI,+HAA+H;IAC/H,6BAA6B;IAC7B,qBAAqB;IACrB,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,gCAAgC;AACpC;AACA;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,oCAAoC;IACpC,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;IACX,SAAS;AACb;AACA;IACI,kBAAkB;AACtB;AACA;IACI,aAAa;AACjB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,oCAAoC;IACpC,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,cAAc;IACd,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,YAAY;AAChB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,UAAU;AACd;AACA;;IAEI,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,iBAAiB,EAAE,mBAAmB,EAAE,yBAAyB;AACrE;AACA;IACI,kCAAkC;AACtC;AACA;IACI,kCAAkC;AACtC;AACA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,oBAAoB;IACpB,YAAY;IACZ,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,4BAA4B;IAC5B,yBAAyB;IACzB,wBAAwB;IACxB,uBAAuB;AAC3B;AACA;;IAEI,iBAAiB;AACrB;AACA;IACI,2BAA2B;AAC/B;AACA,kBAAkB;AAClB;IACI,YAAY;IACZ,qCAAqC;AACzC;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,yBAAyB;AAC7B;AACA,kBAAkB;AAClB;AACA;AACA;IACI,iBAAiB;AACrB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,kBAAkB;AACtB;AACA;;IAEI,WAAW;AACf;AACA;IACI,oCAAoC;IACpC,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,WAAW;AACf;AACA;IACI,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,aAAa;IACb,8BAA8B;IAC9B,oBAAoB;IACpB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ;WACO;IACP,kBAAkB;IAClB,YAAY;IACZ,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;AACzB;AACA;IACI;WACO;AACX;AACA;IACI,OAAO;AACX;AACA;IACI,QAAQ;IACR,qBAAqB;IACrB,6BAA6B;IAC7B,0BAA0B;IAC1B,yBAAyB;IACzB,wBAAwB;AAC5B;AACA;IACI,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,0BAA0B;AAC9B;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,SAAS;IAGT,4BAA4B;AAChC;AACA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,QAAQ;IACR,eAAe;IACf,SAAS;AACb;AACA;IACI,uBAAuB;IACvB,uBAAuB;AAC3B;AACA;AACA;AACA;IACI,qBAAqB;AACzB;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;AACzB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,8HAA8H;IAC9H,SAAS;IACT,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,iBAAiB;AACrB;AACA;IACI,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,WAAW;IACX,+BAA+B;IAC/B,WAAW;AACf;AACA;IACI,UAAU;AACd;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,mBAAmB;IACnB,iCAAiC;IACjC,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,2BAA2B;IAC3B,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,gIAAgI;IAChI,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,6BAA6B;AACjC;AACA;IACI,gBAAgB;IAChB,yBAAyB;IAKzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,+CAA+C;IAC/C,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,qBAAqB;AACzB;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,YAAY;AAChB;AACA;IACI,qIAAqI;IACrI,WAAW;IACX,YAAY;IACZ,qBAAqB;AACzB;AACA;IACI,8FAA8F;IAC9F,sGAAsG;AAC1G;AACA;IACI,6FAA6F;IAC7F,qGAAqG;AACzG;AACA,2PAA2P;AAC3P;IACI,mBAAmB;IACnB,oBAAoB;IACpB,YAAY;IACZ,eAAe;IACf,qBAAqB;IACrB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,2BAA2B;IAC3B,iCAAiC;IACjC,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;AACA,+DAA+D,sBAAsB,CAAC;AACtF;IACI,+CAA+C;IAC/C,oBAAoB;IACpB,YAAY;IACZ,eAAe;IACf,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,SAAS;AACb;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;AAC9B;AACA,iDAAiD,yBAAyB,CAAC;AAC3E;;IAEI,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,sBAAsB;IACtB,sBAAsB;AAC1B;AACA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,0BAA0B;IAC1B,iBAAiB;AACrB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,iBAAiB;AACrB;AACA;IACI,cAAc;AAClB;AACA;IACI,WAAW;AACf;AACA;IACI,YAAY;AAChB;AACA;IACI,yBAAyB;IACzB,4BAA4B;AAChC;AACA;IACI,UAAU;IACV,OAAO;IACP,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,QAAQ;IACR,kBAAkB;IAClB,SAAS;AACb;AACA;IACI,WAAW;IACX,YAAY;IAKZ,qCAAqC;IACrC,qBAAqB;AACzB;AACA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,eAAe;AACnB;AACA;IACI,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,WAAW;AACf;AACA;IACI,cAAc;AAClB;AACA;IACI,aAAa;IACb,qBAAqB;IACrB,WAAW;IACX,eAAe;AACnB;AACA;IACI,+CAA+C;IAC/C,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,qBAAqB;AACzB;AACA;IACI,sBAAsB;AAC1B;AACA;;IAEI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;AACA;;IAEI,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,cAAc;IACd,cAAc;IACd,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,qBAAqB;IACrB,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,0DAA0e;AAC9e;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,aAAa;AACjB;AACA;IACI,4BAA4B;AAChC;AACA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,qBAAqB;AACzB;AACA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,4BAA4B;IAC5B,gCAAgC;AACpC;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,OAAO;IACP,QAAQ;IACR,mBAAmB;IACnB,YAAY;IACZ,gCAAgC;IAChC,UAAU;AACd;AACA;IACI,aAAa;IACb,UAAU;AACd;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,4BAA4B;IAC5B,kBAAkB;IAClB,UAAU;IACV,sBAAsB;IACtB,iBAAiB;IACjB,aAAa;AACjB;AACA;IACI,cAAc;AAClB;AACA;IACI,UAAU;IACV,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,qBAAqB;IACrB,WAAW;AACf;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,UAAU;IACV,qBAAqB;AACzB;AACA;IACI,cAAc;IACd,UAAU;AACd;AACA;;IAEI,cAAc;IACd,0BAA0B;AAC9B;AACA;;IAEI,cAAc;IACd,UAAU;AACd;AACA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,kCAAkC;IAClC,kBAAkB;AACtB;AACA;IACI,UAAU;AACd;AACA;IACI,SAAS;IACT,6BAA6B;IAC7B,sBAAsB;AAC1B;AACA;IACI,YAAY;IACZ,6BAA6B;IAC7B,yBAAyB;AAC7B;AACA;IACI,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,WAAW;IACX,qBAAqB;IACrB,UAAU;IACV,YAAY;IACZ,gBAAgB;AACpB;AACA;;IAEI,sBAAsB;AAC1B;AACA;AACA;AACA;IACI,8BAA8B;IAC9B,cAAc;IACd,yBAAyB;IACzB,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,UAAU;AACd;AACA;IACI,SAAS;IACT,6BAA6B;IAC7B,sBAAsB;AAC1B;AACA;IACI,YAAY;IACZ,6BAA6B;IAC7B,yBAAyB;AAC7B;AACA;IACI,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,WAAW;IACX,qBAAqB;AACzB;AACA;;IAEI,sBAAsB;AAC1B;AACA;IACI,iBAAiB;AACrB;AACA;IACI,eAAe;AACnB;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;AACf;AACA;;IAEI,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,aAAa;IACb,eAAe;IACf,+CAA+C;IAC/C,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;AACpB;AACA;;;IAGI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,MAAM;IACN,QAAQ;IACR,YAAY;IACZ,eAAe;IACf,UAAU;AACd;AACA;IACI,+CAA+C;IAC/C,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA,obAAob;AACpb;IACI,8HAA8H;IAC9H,YAAY;IACZ,WAAW;IACX,YAAY;AAChB;AACA;;IAEI,SAAO;AACX;AACA;IACI,uBAAuB;IACvB,oBAAoB;IACpB;cACU;IACV,kBAAkB;AACtB;AACA;;;;IAII,YAAY;IACZ,yBAAyB;AAC7B;AACA;;IAEI,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,oHAAoH;IACpH,qBAAqB;IACrB,4BAA4B;IAC5B,gCAAgC;IAChC,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,SAAS;IACT,QAAQ;AACZ;AACA;IACI,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,uBAAuB;AAC3B;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;AACA;IACI,WAAW;IACX,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,YAAY;AAChB;AACA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,2BAA2B;AAC/B;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,eAAe;AACnB;AACA;IACI,SAAS;IACT,oBAAoB;IACpB,aAAa;IACb,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,aAAa;AACjB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,qBAAqB;AACzB;AACA;IACI,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,0BAA0B;AAC9B;AACA;IACI,cAAc;IACd,qBAAqB;AACzB;AACA;IACI,UAAU;IACV,gCAAgC;IAChC,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,SAAO;IACP,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,UAAU;IACV,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,SAAO;IACP,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,eAAe;AACnB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,cAAc;AAClB;AACA;;IAEI,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,aAAa;IAKb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,wBAAwB;IACxB,kBAAkB;IAKlB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,qBAAqB;AACzB;AACA;IACI,WAAW;AACf;AACA;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,qBAAqB;IACrB,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;AAC7B;AACA;IACI,gBAAgB;IAChB,OAAO;IACP,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,OAAO;IACP,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,UAAU;AACd;AACA;;IAEI,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,MAAM;IACN,2EAA2E;IAC3E,aAAa;AACjB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,SAAS;IACT,gCAAgC;AACpC;AACA;IACI,gBAAgB;IAChB,OAAO;IACP,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,OAAO;IACP,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,UAAU;AACd;AACA;;IAEI,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,MAAM;IACN,2EAA2E;IAC3E,aAAa;AACjB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,SAAS;IACT,gCAAgC;AACpC;AACA;IACI,gBAAgB;IAChB,OAAO;IACP,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,iCAAiC;IACjC,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,OAAO;IACP,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,iCAAiC;IACjC,UAAU;AACd;AACA;;IAEI,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,MAAM;IACN,2EAA2E;IAC3E,aAAa;AACjB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,SAAS;IACT,gCAAgC;AACpC;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,WAAW;AACf;AACA;IACI,iBAAiB;IACjB,UAAU;AACd;AACA;IACI,iBAAiB;IACjB,UAAU;AACd;AACA;IACI,iBAAiB;IACjB,UAAU;AACd;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,UAAU;AACd;AACA;IACI,2BAA2B;IAC3B,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,UAAU;AACd;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,YAAY;AAChB;AACA;IACI,qIAAqI;IACrI,WAAW;IACX,YAAY;IACZ,qBAAqB;AACzB;AACA;IACI,8FAA8F;IAC9F,sGAAsG;AAC1G;AACA;IACI,6FAA6F;IAC7F,qGAAqG;AACzG;AACA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,YAAY;IACZ,eAAe;IACf,qBAAqB;IACrB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,qBAAqB;IACrB,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,eAAe;AACnB;AAkBA;IACI,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;IAClB,WAAW;IACX,qBAAqB;IACrB,iBAAiB;IACjB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;IACnC,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,YAAY;AAChB;AACA;IACI,WAAW;IACX,mBAAmB;IACnB,qBAAqB;AACzB;AACA;IAKI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;AACb;AACA;IACI,kBAAkB;AACtB;AACA;;IAEI,kBAAkB;IAClB,WAAW;IACX,OAAO;IACP,MAAM;IACN,SAAS;IACT,QAAQ;IACR,mBAAmB;IAKnB,gCAAgC;AACpC;AACA;;;;IAII,WAAW;IAKX,gCAAgC;AACpC;AACA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,2BAA2B;IAC3B,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,aAAa;AACjB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,UAAU;AACd;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,SAAS;AACb;AACA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;AACA;;;;IAII,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,aAAa;AACjB;AACA;;IAEI,YAAY;AAChB;AACA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;;IAEI,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;AACA;;IAEI,gBAAgB;AACpB;AACA;IACI;mBACe;IACf,mBAAmB;AACvB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,MAAM;IACN,YAAY;IACZ,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,kBAAkB;AACtB;AACA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,iCAAiC;IACjC,iBAAiB;IACjB,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,iCAAiC;IACjC,UAAU;IACV,iBAAiB;IACjB,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;AACA;IACI,UAAU;AACd;AACA;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;AACZ;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,aAAa;AACjB;AACA;IACI,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;AACpB;AACA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,kCAAkC;IAClC,mCAAmC;IACnC,0BAA0B;AAC9B;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gCAAgC;IAChC,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;IACtB,eAAe;IACf,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;IACnC,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,cAAc;AAClB;AACA;IACI,2HAA2H;IAC3H,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,kIAAkI;IAClI,WAAW;IACX,WAAW;IACX,iBAAiB;IACjB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;AACf;AACA;IACI,+BAA+B;IAC/B,uCAAuC;AAC3C;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,gBAAgB;AACpB;;AAEA,uBAAuB;AACvB;IACI,cAAc;AAClB;AACA;IACI,UAAU;AACd;AACA;IAGI,YAAY;AAChB;AACA;IACI,yBAAyB;IACzB,4BAA4B;AAChC;AACA;IACI,0BAA0B;IAC1B,6BAA6B;AACjC;AACA;IACI,WAAW;IACX,sBAAsB;IACtB,yBAAyB;IACzB,sBAAsB;IAGtB,wEAAwE;IAExE,qFAAqF;IACrF,oFAAoF;IACpF,mFAAmF;AACvF;AACA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX,gCAAgC;IAChC,gBAAgB;IAChB,YAAY;IACZ,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;IACnC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX,gCAAgC;IAChC,gBAAgB;IAChB,YAAY;IACZ,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;IACnC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,6BAA6B;IAC7B,0BAA0B;IAC1B,yBAAyB;IACzB,wBAAwB;AAC5B;AACA;IACI,YAAY;IACZ,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,qBAAqB;AACzB;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,qBAAqB;IACrB,YAAY;AAChB;AACA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,SAAS;AACb;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,0BAA0B;IAC1B,WAAW;IACX,YAAY;IACZ,gCAAgC;AACpC;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,0BAA0B;IAC1B,WAAW;IACX,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,WAAW;IACX,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI;QAEI,gBAAgB;IACpB;AACJ;;AAEA;IACI,WAAW;AACf;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,qBAAqB;IAErB,gDAAgD;AACpD;AACA;IACI,mBAAmB;IACnB,6BAA6B;IAC7B,4BAA4B;AAChC;AACA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;AACA;IACI,6BAA6B;IAC7B,4BAA4B;AAChC;AACA;;IAEI,mBAAmB;IACnB,yBAAyB;IACzB,qBAAqB;IAErB,gBAAgB;AACpB;AACA;;IAEI,6BAA6B;AACjC;AACA;;IAEI,qBAAqB;AACzB;AACA;;IAEI,qBAAqB;AACzB;AACA;IACI,WAAW;AACf;AACA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,mCAAmC;IACnC,kCAAkC;AACtC;AACA;IACI,6BAA6B;IAC7B,+BAA+B;IAC/B,gCAAgC;AACpC;AACA;IACI,cAAc;IACd,yBAAyB;AAC7B;AACA;IACI,UAAU;AACd;AACA;IACI,iBAAiB;AACrB;AACA;IACI,0BAA0B;IAC1B,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;AACtB;AACA;;IAEI,WAAW;IACX,yBAAyB;AAC7B;AACA;IACI,yBAAyB;IACzB,0DAAgY;IAChY,4BAA4B;IAC5B,2BAA2B;IAC3B,0BAA0B;AAC9B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,sBAAsB;IACtB,0DAAwX;IACxX,4BAA4B;IAC5B,2BAA2B;IAC3B,0BAA0B;AAC9B;AACA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,cAAc;AAClB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,oBAAoB;IACpB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,mBAAmB;AACvB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,8CAA8C;AAClD;AACA;IACI,kCAAkC;IAClC,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,yDAAyD;IACzD,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,qBAAqB;IACrB,kCAAkC;IAClC,cAAc;AAClB;AACA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,sBAAsB;AAC1B;AACA;IACI,cAAc;AAClB;AACA;IACI,kDAAkD;AACtD;AACA;IAEI,sBAAsB;IACtB,WAAW;IACX,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,UAAU;IACV,sBAAsB;IACtB,eAAe;IACf,sBAAsB;IACtB,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,qBAAqB;IACrB,qBAAqB;AACzB;AACA;IACI,cAAc;AAClB;AACA;IACI,QAAQ;IACR,aAAa;AACjB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,cAAc;IACd,aAAa;AACjB;AACA;IACI,6BAA6B;IAC7B,MAAM;IACN,YAAY;IACZ,WAAW;IACX,eAAe;AACnB;AACA;IACI,cAAc;IACd,mBAAmB;AACvB;AACA;;;;IAII,aAAa;AACjB;AACA;IACI,YAAY;AAChB;AACA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,qBAAqB;IAErB,2CAA2C;AAC/C;AACA;IACI,oBAAoB;IACpB,4BAA4B;AAChC;AACA;IACI,sCAAsC;IACtC,6BAA6B;IAC7B,uBAAuB;IACvB,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,MAAM;IACN,SAAS;AACb;AACA;IACI,wBAAwB;IACxB,mBAAmB;AACvB;AACA;IACI,SAAS;AACb;AACA;IACI,gCAAgC;AACpC;AACA;IACI,cAAc;IACd,yDAAiP;IACjP,4BAA4B;IAC5B,yCAAyC;IACzC,0BAA0B;AAC9B;AACA;IACI,YAAY;IACZ,qBAAqB;IACrB,gBAAgB;AACpB;AACA;IACI,SAAS;IACT,YAAY;IACZ,sBAAsB;IACtB,yDAAiP;IACjP,4BAA4B;IAC5B,yCAAyC;IACzC,0BAA0B;AAC9B;AACA;IACI,uBAAuB;IACvB,6BAA6B;AACjC;AACA,oBAAoB;;AAEpB;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,qEAA0P;IAC1P,oCAAoC;IACpC,gCAAgC;IAChC,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;IACnC,qBAAqB;AACzB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,WAAW;AACf;AACA;IACI,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;IACnC,WAAW;AACf;AACA;IACI,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,0DAAwK;IACxK,gCAAgC;IAChC,kBAAkB;IAClB,iDAAiD;IACjD,YAAY;AAChB;AACA;IACI,iCAAiC;IACjC,0DAAuJ;AAC3J;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,oBAAoB;AACxB;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,oBAAoB;IACpB,qBAAqB;AACzB;AACA;IACI,uBAAuB;IACvB,kBAAkB;AACtB;AACA;IACI,WAAW;AACf;AACA;IACI,gBAAgB;AACpB;AACA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;AAC1B;AACA;IACI,SAAS;AACb;AACA;IACI,yBAAyB;IACzB,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,kBAAkB;AACtB;AACA;;IAEI,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,UAAU;IAKV,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IAKZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,eAAe;IACf,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;IACnC,yBAAyB;IACzB,cAAc;AAClB;AACA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,aAAa;IACb,cAAc;IAKd,SAAO;IACP,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;AACA;IACI,2BAA2B;IAC3B,mCAAmC;IACnC,gCAAgC;IAChC,+BAA+B;IAC/B,8BAA8B;IAC9B,gBAAgB;AACpB;AACA;IACI,4BAA4B;IAC5B,cAAc;IACd,oCAAoC;IACpC,iCAAiC;IACjC,gCAAgC;IAChC,+BAA+B;IAC/B,WAAW;AACf;;AAEA;IACI;;QAEI,gBAAgB;IACpB;IACA;;QAEI,gBAAgB;IACpB;IACA;;QAEI,gBAAgB;IACpB;AACJ;;AAEA;IACI;;QAEI,gBAAgB;QAChB,OAAO;QACP,UAAU;IACd;IACA;;QAEI,gBAAgB;QAChB,WAAW;QACX,UAAU;IACd;IACA;;QAEI,WAAW;QACX,kBAAkB;QAClB,MAAM;QACN,OAAO;QACP,SAAS;QACT,QAAQ;QACR,YAAY;QACZ,gBAAgB;IACpB;IACA;;QAEI,UAAU;QACV,kBAAkB;IACtB;IACA;;QAEI,WAAW;QACX,qGAAqG;QACrG,YAAY;QACZ,WAAW;QACX,kBAAkB;QAClB,YAAY;QACZ,SAAS;QACT,MAAM;IACV;IACA;;QAEI,kBAAkB;QAClB,YAAY;IAChB;IACA;QACI,kBAAkB;QAClB,qBAAqB;IACzB;IACA;QACI,WAAW;IACf;IACA;QACI,mBAAmB;IACvB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,oBAAoB;IACxB;IACA;QACI,WAAW;IACf;IACA;QACI,WAAW;IACf;IACA;QACI,gBAAgB;IACpB;IACA;QACI,sBAAsB;QACtB,mBAAmB;QACnB,sBAAsB;IAC1B;IACA;QACI,iBAAiB;QACjB,iCAAiC;IACrC;AACJ;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;;QAEI,sBAAsB;QACtB,kBAAkB;IACtB;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,WAAW;IACf;IACA;QACI,iCAAiC;QACjC,eAAe;IACnB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,WAAW;QACX,YAAY;QACZ,UAAU;IACd;IACA;QACI,qBAAqB;IACzB;IACA;QACI,eAAe;QACf,YAAY;QACZ,WAAW;IACf;IACA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,mBAAmB;IACvB;AACJ;;AAEA;IACI,SAAS;IACT,WAAW;AACf;AACA;IACI,UAAU;AACd;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,2BAA2B;IAC3B,6BAA6B;AACjC;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,aAAa;IACjB;IACA;QACI,cAAc;QACd,qBAAqB;QACrB,mBAAmB;IACvB;IACA;QACI,WAAW;QACX,eAAe;IACnB;AACJ;;AAEA,mBAAmB;;AAEnB;IACI,gBAAgB;AACpB;AACA;IACI,+CAA+C;IAC/C,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,YAAY;AAChB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;AACjB;AACA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IAEZ,mBAAmB;IAGnB,gBAAgB;IAChB,sBAAsB;IACtB,yDAAiP;IACjP,4BAA4B;IAC5B,yCAAyC;IACzC,0BAA0B;IAC1B,eAAe;AACnB;AACA;IACI,+CAA+C;IAC/C,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,WAAW;AACf;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,UAAU;IACV,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,YAAY;IACZ,MAAM;IACN,SAAS;IACT,YAAY;IACZ,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,aAAa,EAAE,iCAAiC;AACpD;AACA;IACI,4BAA4B;AAChC;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;IACX,QAAQ;IACR,SAAS;IACT,6BAA6B;IAC7B,sDAAsD;AAC1D;AACA;IACI,sDAAsD;IACtD,QAAQ;AACZ;AACA;IACI,cAAc;IACd,wBAAwB;IACxB,yBAAyB;IACzB,qBAAqB;IACrB,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,gCAAgC;IAChC,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;IACX,UAAU;IACV,WAAW;IACX,aAAa;IACb,6BAA6B;IAC7B,+BAA+B;IAK/B,yBAAyB;IAKzB,gCAAgC;AACpC;AACA;IACI,aAAa;IACb,SAAS;IACT,6BAA6B;IAC7B,+BAA+B;IAC/B,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,WAAW;AACf;AACA;IACI,cAAc;IACd,iBAAiB;IACjB,6BAA6B;IAC7B,oEAAoE;IACpE,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,mCAAmC;IACnC,YAAY;AAChB;AACA;IACI,aAAa;AACjB;AACA;;IAEI,oCAAoC;AACxC;AACA;IACI,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IAKnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,UAAU;IACV,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,6BAA6B;IAC7B,WAAW;IACX,yBAAyB;IACzB,SAAS;AACb;AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,MAAM;IACN,SAAS;IACT,YAAY;AAChB;AACA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,SAAS;IACT,UAAU;IACV,YAAY;AAChB;AACA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;AACA;IACI,eAAe;AACnB;;AAEA;IACI;QACI,iBAAiB;QACjB,mBAAmB;IACvB;IACA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,0BAA0B;IAC1B,kCAAkC;IAClC,+BAA+B;IAC/B,8BAA8B;IAC9B,6BAA6B;AACjC;AACA;IACI,0BAA0B;IAC1B,kCAAkC;IAClC,+BAA+B;IAC/B,8BAA8B;IAC9B,6BAA6B;IAC7B,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,OAAO;AACX;AACA;IACI,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IAKf,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,uCAAuC;IACvC,0CAA0C;IAC1C,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,oBAAoB;IACpB,eAAe;IACf,WAAW;AACf;AACA;IACI,aAAa;IACb,gCAAgC;IAChC,+BAA+B;IAC/B,wBAAwB;IACxB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,qBAAqB;AACzB;AACA;IACI,WAAW;AACf;AACA;IACI,gBAAgB;AACpB;AACA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IAKI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,aAAa;AACjB;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,8BAA8B;IAC9B,yBAAyB;IACzB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;IAChB,uBAAuB;AAC3B;AACA;IACI,mBAAmB;AACvB;AACA;IACI,SAAO;IACP,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,SAAS;IACT,UAAU;IACV,gBAAgB;AACpB;AACA;IACI,YAAY;AAChB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,8BAA8B;IAC9B,UAAU;IACV,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,mGAAmG;AACvG;AACA;IACI,mGAAmG;AACvG;AACA;IACI,mGAAmG;AACvG;AACA;IACI,mGAAmG;AACvG;AACA;IACI,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,eAAe;AACnB;AACA;IACI,8BAA8B;IAC9B,+BAA+B;IAC/B,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,YAAY;AAChB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,kBAAkB;IAClB,UAAU;IACV,0DAAkP;IAClP,qBAAqB;AACzB;AACA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,SAAS;IACT,yBAAyB;IACzB,iBAAiB;IACjB,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,UAAU;IACV,uBAAuB;IACvB,4BAA4B;AAChC;AACA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;AACA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI;QACI,YAAY;IAChB;IACA;QACI,eAAe;IACnB;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,SAAS;IACT,QAAQ;IACR,SAAS;IACT,kCAAkC;IAClC,mCAAmC;IACnC,6BAA6B;AACjC;AACA;IACI,eAAe;AACnB;;AAEA;IACI,6GAA6G;IAC7G,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,qBAAqB;IACrB,6BAA6B;IAC7B,0BAA0B;IAC1B,yBAAyB;IACzB,wBAAwB;AAC5B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,iBAAiB;AACrB;AACA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,YAAY;AAChB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,gCAAgC;AACpC;AACA;IACI,eAAe;AACnB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;IACV,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,8BAA8B;IAC9B,gCAAgC;IAChC,QAAQ;IACR,OAAO;IACP,yBAAyB;IACzB,iCAAiC;IACjC,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;AAChC;;AAEA,qBAAqB;AACrB;IACI,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IAKb,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,gCAAgC;IAChC,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,iCAAiC;IACjC,yBAAyB;IACzB,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;AACnB;AACA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,QAAQ;AACZ;;AAEA,qBAAqB;;AAErB,cAAc;AACd;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,eAAe;IACf,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,iCAAiC;IACjC,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,UAAU;IACV,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAKlB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,eAAe;IACf,WAAW;IACX,gCAAgC;AACpC;AACA;IACI;gBACY;IACZ,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,qBAAqB;IACrB,6BAA6B;IAC7B,0BAA0B;IAC1B,yBAAyB;IACzB,wBAAwB;IACxB,yBAAyB;AAC7B;AACA;IACI,WAAW;AACf;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;IACrB,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;;;;IAII,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,UAAU;IAKV,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,qBAAqB;IACrB,aAAa;AACjB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,iCAAiC;IACjC,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,sIAAsI;IACtI,aAAa;AACjB;AACA;IACI,aAAa;IACb,iBAAiB;IACjB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,WAAW;AACf;AACA;IACI,cAAc;AAClB;AACA;IACI,qBAAqB;IACrB,8BAA8B;IAC9B,qBAAqB;IACrB,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,+DAA+D;IAC/D,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,0BAA0B;IAC1B,oBAAoB;IACpB,iCAAiC;IACjC,yBAAyB;IACzB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,+DAA+D;IAC/D,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,0BAA0B;IAC1B,oBAAoB;IACpB,iCAAiC;IACjC,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,cAAc;AAClB;AACA;;IAEI,gCAAgC;IAChC,WAAW;IACX,0BAA0B;AAC9B;;AAEA;IACI,YAAY;AAChB;AACA;IACI,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,UAAU;IACV,WAAW;IACX,uBAAuB;IACvB,qBAAqB;IACrB,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,SAAS;IACT,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,8BAA8B;IAC9B,0BAA0B;AAC9B;AACA;IACI,WAAW;IACX,UAAU;IACV,WAAW;IACX,uBAAuB;IACvB,qBAAqB;IACrB,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,SAAS;IACT,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,8BAA8B;IAC9B,wBAAwB;AAC5B;AACA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,iCAAiC;IACjC,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,SAAS;AACb;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,aAAa;IACb,eAAe;AACnB;AACA;IACI,0BAA0B;IAC1B,cAAc;IACd,eAAe;AACnB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,cAAc;AAClB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,cAAc;AAClB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,YAAY;IACZ,YAAY;IACZ,yEAAyE;IACzE,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,qBAAqB;IACrB,mCAAmC;IACnC,kCAAkC;AACtC;AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,iCAAiC;IACjC,aAAa;AACjB;AACA,sQAAsQ;AACtQ;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,sIAAsI;IACtI,aAAa;AACjB;AACA;IACI,aAAa;IACb,iBAAiB;IACjB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,WAAW;AACf;AACA;IACI,cAAc;AAClB;AACA;IACI,qBAAqB;IACrB,8BAA8B;IAC9B,qBAAqB;IACrB,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;AACA;IACI,iCAAiC;IACjC,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,uBAAuB;IACvB,kBAAkB;AACtB;AACA;IACI,0BAA0B;IAC1B,mDAAmD;AACvD;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,0BAA0B;IAC1B,kBAAkB;IAClB,YAAY;IACZ,aAAa;AACjB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,gBAAgB;IAKhB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,gDAAgD;AACpD;;AAEA;IACI,wBAAwB;IACxB,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,YAAY;IAEZ,wBAAwB;AAC5B;AACA;IAEI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,mBAAmB;IACnB,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IACZ,SAAS;IACT,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,SAAS;IACT,mBAAmB;IACnB,eAAe;IACf,kBAAkB;AACtB;AACA,WAAW;AACX;IACI,yBAAyB;IACzB,WAAW;IACX,kBAAkB;AACtB;AACA,OAAO;AACP;IACI,yBAAyB;IACzB,WAAW;IACX,kBAAkB;AACtB;AACA,MAAM;AACN;IACI,yBAAyB;IACzB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI;QACI,0BAA0B;IAC9B;IACA;QACI,4BAA4B;IAChC;IACA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,yBAAyB;IAC7B;IACA;QACI,WAAW;IACf;IACA;QACI,WAAW;QACX,gBAAgB;QAChB,wBAAwB;IAC5B;IACA;;QAEI,aAAa;QACb,WAAW;QACX,2BAA2B;QAC3B,WAAW;QACX,kBAAkB;QAClB,uBAAuB;IAC3B;IACA;QACI,WAAW;QACX,kBAAkB;IACtB;IACA;QACI,WAAW;QACX,gBAAgB;QAChB,yBAAyB;QACzB,0BAA0B;QAC1B,2BAA2B;IAC/B;IACA;QACI,WAAW;IACf;IACA;QACI,UAAU;QACV,YAAY;IAChB;IACA;QACI,UAAU;QACV,YAAY;QACZ,4BAA4B;IAChC;IACA;QACI,WAAW;IACf;IACA;QACI,WAAW;QACX,iCAAiC;IACrC;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;IACA;QACI,SAAS;IACb;IACA;QACI,QAAQ;QACR,wBAAwB;IAC5B;IACA;QACI,QAAQ;QACR,oBAAoB;IACxB;IACA;QACI,QAAQ;IACZ;IACA;QACI,eAAe;IACnB;IACA;QACI,WAAW;IACf;AACJ;;AAEA,cAAc;;AAEd,eAAe;;AAEf,eAAe;AACf;;;;;GAKG;AACH;IACI,WAAW;IACX,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,UAAU;AACd;AACA;;IAEI,2BAA2B;IAC3B,kBAAkB;AACtB;AACA;;IAEI,uBAAuB;IACvB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,UAAU;AACd;AACA;;IAEI,kBAAkB;AACtB;AACA;;IAEI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;IACf,mBAAmB;IAKnB,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;;IAEI,aAAa;AACjB;AACA;;;;IAII,WAAW;AACf;AACA;;;;IAII,WAAW;IACX,yBAAyB;IACzB,mBAAmB;AACvB;AACA;;IAEI,WAAW;IACX,yBAAyB;IACzB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,kIAAkI;AACtI;AACA;IACI,kIAAkI;AACtI;AACA;IACI,mIAAmI;AACvI;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,aAAa;AACjB;AACA;IACI,iDAAiD;IACjD,iBAAiB;IACjB,gBAAgB;AACpB;AACA;;IAEI,yBAAyB;IACzB,YAAY;AAChB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;AAC7B;AACA;IACI,oBAAoB;AACxB;AACA;;IAEI,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;IACrB,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,cAAc;IACd,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,aAAa;AACjB;AACA;IACI,cAAc;IACd,2BAA2B;IAC3B,0BAA0B;IAC1B,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,qBAAqB;IACrB,gBAAgB;IAChB,UAAU;IACV,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,sBAAsB;IACtB,0BAA0B;IAC1B,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,0BAA0B;IAC1B,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,0HAA0H;IAC1H,qBAAqB;AACzB;AACA;;IAEI,2BAA2B;IAC3B,YAAY;AAChB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,0DAA0+B;IAC1+B,4BAA4B;IAC5B,wCAAwC;IACxC,0BAA0B;AAC9B;AACA;IACI,4HAA4H;IAC5H,4BAA4B;IAC5B,wCAAwC;IACxC,0BAA0B;AAC9B;AACA;IACI,0DAAoxB;IACpxB,4BAA4B;IAC5B,wCAAwC;IACxC,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,WAAW;AACf;AACA;IACI,uBAAuB;IACvB,UAAU;IACV,WAAW;IACX,sBAAsB;IACtB,WAAW;IACX;;mCAE+B;IAC/B,SAAS;IACT,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,eAAe;IACf,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;IACnC,yBAAyB;IACzB,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,2BAA2B;IAC3B,mCAAmC;IACnC,gCAAgC;IAChC,+BAA+B;IAC/B,8BAA8B;IAC9B,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,cAAc;IAKd,SAAO;IACP,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,4BAA4B;IAC5B,cAAc;IACd,oCAAoC;IACpC,iCAAiC;IACjC,gCAAgC;IAChC,+BAA+B;IAC/B,WAAW;AACf;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,0BAA0B;IAC1B,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,qBAAqB;AACzB;AACA;IACI,YAAY;IACZ,eAAe;IACf,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,qBAAqB;IACrB,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,cAAc;AAClB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,aAAa;AACjB;AACA;IACI,6FAA6F;AACjG;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,0BAA0B;IAC1B,kBAAkB;IAClB,YAAY;IACZ,aAAa;AACjB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,yBAAyB;IAKzB,aAAa;IACb,YAAY;AAChB;AACA;IACI,kBAAkB;IAKlB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,WAAW;IAKX,SAAO;IACP,YAAY;IACZ,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAKhB,SAAO;IACP,YAAY;IAKZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,gBAAgB;IAKhB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,gDAAgD;AACpD;;AAEA;IACI,wBAAwB;IACxB,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,YAAY;IAEZ,wBAAwB;AAC5B;AACA;IAEI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,mBAAmB;IACnB,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IACZ,SAAS;IACT,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,SAAS;IACT,mBAAmB;IACnB,eAAe;IACf,kBAAkB;AACtB;AACA,WAAW;AACX;IACI,yBAAyB;IACzB,WAAW;IACX,kBAAkB;AACtB;AACA,OAAO;AACP;IACI,yBAAyB;IACzB,WAAW;IACX,kBAAkB;AACtB;AACA,MAAM;AACN;IACI,yBAAyB;IACzB,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;AACA;IACI,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAKhB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;AACnB;AACA;IACI,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,8BAA8B;IAC9B,gCAAgC;IAChC,yBAAyB;IACzB,SAAS;IACT,QAAQ;IACR,iCAAiC;IACjC,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;AAChC;AACA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;AACA;IACI,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,4BAA4B;IAC5B,yBAAyB;IACzB,wBAAwB;IACxB,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;AACf;AACA;IACI,UAAU;IACV,SAAS;IAKT,SAAO;AACX;AACA;IACI,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,eAAe;AACnB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,MAAM;IACN,SAAS;IACT,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kIAAkI;AACtI;AACA;IACI,oIAAoI;AACxI;AACA;IACI,iCAAiC;IACjC,yCAAyC;AAC7C;AACA;IACI,WAAW;AACf;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,oHAAoH;IACpH,qBAAqB;IACrB,4BAA4B;IAC5B,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,QAAQ;IACR,mBAAmB;IACnB,WAAW;AACf;;AAEA;;;;IAII,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,aAAa;AACjB;AACA;;IAEI,YAAY;AAChB;AACA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;;IAEI,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;AACA;;IAEI,gBAAgB;AACpB;AACA;IACI;mBACe;IACf,mBAAmB;AACvB;;AAEA;AACA;;AAEA;IACI;QACI,kBAAkB;QAClB,eAAe;IACnB;AACJ;;AAEA;IACI,gBAAgB;IAChB,iCAAiC;IACjC,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,YAAY;IACZ,eAAe;IACf,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,UAAU;IACV,SAAS;IACT,WAAW;IACX,gBAAgB;AACpB;;AAEA,aAAa;;AAEb,iBAAiB;;AAEjB;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,SAAS;AACb;AACA;IACI,mBAAmB;AACvB;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;AAC9B;;AAEA;IACI,WAAW;AACf;AACA;IACI,gBAAgB;AACpB;AACA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;AAC1B;AACA;;IAEI,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,sBAAsB;AAC1B;AACA;IACI,mBAAmB;AACvB;AACA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,0BAA0B;IAC1B,iBAAiB;AACrB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,iBAAiB;AACrB;AACA;IACI,cAAc;AAClB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,0BAA0B;AAC9B;AACA;IACI,WAAW;AACf;AACA;IACI,YAAY;AAChB;AACA;IACI,kBAAkB;AACtB;;AAEA,qHAAqH;;AAErH;IACI,yBAAyB;IACzB,4BAA4B;AAChC;AACA;IACI,UAAU;IACV,OAAO;IACP,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,QAAQ;IACR,kBAAkB;IAClB,SAAS;AACb;AACA;IACI,WAAW;IACX,YAAY;IAKZ,qCAAqC;IACrC,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,eAAe;AACnB;AACA;IACI,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,WAAW;AACf;AACA;IACI,cAAc;AAClB;AACA;IACI,aAAa;IACb,qBAAqB;IACrB,WAAW;IACX,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,qBAAqB;AACzB;AACA;IACI,sBAAsB;AAC1B;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;AACA;;IAEI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,0DAA0e;AAC9e;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,4BAA4B;AAChC;AACA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,4BAA4B;IAC5B,gCAAgC;AACpC;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,OAAO;IACP,QAAQ;IACR,mBAAmB;IACnB,YAAY;IACZ,gCAAgC;IAChC,UAAU;AACd;AACA;IACI,aAAa;IACb,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,4BAA4B;IAC5B,kBAAkB;IAClB,UAAU;IACV,sBAAsB;IACtB,iBAAiB;IACjB,aAAa;AACjB;AACA;IACI,cAAc;AAClB;AACA;IACI,UAAU;IACV,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,qBAAqB;IACrB,WAAW;AACf;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,UAAU;IACV,qBAAqB;AACzB;AACA;IACI,cAAc;IACd,UAAU;AACd;;AAEA;;IAEI,cAAc;IACd,0BAA0B;AAC9B;AACA;;IAEI,cAAc;IACd,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,kCAAkC;IAClC,kBAAkB;AACtB;AACA;IACI,UAAU;AACd;AACA;IACI,SAAS;IACT,6BAA6B;IAC7B,sBAAsB;AAC1B;AACA;IACI,YAAY;IACZ,6BAA6B;IAC7B,yBAAyB;AAC7B;AACA;IACI,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,WAAW;IACX,qBAAqB;IACrB,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;AACvB;AACA;;IAEI,sBAAsB;AAC1B;;AAEA;AACA;AACA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,UAAU;AACd;AACA;IACI,SAAS;IACT,6BAA6B;IAC7B,sBAAsB;AAC1B;AACA;IACI,YAAY;IACZ,6BAA6B;IAC7B,yBAAyB;AAC7B;AACA;IACI,gBAAgB;AACpB;AACA;IACI,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,WAAW;IACX,qBAAqB;AACzB;AACA;;IAEI,sBAAsB;AAC1B;AACA;IACI,iBAAiB;AACrB;AACA;IACI,eAAe;AACnB;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;AACpB;AACA;;;IAGI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,MAAM;IACN,QAAQ;IACR,YAAY;IACZ,eAAe;IACf,UAAU;AACd;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA,obAAob;AACpb;IACI,8HAA8H;IAC9H,YAAY;IACZ,WAAW;IACX,YAAY;AAChB;AACA;;IAEI,SAAO;AACX;AACA;IACI,uBAAuB;IACvB,oBAAoB;IACpB;cACU;IACV,kBAAkB;AACtB;AACA;;;;IAII,YAAY;IACZ,yBAAyB;AAC7B;AACA;IACI,oHAAoH;IACpH,qBAAqB;IACrB,4BAA4B;IAC5B,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,SAAS;IACT,QAAQ;AACZ;AACA;IACI,kBAAkB;AACtB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;AACA;IACI,WAAW;IACX,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,WAAW;IACX,YAAY;AAChB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ;kBACc;IACd,UAAU;AACd;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,2BAA2B;AAC/B;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,aAAa;IACb,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,qBAAqB;AACzB;AACA;IACI,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,0BAA0B;AAC9B;AACA;IACI,cAAc;IACd,qBAAqB;AACzB;AACA;IACI,oBAAoB;IACpB,gCAAgC;IAChC,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,SAAO;IACP,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,UAAU;IACV,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,SAAO;IACP,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,eAAe;AACnB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,cAAc;AAClB;AACA;;IAEI,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IAKb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,wBAAwB;IACxB,kBAAkB;IAKlB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;AACzB;AACA;IACI,WAAW;AACf;AACA;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,YAAY;AAChB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,qBAAqB;IACrB,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,OAAO;IACP,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,OAAO;IACP,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,UAAU;AACd;AACA;;IAEI,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,MAAM;IACN,2EAA2E;IAC3E,aAAa;AACjB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,OAAO;IACP,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,OAAO;IACP,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,UAAU;AACd;AACA;;IAEI,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,MAAM;IACN,2EAA2E;IAC3E,aAAa;AACjB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,OAAO;IACP,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,iCAAiC;IACjC,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,OAAO;IACP,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,iCAAiC;IACjC,UAAU;AACd;AACA;;IAEI,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,MAAM;IACN,2EAA2E;IAC3E,aAAa;AACjB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,YAAY;AAChB;AACA;IACI,qIAAqI;IACrI,WAAW;IACX,YAAY;IACZ,qBAAqB;AACzB;AACA;IACI,8FAA8F;IAC9F,sGAAsG;AAC1G;AACA;IACI,6FAA6F;IAC7F,qGAAqG;AACzG;AACA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,YAAY;IACZ,eAAe;IACf,qBAAqB;IACrB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,cAAc;AAClB;AACA;IACI,cAAc;AAClB;;AAEA;IACI;;QAEI,gBAAgB;IACpB;IACA;;QAEI,gBAAgB;IACpB;IACA;;QAEI,gBAAgB;IACpB;AACJ;;AAEA;IACI;;QAEI,gBAAgB;QAChB,OAAO;QACP,UAAU;IACd;IACA;;QAEI,gBAAgB;QAChB,WAAW;QACX,UAAU;IACd;IACA;;QAEI,WAAW;QACX,kBAAkB;QAClB,MAAM;QACN,OAAO;QACP,SAAS;QACT,QAAQ;QACR,YAAY;QACZ,gBAAgB;IACpB;IACA;;QAEI,UAAU;QACV,kBAAkB;IACtB;IACA;;QAEI,WAAW;QACX,yEAAyE;QACzE,YAAY;QACZ,WAAW;QACX,kBAAkB;QAClB,YAAY;QACZ,SAAS;QACT,MAAM;IACV;IACA;;QAEI,kBAAkB;QAClB,YAAY;IAChB;;IAEA;QACI,kBAAkB;QAClB,qBAAqB;IACzB;IACA;QACI,WAAW;IACf;IACA;QACI,mBAAmB;IACvB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,gBAAgB;IACpB;AACJ;;AAEA,qBAAqB;;AAErB;IACI,2BAA2B;IAC3B,oBAAoB;IACpB,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,SAAO;IACP,gCAAgC;IAChC,+BAA+B;IAC/B,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IAKI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,aAAa;AACjB;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,8BAA8B;IAC9B,yBAAyB;IACzB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;IAChB,uBAAuB;AAC3B;AACA;IACI,mBAAmB;AACvB;AACA;IACI,SAAO;IACP,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,SAAS;IACT,UAAU;IACV,gBAAgB;AACpB;AACA;IACI,SAAO;AACX;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,8BAA8B;IAC9B,UAAU;IACV,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,mGAAmG;AACvG;AACA;IACI,mGAAmG;AACvG;AACA;IACI,mGAAmG;AACvG;AACA;IACI,mGAAmG;AACvG;AACA;IACI,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,eAAe;AACnB;AACA;IACI,8BAA8B;IAC9B,+BAA+B;IAC/B,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,YAAY;AAChB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,kBAAkB;IAClB,UAAU;IACV,0DAAkP;IAClP,qBAAqB;AACzB;AACA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,SAAS;IACT,yBAAyB;IACzB,iBAAiB;IACjB,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,UAAU;IACV,uBAAuB;IACvB,4BAA4B;AAChC;AACA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;AACA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA,kBAAkB;;AAElB;IACI,gCAAgC;AACpC;AACA;IACI,YAAY;IACZ,UAAU;IAKV,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,qBAAqB;IACrB,WAAW;IACX,eAAe;AACnB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,WAAW;IACX,gCAAgC;IAChC,YAAY;AAChB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,UAAU;IACV,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;AACzB;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,gCAAgC;AACpC;AACA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;IACZ,0DAAqO;AACzO;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;IACnC,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,+BAA+B;IAC/B,WAAW;IACX,YAAY;IACZ,MAAM;IACN,QAAQ;AACZ;AACA;IACI,+BAA+B;IAC/B,uCAAuC;AAC3C;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;IACX,YAAY;IACZ,kHAAkH;AACtH;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;IACX,YAAY;IACZ,oHAAoH;AACxH;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,SAAS;IACT,UAAU;IACV,gBAAgB;AACpB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,mBAAmB;IACnB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;AACzB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IAKZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;IACnC,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,YAAY;AAChB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,mBAAmB;AACvB;AACA;IACI,+BAA+B;IAC/B,uCAAuC;AAC3C;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,6BAA6B;IAC7B,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,SAAS;IACT,QAAQ;IACR,iCAAiC;IACjC,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;AAChC;AACA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,aAAa;AACjB;AACA;IAKI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IAKI,aAAa;IACb,iBAAiB;IACjB,oBAAoB;AACxB;AACA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,YAAY;IAKZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,cAAc;AAClB;AACA;IACI,UAAU;IACV,SAAS;AACb;AACA;IACI,gBAAgB;IAKhB,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IAKX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI;QACI,mBAAmB;IACvB;IACA;QACI,uBAAuB;QACvB,wBAAwB;QACxB,gBAAgB;IACpB;AACJ;AACA,qBAAqB;;AAErB,wBAAwB;AACxB;IAKI,aAAa;IACb,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,YAAY;AAChB;AACA;IACI,sBAAsB;IACtB,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IAKI,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,0BAA0B;IAC1B,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,4BAA4B;IAC5B,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,UAAU;IACV,oCAAoC;IACpC,uCAAuC;IACvC,4BAA4B;IAC5B,SAAS;IACT,QAAQ;AACZ;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IAKzB,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,iIAAiI;IACjI,WAAW;IACX,YAAY;IACZ,6FAA6F;IAC7F,eAAe;IACf,qGAAqG;AACzG;AACA;IACI,wBAAwB;IACxB,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;AACvB;AACA;;IAEI,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,cAAc;IACd,gBAAgB;IAKhB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,iIAAiI;IACjI,WAAW;IACX,YAAY;IACZ,+FAA+F;IAC/F,eAAe;IACf,uGAAuG;AAC3G;AACA;IACI,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;AACpB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,gBAAgB;IAChB,aAAa;AACjB;AACA;IACI,oBAAoB;IACpB,YAAY;IACZ,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,4BAA4B;IAC5B,yBAAyB;IACzB,wBAAwB;IACxB,uBAAuB;AAC3B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,YAAY;IACZ,qCAAqC;AACzC;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,YAAY;AAChB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,WAAW;AACf;AACA;IACI,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;IACrB,0DAAsJ;AAC1J;AACA;IACI,UAAU;IACV,mBAAmB;IAKnB,aAAa;AACjB;AACA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,wCAAwC;AAC5C;AACA;IACI,UAAU;IACV,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,6BAA6B;IAC7B,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;AACA;IAKI,aAAa;IACb,mBAAmB;IACnB,UAAU;AACd;AACA;IACI,sBAAsB;IACtB,qBAAqB;AACzB;AACA;IACI,0DAA0J;AAC9J;;AAEA;IACI;QACI,mBAAmB;QACnB,iBAAiB;QACjB,cAAc;QACd,mBAAmB;QACnB,cAAc;QACd,YAAY;IAChB;IACA;QACI,gBAAgB;QAKhB,aAAa;QACb,mBAAmB;IACvB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,SAAS;QACT,mBAAmB;QACnB,iBAAiB;QAKjB,aAAa;QACb,oBAAoB;IACxB;AACJ;;AAEA,wBAAwB;;AAExB,wBAAwB;AACxB;IACI,UAAU;IACV,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;AACjB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;AACA,4CAA4C,gBAAgB,CAAC;AAC7D;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,qBAAqB;IACrB,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,qBAAqB;IACrB,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,qBAAqB;IACrB,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;AACf;AACA,wBAAwB;;AAExB,wBAAwB;AACxB;IACI,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;IAKV,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;AACjB;AACA;IACI,8BAA8B;IAC9B,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,MAAM;IAKN,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;AACA;IACI,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAKhB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,yBAAyB;IACzB,YAAY;AAChB;AACA;IACI,eAAe;IACf,cAAc;IACd,SAAS;AACb;AACA;IACI,eAAe;AACnB;AACA;IACI,YAAY;IACZ,mBAAmB;IACnB,YAAY;IAKZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;IACrB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAKlB,aAAa;IACb,sBAAsB;IACtB,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;AACd;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,YAAY;IACZ,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,YAAY;IACZ,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,YAAY;IACZ,mBAAmB;IACnB,YAAY;IAKZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;IACrB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;IACnC,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA,wBAAwB;;AAExB,qBAAqB;;AAErB;IACI,YAAY;IACZ,aAAa;IACb,UAAU;AACd;AACA;IACI,kBAAkB;AACtB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,cAAc;IACd,iBAAiB;IACjB,qBAAqB;AACzB;AACA;IACI,kBAAkB;IAKlB,aAAa;IACb,qBAAqB;AACzB;AACA;IACI,8BAA8B;IAC9B,mBAAmB;IAKnB,aAAa;IACb,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,WAAW;AACf;AACA;IACI,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,UAAU;IACV,sCAAsC;IACtC,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;AACzB;AACA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,UAAU;IACV,sCAAsC;AAC1C;AACA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,2BAA2B;IAC3B,0BAA0B;IAC1B,wBAAwB;IACxB,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,yBAAyB;IACzB,iCAAiC;IACjC,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;AACzB;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,gBAAgB;AACpB;AACA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,YAAY,EAAE,wBAAwB;IACtC,yBAAyB;AAC7B;AACA;IACI,eAAe;IACf,2BAA2B;AAC/B;AACA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,sBAAsB;AAC1B;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,sCAAsC;IACtC,kBAAkB;AACtB;AACA;IACI,6CAA6C;AACjD;AACA;IACI,WAAW;IACX,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,eAAe;IACf,QAAQ;IACR,UAAU;IACV,cAAc;AAClB;AACA;IACI,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,iBAAiB;IACjB,WAAW;IACX,mBAAmB;AACvB;AACA;;IAEI,yBAAyB;IACzB,gCAAgC;AACpC;AACA;IACI,4CAA4C;AAChD;;AAEA;IAKI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IAKZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IAKI,SAAO;IACP,SAAS;IACT,eAAe;AACnB;AACA;IACI,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,cAAc;IACd,gBAAgB;IAChB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,MAAM;IACN,SAAS;IACT,YAAY;IAKZ,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,2BAA2B;AAC/B;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,MAAM;IACN,SAAS;IACT,YAAY;IACZ,uBAAuB;IACvB,UAAU;IACV,gCAAgC;AACpC;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,OAAO;IACP,SAAS;IACT,QAAQ;IACR,MAAM;IACN,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,OAAO;IACP,SAAS;IACT,QAAQ;IACR,MAAM;IACN,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,UAAU;IACV,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,0CAA0C;IAC1C,yCAAyC;AAC7C;AACA;IACI,WAAW;IACX,eAAe;AACnB;AACA;IACI,yBAAyB;IACzB,aAAa;IACb,mCAAmC;AACvC;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,UAAU;AACd;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,UAAU;AACd;AACA;IACI,YAAY;AAChB;AACA;IACI,qBAAqB;AACzB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,oBAAoB;AACxB;AACA;IACI,SAAS;AACb;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,UAAU;IAKV,aAAa;IACb,UAAU;IACV,kBAAkB;AACtB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,gCAAgC;IAChC,kBAAkB;AACtB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IAKI,aAAa;AACjB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,mBAAmB;IACnB,SAAO;IACP,cAAc;AAClB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,qBAAqB;IACrB,wBAAwB;IACxB,WAAW;IACX,eAAe;IACf,gCAAgC;AACpC;AACA;IACI,WAAW;AACf;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,cAAc;AAClB;AACA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,mCAAmC;IACnC,wBAAwB;IACxB,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,oBAAoB;IACpB,mBAAmB;AACvB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,mHAAmH;IACnH,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,eAAe;IACf,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,SAAS;IACT,MAAM;IACN,YAAY;IACZ,UAAU;AACd;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAKlB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,eAAe;IACf,eAAe;AACnB;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,qBAAqB;AACzB;AACA;IACI,cAAc;IACd,0BAA0B;AAC9B;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,oBAAoB;IACpB,WAAW;IACX,mBAAmB;IACnB,gCAAgC;IAChC,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,mBAAmB;AACvB;AACA;IACI;gBACY;IACZ,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,mBAAmB;IACnB,8BAA8B;IAC9B,UAAU;IACV,aAAa;IACb,uBAAuB;IAKvB,SAAO;IACP,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,WAAW;IAKX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IAKZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,YAAY;IAKZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,yBAAyB;AAC7B;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,YAAY;AAChB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,WAAW;AACf;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;IACX,gBAAgB;IAChB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,4HAA4H;AAChI;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IAKI,aAAa;IACb,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI;YACQ;AACZ;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAKlB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;AACA;IAKI,SAAO;IAKP,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;AACA,2BAA2B,8BAA8B,CAAC;AAC1D;IACI,aAAa;IACb,sBAAsB;IAKtB,SAAO;IACP,uBAAuB;AAC3B;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,wIAAwI;IACxI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IAKjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;AACA;IAKI,SAAO;AACX;AACA;IACI,WAAW;IACX;YACQ;IACR,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,sIAAsI;IACtI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,gBAAgB;AACpB,uBAAuB;AACvB,oBAAoB;AACpB,qBAAqB;AACrB,4BAA4B;AAC5B;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;AACA;IAKI,aAAa;IACb,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI;YACQ;AACZ;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;IAKT,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,mBAAmB;IAKnB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,8BAA8B;IAC9B,gBAAgB;AACpB;AACA;IAKI,SAAO;AACX;AACA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,qBAAqB;IACrB,cAAc;AAClB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,WAAW;IACX,qBAAqB;AACzB;AACA;IACI,cAAc;AAClB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,gCAAgC;AACpC;AACA;IACI,0BAA0B;IAC1B,kBAAkB;AACtB;AACA;IACI,wBAAwB;IACxB,gCAAgC;AACpC;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,cAAc;AAClB;AACA;IACI,qBAAqB;AACzB;;AAEA;IAKI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;AACA;IACI,SAAO;AACX;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,kBAAkB;AACtB;AACA;IACI,iCAAiC;AACrC;AACA;IACI,aAAa;AACjB;AACA;IACI,qBAAqB;IACrB,yBAAyB;IAKzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;IAChC,gBAAgB;IAChB,WAAW;IACX,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,qBAAqB;AACzB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;sKAsEsK;;AAEtK;;IAEI,eAAe;IACf,WAAW;IACX,WAAW;IACX,wBAAwB;IACxB,8BAA8B;IAC9B,kBAAkB;IAClB,iBAAiB;IACjB,gCAAgC;AACpC;AACA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gCAAgC;AACpC;AACA;IACI,0BAA0B;IAC1B,cAAc;AAClB;AACA;IACI,wIAAwI;IACxI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,cAAc;IACd,eAAe;AACnB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,gCAAgC;IAChC,mBAAmB;IACnB,oBAAoB;AACxB;AACA;;IAEI,mCAAmC;IACnC,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;AACjB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,YAAY;AAChB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,YAAY;IAKZ,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,uBAAuB;AAC3B;AACA;IAKI,SAAO;IAKP,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAKlB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IAKI,SAAO;IAKP,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;AACvB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,aAAa;IACb,oBAAoB;IACpB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;AACA;;IAEI,eAAe;IACf,qBAAqB;IACrB,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IAKnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gCAAgC;AACpC;AACA;;IAEI,mBAAmB;AACvB;AACA;;IAEI,kBAAkB;AACtB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,kHAAkH;IAClH,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;AACA;IAKI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,oBAAoB;AACxB;AACA;;IAEI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;;IAEI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,gCAAgC;IAChC,kBAAkB;AACtB;AACA;;IAEI,yBAAyB;AAC7B;AACA;;IAEI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,SAAS;IACT,MAAM;IACN,YAAY;IACZ;YACQ;AACZ;AACA;;IAEI,6FAA6F;AACjG;AACA;;;IAGI,8GAA8G;IAC9G,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;;;IAGI,mHAAmH;IACnH,UAAU;AACd;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;AACxB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,mCAAmC;IACnC,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;AACjB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,iCAAiC;IACjC,aAAa;IACb,8BAA8B;IAC9B,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,gBAAgB;AACpB;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,gBAAgB;AACpB;AACA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB;AACA;;IAEI,mBAAmB;IACnB,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,SAAO;AACX;AACA;AACA;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,UAAU;IACV,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,qBAAqB;IACrB,mBAAmB;IACnB,WAAW;IACX,uBAAuB;IACvB,qBAAqB;IACrB,gBAAgB;AACpB;AACA;IACI,0BAA0B;IAC1B,cAAc;AAClB;AACA;IACI,cAAc;IACd,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,8BAA8B;AAClC;AACA;IACI,oBAAoB;IACpB,+BAA+B;IAC/B,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,yBAAyB;AAC7B;AACA;IACI,UAAU;IACV,YAAY;AAChB;AACA;IACI,iCAAiC;IACjC,oCAAoC;AACxC;AACA;IACI,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,SAAS;IACT,QAAQ,EAAE,0BAA0B;AACxC;AACA;IACI,aAAa;AACjB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,uBAAuB;AAC3B;AACA;IACI,yBAAyB;IACzB,oBAAoB;IACpB,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;IACvB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,qBAAqB;AACzB;AACA;IACI,0BAA0B;IAC1B,cAAc;AAClB;AACA;;IAEI,cAAc;IACd,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,iBAAiB;IACjB,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,6BAA6B;IAC7B,iBAAiB;IACjB,aAAa;IACb,kCAAkC;IAClC,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,+BAA+B;AACnC;AACA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,WAAW;AACf;AACA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;AACA;IACI,YAAY;IACZ,YAAY;IAKZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,gCAAgC;AACpC;AACA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;AACA;IACI;gBACY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gCAAgC;IAChC,OAAO;AACX;AACA;IACI,SAAS;AACb;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,mCAAmC;IACnC,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;AACjB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;AACxB;AACA;IACI,gBAAgB;AACpB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IAKI,SAAO;IACP,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,YAAY;IAKZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,YAAY;AAChB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,mCAAmC;IACnC,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IAKb,aAAa;IACb,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,kBAAkB;AACtB;AACA;IACI,gCAAgC;AACpC;AACA;IACI,sBAAsB;IAKtB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,+BAA+B;IAC/B,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,gHAAgH;IAChH,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,QAAQ;IACR,MAAM;IACN,YAAY;AAChB;AACA;IACI,WAAW;IACX,gHAAgH;IAChH,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,QAAQ;IACR,MAAM;IACN,YAAY;AAChB;AACA;IACI,WAAW;IACX,uHAAuH;IACvH,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,QAAQ;IACR,MAAM;IACN,YAAY;AAChB;AACA;IACI,WAAW;IACX,qHAAqH;IACrH,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,QAAQ;IACR,MAAM;IACN,YAAY;AAChB;AACA;IACI,WAAW;IACX,kHAAkH;IAClH,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,QAAQ;IACR,MAAM;IACN,YAAY;AAChB;AACA;IACI,WAAW;IACX,kHAAkH;IAClH,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,QAAQ;IACR,MAAM;IACN,YAAY;AAChB;AACA;IACI,WAAW;IACX,uHAAuH;IACvH,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,QAAQ;IACR,MAAM;IACN,YAAY;AAChB;AACA;IACI,WAAW;IACX,kHAAkH;IAClH,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,QAAQ;IACR,MAAM;IACN,YAAY;AAChB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,SAAS;AACb;AACA;IAKI,SAAO;IAKP,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;AACtB;AACA;IACI,aAAa;AACjB;AACA;IACI,eAAe;AACnB;AACA;IACI,YAAY;AAChB;AACA;IACI,oBAAoB;IACpB,eAAe;AACnB;AACA;IACI,cAAc;IACd,gCAAgC;AACpC;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;IACd,gCAAgC;AACpC;AACA;IACI,cAAc;AAClB;;AAEA;IACI,mCAAmC;IACnC,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,0BAA0B;AAC9B;AACA;IACI,eAAe;AACnB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,YAAY;IACZ,mBAAmB;IACnB,UAAU;IACV,YAAY;AAChB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,WAAW;AACf;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,mCAAmC;IACnC,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;AACjB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,OAAO;IACP,MAAM;IACN,SAAS;IACT,QAAQ;IACR,mBAAmB;IAKnB,gCAAgC;IAChC,QAAQ;IACR,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,WAAW;IAKX,gCAAgC;IAChC,YAAY;AAChB;AACA;IACI,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,yBAAyB;AAC7B;AACA;IACI,4BAA4B;AAChC;AACA;IACI,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;IAC5B,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;AACzB;AACA;IACI,YAAY;AAChB;AACA;;IAEI,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,+BAA+B;IAC/B,OAAO;IACP,MAAM;IACN,uCAAuC;IACvC,oCAAoC;IACpC,mCAAmC;IACnC,kCAAkC;IAClC,eAAe;AACnB;AACA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,iBAAiB;AACrB;AACA;IACI,oBAAoB;AACxB;AACA;;IAEI,oBAAoB;AACxB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAKlB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;AACA;;IAEI,4BAA4B;IAC5B,SAAS;AACb;AACA;IACI,YAAY;AAChB;AACA;IACI,eAAe;AACnB;;AAEA;IAKI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;AACA;IAKI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,SAAS;AACb;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;AACA;IACI,qBAAqB;IACrB,cAAc;IACd,qBAAqB;AACzB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,2BAA2B;AAC/B;AACA;IACI,0BAA0B;IAC1B,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,wBAAwB;IACxB,oBAAoB;IACpB,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;;IAEI,WAAW;IAKX,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;AACd;AACA;;IAEI,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,0BAA0B;AAC9B;AACA;IACI,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,SAAS;AACb;AACA;IACI,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,YAAY;IAKZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,cAAc;IACd,cAAc;AAClB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,kCAAkC;IAClC,mCAAmC;IACnC,0BAA0B;AAC9B;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gCAAgC;IAChC,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;IACtB,eAAe;IACf,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;IACnC,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,cAAc;AAClB;AACA;IACI,2HAA2H;IAC3H,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,kIAAkI;IAClI,WAAW;IACX,WAAW;IACX,iBAAiB;IACjB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;AACf;AACA;IACI,+BAA+B;IAC/B,uCAAuC;AAC3C;;AAEA;IACI,mCAAmC;IACnC,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;AACxB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,eAAe;AACnB;AACA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;AAChB;AACA;IACI,WAAW;AACf;AACA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,mCAAmC;IACnC,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;AACjB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;AACxB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,eAAe;AACnB;AACA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,WAAW;AACf;AACA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,sIAAsI;IACtI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,QAAQ;IACR,MAAM;IACN,YAAY;AAChB;AACA;IACI,WAAW;IACX,uHAAuH;IACvH,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,YAAY;AAChB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,SAAO;IACP,iBAAiB;AACrB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,UAAU;IACV,iBAAiB;IAKjB,gCAAgC;IAChC,iBAAiB;IACjB,sBAAsB;AAC1B;AACA;IACI,kCAAkC;AACtC;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,iBAAiB;AACrB;AACA;IACI,+BAA+B;AACnC;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,MAAM;AACV;AACA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,qBAAqB;AACzB;AACA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,iBAAiB;AACrB;AACA;IACI,+BAA+B;AACnC;AACA;IACI,+BAA+B;AACnC;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,qBAAqB;AACzB;AACA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,qBAAqB;AACzB;AACA;IACI,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,4BAA4B;AAChC;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;IACT,YAAY;IACZ,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;AACA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,uBAAuB;IACvB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,oBAAoB;IACpB,qBAAqB;IACrB,WAAW;AACf;AACA;IACI,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,eAAe;IACf,WAAW;AACf;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,sIAAsI;IACtI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;AAC7B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,WAAW;IACX,6BAA6B;IAC7B,iBAAiB;AACrB;AACA;IACI,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,eAAe;AACnB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;AACf;AACA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,sBAAsB;AAC1B;AACA;CACC,WAAW;CACX,YAAY;AACb;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,yBAAyB;AAC7B;AACA;IACI,YAAY;AAChB;AACA;;IAEI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,0DAAmW;IACnW,4BAA4B;IAC5B,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;;IAEI,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,8BAA8B;IAC9B,UAAU;IACV,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;AAChB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,gBAAgB;IAChB,qBAAqB;AACzB;AACA;IACI,0BAA0B;IAC1B,gCAAgC;AACpC;AACA;IACI,eAAe;IACf,cAAc;AAClB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,iCAAiC;IACjC,UAAU;IACV,YAAY;IACZ,oBAAoB;IACpB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,MAAM;IACN,YAAY;IACZ,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,iCAAiC;IACjC,iBAAiB;IACjB,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,iCAAiC;IACjC,UAAU;IACV,iBAAiB;IACjB,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;AACA;IACI,UAAU;AACd;AACA;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,mBAAmB;IACvB;IACA;QACI,kBAAkB;IACtB;IACA;;;QAGI,sBAAsB;IAC1B;IACA;;;;QAII,iBAAiB;IACrB;IACA;;;;QAII,WAAW;IACf;IACA;;;;;QASI,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,mBAAmB;QACnB,kBAAkB;QAClB,eAAe;IACnB;IACA;;;;;;QAMI,WAAW;IACf;IACA;;;;;;;QAOI,SAAS;IACb;AACJ;;AAEA;IACI;QACI,WAAW;QACX,gBAAgB;QAChB,qBAAqB;IACzB;IACA;QACI,WAAW;IACf;IACA;QACI,WAAW;IACf;IACA;QACI,qBAAqB;IACzB;IACA;QACI,sBAAsB;QACtB,mBAAmB;QACnB,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,cAAc;QACd,qBAAqB;QACrB,oBAAoB;QACpB,mBAAmB;IACvB;IACA;QACI,WAAW;IACf;IACA;QACI,WAAW;IACf;IACA;QACI,gBAAgB;IACpB;IACA;QACI,sBAAsB;QACtB,mBAAmB;QACnB,sBAAsB;IAC1B;IACA;QACI,sBAAsB;QACtB,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;IACA;QACI,WAAW;IACf;IACA;QACI,WAAW;IACf;IACA;QACI,mBAAmB;QACnB,kBAAkB;IACtB;IACA;QACI,WAAW;QACX,iBAAiB;QACjB,mBAAmB;IACvB;IACA;QACI,SAAS;QACT,QAAQ;QACR,WAAW;QACX,WAAW;QACX,SAAS;IACb;IACA;QACI,UAAU;QACV,kBAAkB;IACtB;IACA;QACI,WAAW;QACX,SAAS;QACT,OAAO;IACX;;IAEA;QACI,WAAW;IACf;IACA;QACI,mBAAmB;QACnB,mBAAmB;QACnB,WAAW;QACX,sBAAsB;IAC1B;IACA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;IACA;QACI,kBAAkB;QAClB,uBAAuB;QACvB,eAAe;IACnB;IACA;QACI,UAAU;QACV,gBAAgB;QAChB,gBAAgB;QAChB,yBAAyB;QACzB,gBAAgB;IACpB;IACA;QACI,aAAa;QACb,gBAAgB;IACpB;IACA;QACI,SAAS;QACT,mBAAmB;QACnB,8BAA8B;QAC9B,aAAa;QACb,kBAAkB;QAClB,iBAAiB;IACrB;IACA;QACI,gBAAgB;QAChB,sBAAsB;QACtB,oBAAoB;IACxB;IACA;QACI,WAAW;QACX,gBAAgB;QAChB,8BAA8B;IAClC;IACA;QACI,WAAW;QACX,qBAAqB;QACrB,mBAAmB;QACnB,8BAA8B;QAC9B,aAAa;QACb,kBAAkB;QAClB,iBAAiB;IACrB;IACA;QACI,WAAW;QACX,SAAS;QACT,mBAAmB;QACnB,8BAA8B;QAC9B,aAAa;QACb,kBAAkB;QAClB,iBAAiB;IACrB;IACA;QACI,YAAY;QACZ,gBAAgB;IACpB;IACA;QACI,aAAa;IACjB;IACA;QACI,gBAAgB;QAChB,WAAW;QACX,wBAAwB;QACxB,mBAAmB;QACnB,8BAA8B;QAC9B,aAAa;QACb,kBAAkB;QAClB,iBAAiB;IACrB;IACA;QACI,qBAAqB;QACrB,UAAU;QACV,gBAAgB;IACpB;IACA;QACI,aAAa;IACjB;IACA;QACI,WAAW;QACX,uBAAuB;QACvB,mBAAmB;QACnB,8BAA8B;QAC9B,aAAa;QACb,iBAAiB;IACrB;IACA;QACI,SAAS;IACb;IACA;QACI,mBAAmB;IACvB;IACA;;QAEI,mBAAmB;IACvB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,SAAS;IACb;IACA;QACI,SAAS;IACb;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;IACA;QACI,yBAAyB;IAC7B;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,eAAe;QACf,OAAO;QACP,QAAQ;QACR,MAAM;QACN,WAAW;QACX,SAAS;QACT,gBAAgB;QAChB,WAAW;QACX,eAAe;QACf,kBAAkB;QAClB,kBAAkB;QAClB,yBAAyB;QAKzB,+BAA+B;QAK/B,gCAAgC;QAChC,YAAY;IAChB;IACA;QAKI,mCAAmC;QAKnC,gCAAgC;IACpC;IACA;QACI,kBAAkB;QAClB,WAAW;QACX,YAAY;QACZ,gBAAgB;QAChB,SAAS;QACT,WAAW;QACX,YAAY;QACZ,SAAS;IACb;IACA;QACI,0CAA0C;QAC1C,+CAA+C;QAC/C,kDAAkD;QAKlD,gCAAgC;QAChC,WAAW;QACX,WAAW;QACX,WAAW;QACX,gBAAgB;QAChB,kBAAkB;QAClB,kBAAkB;IACtB;IACA;QACI,2CAA2C;QAC3C,gDAAgD;QAChD,mDAAmD;QAKnD,gCAAgC;QAChC,WAAW;QACX,WAAW;QACX,WAAW;QACX,gBAAgB;QAChB,kBAAkB;QAClB,kBAAkB;IACtB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,wBAAwB;QACxB,mBAAmB;QACnB,8BAA8B;IAClC;IACA,2JAA2J;IAC3J;QACI,SAAS;QACT,kBAAkB;QAClB,eAAe;QACf,eAAe;IACnB;IACA;QACI,eAAe;QACf,WAAW;IACf;IACA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,0CAA0C;QAC1C,yCAAyC;IAC7C;IACA,yDAAyD,aAAa,CAAC;IACvE;QACI,sBAAsB;QACtB,kBAAkB;IACtB;IACA;QACI,mBAAmB;QACnB,mBAAmB;QACnB,8BAA8B;IAClC;IACA;QACI,8BAA8B;IAClC;IACA;QACI,gBAAgB;IACpB;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,aAAa;IACjB;IACA;QACI,iBAAiB;QACjB,SAAS;IACb;IACA;QACI,uBAAuB;QACvB,oBAAoB;QACpB,gBAAgB;QAChB,SAAS;QACT,gBAAgB;QAChB,2CAA2C;IAC/C;IACA;QACI,UAAU;QACV,wBAAwB;QACxB,sBAAsB;IAC1B;IACA;QACI,kBAAkB;QAClB,gCAAgC;IACpC;IACA;QACI,aAAa;QACb,mBAAmB;QACnB,8BAA8B;QAC9B,YAAY;QACZ,eAAe;QACf,gCAAgC;QAChC,kBAAkB;QAClB,UAAU;IACd;IACA;QACI,eAAe;QACf,0BAA0B;QAC1B,kBAAkB;QAClB,mBAAmB;IACvB;IACA;QAKI,SAAO;QACP,SAAS;QACT,kBAAkB;IACtB;IACA;QACI,WAAW;QACX,kBAAkB;QAClB,OAAO;QACP,MAAM;QACN,SAAS;QACT,YAAY;QACZ,YAAY;QACZ,mBAAmB;IACvB;IACA;QACI,oBAAoB;QACpB,sBAAsB;QACtB,YAAY;QACZ,kBAAkB;IACtB;IACA;QACI,aAAa;IACjB;IACA;QACI,UAAU;QACV,UAAU;IACd;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,gBAAgB;IACpB;IACA;QACI,mBAAmB;QACnB,gBAAgB;QAChB,aAAa;QACb,WAAW;IACf;IACA;QACI,aAAa;IACjB;IACA;QACI,0BAA0B;QAC1B,2BAA2B;IAC/B;IACA;QACI,YAAY;QACZ,UAAU;QACV,oBAAoB;IACxB;IACA;QACI,aAAa;IACjB;IACA;QACI,yBAAyB;IAC7B;IACA;;QAEI,WAAW;IACf;IACA;QACI,iBAAiB;QACjB,sBAAsB;IAC1B;IACA;QACI,kBAAkB;QAClB,QAAQ;QACR,MAAM;QACN,UAAU;QACV,SAAS;QACT,yBAAyB;QACzB,aAAa;QACb,cAAc;IAClB;IACA;QACI,oBAAoB;IACxB;IACA;QACI,oBAAoB,CAAC,iBAAiB,CAAC,gBAAgB,CAAC,YAAY;IACxE;IACA;QACI,mBAAmB;QACnB,6BAA6B;QAC7B,kBAAkB;QAClB,uBAAuB;QACvB,mBAAmB;IACvB;IACA;QACI,iBAAiB;QACjB,mBAAmB;QACnB,kBAAkB;QAClB,qBAAqB;QACrB,WAAW;QACX,cAAc;QACd,gBAAgB;QAChB,yBAAyB;QACzB,gCAAgC;IACpC;IACA;QACI,mBAAmB;QACnB,WAAW;IACf;IACA;QACI,qBAAqB;QACrB,yBAAyB;QACzB,cAAc;QACd,gBAAgB;QAChB,gCAAgC;QAChC,cAAc;IAClB;IACA;QACI,cAAc;IAClB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,gBAAgB;QAChB,iBAAiB;IACrB;IACA;QACI,qBAAqB;IACzB;IACA;QACI,oBAAoB;QACpB,cAAc;IAClB;IACA;QACI,mBAAmB;QACnB,mBAAmB;IACvB;;IAEA;QAKI,SAAO;QACP,gBAAgB;IACpB;IACA;QAKI,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,mBAAmB;QACnB,kBAAkB;QAClB,eAAe;QACf,mBAAmB;QACnB,cAAc;QACd,eAAe;IACnB;IACA;QACI,aAAa;QACb,mBAAmB;IACvB;IACA;QACI,eAAe;QACf,yBAAyB;QACzB,iBAAiB;QACjB,WAAW;QACX,gCAAgC;IACpC;IACA;QACI,mCAAmC;IACvC;IACA;QACI,oBAAoB;QACpB,kBAAkB;IACtB;IACA;QACI,mBAAmB;QACnB,eAAe;QACf,SAAS;QACT,OAAO;QACP,QAAQ;QACR,WAAW;QACX,+BAA+B;IACnC;IACA;QAKI,kCAAkC;IACtC;IACA;QACI,WAAW;QACX,oBAAoB;QACpB,mBAAmB;IACvB;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,SAAS;QACT,oBAAoB;IACxB;IACA;QACI,kBAAkB;QAClB,uBAAuB;QACvB,aAAa;QACb,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,QAAQ;IACZ;IACA;QACI,kBAAkB;QAClB,UAAU;QACV,WAAW;QACX,MAAM;QACN,gBAAgB;IACpB;IACA;QACI,SAAS;IACb;IACA;QACI,qBAAqB;IACzB;IACA;QACI,qBAAqB;IACzB;IACA;QACI,kBAAkB;QAClB,SAAS;QACT,QAAQ;QACR,gBAAgB;QAChB,iCAAiC;QACjC,aAAa;QACb,sBAAsB;QACtB,YAAY;QACZ,kBAAkB;QAClB,gBAAgB;QAChB,UAAU;QACV,WAAW;QACX,gCAAgC;QAChC,wCAAwC;QACxC,qCAAqC;QACrC,oCAAoC;QACpC,mCAAmC;IACvC;IACA;QACI,SAAS;QACT,UAAU;QACV,UAAU;IACd;IACA;QACI,sBAAsB;QACtB,2BAA2B;QAC3B,mBAAmB;QACnB,eAAe;QACf,qBAAqB;QACrB,WAAW;QACX,iBAAiB;QACjB,uBAAuB;QACvB,2BAA2B;QAC3B,kBAAkB;QAClB,UAAU;QACV,oBAAoB;QACpB,mCAAmC;QACnC,gCAAgC;QAChC,+BAA+B;QAC/B,8BAA8B;QAC9B,qBAAqB;IACzB;IACA;QACI,WAAW;QACX,oCAAoC;IACxC;IACA;QACI,WAAW;QACX,YAAY;QACZ,SAAS;QACT,qBAAqB;QACrB,SAAS;QACT,QAAQ;IACZ;IACA;QACI,6BAA6B;IACjC;IACA;QACI,WAAW;QACX;qBACa;QACb,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,SAAS;QACT,QAAQ;IACZ;IACA;QACI,mBAAmB;QACnB,WAAW;IACf;IACA;QACI,+FAA+F;QAC/F,uGAAuG;IAC3G;IACA;QACI,kBAAkB;IACtB;IACA;QACI,QAAQ;QACR,QAAQ;IACZ;IACA;QACI,mBAAmB;IACvB;IACA;QACI,SAAS;IACb;IACA;QACI,QAAQ;IACZ;IACA;QACI,mBAAmB;IACvB;;IAEA;QACI,UAAU;QACV,SAAS;QACT,QAAQ;IACZ;IACA;QACI,UAAU;IACd;IACA;QACI,UAAU;QACV,QAAQ;IACZ;IACA;QACI,QAAQ;QACR,kCAAkC;QAClC,mBAAmB;QACnB,oBAAoB;QACpB,eAAe;IACnB;IACA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;IACA;QACI,iBAAiB;IACrB;IACA;QACI,sBAAsB;QACtB,kBAAkB;IACtB;IACA;QACI,qBAAqB;IACzB;IACA;QACI,WAAW;IACf;AACJ;;AAEA,qCAAqC,WAAW;;AAEhD;IACI;QACI,sBAAsB;IAC1B;IACA;QACI,mBAAmB;QACnB,WAAW;QACX,mBAAmB;QACnB,8BAA8B;QAC9B,gBAAgB;QAChB,mBAAmB;IACvB;IACA;QACI,2BAA2B;IAC/B;IACA;QACI,kBAAkB;IACtB;IACA,oBAAoB,YAAY;IAChC,yBAAyB,cAAc,CAAC,kBAAkB,CAAC,SAAS,CAAC,WAAW,CAAC;IACjF,qCAAqC,WAAW;IAChD;QACI,kBAAkB;QAClB,aAAa;QACb,gCAAgC;IACpC;IACA;QACI,QAAQ;IACZ;IACA;QACI,WAAW;QACX,YAAY;QACZ,gBAAgB;QAChB,kBAAkB;QAClB,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,qBAAqB;QACrB,WAAW;QACX,eAAe;IACnB;IACA;QACI,UAAU;QACV,WAAW;QACX,yBAAyB;IAC7B;IACA;QACI,YAAY;IAChB;IACA;QACI,mBAAmB;QACnB,mBAAmB;QACnB,uBAAuB;QACvB,gBAAgB;IACpB;IACA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,UAAU;QACV,gBAAgB;IACpB;IACA;QACI,eAAe;IACnB;IACA;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,SAAS;QACT,WAAW;IACf;IACA;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,iBAAiB;QACjB,eAAe;QACf,wBAAwB;QACxB,gBAAgB;QAChB,uBAAuB;QACvB,oBAAoB;QACpB,qBAAqB;QACrB,4BAA4B;IAChC;IACA;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,oBAAoB;IACxB;IACA,oGAAoG;IACpG;QACI,kBAAkB;QAClB,WAAW;IACf;IACA;QACI,kBAAkB;QAClB,mBAAmB;QACnB,WAAW;QACX,iBAAiB;IACrB;IACA;QACI,qBAAqB;QACrB,WAAW;QACX,YAAY;QACZ,kBAAkB;IACtB;IACA;QACI,sBAAsB;QACtB,kBAAkB;QAClB,sBAAsB;QACtB,gBAAgB;QAChB,wBAAwB;IAC5B;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,eAAe;QACf,iBAAiB;QACjB,sBAAsB;IAC1B;IACA;QACI,eAAe;QACf,eAAe;IACnB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,QAAQ;QACR,SAAS;QACT,OAAO;QACP,YAAY;QACZ,WAAW;QACX,WAAW;IACf;IACA;QACI,mBAAmB;QACnB,mBAAmB;QACnB,uBAAuB;IAC3B;IACA;QACI,mBAAmB;QACnB,oBAAoB;IACxB;IACA;QACI,aAAa;QACb,gBAAgB;IACpB;IACA;QACI,YAAY;IAChB;IACA;QACI,uBAAuB;IAC3B;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;IACvB;IACA;QACI,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,gCAAgC;IACpC;IACA;QACI,kBAAkB;IACtB;IACA;QACI,SAAS;IACb;IACA;QACI,kBAAkB;QAClB,sBAAsB;QACtB,oBAAoB;IACxB;IACA;QACI,WAAW;QACX,qBAAqB;QACrB,mBAAmB;QACnB,8BAA8B;QAC9B,aAAa;QACb,kBAAkB;QAClB,iBAAiB;IACrB;IACA;QACI,WAAW;QACX,gBAAgB;QAChB,mBAAmB;QACnB,8BAA8B;QAC9B,kBAAkB;IACtB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,QAAQ;QACR,QAAQ;IACZ;IACA;QACI,aAAa;IACjB;IACA;QACI,aAAa;IACjB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,oBAAoB;IACxB;IACA;QACI,gBAAgB;QAChB,WAAW;QACX,wBAAwB;QACxB,mBAAmB;QACnB,8BAA8B;QAC9B,aAAa;QACb,kBAAkB;QAClB,iBAAiB;IACrB;IACA;QACI,eAAe;QACf,mBAAmB;QACnB,kBAAkB;QAClB,iBAAiB;IACrB;IACA;QACI,kBAAkB;QAClB,UAAU;QACV,SAAS;IACb;IACA;QACI,qBAAqB;IACzB;IACA;QACI,gBAAgB;QAChB,iBAAiB;IACrB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,aAAa;IACjB;IACA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,SAAS;QACT,mBAAmB;QACnB,WAAW;IACf;IACA;QACI,kBAAkB;IACtB;IACA;QACI,kBAAkB;QAClB,yBAAyB;QACzB,mBAAmB;QACnB,aAAa;QACb,2BAA2B;QAC3B,gBAAgB;QAChB,SAAO;QACP,uBAAuB;QACvB,iBAAiB;IACrB;IACA;QACI,kBAAkB;QAClB,YAAY;QACZ,mBAAmB;QACnB,aAAa;QACb,2BAA2B;QAC3B,iBAAiB;IACrB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,YAAY;IAChB;IACA;QACI,YAAY;IAChB;IACA,qFAAqF;IACrF;QACI,sBAAsB;QACtB,aAAa;QACb,2BAA2B;QAC3B,mBAAmB;QACnB,6BAA6B;QAC7B,iBAAiB;QACjB,eAAe;IACnB;IACA;QACI,yBAAyB;QACzB,kBAAkB;QAClB,mBAAmB;IACvB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,oBAAoB;IACxB;IACA;;QAEI,WAAW;QACX,oBAAoB;IACxB;IACA;QACI,gBAAgB;QAChB,WAAW;QACX,wBAAwB;QACxB,mBAAmB;QACnB,8BAA8B;QAC9B,aAAa;QACb,kBAAkB;QAClB,iBAAiB;IACrB;IACA;QACI,UAAU;QACV,gBAAgB;IACpB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,mBAAmB;IACvB;IACA;;QAEI,wBAAwB;QACxB,aAAa;IACjB;IACA;QACI,WAAW;QACX,mBAAmB;QACnB,mBAAmB;QACnB,uBAAuB;IAC3B;IACA;QACI,kBAAkB;IACtB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,YAAY;IAChB;IACA;QACI,SAAS;IACb;IACA;QACI,SAAS;IACb;IACA;QACI,WAAW;QACX,iBAAiB;IACrB;IACA;QACI,oBAAoB;IACxB;IACA;QACI,iBAAiB;QACjB,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;;;;QAII,wBAAwB;IAC5B;IACA;;;;;;QAMI,mBAAmB;IACvB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,aAAa;IACjB;;IAEA;QACI,SAAO;QACP,eAAe;QACf,iBAAiB;IACrB;AACJ;AACA,qBAAqB;;AAErB,mBAAmB;;AAEnB;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,yBAAyB;IACzB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,iCAAiC;IACjC,oCAAoC;IACpC,8BAA8B;IAC9B,UAAU;IACV,SAAS;AACb;AACA;IACI,mBAAmB;AACvB;AACA;IACI,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,UAAU;IACV,YAAY;AAChB;AACA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IAKI,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,aAAa;AACjB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,yBAAyB;AAC7B;AACA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,QAAQ;IACR,SAAS;IACT,MAAM;IACN,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,mBAAmB;AACvB;AACA;IACI,+CAA+C;IAC/C,kCAAkC;IAClC,mBAAmB;IACnB,aAAa;AACjB;AACA;IACI,4CAA4C;IAC5C,kCAAkC;IAClC,mBAAmB;IACnB,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,aAAa;IACb,WAAW;IACX,WAAW;IACX,YAAY;AAChB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;AAChB;AACA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,0DAAyV;IACzV,4BAA4B;IAC5B,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;AACvB;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,gBAAgB;AACpB;AACA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,UAAU;IACV,SAAS;IACT,gBAAgB;IAKhB,aAAa;AACjB;AACA;IACI,mBAAmB;IACnB,iCAAiC;IACjC,2BAA2B;IAC3B,mBAAmB;IAKnB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,eAAe;AACnB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,oIAAoI;IACpI,WAAW;AACf;AACA;IACI,4HAA4H;IAC5H,WAAW;AACf;AACA;IACI,qIAAqI;IACrI,WAAW;AACf;AACA;IACI,2HAA2H;IAC3H,WAAW;AACf;AACA;IACI,4HAA4H;IAC5H,WAAW;AACf;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,WAAW;IACX,WAAW;IAKX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,WAAW;AACf;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;;AAEA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,SAAO;IACP,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,YAAY;IACZ,wIAAwI;IACxI,iBAAiB;AACrB;AACA;IACI,SAAO;IACP,WAAW;IACX,eAAe;IACf,UAAU;IACV,iBAAiB;AACrB;;AAEA;IAKI,SAAO;IACP,kBAAkB;IAKlB,aAAa;IACb,uBAAuB;IACvB,gCAAgC;AACpC;AACA;IACI,WAAW;IACX,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,YAAY;IACZ,QAAQ;IACR,WAAW;IACX,mBAAmB;IACnB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,uBAAuB;IACvB,0DAAqgB;IACrgB,4BAA4B;IAC5B,2BAA2B;IAC3B,qBAAqB;IACrB,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,SAAS;AACb;AACA;IACI,WAAW;IACX,uBAAuB;IACvB,0DAA+V;IAC/V,4BAA4B;IAC5B,2BAA2B;IAC3B,qBAAqB;IACrB,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,WAAW;IAKX,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,cAAc;IACd,sBAAsB;IACtB,uBAAuB;IACvB,yBAAyB;IACzB,uBAAuB;IACvB,qBAAqB;IACrB,qCAAqC;IACrC,0DAAuJ;AAC3J;AACA;IACI,oCAAoC;AACxC;AACA;IACI,0DAAuJ;AAC3J;AACA;IACI,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,cAAc;IACd,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,qGAAqG;AACzG;AACA;IACI,qGAAqG;AACzG;AACA;IACI,qGAAqG;AACzG;AACA;IACI,qGAAqG;AACzG;AACA;IACI,qGAAqG;AACzG;AACA;IACI,UAAU;AACd;AACA;IACI;QACI,sBAAsB;QACtB,mBAAmB;QACnB,mBAAmB;QACnB,kBAAkB;QAClB,eAAe;IACnB;IACA;QACI,gBAAgB;QAChB,4BAA4B;QAC5B,6BAA6B;QAC7B,wBAAwB;QACxB,kBAAkB;QAKlB,aAAa;QACb,uBAAuB;IAC3B;AACJ;;AAEA,0CAA0C;AAC1C;IACI,QAAQ;IACR,UAAU;AACd;;AAEA,yBAAyB;AACzB;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,UAAU;AACd;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;AACA;IAKI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,WAAW;IAKX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,gCAAgC;IAChC,oBAAoB;IACpB,mBAAmB;AACvB;AACA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;AACA;IACI,6BAA6B;AACjC;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,+CAA+C;AACnD;AACA;IACI,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,UAAU;IACV,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,OAAO;IACP,SAAS;AACb;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,SAAS;IACT,QAAQ;IACR,SAAS;IACT,kCAAkC;IAClC,mCAAmC;IACnC,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,wBAAwB;IACxB,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,qBAAqB;IACrB,UAAU;AACd;AACA;IACI,+BAA+B;IAC/B,uCAAuC;AAC3C;AACA;IACI,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,0DAAgX;IAChX,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,0DAAkX;IAClX,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAKhB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;AACnB;AACA;IACI,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,8BAA8B;IAC9B,gCAAgC;IAChC,yBAAyB;IACzB,SAAS;IACT,QAAQ;IACR,iCAAiC;IACjC,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;AAChC;AACA;IACI,SAAO;AACX;AACA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;AACA;IACI,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,0BAA0B;IAC1B,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,qBAAqB;AACzB;AACA;IACI,YAAY;IACZ,eAAe;IACf,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;;AAEA;IACI,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IAKZ,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;AACA;IACI,iBAAiB;IAKjB,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,YAAY;AAChB;AACA;IACI,cAAc;AAClB;AACA;IACI,UAAU;AACd;;AAEA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,UAAU;IACV,YAAY;IACZ,MAAM;IACN,SAAS;IACT,WAAW;IACX,YAAY;AAChB;AACA;IACI,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IAKI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;AAChB;AACA;IAKI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,iBAAiB;IACjB,2BAA2B;IAC3B,qBAAqB;AACzB;AACA;IACI,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,cAAc;AAClB;AACA;IACI,wHAAwH;AAC5H;AACA;IACI,wHAAwH;AAC5H;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,gCAAgC;AACpC;AACA;IACI,gCAAgC;AACpC;;AAEA;IACI;QACI,oBAAoB;QACpB,mBAAmB;IACvB;IACA;QACI,WAAW;QACX,WAAW;QACX,OAAO;QACP,WAAW;QACX,SAAS;QACT,WAAW;IACf;AACJ;;AAEA,kBAAkB;;AAElB;IACI,gCAAgC;AACpC;AACA;IACI,YAAY;IACZ,UAAU;IAKV,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,qBAAqB;IACrB,WAAW;IACX,eAAe;AACnB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,WAAW;IACX,gCAAgC;IAChC,YAAY;AAChB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,UAAU;IACV,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;AACzB;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,gCAAgC;AACpC;AACA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;IACZ,0DAAqO;AACzO;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;IACnC,gBAAgB;IAChB,YAAY;IAKZ,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,+BAA+B;IAC/B,WAAW;IACX,YAAY;IACZ,MAAM;IACN,QAAQ;AACZ;AACA;IACI,+BAA+B;IAC/B,uCAAuC;AAC3C;AACA;IACI,uBAAuB;IAKvB,SAAO;AACX;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;IACX,YAAY;IACZ,kHAAkH;AACtH;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;IACX,YAAY;IACZ,oHAAoH;AACxH;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,mBAAmB;IACnB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;AACzB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IAKZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;IACnC,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,YAAY;AAChB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,mBAAmB;AACvB;AACA;IACI,+BAA+B;IAC/B,uCAAuC;AAC3C;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,6BAA6B;IAC7B,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,SAAS;IACT,QAAQ;IACR,iCAAiC;IACjC,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,aAAa;AACjB;AACA;IAKI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IAKI,aAAa;IACb,iBAAiB;IACjB,oBAAoB;AACxB;AACA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,YAAY;IAKZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,cAAc;AAClB;AACA;IACI,UAAU;IACV,SAAS;AACb;AACA;IACI,gBAAgB;IAKhB,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IAKX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,YAAY;AAChB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,oBAAoB;AACxB;AACA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,UAAU;IACV,8BAA8B;IAC9B,WAAW;IAKX,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,cAAc;IACd,6BAA6B;IAC7B,+BAA+B;IAC/B,wBAAwB;IACxB,YAAY;IACZ,gBAAgB;IAChB,MAAM;IACN,SAAS;IACT,YAAY;IACZ,gCAAgC;IAChC,6BAA6B;IAC7B,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,YAAY;IACZ,YAAY;IAKZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,iCAAiC;IACjC,oCAAoC;IACpC,+BAA+B;IAC/B,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,4BAA4B;IAC5B,kBAAkB;IAClB,aAAa;IACb,kBAAkB;AACtB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,YAAY;AAChB;AACA;IAKI,SAAO;IACP,iBAAiB;AACrB;AACA;IACI,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IAKjB,aAAa;IACb,sBAAsB;AAC1B;AACA;IAKI,SAAO;IAKP,aAAa;AACjB;AACA;IACI,cAAc;IACd,WAAW;IACX,8BAA8B;AAClC;AACA;IACI,cAAc;IACd,qBAAqB;AACzB;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IAKZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,2BAA2B;IAC3B,6BAA6B;IAC7B,SAAS;IACT,UAAU;IACV,yBAAyB;IACzB,iCAAiC;IACjC,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;AAChC;;AAEA;IACI;QACI,mBAAmB;IACvB;IACA;QACI,uBAAuB;QACvB,wBAAwB;QACxB,gBAAgB;IACpB;IACA;QACI,aAAa;IACjB;AACJ;AACA,qBAAqB;;AAErB,4BAA4B;;AAE5B;IACI,UAAU;IACV,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;AACA;IACI,gCAAgC;AACpC;AACA;IACI,yBAAyB;IAKzB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,WAAW;IAKX,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,YAAY;IACZ,6BAA6B;AACjC;AACA;IACI,gBAAgB;IAChB,wBAAwB;AAC5B;AACA;IACI,eAAe;AACnB;AACA;IAKI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,0BAA0B;IAC1B,kBAAkB;IAClB,aAAa;AACjB;AACA;IACI,SAAS;IACT,UAAU;IAKV,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,8BAA8B;AAClC;AACA;IACI,YAAY;IACZ,UAAU;IACV,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IAKf,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;IACtB,8BAA8B;IAC9B,MAAM;IACN,SAAS;IACT,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,2BAA2B;IAC3B,0GAA0G;AAC9G;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,2BAA2B;AAC/B;AACA;IACI,4HAA4H;AAChI;AACA;IACI,sHAAsH;IACtH,qBAAqB;AACzB;AACA;IACI,sHAAsH;IACtH,qBAAqB;IACrB,sBAAsB;AAC1B;AACA;IACI,uHAAuH;IACvH,qBAAqB;AACzB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,8BAA8B;IAC9B,gCAAgC;IAChC,SAAS;IACT,QAAQ;IACR,yBAAyB;IACzB,iCAAiC;IACjC,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IAKzB,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAKlB,SAAO;AACX;AACA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,kBAAkB;IACtB;IACA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,WAAW;IACf;IACA;QACI,WAAW;QACX,gBAAgB;QAChB,oBAAoB;IACxB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;IACA;QACI,YAAY;IAChB;IACA;QACI,eAAe;QACf,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,kBAAkB;IACtB;IACA;QACI,eAAe;QACf,mBAAmB;IACvB;IACA;QACI,sBAAsB;QACtB,2BAA2B;IAC/B;IACA;QACI,kBAAkB;QAClB,gBAAgB;IACpB;AACJ;;AAEA,0BAA0B;;AAE1B,wBAAwB;AACxB;IACI,UAAU;IACV,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;AACjB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,qBAAqB;IACrB,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,qBAAqB;IACrB,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,qBAAqB;IACrB,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;AACf;AACA,wBAAwB;;AAExB;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,+BAA+B;AACnC;AACA;IACI,qBAAqB;AACzB;AACA;IACI,aAAa;IAKb,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,oBAAoB;AACxB;AACA;IACI,gBAAgB;IAChB,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,kCAAkC;IAClC,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,YAAY;IACZ,0DAA0D;AAC9D;AACA;IACI,kBAAkB;AACtB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,kCAAkC;IAClC,oBAAoB;IACpB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IAKI,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,YAAY;IAKZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,2BAAsB;IAAtB,sBAAsB;IACtB,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,sBAAsB;AAC1B;AACA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,WAAW;AACf;AACA;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;AACZ;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,mBAAmB;AACvB;AACA;IACI,qBAAqB;IACrB,iGAAiG;IACjG,yGAAyG;IACzG,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,qBAAqB;IACrB,iGAAiG;IACjG,yGAAyG;AAC7G;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,uBAAuB;AAC3B;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,8BAA8B;IAK9B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;IACnC,gBAAgB;AACpB;AACA;IACI,MAAM;AACV;AACA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,qBAAqB;IAKrB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,gBAAgB;IAChB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,wCAAwC;EAC1C;;EAEA;IACE,aAAa;IACb,eAAe;IACf,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,WAAW;IACX,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,yBAAyB,EAAE,+BAA+B;AAC9D;;AAEA;IACI,eAAe;IACf,WAAW;IACX,eAAe;AACnB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,qBAAqB;IAKrB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,eAAe;AACnB;;AAEA;IACI,yEAAyE;AAC7E;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,YAAY;IACZ,0DAA0D;IAC1D;AACJ;AACA;IACI,gIAAgI;IAChI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,OAAO;IACP,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAKhB,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB,qBAAqB;IACrB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;;AAEA;IACI,iBAAiB;AACrB;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,mBAAmB;AACvB;AACA;IACI;gBACY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gCAAgC;IAChC,OAAO;IACP,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,gIAAgI;IAChI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gCAAgC;IAChC,OAAO;IACP,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,mBAAmB;AACvB;AACA;IACI,gIAAgI;IAChI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gCAAgC;IAChC,OAAO;IACP,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,UAAU;IACV,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,QAAQ;AACZ;;AAEA;IACI,SAAS;AACb;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,UAAU;IACV,WAAW;IACX,SAAS;IACT,YAAY;IACZ,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;IACnC,qBAAqB;AACzB;AACA;IACI,cAAc;AAClB;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB,qBAAqB;IACrB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,yBAAyB;IACzB,WAAW;AACf;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;AACpB;AACA;;;IAGI,WAAW;IACX,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;AACjB;AACA;;;IAGI,gBAAgB;AACpB;AACA;;;IAGI,gBAAgB;AACpB;;AAEA;IAKI,qCAAqC;IACrC,qBAAqB;IACrB,cAAc;IACd,mBAAmB;AACvB;AACA;IACI,8BAA8B;IAC9B,gBAAgB;IAKhB,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,cAAc;AAClB;AACA;IAKI,qCAAqC;IACrC,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;IAEI,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI;QACI,UAAU;QACV,SAAS;QACT,QAAQ;IACZ;IACA;QACI,UAAU;IACd;IACA;QACI,UAAU;QACV,QAAQ;IACZ;IACA;QACI,QAAQ;QACR,kCAAkC;QAClC,mBAAmB;QACnB,oBAAoB;QACpB,eAAe;IACnB;IACA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;IACA;QACI,8BAA8B;QAC9B,aAAa;QACb,iBAAiB;QACjB,kBAAkB;IACtB;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IAKI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,YAAY;IAKZ,aAAa;IACb,sBAAsB;AAC1B;AACA;IAKI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,0DAAsY;IACtY,4BAA4B;IAC5B,2BAA2B;IAC3B,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;AAC7B;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,mBAAmB;AACvB;AACA;IACI,qBAAqB;IACrB,iGAAiG;IACjG,yGAAyG;IACzG,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,qBAAqB;IACrB,iGAAiG;IACjG,yGAAyG;AAC7G;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;AACZ;;AAEA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IAKnB,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,WAAW;AACf;;AAEA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,wBAAwB;IACxB,uBAAuB;AAC3B;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAKlB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,WAAW;AACf;AACA;IACI,wBAAwB;IACxB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,sBAAsB;IACtB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,qBAAqB;AACzB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,QAAQ;AACZ;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,qGAAqG;IACrG,8BAA8B;IAC9B,UAAU;IACV,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,UAAU;AACd;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI;QACI,YAAY;QACZ,SAAS;IACb;IACA;QACI,gBAAgB;QAChB,YAAY;IAChB;AACJ;AACA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,mBAAmB;IACnB,0BAA0B;IAC1B,kBAAkB;IAClB,UAAU;IACV,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,iCAAiC;AACrC;AACA;IACI,aAAa;AACjB;AACA;IACI,0BAA0B;IAC1B,iBAAiB;IACjB,0BAA0B;IAC1B,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,UAAU;IACV,kCAAkC;IAClC,qCAAqC;IACrC,6BAA6B;IAC7B,QAAQ;IACR,SAAS;IACT,YAAY;AAChB;AACA;IACI,wBAAwB;IACxB,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;AACA;IAKI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,sBAAsB;IACtB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,6BAA6B;IAC7B,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,QAAQ;IACR,SAAS;AACb;AACA;IACI,SAAS;IACT,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,+BAA+B;IAK/B,aAAa;IACb,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,WAAW;IAKX,aAAa;IACb,mBAAmB;IACnB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI;qBACiB;IACjB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,+BAA+B;IAC/B,uCAAuC;AAC3C;AACA;IACI,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,+FAA+F;IAC/F,uGAAuG;AAC3G;AACA;IACI,wBAAwB;IACxB,gCAAgC;IAChC,6BAA6B;IAC7B,4BAA4B;IAC5B,2BAA2B;AAC/B;AACA;IACI,yBAAyB;IACzB,iCAAiC;IACjC,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;AAChC;;AAEA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAKlB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qGAAqG;IACrG,iCAAiC;IACjC,8BAA8B;IAC9B,UAAU;IACV,WAAW;IACX,gBAAgB;AACpB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;AACzB;AACA;IACI,WAAW;AACf;AACA;IACI,eAAe;IACf,SAAS;AACb;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;AACb;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,MAAM;IACN,OAAO;AACX;AACA;IACI,SAAS;AACb;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,kBAAkB;IAKlB,aAAa;IACb,uBAAuB;IACvB,gCAAgC;IAChC,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,WAAW;IACX,YAAY;IACZ;YACQ;AACZ;AACA;IACI,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,qIAAqI;AACzI;AACA;IACI,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,oIAAoI;AACxI;AACA;IACI,YAAY;IACZ,WAAW;IACX,YAAY;IACZ;YACQ;AACZ;AACA;IACI,cAAc;IACd,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;IACnC,kBAAkB;AACtB;AACA;IACI,2BAA2B;IAC3B,mCAAmC;IACnC,gCAAgC;IAChC,+BAA+B;IAC/B,8BAA8B;AAClC;;AAEA;IACI;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,eAAe;QACf,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,uBAAuB;IACvB,aAAa;IAKb,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,WAAW;AACf;AACA;IACI,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,YAAY;AAChB;AACA;IACI,qBAAqB;IACrB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,eAAe;IACf,WAAW;IACX,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,+CAA+C;IAC/C,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,YAAY;IAKZ,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,UAAU;AACd;;AAEA;IACI,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;AAChC;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,SAAS;IACT,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,UAAU;IACV,UAAU;IACV,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;AACZ;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,mBAAmB;AACvB;AACA;IACI,qBAAqB;IACrB,iGAAiG;IACjG,yGAAyG;IACzG,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,qBAAqB;IACrB,iGAAiG;IACjG,yGAAyG;AAC7G;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IAKX,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,qIAAqI;IACrI,+FAA+F;IAC/F,uGAAuG;AAC3G;AACA;IACI,wIAAwI;AAC5I;AACA;IACI,oIAAoI;AACxI;AACA;IACI;YACQ;AACZ;AACA;IAKI,SAAO;AACX;;AAEA;IACI;qBACiB;IACjB,WAAW;IACX,YAAY;AAChB;AACA;IACI;YACQ;IACR,WAAW;IACX,YAAY;AAChB;AACA;IACI;YACQ;IACR,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,iCAAiC;IACjC,yCAAyC;AAC7C;;AAEA;IACI,+CAA+C;IAC/C,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IAKZ,aAAa;IACb,sBAAsB;AAC1B;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,gCAAgC;IAChC,mBAAmB;IAKnB,SAAO;AACX;AACA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IACZ;YACQ;AACZ;AACA;IACI,WAAW;IACX,YAAY;IACZ,sIAAsI;AAC1I;AACA;IACI,WAAW;IACX,YAAY;IACZ,uIAAuI;AAC3I;AACA;IACI,WAAW;IACX,YAAY;IACZ;YACQ;AACZ;AACA;IACI,aAAa;IAKb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,uBAAuB;AAC3B;AACA;IACI,eAAe;IACf,eAAe;AACnB;AACA;IACI,eAAe;IACf,iBAAiB;AACrB;AACA;IAKI,SAAO;IAKP,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,cAAc;IAClB;AACJ;AACA;IACI;QACI,iBAAiB;IACrB;AACJ;AACA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,kBAAkB;IACtB;IACA;QACI,uBAAuB;QACvB,kBAAkB;IACtB;IACA;QACI,8BAA8B;IAClC;IACA;QACI,aAAa;IACjB;AACJ;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IAKjB,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,0BAA0B;AAC9B;AACA;IAKI,SAAO;IACP,eAAe;AACnB;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,eAAe;IAKf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT,mBAAmB;IACnB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;IACtB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,UAAU;IACV,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,yBAAyB;IACzB,iBAAiB;IACjB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;IACnC;;iCAE6B;AACjC;;AAEA,iBAAiB;;AAEjB;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;IACV,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,eAAe;AACnB;AACA;IACI,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,aAAa;IACb,WAAW;AACf;AACA;IACI,mBAAmB;AACvB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,UAAU;IACV,mBAAmB;IAKnB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,iCAAiC;AACrC;AACA,oWAAoW;;AAEpW;IACI,WAAW;IACX,YAAY;IACZ,2HAA2H;IAC3H,gGAAgG;IAChG,wGAAwG;AAC5G;AACA;IACI,WAAW;IACX,YAAY;IACZ,qIAAqI;IACrI,gGAAgG;IAChG,wGAAwG;AAC5G;AACA;IACI,WAAW;IACX,YAAY;IACZ,gIAAgI;IAChI,gGAAgG;IAChG,wGAAwG;AAC5G;AACA;IACI,WAAW;IACX,YAAY;IACZ,uIAAuI;IACvI,gGAAgG;IAChG,wGAAwG;AAC5G;AACA;IACI,WAAW;IACX,YAAY;IACZ,0HAA0H;IAC1H,gGAAgG;IAChG,wGAAwG;AAC5G;AACA;IACI,WAAW;IACX,YAAY;IACZ,2HAA2H;IAC3H,gGAAgG;IAChG,wGAAwG;AAC5G;AACA;IACI,WAAW;IACX,YAAY;IACZ;SACK;IACL,gGAAgG;IAChG,wGAAwG;AAC5G;AACA;IACI,WAAW;IACX,YAAY;IACZ,sIAAsI;IACtI,gGAAgG;IAChG,wGAAwG;AAC5G;AACA;IACI,WAAW;IACX,YAAY;IACZ,uIAAuI;IACvI,gGAAgG;IAChG,wGAAwG;AAC5G;AACA;IACI,WAAW;IACX,YAAY;IACZ,wIAAwI;IACxI,gGAAgG;IAChG,wGAAwG;AAC5G;AACA;IACI,WAAW;IACX,YAAY;IACZ,kIAAkI;IAClI,gGAAgG;IAChG,wGAAwG;AAC5G;AACA;IACI,WAAW;IACX,YAAY;IACZ,sIAAsI;IACtI,gGAAgG;IAChG,wGAAwG;AAC5G;AACA;IACI,WAAW;IACX,WAAW;IACX;qBACiB;IACjB,gGAAgG;IAChG,wGAAwG;AAC5G;AACA;;IAEI,WAAW;IACX,YAAY;IACZ,+HAA+H;IAC/H,gGAAgG;IAChG,wGAAwG;IACxG,sBAAsB;AAC1B;AACA;IACI,iBAAiB;AACrB;;AAEA;IAKI,SAAO;IAKP,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;AACA;IAKI,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,SAAS;AACb;AACA;IACI,cAAc;AAClB;AACA;IACI,+FAA+F;IAC/F,uGAAuG;IACvG,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,kCAAkC;IAClC,mCAAmC;IACnC,6BAA6B;IAC7B,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,QAAQ;IACR,SAAS;IACT,SAAS;IACT,gCAAgC;AACpC;AACA;IACI,6BAA6B;AACjC;;AAEA;IAKI,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;IAKT,aAAa;IACb,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,qBAAqB;IACrB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IAKX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,OAAO;IACP,QAAQ;IACR,SAAS;IACT,MAAM;IACN,YAAY;IACZ,mBAAmB;IACnB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,OAAO;IACP,QAAQ;IACR,SAAS;IACT,MAAM;IACN,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,2BAA2B;IAC3B,6BAA6B;IAC7B,SAAS;IACT,QAAQ;IACR,yBAAyB;IACzB,iCAAiC;IACjC,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAKlB,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,8BAA8B;IAK9B,gCAAgC;AACpC;AACA;IACI,iCAAiC;AACrC;AACA;IACI,kBAAkB;AACtB;AACA;IACI,gHAAgH;IAChH,WAAW;IACX,YAAY;IACZ,qBAAqB;IAKrB,gCAAgC;AACpC;AACA;IACI,8FAA8F;IAC9F,qGAAqG;AACzG;AACA;IACI,SAAO;IACP,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,gGAAgG;IAChG,wGAAwG;AAC5G;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,sBAAsB,EAAE,6BAA6B;IACrD,mBAAmB;IACnB,YAAY;IAKZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gCAAgC;AACpC;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,WAAW;AACf;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IAKX,gCAAgC;AACpC;AACA;IACI,yBAAyB;AAC7B;AACA;IAKI,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,gCAAgC;AACpC;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,SAAS;IACT,uBAAuB;IACvB,sBAAsB;IACtB,YAAY;AAChB;AACA;IACI,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,kBAAkB;IAKlB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;IACnC,gBAAgB;AACpB;AACA;IAKI,aAAa;IACb,eAAe;AACnB;AACA;IACI,YAAY;IACZ,eAAe;AACnB;AACA;IACI,cAAc;AAClB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,qBAAqB;IAKrB,gCAAgC;AACpC;AACA;IACI,cAAc;AAClB;;AAEA;IACI,iCAAiC;IACjC,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,oHAAoH;IACpH,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,0BAA0B;AAC9B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,YAAY;AAChB;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;AAC7B;AACA;IACI,gBAAgB;IAKhB,aAAa;IACb,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,eAAe;IACf,0CAA0C;IAC1C,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,eAAe;AACnB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,gCAAgC;AACpC;AACA;IACI,gCAAgC;IAChC,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,oBAAoB;AACxB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,aAAa;AACjB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,aAAa;AACjB;AACA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,8BAA8B;IAC9B,gCAAgC;IAChC,yBAAyB;IACzB,QAAQ;IACR,SAAS;IACT,iCAAiC;IACjC,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;AAChC;AACA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,UAAU;IACV,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;AACd;AACA;IACI,WAAW;AACf;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;AAC3B;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,WAAW;IACX,qBAAqB;IAKrB,gCAAgC;IAChC,gBAAgB;IAChB,+BAA+B;AACnC;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;AACA;IACI,cAAc;AAClB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI;QACI,cAAc;IAClB;IACA;QACI,YAAY;IAChB;IACA;QACI,WAAW;QACX,gBAAgB;QAChB,QAAQ;IACZ;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,uBAAuB;QACvB,gBAAgB;IACpB;AACJ;;AAEA,uBAAuB;;AAEvB;IACI,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IAKnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,aAAa;AACjB;AACA;IACI,cAAc;IACd,aAAa;IAKb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,0BAA0B;IAC1B,4BAA4B;IAC5B,0BAA0B;IAC1B,SAAS;IACT,UAAU;IACV,kCAAkC;IAClC,+BAA+B;IAC/B,8BAA8B;IAC9B,6BAA6B;AACjC;AACA;IACI,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,0BAA0B;IAC1B,4BAA4B;IAC5B,0BAA0B;IAC1B,SAAS;IACT,UAAU;IACV,kCAAkC;IAClC,+BAA+B;IAC/B,8BAA8B;IAC9B,6BAA6B;AACjC;AACA;IACI,oCAAoC;IACpC,kBAAkB;IAClB,uBAAuB;AAC3B;AACA;;IAEI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,eAAe;IACf,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;IACnC,eAAe;AACnB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;AACf;AACA;IACI,iCAAiC;AACrC;AACA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,oHAAoH;AACxH;;AAEA;IACI,YAAY;AAChB;;AAEA,sBAAsB;;AAEtB;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,eAAe;AACnB;AACA;IACI,+BAA+B;IAC/B,uCAAuC;AAC3C;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,yBAAyB;IACzB,iCAAiC;IACjC,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;AAChC;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gCAAgC;IAChC,oBAAoB;AACxB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,SAAS;AACb;AACA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;IACnC,kBAAkB;IAClB,QAAQ;IACR,SAAS;AACb;AACA;IACI,+BAA+B;IAC/B,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,uCAAuC;AAC3C;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;AACA;IACI,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,mBAAmB;AACvB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;AACA,uCAAuC,WAAW,CAAC,YAAY,CAAC,iBAAiB,CAAC,gBAAgB,CAAC;AACnG;IACI,WAAW;IACX,YAAY;IACZ,qIAAqI;IACrI,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,YAAY;IACZ,wIAAwI;IACxI,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,YAAY;IACZ,6HAA6H;IAC7H,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,YAAY;IACZ;uBACmB;IACnB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,0DAA0rB;IAC1rB,4BAA4B;IAC5B,2BAA2B;IAC3B,qCAAqC;IACrC,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,qHAAqH;IACrH,4BAA4B;IAC5B,2BAA2B;IAC3B,gCAAgC;IAChC,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,eAAe;IACf,gCAAgC;AACpC;AACA;IACI,wBAAwB;IACxB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;IAC5B,oCAAoC;IACpC,iCAAiC;IACjC,gCAAgC;IAChC,+BAA+B;AACnC;AACA;IACI,yBAAyB;IACzB,iCAAiC;IACjC,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;AAChC;AACA;IACI,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,YAAY;IAKZ,aAAa;IACb,6BAA6B;IAC7B,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,mBAAmB;IACnB,0BAA0B;IAC1B,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,oBAAoB;IACpB,qBAAqB;IACrB,WAAW;IAKX,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,eAAe;IACf,qBAAqB;IACrB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,2BAA2B;IAC3B,gBAAgB;AACpB;AACA;IACI,uBAAuB;IACvB,iBAAiB;AACrB;AACA;IACI,aAAa;AACjB;;AAEA;IAKI,aAAa;AACjB;AACA;IACI,YAAY;AAChB;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;AACpB;;AAEA;;IAEI,gBAAgB;IAKhB,aAAa;AACjB;AACA;;IAEI,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,0BAA0B;IAK1B,wBAAwB;IACxB,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;;IAEI,0BAA0B;IAC1B,gBAAgB;IAChB,mBAAmB;AACvB;AACA;;IAEI,cAAc;AAClB;;AAEA;IACI,gIAAgI;IAChI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;AACA;IACI,gIAAgI;IAChI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,+BAA+B;IAC/B,uCAAuC;AAC3C;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,wBAAwB;AAC5B;AACA;IACI,mBAAmB;IACnB,0BAA0B;IAC1B,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,oBAAoB;IACpB,qBAAqB;IACrB,cAAc;IAKd,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IAKI,aAAa;AACjB;AACA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,WAAW;AACf;AACA;IACI,+BAA+B;IAC/B,uCAAuC;AAC3C;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,+CAA+C;IAC/C,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IAKnB,aAAa;IACb,qBAAqB;IACrB,uBAAuB;AAC3B;AACA;IACI,+FAA+F;IAC/F,uGAAuG;AAC3G;AACA;IACI,gBAAgB;AACpB;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,cAAc;IACd,WAAW;IACX,SAAS;AACb;AACA;IACI,WAAW;IAKX,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;AACvB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;IACnB,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;IACnB,yBAAyB;AAC7B;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IAKI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;AACvB;AACA;IAKI,SAAO;IACP,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,8BAA8B;AAClC;AACA;IACI,YAAY;IACZ,WAAW;AACf;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,+CAA+C;IAC/C,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,YAAY;AAChB;AACA;IACI,mBAAmB;IAKnB,aAAa;IACb,gBAAgB;IAChB,uBAAuB;AAC3B;AACA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAKhB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,eAAe;IACf,mBAAmB;IACnB,YAAY;IAKZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,WAAW;AACf;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,SAAS;IAKT,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,2BAA2B;IAC3B,eAAe;IACf,SAAS;IACT,iBAAiB;IACjB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;IACnC,gCAAgC;AACpC;AACA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,SAAS;IACT,UAAU;AACd;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,6BAA6B;AACjC;AACA;IACI,WAAW;IACX,kBAAkB;AACtB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,yBAAyB;AAC7B;AACA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,kBAAkB;IAKlB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IAKI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,uBAAuB;IACvB,kCAAkC;IAClC,qCAAqC;IACrC,mCAAmC;IACnC,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,+BAA+B;IAC/B,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,WAAW;AACf;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gCAAgC;IAChC,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;IACnC,kBAAkB;IAClB,QAAQ;IACR,SAAS;AACb;AACA;IACI,+BAA+B;IAC/B,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,uCAAuC;AAC3C;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,+BAA+B;IAC/B,uCAAuC;AAC3C;AACA;IACI,WAAW;IACX,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,2HAA2H;IAC3H,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,UAAU;IACV,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,mBAAmB;IACnB,gBAAgB;IAKhB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,gCAAgC;IAChC,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,YAAY;IACZ,SAAS;AACb;AACA;IACI,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,cAAc;IACd,eAAe;AACnB;AACA;IAKI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IAKjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,YAAY;IACZ,qIAAqI;IACrI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,SAAS;AACb;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;AACvB;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,gBAAgB;AACpB;AACA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,UAAU;IACV,SAAS;IACT,gBAAgB;IAKhB,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,mBAAmB;IACnB,iCAAiC;IACjC,2BAA2B;IAC3B,mBAAmB;IAKnB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,UAAU;IACV,cAAc;IACd,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IAKjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,UAAU;IACV,iBAAiB;IACjB,SAAS;IACT,WAAW;IACX,WAAW;IACX,gCAAgC;IAChC,6BAA6B;AACjC;AACA;IACI,WAAW;IACX,YAAY;IACZ,qIAAqI;IACrI,iBAAiB;AACrB;AACA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;AACf;AACA;IACI,+BAA+B;IAC/B,uCAAuC;AAC3C;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;IACtB,cAAc;IACd,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,wBAAwB;IACxB,YAAY;IACZ,kCAAkC;IAClC,mCAAmC;IACnC,oCAAoC;IACpC,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;AACf;AACA;IACI,YAAY;IACZ,4BAA4B;AAChC;AACA;IACI,0BAA0B;IAC1B,yBAAyB;IACzB,mBAAmB;IACnB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;IACtB,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,gGAAgG;IAChG,wGAAwG;AAC5G;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;AACf;AACA;IACI,+BAA+B;IAC/B,uCAAuC;AAC3C;AACA;IACI,UAAU;AACd;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,WAAW;IAKX,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,gCAAgC;IAChC,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,yBAAyB;IACzB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,iCAAiC;IACjC,oCAAoC;IACpC,8BAA8B;IAC9B,QAAQ;IACR,SAAS;AACb;AACA;IACI,mBAAmB;AACvB;AACA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,uBAAuB;IACvB,0BAA0B;IAC1B,YAAY;AAChB;AACA;IACI,WAAW;IACX,0DAAuV;IACvV,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,YAAY;IACZ,qBAAqB;IACrB,4BAA4B;IAC5B,oCAAoC;AACxC;AACA;IACI,OAAO;AACX;AACA;IACI,QAAQ;IACR,qBAAqB;AACzB;;AAEA;IACI;QACI,sBAAsB;QACtB,kBAAkB;IACtB;IACA;QACI,gBAAgB;QAKhB,aAAa;QACb,uBAAuB;IAC3B;IACA;QACI,gBAAgB;QAChB,WAAW;IACf;IACA;QACI,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,eAAe;QACf,iBAAiB;QACjB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,uBAAuB;IAC3B;IACA;QACI,yBAAyB;QACzB,iCAAiC;QACjC,8BAA8B;QAC9B,6BAA6B;QAC7B,4BAA4B;IAChC;IACA;QACI,kBAAkB;IACtB;IACA;QACI,eAAe;QACf,gBAAgB;QAChB,kBAAkB;QAClB,oBAAoB;IACxB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,kBAAkB;QAClB,qBAAqB;QACrB,YAAY;QACZ,kCAAkC;QAClC,qCAAqC;QACrC,mCAAmC;QACnC,QAAQ;QACR,SAAS;QACT,YAAY;QACZ,OAAO;QACP,QAAQ;QACR,oCAAoC;IACxC;IACA;QACI,mCAAmC;QACnC,SAAS;QACT,8BAA8B;QAC9B,OAAO;IACX;IACA;QACI,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,eAAe;QACf,iBAAiB;QACjB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;IACA;QACI,aAAa;IACjB;IACA;QACI,2BAA2B;IAC/B;IACA;QACI,aAAa;IACjB;IACA;QACI,cAAc;IAClB;IACA;QACI,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,eAAe;QACf,iBAAiB;QACjB,mBAAmB;IACvB;AACJ;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,WAAW;AACf;;AAEA,cAAc;;AAEd;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;IACnB,UAAU;IACV,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iIAAiI;IACjI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,eAAe;IACf,gBAAgB;IAKhB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,eAAe;IACf,gCAAgC;IAChC,YAAY;AAChB;AACA;IACI,WAAW;IACX,YAAY;IACZ,iIAAiI;IACjI,kBAAkB;AACtB;AACA;IACI,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,UAAU;AACd;AACA;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;IAKb,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,mBAAmB;AACvB;AACA;IACI,gCAAgC;AACpC;AACA;IAKI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;AACf;AACA;IAKI,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,cAAc;IACd,eAAe;AACnB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IAKjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,YAAY;IACZ,qIAAqI;IACrI,YAAY;AAChB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;;AAEA;IACI;6HACyH;IACzH,YAAY;IAKZ,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,gBAAgB;IAChB,eAAe;AACnB;AACA,gQAAgQ;AAChQ;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;IACnB,UAAU;IACV,eAAe;IACf,YAAY;IAKZ,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IAKnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,qGAAqG;IACrG,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;AACb;AACA;IACI,SAAS;AACb;AACA;IACI,mBAAmB;AACvB;AACA;IACI,SAAS;AACb;AACA;IACI,iBAAiB;IACjB,8BAA8B;IAC9B,sCAAsC;IACtC,mCAAmC;IACnC,kCAAkC;IAClC,iCAAiC;AACrC;AACA;IACI,WAAW;IACX,WAAW;IACX,8BAA8B;IAC9B,gCAAgC;IAChC,iCAAiC;IACjC,mCAAmC;AACvC;AACA;IACI,gBAAgB;IAChB,8BAA8B;IAC9B,sCAAsC;IACtC,mCAAmC;IACnC,kCAAkC;IAClC,iCAAiC;AACrC;AACA;IACI,UAAU;IACV,WAAW;IACX,kCAAkC;IAClC,gCAAgC;IAChC,iCAAiC;IACjC,+BAA+B;AACnC;AACA;IACI,6DAA6D;IAC7D,cAAc;IACd,UAAU;AACd;AACA;IACI,gCAAgC;IAChC,+BAA+B;AACnC;AACA;IACI,8BAA8B;IAC9B,gCAAgC;IAChC,iCAAiC;IACjC,mCAAmC;AACvC;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,6DAA6D;IAC7D,cAAc;IACd,UAAU;IACV,iCAAiC;IACjC,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,+CAA+C;IAC/C,2BAA2B;IAC3B,mBAAmB;IACnB,UAAU;AACd;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IACZ,+HAA+H;IAC/H,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,iBAAiB;IACjB,8BAA8B;IAC9B,sCAAsC;IACtC,mCAAmC;IACnC,kCAAkC;IAClC,iCAAiC;AACrC;AACA;IACI,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,gCAAgC;IAChC,0BAA0B;IAC1B,+BAA+B;IAC/B,sBAAsB;IACtB,8BAA8B;IAC9B,2BAA2B;IAC3B,0BAA0B;IAC1B,yBAAyB;AAC7B;AACA;IACI,gBAAgB;IAChB,8BAA8B;IAC9B,sCAAsC;IACtC,mCAAmC;IACnC,kCAAkC;IAClC,iCAAiC;AACrC;AACA;IACI,UAAU;IACV,YAAY;IACZ,8BAA8B;IAC9B,gCAAgC;IAChC,0BAA0B;IAC1B,4BAA4B;IAC5B,sBAAsB;IACtB,+BAA+B;IAC/B,2BAA2B;IAC3B,0BAA0B;IAC1B,yBAAyB;AAC7B;AACA;IACI,SAAS;AACb;AACA;IACI,mBAAmB;AACvB;AACA;IACI,SAAS;AACb;;AAEA,oDAAoD,qBAAqB,EAAE,mBAAmB,EAAE,yBAAyB,EAAE,mBAAmB,EAAE,UAAU,EAAE,iBAAiB,EAAE,qBAAqB,EAAE,eAAe,EAAE,cAAc,EAAE,gCAAgC,EAAE,wCAAwC,EAAE,qCAAqC,EAAE,oCAAoC,EAAE,mCAAmC,EAAE,sBAAsB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,iBAAiB,EAAE;AACzf,8DAA8D,mBAAmB,CAAC,WAAW,CAAC;;AAE9F,uEAAuE,mBAAmB,CAAC,qBAAqB,CAAC,cAAc,CAAC;AAChI,kFAAkF,mBAAmB,CAAC,qBAAqB,CAAC,WAAW,CAAC;;AAExI;IACI,6EAAmE;IACnE,aAAa;IACb,kBAAkB;IAClB,wBAAwB;AAC5B;AACA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAKlB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gCAAgC;IAChC,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,MAAM;IACN,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,eAAe;AACnB;AACA;IAKI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,kBAAkB;AACtB;AACA;IAKI,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAKlB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,eAAe;AACnB;AACA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,kCAAkC;IAClC,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,YAAY;IACZ,WAAW;IACX,qBAAqB;IACrB,YAAY;IAKZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,gIAAgI;IAChI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IAKI,SAAO;IACP,iBAAiB;AACrB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,+FAA+F;IAC/F,uGAAuG;AAC3G;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;IACV,aAAa;AACjB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,SAAS;IACT,gBAAgB;AACpB,EAAE,oHAAoH;AACtH;IACI,+CAA+C;IAC/C,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,SAAS;IACT,WAAW;IACX,YAAY;AAChB;AACA;IACI,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,QAAQ;IACR,SAAS;IACT,eAAe;IACf,YAAY;IACZ,UAAU;IAKV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IAKjB,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;AACA;IACI,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,+BAA+B;IAC/B,uCAAuC;AAC3C;;AAEA;IACI,uIAAuI;IACvI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,eAAe;IAKf,aAAa;AACjB;AACA;IACI,+FAA+F;IAC/F,uGAAuG;AAC3G;AACA;IACI,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,8BAA8B;IAC9B,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,UAAU;IACV,WAAW;IACX,YAAY;IAKZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI;QACI,eAAe;QACf,OAAO;QACP,QAAQ;QACR,MAAM;QACN,SAAS;QACT,WAAW;QACX,aAAa;IACjB;IACA;QACI,SAAO;QACP,8BAA8B;QAC9B,mBAAmB;QACnB,mBAAmB;IACvB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,aAAa;QACb,QAAQ;QACR,gBAAgB;IACpB;IACA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA,wBAAwB;;AAExB;IACI,+BAA+B;IAC/B,uCAAuC;AAC3C;;AAEA;IACI,UAAU;AACd;AACA;IACI,eAAe;IACf,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;AACf;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,aAAa;AACjB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IAKT,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,QAAQ;IACR,SAAS;IACT,kCAAkC;IAClC,mCAAmC;IACnC,gCAAgC;IAChC,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,QAAQ;IACR,SAAS;IACT,kCAAkC;IAClC,mCAAmC;IACnC,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;IAKrB,aAAa;IACb,wBAAwB;AAC5B;AACA;IACI,UAAU;IACV,SAAS;IACT,gBAAgB;IAKhB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,YAAY;IACZ;YACQ;IACR,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,YAAY;IACZ,wIAAwI;IACxI,qBAAqB;AACzB;AACA;IACI,+BAA+B;IAC/B,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI;YACQ;IACR,+BAA+B;IAC/B,uCAAuC;AAC3C;;AAEA;IACI,WAAW;IACX,UAAU;AACd;AACA;IACI,kBAAkB;AACtB;AACA;IACI,wBAAwB;IACxB,iBAAiB;AACrB;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,2BAA2B;AAC/B;AACA;IACI,wBAAwB;IACxB,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,WAAW;AACf;AACA;IACI,aAAa;AACjB;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,SAAS;IACT,uBAAuB;IACvB,yBAAyB;IACzB,iCAAiC;IACjC,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;IAC5B,mBAAmB;IACnB,yBAAyB;IACzB,iCAAiC;IACjC,6BAA6B;IAK7B,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;AACvB;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,gBAAgB;AACpB;AACA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,SAAS;IACT,gBAAgB;IAChB,gCAAgC;IAKhC,aAAa;IACb,8BAA8B;AAClC;AACA;IACI,SAAS;IACT,SAAS;AACb;AACA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;IACnC,eAAe;IACf,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,cAAc;AAClB;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,QAAQ;IACR,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,aAAa;AACjB;AACA;IACI,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;AAChB;AACA;;IAEI,gBAAgB;AACpB;AACA;IAKI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;AACA;IAKI,aAAa;AACjB;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,2HAA2H;IAC3H,WAAW;IACX,YAAY;AAChB;AACA;IACI,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,iBAAiB;IAKjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;IACnC,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,0BAA0B;IAC1B,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;AACzB;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,gCAAgC;IAChC,qBAAqB;AACzB;;AAEA;IACI,YAAY;AAChB;AACA;IACI,iCAAiC;IACjC,2BAA2B;IAC3B,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAKlB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,sBAAsB;IACtB,8BAA8B;IAC9B,2BAA2B;IAC3B,0BAA0B;IAC1B,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,YAAY;IACZ;YACQ;IACR,mBAAmB;IACnB,aAAa;AACjB;AACA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;AACzB;AACA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,SAAS;IACT,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;AACA,+EAA+E;AAC/E;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,uBAAuB;IACvB,2BAA2B;IAC3B,mBAAmB;IACnB,YAAY;AAChB;AACA;IACI,WAAW;IACX,0DAAuV;IACvV,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,YAAY;IACZ,qBAAqB;IACrB,4BAA4B;IAC5B,oCAAoC;AACxC;AACA;IACI,WAAW;AACf;AACA;IACI,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,QAAQ;IACR,SAAS;IACT,iCAAiC;IACjC,oCAAoC;IACpC,8BAA8B;IAC9B,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,QAAQ;AACZ;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IAKZ,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,aAAa;IAKb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,mCAAmC;IACnC,kBAAkB;IAClB,aAAa;AACjB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;IAChB,UAAU;IACV,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,UAAU;IACV,WAAW;IACX,YAAY;IAKZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;IACnC,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,0BAA0B;IAC1B,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,eAAe;IACf,qBAAqB;AACzB;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,gCAAgC;IAChC,qBAAqB;AACzB;;AAEA;IACI,mIAAmI;IACnI,WAAW;IACX,YAAY;IACZ,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,gCAAgC;AACpC;AACA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;IAKV,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,gGAAgG;IAChG,wGAAwG;IACxG,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,8FAA8F;AAClG;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;;IAEI,+BAA+B;IAC/B,uCAAuC;AAC3C;AACA;IACI,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,gCAAgC;IAChC,QAAQ;IACR,UAAU;IACV,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,WAAW;IACX,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,2BAA2B;IAC3B,0BAA0B;IAC1B,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;IACZ,eAAe;IACf,WAAW;IACX,YAAY;IAKZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;AACf;AACA;IACI,kBAAkB;AACtB;AACA;IACI,YAAY;AAChB;AACA;IACI,aAAa;AACjB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,2BAA2B;IAC3B,6BAA6B;IAC7B,yBAAyB;IACzB,iCAAiC;IACjC,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;AAChC;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;AACA;IACI,cAAc;IACd,wBAAwB;IAKxB,SAAO;AACX;AACA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;AACf;AACA;IACI,kBAAkB;AACtB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,YAAY;IAKZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,+BAA+B;IAC/B,uCAAuC;AAC3C;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,8BAA8B;IAC9B,+BAA+B;IAC/B,gCAAgC;IAChC,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,QAAQ;IACR,WAAW;IACX,qCAAqC;AACzC;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,YAAY;IACZ,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,YAAY;AAChB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,iCAAiC;IACjC,oCAAoC;IACpC,6BAA6B;IAC7B,UAAU;IACV,UAAU;AACd;;AAEA,aAAa,eAAe,CAAC,gBAAgB,CAAC,kBAAkB,EAAE,eAAe,CAAC,UAAU,CAAC,kBAAkB,CAAC;;AAEhH;IACI,yBAAyB;IACzB,iCAAiC;IACjC,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;AAChC;AACA;IACI,wBAAwB;IACxB,gCAAgC;IAChC,6BAA6B;IAC7B,4BAA4B;IAC5B,2BAA2B;AAC/B;AACA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB;YACQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI;QACI,oBAAoB;IACxB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,eAAe;QACf,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,wBAAwB;QACxB,qBAAqB;QACrB,SAAS;QACT,YAAY;QACZ,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,WAAW;QACX,MAAM;QACN,SAAS;QACT,QAAQ;QACR,mBAAmB;QACnB,UAAU;IACd;AACJ;;AAEA;IACI;QACI,WAAW;QACX,mBAAmB;IACvB;IACA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;AACA;IACI;QACI,SAAS;IACb;IACA;QACI,iBAAiB;IACrB;IACA;QACI,WAAW;IACf;IACA;QACI,cAAc;IAClB;IACA;QACI,uBAAuB;QACvB,gBAAgB;IACpB;IACA;QACI,2BAA2B;QAC3B,4BAA4B;QAC5B,iBAAiB;QACjB,kBAAkB;QAClB,WAAW;QACX,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,WAAW;IACf;IACA;QACI,kBAAkB;IACtB;IACA;QACI,sBAAsB;QACtB,cAAc;QACd,iBAAiB;QACjB,WAAW;QACX,cAAc;IAClB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;AACA;IAKI,oCAAoC;IACpC,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;AAClB;AACA;;IAEI,cAAc;AAClB;AACA;;IAEI,WAAW;AACf;AACA;IACI,oCAAoC;IACpC,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,uBAAuB;AAC3B;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;AACvB;AACA;;;IAGI,uBAAuB;AAC3B;AACA;IACI,gCAAgC;EAClC;AACF;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,UAAU;IACV,YAAY;IACZ,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,gBAAgB;AACpB;;AAEA,+BAA+B;AAC/B;IACI,kBAAkB;AACtB;;AAEA,oBAAoB;AACpB;IACI,UAAU;AACd;;AAEA,oBAAoB;AACpB;IACI,gBAAgB;AACpB;;AAEA,qBAAqB;AACrB;IACI,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,+CAA+C;IAC/C,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,YAAY;IAKZ,aAAa;IACb,gBAAgB;IAChB,yBAAyB;AAC7B;AACA;IAKI,SAAO;IAKP,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,WAAW;IACX,YAAY;IACZ,uHAAuH;IACvH,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IACZ,uHAAuH;IACvH,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;;IAEI,kCAAkC;AACtC;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,8BAA8B;IAC9B,yBAAyB;IACzB,0BAA0B;AAC9B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,oBAAoB;IACpB,iCAAiC;AACrC;AACA;IACI,6FAA6F;IAC7F,qGAAqG;AACzG;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,MAAM;IACN,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,sCAAsC;IACtC,cAAc;AAClB;;AAEA;IACI;QACI,6BAA6B;IACjC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI,0BAA0B;IAC1B,sCAAsC;IACtC,yBAAyB;IACzB,gCAAgC;IAChC,eAAe;IACf,uCAAuC;AAC3C;;AAEA;IACI,iBAAiB;IACjB,gDAAgD;AACpD;AACA;CACC,aAAa;AACd;;AAEA,2CAA2C,wBAAwB,CAAC;;;AAGpE;IACI,aAAa;AACjB;;AAEA;IAKI,aAAa;AACjB;AACA;IACI,gCAAgC;IAChC,2BAA2B;IAC3B,WAAW;IACX,kBAAkB;IAClB,mBAAmB;AACvB;AACA,aAAa,yBAAyB,CAAC,YAAY,CAAC;;;AAGpD,4BAA4B,gBAAgB,CAAC,gBAAgB,CAAC;AAC9D,2BAA2B;AAC3B,mBAAmB,aAAa,EAAE,mBAAmB,EAAE,0BAA0B,EAAE,kCAAkC,EAAE,+BAA+B,EAAE,8BAA8B,EAAE,6BAA6B,EAAwF,aAAa,EAAE,sBAAsB,EAAE,mBAAmB,CAAC;AACxW,0BAA0B,mBAAmB,CAAC,yBAAyB,CAAC,0BAA0B,CAAC,kCAAkC,CAAC,+BAA+B,CAAC,8BAA8B,CAAC,6BAA6B,CAAC,aAAa,CAAC;AACjP,4BAA4B,UAAU,CAAC,SAAS,CAAC,gBAAgB,CAAC;AAClE,gDAAgD,mBAAmB,CAAC;AACpE,gCAAqH,aAAa,CAAC;AACnI,kCAAkC,WAAW,CAAC,YAAY,EAAuF,aAAa,CAAC,kBAAkB,CAAC,eAAe,CAAC;AAClM,4CAA4C,iIAAiI,CAAC;AAC9K,wCAAwC,mIAAmI,CAAC;AAC5K,uCAAuC,iIAAiI,CAAC;AACzK,2CAA2C,wIAAwI,CAAC;AACpL,mCAAmC,wBAAwB,CAAC,iBAAiB,CAAC,mBAAmB,CAAC;AAClG,iCAAiC,cAAc,EAAE,qBAAqB,CAAC;AACvE,uCAAuC,cAAc,CAAC;AACtD,wBAA8G,aAAa,EAAE,uBAAuB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,WAAW,EAAE,YAAY,EAAE,+BAA+B,EAAE,0BAA0B,EAAE,uBAAuB,EAAE,sBAAsB,EAAE,qBAAqB,CAAC;AACnY,2BAA2B,WAAW,CAAC,YAAY,CAAC;AACpD,gCAAgC,WAAW,CAAC,eAAe,CAAC,eAAe,CAAC,gBAAgB,CAAC;;AAE7F,0BAA0B,mBAAmB,CAAC,2BAA2B,CAAC,mBAAmB,CAAC,UAAU,CAAC;AACzG,4BAA4B,UAAU,CAAC,SAAS,CAAC,gBAAgB,CAAC;AAClE,gCAAqH,aAAa,CAAC,mBAAmB,CAAC;AACvJ,gDAAgD,mBAAmB,CAAC;AACpE,qCAAqC,WAAW,CAAC,eAAe,EAAuF,aAAa,CAAC,mBAAmB,CAAC,uBAAuB,CAAC;AACjN,qCAAqC,WAAW,EAAE,YAAY,CAAC,cAAc,EAAE,kBAAkB,EAAuF,aAAa,CAAC,mBAAmB,CAAC,uBAAuB,CAAC;AAClP,sCAAsC,WAAW,EAAE,YAAY,CAAC,yBAAyB,EAAE,kBAAkB,EAAE,0BAA0B,EAAE,uBAAuB,EAAE,sBAAsB,EAAE,qBAAqB,CAAC,sBAAsB,CAAC;AACzO,6DAA6D,WAAW,CAAC,kBAAkB,CAAC,OAAO,CAAC,QAAQ,CAAC,YAAY,CAAC,gCAAgC,CAAC,yBAAyB,CAAC,SAAS,CAAC,QAAQ,CAAC;AACxM,oDAAoD,0FAA0F,CAAC,kGAAkG,CAAC;AAClP,gDAAgD,mBAAmB,CAAC,oBAAoB,CAAC,WAAW,CAAC,YAAY,CAAC;AAClH,0DAA0D,WAAW,EAAE,kBAAkB,EAAE,2BAA2B,EAAE,6BAA6B,EAAE,WAAW,EAAE,WAAW,EAAE,QAAQ,EAAE,SAAS,EAAE,yBAAyB,EAAE,iCAAiC,EAAE,8BAA8B,EAAE,6BAA6B,EAAE,4BAA4B,CAAC;AAChW,qDAAqD,+BAA+B,CAAC;AACrF,+DAA+D,gBAAgB,CAAC;AAChF,mBAAmB,sBAAsB,CAAC,aAAa,CAAC,gBAAgB,CAAC;;;AAGzE,2CAA2C,YAAY,CAAC;;AAExD,cAAc,eAAe;;AAE7B,yFAAyF,cAAc,CAAC;;AAExG,iBAAiB,eAAe,CAAC,eAAe,CAAC;;AAEjD;IACI,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY,CAAC,UAAU,CAAC,6BAA6B;AACzD;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,SAAS;IACT,QAAQ;IACR,YAAY;IACZ,wBAAwB;IACxB,gCAAgC;IAChC,6BAA6B;IAC7B,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;IAC5B,oCAAoC;AACxC;;AAEA,cAAmG,aAAa,CAAkE,SAAO,CAAC;;AAE1L;IACI,aAAa,SAAS,CAAC,gBAAgB,EAAE,mBAAmB,CAAC;AACjE;;AAEA,mBAAmB,sBAAsB,CAAC,kBAAkB,CAAC,iBAAiB,CAAC,WAAW,CAAC,YAAY,CAAC;AACxG,sDAAsD,WAAW,CAAC;;;AAGlE;EACE,oBAAoB;EACpB,gBAAgB,CAAmF,aAAa;;AAElH;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,mBAAmB;EACnB,WAAW;EACX,iBAAiB,CACiE,aAAa;EAC/F,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;AACA,kDACmF,aAAa;CAC/F,gBAAgB;AACjB;;AAEA;IACI;AACJ;AACA,gCAAgC;AAChC,gCAAgC,mBAAmB,CAAC,yBAAyB,CAAC,kBAAkB,CAAC,gBAAgB,CAAC,qBAAqB,CAAC,kBAAkB,CAAC,qBAAqB,CAAC,WAAW,CAAC,gCAAgC,CAAC,wCAAwC,CAAC,qCAAqC,CAAC,oCAAoC,CAAC,mCAAmC,CAAC,UAAU,CAAC;;AAEjY,sCAAsC,sBAAsB,CAAC;AAC7D;;AAEA,cAAc;AACd;AACA,4BAA4B;AAC5B;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,UAAU;AACd;;AAEA,YAAY,WAAW,CAAC,eAAe,CAAC,aAAa,CAAC,uBAAuB,CAAC,kBAAkB,CAAC,2BAA2B,CAAC,iCAAiC,CAAC;AAC/J,sCAAsC,WAAW,CAAC,cAAc,CAAC,WAAW,CAAC,eAAe,CAAC,kBAAkB,CAAC,0BAA0B,CAAC;AAC3I,mBAAmB,WAAW,CAAC,sBAAsB,CAAC;;AAEtD;IACI;QACI;IACJ;AACJ;;AAEA,+BAA+B,gCAAgC,CAAC;AAChE,sCAAsC,gCAAgC,CAAC;AACvE,4DAA4D,yBAAyB,CAAC;;;AAGtF,yBAAyB;;AAEzB,uBAAuB,kBAAkB,CAAC,eAAe,CAAC;AAC1D,0BAA0B,gBAAgB,CAAC,UAAU,CAAC,SAAS,CAAmF,aAAa,CAAC;AAChK,6BAA6B,mBAAmB,CAAC,yBAAyB,CAAC,kBAAkB,CAAC,YAAY,CAAC,aAAa,CAAC,kBAAkB,CAAC,aAAa,CAAmF,aAAa,CAAC,sBAAsB,CAAC,mBAAmB,CAAC;AACrS,6CAA6C,kBAAkB,CAAC;AAChE,gDAAgD,kBAAkB,EAAE,SAAS,EAAE,UAAU,EAAE,WAAW,EAAE,YAAY,EAAE,yBAAyB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,gCAAgC,EAAE,wCAAwC,EAAE,qCAAqC,EAAE,oCAAoC,EAAE,mCAAmC,EAAE,0BAA0B,EAAE,uBAAuB,EAAE,sBAAsB,EAAE,qBAAqB,CAAC,eAAe,CAAC;AACxe,sDAAsD,yBAAyB,CAAC,qBAAqB,CAAC,yDAA+O,CAAC;;AAEtV,mCAAmC,eAAe,CAAC,gBAAgB,CAAC,kBAAkB,CAAC;AACvF,aAAa,kBAAkB,CAAC,YAAY,CAAC,WAAW,CAAmF,aAAa,CAAC;AACzJ,aAAa,0HAA0H,CAAC,WAAW,CAAC,YAAY,CAAC,kBAAkB,CAAC;AACpL,WAAW,yHAAyH,CAAC,WAAW,CAAC,YAAY,CAAC;AAC9J,qBAAqB,8FAA8F,EAAE,sGAAsG,EAAE;;AAE7N,kDAAkD,yBAAyB,EAAE,qBAAqB,CAAC;AACnG,eAAe,WAAW,CAAC,YAAY,CAAC,yBAAyB,CAAmF,aAAa,CAAC,mBAAmB,CAAC,uBAAuB,CAAC,kBAAkB,CAAC,0BAA0B,CAAC,uBAAuB,CAAC,sBAAsB,CAAC,qBAAqB,CAAC;;AAEjU,YAAY;;AAEZ,eAAe,mBAAmB,EAAE,eAAe,EAAE,YAAY,EAAE,WAAW,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,qBAAqB,EAAE,WAAW,EAAwF,aAAa,EAAE,mBAAmB,EAAE,eAAe,EAAE,qBAAqB,EAAE,gCAAgC,EAAE,wCAAwC,EAAE,qCAAqC,EAAE,oCAAoC,EAAE,mCAAmC,EAAE;AAC7f,kBAAkB,iBAAiB,CAAC;AACpC,mBAAmB,WAAW,CAAC,yBAAyB,CAAC;;AAEzD,eAAe,aAAa,CAAC,UAAU,CAAC;AACxC,wBAAwB,YAAY,CAAC,iBAAiB,CAAC,UAAU,CAAC,YAAY,CAAC,mBAAmB,CAAC;AACnG,2CAA2C,gBAAgB,CAAC,mBAAmB,CAAC;AAChF,kDAAkD,eAAe,CAAC,uBAAuB,CAAC,gCAAgC,CAAC,gCAAgC,CAAC,wCAAwC,CAAC,qCAAqC,CAAC,oCAAoC,CAAC,mCAAmC,CAAC,kBAAkB,CAAC,gBAAgB,CAAC;AACxV,uDAAuD,eAAe,CAAC,uBAAuB,CAAC,8BAA8B,CAAC,6BAA6B,CAAC,sCAAsC,CAAC,mCAAmC,CAAC,kCAAkC,CAAC,iCAAiC,CAAC;AAC5S,8CAA8C,kBAAkB,CAAC,MAAM,CAAC,WAAW,CAAC,gBAAgB,CAAC,YAAY,CAAC,cAAc,CAAC;AACjI,UAAU,WAAW,EAAE,YAAY,CAAoF,aAAa,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,uBAAuB,EAAE,sBAAsB,EAAE,qBAAqB,CAAC;AAC/U,qBAAqB,+HAA+H,CAAC,WAAW,CAAC,YAAY,CAAmF,aAAa,CAAC,SAAS,CAAC,UAAU,CAAC;;AAEnS,uBAAuB,8BAA8B,CAAC,cAAc,CAAC;AACrE,mBAAmB,8BAA8B,CAAC,cAAc,CAAC;AACjE,yBAAyB,WAAW,CAAC,YAAY,CAAC,2BAA2B,CAAC,6BAA6B,CAAC,4BAA4B,CAAC,kBAAkB,CAAC,iCAAiC,CAAC,kBAAkB,CAAC,UAAU,CAAC,UAAU,CAAC,qBAAqB,CAAC,gCAAgC,CAAC,wCAAwC,CAAC,qCAAqC,CAAC,oCAAoC,CAAC,mCAAmC,CAAC;AACtb,gCAAgC,WAAW,CAAC,kBAAkB,CAAC,OAAO,CAAC,QAAQ,CAAC,SAAS,CAAC,UAAU,CAAC,WAAW,CAAC,WAAW,CAAC,gBAAgB,CAAC,YAAY,CAAC,gCAAgC,CAAC,wCAAwC,CAAC,qCAAqC,CAAC,oCAAoC,CAAC,mCAAmC,CAAC;;AAEpV,8BAA8B,8BAA8B,CAAC,gCAAgC,CAAC,+BAA+B,CAAC;AAC9H,sCAAsC,mBAAmB,CAAC;;AAE1D,4BAA4B,iBAAiB,CAAC;AAC9C,sBAAsB,WAAW,EAAE,YAAY,CAAC,eAAe,GAAG,cAAc,CAAC;;AAEjF,sBAAsB,4BAA4B,EAAE,2BAA2B,EAAE,qBAAqB,EAAE,kBAAkB,EAAE,WAAW,EAAE,YAAY,EAAE,eAAe,EAAE,gCAAgC,EAAE,wCAAwC,EAAE,qCAAqC,EAAE,oCAAoC,EAAE,mCAAmC,EAAE,sBAAsB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,0BAA0B,EAAE,uBAAuB,EAAE,sBAAsB,EAAE,qBAAqB,EAAE;AACjhB,mBAAmB,0DAAsiB,CAAC;AAC1jB,oCAAoC,sBAAsB,CAAC,yBAAyB,CAAC,0DAAsiB,CAAC;;AAE5nB,uBAAuB,0DAAgc,CAAC;AACxd,wCAAwC,sBAAsB,CAAC,yBAAyB,CAAC,0DAAgc,CAAC;;AAE1hB,qBAAqB,0DAAsiB,CAAC;AAC5jB,sCAAsC,sBAAsB,CAAC,yBAAyB,CAAC,0DAAsiB,CAAC;;AAE9nB,mBAAmB,gBAAgB,CAAC,SAAS,CAAC,gBAAgB,CAAC,gBAAgB,CAAC;AAChF,uCAAuC,mBAAmB,CAAC;AAC3D,qBAAqB,mBAAmB,CAAC,mBAAmB,CAAC,2BAA2B,CAAC,wBAAwB,CAAC,uBAAuB,CAAC,sBAAsB,CAAC,kBAAkB,CAAC,sBAAsB,CAAC,iBAAiB,CAAC,eAAe,CAAC;;AAE7O;AACA,cAAc,UAAU,CAAC;AACzB,wBAAwB,WAAW,EAAE,gBAAgB,EAAE,wBAAwB,EAAE,qBAAqB,EAAE,oBAAoB,EAAE,mBAAmB,EAAE;AACnJ,kDAAkD,aAAa,CAAC,gBAAgB,CAAC,wBAAwB,CAAC,qBAAqB,CAAC,oBAAoB,CAAC,mBAAmB,CAAC;AACzK,SAAS,WAAW,CAAC,YAAY,CAAC;AAClC,uDAAuD,uBAAuB,CAAC,gBAAgB,CAAC,wBAAwB,CAAC,qBAAqB,CAAC,oBAAoB,CAAC,mBAAmB,CAAC;AACxL,wBAAwB,iBAAiB,EAAE,eAAe,CAAC;AAC3D,sBAAsB,kBAAkB,EAAE,0BAA0B,EAAE,uBAAuB,EAAE,sBAAsB,EAAE,qBAAqB,EAAE,aAAa,EAAE;AAC7J;;AAEA,yCAAyC,aAAa,CAAC;AACvD,iDAAmI,aAAa,CAAC;;AAEjJ,qDAAqD;;AAErD,oBAAoB,uBAAuB,CAAC;AAC5C,8CAA8C,kBAAkB,CAAC;AACjE,8BAA8B,uBAAuB,CAAC,yBAAyB,CAAC,kBAAkB,CAAC,WAAW,CAAC,mBAAmB,CAAC;AACnI,uCAAuC,WAAW,EAAE,kBAAkB,EAAE,SAAS,EAAE,OAAO,EAAE,QAAQ,EAAE,kCAAkC,EAAE,mCAAmC,EAAE,6BAA6B,EAAE,QAAQ,EAAE,SAAS,EAAE,YAAY,EAAE,UAAU,EAAE,gCAAgC,EAAE,wCAAwC,EAAE,qCAAqC,EAAE,oCAAoC,EAAE,mCAAmC,EAAE;AAC3b,oCAAoC,yBAAyB,CAAC,yBAAyB,CAAC;AACxF,2CAA2C,YAAY,CAAC,UAAU,CAAC;;AAEnE,sBAAsB,gBAAgB,CAAC,kBAAkB,CAAC;AAC1D,0CAA0C,UAAU,CAAC;AACrD,gDAAgD,mBAAmB,CAAC;AACpE,gDAAgD,gBAAgB,CAAC;AACjE,sDAAsD,gBAAgB,CAAC;;;AAGvE;AACA,+BAAoH,aAAa,CAAC,sBAAsB,CAAC,mBAAmB,CAAC,mBAAmB,CAAC,kBAAkB,CAAC,eAAe,CAAC;AACpO,sCAAsC,YAAY,CAAC,kBAAkB,CAAC;AACtE,2CAA2C,yBAAyB,CAAC;AACrE,kCAAkC,gBAAgB,CAAC,WAAW,CAAC;AAC/D,4CAA4C,WAAW,CAAC;AACxD,+DAA+D,gBAAgB,CAAC;AAChF,4CAA4C,wBAAwB,CAAC,kBAAkB,CAAC;AACxF,qDAAqD,SAAS,CAAC,UAAU,CAAC,YAAY,CAAC,MAAM,CAAC,8BAA8B,CAAC,mCAAmC,CAAC,iCAAiC,CAAC,oCAAoC,CAAC;AACxO,wEAAwE,kBAAkB,CAAC,wBAAwB,CAAC,UAAU,CAAC,WAAW,CAAC;AAC3I;;AAEA;AACA,oBAAoB,sBAAsB,CAAC,iBAAiB,CAAC;AAC7D;;AAEA,YAAiG,aAAa,CAAC,sBAAsB,CAAC,YAAY,CAAC;AACnJ,wBAAwB,eAAe,CAAC,gBAAgB,CAAC,kBAAkB,CAAC;AAC5E,yBAAyB,oBAAoB,CAAC,mBAAmB,CAAC,aAAa,CAAkE,SAAO,CAAC;AACzJ,kCAAkC,kBAAkB,CAAC;AACrD,oBAAoB,iBAAiB,CAAC,gBAAgB,CAAC,iBAAiB,CAAC,qBAAqB,CAAC;AAC/F,+CAA+C,UAAU,CAAC;;AAE1D,UAA+F,aAAa,CAAC,sBAAsB,CAAC,mBAAmB,CAAC,mBAAmB,CAAC,kBAAkB,CAAC,eAAe,CAAC;AAC/M,oBAAoB,mBAAmB,EAAuF,aAAa,CAAC,sBAAsB,CAAC,mBAAmB,CAAC,mBAAmB,CAAC,kBAAkB,CAAC;;AAE9N,uBAAuB,UAAU,CAAC,SAAS,CAAC,gBAAgB,CAAC,WAAW,CAAC;AACzE,2BAAgH,aAAa,CAAC,uBAAuB,CAAC,mBAAmB,CAAC,WAAW,CAAC,gCAAgC,CAAC;AACvN,4BAA4B,aAAa,EAAwF,aAAa,EAAE,sBAAsB,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,eAAe,EAAE,uBAAuB,EAAE,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE,gBAAgB,EAAE,WAAW,EAAE,gCAAgC,EAAE,wCAAwC,EAAE,qCAAqC,EAAE,oCAAoC,EAAE,mCAAmC,EAAE;AACziB,8BAA8B,gCAAgC,EAAE,wCAAwC,EAAE,qCAAqC,EAAE,oCAAoC,EAAE,mCAAmC,EAAE;AAC5N,oEAAoE,yBAAyB,CAAC,WAAW,CAAC;AAC1G,yEAAyE,+BAA+B,EAAE,uCAAuC,EAAE;AACnJ,cAA+E,SAAO,CAAC,mBAAmB,EAAuF,aAAa,CAAC,sBAAsB,CAAC;;AAEtO,cAAc,WAAW,CAAC,YAAY,CAAC,2HAA2H,CAAC;AACnK,eAAe,WAAW,CAAC,YAAY,CAAC,0HAA0H,CAAC;AACnK,YAAY,WAAW,CAAC,YAAY,CAAC,uHAAuH,CAAC;;AAE7J,eAAe,WAAW,CAAC,YAAY,CAAC,0HAA0H,CAAC;AACnK,sBAAsB,WAAW,CAAC,YAAY,CAAC,iIAAiI,CAAC;AACjL,wBAAwB,WAAW,CAAC,YAAY,CAAC,kIAAkI,CAAC;AACpL,uBAAuB,WAAW,CAAC,YAAY,CAAC,kIAAkI,CAAC;AACnL,aAAa,WAAW,CAAC,YAAY,CAAC,yHAAyH,CAAC;AAChK,sBAAsB,WAAW,CAAC,YAAY,CAAC,iIAAiI,CAAC;;AAEjL,4BAA4B,8BAA8B,CAAC,YAAY,CAAC,QAAQ,CAAC,gCAAgC,CAAC,wCAAwC,CAAC,qCAAqC,CAAC,oCAAoC,CAAC,mCAAmC,CAAC,gBAAgB,CAAC;AAC3R,+BAA+B,aAAa,CAAC,sBAAsB,CAAC,mBAAmB,CAAC,mBAAmB,CAAC,kBAAkB,CAAC,eAAe,CAAC,WAAW,CAAC,YAAY,CAAC,iBAAiB,CAAC,uBAAuB,CAAC;AAClN,kCAAkC,WAAW,CAAC,YAAY,CAAC;AAC3D,oCAAoC,YAAY,CAAC,YAAY,CAAC,iBAAiB,EAAE,sBAAsB,CAAC,kBAAkB,CAAC,mBAAmB,CAAC,aAAa,CAAC,iBAAiB,GAAG,kBAAkB,CAAC;AACpM,yCAAyC,sBAAsB,CAAC,cAAc,CAAC;AAC/E,4CAA4C,WAAW,EAAE,mBAAmB,EAAE;AAC9E,cAAc,mIAAmI,CAAC,aAAa,CAAC,gBAAgB,CAAC,WAAW,EAAuF,aAAa,CAAC,uBAAuB,CAAC,mBAAmB,CAAC,aAAa,CAAC;AAC3V,mCAAmC,YAAY,CAAC;AAChD,sCAA2H,aAAa,CAAC;;AAEzI,aAAkG,aAAa,CAAC,uBAAuB,CAAC,mBAAmB,CAAC,YAAY,CAAC,kBAAkB,CAAC;;AAE5L,QAAQ,mBAAmB,EAAuF,aAAa,CAAC,uBAAuB,CAAC,mBAAmB,CAAC,YAAY,CAAC;AACzL,WAAW,yBAAyB,EAAE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,cAAc,EAAE,kBAAkB,EAAE,0BAA0B,EAAE,uBAAuB,EAAE,sBAAsB,EAAE,qBAAqB,EAAE,gCAAgC,EAAE,wCAAwC,EAAE,qCAAqC,EAAE,oCAAoC,EAAE,mCAAmC,EAAE;AAC3Z,kBAAkB,WAAW,EAAE,kBAAkB,EAAE,WAAW,EAAE,WAAW,EAAE,mBAAmB,EAAE,OAAO,EAAE,QAAQ,EAAE,MAAM,EAAE,SAAS,EAAE,YAAY,EAAE,gCAAgC,EAAE,wCAAwC,EAAE,qCAAqC,EAAE,oCAAoC,EAAE,mCAAmC,EAAE;AACpV,iBAAiB,WAAW,EAAE,kBAAkB,EAAE,WAAW,EAAE,WAAW,EAAE,mBAAmB,EAAE,OAAO,EAAE,QAAQ,EAAE,MAAM,EAAE,SAAS,EAAE,YAAY,EAAE,gCAAgC,EAAE,wCAAwC,EAAE,qCAAqC,EAAE,oCAAoC,EAAE,mCAAmC,EAAE;AACnV,0BAA0B,wBAAwB,EAAE,gCAAgC,EAAE,6BAA6B,EAAE,4BAA4B,EAAE,2BAA2B,EAAE;AAChL,eAAe,mBAAmB,CAAC;AACnC,8CAA8C,gBAAgB,CAAC;;AAE/D,eAAe,YAAY,CAAC;AAC5B,yBAAyB,WAAW,CAAC,kBAAkB,CAAC,mBAAmB,CAAC,iBAAiB,CAAC;AAC9F,uCAAuC,gBAAgB,CAAC,kBAAkB,CAAC,iBAAiB,CAAC;AAC7F,6CAA6C,WAAW,CAAC,kBAAkB,CAAC,mBAAmB,CAAC,WAAW,CAAC,YAAY,CAAC,sBAAsB,CAAC,WAAW,CAAC,kBAAkB,CAAC;;AAE/K,4BAA4B,WAAW,CAAC,YAAY,CAAC,qBAAqB,CAAC,+BAA+B,CAAC,YAAY,CAAC,mBAAmB,CAAC;;AAE5I,eAAe,mBAAmB,CAAC,yBAAyB,CAAC,qBAAqB,CAAC,mBAAmB,CAAC,gBAAgB,CAAC,gCAAgC,CAAC,wCAAwC,CAAC,qCAAqC,CAAC,oCAAoC,CAAC,mCAAmC,CAAC;AACjT,oBAAoB,mBAAmB,CAAC,WAAW,CAAC;;AAEpD,yBAAyB,YAAY,CAAC;AACtC,6BAA6B,aAAa,CAAC;AAC3C,yCAAyC,gCAAgC,CAAC;AAC1E,+BAA+B,YAAY,EAAE,YAAY,CAAC;AAC1D,6BAA6B,cAAc,CAAC,qBAAqB,CAAC;AAClE,mCAAmC,WAAW,CAAC;AAC/C,cAAc,aAAa,CAAC,YAAY,CAAC,YAAY,CAAC;AACtD,aAAa,gBAAgB,CAAC,kBAAkB,CAAC,aAAa,CAAC;AAC/D,YAAY,YAAY,CAAC;AACzB,aAAa,mBAAmB,CAAC,kBAAkB,CAAC,aAAa,EAAuF,aAAa,CAAC;AACtK,mBAAmB,iBAAiB,CAAC,gBAAgB,CAAC;AACtD,mBAAmB,YAAY,CAAC,WAAW,CAAC,YAAY,CAAC,kBAAkB,CAAC;;AAE5E,mBAAmB,cAAc,CAAC;AAClC,gBAAgB,uBAAuB,CAAC,sBAAsB,CAAC,mBAAmB,CAAC,YAAY,CAAC,WAAW,CAAC,gCAAgC,CAAC,wCAAwC,CAAC,qCAAqC,CAAC,oCAAoC,CAAC,mCAAmC,CAAC;AACrS,qBAAqB,gBAAgB,CAAC,WAAW,CAAC;;AAElD,eAAqG,aAAa,EAAE,sBAAsB,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,eAAe,EAAE,+CAA+C,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,YAAY,EAAE,0BAA0B,EAAE,uBAAuB,EAAE,sBAAsB,EAAE,qBAAqB,EAAE;AAC7a,oBAAoB,iBAAiB,CAAC,gBAAgB,CAAC;AACvD,qBAAqB,YAAY,EAAE,aAAa,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,0BAA0B,EAAE,uBAAuB,EAAE,sBAAsB,EAAE,qBAAqB,CAAC;;AAE7M,yBAAyB,kHAAkH,CAAC,kBAAkB,CAAC,iBAAiB,CAAC,iBAAiB,CAAC;AACnM,iBAAiB,mBAAmB,CAAC,4BAA4B,CAAC,WAAW,CAAmF,aAAa,CAAC,sBAAsB,CAAC,mBAAmB,CAAC,mBAAmB,CAAC,kBAAkB,CAAC,eAAe,CAAC,kBAAkB,CAAC,gBAAgB,CAAC,iBAAiB,CAAC;;AAEtU,uBAAuB,WAAW,CAAC,mBAAmB,CAAC,kBAAkB,CAAC,SAAS,CAAC,UAAU,CAAC,YAAY,CAAC,YAAY,CAAC,aAAa,CAAC,kBAAkB,CAAC;AAC1J,sBAAsB,UAAU,EAAuF,aAAa,CAAC,sBAAsB,CAAC,mBAAmB,CAAC,iBAAiB,CAAC,kBAAkB,CAAC;AACrN,2BAA2B,kBAAkB,CAAC,mBAAmB,CAAC,kBAAkB,CAAC,WAAW,CAAC,WAAW,CAAC,UAAU,CAAC,QAAQ,CAAC,YAAY,CAAC,QAAQ,CAAC,UAAU,CAAC;AAClK,4BAA4B,kBAAkB,CAAC,mBAAmB,CAAC,kBAAkB,CAAC,WAAW,CAAC,WAAW,CAAC,UAAU,CAAC,QAAQ,CAAC,YAAY,CAAC,QAAQ,CAAC,UAAU,CAAC,uBAAuB,CAAC;AAC3L,+BAA+B,sBAAsB,CAAC,gBAAgB,CAAC,WAAW,CAAC;AACnF,oCAAoC,iBAAiB,CAAC;AACtD,eAAe,mBAAmB,CAAC;AACnC,kBAAkB,mBAAmB,CAAC,eAAe,CAAC,gBAAgB,CAAC,cAAc,CAAC,UAAU,CAAC,kBAAkB,CAAC,iBAAiB,CAAC;AACtI,YAAY,gBAAgB,CAAC,aAAa,CAAC,gBAAgB,CAAC,kBAAkB,CAAC;AAC/E,eAAe,eAAe,CAAC,iBAAiB,CAAC,sBAAsB,CAAC,cAAc,CAAC,mBAAmB,CAAC;AAC3G,uBAAuB,UAAU,CAAC,iBAAiB,CAAC;AACpD,yBAAyB,eAAe,CAAC,gBAAgB,CAAC,kBAAkB,CAAC,kBAAkB,CAAC;;AAEhG,wBAA0G,aAAa,CAAC,eAAe,CAAC,sBAAsB,CAAC,mBAAmB,CAAC,mBAAmB,CAAC,kBAAkB,CAAC,mBAAmB,CAAC,uBAAuB,CAAC;;AAEtQ,2CAA2C,uBAAuB,CAAC,kBAAkB,CAAC,gBAAgB,CAAC;AACvG,wCAAwC,aAAa,CAAC;AACtD,mDAAmD,gBAAgB,CAAC,iCAAiC,CAAC,kBAAkB,CAAC,mBAAmB,CAAC,oBAAoB,CAAC,oBAAoB,CAAC,cAAc,CAAC,kBAAkB,CAAC,UAAU,CAAC,YAAY,CAAC;AACjP,eAAe,YAAY,CAAC,2CAA2C,CAAC,mBAAmB,CAAC,UAAU,CAAmF,aAAa,CAAC,sBAAsB,CAAC,mBAAmB,CAAC,gBAAgB,CAAC,kBAAkB,CAAC,iBAAiB,CAAC,yBAAyB,EAAE;AACnU,2BAA2B,WAAW,CAAC,YAAY,CAAmF,aAAa,CAAC,uBAAuB,CAAC,gBAAgB,CAAC,kBAAkB,CAAC,yBAAyB,EAAE,UAAU,CAAC,kBAAkB,CAAC;AACzQ,+BAA+B,eAAe,CAAC,gBAAgB,CAAC,gBAAgB,CAAC,iBAAiB,EAAE;AACpG,kBAAkB,cAAc,CAAC,eAAe,CAAC,gBAAgB,CAAC,gBAAgB,EAAE,kBAAkB,CAAC;AACvG,sBAAsB,eAAe,CAAC,gBAAgB,CAAC;AACvD,0BAA0B,WAAW,CAAC,WAAW,CAAC,yEAAyE,CAAC,cAAc,CAAC;AAC3I,qBAAqB,gBAAgB,CAAC;AACtC,gCAAgC,kBAAkB,CAAC;AACnD,eAAe,YAAY,CAAC,gBAAgB,CAAC,2BAA2B,CAAC,mBAAmB,CAAC,UAAU,CAAmF,aAAa,CAAC,eAAe,CAAC,sBAAsB,CAAC,mBAAmB,CAAC,mBAAmB,CAAC,kBAAkB,CAAC,sBAAsB,CAAC,mBAAmB,CAAC,gBAAgB,CAAC,kBAAkB,CAAC;AACzX,oBAAoB,kBAAkB,CAAC;AACvC,kBAAkB,cAAc,CAAC,eAAe,CAAC,gBAAgB,CAAC;AAClE,2BAA2B,eAAe,CAAC;;AAE3C,wBAAwB,WAAW,CAAC,2BAA2B,CAAC,iHAAiH,CAAC,cAAc,CAAC;AACjM,yBAAyB,kBAAkB,CAAC,eAAe,CAAC;AAC5D,kCAAkC,WAAW,CAAC;AAC9C,gCAAgC,cAAc,CAAC,eAAe,CAAC,gBAAgB,CAAC;AAChF,0CAA0C,mBAAmB,CAAC;AAC9D,wBAA0G,aAAa,CAAC,uBAAuB,CAAC;AAChJ,iBAAiB,2BAA2B,EAAE,kBAAkB,EAAE,UAAU,EAAE,gBAAgB,EAAwF,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,YAAY,EAAE,eAAe,EAAE,0BAA0B,EAAE,uBAAuB,EAAE,sBAAsB,EAAE,qBAAqB,CAAC;AACrX,iCAAiC,iBAAiB,CAAC;AACnD,oBAAoB,eAAe,CAAC,YAAY,CAAC;;AAEjD,iBAAiB,iBAAiB,CAAC,oBAAoB,CAAC,kBAAkB,CAAC,gBAAgB,CAAC;AAC5F,0BAA0B,sBAAsB,CAAC,+BAA+B,CAAC;;AAEjF,+BAA+B,kBAAkB,CAAC,OAAO,CAAC,QAAQ,CAAC,UAAU,CAAC,SAAS,CAAC,YAAY,CAAC;AACrG,kCAAkC,gBAAgB,CAAC;AACnD,wBAAwB,kBAAkB,CAAC,WAAW,CAAC,QAAQ,CAAC,UAAU,CAAC,mBAAmB,CAAC,cAAc,CAAC,kBAAkB,CAAC,gBAAgB,CAAC,aAAa,CAAC,uBAAuB,CAAC,mBAAmB,CAAC;AAC5M,4BAA4B,kBAAkB,CAAC,MAAM,CAAC,SAAS,CAAC,YAAY,CAAC,WAAW,CAAC,YAAY,CAAC;AACtG,+BAA+B,kBAAkB,CAAC,SAAS,CAAC,QAAQ,CAAC,UAAU,CAAC;AAChF,6BAA6B,cAAc,CAAC,eAAe,CAAC,gBAAgB,CAAC,iBAAiB,CAAC,gBAAgB,CAAC;AAChH,qCAAqC,eAAe,CAAC,gBAAgB,CAAC,gBAAgB,CAAC;AACvF,aAAa,mBAAmB,CAAC;AACjC,WAAW,eAAe,CAAC,kBAAkB,CAAC;AAC9C,6CAA6C,kBAAkB,CAAC,UAAU,CAAC,YAAY,CAAC,mBAAmB,CAAC,QAAQ,CAAC,OAAO,CAAC;AAC7H,eAAe,WAAW,CAAC,YAAY,CAAC,aAAa,CAAC,mBAAmB,CAAC,uBAAuB,CAAC;AAClG,mBAAmB,eAAe,CAAC,gBAAgB,CAAC;AACpD,iBAAiB,eAAe,CAAC,mBAAmB,CAAC;AACrD,sBAAsB,gBAAgB,CAAC;AACvC,YAAY,kBAAkB,CAAC,QAAQ,CAAC,SAAS,CAAC,gBAAgB,CAAC,UAAU,CAAC,kBAAkB,CAAC;AACjG,mBAAmB,cAAc,CAAC;AAClC,cAAc,kBAAkB,CAAC,UAAU,CAAC,YAAY,CAAC,mBAAmB,CAAC,SAAS,CAAC,SAAS,CAAC;AACjG,SAAS,gBAAgB,CAAC;AAC1B,qCAAqC,eAAe,CAAC,iBAAiB,CAAC;AACvE,+CAA+C,eAAe,CAAC;AAC/D,0BAA0B,eAAe,CAAC,kBAAkB,CAAC;AAC7D,sBAAsB,UAAU,CAAC,YAAY,CAAC,QAAQ,CAAC,OAAO,CAAC;AAC/D,uBAAuB,UAAU,CAAC,YAAY,CAAC,SAAS,CAAC,SAAS,CAAC;AACnE,qBAAqB,eAAe,CAAC,iBAAiB,CAAC;AACvD,uBAAuB,kBAAkB,CAAC;;AAE1C,SAAS,gBAAgB,CAAC;AAC1B,SAAS,gBAAgB,CAAC;AAC1B,kCAAkC,WAAW,CAAC;AAC9C,wCAAwC,SAAS,CAAC,QAAQ,CAAC;AAC3D,qCAAqC,eAAe,GAAG,iBAAiB,CAAC;AACzE,+CAA+C,eAAe,CAAC;AAC/D,0BAA0B,eAAe,CAAC,kBAAkB,CAAC;AAC7D,iCAAiC,iBAAiB,CAAC;AACnD,sBAAsB,UAAU,CAAC,YAAY,CAAC,QAAQ,CAAC,OAAO,CAAC;AAC/D,uBAAuB,UAAU,CAAC,YAAY,CAAC,SAAS,CAAC,SAAS,CAAC;AACnE,qBAAqB,eAAe,CAAC,iBAAiB,CAAC;AACvD,uBAAuB,iBAAiB,CAAC;;AAEzC,sCAAsC,QAAQ,CAAC;AAC/C,6CAA6C,SAAS,CAAC,QAAQ,CAAC;AAChE,6BAA6B,kBAAkB,CAAC,UAAU,CAAC,SAAS,CAAC,UAAU,CAAC;AAChF,0BAA0B,mBAAmB,CAAC,UAAU,CAAC,wBAAwB,CAAC,cAAc,CAAC,kBAAkB,CAAC,SAAS,CAAC,WAAW,CAAC;AAC1I,yBAA8G,aAAa,CAAC,mBAAmB,CAAC,mBAAmB,CAAC,WAAW,CAAC,UAAU,CAAC,kBAAkB,CAAC,uBAAuB,CAAC,WAAW,CAAC;;AAElP,8CAA8C,QAAQ,CAAC,YAAY,CAAC;AACpE,iCAAiC,UAAU,CAAC;AAC5C,8EAA8E,SAAS,CAAC,QAAQ,CAAC;AACjG,yGAAyG,gBAAgB,CAAC;AAC1H,oHAAoH,mBAAmB,CAAC,WAAW,CAAC,kBAAkB,CAAC;AACvK,8DAA8D,QAAQ,CAAC,SAAS,CAAC,UAAU,CAAC;AAC5F,4DAA4D,UAAU,CAAC,YAAY,CAAC,QAAQ,CAAC,gBAAgB,CAAC;AAC9G,8DAA8D,uBAAuB,CAAC,gBAAgB,CAAC,cAAc,CAAC,UAAU,CAAC;;AAEjI,oDAAoD,gBAAgB,CAAC,iBAAiB,CAAC,gBAAgB,CAAC;AACxG,4DAA4D,aAAa,CAAC,kBAAkB,CAAC,WAAW,CAAC,UAAU,CAAC,QAAQ,CAAC,YAAY,CAAC,UAAU,CAAC;AACrJ,qEAAqE,cAAc,CAAC,gBAAgB,CAAC,WAAW,CAAC,aAAa,CAAC;;AAE/H,yBAAyB,gBAAgB,CAAC,cAAc,CAAC;AACzD,uCAAuC,QAAQ,CAAC,SAAS,CAAC,UAAU,CAAC;AACrE,2CAA2C,iBAAiB,CAAC;AAC7D,+CAA+C,OAAO;AACtD,qDAAqD,eAAe,CAAC,iBAAiB,CAAC;AACvF,qCAAqC,mBAAmB,CAAC;AACzD,gDAAgD,0BAA0B,CAAC,iBAAiB,CAAC;AAC7F,uDAAuD,QAAQ,CAAC;AAChE,6DAA6D,eAAe,CAAC;AAC7E,qCAAqC,gBAAgB,CAAC,kBAAkB,CAAC;;AAEzE,kBAAkB,cAAc,CAAC,aAAa,CAAC,iBAAiB,CAAC;AACjE,qCAAqC,WAAW,CAAC;AACjD,2CAA2C,gBAAgB,CAAC;AAC5D,2CAA2C,gBAAgB,CAAC;AAC5D,iDAAiD,gBAAgB,CAAC;AAClE,4CAA4C,iBAAiB;AAC7D,qCAAqC,kBAAkB,CAAC,iBAAiB,CAAC,6BAA6B,CAAC,WAAW,CAAmF,aAAa,EAAE,mBAAmB,CAAC;AACzO,uCAAuC,kBAAkB,CAAC;;AAE1D,6CAA6C,yBAAyB,CAAC;AACvE,+CAA+C,4GAA4G,CAAC,WAAW,CAAC,YAAY,EAAE;AACtL,8CAA8C,yBAAyB,CAAC;AACxE,gDAAgD,8GAA8G,CAAC,WAAW,CAAC,YAAY,CAAC;AACxL,+CAA+C,yBAAyB,CAAC;AACzE,iDAAiD,+GAA+G,CAAC,WAAW,CAAC,YAAY,CAAC;AAC1L,6CAA6C,yBAAyB,CAAC;AACvE,+CAA+C,6GAA6G,CAAC,WAAW,CAAC,YAAY,CAAC;AACtL,6CAA6C,yBAAyB,CAAC;AACvE,+CAA+C,6GAA6G,CAAC,WAAW,CAAC,YAAY,CAAC;AACtL,2CAA2C,yBAAyB,CAAC;AACrE,6CAA6C,2GAA2G,CAAC,WAAW,CAAC,YAAY,CAAC;;AAElL,2DAA2D,mBAAmB,CAAC,UAAU,CAAC,qBAAqB,CAAC;AAChH,6DAA6D,gGAAgG,CAAC,wGAAwG,CAAC;AACvQ,4IAA4I,8BAA8B,CAAC,sCAAsC,CAAC;;AAElN,6BAA6B,mBAAmB,CAAC,mBAAmB,CAAC,kBAAkB,CAAC,YAAY,CAAC,kBAAkB,CAAC,kBAAkB,CAAC,gBAAgB,CAAC;AAC5J,qCAAqC,WAAW,EAAE,kBAAkB,EAAE,OAAO,EAAE,OAAO,EAAE,MAAM,EAAE,WAAW,EAAE,SAAS,EAAE,YAAY,EAAE,gCAAgC,EAAE,wCAAwC,EAAE,qCAAqC,EAAE,oCAAoC,EAAE,mCAAmC,CAAC,6BAA6B,EAAE;AAClW,0CAA0C,YAAY,CAAC;AACvD,kDAAkD,aAAa,CAAmF,aAAa,CAAC,uBAAuB,CAAC,gBAAgB,CAAC,gBAAgB,CAAC;AAC1N,gCAAgC,eAAe,CAAC,eAAe,CAAC;AAChE,+BAA+B,SAAS,CAAC;AACzC,+BAA+B,kBAAkB,CAAC,OAAO,CAAC,QAAQ,CAAC,SAAS,CAAC,YAAY,CAAC,YAAY,CAAC,YAAY,CAAC,YAAY,CAAC,gBAAgB,CAAmF,aAAa,CAAC,uBAAuB,CAAC,mBAAmB,CAAC,qBAAqB,CAAC,mBAAmB,CAAC,WAAW,CAAC,gCAAgC,CAAC,wCAAwC,CAAC,qCAAqC,CAAC,oCAAoC,CAAC,mCAAmC,CAAC,UAAU,CAAC;AACxhB,oCAAoC,mBAAmB,CAAC,WAAW,CAAC;AACpE,oCAAoC,UAAU,CAAC,MAAM,GAAG,SAAS,CAAC;;AAElE,qBAAqB,eAAe,CAAC,UAAU,CAAC,UAAU,CAAC,WAAW,CAAC,QAAQ,CAAmF,aAAa,CAAC,sBAAsB,CAAC,iBAAiB,CAAC,4BAA4B,CAAC,oCAAoC,CAAC,iCAAiC,CAAC,gCAAgC,CAAC,+BAA+B,CAAC,qBAAqB,CAAC,eAAe,CAAC,yBAAyB,CAAC,uBAAuB,CAAC,yBAAyB,CAAC,iCAAiC,CAAC,8BAA8B,CAAC,6BAA6B,CAAC,4BAA4B,CAAC,mBAAmB,CAAC,yBAAyB,EAAE,mBAAmB,CAAC,SAAS,CAAC,yBAAyB,CAAC,cAAc,CAAC,iBAAiB,CAAC,gBAAgB,CAAC,gCAAgC,CAAC,wCAAwC,CAAC,qCAAqC,CAAC,oCAAoC,CAAC,mCAAmC,CAAC;AAC97B,0BAA0B,yBAAyB,CAAC;;AAEpD,wBAAwB,eAAe,EAAE,SAAS,EAAE,WAAW,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,SAAS,EAAE,4BAA4B,EAAE,mBAAmB,EAAE,WAAW,EAAE,oCAAoC,EAAE,iCAAiC,EAAE,gCAAgC,EAAE,+BAA+B,CAAC;AAC5T,4BAA4B,yBAAyB,CAAC;;AAEtD,cAAc,+FAA+F,EAAE,uGAAuG,EAAE;AACxN,iBAAiB,kHAAkH,CAAC,WAAW,CAAC,YAAY,CAAC,eAAe,CAAC;;AAE7K,UAAU,mBAAmB,CAAC,mBAAmB,CAAC,aAAa,CAAC,mBAAmB,CAAC;AACpF,oBAAoB,oHAAoH,CAAC,WAAW,CAAC,YAAY,CAAmF,aAAa,CAAC;;AAElQ,SAA2F,aAAa,CAAC,eAAe,CAAC,sBAAsB,CAAC,mBAAmB,CAAC,mBAAmB,CAAC,kBAAkB,CAAC,2BAA2B,CAAC;AACvO,eAAe,0DAA+rB,CAAC,4BAA4B,CAAC,2BAA2B,CAAC,qBAAqB,CAAC,WAAW,CAAC,YAAY,CAAC,iBAAiB,CAAC,eAAe,CAAC,kBAAkB,CAAC;;AAE52B,+BAA+B,0DAA0d,CAAC;AAC1f,oBAAoB,oCAAoC,CAAC;AACzD,sBAAsB,gCAAgC,CAAC,oBAAoB,CAAC,gBAAgB,CAAC;AAC7F,iCAAiC,WAAW,CAAC,YAAY,CAAC,kBAAkB,CAAC,0DAA+rB,CAAC;AAC7wB,iDAAiD,0DAA0d,CAAC;AAC5gB,wBAAwB,iBAAiB,CAAC;AAC1C,cAAc,iIAAiI,CAAC,WAAW,CAAC,YAAY,CAAC,cAAc,CAAC;AACxL,mCAAmC,cAAc,CAAC;AAClD,yCAAyC,WAAW,CAAC;AACrD,4CAA4C,gCAAgC,EAAE,wCAAwC,EAAE;;AAExH,WAAW,mBAAmB,CAAC;AAC/B,WAAW,0DAA+rB,CAAC,4BAA4B,CAAC,2BAA2B,CAAC,qBAAqB,CAAC,WAAW,CAAC,YAAY,CAAC,iBAAiB,CAAC,eAAe,CAAC,kBAAkB,CAAC;AACx2B,kBAAkB,WAAW,CAAC,kBAAkB,CAAC,WAAW,CAAC,YAAY,CAAC,OAAO,CAAC,MAAM,CAAC,SAAS,CAAC,0DAA0d,CAAC,4BAA4B,CAAC,qBAAqB,CAAC,UAAU,CAAC;;AAE5nB,2BAA2B,gBAAgB,CAAC;AAC5C,oCAAoC,UAAU,CAAC;AAC/C,yCAAyC,UAAU,CAAC,UAAU,CAAC;AAC/D,8DAA8D,gBAAgB,CAAC;AAC/E,+EAA+E,UAAU,CAAC;AAC1F,6CAA6C,UAAU,CAAC,UAAU,CAAC;AACnE,qFAAqF,gBAAgB,CAAC;AACtG,8GAA8G,UAAU,CAAC;AACzH,0CAA0C,UAAU,CAAC,UAAU,CAAC;AAChE,sIAAsI,gBAAgB,CAAC;AACvJ,uKAAuK,UAAU,CAAC;AAClL,+CAA+C,UAAU,CAAC,UAAU,CAAC;;AAErE,wKAAwK,gBAAgB,CAAC;AACzL,iNAAiN,UAAU,CAAC;;AAE5N;AACA,iCAAiC,WAAW,CAAC,YAAY,CAAC,kBAAkB,CAAC;AAC7E;;AAEA;AACA,+BAA+B,YAAY,CAAC;AAC5C,wBAAwB,WAAW,CAAC;AACpC,sCAAsC,eAAe,CAAC,iBAAiB,CAAC;AACxE,8CAA8C,eAAe,CAAC;AAC9D,0BAA0B,eAAe,CAAC,kBAAkB,CAAC;AAC7D,qBAAqB,eAAe,CAAC,iBAAiB,CAAC;AACvD;;AAEA;AACA,iCAAiC,QAAQ,CAAC;AAC1C,wBAAwB,WAAW,CAAC;AACpC,wCAAwC,SAAS,CAAC,QAAQ,CAAC,UAAU,CAAC;AACtE,sCAAsC,eAAe,CAAC,iBAAiB,CAAC;AACxE,8CAA8C,eAAe,CAAC,iBAAiB,CAAC;AAChF,qBAAqB,cAAc,CAAC,iBAAiB,CAAC;AACtD,sBAAsB,SAAS,CAAC;AAChC,0BAA0B,eAAe,CAAC,gBAAgB,CAAC;AAC3D;;AAEA,OAAO,YAAY,CAAC;;;AAGpB,YAAY,UAAU,CAAC;AACvB,SAAS,kBAAkB,CAAC,mBAAmB,CAAC,WAAW,CAAC,YAAY,CAAC,OAAO,CAAC,MAAM,CAAC,UAAU,CAAC,wBAAwB,CAAC;AAC5H,gBAAgB,mBAAmB,CAAC,WAAW,CAAC,kBAAkB,CAAC,OAAO,CAAC,SAAS,CAAC,WAAW,CAAC,UAAU,CAAC;AAC5G,wCAAwC,OAAO,CAAC,QAAQ,CAAC,UAAU,CAAC;AACpE,iBAAiB,kBAAkB,CAAC,MAAM,CAAC,WAAW,CAAC,gBAAgB,CAAC;AACxE,8CAA8C,eAAe,CAAC,iBAAiB,CAAC,kBAAkB,CAAC,YAAY,CAAC,UAAU,CAAC,WAAW,CAAC,gBAAgB,CAAC,SAAS,CAAC;AAClK,uEAAuE,iBAAiB,CAAC;AACzF,gBAAgB,YAAY,CAAC,WAAW,CAAC;AACzC,iEAAiE,SAAS,CAAC,QAAQ,CAAC,UAAU,CAAC;AAC/F,+CAA+C,UAAU,CAAC,WAAW,CAAC,QAAQ,CAAC,OAAO,CAAC,kBAAkB,CAAC,mBAAmB,CAAC;AAC9H,4CAA4C,gBAAgB,CAAC,kBAAkB,CAAC;AAChF,yEAAyE,qBAAqB,CAAC,4BAA4B,CAAC,kFAAkF,CAAC,WAAW,CAAC,WAAW,CAAC,mBAAmB,CAAC,qBAAqB,CAAC;;AAEjR,iBAAiB,gBAAgB,CAAC,aAAa,CAAC,kBAAkB,CAAC;AACnE,uBAAuB,kBAAkB,CAAC;AAC1C,2CAA2C,QAAQ,CAAC,OAAO,CAAC,QAAQ,CAAC,kBAAkB,CAAC,eAAe,CAAC,gBAAgB,CAAC;AACzH,6CAA6C,QAAQ,CAAC,OAAO,CAAC,QAAQ,CAAC,kBAAkB,CAAC,eAAe,CAAC,gBAAgB,CAAC;AAC3H,8BAA8B,QAAQ,CAAC,OAAO,CAAC,QAAQ,CAAC,kBAAkB,CAAC,eAAe,CAAC,gBAAgB,CAAC;AAC5G,qCAAqC,cAAc,CAAC,eAAe,CAAC;AACpE,yCAAyC,eAAe,CAAC,gBAAgB,CAAC;AAC1E,oCAAoC,eAAe,CAAC;;AAEpD,0BAA0B,gBAAgB,CAAC,aAAa,CAAC,kBAAkB,CAAC;AAC5E,uBAAuB,kBAAkB,CAAC;AAC1C,mDAAmD,QAAQ,CAAC,OAAO,CAAC,QAAQ,CAAC,kBAAkB,CAAC,eAAe,CAAC,gBAAgB,CAAC;AACjI,qDAAqD,QAAQ,CAAC,OAAO,CAAC,QAAQ,CAAC,kBAAkB,CAAC,eAAe,CAAC,gBAAgB,CAAC;AACnI,sCAAsC,QAAQ,CAAC,OAAO,CAAC,QAAQ,CAAC,kBAAkB,CAAC,eAAe,CAAC,gBAAgB,CAAC;AACpH,6CAA6C,cAAc,CAAC;AAC5D,iDAAiD,eAAe,CAAC,gBAAgB,CAAC;AAClF,4CAA4C,eAAe,CAAC;;AAE5D,2BAA2B,YAAY,CAAC,+CAA+C,CAAC,mBAAmB,CAAC,aAAa,CAAC;AAC1H,sBAAwG,aAAa,CAAC,eAAe,CAAC,sBAAsB,CAAC,mBAAmB,CAAC,mBAAmB,CAAC,kBAAkB,EAAE,kBAAkB,CAAC,mBAAmB,CAAC,gBAAgB,CAAC;AACjR,wBAAwB,WAAW,CAAC,kBAAkB,CAAC,YAAY,CAAC,OAAO,CAAC,MAAM,CAAC,UAAU,CAAC;AAC9F,qCAAqC,QAAQ,CAAC,UAAU,CAAC,WAAW,CAAC,8BAA8B,CAAC,sDAAsD,CAAC,MAAM,CAAC,SAAS,CAAC,mBAAmB,CAAC;AAChM,gCAAgC,UAAU,CAAC,kBAAkB,CAAC,mBAAmB,CAAC;AAClF,4CAA4C,cAAc,CAAC;AAC3D,6CAA6C,eAAe,CAAC,WAAW,CAAC,iBAAiB,CAAC;AAC3F,2CAA2C,eAAe,CAAC,WAAW,CAAC,gBAAgB,CAAC,oBAAoB,CAAC,6BAA6B,CAAC,mBAAmB,CAAC,oBAAoB,CAAC;AACpL,oDAAoD,eAAe,CAAC,gBAAgB,CAAC,WAAW,CAAC;;AAEjG,iCAAiC,UAAU,CAAC,kBAAkB,CAAC,aAAa,CAAC,sBAAsB,CAAC,8BAA8B,CAAC,mBAAmB,CAAC;AACvJ,4CAA4C,mBAAmB,CAAC,cAAc,CAAC;AAC/E,sDAAsD,eAAe,CAAC,gBAAgB,CAAC,WAAW,CAAC;AACnG,2DAA2D,eAAe,CAAC,gBAAgB,CAAC,WAAW,CAAC;AACxG,wCAAwC,cAAc,CAAC;AACvD,qDAAqD,eAAe,CAAC,WAAW,CAAC,mBAAmB,CAAC;AACrG,qCAAqC,eAAe,CAAC,WAAW,CAAC,gBAAgB,CAAC;;AAElF,mCAAmC,YAAY,CAAC;AAChD,qDAAqD,eAAe,CAAC,WAAW,CAAC,iBAAiB,CAAC;AACnG,mDAAmD,eAAe,CAAC,WAAW,CAAC,gBAAgB,CAAC,oBAAoB,CAAC,6BAA6B,CAAC,mBAAmB,CAAC,oBAAoB,CAAC;AAC5L,4DAA4D,eAAe,CAAC,gBAAgB,CAAC,WAAW,CAAC;AACzG,8DAA8D,eAAe,CAAC,gBAAgB,CAAC,WAAW,CAAC;AAC3G,mEAAmE,eAAe,CAAC,gBAAgB,CAAC,WAAW,CAAC;AAChH,6DAA6D,eAAe,CAAC,WAAW,CAAC,mBAAmB,CAAC;AAC7G,6CAA6C,eAAe,CAAC,WAAW,CAAC,gBAAgB,CAAC;;;AAG1F,gBAAgB,gBAAgB,CAAC,gBAAgB,CAAC;AAClD,2BAA2B,eAAe,CAAC;AAC3C,gCAAgC,kBAAkB,CAAC,UAAU,CAAC;AAC9D,2BAA2B,yBAAyB,CAAC,aAAa,CAAC,kBAAkB,CAAC,UAAU,CAAC;AACjG,8BAAkH,aAAa,CAAC,gBAAgB,CAAC,gBAAgB,CAAC,YAAY,CAAC,iBAAiB,CAAC;AACjM,2CAA2C,YAAY,CAAC,aAAa,CAAmF,aAAa,CAAC,mBAAmB,CAAC,uBAAuB,CAAC,kBAAkB,CAAC,gBAAgB,CAAC,sBAAsB,CAAC,kBAAkB,CAAC;AAChS,iCAAiC,eAAe,CAAC,gBAAgB,CAAC,yBAAyB,CAAC,WAAW,CAAC;AACxG,6CAA6C,SAAO,CAAmF,aAAa,CAAC,eAAe,CAAC,sBAAsB,CAAC,mBAAmB,CAAC,mBAAmB,CAAC,kBAAkB,CAAC,sBAAsB,CAAC,aAAa,CAAC,gBAAgB,CAAC,sBAAsB,CAAC;AACpU,2DAA2D,eAAe,CAAC;AAC3E,iDAAiD,UAAU,GAAG,gBAAgB,CAAC,gBAAgB,CAAC,UAAU,CAAC,cAAc,CAAC,aAAa,CAAC,yBAAyB,CAAC;AAClK,wCAAwC,cAAc,CAAC,gBAAgB,CAAC,eAAe,CAAC,mBAAmB,CAAC;AAC5G,2DAA6I,aAAa,CAAC,eAAe,CAAC,sBAAsB,CAAC,mBAAmB,CAAC,mBAAmB,CAAC,kBAAkB,CAAC,eAAe,CAAC;AAC7Q,4EAA4E,mBAAmB,CAAC;AAChG,gEAAgE,UAAU,CAAC,yBAAyB,CAAC,WAAW,CAAC,kBAAkB,CAAC,kBAAkB,CAAC,eAAe,CAAC,mBAAmB,CAAC;AAC3L,gEAAgE,QAAM;AACtE,qCAAqC,kBAAkB,CAAC,oBAAoB,CAAC;;AAE7E,wBAAwB,gBAAgB,CAAC,gBAAgB,CAAC,cAAc,CAAC;AACzE,mCAAmC,eAAe,CAAC;AACnD,oCAAoC,aAAa,CAAC;AAClD,sCAA0H,aAAa,CAAC,gBAAgB,CAAC,gBAAgB,CAAC,YAAY,CAAC,iBAAiB,CAAC;AACzM,mDAAmD,YAAY,CAAC,aAAa,CAAmF,aAAa,CAAC,mBAAmB,CAAC,uBAAuB,CAAC,kBAAkB,CAAC,gBAAgB,CAAC,sBAAsB,CAAC,kBAAkB,CAAC;AACxS,yCAAyC,eAAe,CAAC,gBAAgB,CAAC,yBAAyB,CAAC,WAAW,CAAC;AAChH,6CAA6C,oBAAoB,CAAC;AAClE,wCAAwC,kBAAkB,CAAC,OAAO,CAAC,QAAQ,CAAC,MAAM,CAAC,YAAY,CAAC,yBAAyB,CAAC,UAAU,CAAC;AACrI,wDAAwD,aAAa,CAAC;AACtE,iEAAiE,mBAAmB,CAAC;AACrF,oDAAoD,UAAU,CAAC,SAAS,CAAC,gBAAgB,CAAC;AAC1F,4DAA8I,aAAa,CAAC,eAAe,CAAC,sBAAsB,CAAC,mBAAmB,CAAC,mBAAmB,CAAC,kBAAkB,CAAC;AAC9P,+DAAmJ,aAAa,GAAG,sBAAsB,GAAG,kBAAkB,CAAC,QAAM;AACrN,yCAAyC,cAAc,GAAG,gBAAgB,GAAG,YAAY,CAAC;AAC1F,qCAAqC,WAAW,CAAC,WAAW,CAAC,mBAAmB,CAAC,kBAAkB,CAAC;AACpG,mCAAmC,kBAAkB,CAAC,OAAO,CAAC,QAAQ,CAAC,YAAY,CAAC,WAAW,CAAC,YAAY,CAAC,sBAAsB,CAAC,yBAAyB,CAAC,kBAAkB,CAAC,MAAM,CAAC,SAAS,CAAC,YAAY,CAAC;AAC/M,qDAAqD,iBAAiB,CAAC;AACvE,uCAAuC,gBAAgB,CAAC;AACxD,wCAAwC,eAAe,CAAC;AACxD,gDAAgD,eAAe,CAAC;AAChE,mEAAmE,eAAe,CAAC;;AAEnF,UAAU,WAAW,CAAC,YAAY,CAAC;AACnC,iBAAiB,gCAAgC,CAAC;AAClD,uCAAuC,yBAAyB,CAAC;AACjE,eAAe,yBAAyB,CAAC;;AAEzC,YAAY,uBAAuB,CAAC;AACpC,gBAAgB,yBAAyB,CAAC;AAC1C,gBAAgB,yBAAyB,CAAC;AAC1C,gBAAgB,yBAAyB,CAAC;AAC1C,aAAa,8BAA8B,CAAC,UAAU,CAAC,6BAA6B,CAAC;AACrF,UAAU,gBAAgB,CAAC;AAC3B,SAAS,0BAA0B,CAAC;AACpC,eAAe,oBAAoB,EAAE,yBAAyB,EAAE,mBAAmB,EAAE,iBAAiB,EAAwF,aAAa,EAAE,mBAAmB,EAAE,WAAW,EAAE,gCAAgC,EAAE,wCAAwC,EAAE,qCAAqC,EAAE,oCAAoC,EAAE,mCAAmC,CAAC;AAC5a,oBAAoB,mBAAmB,CAAC,qBAAqB,CAAC,WAAW,CAAC;;AAE1E,gCAAgC,oCAAoC,CAAC;AACrE,mCAAmC,qFAAqF,CAAC,qBAAqB,CAAC,WAAW,CAAC,YAAY,CAAC,qBAAqB,CAAC,aAAa,CAAC;AAC5M,wCAAwC,WAAW,CAAC,UAAU,CAAC;AAC/D,kCAAkC,qFAAqF,CAAC,qBAAqB,CAAC,WAAW,CAAC,YAAY,CAAC,qBAAqB,CAAC,aAAa,CAAC;AAC3M,uEAAuE,gBAAgB,CAAC,uBAAuB,CAAC,oBAAoB,CAAC,qBAAqB,CAAC,4BAA4B,CAAC;;;AAGxL,UAAU,yBAAyB,CAAC;AACpC,8CAA8C,OAAO,EAAE,WAAW,CAAC;;AAEnE,0DAA0D,SAAS,CAAC,yBAAyB,CAAC,mBAAmB,CAAC,QAAQ,CAAC;AAC3H,qDAAqD,QAAQ,CAAC,WAAW,CAAC;;AAE1E,eAAe,yBAAyB,CAAC;AACzC,gDAAgD,uBAAuB,CAAC,mBAAmB,CAAC,gBAAgB,CAAC,wBAAwB,CAAC,qBAAqB,CAAC,gBAAgB,CAAC;;AAE7K,6BAA6B,UAAU,CAAC,SAAS,CAAC,gBAAgB,CAAC;AACnE,+BAA+B,eAAe,CAAC;AAC/C,iDAAiD,6BAA6B,CAAC;AAC/E,iDAAiD,eAAe,CAAC;AACjE,qBAAqB,kBAAkB,CAAC;AACxC,4BAA4B,iBAAiB,CAAC,gBAAgB,CAAC,oBAAoB,CAAC;AACpF,+CAA+C,UAAU,CAAC;AAC1D,4CAA4C,UAAU,CAAC;AACvD,qDAAqD,gBAAgB,CAAC;AACtE,qDAAqD,sBAAsB,CAAC,mBAAmB,CAAC,sBAAsB,CAAC;;;AAGvH,6BAA6B,WAAW,CAAC,kBAAkB,CAAC,kCAAkC,CAAC,qCAAqC,CAAC,gCAAgC,CAAC,SAAS,CAAC,WAAW,CAAC;AAC5L,cAAc,MAAM,CAAC,QAAQ,CAAC,iBAAiB,CAAC,2BAA2B,CAAC,gBAAgB,CAAC;AAC7F;AACA,eAAe,WAAW,CAAC;AAC3B,iCAAiC,SAAS,KAAK,WAAW,KAAK,WAAW,KAAK,wBAAwB,KAAK,UAAU,CAAC;AACvH;;AAEA,0BAA0B,2BAA2B,CAAC;AACtD,4BAA4B,0BAA0B,CAAC,aAAa,CAAC;AACrE,yCAAyC,YAAY,CAAC,iBAAiB,CAAC;AACxE,kBAAkB,sBAAsB,CAAC,oBAAoB,CAAC;AAC9D,qBAAqB,YAAY,CAAC;;AAElC;IACI,6DAA6D;IAC7D,cAAc;IACd,UAAU;AACd;AACA;IACI,gCAAgC;IAChC,+BAA+B;AACnC;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,gBAAgB;AACpB;;AAEA,4BAA4B,WAAW,CAAC,YAAY,CAAC,sBAAsB,CAAC,kBAAkB,CAAC,gBAAgB,CAAC;AAChH,gCAAgC,WAAW,CAAC,YAAY,CAAC;AACzD,+BAA+B,kBAAkB,CAAC;AAClD,mBAAmB,iBAAiB,CAAC;AACrC,qBAAqB,eAAe,CAAC,cAAc,CAAC,iBAAiB,CAAC,mBAAmB,CAAC;AAC1F,YAAY,wBAAwB,CAAC,uBAAuB,EAAE,gBAAgB,CAAC;;AAE/E;IACI,6DAA6D;IAC7D,cAAc;IACd,UAAU;IACV,iCAAiC;IACjC,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,8BAA8B;IAC9B,gCAAgC;IAChC,iCAAiC;IACjC,mCAAmC;AACvC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;;6CAE6C;;GAE1C;IACC,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,0BAA0B;IAC1B,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,0CAA0C;IAC1C,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,eAAe;AACf;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA,0BAA0B;AAC1B;;IAEI,uBAAuB;IACvB,8BAA8B;AAClC;;AAEA;;IAEI,oBAAoB;IACpB,YAAY;AAChB;;;AAGA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,UAAU;AACd;;AAEA,aAAa;;AAEb;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;AACf;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,qBAAqB;IACrB,aAAa;IACb,kBAAkB;IAClB,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;;GAEG;;AAEH;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,OAAO;IACP,QAAQ;IACR,SAAS;IACT,MAAM;IACN,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,OAAO;IACP,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,MAAM;IACN,SAAS;IACT,YAAY;IACZ,gBAAgB;AACpB;;AAEA,8BAA8B,cAAc,CAAC;AAC7C,+BAA+B,cAAc,CAAC;AAC9C,6BAA6B,cAAc,CAAC;;AAE5C,cAAc,oGAAoG,CAAC,mBAAmB,CAAC,UAAU,CAAC,aAAa,CAAC;AAChK,kBAAmF,SAAO,CAAC;AAC3F,qBAAqB,eAAe,CAAC;AACrC,oBAAoB,eAAe,CAAC;;AAEpC,iBAAiB,yBAAyB,CAAC;AAC3C,iBAAiB,yBAAyB,CAAC;AAC3C,gBAAgB,yBAAyB,CAAC;AAC1C,eAAe,yBAAyB,CAAC;AACzC,gBAAgB,0BAA0B,CAAC;AAC3C,gBAAgB,yBAAyB,CAAC;AAC1C,kBAAkB,yBAAyB,CAAC;AAC5C,WAAW,yBAAyB,CAAC;;;AAGrC,mBAAmB,cAAc,CAAC;AAClC,oBAAoB,cAAc,CAAC;;AAEnC,SAAS,gBAAgB,CAAC;AAC1B,WAAW,YAAY,CAAC;AACxB,cAAc,iBAAiB,CAAC;AAChC,gBAAgB,kBAAkB,CAAC,kBAAkB,CAAC,UAAU,CAAC,WAAW,CAAC,gBAAgB,CAAC;;;AAG9F,oBAAoB,2BAA2B,CAAC;;AAEhD,OAAO,kBAAkB,CAAC;AAC1B,cAAc,WAAW,CAAC,kBAAkB,CAAC,OAAO,CAAC,QAAQ,CAAC,MAAM,CAAC,SAAS,CAAC,mBAAmB,CAAC,UAAU,CAAC,YAAY,CAAC;AAC3H,kCAAkC,iCAAiC,CAAC;AACpE,iBAAiB,uBAAuB,CAAC;;AAEzC,+DAA+D,YAAY,CAAC;;AAE5E,mCAAmC,WAAW,CAAC;AAC/C,oEAAoE,cAAc,CAAC;AACnF,uDAAuD,qBAAqB,CAAC;AAC7E,2EAA2E,UAAU,CAAC;AACtF,wEAAwE,UAAU,CAAC;AACnF,iFAAiF,gBAAgB,CAAC;AAClG,iFAAiF,sBAAsB,CAAC,mBAAmB,CAAC,sBAAsB,CAAC;AACnJ;IACI,YAAY;AAChB;;;AAGA;;AAEA;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,oBAAoB;IACpB,yBAAyB;IACzB,mBAAmB;IAKnB,gCAAgC;IAChC,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;IAKX,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,WAAW;IACX,2BAA2B;IAC3B,6BAA6B;IAC7B,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;IACnB,SAAS;IACT,QAAQ;IACR,QAAQ;IACR,kBAAkB;IAClB;AACJ;;AAEA;IACI,eAAe;IACf,UAAU;IACV,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;IACpB,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;;AAGA;IACI,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,SAAS;IACT,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,YAAY;IACZ,WAAW;IACX,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,gBAAgB;AACpB;;AAEA;;EAEE,WAAW;EACX,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,iBAAiB;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,WAAW;IACX,WAAW;IACX,2BAA2B;IAC3B,6BAA6B;AACjC;;AAEA;GACG,aAAa;AAChB;AACA,yCAAyC;AACzC;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,OAAO,CAAC,QAAQ;EAChB,MAAM,CAAC,SAAS;EAChB,YAAY;EACZ,gCAAgC;;AAElC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yCAAyC;AACzC;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,OAAO,CAAC,QAAQ;EAChB,MAAM,CAAC,SAAS;EAChB,YAAY;EACZ,gCAAgC;;AAElC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;AACA,uBAAuB,qBAAqB,EAAuF,aAAa,CAAC,wBAAwB,CAAC;AAC1K,0BAA0B,UAAU,CAAC,SAAS,CAAC,gBAAgB,CAAmF,aAAa,CAAC,sBAAsB,CAAC,mBAAmB,CAAC,mBAAmB,CAAC,kBAAkB,CAAC,eAAe,CAAC,cAAc,CAAC;AACjR,6BAA+G,aAAa,CAAC,sBAAsB,CAAC,mBAAmB,CAAC,mBAAmB,CAAC,kBAAkB,CAAC,eAAe,CAAC,mBAAmB,CAAC;AACnP,8BAA8B,iBAAiB,CAAC;AAChD,kCAAkC,WAAW,CAAC,YAAY,CAAC,2IAA2I,CAAC,qBAAqB,CAAC;AAC7N,yCAAyC,WAAW,CAAC,YAAY,CAAC,wIAAwI,CAAC,qBAAqB,CAAC;AACjO,gCAAgC,WAAW,CAAC,YAAY,CAAC,gIAAgI,CAAC,qBAAqB,CAAC;AAChN,8CAA8C,+BAA+B,CAAC,mBAAmB,CAAC,kBAAkB,CAAC;AACrH,+BAA+B,WAAW,CAAC,YAAY,CAAC,mBAAmB,CAAC,qBAAqB,CAAC,gBAAgB,CAAC,iBAAiB,CAAC,cAAc,CAAC,aAAa,CAAC,2BAA2B,CAAC;AAC9L,uCAAuC,yBAAyB,EAAE,qBAAqB,CAAC;;AAExF,aAAa,aAAa,CAAC,mBAAmB,CAAC,UAAU,CAAC;AAC1D,+BAA+B,aAAa,CAAC,mBAAmB,CAAC,iBAAiB,CAAC,SAAS,CAAC;AAC7F,2BAA2B,yBAAyB,CAAC,qBAAqB,CAAC;;AAE3E,qCAAqC,gBAAgB,CAAC,gBAAgB,CAAC;AACvE,8CAA8C,kBAAkB,CAAC,QAAQ,CAAC,SAAS,CAAC,YAAY,CAAC,SAAS,CAAC,OAAO,CAAC,sCAAsC,CAAC;AAC1J,iDAAiD,oCAAoC,CAAC,eAAe,CAAC;AACtG,0CAA0C,OAAO,CAAC,QAAQ,CAAC,UAAU,CAAC,gBAAgB,CAAC;AACvF,8CAA8C,YAAY,CAAC,WAAW,CAAC,gBAAgB,CAAC;AACxF,kDAAkD,QAAQ,CAAC,iBAAiB,CAAC,gBAAgB,CAAC;AAC9F,sDAAsD,gCAAgC,CAAC,aAAa,CAAC;AACrG,8DAA8D,kBAAkB,CAAC,QAAQ,CAAC,QAAQ,CAAC,YAAY,CAAC;AAChH,0DAA0D,kBAAkB,CAAC,SAAS,CAAC,QAAQ,CAAC,UAAU,CAAC;AAC3G,wDAAwD,cAAc,CAAC,eAAe,CAAC,gBAAgB,CAAC,iBAAiB,CAAC,gBAAgB,CAAC;AAC3I,gEAAgE,eAAe,CAAC,gBAAgB,CAAC,gBAAgB,CAAC,mBAAmB,CAAC,eAAe,CAAC;AACtJ,yCAAyC,mBAAmB,CAAC,eAAe,CAAC;AAC7E,qCAAqC,UAAU,CAAC,WAAW,CAAC,SAAS,CAAC,kBAAkB,CAAC,iBAAiB,CAAC;AAC3G,sDAAsD,eAAe,CAAC;AACtE,4CAA4C,kBAAkB,CAAC,OAAO,CAAC,SAAS,CAAC,mBAAmB,CAAC,UAAU,CAAC,UAAU,CAAC,wBAAwB,CAAC;;AAEpJ,kBAAkB,yBAAyB,CAAC,WAAW,CAAC,gCAAgC,CAAC;AACzF,wBAAwB,yBAAyB,CAAC;AAClD,oBAAoB,kHAAkH,GAAG,WAAW,GAAG,YAAY,GAAG,qBAAqB,GAAG,qBAAqB,CAAC;AACpN,gBAAgB,mHAAmH,GAAG,WAAW,GAAG,YAAY,GAAG,qBAAqB,GAAG,qBAAqB,CAAC;AACjN,uBAAuB,mHAAmH,GAAG,WAAW,GAAG,YAAY,GAAG,qBAAqB,GAAG,qBAAqB,CAAC;AACxN,kBAAkB,sIAAsI,CAAC,WAAW,CAAC,YAAY,CAAC,+BAA+B,CAAC;AAClN,mBAAwG,aAAa,CAAC,eAAe,CAAC,sBAAsB,CAAC,mBAAmB,CAAC,mBAAmB,CAAC,kBAAkB,CAAC,YAAY,CAAC;AACrO,+BAA+B,YAAY,CAAC,WAAW,EAAuF,aAAa,CAAC,gBAAgB,CAAC,oBAAoB,CAAC;AAClM,wBAAwB,mBAAmB,CAAC,kBAAkB,CAAC,aAAa,CAAkE,SAAO,CAAC,WAAW,CAAC;AAClK,yCAAyC,kBAAkB,CAAC;;AAE5D;AACA,mBAAmB,UAAU,CAAC,yBAAyB,CAAC;AACxD;;AAEA,wBAAwB,iBAAiB,EAAE,mBAAmB,CAAC;AAC/D,4CAA4C,mBAAmB,CAAC;AAChE,yBAAyB,WAAW,CAAC,YAAY,CAAC,kBAAkB,CAAC,gBAAgB,EAAuF,aAAa,CAAC,qBAAqB,CAAC,mBAAmB,GAAG;AACtO,6BAA6B,WAAW,CAAC,YAAY,CAAC,iBAAiB,CAAC;;AAExE,qCAAqC,gBAAgB,CAAC,gBAAgB,CAAC;AACvE,0CAA0C,SAAS,CAAC,WAAW,CAAC,kBAAkB,CAAC,kBAAkB,CAAC,OAAO,CAAC,WAAW,CAAC;AAC1H,8CAA8C,gBAAgB,CAAC,YAAY,CAAC;AAC5E,+CAA+C,kBAAkB,CAAC,WAAW,CAAC,0BAA0B,CAAC,UAAU,CAAC,sCAAsC,CAAC;AAC3J,kDAAkD,QAAQ,CAAC,iBAAiB,CAAC,gBAAgB,CAAC;AAC9F,sDAAsD,gCAAgC,CAAC,cAAc,CAAC,WAAW,CAAC;AAClH,mCAAmC,kBAAkB,CAAC,QAAQ,CAAC,UAAU,CAAC,QAAQ,CAAC,WAAW,CAAC,kBAAkB,CAAC,gBAAgB,CAAC;AACnI,uCAAuC,WAAW,CAAC,YAAY,CAAC,iBAAiB,CAAC;AAClF,0DAA0D,kBAAkB,CAAC,SAAS,CAAC,UAAU,CAAC,UAAU,CAAC;AAC7G,wDAAwD,cAAc,CAAC,iBAAiB,CAAC,gBAAgB,CAAC,iBAAiB,CAAC,eAAe,CAAC;AAC5I,gEAAgE,eAAe,CAAC,gBAAgB,CAAC,eAAe,CAAC,mBAAmB,CAAC,cAAc,CAAC,cAAc,CAAC;AACnK,iEAAiE,UAAU,CAAC,WAAW,CAAC,gBAAgB,CAAC,cAAc,CAAC,cAAc,CAAC;AACvI,sCAAsC,aAAa,CAAC,eAAe,CAAC,kBAAkB,CAAC,SAAS,CAAC,QAAQ,CAAC,uBAAuB,CAAC,mBAAmB,CAAC;AACtJ,2CAA2C,WAAW,CAAC,gBAAgB,CAAC,kBAAkB,CAAC,kBAAkB,CAAC,gBAAgB,CAAC,YAAY,CAAC,aAAa,CAAC,eAAe,CAAC,uBAAuB,CAAC,mBAAmB,CAAC,gBAAgB,CAAC;AACvO,+CAA+C,UAAU,CAAC,YAAY,CAAC;AACvE,2CAA2C,WAAW,CAAC,mBAAmB,CAAC,gBAAgB,CAAC,iBAAiB,CAAC;AAC9G,yCAAyC,oCAAoC,CAAC,kBAAkB,CAAC,WAAW,CAAC;AAC7G,mDAAmD,UAAU,CAAC;AAC9D,sDAAsD,WAAW,CAAC,iBAAiB,CAAC;AACpF,qDAAqD,WAAW,CAAC,eAAe,CAAC,mBAAmB,CAAC;AACrG,qCAAqC,kBAAkB,CAAC,SAAS,CAAC,QAAQ,CAAC,mBAAmB,CAAC,qCAAqC,CAAC,qBAAqB,CAAC,UAAU,CAAC,iBAAiB,CAAC;AACxL,yCAAyC,WAAW,CAAC;;AAErD,qCAAqC,gBAAgB,CAAC,gBAAgB,CAAC;AACvE,0CAA0C,SAAS,CAAC,kBAAkB,CAAC,kBAAkB,CAAC,OAAO,CAAC,gBAAgB,CAAC,QAAQ,CAAC,WAAW,CAAC;AACxI,8CAA8C,eAAe,CAAC,YAAY,CAAC,mBAAmB,CAAC;AAC/F,kDAAkD,QAAQ,CAAC,MAAM,CAAC,UAAU,CAAC,aAAa,CAAC,gCAAgC,CAAC,oBAAoB,CAAC,WAAW,CAAC,eAAe,CAAC,gBAAgB,CAAC,iBAAiB,CAAC,iBAAiB,CAAC;AAClO,0DAA0D,kBAAkB,CAAC,QAAQ,CAAC,QAAQ,CAAC,UAAU,CAAC,aAAa,CAAC,wBAAwB,CAAC,gCAAgC,CAAC,uBAAuB,CAAC,UAAU,CAAC;AACrN,wDAAwD,cAAc,CAAC,eAAe,CAAC,gBAAgB,CAAC,iBAAiB,CAAC,eAAe,CAAC;AAC1I,gEAAgE,iBAAiB,CAAC,gBAAgB,CAAC,eAAe,CAAC,WAAW,CAAC,cAAc,CAAC;AAC9I,mCAAmC,kBAAkB,CAAC,OAAO,CAAC,aAAa,CAAC,UAAU,CAAC;AACvF,2CAA2C,kBAAkB,CAAC,UAAU,CAAC,SAAS,CAAC,oBAAoB,CAAC;AACxG,8CAA8C,gBAAgB,CAAC,UAAU,CAAC,SAAS,CAAC;AACpF,+CAAoI,aAAa,CAAC,eAAe,CAAC,sBAAsB,CAAC,mBAAmB,CAAC,mBAAmB,CAAC,kBAAkB,CAAC,mBAAmB,CAAC;AACxQ,+DAA+D,mBAAmB,CAAC;AACnF,sDAAuH,SAAO,CAAC,gBAAgB,CAAC;AAChJ,iEAAiE,YAAY,EAAuF,aAAa,CAAC,uBAAuB,CAAC;AAC1M,kDAAkD,mBAAmB,CAAC,uBAAuB,CAAC,iBAAiB,CAAC,mBAAmB,CAAC,UAAU,CAAC;AAC/I,uDAAuD,kBAAkB,CAAC;AAC1E,4CAA4C,UAAU,CAAC,kBAAkB,CAAC;AAC1E,sDAAsD,WAAW,CAAC,SAAS,CAAC;AAC5E,uCAAuC,kBAAkB,CAAC,cAAc,CAAC;AACzE,wCAAwC,SAAS,CAAC;;AAElD,qCAAqC,gBAAgB,CAAC,gBAAgB,CAAC;AACvE,0CAA0C,SAAS,CAAC,kBAAkB,CAAC,kBAAkB,CAAC,OAAO,CAAC,gBAAgB,CAAC,QAAQ,CAAC;AAC5H,8CAA8C,eAAe,CAAC;AAC9D,kDAAkD,QAAQ,CAAC,MAAM,CAAC,YAAY,CAAC,aAAa,CAAC,gCAAgC,CAAC,mBAAmB,CAAC,WAAW,CAAC,iBAAiB,CAAC,gBAAgB,CAAC,iBAAiB,CAAC,iBAAiB,CAAC;AACrO,0DAA0D,kBAAkB,CAAC,UAAU,CAAC,QAAQ,CAAC,UAAU,CAAC,SAAS,CAAC;AACtH,wDAAwD,cAAc,CAAC,iBAAiB,CAAC,gBAAgB,CAAC,mBAAmB,CAAC,eAAe,CAAC,iBAAiB,CAAC;AAChK,gEAAgE,iBAAiB,CAAC,gBAAgB,CAAC,eAAe,CAAC,mBAAmB,CAAC;AACvI,2CAA2C,kBAAkB,CAAC,QAAQ,CAAC,SAAS,CAAC,oBAAoB,CAAC,YAAY,CAAC,QAAQ,CAAC,wBAAwB,CAAC,8BAA8B,CAAC;AACpL,8CAA8C,gBAAgB,CAAC,UAAU,CAAC,SAAS,CAAC;AACpF,+CAAoI,aAAa,CAAC,eAAe,CAAC,sBAAsB,CAAC,mBAAmB,CAAC,mBAAmB,CAAC,kBAAkB,CAAC,mBAAmB,CAAC,kBAAkB,CAAC;AAC3R,+DAA+D,iBAAiB,CAAC;AACjF,sDAAuH,SAAO,CAAC,gBAAgB,CAAC;AAChJ,iEAAiE,UAAU,EAAuF,aAAa,CAAC,uBAAuB,CAAC;AACxM,+CAA+C,kBAAkB,CAAC,UAAU,CAAC,0BAA0B,CAAC,UAAU,CAAC,wBAAwB,CAAC,8BAA8B,CAAC,QAAQ,CAAC;AACpL,mCAAmC,kBAAkB,CAAC,OAAO,CAAC,WAAW,CAAC,YAAY,CAAC;AACvF,yCAAyC,aAAa,CAAC;AACvD,qDAAqD,kBAAkB,CAAC,SAAS,CAAC,QAAQ,CAAC,YAAY,CAAC,WAAW,CAAC,uBAAuB,CAAC,WAAW,CAAC;AACxJ,8BAA8B,WAAW,CAAC,eAAe,CAAC,gBAAgB,CAAC,iBAAiB,CAAC;AAC7F,6BAA6B,WAAW,CAAC,eAAe,CAAC,iBAAiB,CAAC;AAC3E,kDAAkD,UAAU,CAAC,iBAAiB,CAAC,kBAAkB,CAAC,WAAW,CAAC,SAAS,CAAC;AACxH,sDAAsD,eAAe,CAAC;AACtE,mBAAmB,WAAW,CAAC,QAAQ,CAAC,iBAAiB,CAAC,yBAAyB,CAAC,WAAW,CAAC,gBAAgB,CAAC;AACjH,WAAW,kBAAkB,CAAC,gBAAgB,CAAC;;AAE/C,2BAA2B,mBAAmB,CAAC,+GAA+G,CAAC;;AAE/J,yBAAyB,kBAAkB,CAAC,eAAe,CAAC;AAC5D,4BAA4B,UAAU,CAAC,SAAS,CAAC,gBAAgB,EAAuF,aAAa,CAAC,eAAe,CAAC,sBAAsB,CAAC,mBAAmB,CAAC,mBAAmB,CAAC,kBAAkB,CAAC;AACxQ,+BAA+B,WAAW,CAAC;AAC3C,gDAAgD,kBAAkB,CAAC;AACnE,yCAAyC,aAAa,CAAC,gBAAgB,CAAC,0BAA0B,CAAC,iBAAiB,CAAC;AACrH,6CAA6C,0BAA0B,CAAC,kBAAkB,CAAC;AAC3F,qDAAqD,4BAA4B,CAAC,kBAAkB,CAAC,YAAY,CAAC,cAAc,CAAC,kBAAkB,GAAG,WAAW,GAAG,gBAAgB,CAAC;AACrL,mBAAmB,2HAA2H,CAAC;;AAE/I,UAAU,sBAAsB,CAAC,uBAAuB,CAAC;AACzD,8BAA8B,gBAAgB,CAAC,SAAS,CAAC,UAAU,CAAC,aAAa,CAAC,eAAe,CAAC,kBAAkB,CAAC,eAAe,CAAC,kBAAkB,CAAC;AACxJ,kCAAmG,SAAO,CAAC,kBAAkB,CAAC;AAC9H,kDAAkD,kBAAkB,CAAC,mBAAmB,CAAC;AACzF,0DAA0D,WAAW,CAAC,kBAAkB,CAAC,QAAQ,CAAC,SAAS,CAAC,UAAU,CAAC,WAAW,CAAC,mBAAmB,CAAC;;AAEvJ,mBAAmB,WAAW,CAAC,YAAY,CAAC,UAAU,CAAC;AACvD,yBAAyB,gBAAgB,CAAC,YAAY,CAAC,UAAU,CAAC,oCAAoC,CAAC,kBAAkB,CAAC,WAAW,CAAC,OAAO,CAAC,gBAAgB,CAAC,sBAAsB,CAAC,aAAa,CAAC,kBAAkB,CAAC,kCAAkC,CAAC;AAC1P,+BAA+B,UAAU,CAAC,OAAO,CAAC,YAAY,CAAC;AAC/D,6BAA6B,8BAA8B,EAAE,uBAAuB,CAAC;AACrF,kBAAkB,8BAA8B,EAAE,uBAAuB,CAAC;;AAE1E,UAAU,sBAAsB,CAAC,uBAAuB,CAAC;;AAEzD,oBAAoB,WAAW,CAAC,QAAQ;AACxC,8DAA8D,0BAA0B,CAAC;AACzF,aAAa,0BAA0B,CAAC;AACxC,oBAAoB,yBAAyB,CAAC;AAC9C,oBAAoB,yBAAyB,CAAC;AAC9C,sBAAsB,WAAW,CAAC;;AAElC,uBAAyG,aAAa,CAAC,mBAAmB,CAAC;AAC3I,8BAA8B,WAAW,CAAC,YAAY,CAAC,iBAAiB,CAAC;AACzE,6BAA6B,eAAe,CAAC;AAC7C,sCAAsC,yBAAyB,CAAC,qBAAqB,CAAC;;AAEtF,uBAAuB,UAAU,CAAC;AAClC,+BAA+B,gBAAgB,CAAC,gBAAgB,CAAC,aAAa,CAAC,aAAa,CAAC,sBAAsB,CAAC,uBAAuB,CAAC,mBAAmB,CAAC,gBAAgB,CAAC,WAAW,CAAC,YAAY,CAAC,WAAW,CAAC,yBAAyB,CAAC,UAAU,CAAC;;AAE3P,+CAA+C,WAAW,CAAC,YAAY,CAAC,mBAAmB,CAAC,wBAAwB,CAAC,SAAS,CAAC,8BAA8B,CAAC,+BAA+B,CAAC,6BAA6B,CAAC,gCAAgC,CAAC;AAC7P,4FAA4F,8BAA8B,CAAC,+BAA+B,CAAC,6BAA6B,CAAC,gCAAgC,CAAC;AAC1N,2FAA2F,8BAA8B,CAAC,+BAA+B,CAAC,6BAA6B,CAAC,gCAAgC,CAAC,UAAU,CAAC,yCAAyC,CAAC;AAC9Q,4FAA4F,8BAA8B,CAAC,+BAA+B,CAAC,6BAA6B,CAAC,gCAAgC,CAAC,yCAAyC,CAAC;;AAEpQ,6BAA+G,aAAa,CAAC,sBAAsB,CAAC,mBAAmB,CAAC,mBAAmB,CAAC,kBAAkB,CAAC,eAAe,CAAC,8BAA8B,CAAC;AAC9P,0CAA0C,gBAAgB,EAAE,WAAW,CAAmF,aAAa,CAAC;AACxK,mDAAmD,uBAAuB,CAAC,gBAAgB,CAAC,YAAY,CAAC,aAAa,CAAC;AACvH,+DAA+D,kBAAkB,CAAC,SAAS,CAAC,QAAQ,CAAC,SAAS,CAAC,yBAAyB,CAAC;AACzI,oEAAoE,yBAAyB,CAAC;AAC9F,2DAA2D,WAAW,CAAC,kBAAkB,CAAC,OAAO,CAAC,QAAQ,CAAC,MAAM,CAAC,SAAS,CAAC,YAAY,CAAC,WAAW,CAAC,mBAAmB,CAAC,kBAAkB,CAAC,UAAU,CAAC;AACvM,uDAAuD,WAAW,CAAC,kBAAkB,CAAC;AACtF,iCAAiC,UAAU,CAAC,kBAAkB,CAAmF,aAAa,CAAC,mBAAmB,CAAC,uBAAuB,CAAC,kBAAkB,CAAC,2BAA2B,CAAC,YAAY,CAAC,UAAU,CAAC;AAClR,qCAAqC,sBAAsB,CAAC,cAAc,CAAC,YAAY,CAAC;AACxF,uDAAyI,aAAa,CAAC,sBAAsB,CAAC,gBAAgB,CAAC,mBAAmB,CAAC,uBAAuB,CAAC,kBAAkB,CAAC,WAAW,CAAC,gBAAgB,CAAC;;AAE3R;AACA,6BAA6B,sBAAsB,CAAC,mBAAmB,CAAC;AACxE,kCAAkC,iBAAiB,CAAC;AACpD,mCAAmC,iBAAiB,GAAG,WAAW,GAAG,YAAY,GAAG,YAAY,CAAC;AACjG,uCAAuC,aAAa,CAAC;AACrD;;AAEA;AACA,6BAA6B,sBAAsB,CAAC,mBAAmB,CAAC;AACxE,kCAAkC,iBAAiB,CAAC;AACpD,mCAAmC,iBAAiB,GAAG,WAAW,GAAG,YAAY,GAAG,YAAY,CAAC;AACjG,uCAAuC,aAAa,CAAC;AACrD;;AAEA,yBAAyB,gBAAgB,CAAC;AAC1C,sBAAsB,iCAAiC,CAAC;AACxD,+CAA+C,kBAAkB,CAAC,eAAe,CAAC,gBAAgB,CAAC,QAAQ,CAAC,SAAS,CAAC,iBAAiB,CAAC,yBAAyB,CAAC;AAClK,0CAA0C,WAAW,CAAC,kBAAkB,CAAC,WAAW,CAAC,YAAY,CAAC,wIAAwI,CAAC,QAAQ,CAAC,uBAAuB,CAAC;AAC5Q,qCAAqC,gBAAgB,CAAC;AACtD,iDAAiD,kBAAkB,CAAC,eAAe,CAAC,gBAAgB,CAAC,QAAQ,CAAC,SAAS,CAAC,iBAAiB,CAAC,yBAAyB,CAAC;AACpK,mBAAmB,uIAAuI,CAAC,mBAAmB,CAAC,kBAAkB,CAAC,qBAAqB,CAAC;;AAExN;AACA,+CAA+C,SAAS,CAAC,SAAS,CAAC,iBAAiB,CAAC,yBAAyB,CAAC;AAC/G,iDAAiD,kBAAkB,CAAC,eAAe,CAAC,gBAAgB,CAAC,SAAS,CAAC,UAAU,CAAC,iBAAiB,CAAC,yBAAyB,CAAC;AACtK,0CAA0C,WAAW,CAAC,kBAAkB,CAAC,WAAW,CAAC,YAAY,CAAC,QAAQ,CAAC,eAAe,CAAC,uBAAuB,CAAC;AACnJ;;AAEA,aAAa,UAAU,CAAC,SAAS,CAAC;AAClC,gBAAgB,gBAAgB,CAAC,kBAAkB,CAAmF,aAAa,CAAC,sBAAsB,CAAC,mBAAmB,CAAC,mBAAmB,CAAC,kBAAkB,CAAC,eAAe,CAAC;AACtP,iCAAiC,mBAAmB,CAAC;AACrD,2BAA2B,kBAAkB,CAAC,kBAAkB,CAAC;AACjE,uEAAuE,WAAW,GAAG,UAAU,GAAG,qBAAqB,GAAG,kBAAkB,GAAG,OAAO,GAAG,QAAQ,GAAG,YAAY,GAAG,UAAU,CAAC;AAC9L,kCAAkC,YAAY,CAAC,MAAM,CAAC;AACtD,iCAAiC,gCAAgC,CAAC,SAAS,CAAC;AAC5E,kDAAkD,aAAa,CAAC;AAChE,gDAAgD,aAAa,CAAC;AAC9D,mBAAmB,WAAW,CAAC,YAAY,CAAC,2BAA2B,CAAC,kBAAkB,CAAmF,aAAa,CAAC,uBAAuB,CAAC,mBAAmB,CAAC,eAAe,CAAC,gBAAgB,CAAC,4BAA4B,CAAC,kBAAkB,CAAC,UAAU,CAAC,sBAAsB,CAAC;AAC1V,oCAAoC,wBAAwB,GAAG,2BAA2B,GAAG,kBAAkB,CAAC;AAChH,iDAAiD,uCAAuC,CAAC;;AAEzF,WAAW,gBAAgB,CAAC,qBAAqB,CAAC;;AAElD;AACA,4BAA4B,kBAAkB,CAAC,gBAAgB,CAAC;AAChE,oBAAoB,WAAW,CAAC,YAAY,CAAC,eAAe,CAAC;AAC7D,oCAAoC,wBAAwB,EAAE;AAC9D;;AAEA,gBAAgB,mIAAmI,CAAC,WAAW,CAAC,YAAY,CAAC;AAC7K,qBAAqB,6IAA6I,CAAC;AACnK,uBAAuB,yBAAyB,CAAC;AACjD,uBAAuB,kCAAkC,CAAC;;AAE1D,WAA6F,aAAa,CAAC,sBAAsB,CAAC,mBAAmB,CAAC,mBAAmB,CAAC,kBAAkB,CAAC,eAAe,CAAC,mBAAmB,CAAC,mBAAmB,CAAC,WAAW,CAAC,qBAAqB,CAAC,mBAAmB,CAAC,eAAe,CAAC,gBAAgB,CAAC,gCAAgC,CAAC;AAC7W,WAAW,WAAW,CAAC,eAAe,CAAC,gBAAgB,CAAC;AACxD,sBAAsB,0IAA0I,CAAC,WAAW,CAAC,YAAY,CAAC,kBAAkB,CAAC,gCAAgC,CAAC,OAAO,CAAC;AACtP,4BAA4B,SAAS,CAAC;AACtC,kBAAkB,mBAAmB,CAAC;;AAEtC,qBAAqB,yBAAyB,CAAC,gCAAgC,CAAC;AAChF,2BAA2B,yBAAyB,CAAC,WAAW,CAAC;;AAEjE,YAAY,qBAAqB,CAAC;AAClC,eAAe,2HAA2H,CAAC;AAC3I,eAAe,4HAA4H,CAAC;AAC5I,UAAU,sBAAsB,CAAC,uBAAuB,CAAC;AACzD,aAAa,WAAW,CAAC,WAAW,CAAC,8BAA8B,CAAC,gCAAgC,CAAC,2CAA2C,CAAC;;AAEjJ,mEAAmE,kBAAkB,CAAC;AACtF,8DAA8D,kBAAkB,CAAC,oBAAoB,CAAC,OAAO,CAAC,UAAU,CAAC,SAAS,CAAC;AACnI,sEAAsE,kBAAkB,CAAC;AACzF,mFAAmF,SAAS,CAAC;;AAE7F,eAAe,aAAa;AAC5B,eAAe,aAAa;AAC5B,gBAAgB,mBAAmB,CAAC,wFAAwF,CAAC,6BAA6B,CAAC,oCAAoC,CAAC;AAChM,aAAa,aAAa;;AAE1B;AACA,iCAAiC,YAAY,CAAC,mBAAmB,CAAC,0BAA0B,CAAC;AAC7F,iBAAiB;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;AACA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;;iDAEiD;;AAEjD;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,2CAA2C;IAC3C,gCAAgC;AACpC;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB,kBAAkB;IAClB,wDAAwD;IACxD,eAAe;AACnB;;AAEA;;IAEI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,2CAA2C;AAC/C;;AAEA;IACI,yBAAyB;AAC7B;AACA,gBAAgB,iCAAiC,CAAC;AAClD,QAAQ,aAAa;AACrB,QAAQ,aAAa;AACrB,aAAa,gCAAgC,CAAC;AAC9C,mBAAmB,yBAAyB,CAAC;AAC7C,oCAAoC,kBAAkB,CAAC;AACvD,iCAAiC,yBAAyB,CAAC,eAAe,CAAC;AAC3E,cAAc,0BAA0B,CAAC,mBAAmB,CAAC,mBAAmB,CAAC,sBAAsB,CAAC,kBAAkB,CAAC,eAAe,CAAC,8CAA8C,CAAC;AAC1L,oBAAoB,qBAAqB,CAAC,mBAAmB,CAAC;AAC9D,mBAAmB,WAAW,CAAC,YAAY,CAAC,mBAAmB,CAAC,kBAAkB,CAAC,aAAa,CAAC,mBAAmB,CAAC,uBAAuB,CAAC,mBAAmB,CAAC;AACjK,qBAAqB,iBAAiB,CAAC,cAAc,CAAC;AACtD,4BAA4B,kBAAkB,CAAC,gBAAgB,CAAC,cAAc,CAAC,sBAAsB,CAAC;AACtG,0BAA0B,iBAAiB,CAAC,cAAc,CAAC,sBAAsB,CAAC;AAClF,aAAa,kBAAkB,CAAC,gBAAgB,CAAC,cAAc,CAAC,gBAAgB,CAAC,2BAA2B,CAAC,kBAAkB,CAAC,uBAAuB,CAAC,gDAAgD,CAAC;AACzM,mBAAmB,mBAAmB,CAAC,qBAAqB,CAAC,cAAc,CAAC;AAC5E,WAAW,cAAc,CAAC,qBAAqB,CAAC,sBAAsB,CAAC;AACvE,kBAAkB,cAAc,CAAC;AACjC,uBAAuB,yBAAyB,CAAC;AACjD,sBAAsB,yBAAyB,CAAC;AAChD,kBAAkB,UAAU,CAAC,SAAS,CAAC,gBAAgB,CAAC,kBAAkB,CAAC;AAC3E,0BAA0B,WAAW,CAAC,kBAAkB,CAAC,SAAS,CAAC,MAAM,CAAC,UAAU,CAAC,YAAY,CAAC,mBAAmB,CAAC;AACtH,qBAAqB,kBAAkB,CAAC,kBAAkB,CAAC;AAC3D,sCAAsC,mBAAmB,CAAC;AAC1D,2BAA2B,kBAAkB,CAAC,OAAO,CAAC,SAAS,CAAC,WAAW,CAAC,YAAY,CAAC,mBAAmB,CAAC,kBAAkB,CAAC,iCAAiC,CAAC,yBAAyB,CAAC;AAC5L,oCAAoC,yBAAyB,CAAC;AAC9D,qCAAqC,yBAAyB,CAAC;AAC/D,qCAAqC,yBAAyB,CAAC;AAC/D,kCAAkC,yBAAyB,CAAC;AAC5D,mCAAmC,yBAAyB,CAAC;AAC7D,8BAA8B,gBAAgB,CAAC,gBAAgB,CAAC,gCAAgC,CAAC,gBAAgB,CAAC;AAClH,qCAAqC,aAAa,CAAC;AACnD,oDAAoD,kBAAkB,CAAC;AACvE,mCAAmC,gBAAgB,CAAC,gBAAgB,CAAC,oCAAoC,CAAC,gBAAgB,CAAC,eAAe,CAAC,gBAAgB,CAAC,cAAc,CAAC;AAC3K,0CAA0C,6BAA6B,CAAC,gBAAgB,CAAC,cAAc,CAAC,gCAAgC,CAAC;AACzI,+BAA+B,QAAQ,CAAC,WAAW,CAAC;AACpD,kBAAkB,YAAY,CAAC,aAAa,CAAC;AAC7C,0BAA0B,WAAW,CAAC,YAAY,CAAC;AACnD,sBAAsB,WAAW,CAAC,YAAY,CAAC;;AAE/C,6CAA6C,iBAAiB,CAAC;AAC/D,sCAAsC,mBAAmB,CAAC,mBAAmB,CAAC,eAAe,CAAC,gBAAgB,CAAC,cAAc,CAAC,YAAY,CAAC,iBAAiB,CAAC;AAC7J,6CAA6C,mBAAmB,CAAC,WAAW,CAAC;;AAE7E,gBAAgB,yBAAyB,CAAC;;AAE1C,SAAS,YAAY,CAAC;AACtB,qCAAqC,iBAAiB,CAAC;AACvD,oBAAoB,gBAAgB,CAAC,uBAAuB,CAAC,qBAAqB,CAAC,cAAc,CAAC,gCAAgC,CAAC;AACnI,2BAA2B,yBAAyB,CAAC,WAAW,CAAC,qBAAqB,CAAC;;;AAGvF,gEAAgE,mBAAmB,GAAG,gBAAgB,GAAG,uBAAuB,CAAC,WAAW,CAAC;AAC7I,kGAAkG,aAAa,CAAC;;AAEhH;;6CAE6C;;AAE7C;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,0BAA0B;IAC1B,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,0CAA0C;IAC1C,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,eAAe;AACf;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA,0BAA0B;AAC1B;;IAEI,uBAAuB;IACvB,8BAA8B;AAClC;;AAEA;;IAEI,oBAAoB;IACpB,YAAY;AAChB;;AAEA,YAAY,UAAU,EAAE,WAAW,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,2BAA2B,EAAE,qBAAqB,EAAE,8BAA8B,EAAE;AACnK,mBAAmB,WAAW,UAAU,EAAE,EAAE,MAAM,YAAY,EAAE,EAAE;AAClE,oBAAoB,OAAO,UAAU,EAAE,0BAA0B,EAAE,EAAE,KAAK,UAAU,EAAE,wBAAwB,EAAE,EAAE;;AAElH,mCAAmC,SAAS,CAAC;AAC7C,SAAS,iBAAiB,CAAC,mDAAmD,CAAC,kBAAkB,CAAC,aAAa,CAAC,aAAa,CAAC,mBAAmB,CAAC,SAAS,CAAC,eAAe,CAAC,oBAAoB,CAAC,qBAAqB,CAAC,cAAc,CAAC;AACtO,gBAAgB,8CAA8C,CAAC,8CAA8C,CAAC,2BAA2B,CAAC,4BAA4B,CAAC;AACvK,sBAAsB,yBAAyB,CAAC,sBAAsB,CAAC,cAAc,CAAC;;AAEtF,YAAY,gBAAgB,CAAC;AAC7B,iBAAiB,kBAAkB,CAAC;AACpC,2CAA2C,WAAW,CAAC,kBAAkB,CAAC,UAAU,CAAC,SAAS,CAAC,yBAAyB,CAAC,UAAU,CAAC,YAAY,CAAC;;AAEjJ,sBAAsB,mBAAmB,CAAC,yBAAyB,CAAC,WAAW,CAAC,YAAY,CAAC,eAAe,CAAC,kBAAkB,CAAC;AAChI,kCAAkC,oCAAoC,CAAC,gBAAgB,CAAC;;AAExF,oBAAoB,6EAA6E,CAAC;AAClG,mBAAmB,yBAAyB,CAAC;AAC7C,eAAe,+DAA+D,CAAC;AAC/E,+CAA+C,QAAQ,CAAC,WAAW,CAAC;AACpE,0CAA0C,QAAQ,CAAC,WAAW,CAAC;;AAE/D,6BAA6B;AAC7B,6CAA6C,yBAAyB,CAAC,mBAAmB,CAAC,mCAAmC,CAAC;;AAE/H,oFAAoF,4BAA4B,CAAC,gCAAgC,CAAC;AAClJ,mEAAmE,oCAAoC,CAAC,yBAAyB,CAAC,iBAAiB,CAAC;AACpJ,sEAAsE,6BAA6B,CAAC;AACpG,+HAA+H;AAC/H,sGAAsG,yBAAyB,CAAC,qBAAqB,CAAC;AACtJ,2GAA2G,oCAAoC,CAAC,sBAAsB,CAAC;;AAEvK,2IAA2I;AAC3I,oGAAoG,yBAAyB,CAAC,qBAAqB,CAAC;AACpJ,yGAAyG,oCAAoC,CAAC,yBAAyB,CAAC;;AAExK,yIAAyI;AACzI,qGAAqG,yBAAyB,CAAC,qBAAqB,CAAC;AACrJ,0GAA0G,oCAAoC,CAAC,sBAAsB,CAAC;;AAEtK,6IAA6I;AAC7I,qGAAqG,yBAAyB,CAAC,qBAAqB,CAAC;AACrJ,0GAA0G,oCAAoC,CAAC,sBAAsB,CAAC;;AAEtK;AACA,iBAAiB,0CAA0C,CAAC;AAC5D;AACA;AACA,iBAAiB,2CAA2C,CAAC;AAC7D;;;AAGA,iFAAiF;AACjF;;;IAGI,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;;;IAGI,6BAA6B;IAC7B,oCAAoC;IACpC,2BAA2B;IAC3B,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;;;IAGI,2BAA2B;IAC3B,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;;;IAGI,6BAA6B;IAC7B,oCAAoC;IACpC,2BAA2B;IAC3B,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;;;IAGI,6BAA6B;IAC7B,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,2BAA2B;IAC3B,8BAA8B;AAClC;AACA;;6CAE6C;GAC1C;IACC,eAAe;IACf,QAAQ;IACR,aAAa;IACb,0BAA0B;IAC1B,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,6CAA6C;IAC7C,qCAAqC;IACrC,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,UAAU;IACV,2DAA2D;IAC3D,uCAAuC;AAC3C;AACA;IACI,OAAO,UAAU,EAAE,iCAAiC,EAAE;IACtD,OAAO,UAAU,EAAE,0BAA0B,EAAE;IAC/C,OAAO,UAAU,EAAE,0BAA0B,EAAE;IAC/C,OAAO,UAAU,EAAE,0BAA0B,EAAE;IAC/C,OAAO,UAAU,EAAE,iCAAiC,EAAE;AAC1D;AACA;IACI;QACI,kDAAkD;QAClD,eAAe;IACnB;IACA;QACI,WAAW,UAAU,EAAE,EAAE,MAAM,YAAY,EAAE;IACjD;AACJ;;AAEA;IACI,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,qBAAqB;IACrB,YAAY;IACZ,gDAAgD;AACpD;AACA,0BAA0B,UAAU,EAAE,0BAA0B,EAAE;AAClE,oBAAoB,WAAW,EAAE,YAAY,EAAE,cAAc,EAAE;;AAE/D,WAAW,gBAAgB,EAAE;AAC7B;IACI,iBAAiB;IACjB,iBAAiB;IACjB,oBAAoB;IACpB,UAAU;IACV,4BAA4B;AAChC;AACA,0BAA0B,UAAU,EAAE;AACtC,0BAA0B,qBAAqB,EAAE,gBAAgB,EAAE;;AAEnE;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,0BAA0B;AAC9B;AACA,+BAA+B,0BAA0B,EAAE;;AAE3D;IACI,+BAA+B,gBAAgB,EAAE;AACrD;;AAEA,8DAA8D;AAC9D;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,+BAA+B;IAC/B,mBAAmB;IACnB,SAAS;IACT,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,qDAAqD;AACrD;IACI,oBAAoB;IACpB,yBAAyB;IACzB,kBAAkB;IAClB,oBAAoB;;IAEpB,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,SAAS;IACT,SAAS;IACT,0BAA0B;IAC1B,gBAAgB;IAChB,mBAAmB;IACnB,2EAA2E;IAC3E,wCAAwC;IACxC;;0CAEsC;IACtC,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;IACjB,mDAAmD;AACvD;;AAEA;IACI,WAAW;IACX,UAAU;IACV,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,sEAAsE;IACtE,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;IACrB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,uBAAuB;IACvB,kCAAkC;IAClC,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,yEAAyE;IACzE,0BAA0B;IAC1B,mEAAmE;IACnE,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI;QACI,UAAU;QACV,0BAA0B;IAC9B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;IACA;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI;QACI,yBAAyB;QACzB,gBAAgB;QAChB,mBAAmB;QACnB,QAAQ;IACZ;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA,4FAA4F;AAC5F;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,6BAA6B;IAC7B,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,aAAa;AACjB;AACA;IACI,kBAAkB;AACtB;AACA,8DAA8D;AAC9D;IACI;QACI,iBAAiB;QACjB,SAAO;QACP,YAAY;IAChB;;IAEA;QACI,iBAAiB;QACjB,SAAO;QACP,YAAY;QACZ,gBAAgB;QAChB,qBAAqB;QACrB,aAAa;IACjB;;IAEA;QACI,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;AACJ;;AAEA,gCAAgC,WAAW,CAAC,0DAAwK,CAAC,gCAAgC,CAAC,kBAAkB,CAAC,gDAAgD,CAAC,YAAY,CAAC,sBAAsB,CAAC;AAC9V,wCAAwC,iCAAiC,CAAC,0DAAuJ,CAAC;;AAElO,yEAAyE;AACzE;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,4CAA4C;IAC5C,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;;IAEI,sBAAsB;IACtB,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,iCAAiC;IACjC,sBAAsB;IACtB,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA;IACI,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;;;+EAG+E;AAC/E;IACI,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,wBAAwB;IACxB,qBAAqB;IACrB,uBAAuB;IACvB,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,kCAAkC;IAClC,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;IACjB,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,iCAAiC;IACjC,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,yCAAyC;IACzC,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,WAAW;IACX,gCAAgC;AACpC;;AAEA;IACI,4BAA4B;IAC5B,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,gCAAgC;AACpC;;AAEA;IACI,0BAA0B;IAC1B,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,kCAAkC;IAClC,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,SAAO;IACP,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,eAAe;IACf,kCAAkC;IAClC,kBAAkB;IAClB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kCAAkC;IAClC,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,qBAAqB;IACrB,OAAO;IACP,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,gBAAgB;IAChB,kCAAkC;IAClC,kBAAkB;IAClB,6CAA6C;AACjD;;AAEA;;IAEI,SAAS;IACT,uBAAuB;IACvB,UAAU;IACV,cAAc;IACd,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,aAAa;IACb,eAAe;AACnB;;AAEA;;IAEI,4BAA4B;IAC5B,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,qBAAqB;IACrB,OAAO;IACP,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,kCAAkC;IAClC,kBAAkB;IAClB,6CAA6C;AACjD;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,qBAAqB;IACrB,YAAY;IACZ,gBAAgB;IAChB,yCAAyC;IACzC,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,kBAAkB;IAClB,mBAAmB;IACnB,yCAAyC;IACzC,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,kCAAkC;IAClC,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,0BAA0B;IAC1B,WAAW;IACX,4BAA4B;AAChC;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;IAClB,yCAAyC;IACzC,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,QAAQ;AACZ;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,OAAO;IACP,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,qBAAqB;IACrB,gBAAgB;IAChB,kCAAkC;IAClC,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,sCAAsC;IACtC,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,4BAA4B;IAC5B,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;IAC1B,WAAW;IACX,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,kCAAkC;IAClC,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;IAC1B,WAAW;IACX,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,oBAAoB;IACpB,0BAA0B;IAC1B,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,uBAAuB;IACvB,oCAAoC;IACpC,6BAA6B;IAC7B,2BAA2B;IAC3B,2BAA2B;AAC/B;;AAEA;IACI,uCAAuC;IACvC,uDAAuD;AAC3D;;AAEA;;IAEI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,SAAS;IACT,uBAAuB;IACvB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,eAAe;IACf,QAAQ;IACR,kCAAkC;IAClC,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,QAAQ;IACR,YAAY;IACZ,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,2CAA2C;IAC3C,aAAa;IACb,aAAa;IACb,sBAAsB;AAC1B;;AAEA;;IAEI,kBAAkB;IAClB,yCAAyC;IACzC,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,SAAS;AACb;;AAEA;;IAEI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,yCAAyC;IACzC,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,oCAAoC;AACxC;;AAEA;IACI,qBAAqB;IACrB,mCAAmC;AACvC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,SAAO;AACX;;AAEA;;IAEI,kBAAkB;IAClB,sCAAsC;IACtC,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,UAAU;AACd;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,sBAAsB;IACtB,yCAAyC;IACzC,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,yCAAyC;AAC7C;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;;IAEI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB,SAAS;IACT,uBAAuB;IACvB,gBAAgB;IAChB,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,iBAAiB;IACjB,kCAAkC;IAClC,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,0DAAuJ;IACvJ,gCAAgC;IAChC,YAAY;IACZ,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,iCAAiC;IACjC,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;IAChB,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB,mCAAmC;IACnC,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,YAAY;IACZ,6BAA6B;IAC7B,8BAA8B;IAC9B,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,8CAA8C;AAClD;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;IAC5B,mBAAmB;IACnB,wCAAwC;AAC5C;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,QAAQ;IACR,kBAAkB;IAClB,mBAAmB;IACnB,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,SAAS;IACT,uBAAuB;IACvB,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,UAAU;AACd;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,qCAAqC;IACrC,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,gBAAgB;QAChB,aAAa;QACb,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,iBAAiB;QACjB,oCAAoC;QACpC,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;QACjB,mCAAmC;IACvC;;IAEA;;QAEI,0BAA0B;IAC9B;AACJ","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Jost:ital,wght@0,100..900;1,100..900&family=Waterfall&display=swap&family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap&family=Arvo:ital,wght@0,400;0,700;1,400;1,700&family=Joan&display=swap');\n:root {\n    --bs-purple-rgb: 124, 58, 237;\n}\n* {\n    padding: 0;\n    margin: 0;\n    box-sizing: border-box;\n    font-family: 'Jost', sans-serif;\n}\nbody {\n    background: #fff;\n    overflow: visible !important;\n    padding: 0 !important;\n}\nbody.flex100vh,\nbody > div#root {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n    min-height: 100vh;\n}\nbody > div#root ~ .modal-backdrop{display: none !important;}\nbody {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n    min-height: 100vh;\n    background: #f3f3f3;\n}\n.flex-1 {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n}\na {\n    color: #d42941;\n}\na:hover {\n    color: #bb1b32;\n    text-decoration: none;\n}\n.font-12 {\n    font-size: 12px !important;\n}\n.font-13 {\n    font-size: 13px !important;\n}\n.font-14 {\n    font-size: 14px !important;\n}\n.font-15 {\n    font-size: 15px !important;\n}\n.font-16 {\n    font-size: 16px !important;\n}\n.font-17 {\n    font-size: 17px !important;\n}\n.font-18 {\n    font-size: 18px !important;\n}\n.font-19 {\n    font-size: 19px !important;\n}\n.font-20 {\n    font-size: 20px !important;\n}\n.font-21 {\n    font-size: 21px !important;\n}\n.font-22 {\n    font-size: 22px !important;\n}\n.font-23 {\n    font-size: 23px !important;\n}\n.font-24 {\n    font-size: 24px !important;\n}\n.font-25 {\n    font-size: 25px !important;\n}\n.font-26 {\n    font-size: 26px !important;\n}\n.font-27 {\n    font-size: 27px !important;\n}\n.font-28 {\n    font-size: 28px !important;\n}\n.font-29 {\n    font-size: 29px !important;\n}\n.font-30 {\n    font-size: 30px !important;\n}\n.font-31 {\n    font-size: 31px !important;\n}\n.font-32 {\n    font-size: 32px !important;\n}\n.font-48 {\n    font-size: 48px !important;\n}\n.font-700 {\n    font-weight: 700 !important;\n}\n.font-600 {\n    font-weight: 600 !important;\n}\n.font-500 {\n    font-weight: 500 !important;\n}\n.font-400 {\n    font-weight: 400 !important;\n}\n.font-300 {\n    font-weight: 300 !important;\n}\n.f.input-otp.input-otpont-100 {\n    font-weight: 100 !important;\n}\n.text-burgandi {\n    color: #d42941;\n}\n.text-green {\n    color: #5cae48;\n}\n.text-dark-blue {\n    color: #0b3454;\n}\n.text-light-blue,\n.text-sky-blue {\n    color: #26a7df;\n}\n.text-purple {\n    color: #51499c;\n}\n.text-gray-41 {\n    color: #414141;\n}\n.text-gray-84 {\n    color: #848484;\n}\n.text-gray-64 {\n    color: #646464;\n}\n.text-gray-53 {\n    color: #535353;\n}\n.text-gray-4b {\n    color: #4b4b4b;\n}\n.text-orange {\n    color: #F05A2A;\n}\n.line-height-24 {\n    line-height: 24px;\n}\n.line-height-16 {\n    line-height: 16px;\n}\n.line-height-13 {\n    line-height: 13px;\n}\n.top-10 {\n    top: 10px !important;\n}\n.top-20 {\n    top: 20px !important;\n}\n.top-30 {\n    top: 30px !important;\n}\n.top-40 {\n    top: 40px !important;\n}\n.top-50 {\n    top: 50px !important;\n}\n.bottom-10 {\n    bottom: 10px !important;\n}\n.bottom-20 {\n    bottom: 20px !important;\n}\n.bottom-30 {\n    bottom: 30px !important;\n}\n.bottom-40 {\n    bottom: 40px !important;\n}\n.bottom-50 {\n    bottom: 50px !important;\n}\n.right-10 {\n    right: 10px !important;\n}\n.right-20 {\n    right: 20px !important;\n}\n.right-30 {\n    right: 30px !important;\n}\n.right-40 {\n    right: 40px !important;\n}\n.right-50 {\n    right: 50px !important;\n}\n.max-1250 {\n  max-width: 1250px;\n  width: 90%;\n}\n.max-1170 {\n    max-width: 1170px;\n    width: 90%;\n}\n.max-1140 {\n    max-width: 1140px;\n    width: 94%;\n}\n.max-1040 {\n    max-width: 1040px;\n    width: 94%;\n}\n.max-1010 {\n    max-width: 1010px;\n    width: 94%;\n}\n.max-940 {\n    max-width: 940px;\n    width: 94%;\n}\n.max-900 {\n    max-width: 900px;\n    width: 90%;\n}\n.max-850 {\n    max-width: 850px;\n    width: 94%;\n}\n.max-740 {\n    max-width: 740px;\n    width: 90%;\n}\n.max-700 {\n    max-width: 700px;\n    width: 90%;\n}\n.max-650 {\n    max-width: 650px;\n    width: 90%;\n}\n.max-630 {\n    max-width: 630px;\n    width: 90%;\n}\n.max-620 {\n    max-width: 620px;\n    width: 90%;\n}\n.max-570 {\n    max-width: 570px;\n    width: 90%;\n}\n.max-540 {\n    max-width: 540px;\n    width: 90%;\n}\n\n.max-120 {\n    max-width: 120px !important;\n    width: 120px;\n}\n.max-150 {\n    max-width: 150px !important;\n    width: 150px;\n}\n.max-167 {\n    max-width: 167px !important;\n    width: 167px;\n}\n.max-170 {\n    max-width: 170px !important;\n    width: 170px;\n}\n.max-190 {\n    max-width: 190px !important;\n    width: 190px;\n}\n.max-200 {\n    max-width: 200px !important;\n    width: 100% !important;\n}\n.max-210 {\n    max-width: 210px !important;\n    width: 210px !important;\n}\n.max-240 {\n    max-width: 240px !important;\n    width: 100%;\n}\n.max-250 {\n    max-width: 250px !important;\n    width: 100%;\n}\n.max-300 {\n    max-width: 300px !important;\n    width: 100%;\n}\n.max-360 {\n    max-width: 360px !important;\n    width: 100%;\n}\n.max-420 {\n    max-width: 420px !important;\n    width: 90%;\n}\n.max-470 {\n    max-width: 470px !important;\n    width: 100%;\n}\n.max-100per {\n    max-width: 100% !important;\n    width: 100%;\n}\n.min-100per {\n    min-width: 100% !important;\n}\n.max-80 {\n    max-width: 100% !important;\n    width: 80px;\n}\n.min-wauto {\n    min-width: auto !important;\n    width: auto;\n}\n\n/* login and signup css */\nbody .bg_side_blue {\n    position: relative;\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n}\nbody .bg_side_blue::after {\n    position: absolute;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    content: '';\n    background: #0b3454;\n    width: 32%;\n}\n\n@media (max-width: 767px) {\n    body .bg_side_blue::after {\n        width: 100%;\n    }\n}\nbody .bg_side_blue > .container {\n    z-index: 1;\n}\n.custom_logo {\n    padding: 40px 0 0;\n}\n.custom_logo .img-fluid {\n    max-height: 100px;\n    width: auto;\n}\n.leftPaneMain {\n    width: 100%;\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 50px 0;\n}\n.leftPaneMain h2 {\n    font-size: 30px;\n    line-height: 35px;\n    max-width: 420px;\n    text-align: center;\n    font-weight: bold;\n    margin: 0 0 20px;\n}\n.leftPaneMain .login_carousel {\n    max-width: 460px;\n    margin: 0 auto 30px;\n    width: 90%;\n}\n.leftPaneMain .login_carousel .innercover .img img {\n    max-width: 320px;\n}\n.leftPaneMain .login_carousel .innercover h3 {\n    font-size: 30px;\n    line-height: 35px;\n    font-weight: bold;\n}\n.leftPaneMain .login_carousel .innercover p {\n    font-size: 18px;\n    line-height: 26px;\n}\n.leftPaneMain .login_carousel .owl-dots {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.leftPaneMain .login_carousel .owl-dots .owl-dot {\n    background: #585858 !important;\n    opacity: 0.2;\n    width: 9px;\n    height: 9px;\n    margin: 0 4px;\n    opacity: 0.2;\n    filter: alpha(opacity=20);\n    border-radius: 50%;\n    -webkit-border-radius: 50%;\n    -moz-border-radius: 50%;\n    -ms-border-radius: 50%;\n    -o-border-radius: 50%;\n}\n.leftPaneMain .login_carousel .owl-dots .owl-dot.active {\n    opacity: 0.8;\n    filter: alpha(opacity=80);\n}\n\n.carousel-item figure {\n    padding: 0px;\n    margin: 0px 0 30px 0;\n    height: 240px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: end;\n}\n.carousel-item figure img {\n    max-width: 250px;\n    width: 100%;\n}\n.carousel-item h4 {\n    font-size: 30px;\n    line-height: 35px;\n    color: #000000;\n    padding: 0px;\n    margin: 0px auto 20px auto;\n    font-weight: 600;\n    max-width: unset;\n}\n.carousel-item p {\n    font-size: 16px;\n    line-height: 22px;\n    color: #000000;\n    padding: 0px;\n    margin: 0px auto;\n    max-width: 400px;\n}\n\n.leftPaneFooter {\n    padding: 40px 0;\n    width: 100%;\n}\n.leftPaneFooter .copyRight {\n    font-size: 14px;\n    font-weight: 500;\n}\n.leftPaneFooter .copyRight span {\n    display: block;\n    font-size: 13px;\n    color: #060606;\n    opacity: 0.6;\n}\n.leftPaneFooter .powerby {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n    max-width: 127px;\n}\n.leftPaneFooter .powerby span {\n    font-size: 14px;\n}\n.btn-View-appeal {\n    background: #d42941;\n    border-radius: 35px;\n    -webkit-border-radius: 35px;\n    -moz-border-radius: 35px;\n    -ms-border-radius: 35px;\n    -o-border-radius: 35px;\n    color: #fff;\n    border: 0;\n    height: 50px;\n    padding: 5px !important;\n    align-items: center;\n    margin: 0 auto;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n}\n.btn-View-appeal i {\n    width: 40px;\n    height: 40px;\n    background: #fff;\n    border-radius: 50%;\n    -webkit-border-radius: 50%;\n    -moz-border-radius: 50%;\n    -ms-border-radius: 50%;\n    -o-border-radius: 50%;\n    margin-right: 10px;\n    position: relative;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n}\n.btn-View-appeal i::before {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    top: 0;\n    margin: auto;\n    width: 22px;\n    height: 16px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/youtube.svg);\n}\n.btn-View-appeal span {\n    font-size: 16px;\n    font-weight: 500;\n    margin-right: 20px;\n}\n.btn-View-appeal:hover {\n    background: #e8354e;\n}\n.btn-View-appeal:hover i {\n    background: #000;\n}\n.btn-View-appeal:hover i::before {\n    filter: invert(1) brightness(1);\n    -webkit-filter: invert(1) brightness(1);\n}\n.bg_side_blue .signup {\n    flex-direction: column;\n    padding-top: 40px;\n    background: #0b3454;\n    margin-right: -1px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    border-radius: 0 18px 18px 80px;\n    -webkit-border-radius: 0 18px 18px 80px;\n    -moz-border-radius: 0 18px 18px 80px;\n    -ms-border-radius: 0 18px 18px 80px;\n    -o-border-radius: 0 18px 18px 80px;\n}\n.bg_side_blue .signup h2 {\n    color: #fff;\n    font-size: 28px;\n}\n.bg_side_blue .signup h2:empty,\n.bg_side_blue .signup h6:empty {\n    display: none;\n}\n.bg_side_blue .signup > ul.nav {\n    display: inline-flex !important;\n    border-bottom: 0px solid #000;\n    max-width: 496px;\n    width: 90%;\n    margin: 0 auto;\n}\n.bg_side_blue .signup > ul.nav li {\n    -webkit-box-flex: 2;\n    -moz-box-flex: 2;\n    -webkit-flex: 2;\n    -ms-flex: 2;\n    flex: 2;\n}\n.bg_side_blue .signup > ul.nav li button {\n    width: 100%;\n    border: 0;\n    border-radius: 0;\n    line-height: 70px;\n    padding: 0;\n    font-size: 14px;\n    font-weight: 500;\n    color: rgba(255, 255, 255, 0.5);\n    border-bottom: 2px solid #375973;\n    background: none !important;\n    font-size: 16px !important;\n    border-radius: 0;\n    -webkit-border-radius: 0;\n    -moz-border-radius: 0;\n    -ms-border-radius: 0;\n    -o-border-radius: 0;\n}\n.bg_side_blue .signup > ul.nav li button.active {\n    color: #fff;\n    border-color: #5cae48;\n}\n.bg_side_blue .signup > .tab-content {\n    max-width: 496px;\n    width: 90%;\n    margin: 0 auto;\n}\n.bg_side_blue .signup .form-group {\n    position: relative;\n}\n.bg_side_blue .signup .form-label {\n    color: #fff;\n    font-size: 16px;\n}\n.bg_side_blue .signup .form-group .viewpassword {\n    position: absolute;\n    right: 15px;\n    bottom: auto;\n    top: 14px;\n    margin: auto;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-content: center;\n    z-index: 2;\n}\n.bg_side_blue .signup .form-group .form-check-label {\n    cursor: pointer;\n}\n.bg_side_blue .signup .form-group .form-check-label .icon-whatapp {\n    width: 20px;\n    height: 20px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/whatsapp.svg) no-repeat 0 0;\n    display: inline-block;\n    margin-right: 5px;\n    margin-top: 3px;\n}\n.bg_side_blue .signup .form-check {\n    position: relative;\n}\n.bg_side_blue .signup .form-check #agreeToUnivariety + .text-danger {\n    position: absolute;\n    top: calc(100% + 5px);\n    left: 0;\n}\n.bg_side_blue .signup .form-check-label {\n    color: #fff;\n}\n.bg_side_blue .signup .form-check-label[for*='provideUpdatesOnWhatsapp'] {\n    display: inline-flex;\n    align-content: center;\n}\n.bg_side_blue .signup .form-check-label[for*='provideUpdatesOnWhatsapp']:before {\n    content: '';\n    width: 20px;\n    height: 20px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/whatsapp.svg) no-repeat 0 0;\n    display: inline-block;\n    margin: 0 5px 0 0;\n}\n#provideUpdatesOnWhatsapp {\n    vertical-align: top;\n    display: inline-block;\n    position: static;\n    order: -1;\n}\n.bg_side_blue .signup .email-text {\n    color: #ffffff99;\n}\n.bg_side_blue .signup .btn-completed {\n    background: #5cae48;\n    color: #fff;\n    border-color: #5cae48;\n    max-width: 200px;\n    width: 100%;\n    border-radius: 25px;\n    -webkit-border-radius: 25px;\n    -moz-border-radius: 25px;\n    -ms-border-radius: 25px;\n    -o-border-radius: 25px;\n}\n.bg_side_blue .signup .btn-completed:hover {\n    background: #88bb1b;\n    color: #fff;\n    border-color: #88bb1b;\n}\n.bg_side_blue .signup .btn-View-appeal {\n    background: #fff;\n    color: #d42941;\n    line-height: 18px;\n}\n.bg_side_blue .signup .btn-View-appeal i {\n    background: #d42941;\n}\n.bg_side_blue .signup .btn-View-appeal i::before {\n    filter: invert(1);\n    -webkit-filter: invert(1);\n}\n.bg_side_blue .signup .btn-View-appeal:hover {\n    background: #5cae48;\n    color: #fff;\n}\n.bg_side_blue .signup .btn-View-appeal:hover i {\n    background: #fff;\n}\n.bg_side_blue .signup .btn-View-appeal:hover i::before {\n    filter: invert(0);\n    -webkit-filter: invert(0);\n}\n.bg_side_blue .signup .or {\n    margin: 0 0 20px;\n    text-align: center;\n    display: inline-block;\n    width: 100%;\n    font-size: 18px;\n    line-height: 22px;\n    color: #fff;\n    position: relative;\n}\n.bg_side_blue .signup .or::after {\n    background: #38566e;\n    width: 100%;\n    height: 1px;\n    position: absolute;\n    bottom: 11px;\n    margin: auto;\n    content: '';\n    left: 0;\n    right: 0;\n    max-width: 463px;\n}\n.bg_side_blue .signup .or b {\n    font-weight: 400;\n    background: #0b3454;\n    position: relative;\n    z-index: 2;\n    padding: 0 10px;\n}\n.bg_side_blue .signup .sociallnks {\n    text-align: center;\n}\n.bg_side_blue .signup .sociallnks p {\n    font-size: 14px;\n    line-height: 17px;\n    color: #fff;\n    font-family: 'Jost', sans-serif;\n    margin: 0;\n    font-weight: 400;\n}\n.bg_side_blue .signup .sociallnks p a {\n    color: #a2e609;\n    font-weight: 500;\n}\n.bg_side_blue .signup .sociallnks p a:hover {\n    color: #5cae48 !important;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n    text-decoration: none;\n}\n.bg_side_blue .signup .sociallnks ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    justify-content: center;\n}\n.bg_side_blue .signup .sociallnks ul li {\n    width: 100px;\n    margin: 20px 10px;\n}\n.bg_side_blue .signup .sociallnks ul li a {\n    background: #ffffff;\n    box-shadow: 0px 5px 10px #0000001a;\n    width: 100%;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    border-radius: 18px;\n    -webkit-border-radius: 18px;\n    -moz-border-radius: 18px;\n    -ms-border-radius: 18px;\n    -o-border-radius: 18px;\n    height: 36px;\n    justify-content: center;\n    align-items: center;\n}\n.bg_side_blue .signup .leftPaneFooter {\n    background: #fff;\n    padding: 20px;\n    width: auto;\n    margin-right: calc(var(--bs-gutter-x) / -1.03);\n    margin-left: calc(var(--bs-gutter-x) / -1.02);\n}\n\n.login_social_media .or {\n    display: block;\n    text-align: center;\n    font-size: 18px;\n    line-height: 24px;\n    color: #ffffff;\n    position: relative;\n    padding-bottom: 4px;\n    margin-bottom: 24px;\n}\n.login_social_media .or:after {\n    width: 100%;\n    height: 1px;\n    background: #1e4d94;\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    display: block;\n    content: '';\n}\n.login_social_media .or em {\n    font-style: normal;\n    padding: 0 15px;\n    background: #0d3453;\n    font-size: 18px;\n    line-height: 24px;\n    color: #ffffff;\n    position: relative;\n    z-index: 99;\n}\n.login_social_media ul {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0 0 20px 0;\n    padding: 0px;\n    list-style: none;\n}\n.login_social_media ul li {\n    padding: 0 10px;\n    width: 100%;\n    max-width: 285px;\n}\n.login_social_media ul li a {\n    width: 100%;\n    height: auto;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 3px;\n    padding: 15px 30px;\n    color: #fff;\n    text-decoration: none;\n    font-size: 18px;\n    font-weight: 500;\n    -webkit-border-radius: 3px;\n    -moz-border-radius: 3px;\n    -ms-border-radius: 3px;\n    -o-border-radius: 3px;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.login_social_media ul li a img {\n    filter: brightness(0) invert(1);\n    -webkit-filter: brightness(0) invert(1);\n}\n.login_social_media ul li a.google {\n    background-color: #cb4023;\n}\n\n.login_social_media ul li a.linkedin {\n    background-color: #0077b7;\n}\n\n.login_social_media ul li a.keyCloak {\n    background-color: #fff;\n    color: #0077b7 !important;\n}\n\n.login_social_media ul li a.google:hover {\n    background-color: #fff;\n    color: #cb4023 !important;\n}\n.login_social_media ul li a.linkedin:hover {\n    background-color: #fff;\n    color: #0077b7 !important;\n}\n.login_social_media ul li a.keyCloak:hover {\n    background-color: #0077b7;\n    color: #fff !important;\n}\n.login_social_media ul li a:hover img {\n    filter: none;\n    -webkit-filter: none;\n}\n.login_social_media label {\n    display: block;\n    text-align: center;\n    font-size: 14px;\n    color: #ffffff;\n    margin-bottom: 18px;\n}\n.login_social_media p {\n    display: block;\n    text-align: center;\n    font-size: 14px;\n    color: #ffffff;\n    padding: 0px;\n    margin: 0px;\n}\n.login_social_media p a {\n    color: #a2e609;\n}\n\n.cursor-pointer {\n    cursor: pointer;\n}\n.max-1300 {\n    max-width: 1300px;\n    width: 94%;\n}\n\n@media (max-width: 767px) {\n    .bg_side_blue .signup {\n        padding-top: 0px;\n    }\n    .bg_side_blue .signup .custom_logo {\n        background: #fff;\n        padding: 20px;\n        margin-right: calc(var(--bs-gutter-x) / -1.03);\n        margin-left: calc(var(--bs-gutter-x) / -1.02);\n        margin-bottom: 40px;\n    }\n    .max-1300 {\n        width: 100%;\n    }\n    .bg_side_blue .signup .leftPaneFooter {\n        margin-top: auto;\n    }\n}\n\n.landing_login_page .form-control {\n    min-height: 40px;\n    border: none;\n    border-radius: 6px;\n    -webkit-border-radius: 6px;\n    -moz-border-radius: 6px;\n    -ms-border-radius: 6px;\n    -o-border-radius: 6px;\n    font-weight: 500;\n    color: #000;\n    font-size: 16px;\n    z-index: 1;\n    position: relative;\n}\n.input-otp {\n    max-width: 60px;\n    width: 100%;\n    outline: none;\n    box-shadow: none;\n    height: 55px;\n    border-radius: 6px;\n    -webkit-border-radius: 6px;\n    -moz-border-radius: 6px;\n    -ms-border-radius: 6px;\n    -o-border-radius: 6px;\n}\n.password-toggle {\n    right: 20px;\n    width: 20px;\n    cursor: pointer;\n    float: right;\n    margin: -34px 0 0;\n    position: relative;\n    z-index: 1;\n}\n.password-toggle img {\n    width: 100%;\n}\n.landing_login_page #myloginTabContent > .bg {\n    position: relative;\n    margin-top: 30px;\n}\n.landing_login_page #myloginTabContent > .bg p {\n    width: 100%;\n    left: 0;\n    right: 0;\n    top: 0;\n    padding: 10px;\n    border-radius: 3px;\n    text-align: center;\n    font-size: 18px;\n    color: #fff;\n    font-weight: 500;\n    max-width: 380px;\n    margin: auto;\n}\n.landing_login_page #myloginTabContent > .bg.fail-message p {\n    background: #e30000;\n}\n.landing_login_page #myloginTabContent > .bg.success-message p {\n    background: #5cae48;\n}\n.btn-forgotpw {\n    color: #fff;\n}\n.btn-forgotpw a {\n    color: #fff;\n}\n.btn-relogin {\n    color: #fff;\n}\n.form-pop-up {\n    max-width: 280px;\n}\n.form-pop-up .icon {\n    width: 70px;\n    height: 70px;\n    margin: auto auto 15px;\n    display: inline-block;\n    border-radius: 50%;\n}\n.form-pop-up h2 {\n    font-size: 24px;\n    font-weight: 500;\n    margin: 0 0 7px;\n}\n.form-pop-up .icon.success {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/popup-checked.png) no-repeat 0 0 /\n        100%;\n}\n.form-pop-up .icon.sorry {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/popup-cancel.png) no-repeat 0 0 /\n        100%;\n}\n.success {\n    color: #32ba7c;\n}\n.sorry {\n    color: #e31e1e;\n}\n.form-pop-up p {\n    margin-bottom: 30px;\n}\n.form-pop-up button {\n    border: 0;\n    border-radius: 25px;\n    max-width: 120px;\n    margin: auto;\n    width: 100%;\n    padding: 5px;\n    text-transform: uppercase;\n    font-weight: 500;\n    font-size: 14px;\n    height: 35px;\n    color: #fff;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.form-pop-up button.btn-success {\n    background: #32ba7c;\n    color: #fff;\n}\n.form-pop-up button.btn-success:hover {\n    background: #3a8c26;\n}\n.form-pop-up button.btn-sorry {\n    background: #e31e1e;\n    color: #fff;\n}\n.form-pop-up button.btn-sorry:hover {\n    background: #ad0e0e;\n}\n/* login and signup css End */\n\n/* Profile Registration Start */\n\n.bg-skyblue-gradient,\n.basic-information {\n    background: #f3f9ff;\n    background: -moz-linear-gradient(top, #f3f9ff 0%, #f7fbff 44%, #f0f7ff 100%);\n    background: -webkit-linear-gradient(top, #f3f9ff 0%, #f7fbff 44%, #f0f7ff 100%);\n    background: linear-gradient(to bottom, #f3f9ff 0%, #f7fbff 44%, #f0f7ff 100%);\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f3f9ff', endColorstr='#f0f7ff',GradientType=0 );\n}\n.bg-beige-gradient,\n.undergraduate-college {\n    background: #fffbf2;\n    background: -moz-linear-gradient(top, #fffbf2 0%, #fef8ea 44%, #fef7e7 100%);\n    background: -webkit-linear-gradient(top, #fffbf2 0%, #fef8ea 44%, #fef7e7 100%);\n    background: linear-gradient(to bottom, #fffbf2 0%, #fef8ea 44%, #fef7e7 100%);\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#FFFBF2', endColorstr='#FEF7E7',GradientType=0 );\n}\n.bg-purple-gradient {\n    background: transparent linear-gradient(144deg, #edebff 0%, #f6f5ff 100%) !important;\n}\n.bg-green-gradient {\n    background: transparent linear-gradient(211deg, #fefffd 0%, #ebffe6 76%, #c6ebbe 100%) !important;\n}\n.bg-pink-gradient {\n    background: transparent linear-gradient(145deg, #ffe8eb 0%, #fff8f9 100%) !important;\n}\n.rightPane.basic-information .rightPaneHeaderWrap {\n    background: #f3f9ff;\n}\n.rightPane.undergraduate-college .rightPaneHeaderWrap {\n    background: #fffbf2;\n}\n.rightPane.bg-purple-gradient .rightPaneHeaderWrap {\n    background: #efedff;\n}\n.bg-green-gradient .rightPaneHeaderWrap {\n    background: #f0ffec !important;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n}\n.bg-pink-gradient .rightPaneHeaderWrap {\n    background: transparent !important;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n}\n.green_recom_bg {\n    background: transparent linear-gradient(95deg, #5cae48 0%, #27a7df 100%) !important;\n    right: 50px !important;\n}\n.bg_transparant {\n    background: transparent !important;\n}\n.prize_bg {\n    background: transparent linear-gradient(94deg, #51499c 0%, #d42941 100%) !important;\n}\n.laststep_bg {\n    background: transparent linear-gradient(101deg, #51499c 0%, #27a7df 100%) !important;\n}\n.user_name span {\n    font-weight: 600;\n}\n.main-wrap {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    background-color: #fff;\n}\n.main-wrap > .row {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n}\n.leftPane {\n    width: 57.82%;\n}\n.leftPaneHeaderWrap {\n    padding: 25px 0px;\n    border-bottom: 1px solid #e2e8ef;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: end;\n    position: sticky;\n    top: 0;\n    background: #fff;\n    z-index: 3;\n    height: 93px;\n}\n.leftPaneHeader {\n    max-width: 900px;\n    width: 96%;\n}\n.leftPaneHeader .user_name {\n    display: none;\n}\n.leftPaneHeader img {\n    height: 100%;\n    width: auto;\n}\n.leftPaneBodyWrap {\n    padding: 50px 0;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: end;\n}\n.leftPaneBody {\n    padding: 0 100px;\n    max-width: 890px;\n    width: 100%;\n}\n.leftPaneWrap {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n}\n.leftPaneWrap .leftPaneBodyWrap {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n}\n.leftPaneBody .qs_body {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n}\n.leftPaneBody .qs_body .step {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n}\n.leftPaneBody .qs_body .steps {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n}\n.leftPaneBody .qs_body .form-check-inline {\n    min-height: 45px;\n    display: inline-flex;\n    align-items: center;\n    margin-top: 2px;\n}\n.leftPaneBody .qs_body legend ~ .form-check-inline {\n    min-height: 0;\n}\n.leftPaneBody .qs_body .form-check-inline input {\n    margin-right: 5px;\n    width: 20px;\n    height: 20px;\n    transition: all 0.3s ease-in-out;\n}\n.leftPaneBody .qs_body .form-check-inline .form-check-label {\n    margin-top: 2px;\n}\n.progress_svg {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    z-index: 2;\n    background: white;\n    border-radius: 50%;\n}\n.global {\n    position: absolute;\n    background: white;\n    border-radius: 50%;\n    width: 100px;\n    height: 100px;\n    bottom: -50px;\n    right: -50px;\n}\n.unlock {\n    white-space: nowrap;\n    display: flex;\n    align-items: center;\n    background: transparent linear-gradient(96deg, #f05a2a 0%, #f8b018 100%);\n    border-radius: 30px 0px 0px 30px;\n    height: 40px;\n    right: 20px;\n    position: absolute;\n    bottom: 0;\n    top: 0;\n    margin: auto;\n    z-index: 1;\n    -webkit-border-radius: 30px 0px 0px 30px;\n    -moz-border-radius: 30px 0px 0px 30px;\n    -ms-border-radius: 30px 0px 0px 30px;\n    -o-border-radius: 30px 0px 0px 30px;\n    width: auto;\n    transition: all 0.5s ease-in-out;\n    opacity: 0;\n    -webkit-transition: all 0.5s ease-in-out;\n    -moz-transition: all 0.5s ease-in-out;\n    -ms-transition: all 0.5s ease-in-out;\n    -o-transition: all 0.5s ease-in-out;\n}\n.unlock_blue {\n    background: transparent linear-gradient(95deg, #27a7df 0%, #51499c 100%) !important;\n    border-radius: 30px 0px 0px 30px !important;\n}\n.unlock .img {\n    margin: 0 10px 0 5px;\n}\n.unlock .img img {\n    width: 30px;\n    height: 30px;\n}\n.unlock.prize_bg .img,\n.unlock.laststep_bg .img {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: end;\n    height: 100%;\n}\n.unlock.unlock_blue .img {\n    margin: 0 5px 10px -3px;\n}\n.unlock.green_recom_bg .img {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: end;\n    height: 100%;\n    padding: 0 0 5px 8px;\n}\n.unlock.prize_bg .img img {\n    width: 62px;\n    height: auto;\n}\n.unlock.laststep_bg .img img {\n    width: 48px;\n    height: auto;\n}\n.unlock.green_recom_bg .img img {\n    width: 43px;\n    height: auto;\n}\n.unlock.unlock_blue .img img {\n    width: 57px;\n    height: auto;\n}\n.unlock.prize_bg .img {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: end;\n    height: 100%;\n}\n.unlock.prize_bg .img img {\n    width: 62px;\n    height: auto;\n}\n.unlock .text {\n    line-height: 18px;\n    color: #fff;\n    padding-right: 30px;\n    font-size: 18px;\n    font-weight: 400;\n    width: 0;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.progress_svg span {\n    position: absolute;\n    left: auto;\n    right: auto;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    font-size: 25px !important;\n    font-weight: 600;\n    color: #000 !important;\n    line-height: 90px !important;\n}\n.progress_svg span::after {\n    content: '%';\n    font-size: 18px !important;\n}\n.progress_svg .gaugeMeter {\n    width: 90px;\n    height: 90px;\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    top: 0;\n    margin: auto;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.global.show .unlock .text {\n    width: auto;\n}\n.global.show .unlock {\n    right: 80px;\n    opacity: 1;\n}\n.rightPane {\n    width: 42.18%;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    transition: all 0.5s ease-in-out;\n    -webkit-transition: all 0.5s ease-in-out;\n    -moz-transition: all 0.5s ease-in-out;\n    -ms-transition: all 0.5s ease-in-out;\n    -o-transition: all 0.5s ease-in-out;\n}\n.rightPaneWrap {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n}\n.rightPaneHeaderWrap {\n    min-height: 93px;\n    border-bottom: 1px solid #e4e8ef;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    position: sticky;\n    top: 0;\n    z-index: 2;\n    transition: all 0.5s ease-in-out;\n    -webkit-transition: all 0.5s ease-in-out;\n    -moz-transition: all 0.5s ease-in-out;\n    -ms-transition: all 0.5s ease-in-out;\n    -o-transition: all 0.5s ease-in-out;\n}\n.rightPaneHeader {\n    max-width: 600px;\n    width: 96%;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: end;\n    align-items: center;\n}\n.rightPaneBodyWrap {\n    padding: 50px 60px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    position: sticky;\n    top: 93px;\n}\n.rightPaneBody {\n    padding: 0;\n    width: 100%;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n}\n.step {\n    display: none;\n    flex-direction: column;\n}\n.step .stepHeader {\n    width: 100%;\n    margin: 0;\n    font-size: 22px;\n    font-weight: 600;\n    text-transform: uppercase;\n    position: relative;\n    padding: 0;\n}\n/* .step .stepHeader::before {content: '';position: absolute;left: 0;bottom: 0;width: 44px;height: 4px;background: #5cae48;border-radius: 5px;}*/\n.step_img {\n    margin: 0;\n}\n.step_img img {\n    width: inherit;\n}\n.step p {\n    width: 100%;\n    margin: 0;\n    font-size: 18px;\n}\n.listed_points {\n    margin-top: 20px;\n}\n.step_header_wrap_link {\n    display: none;\n}\n.listed_points ul {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n}\n.listed_points ul li {\n    position: relative;\n    margin-bottom: 15px;\n    font-size: 20px;\n    font-weight: 400;\n    line-height: 22px;\n    padding: 0 0 0 10px;\n}\n.listed_points ul li:before {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 0px;\n    width: 3px;\n    height: 20px;\n    background: #27a7df;\n    border-radius: 15px;\n}\n.listed_points ul.beige-line li:before {\n    background: #f8b018 !important;\n}\n.listed_points ul.purple-line li:before {\n    background: #51499c !important;\n}\n.listed_points ul.orange-line li:before {\n    background: #f05a2a !important;\n}\n.listed_points ul.green-line li:before {\n    background: #5cae48 !important;\n}\n.listed_points ul.pink-line li:before {\n    background: #ee4c61 !important;\n}\n.undergraduate-college .listed_points ul li::before {\n    background: #f8b018;\n}\n.rightPane.basic-information .step_1 {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n}\n.rightPane.undergraduate-college .step_2 {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n}\n.steps {\n    /*height: 0px;opacity: 0;overflow: hidden;*/\n    transition: all 1s ease-in-out;\n    -webkit-transition: all 1s ease-in-out;\n    -moz-transition: all 1s ease-in-out;\n    -ms-transition: all 1s ease-in-out;\n    -o-transition: all 1s ease-in-out;\n}\n.steps.showTab {\n    height: auto;\n    opacity: 1;\n}\n.action_btns #viewcareersbtn {\n    display: none;\n}\n.steps_questions {\n    padding: 0 0 0 0px;\n    margin-top: 0px; /* left: -50px; */\n    position: relative; /* opacity: 0; */\n    transition: all 1s ease-in-out;\n    -webkit-transition: all 1s ease-in-out;\n    -moz-transition: all 1s ease-in-out;\n    -ms-transition: all 1s ease-in-out;\n    -o-transition: all 1s ease-in-out;\n    max-width: 640px;\n}\n.steps.showTab .steps_questions {\n    /* left: 0px;opacity: 1; */\n}\n.steps_questions h2 {\n    font-size: 22px;\n    font-weight: 800; /* margin-left: 50px; */ /* opacity: 0; */\n    transition: all 0.3s ease-in-out;\n}\n.steps.showTab h2 {\n    margin-left: 0px;\n    opacity: 1;\n}\n.steps_questions h2 span {\n    position: relative;\n}\n.steps_questions h2 span:before {\n    content: '';\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    width: 0;\n    height: 2px;\n    background: #5dae48;\n    border-radius: 5px;\n    transition: all 0.5s ease-in-out;\n    -webkit-transition: all 0.5s ease-in-out;\n    -moz-transition: all 0.5s ease-in-out;\n    -ms-transition: all 0.5s ease-in-out;\n    -o-transition: all 0.5s ease-in-out;\n}\n.steps_questions h2 span:before {\n    width: 100%;\n}\n.steps_questions .form-control {\n    margin-bottom: 0;\n}\n.steps.showTab h2 {\n    opacity: 1;\n    margin-left: 0;\n}\n.question_wrap {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n}\n.question_number {\n    margin-right: 10px;\n    display: none;\n}\n.question_number span {\n    width: 33px;\n    height: 33px;\n    border: 2px solid #dddddd;\n    border-radius: 50%;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 14px;\n    font-weight: 500;\n    color: #000;\n}\n.question .form-label {\n    font-size: 18px;\n    font-weight: 500;\n    margin-top: 3px;\n    margin-bottom: 3px;\n}\n.question .form-label .info {\n    width: 20px;\n    height: 20px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    background: #656565;\n    border: 1px solid #656565;\n    border-radius: 50%;\n    font-style: italic;\n    font-family: initial;\n    font-weight: 600;\n    font-size: 12px;\n    color: #fff;\n}\n.question {\n    width: 100%;\n    position: relative;\n}\n.main-wrap .form-control {\n    max-width: 100%;\n    height: 45px;\n    border: 1px solid #b5c2cb;\n    border-radius: 6px;\n    line-height: 30px;\n}\n.profile_wrap textarea.form-control {\n    margin-bottom: 20px;\n}\n.flex-fill.form-control {\n    z-index: inherit;\n}\n.input-group-text {\n    border-color: #b5c2cb;\n}\n.main-wrap .small-text {\n    color: #0b3454;\n    font-size: 15px;\n}\n.main-wrap .form-select {\n    max-width: 100%;\n    height: 45px;\n    border: 1px solid #b5c2cb;\n    border-radius: 6px;\n}\n.form-check-input + label.gap-switch {\n    background: #fff;\n    padding: 5px;\n    border-radius: 25px;\n    position: relative;\n    width: 100px;\n    height: 40px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    align-items: center;\n    cursor: pointer;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    border: 2px solid #f34e65;\n    color: #f34e65;\n}\n.form-check-input:checked + label.gap-switch {\n    background: #5dae48;\n    border-color: #5dae48;\n}\n.form-check-input + label.gap-switch:before {\n    width: 24px;\n    height: 24px;\n    display: inline-block;\n    background: #f34e65;\n    border-radius: 50%;\n    content: '';\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.form-check-input:checked + label.gap-switch::before {\n    transform: translateX(62px);\n    -webkit-transform: translateX(62px);\n    -moz-transform: translateX(62px);\n    -ms-transform: translateX(62px);\n    -o-transform: translateX(62px);\n    background: #fff;\n}\n.form-check-input + label.gap-switch:after {\n    content: 'NO';\n    color: #f34e65;\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    text-align: center;\n    font-weight: 500;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.form-check-input:checked + label.gap-switch::after {\n    transform: translateX(-30px);\n    content: 'YES';\n    -webkit-transform: translateX(-30px);\n    -moz-transform: translateX(-30px);\n    -ms-transform: translateX(-30px);\n    -o-transform: translateX(-30px);\n    color: #fff;\n}\n.action_btns {\n    max-width: 650px;\n    background: #f5faff;\n    padding: 20px;\n    border-radius: 5px;\n    margin: 35px 0 0 0px;\n    text-align: center;\n}\n.form-switch .form-check-input:focus,\n.form-switch .form-check-input {\n    --bs-form-switch-bg: url('data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23F34E65%27/%3e%3c/svg%3e');\n    border: 2px solid #f34e65;\n    cursor: pointer;\n}\n.form-check-input:checked {\n    background-color: #29a745;\n    border-color: #29a745;\n}\n.form-switch .form-check-input:checked:focus {\n    --bs-form-switch-bg: url('data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23FFFFFF%27/%3e%3c/svg%3e');\n    border: 2px solid #29a745;\n}\n.action_btns button.nextbtn {\n    padding: 0px 30px;\n    font-size: 1.5em;\n    width: 180px;\n    cursor: pointer;\n    border: 0px;\n    position: relative;\n    margin: auto;\n    transition: all 0.25s ease;\n    background: #0b3454;\n    color: #fff;\n    overflow: hidden;\n    border-radius: 25px;\n    height: 45px;\n    text-transform: uppercase;\n    font-size: 16px;\n    font-weight: 500;\n    letter-spacing: 1px;\n}\n.load {\n    position: absolute;\n    left: 0px;\n    top: 0px;\n    width: 100%;\n    height: 100%;\n    background: inherit;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: inherit;\n    -webkit-border-radius: inherit;\n    -moz-border-radius: inherit;\n    -ms-border-radius: inherit;\n    -o-border-radius: inherit;\n}\n.load::after {\n    content: '';\n    position: absolute;\n    border-radius: 50%;\n    border: 3px solid #fff;\n    width: 30px;\n    height: 30px;\n    border-left: 3px solid transparent;\n    border-bottom: 3px solid transparent;\n    animation: loading1 1s ease infinite;\n    -webkit-animation: loading1 1s ease infinite;\n    z-index: 10;\n}\n.load::before {\n    content: '';\n    position: absolute;\n    border-radius: 50%;\n    border: 3px dashed #fff;\n    width: 30px;\n    height: 30px;\n    border-left: 3px solid transparent;\n    border-bottom: 3px solid transparent;\n    animation: loading1 2s linear infinite;\n    -webkit-animation: loading1 2s linear infinite;\n    z-index: 5;\n}\n@keyframes loading1 {\n    0% {\n        transform: rotate(0deg);\n        -webkit-transform: rotate(0deg);\n        -moz-transform: rotate(0deg);\n        -ms-transform: rotate(0deg);\n        -o-transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n        -webkit-transform: rotate(360deg);\n        -moz-transform: rotate(360deg);\n        -ms-transform: rotate(360deg);\n        -o-transform: rotate(360deg);\n    }\n}\n.float_horizontal_animate {\n    transform: translatex(0px);\n    animation: float_horizontal 4s ease-in-out infinite;\n    -webkit-animation: float_horizontal 4s ease-in-out infinite;\n    -webkit-transform: translatex(0px);\n    -moz-transform: translatex(0px);\n    -ms-transform: translatex(0px);\n    -o-transform: translatex(0px);\n}\n@keyframes float_horizontal {\n    0% {\n        transform: translatex(0px);\n        -webkit-transform: translatex(0px);\n        -moz-transform: translatex(0px);\n        -ms-transform: translatex(0px);\n        -o-transform: translatex(0px);\n    }\n    50% {\n        transform: translatex(-10px);\n        -webkit-transform: translatex(-10px);\n        -moz-transform: translatex(-10px);\n        -ms-transform: translatex(-10px);\n        -o-transform: translatex(-10px);\n    }\n    100% {\n        transform: translatex(0px);\n        -webkit-transform: translatex(0px);\n        -moz-transform: translatex(0px);\n        -ms-transform: translatex(0px);\n        -o-transform: translatex(0px);\n    }\n}\nbutton .loading {\n    opacity: 0;\n    visibility: hidden;\n}\nbutton.activeLoading .loading {\n    visibility: visible;\n    opacity: 1;\n}\n.question .form-select.max-100 {\n    max-width: 100%;\n}\n.check_box {\n    background: #f5f7f8;\n    border-radius: 6px;\n    min-height: 48px;\n    padding: 12px 20px 10px;\n    margin: 20px 0 -35px 0;\n    max-width: 640px;\n}\n.check_box .form-check-input {\n    width: 20px;\n    height: 20px;\n    vertical-align: top;\n    display: inline-block;\n    margin-top: 0.5px;\n    border: 1px solid #0b3454cc;\n}\n.check_box .form-check-input:checked {\n    background-color: #5dae48;\n    border-color: #5dae48;\n}\n.check_box .form-check-input:focus {\n    box-shadow: none;\n}\n.datewrap {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    background: #ffffff;\n    border: 1px solid #b5c2cb;\n    border-radius: 6px;\n    height: 45px;\n    position: relative;\n    overflow: hidden;\n}\n.daterangePickerList,\n.singledaterangePickerList {\n    width: 100%;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    top: 0;\n    right: 0;\n    margin: auto;\n    cursor: pointer;\n    opacity: 0;\n}\n.datewrap .arrow {\n    background: #f1f1f1;\n    width: 45px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.datewrap .from,\n.datewrap .to {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n}\n.form-control[type='date'] {\n    background: #fff url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/calender.svg) no-repeat right\n        10px center;\n    text-align: left;\n    padding-right: 5px;\n    position: relative;\n}\n.form-control[type='date']::-webkit-calendar-picker-indicator,\n.form-control[type='date']::-moz-calendar-picker-indicator {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    width: auto;\n    height: auto;\n    color: transparent;\n    background: transparent;\n}\n.form-control.form-date {\n    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/calender.svg);\n    background-position: center right 15px;\n    background-repeat: no-repeat;\n}\n.form-control.form-search {\n    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/search.svg);\n    background-size: 14px;\n    background-repeat: no-repeat;\n    background-position: 13px center;\n    padding-left: 34px;\n}\n.form-control.form-linkedin {\n    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/linkedin.svg);\n    background-size: 20px;\n    background-repeat: no-repeat;\n    background-position: 13px center;\n    padding-left: 48px;\n}\n.form-control.form-facebook {\n    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/facebook.svg);\n    background-size: 20px;\n    background-repeat: no-repeat;\n    background-position: 13px center;\n    padding-left: 48px;\n}\n.form-control.form-instagram {\n    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/instagram.svg);\n    background-size: 20px;\n    background-repeat: no-repeat;\n    background-position: 13px center;\n    padding-left: 48px;\n}\n.form-control.form-twitter {\n    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/twitter.svg);\n    background-size: 20px;\n    background-repeat: no-repeat;\n    background-position: 13px center;\n    padding-left: 48px;\n}\n.datepicker {\n    max-width: 280px;\n    width: 100%;\n    padding: 0;\n}\n.datepicker-years {\n    overflow: hidden;\n    border-radius: 5px;\n}\n\n.react-datepicker-cnt > div,\n.react-datepicker-cnt > div > div {\n    width: 100%;\n}\n.react-datepicker-cnt {\n    position: relative;\n}\n.react-datepicker-cnt .form-control.form-date {\n    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/calender.svg) !important;\n    background-position: center right 15px !important;\n    background-repeat: no-repeat;\n}\n.datepicker .table-condensed {\n    width: 100%;\n}\n.datepicker table tr td span {\n    height: auto;\n    line-height: 35px;\n    border-radius: 25px;\n}\n.datepicker thead {\n    background: #f4faff;\n    line-height: 40px;\n}\n.datepicker table tr td span.active.active {\n    background: #5dae48;\n}\n.prev {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e\");\n    background-repeat: no-repeat !important;\n    background-position: center !important;\n    background-size: 16px 12px !important;\n    font-size: 0;\n    width: 50px !important;\n}\n.opacity-0 {\n    opacity: 0;\n}\n.next {\n    background-image: url(\"data:; image/svg+xml,%3csvgxmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e\");\n    background-repeat: no-repeat !important;\n    background-position: center !important;\n    background-size: 16px 12px !important;\n    font-size: 0;\n    width: 50px !important;\n    transform: scaleX(-1);\n    -webkit-transform: scaleX(-1);\n    -moz-transform: scaleX(-1);\n    -ms-transform: scaleX(-1);\n    -o-transform: scaleX(-1);\n}\n.datepicker .datepicker-switch {\n    font-size: 16px;\n    font-weight: 500;\n    letter-spacing: 5px;\n}\n.form-check.custom-rectbox-radio .form-check-input + label {\n    width: 100%;\n    height: 45px;\n    font-weight: 500;\n    border: 1px solid #b9c2cb;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border-radius: 5px;\n    padding: 0 14px;\n    position: relative;\n    cursor: pointer;\n    transition: all 0.3s;\n    -webkit-transition: all 0.3s;\n    -moz-transition: all 0.3s;\n    -ms-transition: all 0.3s;\n    -o-transition: all 0.3s;\n}\n.form-check.custom-rectbox-radio .form-check-input:checked + label {\n    background: #5dae48;\n    border: 1px solid #5dae48;\n    color: #fff;\n}\n.custom-rectbox-radio {\n    padding: 0;\n    margin: 0;\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n}\n.custom-rectbox-radio:not(:last-child) {\n    margin-right: 8px;\n}\n.radio_parent {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n}\n.form-check.custom-rectbox-radio .form-check-input + label:before {\n    content: '';\n    position: absolute;\n    right: 10px;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    width: 24px;\n    height: 24px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/male_icon.svg) no-repeat center;\n}\n.form-check.custom-rectbox-radio .form-check-input + label[for='female']:before {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/female_icon.svg) no-repeat center;\n}\n.form-check.custom-rectbox-radio .form-check-input:checked + label::before {\n    filter: invert(1) brightness(100);\n    -webkit-filter: invert(1) brightness(100);\n}\n.step_header_wrap {\n    display: none;\n}\n.header_container {\n    max-width: 1500px;\n    margin: auto;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 25px 0px;\n    width: 96%;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n}\n.ful-header {\n    border-bottom: 1px solid #e2e8ef;\n    position: sticky;\n    top: 0;\n    background: #fff;\n    z-index: 1;\n}\n.header_container .user_name {\n    font-size: 20px;\n}\n.rightSection_header {\n    position: relative;\n}\n.global_wrap {\n    position: relative;\n    margin-left: auto;\n    height: 100%;\n    margin-right: 0px;\n}\n.global_wrap .global {\n    right: 0;\n    top: 0px;\n    bottom: auto;\n}\n.scholarship_banner {\n    background: transparent linear-gradient(262deg, #fffdf8 0%, #fef6e4 76%, #feeccb 100%);\n    width: 100%;\n    height: 100%;\n}\n.scholarship_container {\n    max-width: 1066px;\n    width: 90%;\n    margin: auto;\n    padding-top: 0px;\n}\n.scholarship_container h2 {\n    font-size: 22px;\n    font-weight: 600;\n    margin-top: 55px;\n}\n.scholarship_container h2 span {\n    position: relative;\n}\n.scholarship_container h2 span:before {\n    content: '';\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    width: 100%;\n    height: 2px;\n    background: #5cae48;\n    border-radius: 5px;\n    transition: all 0.5s ease-in-out;\n    -webkit-transition: all 0.5s ease-in-out;\n    -moz-transition: all 0.5s ease-in-out;\n    -ms-transition: all 0.5s ease-in-out;\n    -o-transition: all 0.5s ease-in-out;\n}\n.scholarship_detail_list {\n    margin: 24px 0 20px 0;\n    padding: 0;\n    list-style: none;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    font-size: 18px;\n    font-weight: 500;\n    line-height: 22px;\n}\n.scholarship_detail_list li:not(:last-child) {\n    margin-right: 30px;\n}\n.scholarship_detail_list li {\n    position: relative;\n    padding-left: 27px;\n    margin-bottom: 16px;\n}\n.scholarship_detail_list li:before {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 2px;\n    width: 20px;\n    height: 18px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/tick.svg) no-repeat 0 0;\n}\n.scholarship_detail_carousel_container {\n    max-width: 1066px;\n    margin: auto;\n    width: 90%;\n}\n.scholarship_detail_carousel {\n    width: 100%;\n    padding: 40px 0;\n}\n.joined_offer_wrap {\n    position: relative;\n    margin-left: 0;\n    margin-bottom: 15px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n}\n.joined_offer_wrap:before {\n    content: '';\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    left: 0;\n    right: 0;\n    background: #5cae48;\n    height: 1px;\n}\n.joined_label {\n    position: relative;\n    background: #5cae48;\n    border-radius: 16px;\n    height: 32px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    color: #fff;\n    font-weight: 400;\n    padding: 7px 20px 7px 7px;\n    font-size: 14px;\n}\n.joined_label i {\n    width: 20px;\n    height: 20px;\n    display: inline-block;\n    background: #fff;\n    border-radius: 50%;\n    margin-right: 7px;\n    position: relative;\n}\n.joined_label i:before {\n    content: '';\n    position: absolute;\n    width: 10px;\n    height: 5px;\n    border-left: 2px solid #5cae48;\n    border-bottom: 2px solid #5cae48;\n    transform: rotate(-45deg);\n    -webkit-transform: rotate(-45deg);\n    -moz-transform: rotate(-45deg);\n    -ms-transform: rotate(-45deg);\n    -o-transform: rotate(-45deg);\n    left: 5px;\n    top: 7px;\n}\n.joined_label_noline:before {\n    display: none !important;\n}\n.w-65 {\n    width: 65%;\n}\n.offered-univarsity-name {\n    font-size: 28px;\n    line-height: 32px;\n    font-weight: 700;\n}\n.joined_label.didnt-join {\n    background: #0b3454;\n}\n.joined_label.didnt-join i:before {\n    border-left: 2px solid #0b3454;\n    border-bottom: 2px solid #0b3454;\n}\n.joined_offer_wrap.didnt-join:before {\n    background: #0b3454;\n}\n.scholarship_block {\n    width: 350px;\n}\n.card_profiles {\n    background: transparent linear-gradient(144deg, #edebff 0%, #f6f5ff 100%);\n    border-radius: 6px;\n    padding: 1px;\n    height: auto;\n    max-height: initial;\n    min-height: initial;\n}\n.card_profiles_pink {\n    background: transparent linear-gradient(145deg, #ffe8eb 0%, #fff8f9 100%) !important;\n}\n.card_profiles:first-child {\n    margin: 0 0 10px;\n}\n.card_profiles .card_profiles_univarsity {\n    padding: 19px 19px 13px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n}\n.card_profiles .card_profiles_univarsity .card_profiles_name {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    align-items: center;\n}\n.card_profiles .card_profiles_univarsity .card_profiles_name .student_detail {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n}\n.card_profiles .card_profiles_univarsity .card_profiles_name > a {\n    border-radius: 50%;\n    overflow: hidden;\n    margin-right: 12px;\n    width: 70px;\n    height: 70px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.card_profiles .card_profiles_univarsity .card_profiles_name a img {\n    width: auto;\n    height: 100%;\n}\n.card_profiles .card_profiles_univarsity .card_profiles_name .student_detail h2 {\n    font-size: 22px;\n    font-weight: 600;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n}\n.card_profiles .card_profiles_univarsity .card_profiles_name .student_detail h2 a {\n    border-radius: 0;\n    text-decoration: none;\n    color: #000;\n}\n.card_profiles .card_profiles_univarsity .card_profiles_name .student_detail h2 span {\n    font-size: 15px;\n    font-weight: 500;\n    margin-top: 5px;\n    color: #0b3454;\n}\n.carousel-indicators .dot {\n    width: 10px;\n    height: 10px;\n    background: #0b34541a;\n    border-radius: 50%;\n    margin: 0 4px;\n    padding: 0 !important;\n    border: 0;\n}\n.carousel-indicators .dot.active {\n    background: #0b3454b3;\n}\n.scholarship_block > h3 {\n    text-align: center;\n    font-size: 16px;\n    font-weight: 500;\n    margin: 0 0 10px;\n}\n.scholarship_block > h3 span {\n    font-size: 18px;\n    font-weight: 600;\n    display: block;\n}\n.scholarship_amt_detail {\n    background: #ffffff;\n    border-radius: 0px 0px 6px 6px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 20px;\n    -webkit-border-radius: 0px 0px 6px 6px;\n    -moz-border-radius: 0px 0px 6px 6px;\n    -ms-border-radius: 0px 0px 6px 6px;\n    -o-border-radius: 0px 0px 6px 6px;\n}\n.scholarship_amt {\n    font-size: 24px;\n    font-weight: 700;\n}\n.scholarship_label {\n    font-size: 16px;\n    font-weight: 500;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n}\n.scholarship_label i {\n    width: 37px;\n    height: 25px;\n    display: inline-block;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/scholarships-hat.jpg) no-repeat 0 0;\n    margin-right: 10px;\n}\n.univarsity-block {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    margin-top: 3px;\n}\n.univarsity-block .univarsity-block-cover {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    max-width: 255px;\n    width: 100%;\n}\n.card_profiles .card_profiles_univarsity .card_profiles_name a img {\n    width: auto;\n    height: 100%;\n}\n.univarsity-block .univarsity-block-cover > a {\n    width: 67px;\n    height: 67px;\n    background: #fff;\n    border-radius: 50%;\n    overflow: hidden;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 10px;\n    border: 1px solid #ddd;\n    margin-right: 10px;\n}\n.univarsity-block .univarsity-block-cover > a img {\n    width: auto;\n    height: 100%;\n}\n.univarsity-block .univarsity-block-cover h3 {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    margin: 0;\n}\n.univarsity-block .univarsity-block-cover h3 p {\n    font-size: 16px;\n    font-weight: 500;\n    margin: 0 0 3px;\n}\n.univarsity-block .univarsity-block-cover h3 p a {\n    text-decoration: none;\n    color: #000;\n}\n.univarsity-block .univarsity-block-cover h3 .course {\n    font-size: 15px;\n    font-weight: 500;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    align-items: start;\n}\n.univarsity-block .univarsity-block-cover h3 .course .img-fluid {\n    width: 16px;\n    margin-right: 7px;\n    margin-top: 1px;\n}\n.univarsity-block .univarsity-block-cover h3 .course span {\n    width: calc(100% - 23px);\n}\n.scholarship_carousel .owl-dots {\n    display: flex;\n    justify-content: center;\n    margin: 15px;\n}\n.scholarship_carousel .owl-dots .owl-dot {\n    width: 8px;\n    height: 8px;\n    background: #0b34541a;\n    border-radius: 50%;\n    margin: 0 4px;\n}\n.scholarship_carousel .owl-dots .owl-dot.active {\n    background: #0b3454b3;\n}\n#skip_pop .modal-dialog {\n    max-width: 600px;\n    border-radius: 10px;\n}\n#skip_pop .modal-content {\n    border-radius: 10px;\n}\n#skip_pop .modal-dialog .modal-body {\n    padding: 40px 0 0 50px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    border-radius: 10px;\n    min-height: 300px;\n}\n.img_pop {\n    position: relative;\n    z-index: 1;\n    float: right;\n}\n#skip_pop .modal-dialog .modal-body h4 {\n    font-size: 22px;\n    font-weight: 600;\n    position: relative;\n    text-transform: uppercase;\n}\n#skip_pop .modal-dialog .modal-body h4::before {\n    content: '';\n    position: absolute;\n    bottom: -17px;\n    width: 50px;\n    height: 3px;\n    background: #5cae48;\n    border-radius: 5px;\n}\n#skip_pop .modal-dialog .modal-body p {\n    font-size: 20px;\n    line-height: 28px;\n    max-width: 318px;\n    margin: 40px 0 0;\n    font-weight: 500;\n}\n#skip_pop .img_pop {\n    position: relative;\n    z-index: 1;\n    float: right;\n    margin-top: -30px;\n    width: 220px;\n    text-align: right;\n    display: flex;\n    align-items: end;\n}\n#skip_pop .modal-footer {\n    background: transparent linear-gradient(261deg, #fdfeff 0%, #eff7ff 16%, #d4ffc9 100%);\n    border-radius: 90px 10px 10px 10px;\n    -webkit-border-radius: 90px 10px 10px 10px;\n    -moz-border-radius: 90px 10px 10px 10px;\n    -ms-border-radius: 90px 10px 10px 10px;\n    -o-border-radius: 90px 10px 10px 10px;\n    opacity: 1;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: start;\n    padding-left: 70px;\n    border: 0;\n    min-height: 90px;\n    position: relative;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    margin-top: -90px;\n}\n.btn-goback {\n    background: #5cae48;\n    border-radius: 31px;\n    width: 158px;\n    height: 50px;\n    color: #fff;\n    font-weight: 500;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    text-decoration: none;\n    -webkit-border-radius: 31px;\n    -moz-border-radius: 31px;\n    -ms-border-radius: 31px;\n    -o-border-radius: 31px;\n}\n.btn-goback:hover {\n    background: #27970b;\n    color: #fff;\n}\n.btn-later {\n    font-size: 14px;\n    font-weight: 500;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.btn-later:hover {\n    color: #f34e65;\n}\n.btn-skip {\n    margin: 15px;\n    font-size: 12px;\n    text-decoration: navajowhite;\n    font-weight: 500;\n    color: #000;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    background: no-repeat;\n    border: 0;\n}\n.btn-skip:hover {\n    color: #d42941;\n}\n.modal-backdrop.show {\n    opacity: 0.8;\n}\n.multiple_benefits_banner {\n    background: transparent linear-gradient(262deg, #fdfeff 0%, #eff7ff 76%, #dbf1ff 100%);\n    width: 100%;\n    padding-top: 24px;\n}\n.multiple_benefits_container {\n    max-width: 990px;\n    margin: auto;\n    width: 90%;\n}\n.multiple_benefits_container h2 {\n    font-size: 22px;\n    font-weight: 600;\n    position: relative;\n    margin: 37px 0 25px;\n    line-height: 24px;\n}\n.multiple_benefits_container h2:before {\n    content: '';\n    position: absolute;\n    width: 40px;\n    height: 3px;\n    background: #5cae48;\n    left: 0;\n    bottom: -5px;\n}\n.multiple_benefits_container p {\n    font-size: 18px;\n    font-weight: 500;\n    line-height: 22px;\n    max-width: 490px;\n}\n.multiple_benefits_cards_container {\n    max-width: 990px;\n    width: 90%;\n    margin: auto;\n}\n.multiple_benefits_cards {\n    width: 100%;\n    padding: 30px 0;\n}\n.multiple_benefits_cards_container .card {\n    border: 0;\n    border-radius: 6px; /* overflow: hidden; */\n    height: 100%;\n}\n.multiple_benefits_cards_container .card.network-card {\n    background: #fff7f8;\n}\n.multiple_benefits_cards_container .card.event-card {\n    background: #f9f8ff;\n}\n.multiple_benefits_cards_container .card .card-header {\n    padding: 18px 40px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    min-height: 144px;\n}\n.multiple_benefits_cards_container .card .card-header .title {\n    font-size: 20px;\n    line-height: 22px;\n    flex: 1;\n    color: #fff;\n}\n.multiple_benefits_cards_container .card .card-header .card-img {\n    width: auto;\n}\n.multiple_benefits_cards_container .card.network-card .card-header {\n    background: #d42941;\n}\n.multiple_benefits_cards_container .card.event-card .card-header {\n    background: #51499c;\n}\n.multiple_benefits_cards_container .card .card-body {\n    padding: 0;\n}\n.card .card-body .benefits_toggle {\n    border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n}\n.card.network-card .card-body .benefits_toggle {\n    background: #fce4e7;\n}\n.card.event-card .card-body .benefits_toggle {\n    background: #e8e7f0;\n}\n.multiple_benefits_cards_container .card .card-body .benefits_toggle .btn {\n    width: 100%;\n    border-radius: 0;\n    min-height: 56px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    padding: 15px 20px 15px 30px;\n    font-weight: 500;\n    font-size: 18px;\n    color: #000;\n    border: 0;\n    justify-content: space-between;\n}\n.benefits_toggle .btn:focus {\n    box-shadow: none;\n}\n.benefits_toggle .toggle {\n    width: 15px;\n    height: 15px;\n    position: relative;\n}\n.benefits_toggle .toggle::before {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    width: 15px;\n    height: 3px;\n    background: #000;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.benefits_toggle .toggle::after {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    width: 3px;\n    height: 15px;\n    background: #000;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.benefits_toggle .btn[aria-expanded='true'] .toggle::after {\n    transform: rotate(90deg);\n    -webkit-transform: rotate(90deg);\n    -moz-transform: rotate(90deg);\n    -ms-transform: rotate(90deg);\n    -o-transform: rotate(90deg);\n}\n.multiple_benefits_cards_container .card.network-card .card-body .benefits_toggle .btn {\n    background: #fce4e7;\n}\n.benefit-list {\n    padding: 0px 30px 26px;\n}\n.multiple_benefits_cards_container .card .card-body .benefit_form {\n    padding: 20px 30px 40px;\n}\n.benefit-list ul {\n    padding: 0;\n    margin: 0;\n    list-style: none;\n    font-size: 18px;\n    line-height: 22px;\n}\n.benefit-list ul li {\n    padding-left: 25px;\n    position: relative;\n    margin-bottom: 10px;\n}\n.benefit-list ul li:before {\n    content: '';\n    position: absolute;\n    width: 12px;\n    height: 6px;\n    border-left: 2px solid #000;\n    border-bottom: 2px solid #000;\n    transform: rotate(-45deg);\n    left: 0;\n    top: 7px;\n    -webkit-transform: rotate(-45deg);\n    -moz-transform: rotate(-45deg);\n    -ms-transform: rotate(-45deg);\n    -o-transform: rotate(-45deg);\n}\n.video-btn {\n    background: #0b3454;\n    border-radius: 25px;\n    padding: 9px 20px;\n    display: inline-flex;\n    text-decoration: none;\n    color: #fff;\n    font-size: 16px;\n    font-weight: 500;\n    align-items: center;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    border: 0;\n    -webkit-border-radius: 25px;\n    -moz-border-radius: 25px;\n    -ms-border-radius: 25px;\n    -o-border-radius: 25px;\n}\n.video-btn b {\n    width: 16px;\n    height: 16px;\n    background: #fff;\n    border-radius: 50%;\n    margin: 0 0 0 7px;\n    display: inline-block;\n    font-size: 0;\n    position: relative;\n}\n.video-btn b::before {\n    content: '';\n    position: absolute;\n    top: 4px;\n    left: 5.5px;\n    margin: auto;\n    width: 0;\n    border-top: 4px solid transparent;\n    border-bottom: 4px solid transparent;\n    border-left: 5px solid #0b3454;\n    height: 0;\n}\n.video-btn:hover {\n    color: #fff;\n    background: #5bae47;\n}\n.video-btn:hover b::before {\n    border-left: 5px solid #5bae47;\n}\n.form-label {\n    font-size: 16px;\n    line-height: 22px;\n    font-weight: 500;\n    margin: 0 0 4px;\n}\n.select-option.first-option,\n.select-option.second-option {\n    position: relative;\n}\n.select-option.first-option .form-select,\n.select-option.second-option .form-select {\n    margin-bottom: 20px;\n}\n.form-check-input:checked ~ .select-option.first-option:after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    border-bottom: 1px solid #00000016;\n    width: 208%;\n    left: 0;\n}\n.form-check-input:checked ~ .select-option.second-option:after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    border-bottom: 1px solid #00000016;\n    width: 208%;\n    right: 0;\n}\n.benefit_form .form-check {\n    margin: 0;\n    padding: 0;\n}\n.benefit_form .form-check .form-check-input[role='switch'] {\n    margin-left: 0;\n}\n.custom_radius_check {\n    background: #ffffff;\n    border: 1px solid #0b3454;\n    border-radius: 25px;\n    width: 100%;\n    padding: 10px 20px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    font-size: 16px;\n    font-weight: 500;\n    justify-content: space-between;\n    position: relative;\n    cursor: pointer;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    -webkit-border-radius: 25px;\n    -moz-border-radius: 25px;\n    -ms-border-radius: 25px;\n    -o-border-radius: 25px;\n}\n.custom_radius_check i {\n    width: 17px;\n    height: 12px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/check-tick.svg) no-repeat 0 0;\n    filter: invert(76%) sepia(79%) saturate(0%) hue-rotate(131deg) brightness(94%) contrast(96%);\n    -webkit-filter: invert(76%) sepia(79%) saturate(0%) hue-rotate(131deg) brightness(94%) contrast(96%);\n}\n.select-option {\n    display: none;\n    width: 100%;\n    position: relative;\n}\n.form-check-input:checked ~ .select-option {\n    display: inline-block;\n}\n.select-option .form-select {\n    margin-top: 16px;\n    border: 1px solid #0b3454;\n    border-radius: 6px;\n    height: 42px;\n}\n.form-check-input:checked + .custom_radius_check {\n    background: #5cae48;\n    border-color: #5cae48;\n    color: #fff;\n}\n.form-check-input:checked + .custom_radius_check i {\n    filter: invert(1) brightness(1);\n    -webkit-filter: invert(1) brightness(1);\n}\n.custom_radius_check::after {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    border-right: 7px solid transparent;\n    border-left: 7px solid transparent;\n    border-top: 7px solid transparent;\n    width: 0;\n    margin: auto;\n    top: 85%;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    opacity: 0;\n}\n.form-check-input:checked + .custom_radius_check::after {\n    top: 100%;\n    border-top: 7px solid #5cae48;\n    opacity: 1;\n}\n.multiple_benefits_cards_container .action_btns {\n    max-width: 100%;\n    margin: 0;\n}\n.bg-drop {\n    display: none;\n}\nfooter.footer {\n    padding: 15px 0;\n    border-top: 1px solid #eee;\n    background: #fff;\n    position: relative;\n    height: auto;\n}\n.modal-open footer.footer{display: none;}\n.footer-wrap {\n    width: 90%;\n    margin: auto;\n    max-width: 1500px;\n}\n.powerby {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n    width: 139px;\n}\n.pop-dialog {\n    max-width: 700px;\n    width: 90%;\n    margin: auto;\n}\n.modal.show .modal-dialog .pop-content {\n    background: #ffffff;\n    border-radius: 10px;\n    width: 100%;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n}\n.pop-footer {\n    background: transparent linear-gradient(261deg, #fdfeff 0%, #eff7ff 16%, #d4ffc9 100%);\n    border-radius: 90px 0px 10px 10px;\n    opacity: 1;\n    padding: 20px 66px;\n    margin-left: 10px;\n    -webkit-border-radius: 90px 0px 10px 10px;\n    -moz-border-radius: 90px 0px 10px 10px;\n    -ms-border-radius: 90px 0px 10px 10px;\n    -o-border-radius: 90px 0px 10px 10px;\n}\n.pop-body {\n    min-height: 255px;\n    padding: 80px 50px 0;\n}\n.pop-body .img_pop {\n    position: absolute;\n    right: -38px;\n    bottom: 0;\n}\n.pop-dialog h4 {\n    font-size: 22px;\n    font-weight: 600;\n    position: relative;\n    margin: 0 0 35px;\n}\n.pop-dialog h4::before {\n    content: '';\n    position: absolute;\n    bottom: -12px;\n    width: 50px;\n    height: 3px;\n    background: #5cae48;\n    border-radius: 5px;\n}\n.pop-body p {\n    font-size: 18px;\n    font-weight: 500;\n    line-height: 22px;\n}\n.pop_step {\n    padding: 0;\n    margin: 40px 0 0;\n    list-style: none;\n}\n.pop_step li {\n    padding: 0 0 30px 53px;\n    line-height: 22px;\n    position: relative;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n    font-size: 18px;\n    font-weight: 500;\n}\n.pop_step li b {\n    font-size: 20px;\n    font-weight: 500;\n    margin-bottom: 7px;\n}\n.pop_step li .completed_li {\n    position: absolute;\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    background: #5cae48;\n    left: 0;\n    top: -7px;\n    margin: 0 8px;\n}\n.pop_step li .completed_li:before {\n    content: '';\n    position: absolute;\n    border-left: 3px solid #fff;\n    border-bottom: 3px solid #fff;\n    width: 12px;\n    height: 7px;\n    left: 6px;\n    top: 7px;\n    transform: rotate(-45deg);\n    -webkit-transform: rotate(-45deg);\n    -moz-transform: rotate(-45deg);\n    -ms-transform: rotate(-45deg);\n    -o-transform: rotate(-45deg);\n}\n.pop_step li .edit_li {\n    position: absolute;\n    width: 40px;\n    height: 40px;\n    background: #0b3454 url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/blue_edit.png) no-repeat\n        center;\n    left: 0;\n    top: 0;\n    border-radius: 50%;\n}\n.pop_step li.pop_completed::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 19px;\n    background: #5cae48;\n    width: 2px;\n    bottom: 0;\n    margin: auto;\n}\n.mentoring_contact i {\n    width: 36px;\n    height: 36px;\n    background: #27a7df;\n    display: flex;\n    border-radius: 60px;\n    align-items: center;\n    justify-content: center;\n}\n.btn-update {\n    border: none;\n    padding: 10px 30px;\n    background: #5cae48;\n    border-radius: 25px;\n    color: #ffff;\n    text-transform: uppercase;\n    font-weight: 500;\n    font-size: 14px;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.form-control {\n    max-width: 100%;\n    height: 45px;\n    border: 1px solid #b5c2cb;\n    border-radius: 6px;\n}\ntextarea.form-control {\n    min-height: 60px;\n}\n.btn-update:hover {\n    background: #43992e;\n}\n.edit_phone .btn-close {\n    font-size: 12px;\n}\n.btn-cancel {\n    background: none;\n    border: 0;\n    padding: 10px 5px;\n    border-radius: 25px;\n    margin-left: 10px;\n    font-weight: 500;\n    color: #828282;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.btn-cancel:hover {\n    color: #000;\n}\n\n@media (max-width: 1199px) {\n    /* .global {bottom: -60px;}\n */\n    .global.show .unlock {\n        white-space: normal;\n        width: 310px;\n    }\n    .global.show .unlock .text {\n        line-height: 17px;\n        font-size: 16px;\n    }\n    .cta_add {\n        flex-direction: column;\n    }\n    .cta_add .btn-add {\n        margin-bottom: 10px;\n    }\n}\n\n@media (max-width: 991px) {\n    .leftPaneBody {\n        padding: 0 50px;\n    }\n    .rightPaneBodyWrap {\n        padding: 50px 40px;\n    }\n    .action_btns button.nextbtn {\n        width: 150px;\n    }\n    .scholarship_block {\n        width: 100%;\n    }\n    .scholarship_carousel .item {\n        display: -webkit-box;\n        display: -moz-box;\n        display: -ms-flexbox;\n        display: -webkit-flex;\n        display: flex;\n        justify-content: space-between;\n    }\n    .scholarship_carousel .item .card_profiles {\n        width: 49%;\n        display: -webkit-box;\n        display: -moz-box;\n        display: -ms-flexbox;\n        display: -webkit-flex;\n        display: flex;\n        flex-direction: column;\n    }\n    .item-wrap {\n        display: -webkit-box;\n        display: -moz-box;\n        display: -ms-flexbox;\n        display: -webkit-flex;\n        display: flex;\n        -webkit-box-wrap: wrap;\n        -moz-box-wrap: wrap;\n        -ms-flex-wrap: wrap;\n        -webkit-wrap: wrap;\n        flex-wrap: wrap;\n        justify-content: space-between;\n    }\n    .item-wrap .card_profiles {\n        width: 49%;\n        margin: 0;\n    }\n}\n\n@media (min-width: 768px) and (max-width: 992.98px) {\n    .form-check-input:checked ~ .select-option.first-option::after {\n        content: '';\n        position: absolute;\n        bottom: 0;\n        border-bottom: 1px solid #00000016;\n        width: 208%;\n        left: -10%;\n    }\n    .form-check-input:checked ~ .select-option.second-option::after {\n        content: '';\n        position: absolute;\n        bottom: 0;\n        border-bottom: 1px solid #00000016;\n        width: 208%;\n        right: -10%;\n    }\n    .form-check-input:checked ~ .select-option.third-option::after {\n        content: '';\n        position: absolute;\n        bottom: 0;\n        border-bottom: 1px solid #00000016;\n        width: 208%;\n        left: -10%;\n    }\n    .select-option.third-option .form-select {\n        margin-bottom: 20px;\n    }\n}\n\n@media (max-width: 767px) {\n    .leftPane {\n        width: 100%;\n    }\n    .leftPaneBody {\n        max-width: 100%;\n        padding: 30px;\n    }\n    .leftPaneBodyWrap {\n        padding: 0px 0 50px;\n    }\n    .rightPane {\n        width: 100%;\n        box-shadow: 0px -7px 15px #00000026;\n        border-radius: 15px 15px 0px 0px;\n        padding: 45px 0px 0px 25px;\n        cursor: pointer;\n        position: fixed;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        z-index: 7;\n        display: none !important;\n    }\n    .rightPane.basic-information .rightPaneHeaderWrap {\n        display: none;\n    }\n    .rightPaneBodyWrap {\n        padding: 0;\n        position: static;\n    }\n    .rightPane.basic-information {\n        background: transparent linear-gradient(254deg, #fdfeff 0%, #eff7ff 76%, #dbf1ff 100%);\n    }\n    .rightPane.basic-information.undergraduate-college {\n        background: transparent linear-gradient(213deg, #fffdf8 0%, #fef6e4 76%, #feeccb 100%) !important;\n    }\n    .rightPane.basic-information .step_1 {\n        width: 100%;\n        flex-direction: row;\n        justify-content: space-between;\n        align-items: end;\n    }\n    .step_img img {\n        width: auto;\n        height: 128px;\n    }\n    .mobile-step-block[aria-expanded='true'] ~ .step_img {\n        position: absolute;\n        right: 0;\n        border: 0;\n        opacity: 0.2;\n    }\n    .textDetail {\n        -webkit-box-flex: 1;\n        -moz-box-flex: 1;\n        -webkit-flex: 1;\n        -ms-flex: 1;\n        flex: 1;\n    }\n    .action_btns {\n        max-width: 90%;\n        margin: auto;\n        width: 100%;\n    }\n    .action_btns.social {\n        margin: auto;\n    }\n    .custom-rectbox-radio {\n        flex: none;\n        width: 130px;\n    }\n    .step_header_wrap {\n        display: none !important;\n        -webkit-box-wrap: wrap;\n        -moz-box-wrap: wrap;\n        -ms-flex-wrap: wrap;\n        -webkit-wrap: wrap;\n        flex-wrap: wrap;\n        justify-content: space-between;\n        margin: 0;\n        position: fixed;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        z-index: 9;\n        background: transparent linear-gradient(254deg, #fdfeff 0%, #eff7ff 76%, #dbf1ff 100%);\n        box-shadow: 0px -7px 15px #00000026;\n        border-radius: 15px 15px 0px 0px;\n        padding: 45px 0px 0px 25px;\n        cursor: pointer;\n        transition: all 0.1s ease-in-out;\n        -webkit-transition: all 0.1s ease-in-out;\n        -moz-transition: all 0.1s ease-in-out;\n        -ms-transition: all 0.1s ease-in-out;\n        -o-transition: all 0.1s ease-in-out;\n        align-items: end;\n    }\n    .step_header_wrap_bg-beige {\n        background: transparent linear-gradient(213deg, #fffdf8 0%, #fef6e4 76%, #feeccb 100%) !important;\n    }\n    .step_header_wrap::before,\n    .rightPane::before {\n        content: '';\n        position: absolute;\n        left: 0;\n        right: 0;\n        width: 50px;\n        height: 2px;\n        background: #727272;\n        margin: auto;\n        top: 20px;\n    }\n    .step_header_wrap_img img {\n        height: 128px;\n    }\n    .step_header_wrap_title {\n        padding-top: 15px;\n        -webkit-box-flex: 1;\n        -moz-box-flex: 1;\n        -webkit-flex: 1;\n        -ms-flex: 1;\n        flex: 1;\n    }\n    .steps.showTab > h2 {\n        padding: 40px 40px 0;\n    }\n    .steps_questions {\n        /* padding: 0px 40px 40px; */\n        margin-top: 30px;\n        max-width: 100%;\n    }\n    .leftPaneHeaderWrap {\n        justify-content: center;\n        display: -webkit-box;\n        display: -moz-box;\n        display: -ms-flexbox;\n        display: -webkit-flex;\n        display: flex;\n        flex-direction: column;\n        height: auto;\n    }\n    .leftPaneHeader {\n        display: -webkit-box;\n        display: -moz-box;\n        display: -ms-flexbox;\n        display: -webkit-flex;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        width: 94%;\n        margin: auto;\n    }\n    .leftPaneHeader .user_name {\n        display: inline-block;\n        font-size: 18px;\n    }\n    .check_box {\n        margin: 20px auto -35px;\n        max-width: 680px;\n        width: 90%;\n    }\n    .step_header_wrap_title > h2 {\n        font-size: 18px;\n        font-weight: 600;\n        margin-right: 15px;\n    }\n    .step_header_wrap_link {\n        background: transparent;\n        border-radius: 27px;\n        color: #0b3454;\n        text-decoration: none;\n        padding: 3px 20px;\n        transition: all 0.3s ease-in-out;\n        display: inline-block;\n        margin-bottom: 18px;\n        font-weight: 500;\n        border: 2px solid #0b3454;\n        -webkit-transition: all 0.3s ease-in-out;\n        -moz-transition: all 0.3s ease-in-out;\n        -ms-transition: all 0.3s ease-in-out;\n        -o-transition: all 0.3s ease-in-out;\n        -webkit-border-radius: 27px;\n        -moz-border-radius: 27px;\n        -ms-border-radius: 27px;\n        -o-border-radius: 27px;\n        display: inline-block;\n        margin-top: 16px;\n    }\n    .step_header_wrap_link span {\n        transition: all 0.3s ease-in-out;\n    }\n    .step_header_wrap_link .less {\n        font-size: 0;\n    }\n    .step_header_wrap_link:hover {\n        background: #0b3454;\n        color: #fff;\n    }\n    .step_header_wrap.open .step_header_wrap_link {\n        margin-bottom: 20px;\n    }\n    .listed_points:not(.show) {\n        height: 0;\n        overflow: hidden;\n    }\n    .listed_points ul li {\n        font-size: 16px;\n        font-size: 16px;\n        margin-bottom: 15px;\n        line-height: 19px;\n    }\n    .listed_points ul li:last-child {\n        margin-bottom: 0;\n    }\n    .mobile-step-block {\n        position: absolute;\n        left: 0;\n        right: 0;\n        top: 0;\n        bottom: 0;\n        z-index: 9;\n    }\n    .mobile-step-block[aria-expanded='false'] + .step_header_wrap_title .step_header_wrap_link .more,\n    .mobile-step-block[aria-expanded='false'] + .textDetail .step_header_wrap_link .more {\n        font-size: 16px;\n    }\n    .mobile-step-block[aria-expanded='false'] + .step_header_wrap_title .step_header_wrap_link .less,\n    .mobile-step-block[aria-expanded='false'] + .textDetail .step_header_wrap_link .less {\n        font-size: 0;\n    }\n    .mobile-step-block[aria-expanded='true'] + .step_header_wrap_title .step_header_wrap_link .more,\n    .mobile-step-block[aria-expanded='true'] + .textDetail .step_header_wrap_link .more {\n        font-size: 0px;\n    }\n    .mobile-step-block[aria-expanded='true'] + .step_header_wrap_title .step_header_wrap_link .less,\n    .mobile-step-block[aria-expanded='true'] + .textDetail .step_header_wrap_link .less {\n        font-size: 16px;\n    }\n    .step_header_wrap_title .listed_points ul li::before {\n        height: 17px;\n    }\n    .global {\n        width: 100%;\n        height: 40px;\n        position: relative;\n        margin-bottom: -26px;\n        background: none;\n        border-radius: 0;\n        margin-top: 25px;\n        border-top: 1px solid #e2e8ef;\n        bottom: auto;\n        right: auto;\n    }\n    .global .unlock,\n    .global.show .unlock {\n        width: 100%;\n        right: 0;\n        bottom: 0;\n        border-radius: 0;\n        position: static;\n        opacity: 1;\n    }\n    .progress_svg {\n        width: 70px;\n        height: 70px;\n        position: absolute;\n        right: 30px;\n        top: auto;\n        bottom: 0px;\n        background: #fff;\n        padding: 0;\n        border-radius: 50%;\n        box-shadow: 0px 0px 10px 0 #d3d3d3;\n    }\n    .progress_svg .gaugeMeter {\n        width: 60px !important;\n        height: 60px;\n    }\n    .progress_svg .gaugeMeter canvas {\n        width: 100%;\n        height: 100%;\n    }\n    .progress_svg span {\n        line-height: 60px !important;\n        font-size: 18px !important;\n    }\n    .global_wrap {\n        width: 100%;\n        order: 1;\n    }\n    .global.show .unlock,\n    .global .unlock {\n        white-space: normal;\n    }\n    .global.show .unlock.prize_bg,\n    .global .unlock.prize_bg {\n        width: auto;\n        margin: 0 -2%;\n    }\n    .global.show .unlock .text,\n    .global .unlock .text {\n        width: calc(100% - 140px);\n    }\n    .global .unlock.unlock_blue {\n        border-radius: 0 !important;\n    }\n    .global .unlock .text {\n        font-size: 16px;\n        font-weight: 500;\n    }\n    .scholarship_carousel .item {\n        display: -webkit-box;\n        display: -moz-box;\n        display: -ms-flexbox;\n        display: -webkit-flex;\n        display: flex;\n        -webkit-box-wrap: wrap;\n        -moz-box-wrap: wrap;\n        -ms-flex-wrap: wrap;\n        -webkit-wrap: wrap;\n        flex-wrap: wrap;\n        justify-content: space-between;\n    }\n    .scholarship_block {\n        width: 100%;\n        margin-top: 15px;\n        margin-bottom: 30px;\n        position: relative;\n        z-index: 0;\n    }\n    .scholarship_carousel .item .card_profiles {\n        width: 48%;\n        margin: 0 0 10px;\n        display: -webkit-box;\n        display: -moz-box;\n        display: -ms-flexbox;\n        display: -webkit-flex;\n        display: flex;\n        flex-direction: column;\n    }\n    .scholarship_amt {\n        font-size: 18px;\n        font-weight: 700;\n    }\n    .scholarship_amt_detail {\n        padding: 20px 15px;\n    }\n    .bg-drop {\n        position: fixed;\n        left: 0;\n        right: 0;\n        top: 100%;\n        bottom: 0;\n        margin: auto;\n        background: rgba(0, 0, 0, 0.7);\n        z-index: 6;\n        transition: all 0.1s ease-in-out;\n        display: block;\n        -webkit-transition: all 0.1s ease-in-out;\n        -moz-transition: all 0.1s ease-in-out;\n        -ms-transition: all 0.1s ease-in-out;\n        -o-transition: all 0.1s ease-in-out;\n    }\n    .bg-drop[aria-expanded='true'] {\n        top: 0;\n    }\n    .mobile-step-block[aria-expanded='true'] ~ .step_header_wrap_img {\n        position: absolute;\n        right: 0;\n        border: 0;\n        opacity: 0.2;\n    }\n    .scholarship_detail_carousel {\n        padding: 0;\n    }\n    .leftPaneHeaderWrap .global.nobadge {\n        height: 0;\n    }\n    .leftPaneHeaderWrap .global.nobadge .progress_svg {\n        top: -30px;\n    }\n    .global_wrap .global.nobadge {\n        height: auto;\n        border: 0;\n    }\n    .global_wrap .global.nobadge .progress_svg {\n        top: -30px;\n    }\n    footer {\n        margin-bottom: 160px;\n    }\n    .pop-body .img_pop {\n        position: static;\n        width: 100%;\n        text-align: center;\n    }\n}\n\n@media (max-width: 575px) {\n    div#root > div {\n        overflow: hidden;\n    }\n    .ful-header + .main-wrap {\n        padding: 30px;\n    }\n    .leftPaneBody {\n        padding: 30px;\n    }\n    .listed_points {\n        margin-top: 10px;\n        margin-right: 15px;\n    }\n    .leftPaneHeader img {\n        width: 130px;\n    }\n    .header_container img {\n        width: 130px;\n    }\n    .step_header_wrap_title {\n        padding-top: 0;\n    }\n    .steps.showTab > h2 {\n        padding: 30px 25px 0;\n    }\n    .steps_questions {\n        /* padding: 0px 25px 30px; */\n    }\n    .action_btns {\n        max-width: 100%;\n        margin: 0 auto;\n        padding: 10px;\n    }\n    .step_header_wrap_img img {\n        height: 100px;\n        animation: none;\n        -webkit-animation: none;\n    }\n    .leftPaneHeader .user_name span {\n        font-weight: 600;\n        width: 100px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        display: inline-block;\n        vertical-align: top;\n    }\n    .global .unlock {\n        padding: 12px 0;\n    }\n    .global {\n        height: auto;\n    }\n    .global .unlock {\n        height: auto;\n    }\n    .progress_svg {\n        bottom: 10px;\n        right: 10px;\n    }\n    .global_wrap .progress_svg {\n        right: 0;\n        bottom: 5px;\n    }\n    .scholarship_carousel .item .card_profiles {\n        width: 100%;\n        margin: 0 0 10px;\n    }\n    .scholarship_detail_carousel_container {\n        width: 100%;\n        overflow: hidden;\n    }\n    .joined_offer_wrap {\n        margin-left: 0;\n    }\n    .scholarship_block {\n        width: 100%;\n        margin: auto;\n    }\n    .scholarship_detail_carousel {\n        padding: 0px 0 40px;\n    }\n    .global_wrap .global {\n        top: 0;\n        left: 0px;\n    }\n    .skip_pop .brife {\n        -webkit-box-flex: 1;\n        -moz-box-flex: 1;\n        -webkit-flex: 1;\n        -ms-flex: 1;\n        flex: 1;\n    }\n    #skip_pop .modal-footer {\n        margin: 0;\n    }\n    #skip_pop .modal-dialog .modal-body {\n        padding: 30px 0 0 30px;\n    }\n    .action_btns .btn-skip {\n        margin: 18px 18px 0;\n        display: inline-block;\n    }\n    #skip_pop .img_pop {\n        margin-top: 15px;\n        text-align: center;\n        width: 100%;\n        padding-right: 30px;\n    }\n    .form-check-input:checked ~ .select-option.first-option::after {\n        content: '';\n        position: absolute;\n        bottom: 0;\n        border-bottom: 1px solid #00000016;\n        width: 208%;\n        left: -10%;\n    }\n    .form-check-input:checked ~ .select-option.second-option::after {\n        content: '';\n        position: absolute;\n        bottom: 0;\n        border-bottom: 1px solid #00000016;\n        width: 208%;\n        right: -10%;\n    }\n    .form-check-input:checked ~ .select-option.third-option::after {\n        content: '';\n        position: absolute;\n        bottom: 0;\n        border-bottom: 1px solid #00000016;\n        width: 208%;\n        left: -10%;\n    }\n    .select-option.third-option .form-select {\n        margin-bottom: 20px;\n    }\n    .global.nobadge {\n        top: auto;\n        bottom: auto;\n        height: 20px;\n        border: 0;\n    }\n    .global.nobadge .progress_svg {\n        top: -23px;\n        bottom: auto;\n        right: 0;\n    }\n    .leftPaneHeaderWrap .global.nobadge .progress_svg {\n        right: 10px;\n        top: -23px;\n    }\n    .global.show .unlock.prize_bg,\n    .global .unlock.prize_bg,\n    .global .unlock.laststep_bg {\n        height: 50px;\n    }\n    .unlock.prize_bg .img,\n    .unlock.laststep_bg .img {\n        margin-bottom: -20px;\n    }\n    .leftPaneHeaderWrap .progress_svg {\n        top: -22px;\n    }\n    .global_wrap .global.nobadge .progress_svg {\n        top: -23px;\n    }\n    .global_wrap .global.nobadge {\n        padding: 10px;\n    }\n    .global .unlock.green_recom_bg {\n        padding: 7px 0;\n    }\n    .global .unlock.green_recom_bg .text {\n        width: calc(100% - 0px);\n        padding: 0 20px 0 0;\n    }\n    .global .unlock.unlock_blue {\n        padding: 0;\n    }\n    .pop-body {\n        padding: 30px 30px 0;\n    }\n    .edit_phone .btn-close {\n        font-size: 12px;\n        position: absolute;\n        top: 0px;\n        right: -10px;\n    }\n    .step_img img {\n        height: auto;\n        width: 125px;\n    }\n    .item-wrap .card_profiles {\n        width: 100%;\n        margin: 0 0 20px;\n    }\n    .pop-body .img_pop img {\n        width: 100%;\n        max-width: 210px;\n    }\n}\n\n@media (max-width: 400px) {\n    .global.show .unlock .text {\n        line-height: 16px;\n        font-size: 13px;\n    }\n}\n.cta_add {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    font-size: 16px;\n    font-weight: 500;\n}\n.cta_add .form-check label {\n    color: #0b3454;\n}\n.cta_add .form-check input {\n    border: 2px solid #0b3454;\n    width: 22px;\n    height: 22px;\n    border-radius: 40px;\n    margin-right: 10px;\n}\n.cta_add .form-check-input:checked {\n    background-color: #27970b;\n    border: 0 !important;\n}\n.cta_add .form-check label {\n    padding-top: 3px;\n    color: #0b3454;\n}\n.cta_add .btn-add {\n    color: #27a7df;\n    padding: 0 30px 0 0;\n    text-decoration: none;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n}\n.cta_add .btn-add:hover {\n    color: #5cae48;\n}\n.cta_add .btn-add i {\n    margin-right: 10px;\n    margin-top: -4px;\n}\n.cta_add .btn-add i path {\n    fill: #5cae48;\n    color: #5cae48;\n}\n.cta_add .btn-add:focus {\n    box-shadow: none;\n}\n.cta_add .btn-add:focus-visible {\n    border: none;\n    outline: none;\n}\n.cta_add .btn-add:hover i img {\n    filter: invert(54%) sepia(94%) saturate(312%) hue-rotate(63deg) brightness(93%) contrast(83%);\n    -webkit-filter: invert(54%) sepia(94%) saturate(312%) hue-rotate(63deg) brightness(93%) contrast(83%);\n}\n.btn-delete {\n    padding: 0;\n    width: 18px;\n    height: 18px;\n    position: absolute;\n    right: 100%;\n    top: 15px;\n    opacity: 0.4;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    background: transparent\n        url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23000'%3e%3cpath d='M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z'/%3e%3c/svg%3e\")\n        0 0 / 18px auto no-repeat;\n}\n.btn-delete:hover {\n    opacity: 1;\n}\n.form-label ~ .btn-delete {\n    top: 45px;\n}\n.section {\n    position: relative;\n    padding-right: 20px;\n}\n.section + .section {\n    margin-top: 60px;\n}\n.section:first-child {\n    margin-top: 20px;\n}\n.section .btn-delete {\n    top: 35px;\n    bottom: 0;\n    margin: auto;\n    right: -60px;\n}\n.section::after {\n    content: '';\n    position: absolute;\n    right: -2px;\n    top: 23px;\n    bottom: 0;\n    width: 1px;\n    height: calc(100% - 23px);\n    background: #e2e8ef;\n}\n\n@media (max-width: 767px) {\n    .cta_add {\n        display: block;\n    }\n    .cta_add .btn-add {\n        margin-bottom: 10px;\n    }\n    .section {\n        width: calc(100% - 25px);\n    }\n    .section .btn-delete {\n        right: -50px;\n    }\n}\n.font-18 {\n    font-size: 18px;\n}\n.mentoring_contact {\n    border: 1px solid #b5c1cb;\n    border-radius: 6px;\n}\n.mentoring_contact p {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    font-size: 18px;\n    font-weight: 500;\n}\n.mentoring_contact p i {\n    width: 36px;\n    height: 36px;\n    background: #27a7df;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    border-radius: 60px;\n    align-items: center;\n    justify-content: center;\n    margin-right: 10px;\n}\n.mentoring_contact p i img {\n    /* height: auto; */\n}\n.card_achievements {\n    text-align: center;\n}\n.card_achievements .card_profiles_name {\n    display: block !important;\n}\n.card_achievements .card_profiles_univarsity .card_profiles_name > a {\n    margin: 0 auto;\n    margin-bottom: -47px;\n    width: 80px;\n    height: 80px;\n    position: relative;\n    overflow: inherit; /* z-index: 9999; */\n}\n.card_achievements .scholarship_amt {\n    margin: 0 auto;\n    margin-top: 30px;\n    font-size: 18px;\n}\n.card_achievements .card_profiles_univarsity .card_profiles_name > a span {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/badge.svg) no-repeat center;\n    position: absolute;\n    left: 50%;\n    bottom: 0;\n    width: 20px;\n    height: 28px;\n    margin-left: -10px;\n    bottom: -15px;\n}\n.card_achievements .card_profiles_univarsity .card_profiles_name > a img {\n    border-radius: 50%;\n}\n.profile_picture_qr {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    min-height: 242px;\n    border-radius: 10px;\n    overflow: hidden;\n}\n.profile_picture_qr .or {\n    width: 2px;\n    position: relative;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n}\n.profile_picture_qr .profile_picture_section {\n    background: #d42941;\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 15px;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    position: relative;\n}\n.profile_picture_qr .profile_picture_section:hover {\n    background: #bd1f35;\n}\n.profile_picture_qr .profile_picture_section .block {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    cursor: pointer;\n    z-index: 1;\n}\n.profile_picture_qr .qr_section {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    background: #cffed2;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n.profile_picture_qr .or span {\n    background: #fff;\n    width: 42px;\n    height: 42px;\n    border-radius: 50%;\n    position: absolute;\n    left: -21px;\n    bottom: 0;\n    top: 0;\n    margin: auto;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 16px;\n    font-weight: 500;\n    text-transform: uppercase;\n}\n.profile_picture_qr .or::after {\n    display: none;\n}\n.profile_picture_edit {\n    border: 2px dashed #ffffff;\n    border-radius: 74px;\n    width: 145px;\n    height: 145px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    box-shadow: 0 0 0 5px #d42941 inset;\n    position: relative;\n}\n.profile_picture_edit:before {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    width: 100%;\n    background: #fff;\n    border-radius: 50%;\n    z-index: 0;\n}\n.profile_picture_edit img {\n    width: 100%;\n    position: relative;\n}\n.profile_picture_edit .image-edit {\n    position: absolute;\n    top: 5px;\n    right: 5px;\n    width: 32px;\n    height: 32px;\n    background: #5cae48;\n    border: 3px solid #fff;\n    border-radius: 50%;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.profile_picture_edit .image-edit:before {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    width: 2px;\n    height: 12px;\n    background: #fff;\n    margin: auto;\n}\n.profile_picture_edit .image-edit:after {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    width: 12px;\n    height: 2px;\n    background: #fff;\n    margin: auto;\n}\n.profile_picture_edit .image-edit:hover {\n    background: #669f34;\n}\n.profile_picture_edit_btn {\n    margin-top: 10px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n    text-align: center;\n}\n.profile_picture_edit_btn label {\n    background: #ffe3e3;\n    border: 2px solid #ffffff;\n    border-radius: 60px;\n    font-size: 12px;\n    font-weight: 500;\n    width: 140px;\n    height: 30px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.profile_picture_section:hover .profile_picture_edit_btn label {\n    background: #f7b3b3;\n    border: 2px solid#F7B3B3;\n}\n.profile_picture_edit_btn span {\n    font-size: 14px;\n    color: #fff;\n    line-height: 18px;\n}\n.profile_picture_qr .qr_section p {\n    font-size: 16px;\n    margin: 8px 0 0;\n    font-weight: 500;\n}\n.whatapp_text i {\n    width: 20px;\n    height: 20px;\n    margin-right: 5px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/whatsapp.svg) no-repeat 0 0;\n}\n.whatapp_text {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    font-size: 16px;\n    font-weight: 600;\n    align-items: center;\n}\n.desclamier {\n    font-size: 14px;\n    font-style: italic;\n    margin: 10px 0 20px;\n}\n\n@media (min-width: 768px) and (max-width: 992.98px) {\n    .profile_picture_qr {\n        flex-direction: column;\n    }\n    .profile_picture_qr .profile_picture_section {\n        padding: 30px;\n    }\n    .profile_picture_qr .qr_section {\n        padding: 30px;\n    }\n    .profile_picture_qr .or {\n        width: 100%;\n    }\n    .profile_picture_qr .or span {\n        left: 0;\n        right: 0;\n    }\n}\n\n@media (max-width: 575px) {\n    .profile_picture_qr {\n        flex-direction: column;\n    }\n    .profile_picture_qr .profile_picture_section {\n        padding: 30px;\n    }\n    .profile_picture_qr .qr_section {\n        padding: 30px;\n    }\n    .profile_picture_qr .or {\n        width: 100%;\n    }\n    .profile_picture_qr .or span {\n        left: 0;\n        right: 0;\n    }\n    .btn-delete {\n        right: -20px;\n    }\n}\n\n.success_popup {\n    max-width: 700px;\n}\n.success_popup .img_pop {\n    position: absolute;\n    right: -40px;\n    bottom: 0;\n}\n.success_popup .modal-content {\n    min-height: 380px;\n    border-radius: 10px;\n    -webkit-border-radius: 10px;\n    -moz-border-radius: 10px;\n    -ms-border-radius: 10px;\n    -o-border-radius: 10px;\n}\n.success_popup .modal-body {\n    display: flex;\n    align-items: center;\n    padding-left: 60px;\n}\n.success_popup .brife {\n    margin-top: -30px;\n    max-width: 320px;\n}\n.success_popup .modal-body h4::after {\n    content: '';\n    position: absolute;\n    left: 0;\n    bottom: 0px;\n    width: 50px;\n    height: 3px;\n    background: #5cae48;\n    border-radius: 15px;\n}\n.success_popup .modal-body h4 {\n    position: relative;\n    padding-bottom: 10px;\n    margin-bottom: 20px;\n}\n.success_popup .modal-footer {\n    background: transparent linear-gradient(261deg, #fdfeff 0%, #eff7ff 16%, #d4ffc9 100%);\n    border-radius: 90px 10px 10px 10px;\n    opacity: 1;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: start;\n    padding-left: 70px;\n    border: 0;\n    min-height: 90px;\n    position: relative;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    margin-top: -90px;\n    -webkit-border-radius: 90px 10px 10px 10px;\n    -moz-border-radius: 90px 10px 10px 10px;\n    -ms-border-radius: 90px 10px 10px 10px;\n    -o-border-radius: 90px 10px 10px 10px;\n}\n.file {\n    position: relative;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.file > input[type='file'] {\n    display: none;\n}\n.file > label {\n    font-size: 1rem;\n    font-weight: 300;\n    cursor: pointer;\n    outline: 0;\n    user-select: none;\n    border-radius: 6px;\n    padding-right: 16px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    border: 1px dotted #8499a9;\n    min-height: 60px;\n    padding: 0;\n    font-weight: 400;\n    color: #0b3454;\n}\n.file > label span {\n    padding-left: 5px;\n    text-decoration: underline;\n    color: #27a7df;\n    font-weight: 400;\n}\n.file > label:hover {\n    border-color: hsl(0, 0%, 21%);\n}\n.file > label:active {\n    background-color: hsl(0, 0%, 96%);\n}\n.file > label > i {\n    padding-right: 15px;\n}\n.file--upload > label {\n}\n.file--upload > label:hover {\n    border-color: hsl(204, 86%, 53%);\n    background-color: hsl(204, 86%, 96%);\n}\n.file--upload > label:active {\n    background-color: hsl(204, 86%, 91%);\n}\n.file--uploading > label {\n    color: hsl(48, 100%, 67%);\n    border-color: hsl(48, 100%, 67%);\n}\n.file--uploading > label > i {\n    animation: pulse 5s infinite;\n    -webkit-animation: pulse 5s infinite;\n}\n.file--uploading > label:hover {\n    border-color: hsl(48, 100%, 67%);\n    background-color: hsl(48, 100%, 96%);\n}\n.file--uploading > label:active {\n    background-color: hsl(48, 100%, 91%);\n}\nform-control.is-valid,\n.was-validated .form-control:valid {\n    background-image: none;\n}\n.was-validated .form-select:valid:not([multiple]):not([size]) {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e\");\n}\n.form-select.is-valid,\n.was-validated .form-select:valid {\n    color: #000;\n}\n.question .form-select.customSelect {\n    border: 1px solid #b5c2cb;\n    border-radius: 6px;\n    background-color: #fff;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n}\n.customChoose {\n    background: #ffffff;\n    box-shadow: 0px 10px 20px #efefef;\n    border: 1px solid #b5c1cb;\n    border-radius: 6px;\n    overflow: hidden;\n    position: absolute;\n    width: 100%;\n    top: 150%;\n    z-index: -1;\n    opacity: 0;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.question .customChoose .form-control {\n    border-width: 0 0 1px 0;\n    border-radius: 0;\n}\n.customChoose.open {\n    opacity: 1;\n    z-index: 1;\n    top: 102%;\n}\n.customChooseoptions {\n    margin: 20px 0 20px;\n    padding: 0 15px;\n    list-style: none;\n    max-height: 160px;\n    overflow: auto;\n    line-height: 16px;\n    scrollbar-width: 4px;\n}\n.customChooseoptions::-webkit-scrollbar {\n    width: 4px;\n}\n.customChooseoptions::-moz-scrollbar {\n    width: 4px;\n}\n.customChooseoptions::-webkit-scrollbar-track {\n    background: #eee;\n}\n.customChooseoptions::-webkit-scrollbar-thumb {\n    background-color: #666;\n    border-radius: 20px;\n    border: 2px solid #eee;\n}\n.customChooseoptions li {\n    cursor: pointer;\n    font-weight: 500;\n    font-size: 16px;\n}\n.customChooseoptions li:hover {\n    color: #5cae48;\n}\n.customChooseoptions li:not(:last-child) {\n    margin-bottom: 12px;\n}\n.customInputSearch + .customChoose.open,\n.customInputSearch:focus + .customChoose {\n    opacity: 1;\n    top: 102%;\n    z-index: 1;\n}\n.input-group-customSelect {\n    width: 33.3%;\n}\n.input-group .customSelect {\n    border-radius: 6px 0 0 6px !important;\n}\n.input-group-customSelect:not(:first-child) label {\n    border-radius: 0 !important;\n}\n.form-select.CurrencySelect.customSelect ~ .customChoose {\n    width: 168px;\n    border-radius: 6px !important;\n}\n#login_pop .signup,\n#sociallogin,\n.bg_side_blue .signup {\n    background: #0b3454;\n    margin-right: -1px;\n    border-radius: 0px 18px 18px 80px;\n}\n#login_pop .signup h1 {\n    font-family: 'Jost', sans-serif;\n    color: #fff;\n}\n#login_pop .signup:before {\n    display: none;\n}\n#login_pop .signup .title {\n    position: relative;\n}\n#login_pop .innercover {\n    max-width: 385px;\n    width: 90%;\n    margin: auto;\n    padding: 0 20px;\n}\n#login_pop .innercover .img {\n    display: flex;\n    height: auto;\n    align-items: flex-end;\n    margin-bottom: 37px;\n    justify-content: center;\n}\n.innercover .img img {\n    max-width: 200px;\n}\n.icon.icon-correct::before {\n    content: '';\n    width: 13px;\n    height: 7px;\n    border-left: 2px solid #98bbdf;\n    border-bottom: 2px solid #98bbdf;\n    display: inline-block;\n    transform: rotate(-40deg);\n    margin: 7px 3px 0 0;\n    vertical-align: top;\n    -webkit-transform: rotate(-40deg);\n    -moz-transform: rotate(-40deg);\n    -ms-transform: rotate(-40deg);\n    -o-transform: rotate(-40deg);\n}\n.signup form .form-check-label {\n    cursor: pointer;\n}\n.form-group label[onclick] {\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n}\n.form-group.form-control-email::before {\n    width: 16px;\n    height: 12px;\n    content: '';\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/form-email.svg) no-repeat 0 center;\n    position: absolute;\n    top: 15px;\n    bottom: auto;\n    margin: auto;\n    left: 16px;\n    z-index: 2;\n}\n.form-group.form-control-password::before {\n    width: 12px;\n    height: 16px;\n    content: '';\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/form-lock.svg) no-repeat 0 center;\n    position: absolute;\n    top: 15px;\n    bottom: auto;\n    margin: auto;\n    left: 19px;\n    z-index: 2;\n}\n/* .form-group.form-control-mobile::before {width: 9px;height: 16px;content: '';background: url(../images/form-cell-phone.svg) no-repeat 0 center;position: absolute;top: 15px;bottom: auto;margin: auto;left: 16px;z-index: 2;} */\n.form-group label[onclick]:hover,\n.signup form .form-check-label[for='exampleCheck1']:hover,\n.signup a:hover {\n    color: #5cae48 !important;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n    text-decoration: none;\n}\nform a:hover {\n    text-decoration: none;\n}\n.form-group label[onclick]:hover {\n    color: #5cae48 !important;\n}\n.signup form .form-check-input:not(#exampleCheck1):checked + label.form-check-label {\n    background: #217aff !important;\n    border-color: #217aff !important;\n    color: #fff;\n}\n.signup form .form-check-input:checked + label .icon.icon-correct::before {\n    border-color: #fff !important;\n}\n.signup form .form-control {\n    min-height: 40px;\n    border: none;\n    border-radius: 6px;\n    font-weight: 500;\n    color: #000;\n    font-family: 'Jost', sans-serif;\n    font-size: 16px;\n    z-index: 1;\n    position: relative;\n}\n.signup #existing-user form .form-control {\n    padding-left: 50px;\n}\n.signup #existing-user form .form-control#ShopLoginFormModel_email {\n    background: #fff url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/form-email.svg) no-repeat 16px\n        center;\n}\n.email-text {\n    color: #ffffff99;\n}\n.signup #existing-user form .form-control#ShopLoginFormModel_password,\n.signup #existing-user form .form-control#ShopSignupFormModel_password {\n    background: #fff url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/form-lock.svg) no-repeat 19px\n        center;\n}\n.signup #existing-user form .form-control#ShopSignupFormModel_first_name,\n.signup form .form-group {\n    position: relative;\n}\n.signup form .form-group .viewpassword {\n    position: absolute;\n    right: 15px;\n    bottom: auto;\n    top: 14px;\n    margin: auto;\n    display: flex;\n    justify-content: center;\n    align-content: center;\n    z-index: 2;\n}\n.signup form .form-control + .viewpassword::before {\n    content: '';\n    width: 0%;\n    height: 2px;\n    background: #022d6d;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    transform: rotate(45deg);\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n}\n.signup form .form-control[type='text'] + .viewpassword::before {\n    width: 100%;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n}\n.signup form .form-check-input {\n    width: 1em;\n    height: 1em;\n    margin-top: 0.25em;\n    vertical-align: top;\n    background-color: #fff;\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: contain;\n    border: 1px solid rgba(0, 0, 0, 0.25);\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    -webkit-print-color-adjust: exact;\n    color-adjust: exact;\n    transition: background-color 0.15s ease-in-out, background-position 0.15s ease-in-out, border-color 0.15s ease-in-out,\n        box-shadow 0.15s ease-in-out;\n    -webkit-transition: background-color 0.15s ease-in-out, background-position 0.15s ease-in-out, border-color 0.15s ease-in-out,\n        box-shadow 0.15s ease-in-out;\n    -moz-transition: background-color 0.15s ease-in-out, background-position 0.15s ease-in-out, border-color 0.15s ease-in-out,\n        box-shadow 0.15s ease-in-out;\n    -ms-transition: background-color 0.15s ease-in-out, background-position 0.15s ease-in-out, border-color 0.15s ease-in-out,\n        box-shadow 0.15s ease-in-out;\n    -o-transition: background-color 0.15s ease-in-out, background-position 0.15s ease-in-out, border-color 0.15s ease-in-out,\n        box-shadow 0.15s ease-in-out;\n}\n.signup form .form-check .form-check-input {\n    float: left;\n    margin-left: -1.5em;\n}\n.signup form .form-check-input[type='checkbox'] {\n    border-radius: 0.25em;\n}\n.signup form .form-check-input:checked {\n    background-color: #7fb507;\n    border-color: #7fb507;\n}\n.signup form .form-check-input:checked[type='checkbox'] {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/%3e%3c/svg%3e\");\n}\n.signup .owl-dots .owl-dot {\n    box-shadow: 0 0 0 0;\n}\n.signup .owl-theme .owl-dots .owl-dot.active span,\n.signup .owl-theme .owl-dots .owl-dot:hover span {\n    background: #585858;\n    opacity: 0.8;\n}\n.login-footer {\n    margin: 50px 0;\n}\n.login-footer p {\n    font-size: 12px;\n    font-weight: 600;\n    margin: 0;\n    position: relative;\n}\n.login-footer p::after {\n    background: #c5c5c5;\n    width: 100%;\n    height: 1px;\n    position: absolute;\n    bottom: 7px;\n    margin: auto;\n    content: '';\n    left: 0;\n    right: 0;\n}\n.login-footer p b {\n    font-size: 12px;\n    font-weight: 600;\n    margin: 0;\n    position: relative;\n    z-index: 2;\n    background: #fff;\n    padding-right: 15px;\n}\n.login-footer > span {\n    color: #060606;\n    font-size: 12px;\n    line-height: 16px;\n    opacity: 0.6;\n}\n.signup .or {\n    margin: 0 0 20px;\n    text-align: center;\n    display: inline-block;\n    width: 100%;\n    font-size: 18px;\n    line-height: 22px;\n    color: #fff;\n    position: relative;\n}\n#existing-user.active ~ div .btn-signin {\n    display: none;\n}\n.input-otp {\n    max-width: 60px;\n    width: 100%;\n    outline: none;\n    box-shadow: none;\n}\n#new-user.active ~ div .btn-signup {\n    display: none;\n}\n#new-user .nav-pills .nav-link {\n    background: #fff;\n    width: 100%;\n}\n#new-user .nav-pills .nav-link.active {\n    background: #217aff;\n}\n#new-user ul.nav-pills li {\n    width: 30%;\n}\n#new-user .nav-pills .nav-link.active .icon.icon-correct::before {\n    border-color: #fff !important;\n}\n#pills-others.active + div {\n    display: none;\n}\n.or::after {\n    background: #38566e;\n    width: 100%;\n    height: 1px;\n    position: absolute;\n    bottom: 7px;\n    margin: auto;\n    content: '';\n    left: 0;\n    right: 0;\n    max-width: 463px;\n}\n.signup .or b {\n    font-weight: 400;\n    font-family: 'Jost', sans-serif;\n    background: #0b3454;\n    position: relative;\n    z-index: 2;\n    padding: 0 10px;\n}\n.sociallnks {\n    text-align: center;\n}\n.sociallnks p {\n    font-size: 14px;\n    line-height: 17px;\n    color: #fff;\n    font-family: 'Jost', sans-serif;\n    margin: 0;\n    font-weight: 400;\n}\n.sociallnks p a {\n    color: #a2e609;\n    font-weight: 500;\n}\n.sociallnks p a:hover {\n    text-decoration: none;\n}\n.sociallinks ul {\n    list-style: none;\n}\n.sociallnks ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    justify-content: center;\n}\n.sociallnks ul li a {\n    background: #ffffff;\n    box-shadow: 0px 5px 10px #0000001a;\n    border-radius: 18px;\n    width: 100%;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    height: 36px;\n    justify-content: center;\n    align-items: center;\n}\n.sociallnks ul li {\n    width: 100px;\n    margin: 20px 10px;\n}\n.signup form .gendar-radio-button + label {\n    float: left;\n    padding: 0.5em 1em;\n    cursor: pointer;\n    border: 1px solid #28608f;\n    margin-right: -1px;\n    color: #000;\n    background-color: #ffffff;\n    width: 100%;\n    border-radius: 6px;\n    min-height: 40px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    border: none;\n}\n.signup form .error .error-valid-text {\n    color: #fff !important;\n    margin-top: 3px;\n}\n.signup form .error .form-control {\n    background-color: #f7d7d7 !important;\n    border: 1px solid #fd7373;\n}\n.signup form .gendar-radio-button + label:first-of-type {\n}\n.signup form .gendar-radio-button + label:last-of-type {\n}\n.signup form .gendar-radio-button:checked + label {\n    background-color: #1074e9;\n    color: #fff;\n}\n.btn-access {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    margin: auto;\n}\n#new-user .progress {\n    height: 6px;\n    background: #051c3e;\n}\n#new-user a#but_add {\n    cursor: pointer;\n}\n#myloginTab {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n}\n#myloginTab li {\n    flex: 2;\n}\n#myloginTab li button {\n    width: 100%;\n    border: 0;\n    border-radius: 0;\n    line-height: 70px;\n    padding: 0;\n    font-size: 14px;\n    font-weight: 500;\n    font-family: 'Jost', sans-serif;\n    background: #04243c;\n    color: rgba(255, 255, 255, 0.5);\n}\n#myloginTab li button.active {\n    background: #0b3454;\n    color: #fff;\n}\n.daterangepicker .calendar-table th {\n    background-image: none;\n}\n.daterangepicker .calendar-table .next span {\n    transform: rotate(130deg);\n    -webkit-transform: rotate(130deg);\n}\n.page_loader {\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: rgba(0, 0, 0, 0.8);\n    z-index: 999999999;\n}\n.page_loader .sr-only {\n    font-size: 0;\n}\n.page_loader .spinner-border {\n    border-color: #fff #fff #fff transparent;\n    width: 100px;\n    height: 100px;\n    border-width: 10px;\n}\n.css-b62m3t-container .css-t3ipsp-control,\n.css-b62m3t-container,\n.css-13cymwt-control {\n    height: 43px !important;\n    border: 0 !important;\n    flex: 1;\n}\ndiv.css-9kqgro-control,\ndiv.css-xpesdl-control,\ndiv.css-9kqgro-control {\n    min-height: 38px !important;\n    margin-top: 1px;\n    margin-right: 1px;\n}\ndiv.css-1fdsijx-ValueContainer {\n    padding: 0;\n}\ndiv.css-3w2yfm-ValueContainer {\n    display: inline-block;\n    overflow: hidden;\n    padding-left: 8px;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical;\n    overflow-x: auto;\n    scrollbar-width: thin;\n}\ndiv.css-3w2yfm-ValueContainer::-webkit-scrollbar {\n    height: 3px;\n}\ndiv.css-3w2yfm-ValueContainer::-moz-scrollbar {\n    height: 3px;\n}\ndiv.css-3w2yfm-ValueContainer::-webkit-scrollbar-track {\n    background: #ccc;\n}\ndiv.css-3w2yfm-ValueContainer::-webkit-scrollbar-thumb {\n    background-color: #666;\n    border-radius: 20px;\n    border: 2px solid #666;\n}\ndiv.css-1p3m7a8-multiValue {\n    display: inline-flex;\n}\n.delete-sticky {\n    position: sticky;\n    top: 147px;\n    right: 0;\n    text-align: right;\n    cursor: pointer;\n}\n.blue-tick {\n    color: blue;\n}\n/* Profile Registration End */\n\n/* Alumni Dashboard Start */\n@font-face {\n    font-family: 'icomoon';\n    src: url('fonts/icomoon.eot?ynntp9');\n    src: url('fonts/icomoon.eot?ynntp9#iefix') format('embedded-opentype'), url('fonts/icomoon.woff2?ynntp9') format('woff2'),\n        url('fonts/icomoon.ttf?ynntp9') format('truetype'), url('fonts/icomoon.woff?ynntp9') format('woff'),\n        url('fonts/icomoon.svg?ynntp9#icomoon') format('svg');\n    font-weight: normal;\n    font-style: normal;\n    font-display: block;\n}\n[class^='icon-'],\n[class*=' icon-'] {\n    font-family: 'icomoon' !important;\n    speak: never;\n    font-style: normal;\n    font-weight: normal;\n    font-variant: normal;\n    text-transform: none;\n    line-height: 1;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n.icon-add-user:before {\n    content: '\\e900';\n}\n.icon-notification:before {\n    content: '\\e901';\n}\n.icon-book:before {\n    content: '\\e902';\n}\n.icon-box:before {\n    content: '\\e903';\n}\n.icon-brife-case:before {\n    content: '\\e904';\n}\n.icon-calendar:before {\n    content: '\\e905';\n}\n.icon-calender-time:before {\n    content: '\\e906';\n}\n.icon-chat:before {\n    content: '\\e907';\n}\n.icon-chat-invert:before {\n    content: '\\e908';\n}\n.icon-check:before {\n    content: '\\e909';\n}\n.icon-check-list:before {\n    content: '\\e90a';\n}\n.icon-clipboard:before {\n    content: '\\e90b';\n}\n.icon-correct:before {\n    content: '\\e90c';\n}\n.icon-correct-invert:before {\n    content: '\\e90d';\n}\n.icon-cross:before {\n    content: '\\e90e';\n}\n.icon-dashboard:before {\n    content: '\\e90f';\n}\n.icon-down-arrow:before {\n    content: '\\e910';\n}\n.icon-down-arrow-invert:before {\n    content: '\\e911';\n}\n.icon-edit:before {\n    content: '\\e912';\n}\n.icon-edit-pencil:before {\n    content: '\\e913';\n}\n.icon-mail:before {\n    content: '\\e914';\n}\n.icon-filter:before {\n    content: '\\e915';\n}\n.icon-folder:before {\n    content: '\\e916';\n}\n.icon-goal:before {\n    content: '\\e917';\n}\n.icon-headphones:before {\n    content: '\\e918';\n}\n.icon-heart:before {\n    content: '\\e919';\n}\n.icon-info:before {\n    content: '\\e91a';\n}\n.icon-insert-picture-icon:before {\n    content: '\\e91b';\n}\n.icon-insert-picture-square:before {\n    content: '\\e91c';\n}\n.icon-invert-cross:before {\n    content: '\\e91d';\n}\n.icon-invert-down-arrow:before {\n    content: '\\e91e';\n}\n.icon-invert-play:before {\n    content: '\\e91f';\n}\n.icon-key:before {\n    content: '\\e920';\n}\n.icon-laptop:before {\n    content: '\\e921';\n}\n.icon-left-arrow:before {\n    content: '\\e922';\n}\n.icon-like:before {\n    content: '\\e923';\n}\n.icon-location-pin:before {\n    content: '\\e924';\n}\n.icon-lock:before {\n    content: '\\e925';\n}\n.icon-log-in:before {\n    content: '\\e926';\n}\n.icon-multiple-users:before {\n    content: '\\e927';\n}\n.icon-pdf:before {\n    content: '\\e928';\n}\n.icon-pdf-upload:before {\n    content: '\\e929';\n}\n.icon-profit-report:before {\n    content: '\\e92a';\n}\n.icon-qualified:before {\n    content: '\\e92b';\n}\n.icon-question:before {\n    content: '\\e92c';\n}\n.icon-ribbon:before {\n    content: '\\e92d';\n}\n.icon-ribbon-invert:before {\n    content: '\\e92e';\n}\n.icon-right-arrow:before {\n    content: '\\e92f';\n}\n.icon-rupee:before {\n    content: '\\e930';\n}\n.icon-rupee-invert:before {\n    content: '\\e931';\n}\n.icon-search:before {\n    content: '\\e932';\n}\n.icon-setting:before {\n    content: '\\e933';\n}\n.icon-share:before {\n    content: '\\e934';\n}\n.icon-shuttle:before {\n    content: '\\e935';\n}\n.icon-shuttle-invert:before {\n    content: '\\e936';\n}\n.icon-sound:before {\n    content: '\\e937';\n}\n.icon-speak:before {\n    content: '\\e938';\n}\n.icon-star:before {\n    content: '\\e939';\n}\n.icon-study:before {\n    content: '\\e93a';\n}\n.icon-switch:before {\n    content: '\\e93b';\n}\n.icon-university:before {\n    content: '\\e93c';\n}\n.icon-up-arrow:before {\n    content: '\\e93d';\n}\n.icon-upload:before {\n    content: '\\e93e';\n}\n.icon-upload-big-arrow:before {\n    content: '\\e93f';\n}\n.icon-user-invert:before {\n    content: '\\e940';\n}\n.icon-user:before {\n    content: '\\e941';\n}\n.icon-varified:before {\n    content: '\\e942';\n}\n.icon-video-camera:before {\n    content: '\\e943';\n}\n.icon-view:before {\n    content: '\\e944';\n}\n.icon-world:before {\n    content: '\\e945';\n}\n.icon-hat:before {\n    content: '';\n}\n.custom-header {\n    min-height: 85px;\n    overflow: hidden;\n}\n.custom-header:hover {\n    overflow: visible;\n}\nheader {\n    position: relative;\n    z-index: 99;\n    background: #fff;\n}\n.univarsity_logo {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    padding: 0;\n    width: auto;\n}\n.univarsity_logo .logo img {\n    max-height: 70px;\n    width: auto;\n    max-width: 170px;\n}\n.profileSection {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n}\n.manager_profile .profileSection {\n    margin: 0 0 0 20px;\n    padding: 0 0 0 20px;\n    border-left: 1px solid #e1dede;\n    display: none;\n}\n.profileNamePosition .position {\n    background: #d6ffcc;\n    border-radius: 12px;\n    font-size: 12px;\n    font-weight: 500;\n    text-align: center;\n    line-height: 20px;\n    height: 20px;\n    -webkit-border-radius: 12px;\n    -moz-border-radius: 12px;\n    -ms-border-radius: 12px;\n    -o-border-radius: 12px;\n}\n.profileNamePosition {\n    margin-left: 10px;\n}\n.profileNamePosition .name {\n    font-weight: 500;\n    font-size: 16px;\n}\n.search {\n    max-width: 400px;\n    padding: 0;\n    background: #f1f1f1;\n    border-radius: 20px;\n    height: 40px;\n    -webkit-border-radius: 20px;\n    -moz-border-radius: 20px;\n    -ms-border-radius: 20px;\n    -o-border-radius: 20px;\n}\n.headerRightSide {\n    padding: 0;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    width: auto;\n    z-index: 1;\n}\n.headerRightSide > ul li:not(:last-child) {\n    margin-right: 20px;\n}\n.headerRightSide > ul li {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: right;\n}\n.headerRightSide > ul li div.username > label {\n    overflow: hidden;\n    border-radius: 50%;\n}\n.userimg {\n    font-size: 34px;\n    color: #0b3454;\n}\n.headerRightSide > ul li .username {\n    margin-right: 18px;\n}\n.headerRightSide > ul li div.username > i {\n    top: 15px;\n    right: -14px;\n    font-size: 9px;\n    cursor: pointer;\n}\n.headerRightSide > ul li div.username:hover > i {\n    color: #5cae48;\n}\n.headerRightSide > ul li div.username:hover {\n    overflow: visible;\n}\n.headerRightSide > ul li a {\n    cursor: pointer;\n}\n.headerRightSide > ul li a.mail {\n    position: relative;\n}\n.headerRightSide > ul li a.mail .count {\n    position: absolute;\n    background: #5cae48;\n    border-radius: 50%;\n    color: #fff;\n    font-size: 12px;\n    width: 17px;\n    height: 17px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    top: -10px;\n    right: -10px;\n}\n.headerRightSide > ul li a.invite {\n    background: #5cae48;\n    border-radius: 25px;\n    height: 35px;\n    padding: 0 10px;\n    display: flex;\n    align-items: center;\n    text-decoration: none;\n    color: #fff;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.headerRightSide > ul li a.invite:hover {\n    background: #408e2d;\n    color: #fff;\n}\n.headerRightSide > ul li a:hover,\n.username:hover .userimg {\n    color: #5cae48;\n}\n.headerRightSide .user-dropdown ul li a b {\n    font-size: 12px;\n    color: #5cae48;\n}\n.userimg {\n    cursor: pointer;\n    vertical-align: bottom;\n}\n.search .form-control {\n    border: 0;\n    background: none;\n    height: 38px;\n    border-radius: 20px;\n}\n.search .form-control::placeholder {\n    color: rgba(0, 0, 0, 0.8);\n    opacity: 1;\n    font-size: 16px;\n    font-weight: 400;\n}\n.search .form-control:-ms-input-placeholder {\n    color: #000;\n}\n.search .form-control::-ms-input-placeholder {\n    color: #000;\n}\n.form-control:focus,\n.search .btn-search:focus {\n    box-shadow: none;\n}\n.form-control:focus-visible,\n.search .btn-search:focus-visible {\n    outline: none;\n}\n.search .btn-search {\n    font-size: 13px;\n    padding: 0;\n    width: 28px;\n    height: 28px;\n    padding: 0;\n    position: absolute;\n    right: 7px;\n    top: 7px;\n}\n.search .btn-search:hover {\n    color: #26a7df;\n}\n.search > form,\n.search > div {\n    position: relative;\n}\n.search > form input:focus,\n.search > div input:focus {\n    box-shadow: none;\n    background: #fff;\n}\n.search > form input:focus + .btn-search,\n.search > div input:focus + .btn-search {\n    color: #000;\n}\n.user-dropdown {\n    background: #ffffff;\n    box-shadow: 0px 3px 6px #0000001a;\n    border: 1px solid #d2d2d2;\n    border-radius: 6px;\n    top: 80px;\n    right: -17px;\n    z-index: 1;\n    width: 150px;\n    opacity: 0;\n    position: absolute;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n}\n.username:hover div.user-dropdown {\n    opacity: 1;\n    top: 50px;\n}\n.username:hover div.user-dropdown::before {\n    width: 20px;\n    height: 20px;\n    content: '';\n    position: absolute;\n    top: -20px;\n    right: 6px;\n}\n.username:not(:hover) div.user-dropdown ul li a {\n    pointer-events: none;\n}\n.user-dropdown ul {\n    padding: 15px;\n    margin: 0;\n}\n.headerRightSide * {\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n}\n.headerRightSide .user-dropdown ul li a {\n    color: #000;\n    text-decoration: none;\n    font-weight: 500;\n    font-size: 14px;\n}\n.headerRightSide .user-dropdown ul li a .message_count {\n    font-size: 12px;\n    width: 17px;\n    height: 17px;\n    background: #5cae48;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    color: #fff;\n}\n.headerRightSide .user-dropdown ul li a:hover {\n    color: #5cae48;\n}\n.headerRightSide .user-dropdown ul li:not(:last-child) {\n    margin: 0 0 15px 0;\n}\n.headerRightSide > ul {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n.calender {\n    width: 20px;\n    height: 21px;\n    display: inline-block;\n    text-decoration: none;\n    color: #0b3454;\n    font-size: 20px;\n}\n.mail {\n    width: 18px;\n    display: inline-block;\n    color: #0b3454;\n    font-size: 18px;\n    text-decoration: none;\n}\n.notification {\n    width: 20px;\n    height: 21px;\n    display: inline-block;\n    font-size: 20px;\n    color: #0b3454;\n    text-decoration: none;\n}\n.mobileonly {\n    display: none;\n}\n.btn-search-toggle {\n    display: none;\n}\n.main {\n    position: relative;\n}\n.main.dashboard::before {\n    content: '';\n    width: 50%;\n    height: 100%;\n    background: #f3f3f3;\n    position: absolute;\n}\n.mainContainer {\n    position: relative;\n    background: #fff;\n}\n.sideBar * {\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n}\n.sideBar {\n    width: 80px;\n    position: relative;\n    z-index: 1;\n}\n.sideBar ul {\n    background: #f3f3f3;\n    box-shadow: 8px 10px 10px 0px #e8e8e8;\n    border-right: 1px solid #dbdbdb;\n    list-style: none;\n    padding: 36px 0 0 0;\n    margin: 0;\n    height: 100%;\n    width: 80px;\n}\n.sideBar ul:hover {\n    width: 260px;\n}\n.sideBar ul li a {\n    width: 100%;\n    float: left;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    color: #000;\n    text-decoration: none;\n    cursor: pointer;\n}\n.sideBar ul li a > b {\n    width: 60px;\n    height: 60px;\n    border-radius: 30px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin: auto 0;\n    max-width: 60px;\n    font-size: 25px;\n    position: relative;\n}\n.sideBar ul li:not(.active) a > b::after {\n    position: absolute;\n    width: 0%;\n    height: 0%;\n    content: '';\n    background: transparent;\n    border-radius: 50%;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    margin: auto;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n}\n.sideBar ul li:not(.active) a > b::before {\n    position: relative;\n    z-index: 2;\n}\n.sideBar ul li:not(.active) a:hover > b::after {\n    width: 100%;\n    height: 100%;\n}\n.sideBar ul li:hover a > b {\n    color: #26a7df;\n}\n.sideBar ul li.active a > b {\n    background: #26a7df;\n    color: #fff;\n}\n.sideBar ul li a span {\n    padding: 0 0 0 13px;\n    font-size: 18px;\n    line-height: 22px;\n    width: 0;\n    overflow: hidden;\n}\n.sideBar ul:hover li a span {\n    width: 199px;\n}\n.sideBar ul li a span b {\n    width: 175px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    font-weight: 400;\n}\n.pageContent {\n    padding-left: 50px;\n}\n.btn-green {\n    background: #5cae48;\n    height: 40px;\n    padding: 0 25px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: #fff;\n    text-decoration: none;\n    font-size: 16px;\n    line-height: 16px;\n    font-weight: 500;\n    position: relative;\n    overflow: hidden;\n    border: 0;\n    border-radius: 27px;\n    -webkit-border-radius: 27px;\n    -moz-border-radius: 27px;\n    -ms-border-radius: 27px;\n    -o-border-radius: 27px;\n}\n.btn-green:hover {\n    color: #eeffea;\n}\n.btn-green .icon-question.circle {\n    border-radius: 50%;\n    border: 2px solid #fff;\n    padding: 2px;\n    font-size: 12px;\n    width: 22px;\n    height: 22px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-right: 4px;\n}\n.btn-green:focus-visible {\n    background: #5cae48;\n}\n.welcome-title h1 {\n    font-size: 35px;\n    font-weight: 600;\n    margin: 0 0 5px;\n}\n.welcome-title p {\n    font-size: 18px;\n    margin: 0;\n}\n.footer {\n    padding: 20px 40px 40px;\n    border-top: 0px solid #dedede;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: space-between;\n    font-size: 14px !important;\n}\n.powerby {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n}\n.milestone {\n    background: #fff;\n    box-shadow: 0px 3px 6px #0000001a;\n    border: 1px solid #d2d2d2;\n    border-radius: 6px;\n    height: 100%;\n    position: relative;\n    padding: 30px;\n    text-align: center;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n}\n.milestone .icon {\n    position: absolute;\n    left: 0;\n    right: 0;\n    margin: auto;\n    top: -33px;\n    background: #d42941;\n    width: 60px;\n    height: 60px;\n    border-radius: 50%;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: #fff;\n}\n.milestone .icon span {\n    font-size: 32px;\n    color: #fff;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.milestone .icon span:before {\n    color: #fff;\n}\n.milestone .count {\n    font-size: 22px;\n    font-weight: 600;\n    text-align: left;\n}\n.milestone .count {\n    font-size: 22px;\n    font-weight: 600;\n    position: absolute;\n    left: 15px;\n    top: 12px;\n}\n.milestone .btn,\n.activity-btn {\n    height: 40px;\n    text-align: center;\n    margin: auto;\n    display: inline-block;\n    padding: 0 25px;\n    border-radius: 25px;\n    line-height: 36px;\n    overflow: hidden;\n    position: relative;\n}\n.milestone .btn span,\n.btn-green span,\n.activity-btn span {\n    position: relative;\n}\n.activity-btn {\n    min-width: 140px;\n}\n.btn-complete-now {\n    background: #0b3454;\n    color: #fff;\n}\n.btn-complete-now::before {\n    position: absolute;\n    content: '';\n    left: 0;\n    top: 0;\n    bottom: 0;\n    width: 0;\n    background: #185584;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n}\n.btn-complete-now:hover::before {\n    width: 100%;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n}\n.btn-complete-now:hover {\n    color: #fff;\n}\n.btn-completed {\n    background: #5cae48;\n    color: #fff;\n}\n.btn-green::before {\n    position: absolute;\n    content: '';\n    left: 0;\n    top: 0;\n    bottom: 0;\n    width: 0;\n    background: #398227;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n}\n.btn-green:hover::before {\n    width: 100%;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n}\n.btn-completed:hover {\n    color: #d7f7cf;\n}\n.btn-completed .icon-correct {\n    font-size: 12px;\n}\n.milestone .count {\n    font-size: 22px;\n    font-weight: 600;\n    position: absolute;\n    left: 15px;\n    top: 12px;\n}\n.milestone h3 {\n    text-align: center;\n    width: calc(100% - 34px);\n    margin: 10px auto 0;\n    font-size: 20px;\n    font-weight: 600;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    line-height: 25px;\n}\n.milestone .progress-status {\n    padding: 0;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    text-align: center;\n    list-style: none;\n    justify-content: center;\n    align-items: center;\n    margin: 16px 0 0;\n}\n.milestone .progress-status li {\n    width: 40px;\n    height: 3px;\n    background: #dedede;\n    display: inline-block;\n    margin: 0 7px;\n}\n.milestone .progress-status li.completed {\n    background: #5cae48;\n}\n.activities_status {\n    font-size: 16px;\n    font-weight: 600;\n    text-align: center;\n    margin-bottom: 20px;\n    cursor: pointer;\n    padding: 15px 0 0 0;\n}\n.sticky-notification {\n    background: #0b3454;\n    box-shadow: 0px 5px 10px #0b345463;\n    border-radius: 6px;\n    max-width: 840px;\n    margin: auto auto 50px;\n    position: relative;\n    height: 100px;\n    align-items: flex-end;\n    -webkit-border-radius: 6px;\n    -moz-border-radius: 6px;\n    -ms-border-radius: 6px;\n    -o-border-radius: 6px;\n}\n.sticky-notification .btn-close {\n    color: #fff;\n    opacity: 1;\n    font-size: 9px;\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    text-decoration: none;\n}\n.sticky-notification .imgplace {\n    padding-left: 5px;\n}\n.sticky-notification .notification-detail {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    height: 100%;\n    justify-content: space-around;\n}\n.sticky-notification .notification-detail p {\n    margin: 0;\n    color: #fff;\n    max-width: 315px;\n}\n.imglink {\n    max-width: 299px;\n    width: 100%;\n}\n.imglink .imgplace {\n    display: none;\n}\n.sticky-notification .notification-detail .links {\n    max-width: 299px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n}\n.btn-message {\n    background: #fff;\n    padding: 0 25px;\n    line-height: 38px;\n    text-decoration: none;\n    border-radius: 25px;\n    color: #000;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n    position: relative;\n    overflow: hidden;\n}\n.btn-message span {\n    position: relative;\n}\n.btn-message::before {\n    width: 0;\n    height: 100%;\n    content: '';\n    background: #a4a4a4;\n    position: absolute;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n}\n.btn-message:hover::before {\n    width: 100%;\n}\n.btn-message:hover {\n    color: #fff;\n}\n#dashboard-pills-tab.nav-pills .nav-link {\n    width: 175px;\n    border-radius: 25px;\n    border: 2px solid #7d7d7d;\n    color: #414141;\n}\n#dashboard-pills-tab.nav-pills .nav-item:not(:last-child) {\n    margin-right: 15px;\n}\n#dashboard-pills-tab.nav-pills .nav-link.active {\n    background: #5cae48;\n    border-color: #5cae48;\n    color: #fff;\n}\n.expandOption {\n    text-align: right;\n    margin: 10px 0 20px;\n}\n.expandOption .btn-expand {\n    font-size: 16px;\n    font-weight: 500;\n    color: #147ad6;\n}\n.expandOption .btn-expand .colapse {\n    display: none;\n}\n.expandOption .btn-collapse .expand {\n    display: none;\n}\n.dashboardAccordion .accordion-item:not(:last-child) {\n    margin-bottom: 20px;\n}\n.dashboardAccordion .accordion-item {\n    border: 1px solid #d2d2d2;\n    border-radius: 6px;\n}\n.dashboardAccordion .accordion-item .accordion-button {\n    background-color: transparent;\n    font-size: 22px;\n    font-weight: 600;\n    color: #000;\n    box-shadow: none;\n    padding: 20px 13px 20px 30px;\n}\n.dashboardAccordion .accordion-item .accordion-button.text-burgandi {\n    color: #d42941;\n}\n.dashboardAccordion .accordion-item .accordion-button span {\n    font-size: 19px;\n    margin-left: 40px;\n    color: #0b3454;\n}\n.dashboardAccordion .accordion-item .accordion-button::after {\n    content: '';\n    background-color: #fff;\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e\");\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: 20px 20px;\n    width: 20px;\n    height: 20px;\n}\n.dashboardAccordion .accordion-item .accordion-body {\n    padding: 10px 30px 30px;\n}\n.dashboardAccordion h3 {\n    font-size: 22px;\n    font-weight: 600;\n    margin: 0;\n}\n.orange {\n    background-color: #ff9f40;\n}\n.dark-blue {\n    background-color: #147ad6;\n}\n.lite-red {\n    background-color: #ff6384;\n}\n.gold {\n    background-color: #ffcd56;\n}\n.cyan {\n    background-color: #4bc0c0;\n}\n.pink {\n    background-color: #e86bc2;\n}\n.yellow {\n    background-color: #f9ff54;\n    border: 1px solid #f0f64b;\n}\n.sky-blue {\n    background-color: #79d2de;\n}\n.bg-red {\n    background: #d52941; /* background:#b92940*/\n}\n.bg-gray {\n    background: #f8f8f8;\n}\n.bg-lighter-blue {\n    background: #f2f9ff;\n}\n.radius-10 {\n    border-radius: 10px;\n}\n.custom-border-84 {\n    width: 24px;\n    height: 24px;\n    border-width: 2px;\n    border-color: #848484;\n}\n.custom-border-84.form-check-input:checked {\n    background-color: #848484 !important;\n    border-color: #848484 !important;\n    box-shadow: inset 0 0 0 4px #fff;\n    background-image: none !important;\n}\n.custom-border-84-20 {\n    width: 20px;\n    height: 20px;\n    border-width: 2px;\n    border-color: #848484;\n}\n.custom-border-84-20.form-check-input:checked {\n    background-color: #848484 !important;\n    border-color: #848484 !important;\n    box-shadow: inset 0 0 0 4px #fff;\n    background-image: none !important;\n}\n.custom-border-white.form-check-input {\n    width: 18px;\n    height: 18px;\n}\n.custom-border-white.form-check-input:checked {\n    background-color: #707070 !important;\n    border-color: #707070 !important;\n    box-shadow: inset 0 0 0 4px #fff;\n    background-image: none !important;\n}\n.blue-strip > div:nth-child(2n) {\n    background: #f2f9ff;\n}\n.graph-result-list ul {\n    margin: 20px auto 0;\n    padding: 0;\n    list-style: none;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    max-width: 317px;\n}\n.graph-result-list ul li {\n    min-width: auto;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    margin: 0 11px 10px 0;\n}\n.graph-result-list ul li .color {\n    width: 16px;\n    height: 16px;\n    display: inline-block;\n    margin: 0 11px 0 0;\n    border-radius: 2px;\n}\n.graph-result-list.oneLine ul,\n.graph-result-list.rightPaneColor ul {\n    max-width: initial;\n}\n.graph-result-list.oneLine ul li:last-child,\n.graph-result-list.rightPaneColor ul li:last-child {\n    margin-right: 0;\n}\n.onboardingLaunchGraph ul,\n.triangleGraph ul {\n    padding: 0;\n    margin: 0;\n    text-align: right;\n    list-style: none;\n}\n.onboardingLaunchGraph ul li,\n.triangleGraph ul li {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    position: relative;\n}\n.onboardingLaunchGraph ul li div,\n.triangleGraph ul li div {\n    width: 100%;\n    text-align: center;\n    height: 65px;\n    margin-bottom: 2px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    max-width: 380px;\n    justify-content: center;\n}\n.onboardingLaunchGraph ul li div span,\n.triangleGraph ul li div span {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    height: 100%;\n    align-items: center;\n    color: #fff;\n    font-weight: 500;\n    font-size: 16px;\n    position: relative;\n}\n.onboardingLaunchGraph ul li div span:before,\n.triangleGraph ul li div span:before {\n    content: '';\n    width: 0;\n    height: 0;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    border-width: 34px 10px 34px 10px;\n    border-style: solid solid solid solid;\n    border-color: transparent white white transparent;\n}\n.onboardingLaunchGraph ul li div span::before,\n.triangleGraph ul li div span::before {\n    transform: scaleX(-1);\n    -webkit-transform: scaleX(-1);\n    -moz-transform: scaleX(-1);\n    -ms-transform: scaleX(-1);\n    -o-transform: scaleX(-1);\n}\n.onboardingLaunchGraph ul li div span:after,\n.triangleGraph ul li div span:after {\n    content: '';\n    width: 0;\n    height: 0;\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    border-width: 34px 10px 34px 10px;\n    border-style: solid solid solid solid;\n    border-color: transparent white white transparent;\n}\n.onboardingLaunchGraph ul li:nth-child(1) div span,\n.triangleGraph ul li:nth-child(1) div span {\n    width: 100%;\n    background: #ff9f40;\n}\n.onboardingLaunchGraph ul li:nth-child(2) div span,\n.triangleGraph ul li:nth-child(2) div span {\n    width: calc(100% - 40px);\n    margin: 0 20px;\n    background: #147ad6;\n}\n.onboardingLaunchGraph ul li:nth-child(3) div span,\n.triangleGraph ul li:nth-child(3) div span {\n    width: calc(100% - 80px);\n    margin: 0 40px;\n    background: #4bc0c0;\n}\n.onboardingLaunchGraph ul li:nth-child(4) div span,\n.triangleGraph ul li:nth-child(4) div span {\n    width: calc(100% - 60px);\n    margin: 0 60px;\n    background: #ff6384;\n}\n.onboardingLaunchGraph ul li:nth-child(5) div span,\n.triangleGraph ul li:nth-child(5) div span {\n    width: calc(100% - 160px);\n    margin: 0 60px;\n    background: #ffcd56;\n}\n.onboardingLaunchGraph ul li:nth-child(6) div span,\n.triangleGraph ul li:nth-child(6) div span {\n    width: calc(100% - 200px);\n    margin: 0 60px;\n    background: #e86bc2;\n}\n.onboardingLaunchGraph ul li label,\n.triangleGraph ul li label {\n    font-size: 16px;\n    font-weight: 600;\n    margin-left: 40px;\n    white-space: nowrap;\n    position: absolute;\n    right: 0;\n}\n.blue-container {\n    background: #26a7df url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/bulb.jpg) no-repeat right\n        20px bottom 20px;\n    border-radius: 6px;\n    padding: 25px 30px;\n    color: #fff;\n    height: 100%;\n}\n.onboarding {\n    max-width: 120px;\n    height: 35px;\n    border-radius: 25px;\n    font-size: 16px;\n    line-height: 16px;\n    margin-bottom: 25px;\n    border: 2px solid #7d7d7d;\n}\n.highlight-text {\n    text-align: center;\n    margin: 20px 0 0;\n    font-size: 16px;\n    font-weight: 500;\n}\n.dashboardAccordion .blue-container h3 {\n    font-size: 20px;\n    font-weight: 500;\n}\n.blue-container ul {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n}\n.blue-container ul li {\n    margin-bottom: 25px !important;\n}\n.blue-container ul li {\n    position: relative;\n    padding: 0 0 0 19px;\n}\n.blue-container ul li:before {\n    content: '';\n    width: 3px;\n    height: 14px;\n    background: #fff;\n    position: absolute;\n    left: 0;\n    top: 6px;\n    display: inline-block;\n    border-radius: 55px;\n}\n.blue-container ul li p {\n    margin: 0;\n}\n.actionableInsights {\n    max-width: 350px;\n}\n#milestoneProgress-collapseThree .graph-result-list ul,\n#tasksAssessmentsProgress-collapseFour .graph-result-list ul {\n    max-width: initial;\n}\n.milestoneProgressGraph {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    justify-content: space-between;\n}\n.milestoneGraph {\n    min-height: 260px;\n    width: 16%;\n}\n.milestoneGraph .progress {\n    width: 30%;\n    height: auto;\n}\n.dashboardAccordion .milestoneGraph h3 {\n    font-size: 16px;\n    margin: 0 0 10px;\n}\n#milestoneProgress-collapseThree .graph-result-list ul li:last-child {\n    margin-right: 0;\n}\n#tasksAssessmentsProgress-collapseFour .graph-result-list ul li:last-child {\n    margin-right: 0;\n}\n.status_progress {\n    max-width: 260px;\n    height: 40px;\n    width: 260px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    overflow: hidden;\n    border-radius: 3px;\n}\n.status_progress > div {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #fff;\n}\n.tablesection {\n}\n.tablesection > .table {\n    border: 1px solid #d2d2d2;\n    border-radius: 6px;\n    overflow: auto;\n    padding: 0px;\n}\n.tablesection > .table thead {\n    background: #0b3454;\n    color: #fff;\n}\n.tablesection > .table > .table {\n    margin: 0;\n}\n.tablesection > .table > .table tr:last-child {\n    border-color: transparent;\n}\n.tablesection > .table > .table tr th + th,\n.tablesection > .table > .table tr td {\n    text-align: center;\n    vertical-align: middle;\n}\n.alumni_directory_details .tablesection > .table > .table tr th + th,\n.alumni_directory_details .tablesection > .table > .table tr td {\n    text-align: left;\n    font-weight: 500;\n}\n.tablesection > .table > .table > tbody th {\n    font-weight: 500;\n}\n#tasksAssessmentsProgress-headingFour .tablesection > .table > .table tr td:last-child {\n    width: 260px;\n}\n.tablesection > .table > .table th,\n.tablesection > .table > .table td {\n    vertical-align: middle;\n    padding: 15px 25px;\n}\n.tablesection > .table > .table thead tr th {\n    text-transform: uppercase;\n    font-weight: 500;\n    height: 57px;\n}\n.tablesection > .table > .table td a {\n    color: #147ad6;\n}\n.tablesection > .table > .table td a:hover {\n    color: #0b3454;\n}\n.tablesection > .table > .table td a.btn-border {\n    color: #fff;\n}\n.tablesection > .table > .table td a.btn-border:hover {\n    color: #fff;\n}\n.btn-border-gray {\n    border-radius: 25px !important;\n    padding: 0 25px;\n    line-height: 32px;\n    border: 2px solid #7d7d7d;\n    height: 35px;\n    display: inline-flex;\n    text-decoration: none;\n    color: #000;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n    position: relative;\n    overflow: hidden;\n    justify-content: center;\n    align-items: center;\n    background: #fff;\n    -webkit-border-radius: 25px !important;\n    -moz-border-radius: 25px !important;\n    -ms-border-radius: 25px !important;\n    -o-border-radius: 25px !important;\n}\n.btn-border-gray::before {\n    width: 0;\n    height: 100%;\n    content: '';\n    background: #0b3454;\n    position: absolute;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n}\n.btn-border-gray:hover::before {\n    width: 100%;\n}\n.btn-border-gray:hover {\n    color: #fff;\n    background: #0b3454;\n    border: 2px solid #0b3454;\n}\n.btn-border-gray span {\n    position: relative;\n}\n.btn-border-gray-de {\n    border-radius: 25px;\n    padding: 0 25px;\n    line-height: 32px;\n    border: 2px solid #dedede;\n    height: 35px;\n    display: inline-flex;\n    text-decoration: none;\n    color: #0b3454;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n    position: relative;\n    overflow: hidden;\n    justify-content: center;\n    align-items: center;\n    background: #fff;\n}\n.btn-border-gray-de::before {\n    width: 0;\n    height: 100%;\n    content: '';\n    background: #0b3454;\n    position: absolute;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n}\n.btn-border-gray-de:hover::before {\n    width: 100%;\n}\n.btn-border-gray-de:hover {\n    color: #fff;\n    background: #0b3454;\n    border: 2px solid #0b3454;\n}\n.btn-border-gray-de i,\n.btn-border-gray-de:hover i {\n    color: #0b3454;\n}\n.btn-border-gray-de:hover i {\n    color: #fff;\n}\n.btn-border-gray-de span {\n    position: relative;\n}\n.btn-border-gray.disabled {\n    opacity: 0.5;\n    pointer-events: none;\n}\n.btn-white-border {\n    padding: 0 25px;\n    height: 35px;\n    line-height: 30px;\n    text-align: center;\n    display: inline-block;\n    border: 2px solid #fff;\n    border-radius: 25px;\n    text-decoration: none;\n    color: #fff;\n    margin-top: 10px;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n    position: relative;\n    overflow: hidden;\n}\n.btn-white-border::before {\n    width: 0;\n    height: 100%;\n    content: '';\n    background: #fff;\n    position: absolute;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n}\n.btn-white-border:hover::before {\n    width: 100%;\n}\n.btn-white-border:hover {\n    background: #fff;\n    color: #000;\n}\n.btn-white {\n    padding: 0 25px;\n    height: 35px;\n    line-height: 35px;\n    text-align: center;\n    display: inline-block;\n    border-radius: 35px;\n    text-decoration: none;\n    color: #000;\n    background: #fff;\n    margin-top: 10px;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n    position: relative;\n    overflow: hidden;\n}\n.btn-white::before {\n    width: 0;\n    height: 100%;\n    content: '';\n    background: #0b3454;\n    position: absolute;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n}\n.btn-white:hover::before {\n    width: 100%;\n}\n.btn-white:hover {\n    color: #fff;\n}\n.btn-white span,\n.btn-white-border span,\n.btn-border span {\n    position: relative;\n}\n.shortList ul {\n    padding: 0;\n    margin: 0 0 24px 0;\n    list-style: none;\n}\n.shortList ul li {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: space-between;\n    padding: 15px 0 15px 44px;\n    position: relative;\n}\n.shortList ul li:not(:last-child) {\n    border-bottom: 1px solid #d2d2d2;\n}\n.shortList ul li span {\n    font-weight: 500;\n}\n.shortList ul li span:before {\n    content: '';\n    width: 24px;\n    height: 24px;\n    background: url(https://ap-south-1.console.aws.amazon.com/s3/object/media.univariety.com?region=ap-south-1&bucketType=general&prefix=userreactapp/style-images/flag.svg)\n        no-repeat 0 0;\n    position: absolute;\n    left: 0;\n    top: 15px;\n}\n.horizontalProgress .progress {\n    height: 35px;\n    border-radius: 4px;\n    position: relative;\n    background: #d8e7f2;\n    margin-bottom: 28px;\n}\n.horizontalProgress .progress .progress-bar {\n    border-radius: 4px;\n    text-align: right;\n    padding: 0 25px;\n    font-size: 16px;\n    font-weight: 500;\n    letter-spacing: 0.32px;\n}\n.horizontalProgress .progress label {\n    position: absolute;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    padding-right: 20px;\n    font-size: 16px;\n    color: #000;\n    font-weight: 500;\n}\n.verticle-progress .progress {\n    width: 59px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    height: 177px;\n    align-items: flex-end;\n    margin: 0 10px;\n}\n.verticle-progress .progress .progress-bar {\n    width: 100%;\n    border-radius: 4px;\n    justify-content: flex-end;\n    padding-bottom: 7px;\n    font-size: 16px;\n    font-weight: 500;\n}\n.verticle-progress {\n    margin-bottom: 15px;\n}\n.thinVerticleProgress {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    width: 926px;\n    max-width: 926px;\n}\n.thinVerticleProgress .verticleProgress {\n    width: 28px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: space-between;\n    min-height: 510px;\n    position: relative;\n    flex-direction: column;\n}\n.thinVerticleProgress .verticleProgress .caption {\n    position: relative;\n    white-space: nowrap;\n    text-align: right;\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: flex-start;\n    justify-content: flex-start;\n}\n.thinVerticleProgress .verticleProgress .caption span {\n    position: absolute;\n    -moz-transform: rotate(-90deg);\n    -webkit-transform: rotate(-90deg);\n    -o-transform: rotate(-90deg);\n    -ms-transform: rotate(-90deg);\n    transform: rotate(-90deg);\n    top: 15px;\n    width: 100%;\n    text-align: left;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: flex-end;\n    height: 28px;\n    align-items: center;\n}\n.thinVerticleProgress .verticleProgress .graphContainer {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: space-between;\n}\n.thinVerticleProgress .verticleProgress .graphContainer .progress {\n    width: 11px;\n    height: 177px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: flex-end;\n}\n.thinVerticleProgress .verticleProgress .graphContainer .progress .progress-bar {\n    width: 100%;\n    border-radius: 4px;\n}\n.width-97 {\n    width: 97px;\n}\n.width-59 {\n    width: 59px;\n}\n.width-56 {\n    width: 56px;\n}\n.width-43 {\n    width: 43px;\n}\n.height-30 {\n    height: 30px !important;\n}\n.height-32 {\n    height: 32px !important;\n}\n.height-35 {\n    height: 35px !important;\n}\n.height-40 {\n    height: 40px !important;\n}\n.height-85 {\n    height: 85px !important;\n}\n.height-125 {\n    height: 125px !important;\n}\n.height-217 {\n    height: 217px !important;\n}\n.paddings-67 {\n    padding-left: 67px;\n}\n.horizontalScrol {\n    overflow-x: auto;\n    padding-bottom: 30px;\n}\n.horizontalScrol::-webkit-scrollbar {\n    height: 3px;\n}\n.horizontalScrol::-moz-scrollbar {\n    height: 3px;\n}\n.horizontalScrol::-webkit-scrollbar-track {\n    background: #eee;\n}\n.horizontalScrol::-webkit-scrollbar-thumb {\n    background-color: #666;\n    border-radius: 20px;\n    border: 2px solid #666;\n}\n.bigVerticalProgress {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: start;\n}\n.bigVerticalProgress .graphContainer {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n.bigVerticalProgress .graphContainer .progress {\n    width: 100%;\n    height: 177px;\n    align-items: flex-end;\n}\n.bigVerticalProgress .graphContainer .progress .progress-bar {\n    border-radius: 4px;\n    width: 100%;\n    justify-content: flex-end;\n    padding-bottom: 0px;\n    font-size: 16px;\n    font-weight: 500;\n}\n.bigVerticalProgress .verticleProgress {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    max-width: 97px;\n}\n.bigVerticalProgress .verticleProgress:not(:last-child) {\n    margin-right: 43px;\n}\n.bigVerticalProgress .verticleProgress .caption {\n    text-align: center;\n}\n.event {\n    background: #ffffff;\n    border: 1px solid #d2d2d2;\n    border-radius: 6px;\n    padding: 20px;\n    margin-bottom: 14px;\n}\n.eventDetails {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: flex-start;\n}\n.eventDetails .datedetail > div:not(.time) {\n    width: 80px;\n    height: 80px;\n    background: #51499c;\n    border-radius: 6px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    margin-right: 20px;\n}\n.eventDetails .datedetail.Fair > div:not(.time) {\n    background: #0b3454;\n}\n.eventDetails .date {\n    font-size: 35px;\n    font-weight: 600;\n    line-height: 30px;\n    color: #fff;\n}\n.eventDetails .month {\n    color: #fff;\n    font-weight: 500;\n    line-height: 16px;\n}\n.eventType .badge {\n    padding: 0 20px;\n    height: 25px;\n    background: #0b3454;\n    border-radius: 25px;\n    line-height: 20px;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 25px;\n}\n.eventType h2 {\n    font-size: 18px;\n    margin: 12px 0 10px;\n}\n.hostby {\n    border-top: 1px solid #dedede;\n    width: 100%;\n    padding: 12px 0 0 0;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n}\n.eventType {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    padding: 0 5% 0 0;\n}\n.hostNamePosition p {\n    margin: 0;\n}\n.hostImg {\n    margin-right: 14px;\n}\n.dashboardAccordion .hostNamePosition h3 {\n    font-size: 16px;\n}\n.participants {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n}\n.participants label {\n    width: 100%;\n    text-align: center;\n    font-size: 16px;\n    font-weight: 500;\n}\n.participantsnumber {\n    width: 100%;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    background: #f6f6f6;\n    border-radius: 6px;\n    padding: 11px 7px;\n    margin: 5px 0 20px;\n}\n.participantsnumber > div {\n    width: 50%;\n    text-align: center;\n    font-size: 16px;\n    font-weight: 500;\n}\n.participantsnumber > div.participantsnumberuniversity {\n    border-right: 1px solid #000;\n}\n.event a {\n    color: #147ad6;\n}\n.event a:hover {\n    color: #000;\n}\n.alumni_directory_details a {\n    text-decoration: underline;\n}\n.alumni_directory_details a:hover {\n    text-decoration: none;\n}\n.white-block {\n    background: #ffffff;\n    box-shadow: 0px 3px 6px #0000001a;\n    border: 1px solid #d2d2d2;\n    border-radius: 6px;\n    opacity: 1;\n    padding: 30px;\n}\n.white-block-notopborderradius {\n    border-radius: 0 0 6px 6px;\n    border-top: 0;\n}\n.alumni_directory_details ul.orderlist {\n    list-style: none;\n    padding: 0;\n}\n.alumni_directory_details ul.orderlist li:not(:last-child) {\n    margin-bottom: 20px;\n}\n.alumni_directory_details ul.orderlist li {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: space-between;\n    position: relative;\n    padding-left: 0px;\n}\n.alumni_directory_details ul.orderlist li .btn-border {\n    margin: 0;\n    color: #fff;\n    text-decoration: none;\n    max-width: 154px;\n    width: 100%;\n    font-size: 14px;\n    height: 32px;\n    padding: 0 15px;\n    line-height: 32px;\n    font-weight: 400;\n}\n.alumni_directory_details ul.orderlist li p {\n    margin: 3px 0 0;\n    font-weight: 500;\n    color: #414141;\n}\n.alumni_directory_details ul.orderlist li:before {\n    content: '';\n    width: 3px;\n    height: 20px;\n    background: #5cae48;\n    position: absolute;\n    top: 6px;\n    left: 0;\n    display: none;\n}\n.alumni_directory_details ul.orderlist.arrow li:before {\n    top: 3px;\n}\n.alumni_directory_details ul.orderlist.arrow li {\n    margin-top: 28px;\n}\n.gray-radius-box {\n    background: #fff;\n    border: 2px solid #e8e8e8;\n    border-radius: 6px;\n    opacity: 1;\n}\n.mapChart .btn-border-gray[aria-expanded='true'] {\n    display: none;\n}\n.alumni_directory_details ul.orderlist.arrow li a {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: space-between;\n    text-decoration: none;\n    color: #000;\n    align-items: center;\n}\n.alumni_directory_details ul.orderlist.arrow li a i {\n    -webkit-transition: all 0.2s ease-in-out;\n    -moz-transition: all 0.2s ease-in-out;\n    -ms-transition: all 0.2s ease-in-out;\n    -o-transition: all 0.2s ease-in-out;\n    transition: all 0.2s ease-in-out;\n}\n.alumni_directory_details ul.orderlist.arrow li a:hover i {\n    -moz-transform: translateX(3px);\n    -webkit-transform: translateX(3px);\n    -o-transform: translateX(3px);\n    -ms-transform: translateX(3px);\n    transform: translateX(3px);\n}\n.mapChart .accordion-item {\n    border: 0;\n}\n.mapChart .accordion-body {\n    padding: 0;\n}\n.mapChart .accordion-body .mapSection {\n    padding: 250px 0;\n    position: relative;\n}\n.mapChart .accordion-body .mapSection iframe {\n    position: absolute;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    margin: auto;\n}\n.mapChart .bigVerticalProgress .graphContainer .progress .progress-bar {\n    border-radius: 4px 4px 0 0 !important;\n}\n.mapChart .progress {\n    border-radius: 0;\n}\n.map-Search {\n    position: absolute;\n    z-index: 1;\n    top: 30px;\n    left: 30px;\n    max-width: 414px;\n    width: 100%;\n    height: 50px;\n    background: #ffffff;\n    box-shadow: 0px 0px 20px #0000001a;\n    border-radius: 6px;\n    opacity: 1;\n}\n.map-Search .btn-search {\n    background: #0b3454;\n    border-radius: 0px 6px 6px 0px;\n    opacity: 1;\n    color: #fff;\n}\n.presentCareer .bigVerticalProgress .graphContainer .progress {\n    border-radius: 0;\n}\n.presentCareer .bigVerticalProgress .graphContainer .progress .progress-bar {\n    border-radius: 0;\n}\n.presentCareer .bigVerticalProgress .graphContainer .progress .progress-bar:first-child {\n    border-radius: 4px 4px 0 0;\n}\n.number-bg {\n    width: 32px;\n    height: 32px;\n    background: #51499c;\n    border-radius: 50%;\n    text-align: center;\n    font-size: 14px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #fff;\n}\n.custom-border-gray {\n    border-color: #dedede !important;\n}\n.custom-border-gray-848484 {\n    border-color: #848484 !important;\n}\n.school_notification {\n    padding: 0;\n    margin: 0;\n    list-style: none;\n}\n.school_notification li:not(:last-child) {\n    border-bottom: 1px solid #dedede;\n}\n.school_notification li {\n    padding: 30px 0;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: space-between;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    align-items: center;\n}\n.school_notification li .detail {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: flex-start;\n}\n.icon-checked {\n    position: relative;\n    width: 14px;\n    height: 11px;\n    display: inline-block;\n}\n.icon-checked::before,\n.icon-checked::after {\n    content: '';\n    position: absolute;\n    border-left: 2px solid #b1b1b1;\n    border-bottom: 2px solid #b1b1b1;\n    width: 12px;\n    height: 6px;\n    left: 0;\n    top: 0;\n    -moz-transform: rotate(-40deg);\n    -webkit-transform: rotate(-40deg);\n    -o-transform: rotate(-40deg);\n    -ms-transform: rotate(-40deg);\n    transform: rotate(-40deg);\n}\n.unread .icon-checked::before,\n.unread .icon-checked::after {\n    border-color: #26a7df;\n}\n.icon-checked::after {\n    top: 5px;\n}\n.btn-close-small {\n    width: 12px;\n    height: 12px;\n    padding: 0 !important;\n    position: absolute;\n    top: 25px;\n    right: 25px;\n    z-index: 9;\n}\n.input-otp {\n    max-width: 80px;\n    height: 60px;\n    width: 100%;\n    border-radius: 10px;\n    border: 1px solid #848484;\n    margin: 0 5px;\n}\n.btn-edit {\n    background: #ffffff;\n    border: 1px solid #e1e1e1;\n    border-radius: 27px;\n    opacity: 1;\n    padding: 0 15px;\n    margin-left: 20px;\n    font-size: 14px;\n    line-height: 12px;\n    height: 30px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n}\n.profilePicSection {\n    width: 200px;\n    height: 200px;\n    border: 1px dashed #707070;\n    border-radius: 50%;\n    margin: auto;\n    padding: 14px;\n}\n.profileImg {\n    background: #e3e3e3;\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n}\n.profileImg.icon-user {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 145px;\n    color: #fff;\n}\n.editProfilePicSection {\n    overflow: hidden;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n}\n.editprofileImg:after {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    width: 172px;\n    height: 172px;\n    border: 2px solid #0b3454;\n    margin: auto;\n    border-radius: 50%;\n    box-shadow: 0 0 0 100px rgba(255, 255, 255, 0.5);\n}\n.small-thumb > .thumb + .thumb {\n    margin-left: -30px;\n}\n.small-thumb {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n}\n.thumb {\n    width: 60px;\n    display: inline-block;\n    height: 60px;\n    background: #fff;\n    border-radius: 50%;\n    padding: 3px;\n}\n#GaugeMeter_1 {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 113px;\n    position: relative;\n    flex-direction: column;\n}\n.percentage-score span {\n    line-height: 20px !important;\n    color: #000 !important;\n    font-weight: 500;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: flex-end;\n    justify-content: center;\n    z-index: 2;\n}\n.percentage-score span::after {\n    content: ' %';\n    font-size: 14px;\n    line-height: 14px;\n    margin-left: 3px;\n}\n#GaugeMeter_1 canvas {\n    position: absolute;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    margin: auto;\n}\n.percentage-score b {\n    line-height: 23px !important;\n    position: relative;\n    z-index: 2;\n    font-size: 12px;\n    font-weight: 500;\n    font-style: italic;\n}\n.alumni_directory_details .custom-border {\n    border-right: 1px solid #e8e8e8;\n}\n.slideRange {\n    -webkit-appearance: none;\n    appearance: none;\n    width: 100%;\n    height: 5px;\n    border-radius: 5px;\n    background: #d3d3d3;\n    outline: none;\n    opacity: 0.7;\n    -webkit-transition: 0.2s;\n    transition: opacity 0.2s;\n}\n.slideRange::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    appearance: none;\n    width: 14px;\n    height: 14px;\n    border: 0;\n    background: #5cae48;\n    cursor: pointer;\n    border-radius: 50%;\n}\n.slideRange::-moz-range-thumb {\n    width: 14px;\n    height: 14px;\n    border: 0;\n    background: #5cae48;\n    cursor: pointer;\n}\n.slideRange::-ms-thumb {\n    width: 14px;\n    height: 14px;\n    border: 0;\n    background: #5cae48;\n    cursor: pointer;\n    border-radius: 50%;\n}\n.slideRange::-webkit-range-progress {\n    background-color: #5cae48;\n    height: 5px;\n    border-radius: 5px;\n}\ninput[type='range'].slideRange::-moz-range-progress {\n    background-color: #5cae48;\n    height: 5px;\n    border-radius: 5px;\n}\ninput[type='range'].slideRange::-ms-fill-lower {\n    background-color: #5cae48;\n    height: 5px;\n    border-radius: 5px;\n}\n.basicInformation {\n    padding: 30px 20px 40px 0;\n}\n.basicInformation .phone_number {\n    line-height: 18px;\n}\n.profile_container {\n    background: #ffffff;\n    box-shadow: 0px 3px 6px #0000001a;\n    border: 1px solid #d2d2d2;\n    border-radius: 6px;\n    overflow: hidden;\n}\n.location-pin {\n    background: url(https://ap-south-1.console.aws.amazon.com/s3/object/media.univariety.com?region=ap-south-1&bucketType=general&prefix=userreactapp/style-images/pointer.png)\n        no-repeat 0 0;\n    width: 12px;\n    display: inline-block;\n    height: 16px;\n    margin-top: 9px;\n    vertical-align: top;\n    margin-right: 5px;\n}\n.btn:hover .location-pin {\n    filter: invert(1);\n    -webkit-filter: invert(1);\n}\n.contactrow .country-code {\n    width: 85px;\n    border-radius: 0.25rem 0 0 0.25rem;\n    border-right: 0 !important;\n}\n.contactrow #PhoneNumber {\n    width: calc(100% - 85px);\n    border-radius: 0 0.25rem 0.25rem 0;\n}\n.contactrow {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n}\n.profilenameclass .profilename {\n    line-height: 24px;\n}\n.profilenameclass .class {\n    line-height: 18px;\n}\n#profile_progress {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    width: 65px;\n    margin-right: 14px;\n}\n#profile_progress img {\n    border: 2px solid #fff;\n    border-radius: 50%;\n    width: 100%;\n}\n.profileLinks {\n    display: none;\n}\n.profile_videos {\n    height: 100%;\n    background: #00000033;\n    padding: 35px 0;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n.profile_video_block {\n    border: 4px solid #00000066;\n    border-radius: 6px;\n    max-width: 300px;\n    width: 100%;\n    position: relative;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    overflow: hidden;\n}\n.profile_video_block:hover {\n    border-color: #010000;\n}\n.profile_video_number {\n    font-size: 16px;\n    line-height: 16px;\n    margin-top: 15px;\n    color: #fff;\n}\n.profile_video_block .video_thumb_title {\n    text-align: center;\n    position: absolute;\n    bottom: -4px;\n    background: #000000;\n    border-radius: 6px 6px 0px 0px;\n    height: 45px;\n    width: 280px;\n    margin: auto;\n    left: 0;\n    right: 0;\n    font-size: 16px;\n    font-weight: 500;\n    color: #fff;\n    line-height: 45px;\n    -webkit-border-radius: 6px 6px 0px 0px;\n    -moz-border-radius: 6px 6px 0px 0px;\n    -ms-border-radius: 6px 6px 0px 0px;\n    -o-border-radius: 6px 6px 0px 0px;\n}\n.profile_video_block:hover .video_thumb_title {\n    color: #5cae48;\n}\n.profile_video_block .icon-invert-play {\n    position: absolute;\n    color: #000;\n    font-size: 41px;\n    width: 41px;\n    height: 41px;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    top: 0;\n    margin: auto;\n    background: #fff;\n    border-radius: 50%;\n    z-index: 9;\n}\n.profile_video_block:hover .icon-invert-play {\n    color: #5cae48;\n}\n.profile_videos_empty {\n    max-width: 282px;\n    width: 90%;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n}\n.profile_videos_empty p {\n    margin: 0 0 30px;\n    color: #fff;\n    text-align: center;\n    font-size: 15px;\n    line-height: 18px;\n}\n.profile_videos_empty span {\n    margin-bottom: 10px;\n}\n.profile_videos_empty .btn-white-border {\n    margin: 0;\n    height: 40px;\n    font-weight: 500;\n}\n.video_thumb img {\n    transition: all 0.5s ease-in-out;\n    -webkit-transition: all 0.5s ease-in-out;\n    -moz-transition: all 0.5s ease-in-out;\n    -ms-transition: all 0.5s ease-in-out;\n    -o-transition: all 0.5s ease-in-out;\n}\n.profile_video_block:hover img {\n    transform: scale(1.1);\n    -webkit-transform: scale(1.1);\n    -moz-transform: scale(1.1);\n    -ms-transform: scale(1.1);\n    -o-transform: scale(1.1);\n}\n.meter {\n    background: #ffffff;\n    border: 1px solid #dedede;\n    border-radius: 18px;\n    opacity: 1;\n    padding: 5px 15px;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n    margin-right: 5px;\n    letter-spacing: 0.32px;\n}\n.meter:hover {\n    box-shadow: 0px 0px 20px #00000033;\n}\n.meter:not(:last-child) {\n    margin-bottom: 5px;\n}\n.custom_breadcrumb {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    padding: 0 0;\n    margin-bottom: 0;\n    list-style: none;\n}\n.custom_breadcrumb-item {\n    padding-right: 0.5rem;\n}\n.custom_breadcrumb-item:not(.active)::after {\n    float: right;\n    padding-left: 0.5rem;\n    color: #d42941;\n    content: var(--bs-breadcrumb-divider, '/');\n}\n.custom_breadcrumb-item.active {\n    color: #000;\n}\n.search-icon {\n    padding-left: 40px;\n    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/search.svg);\n    background-size: 16px;\n    background-repeat: no-repeat;\n    background-position: 13px 13px;\n}\n.minus-marginx-30 {\n    margin-left: -30px;\n    margin-right: -30px;\n}\n.minus-paddingx-30 {\n    padding-left: 30px;\n    padding-right: 30px;\n}\n.padding-30 {\n    padding: 30px;\n}\n.p-40 {\n    padding: 40px;\n}\n.modal-content.copywriting {\n    padding: 40px;\n}\n.copywritecontainer {\n    overflow: auto;\n    max-height: 565px;\n    scrollbar-width: thin;\n}\n.copywriting .modal-header {\n    border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n    margin-bottom: 25px;\n    padding-bottom: 20px;\n}\n.copywriting .modal-header h5.modal-title {\n    font-size: 28px;\n    font-weight: 600;\n    margin-bottom: 5px;\n    line-height: 35px;\n}\n.copywriting .modal-header .sub-head {\n    font-size: 16px;\n    font-weight: 600;\n    margin-bottom: 16px;\n    color: #0b3454;\n}\n.copywriting .modal-header .sub-head span {\n    position: relative;\n}\n.copywriting .modal-header .sub-head span:not(:first-child):before {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    width: 5px;\n    height: 5px;\n    background: #000;\n    border-radius: 50%;\n}\n.copywriting .modal-header .sub-head span:not(:first-child) {\n    margin-left: 15px;\n    padding-left: 20px;\n}\n.btn-download {\n    background: #ffffff;\n    border: 1px solid #dedede;\n    border-radius: 18px;\n    opacity: 1;\n    font-size: 14px;\n    font-weight: 500;\n    font-family: 'Jost', sans-serif;\n    padding: 0 20px;\n    height: 32px;\n    display: flex;\n    align-items: center;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    color: #0b3454;\n}\n.btn-download:hover {\n    background: #dedede;\n}\n.btn-download span {\n    width: 13px;\n    height: 13px;\n    display: inline-block;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/download.svg) no-repeat 0 0;\n    margin-right: 5px;\n}\n.copywritecontainer h4 {\n    font-size: 16px;\n    font-weight: 600;\n}\n.copywritecontainer p {\n    font-size: 16px;\n    line-height: 23px;\n    margin-bottom: 30px;\n}\n.copywritecontainer p:last-child {\n    margin-bottom: 0px;\n}\n.copywritecontainer p a {\n    color: #000;\n}\n.copywritecontainer p a:hover {\n    color: #333;\n    text-decoration: none;\n}\n.copywritecontainer ul {\n    list-style: none;\n    padding: 0;\n    margin: 0 0 30px 19px;\n}\n.copywritecontainer ul li {\n    position: relative;\n    padding: 0 0 0 12px;\n    font-size: 16px;\n    line-height: 23px;\n}\n.copywritecontainer ul li:before {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 12px;\n    width: 5px;\n    height: 2px;\n    background: black;\n}\n.modal-content.viewRequests {\n    padding: 30px 40px;\n}\n.modal-content.viewRequests .modal-header h5.modal-title {\n    font-size: 24px;\n    font-weight: 600;\n}\n.modal-content.viewRequests .modal-header {\n    border: 0;\n    padding: 0;\n}\n.profileRow:not(:last-child) {\n    margin-bottom: 20px;\n    padding-bottom: 20px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n}\n.profileRow {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    justify-content: space-between;\n}\n.profile_link {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    margin-top: 10px;\n}\n.profileLeftSide {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n}\n.profileLeftSide .profileImg {\n    width: 60px;\n    height: 60px;\n    margin-right: 10px;\n}\n.profileLeftSide .profileLeftSideDetail {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n}\n.profileLeftSide .profileLeftSideDetail h3 {\n    font-size: 16px;\n    margin-bottom: 0;\n}\n.profileLeftSide .profileLeftSideDetail h3 span {\n    font-size: 14px;\n    font-style: italic;\n}\n.profileLeftSide .profileLeftSideDetail .profileUniversity {\n    font-size: 14px;\n    color: #646464;\n    font-style: italic;\n    font-weight: 500;\n}\n.profileLeftSide .profileLeftSideDetail p {\n    margin: 0;\n    font-size: 16px;\n    font-weight: 500;\n}\n.profileLeftSide .profileLeftSideDetail .profileUniversity span {\n    color: #000;\n}\n.profile_link .btn-border {\n    width: 70px;\n    margin: 0;\n}\n.alumni_college {\n    background: #ffffff;\n    border: 1px solid #d2d2d2;\n    border-radius: 6px;\n    position: relative;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    -webkit-border-radius: 6px;\n    -moz-border-radius: 6px;\n    -ms-border-radius: 6px;\n    -o-border-radius: 6px;\n}\n.alumni_college_yr {\n    position: absolute;\n    background: #0b3454;\n    border-radius: 0px 6px 0px 15px;\n    color: #fff;\n    height: 25px;\n    font-size: 14px;\n    padding: 0 14px;\n    top: -1px;\n    right: -1px;\n    line-height: 24px;\n}\n.alumni_college > div:not(.alumni_college_yr) {\n    /* padding: 15px; */\n}\n.alumni_college_bottom {\n    background: #f2f9ff;\n    border-radius: 0px 0px 6px 6px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    padding: 5px 15px 15px;\n}\n.alumni_college_top {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    align-items: center;\n    padding: 15px 15px 8px;\n}\n.alumni_college_top p {\n    margin: 0;\n    font-size: 18px;\n    font-weight: 600;\n}\n.alumni_college_profileimg {\n    margin-right: 20px;\n}\n.alumni_college_bottom label {\n    color: #d52941;\n    font-size: 13px;\n    font-weight: 500;\n}\n.CollegeLabel {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n}\n.courseLabel {\n    margin-right: 37px;\n    max-width: 120px;\n    width: 100%;\n}\n.alumni_college_bottom label + div {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    align-items: center;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 18px;\n}\n.alumni_college_bottom label + div span {\n    font-size: 16px;\n    font-weight: 500;\n}\n.alumni_college_bottom label + div span.alumni_university {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    margin-right: 7px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n}\n.video_block,\n.uni_profiles .video_block,\n.underGraduate-detail .video_block {\n    background: #ffffff;\n    border: 1px solid #d2d2d2;\n    border-radius: 6px;\n    overflow: hidden;\n    text-decoration: none;\n    position: relative;\n    display: inline-block;\n    color: #000;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    padding: 0;\n}\n.icon-invert-play {\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.uni_profiles .video_block:hover,\n.uni_profiles .video_block:hover .icon-invert-play,\n.video_block:hover,\n.video_block:hover .icon-invert-play {\n    color: #5cae48;\n    background: none;\n}\n.video_block_name {\n    background: #ffffff;\n    border-radius: 6px 6px 0px 0px;\n    opacity: 1;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: space-between;\n    padding: 0px 20px;\n    margin: -26px 11px 0;\n    position: relative;\n    align-items: center;\n    height: 78px;\n}\n.uni_profiles .video_block:hover .video_block_img img,\n.video_block:hover .video_block_img img {\n    transform: scale(1.1);\n    -webkit-transform: scale(1.1);\n    -moz-transform: scale(1.1);\n    -ms-transform: scale(1.1);\n    -o-transform: scale(1.1);\n}\n.uni_profiles .video_block_img {\n    overflow: hidden;\n    display: inline-block;\n}\n.uni_profiles .video_block_img img,\n.video_block_img img {\n    border-radius: 6px 6px 0 0;\n    transition: all 0.5s ease-in-out;\n    -webkit-transition: all 0.5s ease-in-out;\n    -moz-transition: all 0.5s ease-in-out;\n    -ms-transition: all 0.5s ease-in-out;\n    -o-transition: all 0.5s ease-in-out;\n}\n.uni_profiles .video_block_name .icon-invert-play,\n.video_block_name .icon-invert-play {\n    font-size: 30px;\n    color: #0b3454;\n}\n.uni_profiles .video_block_name label,\n.video_block_name label {\n    font-size: 18px;\n    font-weight: 600;\n    margin-right: 15px;\n    line-height: 22px;\n}\n.uni_profiles .video_block .video-btn,\n.video_block .video-btn {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n}\n#video_pop button.btn-close {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    background-color: #fff !important;\n    opacity: 1;\n    z-index: 999;\n    background-size: 40%;\n    width: 30px;\n    height: 30px;\n    border-radius: 50%;\n    padding: 0;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n#video_pop button.btn-close:hover {\n    background-color: #5cae48 !important;\n}\n#video_pop button.btn-close span {\n    display: none;\n}\n.profile-detail {\n    padding: 0;\n    margin: 10px 0 0;\n    list-style: none;\n    color: #fff;\n    font-size: 16px;\n    font-weight: 500;\n}\n.profile-detail li {\n    border-left: 4px solid #fff;\n    padding-left: 7px;\n}\n.profile-detail li:not(:last-child) {\n    margin-bottom: 20px;\n}\n.bullet ul {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n    color: #fff;\n}\n.bullet ul li:not(:last-child) {\n    margin-bottom: 20px;\n}\n.bullet ul li div.bullet_bg {\n    display: flex;\n    align-items: start;\n}\n.bullet ul li b {\n    width: 120px;\n    height: 41px;\n    display: flex;\n    align-items: center;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/bullet-bg.jpg);\n    padding-left: 17px;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 16px;\n    margin-right: 10px;\n}\n.bullet ul li {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n}\n.bullet ul li div.bullet_brife {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: start;\n}\n.bullet ul li div span {\n    width: auto;\n    position: relative;\n    line-height: 20px;\n}\n.bullet ul li div span.highlight {\n    width: auto;\n    position: relative;\n}\n.bullet ul li div span.highlight::after {\n    content: '';\n    position: absolute;\n    right: 0;\n    top: 3px;\n    width: 16px;\n    height: 25px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/subtraction.svg);\n    filter: brightness(0) invert(1);\n    display: none;\n}\n.bullet ul li div i.highlight {\n    width: 16px;\n    height: 25px;\n    display: inline-block;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/subtraction.svg);\n    margin-left: 5px;\n    margin-top: 1px;\n    filter: brightness(0) invert(1);\n    vertical-align: top;\n}\n.skillnactivityDetail {\n    max-width: 400px;\n    width: 100%;\n}\n.skillnactivityDetail h3 {\n    font-size: 18px;\n    font-weight: 600;\n    margin-bottom: 20px;\n}\n.skillnactivityDetail > div {\n    padding: 30px;\n    background: transparent linear-gradient(180deg, #ffffff 0%, #f8f8f8 100%);\n    border: 1px solid #e1e1e1;\n    border-radius: 6px;\n}\n.skillnactivityDetail > div.skillDetail {\n    margin-bottom: 20px;\n}\n.skillnactivityDetail h4 {\n    color: #d42941;\n    font-size: 14px;\n    font-weight: 500;\n    margin: 30px 0 5px;\n}\n.skillnactivityDetail .skillinterest {\n    font-size: 16px;\n    font-weight: 500;\n}\n.recentActivitycontainer {\n    max-height: 325px;\n    overflow-y: auto;\n    scrollbar-width: thin;\n}\n.recentActivitycontainer::-webkit-scrollbar {\n    width: 8px;\n}\n.recentActivitycontainer::-webkit-scrollbar-track {\n    background: #f0f0f0;\n}\n.recentActivitycontainer::-webkit-scrollbar-thumb {\n    background: #cdcdcd;\n}\n.recentActivitycontainer ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n}\n.recentActivitycontainer ul li {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n}\n.recentActivitycontainer ul li:not(:last-child) {\n    margin-bottom: 20px;\n}\n.recentActivitycontainer ul li .detail span {\n    display: block;\n    letter-spacing: 0.28px;\n    color: #0b3454;\n    font-size: 14px;\n    line-height: 20px;\n}\n.recentActivitycontainer ul li .detail {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    font-size: 16px;\n    line-height: 20px;\n    padding-top: 4px;\n}\n.recentActivitycontainer ul li i {\n    width: 48px;\n    height: 48px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #0b3454;\n    margin-right: 10px;\n    background: #ffffff;\n    border: 1px solid #0b34541a;\n}\n.year_section ul li > i {\n    background: #d1f1ff;\n    width: 48px;\n    height: 48px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-right: 10px;\n    font-size: 19px;\n    position: relative;\n    z-index: 1;\n}\n#alumniProfileTab {\n    border: 0;\n    flex-wrap: nowrap;\n    height: 44px;\n}\n#alumniProfileTab .nav-item:not(:last-child) {\n    margin-right: 10px;\n}\n#alumniProfileTab .nav-item .nav-link {\n    background: #ffffff;\n    border: 2px solid #7d7d7d;\n    border-radius: 20px;\n    width: 180px;\n    height: 40px;\n    padding: 0;\n    font-size: 16px;\n    font-weight: 500;\n    color: #414141;\n}\n#alumniProfileTab .nav-item .nav-link.active {\n    background: #0b3454;\n    border-color: #0b3454;\n    color: #fff;\n}\n.yearNumber {\n    position: relative;\n}\n.yearNumber label {\n    background: #26a7df;\n    border-radius: 6px;\n    height: 32px;\n    width: 90px;\n    text-align: center;\n    line-height: 32px;\n    color: #fff;\n    font-size: 16px;\n    font-weight: 600;\n}\n.year_section ul {\n    list-style: none;\n    padding: 20px 0 50px 20px;\n    margin: 0;\n    position: relative;\n}\n.year_section ul::before {\n    content: '';\n    position: absolute;\n    width: 2px;\n    height: 50px;\n    background: #d1f1ff;\n    left: 43px;\n    top: 0;\n    z-index: 0;\n}\n.year_section:not(:last-child) ul::after {\n    content: '';\n    position: absolute;\n    width: 2px;\n    height: 50px;\n    background: #d1f1ff;\n    left: 43px;\n    bottom: 0;\n    z-index: 0;\n}\n.year_section ul li:not(:last-child) {\n    margin-bottom: 30px;\n}\n.year_section ul li {\n    display: flex;\n    position: relative;\n}\n.year_section ul li::before {\n    content: '';\n    position: absolute;\n    width: 2px;\n    height: calc(100% + 30px);\n    background: #d1f1ff;\n    left: 23px;\n    top: 0;\n    z-index: 1;\n}\n.year_section ul li .brife {\n    display: flex;\n    align-items: start;\n    flex-wrap: wrap;\n    flex-direction: column;\n    justify-content: center;\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n}\n.year_section ul li .brife p {\n    margin: 0;\n    line-height: 23px;\n    font-size: 16px;\n}\n.year_section ul li > i.icon-hat::before {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/hat.svg);\n    width: 24px;\n    height: 23px;\n    background-size: 100%;\n}\n.year_section ul li .brife .offer {\n    position: relative;\n    padding-left: 40px;\n}\n.year_section ul li .brife .offer::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    width: 100%;\n    height: 2px;\n    margin: auto;\n    left: 0;\n}\n.year_section:last-child ul li:last-child:before {\n    opacity: 0;\n}\n.year_section ul li .brife .offer.joined::before {\n    background: #5cae48;\n}\n.year_section ul li .brife .offer.dintjoined::before {\n    background: #d52941;\n}\n.year_section ul li .brife .offer.joined {\n    color: #5cae48;\n}\n.year_section ul li .brife .offer.dintjoined {\n    color: #d52941;\n}\n.year_section ul li .brife .offer span {\n    position: relative;\n    background: #fff;\n    padding-left: 7px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    align-items: center;\n    font-size: 16px;\n    font-weight: 600;\n}\n.year_section ul li .brife .offer span i {\n    font-size: 16px;\n    margin-right: 7px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n}\n.year_section ul li .brife .offer span i.icon-correct-invert {\n    color: #5cae48;\n}\n.year_section ul li .brife .offer span i.icon-cross {\n    width: 16px;\n    height: 16px;\n    background: #d42941;\n    border-radius: 50%;\n    font-size: 6px;\n    color: #fff;\n}\n.achievementsBlocks {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n}\n.achievementsBlocks .icon {\n    width: 38px;\n    margin-right: 14px;\n}\n.achievementsBlocksDetails {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n}\n.achievementsBlocksDetails h2 {\n    font-size: 18px;\n    font-weight: 500;\n    margin: 11px 0 25px;\n}\n.achievementsBlocks:not(:last-child) {\n    padding-bottom: 30px;\n    margin-bottom: 35px;\n    border-bottom: 2px solid #e1e1e1;\n}\n.achievementsBlocksDetails h2 a {\n    color: #147ad6;\n    font-size: 14px;\n    line-height: 20px;\n    letter-spacing: 0.28px;\n    text-decoration: underline;\n}\n.achievementsBlocksDetails h2 a:hover {\n    text-decoration: none;\n    color: #0b3454;\n}\n.achievementsBlocksDetailsection .blockrow:not(:last-child) {\n    margin-bottom: 21px;\n}\n.achievementsBlocksDetailsection .blockrow {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n}\n.achievementsBlocksDetailsection .blockrow label {\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 20px;\n    width: 130px;\n}\n.achievementsBlocksDetailsection .blockrow .colon {\n    margin: 0 30px;\n    line-height: 16px;\n}\n.achievementsBlocksDetailsection .blockrow .brife {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    font-size: 14px;\n    line-height: 20px;\n    font-weight: 500;\n    letter-spacing: 0.32px;\n    max-width: 305px;\n}\n.achievementsBlocksDetailsection .blockrow .brife a {\n    text-decoration: underline;\n    color: #147ad6;\n}\n.achievementsBlocksDetailsection .blockrow .brife a:hover {\n    text-decoration: none;\n    color: #0b3454;\n}\n.contributionsSection > div:not(:last-child) {\n    margin-bottom: 40px;\n}\n.alumnislider .video_block_name label {\n    font-size: 16px;\n}\n.alumnislider .album_contblk h3 {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    -webkit-line-clamp: 2;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n}\n.contributionsSection > div:not(:last-child) {\n    margin-bottom: 40px;\n}\n.seactionheader {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 8px;\n    flex-wrap: wrap;\n}\n.countnbtn {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n.seactionheader h3 {\n    font-size: 24px;\n    margin: 0;\n}\n.countnbtn .count {\n    margin-right: 20px;\n    font-style: italic;\n    font-size: 14px;\n    color: #0b3454;\n}\n.custom-btns a {\n    display: inline-block;\n    color: #0b3454;\n    text-decoration: none;\n}\n.custom-btns a:hover {\n    color: #d42941;\n}\n.jobsandInternshipslist .act_lst > .row.postedrow > div:last-child,\n.jobsandInternshipslist .act_lst.actlst_listed > .row > div:last-child {\n    width: auto;\n}\n.nolisting {\n    background: #fff;\n    border: 1px solid #d2d2d2;\n    border-radius: 6px;\n    padding: 30px;\n    text-align: center;\n}\n.selected_univarsity {\n    background: #f8f8f8;\n    padding: 20px;\n    border-radius: 7px;\n    position: relative;\n}\n.selected-form-label {\n    background: #ffffff;\n    border-radius: 7px;\n    width: 100%;\n    height: 50px;\n    padding: 0 20px;\n    font-size: 16px;\n    display: flex;\n    align-items: center;\n    font-weight: 600;\n}\n.selected_univarsity .btn-cross {\n    position: absolute;\n    top: 22px;\n    right: -20px;\n    font-size: 8px;\n    color: #0b345480;\n}\n.dashboard.innerpage {\n    display: flex;\n    align-items: center;\n}\n.dashboard.innerpage .label {\n    margin-right: 15px;\n    font-weight: 500;\n}\n.uni_connect_sec {\n    border: 1px solid #d2d2d2;\n    border-radius: 6px;\n    padding: 10px 20px 10px 10px;\n}\n.logo-icon {\n    width: 50px;\n    height: 50px;\n    border: 1px solid #e3e2e2;\n    border-radius: 50%;\n    margin-right: 15px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.selected-prodile-invite > div {\n    background: #fff;\n    box-shadow: 0px 1px 1px #f1f1f1;\n    border: 1px solid #dedede;\n    border-radius: 7px;\n    padding: 10px 20px;\n    margin-top: 5px;\n    position: relative;\n}\n.selected-prodile-invite p.font-16 {\n    line-height: 16px;\n}\n.selected-prodile-invite p.font-14 {\n    line-height: 14px;\n}\n.selected-prodile-invite a {\n    text-decoration: none;\n    color: #000;\n}\n.selected-prodile-invite a:hover {\n    color: #5cae48;\n}\n.selected-prodile-invite a[class*='icon'] {\n    color: #535353;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    right: 15px;\n    height: 16px;\n    width: 16px;\n}\n.selected-prodile-invite a[class*='icon']:hover {\n    color: #000;\n}\n\n@media (min-width: 992px) {\n    body::before {\n        position: fixed;\n        top: 0;\n        bottom: auto;\n        right: 0;\n        left: 0;\n        margin: auto;\n        content: '';\n        background: rgba(0, 0, 0, 0.8);\n        width: 100%;\n        height: 0;\n        opacity: 0;\n        z-index: 1;\n        transition: unset;\n    }\n    .mouseHover::before {\n        height: 100%;\n        opacity: 1;\n        z-index: 1;\n        transition: unset;\n    }\n    body.mouseHover::before {\n        z-index: 9;\n    }\n    nav.custom-nav.offcanvas.offcanvas-start {\n        background: #0b3454;\n        height: 70px;\n        position: static;\n        visibility: visible !important;\n        transform: translateX(0);\n        width: 100%;\n        padding: 0;\n        -webkit-transform: translateX(0);\n        -moz-transform: translateX(0);\n        -ms-transform: translateX(0);\n        -o-transform: translateX(0);\n    }\n    nav.custom-nav.offcanvas.offcanvas-start ~ .offcanvas-backdrop.show {\n        display: none;\n    }\n    .custom-nav > ul {\n        max-width: 1155px;\n        margin: 0 auto;\n        position: relative;\n        z-index: 2;\n        width: 94%;\n    }\n    .custom-nav > ul > li > a.nav-link {\n        color: #fff;\n        position: relative;\n        z-index: -1;\n    }\n    .custom-nav > ul li.nav-item a.nav-link::before {\n        content: '';\n        width: 0;\n        height: 5px;\n        position: absolute;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        background: #5cae48;\n        margin: auto;\n        -webkit-transition: all 0.3s ease-in-out;\n        -moz-transition: all 0.3s ease-in-out;\n        -ms-transition: all 0.3s ease-in-out;\n        -o-transition: all 0.3s ease-in-out;\n        transition: all 0.3s ease-in-out;\n    }\n    .custom-nav > ul li.nav-item:hover a.nav-link::before,\n    .custom-nav > ul li.nav-item.active a.nav-link::before {\n        width: 100%;\n    }\n    .custom-nav > ul li.nav-item a.nav-link {\n        color: #fff;\n        text-transform: uppercase;\n        font-size: 14px;\n        font-weight: 500;\n        line-height: 54px;\n    }\n    .custom-nav > ul li.nav-item:hover a.nav-link {\n        color: #26a7df;\n    }\n    .custom-nav > ul > li > ul {\n        position: absolute;\n        background: #ffffff;\n        box-shadow: 0px 3px 6px #0000001a;\n        border: 1px solid #d2d2d2;\n        border-radius: 6px;\n        padding: 20px 30px;\n        width: max-content;\n        list-style: none;\n        left: -20px;\n    }\n    .custom-nav > ul > li > ul {\n        display: block !important;\n        z-index: -1;\n        opacity: 0;\n        top: 100px;\n        -webkit-transition: all 0.3s ease-in-out;\n        -moz-transition: all 0.3s ease-in-out;\n        -ms-transition: all 0.3s ease-in-out;\n        -o-transition: all 0.3s ease-in-out;\n        transition: all 0.3s ease-in-out;\n    }\n    .custom-nav > ul > li:hover > ul {\n        top: 55px;\n        opacity: 1;\n    }\n    .custom-nav > ul > li {\n        overflow: hidden;\n        margin: 0;\n    }\n    .custom-nav > ul > li:hover {\n        overflow: visible;\n    }\n    .custom-nav > ul > li:last-child > ul {\n        right: -10px;\n        left: auto;\n    }\n    .custom-nav > ul > li:hover > ul > li:not(:last-child) {\n        margin-bottom: 8px;\n    }\n    .custom-nav > ul > li:hover > ul > li > a {\n        color: #000;\n        text-decoration: none;\n        font-size: 16px;\n        font-weight: 500;\n        display: -webkit-box;\n        display: -moz-box;\n        display: -ms-flexbox;\n        display: -webkit-flex;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        padding: 0;\n        background: none;\n    }\n    .custom-nav > ul > li:hover > ul > li > a:hover,\n    .custom-nav > ul > li:hover > ul > li > ul li a:hover {\n        color: #26a7df;\n    }\n    .custom-nav > ul > li:hover > ul > li > a.gray-effect {\n        color: #8c8c8c;\n        cursor: default;\n    }\n    .custom-nav > ul > li:hover > ul > li > ul {\n        display: block;\n        position: absolute;\n        left: 80%;\n        top: -16px;\n        width: 250px;\n        padding: 0;\n        z-index: -1;\n        transition: all 0.3s ease-in-out;\n        opacity: 0;\n        background: #ffffff;\n        box-shadow: 0px 3px 6px #0000001a;\n        border: 1px solid #d2d2d2;\n        border-radius: 6px;\n        padding: 10px 20px;\n        -webkit-transition: all 0.3s ease-in-out;\n        -moz-transition: all 0.3s ease-in-out;\n        -ms-transition: all 0.3s ease-in-out;\n        -o-transition: all 0.3s ease-in-out;\n    }\n    .custom-nav > ul > li:hover > ul > li {\n        position: relative;\n    }\n    .custom-nav > ul > li:hover > ul > li:hover > ul {\n        left: 105%;\n        opacity: 1;\n    }\n    .custom-nav > ul > li:hover > ul > li > ul > li > a {\n        padding: 5px 15px;\n        display: block;\n        color: #000;\n        text-decoration: none;\n        font-size: 16px;\n        font-weight: 500;\n    }\n    .custom-nav > ul > li:hover > ul > li > ul li {\n        list-style: none;\n    }\n    .custom-nav > ul > li:hover > ul > li > a .icon.icon-arrow-right {\n        border-top: 2px solid #000;\n        border-right: 2px solid #000;\n        width: 10px;\n        height: 10px;\n        -moz-transform: rotate(45deg);\n        -webkit-transform: rotate(45deg);\n        -o-transform: rotate(45deg);\n        -ms-transform: rotate(45deg);\n        transform: rotate(45deg);\n        margin-right: 2px;\n    }\n    .custom-nav > ul > li:hover > ul > li:hover {\n        overflow: visible;\n    }\n}\n\n@media (max-width: 1199px) {\n    .search {\n        width: 30%;\n    }\n    .skillnactivityDetail {\n        max-width: 305px;\n        width: 100%;\n    }\n}\n\n@media (max-width: 1140px) {\n    .onboardingLaunchGraph ul li div,\n    .triangleGraph ul li div {\n        width: 65%;\n    }\n}\n\n@media (max-width: 991px) {\n    .mobileonly {\n        display: block;\n    }\n    .custom-nav {\n        width: 300px !important;\n        background: #0b3454;\n        padding: 0;\n        overflow-y: auto;\n    }\n    .manager_profile .profileSection {\n        display: none;\n    }\n    .logo {\n        display: -webkit-box;\n        display: -moz-box;\n        display: -ms-flexbox;\n        display: -webkit-flex;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n    }\n    .logo .btn-offcanvas {\n        border: 0;\n        background: none;\n        font-size: 0;\n        margin-right: 15px;\n    }\n    .btn-offcanvas .navbar-toggler-icon::before {\n        font-size: 0;\n        display: -webkit-box;\n        display: -moz-box;\n        display: -ms-flexbox;\n        display: -webkit-flex;\n        display: flex;\n        flex-direction: column;\n        justify-content: space-between;\n        align-items: flex-end;\n        background: none;\n        border: 0;\n        content: '';\n        width: 100%;\n        height: 3px;\n        background: #000;\n        -webkit-transition: all 0.3s ease-in-out;\n        -moz-transition: all 0.3s ease-in-out;\n        -ms-transition: all 0.3s ease-in-out;\n        -o-transition: all 0.3s ease-in-out;\n        transition: all 0.3s ease-in-out;\n    }\n    .btn-offcanvas .navbar-toggler-icon::after {\n        font-size: 0;\n        display: -webkit-box;\n        display: -moz-box;\n        display: -ms-flexbox;\n        display: -webkit-flex;\n        display: flex;\n        flex-direction: column;\n        justify-content: space-between;\n        align-items: flex-end;\n        background: none;\n        border: 0;\n        content: '';\n        width: 70%;\n        height: 3px;\n        background: #000;\n        -webkit-transition: all 0.3s ease-in-out;\n        -moz-transition: all 0.3s ease-in-out;\n        -ms-transition: all 0.3s ease-in-out;\n        -o-transition: all 0.3s ease-in-out;\n        transition: all 0.3s ease-in-out;\n    }\n    .btn-offcanvas .navbar-toggler-icon {\n        width: 20px;\n        height: 20px;\n        justify-content: space-between;\n        flex-direction: column;\n        display: -webkit-box;\n        display: -moz-box;\n        display: -ms-flexbox;\n        display: -webkit-flex;\n        display: flex;\n    }\n    .btn-offcanvas .navbar-toggler-icon b {\n        height: 3px;\n        width: 85%;\n        background: #000;\n        -webkit-transition: all 0.3s ease-in-out;\n        -moz-transition: all 0.3s ease-in-out;\n        -ms-transition: all 0.3s ease-in-out;\n        -o-transition: all 0.3s ease-in-out;\n        transition: all 0.3s ease-in-out;\n    }\n    body[style*='overflow:hidden'] .btn-offcanvas .navbar-toggler-icon b {\n        -moz-transform: scale(0);\n        -webkit-transform: scale(0);\n        -o-transform: scale(0);\n        -ms-transform: scale(0);\n        transform: scale(0);\n    }\n    body[style*='overflow:hidden'] .btn-offcanvas span.navbar-toggler-icon::before {\n        transform: translateY(10px) rotate(135deg);\n        -moz-transform: translateY(10px) rotate(135deg);\n        -webkit-transform: translateY(10px) rotate(135deg);\n        -webkit-transition: all 0.3s ease-in-out;\n        -moz-transition: all 0.3s ease-in-out;\n        -ms-transition: all 0.3s ease-in-out;\n        -o-transition: all 0.3s ease-in-out;\n        transition: all 0.3s ease-in-out;\n        width: 100%;\n        height: 3px !important;\n    }\n    body[style*='overflow:hidden'] .btn-offcanvas span.navbar-toggler-icon::after {\n        transform: translateY(-7px) rotate(-135deg);\n        -moz-transform: translateY(-7px) rotate(-135deg);\n        -webkit-transform: translateY(-7px) rotate(-135deg);\n        -webkit-transition: all 0.3s ease-in-out;\n        -moz-transition: all 0.3s ease-in-out;\n        -ms-transition: all 0.3s ease-in-out;\n        -o-transition: all 0.3s ease-in-out;\n        transition: all 0.3s ease-in-out;\n        width: 100%;\n        height: 3px !important;\n    }\n     header .offcanvas ~ .modal{z-index: 99999;}\n    #custom-nav {\n        margin: 0 !important;\n        padding: 10px 0 0;\n        width: 100%;\n    }\n    #custom-nav > li.mobileonly {\n        background: #fff;\n        padding: 0;\n        margin-bottom: 15px;\n    }\n    #custom-nav > li {\n        padding: 0 20px;\n    }\n    #custom-nav > li .nav-link {\n        display: -webkit-box;\n        display: -moz-box;\n        display: -ms-flexbox;\n        display: -webkit-flex;\n        display: flex;\n        justify-content: space-between;\n        color: #fff;\n        align-items: center;\n        font-size: 14px;\n        font-weight: 500;\n        text-transform: uppercase;\n    }\n    #custom-nav > li .nav-link .icon {\n        display: none;\n    }\n    #custom-nav > li.mobileonly ul {\n        padding: 0;\n        list-style: none;\n        margin-top: 0px;\n    }\n    #custom-nav > li.mobileonly ul li a {\n        width: 100%;\n        padding: 10px 0 10px 33px;\n        font-size: 16px;\n        color: #000;\n        font-weight: 500;\n        text-decoration: none;\n        display: block;\n        height: auto;\n        background-position: center left;\n        cursor: pointer;\n    }\n    #custom-nav > li.mobileonly ul li:not(:first-child) {\n        border-top: 1px solid #e3e3e3;\n    }\n    #custom-nav > li.mobileonly .profileSection {\n        margin-bottom: 17px;\n    }\n    #custom-nav > li.mobileonly .btn-close {\n        margin: 0;\n        opacity: 1;\n        position: absolute;\n        right: 12px;\n        top: 8px;\n        background-size: 12px auto;\n    }\n    #custom-nav > li .nav-link.nav-invite {\n        justify-content: start;\n        background: #5cae48;\n        border-radius: 25px;\n        padding: 10px 15px 10px 10px;\n        width: auto;\n    }\n    #custom-nav > li .nav-link.nav-invite:hover {\n        color: #ffff;\n        background: #408e2d;\n    }\n    .headerRightSide > ul > li:not(:last-child) {\n        margin-right: 30px;\n        display: none;\n    }\n    .search {\n        max-width: 275px;\n        padding: 0;\n        background: #f1f1f1;\n        border-radius: 20px;\n        height: 40px;\n        margin-left: auto;\n        margin-right: 30px;\n        width: 100%;\n    }\n    #custom-nav > li > ul {\n        list-style: none;\n        padding: 0 0 0 10px;\n    }\n    #custom-nav > li > ul > li a {\n        font-size: 16px;\n        color: #fff;\n        text-decoration: none;\n        display: -webkit-box;\n        display: -moz-box;\n        display: -ms-flexbox;\n        display: -webkit-flex;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n    }\n    #custom-nav > li > ul > li a.gray-effect {\n        cursor: default;\n        color: #335168;\n    }\n    #custom-nav li a {\n        width: 100%;\n        display: block;\n    }\n    #custom-nav > li > ul > li:not(:last-child) {\n        margin-bottom: 0px;\n    }\n    #custom-nav > li .nav-link:hover {\n        color: #5cae48;\n    }\n    #custom-nav > li > ul > li a:hover {\n        color: #5cae48;\n    }\n    #custom-nav > li > ul > li ul {\n        list-style: none;\n        padding: 0 0 0 15px;\n    }\n    .custom-nav > ul > li > ul > li > a .icon.icon-arrow-right {\n        border-top: 2px solid #fff;\n        border-right: 2px solid #fff;\n        width: 8px;\n        height: 8px;\n        -moz-transform: rotate(135deg);\n        -webkit-transform: rotate(135deg);\n        -o-transform: rotate(135deg);\n        -ms-transform: rotate(135deg);\n        transform: rotate(135deg);\n        margin-right: 2px;\n    }\n    .sideBar {\n        width: 100%;\n        overflow-y: auto;\n    }\n    .sideBar::-webkit-scrollbar {\n        display: none;\n    }\n    .sideBar {\n        -ms-overflow-style: none;\n        scrollbar-width: none;\n    }\n    .mainContainer {\n        background: none;\n        flex-direction: column;\n    }\n    .sideBar ul {\n        width: auto;\n        border-right: 0;\n        padding: 11px 0 0;\n        background: none;\n        height: 70px;\n        box-shadow: none;\n        display: -webkit-box;\n        display: -moz-box;\n        display: -ms-flexbox;\n        display: -webkit-flex;\n        display: flex;\n    }\n    .sideBar ul li {\n        display: inline-block;\n    }\n    .main:before {\n        width: 100%;\n        height: 70px;\n        box-shadow: 8px 10px 10px 0px #e8e8e8;\n        border-bottom: 1px solid #dbdbdb;\n    }\n    .pageContent {\n        padding: 0;\n    }\n    .sideBar ul li a > b {\n        width: 45px;\n        height: 45px;\n    }\n    .sideBar ul li a span {\n        width: auto;\n    }\n    .sideBar ul:hover {\n        width: auto;\n    }\n    .sideBar ul li a span b {\n        width: auto;\n        white-space: nowrap;\n    }\n    .sideBar ul li:not(:last-child) {\n        margin-right: 30px;\n    }\n    .sideBar ul:hover li a span {\n        width: auto;\n    }\n    .footer {\n        padding: 20px 0;\n    }\n    .onboardingLaunchGraph ul li label,\n    .triangleGraph ul li label {\n        font-size: 14px;\n    }\n    .onboardingLaunchGraph ul li div span::before,\n    .triangleGraph ul li div span::before {\n        border-width: 17px 10px 17px 10px;\n    }\n    .onboardingLaunchGraph ul li div span::after,\n    .triangleGraph ul li div span::after {\n        border-width: 17px 10px 17px 10px;\n    }\n    .onboardingLaunchGraph ul li div span,\n    .triangleGraph ul li div span {\n        font-size: 12px;\n    }\n    .onboardingLaunchGraph ul li div,\n    .triangleGraph ul li div {\n        width: 65%;\n        height: 35px;\n    }\n    .dashboardAccordion .accordion-item .accordion-body {\n        padding: 0 13px 20px;\n    }\n    #dashboard-pills-tab {\n        flex-wrap: inherit;\n        overflow: auto;\n        -ms-overflow-style: none;\n        scrollbar-width: none;\n    }\n    #dashboard-pills-tab::-webkit-scrollbar {\n        display: none;\n    }\n    .alumni_directory_details .bigVerticalProgress {\n        max-width: 990px;\n        width: max-content;\n    }\n    .alumni_directory_details .bigVerticalProgress .verticleProgress {\n        margin: 0 1% 20px;\n    }\n    .alumni_directory_details .tablesection > .table > .table {\n        max-width: 990px;\n        width: 990px;\n    }\n    .icn_details > .flex-1 {\n        float: left;\n        margin: 0 0 15px;\n        width: calc(100% - 70px);\n    }\n    .input-otp {\n        max-width: 50px;\n    }\n}\n\n@media (max-width: 800px) {\n    .sticky-notification .notification-detail {\n        flex-direction: column;\n        align-items: flex-start !important;\n        padding-left: 15px;\n        justify-content: center;\n    }\n    .sticky-notification .notification-detail p {\n        max-width: 100%;\n        margin-bottom: 10px;\n    }\n    .sticky-notification {\n        height: 130px;\n    }\n}\n\n@media (min-width: 768px) and (max-width: 991px) {\n    .dashboardAccordion .accordion-item .accordion-button {\n        padding: 20px 13px;\n    }\n    .dashboardAccordion .accordion-item .accordion-button span {\n        margin: 0 10px;\n    }\n    .participantsnumber > div {\n        display: -webkit-box;\n        display: -moz-box;\n        display: -ms-flexbox;\n        display: -webkit-flex;\n        display: flex;\n        flex-direction: column;\n    }\n    .courseLabel {\n        margin-right: 0;\n    }\n    .alumni_college_bottom {\n        flex-direction: column;\n    }\n    .btn .btn-green {\n        line-height: 14px;\n    }\n}\n\n@media (min-width: 768px) and (max-width: 890px) {\n    .achievementsBlocksDetailsection .blockrow {\n        flex-direction: column;\n    }\n    .achievementsBlocksDetailsection .blockrow .colon {\n        display: none;\n    }\n    .achievementsBlocksDetailsection .blockrow label::after {\n        content: ' :';\n    }\n    .achievementsBlocksDetailsection .blockrow label {\n        width: 100%;\n    }\n}\n\n@media (max-width: 767px) {\n    .btn-search-toggle {\n        font-size: 13px;\n        padding: 0;\n        width: 40px;\n        height: 40px;\n        display: -webkit-box;\n        display: -moz-box;\n        display: -ms-flexbox;\n        display: -webkit-flex;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        text-decoration: none;\n        color: #0b3454;\n    }\n    .search {\n        position: absolute;\n        right: 50px;\n        top: 24px;\n        width: 40px;\n        -webkit-transition: all 0.3s ease-in-out;\n        -moz-transition: all 0.3s ease-in-out;\n        -ms-transition: all 0.3s ease-in-out;\n        -o-transition: all 0.3s ease-in-out;\n        transition: all 0.3s ease-in-out;\n    }\n    .search form,\n    .search > div {\n        display: none !important;\n    }\n    .search.open {\n        width: 260px;\n        border: 1px solid #c8c8c8;\n    }\n    .search.open form,\n    .search.open > div {\n        display: -webkit-box !important;\n        display: -moz-box !important;\n        display: -ms-flexbox !important;\n        display: -webkit-flex !important;\n        display: flex !important;\n    }\n    .search.open .btn-search-toggle {\n        display: none;\n    }\n    .dashboard {\n        position: fixed;\n        z-index: 9;\n        height: 80px;\n        background: #fff;\n        bottom: 0;\n        right: 0;\n        width: 100%;\n        display: -webkit-box;\n        display: -moz-box;\n        display: -ms-flexbox;\n        display: -webkit-flex;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        box-shadow: 0px 4px 7px #92929259;\n        border-top: 1px solid #dbdbdb;\n    }\n    .dashboard .booksessionEnroll {\n        margin: 5px 0 0;\n    }\n    .dashboard.smart-scroll.scrolled-down {\n        transition: all 0.3s ease-in-out;\n        bottom: 0;\n        -webkit-transition: all 0.3s ease-in-out;\n        -moz-transition: all 0.3s ease-in-out;\n        -ms-transition: all 0.3s ease-in-out;\n        -o-transition: all 0.3s ease-in-out;\n    }\n    .dashboard.smart-scroll.scrolled-up {\n        bottom: 0;\n        transition: all 0.3s ease-in-out;\n        -webkit-transition: all 0.3s ease-in-out;\n        -moz-transition: all 0.3s ease-in-out;\n        -ms-transition: all 0.3s ease-in-out;\n        -o-transition: all 0.3s ease-in-out;\n    }\n    .dashboard.innerpage {\n        padding: 0 15px;\n        justify-content: center;\n    }\n    .footer {\n        flex-direction: column;\n        text-align: center;\n        padding: 20px;\n        margin: 0 0;\n    }\n    .powerby {\n        margin-top: 15px;\n    }\n    .powerby img {\n        max-width: 139px;\n        margin: auto;\n    }\n    .welcome-title h1,\n    .welcome-title p {\n        text-align: left;\n    }\n    .highlight-text {\n        margin: 20px 0;\n    }\n    .blue-container {\n        max-width: initial;\n        margin: 0 -13px 0;\n        width: auto;\n        border-radius: 0 0 5px 5px;\n        padding: 25px !important;\n    }\n    .dashboardAccordion .accordion-item .accordion-body {\n        padding: 0 13px 0px;\n    }\n    .dashboardAccordion .accordion-item {\n        box-shadow: 0px 3px 6px #0000001a;\n    }\n    .dashboardAccordion .accordion-item .accordion-button {\n        padding: 20px 13px 20px;\n    }\n    .dashboardAccordion .accordion-item .accordion-button[aria-expanded='true'] {\n        padding: 20px 13px 5px !important;\n    }\n    .bigVerticalProgress {\n        margin: 0 -1%;\n        justify-content: flex-start;\n    }\n    .bigVerticalProgress .verticleProgress {\n        width: 18%;\n        margin: 0 1% 20px;\n    }\n    .participants {\n        align-items: flex-start;\n    }\n    .participants label {\n        text-align: left;\n    }\n    #pills-student .accordion-item .accordion-body > .row > div.col-md-6:first-child {\n        margin-bottom: 25px;\n    }\n    #pills-student .accordion-item .accordion-body > .row.pt-3 {\n        padding-top: 0 !important;\n    }\n    .school_notification li .check {\n        display: -webkit-box;\n        display: -moz-box;\n        display: -ms-flexbox;\n        display: -webkit-flex;\n        display: flex;\n        justify-content: flex-end;\n        align-items: center;\n        width: 100%;\n        margin-top: 15px;\n    }\n    .school_notification li .check span {\n        margin-right: 5px;\n    }\n    .alumni_directory_details .custom-border {\n        border-right: 0;\n        border-bottom: 1px solid #e8e8e8;\n        padding-bottom: 25px;\n        margin-bottom: 20px;\n    }\n    .profileRow {\n        flex-direction: column;\n    }\n    .courseLabel {\n        margin-right: 0;\n    }\n    .alumni_college_bottom {\n        flex-direction: column;\n    }\n    .profile_videos {\n        margin: 0 -19px;\n    }\n    .skillnactivityDetail {\n        max-width: 100%;\n    }\n}\n\n@media (max-width: 575px) {\n    .search {\n        right: 38px;\n    }\n    .overlaystick.aos-animate {\n        position: fixed;\n        left: 0;\n        bottom: 0;\n        right: 0;\n        top: 0;\n        background: rgba(0, 0, 0, 0.7);\n        z-index: 9;\n        display: flex;\n        align-items: flex-end;\n    }\n    .overlaystick.aos-animate .sticky-notification {\n        border-radius: 60px 60px 0 0 / 60px 60px 0 0;\n        height: 231px;\n        left: 0;\n        right: 0;\n        margin: 0;\n        width: 100%;\n    }\n    .overlaystick.aos-animate .sticky-notification > .imgplace {\n        display: none;\n    }\n    .overlaystick.aos-animate .sticky-notification .notification-detail {\n        padding: 20px 20px 0;\n        justify-content: flex-end;\n    }\n    .overlaystick.aos-animate .sticky-notification .notification-detail p {\n        text-align: center;\n        max-width: 100%;\n        margin: 0 auto 20px;\n    }\n    .imglink {\n        max-width: 100%;\n        display: -webkit-box;\n        display: -moz-box;\n        display: -ms-flexbox;\n        display: -webkit-flex;\n        display: flex;\n        justify-content: space-around;\n    }\n    .imglink .imgplace {\n        display: block;\n    }\n    .sticky-notification .notification-detail .links {\n        display: -webkit-box;\n        display: -moz-box;\n        display: -ms-flexbox;\n        display: -webkit-flex;\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        text-align: center;\n    }\n    .sticky-notification .notification-detail .links .btn-green {\n        margin-bottom: 13px;\n    }\n    .sticky-notification .notification-detail .links a {\n        max-width: 190px;\n        width: 100%;\n    }\n    .overlaystick.aos-animate .sticky-notification .btn-close {\n        left: 0;\n        right: 0;\n        width: 40px;\n        height: 40px;\n        margin: auto;\n        border: 2px solid #fff;\n        border-radius: 50%;\n        background: none;\n        display: -webkit-box;\n        display: -moz-box;\n        display: -ms-flexbox;\n        display: -webkit-flex;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        font-size: 16px;\n        top: -75px;\n    }\n    .dashboardAccordion .accordion-item .accordion-button {\n        padding: 20px 13px;\n    }\n    .dashboardAccordion .accordion-item .accordion-button span {\n        margin: 0 10px;\n    }\n    .onboardingLaunchGraph ul li label,\n    .onboardingLaunchGraph ul li label {\n        font-size: 14px;\n    }\n    .onboardingLaunchGraph ul li div span::before,\n    .onboardingLaunchGraph ul li div span::before {\n        border-width: 17px 10px 17px 10px;\n    }\n    .onboardingLaunchGraph ul li div span::after {\n        border-width: 17px 10px 17px 10px;\n    }\n    .onboardingLaunchGraph ul li div span {\n        font-size: 12px;\n    }\n    .onboardingLaunchGraph ul li div {\n        width: 65%;\n        height: 35px;\n    }\n    .dashboardAccordion .accordion-item .accordion-body {\n        padding: 0 13px;\n    }\n    .milestoneProgressGraph {\n        justify-content: center;\n        margin: 0 -5px;\n    }\n    .milestoneGraph {\n        width: 29%;\n        margin: 0px 5px 30px;\n    }\n    .bigVerticalProgress .verticleProgress {\n        width: 23%;\n    }\n    .white-block {\n        padding: 15px;\n    }\n    .profile_radiorow > .icon-cross {\n        right: -18px;\n        padding: 5px;\n    }\n    .btn-white-border {\n        padding: 0 15px;\n    }\n    .courseLabel {\n        margin-right: 20px;\n    }\n    .alumni_college_bottom {\n        flex-direction: row;\n    }\n    .achievementsBlocksDetailsection .blockrow {\n        flex-direction: column;\n    }\n    .achievementsBlocksDetailsection .blockrow .colon {\n        display: none;\n    }\n    .achievementsBlocksDetailsection .blockrow label::after {\n        content: ' :';\n    }\n    .achievementsBlocksDetailsection .blockrow label {\n        width: 100%;\n    }\n    .selected_univarsity .btn-cross {\n        top: 8px;\n        right: 8px;\n    }\n}\n\n@media (max-width: 480px) {\n    .sticky-notification {\n        height: 210px;\n        flex-direction: row-reverse;\n    }\n    .sticky-notification .notification-detail .links {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n    .sticky-notification .notification-detail .links .btn-green {\n        margin-bottom: 15px;\n    }\n    .eventDetails {\n        flex-direction: column;\n        align-items: center;\n    }\n    .eventType {\n        flex: 0;\n        width: 100%;\n        flex-basis: 100%;\n        margin: 20px 0;\n        padding: 0;\n        flex-direction: column;\n        display: -webkit-box;\n        display: -moz-box;\n        display: -ms-flexbox;\n        display: -webkit-flex;\n        display: flex;\n        align-items: center;\n    }\n    .eventDetails .datedetail {\n        margin: 0;\n    }\n    .hostby {\n        flex-direction: column;\n        padding-top: 20px;\n    }\n    .hostImg {\n        margin: 0 0 14px;\n    }\n    .hostNamePosition {\n        text-align: center;\n    }\n    .participants {\n        align-items: center;\n    }\n    .eventType h2 {\n        text-align: center;\n        margin-bottom: 20px;\n    }\n}\n\n.overlaystick.hide {\n    display: none;\n}\n.btn-verify {\n    background: linear-gradient(to right, #185584 50%, #0d3453 50%);\n    color: #fff;\n    width: 140px;\n    height: 40px;\n    line-height: 38px;\n    padding: 0 25px;\n    text-decoration: none;\n    border-radius: 25px;\n    text-align: center;\n    background-size: 200% 100%;\n    transition: all 0.5s;\n    background-position: right bottom;\n    border: 1px solid #0d3453;\n    font-size: 16px;\n    font-weight: 400;\n    -webkit-transition: all 0.5s;\n    -moz-transition: all 0.5s;\n    -ms-transition: all 0.5s;\n    -o-transition: all 0.5s;\n}\n.btn-border {\n    background: linear-gradient(to right, #185584 50%, #0d3453 50%);\n    color: #fff;\n    width: max-content;\n    height: 40px;\n    line-height: 38px;\n    padding: 0 25px;\n    text-decoration: none;\n    border-radius: 25px;\n    text-align: center;\n    background-size: 200% 100%;\n    transition: all 0.5s;\n    background-position: right bottom;\n    border: 1px solid #0d3453;\n    font-size: 16px;\n    font-weight: 500;\n    display: flex;\n    margin: 0 auto;\n    justify-content: center;\n    align-items: center;\n}\n.btn-border:hover,\n.btn-verify:hover {\n    background-position: left bottom;\n    color: #fff;\n    background-size: 201% 100%;\n}\n.icn_details .btn-green {\n    width: 140px;\n}\n.icn_details .btn-green span {\n    font-weight: 500;\n    font-size: 16px;\n}\n.icn_details .btn-green span.icon-correct::before {\n    font-size: 13px;\n}\na.dashb_arr {\n    width: 40px;\n    height: 40px;\n    background: #f1f1f1;\n    border-radius: 50%;\n    position: relative;\n    display: inline-block;\n}\na.dashb_left::before {\n    content: '';\n    width: 8px;\n    height: 8px;\n    background: transparent;\n    display: inline-block;\n    position: absolute;\n    left: 17px;\n    top: 0;\n    bottom: 0;\n    right: auto;\n    margin: auto;\n    border-top: 1.5px solid #000;\n    border-right: 1.5px solid #000;\n    transform: rotate(-135deg);\n    -webkit-transform: rotate(-135deg);\n    -moz-transform: rotate(-135deg);\n    -ms-transform: rotate(-135deg);\n    -o-transform: rotate(-135deg);\n}\na.dashb_right::before {\n    content: '';\n    width: 8px;\n    height: 8px;\n    background: transparent;\n    display: inline-block;\n    position: absolute;\n    left: 15px;\n    top: 0;\n    bottom: 0;\n    right: auto;\n    margin: auto;\n    border-top: 1.5px solid #000;\n    border-right: 1.5px solid #000;\n    transform: rotate(45deg);\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n}\n.iconsec {\n    height: 50px;\n    width: 50px;\n    background: #d42941;\n    border-radius: 50%;\n}\n.iconsec > b {\n    color: #fff;\n    font-size: 23px;\n}\n.icn_details {\n    background: #ffffff;\n    box-shadow: 0px 3px 6px #0000001a;\n    border: 1px solid #d2d2d2;\n    border-radius: 6px;\n    padding: 25px 30px;\n}\n.iconsec_title {\n    font-weight: 500;\n    font-size: 18px;\n    color: #000;\n    margin: 0 0 8px;\n}\n.iconsec_cont {\n    font-weight: 400;\n    font-size: 16px;\n    color: #000;\n    display: none;\n    margin: 0 0 8px;\n}\n.iconsec_link {\n    text-decoration: underline;\n    color: #147ad6;\n    font-size: 14px;\n}\n.iconsec_link:hover {\n    text-decoration: none;\n}\n.iconsec_link .readmore {\n    display: block;\n}\n.iconsec_link .readless {\n    display: none;\n}\n.iconsec_link.active .readmore {\n    display: none;\n}\n.iconsec_link.active .readless {\n    display: block;\n}\n.profile_setup {\n    width: 100%;\n    max-width: 682px;\n}\n.profile_setup_help {\n    width: 100%;\n    max-width: 304px;\n    height: auto;\n    background: transparent linear-gradient(180deg, #ffffff 0%, #f8f8f8 100%) 0% 0% no-repeat padding-box;\n    border: 1px solid #e1e1e1;\n    border-radius: 6px;\n    padding: 30px;\n    text-align: center;\n}\n.profile_setup > div:not(:last-child) {\n    margin: 0 0 15px;\n}\n.container.my-5.profile_setup_cont {\n    max-width: 100%;\n}\n.profile_setup_help > p:first-child {\n    width: 100%;\n    margin: auto;\n    text-align: center;\n    max-width: 190px;\n}\n.custom-nav > ul li.nav-item a.nav-link.dropdown-toggle::after {\n    margin-left: 17px;\n    vertical-align: middle;\n    border-top: 7px solid;\n    border-right: 5px solid transparent;\n    border-left: 5px solid transparent;\n}\n.activities_status_hovercont ol {\n    margin: 0 0 0 20px;\n    padding: 0 10px 0 0;\n    text-align: left;\n}\n.activities_status_hovercont ol li {\n    line-height: 18px;\n}\n.activities_status_hovercont ol li:not(:last-child) {\n    margin: 0 0 8px 0;\n}\n.activities_status_hovercont {\n    background: #fff;\n    border: 1px solid #d2d2d2;\n    border-radius: 6px;\n    padding: 20px;\n    width: 270px;\n    height: 165px;\n    position: absolute;\n    top: -30px;\n    left: 0;\n    right: 0;\n    margin: auto;\n    box-shadow: 0px 3px 6px #0000001a;\n    display: none;\n}\n.activities_status_hovercont::after {\n    position: absolute;\n    content: '';\n    width: 23px;\n    height: 18px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/hover_after.png) left top no-repeat;\n    bottom: -18px;\n}\n.activities_status_hovercont > div {\n    height: 125px;\n    overflow-y: scroll;\n    scrollbar-width: thin;\n    font-size: 14px;\n    font-weight: 400;\n}\n.activities_status:hover .activities_status_hovercont {\n    display: block;\n    color: #000;\n}\n.activities_status:hover {\n    color: #26a7df;\n}\n.activities_status_hovercont > div::-webkit-scrollbar {\n    scrollbar-width: thin;\n}\n.profile_setup > div.icn_details:first-child .iconsec_cont {\n    display: block;\n}\n.dashboardAccordion .accordion-item .accordion-button:hover {\n    box-shadow: 0px 0px 5px #0000001a;\n    background: #fafafa;\n    border-radius: 5px;\n}\n.dashboardAccordion .accordion-item .accordion-button[aria-expanded='true']:hover {\n    box-shadow: unset;\n    background: transparent;\n    border-radius: 5px;\n}\n.float_horizontal_animate {\n    transform: translatex(0px);\n    animation: float_horizontal 4s ease-in-out infinite;\n    -webkit-animation: float_horizontal 4s ease-in-out infinite;\n    -webkit-transform: translatex(0px);\n    -moz-transform: translatex(0px);\n    -ms-transform: translatex(0px);\n    -o-transform: translatex(0px);\n}\n\n@keyframes float_horizontal {\n    0% {\n        transform: translatex(0px);\n        -webkit-transform: translatex(0px);\n        -moz-transform: translatex(0px);\n        -ms-transform: translatex(0px);\n        -o-transform: translatex(0px);\n    }\n    50% {\n        transform: translatex(-10px);\n        -webkit-transform: translatex(-10px);\n        -moz-transform: translatex(-10px);\n        -ms-transform: translatex(-10px);\n        -o-transform: translatex(-10px);\n    }\n    100% {\n        transform: translatex(0px);\n        -webkit-transform: translatex(0px);\n        -moz-transform: translatex(0px);\n        -ms-transform: translatex(0px);\n        -o-transform: translatex(0px);\n    }\n}\n\n@media (max-width: 1080px) {\n    .profile_setup_cont .profile_setup_help {\n        width: 274px;\n    }\n    .profile_setup_cont .profile_setup {\n        width: calc(100% - 300px);\n    }\n}\n\n@media (max-width: 767px) {\n    .icn_details {\n        display: block !important;\n    }\n    .iconsec {\n        float: left;\n    }\n    .icn_details > .flex-1 {\n        float: left;\n        margin: 0 0 15px;\n        width: calc(100% - 70px);\n    }\n    .btn-verify,\n    .icn_details .btn-green {\n        display: -webkit-box;\n        display: -moz-box;\n        display: -ms-flexbox;\n        display: -webkit-flex;\n        display: flex;\n        clear: both;\n        margin: 0 auto 0 !important;\n        float: none;\n        text-align: center;\n        justify-content: center;\n    }\n    .profile_setup_cont .row > .profile_setup {\n        width: 100%;\n        margin: 0 0 30px 0;\n    }\n    .profile_setup_cont .row > .profile_setup_help {\n        width: 100%;\n        border-radius: 0;\n        border-left: 0 solid #fff;\n        border-right: 0 solid #fff;\n        border-bottom: 0 solid #fff;\n    }\n    .max-1140.profile_container {\n        width: 100%;\n    }\n    .profile_container .sideBar {\n        width: 94%;\n        margin: auto;\n    }\n    .profile_container .pageContent > div:first-child {\n        width: 94%;\n        margin: auto;\n        padding-top: 35px !important;\n    }\n    .profile_container .pageContent > div:first-child .welcome-title {\n        width: 100%;\n    }\n    .profile_container .container.profile_setup_cont {\n        width: 100%;\n        margin: 25px auto 25px !important;\n    }\n    .profile_setup_cont .row > .profile_setup {\n        width: 94%;\n        margin: 0 auto 30px auto;\n    }\n    .profile_container .footer {\n        margin: 0;\n    }\n    .dashboard .btn-green {\n        order: 1;\n        margin: 0 15px;\n    }\n    .dashboard .dashb_left {\n        order: 0;\n        margin: 0 !important;\n    }\n    .dashboard .dashb_right {\n        order: 2;\n    }\n    .profile_container .welcome-title h1 {\n        font-size: 30px;\n    }\n    .profile_setup_help > p:first-child {\n        width: 100%;\n    }\n    .profile_setup_help {\n        margin-top: 30px;\n        max-width: 100%;\n        margin-bottom: 25px;\n    }\n    .milestoneSection .white-block {\n        padding: 15px;\n    }\n}\n\n@media (max-width: 575px) {\n    .profile_container .container.profile_setup_cont {\n        margin: 25px auto 0 !important;\n    }\n    .icn_details {\n        display: flex !important;\n        flex-direction: column;\n        justify-content: center !important;\n        align-items: center;\n    }\n    .icn_details > .flex-1 {\n        width: 100%;\n    }\n    .iconsec_title {\n        margin: 20px 0 10px;\n        text-align: left;\n    }\n    .iconsec_link,\n    .iconsec_cont {\n        text-align: center;\n    }\n    .minus-paddingx-30 {\n        padding-left: 15px;\n        padding-right: 15px;\n    }\n    .padding-30 {\n        padding: 15px;\n    }\n    .copywriting .modal-header > div:first-child {\n        flex-direction: column;\n        align-items: start !important;\n        margin-bottom: 20px;\n    }\n    .modal-content.viewRequests {\n        padding: 15px 20px;\n    }\n}\n\n@media (max-width: 380px) {\n    .bullet ul li div span {\n        margin-top: -4px;\n    }\n}\n.sideBar li a > b:first-child,\n.headerRightSide > ul > li > a,\n.pageContent > .container > .row > div .milestone > .icon > span,\n.milestone > .icon > span,\n.icn_details .iconsec > b,\n.user-dropdown ul li a b,\n.swingtag .swingicon {\n    -webkit-animation-name: bounceIn;\n    animation-name: bounceIn;\n    -webkit-transform-origin: center bottom;\n    -ms-transform-origin: center bottom;\n    transform-origin: center bottom;\n    -webkit-animation-duration: 1s;\n    animation-duration: 1s;\n    -webkit-animation-fill-mode: both;\n    animation-fill-mode: both;\n    -webkit-animation-iteration-count: 1;\n    animation-iteration-count: 1;\n}\n.sideBar li:hover a > b:first-child,\n.headerRightSide > ul > li:hover > a,\n.pageContent > .container > .row > div:hover .milestone > .icon > span,\n.milestone:hover > .icon > span,\n.icn_details:hover .iconsec > b,\n.user-dropdown ul li a:hover b,\n.swingtag:hover .swingicon {\n    -webkit-transform-origin: top center;\n    -ms-transform-origin: top center;\n    transform-origin: top center;\n    -webkit-animation-name: swing;\n    animation-name: swing;\n}\n.sideBar li.active:hover a > b:first-child,\n.headerRightSide > ul li a.invite {\n    -webkit-animation-name: unset;\n    animation-name: unset;\n}\n\n@keyframes swing {\n    20% {\n        -webkit-transform: rotate3d(0, 0, 1, 15deg);\n        transform: rotate3d(0, 0, 1, 15deg);\n    }\n    40% {\n        -webkit-transform: rotate3d(0, 0, 1, -10deg);\n        transform: rotate3d(0, 0, 1, -10deg);\n    }\n    60% {\n        -webkit-transform: rotate3d(0, 0, 1, 5deg);\n        transform: rotate3d(0, 0, 1, 5deg);\n    }\n    80% {\n        -webkit-transform: rotate3d(0, 0, 1, -5deg);\n        transform: rotate3d(0, 0, 1, -5deg);\n    }\n    100% {\n        -webkit-transform: rotate3d(0, 0, 1, 0deg);\n        transform: rotate3d(0, 0, 1, 0deg);\n    }\n}\n.tooltip-inner {\n    background: #0b3454;\n    border: 1px solid #0b3454;\n}\n.bs-tooltip-top .tooltip-arrow::before {\n    border-top-color: #0b3454;\n}\na.text-burgandi:hover {\n    color: #d42941;\n}\n.welcome-title + .dashboard {\n    margin-left: 100px;\n}\n.custom-nav > ul li.nav-item a.nav-link.dropdown-toggle.dashboardnav::after,\n.interestsPreferences_sidebar,\n.achievements_sidebar {\n    display: none;\n}\n.profile_setup .btn-verify {\n    padding: 0 15px;\n}\n.alumni-directory-block .icon-right-arrow:hover {\n    color: #0b3454;\n}\n.aldir_scroll > .row > .aldir_box {\n    width: 212px;\n    height: 133px;\n    padding: 0;\n}\n.aldir_scroll > .row > .aldir_box:not(:last-child) {\n    margin-right: 20px;\n}\n.aldir_box .number {\n    padding: 10px 12px 0 20px;\n}\n.aldir_box .number + div > div.font-16 {\n    color: #0b3454;\n    line-height: 18px;\n    padding: 8px 0 0 18px;\n}\n.aldir_box .alumni-directory-img {\n    margin-right: 10px;\n    display: flex;\n    align-items: flex-end;\n}\n.aldir_box .alumni-directory-block {\n    justify-content: space-between;\n    flex-direction: row;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n}\n.aldir_box .alumni-directory-block.active {\n    background: linear-gradient(-30deg, #fff, #41edff);\n}\n.aldir_box .alumni-directory-block > div {\n    width: 100%;\n}\n.aldir_box .number + div > div.font-16.min94 {\n    min-width: 94px;\n}\n.aldir_scroll > .row {\n    width: max-content;\n    margin: 0;\n}\n.profile_pic .profile_picedt {\n    height: 24px;\n    width: 24px;\n    background: #5cae48;\n    border-radius: 50%;\n    text-align: center;\n    top: 0px;\n    right: -4px;\n}\n.phone_number.max-135 {\n    max-width: 135px;\n}\n.btn-white-border.verifynow {\n    padding: 0 20px;\n    height: 30px;\n    line-height: 26px;\n    border: 2px solid #e1e1e1;\n}\n.btn-white.locbtn:hover .text-dark-blue {\n    color: #fff;\n}\n.btn-white.locbtn {\n    line-height: 14px;\n}\n.locbtncol {\n    justify-content: flex-end;\n    align-items: center;\n}\n.height-40 {\n    height: 40px !important;\n    line-height: 40px;\n}\n.height-45 {\n    height: 45px !important;\n    line-height: 45px;\n}\n.height-28 {\n    height: 28px !important;\n}\n.height-36 {\n    height: 36px !important;\n}\n.line-height-18 {\n    line-height: 18px;\n}\n.line-height-26 {\n    line-height: 26px;\n}\n.text-gray-e1 {\n    color: #e1e1e1;\n}\n.text-gray-98 {\n    color: #989898;\n}\n.text-black {\n    color: #000;\n}\n.font-35 {\n    font-size: 35px;\n}\n.me5 {\n    margin-right: 5px;\n}\n.me10 {\n    margin-right: 10px;\n}\n.mb-10 {\n    margin-bottom: 10px !important;\n}\n.mb-20 {\n    margin-bottom: 20px;\n}\n.mt-20 {\n    margin-top: 20px;\n}\n.mt-30 {\n    margin-top: 30px;\n}\n.mb-30 {\n    margin-bottom: 30px;\n}\n.mt-38 {\n    margin-top: 38px;\n}\n.mt-39 {\n    margin-top: 39px;\n}\n.mt-40 {\n    margin-top: 40px;\n}\n.mb-40 {\n    margin-bottom: 40px;\n}\n.mt-43 {\n    margin-top: 43px;\n}\n.mt-42 {\n    margin-top: 42px;\n}\n.ps-20 {\n    padding-left: 20px;\n}\n.xscroll {\n    width: 100%;\n    overflow-x: auto;\n    scrollbar-width: thin;\n    position: relative;\n    z-index: 8;\n}\n.max-400 {\n    max-width: 400px !important;\n    width: 90% !important;\n}\n.max-464 {\n    max-width: 464px !important;\n    width: 90%;\n}\n.max-480 {\n    max-width: 480px !important;\n    width: 90%;\n}\n.border-lightgray {\n    background: #f3f3f3;\n    height: 1px;\n    width: 100%;\n    display: block;\n}\n.border-gray-e2 {\n    background: #e2e2e2;\n    height: 1px;\n    width: 100%;\n    display: block;\n}\n.border-gray-dc {\n    background: #dcdcdc;\n    height: 1px;\n    width: 100%;\n    display: block;\n}\n.border-radius-6 {\n    border-radius: 6px;\n    -webkit-border-radius: 6px;\n    -moz-border-radius: 6px;\n    -ms-border-radius: 6px;\n    -o-border-radius: 6px;\n}\n.w-max-content {\n    width: max-content !important;\n}\n.bg-skyblue {\n    background: #26a7df;\n}\n.bg-purple {\n    background: #51499c;\n}\n.btn-darkblue {\n    background: #0b3454;\n    border-radius: 27px;\n    height: 40px;\n    padding: 0 25px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: #fff;\n    text-decoration: none;\n    font-size: 16px;\n    line-height: 16px;\n    font-weight: 500;\n    position: relative;\n    overflow: hidden;\n    border: 0;\n}\n.btn-darkblue:hover{\n    background-color: #0b3454;\n    color: #fff;\n}\n\n.btn-green-msg:hover,\n.btn-pink-msg:hover {\n    color: #fff;\n}\n.btn-darkblue span,\n.btn-green-msg span,\n.btn-pink-msg span {\n    position: relative;\n}\n.btn-darkblue::before {\n    position: absolute;\n    content: '';\n    left: 0;\n    top: 0;\n    bottom: 0;\n    width: 0;\n    background: #08273f;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n}\n.btn-darkblue:hover::before,\n.btn-green-msg:hover::before,\n.btn-pink-msg:hover::before {\n    width: 100%;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n}\n.btn-icon-bg,\n.circle-effect {\n    background: #fff;\n    position: relative;\n}\n.btn-icon-bg:hover,\n.circle-effect:hover,\n.btn-icon-bg:hover span,\n.listblk_icon:hover > span.icon,\n.album_shareblk > a.btn.btnicon:hover span.icon {\n    color: #fff;\n}\n.btn-icon-bg span,\n.circle-effect span {\n    position: relative;\n}\n.btn-icon-bg::before {\n    position: absolute;\n    content: '';\n    left: 0;\n    top: 0;\n    bottom: 0;\n    width: 0;\n    background: #08273f;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n}\n.btn-icon-bg:hover img {\n    filter: brightness(0) invert(1);\n    -webkit-filter: brightness(0) invert(1);\n}\n.circle-effect::before {\n    position: absolute;\n    content: '';\n    left: 0;\n    top: 0;\n    bottom: 0;\n    width: 0;\n    background: #08273f;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n    right: 0;\n    width: 0;\n    height: 0;\n    margin: auto;\n    border-radius: 50%;\n}\n.btn-icon-bg:hover::before {\n    width: 100%;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n}\n.circle-effect:hover::before {\n    width: 100%;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n    height: 100%;\n}\n.btn-green-msg {\n    background: #5cae48;\n    border-radius: 4px;\n    padding: 0 20px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: #fff;\n    text-decoration: none;\n    font-size: 16px;\n    line-height: 16px;\n    font-weight: 500;\n    position: relative;\n    overflow: hidden;\n    border: 0;\n}\n.btn-green-msg::before {\n    position: absolute;\n    content: '';\n    left: 0;\n    top: 0;\n    bottom: 0;\n    width: 0;\n    background: #398227;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n}\n.btn-pink-msg {\n    background: #e37070;\n    border-radius: 4px;\n    padding: 0 20px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: #fff;\n    text-decoration: none;\n    font-size: 16px;\n    line-height: 16px;\n    font-weight: 500;\n    position: relative;\n    overflow: hidden;\n    border: 0;\n}\n.btn-pink-msg::before {\n    position: absolute;\n    content: '';\n    left: 0;\n    top: 0;\n    bottom: 0;\n    width: 0;\n    background: #d55151;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n}\n.btn-dark-blue {\n    /* width: 150px; */\n    text-align: center;\n    padding: 0 20px;\n    border: 1px solid #0b3454;\n    border-radius: 27px;\n    background: linear-gradient(to right, #08273f 50%, #0b3454 50%);\n    background-size: 201% 100%;\n    transition: all 0.5s;\n    background-position: right bottom;\n}\n.btn-greenm {\n    width: 150px;\n    text-align: center;\n    padding: 0 20px;\n    border: 1px solid #5cae48;\n    border-radius: 27px;\n    background: linear-gradient(to right, #398227 50%, #5cae48 50%);\n    background-size: 201% 100%;\n    transition: all 0.5s;\n    background-position: right bottom;\n    -webkit-transition: all 0.5s;\n    -moz-transition: all 0.5s;\n    -ms-transition: all 0.5s;\n    -o-transition: all 0.5s;\n}\n.btn-dark-blue:hover,\n.btn-greenm:hover {\n    background-position: left bottom;\n    background-size: 201% 100%;\n}\n.btn-greenm.btnverified {\n    width: 104px;\n    text-align: center;\n    padding: 0 20px;\n    border: 1px solid #5cae48;\n    border-radius: 27px;\n    background: linear-gradient(to right, #398227 50%, #5cae48 50%);\n    background-size: 200% 100%;\n    transition: all 0.5s;\n    background-position: right bottom;\n    height: 30px;\n    line-height: 30px;\n    color: #fff;\n    text-decoration: none;\n    font-size: 13px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: 10px;\n}\n.btn-greenm.btnverified:hover {\n    background-position: left bottom;\n    background-size: 201% 100%;\n    color: #fff;\n}\n.btn-red.btnverified {\n    background: #0000001a;\n    border: 2px solid #ffffff99;\n    border-radius: 20px;\n    font-size: 12px;\n    padding: 0 12px;\n    height: 30px;\n    width: 99px;\n    display: flex;\n    align-items: center;\n    text-decoration: none;\n    color: #fff;\n    justify-content: center;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.btn-red.btnverified:hover {\n    background: #fff;\n    color: #000;\n}\n.btn-red.btnverified:hover .icon-varified {\n    color: #000 !important;\n}\n.polartabsec {\n    padding: 18px 25px;\n    margin: 0;\n    background: #f2f9ff;\n}\n.polartabsec ul {\n    border-bottom: 0 solid #fff;\n    width: max-content;\n}\n.polartabsec ul li {\n    background: transparent;\n    border: 0px solid #7d7d7d;\n    border-radius: 20px;\n    height: 40px;\n    padding: 0;\n}\n.polartabsec ul li .nav-link {\n    color: #414141;\n    font-size: 16px;\n    font-weight: 500;\n    height: 40px;\n    line-height: 38px;\n    background: #fff;\n    border: 2px solid #7d7d7d;\n    padding: 0 23px;\n    border-radius: 20px;\n}\n.polartabsec ul li .nav-link.active,\n.polartabsec ul li .nav-link:hover {\n    color: #fff;\n    border: 2px solid #5cae48;\n    background: #5cae48;\n}\n.polartabsec ul li:not(:last-child) {\n    margin: 0 10px 0 0;\n}\n.ji_filtersec .icon-filter {\n    font-size: 15px;\n    color: #000;\n    margin: -3px 5px 0 0;\n}\n.fiterItem {\n    padding: 0;\n    border: 1px solid rgba(0, 0, 0, 0.125);\n    border-radius: 6px;\n    overflow: hidden;\n}\n.filterHeader {\n    background: transparent;\n    border-radius: 0;\n    padding: 0;\n    border: 0px solid rgba(0, 0, 0, 0.125);\n}\n.filterHeader button span.toggle {\n    width: 10px;\n    height: 10px;\n    margin-left: 10px;\n    position: relative;\n}\n.filterHeader button span.toggle::before {\n    width: 10px;\n    height: 10px;\n    background: transparent;\n    border-left: 2px solid #000;\n    border-top: 2px solid #000;\n    transform: rotate(45deg);\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    margin: auto;\n    content: '';\n    transition: all 0.3s ease-in-out;\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.filterHeader button.collapsed span.toggle::before {\n    transform: rotate(225deg);\n    -webkit-transform: rotate(225deg);\n    -moz-transform: rotate(225deg);\n    -ms-transform: rotate(225deg);\n    -o-transform: rotate(225deg);\n}\n.scrollMe {\n    max-height: 215px;\n    margin-bottom: 0px;\n    overflow-y: auto;\n    scrollbar-width: thin;\n}\n.scrollMe::-webkit-scrollbar {\n    width: 4px;\n}\n.scrollMe::-moz-scrollbar {\n    width: 4px;\n}\n.scrollMe::-webkit-scrollbar-track {\n    background: #eee;\n}\n.scrollMe::-webkit-scrollbar-thumb {\n    background-color: #ccc;\n    border-radius: 20px;\n    border: 2px solid #666;\n}\n.fiterItem .form-check:not(:last-child) {\n    margin-bottom: 10px;\n}\n.fiterItem .form-check .form-check-input {\n    width: 20px;\n    height: 20px; /* margin-left: -20px; */\n    border: 1px solid #bacfde;\n}\n.fiterItem label {\n    cursor: pointer;\n    padding-top: 3px !important;\n}\n.fiterItem .card {\n    border-radius: 0;\n    border: 0px solid #fff;\n    padding: 0px 20px 20px;\n}\n.fiterItem .form-check {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n}\n.filterHeader button {\n    background: #fff;\n    border-radius: 0;\n    padding: 0;\n    border: 0px solid rgba(0, 0, 0, 0.125);\n    padding: 15px 20px;\n}\n.filterHeader button.collapsed {\n    border-bottom: 0px solid rgba(0, 0, 0, 0.125);\n}\n.filterSearchblk {\n    margin: 0px;\n    padding: 0 18px;\n}\n.filterSearchblk .filterSearch input {\n    background: #f3f3f3;\n    border: 0 solid #fff;\n    border-radius: 6px;\n    color: #000;\n    height: 36px;\n    line-height: 36px;\n    margin: 0 4px 2px;\n}\n.filterSearchblk .filterSearch button {\n    position: absolute;\n    right: 14px;\n    width: 14px;\n    height: 14px;\n    font-size: 14px;\n    top: 9px;\n    padding: 0;\n    color: #414141;\n}\n.ji_filtersec {\n    width: 100%;\n    max-width: 320px;\n}\nform.minmaxlb .form-label {\n    color: #535353;\n    font-size: 14px;\n    font-weight: 500;\n    font-style: italic;\n}\nform.minmaxlb button {\n    max-width: 91px;\n    background: #0b3454;\n    padding: 0;\n    height: 36px;\n    line-height: 36px;\n    color: #fff;\n    border-radius: 18px;\n}\n.fiterItem .card .form-check-input:checked,\nform.lstCustForm .form-check-input:checked {\n    background-color: #5cae48;\n    border-color: #5cae48 !important;\n}\n.form-check-input:focus {\n    box-shadow: 0 0 0 0 rgba(13, 110, 253, 0.25);\n}\n.act_lst {\n    border: 1px solid #d2d2d2;\n    padding: 40px 25px 25px 25px;\n    border-radius: 6px;\n    -webkit-border-radius: 6px;\n    -moz-border-radius: 6px;\n    -ms-border-radius: 6px;\n    -o-border-radius: 6px;\n}\n.act_lst > .row > div:last-child {\n    width: 255px;\n}\n.act_lst > .row.postedrow > div:last-child,\n.act_lst.actlst_listed > .row > div:last-child {\n    width: 150px;\n}\n.list_badge {\n    position: absolute;\n    width: 90px;\n    height: 25px;\n    line-height: 25px;\n    color: #fff;\n    background: #d42941;\n    text-align: center;\n    border-radius: 6px 0px 10px 0px;\n    left: 0;\n    top: 0;\n}\n.exp_loc > a.btn {\n    display: inline-flex;\n    align-items: center;\n    border: 1px solid #dedede;\n    height: 32px;\n    line-height: 32px;\n    padding: 0 16px;\n    border-radius: 18px;\n    font-size: 14px;\n    font-weight: 500;\n    color: #0b3454;\n    margin-bottom: 10px;\n    background: #fff;\n    overflow: hidden;\n}\n.exp_loc > a.btn:not(:last-child) {\n    margin-right: 5px;\n}\n.exp_loc > a .btn > img {\n    margin: -3px 8px 0 0;\n}\n.exp_loc > a.btn > span.icon,\n.exp_loc > a.btn > img {\n    margin: -3px 8px 0 0;\n}\n.person_detls {\n    margin-top: 10px;\n}\n.listblk_icon {\n    border: 1px solid #dedede;\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    overflow: hidden;\n}\n.listblk_icon > span.icon,\n.album_shareblk > a.btn.btnicon span.icon {\n    color: rgba(11, 52, 84, 0.4);\n}\n.act_lst > .row > div:last-child .btn-green {\n    width: 150px;\n}\n.act_lst .btn-green {\n    padding: 0 20px;\n}\n.load_more_btn {\n    display: block;\n    margin: 30px auto 0;\n    width: 80%;\n    max-width: 318px;\n    height: 50px;\n    line-height: 48px;\n    border: 1px solid #e1e1e1;\n    border-radius: 25px;\n    text-align: center;\n    text-decoration: none;\n    font-size: 18px;\n    font-weight: 500;\n    color: #535353;\n    background: linear-gradient(to right, #fff 50%, #fff 50%);\n    background-size: 200% 100%;\n    transition: all 0.5s;\n    background-position: right bottom;\n    -webkit-transition: all 0.5s;\n    -moz-transition: all 0.5s;\n    -ms-transition: all 0.5s;\n    -o-transition: all 0.5s;\n}\n.load_more_btn:hover {\n    background-position: left bottom;\n    background-size: 201% 100%;\n    color: #d42941;\n}\n.load_more_btn img {\n    margin: 0 15px 0 0;\n}\n.no_listed_items_blk > div {\n    text-align: center;\n    border: 1px solid #d2d2d2;\n    border-radius: 6px;\n    padding: 40px;\n}\n.JobInternshipForm {\n    width: 94%;\n    max-width: 670px;\n    display: none;\n}\n.JobInternshipForm h2 {\n    border-bottom: 1px solid rgba(125, 125, 125, 0.3);\n    padding: 0 0 10px;\n    margin: 0 0 40px;\n}\nform.lstCustForm .form-select,\nform.lstCustForm input.form-control {\n    border: 1px solid #848484;\n    height: 45px;\n}\nform.lstCustForm textarea.form-control {\n    border: 1px solid #848484;\n}\nform.lstCustForm .form-check .form-check-input {\n    width: 24px;\n    height: 24px;\n    margin-left: -20px;\n    border: 2px solid #848484;\n}\nform.lstCustForm .form-check:not(:last-child) {\n    margin: 0 40px 5px 0;\n}\nform.lstCustForm .btn-greenm,\n.btn-greenm252 {\n    min-width: 252px;\n}\nform.lstCustForm label span {\n    font-size: 14px;\n    color: #848484;\n    font-weight: 400;\n    font-style: italic;\n    display: inline-block;\n    padding: 0 0 0 20px;\n}\nform.lstCustForm .inputfile_parent label span.uploadlabel {\n    font-size: 16px;\n    color: #414141;\n    font-weight: 400;\n    display: inline-block;\n    padding: 0 0 0 8px;\n    font-style: normal;\n}\nform.lstCustForm label span.icon {\n    font-style: unset;\n    color: #414141;\n}\n.fileclose {\n    height: 12px;\n    line-height: 10px;\n    width: 12px;\n    text-align: center;\n    background: #959595;\n    border-radius: 50%;\n    color: #fff;\n    font-size: 12px;\n    cursor: pointer;\n    display: none;\n    margin-left: 6px;\n    justify-content: center;\n    align-items: center;\n    -webkit-border-radius: 50%;\n    -moz-border-radius: 50%;\n    -ms-border-radius: 50%;\n    -o-border-radius: 50%;\n}\n.fileclose span {\n    font-size: 6px;\n    display: block;\n    margin: 0 0 0px 1px;\n}\n.fileicon {\n    display: none;\n    margin-right: 6px;\n}\n.docselect {\n    display: none;\n    align-items: center;\n    width: max-content;\n}\n.docselect.docseladdbg {\n    background: #f8f8f8;\n    display: flex;\n    padding: 7px 12px;\n    margin: 10px 0 0 0;\n    border-radius: 6px;\n    -webkit-border-radius: 6px;\n    -moz-border-radius: 6px;\n    -ms-border-radius: 6px;\n    -o-border-radius: 6px;\n}\n.inputfile::file-selector-button {\n    font: inherit;\n    display: none;\n}\n.inputfile_parent label {\n    color: #f1e5e6;\n    background-color: #f3f3f3;\n    border: 1px dashed #848484;\n    border-radius: 6px;\n    height: 60px;\n    line-height: 60px;\n    max-width: 100%;\n    font-size: 1.25rem;\n    font-weight: 500;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    cursor: pointer;\n    display: inline-block;\n    overflow: hidden;\n    padding: 0;\n    width: 100%;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.albmform .inputfile_parent label {\n    height: 80px;\n    line-height: 80px;\n}\n.inputfile_parent label span {\n    font-size: 16px;\n    color: #414141;\n    font-weight: 500;\n    font-style: unset;\n    float: none;\n    padding: 0 0 0 10px;\n}\n.inputfile_parent {\n    position: relative;\n    height: auto;\n}\n.inputfile_parent.profile .docselect {\n    display: none;\n}\n.inputfile_parent.profile.select + p {\n    display: none;\n}\n.inputfile_parent.profile label {\n    background-color: #fff;\n    border: 1px dashed #a8c5dd;\n    border-radius: 6px;\n    height: 40px;\n    line-height: 40px;\n    -webkit-border-radius: 6px;\n    -moz-border-radius: 6px;\n    -ms-border-radius: 6px;\n    -o-border-radius: 6px;\n}\n.inputfile_parent.profile.select .docseladdbg {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    background: #eaeaea;\n}\n.inputfile_parent.profile.pop-up label {\n    background: #f3f3f3;\n    border: 1px dashed #848484;\n    border-radius: 6px;\n    opacity: 1;\n    height: 45px;\n    line-height: 45px;\n    -webkit-border-radius: 6px;\n    -moz-border-radius: 6px;\n    -ms-border-radius: 6px;\n    -o-border-radius: 6px;\n}\n.album_imgblk img {\n    width: auto;\n    height: auto;\n    max-width: 100%;\n    max-height: 190px;\n}\n.album_blk {\n    border: 1px solid #d2d2d2;\n    border-radius: 6px;\n    height: 100%;\n}\n.album_badge {\n    background: #d42941;\n    padding: 0 20px;\n    height: 32px;\n    line-height: 32px;\n    border-radius: 6px 0 15px 0;\n    top: 0;\n    left: 0;\n}\n.album_imgblk {\n    border-radius: 6px 6px 0 0;\n    overflow: hidden;\n    min-height: 190px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.album_contblk {\n    background: #fff;\n    border-radius: 6px;\n    width: calc(100% - 20px);\n    margin: -40px auto 0;\n    position: relative;\n    padding: 20px 20px 15px;\n}\n.album_contblk h3 {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n}\n.album_shareblk {\n    width: 60px;\n    padding: 0 0 0 20px;\n}\n.album_shareblk > span,\n.album_shareblk > a.btn.btnicon {\n    width: 40px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    height: 40px;\n    line-height: 38px;\n    border: 1px solid #dedede;\n    border-radius: 50%;\n    justify-content: center;\n    align-items: center;\n}\n.album_shareblk > span:not(:last-child),\n.album_shareblk > a.btn:not(:last-child) {\n    margin: 0 0 5px;\n}\n.albumblk_footer {\n    background: #f2f9ff;\n    padding: 13px 30px;\n    border-radius: 0 0 6px 6px;\n}\n.albumblk_footer img {\n    margin: 0 6px 0 0;\n}\n.album_blk_parent {\n    margin: 0 0 20px 0;\n}\n.album_imgvdo {\n    right: 10px;\n    top: 10px;\n}\n.Wrdrow {\n    width: calc(100% - 60px);\n}\n.lstperdetails {\n    width: calc(100% - 40px);\n}\n.image_tn {\n    margin: 0 0 5px 0;\n}\n.image_tn > a {\n    width: 63px;\n    height: 30px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: rgba(0, 0, 0, 0.5);\n    border-radius: 16px;\n    color: #e1e1e1;\n    font-size: 13px;\n    text-decoration: none;\n}\n.image_tn > a img.gallicon {\n    width: 14px;\n    height: auto;\n    margin: 0 3px 0 0;\n}\nimg.custimg {\n    width: auto;\n    display: block;\n    margin: 0 auto;\n}\n.icon_bluecir {\n    background: #d1f1ff;\n    height: 40px;\n    width: 40px;\n    border-radius: 50%;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.EventsBlk .btn-border-gray {\n    color: #414141;\n    min-width: 110px;\n    padding: 0 12px;\n}\n.EventsBlk .btn-border-gray.text-gray-41:hover {\n    color: #fff;\n}\n.album_contblk.eventsbox {\n    padding: 20px 8px 15px 20px;\n}\n.lightboxcontainer {\n    width: 100%;\n    text-align: left;\n}\n.lightboxleft {\n    width: 40%;\n    float: left;\n}\n.lightboxright {\n    width: 60%;\n    float: left;\n}\n.lightboxright iframe {\n    min-height: 390px;\n}\n.divtext {\n    margin: 36px;\n}\n#html5lightbox-watermark,\n.html5-nav-showcontrol {\n    display: none !important;\n}\n.html5-image {\n    padding: 0 !important;\n}\n#html5-lightbox-box,\n.html5-elem-wrap,\n.html5lightbox-video iframe {\n    width: 600px !important;\n    height: 400px !important;\n}\n.html5-prev-inside .mh-icon-left,\n.html5-next-inside .mh-icon-right {\n    position: relative;\n}\n.html5-next-inside .mh-icon-right::after {\n    position: absolute;\n    width: 12px;\n    height: 12px;\n    border-top: 2px solid #fff;\n    border-right: 2px solid #fff;\n    content: '';\n    transform: rotate(45deg);\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n}\n.html5-prev-inside .mh-icon-left::after {\n    position: absolute;\n    width: 12px;\n    height: 12px;\n    border-top: 2px solid #fff;\n    border-right: 2px solid #fff;\n    content: '';\n    transform: rotate(-135deg);\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    -webkit-transform: rotate(-135deg);\n    -moz-transform: rotate(-135deg);\n    -ms-transform: rotate(-135deg);\n    -o-transform: rotate(-135deg);\n}\n.html5gallery-title-0 {\n    top: 360px !important;\n}\n.html5gallery-title-text-0 {\n    color: #333 !important;\n    background-color: transparent !important;\n    text-align: center !important;\n    font-size: 18px !important;\n    filter: progid: DXImageTransform.Microsoft.gradient(enabled=false) !important;\n}\n.html5gallery-play-0,\n.html5gallery-pause-0,\n.html5gallery-lightbox-0 {\n    top: 8px !important;\n}\n.skills_input_selected > span {\n    padding: 6px 15px;\n    border: 1px solid #dedede;\n    border-radius: 7px;\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n}\n.profile_radiorow > .icon-cross {\n    position: absolute;\n    font-size: 8px;\n    color: #0b345480;\n    right: -17px;\n    top: 19px;\n    cursor: pointer;\n}\n.msg_title .form-check-input:focus,\n.msg_title.msg_heading_row form select:focus {\n    box-shadow: unset;\n}\n.w-h-32 {\n    width: 32px;\n    height: auto;\n}\n.w-h-90 {\n    width: 90px;\n    height: auto;\n}\n.dropdowncheck span {\n    padding: 5px 12px;\n    border: 1px solid #dedede;\n    border-radius: 7px;\n    font-size: 14px;\n    font-weight: 400;\n    width: max-content;\n    margin: 0 10px 0 0;\n}\n.text-gray-f3 {\n    color: #f3f3f3;\n}\n.albumadd {\n    background: #f3f3f3;\n    border-radius: 6px;\n    padding: 12px 16px 12px 12px;\n    margin-bottom: 10px;\n}\n.albumadd img {\n    border-radius: 6px;\n}\n.albumadd > div textarea.form-control {\n    border: 1px solid #d9d9d9;\n    min-height: 112px;\n}\n.albumadd .addvdo i {\n    color: #000;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    top: 0;\n    margin: auto;\n    width: 30px;\n    height: 30px;\n    filter: invert(100%);\n    background: #fff;\n    border-radius: 50%;\n    -webkit-filter: invert(100%);\n}\n.list_badge.thumbbadge {\n    width: 108px;\n    height: 32px;\n    line-height: 32px;\n    border-radius: 6px 0px 15px 0px;\n}\n.albumadd .dropdown-menu li a:hover {\n    color: #5cae48;\n    background-color: transparent;\n}\n.albumadd .dropdown-menu {\n    transform: unset !important;\n    top: 22px !important;\n    right: -2px !important;\n    left: auto !important;\n    padding: 10px 15px;\n    width: 108px;\n    height: 92px;\n    max-width: 108px;\n}\n.albumadd .dropdown-menu .dropdown-item {\n    padding: 2px 0;\n    font-weight: 400;\n    color: #000000;\n    font-size: 14px;\n}\n.gallimg_update.modal-dialog {\n    max-width: 700px;\n    width: 94%;\n}\n.gallimg_update .editprofileImg::after {\n    display: none;\n}\n.gallimg_update .editprofileImg {\n    max-width: 370px;\n}\n.profiles_blk > div > div {\n    border: 1px solid #d2d2d2;\n    border-radius: 6px;\n}\n.profiles_contsec {\n    padding: 0 20px 20px;\n    text-align: center;\n}\n.profiles_blk img {\n    border-radius: 6px 6px 0 0;\n    width: 100%;\n    height: auto;\n}\n.profiles_contsec .btn-green {\n    line-height: 14px;\n}\n.uni_profiles_sec {\n    border: 1px solid #d2d2d2;\n    border-radius: 6px;\n    padding: 20px 30px 20px 20px;\n}\n.uni_profiles_100 .uni_profiles_sec {\n    border: 0px solid #d2d2d2;\n    border-radius: 0;\n    padding: 0;\n}\ntextarea.graybg-textarea,\ntextarea.graybg-textarea:focus {\n    background: #f3f3f3;\n    border: 1px solid #dddddd;\n    border-radius: 5px;\n    color: #414141;\n    font-size: 16px;\n    font-weight: 500;\n}\n.btn-green.disable {\n    border-radius: 25px;\n    padding: 0 25px;\n    line-height: 32px;\n    border: 2px solid #cbcbcb;\n    height: 35px;\n    display: inline-flex;\n    text-decoration: none;\n    color: #bcbcbc;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n    position: relative;\n    overflow: hidden;\n    justify-content: center;\n    align-items: center;\n    background: #fff;\n}\n.btn-green.disable::before {\n    width: 0;\n    height: 100%;\n    content: '';\n    background: #fff;\n    position: absolute;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n}\n.btn-green.disable:hover::before {\n    width: 100%;\n}\n.btn-green.disable:hover {\n    color: #bcbcbc;\n    background: #fff;\n}\n.btn-green.disable span {\n    position: relative;\n}\n.polartabsec ul.msgtabs li button.nav-link {\n    padding: 0 18px;\n}\n.newmsg .ji_filtersec {\n    background: #f8f8f8;\n    padding: 25px 30px 30px;\n}\n.newmsg .filterSearch input {\n    border-radius: 18px;\n    border: 1px solid #e1e1e1;\n    padding-left: 37px;\n    color: #000000;\n    height: 35px;\n}\n.newmsg .filterSearch .btn.icon-search {\n    left: 11px;\n    top: 13px;\n    padding: 0;\n    font-size: 14px;\n    color: #414141;\n    font-weight: 400;\n    z-index: 1;\n}\n.dotted-blue-border {\n    height: 1px;\n    width: 100%;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/dotted_border_bg.png) left top\n        repeat-x;\n}\n.newmsg .ji_filtersec ul {\n    list-style: none;\n    padding: 0;\n}\n.newmsg .ji_filtersec ul li {\n    margin: 0 0 20px;\n}\n.newmsg .ji_filtersec ul li a {\n    color: #0b3454;\n    font-weight: 500;\n    font-size: 16px;\n    text-decoration: none;\n    width: 100%;\n    display: inline-block;\n}\n.newmsg .ji_filtersec ul li.active a {\n    color: #5cae48;\n}\n.msgtabcont {\n    padding: 25px;\n}\n.msgtabcont.msgwrapext {\n    padding: 25px 10px 25px 25px;\n}\n.msgtabcont .msgbox {\n    border: 1px solid #dedede;\n    border-radius: 6px;\n    padding: 20px 0px 90px;\n    min-height: 470px;\n}\n.msgtabcont .msgbox.msgboxconvo {\n    padding: 5px 0px 90px;\n}\n.msgbox .filterSearch input {\n    height: 45px;\n    line-height: 45px;\n    border: 1px solid #848484;\n    border-radius: 23px;\n    font-size: 16px;\n    color: #666666;\n}\n.newmsg .msgbox .filterSearch .btn.icon-search {\n    top: 14px;\n}\n.search_btmshadow {\n    background: transparent linear-gradient(180deg, #f2f2f2 0%, #ffffff 100%) 0% 0% no-repeat padding-box;\n    height: 20px;\n    width: 100%;\n}\n.msgbox_send {\n    width: 100%;\n    height: 60px;\n    background: #f3f3f3;\n    left: 0;\n    bottom: 0;\n    border-radius: 0 0 6px 6px;\n    padding: 5px;\n}\n.msgbox_send input {\n    height: 50px;\n    line-height: 50px;\n    font-size: 16px;\n    font-weight: 500;\n    color: #414141;\n    padding-right: 80px;\n}\n.btn-complete-now.msgsendbtn span {\n    font-size: 14px;\n    font-weight: 600;\n    position: relative;\n}\n.btn-complete-now.msgsendbtn {\n    top: 5px;\n    right: 5px;\n    position: absolute;\n    z-index: 1;\n}\n.search_sugg {\n    background: #fff;\n    position: absolute;\n    height: auto;\n    width: 100%;\n    top: auto;\n    border: 1px solid #dedede;\n    border-radius: 20px;\n    box-shadow: 0px 10px 20px #0000001a;\n    padding: 25px;\n    transition: all 0.5s ease-in-out;\n    z-index: 9;\n    display: none;\n    -webkit-border-radius: 20px;\n    -moz-border-radius: 20px;\n    -ms-border-radius: 20px;\n    -o-border-radius: 20px;\n}\n.msgbox .filterSearch input.open + .search_sugg {\n    display: block;\n}\n.msgbox .uni_profiles_sec {\n    padding: 20px 45px 20px 20px;\n}\n.msgbox .uni_profiles_sec .icon-invert-cross {\n    color: #a9a9a9;\n    right: 20px;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    height: 16px;\n    width: 16px;\n}\n.search_ttlblk .uni_profiles_sec {\n    padding: 0;\n    border: 0 solid #fff;\n}\n.msgbox .search_cont {\n    height: 280px;\n    overflow-y: auto;\n    scrollbar-width: thin;\n}\n.msg_popup_cont {\n    background: #f8f8f8;\n    border-radius: 10px;\n    margin: 60px 0 0 0;\n    padding: 70px 30px 25px;\n    position: relative;\n}\n.msg_popup_cont > img {\n    width: 90px;\n    height: auto;\n    left: 0;\n    right: 0;\n    margin: 0 auto;\n    top: -50px;\n    border: 6px solid #fff;\n    box-sizing: content-box;\n}\n.msg_popup_modal .modal-body {\n    padding: 30px;\n}\n.alumni-switch-container.msg-switch {\n    background: #fff;\n    border: 1px solid #b9b9b9;\n    width: 342px;\n}\n.alumni-switch-container.msg-switch .switch > a {\n    color: #000;\n}\n.alumni-switch-container.msg-switch .switch > a.active {\n    color: #fff;\n}\n.alumni-switch-container.msg-switch .switch > span {\n    background: #5cae48;\n}\n.msg_name {\n    width: max-content;\n    background: #f3f3f3;\n    padding: 16px 20px;\n    border-radius: 6px;\n    -webkit-border-radius: 6px;\n    -moz-border-radius: 6px;\n    -ms-border-radius: 6px;\n    -o-border-radius: 6px;\n}\n.msg_area {\n    background: #f3f3f3;\n    border-radius: 6px;\n    padding: 20px 20px;\n    max-width: 620px;\n    -webkit-border-radius: 6px;\n    -moz-border-radius: 6px;\n    -ms-border-radius: 6px;\n    -o-border-radius: 6px;\n}\n.msg_title .icon-star {\n    color: #dedede;\n}\n.msg_title .icon-star.selected {\n    color: #f8b018;\n}\n\n/* conversation */\n.profile_person {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n    align-items: end;\n}\n.profile_person p {\n    background: #2296c9;\n    padding: 11px 20px;\n    border-radius: 10px 10px 0px 10px;\n    color: #fff;\n    max-width: 456px;\n    line-height: 20px;\n    margin-bottom: 10px;\n}\n.profile_person p.accepted {\n    background: #5cae48;\n    border-radius: 6px;\n    max-width: 150px;\n    width: 100%;\n    text-align: center;\n}\n.profile_person p.reject {\n    background: #a00;\n    border-radius: 6px;\n    max-width: 150px;\n    width: 100%;\n    text-align: center;\n}\n.profile_person p.date {\n    background: none;\n    color: #848484;\n    font-size: 14px;\n    font-weight: 500;\n    padding: 0;\n}\n.profile_person p + p.date {\n    margin-top: -10px;\n}\n.non-profile_person {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n    align-items: start;\n}\n.non-profile_person p {\n    background: #413a7d;\n    padding: 11px 20px;\n    border-radius: 10px 10px 10px 0px;\n    color: #fff;\n    max-width: 456px;\n    line-height: 20px;\n    margin-bottom: 10px;\n}\n.non-profile_person p.accepted {\n    background: #5cae48;\n    border-radius: 6px;\n}\n.non-profile_person p.reject {\n    background: #a00;\n    border-radius: 6px;\n}\n.non-profile_person p.date {\n    background: none;\n    color: #848484;\n    font-size: 14px;\n    font-weight: 500;\n    padding: 0;\n}\n.non-profile_person p + p.date {\n    margin-top: -10px;\n}\n.university_ttl > span.unicon {\n    width: 32px;\n    height: 32px;\n    display: inline-block;\n    color: #fff;\n    text-align: center;\n    line-height: 32px;\n    border-radius: 50%;\n    margin: 0 5px 0 0;\n    -webkit-border-radius: 50%;\n    -moz-border-radius: 50%;\n    -ms-border-radius: 50%;\n    -o-border-radius: 50%;\n}\n.university_ttl {\n    max-width: 180px;\n    min-width: 180px;\n}\n.msg_title .form-check .form-check-input {\n    width: 20px;\n    height: 20px;\n    border: 2px solid #848484;\n}\n.msg_title .form-check-input:checked {\n    background-color: #0b3454;\n    border-color: #0b3454;\n    background-size: 18px auto;\n}\n.convo_btns a.btn {\n    height: 30px;\n    width: 180px;\n    background: #f3f3f3;\n    border-radius: 6px;\n    padding: 0 10px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    font-size: 14px;\n    font-weight: 500;\n    color: #000;\n    justify-content: flex-start;\n    text-align: left;\n}\n.msg_title.msg_title_row {\n    border: 1px solid #dedede;\n    border-radius: 6px;\n    margin-bottom: 10px;\n    min-height: 80px;\n}\n.msg_title_row_wrapper .msg_title.msg_title_row:last-child {\n    margin-bottom: 0;\n}\n.msg_title_row_wrapper {\n    max-height: 264px;\n    overflow-y: auto;\n    margin-bottom: 10px;\n    scrollbar-width: thin;\n    padding-right: 15px;\n}\n.extmar {\n    margin-right: 15px !important;\n}\n.msg_lt_rt a.btn {\n    background: #f3f3f3;\n    height: 36px;\n    width: 36px;\n    display: inline-block;\n    line-height: 36px;\n    text-align: center;\n    border-radius: 6px;\n    padding: 0;\n    font-size: 14px;\n    font-weight: 800;\n    -webkit-border-radius: 6px;\n    -moz-border-radius: 6px;\n    -ms-border-radius: 6px;\n    -o-border-radius: 6px;\n}\n.msg_lt_rt a.btn.msg_lt i {\n    margin-left: -2px;\n}\n.msg_lt_rt a.btn.msg_rt i {\n    margin-right: -2px;\n}\n.msg_title.msg_heading_row .btn-complete-now {\n    height: 36px;\n    text-align: center;\n    margin: auto;\n    display: inline-block;\n    padding: 0 20px;\n    border-radius: 25px;\n    line-height: 32px;\n    overflow: hidden;\n    position: relative;\n    font-size: 14px;\n    font-weight: 500;\n    -webkit-border-radius: 25px;\n    -moz-border-radius: 25px;\n    -ms-border-radius: 25px;\n    -o-border-radius: 25px;\n}\n.msg_title.msg_heading_row .btn-complete-now span {\n    position: relative;\n}\n.msg_title.msg_heading_row form select {\n    border: 2px solid #7d7d7d;\n    border-radius: 18px;\n    height: 36px;\n    min-width: 170px;\n    max-width: 170px;\n    -webkit-border-radius: 18px;\n    -moz-border-radius: 18px;\n    -ms-border-radius: 18px;\n    -o-border-radius: 18px;\n}\n.send_msg_text {\n    width: max-content;\n}\n.send_msg_text > a {\n    width: 150px;\n    height: 70px;\n    background: #5cae48;\n    border-radius: 10px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    color: #fff;\n    text-decoration: none;\n    font-size: 16px;\n    line-height: 23px;\n    font-weight: 500;\n    -webkit-border-radius: 10px;\n    -moz-border-radius: 10px;\n    -ms-border-radius: 10px;\n    -o-border-radius: 10px;\n}\n.send_msg_text > a:not(:last-child) {\n    margin-right: 10px;\n}\n.uniprof_btnmbl_align.paddings-67 {\n    padding-left: 20px;\n}\n.welcome_pg {\n    padding-left: 50px;\n    padding-right: 50px;\n}\n.cpw_bg {\n    padding: 40px;\n    background: #f8f8f8;\n    border-radius: 8px;\n    margin: 0 0 30px 0;\n    -webkit-border-radius: 8px;\n    -moz-border-radius: 8px;\n    -ms-border-radius: 8px;\n    -o-border-radius: 8px;\n}\n.cpw_bg > div {\n    width: 94%;\n    max-width: 385px;\n    margin: 0 auto;\n}\n.icon-green-right {\n    width: 48px;\n    height: 48px;\n    background: #3bb54a;\n    border-radius: 50%;\n    margin: auto auto 25px;\n    position: relative;\n    -webkit-border-radius: 50%;\n    -moz-border-radius: 50%;\n    -ms-border-radius: 50%;\n    -o-border-radius: 50%;\n}\n.icon-green-right:after {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    margin: auto;\n    width: 23px;\n    height: 13px;\n    border-left: 5px solid #fff;\n    border-bottom: 5px solid #fff;\n    content: '';\n    transform: rotate(-45deg);\n    top: -7px;\n    -webkit-transform: rotate(-45deg);\n    -moz-transform: rotate(-45deg);\n    -ms-transform: rotate(-45deg);\n    -o-transform: rotate(-45deg);\n}\n\n@media (min-width: 1600px) {\n    #html5-lightbox-box,\n    .html5-elem-wrap,\n    .html5lightbox-video iframe {\n        width: 1000px !important;\n        height: 667px !important;\n    }\n}\n\n@media (min-width: 768px) {\n    .mobileFilter.mobileonly,\n    .btn-filter.mobileonly {\n        display: none;\n    }\n    .welcome-title + .dashboard.actdashboard {\n        min-width: 292px;\n    }\n    .school_notification li div.check.notifychk {\n        width: 100px;\n        text-align: right;\n        margin-left: 30px;\n    }\n}\n\n@media (max-width: 1180px) {\n    .msgacpign {\n        width: 100% !important;\n        align-items: start !important;\n        flex-direction: column;\n        margin-left: 74px;\n    }\n    .msgacpign > .flex-column {\n        flex-direction: row !important;\n        order: 2;\n        margin: 8px 0 0 0;\n    }\n    .msgacpign > .flex-column a.mb-2 {\n        margin-bottom: 0 !important;\n    }\n    .university_ttl {\n        max-width: unset;\n        min-width: unset;\n        width: calc(100% - 85px);\n        margin-right: 0 !important;\n    }\n    .msg_title_txt {\n        width: calc(100% - 80px);\n        max-width: unset !important;\n        margin-left: 74px;\n        margin-right: 0 !important;\n    }\n    .msg_title.msg_title_row {\n        padding-top: 20px !important;\n        padding-bottom: 20px !important;\n    }\n    .msgtabcont .msgbox.msgboxconvo .search_ttlblk {\n        padding-top: 15px;\n        padding-bottom: 15px;\n    }\n    .msg_title_row_wrapper {\n        max-height: 514px;\n    }\n}\n\n@media (max-width: 1150px) {\n    .aldir_scroll {\n        width: 100%;\n        overflow-x: auto;\n        scrollbar-width: thin;\n    }\n    .aldir_scroll::-webkit-scrollbar {\n        height: 4px;\n    }\n    .aldir_scroll::-moz-scrollbar {\n        height: 4px;\n    }\n    .aldir_scroll::-webkit-scrollbar-track {\n        background: #e372848f;\n    }\n    .aldir_scroll::-webkit-scrollbar-thumb {\n        background-color: #ccc;\n        border-radius: 20px;\n        border: 2px solid #810d20;\n    }\n}\n\n@media (max-width: 1080px) {\n    .act_lst > .row > .flex-1 {\n        width: 100%;\n        flex: unset;\n        padding-right: 0 !important;\n    }\n    .act_lst > .row > div:last-child {\n        width: 100%;\n        padding: 15px 0 0 0;\n        text-align: left !important;\n    }\n    .act_lst > .row.postedrow > div:last-child {\n        width: 100%;\n        padding: 5px 0 0 0;\n    }\n    .act_lst.actlst_listed > .row > div:last-child {\n        width: 100%;\n        padding: 10px 0 0 0;\n    }\n    .act_lst .postedtxt {\n        margin-bottom: 5px !important;\n    }\n    .ji_filtersec {\n        max-width: 275px;\n    }\n    .act_lst.actlst_listed .btn-green {\n        margin-bottom: 5px;\n    }\n    .act_lst > .row,\n    .act_lst > .row > div:last-child > div {\n        justify-content: start !important;\n    }\n    .welcome-title + .dashboard {\n        margin-left: 30px;\n    }\n    ul.school_notification li.read .check {\n        width: 100%;\n        text-align: right;\n    }\n}\n\n@media (min-width: 768px) and (max-width: 1080px) {\n    .school_notification li div.check.notifychk {\n        width: 100px;\n        text-align: right;\n        margin-left: 30px;\n    }\n}\n\n@media (min-width: 992px) and (max-width: 1160px) {\n    .album_contblk .btn-green {\n        height: 34px;\n        padding: 0 15px;\n        line-height: 34px;\n    }\n    .album_contblk {\n        padding: 20px 15px 15px;\n    }\n    .album_shareblk > span img {\n        max-width: 14px;\n        height: auto;\n    }\n    .album_shareblk > span img.vimg {\n        max-width: unset;\n        max-height: 16px;\n        width: auto;\n    }\n}\n\n@media (max-width: 1024px) {\n    .welcome-title h1,\n    .notificationSection h3.font-35 {\n        font-size: 30px;\n    }\n}\n\n@media (min-width: 768px) and (max-width: 1180px) {\n    .dashboard.actdashboard .ms-4.me-3.dashb_arr.dashb_left {\n        margin-left: 10px !important;\n        margin-right: 10px !important;\n    }\n}\n\n@media (max-width: 1024px) {\n    .msg_title_row_wrapper {\n        max-height: 530px;\n    }\n}\n\n@media (min-width: 768px) and (max-width: 1024px) {\n    .profile_setup .icn_details .iconsec + .flex-1 {\n        width: calc(100% - 80px);\n        flex: unset;\n        margin: 0 0 15px 0px;\n        -webkit-box-flex: unset;\n        -moz-box-flex: unset;\n        -webkit-flex: unset;\n        -ms-flex: unset;\n    }\n    .profile_setup .icn_details .activity-btn {\n        margin: auto !important;\n        display: block;\n        min-width: 140px;\n        max-width: max-content;\n    }\n}\n\n@media (max-width: 991px) {\n    .tabw-100 {\n        width: 100% !important;\n        max-width: unset !important;\n    }\n    .msg_title.msg_heading_row form {\n        width: 100%;\n        padding-top: 10px;\n    }\n    .selallarr {\n        width: max-content !important;\n        position: static;\n        right: 0px;\n        top: 0;\n        margin-left: auto;\n    }\n}\n\n@media (max-width: 900px) {\n    .convo_btns {\n        width: 100%;\n        padding-left: 74px;\n    }\n}\n\n@media (max-width: 800px) {\n    .lightboxleft,\n    .lightboxright {\n        width: 100%;\n    }\n    .divtext {\n        margin: 12px;\n    }\n    .uni_profiles_sec.profiles_sec_brk {\n        -webkit-box-wrap: wrap;\n        -moz-box-wrap: wrap;\n        -ms-flex-wrap: wrap;\n        -webkit-wrap: wrap;\n        flex-wrap: wrap;\n    }\n    .uniprof_btnmbl_align.paddings-67 {\n        width: 100%;\n        padding-left: 67px;\n    }\n}\n\n@media (min-width: 768px) and (max-width: 991px) {\n    .no_listed_items_blk .max-470 {\n        max-width: unset !important;\n        width: 300px;\n    }\n    .no_listed_items_blk > div {\n        padding: 30px;\n    }\n    .footer {\n        padding: 20px 40px;\n    }\n    header {\n        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n    }\n}\n\n@media (min-width: 768px) and (max-width: 800px) {\n    .uniprof_btnmbl_align a:first-child {\n        margin-bottom: 10px;\n    }\n}\n\n@media (max-width: 767px) {\n    .activity-btn {\n        margin: auto !important;\n        display: block;\n        min-width: 140px;\n        max-width: max-content;\n    }\n    .filters {\n        position: fixed;\n        left: 0;\n        right: 0;\n        top: 0;\n        width: 100%;\n        bottom: 0;\n        background: #fff;\n        z-index: 99;\n        max-width: 100%;\n        overflow-x: scroll;\n        padding: 40px 20px;\n        display: block !important;\n        -moz-transform: translate3d(0, 0, 0);\n        -webkit-transform: translate3d(0, 0, 0);\n        -o-transform: translate3d(0, 0, 0);\n        -ms-transform: translate3d(0, 0, 0);\n        transform: translate3d(0, 0, 0);\n        -webkit-transition: all 0.3s ease-in-out;\n        -moz-transition: all 0.3s ease-in-out;\n        -ms-transition: all 0.3s ease-in-out;\n        -o-transition: all 0.3s ease-in-out;\n        transition: all 0.3s ease-in-out;\n        height: 100%;\n    }\n    .filters.show {\n        -moz-transform: translate3d(0, -100%, 0);\n        -webkit-transform: translate3d(0, -100%, 0);\n        -o-transform: translate3d(0, -100%, 0);\n        -ms-transform: translate3d(0, -100%, 0);\n        transform: translate3d(0, -100%, 0);\n        -webkit-transition: all 0.3s ease-in-out;\n        -moz-transition: all 0.3s ease-in-out;\n        -ms-transition: all 0.3s ease-in-out;\n        -o-transition: all 0.3s ease-in-out;\n        transition: all 0.3s ease-in-out;\n    }\n    .filters .btn-filter {\n        position: absolute;\n        right: 25px;\n        font-size: 0;\n        background: none;\n        border: 0;\n        width: 20px;\n        height: 20px;\n        top: 25px;\n    }\n    .filters .btn-filter::before {\n        transform: translateY(10px) rotate(135deg);\n        -moz-transform: translateY(10px) rotate(135deg);\n        -webkit-transform: translateY(-5px) rotate(135deg);\n        -webkit-transition: all 0.3s ease-in-out;\n        -moz-transition: all 0.3s ease-in-out;\n        -ms-transition: all 0.3s ease-in-out;\n        -o-transition: all 0.3s ease-in-out;\n        transition: all 0.3s ease-in-out;\n        width: 18px;\n        height: 2px;\n        content: '';\n        background: #000;\n        position: absolute;\n        border-radius: 5px;\n    }\n    .filters .btn-filter::after {\n        transform: translateY(-5px) rotate(-135deg);\n        -moz-transform: translateY(-5px) rotate(-135deg);\n        -webkit-transform: translateY(-5px) rotate(-135deg);\n        -webkit-transition: all 0.3s ease-in-out;\n        -moz-transition: all 0.3s ease-in-out;\n        -ms-transition: all 0.3s ease-in-out;\n        -o-transition: all 0.3s ease-in-out;\n        transition: all 0.3s ease-in-out;\n        width: 18px;\n        height: 2px;\n        content: '';\n        background: #000;\n        position: absolute;\n        border-radius: 5px;\n    }\n    .filters #accordionFilters {\n        margin-bottom: 30px;\n    }\n    .filters > h3 {\n        display: -webkit-box !important;\n        display: -moz-box !important;\n        display: -ms-flexbox !important;\n        display: -webkit-flex !important;\n        display: flex !important;\n        align-items: center;\n        justify-content: space-between;\n    }\n    .mobileFilter .btn-filter {\n        border: 0;\n        background-color: transparent;\n        padding-right: 0px;\n        padding-left: 0;\n        cursor: pointer;\n    }\n    .filters {\n        max-width: 100%;\n        width: 100%;\n    }\n    .ji_filtersec {\n        max-width: unset;\n    }\n    .JobInternshipForm {\n        padding: 0;\n        width: 90%;\n    }\n    .JobInternshipForm > .col-12 {\n        padding: 0;\n    }\n    #html5-lightbox-box,\n    .html5-elem-wrap,\n    .html5lightbox-video iframe {\n        width: 450px !important;\n        height: 300px !important;\n    }\n    .container.max-1140,\n    .max-1140 {\n        width: 100%;\n        padding: 0;\n    }\n    header .container.max-1140 {\n        max-width: 1140px;\n        width: 94%;\n        padding-right: var(--bs-gutter-x, 0.75rem);\n        padding-left: var(--bs-gutter-x, 0.75rem);\n    }\n    footer .max-1140 {\n        padding: 20px 0px;\n        width: 90%;\n        align-items: center;\n    }\n    .milestoneSection > .container > .row,\n    .notificationSection > .container > .row {\n        margin: 0;\n    }\n    .milestoneSection > .container > .row > .col-md-12,\n    .notificationSection > .container > .row > .col-md-12 {\n        padding: 0;\n    }\n    .white-block {\n        box-shadow: unset;\n        border: 0px solid #d2d2d2;\n        border-radius: 0px;\n    }\n    .welcome-title + .dashboard {\n        margin-left: auto;\n    }\n    .dashboard.innerpage > a.btn {\n        margin-top: 0 !important;\n    }\n    header {\n        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n    }\n    .font-35 {\n        font-size: 24px;\n        line-height: 28px;\n    }\n    .welcome-title h1,\n    .notificationSection h3.font-35 {\n        font-size: 24px;\n    }\n    #alumni_directory .container.max-1140 {\n        padding: 0 20px;\n    }\n    .phone_number.max-135 {\n        max-width: unset;\n        -webkit-box-flex: 1;\n        -moz-box-flex: 1;\n        -webkit-flex: 1;\n        -ms-flex: 1;\n        flex: 1;\n    }\n    .modal-dialog.modal-dialog-centered {\n        align-items: flex-start;\n        margin-top: 25px;\n    }\n    .polarcontsec {\n        margin-top: 20px;\n        padding: 0;\n    }\n    .page_ttl_row,\n    .m-w-90,\n    .max-1010.m-w-90,\n    .m-w-90.plr0 {\n        padding-left: 0 !important;\n        padding-right: 0 !important;\n        width: 90%;\n        margin: auto !important;\n    }\n    .milestoneSection .white-block.m-w-90-parent {\n        padding: 0;\n    }\n    .msgtabcont.polarcontsec {\n        padding: 20px 0 0 0;\n        width: 90%;\n        margin: auto !important;\n        flex: unset;\n        -webkit-box-flex: unset;\n        -moz-box-flex: unset;\n        -webkit-flex: unset;\n        -ms-flex: unset;\n    }\n    form.lstCustForm .form-check:not(:last-child) {\n        margin: 0 25px 8px 0;\n    }\n    .profile_radiorow > .icon-cross {\n        right: 12px;\n        top: 12px;\n        background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/trash.svg) no-repeat 0 0;\n        width: 16px;\n        height: 16px;\n    }\n    .profile_radiorow > .icon-cross::before {\n        display: none;\n    }\n    .max-630 {\n        max-width: 100%;\n        width: 90%;\n    }\n    .page_ttl_row > .mx-sm-1 {\n        margin-right: 0 !important;\n        margin-left: 0 !important;\n    }\n    .welcome_pg {\n        padding-left: 0;\n        padding-right: 0;\n    }\n    .msg_title_row_wrapper {\n        scrollbar-width: none;\n        padding-right: 0;\n    }\n    .extmar {\n        margin-right: 0px !important;\n    }\n    .msgtabcont.polarcontsec.msgwrapext {\n        padding: 20px 0 0 0;\n    }\n}\n\n@media (max-width: 575px) {\n    .btn-verify {\n        line-height: 40px;\n    }\n    .cpw_bg {\n        padding: 20px;\n    }\n    .JobInternshipForm h2 {\n        margin: 0 0 30px;\n    }\n    .btn-border:hover,\n    .btn-verify:hover {\n        background-size: 200% 100%;\n    }\n    .polartabsec {\n        padding: 18px 0;\n    }\n    .polartabsec .xscroll {\n        width: 95%;\n        margin-left: 5%;\n    }\n    .polartabsec + div {\n        padding-bottom: 30px !important;\n    }\n    .polartabsec + div.newmsg {\n        padding: 0 !important;\n    }\n    .act_lst {\n        padding: 40px 15px 15px 15px;\n        text-align: left;\n    }\n    .exp_loc,\n    .act_lst > .row > div:last-child > div {\n        justify-content: flex-start !important;\n    }\n    .person_detls {\n        justify-content: flex-start;\n        margin-top: 5px;\n    }\n    .act_lst > .row > div:last-child {\n        text-align: left !important;\n    }\n    .lstperdetails {\n        width: 100%;\n    }\n    .listblk_icon {\n        margin-bottom: 10px;\n        width: 34px;\n        height: 34px;\n    }\n    .act_lst.actlst_listed .btn-green,\n    .act_lst .btn-green,\n    .act_lst .btn-dark-blue {\n        height: 34px !important;\n        line-height: 34px;\n    }\n    .listblk_icon .listblk_icon_bm {\n        width: 10px;\n        height: auto;\n    }\n    .listblk_icon .listblk_icon_sh {\n        width: 14px;\n        height: auto;\n    }\n    .load_more_btn {\n        height: 40px;\n        line-height: 38px;\n    }\n    .docselect {\n        width: 100%;\n    }\n    .docselect .inputfile {\n        text-overflow: ellipsis;\n        overflow: hidden;\n        white-space: nowrap;\n        -webkit-box-flex: 1;\n        -moz-box-flex: 1;\n        -webkit-flex: 1;\n        -ms-flex: 1;\n        flex: 1;\n    }\n    .album_shareblk {\n        width: 100%;\n        padding: 20px 0 0 0px;\n        display: -webkit-box;\n        display: -moz-box;\n        display: -ms-flexbox;\n        display: -webkit-flex;\n        display: flex;\n        justify-content: start;\n    }\n    .album_shareblk > span:not(:last-child) {\n        margin: 0 5px 5px 0;\n    }\n    .EventsBlk .album_shareblk {\n        width: 60px;\n        padding: 0px 0 0 20px;\n    }\n    .justify-content-start.mContCenter {\n        justify-content: flex-start !important;\n    }\n    .d-flex.mflexcol {\n        flex-direction: column;\n        align-items: flex-start !important;\n    }\n    .d-flex.mflexcol.btnview {\n        flex-direction: row;\n    }\n    .d-flex.mflexcol.btnview > span {\n        margin-left: 10px;\n    }\n    .alumni_directory_details ul.orderlist li {\n        flex-wrap: wrap;\n    }\n    .alumni_directory_details ul.orderlist li p {\n        margin: 3px 0 5px;\n        width: 100%;\n    }\n    .mscroll {\n        width: 100%;\n        overflow-x: auto;\n        scrollbar-width: thin;\n    }\n    .mscroll > div {\n        width: max-content;\n    }\n    .graph-result-list {\n        width: 100%;\n    }\n    .mjcstart {\n        justify-content: flex-start !important;\n    }\n    .mjcstart select:last-child {\n        margin-left: 5px;\n    }\n    .map-Search {\n        max-width: 260px;\n    }\n    .locbtncol {\n        justify-content: flex-start;\n        align-items: flex-start;\n        margin: 0 0 10px;\n    }\n    .phone_number.max-135 {\n        max-width: unset;\n        -webkit-box-flex: unset;\n        -moz-box-flex: unset;\n        -webkit-flex: unset;\n        -ms-flex: unset;\n        flex: unset;\n        width: unset;\n    }\n    .phone_number.contemail {\n        max-width: unset;\n        -webkit-box-flex: unset;\n        -moz-box-flex: unset;\n        -webkit-flex: unset;\n        -ms-flex: unset;\n        flex: unset;\n        width: unset;\n        margin: 10px 0 0;\n    }\n    .albumadd {\n        position: relative;\n    }\n    .albumadd > .flex-1 {\n        -webkit-box-flex: unset;\n        -moz-box-flex: unset;\n        -webkit-flex: unset;\n        -ms-flex: unset;\n        flex: unset;\n        width: 100%;\n        margin: 15px 0 0 !important;\n    }\n    .albumadd .albm_edit_settings {\n        position: absolute !important;\n        right: 15px;\n        top: 15px;\n    }\n    form.lstCustForm .btn-greenm,\n    .btn-greenm252 {\n        min-width: unset;\n        width: auto;\n        line-height: 15px;\n        justify-content: center;\n        align-items: center;\n        display: flex !important;\n        max-width: 252px;\n    }\n    .font-24 {\n        font-size: 20px !important;\n    }\n    .btn-green {\n        font-size: 14px;\n        line-height: 14px;\n    }\n    .album_contblk,\n    .album_contblk.eventsbox {\n        padding: 12px 15px 15px 15px;\n    }\n    .EventsBlk .btn-border-gray {\n        min-width: 92px;\n        padding: 0 8px;\n    }\n    .btn-green.max-170 {\n        max-width: unset !important;\n        width: unset;\n        min-width: 110px;\n    }\n    .uniprof_btnmbl_align .btn-darkblue {\n        font-size: 14px;\n    }\n    .search_cont.px-4 {\n        padding-left: 12px !important;\n        padding-right: 12px !important;\n    }\n    .msgbox .uni_profiles_sec .icon-invert-cross {\n        right: 12px;\n    }\n    .msgbox .uni_profiles_sec {\n        padding: 5px 35px 5px 15px;\n    }\n    .search_ttlblk .uni_profiles_sec {\n        padding: 0px 15px 5px;\n    }\n    .msg_area {\n        -webkit-box-wrap: wrap;\n        -moz-box-wrap: wrap;\n        -ms-flex-wrap: wrap;\n        -webkit-wrap: wrap;\n        flex-wrap: wrap;\n    }\n    .msg_area .flex-1 {\n        flex: unset;\n        -webkit-box-flex: unset;\n        -moz-box-flex: unset;\n        -webkit-flex: unset;\n        -ms-flex: unset;\n        width: 100%;\n        margin: 0 0 12px 0 !important;\n    }\n    .msg_area .flex-column {\n        flex-direction: row !important;\n        width: 100%;\n        justify-content: end;\n    }\n    .msg_area .flex-column a:first-child {\n        margin-right: 5px;\n    }\n    .msg_title_txt,\n    .msgacpign {\n        width: 100%;\n        margin-left: 0px;\n    }\n    .convo_btns {\n        padding-left: 0;\n    }\n    form.lstCustForm label span {\n        padding: 0 0 0 0px;\n        width: 100%;\n    }\n    form.lstCustForm .inputfile_parent label span {\n        width: unset;\n    }\n}\n\n@media (max-width: 479px) {\n    #html5-lightbox-box,\n    .html5-elem-wrap,\n    .html5lightbox-video iframe {\n        width: 300px !important;\n        height: 200px !important;\n    }\n    .uniprof_btnmbl_align .btn-green.height-40 {\n        height: 34px !important;\n        line-height: 34px;\n        padding: 0 13px;\n    }\n    .uniprof_btnmbl_align .btn-darkblue {\n        height: 34px !important;\n        padding: 0 13px;\n        line-height: 14px;\n    }\n    .alumni-switch-container.msg-switch {\n        width: 290px;\n    }\n    .alumni-switch-container.msg-switch .switch > a {\n        font-size: 14px !important;\n    }\n}\n\n@media (max-width: 350px) {\n    .m-max-105 {\n        max-width: 105px;\n    }\n}\n\n.sideBar-btn {\n    width: 48px;\n    height: 48px;\n    background: #414141;\n    border-radius: 0 5px 5px 0;\n    border: 0;\n    left: 100%;\n    top: 180px;\n}\n.customOffcanvas {\n    width: 250px;\n    background: #414141;\n    border-color: #414141;\n}\n.sideBar-btn .navbar-toggler-icon {\n    width: 20px;\n    height: 30px;\n    font-size: 0;\n}\n.sideBar-btn .navbar-toggler-icon::after,\n.sideBar-btn .navbar-toggler-icon::before,\n.sideBar-btn .navbar-toggler-icon b {\n    background-color: #b3b3b3;\n    -o-border-radius: 3px;\n    -moz-border-radius: 3px;\n    -ms-border-radius: 3px;\n    -webkit-border-radius: 3px;\n    border-radius: 5px;\n    content: '';\n    display: block;\n    height: 2px;\n    margin: 6px 0;\n    -moz-transition: all 0.2s ease-in-out;\n    -webkit-transition: all 0.2s ease-in-out;\n    transition: all 0.2s ease-in-out;\n    font-size: 0;\n}\n.offcanvas[aria-modal='true'] .sideBar-btn .navbar-toggler-icon::before {\n    transform: translateY(10px) rotate(135deg);\n    -moz-transform: translateY(10px) rotate(135deg);\n    -webkit-transform: translateY(10px) rotate(135deg);\n    width: 20px;\n    height: 3px;\n    -ms-transform: translateY(10px) rotate(135deg);\n    -o-transform: translateY(10px) rotate(135deg);\n}\n.offcanvas[aria-modal='true'] .sideBar-btn .navbar-toggler-icon b {\n    -moz-transform: scale(0);\n    -webkit-transform: scale(0);\n    transform: scale(0);\n    -ms-transform: scale(0);\n    -o-transform: scale(0);\n}\n.offcanvas[aria-modal='true'] .sideBar-btn .navbar-toggler-icon::after {\n    transform: translateY(-7px) rotate(-135deg);\n    -moz-transform: translateY(-7px) rotate(-135deg);\n    -webkit-transform: translateY(-7px) rotate(-135deg);\n    width: 20px;\n    height: 3px;\n    -ms-transform: translateY(-7px) rotate(-135deg);\n    -o-transform: translateY(-7px) rotate(-135deg);\n}\n.offcanvas.offcanvas-start:not(.show) ~ div.offcanvas-backdrop {\n    display: none;\n}\n.offcanvas-body > ul > li:not(:last-child) {\n    border-bottom: 1px solid #545454;\n}\n.offcanvas-body > ul > li > a {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    padding: 15px 0;\n    color: #fff;\n    justify-content: space-between;\n    font-size: 16px;\n}\n.offcanvas-body > ul > li > a .icon {\n    font-size: 12px;\n    transform: rotate(90deg);\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n    -webkit-transform: rotate(90deg);\n    -moz-transform: rotate(90deg);\n    -ms-transform: rotate(90deg);\n    -o-transform: rotate(90deg);\n}\n.offcanvas-body > ul > li > a[aria-expanded='true'] .icon {\n    transform: rotate(270deg);\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n    -webkit-transform: rotate(270deg);\n    -moz-transform: rotate(270deg);\n    -ms-transform: rotate(270deg);\n    -o-transform: rotate(270deg);\n}\n.offcanvas-body > ul > li ul {\n    margin-bottom: 20px;\n    list-style: none;\n    margin-left: 0;\n    padding: 0 0 0 10px;\n}\n.offcanvas-body > ul > li ul a {\n    font-size: 14px;\n    color: #fff;\n}\n.offcanvas-body a:hover,\n.offcanvas-body a:focus {\n    color: #fff;\n}\n.offcanvas-body {\n    -ms-overflow-style: none;\n    scrollbar-width: none;\n}\n.offcanvas-body::-webkit-scrollbar {\n    display: none;\n}\n.tooltip-inner {\n    background: #0b3454;\n    border: 1px solid #0b3454;\n}\n.bs-tooltip-top .tooltip-arrow::before {\n    border-top-color: #0b3454;\n}\n.alumni-switch-container {\n    background: rgba(0, 0, 0, 0.3);\n    border-radius: 20px;\n    width: 261px;\n    height: 40px;\n}\n.alumni-switch-container .switch {\n    width: 100%;\n    height: 40px;\n}\n.alumni-switch-container .switch label {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    color: #fff;\n    text-align: center;\n    height: 100%;\n    cursor: pointer;\n    position: relative;\n    opacity: 0.6;\n}\n.switch {\n    position: relative;\n}\n.switch > span {\n    width: 50%;\n    height: 40px;\n    background: #fafcff;\n    content: '';\n    border-radius: 20px;\n    position: absolute;\n}\n.alumni-switch-container * {\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.alumni-switch-container .form-check-input[id*='shortlistCheck']:checked ~ div.switch::before {\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.alumni-switch-container .form-check-input[id*='finalizeCheck']:checked ~ div.switch::before {\n    transform: translateX(100%);\n    transition: all 0.3s ease-in-out;\n    -webkit-transform: translateX(100%);\n    -moz-transform: translateX(100%);\n    -ms-transform: translateX(100%);\n    -o-transform: translateX(100%);\n}\n.alumni-switch-container .form-check-input[id*='shortlistCheck']:checked ~ div.switch label[for*='shortlistCheck'] {\n    color: #0b3454;\n    opacity: 1;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.alumni-switch-container .form-check-input[id*='finalizeCheck']:checked ~ div.switch label[for*='finalizeCheck'] {\n    color: #0b3454;\n    opacity: 1;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.alumni-switch-container .switch > a {\n    width: 50%;\n    color: rgba(255, 255, 255, 0.6);\n    text-decoration: none;\n    position: relative;\n    z-index: 1;\n}\n.alumni-switch-container .switch > a.active {\n    color: #0b3454;\n}\n.alumni-switch-container .switch > a.btn-allCampuses.active + span {\n    transform: translateX(100%);\n    -webkit-transform: translateX(100%);\n    -moz-transform: translateX(100%);\n    -ms-transform: translateX(100%);\n    -o-transform: translateX(100%);\n}\n.aldir_scroll {\n    display: none;\n}\n.aldir_scroll.active {\n    display: block;\n}\n.load_more_btn img {\n    animation: spin 4s infinite linear;\n    -webkit-animation: spin 4s infinite linear;\n}\n\n@keyframes spin {\n    0% {\n        transform: rotate(0deg);\n        -webkit-transform: rotate(0deg);\n        -moz-transform: rotate(0deg);\n        -ms-transform: rotate(0deg);\n        -o-transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n        -webkit-transform: rotate(360deg);\n        -moz-transform: rotate(360deg);\n        -ms-transform: rotate(360deg);\n        -o-transform: rotate(360deg);\n    }\n}\n.filterChecked .selected {\n    background: #ffffff;\n    box-shadow: 0px 1px 1px #f1f1f1;\n    border: 1px solid #dedede;\n    border-radius: 7px;\n    opacity: 1;\n    margin: 3px;\n    padding: 0px 10px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.btn-back * {\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n}\n.btn-back {\n    text-decoration: none;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n}\n.btn-back:hover span {\n    text-decoration: underline;\n}\n.btn-back:hover .icon-left-arrow {\n    -moz-transform: translateX(-5px);\n    -webkit-transform: translateX(-5px);\n    -o-transform: translateX(-5px);\n    -ms-transform: translateX(-5px);\n    transform: translateX(-5px);\n}\n.calendar_status {\n    display: none;\n}\n.fc-header-toolbar {\n    background: #f2f9ff;\n    padding: 20px 30px;\n}\n.fc-toolbar-chunk:first-child > div {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n}\n.fc-theme-standard td,\n.fc-theme-standard th {\n    position: relative;\n}\n.fc-toolbar-chunk:first-child > div .fc-toolbar-title {\n    margin: 3px 10px 0;\n    font-size: 18px;\n    font-weight: 600;\n}\n.fc-toolbar-chunk:first-child > div .fc-button {\n    background: none;\n    border: 0;\n    color: #000;\n    padding: 0;\n}\n.fc-toolbar-chunk:first-child > div .fc-button.fc-button-primary:focus {\n    box-shadow: none;\n}\n.fc-toolbar-chunk:first-child > div .fc-button.fc-button-primary:not(:disabled):active,\n.fc .fc-button-primary:not(:disabled).fc-button-active {\n    color: #000;\n    color: var(--fc-button-text-color, #fff);\n    background-color: transparent;\n    background-color: var(--fc-button-active-bg-color, transparent);\n    border-color: transparent;\n    border-color: var(--fc-button-active-border-color, transparent);\n}\n.fc-toolbar-chunk:last-child > div.fc-button-group {\n    max-width: 312px;\n    width: 312px;\n    background: #fff;\n    border: 1px solid #b9b9b9;\n    border-radius: 20px;\n    opacity: 1;\n}\n.fc-toolbar-chunk:last-child > div.fc-button-group .fc-button {\n    background: #fff;\n    font-size: 16px;\n    color: #000;\n    text-transform: capitalize;\n    font-weight: 500;\n    border: 0;\n    border-radius: 20px;\n    position: relative;\n    z-index: 1;\n}\n.fc-toolbar-chunk:last-child > div.fc-button-group .fc-button.fc-button-active {\n    background: #5cae48;\n    color: #fff;\n    border: 0;\n    position: relative;\n    z-index: 2;\n}\n.fc-toolbar-chunk:last-child > div.fc-button-group .fc-button:focus {\n    outline: none;\n    box-shadow: none;\n}\n.fc-view {\n    padding: 10px 30px 30px;\n}\n.calendar_filter {\n    display: none;\n}\n.fc-col-header .fc-scrollgrid-sync-inner {\n    height: 50px;\n    padding: 7px 15px;\n    text-align: left;\n}\n.fc-col-header .fc-scrollgrid-sync-inner .fc-col-header-cell-cushion {\n    font-size: 14px;\n    text-decoration: none;\n    font-weight: 500;\n    text-transform: uppercase;\n    padding: 0;\n    color: #000;\n}\n.fc div.fc-daygrid-day-top {\n    flex-direction: row;\n}\n.fc a.fc-daygrid-day-number {\n    padding: 18px;\n    text-decoration: none;\n    color: #000;\n    font-size: 14px;\n    font-weight: 500;\n}\n.fc-direction-ltr .fc-daygrid-week-number {\n    display: none;\n}\n.fc .fc-bg-event.bluesection {\n    background: #f2f9ff;\n    opacity: 1;\n}\n.fc-scrollgrid-sync-inner.eventHas {\n    background: #f2f9ff;\n    opacity: 1;\n    border-left: 2px solid #26a7df;\n}\n.fc .fc-bg-event.bluesection .fc-event-title {\n    margin-top: 44px;\n    padding-left: 8px;\n    font-weight: 500;\n}\n.fc-scrollgrid-sync-inner.eventHas {\n    background: #f2f9ff;\n    border-left: 2px solid #26a7df;\n    max-height: 100%;\n    box-sizing: border-box;\n    max-width: 100%;\n    height: 100%;\n    width: 100%;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    top: 0;\n    margin: auto;\n    position: absolute !important;\n}\n.fc .fc-daygrid-body-balanced div.fc-daygrid-day-events {\n    left: 10px;\n}\n.fc .fc-daygrid-event {\n    color: #0b3454;\n}\n.fc-daygrid-dot-event div.fc-event-title {\n    font-size: 13px;\n    font-weight: 400;\n}\n.fc-direction-ltr .fc-daygrid-event div.fc-event-time {\n    font-size: 13px;\n    font-weight: 400;\n    padding-right: 3px;\n}\n.fc .fc-daygrid-event-harness a.bluesection div {\n    color: #000;\n}\n.fc-daygrid-block-event .fc-event-title {\n    font-size: 12px;\n}\n.fc-media-screen .fc-timegrid-event {\n    background: #f2f9ff;\n    border-color: #26a7df;\n    border-width: 0 0 0 2px;\n    border-radius: 0;\n    box-shadow: none !important;\n}\n.fc-direction-ltr .fc-timegrid-col-events {\n    margin: 0;\n}\ndiv.fc-daygrid-event-dot {\n    border: calc(var(--fc-daygrid-event-dot-width, 8px) / 2.5) solid var(--fc-event-border-color, #26a7df);\n}\n.fc .fc-timeGridWeek-view .fc-bg-event.bluesection .fc-event-title {\n    margin: 6px 0 0;\n}\n.fc .fc-timeGridWeek-view .fc-v-event .fc-event-main-frame {\n    color: #000;\n}\n.fc-direction-ltr .fc-timegrid-col-events {\n    margin: 0;\n}\n.share_option {\n    padding: 0;\n    margin: 0 -9px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n}\n.share_option li {\n    list-style: none;\n    width: 206px;\n    margin: 0 5px 10px;\n}\n.share_option li a {\n    width: 100%;\n    height: 45px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    border-radius: 6px;\n    padding: 8px 15px;\n    font-size: 16px;\n    color: #fff;\n    text-decoration: none;\n    align-items: center;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n}\n.share_option li a.wa {\n    color: #000;\n}\n.share_option li a:hover {\n    -moz-transform: translateY(-3px);\n    -webkit-transform: translateY(-3px);\n    -o-transform: translateY(-3px);\n    -ms-transform: translateY(-3px);\n    transform: translateY(-3px);\n}\n.fc-timeGridDay-view .fc-v-event .fc-event-main-frame {\n    color: #000;\n    padding: 5px 10px;\n}\n.fc .fc-timegrid-axis-cushion {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    text-decoration: none;\n    color: #000;\n    font-weight: 500;\n}\n.fc-direction-ltr div.fc-timegrid-col-events {\n    margin: 0;\n}\n.share_option li a img {\n    width: 28px;\n}\n.fb {\n    background-color: #3d5a96;\n}\n.tw {\n    background-color: #2aa3ef;\n}\n.in {\n    background-color: #017ab7;\n}\n.wa {\n    background: #41c452;\n}\n.mobilesidebar .accordion-button {\n    max-width: 155px;\n    background: none;\n    color: #5cae48;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: space-between;\n}\n.mobilesidebar .accordion-button:not(.collapsed) {\n    background: none;\n    box-shadow: none;\n}\n.mobilesidebar .accordion-button:focus {\n    outline: 0;\n    box-shadow: none;\n}\n.paddingx-30 {\n    padding-left: 6%;\n    padding-right: 6%;\n}\n#accordionSideMenu .accordion-item {\n    border: 0;\n    background: none;\n    border-bottom: 1px solid #eee;\n}\n#accordionSideMenu .accordion-button {\n    font-size: 16px;\n    font-weight: 600;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: space-between;\n}\n#accordionSideMenu .accordion-button:not(.collapsed) {\n    color: #5cae48;\n    background-color: #fff;\n    box-shadow: none;\n}\n.sideMenu .accordion-button:focus {\n    box-shadow: none;\n}\n.sideMenu .accordion-button span {\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.sideMenu .accordion-button::after {\n    display: none;\n}\n.sideMenu .accordion-button:not(.collapsed) span[class*='icon'] {\n    transform: rotate(-180deg);\n    -webkit-transform: rotate(-180deg);\n    -moz-transform: rotate(-180deg);\n    -ms-transform: rotate(-180deg);\n    -o-transform: rotate(-180deg);\n}\n.toggleSearch {\n    width: 33px;\n    height: 33px;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    margin: auto;\n    border-radius: 50%;\n    background: #fff;\n    border: 1px solid #e1e1e1;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-decoration: none;\n    color: #414141;\n    font-size: 14px;\n    right: 0;\n}\n.mobilesidebar .filterSearch {\n    -moz-transform: translateX(100%);\n    -webkit-transform: translateX(100%);\n    -o-transform: translateX(100%);\n    -ms-transform: translateX(100%);\n    transform: translateX(100%);\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n}\n.mobilesidebar .open .filterSearch {\n    -moz-transform: translateX(0px);\n    -webkit-transform: translateX(0px);\n    -o-transform: translateX(0px);\n    -ms-transform: translateX(0px);\n    transform: translateX(0px);\n}\n.needs-validation.was-validated .form-control:invalid,\n.login_wrap .login_form form.was-validated .form-group .form-control:invalid,\n.needs-validation.was-validated .form-select:invalid {\n    border-color: #e55355;\n    box-shadow: 0px 0px 10px #e55355 !important;\n}\n.needs-validation .form-control {\n    position: relative;\n}\n.needs-validation .invalid-feedback {\n    display: none;\n    width: 100%;\n    margin-top: 0;\n    font-size: 0.875em;\n    color: #fff;\n    background: #d86465;\n    padding: 5px 15px 5px;\n    border-radius: 4px;\n    position: relative;\n    font-size: 13px;\n    font-style: italic;\n}\n.needs-validation .invalid-feedback::before {\n    position: absolute;\n    content: '';\n    width: 10px;\n    height: 10px;\n    border-bottom: 7px solid #d86465;\n    border-left: 7px solid transparent;\n    border-right: 7px solid transparent;\n    top: -10px;\n    left: 20px;\n}\n\n@media (min-width: 630px) and (max-width: 767px) {\n    .fc .fc-daygrid-body-balanced div.fc-daygrid-day-events {\n        left: 10px;\n        bottom: 13px;\n    }\n    .fc .fc-bg-event.bluesection .fc-event-title {\n        margin-top: 40px;\n        padding-left: 8px;\n        font-weight: 500;\n        white-space: nowrap;\n        max-width: 100px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n    .fc-v-event .fc-event-title {\n        white-space: nowrap;\n        max-width: 100px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n    .fc .fc-timegrid-axis-cushion {\n        display: -webkit-box;\n        display: -moz-box;\n        display: -ms-flexbox;\n        display: -webkit-flex;\n        display: flex;\n        align-items: center;\n        text-decoration: none;\n        color: #000;\n        font-weight: 500;\n    }\n}\n\n@media (max-width: 767px) {\n    .fc-header-toolbar {\n        padding: 20px 0px;\n    }\n    .fc-header-toolbar > div {\n        width: 90%;\n        margin: auto;\n        text-align: center;\n    }\n    .fc-view {\n        padding: 10px 0px 30px;\n        width: 90%;\n        margin: auto;\n    }\n}\n\n@media (max-width: 629px) {\n    .share_option {\n        justify-content: center;\n    }\n    .fc-toolbar-chunk {\n        width: 100%;\n    }\n    .fc-toolbar-chunk:first-child > div {\n        justify-content: center;\n        margin-bottom: 15px;\n    }\n    .fc .fc-toolbar {\n        -webkit-box-wrap: wrap;\n        -moz-box-wrap: wrap;\n        -ms-flex-wrap: wrap;\n        -webkit-wrap: wrap;\n        flex-wrap: wrap;\n    }\n    .fc-toolbar-chunk:last-child > div.fc-button-group {\n        width: 100%;\n    }\n    .fc a.fc-daygrid-day-number {\n        padding: 8px;\n        font-size: 12px;\n    }\n    .fc .fc-bg-event.bluesection .fc-event-title {\n        margin-top: 30px;\n        padding-left: 0px;\n        font-weight: 500;\n    }\n    .fc-col-header .fc-scrollgrid-sync-inner {\n        padding: 5px;\n        height: 40px;\n    }\n    .fc .fc-daygrid-body-balanced .fc-daygrid-day-events {\n        left: 0 !important;\n        bottom: 0;\n        font-size: 12px;\n    }\n    .fc .fc-bg-event.bluesection .fc-event-title {\n        margin-top: 14px;\n        padding-left: 0px;\n        font-weight: 500;\n        font-size: 11px;\n        max-width: 36px;\n        width: 100%;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n    .fc-direction-ltr .fc-timegrid-col-events {\n        margin: 0;\n    }\n    .fc-timegrid-event {\n        border-radius: 0;\n        background: #f2f9ff;\n        border-left-color: #26a7df;\n        border-width: 0 0 0 2px;\n        padding: 5px 12px;\n        color: #000 !important;\n    }\n    .fc-v-event .fc-event-main-frame {\n        color: #000;\n    }\n    .fc .fc-timegrid-axis-cushion {\n        max-width: 60px;\n        flex-shrink: 0;\n        display: -webkit-box;\n        display: -moz-box;\n        display: -ms-flexbox;\n        display: -webkit-flex;\n        display: flex;\n        align-items: center;\n        text-decoration: none;\n        color: #000;\n        font-weight: 500;\n    }\n}\n\n@media (max-width: 480px) {\n    .fc-col-header .fc-scrollgrid-sync-inner .fc-col-header-cell-cushion {\n        font-size: 12px;\n    }\n    .fc .fc-timegrid-axis-cushion {\n        font-size: 16px;\n    }\n    .fc a.fc-daygrid-day-number {\n        padding: 5px;\n        font-size: 12px;\n    }\n    .fc .fc-daygrid-more-link {\n        white-space: nowrap;\n    }\n    .fc-media-screen .fc-timegrid-event {\n        padding: 3px;\n    }\n}\n\n@media (max-width: 400px) {\n    .courseLabel {\n        margin-right: 0;\n    }\n    .alumni_college_bottom {\n        flex-direction: column;\n    }\n}\n\n.modal.show .modal-dialog {\n    margin-left: auto;\n    margin-right: auto;\n}\n#html5box-html5-lightbox {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: calc(100% - 97px);\n}\n#html5-lightbox-box {\n    margin: auto !important;\n}\n.html5-elem-data-box {\n    position: fixed !important;\n    top: 15px;\n    left: 0;\n    right: 0;\n    background: none !important;\n    color: #fff !important;\n    height: auto;\n}\n#html5box-html5-lightbox .html5-text {\n    color: #fff;\n    text-align: center;\n    margin: 0 !important;\n    height: auto;\n}\n#html5box-html5-lightbox .html5-text .html5-title {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column-reverse;\n    justify-content: flex-start;\n    height: auto;\n    align-items: center;\n    color: #fff;\n    font-weight: 500;\n}\n#html5box-html5-lightbox .html5-text .html5-title .html5-playpause {\n    display: none !important;\n}\n.html5-nav-thumb.video img {\n    position: relative;\n}\n.html5-nav-thumb.video:before {\n    content: '\\e91f';\n    font-family: 'icomoon' !important;\n    speak: never;\n    font-style: normal;\n    font-weight: normal;\n    font-variant: normal;\n    text-transform: none;\n    line-height: 1;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    position: absolute;\n    z-index: 1;\n    position: absolute;\n    left: 0;\n    right: 0 !important;\n    bottom: 0;\n    top: 0 !important;\n    margin: auto;\n    color: #fff;\n    font-size: 25px;\n    text-align: center;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.html5-nav-thumb.video {\n    position: relative;\n}\n.no-background-img {\n    background-image: none !important;\n}\n.customselect_parnt .custom-select {\n    position: relative;\n    width: max-content;\n    flex: unset;\n    min-width: 109px;\n}\n.customselect_parnt .custom-select select {\n    display: none;\n}\n.customselect_parnt .select-selected {\n    background-color: DodgerBlue;\n}\n.customselect_parnt .select-selected:after {\n    position: absolute;\n    content: '';\n    top: 14px;\n    right: 10px;\n    width: 0;\n    height: 0;\n    border: 6px solid transparent;\n    border-color: #fff transparent transparent transparent;\n}\n.customselect_parnt .select-selected.select-arrow-active:after {\n    border-color: transparent transparent #fff transparent;\n    top: 7px;\n}\n.customselect_parnt .select-selected {\n    color: #414141;\n    padding: 0px 30px 0 14px;\n    border: 2px solid #7d7d7d;\n    border-color: #7d7d7d;\n    cursor: pointer;\n    border-radius: 18px;\n    height: 32px;\n    width: max-content;\n    transition: all 0.3s ease-in-out;\n    background: #fff;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 32px;\n    min-width: 65px;\n    box-sizing: initial;\n    border-radius: 18px;\n}\n.customselect_parnt .select-selected::after {\n    position: absolute;\n    content: '';\n    top: 10px;\n    right: 12px;\n    width: 10px;\n    height: 10px;\n    border: unset;\n    border-top: 2px solid #7d7d7d;\n    border-right: 2px solid #7d7d7d;\n    transform: rotate(135deg);\n    transition: all 0.2s ease-in-out;\n    -webkit-transition: all 0.2s ease-in-out;\n    -moz-transition: all 0.2s ease-in-out;\n    -ms-transition: all 0.2s ease-in-out;\n    -o-transition: all 0.2s ease-in-out;\n    -webkit-transform: rotate(135deg);\n    -moz-transform: rotate(135deg);\n    -ms-transform: rotate(135deg);\n    -o-transform: rotate(135deg);\n}\n.customselect_parnt .select-selected.select-arrow-active::after {\n    border: unset;\n    top: 15px;\n    border-top: 2px solid #7d7d7d;\n    border-right: 2px solid #7d7d7d;\n    transform: rotate(-45deg);\n    width: 10px;\n    height: 10px;\n    right: 12px;\n    -webkit-transform: rotate(-45deg);\n    -moz-transform: rotate(-45deg);\n    -ms-transform: rotate(-45deg);\n    -o-transform: rotate(-45deg);\n}\n.customselect_parnt .select-items div {\n    color: #000000;\n    padding: 3px 16px;\n    border: 0px solid transparent;\n    border-color: transparent transparent rgba(0, 0, 0, 0.1) transparent;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 500;\n}\n.customselect_parnt .select-items div:first-child {\n    margin-top: 10px;\n}\n.customselect_parnt .select-items div:last-child {\n    margin-bottom: 10px;\n}\n.customselect_parnt .select-items {\n    position: absolute;\n    background-color: #fff;\n    top: 100%;\n    left: 0;\n    right: 0;\n    z-index: 99;\n    border: 1px solid #dedede;\n    border-radius: 18px;\n    box-shadow: 0px 10px 20px #0000001a;\n    width: 145px;\n    -webkit-border-radius: 18px;\n    -moz-border-radius: 18px;\n    -ms-border-radius: 18px;\n    -o-border-radius: 18px;\n}\n.customselect_parnt .select-hide {\n    display: none;\n}\n.customselect_parnt .select-items div:hover,\n.customselect_parnt .same-as-selected {\n    background-color: rgba(0, 0, 0, 0.1);\n}\n.needs-validation.was-validated.contfwrap .form-control:invalid,\n.login_wrap .login_form form.was-validated.contfwrap .form-group .form-control:invalid,\n.needs-validation.was-validated.contfwrap .form-select:invalid {\n    border-color: #e55355;\n    box-shadow: 0px 0px 5px #e553554d !important;\n}\n.needs-validation.contfwrap .invalid-feedback {\n    color: #d42941;\n    background: transparent;\n    padding: 3px 0 0;\n    border-radius: unset;\n    font-size: 14px;\n    font-style: unset;\n}\n.needs-validation.contfwrap .invalid-feedback::before {\n    display: none;\n}\n.btn-response-msg {\n    background: #26a7df;\n    line-height: 23px;\n    padding: 0;\n    max-width: 150px;\n    width: 76px !important;\n    color: #fff;\n    font-weight: 500;\n}\n.btn-response-msg:hover,\n.btn-response-msg.open {\n    background: #0b3454;\n    color: #fff;\n}\n.response-cover {\n    position: absolute;\n    top: 54px;\n    background: #0b3454;\n    padding: 10px;\n    border-radius: 5px;\n    z-index: -1;\n    left: -31px;\n    width: 138px;\n    opacity: 0;\n    transition: all 0.3s ease-in-out;\n    border: 1px solid #0b3454;\n    box-shadow: 0px 3px 6px #0000001a;\n}\n.btn-response-msg.open + div.response-cover {\n    opacity: 1;\n    z-index: 1;\n    top: 39px;\n}\n.response-cover:before {\n    content: '';\n    position: absolute;\n    width: 0;\n    height: 0;\n    border-left: 5px solid transparent;\n    border-right: 5px solid transparent;\n    border-bottom: 5px solid #0b3454;\n    left: 0;\n    right: 0;\n    margin: auto;\n    top: -6px;\n}\n.btn-response-msg:focus {\n    box-shadow: none;\n}\n.tooltip.show {\n    opacity: 1;\n}\n.tooltip-response > div:not(.tooltip-arrow) {\n    padding-top: 8px;\n    padding-bottom: 8px;\n}\n.universities_list_wrap {\n    overflow: auto;\n    max-height: 375px;\n    padding: 3px 3px;\n}\n.universities_list_wrap ul {\n    padding: 0;\n    margin: 0;\n    list-style: none;\n}\n.universities_list_wrap ul li {\n    display: flex;\n    align-items: center;\n}\n.universities_list_wrap ul li .logo_college {\n    width: 60px;\n    background: #fff;\n    padding: 10px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 60px;\n    box-shadow: 0 0 3px 0px #ccc;\n    margin-right: 15px;\n}\n.universities_list_wrap ul li .logo_college img {\n    width: auto;\n    height: 100%;\n}\n.universities_list_wrap ul li:not(:last-child) {\n    margin-bottom: 15px;\n}\n.universities_list_wrap ul li span {\n    font-size: 18px;\n    font-weight: 500;\n}\n.universities_list_wrap::-webkit-scrollbar {\n    width: 7px;\n}\n.universities_list_wrap::-moz-scrollbar {\n    width: 7px;\n}\n.universities_list_wrap::-webkit-scrollbar-track {\n    background: #eee;\n}\n.universities_list_wrap::-webkit-scrollbar-thumb {\n    background-color: #ccc;\n    border-radius: 20px;\n    border: 2px solid #eee;\n}\n.view_new_message_wrap {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    justify-content: end;\n    margin: 0;\n}\n.view_new_message_wrap .form-select {\n    border: 2px solid #7d7d7d;\n    border-radius: 25px;\n    height: 36px;\n    min-width: 150px;\n    max-width: 150px;\n    margin-right: 10px;\n    padding-top: 0;\n    padding-bottom: 0;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 32px;\n    min-width: 55px;\n    box-sizing: initial;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n}\n.view_new_message_wrap .btn-green-msg {\n    border-radius: 25px;\n}\n.msg_title.msg_heading_row .btn-complete-now:hover span {\n    color: #fff;\n}\n.alumni_message {\n    background: transparent;\n    padding: 0;\n    font-size: 14px;\n    border-radius: 25px;\n    line-height: 22px;\n    margin: 3px 0 0;\n    color: #d42941;\n    text-transform: uppercase;\n    font-weight: 500;\n}\n.student_message {\n    background: transparent;\n    padding: 0;\n    font-size: 14px;\n    border-radius: 25px;\n    line-height: 22px;\n    color: #c38400;\n    text-transform: uppercase;\n    font-weight: 500;\n    margin: 3px 0 0;\n}\n.school_message {\n    background: transparent;\n    padding: 0;\n    font-size: 14px;\n    border-radius: 25px;\n    line-height: 22px;\n    color: #26a7df;\n    text-transform: uppercase;\n    font-weight: 500;\n    margin: 3px 0 0;\n}\n.msg_title_row .university_ttl span[class*='message'] {\n    display: block;\n    font-size: 14px !important;\n    color: #000;\n    line-height: 16px;\n}\n.mgs_sender {\n    flex-direction: column;\n    align-items: end;\n}\n\n@media (max-width: 1180px) {\n    .mgs_sender {\n        flex-direction: row;\n    }\n    .mgs_sender > span[class*='_message'] {\n        margin-left: 10px;\n        margin-top: -1px;\n    }\n}\n\n@media (max-width: 650px) {\n    .view_new_message_wrap {\n        margin-top: 14px;\n    }\n}\n\n@media (max-width: 575px) {\n    .university_ttl {\n        width: 100%;\n        margin-right: 0 !important;\n    }\n}\n\n@media (max-width: 400px) {\n    .view_new_message_wrap .form-select {\n        width: calc(100% - 201px);\n        max-width: initial;\n        min-width: initial;\n    }\n}\n.user_id {\n    position: absolute;\n    bottom: -25px;\n    right: 10px;\n    color: #fff;\n    font-size: 14px;\n    background: #5cae48;\n    font-weight: 500;\n    padding: 0 15px;\n    border-radius: 10px 10px 0 0;\n    white-space: nowrap;\n}\nheader > .container {\n    position: relative;\n}\n\n/* New css 10012023 */\n.alumni-directory-header {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 20px;\n}\n.alumni-directory-header_search {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    align-items: center;\n}\n.alumni-directorySearch {\n    background: #fff;\n    width: 365px;\n    height: 40px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    border-radius: 25px;\n    overflow: hidden;\n    position: relative;\n}\n.alumni-directorySearch .form-control {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    border: 0;\n    padding-left: 0;\n}\n.alumni-directorySearch .btn.icon-search {\n    font-size: 12px;\n    padding: 0 10px 0 20px;\n}\n.alumni-directorySearch .btn-search-cross {\n    position: absolute;\n    right: 13px;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    color: #000;\n    font-weight: 100 !important;\n}\n.alumni-directorySearch .btn-cross {\n    width: 14px;\n    height: 14px;\n    position: absolute;\n    right: -15px;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    transform: rotate(0deg);\n    opacity: 0;\n    transition: all 0.5s ease-in-out;\n}\n.alumni-directorySearch .btn-cross:before {\n    content: '';\n    position: absolute;\n    width: 14px;\n    height: 2px;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    top: 0;\n    margin: auto;\n    background: #000;\n    border-radius: 5px;\n}\n.alumni-directorySearch .btn-cross:after {\n    content: '';\n    position: absolute;\n    width: 2px;\n    height: 14px;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    top: 0;\n    margin: auto;\n    background: #000;\n    border-radius: 5px;\n}\n.alumni-directorySearch .form-control:valid + .btn-cross {\n    opacity: 1;\n    right: 15px;\n    transform: rotate(135deg);\n}\n.alumni_directory_filter {\n    padding: 30px 0;\n    padding-right: var(--bs-gutter-x, 0.75rem);\n    padding-left: var(--bs-gutter-x, 0.75rem);\n}\n.alumni_directory_filter .ji_filtersec {\n    width: 100%;\n    max-width: 100%;\n}\n.alumni_directory_filter .fiterItem {\n    width: 220px;\n    margin: 0 5px;\n    box-shadow: 0px 10px 25px #00000008;\n}\n.alumni_directory_filter .fiterItem.key {\n    border-color: #5cae48;\n}\n.alumni_directory_filter .filterGroup {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    align-items: start;\n    margin: 0 -5px;\n}\n.alumni_directory_filter .filterSearchblk {\n    background: #fff;\n    padding: 0 14px 10px;\n}\n.alumni_directory_filter .filterSearchblk .filterSearch input {\n    margin: 0;\n}\n.alumni_directory_filter .filterHeader button {\n    transition: all 0.3s ease-in-out;\n    padding: 15px 15px;\n}\n.alumni_directory_filter .filterHeader button:not([aria-expanded='false']) {\n    padding-bottom: 8px;\n}\n.alumni_directory_filter .fiterItem .card {\n    padding: 0px 15px 15px;\n}\n.alumni_directory_filter .scrollMe {\n    max-height: 122px;\n    min-height: 122px;\n    overflow-x: hidden;\n}\n.alumni_directory_filter .fiterItem .form-check:not(:last-child) {\n    margin-bottom: 4px;\n}\n.additionalfilter_count {\n    display: none;\n}\n.btn-md-filter {\n    text-decoration: none;\n    transform: rotate(90deg);\n    color: #000;\n    font-size: 20px;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.btn-md-filter:hover {\n    color: #000;\n}\n.btn-md-filter[aria-expanded='true'] {\n    transform: rotate(270deg);\n    -webkit-transform: rotate(270deg);\n    -moz-transform: rotate(270deg);\n    -ms-transform: rotate(270deg);\n    -o-transform: rotate(270deg);\n}\n.additionalfilter_wrap {\n    width: 100%;\n    padding: 0 5px;\n}\n.alumni_directory_filter .filterGroup > div {\n    order: 1;\n}\n.alumni_directory_filter .filterGroup > div:nth-child(5) ~ div {\n    order: 3;\n}\n.alumni_directory_filter .filterGroup > div:nth-child(5) ~ div.additionalfilter_wrap {\n    order: 2;\n}\n.alumni_directory_filter .filterGroup > div:nth-child(5) ~ div.additionalfilter_wrap.last {\n    order: 9;\n}\n.alumni_directory_filter .fiterItem.campus {\n    width: 450px;\n}\n.showProfiles_wrap {\n    background: #fff;\n    border: 1px solid #d2d2d2;\n    border-radius: 6px;\n    box-shadow: 0px 10px 25px #00000008;\n    width: calc(100% - 10px);\n    margin: 0 5px;\n    padding: 17px 30px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n.showProfiles_left {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    align-items: center;\n}\n.showProfiles_left h3 {\n    margin: 0 30px 0 0;\n    font-size: 18px;\n    line-height: 20px;\n    font-weight: 600;\n}\n.showProfiles_left .form-check-label {\n    font-size: 16px;\n}\n.showProfiles_left .form-check-input {\n    width: 20px;\n    height: 20px;\n    vertical-align: top;\n    margin-top: -2px;\n    margin-right: 10px;\n}\n.showProfiles_left .form-check.form-check-inline {\n    display: inline-flex;\n    align-items: center;\n}\n.showProfiles_left .check_list {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    align-items: center;\n}\n.showProfiles_left .form-check-input:checked {\n    background-color: #5cae48;\n    border-color: #5cae48;\n}\n.showProfiles_right .icon {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/subtraction.svg);\n    width: 16px;\n    height: 25px;\n    margin-right: 8px;\n}\n.showProfiles_right {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    align-items: center;\n}\n.showProfiles_right .title {\n    font-size: 14px;\n    letter-spacing: -0.35px;\n}\n.alumni-bucket {\n    background: #fff;\n    border: 1px solid #d2d2d2;\n    border-radius: 6px;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n}\n.alumni-bucket .block-link {\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    top: 0;\n    margin: auto;\n    z-index: 1;\n}\n.alumni_img {\n    width: 60px;\n    margin-right: 10px;\n    height: 60px;\n    background: #f1f1f1;\n    border-radius: 50%;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    overflow: hidden;\n}\n.alumni_img img {\n    width: auto;\n    height: 100%;\n    border-radius: 50%;\n}\n.alumni_img.no_pic {\n    align-items: end;\n}\n.alumni_img.no_pic img {\n    width: auto;\n    height: auto;\n}\n.alumni_name_brife h3 {\n    font-size: 18px;\n    margin: 0;\n}\n.class_year {\n    color: #6a6868;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 18px;\n}\n.alumni_directory_details .btn-viewcompus {\n    font-size: 13px;\n    color: #1452ce;\n    font-weight: 500;\n    line-height: 18px;\n    position: relative;\n    z-index: 2;\n    text-decoration: none;\n}\n.alumni_directory_details .btn-viewcompus:hover {\n    color: #0b3454;\n    text-decoration: underline;\n}\n.alumni_directory_details a.btn-send {\n    padding: 0 20px;\n    line-height: 36px;\n    text-decoration: none;\n    background: #5cae48;\n    border-radius: 25px;\n    height: 36px;\n    display: inline-flex;\n    color: #fff;\n    align-items: center;\n    transition: all 0.3s ease-in-out;\n    position: relative;\n    z-index: 2;\n}\n.alumni_directory_details a.btn-send:hover {\n    background: #40862f;\n}\n.alumni_directory_details a.btn-send span {\n    display: none;\n}\n.icon-alumni-send {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/send_alumni_profile.svg) no-repeat 0\n        0 / 100%;\n    width: 19px;\n    height: 19px;\n    margin-right: 0;\n    margin-left: 0;\n}\n.alumni_univarsity_details {\n    background: #f9f9f9;\n    border-radius: 0px 0px 5px 5px;\n    opacity: 1;\n    display: flex;\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    padding: 10px 20px 15px;\n    position: relative;\n}\n.alumni_univarsity_details .alumni_univarsity_details_inner_cover {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    width: 100%;\n}\n.alumni_univarsity_details .alumni_univarsity_details_inner_cover .alumni_univarsity_logo {\n    width: 64px;\n    margin-right: 10px;\n    margin-top: 6px;\n    height: 64px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.alumni_univarsity_details .alumni_univarsity_details_inner_cover .alumni_univarsity_logo img {\n    width: 100%;\n    max-width: 100%;\n    max-height: 100%;\n    width: auto;\n    height: auto;\n    object-fit: contain;\n}\n.alumni_univarsity_details .alumni_univarsity_details_inner_cover .alumni_univarsity_logo img[src*='no_img.png'] {\n    max-width: 35px;\n}\n.alumni_univarsity_details .alumni_univarsity_details_inner_cover .alumni_univarsity_brife {\n    width: calc(100% - 75px);\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}\n.alumni_directory_details a.alumni_name_link {\n    color: #000;\n    text-decoration: none;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n    width: 100%;\n    display: inline-block;\n}\n.alumni_directory_details a.alumni_name_link:hover {\n    color: #1452ce;\n}\n.alumni_class_link {\n    padding: 15px 20px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n}\n\n.alumni_class_link .send_link .btn-monitor {\n    width: 35px;\n    height: 35px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border: 1px solid #a1a1a1;\n    border-radius: 50%;\n    text-decoration: none;\n    color: #666;\n    transition: all 0.3s ease-in-out;\n}   \n.alumni_class_link .send_link .btn-monitor:hover{\n    background-color: #5cae48;\n    border-color: #5cae48;\n    color: #fff;\n}\n.alumni_name_detail {\n    width: calc(100% - 64px);\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n}\n.alumni_name_brife {\n    display: flex;\n    flex-direction: column;\n    width: calc(100% - 70px);\n    justify-content: center;\n}\n.alumni_education {\n    color: #4d4d4d;\n    font-size: 13px;\n    font-weight: 500;\n    line-height: 18px;\n}\n.current-roles-count {\n    display: inline-flex;\n    align-items: center;\n    margin-left: 6px;\n    padding: 2px 10px;\n    border-radius: 999px;\n    background: #e5f4df;\n    color: #5a9a48;\n    font-size: 12px;\n    font-weight: 600;\n    line-height: 16px;\n    white-space: nowrap;\n    vertical-align: middle;\n}\n.current-roles-count--above {\n    margin-left: 0;\n}\n.current-companies-card {\n    width: 100%;\n    background: transparent;\n    padding: 0;\n    margin-bottom: 16px;\n}\n.current-companies-card__top {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    margin-bottom: 10px;\n}\n.current-companies-card__label {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    color: #5cae48;\n    font-size: 13px;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n}\n.current-companies-card__count {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 22px;\n    height: 22px;\n    padding: 0 7px;\n    border-radius: 999px;\n    background: #e5f4df;\n    color: #3c8f32;\n    font-size: 12px;\n    font-weight: 700;\n    letter-spacing: 0;\n}\n.current-companies-card__nav {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    color: #6b7280;\n    font-size: 14px;\n    font-weight: 500;\n}\n.current-companies-card__nav button {\n    width: 28px;\n    height: 28px;\n    border-radius: 50%;\n    border: 1px solid #d9dde3;\n    background: #fff;\n    color: #4b5563;\n    line-height: 1;\n    font-size: 18px;\n    padding: 0 0 2px;\n}\n.current-companies-card__body {\n    display: flex;\n    align-items: center;\n    gap: 14px;\n    border: 1px solid #e6e8ee;\n    border-radius: 12px;\n    background: #fff;\n    padding: 14px 16px;\n}\n.current-companies-card__logo {\n    width: 72px;\n    height: 72px;\n    flex: 0 0 72px;\n}\n.current-companies-card__name {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 8px;\n    color: #1a1a1a;\n    font-size: 20px;\n    line-height: 26px;\n    font-weight: 700;\n}\n.current-companies-card__primary {\n    display: inline-flex;\n    align-items: center;\n    padding: 1px 8px;\n    border-radius: 999px;\n    background: #eef3ff;\n    color: #3d6fd8;\n    font-size: 12px;\n    font-weight: 600;\n    line-height: 18px;\n}\n.current-companies-card .alumni_profile_college_subject.current-companies-card__role {\n    width: fit-content;\n    max-width: 100%;\n    justify-content: flex-start;\n    margin-top: 6px;\n}\n.current-companies-card .alumni_profile_college_subject.current-companies-card__role span {\n    width: auto;\n}\n.current-companies-card__since {\n    color: #8a8f98;\n    font-size: 13px;\n    line-height: 18px;\n    margin-top: 4px;\n}\n.alumni_univarsity_name {\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 18px;\n    margin-bottom: 3px; /* word-break: break-sall; */\n    width: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n}\n.alumni_univarsity_name .icon-subtraction {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/subtraction.svg) no-repeat 0 0 / 100%;\n    width: 12px;\n    height: 20px;\n    margin-left: 3px;\n    display: inline-block;\n    vertical-align: top;\n}\n.alumni_univarsity_name span:empty ~ .icon-subtraction {\n    display: none;\n}\n.alumni_univarsity_subject {\n    color: #0b3454;\n    font-size: 14px;\n    line-height: 16px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n}\n.alumni_univarsity_subject span {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n}\n.alumni_univarsity_subject i {\n    width: 16px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/subject_setting.svg) no-repeat 0 0 /\n        100%;\n    height: 16px;\n    margin-right: 7px;\n}\n.filter_result ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n}\n.filter_result_title {\n    margin-bottom: 18px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    margin-top: 10px;\n}\n.filter_result_title .filter_result {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n}\n.filter_result ul li {\n    background: #e9f6fc;\n    border-radius: 25px;\n    padding: 9px 23px;\n    margin-top: 6px;\n    margin-bottom: 6px;\n}\n.filter_result ul li:not(:last-child) {\n    margin-right: 10px;\n}\n.filter_result ul li:last-child {\n    background: no-repeat;\n    padding: 9px 0;\n}\n.filter_result ul li span {\n    margin-right: 10px;\n}\n.filter_result ul li .btn-cross {\n    font-size: 10px;\n    color: #000;\n    text-decoration: none;\n}\n.filter_result ul li .btn-cross:hover {\n    color: #105271;\n}\n.alumni_count {\n    font-size: 18px;\n    font-weight: 500;\n    line-height: 20px;\n    margin: 18px 0 0;\n}\n.btn-additionalfilter {\n    text-decoration: none;\n    font-size: 14px;\n    color: #1452ce;\n    font-weight: 500;\n    display: inline-flex;\n    align-items: center;\n    transition: all 0.3s ease-in-out;\n}\n.btn-additionalfilter span {\n    text-decoration: underline;\n    margin-right: 10px;\n}\n.btn-additionalfilter .icon-right-arrow {\n    transform: rotate(90deg);\n    transition: all 0.3s ease-in-out;\n}\n.btn-additionalfilter[aria-expanded='true'] .icon-right-arrow {\n    transform: rotate(270deg);\n}\n.btn-additionalfilter:hover {\n    color: #0b3454;\n}\n.btn-additionalfilter:hover span {\n    text-decoration: none;\n}\n.alumni_directory_filter .filters-head h3 {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    margin: 0;\n    align-items: center;\n}\n.alumni_directory_filter .filters-head h3 .icon-filter + span {\n    flex: 1;\n}\n.alumni_directory_filter .filters-head h3[aria-expanded='true'] i {\n    transform: rotate(270deg);\n}\n.alumni_directory_details .load_more_btn {\n    text-decoration: none;\n    text-transform: uppercase;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.alumni_directory_details .load_more_btn:hover {\n    background: #0b3454;\n    color: #fff;\n    border-color: #0b3454;\n}\n.alumni_directory_details .load_more_btn img {\n    -webkit-animation: none;\n}\n.alumni_directory_details .load_more_btn:hover img {\n    filter: invert(1) brightness(100);\n}\n.tooltip-viewcompus .tooltip-arrow::before {\n    display: none;\n}\n.alumni_profile_brife_wrap {\n    border-bottom: 1px solid #e7e7e7;\n}\n.alumni_profile_brife {\n    padding: 40px 0;\n}\n.alumni_profile_brife .btn-back {\n    color: #000;\n    font-size: 14px;\n    line-height: 16px;\n    font-weight: 500;\n}\n.alumni_profile_brife .btn-back .icon-right-arrow {\n    transform: scaleX(-1);\n    margin-right: 7px;\n    font-size: 12px;\n}\n.alumni_profile_brife .btn-back:hover {\n    color: #0b3454;\n}\n.alumni_profile_name_college_other_detail_wrap {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n}\n.alumni_profile_image_name_other_detail {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    padding: 0 20px 0 0;\n    position: relative;\n    width: 48%;\n}\n.alumni_profile_image_name_other_detail:after {\n    content: '';\n    width: 1px;\n    height: 85%;\n    background: #d4d4d4;\n    position: absolute;\n    right: 0;\n    top: 0;\n}\n.alumni_profile_image {\n    width: 110px;\n    height: 110px;\n    background: #f1f1f1;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n    margin-right: 20px;\n}\n.alumni_profile_image img {\n    width: auto;\n    height: 100%;\n}\n.alumni_profile_image.no_pic {\n    align-items: end;\n}\n.alumni_profile_image.no_pic img {\n    height: 80%;\n}\n.alumni_profile_name_other_detail {\n    width: calc(100% - 130px);\n}\n.alumni_profile_name_other_detail h2 {\n    font-size: 26px;\n    line-height: 18px;\n    font-weight: 600;\n    word-break: break-all;\n    line-height: 28px;\n}\n.alumni_profile_name_other_detail .alumni_profile_location {\n    font-size: 14px;\n    font-weight: 500;\n    margin-bottom: 15px;\n}\n.alumni_profile_class_college {\n    position: relative;\n    padding: 0 0 0 20px;\n    margin-bottom: 13px;\n}\n.alumni_profile_class_college:before {\n    content: '';\n    position: absolute;\n    left: 6px;\n    top: 0;\n    bottom: 0;\n    width: 3px;\n    height: 100%;\n    background: #d52941;\n    border-radius: 5px;\n}\n.alumni_profile_class_college .alumni_profile_class {\n    font-size: 16px;\n    font-weight: 500;\n    letter-spacing: 0.32px;\n    line-height: 18px;\n    margin-bottom: 5px;\n}\n.alumni_profile_class_college .alumni_profile_college {\n    font-size: 16px;\n    font-weight: 500;\n    letter-spacing: 0.32px;\n    line-height: 18px;\n}\n.alumni_profile_college_phone {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    align-items: center;\n}\n.alumni_profile_college_phone .verifyLink {\n    font-size: 16px;\n    font-weight: 500;\n}\n.verifiedLink {\n    color: #5cae48;\n    text-decoration: none;\n    display: flex;\n    align-items: center;\n    font-weight: 400;\n    font-size: 16px;\n}\n.alumni_profile_name_other_detail .btn-send {\n    width: auto;\n    height: 40px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    background: #5cae48;\n    border-radius: 25pc;\n    color: #fff;\n    text-decoration: none;\n    align-items: center;\n    padding: 0 25px;\n    font-size: 16px;\n    font-weight: 500;\n    transition: all 0.3s ease-in-out;\n}\n.alumni_profile_name_other_detail .btn-send .icon-send {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/send_alumni_profile.svg) no-repeat 0\n        0 / 100%;\n    width: 19px;\n    height: 19px;\n    margin-right: 10px;\n    position: relative;\n    transition: all 0.3s ease-in-out;\n    left: 0;\n}\n.alumni_profile_name_other_detail .btn-send:hover {\n    background: #2fa612;\n}\n.alumni_profile_name_other_detail .btn-send:hover .icon-send {\n    left: 3px;\n}\n.alumni_profile_college_name_other_detail_wrap {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    padding: 0 0 0 40px;\n}\n.alumni_profile_college_name_other_detail_wrap .alumni_profile_college_logo {\n    width: 100px;\n    height: 100px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    border: 1px solid #d2d2d2;\n    margin-right: 18px;\n}\n.alumni_profile_college_name_other_detail_wrap .alumni_profile_college_logo img {\n    max-width: 100%;\n    max-height: 100%;\n    width: auto;\n    height: auto;\n}\n.alumni_profile_college_name_other_detail_wrap .alumni_profile_college_logo img[src*='college_icon'] {\n    width: 40px;\n}\n.alumni_profile_college_name_other_detail_wrap .alumni_profile_college_logo img[src*='no_img'] {\n    width: auto;\n}\n.alumni_profile_college_name_other_detail_wrap .alumni_profile_college_name_other_detail {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    align-items: start;\n    width: calc(100% - 120px);\n}\n.alumni_profile_brife_tab {\n    margin-bottom: 20px;\n}\n.alumni_profile_status {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n.alumni_profile_status li {\n    margin-bottom: 16px;\n    width: 176px;\n    position: relative;\n    padding-left: 16px;\n}\n.alumni_profile_status li .title {\n    letter-spacing: 0.32px;\n    color: #000000;\n    font-size: 16px;\n}\n.alumni_profile_status li p {\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 20px;\n    letter-spacing: 0.32px;\n}\n.alumni_profile_status li .alumni_profile_name_other_detail{\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n}\n\n.alumni_profile_status li:before {\n    content: '';\n    width: 3px;\n    height: 17px;\n    position: absolute;\n    left: 0;\n    top: 4px;\n    background: #d52941;\n    border-radius: 5px;\n}\n.alumni_profile_college_joined {\n    color: #5cae48;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 18px;\n    margin-bottom: 5px;\n}\n.alumni_profile_college_name_detail {\n    width: calc(100% - 176px);\n    padding-right: 50px;\n}\n.alumni_profile_college_name_other_detail_wrap .alumni_profile_college_name_detail h3 {\n    font-size: 20px;\n    line-height: 26px;\n    font-weight: 600;\n}\n.alumni_profile_college_subject {\n    min-height: 30px;\n    height: auto;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 6px 15px;\n    background: #e5f1fb;\n    border-radius: 18px;\n    font-size: 16px;\n    line-height: 20px;\n    font-weight: 600;\n    color: #0b3454;\n    -webkit-border-radius: 18px;\n    -moz-border-radius: 18px;\n    -ms-border-radius: 18px;\n    -o-border-radius: 18px;\n    max-width: 100%;\n}\n.alumni_profile_college_subject span {\n    white-space: normal;\n    word-break: break-word;\n    width: calc(100% - 20px);\n}\n.alumni_profile_college_subject .icon {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/course_alumni_profile.svg);\n    width: 16px;\n    height: 16px;\n    margin-right: 8px;\n    min-width: 16px;\n}\n.alumni_profile_detail {\n    padding: 30px 0;\n}\n.alumni_profile_brife_tab .nav {\n    justify-content: center;\n}\n.alumni_profile_brife_tab .nav-item:not(:last-child) {\n    margin-right: 10px;\n}\n.alumni_profile_brife_tab .nav-pills .nav-link {\n    min-width: 100px;\n    height: 40px;\n    white-space: nowrap;\n    border: 2px solid #7d7d7d;\n    border-radius: 25px;\n    background: #fff;\n    color: #000;\n    padding: 0 20px;\n}\n.alumni_profile_brife_tab .nav-pills .nav-link.active,\n.alumni_profile_brife_tab .nav-pills .nav-link:hover {\n    background: #0b3454;\n    border-color: #0b3454;\n    color: #fff;\n}\n.underGraduate-detail .main_title,\n.blockHeader {\n    font-size: 22px;\n    color: #000;\n    width: auto;\n    margin: -40px -40px 25px;\n    border-radius: 6px 6px 0px 0px;\n    padding: 20px 40px;\n    line-height: 22px;\n    border-bottom: 1px solid #f5f5f5;\n}\n.blockHeader .title span {\n    font-weight: 600;\n}\n.graduateRow .college_detail_wrap .college_detail h3 {\n    font-size: 20px;\n    font-weight: 600;\n    margin: 0 0 2px;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.college_name_scholarship .college_name a {\n    color: #000;\n    text-decoration: none;\n}\n/* AGS-362 @dt 2nd.Aug,2K23 @by RG */\n\n/* .graduateRow .college_detail_wrap:hover h3 {text-decoration: underline;color: #1452ce;} */\n.graduateRow .college_detail_wrap .college_detail h3 .icon-subtraction {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/subtraction.svg) no-repeat 0 0 / 100%;\n    width: 16px;\n    height: 25px;\n    margin-left: 3px;\n    display: inline-block;\n    vertical-align: top;\n}\n.graduateRow .college_detail_wrap .college_detail p {\n    font-size: 16px;\n    color: #414141;\n    margin: 0 0 5px;\n}\n.graduateRow {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    position: relative;\n}\n.graduateRow:not(:last-child) {\n    border-bottom: 2px solid #e5e5e5;\n    margin-bottom: 28px;\n    padding-bottom: 28px;\n}\n.underGraduate-detail,\n.postGraduate-detail {\n    box-shadow: 0px 10px 25px #00000008;\n    border-radius: 6px;\n    background: #fff;\n    padding: 40px;\n}\n.graduateRow .college_detail_wrap {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    width: calc(100% - 265px);\n    padding-right: 40px;\n    position: relative;\n    align-items: center;\n}\n.graduateRow .college_detail_wrap > a {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n}\n.graduateRow .college_detail_wrap:after {\n    content: '';\n    position: absolute;\n    top: 13px;\n    right: 0;\n    width: 2px;\n    height: 63px;\n    background: #d1d1d1;\n}\n.graduateRow .offer {\n    width: 265px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n    align-items: end;\n    justify-content: center;\n}\n.graduateRow .college_detail_wrap .college_detail {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n}\n.graduateRow .college_detail_wrap .college_detail .college_logo {\n    margin-right: 20px;\n    width: 150px;\n    height: 95px;\n    border: 1px solid #d5d5d5;\n    border-radius: 6px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.graduateRow .college_detail_wrap .college_detail .college_logo img[src*=\"no_university_img\"]{width:50px}\n.college_name_scholarship {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    align-items: center;\n}\n.college_name_scholarship .college_name {\n    width: calc(100% - 100px);\n    display: flex;\n    flex-direction: column;\n    align-items: start;\n}\n.graduateRow .college_detail_wrap .college_detail .college_logo .logo_link {\n    padding: 10px;\n    display: inline-block;\n    width: 100%;\n    height: 100%;\n}\n.graduateRow .college_detail_wrap .scholarship {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n    text-align: center;\n    line-height: 20px;\n}\n.graduateRow .college_detail_wrap .scholarship .scholarship_label {\n    font-weight: 500;\n    color: #8a8a8a;\n}\n.graduateRow .college_detail_wrap .scholarship .scholarship_amt {\n    font-weight: 600;\n    white-space: nowrap;\n}\n.graduateRow .offer > a,\n.graduateRow .offer a.joindeLink {\n    padding: 0 20px;\n    text-decoration: none;\n    height: 37px;\n    background: #5cae48;\n    color: #fff;\n    border-radius: 25px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 14px;\n    font-weight: 500;\n    margin-bottom: 10px;\n    transition: all 0.3s ease-in-out;\n}\n.graduateRow .offer > a:hover,\n.graduateRow .offer a.joindeLink:hover {\n    background: #3e9329;\n}\n.graduateRow .offer > a i,\n.graduateRow .offer a.joindeLink i {\n    margin-right: 10px;\n}\n.graduateRow .offer > a:hover {\n    background: #3b8d27;\n}\n.graduateRow .offer .got_offer {\n    font-weight: 500;\n    font-size: 16px;\n    margin-bottom: 5px;\n}\n.graduateRow .offer .got_offer i {\n    margin-right: 10px;\n    font-size: 20px;\n    color: #5cae48;\n}\n.graduateRow .offer .offerLink {\n    color: #1452ce;\n}\n.graduateRow .offer .offerLink:hover {\n    color: #0b3454;\n}\n.graduateRow .offer .offer_joined i {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/hat_alumni.svg);\n    width: 23px;\n    height: 17px;\n    margin-right: 10px;\n}\n.graduateRow .offer .offer_joined {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n}\n.graduateRow.edit .college_detail_wrap {\n    width: calc(100% - 350px);\n}\n.graduateRow .offer.offer_edit {\n    flex-direction: row;\n    align-items: center;\n    width: 350px;\n    justify-content: end;\n}\n.graduateRow .offer.offer_edit .edit_section,\n.edit_section {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    margin-left: 20px;\n    align-items: center;\n}\n.edit_section_inner {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n}\n.graduateRow .offer .edit_link,\n.edit_section .edit_link {\n    width: 52px;\n    height: 30px;\n    background: #eaf4fc;\n    border-radius: 20px;\n    transition: all 0.3s ease-in-out;\n    position: relative;\n}\n.graduateRow .offer .edit_link:hover,\n.edit_section .edit_link:hover {\n    background-color: #0b3454;\n}\n.graduateRow .offer .edit_link:before,\n.edit_section .edit_link::before {\n    content: '';\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    top: 0;\n    margin: auto;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/draw.svg) no-repeat center / 18px\n        auto;\n}\n.graduateRow .offer .edit_link:hover:before,\n.edit_section .edit_link:hover::before {\n    filter: invert(99%) sepia(1%) saturate(2%) hue-rotate(228deg) brightness(110%) contrast(100%);\n}\n.graduateRow .offer .del_link,\n.edit_section .del_link,\n.del_link {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/delete.svg);\n    width: 14px;\n    height: 16px;\n    margin-left: 10px;\n    opacity: 0.5;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.graduateRow .offer .del_link:hover,\n.edit_section .del_link:hover,\n.del_link:hover {\n    opacity: 1;\n}\n.graduateRow .offer .offer_existing_links {\n    display: flex;\n    flex-direction: column;\n    align-items: end;\n}\n.form-group .del_link {\n    position: absolute;\n    top: 15px;\n    right: -20px;\n}\n.graduation-title {\n    font-size: 22px;\n    font-weight: 400;\n    margin: -15px 0 20px;\n}\n.graduation-title span {\n    font-weight: 600;\n}\n.graduation_carousel_wrap {\n    margin-top: 20px;\n    box-shadow: 0px 10px 25px #00000008;\n    border-radius: 6px;\n    background: #fff;\n    padding: 40px;\n}\n.graduation_carousel_wrap .card_profiles:first-child {\n    margin-bottom: 18px;\n}\n.graduation_carousel_wrap .seactionheader {\n    margin: -10px 0 27px;\n}\n.graduation_carousel_wrap .seactionheader h3 {\n    font-size: 22px;\n    font-weight: 400;\n}\n.graduation_carousel_wrap .seactionheader h3 span {\n    font-weight: 600;\n}\n.owl-item .card_profiles {\n    border: 1px solid #d2d2d2;\n    padding: 20px;\n    border-radius: 6px;\n    flex-direction: column !important;\n    display: flex;\n    justify-content: space-between;\n    height: 100%;\n    position: relative;\n    background: #fff;\n    max-height: 240px;\n    min-height: 240px;\n    -webkit-border-radius: 6px;\n    -moz-border-radius: 6px;\n    -ms-border-radius: 6px;\n    -o-border-radius: 6px;\n    overflow-y: auto;\n}\n.card_profiles::-webkit-scrollbar {\n    width: 4px;\n}\n.card_profiles::-moz-scrollbar {\n    width: 4px;\n}\n.card_profiles::-webkit-scrollbar-track {\n    background: #ccc;\n}\n.card_profiles::-webkit-scrollbar-thumb {\n    background-color: #666;\n    border-radius: 20px;\n    border: 2px solid #666;\n}\n.card_profiles .alumni-Profile-button-rounded {\n    position: absolute;\n    right: 20px;\n    padding: 0 20px;\n}\n.card_profiles .alumni-Profile-button-rounded:hover,\n.card_profiles .alumni-Profile-button-rounded:focus {\n    background: #40952c;\n    color: #fff;\n    background-color: #40952c;\n    border-color: 0;\n    box-shadow: none;\n}\n.card_profiles figure.student {\n    width: 90px;\n    height: 90px;\n    overflow: hidden;\n    border-radius: 200px;\n    margin-right: 10px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.card_profiles figure.student img {\n    border-radius: 200px;\n}\n.student_details {\n    width: calc(100% - 110px);\n}\n.card_profiles .student_details figure img {\n}\n.card_profiles .student_details h2 {\n    font-size: 20px;\n    font-weight: 700;\n    margin-bottom: 15px;\n    width: 65%;\n    margin-top: 010px;\n}\n.card_profiles .student_details h2 a {\n    color: #000;\n    text-decoration: none;\n    white-space: nowrap;\n    width: 100%;\n    text-overflow: ellipsis;\n    display: inline-block;\n    overflow: hidden;\n}\n.card_profiles .student_details h2 a:hover {\n    text-decoration: underline;\n    color: #1452ce;\n}\n.card_profiles .student_details h2 span {\n    display: block;\n    font-size: 16px;\n    color: #6a6868;\n    font-weight: 500;\n}\n.card_profiles .student_details .sub_details {\n    display: flex;\n    flex-grow: 1 !important;\n}\n.card_profiles .student_details .sub_details_workExp {\n    align-items: center;\n    position: relative;\n    padding-bottom: 5px;\n}\n.card_profiles .student_details .sub_details_achivements figure {\n    background: #0b3454 !important;\n}\n.card_profiles .student_details .sub_details_workExp figure {\n    border: 0 !important;\n    border-radius: 100px !important;\n    min-width: 50px !important;\n    height: 50px !important;\n    width: 50px !important;\n    background-color: #d52941;\n}\n.card_profiles .student_details .sub_details_workExp figure img {\n    width: 45%;\n    height: auto;\n}\n.card_profiles .student_details .sub_details_workExp figure.bg_white {\n    background-color: #fff !important;\n    border: 1px solid #d2d2d2 !important;\n}\n.card_profiles .student_details .sub_details_workExp figure.bg_white img {\n    width: 80%;\n}\n.card_profiles .student_details .sub_details_workExp:after {\n    position: absolute;\n    width: 83%;\n    height: 1px;\n    content: '';\n    background: #c1c1c1;\n    bottom: 0;\n    right: 0;\n}\n.card_profiles .student_details .sub_details_workExp1:after {\n    display: none;\n}\n.card_profiles .student_details .sub_details h3 {\n    margin-bottom: 0;\n    min-width: 43px;\n    justify-content: center;\n}\n.card_profiles .student_details .sub_details figure {\n    border: 1px solid #d2d2d2;\n    border-radius: 100px;\n    min-width: 80px;\n    height: 80px;\n    overflow: hidden;\n    margin-right: 10px;\n    margin-bottom: 0;\n    width: 80px;\n    margin-top: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.card_profiles .student_details .sub_details p {\n    font-size: 18px;\n    font-weight: 500;\n    margin-bottom: 5px;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    max-height: 43px;\n    overflow: hidden;\n    line-height: 18px;\n}\n.card_profiles .student_details .sub_details a {\n    color: #000;\n    text-decoration: none;\n}\n.card_profiles .student_details .sub_details a:hover {\n    text-decoration: underline;\n    color: #1452ce;\n}\n.card_profiles .student_details .sub_details p.title,\n.card_profiles .student_details .sub_details p.green-title {\n    color: #5cae48;\n    font-size: 14px;\n    margin-bottom: 10px;\n}\n.card_profiles .student_details .sub_details span {\n    color: #333333;\n    font-size: 14px;\n    margin-bottom: 15px;\n    font-weight: 400;\n}\n.card_profiles .student_details .sub_details span.course {\n    color: #0b3454;\n    font-size: 16px;\n    font-weight: 400;\n    display: flex;\n    align-items: center;\n    margin-bottom: 0;\n}\n.card_profiles .student_details .sub_details span.course img {\n    margin-right: 6px;\n    width: 16px;\n}\n.card_profiles .action_btns {\n    margin-top: 20px;\n    border-top: 1px solid #d2d2d2;\n    padding-top: 20px;\n    display: flex;\n    justify-content: center !important;\n    width: 100%;\n}\n.card_profiles .action_btns .btn-outline-primary {\n    margin-right: 10px;\n    border: 2px solid #5bae47;\n    border-radius: 50px;\n    padding: 7px 20px;\n    color: #5bae47;\n}\n.card_profiles .action_btns .btn-outline-primary:hover img {\n    filter: brightness(0) invert(1);\n    -webkit-filter: brightness(0) invert(1);\n}\n.card_profiles .action_btns .btn-outline-primary:hover {\n    border: 2px solid #418d2e;\n    background-color: #418d2e;\n    color: #fff;\n}\n.card_profiles .action_btns .btn-secondary {\n    border-radius: 50px;\n    padding: 7px 20px;\n    color: #fff;\n    background: #0b3454;\n}\n.card_profiles .action_btns .btn-secondary:hover {\n    background: #26a7df;\n    border: 1px solid #26a7df;\n}\n.card_profiles .btn-send {\n    width: 123px;\n    height: 40px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    background: #5cae48;\n    border-radius: 25pc;\n    color: #fff;\n    text-decoration: none;\n    align-items: center;\n    padding: 0 25px;\n    font-size: 16px;\n    font-weight: 500;\n    transition: all 0.3s ease-in-out;\n}\n.card_profiles .btn-send {\n    color: #fff;\n    font-size: 16px;\n    font-weight: 500;\n    position: absolute;\n    top: 20px;\n    right: 20px;\n}\n.card_profiles .btn-send .icon-send {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/send_alumni_profile.svg) no-repeat 0\n        0 / 100%;\n    width: 19px;\n    height: 19px;\n    margin-right: 10px;\n    position: relative;\n    transition: all 0.3s ease-in-out;\n    left: 0;\n}\n.card_profiles .btn-send:hover .icon-send {\n    left: 3px;\n}\n.card_profiles .btn-send:hover {\n    background: #3b8d27;\n}\n.workExperience-detail {\n    box-shadow: 0px 10px 25px #00000008;\n    border-radius: 6px;\n    background: #fff;\n    padding: 40px;\n}\n.workExperience-detail .workExperience-title {\n    font-size: 22px;\n    font-weight: 400;\n    margin: -15px 0 30px;\n}\n.workExperience-detail .workExperience-title span {\n    font-weight: 600;\n}\n.work-block {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    align-items: center;\n    position: relative;\n}\n.work-block .work-detail {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n}\n.work-block .icon {\n    width: 55px;\n    height: 55px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 26px;\n    margin-right: 20px;\n    background: #d52941;\n    border-radius: 50%;\n    color: #fff;\n}\n.work-block .icon.workex-logo {\n    border-radius: 0;\n}\n.work-block .icon.workex-logo img {\n    max-width: 100%;\n    max-height: 100%;\n    width: auto;\n    height: auto;\n}\n.work-block .work-detail p {\n    font-size: 20px;\n    line-height: 24px;\n    margin: 0 0 5px;\n    font-weight: 500;\n}\n.work-block .work-detail span {\n    font-size: 16px;\n    color: #6d6b6b;\n    line-height: 16px;\n    font-weight: 500;\n}\n.achievements-block {\n    box-shadow: 0px 10px 25px #00000008;\n    border-radius: 6px;\n    background: #fff;\n    padding: 30px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-border-radius: 6px;\n    -moz-border-radius: 6px;\n    -ms-border-radius: 6px;\n    -o-border-radius: 6px;\n    position: relative;\n}\n.achievements-block:not(:last-child) {\n    border-bottom: 1px solid #f5f5f5;\n}\n.achievements-icon-block {\n    padding: 0 55px 0 30px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    min-width: 185px;\n    max-width: 185px;\n    align-items: center;\n    text-align: center;\n    border-right: 1px solid #cecece;\n    margin-right: 30px;\n}\n.achievements-icon-block .icon {\n    width: 60px;\n    height: 60px;\n    background: #0b3454;\n    border-radius: 50%;\n    margin-bottom: 8px;\n    position: relative;\n}\n.achievements-icon-block .icon.icon-medal:before {\n    content: '';\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/exam_ico.svg);\n    width: 26px;\n    height: 36px;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    top: 0;\n    margin: auto;\n}\n.achievements-icon-block .icon.icon-grade:before {\n    content: '';\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/exam_ico.svg);\n    width: 25px;\n    height: 31px;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    top: 0;\n    margin: auto;\n}\n.achievements-icon-block .icon.icon-publication:before {\n    content: '';\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/publication_ico.svg);\n    width: 29px;\n    height: 31px;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    top: 0;\n    margin: auto;\n}\n.achievements-icon-block .icon.icon-promotion:before {\n    content: '';\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/promotion_ico.svg);\n    width: 32px;\n    height: 37px;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    top: 0;\n    margin: auto;\n}\n.achievements-icon-block .icon.icon-course-completion:before {\n    content: '';\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/course_ico.svg);\n    width: 31px;\n    height: 37px;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    top: 0;\n    margin: auto;\n}\n.achievements-icon-block .icon.icon-social-service:before {\n    content: '';\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/social_ico.svg);\n    width: 36px;\n    height: 36px;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    top: 0;\n    margin: auto;\n}\n.achievements-icon-block .icon.icon-scholarship:before {\n    content: '';\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/scholarship_ico.svg);\n    width: 39px;\n    height: 28px;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    top: 0;\n    margin: auto;\n}\n.achievements-icon-block .icon.icon-others:before {\n    content: '';\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/others_ico.svg);\n    width: 32px;\n    height: 32px;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    top: 0;\n    margin: auto;\n}\n.achievements-icon-block .achievements-title {\n    font-size: 18px;\n    font-weight: 600;\n}\n.achievements-icon-block .achievements-year {\n    font-size: 18px;\n    line-height: 22px;\n    color: #414141;\n}\n.achievements-block-detail h3 {\n    font-size: 22px;\n    font-weight: 400;\n    margin-bottom: 0px;\n}\n.achievements-block-detail h3 span {\n    font-weight: 600;\n}\n.achievements-block-detail p {\n    font-size: 16px;\n    line-height: 24px;\n    margin: 0;\n}\n.achievements-block-detail {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    position: relative;\n}\n.hide {\n    display: none;\n}\n.achievements-block-detail p.show .hide {\n    display: inline;\n}\n.achievements-block-detail p.show .btn-readmore {\n    font-size: 0;\n}\n.achievements-block-detail p.show .btn-readmore:before {\n    content: 'Read Less';\n    font-size: 16px;\n}\n.achievements-block-detail p .btn-readmore {\n    color: #1452ce;\n    transition: all 0.3s ease-in-out;\n}\n.achievements-block-detail p .btn-readmore:hover {\n    color: #1046b3;\n}\n.achievements-block-detail .url-link {\n    color: #1452ce;\n    transition: all 0.3s ease-in-out;\n}\n.achievements-block-detail .url-link:hover {\n    color: #1046b3;\n}\n.achievements-list {\n    box-shadow: 0px 10px 25px #00000008;\n    border-radius: 6px;\n    background: #fff;\n}\n.achievements-block-title {\n    padding: 20px 40px;\n    border-bottom: 1px solid #f5f5f5;\n    border-radius: 6px 6px 0 0;\n}\n.achievements-block-title .title {\n    font-size: 22px;\n}\n.achievements-block-title .title span {\n    font-weight: 600;\n}\n.btn-add-section {\n    background: #fff;\n    border: 1px solid #0b3454;\n    border-radius: 19px;\n    height: 37px;\n    display: flex;\n    padding: 0 20px;\n    align-items: center;\n    text-decoration: none;\n    font-weight: 500;\n    font-size: 14px;\n    color: #0b3454;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.btn-add-section i {\n    position: relative;\n    width: 11px;\n    height: 110px;\n    margin-right: 10px;\n}\n.btn-add-section i:before {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    background: #0b3454;\n    width: 2px;\n    height: 10px;\n}\n.btn-add-section i:after {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    background: #0b3454;\n    width: 10px;\n    height: 2px;\n}\n.btn-add-section:hover {\n    background: #0b3454;\n    color: #fff;\n}\n.btn-add-section:hover i:before,\n.btn-add-section:hover i:after {\n    background: #fff;\n}\n.contributions-block {\n    box-shadow: 0px 10px 25px #00000008;\n    border-radius: 6px;\n    background: #fff;\n    padding: 40px;\n}\n.contributions-block:not(:last-child) {\n    margin-bottom: 20px;\n}\n.contributions-block .act_lst:not(:last-child) {\n    margin-bottom: 20px;\n}\n.contributions-block .seactionheader {\n    margin: -10px 0 20px;\n}\n.contributions-block h3 {\n    font-size: 22px;\n    font-weight: 600;\n}\n.contributions-block .circle-effect::before {\n    background: #6c8598;\n}\n.contributions-block .list_badge {\n    color: #d52941;\n    background: no-repeat;\n    position: static;\n    text-transform: uppercase;\n}\n.contributions-block .act_lst {\n    padding: 25px 25px 25px 25px;\n}\n.contributions-block .video_block_name label {\n    font-size: 16px;\n}\n.skills-block {\n    box-shadow: 0px 10px 25px #00000008;\n    border-radius: 6px;\n    background: #fff;\n    padding: 40px;\n    position: relative;\n}\n.skills-block:first-child {\n    padding-bottom: 20px;\n}\n.skills-block.EntranceExam-skills-block {\n    padding-bottom: 33px;\n}\n.skills-block:not(:last-child) {\n    margin-bottom: 20px;\n}\n.skills-block h2 {\n    font-size: 22px;\n    font-weight: 400;\n    margin-bottom: 15px;\n    margin: -10px 0 25px;\n}\n.skills-block h2 span {\n    font-weight: 600;\n}\n.skills-block-detail {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n}\n.skills-block-detail .meter {\n    margin: 0 12px 20px 0;\n    border: 1px solid #c7c7c7;\n    padding: 10px 30px;\n    border-radius: 50px;\n    font-size: 20px;\n    font-weight: 500;\n    align-items: center;\n}\n.skills-block-detail .meter img {\n    width: 50px;\n}\n.skills-block-title {\n    margin-top: -30px;\n    margin-bottom: 20px;\n}\n.preferences-block {\n    box-shadow: 0px 10px 25px #00000008;\n    border-radius: 6px;\n    background: #fff;\n    padding: 40px;\n}\n.preferences-block:not(:last-child) {\n    margin-bottom: 20px;\n}\n.preferences-block.EntranceExam-skills-block {\n    padding-bottom: 33px;\n}\n.preferences-block h2 {\n    font-size: 22px;\n    font-weight: 400;\n    margin-bottom: 15px;\n    margin: -10px 0 25px;\n}\n.preferences-block h2 span {\n    font-weight: 600;\n}\n.preferences-block-detail {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n}\n.preferences-block-detail .meter {\n    margin: 0 12px 20px 0;\n    border: 1px solid #c7c7c7;\n    padding: 10px 30px;\n    border-radius: 50px;\n    font-size: 20px;\n    font-weight: 500;\n    align-items: center;\n}\n.preferences-block-detail .meter img {\n    width: 50px;\n}\n.preferences-block-title {\n    margin-top: -30px;\n    margin-bottom: 20px;\n}\n.interested-block .icon {\n    width: 55px;\n    height: 55px;\n    border-radius: 50%;\n    background: #0b3454;\n    position: relative;\n    margin-right: 20px;\n}\n.interested-block .icon.icon-bulb::before {\n    content: '';\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/bulb.svg) no-repeat 0 0 / 34px auto;\n    width: 34px;\n    height: 36px;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    top: 0;\n    margin: auto;\n}\n.interested-block .icon.icon-note::before {\n    content: '';\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/publication_ico.svg);\n    width: 29px;\n    height: 31px;\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n}\n.interested-block {\n    display: flex;\n    align-items: center;\n}\n.interested-block .interested-topics {\n    font-size: 20px;\n    flex: 1;\n    line-height: 22px;\n}\n.interested-block .interested-topics span {\n    font-weight: 500;\n}\n.graduationslider .meter {\n    padding: 10px 30px;\n    display: inline-flex;\n    flex-wrap: wrap;\n    align-items: center;\n    border-radius: 50px;\n    font-size: 18px;\n    font-weight: 500;\n    margin-bottom: 10px;\n}\n.profile-item {\n    text-align: center;\n    width: 196px;\n    height: 210px;\n    display: flex;\n    flex-direction: column;\n    padding-top: 10px;\n}\n.owl-item:not(:last-child) .profile-item {\n    border-right: 1px solid #d2d2d2;\n}\n.profile-item-img {\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    margin-bottom: 11px;\n}\n.profile-item-name-class h3 {\n    font-size: 16px;\n    font-weight: 600;\n    margin: 0 0 4px;\n}\n.profile-item-name-class p {\n    margin: 0 0 11px;\n    font-size: 14px;\n    font-style: italic;\n    color: #535353;\n}\n.profile-item-name-class .subject {\n    color: #0b3454;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 20px;\n    position: relative;\n    padding-top: 10px;\n}\n.profile-item-name-class .subject:before {\n    content: '';\n    width: 30px;\n    height: 2px;\n    background: #5cae48;\n    position: absolute;\n    left: 0;\n    right: 0;\n    margin: auto;\n    top: 0;\n}\n.profile-item-name-class .btn-viewcompus {\n    font-size: 13px;\n    color: #1452ce;\n    font-weight: 500;\n    line-height: 18px;\n    position: relative;\n    z-index: 2;\n    text-decoration: none;\n}\n.profile-item-name-class .btn-viewcompus:hover {\n    color: #0b3454;\n    text-decoration: underline;\n}\n.psychology-item {\n    text-align: center;\n    width: 245px;\n    height: 196px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    padding-top: 10px;\n}\n.owl-item:not(:last-child) .psychology-item {\n    border-right: 1px solid #d2d2d2;\n}\n.popularCollegesslider .owl-item.active + .owl-item.active + .owl-item.active + .owl-item.active .psychology-item {\n    border-right: 0px solid #d2d2d2;\n}\n.psychology-item-img {\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    margin-bottom: 20px;\n    height: 90px;\n    align-items: center;\n}\n.psychology-item-name h3 {\n    font-size: 16px;\n    font-weight: 600;\n    margin: 0 0 5px;\n    line-height: 17px;\n}\n.psychology-item-name p {\n    font-size: 14px;\n    font-style: italic;\n    font-weight: 500;\n    line-height: 20px;\n}\n.alumni_directory_details .btn-working {\n    font-size: 13px;\n    color: #1452ce;\n    font-weight: 500;\n    line-height: 18px;\n    position: relative;\n    z-index: 2;\n    text-decoration: none;\n}\n.alumni_directory_details .btn-working:hover {\n    color: #0b3454;\n    text-decoration: underline;\n}\n.tooltip-viewcompus .tooltip-inner {\n    background: #3b3b3b;\n    border-color: #3b3b3b;\n}\n.tooltip-working .tooltip-inner {\n    display: flex;\n    flex-direction: column;\n    padding: 15px;\n    background: #3b3b3b;\n    border-color: #3b3b3b;\n}\n.tooltip-working .tooltip-inner .logo {\n    position: relative;\n    font-size: 20px;\n}\n.tooltip-working .tooltip-inner span.logo + span {\n    font-size: 16px;\n}\n.tooltip-working.bs-tooltip-top .tooltip-arrow::before {\n    border-top-color: #3b3b3b;\n}\n.tooltip-working.bs-tooltip-bottom .tooltip-arrow::before {\n    border-bottom-color: #3b3b3b;\n}\n.tooltip-working.bs-tooltip-end .tooltip-arrow::before {\n    border-right-color: #3b3b3b;\n}\n.tooltip-working.bs-tooltip-start .tooltip-arrow::before {\n    border-left-color: #3b3b3b;\n}\n.alumni_name_brife > div {\n    align-items: center;\n}\n.alumni_name_brife > div .sep {\n    margin: 0 6px;\n    color: #1452ce;\n}\n.custom_badge {\n    display: inline-block;\n    border: 1px solid #dedede;\n    height: 32px;\n    line-height: 32px;\n    padding: 0 16px;\n    border-radius: 18px;\n    font-size: 14px;\n    font-weight: 500;\n    color: #0b3454;\n    margin: 0 5px 10px 0;\n    background: #fff;\n    overflow: hidden;\n}\n.custom_badge .icon {\n    margin-right: 5px;\n}\n.delete_confirm .icon-cross {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    border: 1px solid red;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: #e94e58;\n}\n.delete_confirm .del_text {\n    margin: 20px 0 10px;\n    text-align: center;\n    max-width: 240px;\n    font-size: 28px;\n    line-height: 36px;\n    font-weight: 500;\n    width: 100%;\n}\n.delete_confirm .btn-delete {\n    background: #d52941;\n    border-radius: 31px;\n    border: 0;\n    height: 36px;\n    color: #fff;\n    padding: 0 20px;\n    font-weight: 600;\n    font-size: 14px;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.delete_confirm .btn-delete:hover {\n    background: #a0182b;\n}\n.selected_options ul {\n    display: flex;\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n.selected_options ul li {\n    background: #f7fbff;\n    border: 1px solid #0b34544d;\n    border-radius: 18px;\n    height: 35px;\n    display: flex;\n    align-items: center;\n    padding: 0 18px;\n    margin: 12px 12px 6px 0;\n    font-size: 16px;\n    font-weight: 500;\n}\n.selected_options ul li .icon-cross {\n    font-size: 9px;\n    margin: 2px 0 0 10px;\n    text-decoration: none;\n    color: #000;\n}\n.selected_options ul li .icon-cross:hover {\n    text-decoration: none;\n    color: #333;\n}\n.question .form-select.w-90 {\n    width: 90px !important;\n    max-width: 90px;\n}\n.custom_row_title {\n    margin-bottom: 10px;\n    font-weight: 400;\n    font-size: 20px;\n}\n.custom_row_title span {\n    font-weight: 600;\n}\n.custom_row_block .program {\n    font-size: 20px;\n}\n.custom_row_block .program span {\n    font-weight: 500;\n}\n.program-time-interest {\n    color: #414141;\n    font-size: 16px;\n    line-height: 20px;\n}\n.custom_row_block {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    width: 100%;\n}\n.custom_row_block .icon {\n    width: 55px;\n    height: 55px;\n    border-radius: 50%;\n    background: #0b3454;\n    margin-right: 15px;\n    position: relative;\n}\n.custom_row_block .icon.icon-hat:before {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/hat_alumni.svg) no-repeat 0 0 /26px;\n    width: 26px;\n    height: 20px;\n    display: inline-block;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    position: absolute;\n    filter: invert(1);\n    -webkit-filter: invert(1);\n}\n.custom_row_block .icon + div {\n    width: calc(100% - 70px);\n}\n.custom_row {\n    width: 100%;\n    border-top: 1px solid #dbdbdb;\n    padding-top: 20px;\n}\n.custom_row:not(:last-child) {\n    padding-bottom: 20px;\n}\n.radius_block {\n    background: #ffffff;\n    border: 1px solid #c7c7c7;\n    border-radius: 30px;\n    height: 60px;\n    padding: 0 30px;\n    display: flex;\n    align-items: center;\n    font-size: 20px;\n    line-height: 20px;\n    font-weight: 500;\n}\n.radius_block span {\n    margin-right: 30px;\n}\n.radius_block i {\n    font-size: 24px;\n}\n.radius_block i.gray {\n    color: #8599a9;\n}\n.radius_block i.green {\n    color: #5dae48;\n}\n.universities_block {\n    background: #ffffff;\n    border: 1px solid #c7c7c7;\n    border-radius: 30px;\n    height: 60px;\n    padding: 0 8px;\n    display: flex;\n    align-items: center;\n    font-size: 20px;\n    line-height: 26px;\n    font-weight: 500;\n    -webkit-border-radius: 30px;\n    -moz-border-radius: 30px;\n    -ms-border-radius: 30px;\n    -o-border-radius: 30px;\n}\n.universities_block .logo {\n    width: auto;\n    height: 40px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-right: 15px;\n    border-radius: 50%;\n    overflow: hidden;\n    -webkit-border-radius: 50%;\n    -moz-border-radius: 50%;\n    -ms-border-radius: 50%;\n    -o-border-radius: 50%;\n}\n.universities_block span {\n    font-size: 20px;\n    margin-right: 15px;\n    line-height: 20px;\n}\n.logo.no_logo {\n    width: 40px;\n    border: 1px solid #cad6df;\n}\n.edit_section {\n    font-size: 0;\n}\n.edit_section_toggle,\n.custom-btns a.edit_section_toggle {\n    display: none;\n    width: 20px;\n    height: 20px;\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='%23343a40' stroke='none' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z'/%3e%3c/svg%3e\");\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: 20px 20px;\n    border: 0;\n    background-color: transparent;\n}\n\n@media (min-width: 768px) {\n    .fiterItem .accordion-collapse {\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: column;\n}\n}\n@media (max-width: 1199px) {\n    .alumni_profile_college_name_other_detail_wrap {\n        padding: 0 0 0 50px;\n    }\n}\n\n@media (max-width: 1130px) {\n    .alumni_profile_brife_tab {\n        overflow: auto;\n        scrollbar-width: thin;\n        padding-bottom: 10px;\n        margin-bottom: 10px;\n    }\n    .alumni_profile_brife_tab::-webkit-scrollbar {\n        height: 4px;\n    }\n    .alumni_profile_brife_tab::-moz-scrollbar {\n        height: 4px;\n    }\n    .alumni_profile_brife_tab::-webkit-scrollbar-track {\n        background: #ccc;\n    }\n    .alumni_profile_brife_tab::-webkit-scrollbar-thumb {\n        background-color: #666;\n        border-radius: 20px;\n        border: 2px solid #666;\n    }\n    .alumni_profile_brife_tab .nav {\n        justify-content: start;\n        flex-wrap: nowrap;\n    }\n}\n\n@media (max-width: 1099px) {\n    .alumni_profile_college_name_other_detail_wrap {\n        padding: 0 0 0 30px;\n    }\n    .alumni_profile_image_name_other_detail {\n        padding: 0 30px;\n        width: 45%;\n    }\n    .alumni_profile_college_name_other_detail_wrap .alumni_profile_college_name_other_detail {\n        flex-direction: column;\n    }\n    .alumni_profile_college_name_detail {\n        padding: 0 0 21px;\n    }\n    .alumni_profile_status {\n        display: -webkit-box;\n        display: -moz-box;\n        display: -ms-flexbox;\n        display: -webkit-flex;\n        display: flex;\n        -webkit-box-wrap: wrap;\n        -moz-box-wrap: wrap;\n        -ms-flex-wrap: wrap;\n        -webkit-wrap: wrap;\n        flex-wrap: wrap;\n    }\n    .alumni_profile_status li {\n        margin-right: 16px;\n    }\n    .alumni_profile_name_other_detail h2 {\n        line-height: 30px;\n    }\n    .college_name_scholarship .college_name {\n        width: 100%;\n        margin-bottom: 10px;\n    }\n}\n\n@media (max-width: 1035px) {\n    .college_name_scholarship {\n        flex-direction: column;\n        align-items: start;\n    }\n    .graduateRow .college_detail_wrap .scholarship {\n        margin-top: 10px;\n    }\n    .graduateRow .offer {\n        justify-content: start;\n        padding-top: 13px;\n    }\n}\n\n@media (min-width: 992px) and (max-width: 1150px) {\n    .filter_result_title {\n        flex-direction: column;\n    }\n    .alumni_count {\n        text-align: right;\n    }\n    .alumni_class_link {\n        flex-direction: column;\n    }\n    .alumni_class_link .send_link {\n        padding: 10px 0 0 70px;\n    }\n}\n\n@media (max-width: 991px) {\n    .alumni-directorySearch {\n        width: 230px;\n    }\n    .alumni_profile_name_college_other_detail_wrap {\n        flex-direction: column;\n    }\n    .alumni_profile_image_name_other_detail {\n        width: 100%;\n        padding-bottom: 45px;\n        margin-bottom: 45px;\n    }\n    .alumni_profile_image_name_other_detail::after {\n        content: '';\n        width: 100%;\n        height: 1px;\n        background: #d4d4d4;\n        position: absolute;\n        right: auto;\n        top: auto;\n        bottom: 0;\n        left: 0;\n    }\n    .alumni_profile_college_name_other_detail_wrap {\n        padding: 0;\n    }\n    .alumni_profile_college_name_other_detail_wrap .alumni_profile_college_name_other_detail {\n        flex-direction: row;\n    }\n    .alumni_profile_brife_tab .nav-item:not(:last-child) {\n        margin-right: 7px;\n    }\n    .card_profiles {\n        overflow: visible;\n        max-height: initial;\n    }\n}\n\n@media (max-width: 950px) {\n    .showProfiles_left {\n        flex-direction: column;\n        align-items: start;\n        -webkit-box-flex: 1;\n        -moz-box-flex: 1;\n        -webkit-flex: 1;\n        -ms-flex: 1;\n        flex: 1;\n    }\n    .showProfiles_left h3 {\n        margin: 0 0 10px;\n    }\n}\n\n@media (max-width: 875px) {\n    .graduateRow {\n        flex-direction: column;\n    }\n    .graduateRow .college_detail_wrap {\n        width: 100%;\n    }\n    .graduateRow .offer {\n        width: 100%;\n    }\n    .college_name_scholarship {\n        flex-direction: row;\n        align-items: start;\n    }\n    .graduateRow .college_detail_wrap {\n        width: 100%;\n        padding: 0 0 20px;\n        margin-bottom: 20px;\n    }\n    .graduateRow .college_detail_wrap::after {\n        top: auto;\n        right: 0;\n        width: 75px;\n        height: 2px;\n        bottom: 0;\n    }\n    .graduateRow .offer {\n        padding: 0;\n        align-items: start;\n    }\n    .graduateRow .college_detail_wrap::after {\n        right: auto;\n        bottom: 0;\n        left: 0;\n    }\n    .graduateRow.edit .college_detail_wrap {\n        width: 100%;\n    }\n    .graduateRow .offer.offer_edit {\n        flex-direction: row;\n        align-items: center;\n        width: 100%;\n        justify-content: start;\n    }\n    .graduateRow .offer .offer_existing_links {\n        align-items: start;\n    }\n}\n\n@media (max-width: 820px) {\n    .graduation_carousel_wrap {\n        padding: 20px;\n    }\n    .graduationslider .meter {\n        padding: 10px 15px;\n        margin: 15px 0 10px 0px;\n        font-size: 16px;\n    }\n    .postGraduate-detail {\n        padding: 0;\n        background: none;\n        box-shadow: none;\n        border: 1px solid #d2d2d2;\n        overflow: hidden;\n    }\n    .postGraduate-detail .graduateRow {\n        padding: 20px;\n        background: #fff;\n    }\n    .graduation-title {\n        margin: 0;\n        background: #eff8ff;\n        border-radius: 6px 6px 0px 0px;\n        padding: 20px;\n        text-align: center;\n        line-height: 22px;\n    }\n    .graduation_carousel_wrap .seactionheader {\n        margin: 0 0 15px;\n        flex-direction: column;\n        align-items: inherit;\n    }\n    .graduation_carousel_wrap .seactionheader .countnbtn {\n        width: 100%;\n        margin-top: 13px;\n        justify-content: space-between;\n    }\n    .graduation_carousel_wrap .seactionheader h3 {\n        width: auto;\n        margin: -20px -20px 0;\n        background: #eff8ff;\n        border-radius: 6px 6px 0px 0px;\n        padding: 20px;\n        text-align: center;\n        line-height: 22px;\n    }\n    .workExperience-detail .workExperience-title {\n        width: auto;\n        margin: 0;\n        background: #eff8ff;\n        border-radius: 6px 6px 0px 0px;\n        padding: 20px;\n        text-align: center;\n        line-height: 22px;\n    }\n    .workExperience-detail {\n        padding: 0px;\n        overflow: hidden;\n    }\n    .workExperienceRow {\n        padding: 25px;\n    }\n    .skills-block-title {\n        margin: 0 0 20px;\n        width: auto;\n        margin: -40px -40px 20px;\n        background: #eff8ff;\n        border-radius: 6px 6px 0px 0px;\n        padding: 20px;\n        text-align: center;\n        line-height: 22px;\n    }\n    .skills-block-title h2 {\n        background: no-repeat;\n        padding: 0;\n        text-align: left;\n    }\n    .preferences-block {\n        padding: 30px;\n    }\n    .preferences-block-title {\n        width: auto;\n        margin: -30px -30px 0px;\n        background: #eff8ff;\n        border-radius: 6px 6px 0px 0px;\n        padding: 20px;\n        line-height: 22px;\n    }\n    .custom_row:first-child {\n        border: 0;\n    }\n    .achievements-block-title {\n        background: #eff8ff;\n    }\n    .underGraduate-detail .main_title,\n    .blockHeader {\n        background: #eff8ff;\n    }\n    .graduateRow {\n        background: #fff;\n    }\n    .postGraduate-detail .blockHeader {\n        margin: 0;\n    }\n    .workExperience-detail .blockHeader {\n        margin: 0;\n    }\n}\n\n@media (min-width: 767px) {\n    .nolisting_wrap .nolisting {\n        max-width: 850px;\n        margin: auto;\n        border: 0;\n        display: -webkit-box;\n        display: -moz-box;\n        display: -ms-flexbox;\n        display: -webkit-flex;\n        display: flex;\n        -webkit-box-wrap: wrap;\n        -moz-box-wrap: wrap;\n        -ms-flex-wrap: wrap;\n        -webkit-wrap: wrap;\n        flex-wrap: wrap;\n        text-align: left;\n        padding-bottom: 10px;\n    }\n    .nolisting_text {\n        flex: 1;\n        display: flex;\n        flex-direction: column;\n        align-items: start;\n    }\n    .nolisting_icon {\n        margin-right: 40px;\n    }\n}\n\n@media (max-width: 767px) {\n    .alumni_directory_filter {\n        padding: 18px 0;\n        padding-right: var(--bs-gutter-x, 0.75rem);\n        padding-left: var(--bs-gutter-x, 0.75rem);\n    }\n    .alumni-directory-header_search {\n        flex-direction: column;\n        align-items: start;\n    }\n    .alumni-directory-header_search h2 {\n        margin-bottom: 15px !important;\n    }\n    .alumni-directory-header {\n        align-items: end;\n    }\n    .filter_result_title {\n        flex-direction: column;\n    }\n    .filter_result_title .filter_result {\n        display: none;\n    }\n    .alumni_count {\n        text-align: right;\n        margin: 0;\n    }\n    .alumni_directory_filter .fiterItem {\n        width: 170px;\n        margin: 0 !important;\n        box-shadow: none;\n        border: 0;\n        border-radius: 0;\n        border-bottom: 1px solid #e6e6e6 !important;\n    }\n    .alumni_directory_filter .filters {\n        padding: 0;\n        display: flex !important;\n        flex-direction: column;\n    }\n    .alumni_directory_filter .filters > div:first-child {\n        padding: 15px 20px;\n        border-bottom: 1px solid #dbdbdb;\n    }\n    .alumni_directory_filter .filters-head {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n    }\n    .alumni_directory_filter .filters #accordionFilters {\n        -webkit-box-flex: 1;\n        -moz-box-flex: 1;\n        -webkit-flex: 1;\n        -ms-flex: 1;\n        flex: 1;\n        margin: 0;\n        position: relative;\n    }\n    .alumni_directory_filter .filters #accordionFilters::before {\n        content: '';\n        position: absolute;\n        left: 0;\n        top: 0;\n        bottom: 0;\n        margin: auto;\n        width: 170px;\n        background: #f5f5f5;\n    }\n    .alumni_directory_filter .filters > #accordionFilters > .filterGroup.mt-3 {\n        margin: 0 !important;\n        flex-direction: column;\n        height: 100%;\n        position: relative;\n    }\n    .alumni_directory_filter .fiterItem .filterHeader > div {\n        border-radius: 0;\n    }\n    .alumni_directory_filter .fiterItem .filterHeader > div button {\n        background: #f5f5f5;\n        border-radius: 0;\n        padding: 10px;\n        color: #000;\n    }\n    .alumni_directory_filter .fiterItem .filterHeader > div button .toggle {\n        display: none;\n    }\n    .alumni_directory_filter .fiterItem .filterHeader > div button .font-18.font-600 {\n        font-size: 16px !important;\n        font-weight: 500 !important;\n    }\n    .additionalfilter_wrap {\n        width: 170px;\n        padding: 0;\n        margin: 0 !important;\n    }\n    .btn-additionalfilter {\n        display: none !important;\n    }\n    .additionalfilter_wrap > #additionalfilter {\n        display: block !important;\n    }\n    .alumni_directory_filter .fiterItem .filterHeader + div {\n        position: absolute;\n        right: 0;\n        top: 0;\n        padding: 0;\n        bottom: 0;\n        width: calc(100% - 170px);\n        padding: 15px;\n        overflow: auto;\n        background: #fff;\n    }\n    .alumni_directory_filter .filterGroup {\n        margin: 0 !important;\n    }\n    .alumni_directory_filter .filterGroup.mt-3 {\n        margin: 0 !important;\n        display: flex;\n        flex-direction: column;\n        height: 100%;\n    }\n    .filter_close_apply {\n        background: #ffffff;\n        border-top: 1px solid #e9e9e9;\n        padding: 15px 20px;\n        justify-content: center;\n        align-items: center;\n    }\n    .filter_close_apply > a.btn-filter-apply {\n        padding: 8px 30px;\n        background: #5cae48;\n        border-radius: 3px;\n        text-decoration: none;\n        color: #fff;\n        margin: 0 15px;\n        font-weight: 500;\n        text-transform: uppercase;\n        transition: all 0.3s ease-in-out;\n    }\n    .filter_close_apply > a.btn-filter-apply:hover {\n        background: #448e32;\n        color: #fff;\n    }\n    .filter_close_apply > a.btn-filter-close {\n        text-decoration: none;\n        text-transform: uppercase;\n        color: #979797;\n        font-weight: 500;\n        transition: all 0.3s ease-in-out;\n        margin: 0 15px;\n    }\n    .filter_close_apply > a.btn-filter-close:hover {\n        color: #666262;\n    }\n    .alumni_directory_filter .showProfiles_right {\n        margin-left: 12px;\n    }\n    .alumni_directory_filter .filterSearchblk {\n        background: #fff;\n        padding: 0 0 10px;\n    }\n    .alumni_directory_filter .fiterItem .card {\n        padding: 0px 0px 15px;\n    }\n    .alumni_directory_filter .fiterItem .filterHeader > div button[aria-expanded='true'] {\n        pointer-events: none;\n        color: #1452ce;\n    }\n    .alumni_directory_filter .scrollMe {\n        max-height: initial;\n        min-height: initial;\n    }\n    .additionalfilter_count {\n        display: block;\n        letter-spacing: 2px;\n    }\n    .additionalfilter_count:before {\n        content: '(';\n    }\n    .additionalfilter_count:after {\n        content: ')';\n    }\n    .alumni_directory_filter .mobileFilter .btn-filter .icon-filter + span {\n        -webkit-box-flex: 1;\n        -moz-box-flex: 1;\n        -webkit-flex: 1;\n        -ms-flex: 1;\n        flex: 1;\n        text-align: left;\n    }\n    .alumni_directory_filter .mobileFilter .btn-filter .icon-filter + span + span {\n        display: -webkit-box;\n        display: -moz-box;\n        display: -ms-flexbox;\n        display: -webkit-flex;\n        display: flex;\n        -webkit-box-wrap: wrap;\n        -moz-box-wrap: wrap;\n        -ms-flex-wrap: wrap;\n        -webkit-wrap: wrap;\n        flex-wrap: wrap;\n        align-items: center;\n        color: #b92940;\n        font-size: 14px;\n    }\n    .alumni_directory_filter .mobileFilter .btn-filter {\n        display: flex;\n        align-items: center;\n    }\n    .alumni_directory_filter .mobileFilter .btn-filter .icon-filter + span + span .icon-right-arrow {\n        font-size: 15px;\n        transform: rotate(270deg);\n        margin-left: 10px;\n        color: #000;\n        transition: all 0.3s ease-in-out;\n    }\n    .alumni_directory_filter .mobileFilter .btn-filter[aria-expanded='false'] .icon-right-arrow {\n        transform: rotate(90deg) !important;\n    }\n    #filter_collapse h3 {\n        pointer-events: none;\n    }\n    .alumni_directory_filter {\n        background: #f3f3f3;\n        position: fixed;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        z-index: 99;\n        box-shadow: 0 0 5px 0px #cacaca;\n    }\n    .alumni_directory_filter .filters.show {\n        -moz-transform: translate3d(0, 100%, 0);\n        -webkit-transform: translate3d(0, 100%, 0);\n        -o-transform: translate3d(0, 100%, 0);\n        -ms-transform: translate3d(0, 100%, 0);\n        transform: translate3d(0, 100%, 0);\n    }\n    .alumni_profile_image_name_other_detail {\n        width: 100%;\n        padding-bottom: 30px;\n        margin-bottom: 30px;\n    }\n    .alumni_profile_college_name_other_detail_wrap .alumni_profile_college_name_other_detail {\n        flex-direction: column;\n    }\n    .nolisting_wrap .nolisting {\n        border: 0;\n        padding: 20px 0 10px;\n    }\n    .nolisting_text {\n        text-align: center;\n        justify-content: center;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n    }\n    .edit_section {\n        position: absolute;\n        right: 20px;\n        top: 5px;\n    }\n    .countnbtn .edit_section {\n        position: relative;\n        left: auto;\n        right: auto;\n        top: 0;\n        margin-left: 5px;\n    }\n    .skills-block .edit_section {\n        top: 22px;\n    }\n    .edit_section .edit_section_toggle {\n        display: inline-block;\n    }\n    .custom-btns a.edit_section_toggle {\n        display: inline-block;\n    }\n    .edit_section .edit_section_inner {\n        position: absolute;\n        top: 50px;\n        right: 0;\n        background: #fff;\n        box-shadow: 0px 0px 5px #57555533;\n        display: flex;\n        flex-direction: column;\n        width: 100px;\n        border-radius: 6px;\n        overflow: hidden;\n        opacity: 0;\n        z-index: -1;\n        transition: all 0.3s ease-in-out;\n        -webkit-transition: all 0.3s ease-in-out;\n        -moz-transition: all 0.3s ease-in-out;\n        -ms-transition: all 0.3s ease-in-out;\n        -o-transition: all 0.3s ease-in-out;\n    }\n    .edit_section.open .edit_section_inner {\n        top: 30px;\n        opacity: 1;\n        z-index: 9;\n    }\n    .edit_section .edit_section_inner a {\n        width: 100% !important;\n        border-radius: 0 !important;\n        padding: 0 0 0 30px;\n        font-size: 14px;\n        text-decoration: none;\n        color: #000;\n        line-height: 33px;\n        height: 35px !important;\n        background: #fff !important;\n        position: relative;\n        opacity: 1;\n        margin: 0 !important;\n        -webkit-border-radius: 0 !important;\n        -moz-border-radius: 0 !important;\n        -ms-border-radius: 0 !important;\n        -o-border-radius: 0 !important;\n        opacity: 1 !important;\n    }\n    .edit_section .edit_section_inner a:hover {\n        color: #fff;\n        background-color: #0b3454 !important;\n    }\n    .edit_section .edit_section_inner a.edit_link:before {\n        width: 16px;\n        height: 16px;\n        margin: 0;\n        background-size: 14px;\n        left: 7px;\n        top: 8px;\n    }\n    .edit_section .edit_section_inner a:first-child {\n        border-bottom: 1px solid #eee;\n    }\n    .edit_section .edit_section_inner a.del_link:before {\n        content: '';\n        background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/delete.svg) no-repeat center /\n            14px auto;\n        width: 14px;\n        height: 16px;\n        position: absolute;\n        left: 8px;\n        top: 8px;\n    }\n    .edit_section .edit_section_inner a.del_link:hover {\n        background: #0b3454;\n        color: #fff;\n    }\n    .edit_section .edit_section_inner a.del_link:hover:before {\n        filter: invert(92%) sepia(100%) saturate(0%) hue-rotate(202deg) brightness(106%) contrast(106%);\n        -webkit-filter: invert(92%) sepia(100%) saturate(0%) hue-rotate(202deg) brightness(106%) contrast(106%);\n    }\n    .graduateRow .college_detail_wrap .scholarship {\n        margin-right: 60px;\n    }\n    .achievements-block-detail .edit_section {\n        top: 4px;\n        right: 0;\n    }\n    .achievements-block-detail {\n        padding-right: 25px;\n    }\n    .postGraduate-detail .graduateRow .offer.offer_edit .edit_section {\n        top: 20px;\n    }\n    .work-block .edit_section {\n        right: 0;\n    }\n    .work-block .work-detail {\n        padding-right: 24px;\n    }\n    .directory_wrap {\n        position: fixed;\n        width: 100%;\n        height: 100%;\n        top: 100%;\n        bottom: auto;\n        left: 0;\n        right: 0;\n        margin: auto;\n        background: white;\n        display: flex;\n        flex-direction: column;\n        transition: all 0.3s ease-in-out;\n        -webkit-transition: all 0.3s ease-in-out;\n        -moz-transition: all 0.3s ease-in-out;\n        -ms-transition: all 0.3s ease-in-out;\n        -o-transition: all 0.3s ease-in-out;\n    }\n    .directory_wrap.open {\n        top: 0;\n        bottom: 0;\n    }\n}\n\n@media (min-width: 575px) and (max-width: 767px) {\n    .filter_result_title {\n        flex-direction: column;\n    }\n    .alumni_count {\n        text-align: right;\n    }\n    .alumni_class_link {\n        flex-direction: column;\n    }\n    .alumni_class_link .send_link {\n        padding: 10px 0 0 70px;\n    }\n}\n\n@media (max-width: 575px) {\n    .alumni-directory-header {\n        flex-direction: column;\n    }\n    .alumni-directory-header_search {\n        flex-direction: row;\n        width: 100%;\n        margin-bottom: 20px;\n        justify-content: space-between;\n        overflow: hidden;\n        align-items: center;\n    }\n    .alumni-directory-header_search h2 {\n        margin-bottom: 0 !important;\n    }\n    .alumni-directorySearch-wrap {\n        position: relative;\n    }\n    .alumni-directorySearch-wrap .alumni-directorySearch {\n        position: absolute;\n        right: -230px;\n        transition: all 0.3s ease-in-out;\n    }\n    .alumni-directorySearch-wrap.show .alumni-directorySearch {\n        right: 0;\n    }\n    .btn-alumniSearchToggle.icon-search {\n        width: 40px;\n        height: 40px;\n        background: #fff;\n        border-radius: 50%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        text-decoration: none;\n        color: #000;\n        font-size: 12px;\n    }\n    .alumni-directorySearch .form-control + .btn-cross {\n        opacity: 1;\n        right: 15px;\n        transform: rotate(135deg);\n    }\n    .alumni-switch-container {\n        margin: auto;\n    }\n    .alumni-directorySearch .form-control {\n        padding-right: 40px;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        overflow: hidden;\n    }\n    .alumni_profile_image_name_other_detail {\n        padding: 0 0 20px;\n        margin-bottom: 20px;\n    }\n    .alumni_profile_college_name_other_detail .alumni_profile_other_detail {\n        margin: 0 0 0 -98px;\n        width: calc(100% + 98px);\n    }\n    .alumni_profile_status li {\n        width: 47%;\n        margin-bottom: 0;\n    }\n    .alumni_profile_status li:last-child {\n        margin-right: 0;\n    }\n    .alumni_profile_image {\n        width: 80px;\n        height: 80px;\n    }\n    .alumni_profile_name_other_detail h2 {\n        line-height: 30px;\n        font-size: 24px;\n    }\n    .alumni_profile_college_name_other_detail_wrap .alumni_profile_college_logo {\n        width: 80px;\n        height: 80px;\n    }\n    .alumni_profile_college_name_other_detail_wrap .alumni_profile_college_name_other_detail {\n        flex-direction: row;\n    }\n    .alumni_profile_brife {\n        padding: 20px 0 10px;\n    }\n    /*.graduateRow .college_detail_wrap .college_detail {  flex-direction: column;align-items: center;}*/\n    .graduateRow .college_detail_wrap .college_detail {\n        padding-right: 25px;\n    }\n    .graduateRow {\n        margin-left: -20px;\n        margin-right: -20px;\n        width: auto;\n        padding: 5px 20px;\n    }\n    .graduateRow .college_detail_wrap .college_detail .college_logo {\n        margin: 0 10px 10px 0;\n        width: 70px;\n        height: 70px;\n        border-radius: 50%;\n    }\n    .graduateRow .college_name_scholarship {\n        flex-direction: column;\n        align-items: start;\n        justify-content: start;\n        text-align: left;\n        width: calc(100% - 80px);\n    }\n    .graduateRow .college_detail_wrap .college_detail h3 {\n        font-size: 19px;\n        line-height: 20px;\n    }\n    .alumni_profile_college_subject {\n        padding: 0 15px;\n        font-size: 15px;\n        width: 100%;\n    }\n    .graduateRow .college_detail_wrap .scholarship {\n        flex-direction: row;\n    }\n    .graduateRow .college_detail_wrap .scholarship .scholarship_label {\n        margin-right: 7px;\n    }\n    .graduateRow .college_detail_wrap::after {\n        right: 0;\n        bottom: 0;\n        left: 0;\n        margin: auto;\n        width: 100%;\n        height: 1px;\n    }\n    .graduateRow .offer {\n        align-items: center;\n        flex-direction: row;\n        justify-content: center;\n    }\n    .graduateRow:not(:last-child) {\n        margin-bottom: 15px;\n        padding-bottom: 20px;\n    }\n    .graduateRow .college_detail_wrap .college_detail .college_logo img[src*=\"no_university_img\"]{width:38px}\n    .underGraduate-detail {\n        padding: 20px;\n        box-shadow: none;\n    }\n    .workExperience-detail {\n        padding: 0px;\n    }\n    .workExperienceRow {\n        padding: 20px 20px 30px;\n    }\n    .achievements-block {\n        flex-direction: column;\n    }\n    .achievements-icon-block {\n        border-right: 0;\n        margin: 0 0 18px;\n        padding: 0 0 18px;\n        border-bottom: 1px solid #cecece;\n    }\n    .achievements-block-detail {\n        text-align: center;\n    }\n    .achievements-block-detail h3 {\n        margin: 0;\n    }\n    .contributions-block .seactionheader {\n        margin: 0px 0 20px;\n        flex-direction: column;\n        align-items: inherit;\n    }\n    .contributions-block .seactionheader > h3 {\n        width: auto;\n        margin: -20px -20px 0;\n        background: #eff8ff;\n        border-radius: 6px 6px 0px 0px;\n        padding: 20px;\n        text-align: center;\n        line-height: 22px;\n    }\n    .contributions-block .seactionheader .countnbtn {\n        width: 100%;\n        margin-top: 10px;\n        align-items: center;\n        justify-content: space-between;\n        position: relative;\n    }\n    .contributions-block .seactionheader .countnbtn .custom-btns {\n        padding-right: 0;\n    }\n    .contributions-block .seactionheader .countnbtn .custom-btns .edit_section {\n        right: 0;\n        top: 0px;\n    }\n    .contributions-block {\n        padding: 20px;\n    }\n    .skills-block {\n        padding: 20px;\n    }\n    .skills-block:first-child {\n        padding-bottom: 5px;\n    }\n    .skills-block.EntranceExam-skills-block {\n        padding-bottom: 25px;\n    }\n    .skills-block h2 {\n        margin: 0 0 20px;\n        width: auto;\n        margin: -20px -20px 20px;\n        background: #eff8ff;\n        border-radius: 6px 6px 0px 0px;\n        padding: 20px;\n        text-align: center;\n        line-height: 22px;\n    }\n    .skills-block-detail .meter {\n        font-size: 18px;\n        align-items: center;\n        padding: 10px 20px;\n        line-height: 18px;\n    }\n    .card_profiles figure.student {\n        position: absolute;\n        left: 15px;\n        top: 15px;\n    }\n    .card_profiles .student_details h2 {\n        margin: 0 0 10px 90px;\n    }\n    .card_profiles .btn-send {\n        position: static;\n        margin-left: 90px;\n    }\n    .card_profiles .student_details .sub_details {\n        margin-top: 15px;\n    }\n    .card_profiles .student_details .sub_details span.course {\n        line-height: 15px;\n    }\n    .contributions-block .act_lst {\n        padding: 15px;\n    }\n    .contributions-block .act_lst .postedtxt {\n        text-align: left;\n        position: absolute;\n        top: 15px;\n        white-space: nowrap;\n        right: 15px;\n    }\n    .graduateRow .offer > a {\n        margin: 0 10px 0 0;\n    }\n    .graduateRow .offer div.got_offer {\n        margin-right: 10px;\n        width: 50%;\n        align-items: center;\n        display: flex;\n        margin-bottom: 0 !important;\n        text-align: left;\n        flex: none;\n        justify-content: center;\n        line-height: 18px;\n    }\n    .graduateRow .offer .offer_joined {\n        align-items: start;\n        width: 50%;\n        align-items: center;\n        display: flex;\n        margin-bottom: 0 !important;\n        line-height: 16px;\n    }\n    .graduateRow .offer .offer_joined:only-child {\n        width: auto;\n    }\n    .graduateRow .offer .offer_joined i {\n        margin-right: 8px;\n    }\n    .contributions-block .act_lst > .row > div:last-child .btn-green {\n        width: 135px;\n    }\n    .contributions-block .act_lst .btn-dark-blue {\n        width: 135px;\n    }\n    .contributions-block .listblk_icon {\n        margin-bottom: 0;\n        width: 34px;\n        height: 34px;\n    }\n    .contributions-block .act_lst .postedrow > div:last-child {\n        width: 100% !important;\n        display: flex;\n        flex-direction: row-reverse;\n        align-items: center;\n        border-top: 1px solid #d1d1d1;\n        padding-top: 10px;\n        margin-top: 8px;\n    }\n    .act_lst > .row.postedrow > div:last-child > div:first-child {\n        width: calc(100% - 190px);\n        margin: 0 0 0 15px;\n        align-items: center;\n    }\n    .alumni_class_link {\n        align-items: center;\n    }\n    .filter_result_title {\n        margin-bottom: 12px;\n    }\n    .contributions-block .album_shareblk {\n        padding: 5px 0 0 0px;\n    }\n    .profile-item,\n    .psychology-item {\n        width: 100%;\n        border: 0 !important;\n    }\n    .skills-block-title {\n        margin: 0 0 20px;\n        width: auto;\n        margin: -20px -20px 20px;\n        background: #eff8ff;\n        border-radius: 6px 6px 0px 0px;\n        padding: 20px;\n        text-align: center;\n        line-height: 22px;\n    }\n    .skills-block-title h2 {\n        padding: 0;\n        text-align: left;\n    }\n    #edit_Higher_Education .question {\n        padding-right: 20px;\n    }\n    #job_Preferences .question {\n        padding-right: 20px;\n    }\n    .underGraduate-detail .main_title,\n    .blockHeader {\n        margin: -20px -20px 30px;\n        padding: 20px;\n    }\n    .graduateRow .offer .offer_existing_links {\n        width: 100%;\n        flex-direction: row;\n        align-items: center;\n        justify-content: center;\n    }\n    .graduateRow .offer .got_offer {\n        margin-right: 10px;\n    }\n    .graduateRow .offer a.joindeLink {\n        margin: 0 10px 0 0;\n    }\n    .powerby {\n        margin: auto;\n    }\n    .graduateRow .offer.offer_edit .edit_section {\n        top: 10px;\n    }\n    .postGraduate-detail .graduateRow {\n        margin: 0;\n    }\n    .alumni_profile_college_name_detail {\n        width: 100%;\n    }\n}\n\n@media (max-width: 480px) {\n    .card_profiles.card_profiles_pg > div {\n        flex-direction: column;\n        display: flex;\n    }\n}\n\n@media (max-width: 400px) {\n    .graduateRow .offer.offer_edit {\n        flex-direction: column;\n        align-items: start;\n    }\n    .graduateRow .offer.offer_edit .edit_section {\n        margin: 0;\n    }\n}\ninput[type='search']::-webkit-search-decoration,\ninput[type='search']::-webkit-search-cancel-button,\ninput[type='search']::-webkit-search-results-button,\ninput[type='search']::-webkit-search-results-decoration {\n    appearance: none;\n    -webkit-appearance: none;\n}\nheader + .relevantAlumniMatch {\n    display: none;\n}\n.relevantAlumniMatch {\n    background: transparent linear-gradient(93deg, #fff7f8 0%, #ffe6ea 100%);\n    box-shadow: 0px 10px 20px #ffebee;\n    border: 1px solid #fdd3da;\n    border-radius: 8px;\n    padding: 15px 20px;\n    margin-bottom: 20px;\n    position: relative;\n}\n.relevantAlumniMatch p {\n    font-size: 20px;\n    margin: 0;\n    font-weight: 500;\n    line-height: 22px;\n}\n.relevantAlumniMatch .btn-complete-now {\n    border: 1px solid #d42941;\n    border-radius: 25px;\n    width: 160px;\n    height: 40px;\n    background: #fff;\n    color: #000;\n    font-size: 16px;\n    line-height: 16px;\n    font-weight: 500;\n    margin-right: 23px;\n    transition: all 0.3s ease-in-out;\n}\n.relevantAlumniMatch .btn-complete-now:before {\n    display: none;\n}\n.relevantAlumniMatch .btn-complete-now:hover {\n    background: #d42941;\n    color: #fff;\n}\n.relevantAlumniMatch .btn-close {\n    font-size: 10px;\n}\n\n@media (max-width: 767px) {\n    .relevantAlumniMatch .btn-close {\n        font-size: 10px;\n        position: absolute;\n        top: 13px;\n        right: 10px;\n    }\n}\n.pencil-edit {\n    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/draw.svg);\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: 17px;\n    width: 17px;\n    height: 17px;\n    display: inline-block;\n}\n.alumni_profile_image_name_other_detail .pencil-edit {\n    position: absolute;\n    right: 30px;\n    top: 10px;\n}\n.verifynow {\n    border: 2px solid #d52941;\n    padding: 2px 14px;\n    border-radius: 25px;\n    text-decoration: none;\n    font-size: 14px;\n    font-weight: 500;\n    transition: all 0.3s ease-in-out;\n    height: 30px;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    -webkit-border-radius: 25px;\n    -moz-border-radius: 25px;\n    -ms-border-radius: 25px;\n    -o-border-radius: 25px;\n}\n.verifynow:hover {\n    background: #d52941;\n    color: #fff;\n}\n.alumni_profile_image_name_other_detail .btnverified {\n    background: #5cae48;\n    border: 0;\n    padding: 0 22px;\n    width: auto;\n    font-size: 14px;\n}\n.alumni_profile_image_name_other_detail .btnverified:hover {\n    background: #439130;\n    color: #fff;\n}\n.alumni_profile_image_name_other_detail .btnverified:hover .icon-varified {\n    color: #fff !important;\n}\n.btn-back-dismiss {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='%23343a40' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='0.2' d='M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z'/%3e%3c/svg%3e\");\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: 50px 32px;\n    width: 20px;\n    height: 15px;\n    margin: 5px 5px 0 0px;\n}\n#delete_confirm_pop {\n    z-index: 9999;\n}\n.modal.show ~ .modal.show ~ .modal-backdrop {\n    z-index: 9998;\n    opacity: 0.7;\n}\n\n/* css 11042023 */\n.landing_login_page .carousel button {\n    background: no-repeat;\n}\n.landing_login_page .carousel button span {\n    filter: invert(1);\n    -webkit-filter: invert(1);\n}\n.landing_login_page #myloginTab {\n    border: 0;\n    display: flex;\n    justify-content: center;\n    max-width: 496px;\n    width: 90%;\n}\n.landing_login_page #myloginTab .nav-item button {\n    line-height: 70px;\n    width: 100%;\n    background: none;\n    border: 0;\n    color: rgba(255, 255, 255, 0.5);\n    border-bottom: 2px solid #375973;\n}\n.landing_login_page #myloginTab .nav-item {\n    max-width: 200px;\n    width: 100%;\n}\n.landing_login_page #myloginTab .nav-item button.active {\n    color: #fff;\n    border-color: #5cae48;\n}\n.landing_login_page #myloginTabContent {\n    max-width: 496px;\n    width: 90%;\n    margin: 0 auto;\n}\n.landing_login_page .form-control {\n    min-height: 40px;\n    border: none;\n    border-radius: 6px;\n    -webkit-border-radius: 6px;\n    -moz-border-radius: 6px;\n    -ms-border-radius: 6px;\n    -o-border-radius: 6px;\n    font-weight: 500;\n    color: #000;\n    font-size: 16px;\n    z-index: 1;\n    position: relative;\n}\n.landing_login_page .action_btns {\n    padding: 0;\n    margin: 0;\n    background: none;\n}\n.landing_login_page .action_btns .btn-login,\n.btn-setPassWord {\n    background: #5cae48;\n    color: #fff;\n    border-color: #5cae48;\n    max-width: 200px;\n    width: 100%;\n    border-radius: 25px;\n    -webkit-border-radius: 25px;\n    -moz-border-radius: 25px;\n    -ms-border-radius: 25px;\n    -o-border-radius: 25px;\n}\n.landing_login_page .action_btns .btn-login:hover,\n.btn-setPassWord:hover {\n    background: #88bb1b;\n    color: #fff;\n    border-color: #88bb1b;\n}\n.landing_login_page .carousel-indicators button {\n    border: 0;\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    background: #333 !important;\n    opacity: 0.5;\n    -webkit-border-radius: 50%;\n    -moz-border-radius: 50%;\n    -ms-border-radius: 50%;\n    -o-border-radius: 50%;\n}\n.landing_login_page .carousel-indicators button.active {\n    opacity: 1;\n}\n.landing_login_page .form-select {\n    border-radius: 6px;\n}\n.form-select#mobileCountryCode {\n    width: 125px;\n    height: 45px;\n    font-size: 16px;\n    font-weight: 500;\n}\n.footer {\n    position: relative;\n    bottom: 0;\n    width: 100%;\n    height: 60px;\n}\n.headerRightSide > ul li .user_id {\n    position: static;\n    border-radius: 5px 5px 0 0;\n    width: 100%;\n    padding: 7px 15px;\n    text-align: right;\n    background: #eee;\n    color: #000;\n}\n.headerRightSide span.userimg {\n    width: 34px;\n    height: 34px;\n    border-radius: 50%;\n    overflow: hidden;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.headerRightSide span.userimg img {\n    width: auto;\n    height: 100%;\n}\n.headerRightSide span.userimg.icon-user-invert img {\n    display: none;\n}\n.username:hover div.user-dropdown::before {\n    width: 0;\n    height: 0;\n    content: '';\n    position: absolute;\n    top: -5px;\n    right: 10px;\n    border-left: 5px solid transparent;\n    border-right: 5px solid transparent;\n    border-bottom: 5px solid #d2d2d2;\n}\n.newmsg > .containerinnercover {\n    width: calc(100% - 320px);\n}\n.containerinnercover div.css-13cymwt-control {\n    height: auto !important;\n    border: 1px solid #eaeaea !important;\n}\n.containerinnercover div.css-1fdsijx-ValueContainer {\n    height: auto !important;\n    border: 1px solid #eaeaea;\n    border-radius: 5px;\n    -webkit-border-radius: 5px;\n    -moz-border-radius: 5px;\n    -ms-border-radius: 5px;\n    -o-border-radius: 5px;\n}\n.containerinnercover div.css-b62m3t-container {\n    height: auto !important;\n    border: 1px solid #eaeaea;\n}\n.containerinnercover .css-b62m3t-container .css-t3ipsp-control {\n    height: auto !important;\n}\n.containerinnercover div.css-1p3m7a8-multiValue {\n    background: #f7f7f7;\n    border-radius: 5px;\n}\n.containerinnercover .university_ttl img {\n    width: 40px;\n}\n.containerinnercover .university_ttl {\n    width: inherit;\n    max-width: inherit;\n    padding: 5px 10px;\n    border-radius: 3px;\n}\n.containerinnercover .css-qbdosj-Input {\n    min-height: 45px;\n}\n.containerinnercover div[class*='-placeholder'] {\n    padding-left: 15px;\n}\n.containerinnercover.singleOption div[class*='-singleValue'] {\n    padding-left: 15px;\n}\n.containerinnercover.singleOption div[data-value] {\n    padding-left: 15px;\n}\n.containerinnercover.singleOption div[data-value] input {\n    min-height: 50px;\n}\n.student_profile {\n    position: relative;\n}\n.student_profile .pencil-edit {\n    position: absolute;\n    top: 12px;\n    right: 0;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.student_profile .pencil-edit:hover {\n    opacity: 1;\n}\n.student_profile .alumni_profile_image_name_other_detail:after {\n    opacity: 0;\n}\n.student_profile .alumni_profile_class_college::before {\n    background: #f8b018;\n    left: 0;\n}\n.student_profile .alumni_profile_image_name_other_detail {\n    width: 100%;\n}\n.student_profile_details {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    align-items: start;\n}\n.student_profile_details .alumni_profile_class_college {\n    margin-right: 70px;\n    padding-left: 17px;\n    margin-bottom: 25px;\n}\n.student_profile_details .verifiedLink {\n    margin-left: 20px;\n}\n.student_profile .school_other_details {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n.student_profile .school_other_details li {\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    padding-left: 10px;\n    font-size: 16px;\n    line-height: 22px;\n    margin-bottom: 10px;\n}\n.student_profile .school_other_details li:not(:last-child) {\n    margin-right: 70px;\n}\n.student_profile .school_other_details li:before {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 3px;\n    bottom: 0;\n    width: 3px;\n    height: 17px;\n    background: #f8b018;\n    border-radius: 5px;\n}\n.alumni_profile_name_other_detail .btn-send {\n    width: auto;\n    height: 40px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    background: #5cae48;\n    border-radius: 25pc;\n    color: #fff;\n    text-decoration: none;\n    align-items: center;\n    padding: 0 25px;\n    font-size: 16px;\n    font-weight: 500;\n    transition: all 0.3s ease-in-out;\n}\n.alumni_profile_name_other_detail .btn-send .icon-send {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/send_alumni_profile.svg) no-repeat 0\n        0 / 100%;\n    width: 19px;\n    height: 19px;\n    margin-right: 10px;\n    position: relative;\n    transition: all 0.3s ease-in-out;\n    left: 0;\n}\n.alumni_profile_name_other_detail .btn-send:hover {\n    background: #2fa612;\n}\n.alumni_profile_name_other_detail .btn-send:hover .icon-send {\n    left: 3px;\n}\n.edit-profile-image .imgUpload {\n    position: absolute;\n    top: -100px;\n    left: 0;\n    right: 0;\n    margin: auto;\n    width: 90px;\n    height: 30px;\n    background: #0b3454;\n    border-radius: 3px;\n    color: #fff;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.5 ease-in-out;\n    -webkit-transition: all 0.5s ease-in-out;\n    -moz-transition: all 0.5s ease-in-out;\n    -ms-transition: all 0.5s ease-in-out;\n    -o-transition: all 0.5s ease-in-out;\n}\n.edit-profile-image .imgUpload i {\n    margin-left: 5px;\n}\n.edit-profile-image:hover span.imgUpload {\n    top: 40px;\n}\n\n/*tab 31032023*/\n.tab-white-block {\n    box-shadow: 0px 10px 25px #00000008;\n    border-radius: 6px;\n    background: #fff;\n    padding: 44px;\n    position: relative;\n}\n.customRow:not(:last-child) {\n    margin-bottom: 30px;\n    padding-bottom: 30px;\n    border-bottom: 1px solid #dbdbdb;\n}\n.customRow-header {\n    display: flex;\n    align-items: center;\n}\n.customRow-header .icon {\n    width: 47px;\n    height: 47px;\n    border-radius: 50%;\n    background-color: #f8b018;\n    margin-right: 10px;\n}\n.customRow-header .icon:before {\n    display: none;\n}\n.icon.icon-book {\n    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/open-book.svg);\n    background-position: center;\n    background-repeat: no-repeat;\n}\n.icon.icon-book-white {\n    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/open-book-white.svg);\n    background-position: center;\n    background-repeat: no-repeat;\n}\n.icon.icon-global {\n    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/world.svg);\n    background-position: center;\n    background-repeat: no-repeat;\n}\n.icon.icon-university-college {\n    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/college.svg);\n    background-position: center;\n    background-repeat: no-repeat;\n}\n.icon.icon-book {\n    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/open-book.svg);\n    background-position: center;\n    background-repeat: no-repeat;\n}\n.icon.icon-global {\n    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/world.svg);\n    background-position: center;\n    background-repeat: no-repeat;\n}\n.icon.icon-father {\n    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/father.svg);\n    background-position: center;\n    background-repeat: no-repeat;\n}\n.icon.icon-mother {\n    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/mother.svg);\n    background-position: center;\n    background-repeat: no-repeat;\n}\n.icon.icon-guardian {\n    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/guardian.svg);\n    background-position: center;\n    background-repeat: no-repeat;\n}\n.icon.icon-college {\n    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/edu-college.svg);\n    background-position: center;\n    background-repeat: no-repeat;\n}\n.icon.icon-school {\n    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/school-bag.svg);\n    background-position: center;\n    background-repeat: no-repeat;\n}\n.icon.icon-exam-note {\n    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/exam-note.svg);\n    background-position: center;\n    background-repeat: no-repeat;\n}\n.icon.icon-aboutMe {\n    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/about-me.svg);\n    background-position: center;\n    background-repeat: no-repeat;\n}\n.icon.icon-achievements {\n    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/trophy.svg);\n    background-position: center;\n    background-repeat: no-repeat;\n}\n.icon.icon-books {\n    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/book.svg);\n    background-position: center;\n    background-repeat: no-repeat;\n}\n.icon.icon-activities {\n    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/target.svg);\n    background-position: center;\n    background-repeat: no-repeat;\n}\n.customRow-detail {\n    padding: 0 0 0 58px;\n}\n.tab-white-block .pencil-edit {\n    background-color: #bee0fb;\n    width: 37px;\n    height: 37px;\n    border-radius: 19px;\n    opacity: 0.5;\n    position: absolute;\n    top: 20px;\n    right: 20px;\n    transition: all 0.5s ease-in-out;\n    -webkit-transition: all 0.5s ease-in-out;\n    -moz-transition: all 0.5s ease-in-out;\n    -ms-transition: all 0.5s ease-in-out;\n    -o-transition: all 0.5s ease-in-out;\n}\n.tab-white-block .pencil-edit:hover {\n    opacity: 1;\n}\n.curriculars-item {\n    background: #ffffff 0% 0% no-repeat padding-box;\n    box-shadow: 0px 10px 25px #00000008;\n    border-radius: 6px;\n    position: relative;\n}\n.curriculars-item:not(:last-child) {\n    margin-bottom: 10px;\n}\n.curriculars-header .customRow-header {\n    padding: 20px 20px 20px 40px;\n    cursor: pointer;\n    transition: all 0.5s ease-in-out;\n    -webkit-transition: all 0.5s ease-in-out;\n    -moz-transition: all 0.5s ease-in-out;\n    -ms-transition: all 0.5s ease-in-out;\n    -o-transition: all 0.5s ease-in-out;\n}\n.customRow-header-title {\n    width: calc(100% - 110px);\n}\n.curriculars-body {\n    padding: 0px 20px 20px 40px;\n}\n.curriculars-header .customRow-header[aria-expanded='true'] {\n    padding-bottom: 10px;\n}\n.curriculars-header .pencil-edit {\n    background-color: #bee0fb;\n    width: 37px;\n    height: 37px;\n    border-radius: 19px;\n    opacity: 0.5;\n    position: absolute;\n    top: 25px;\n    right: 60px;\n    transition: all 0.5s ease-in-out;\n    -webkit-transition: all 0.5s ease-in-out;\n    -moz-transition: all 0.5s ease-in-out;\n    -ms-transition: all 0.5s ease-in-out;\n    -o-transition: all 0.5s ease-in-out;\n}\n.curriculars-header .pencil-edit:hover {\n    opacity: 1;\n}\ntr:nth-child(even) {\n    background: #f1f1f170;\n}\n.curriculars_table th div {\n    padding: 8px 20px;\n    background-color: #f1f1f1;\n    font-size: 16px;\n    font-weight: 400;\n}\n.curriculars_table thead th:first-child div {\n    border-radius: 5px 0px 0px 5px;\n}\n.curriculars_table thead th:last-child div {\n    border-radius: 0px 5px 5px 0px;\n}\n.curriculars_table tbody th {\n    padding: 20px;\n    font-size: 18px;\n    font-weight: 500;\n}\n.curriculars_table td {\n    padding: 20px;\n}\n.curriculars-header .customRow-header i {\n    position: absolute;\n    width: 16px;\n    height: 16px;\n    right: 30px;\n    top: 36px;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.curriculars-header .customRow-header[aria-expanded='true'] i:before {\n    transform: rotate(90deg);\n    -webkit-transform: rotate(90deg);\n    -moz-transform: rotate(90deg);\n    -ms-transform: rotate(90deg);\n    -o-transform: rotate(90deg);\n}\n.curriculars-header .customRow-header i:before {\n    content: '';\n    width: 2px;\n    height: 16px;\n    background: #0d4466;\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    top: 0;\n    margin: auto;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.curriculars-header .customRow-header i:after {\n    content: '';\n    width: 16px;\n    height: 2px;\n    background: #0d4466;\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    top: 0;\n    margin: auto;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.book-wrap {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n}\n.book-wrap .book-detial {\n    width: calc(100% - 80px);\n    margin-left: 15px;\n}\n.book-wrap .book-img img {\n    box-shadow: 0 0 3px 1px #ccc;\n}\n.lineHeight-26 {\n    line-height: 26px;\n}\n\n@media (max-width: 767px) {\n    .newmsg > .containerinnercover {\n        width: 100%;\n    }\n}\n\n@media (max-width: 575px) {\n    .tab-white-block {\n        padding: 24px;\n    }\n    .curriculars-header .customRow-header {\n        padding: 24px 20px 24px 24px;\n    }\n    .curriculars-body {\n        padding: 0px 20px 20px 24px;\n    }\n    .curriculars-body .customRow-detail {\n        padding: 0;\n    }\n    .curriculars-header .pencil-edit {\n        top: 25px;\n    }\n    .curriculars-header .customRow-header i {\n        top: 35px;\n    }\n}\n\nheader .search .form-inline {\n    border-radius: 20px;\n    border: 1px solid #f1f1f1;\n}\nheader .search .form-inline .css-b62m3t-container {\n    border-radius: 20px;\n}\nheader .search .form-inline .css-b62m3t-container .css-13cymwt-control {\n    border-radius: 20px;\n}\nheader .search .form-inline .css-b62m3t-container .css-t3ipsp-control {\n    border-radius: 20px;\n}\nheader .search .form-inline .css-b62m3t-container input {\n    padding: 0 15px !important;\n    font-size: 16px !important;\n}\nheader .search .form-inline .css-b62m3t-container .css-1jqq78o-placeholder {\n    padding: 0 15px;\n    font-size: 16px;\n}\nheader .search .form-inline .css-t3ipsp-control .css-1jqq78o-placeholder {\n    display: none;\n}\nheader .search .form-inline .css-b62m3t-container .css-qbdosj-Input,\nheader .search .form-inline .css-b62m3t-container .css-166bipr-Input {\n    display: -webkit-box !important;\n    display: -moz-box !important;\n    display: -ms-flexbox !important;\n    display: -webkit-flex !important;\n    display: flex !important;\n}\nheader .search .form-inline div * {\n    display: block;\n    line-height: 40px;\n}\nheader .search .form-inline div[aria-hidden='true'] {\n    display: none;\n}\nheader .search .form-inline div.css-t3ipsp-control > div {\n    margin: 0;\n    padding: 0;\n}\nheader .search .form-inline div[class*='-control'] > div {\n    padding: 0;\n}\nheader .search .form-inline div[data-value] {\n    margin: 0;\n    padding: 0;\n}\nheader .search .form-inline #react-select-2-placeholder {\n    line-height: 43px;\n}\nheader .search .form-inline .css-t3ipsp-control #react-select-2-placeholder {\n    display: none;\n}\nheader .search .form-inline .css-t3ipsp-control input {\n    height: 45px;\n}\n.lstCustForm .css-b62m3t-container {\n    border-radius: 5px;\n    -webkit-border-radius: 5px;\n    -moz-border-radius: 5px;\n    -ms-border-radius: 5px;\n    -o-border-radius: 5px;\n}\n.lstCustForm .select__value-container {\n    -webkit-box-flex-wrap: nowrap;\n    -webkit-flex-wrap: nowrap;\n    -ms-flex-wrap: nowrap;\n    flex-wrap: nowrap;\n}\n.lstCustForm .css-b62m3t-container .css-13cymwt-control {\n    border-radius: 5px;\n    -webkit-border-radius: 5px;\n    -moz-border-radius: 5px;\n    -ms-border-radius: 5px;\n    -o-border-radius: 5px;\n    border: 1px solid #848484 !important;\n}\n.lstCustForm .css-b62m3t-container .css-t3ipsp-control {\n    border-radius: 5px;\n    -webkit-border-radius: 5px;\n    -moz-border-radius: 5px;\n    -ms-border-radius: 5px;\n    -o-border-radius: 5px;\n    border: 1px solid #848484 !important;\n}\n\n.lstCustForm div[class*='-singleValue']{margin-left: 20px;}\n\n.lstCustForm .css-b62m3t-container input {\n    padding: 0 15px !important;\n    font-size: 16px !important;\n}\n.lstCustForm .css-b62m3t-container .css-1jqq78o-placeholder {\n    padding: 0 15px;\n    font-size: 16px;\n}\n.lstCustForm .css-b62m3t-container .css-qbdosj-Input,\n.lstCustForm .css-b62m3t-container div[data-value] {\n    display: -webkit-box !important;\n    display: -moz-box !important;\n    display: -ms-flexbox !important;\n    display: -webkit-flex !important;\n    display: flex !important;\n}\n.lstCustForm .css-b62m3t-container .css-qbdosj-Input,\n.lstCustForm .css-b62m3t-container .css-166bipr-Input {\n    display: -webkit-box !important;\n    display: -moz-box !important;\n    display: -ms-flexbox !important;\n    display: -webkit-flex !important;\n    display: flex !important;\n}\n.lstCustForm .css-b62m3t-container div[data-value] {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n}\n.attendee_dtl .table thead th {\n    background: #f1f1f1;\n    font-size: 14px;\n    font-weight: 500;\n    height: 40px;\n    border: 0;\n}\n.attendee_dtl .table thead th:first-child {\n    border-radius: 6px 0 0 6px;\n}\n.attendee_dtl .table thead th:last-child {\n    border-radius: 0 6px 6px 0;\n}\n.table-responsive.attendee_dtl table td:first-child,\n.table-responsive.attendee_dtl > table th:first-child {\n    padding-left: 20px;\n}\n.table-responsive.attendee_dtl table td {\n    padding-top: 15px;\n    padding-bottom: 15px;\n    font-size: 14px;\n    font-weight: 500;\n    vertical-align: middle;\n}\n.table-responsive.attendee_dtl table .btn {\n    line-height: 15px;\n    display: flex;\n    align-items: center;\n    padding: 0 20px !important;\n    margin: 0 5px 0 0;\n}\n.table-responsive.attendee_dtl table td.active {\n    width: 315px;\n}\n.table-responsive.attendee_dtl table td.engagement {\n    width: 245px;\n}\n.table-responsive.attendee_dtl > table .university-name {\n    width: 175px;\n}\n.table-responsive.attendee_dtl > table td.sentDeliveredOpened {\n    width: 365px;\n}\n.table-responsive.attendee_dtl a.tablink {\n    color: #0b3454;\n    display: flex;\n    align-items: center;\n    text-decoration: none;\n    line-height: 18px;\n}\n.table-responsive.attendee_dtl a.tablink:hover {\n    color: #4c4f51;\n}\n.table-responsive.attendee_dtl a.btn-gray-border:hover {\n    color: #fff;\n}\n.table-responsive.attendee_dtl > table td.deliveryStatus {\n    width: 205px;\n}\n.table_cus_badge {\n    background: #fef7e8;\n    border-radius: 20px;\n    height: 36px;\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 14px;\n    color: #000;\n    font-weight: 500;\n    padding: 0 15px;\n    margin: 3px;\n    min-width: 65px;\n}\n.tab-ul {\n    padding: 0;\n    line-height: 22px;\n    list-style: none;\n    margin: 0 13px 0 0;\n}\n.attendee_dtl input[type='checkbox'] {\n    width: 18px;\n    height: 18px;\n    display: inline-block;\n}\n.aldir_scroll {\n    width: 100%;\n    overflow-x: auto;\n    scrollbar-width: thin;\n    scrollbar-color: #fb9aa7 #780011;\n    padding: 0;\n}\n.aldir_scroll::-webkit-scrollbar {\n    height: 4px;\n}\n.aldir_scroll::-moz-scrollbar {\n    height: 4px;\n}\n.aldir_scroll::-webkit-scrollbar-track {\n    background: #780011 !important;\n}\n.aldir_scroll::-webkit-scrollbar-thumb {\n    background-color: #fb9aa7;\n    border-radius: 20px;\n    border: 1px solid #780011 !important;\n    -webkit-border-radius: 20px;\n    -moz-border-radius: 20px;\n    -ms-border-radius: 20px;\n    -o-border-radius: 20px;\n}\n.css-1n6sfyn-MenuList::-webkit-scrollbar {\n    width: 4px;\n}\n.css-1n6sfyn-MenuList::-moz-scrollbar {\n    width: 4px;\n}\n.css-1n6sfyn-MenuList::-webkit-scrollbar-track {\n    background: #ccc !important;\n}\n.css-1n6sfyn-MenuList::-webkit-scrollbar-thumb {\n    background-color: #fff;\n    border-radius: 20px;\n    border: 1px solid #ccc !important;\n    -webkit-border-radius: 20px;\n    -moz-border-radius: 20px;\n    -ms-border-radius: 20px;\n    -o-border-radius: 20px;\n}\n.fitergroup .show .accordion-body {\n    border-radius: 0 6px 6px 6px;\n}\n.fitergroup .accordion-body {\n    background: #f1f1f1;\n    border-radius: 6px;\n}\n.fitergroup .form-select {\n    height: 45px;\n}\n.btn-grpfiter {\n    border: 0px solid #e1e1e1;\n    border-radius: 20px;\n    height: 40px;\n    padding: 0 25px;\n    font-size: 14px;\n    font-weight: 500;\n    background: #f1f1f1;\n    position: relative;\n}\n.btn-grpfiter[aria-expanded='true'] {\n    border-radius: 20px 20px 0 0;\n    transition: all 0.3s ease-in-out;\n}\n.btn-grpfiter::before {\n    content: '';\n    position: absolute;\n    bottom: -20px;\n    left: 0;\n    right: 0;\n    background: #f1f1f1;\n    height: 10px;\n    transition: all 0.3s ease-in-out;\n    opacity: 0;\n}\n.btn-grpfiter[aria-expanded='true']::before {\n    bottom: -10px;\n    opacity: 1;\n}\n/* .btn-grpfiter ~ div .form-control {max-height: 38px;background-size: 14px;background-repeat: no-repeat;background-position: 13px center;padding-left: 34px;height: 40px;border-radius: 25px;-webkit-border-radius: 25px;-moz-border-radius: 25px;-ms-border-radius: 25px;-o-border-radius: 25px;} */\n.btn-grpfiter ~ div .form-control {\n    border-color: #dee2c6;\n}\n/* background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/search.svg); */\n\n@media (max-width: 480px) {\n    .vertical-input-group {\n        flex-direction: column;\n    }\n    .vertical-input-group.input-group .form-select,\n    .vertical-input-group .form-control {\n        width: 100%;\n    }\n    .vertical-input-group.input-group\n        > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {\n        margin-left: 0px;\n        margin-top: -1px;\n        border-top-left-radius: 0;\n        border-bottom-left-radius: 0;\n        border-top-right-radius: 0;\n        border-bottom-right-radius: 0;\n    }\n    .vertical-input-group.has-validation.input-group > .dropdown-toggle:nth-last-child(n + 4),\n    .vertical-input-group.has-validation > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu) {\n        border-top-right-radius: 6px;\n        border-bottom-right-radius: 0;\n        border-top-left-radius: 6px;\n        border-bottom-left-radius: 0;\n    }\n    .vertical-input-group.has-validation.input-group > .form-select:nth-last-child(2) {\n        border-top-right-radius: 0;\n        border-bottom-right-radius: 6px !important;\n        border-top-left-radius: 0;\n        border-bottom-left-radius: 6px !important;\n    }\n}\n.custom-input-group[style*='grid'] {\n    border: 1px solid #cccccc;\n    border-radius: 6px;\n    display: flex !important;\n    height: auto !important;\n}\n.custom-input-group[style*='grid'] .basic-multi-select{height: auto !important;min-height: 43px;}\n.custom-input-group[style*='grid'] .border {\n    border: 0 !important;\n    border-radius: 5px 0px 0 5px;\n}\n.custom-input-group[style*='grid'] .css-nozp1o-control {\n    border: none !important;\n    height: 43px;\n    border-radius: 0 5px 5px 0;\n    overflow: visible;\n}\n.custom-input-group[style*='grid'] .select__control{height: auto;padding: 5px;}\n.custom-input-group[style*='grid'] .css-oorrsa-IndicatorsContainer{height: auto;}\n.custom-input-group[style*='grid'] .select__indicators{height: auto;}\n\nselect#rangeOption ~ .form-control[type*='date'] {\n    background-image: none;\n}\n.modal-dialog .modal-content .modal-header .btn-close {\n    background-color: none;\n    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/close.svg);\n    width: 15px;\n    padding: 0;\n    font-size: 12px;\n    margin-right: 10px;\n    color: #000000;\n    opacity: 2;\n}\n.modal-dialog .modal-content .modal-header .btn-close::before {\n    display: none;\n}\n.top20 {\n    top: 20px;\n}\n.top40 {\n    top: 40px;\n}\n.right20 {\n    right: 20px;\n}\n.z1 {\n    z-index: 1;\n}\n.z2 {\n    z-index: 2;\n}\n.z3 {\n    z-index: 3;\n}\n.z4 {\n    z-index: 4;\n}\n.z5 {\n    z-index: 5;\n}\n.z6 {\n    z-index: 6;\n}\n.z7 {\n    z-index: 7;\n}\n.z8 {\n    z-index: 8;\n}\n.z9 {\n    z-index: 9;\n}\n.radius-20 {\n    border-radius: 20px;\n    -webkit-border-radius: 20px;\n    -moz-border-radius: 20px;\n    -ms-border-radius: 20px;\n    -o-border-radius: 20px;\n}\n.radius-15 {\n    border-radius: 15px;\n    -webkit-border-radius: 15px;\n    -moz-border-radius: 15px;\n    -ms-border-radius: 15px;\n    -o-border-radius: 15px;\n}\n.radius-10 {\n    border-radius: 10px;\n    -webkit-border-radius: 10px;\n    -moz-border-radius: 10px;\n    -ms-border-radius: 10px;\n    -o-border-radius: 10px;\n}\n.radius-5 {\n    border-radius: 5px;\n    -webkit-border-radius: 5px;\n    -moz-border-radius: 5px;\n    -ms-border-radius: 5px;\n    -o-border-radius: 5px;\n}\n/* Alumni Dashboard End */\n\n.tooltip .tooltip-inner {\n    background-color: #5a6268;\n    color: #fff;\n    font-size: 16px;\n    padding: 10px;\n}\n.tooltip .tooltip-arrow {\n    border-color: #5a6268;\n}\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\ninput[type='number'] {\n    -moz-appearance: textfield;\n}\n.social-block {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    align-items: center;\n    border-radius: 6px;\n    height: 48px;\n    padding: 0 20px;\n    line-height: 38px;\n    font-size: 18px;\n    font-weight: 600;\n    color: #fff;\n    cursor: pointer;\n}\nform.lstCustForm label.social-block span {\n    color: #fff;\n    font-style: normal;\n    font-size: 18px;\n    font-weight: 600;\n    color: #fff;\n    padding-left: 0;\n}\n.social-block.fb {\n    background: #3456a2;\n}\n.social-block.tw {\n    background: #00a1f9;\n}\n.social-block.linkedin {\n    background: #0077b5;\n}\n.social-block.fb img {\n    margin-top: -4px;\n}\n.social-check label {\n    width: 24px;\n    height: 24px;\n    background: rgba(0, 0, 0, 0.3);\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 0px;\n    color: #fff;\n    cursor: pointer;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n}\n.social-check input:checked + label {\n    background: #5cae48;\n    border-color: #5cae48;\n    font-size: 11px;\n}\n.toggle-switch-parent {\n    width: 380px;\n    margin-right: 30px;\n}\n.masRow {\n    display: flex;\n    flex-wrap: wrap;\n}\n.masRow:not(:last-child) {\n    margin-bottom: 20px;\n}\n.form-check-input-parent {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    flex: 1;\n}\n.form-check-input-parent .form-control {\n    max-width: 80px;\n    width: 80px;\n}\n.form-check-input-parent .btn-customize:not(:checked) ~ .form-control {\n    background-color: #f2f2f2 !important;\n    border-color: #dfdfdf !important;\n    pointer-events: none;\n}\n.socialist-label {\n    font-size: 20px;\n    font-weight: 500;\n    flex: 1;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    line-height: 22px;\n}\n.socialist-block {\n    background: #f3f3f3;\n    border-radius: 6px;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    padding: 5px 20px;\n    height: 40px;\n    width: 320px;\n}\n.sociallist-detail ul {\n    display: flex;\n    align-items: center;\n    list-style: none;\n    font-size: 14px;\n    padding: 0;\n    margin: 0;\n}\n.sociallist-detail ul li {\n    position: relative;\n}\n.sociallist-detail ul li:not(:first-child):before {\n    content: '';\n    width: 7px;\n    height: 7px;\n    border-radius: 50%;\n    background: #000;\n    position: absolute;\n    margin: auto;\n    opacity: 0.3;\n    top: 0;\n    bottom: 0;\n    left: -3px;\n}\n.sociallist-detail ul li:not(:first-child) {\n    padding: 0 0 0 15px;\n    margin: 0 0 0 15px;\n}\n.socialist {\n    padding: 20px;\n    border: 1px solid #eee;\n    border-radius: 6px;\n}\n.socialist:not(:last-child) {\n    margin-bottom: 10px;\n}\n.postdetail {\n    display: flex;\n    justify-content: flex-end;\n    flex-wrap: wrap;\n}\n.postdetail .poston {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    font-size: 13px;\n    opacity: 0.8;\n    line-height: 17px;\n}\n.text-gray-68 {\n    color: #686868;\n}\n.row_parent {\n    padding: 15px 35px 20px !important;\n    margin: -20px -25px 20px !important;\n}\n.row_parent:nth-child(even) {\n    background: #f2f6fa;\n}\n.row_parent:last-child {\n    margin-bottom: -25px !important;\n}\nform.lstCustForm .form-select,\nform.lstCustForm input.form-control {\n    border: 1px solid #848484;\n    height: 45px;\n}\nform.lstCustForm textarea.form-control {\n    border: 1px solid #848484;\n}\nform.lstCustForm .form-check .form-check-input {\n    width: 24px;\n    height: 24px;\n    margin-left: 0px;\n    border: 2px solid #848484;\n}\nform.lstCustForm .form-check:not(:last-child) {\n    margin: 0 40px 5px 0;\n}\nform.lstCustForm .btn-greenm,\n.btn-greenm252 {\n    min-width: 252px;\n}\nform.lstCustForm label span {\n    font-size: 14px;\n    color: #848484;\n    font-weight: 400;\n    font-style: italic;\n    float: right;\n    display: inline-block;\n    padding: 0 0 0 20px;\n}\nform.lstCustForm .inputfile_parent label span.uploadlabel {\n    font-size: 16px;\n    color: #414141;\n    font-weight: 400;\n    float: right;\n    display: inline-block;\n    padding: 0 0 0 8px;\n    font-style: normal;\n}\nform.lstCustForm label span.icon {\n    font-style: unset;\n    color: #414141;\n}\n.fileclose {\n    height: 12px;\n    line-height: 10px;\n    width: 12px;\n    text-align: center;\n    background: #959595;\n    border-radius: 50%;\n    color: #fff;\n    font-size: 12px;\n    cursor: pointer;\n    display: none;\n    margin-left: 6px;\n    justify-content: center;\n    align-items: center;\n}\n.fileclose span {\n    font-size: 6px;\n    display: block;\n    margin: 0 0 0px 1px;\n}\n.fileicon {\n    display: none;\n    margin-right: 6px;\n}\n.docselect {\n    display: none;\n    align-items: center;\n    width: max-content;\n}\n.docselect.docseladdbg {\n    background: #f8f8f8;\n    display: flex;\n    padding: 7px 12px;\n    margin: 10px 0 0 0;\n    border-radius: 6px;\n}\n.inputfile::file-selector-button {\n    font: inherit;\n    display: none;\n}\n.inputfile_parent label {\n    color: #f1e5e6;\n    background-color: #f3f3f3;\n    border: 1px dashed #848484;\n    border-radius: 6px;\n    height: 60px;\n    line-height: 60px;\n    max-width: 100%;\n    font-size: 1.25rem;\n    font-weight: 500;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    cursor: pointer;\n    display: inline-block;\n    overflow: hidden;\n    padding: 0;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.albmform .inputfile_parent label {\n    height: 80px;\n    line-height: 80px;\n}\n.inputfile_parent label span {\n    font-size: 16px;\n    color: #414141;\n    font-weight: 500;\n    font-style: unset;\n    float: none;\n    padding: 0 0 0 10px;\n}\n.inputfile_parent {\n    position: relative;\n    height: auto;\n}\n.inputfile_parent.profile .docselect {\n    display: none;\n}\n.inputfile_parent.profile.select + p {\n    display: none;\n}\n.inputfile_parent.profile label {\n    background-color: #fff;\n    border: 1px dashed #a8c5dd;\n    border-radius: 6px;\n    height: 40px;\n    line-height: 40px;\n}\n.inputfile_parent.profile.select .docseladdbg {\n    display: flex;\n    background: #eaeaea;\n}\n.inputfile_parent.profile.pop-up label {\n    background: #f3f3f3 0% 0% no-repeat padding-box;\n    border: 1px dashed #848484;\n    border-radius: 6px;\n    opacity: 1;\n    height: 45px;\n    line-height: 45px;\n}\n.newmsg .ji_filtersec {\n    background: #e6ebee;\n    padding: 25px 30px 30px;\n    margin-top: -1px;\n}\n.newmsg .filterSearch input {\n    border-radius: 18px;\n    border: 1px solid #e1e1e1;\n    padding-left: 47px;\n    color: #000000;\n}\n.newmsg .filterSearch .btn.icon-search {\n    left: 20px;\n    top: 10px;\n    padding: 0;\n    font-size: 14px;\n    color: #414141;\n    font-weight: 400;\n}\n.newmsg .filterSearch .btn.icon-search:hover {\n    color: #0b3454;\n}\n.dotted-blue-border {\n    height: 1px;\n    width: 100%;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/dotted_border_bg.png) left top\n        repeat-x;\n}\n.newmsg .ji_filtersec ul {\n    list-style: none;\n    padding: 0;\n}\n.newmsg .ji_filtersec ul li {\n    margin: 0 0 20px;\n}\n.newmsg .ji_filtersec ul li a {\n    color: #0b3454;\n    font-weight: 400;\n    font-size: 16px;\n    text-decoration: none;\n    width: 100%;\n    display: inline-block;\n}\n.newmsg .ji_filtersec ul li.active a,\n.newmsg .ji_filtersec ul li a:hover {\n    color: #5cae48;\n}\n.msgtabcont {\n    padding: 25px;\n}\n.msgtabcont.msgwrapext {\n    padding: 25px 10px 25px 25px;\n}\n.msgtabcont .msgbox {\n    border: 1px solid #dedede;\n    border-radius: 6px;\n    padding: 20px 0px 90px;\n    min-height: 490px;\n    max-height: 490px;\n}\n.msgtabcont .msgbox.msgboxconvo {\n    padding: 5px 0px 60px;\n    display: flex;\n    flex-direction: column;\n}\n.mgs-links {\n    display: flex;\n    padding: 0 0 8px;\n    width: 291px;\n}\n.mgs-links .btn {\n    background: #d4edf9 0% 0% no-repeat padding-box;\n    border: 1px solid #93d3ef;\n    border-radius: 18px;\n    font-size: 14px;\n    color: #000;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n    height: 36px;\n}\n.mgs-links .btn:first-child {\n    margin-right: 10px;\n}\n.mgs-links .btn:hover {\n    background: #93d3ef;\n    color: #0e2d39;\n}\n.mgs-links .btn:focus {\n    box-shadow: none;\n}\n.mgs-links .btn:focus-visible {\n    outline: none;\n}\n.search-form-control {\n    background: #fff url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/search.svg) no-repeat left 13px\n        top 14px / 16px auto;\n    border: 1px solid #d4d4d4;\n    border-radius: 23px;\n    opacity: 1;\n    padding: 6px 10px 6px 43px;\n    height: 45px;\n}\n.msgbox .filterSearch input {\n    height: 45px;\n    line-height: 45px;\n    border: 1px solid #848484;\n    border-radius: 23px;\n    font-size: 16px;\n    color: #666666;\n}\n.msgbox .filterSearch input:focus {\n    border-color: #86b7fe;\n}\n.msgbox .filterSearch input:focus-visible {\n    border-color: #86b7fe;\n}\n.msgbox .filterSearch input:focus-within {\n    border-color: #86b7fe;\n}\n.newmsg .msgbox .filterSearch .btn.icon-search {\n    top: 15px;\n}\n.msgbox .filterSearch input:focus-visible {\n    border-color: #86b7fe;\n}\n.search_btmshadow {\n    background: transparent linear-gradient(180deg, #f2f2f2 0%, #ffffff 100%) 0%0% no-repeat padding-box;\n    height: 20px;\n    width: 100%;\n}\n.msgbox_send {\n    width: 100%;\n    height: 60px;\n    background: #f3f3f3;\n    left: 0;\n    bottom: 0;\n    border-radius: 0 0 6px 6px;\n    padding: 5px;\n}\n.msgbox_send input {\n    height: 50px;\n    line-height: 50px;\n    font-size: 16px;\n    font-weight: 500;\n    color: #414141;\n}\n.btn-complete-now.msgsendbtn span {\n    font-size: 14px;\n    font-weight: 600;\n    position: relative;\n}\n.btn-complete-now.msgsendbtn {\n    top: 5px;\n    right: 5px;\n    position: absolute;\n    max-width: 70px;\n    width: 100%;\n}\n.peerprofile {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 60px;\n    height: 60px;\n    background: #f4f4f4;\n    border-radius: 50%;\n    margin: 0 10px 0 0;\n    overflow: hidden;\n}\n.peerprofile img[src*='dummy_male.svg'] {\n    margin-top: auto;\n    width: auto;\n    height: 85%;\n}\n.customCheckBox {\n    width: 20px;\n    height: 20px;\n    border-width: 2px;\n}\n.customCheckBox:checked {\n    background-color: #0b3454;\n    border-color: #0b3454;\n}\n.customCheckBox:checked[type='checkbox'] {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/%3e%3c/svg%3e\");\n}\n.lite-blue {\n    background-color: #e9f6fc;\n}\n.height-80 {\n    height: 80px !important;\n}\n.min-h-420 {\n    min-height: 420px;\n}\n.min-h-280 {\n    min-height: 280px;\n}\n.radius-6 {\n    border-radius: 6px !important;\n}\n.broadcast_submit .btn {\n    background: #fff;\n    box-shadow: 1px 1px 1px #0b34541a;\n    border: 1px solid #0b34544d;\n    border-radius: 25px;\n    margin: 5px;\n    font-size: 16px;\n    transition: all 0.3s ease-in-out;\n    padding: 0 25px;\n    height: 50px;\n}\n.broadcast_submit .btn:hover {\n    background: #5cae48;\n    color: #fff;\n    border-color: #5cae48;\n}\n.broadcast_submit .btn-publish {\n    background: #5cae48;\n    width: 200px;\n    color: #fff;\n}\n.broadcast_submit .btn-publish:hover {\n    background: #4c9649;\n}\n.card.twitter {\n    border-color: #1da1f3;\n    overflow: hidden;\n}\n.card.twitter .card-header {\n    background: #1da1f3;\n    color: #fff;\n}\n.card.facebook {\n    border-color: #3456a2;\n    overflow: hidden;\n}\n.card.facebook .card-header {\n    background: #3456a2;\n    color: #fff;\n}\n.card.instagram {\n    border-color: #f84e44;\n    overflow: hidden;\n}\n.card.instagram .card-header {\n    color: #fff;\n    background: rgb(171,16,128);\n    background: linear-gradient(208deg, rgba(171,16,128,1) 0%, rgba(254,83,64,1) 70%, rgba(255,213,84,1) 100%);\n}\n.card.linkedin {\n    border-color: #0077b5;\n    overflow: hidden;\n}\n.card.linkedin .card-header {\n    background: #0077b5;\n    color: #fff;\n}\n.icon-star.circle-img {\n    position: absolute;\n    bottom: -3px;\n    right: -3px;\n    background: #5cae48;\n    border-radius: 50%;\n    color: #fff;\n    font-size: 7px;\n    padding: 4px;\n}\n.filter-custom-select {\n    width: 100%;\n    height: 45px;\n    border: 1px solid #dee2e6;\n    border-radius: 6px;\n    background-color: #fff;\n    background-image: url('data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M2 5l6 6 6-6%27/%3e%3c/svg%3e');\n    background-repeat: no-repeat;\n    background-position: center right 10px;\n    background-size: 12px 12px;\n    padding-right: 30px;\n}\n.dropdown-wrap {\n    overflow-x: hidden;\n    max-height: 250px;\n}\n.dropdown-wrap label input {\n    margin-right: 5px;\n    width: 18px;\n    height: 18px;\n}\n.filter-custom-select.dashboard-filter {\n    width: 150px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    padding-left: 10px;\n    /* border: 2px solid #7d7d7d; */\n    border: 1px solid #b5c2cb;\n    /* height: 35px; */\n    height: 45px;\n    border-radius: 25px;\n}\n.alumni-directory-header {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 20px;\n}\n.alumni-directory-header_search {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    align-items: center;\n}\n.alumni-directorySearch {\n    background: #ffffff;\n    width: 365px;\n    height: 40px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    border-radius: 25px;\n    overflow: hidden;\n    position: relative;\n}\n.alumni-directorySearch .form-control {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    border: 0;\n    padding-left: 0;\n}\n.alumni-directorySearch .btn.icon-search {\n    font-size: 12px;\n    padding: 0 10px 0 20px;\n}\n.alumni-directorySearch .btn-search-cross {\n    position: absolute;\n    right: 13px;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    color: #000;\n    font-weight: 100 !important;\n}\n.alumni-directorySearch .btn-cross {\n    width: 14px;\n    height: 14px;\n    position: absolute;\n    right: -15px;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    transform: rotate(0deg);\n    opacity: 0;\n    transition: all 0.5s ease-in-out;\n}\n.alumni-directorySearch .btn-cross:before {\n    content: '';\n    position: absolute;\n    width: 14px;\n    height: 2px;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    top: 0;\n    margin: auto;\n    background: #000;\n    border-radius: 5px;\n}\n.alumni-directorySearch .btn-cross:after {\n    content: '';\n    position: absolute;\n    width: 2px;\n    height: 14px;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    top: 0;\n    margin: auto;\n    background: #000;\n    border-radius: 5px;\n}\n.alumni-directorySearch .form-control:valid + .btn-cross {\n    opacity: 1;\n    right: 15px;\n    transform: rotate(135deg);\n}\n.alumni_directory_filter {\n    padding: 30px 0;\n    padding-right: var(--bs-gutter-x, 0.75rem);\n    padding-left: var(--bs-gutter-x, 0.75rem);\n}\n.alumni_directory_filter .ji_filtersec {\n    width: 100%;\n    max-width: 100%;\n}\n.alumni_directory_filter .fiterItem {\n    width: 220px;\n    margin: 0 5px;\n    box-shadow: 0px 10px 25px #00000008;\n}\n.alumni_directory_filter .fiterItem.key {\n    border-color: #5cae48;\n}\n.alumni_directory_filter .filterGroup {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    align-items: start;\n    margin: 0 -5px;\n}\n.alumni_directory_filter .filterSearchblk {\n    background: #fff;\n    padding: 0 14px 10px;\n}\n.alumni_directory_filter .filterSearchblk .filterSearch input {\n    margin: 0;\n}\n.alumni_directory_filter .filterHeader button {\n    transition: all 0.3s ease-in-out;\n    padding: 15px 15px;\n}\n.alumni_directory_filter .filterHeader button:not([aria-expanded='false']) {\n    padding-bottom: 8px;\n}\n.alumni_directory_filter .fiterItem .card {\n    padding: 0px 15px 15px;\n}\n.alumni_directory_filter .scrollMe {\n    max-height: 122px;\n    min-height: 122px;\n    overflow-x: hidden;\n}\n.alumni_directory_filter .fiterItem .form-check:not(:last-child) {\n    margin-bottom: 4px;\n}\n.additionalfilter_count {\n    display: none;\n}\n.btn-md-filter {\n    text-decoration: none;\n    transform: rotate(90deg);\n    color: #000;\n    font-size: 20px;\n    transition: all 0.3s ease-in-out;\n}\n.btn-md-filter:hover {\n    color: #000;\n}\n.btn-md-filter[aria-expanded='true'] {\n    transform: rotate(270deg);\n}\n.additionalfilter_wrap {\n    width: 100%;\n    padding: 0 5px;\n}\n.alumni_directory_filter .fiterItem.campus {\n    width: 450px;\n}\n.showProfiles_wrap {\n    background: #fff;\n    border: 1px solid #d2d2d2;\n    border-radius: 6px;\n    box-shadow: 0px 10px 25px #00000008;\n    width: calc(100% - 10px);\n    margin: 0 5px;\n    padding: 17px 30px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n.showProfiles_left {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    align-items: center;\n}\n.showProfiles_left h3 {\n    margin: 0 30px 0 0;\n    font-size: 18px;\n    line-height: 20px;\n    font-weight: 600;\n}\n.showProfiles_left .form-check-label {\n    font-size: 16px;\n}\n.showProfiles_left .form-check-input {\n    width: 20px;\n    height: 20px;\n    vertical-align: top;\n    margin-top: -2px;\n    margin-right: 10px;\n}\n.showProfiles_left .form-check.form-check-inline {\n    display: inline-flex;\n    align-items: center;\n}\n.showProfiles_left .check_list {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    align-items: center;\n}\n.showProfiles_left .form-check-input:checked {\n    background-color: #5cae48;\n    border-color: #5cae48;\n}\n.showProfiles_right .icon {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/subtraction.svg);\n    width: 16px;\n    height: 25px;\n    margin-right: 8px;\n}\n.showProfiles_right {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n}\n.showProfiles_right .title {\n    font-size: 14px;\n    letter-spacing: -0.35px;\n}\n.alumni-bucket {\n    background: #ffffff;\n    border: 1px solid #d2d2d2;\n    border-radius: 6px;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n}\n.alumni-bucket .block-link {\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    top: 0;\n    margin: auto;\n    z-index: 1;\n}\n.alumni_img {\n    width: 60px;\n    margin-right: 10px;\n    height: 60px;\n    background: #f1f1f1;\n    border-radius: 50%;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.alumni_img img {\n    width: auto;\n    height: 100%;\n}\n.alumni_img.no_pic {\n    align-items: end;\n}\n.alumni_img.no_pic img {\n    width: auto;\n    height: auto;\n}\n.alumni_name_brife h3 {\n    font-size: 18px;\n    margin: 0;\n}\n.class_year {\n    color: #6a6868;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 18px;\n}\n.alumni_directory_details .btn-viewcompus {\n    font-size: 13px;\n    color: #1452ce;\n    font-weight: 500;\n    line-height: 18px;\n    position: relative;\n    z-index: 2;\n    text-decoration: none;\n}\n.alumni_directory_details .btn-viewcompus:hover {\n    color: #0b3454;\n    text-decoration: underline;\n}\n.alumni_directory_details a.btn-send {\n    padding: 0 20px;\n    line-height: 36px;\n    text-decoration: none;\n    background: #5cae48;\n    border-radius: 25px;\n    height: 36px;\n    display: inline-flex;\n    color: #fff;\n    align-items: center;\n    transition: all 0.3s ease-in-out;\n    position: relative;\n    z-index: 2;\n}\n.alumni_directory_details a.btn-send:hover {\n    background: #40862f;\n}\n.icon-alumni-send {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/send_alumni_profile.svg) no-repeat 0\n        0 / 100%;\n    width: 19px;\n    height: 19px;\n    margin-right: 8px;\n    margin-left: -3px;\n}\n/* .alumni_univarsity_details {background: #F9F9F9 ;border-radius: 0px 0px 5px 5px;opacity: 1;display: flex;justify-content: center;-webkit-box-flex: 1;-moz-box-flex: 1;-webkit-flex: 1;-ms-flex: 1;flex: 1;padding: 11px;position:relative}\n.alumni_univarsity_details .alumni_univarsity_details_inner_cover {max-width: 260px;width: 90%;display: flex;flex-wrap: wrap;}\n.alumni_univarsity_details .alumni_univarsity_details_inner_cover .alumni_univarsity_logo {width: 64px;margin-right: 10px;padding-top: 6px;}\n.alumni_univarsity_details .alumni_univarsity_details_inner_cover .alumni_univarsity_logo img {width: 100%;border-radius: 50%;}\n.alumni_univarsity_details .alumni_univarsity_details_inner_cover .alumni_univarsity_brife {width: calc(100% - 75px);} */\n.alumni_directory_details a.alumni_name_link {\n    color: #000;\n    text-decoration: none;\n}\n.alumni_directory_details a.alumni_name_link:hover {\n    color: #1452ce;\n}\n.alumni_class_link {\n    padding: 15px 20px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n}\n.alumni_education {\n    color: #4d4d4d;\n    font-size: 13px;\n    font-weight: 500;\n    line-height: 18px;\n}\n.alumni_univarsity_name {\n    font-size: 19px;\n    font-weight: 500;\n    line-height: 20px;\n    margin-bottom: 3px;\n}\n.alumni_univarsity_name .icon-subtraction {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/subtraction.svg) no-repeat 0 0 / 100%;\n    width: 12px;\n    height: 20px;\n    margin-left: 3px;\n    display: inline-block;\n    vertical-align: top;\n}\n.alumni_univarsity_subject {\n    color: #0b3454;\n    font-size: 14px;\n    line-height: 16px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n}\n.alumni_univarsity_subject span {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n}\n.alumni_univarsity_subject i {\n    width: 16px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/subject_setting.svg) no-repeat 0 0 /\n        100%;\n    height: 16px;\n    margin-right: 7px;\n}\n.filter_result ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n}\n.filter_result_title {\n    margin-bottom: 18px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    margin-top: 10px;\n}\n.filter_result_title .filter_result {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n}\n.filter_result ul li {\n    background: #e9f6fc;\n    border-radius: 25px;\n    padding: 9px 23px;\n    margin-top: 6px;\n    margin-bottom: 6px;\n}\n.filter_result ul li:not(:last-child) {\n    margin-right: 10px;\n}\n.filter_result ul li:last-child {\n    background: no-repeat;\n    padding: 9px 0;\n}\n.filter_result ul li span {\n    margin-right: 10px;\n}\n.filter_result ul li .btn-cross {\n    font-size: 10px;\n    color: #000;\n    text-decoration: none;\n}\n.filter_result ul li .btn-cross:hover {\n    color: #105271;\n}\n.alumni_count {\n    font-size: 18px;\n    font-weight: 500;\n    line-height: 20px;\n    margin: 18px 0 0;\n}\n.btn-additionalfilter {\n    text-decoration: none;\n    font-size: 14px;\n    color: #1452ce;\n    font-weight: 500;\n    display: inline-flex;\n    align-items: center;\n    transition: all 0.3s ease-in-out;\n}\n.btn-additionalfilter span {\n    text-decoration: underline;\n    margin-right: 10px;\n}\n.btn-additionalfilter .icon-right-arrow {\n    transform: rotate(90deg);\n    transition: all 0.3s ease-in-out;\n}\n.btn-additionalfilter[aria-expanded='true'] .icon-right-arrow {\n    transform: rotate(270deg);\n}\n.btn-additionalfilter:hover {\n    color: #0b3454;\n}\n.btn-additionalfilter:hover span {\n    text-decoration: none;\n}\n.alumni_directory_filter .filters-head h3 {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    margin: 0;\n    align-items: center;\n}\n.alumni_directory_filter .filters-head h3 .icon-filter + span {\n    flex: 1;\n}\n.alumni_directory_filter .filters-head h3[aria-expanded='true'] i {\n    transform: rotate(270deg);\n}\n.alumni_directory_details .load_more_btn {\n    text-decoration: none;\n    text-transform: uppercase;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.alumni_directory_details .load_more_btn:hover {\n    background: #0b3454;\n    color: #fff;\n    border-color: #0b3454;\n}\n.alumni_directory_details .load_more_btn img {\n    -webkit-animation: none;\n}\n.alumni_directory_details .load_more_btn:hover img {\n    filter: invert(1) brightness(100);\n}\n.tooltip-viewcompus .tooltip-arrow::before {\n    display: none;\n}\n.alumni_profile_brife_wrap {\n    border-bottom: 1px solid #e7e7e7;\n}\n.alumni_profile_brife {\n    padding: 40px 0;\n}\n.alumni_profile_brife .btn-back {\n    color: #000;\n    font-size: 14px;\n    line-height: 16px;\n    font-weight: 500;\n}\n.alumni_profile_brife .btn-back .icon-right-arrow {\n    transform: scaleX(-1);\n    margin-right: 7px;\n    font-size: 12px;\n}\n.alumni_profile_brife .btn-back:hover {\n    color: #0b3454;\n}\n.alumni_profile_name_college_other_detail_wrap {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n}\n.alumni_profile_image_name_other_detail {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    padding: 0 20px 0 0;\n    position: relative;\n    width: 48%;\n}\n.alumni_profile_image_name_other_detail:after {\n    content: '';\n    width: 1px;\n    height: 100%;\n    background: #d4d4d4;\n    position: absolute;\n    right: 0;\n    top: 0;\n}\n.alumni_profile_image {\n    width: 110px;\n    height: 110px;\n    background: #f1f1f1;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n    margin-right: 20px;\n}\n.alumni_profile_image img {\n    width: auto;\n    height: 100%;\n}\n.alumni_profile_image.no_pic {\n    align-items: end;\n}\n.alumni_profile_image.no_pic img {\n    height: 80%;\n}\n.alumni_profile_name_other_detail {\n    width: calc(100% - 130px);\n}\n.alumni_profile_name_other_detail h2 {\n    font-size: 26px;\n    line-height: 18px;\n    font-weight: 600;\n    word-break: break-all;\n    line-height: 28px;\n}\n.alumni_profile_name_other_detail .alumni_profile_location {\n    font-size: 14px;\n    font-weight: 500;\n    margin-bottom: 15px;\n}\n.alumni_profile_class_college {\n    position: relative;\n    padding: 0 0 0 20px;\n    margin-bottom: 13px;\n}\n.alumni_profile_class_college:before {\n    content: '';\n    position: absolute;\n    left: 6px;\n    top: 0;\n    bottom: 0;\n    width: 3px;\n    height: 100%;\n    background: #d52941;\n    border-radius: 5px;\n}\n.alumni_profile_class_college .alumni_profile_class {\n    font-size: 16px;\n    font-weight: 500;\n    letter-spacing: 0.32px;\n    line-height: 18px;\n    margin-bottom: 5px;\n}\n.alumni_profile_class_college .alumni_profile_college {\n    font-size: 16px;\n    font-weight: 500;\n    letter-spacing: 0.32px;\n    line-height: 18px;\n}\n.alumni_profile_college_phone {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    align-items: center;\n}\n.alumni_profile_college_phone .verifyLink {\n    font-size: 16px;\n    font-weight: 500;\n}\n.verifiedLink {\n    color: #5cae48;\n    text-decoration: none;\n    display: flex;\n    align-items: center;\n    font-weight: 400;\n    font-size: 16px;\n}\n.alumni_profile_name_other_detail .btn-send {\n    width: auto;\n    height: 40px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    background: #5cae48;\n    border-radius: 25pc;\n    color: #fff;\n    text-decoration: none;\n    align-items: center;\n    padding: 0 25px;\n    font-size: 16px;\n    font-weight: 500;\n    transition: all 0.3s ease-in-out;\n}\n.alumni_profile_name_other_detail .btn-send .icon-send {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/send_alumni_profile.svg) no-repeat 0\n        0 / 100%;\n    width: 19px;\n    height: 19px;\n    margin-right: 10px;\n    position: relative;\n    transition: all 0.3s ease-in-out;\n    left: 0;\n}\n.alumni_profile_name_other_detail .btn-send:hover {\n    background: #2fa612;\n}\n.alumni_profile_name_other_detail .btn-send:hover .icon-send {\n    left: 3px;\n}\n.alumni_profile_brife_tab {\n    margin-bottom: 20px;\n}\n.alumni_profile_status {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n.alumni_profile_status li {\n    margin-bottom: 16px;\n    width: 176px;\n    position: relative;\n    padding-left: 16px;\n}\n.alumni_profile_status li .title {\n    letter-spacing: 0.32px;\n    color: #000000;\n    font-size: 16px;\n}\n.alumni_profile_status li p {\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 20px;\n    letter-spacing: 0.32px;\n}\n.alumni_profile_status li:before {\n    content: '';\n    width: 3px;\n    height: 17px;\n    position: absolute;\n    left: 0;\n    top: 4px;\n    background: #d52941;\n    border-radius: 5px;\n}\n.alumni_profile_college_joined {\n    color: #5cae48;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 18px;\n    margin-bottom: 5px;\n}\n\n.alumni_profile_college_name_other_detail_wrap .alumni_profile_college_name_detail h3 {\n    font-size: 20px;\n    line-height: 26px;\n    font-weight: 600;\n}\n.alumni_profile_college_subject {\n    min-height: 30px;\n    height: auto;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 6px 15px;\n    background: #e5f1fb;\n    border-radius: 18px;\n    font-size: 16px;\n    line-height: 20px;\n    font-weight: 600;\n    color: #0b3454;\n}\n\n.underGraduate-detail .main_title,\n.blockHeader {\n    font-size: 22px;\n    color: #000;\n    width: auto;\n    margin: -40px -40px 25px;\n    border-radius: 6px 6px 0px 0px;\n    padding: 20px 40px;\n    line-height: 22px;\n    border-bottom: 1px solid #f5f5f5;\n}\n.blockHeader .title span {\n    font-weight: 600;\n}\n.graduateRow .college_detail_wrap .college_detail h3 {\n    font-size: 20px;\n    font-weight: 600;\n    margin: 0 0 2px;\n    transition: all 0.3s ease-in-out;\n}\n.graduateRow .college_detail_wrap:hover h3 {\n    text-decoration: underline;\n    color: #1452ce;\n}\n.graduateRow .college_detail_wrap .college_detail h3 .icon-subtraction {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/subtraction.svg) no-repeat 0 0 / 100%;\n    width: 16px;\n    height: 25px;\n    margin-left: 3px;\n    display: inline-block;\n    vertical-align: top;\n}\n.graduateRow .college_detail_wrap .college_detail p {\n    font-size: 16px;\n    color: #414141;\n    margin: 0 0 5px;\n}\n.graduateRow {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    position: relative;\n}\n.graduateRow:not(:last-child) {\n    border-bottom: 2px solid #e5e5e5;\n    margin-bottom: 28px;\n    padding-bottom: 28px;\n}\n.underGraduate-detail,\n.postGraduate-detail {\n    box-shadow: 0px 10px 25px #00000008;\n    border-radius: 6px;\n    background: #fff;\n    padding: 40px;\n}\n.graduateRow .college_detail_wrap {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    width: calc(100% - 265px);\n    padding-right: 40px;\n    position: relative;\n    align-items: center;\n}\n.graduateRow .college_detail_wrap > a {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n}\n.graduateRow .college_detail_wrap:after {\n    content: '';\n    position: absolute;\n    top: 13px;\n    right: 0;\n    width: 2px;\n    height: 63px;\n    background: #d1d1d1;\n}\n.graduateRow .offer {\n    width: 265px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n    align-items: end;\n    justify-content: center;\n}\n.graduateRow .college_detail_wrap .college_detail {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n}\n.graduateRow .college_detail_wrap .college_detail .college_logo {\n    margin-right: 20px;\n    width: 150px;\n    height: 95px;\n    border: 1px solid #d5d5d5;\n    border-radius: 6px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.college_name_scholarship {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    align-items: center;\n}\n.college_name_scholarship .college_name {\n    width: calc(100% - 100px);\n}\n.graduateRow .college_detail_wrap .college_detail .college_logo .logo_link {\n    padding: 10px;\n    display: inline-block;\n    width: 100%;\n    height: 100%;\n}\n.graduateRow .college_detail_wrap .college_detail .college_logo .logo_link img {\n    width: 100%;\n    height: 100%;\n}\n.graduateRow .college_detail_wrap .scholarship {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n    text-align: center;\n    line-height: 20px;\n}\n.graduateRow .college_detail_wrap .scholarship .scholarship_label {\n    font-weight: 500;\n    color: #8a8a8a;\n}\n.graduateRow .college_detail_wrap .scholarship .scholarship_amt {\n    font-weight: 600;\n    white-space: nowrap;\n}\n.graduateRow .offer > a,\n.graduateRow .offer a.joindeLink {\n    padding: 0 20px;\n    text-decoration: none;\n    height: 37px;\n    background: #5cae48;\n    color: #fff;\n    border-radius: 25px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 14px;\n    font-weight: 500;\n    margin-bottom: 10px;\n    transition: all 0.3s ease-in-out;\n}\n.graduateRow .offer > a:hover,\n.graduateRow .offer a.joindeLink:hover {\n    background: #3e9329;\n}\n.graduateRow .offer > a i,\n.graduateRow .offer a.joindeLink i {\n    margin-right: 10px;\n}\n.graduateRow .offer > a:hover {\n    background: #3b8d27;\n}\n.graduateRow .offer .got_offer {\n    font-weight: 500;\n    font-size: 16px;\n    margin-bottom: 5px;\n}\n.graduateRow .offer .got_offer i {\n    margin-right: 10px;\n    font-size: 20px;\n    color: #5cae48;\n}\n.graduateRow .offer .offerLink {\n    color: #1452ce;\n}\n.graduateRow .offer .offerLink:hover {\n    color: #0b3454;\n}\n.graduateRow .offer .offer_joined i {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/hat_alumni.svg);\n    width: 23px;\n    height: 17px;\n    margin-right: 10px;\n}\n.graduateRow .offer .offer_joined {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n}\n.graduateRow.edit .college_detail_wrap {\n    width: calc(100% - 350px);\n}\n.graduateRow .offer.offer_edit {\n    flex-direction: row;\n    align-items: center;\n    width: 350px;\n    justify-content: end;\n}\n.graduateRow .offer.offer_edit .edit_section,\n.edit_section {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    margin-left: 20px;\n    align-items: center;\n}\n.edit_section_inner {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n}\n.graduateRow .offer .edit_link,\n.edit_section .edit_link {\n    width: 52px;\n    height: 30px;\n    background: #eaf4fc;\n    border-radius: 20px;\n    transition: all 0.3s ease-in-out;\n    position: relative;\n}\n.graduateRow .offer .edit_link:hover,\n.edit_section .edit_link:hover {\n    background-color: #0b3454;\n}\n.graduateRow .offer .edit_link:before,\n.edit_section .edit_link::before {\n    content: '';\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    top: 0;\n    margin: auto;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/draw.svg) no-repeat center / 18px\n        auto;\n}\n.graduateRow .offer .edit_link:hover:before,\n.edit_section .edit_link:hover::before {\n    filter: invert(99%) sepia(1%) saturate(2%) hue-rotate(228deg) brightness(110%) contrast(100%);\n}\n.graduateRow .offer .del_link,\n.edit_section .del_link,\n.del_link {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/delete.svg);\n    width: 14px;\n    height: 16px;\n    margin-left: 10px;\n    opacity: 0.5;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.graduateRow .offer .del_link:hover,\n.edit_section .del_link:hover,\n.del_link:hover {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/delete_dark.svg);\n    opacity: 1;\n}\n.graduateRow .offer .offer_existing_links {\n    display: flex;\n    flex-direction: column;\n    align-items: end;\n}\n.form-group .del_link {\n    position: absolute;\n    top: 15px;\n    right: -20px;\n}\n.graduation-title {\n    font-size: 22px;\n    font-weight: 400;\n    margin: -15px 0 20px;\n}\n.graduation-title span {\n    font-weight: 600;\n}\n.graduation_carousel_wrap {\n    margin-top: 20px;\n    box-shadow: 0px 10px 25px #00000008;\n    border-radius: 6px;\n    background: #fff;\n    padding: 40px;\n}\n.graduation_carousel_wrap .card_profiles:first-child {\n    margin-bottom: 18px;\n}\n.graduation_carousel_wrap .seactionheader {\n    margin: -10px 0 27px;\n}\n.graduation_carousel_wrap .seactionheader h3 {\n    font-size: 22px;\n    font-weight: 400;\n}\n.graduation_carousel_wrap .seactionheader h3 span {\n    font-weight: 600;\n}\n.card_profiles {\n    border: 1px solid #d2d2d2;\n    padding: 20px;\n    border-radius: 6px;\n    flex-direction: column !important;\n    display: flex;\n    justify-content: space-between;\n    height: 100%;\n    position: relative;\n    background: #fff;\n    max-height: 240px;\n    min-height: 240px;\n    -webkit-border-radius: 6px;\n    -moz-border-radius: 6px;\n    -ms-border-radius: 6px;\n    -o-border-radius: 6px;\n    overflow-y: auto;\n}\n.card_profiles::-webkit-scrollbar {\n    width: 4px;\n}\n.card_profiles::-moz-scrollbar {\n    width: 4px;\n}\n.card_profiles::-webkit-scrollbar-track {\n    background: #ccc;\n}\n.card_profiles::-webkit-scrollbar-thumb {\n    background-color: #666;\n    border-radius: 20px;\n    border: 2px solid #666;\n}\n.card_profiles .alumni-Profile-button-rounded {\n    position: absolute;\n    right: 20px;\n    padding: 0 20px;\n}\n.card_profiles .alumni-Profile-button-rounded:hover,\n.card_profiles .alumni-Profile-button-rounded:focus {\n    background: #40952c;\n    color: #fff;\n    background-color: #40952c;\n    border-color: 0;\n    box-shadow: none;\n}\n.card_profiles figure.student {\n    width: 90px;\n    height: 90px;\n    overflow: hidden;\n    border-radius: 200px;\n    margin-right: 10px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.card_profiles figure.student img {\n    border-radius: 200px;\n}\n.student_details {\n    width: calc(100% - 110px);\n}\n.card_profiles .student_details figure img {\n}\n.card_profiles .student_details h2 {\n    font-size: 20px;\n    font-weight: 700;\n    margin-bottom: 15px;\n    width: 65%;\n    margin-top: 010px;\n}\n.card_profiles .student_details h2 a {\n    color: #000;\n    text-decoration: none;\n    white-space: nowrap;\n    width: 100%;\n    text-overflow: ellipsis;\n    display: inline-block;\n    overflow: hidden;\n}\n.card_profiles .student_details h2 a:hover {\n    text-decoration: underline;\n    color: #1452ce;\n}\n.card_profiles .student_details h2 span {\n    display: block;\n    font-size: 16px;\n    color: #6a6868;\n    font-weight: 500;\n}\n.card_profiles .student_details .sub_details {\n    display: flex;\n    flex-grow: 1 !important;\n}\n.card_profiles .student_details .sub_details_workExp {\n    align-items: center;\n    position: relative;\n    padding-bottom: 5px;\n}\n.card_profiles .student_details .sub_details_achivements figure {\n    background: #0b3454 !important;\n}\n.card_profiles .student_details .sub_details_workExp figure {\n    border: 0 !important;\n    border-radius: 100px !important;\n    min-width: 50px !important;\n    height: 50px !important;\n    width: 50px !important;\n    background-color: #d52941;\n}\n.card_profiles .student_details .sub_details_workExp figure img {\n    width: 45%;\n    height: auto;\n}\n.card_profiles .student_details .sub_details_workExp figure.bg_white {\n    background-color: #fff !important;\n    border: 1px solid #d2d2d2 !important;\n}\n.card_profiles .student_details .sub_details_workExp figure.bg_white img {\n    width: 80%;\n}\n.card_profiles .student_details .sub_details_workExp:after {\n    position: absolute;\n    width: 83%;\n    height: 1px;\n    content: '';\n    background: #c1c1c1;\n    bottom: 0;\n    right: 0; /* padding-bottom: 20px; */\n}\n.card_profiles .student_details .sub_details_workExp1:after {\n    display: none;\n}\n.card_profiles .student_details .sub_details h3 {\n    margin-bottom: 0;\n    min-width: 43px;\n    justify-content: center;\n}\n.card_profiles .student_details .sub_details figure {\n    border: 1px solid #d2d2d2;\n    border-radius: 100px;\n    min-width: 80px;\n    height: 80px;\n    overflow: hidden;\n    margin-right: 10px;\n    margin-bottom: 0;\n    width: 80px;\n    margin-top: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.card_profiles .student_details .sub_details p {\n    font-size: 18px;\n    font-weight: 500;\n    margin-bottom: 5px;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    max-height: 43px;\n    overflow: hidden;\n    line-height: 18px;\n}\n.card_profiles .student_details .sub_details a {\n    color: #000;\n    text-decoration: none;\n}\n.card_profiles .student_details .sub_details a:hover {\n    text-decoration: underline;\n    color: #1452ce;\n}\n.card_profiles .student_details .sub_details p.title,\n.card_profiles .student_details .sub_details p.green-title {\n    color: #5cae48;\n    font-size: 14px;\n    margin-bottom: 10px;\n}\n.card_profiles .student_details .sub_details span {\n    color: #333333;\n    font-size: 14px;\n    margin-bottom: 15px;\n    font-weight: 400;\n}\n.card_profiles .student_details .sub_details span.course {\n    color: #0b3454;\n    font-size: 16px;\n    font-weight: 400;\n    display: flex;\n    align-items: center;\n    margin-bottom: 0;\n}\n.card_profiles .student_details .sub_details span.course img {\n    margin-right: 6px;\n    width: 16px;\n}\n.card_profiles .action_btns {\n    margin-top: 20px;\n    border-top: 1px solid #d2d2d2;\n    padding-top: 20px;\n    display: flex;\n    justify-content: center !important;\n    width: 100%;\n}\n.card_profiles .action_btns .btn-outline-primary {\n    margin-right: 10px;\n    border: 2px solid #5bae47;\n    border-radius: 50px;\n    padding: 7px 20px;\n    color: #5bae47;\n}\n.card_profiles .action_btns .btn-outline-primary:hover img {\n    filter: brightness(0) invert(1);\n}\n.card_profiles .action_btns .btn-outline-primary:hover {\n    border: 2px solid #418d2e;\n    background-color: #418d2e;\n    color: #fff;\n}\n.card_profiles .action_btns .btn-secondary {\n    border-radius: 50px;\n    padding: 7px 20px;\n    color: #fff;\n    background: #0b3454;\n}\n.card_profiles .action_btns .btn-secondary:hover {\n    background: #26a7df;\n    border: 1px solid #26a7df;\n}\n.card_profiles .btn-send {\n    width: 123px;\n    height: 40px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    background: #5cae48;\n    border-radius: 25pc;\n    color: #fff;\n    text-decoration: none;\n    align-items: center;\n    padding: 0 25px;\n    font-size: 16px;\n    font-weight: 500;\n    transition: all 0.3s ease-in-out;\n}\n.card_profiles .btn-send {\n    color: #fff;\n    font-size: 16px;\n    font-weight: 500;\n    position: absolute;\n    top: 20px;\n    right: 20px;\n}\n.card_profiles .btn-send .icon-send {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/send_alumni_profile.svg) no-repeat 0\n        0 / 100%;\n    width: 19px;\n    height: 19px;\n    margin-right: 10px;\n    position: relative;\n    transition: all 0.3s ease-in-out;\n    left: 0;\n}\n.card_profiles .btn-send:hover .icon-send {\n    left: 3px;\n}\n.card_profiles .btn-send:hover {\n    background: #3b8d27;\n}\n.workExperience-detail {\n    box-shadow: 0px 10px 25px #00000008;\n    border-radius: 6px;\n    background: #fff;\n    padding: 40px;\n}\n.workExperience-detail .workExperience-title {\n    font-size: 22px;\n    font-weight: 400;\n    margin: -15px 0 30px;\n}\n.workExperience-detail .workExperience-title span {\n    font-weight: 600;\n}\n.work-block {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    align-items: center;\n    position: relative;\n}\n.work-block .work-detail {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n}\n.work-block .icon {\n    width: 55px;\n    height: 55px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 26px;\n    margin-right: 20px;\n    background: #d52941;\n    border-radius: 50%;\n    color: #fff;\n}\n.work-block .icon.workex-logo {\n    border-radius: 0;\n}\n.work-block .icon.workex-logo img {\n    max-width: 100%;\n    max-height: 100%;\n    width: auto;\n    height: auto;\n}\n.work-block .work-detail p {\n    font-size: 20px;\n    line-height: 24px;\n    margin: 0 0 5px;\n    font-weight: 500;\n}\n.work-block .work-detail span {\n    font-size: 16px;\n    color: #6d6b6b;\n    line-height: 16px;\n    font-weight: 500;\n}\n.achievements-block {\n    box-shadow: 0px 10px 25px #00000008;\n    border-radius: 6px;\n    background: #fff;\n    padding: 30px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-border-radius: 6px;\n    -moz-border-radius: 6px;\n    -ms-border-radius: 6px;\n    -o-border-radius: 6px;\n    position: relative;\n}\n.achievements-block:not(:last-child) {\n    border-bottom: 1px solid #f5f5f5;\n}\n.achievements-icon-block {\n    padding: 0 55px 0 30px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    min-width: 185px;\n    max-width: 185px;\n    align-items: center;\n    text-align: center;\n    border-right: 1px solid #cecece;\n    margin-right: 30px;\n}\n.achievements-icon-block .icon {\n    width: 60px;\n    height: 60px;\n    background: #0b3454;\n    border-radius: 50%;\n    margin-bottom: 8px;\n    position: relative;\n}\n.achievements-icon-block .icon.icon-medal:before {\n    content: '';\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/exam_ico.svg);\n    width: 26px;\n    height: 36px;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    top: 0;\n    margin: auto;\n}\n.achievements-icon-block .icon.icon-grade:before {\n    content: '';\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/exam_ico.svg);\n    width: 25px;\n    height: 31px;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    top: 0;\n    margin: auto;\n}\n.achievements-icon-block .icon.icon-publication:before {\n    content: '';\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/publication_ico.svg);\n    width: 29px;\n    height: 31px;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    top: 0;\n    margin: auto;\n}\n.achievements-icon-block .icon.icon-promotion:before {\n    content: '';\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/promotion_ico.svg);\n    width: 32px;\n    height: 37px;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    top: 0;\n    margin: auto;\n}\n.achievements-icon-block .icon.icon-course-completion:before {\n    content: '';\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/course_ico.svg);\n    width: 31px;\n    height: 37px;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    top: 0;\n    margin: auto;\n}\n.achievements-icon-block .icon.icon-social-service:before {\n    content: '';\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/social_ico.svg);\n    width: 36px;\n    height: 36px;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    top: 0;\n    margin: auto;\n}\n.achievements-icon-block .icon.icon-scholarship:before {\n    content: '';\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/scholarship_ico.svg);\n    width: 39px;\n    height: 28px;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    top: 0;\n    margin: auto;\n}\n.achievements-icon-block .icon.icon-others:before {\n    content: '';\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/others_ico.svg);\n    width: 32px;\n    height: 32px;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    top: 0;\n    margin: auto;\n}\n.achievements-icon-block .achievements-title {\n    font-size: 18px;\n    font-weight: 600;\n}\n.achievements-icon-block .achievements-year {\n    font-size: 18px;\n    line-height: 22px;\n    color: #414141;\n}\n.achievements-block-detail h3 {\n    font-size: 22px;\n    font-weight: 400;\n    margin-bottom: 0px;\n}\n.achievements-block-detail h3 span {\n    font-weight: 600;\n}\n.achievements-block-detail p {\n    font-size: 16px;\n    line-height: 24px;\n    margin: 0;\n}\n.achievements-block-detail {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    position: relative;\n}\n.hide {\n    display: none;\n}\n.achievements-block-detail p.show .hide {\n    display: inline;\n}\n.achievements-block-detail p.show .btn-readmore {\n    font-size: 0;\n}\n.achievements-block-detail p.show .btn-readmore:before {\n    content: 'Read Less';\n    font-size: 16px;\n}\n.achievements-block-detail p .btn-readmore {\n    color: #1452ce;\n    transition: all 0.3s ease-in-out;\n}\n.achievements-block-detail p .btn-readmore:hover {\n    color: #1046b3;\n}\n.achievements-block-detail .url-link {\n    color: #1452ce;\n    transition: all 0.3s ease-in-out;\n}\n.achievements-block-detail .url-link:hover {\n    color: #1046b3;\n}\n.achievements-list {\n    box-shadow: 0px 10px 25px #00000008;\n    border-radius: 6px;\n    background: #fff;\n}\n.achievements-block-title {\n    padding: 20px 40px;\n    border-bottom: 1px solid #f5f5f5;\n    border-radius: 6px 6px 0 0;\n}\n.achievements-block-title .title {\n    font-size: 22px;\n}\n.achievements-block-title .title span {\n    font-weight: 600;\n}\n.btn-add-section {\n    background: #ffffff;\n    border: 1px solid #0b3454;\n    border-radius: 19px;\n    height: 37px;\n    display: flex;\n    padding: 0 20px;\n    align-items: center;\n    text-decoration: none;\n    font-weight: 500;\n    font-size: 14px;\n    color: #0b3454;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.btn-add-section i {\n    position: relative;\n    width: 11px;\n    height: 110px;\n    margin-right: 10px;\n}\n.btn-add-section i:before {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    background: #0b3454;\n    width: 2px;\n    height: 10px;\n}\n.btn-add-section i:after {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    background: #0b3454;\n    width: 10px;\n    height: 2px;\n}\n.btn-add-section:hover {\n    background: #0b3454;\n    color: #fff;\n}\n.btn-add-section:hover i:before,\n.btn-add-section:hover i:after {\n    background: #fff;\n}\n.contributions-block {\n    box-shadow: 0px 10px 25px #00000008;\n    border-radius: 6px;\n    background: #fff;\n    padding: 40px;\n}\n.contributions-block:not(:last-child) {\n    margin-bottom: 20px;\n}\n.contributions-block .act_lst:not(:last-child) {\n    margin-bottom: 20px;\n}\n.contributions-block .seactionheader {\n    margin: -10px 0 20px;\n}\n.contributions-block h3 {\n    font-size: 22px;\n    font-weight: 600;\n}\n.contributions-block .circle-effect::before {\n    background: #6c8598;\n}\n.contributions-block .list_badge {\n    color: #d52941;\n    background: no-repeat;\n    position: static;\n    text-transform: uppercase;\n}\n.contributions-block .act_lst {\n    padding: 25px 25px 25px 25px;\n}\n.contributions-block .video_block_name label {\n    font-size: 16px;\n}\n.skills-block {\n    box-shadow: 0px 10px 25px #00000008;\n    border-radius: 6px;\n    background: #fff;\n    padding: 40px;\n    position: relative;\n}\n.skills-block:first-child {\n    padding-bottom: 20px;\n}\n.skills-block.EntranceExam-skills-block {\n    padding-bottom: 33px;\n}\n.skills-block:not(:last-child) {\n    margin-bottom: 20px;\n}\n.skills-block h2 {\n    font-size: 22px;\n    font-weight: 400;\n    margin-bottom: 15px;\n    margin: -10px 0 25px;\n}\n.skills-block h2 span {\n    font-weight: 600;\n}\n.skills-block-detail {\n    display: flex;\n    flex-wrap: wrap;\n}\n.skills-block-detail .meter {\n    margin: 0 12px 20px 0;\n    border: 1px solid #c7c7c7;\n    padding: 10px 30px;\n    border-radius: 50px;\n    font-size: 20px;\n    font-weight: 500;\n    align-items: center;\n}\n.skills-block-detail .meter img {\n    width: 50px;\n}\n.skills-block-title {\n    margin-top: -30px;\n    margin-bottom: 20px;\n}\n.preferences-block {\n    box-shadow: 0px 10px 25px #00000008;\n    border-radius: 6px;\n    background: #fff;\n    padding: 40px;\n}\n.preferences-block:not(:last-child) {\n    margin-bottom: 20px;\n}\n.preferences-block.EntranceExam-skills-block {\n    padding-bottom: 33px;\n}\n.preferences-block h2 {\n    font-size: 22px;\n    font-weight: 400;\n    margin-bottom: 15px;\n    margin: -10px 0 25px;\n}\n.preferences-block h2 span {\n    font-weight: 600;\n}\n.preferences-block-detail {\n    display: flex;\n    flex-wrap: wrap;\n}\n.preferences-block-detail .meter {\n    margin: 0 12px 20px 0;\n    border: 1px solid #c7c7c7;\n    padding: 10px 30px;\n    border-radius: 50px;\n    font-size: 20px;\n    font-weight: 500;\n    align-items: center;\n}\n.preferences-block-detail .meter img {\n    width: 50px;\n}\n.preferences-block-title {\n    margin-top: -30px;\n    margin-bottom: 20px;\n}\n.interested-block .icon {\n    width: 55px;\n    height: 55px;\n    border-radius: 50%;\n    background: #0b3454;\n    position: relative;\n    margin-right: 20px;\n}\n.interested-block .icon.icon-bulb::before {\n    content: '';\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/bulb.svg) no-repeat 0 0 / 34px auto;\n    width: 34px;\n    height: 36px;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    top: 0;\n    margin: auto;\n}\n.interested-block .icon.icon-note::before {\n    content: '';\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/publication_ico.svg);\n    width: 29px;\n    height: 31px;\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n}\n.interested-block {\n    display: flex;\n    align-items: center;\n}\n.interested-block .interested-topics {\n    font-size: 20px;\n    flex: 1;\n    line-height: 22px;\n}\n.interested-block .interested-topics span {\n    font-weight: 500;\n}\n.graduationslider .meter {\n    padding: 10px 30px;\n    display: inline-flex;\n    flex-wrap: wrap;\n    align-items: center;\n    border-radius: 50px;\n    font-size: 18px;\n    font-weight: 500;\n    margin-bottom: 10px;\n}\n.profile-item {\n    text-align: center;\n    width: 196px;\n    height: 210px;\n    display: flex;\n    flex-direction: column;\n    padding-top: 10px;\n}\n.owl-item:not(:last-child) .profile-item {\n    border-right: 1px solid #d2d2d2;\n}\n.profile-item-img {\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    margin-bottom: 11px;\n}\n.profile-item-name-class h3 {\n    font-size: 16px;\n    font-weight: 600;\n    margin: 0 0 4px;\n}\n.profile-item-name-class p {\n    margin: 0 0 11px;\n    font-size: 14px;\n    font-style: italic;\n    color: #535353;\n}\n.profile-item-name-class .subject {\n    color: #0b3454;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 20px;\n    position: relative;\n    padding-top: 10px;\n}\n.profile-item-name-class .subject:before {\n    content: '';\n    width: 30px;\n    height: 2px;\n    background: #5cae48;\n    position: absolute;\n    left: 0;\n    right: 0;\n    margin: auto;\n    top: 0;\n}\n.profile-item-name-class .btn-viewcompus {\n    font-size: 13px;\n    color: #1452ce;\n    font-weight: 500;\n    line-height: 18px;\n    position: relative;\n    z-index: 2;\n    text-decoration: none;\n}\n.profile-item-name-class .btn-viewcompus:hover {\n    color: #0b3454;\n    text-decoration: underline;\n}\n.psychology-item {\n    text-align: center;\n    width: 245px;\n    height: 196px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    padding-top: 10px;\n}\n.owl-item:not(:last-child) .psychology-item {\n    border-right: 1px solid #d2d2d2;\n}\n.popularCollegesslider .owl-item.active + .owl-item.active + .owl-item.active + .owl-item.active .psychology-item {\n    border-right: 0px solid #d2d2d2;\n}\n.psychology-item-img {\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    margin-bottom: 20px;\n    height: 90px;\n    align-items: center;\n}\n.psychology-item-name h3 {\n    font-size: 16px;\n    font-weight: 600;\n    margin: 0 0 5px;\n    line-height: 17px;\n}\n.psychology-item-name p {\n    font-size: 14px;\n    font-style: italic;\n    font-weight: 500;\n    line-height: 20px;\n}\n.alumni_directory_details .btn-working {\n    font-size: 13px;\n    color: #1452ce;\n    font-weight: 500;\n    line-height: 18px;\n    position: relative;\n    z-index: 2;\n    text-decoration: none;\n}\n.alumni_directory_details .btn-working:hover {\n    color: #0b3454;\n    text-decoration: underline;\n}\n.tooltip-viewcompus .tooltip-inner {\n    background: #3b3b3b;\n    border-color: #3b3b3b;\n}\n.tooltip-working .tooltip-inner {\n    display: flex;\n    flex-direction: column;\n    padding: 15px;\n    background: #3b3b3b;\n    border-color: #3b3b3b;\n}\n.tooltip-working .tooltip-inner .logo {\n    position: relative;\n    font-size: 20px;\n}\n.tooltip-working .tooltip-inner span.logo + span {\n    font-size: 16px;\n}\n.tooltip-working.bs-tooltip-top .tooltip-arrow::before {\n    border-top-color: #3b3b3b;\n}\n.tooltip-working.bs-tooltip-bottom .tooltip-arrow::before {\n    border-bottom-color: #3b3b3b;\n}\n.tooltip-working.bs-tooltip-end .tooltip-arrow::before {\n    border-right-color: #3b3b3b;\n}\n.tooltip-working.bs-tooltip-start .tooltip-arrow::before {\n    border-left-color: #3b3b3b;\n}\n.alumni_name_brife > div {\n    align-items: center;\n}\n.alumni_name_brife > div .sep {\n    margin: 0 6px;\n    color: #1452ce;\n}\n.custom_badge {\n    display: inline-block;\n    border: 1px solid #dedede;\n    height: 32px;\n    line-height: 32px;\n    padding: 0 16px;\n    border-radius: 18px;\n    font-size: 14px;\n    font-weight: 500;\n    color: #0b3454;\n    margin: 0 5px 10px 0;\n    background: #fff;\n    overflow: hidden;\n}\n.custom_badge .icon {\n    margin-right: 5px;\n}\n.delete_confirm .icon-cross {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    border: 1px solid red;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: #e94e58;\n}\n.delete_confirm .del_text {\n    margin: 20px 0 10px;\n    text-align: center;\n    max-width: 240px;\n    font-size: 28px;\n    line-height: 36px;\n    font-weight: 500;\n    width: 100%;\n}\n.delete_confirm .btn-delete {\n    background: #d52941;\n    border-radius: 31px;\n    border: 0;\n    height: 36px;\n    color: #fff;\n    padding: 0 20px;\n    font-weight: 600;\n    font-size: 14px;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.delete_confirm .btn-delete:hover {\n    background: #a0182b;\n}\n.selected_options ul {\n    display: flex;\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n.selected_options ul li {\n    background: #f7fbff;\n    border: 1px solid #0b34544d;\n    border-radius: 18px;\n    height: 35px;\n    display: flex;\n    align-items: center;\n    padding: 0 18px;\n    margin: 12px 12px 6px 0;\n    font-size: 16px;\n    font-weight: 500;\n}\n.selected_options ul li .icon-cross {\n    font-size: 9px;\n    margin: 2px 0 0 10px;\n    text-decoration: none;\n    color: #000;\n}\n.selected_options ul li .icon-cross:hover {\n    text-decoration: none;\n    color: #333;\n}\n.question .form-select.w-90 {\n    width: 90px !important;\n    max-width: 90px;\n}\n.custom_row_title {\n    margin-bottom: 10px;\n    font-weight: 400;\n    font-size: 20px;\n}\n.custom_row_title span {\n    font-weight: 600;\n}\n.custom_row_block .program {\n    font-size: 20px;\n}\n.custom_row_block .program span {\n    font-weight: 500;\n}\n.program-time-interest {\n    color: #414141;\n    font-size: 16px;\n    line-height: 20px;\n}\n.custom_row_block {\n    display: flex;\n    flex-wrap: wrap;\n    width: 100%;\n}\n.custom_row_block .icon {\n    width: 55px;\n    height: 55px;\n    border-radius: 50%;\n    background: #0b3454;\n    margin-right: 15px;\n    position: relative;\n}\n.custom_row_block .icon.icon-hat:before {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/hat_alumni.svg) no-repeat 0 0 /26px;\n    width: 26px;\n    height: 20px;\n    display: inline-block;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    position: absolute;\n    filter: invert(1);\n    -webkit-filter: invert(1);\n}\n.custom_row_block .icon + div {\n    width: calc(100% - 70px);\n}\n.custom_row {\n    width: 100%;\n    border-top: 1px solid #dbdbdb;\n    padding-top: 20px;\n}\n.custom_row:not(:last-child) {\n    padding-bottom: 20px;\n}\n.radius_block {\n    background: #ffffff;\n    border: 1px solid #c7c7c7;\n    border-radius: 30px;\n    height: 60px;\n    padding: 0 30px;\n    display: flex;\n    align-items: center;\n    font-size: 20px;\n    line-height: 20px;\n    font-weight: 500;\n}\n.radius_block span {\n    margin-right: 30px;\n}\n.radius_block i {\n    font-size: 24px;\n}\n.radius_block i.gray {\n    color: #8599a9;\n}\n.radius_block i.green {\n    color: #5dae48;\n    background-color: transparent !important;\n}\n.radius_block.yes {\n    background: #5dae48;\n    border-color: #5dae48;\n    color: #fff;\n}\n.radius_block.yes span {\n    margin: 0 20px;\n}\n.radius_block.no {\n    background: #c7c7c7;\n    color: #333;\n}\n.radius_block.no span {\n    margin: 0 20px;\n}\n.universities_block {\n    background: #ffffff;\n    border: 1px solid #c7c7c7;\n    border-radius: 30px;\n    height: 60px;\n    padding: 0 8px;\n    display: flex;\n    align-items: center;\n    font-size: 20px;\n    line-height: 26px;\n    font-weight: 500;\n    -webkit-border-radius: 30px;\n    -moz-border-radius: 30px;\n    -ms-border-radius: 30px;\n    -o-border-radius: 30px;\n}\n.universities_block .logo {\n    width: auto;\n    height: 40px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-right: 15px;\n    border-radius: 50%;\n    overflow: hidden;\n    -webkit-border-radius: 50%;\n    -moz-border-radius: 50%;\n    -ms-border-radius: 50%;\n    -o-border-radius: 50%;\n}\n.universities_block span {\n    font-size: 20px;\n    margin-right: 15px;\n    line-height: 20px;\n}\n.logo.no_logo {\n    width: 40px;\n    border: 1px solid #cad6df;\n}\n.edit_section {\n    font-size: 0;\n}\n.edit_section_toggle,\n.custom-btns a.edit_section_toggle {\n    display: none;\n    width: 20px;\n    height: 20px;\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='%23343a40' stroke='none' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z'/%3e%3c/svg%3e\");\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: 20px 20px;\n}\n\n@media (max-width: 1199px) {\n    .alumni_profile_college_name_other_detail_wrap {\n        padding: 0 0 0 50px;\n    }\n}\n\n@media (max-width: 1130px) {\n    .alumni_profile_brife_tab {\n        overflow: auto;\n        scrollbar-width: thin;\n        padding-bottom: 10px;\n        margin-bottom: 10px;\n    }\n    .alumni_profile_brife_tab::-webkit-scrollbar {\n        height: 4px;\n    }\n    .alumni_profile_brife_tab::-moz-scrollbar {\n        height: 4px;\n    }\n    .alumni_profile_brife_tab::-webkit-scrollbar-track {\n        background: #ccc;\n    }\n    .alumni_profile_brife_tab::-webkit-scrollbar-thumb {\n        background-color: #666;\n        border-radius: 20px;\n        border: 2px solid #666;\n    }\n    .alumni_profile_brife_tab .nav {\n        justify-content: start;\n        flex-wrap: nowrap;\n    }\n}\n\n@media (max-width: 1099px) {\n    .alumni_profile_college_name_other_detail_wrap {\n        padding: 0 0 0 30px;\n    }\n    .alumni_profile_image_name_other_detail {\n        padding: 0 30px;\n        width: 45%;\n    }\n    .alumni_profile_college_name_other_detail_wrap .alumni_profile_college_name_other_detail {\n        flex-direction: column;\n    }\n    .alumni_profile_college_name_detail {\n        padding: 0 0 21px;\n    }\n    .alumni_profile_status {\n        display: -webkit-box;\n        display: -moz-box;\n        display: -ms-flexbox;\n        display: -webkit-flex;\n        display: flex;\n        -webkit-box-wrap: wrap;\n        -moz-box-wrap: wrap;\n        -ms-flex-wrap: wrap;\n        -webkit-wrap: wrap;\n        flex-wrap: wrap;\n    }\n    .alumni_profile_status li {\n        margin-right: 16px;\n    }\n    .alumni_profile_name_other_detail h2 {\n        line-height: 30px;\n    }\n    .college_name_scholarship .college_name {\n        width: 100%;\n        margin-bottom: 10px;\n    }\n}\n@media (max-width: 1035px) {\n    .college_name_scholarship {\n        flex-direction: column;\n        align-items: start;\n    }\n    .graduateRow .college_detail_wrap .scholarship {\n        margin-top: 10px;\n    }\n    .graduateRow .offer {\n        justify-content: start;\n        padding-top: 13px;\n    }\n}\n\n@media (min-width: 992px) and (max-width: 1150px) {\n    .filter_result_title {\n        flex-direction: column;\n    }\n    .alumni_count {\n        text-align: right;\n    }\n    .alumni_class_link {\n        flex-direction: column;\n    }\n    .alumni_class_link .send_link {\n        padding: 10px 0 0 70px;\n    }\n}\n\n@media (max-width: 991px) {\n    .alumni-directorySearch {\n        width: 230px;\n    }\n    .alumni_profile_name_college_other_detail_wrap {\n        flex-direction: column;\n    }\n    .alumni_profile_image_name_other_detail {\n        width: 100%;\n        padding-bottom: 45px;\n        margin-bottom: 45px;\n    }\n    .alumni_profile_image_name_other_detail::after {\n        content: '';\n        width: 100%;\n        height: 1px;\n        background: #d4d4d4;\n        position: absolute;\n        right: auto;\n        top: auto;\n        bottom: 0;\n        left: 0;\n    }\n    .alumni_profile_college_name_other_detail_wrap {\n        padding: 0;\n    }\n    .alumni_profile_college_name_other_detail_wrap .alumni_profile_college_name_other_detail {\n        flex-direction: row;\n    }\n    .alumni_profile_brife_tab .nav-item:not(:last-child) {\n        margin-right: 7px;\n    }\n    .card_profiles {\n        overflow: visible;\n        max-height: initial;\n    }\n}\n\n@media (max-width: 950px) {\n    .showProfiles_left {\n        flex-direction: column;\n        align-items: start;\n        -webkit-box-flex: 1;\n        -moz-box-flex: 1;\n        -webkit-flex: 1;\n        -ms-flex: 1;\n        flex: 1;\n    }\n    .showProfiles_left h3 {\n        margin: 0 0 10px;\n    }\n}\n\n@media (max-width: 875px) {\n    .graduateRow {\n        flex-direction: column;\n    }\n    .graduateRow .college_detail_wrap {\n        width: 100%;\n    }\n    .graduateRow .offer {\n        width: 100%;\n    }\n    .college_name_scholarship {\n        flex-direction: row;\n        align-items: start;\n    }\n    .graduateRow .college_detail_wrap {\n        width: 100%;\n        padding: 0 0 20px;\n        margin-bottom: 20px;\n    }\n    .graduateRow .college_detail_wrap::after {\n        top: auto;\n        right: 0;\n        width: 75px;\n        height: 2px;\n        bottom: 0;\n    }\n    .graduateRow .offer {\n        padding: 0;\n        align-items: start;\n    }\n    .graduateRow .college_detail_wrap::after {\n        right: auto;\n        bottom: 0;\n        left: 0;\n    }\n    .graduateRow.edit .college_detail_wrap {\n        width: 100%;\n    }\n    .graduateRow .offer.offer_edit {\n        flex-direction: row;\n        align-items: center;\n        width: 100%;\n        justify-content: start;\n    }\n    .graduateRow .offer .offer_existing_links {\n        align-items: start;\n    }\n}\n\n@media (max-width: 820px) {\n    .graduation_carousel_wrap {\n        padding: 20px;\n    }\n    .graduationslider .meter {\n        padding: 10px 15px;\n        margin: 15px 0 10px 0px;\n        font-size: 16px;\n    }\n    .postGraduate-detail {\n        padding: 0;\n        background: none;\n        box-shadow: none;\n        border: 1px solid #d2d2d2;\n        overflow: hidden;\n    }\n    .postGraduate-detail .graduateRow {\n        padding: 20px;\n        background: #fff;\n    }\n    .graduation-title {\n        margin: 0;\n        background: #eff8ff;\n        border-radius: 6px 6px 0px 0px;\n        padding: 20px;\n        text-align: center;\n        line-height: 22px;\n    }\n    .graduation_carousel_wrap .seactionheader {\n        margin: 0 0 15px;\n        flex-direction: column;\n        align-items: inherit;\n    }\n    .graduation_carousel_wrap .seactionheader .countnbtn {\n        width: 100%;\n        margin-top: 13px;\n        justify-content: space-between;\n    }\n    .graduation_carousel_wrap .seactionheader h3 {\n        width: auto;\n        margin: -20px -20px 0;\n        background: #eff8ff;\n        border-radius: 6px 6px 0px 0px;\n        padding: 20px;\n        text-align: center;\n        line-height: 22px;\n    }\n    .workExperience-detail .workExperience-title {\n        width: auto;\n        margin: 0;\n        background: #eff8ff;\n        border-radius: 6px 6px 0px 0px;\n        padding: 20px;\n        text-align: center;\n        line-height: 22px;\n    }\n    .workExperience-detail {\n        padding: 0px;\n        overflow: hidden;\n    }\n    .workExperienceRow {\n        padding: 25px;\n    }\n    .skills-block-title {\n        margin: 0 0 20px;\n        width: auto;\n        margin: -40px -40px 20px;\n        background: #eff8ff;\n        border-radius: 6px 6px 0px 0px;\n        padding: 20px;\n        text-align: center;\n        line-height: 22px;\n    }\n    .skills-block-title h2 {\n        background: no-repeat;\n        padding: 0;\n        text-align: left;\n    }\n    .preferences-block {\n        padding: 30px;\n    }\n    .preferences-block-title {\n        width: auto;\n        margin: -30px -30px 0px;\n        background: #eff8ff;\n        border-radius: 6px 6px 0px 0px;\n        padding: 20px;\n        line-height: 22px;\n    }\n    .custom_row:first-child {\n        border: 0;\n    }\n    .achievements-block-title {\n        background: #eff8ff;\n    }\n    .underGraduate-detail .main_title,\n    .blockHeader {\n        background: #eff8ff;\n    }\n    .graduateRow {\n        background: #fff;\n    }\n    .postGraduate-detail .blockHeader {\n        margin: 0;\n    }\n    .workExperience-detail .blockHeader {\n        margin: 0;\n    }\n}\n\n@media (min-width: 767px) {\n    .nolisting_wrap .nolisting {\n        max-width: 850px;\n        margin: auto;\n        border: 0;\n        display: flex;\n        flex-wrap: wrap;\n        text-align: left;\n        padding-bottom: 10px;\n    }\n    .nolisting_text {\n        flex: 1;\n        display: flex;\n        flex-direction: column;\n        align-items: start;\n    }\n    .nolisting_icon {\n        margin-right: 40px;\n    }\n}\n\n@media (max-width: 767px) {\n    .alumni_directory_filter {\n        padding: 18px 0;\n        padding-right: var(--bs-gutter-x, 0.75rem);\n        padding-left: var(--bs-gutter-x, 0.75rem);\n    }\n    .alumni-directory-header_search {\n        flex-direction: column;\n        align-items: start;\n    }\n    .alumni-directory-header_search h2 {\n        margin-bottom: 15px !important;\n    }\n    .alumni-directory-header {\n        align-items: end;\n    }\n    .filter_result_title {\n        flex-direction: column;\n    }\n    .filter_result_title .filter_result {\n        display: none;\n    }\n    .alumni_count {\n        text-align: right;\n        margin: 0;\n    }\n    .alumni_directory_filter .fiterItem {\n        width: 170px;\n        margin: 0 !important;\n        box-shadow: none;\n        border: 0;\n        border-radius: 0;\n        border-bottom: 1px solid #e6e6e6 !important;\n        min-height: 45px;\n    }\n    .alumni_directory_filter .filters {\n        padding: 0;\n        display: flex !important;\n        flex-direction: column;\n    }\n    .alumni_directory_filter .filters > div:first-child {\n        padding: 15px 20px;\n        border-bottom: 1px solid #dbdbdb;\n    }\n    .alumni_directory_filter .filters-head {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        height: auto;\n        padding: 0 15px;\n        box-shadow: 0px 0px 3px 0px #ccc;\n        position: relative;\n        z-index: 1;\n    }\n    .alumni_directory_filter .filters-head + #accordionFilters {\n        flex: 1 1;\n        position: relative;\n        background: #f5f5f5;\n    }\n    .alumni_directory_filter .filters #accordionFilters {\n        -webkit-box-flex: 1;\n        -moz-box-flex: 1;\n        -webkit-flex: 1;\n        -ms-flex: 1;\n        flex: 1;\n        margin: 0;\n        position: relative;\n    }\n    .alumni_directory_filter .filters #accordionFilters::before {\n        content: '';\n        position: absolute;\n        left: 0;\n        top: 0;\n        bottom: 0;\n        margin: auto;\n        width: 170px;\n        background: #f5f5f5;\n    }\n    .alumni_directory_filter .filters > #accordionFilters > .filterGroup.mt-3 {\n        margin: 0 !important;\n        flex-direction: column;\n        height: 100%;\n        position: relative;\n    }\n    .alumni_directory_filter .fiterItem .filterHeader > div {\n        border-radius: 0;\n    }\n    .alumni_directory_filter .fiterItem .filterHeader > div button {\n        background: #f5f5f5;\n        border-radius: 0;\n        padding: 10px;\n        color: #000;\n    }\n    .alumni_directory_filter .fiterItem .filterHeader > div button .toggle {\n        display: none;\n    }\n    .alumni_directory_filter .fiterItem .filterHeader > div button .font-18.font-600 {\n        font-size: 16px !important;\n        font-weight: 500 !important;\n    }\n    .additionalfilter_wrap {\n        width: 170px;\n        padding: 0;\n        margin: 0 !important;\n    }\n    /* .btn-additionalfilter {display: none;} */\n    .additionalfilter_wrap > #additionalfilter {\n        display: block !important;\n    }\n    .alumni_directory_filter .fiterItem .filterHeader + div {\n        position: absolute;\n        right: 0;\n        top: 0;\n        padding: 0;\n        bottom: 0;\n        width: calc(100% - 170px);\n        padding: 15px;\n        overflow: auto;\n        background: #fff;\n    }\n    .alumni_directory_filter .filterGroup {\n        margin: 0 !important;\n    }\n    .alumni_directory_filter .filterGroup.mt-3 {\n        margin: 0 !important;\n        display: flex;\n        flex-direction: column;\n        height: 100%;\n    }\n    .filter_close_apply {\n        background: #ffffff;\n        border-top: 1px solid #e9e9e9;\n        padding: 15px 20px;\n        justify-content: center;\n        align-items: center;\n    }\n    .filter_close_apply > a.btn-filter-apply {\n        padding: 8px 30px;\n        background: #5cae48;\n        border-radius: 3px;\n        text-decoration: none;\n        color: #fff;\n        margin: 0 15px;\n        font-weight: 500;\n        text-transform: uppercase;\n        transition: all 0.3s ease-in-out;\n    }\n    .filter_close_apply > a.btn-filter-apply:hover {\n        background: #448e32;\n        color: #fff;\n    }\n    .filter_close_apply > a.btn-filter-close {\n        text-decoration: none;\n        text-transform: uppercase;\n        color: #979797;\n        font-weight: 500;\n        transition: all 0.3s ease-in-out;\n        margin: 0 15px;\n    }\n    .filter_close_apply > a.btn-filter-close:hover {\n        color: #666262;\n    }\n    .alumni_directory_filter .showProfiles_right {\n        margin-left: 12px;\n    }\n    .alumni_directory_filter .filterSearchblk {\n        background: #fff;\n        padding: 0 0 10px;\n    }\n    .alumni_directory_filter .fiterItem .card {\n        padding: 0px 0px 15px;\n    }\n    .alumni_directory_filter .fiterItem .filterHeader > div button[aria-expanded='true'] {\n        pointer-events: none;\n        color: #1452ce;\n    }\n    .alumni_directory_filter .scrollMe {\n        max-height: initial;\n        min-height: initial;\n    }\n    .additionalfilter_count {\n        display: block;\n        letter-spacing: 2px;\n    }\n    .additionalfilter_count:before {\n        content: '(';\n    }\n    .additionalfilter_count:after {\n        content: ')';\n    }\n    .alumni_directory_filter .mobileFilter .btn-filter .icon-filter + span {\n        -webkit-box-flex: 1;\n        -moz-box-flex: 1;\n        -webkit-flex: 1;\n        -ms-flex: 1;\n        flex: 1;\n        text-align: left;\n    }\n    .alumni_directory_filter .mobileFilter .btn-filter .icon-filter + span + span {\n        display: -webkit-box;\n        display: -moz-box;\n        display: -ms-flexbox;\n        display: -webkit-flex;\n        display: flex;\n        -webkit-box-wrap: wrap;\n        -moz-box-wrap: wrap;\n        -ms-flex-wrap: wrap;\n        -webkit-wrap: wrap;\n        flex-wrap: wrap;\n        align-items: center;\n        color: #b92940;\n        font-size: 14px;\n    }\n    .alumni_directory_filter .mobileFilter .btn-filter {\n        display: flex;\n        align-items: center;\n    }\n    .alumni_directory_filter .mobileFilter .btn-filter .icon-filter + span + span .icon-right-arrow {\n        font-size: 15px;\n        transform: rotate(270deg);\n        margin-left: 10px;\n        color: #000;\n        transition: all 0.3s ease-in-out;\n    }\n    .alumni_directory_filter .mobileFilter .btn-filter[aria-expanded='false'] .icon-right-arrow {\n        transform: rotate(90deg) !important;\n    }\n    #filter_collapse h3 {\n        pointer-events: none;\n    }\n    .alumni_directory_filter {\n        background: #f3f3f3;\n        position: fixed;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        z-index: 99;\n        box-shadow: 0 0 5px 0px #cacaca;\n    }\n    .alumni_directory_filter .filters.show {\n        -moz-transform: translate3d(0, 100%, 0);\n        -webkit-transform: translate3d(0, 100%, 0);\n        -o-transform: translate3d(0, 100%, 0);\n        -ms-transform: translate3d(0, 100%, 0);\n        transform: translate3d(0, 100%, 0);\n    }\n    .alumni_profile_image_name_other_detail {\n        width: 100%;\n        padding-bottom: 30px;\n        margin-bottom: 30px;\n    }\n    .alumni_profile_college_name_other_detail_wrap .alumni_profile_college_name_other_detail {\n        flex-direction: column;\n    }\n    .nolisting_wrap .nolisting {\n        border: 0;\n        padding: 20px 0 10px;\n    }\n    .nolisting_text {\n        text-align: center;\n        justify-content: center;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n    }\n    .edit_section {\n        position: absolute;\n        right: 20px;\n        top: 5px;\n    }\n    .countnbtn .edit_section {\n        position: relative;\n        left: auto;\n        right: auto;\n        top: 0;\n        margin-left: 5px;\n    }\n    .skills-block .edit_section {\n        top: 22px;\n    }\n    .edit_section .edit_section_toggle {\n        display: inline-block;\n    }\n    .custom-btns a.edit_section_toggle {\n        display: inline-block;\n    }\n    .edit_section .edit_section_inner {\n        position: absolute;\n        top: 50px;\n        right: 0;\n        background: #fff;\n        box-shadow: 0px 0px 5px #57555533;\n        display: flex;\n        flex-direction: column;\n        width: 100px;\n        border-radius: 6px;\n        overflow: hidden;\n        opacity: 0;\n        z-index: -1;\n        transition: all 0.3s ease-in-out;\n        -webkit-transition: all 0.3s ease-in-out;\n        -moz-transition: all 0.3s ease-in-out;\n        -ms-transition: all 0.3s ease-in-out;\n        -o-transition: all 0.3s ease-in-out;\n    }\n    .edit_section.open .edit_section_inner {\n        top: 30px;\n        opacity: 1;\n        z-index: 9;\n    }\n    .edit_section .edit_section_inner a {\n        width: 100% !important;\n        border-radius: 0 !important;\n        padding: 0 0 0 30px;\n        font-size: 14px;\n        text-decoration: none;\n        color: #000;\n        line-height: 33px;\n        height: 35px !important;\n        background: #fff !important;\n        position: relative;\n        opacity: 1;\n        margin: 0 !important;\n        -webkit-border-radius: 0 !important;\n        -moz-border-radius: 0 !important;\n        -ms-border-radius: 0 !important;\n        -o-border-radius: 0 !important;\n        opacity: 1 !important;\n    }\n    .edit_section .edit_section_inner a:hover {\n        color: #fff;\n        background-color: #0b3454 !important;\n    }\n    .edit_section .edit_section_inner a.edit_link:before {\n        width: 16px;\n        height: 16px;\n        margin: 0;\n        background-size: 14px;\n        left: 7px;\n        top: 8px;\n    }\n    .edit_section .edit_section_inner a:first-child {\n        border-bottom: 1px solid #eee;\n    }\n    .edit_section .edit_section_inner a.del_link:before {\n        content: '';\n        background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/delete.svg) no-repeat center /\n            14px auto;\n        width: 14px;\n        height: 16px;\n        position: absolute;\n        left: 8px;\n        top: 8px;\n    }\n    .edit_section .edit_section_inner a.del_link:hover {\n        background: #0b3454;\n        color: #fff;\n    }\n    .edit_section .edit_section_inner a.del_link:hover:before {\n        filter: invert(92%) sepia(100%) saturate(0%) hue-rotate(202deg) brightness(106%) contrast(106%);\n        -webkit-filter: invert(92%) sepia(100%) saturate(0%) hue-rotate(202deg) brightness(106%) contrast(106%);\n    }\n    .graduateRow .college_detail_wrap .scholarship {\n        margin-right: 60px;\n    }\n    .achievements-block-detail .edit_section {\n        top: 4px;\n        right: 0;\n    }\n    .achievements-block-detail {\n        padding-right: 25px;\n    }\n    .postGraduate-detail .graduateRow .offer.offer_edit .edit_section {\n        top: 20px;\n    }\n    .work-block .edit_section {\n        right: 0;\n    }\n    .work-block .work-detail {\n        padding-right: 24px;\n    }\n    .directory_wrap {\n        position: fixed;\n        width: 100%;\n        height: 100%;\n        top: 100%;\n        bottom: auto;\n        left: 0;\n        right: 0;\n        margin: auto;\n        background: white;\n        display: flex;\n        flex-direction: column;\n        transition: all 0.3s ease-in-out;\n        -webkit-transition: all 0.3s ease-in-out;\n        -moz-transition: all 0.3s ease-in-out;\n        -ms-transition: all 0.3s ease-in-out;\n        -o-transition: all 0.3s ease-in-out;\n    }\n    .directory_wrap.open {\n        top: 0;\n        bottom: 0;\n    }\n}\n\n@media (min-width: 575px) and (max-width: 767px) {\n    .filter_result_title {\n        flex-direction: column;\n    }\n    .alumni_count {\n        text-align: right;\n    }\n    .alumni_class_link {\n        flex-direction: column;\n    }\n    .alumni_class_link .send_link {\n        padding: 10px 0 0 70px;\n    }\n}\n\n@media (max-width: 575px) {\n    .alumni-directory-header {\n        flex-direction: column;\n    }\n    .alumni-directory-header_search {\n        flex-direction: row;\n        width: 100%;\n        margin-bottom: 20px;\n        justify-content: space-between;\n        overflow: hidden;\n        align-items: center;\n    }\n    .alumni-directory-header_search h2 {\n        margin-bottom: 0 !important;\n    }\n    .alumni-directorySearch-wrap {\n        position: relative;\n    }\n    .alumni-directorySearch-wrap .alumni-directorySearch {\n        position: absolute;\n        right: -230px;\n        transition: all 0.3s ease-in-out;\n    }\n    .alumni-directorySearch-wrap.show .alumni-directorySearch {\n        right: 0;\n    }\n    .btn-alumniSearchToggle.icon-search {\n        width: 40px;\n        height: 40px;\n        background: #fff;\n        border-radius: 50%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        text-decoration: none;\n        color: #000;\n        font-size: 12px;\n    }\n    .alumni-directorySearch .form-control + .btn-cross {\n        opacity: 1;\n        right: 15px;\n        transform: rotate(135deg);\n    }\n    .alumni-switch-container {\n        margin: auto;\n    }\n    .alumni-directorySearch .form-control {\n        padding-right: 40px;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        overflow: hidden;\n    }\n    .alumni_profile_image_name_other_detail {\n        padding: 0 0 20px;\n        margin-bottom: 20px;\n    }\n    .alumni_profile_college_name_other_detail .alumni_profile_other_detail {\n        margin: 0 0 0 -98px;\n    }\n    .alumni_profile_status li {\n        width: 47%;\n        margin-bottom: 0;\n    }\n    .alumni_profile_status li:last-child {\n        margin-right: 0;\n    }\n    .alumni_profile_image {\n        width: 80px;\n        height: 80px;\n    }\n    .alumni_profile_name_other_detail h2 {\n        line-height: 30px;\n        font-size: 24px;\n    }\n    .alumni_profile_college_name_other_detail_wrap .alumni_profile_college_logo {\n        width: 80px;\n        height: 80px;\n    }\n    .alumni_profile_brife {\n        padding: 20px 0 10px;\n    }\n    /*.graduateRow .college_detail_wrap .college_detail {  flex-direction: column;align-items: center;}*/\n    .graduateRow .college_detail_wrap .college_detail {\n        padding-right: 25px;\n    }\n    .graduateRow {\n        margin-left: -20px;\n        margin-right: -20px;\n        width: auto;\n        padding: 5px 20px;\n    }\n    .graduateRow .college_detail_wrap .college_detail .college_logo {\n        margin: 0 10px 10px 0;\n        width: 70px;\n        height: 70px;\n        border-radius: 50%;\n    }\n    .graduateRow .college_name_scholarship {\n        flex-direction: column;\n        align-items: start;\n        justify-content: start;\n        text-align: left;\n        width: calc(100% - 80px);\n    }\n    .graduateRow .college_detail_wrap .college_detail h3 {\n        font-size: 19px;\n        line-height: 20px;\n    }\n    .alumni_profile_college_subject {\n        padding: 0 15px;\n        font-size: 15px;\n    }\n    .graduateRow .college_detail_wrap .scholarship {\n        flex-direction: row;\n    }\n    .graduateRow .college_detail_wrap .scholarship .scholarship_label {\n        margin-right: 7px;\n    }\n    .graduateRow .college_detail_wrap::after {\n        right: 0;\n        bottom: 0;\n        left: 0;\n        margin: auto;\n        width: 100%;\n        height: 1px;\n    }\n    .graduateRow .offer {\n        align-items: center;\n        flex-direction: row;\n        justify-content: center;\n    }\n    .graduateRow:not(:last-child) {\n        margin-bottom: 15px;\n        padding-bottom: 20px;\n    }\n    .underGraduate-detail {\n        padding: 20px;\n        box-shadow: none;\n    }\n    .workExperience-detail {\n        padding: 0px;\n    }\n    .workExperienceRow {\n        padding: 20px 20px 30px;\n    }\n    .achievements-block {\n        flex-direction: column;\n    }\n    .achievements-icon-block {\n        border-right: 0;\n        margin: 0 0 18px;\n        padding: 0 0 18px;\n        border-bottom: 1px solid #cecece;\n    }\n    .achievements-block-detail {\n        text-align: center;\n    }\n    .achievements-block-detail h3 {\n        margin: 0;\n    }\n    .contributions-block .seactionheader {\n        margin: 0px 0 20px;\n        flex-direction: column;\n        align-items: inherit;\n    }\n    .contributions-block .seactionheader > h3 {\n        width: auto;\n        margin: -20px -20px 0;\n        background: #eff8ff;\n        border-radius: 6px 6px 0px 0px;\n        padding: 20px;\n        text-align: center;\n        line-height: 22px;\n    }\n    .contributions-block .seactionheader .countnbtn {\n        width: 100%;\n        margin-top: 10px;\n        align-items: center;\n        justify-content: space-between;\n        position: relative;\n    }\n    .contributions-block .seactionheader .countnbtn .custom-btns {\n        padding-right: 0;\n    }\n    .contributions-block .seactionheader .countnbtn .custom-btns .edit_section {\n        right: 0;\n        top: 0px;\n    }\n    .contributions-block {\n        padding: 20px;\n    }\n    .skills-block {\n        padding: 20px;\n    }\n    .skills-block:first-child {\n        padding-bottom: 5px;\n    }\n    .skills-block.EntranceExam-skills-block {\n        padding-bottom: 25px;\n    }\n    .skills-block h2 {\n        margin: 0 0 20px;\n        width: auto;\n        margin: -20px -20px 20px;\n        background: #eff8ff;\n        border-radius: 6px 6px 0px 0px;\n        padding: 20px;\n        text-align: center;\n        line-height: 22px;\n    }\n    .skills-block-detail .meter {\n        font-size: 18px;\n        align-items: center;\n        padding: 10px 20px;\n        line-height: 18px;\n    }\n    .card_profiles figure.student {\n        position: absolute;\n        left: 15px;\n        top: 15px;\n    }\n    .card_profiles .student_details h2 {\n        margin: 0 0 10px 90px;\n    }\n    .card_profiles .btn-send {\n        position: static;\n        margin-left: 90px;\n    }\n    .card_profiles .student_details .sub_details {\n        margin-top: 15px;\n    }\n    .card_profiles .student_details .sub_details span.course {\n        line-height: 15px;\n    }\n    .contributions-block .act_lst {\n        padding: 15px;\n    }\n    .contributions-block .act_lst .postedtxt {\n        text-align: left;\n        position: absolute;\n        top: 15px;\n        white-space: nowrap;\n        right: 15px;\n    }\n    .graduateRow .offer > a {\n        margin: 0 10px 0 0;\n    }\n    .graduateRow .offer div.got_offer {\n        margin-right: 15px;\n        width: calc(100% - 173px);\n        align-items: center;\n        display: flex;\n        margin-bottom: 0 !important;\n        text-align: left;\n        flex: 1;\n        justify-content: center;\n        line-height: 18px;\n    }\n    .graduateRow .offer .offer_joined {\n        align-items: start;\n        width: 158px;\n        align-items: center;\n        display: flex;\n        margin-bottom: 0 !important;\n        line-height: 16px;\n    }\n    .graduateRow .offer .offer_joined i {\n        margin-right: 8px;\n    }\n    .contributions-block .act_lst > .row > div:last-child .btn-green {\n        width: 135px;\n    }\n    .contributions-block .act_lst .btn-dark-blue {\n        width: 135px;\n    }\n    .contributions-block .listblk_icon {\n        margin-bottom: 0;\n        width: 34px;\n        height: 34px;\n    }\n    .contributions-block .act_lst .postedrow > div:last-child {\n        width: 100% !important;\n        display: flex;\n        flex-direction: row-reverse;\n        align-items: center;\n        border-top: 1px solid #d1d1d1;\n        padding-top: 10px;\n        margin-top: 8px;\n    }\n    .act_lst > .row.postedrow > div:last-child > div:first-child {\n        width: calc(100% - 190px);\n        margin: 0 0 0 15px;\n        align-items: center;\n    }\n    .alumni_class_link {\n        align-items: center;\n    }\n    .filter_result_title {\n        margin-bottom: 12px;\n    }\n    .contributions-block .album_shareblk {\n        padding: 5px 0 0 0px;\n    }\n    .profile-item,\n    .psychology-item {\n        width: 100%;\n        border: 0 !important;\n    }\n    /*.user_id {\tbottom: 0;}*/\n    .skills-block-title {\n        margin: 0 0 20px;\n        width: auto;\n        margin: -20px -20px 20px;\n        background: #eff8ff;\n        border-radius: 6px 6px 0px 0px;\n        padding: 20px;\n        text-align: center;\n        line-height: 22px;\n    }\n    .skills-block-title h2 {\n        padding: 0;\n        text-align: left;\n    }\n    #edit_Higher_Education .question {\n        padding-right: 20px;\n    }\n    #job_Preferences .question {\n        padding-right: 20px;\n    }\n    .underGraduate-detail .main_title,\n    .blockHeader {\n        margin: -20px -20px 30px;\n        padding: 20px;\n    }\n    .graduateRow .offer .offer_existing_links {\n        width: 100%;\n        flex-direction: row;\n        align-items: center;\n        justify-content: center;\n    }\n    .graduateRow .offer .got_offer {\n        margin-right: 10px;\n    }\n    .graduateRow .offer a.joindeLink {\n        margin: 0 10px 0 0;\n    }\n    .powerby {\n        margin: auto;\n    }\n    .graduateRow .offer.offer_edit .edit_section {\n        top: 10px;\n    }\n    .postGraduate-detail .graduateRow {\n        margin: 0;\n    }\n    .alumni_profile_college_name_detail {\n        width: 100%;\n    }\n}\n\n@media (max-width: 480px) {\n    .card_profiles.card_profiles_pg > div {\n        flex-direction: column;\n        display: flex;\n    }\n}\n\n@media (max-width: 400px) {\n    .graduateRow .offer.offer_edit {\n        flex-direction: column;\n        align-items: start;\n    }\n    .graduateRow .offer.offer_edit .edit_section {\n        margin: 0;\n    }\n}\n\ninput[type='search']::-webkit-search-decoration,\ninput[type='search']::-webkit-search-cancel-button,\ninput[type='search']::-webkit-search-results-button,\ninput[type='search']::-webkit-search-results-decoration {\n    -webkit-appearance: none;\n}\nheader + .relevantAlumniMatch {\n    display: none;\n}\n.relevantAlumniMatch {\n    background: transparent linear-gradient(93deg, #fff7f8 0%, #ffe6ea 100%);\n    box-shadow: 0px 10px 20px #ffebee;\n    border: 1px solid #fdd3da;\n    border-radius: 8px;\n    padding: 15px 20px;\n    margin-bottom: 20px;\n    position: relative;\n}\n.relevantAlumniMatch p {\n    font-size: 20px;\n    margin: 0;\n    font-weight: 500;\n    line-height: 22px;\n}\n.relevantAlumniMatch .btn-complete-now {\n    border: 1px solid #d42941;\n    border-radius: 25px;\n    width: 160px;\n    height: 40px;\n    background: #fff;\n    color: #000;\n    font-size: 16px;\n    line-height: 16px;\n    font-weight: 500;\n    margin-right: 23px;\n    transition: all 0.3s ease-in-out;\n}\n.relevantAlumniMatch .btn-complete-now:before {\n    display: none;\n}\n.relevantAlumniMatch .btn-complete-now:hover {\n    background: #d42941;\n    color: #fff;\n}\n.relevantAlumniMatch .btn-close {\n    font-size: 10px;\n}\n\n@media (max-width: 767px) {\n    .relevantAlumniMatch .btn-close {\n        font-size: 10px;\n        position: absolute;\n        top: 13px;\n        right: 10px;\n    }\n}\n.pencil-edit {\n    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/draw.svg);\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: 17px;\n    width: 17px;\n    height: 17px;\n    display: inline-block;\n}\n.alumni_profile_image_name_other_detail .pencil-edit {\n    position: absolute;\n    right: 30px;\n    top: 10px;\n}\n.verifynow {\n    border: 2px solid #d52941;\n    padding: 2px 14px;\n    border-radius: 25px;\n    text-decoration: none;\n    font-size: 14px;\n    font-weight: 500;\n    transition: all 0.3s ease-in-out;\n    height: 30px;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    -webkit-border-radius: 25px;\n    -moz-border-radius: 25px;\n    -ms-border-radius: 25px;\n    -o-border-radius: 25px;\n}\n.verifynow:hover {\n    background: #d52941;\n    color: #fff;\n}\n.alumni_profile_image_name_other_detail .btnverified {\n    background: #5cae48;\n    border: 0;\n    padding: 0 22px;\n    width: auto;\n    font-size: 14px;\n}\n.alumni_profile_image_name_other_detail .btnverified:hover {\n    background: #439130;\n    color: #fff;\n}\n.alumni_profile_image_name_other_detail .btnverified:hover .icon-varified {\n    color: #fff !important;\n}\n.btn-back-dismiss {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='%23343a40' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='0.2' d='M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z'/%3e%3c/svg%3e\");\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: 50px 32px;\n    width: 20px;\n    height: 15px;\n    margin: 5px 5px 0 0px;\n}\n#delete_confirm_pop {\n    z-index: 9999;\n}\n.modal.show ~ .modal.show ~ .modal-backdrop {\n    z-index: 9998;\n    opacity: 0.7;\n}\n.headerRightSide > ul li .user_id {\n    position: static;\n    border-radius: 5px 5px 0 0;\n    width: 100%;\n    padding: 7px 15px;\n    text-align: right;\n    background: #eee;\n    color: #000;\n}\n.username:hover div.user-dropdown::before {\n    width: 0;\n    height: 0;\n    content: '';\n    position: absolute;\n    top: -5px;\n    right: 10px;\n    border-left: 5px solid transparent;\n    border-right: 5px solid transparent;\n    border-bottom: 5px solid #d2d2d2;\n}\n/* New css */\n.modal-dialog .modal-content .modal-header .btn-close {\n    background-color: none;\n    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/close.svg);\n    width: 15px;\n    padding: 0;\n    font-size: 12px;\n    margin-right: 10px;\n    color: #000000;\n    opacity: 2;\n}\n.modal-dialog .modal-content .modal-header .btn-close::before {\n    display: none;\n}\n.icon-plus {\n    position: relative;\n    width: 20px;\n    height: 20px;\n}\n.icon-plus::before,\n.icon-plus::after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    top: 0;\n    left: 0;\n    right: 0;\n    margin: auto;\n    width: 2px;\n    height: 10px;\n    background: #fff;\n}\n.icon-plus::after {\n    transform: rotate(90deg);\n}\n.icon-medal {\n    width: 16px;\n    height: 16px;\n    display: inline-block;\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3e%3cpath fill='%23343a40' stroke='' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M223.7 130.8L149.1 7.77C147.1 2.949 141.9 0 136.3 0H16.03c-12.95 0-20.53 14.58-13.1 25.18l111.3 158.9C143.9 156.4 181.7 137.3 223.7 130.8zM256 160c-97.25 0-176 78.75-176 176S158.8 512 256 512s176-78.75 176-176S353.3 160 256 160zM348.5 317.3l-37.88 37l8.875 52.25c1.625 9.25-8.25 16.5-16.63 12l-46.88-24.62L209.1 418.5c-8.375 4.5-18.25-2.75-16.63-12l8.875-52.25l-37.88-37C156.6 310.6 160.5 299 169.9 297.6l52.38-7.625L245.7 242.5c2-4.25 6.125-6.375 10.25-6.375S264.2 238.3 266.2 242.5l23.5 47.5l52.38 7.625C351.6 299 355.4 310.6 348.5 317.3zM495.1 0H375.7c-5.621 0-10.83 2.949-13.72 7.77l-73.76 122.1c42 6.5 79.88 25.62 109.5 53.38l111.3-158.9C516.5 14.58 508.9 0 495.1 0z'/%3e%3c/svg%3e\");\n    background-size: cover;\n}\n.icon-dollor {\n    width: 20px;\n    height: 20px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/dollor.svg) no-repeat 0 0 / 100%;\n    display: inline-block;\n}\n.icon-note {\n    width: 16px;\n    height: 20px;\n    display: inline-block;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/document.svg) no-repeat 0 0 / 100%;\n}\n.top20 {\n    top: 20px;\n}\n.top40 {\n    top: 40px;\n}\n.right20 {\n    right: 20px;\n}\n.z1 {\n    z-index: 1;\n}\n.z2 {\n    z-index: 2;\n}\n.z3 {\n    z-index: 3;\n}\n.z4 {\n    z-index: 4;\n}\n.z5 {\n    z-index: 5;\n}\n.z6 {\n    z-index: 6;\n}\n.z7 {\n    z-index: 7;\n}\n.z8 {\n    z-index: 8;\n}\n.z9 {\n    z-index: 9;\n}\n.radius-25 {\n    border-radius: 25px;\n    -webkit-border-radius: 25px;\n    -moz-border-radius: 25px;\n    -ms-border-radius: 25px;\n    -o-border-radius: 25px;\n}\n.radius-20 {\n    border-radius: 20px;\n    -webkit-border-radius: 20px;\n    -moz-border-radius: 20px;\n    -ms-border-radius: 20px;\n    -o-border-radius: 20px;\n}\n.radius-15 {\n    border-radius: 15px;\n    -webkit-border-radius: 15px;\n    -moz-border-radius: 15px;\n    -ms-border-radius: 15px;\n    -o-border-radius: 15px;\n}\n.radius-10 {\n    border-radius: 10px;\n    -webkit-border-radius: 10px;\n    -moz-border-radius: 10px;\n    -ms-border-radius: 10px;\n    -o-border-radius: 10px;\n}\n.radius-5 {\n    border-radius: 5px;\n    -webkit-border-radius: 5px;\n    -moz-border-radius: 5px;\n    -ms-border-radius: 5px;\n    -o-border-radius: 5px;\n}\n.skill-range .progress {\n    height: 20px;\n    max-width: 800px;\n    width: 90%;\n    border-radius: 25px;\n}\n.skill-range .progress .progress-bar {\n    border-radius: 25px;\n}\n.green {\n    background: #5cae48 !important;\n}\n#skillvideoslider {\n    padding: 0 30px;\n}\n.owl-theme#skillvideoslider .owl-nav [class*='owl-'] {\n    position: absolute;\n    top: 37%;\n    width: 10px;\n    height: 10px;\n    border-top: 2px solid #000;\n    border-right: 2px solid #000;\n    border-radius: 0;\n    transform: rotate(45deg);\n    font-size: 0;\n}\n.owl-theme#skillvideoslider .owl-nav [class*='owl-']:hover {\n    background-color: transparent;\n}\n.owl-theme#skillvideoslider .owl-nav .owl-prev {\n    left: 0;\n    transform: scaleX(-1) rotate(45deg);\n}\n.owl-theme#skillvideoslider .owl-nav .owl-next {\n    right: 0;\n}\n.owl-theme#skillvideoslider .owl-dots .owl-dot span {\n    width: 16px;\n    height: 16px;\n    background: #fff;\n    border: 1px solid #c2c2c2;\n    margin: 0px 5px;\n}\n.owl-theme#skillvideoslider .owl-dots .owl-dot.active span,\n.owl-theme#skillvideoslider .owl-dots .owl-dot:hover span {\n    background: #fff;\n    border: 0;\n    box-shadow: 0 0 0 5px #0b3454 inset;\n}\n.small-line {\n    position: relative;\n}\n.small-line:before {\n    position: absolute;\n    content: '';\n    width: 40px;\n    height: 2px;\n    background: #2680eb 0% 0% no-repeat padding-box;\n    border-radius: 100px;\n    border-radius: 100px;\n    bottom: -5px;\n}\n.benefitsBox {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n}\n.benefitsBox li {\n    width: 49%;\n    border-radius: 10px;\n    opacity: 1;\n    min-height: 80px;\n    margin-bottom: 10px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    font-size: 16px;\n    font-weight: 500;\n    padding: 15px 30px;\n}\n.beige {\n    background: #f6ebdf;\n}\n.lightGreen {\n    background: #daf3e5;\n}\n.lime {\n    background: #e4f7cd;\n}\n.lightsky {\n    background: #d3f1f7;\n}\nul.green-right {\n    list-style: none;\n    margin: 0 0 20px;\n    padding: 0;\n}\nul.green-right li {\n    position: relative;\n    padding-left: 30px;\n    font-size: 16px;\n    margin: 0 0 18px;\n    font-family: 'Jost', sans-serif;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    justify-content: space-between;\n}\nul.green-correct li:last-child {\n    margin: 0;\n}\nul.green-right li .rupee {\n    line-height: 22px;\n}\nul.green-right li::before {\n    content: '';\n    width: 18px;\n    height: 16px;\n    display: inline-block;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/15-checked.svg);\n    position: absolute;\n    left: 0px;\n    top: 3px;\n}\n.btn-play {\n    bottom: 20px;\n    left: 20px;\n    background: #fff;\n    border-radius: 25px;\n    width: 120px;\n    height: 40px;\n    padding: 8px;\n    display: flex;\n    align-items: center;\n    z-index: 2;\n    transition: all 0.3s ease-in-out;\n    font-size: 16px;\n    text-transform: uppercase;\n    color: #000;\n}\n.btn-play .play-icon {\n    width: 24px;\n    height: 24px;\n    position: relative;\n    left: auto;\n    right: auto;\n    bottom: auto;\n    top: auto;\n    margin: auto;\n    background: #000;\n    display: inline-block;\n    margin: 0 8px 0 0;\n}\n.btn-play .play-icon:after {\n    border-left: 6px solid #fff;\n    border-top: 5px solid transparent;\n    border-bottom: 5px solid transparent;\n    left: 10px;\n    right: auto;\n}\n.video-btn:hover .btn-play {\n    background: #5cae48;\n    color: #fff;\n}\n.video-btn:hover .btn-play .play-icon {\n    background: #fff;\n}\n.video-btn:hover .btn-play .play-icon:after {\n    border-left: 6px solid #5cae48;\n}\n.play-icon {\n    left: 0;\n    right: 0;\n    bottom: 0;\n    top: 0;\n    margin: auto;\n    width: 40px;\n    height: 40px;\n    background: rgba(0, 0, 0, 0.5);\n    border-radius: 50%;\n    z-index: 2;\n}\n.play-icon::after {\n    content: '';\n    width: 0;\n    height: 0;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    border-top: 7px solid transparent;\n    border-bottom: 7px solid transparent;\n    border-left: 10px solid #fff;\n    margin: auto;\n}\n.video-btn:hover img {\n    transform: scale(1.1);\n    transition: all 0.3s ease-in-out;\n}\n.video-btn:hover img {\n    transform: scale(1.1);\n    transition: all 0.3s ease-in-out;\n}\n.imgplace .video-btn:hover img {\n    transform: scale(1.1);\n    transition: all 0.3s ease-in-out;\n}\n.btn-submit {\n    max-width: 200px;\n    height: 45px;\n    width: 100%;\n    border: 0;\n    border-radius: 25px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 16px;\n    font-weight: 500;\n    background: #5cae48;\n    color: #fff;\n    transition: all 0.5s ease-in-out;\n    -webkit-transition: all 0.5s ease-in-out;\n    -moz-transition: all 0.5s ease-in-out;\n    -ms-transition: all 0.5s ease-in-out;\n    -o-transition: all 0.5s ease-in-out;\n    -webkit-border-radius: 25px;\n    -moz-border-radius: 25px;\n    -ms-border-radius: 25px;\n    -o-border-radius: 25px;\n    text-decoration: none;\n}\n.btn-submit:hover {\n    background: #88bb1b;\n    color: #fff;\n    border-color: #88bb1b;\n}\n.info {\n    background: #edf6fb;\n    width: 48px;\n    height: 48px;\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-right: 15px;\n    font-family: sans;\n    font-size: 30px;\n    font-weight: 600;\n    color: rgba(11, 52, 84, 0.8);\n}\n.rightcustomborder {\n    padding: 0 30px 0 0;\n    border-right: 1px solid #e3e3e3;\n}\n.s_no label {\n    width: 32px;\n    height: 32px;\n    background: #0b3454;\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: #fff;\n}\n.s_no label {\n    width: 32px;\n    height: 32px;\n    background: #0b3454;\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: #fff;\n}\n.skillBlock .form-check-input[type='radio'] + label {\n    background: #ffffff 0% 0% no-repeat padding-box;\n    border: 1px solid #0b345440;\n    border-radius: 6px;\n    opacity: 1;\n    padding: 10px;\n    height: 100%;\n    width: 100%;\n    cursor: pointer;\n    text-align: center;\n    -webkit-border-radius: 6px;\n    -moz-border-radius: 6px;\n    -ms-border-radius: 6px;\n    -o-border-radius: 6px;\n}\n.skillBlock .form-check-input[type='radio']:checked + label {\n    background: #0b3454;\n    border: 1px solid #0b3454 !important;\n    color: #fff;\n}\n/* alumni_statistics starts */\n.alumni_statistics .filters {\n    position: static;\n    padding-top: 0;\n    padding-bottom: 0;\n}\n.alumni_statistics .filters .additionalfilters {\n    font-size: 14px;\n    text-transform: uppercase;\n    text-decoration: underline;\n    color: #26a7df;\n    font-weight: 500;\n}\n.alumni_statistics .filters .apply_filters {\n    font-size: 20px;\n    font-weight: 600;\n    text-transform: uppercase;\n    background-color: #5bae47;\n    border: 0;\n    border-radius: 100px;\n    padding: 10px 40px;\n    width: 170px;\n}\n.alumni_statistics .filters .apply_filters:hover {\n    background-color: #198754;\n}\n.alumni_statistics .filters .additionalfilters:hover {\n    color: #5bae47;\n}\n.alumni_statistics .filters .form-search {\n    background: url('https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/search.svg') no-repeat 15px;\n    padding-left: 40px !important;\n    background-size: 16px;\n    max-width: 100%;\n}\n.alumni_statistics .filters .accordion-button {\n    background: none;\n    box-shadow: none;\n    font-size: 24px;\n    font-weight: 500;\n    color: #000;\n    padding: 25px;\n    border-bottom: 1px solid #e6eaed;\n}\n.alumni_statistics .filters .accordion-item:last-of-type .accordion-button.collapsed {\n    border-bottom: 0;\n}\n.alumni_statistics .filters .text-bg-primary {\n    width: 40px;\n    height: 40px;\n    font-size: 16px;\n    display: flex;\n    align-items: center;\n    background-color: #0b3454 !important;\n    position: absolute;\n    padding: 0;\n    margin: 0;\n    justify-content: center;\n    font-weight: 400;\n    right: 70px;\n    top: 20px;\n}\n.alumni_statistics .filters .accordion-button img {\n    margin-right: 10px;\n}\n.alumni_statistics .filters .accordion-body {\n    padding: 30px;\n}\n.alumni_statistics .selected_filters {\n    margin-bottom: 20px;\n}\n.alumni_statistics .selected_filters p {\n    background-color: #e9f6fc !important;\n    padding: 10px 15px;\n    display: flex;\n    align-items: center;\n    font-weight: 400;\n    font-size: 14px;\n    margin-right: 10px;\n    margin-bottom: 0;\n    color: #000;\n}\n.alumni_statistics .selected_filters .clearfilters {\n    color: #d42941;\n    text-transform: uppercase;\n    font-weight: 500;\n    font-size: 14px;\n    padding: 6px;\n}\n.alumni_statistics .selected_filters .clearfilters:hover {\n    text-decoration: none;\n}\n.alumni_statistics .selected_filters p a {\n    margin-left: 15px;\n}\n.alumni_statistics .selected_filters p a img {\n    margin-top: -3px;\n    width: 9px;\n}\n.alumni_statistics .filters .form-control,\n.alumni_statistics .filters .form-select {\n    min-height: 50px;\n    padding: 0 20px;\n    border-radius: 5px;\n    line-height: 48px; /* display: flex; */ /* align-items: center; */\n}\n.accordion-body .form-control:focus {\n    box-shadow: 0px 0px 20px #00000033;\n}\n.accordion-body .form-select:focus {\n    box-shadow: 0px 0px 20px #00000033;\n}\n.alumni_statistics .filters .form-check {\n    margin-bottom: 0;\n    display: flex;\n    align-items: center;\n}\n.alumni_statistics .filters .form-check-label {\n    padding-top: 5px;\n}\n.alumni_statistics .filters .form-check-input {\n    width: 20px;\n    height: 20px;\n    margin-right: 10px;\n}\n.form-check-input:checked {\n    background-color: #0b3454;\n    border-color: #0b3454;\n}\n.alumni_statistics .card_custom .alumni_presence {\n    padding: 0 30px 40px;\n}\n.alumni_statistics .card_custom .card-header {\n    background: transparent;\n    border-bottom: none;\n    font-size: 22px;\n    text-transform: uppercase;\n    font-weight: 600;\n    padding: 30px 30px;\n}\n.alumni_statistics .card_custom .card-header select {\n    border-radius: 200px;\n    height: 40px;\n    border: 1px solid #8499a9;\n    font-weight: 500;\n    font-size: 16px;\n    width: auto;\n    max-width: 180px;\n    padding-left: 15px;\n    -webkit-border-radius: 200px;\n    -moz-border-radius: 200px;\n    -ms-border-radius: 200px;\n    -o-border-radius: 200px;\n}\n.alumni_statistics .card_custom .top-countries,\n.alumni_statistics .card_custom .top-careers {\n    min-height: 415px;\n}\n.alumni_statistics .card_custom .card-header p span img {\n    margin-top: -7px !important;\n}\n/* Top Countries */\n.alumni_statistics .top-countries .progress {\n    height: 40px;\n    background-color: rgba(0, 0, 0, 0.06);\n}\n.alumni_statistics .top-countries .progress-bar.countries {\n    background-color: #26a7df;\n}\n.alumni_statistics .top-countries .exclude_india {\n    font-size: 18px;\n    font-weight: 500;\n}\n.alumni_statistics .top-countries .caountryname {\n    line-height: 15px;\n}\n.alumni_statistics .top-careers .progress-bar.countries {\n    background-color: #51499c;\n}\n/* Top Countries */\n.alumni_statistics .top-colleges {\n}\n.alumni_statistics .top-colleges .slider {\n    padding: 0px 70px;\n}\n.alumni_statistics .filters .accordion-item {\n    border: 1px solid #d2d2d2;\n}\n.alumni_statistics .filters .accordion-header {\n    position: relative;\n}\n.alumni_statistics .top-colleges .carousel-control-prev,\n.alumni_statistics .top-colleges .carousel-control-next {\n    width: auto;\n}\n.alumni_statistics .top-colleges .slider .colleges {\n    border: 1px solid #d2d2d2 !important;\n    display: flex;\n    align-items: center !important;\n    border-radius: 6px;\n    line-height: 18px;\n    padding-right: 20px;\n}\n.alumni_statistics .top-colleges .slider .colleges:not(:last-child) {\n    margin-bottom: 10px;\n}\n.alumni_statistics .top-colleges .slider .colleges img {\n    width: 65px;\n}\n.alumni_statistics .top-colleges .nav-link {\n    font-size: 18px;\n    color: #0b3454;\n    border: 1px solid #8499a9;\n    display: flex;\n    align-items: center !important;\n    border-radius: 100px;\n    padding: 15px 30px;\n}\n.alumni_statistics .top-colleges .nav-item {\n    margin-right: 10px;\n    white-space: nowrap;\n}\n.alumni_statistics .top-colleges .nav-item:last-child {\n    margin-right: 0px;\n}\n.alumni_statistics .top-colleges .nav-link.active {\n    color: #fff;\n    background: #0b3454;\n}\n.alumni_statistics .top-colleges .nav-link.active {\n    color: #fff;\n    background: #0b3454;\n}\n.alumni_statistics .top-colleges .carousel-item {\n    min-height: 380px;\n}\n.owl-theme.college-slider .owl-nav button {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    margin: auto !important;\n    width: 50px;\n    height: 50px;\n    background: transparent url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/arrow-left.svg) no-repeat\n        0 0;\n    border-radius: 50%;\n    font-size: 0;\n    -webkit-border-radius: 50%;\n    -moz-border-radius: 50%;\n    -ms-border-radius: 50%;\n    -o-border-radius: 50%;\n}\n.owl-theme.college-slider .owl-nav button:hover {\n    background: transparent url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/arrow-left.svg) no-repeat\n        0 0;\n}\n.owl-theme.college-slider .owl-nav button.owl-prev {\n    left: 0;\n}\n.owl-theme.college-slider .owl-nav button.owl-next {\n    right: 0;\n    transform: scaleX(-1);\n    -webkit-transform: scaleX(-1);\n    -moz-transform: scaleX(-1);\n    -ms-transform: scaleX(-1);\n    -o-transform: scaleX(-1);\n}\n.alumni_statistics .alumni_presence .progress-bar-vertical {\n    width: 80px;\n    min-height: 200px;\n    display: flex;\n    align-items: flex-end;\n    margin-right: 20px;\n    float: left;\n    margin: 0 auto;\n    border-radius: 6px 6px 0 0;\n}\n.alumni_statistics .alumni_presence .progress-bar-vertical .prestigiouscolor {\n    background: #26a7df;\n}\n.alumni_statistics .alumni_presence .progress-bar-vertical .nonprestigiouscolor {\n    background: #51499c;\n}\n.alumni_statistics .alumni_presence .progress-bar-vertical {\n    position: relative;\n}\n.alumni_statistics .alumni_presence .progress-bar-vertical span {\n    position: absolute;\n    top: 0;\n    width: 100%;\n    text-align: center;\n    font-size: 18px;\n    font-weight: 600;\n}\n.alumni_statistics .alumni_presence .progress-bar-vertical .progress-bar {\n    width: 100%;\n    height: 0;\n    -webkit-transition: height 0.6s ease;\n    -o-transition: height 0.6s ease;\n    transition: height 0.6s ease;\n}\n.alumni_statistics .alumni_presence .prestigious {\n    border-top: 1px solid #e2e2e2;\n    margin-bottom: 0;\n    padding: 5px;\n    min-width: 140px;\n    text-align: center;\n    font-size: 18px;\n    font-weight: 500;\n}\n.alumni_statistics .alumni_presence p.prestigiousnumber {\n    text-align: center;\n    font-size: 18px;\n    font-weight: 600;\n    margin-bottom: 10px;\n}\n.alumni_statistics .alumni_presence .stats {\n    position: relative;\n}\n.alumni_statistics .alumni_presence .stats:after {\n    content: 'vs';\n    position: absolute;\n    top: 45%;\n    font-size: 20px;\n    left: 47%;\n}\n.alumni_statistics .card_profiles {\n    min-height: max-content;\n    max-height: max-content;\n}\n.guidance_videos {\n}\n.guidance_videos .videos_list {\n    text-decoration: none;\n}\n.guidance_videos .videos_list figure {\n    max-height: 180px;\n    overflow: hidden;\n    position: relative;\n    border-radius: 4px;\n    border: 2px solid #000;\n}\n.guidance_videos .videos_list figure:before {\n    content: '';\n    display: block;\n    width: 100%;\n    position: absolute;\n    height: 100%;\n    background: #00000050;\n}\n.guidance_videos .videos_list figure img {\n    transition: all 0.3s ease;\n}\n.guidance_videos .videos_list:hover figure img {\n    transform: scale(1.05);\n}\n.guidance_videos .videos_list figure:after {\n    content: '';\n    position: absolute;\n    background: url('https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/play_video.svg') no-repeat;\n    left: 50%;\n    width: 56px;\n    height: 56px;\n    margin-left: -28px;\n    top: 50%;\n    margin-top: -25px;\n}\n.guidance_videos .videos_list figure img {\n    width: 100%;\n}\n.guidance_videos .videos_list p {\n    text-align: center;\n    font-size: 20px;\n    color: #000;\n    text-decoration: none;\n    font-weight: 500;\n    line-height: 29px;\n}\n.guidance_video_popup {\n    border-radius: 0;\n    background: #000;\n    position: relative;\n}\n.guidance_video_popup .btn-close {\n    position: absolute;\n    right: 0;\n    top: -30px;\n    color: #fff;\n    filter: brightness(0) invert(1);\n    opacity: 01;\n}\n.w-10 {\n    width: 10%;\n}\n.bg-darker-blue {\n    background-color: #0b3454;\n}\n.profileContainer {\n    background: #ffffff;\n    box-shadow: 0px 3px 6px #0000001a;\n    border: 1px solid #d2d2d2;\n    border-radius: 6px;\n    overflow: hidden;\n}\n.profilenameclass .profilename {\n    line-height: 24px;\n}\n.profilenameclass .univarsity-school {\n    border-left: 4px solid #fff;\n    padding-left: 7px;\n}\n.alumni_profile_college_name_other_detail_wrap .phone_number label {\n    width: 140px;\n    margin-right: 20px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/path-72031.svg) no-repeat 0 0;\n    height: 40px;\n    padding-left: 13px;\n    display: flex;\n    align-items: center;\n    font-weight: 500;\n}\n.btn-white-border.verifynow {\n    height: 30px;\n    line-height: 25px;\n}\n.alumni_profile_college_name_other_detail_wrap .phone_number {\n    align-items: center;\n}\n.profilenameclass .class {\n    line-height: 18px;\n}\n.alumni_profile_brife_wrap.myProfile {\n    border-top: 1px solid #264a66;\n}\n.myProfile .alumni_profile_college_name_other_detail_wrap .verifynow {\n    background: #fff;\n    border: 2px solid #224764;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 30px;\n    color: #224764;\n}\n.myProfile .alumni_profile_college_name_other_detail_wrap .verifynow:hover {\n    background: #224764;\n    color: #fff;\n}\n.days .white-block {\n    background: #ffffff 0% 0% no-repeat padding-box;\n    border: 1px solid #dedede;\n    border-radius: 18px;\n    height: 35px;\n    padding: 0 20px;\n    display: flex;\n    align-items: center;\n    margin: 0 10px 10px 0;\n}\n.customselect_parnt > .form-select {\n    border-radius: 25px;\n    margin-right: 10px;\n    border: 2px solid #7d7d7d;\n    height: 36px;\n    display: flex;\n    align-items: center;\n    line-height: 18px;\n}\n.customselect_parnt button {\n    height: 36px;\n}\n.icon-download {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/download.svg) no-repeat 0 0 / 100%;\n    width: 17px;\n    height: 16px;\n    display: inline-block;\n}\n.mailSetting .icon-download {\n    filter: invert(16%) sepia(71%) saturate(697%) hue-rotate(167deg) brightness(92%) contrast(99%);\n    -webkit-filter: invert(16%) sepia(71%) saturate(697%) hue-rotate(167deg) brightness(92%) contrast(99%);\n}\n.mailSetting .icon-download:hover {\n    filter: invert(53%) sepia(75%) saturate(353%) hue-rotate(62deg) brightness(97%) contrast(89%);\n    -webkit-filter: invert(53%) sepia(75%) saturate(353%) hue-rotate(62deg) brightness(97%) contrast(89%);\n}\n/*.gray_badge .badge {background: #F1F1F1 0% 0% no-repeat padding-box;border-radius: 100px;height: 28px;padding: 0 15px;display: inline-flex;justify-content: center;align-items: center;font-size: 14px;color: #000;font-weight: 400;margin-bottom: 5px;}*/\n.gray_badge .badge {\n    background: #f1f1f1;\n    border-radius: 100px;\n    height: 28px;\n    padding: 0 15px;\n    display: inline-block;\n    font-size: 14px;\n    color: #000;\n    font-weight: 400;\n    margin-bottom: 5px;\n    max-width: 108px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    width: 100%;\n    text-align: center;\n    line-height: 28px;\n}\n.tooltip-white .tooltip-inner {\n    background: #fff !important;\n    box-shadow: 0px 3px 6px #0000001a;\n    padding: 20px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    max-width: 230px;\n    width: 100%;\n    border: none;\n    text-align: left;\n}\n.tooltip-white .tooltip-inner p, .tooltip-white .tooltip-inner{color: #000 !important;}\n.tooltip-white .tooltip-inner .badge {\n    background: #f1f1f1 0% 0% no-repeat padding-box;\n    border-radius: 100px;\n    height: 28px;\n    padding: 0 15px;\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 14px;\n    color: #000;\n    font-weight: 400;\n    text-align: left;\n}\n.tooltip-white .tooltip-inner .badge:not(:last-child) {\n    margin-bottom: 5px;\n}\n.tooltip-white .tooltip-arrow::before {\n    border-top-color: #fff;\n}\n\n.attendee_dtl .table > thead th {\n    background: #f1f1f1;\n    font-size: 14px;\n    font-weight: 500;\n    height: 40px;\n    border: 0;\n}\n.attendee_dtl .table > thead th:first-child {\n    border-radius: 6px 0 0 6px;\n}\n.attendee_dtl .table > thead th:last-child {\n    border-radius: 0 6px 6px 0;\n}\n.attendee_dtl .table.lite-blue-header > thead th{background-color: #F2F9FF;}\n.table-responsive.attendee_dtl > table td:first-child,\n.table-responsive.attendee_dtl > table th:first-child {\n    padding-left: 20px;\n}\n.table-responsive.attendee_dtl > table td {\n    padding-top: 15px;\n    padding-bottom: 15px;\n    font-size: 14px;\n    vertical-align: middle;\n    background-color: #fff;\n}\n.table-responsive.attendee_dtl > table .btn {\n    line-height: 15px;\n    display: flex;\n    align-items: center;\n    padding: 0 20px !important;\n    margin: 0 5px 0 0;\n}\n.table-responsive.attendee_dtl > table td.active {\n    width: 315px;\n}\n.table-responsive.attendee_dtl > table td.engagement {\n    width: 245px;\n}\n.table-responsive.attendee_dtl > table .university-name {\n    width: 175px;\n}\n.table-responsive.attendee_dtl > table td.sentDeliveredOpened {\n    width: 365px;\n}\n.table-responsive.attendee_dtl a.tablink {\n    color: #0b3454;\n    display: flex;\n    align-items: center;\n    text-decoration: none;\n    line-height: 18px;\n}\n.table-responsive.attendee_dtl a.tablink:hover {\n    color: #5cae48;\n}\n.table-responsive.attendee_dtl a.btn-gray-border:hover {\n    color: #fff;\n}\n.table-responsive.attendee_dtl > table td.deliveryStatus {\n    width: 205px;\n}\n.input-group-select select.form-select {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n}\n.empty-notification .profile-selection-notification {\n    z-index: 9;\n    left: 0;\n    max-width: 1012px;\n    margin: auto;\n    width: 1012px;\n    right: 0;\n    position: absolute;\n    top: 50px;\n}\n.table-responsive .icon-like.dislike {\n    width: 15px;\n    height: 15px;\n    -moz-transform: scale(-1);\n    -webkit-transform: scale(-1);\n    -o-transform: scale(-1);\n    -ms-transform: scale(-1);\n    transform: scale(-1) translateY(-3px);\n    display: inline-block;\n}\n.table_cus_badge {\n    background: #fef7e8;\n    border-radius: 20px;\n    height: 36px;\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 14px;\n    color: #000;\n    font-weight: 500;\n    padding: 0 15px;\n    margin: 3px;\n    min-width: 65px;\n}\n.tab-ul {\n    padding: 0;\n    line-height: 22px;\n    list-style: none;\n    margin: 0 13px 0 0;\n}\n.tab-ul a {\n    color: #000;\n}\n.tab-ul a:hover {\n    color: #414141;\n}\n.custom-btn a {\n    margin: 0 2px;\n    text-decoration: none;\n    color: #000;\n    font-size: 12px;\n}\n.active-status {\n    background: #ffffff 0% 0% no-repeat padding-box;\n    border: 1px solid #d2d2d2;\n    border-radius: 20px;\n    width: 120px;\n    height: 36px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.attendee_dtl a.icon-cross {\n    text-decoration: none;\n}\n.attendee_dtl a.icon-cross:hover {\n    color: #666 !important;\n}\n.attendee_dtl .form-check-input,\n.ActiveListings_present .form-check-input {\n    width: 20px;\n    height: 20px;\n    border-width: 2px;\n}\n.attendee_dtl .form-check-input:checked,\n.ActiveListings_present .form-check-input:checked {\n    background-color: #0b3454;\n    border-color: #0b3454;\n}\n.icon-sort-arrow {\n    font-size: 6px;\n    color: #7f7f7f;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n}\n.icon-sort-arrow .icon-invert-down-arrow {\n    transform: scaleY(-1);\n}\n.labelItem {\n    color: #000;\n    text-decoration: none;\n    display: flex;\n    align-items: center;\n}\n.text-center .labelItem {\n    justify-content: center;\n}\n.labelItem:hover {\n    color: #153d5b;\n}\n.labelItem .icon-sort {\n    margin-left: 5px;\n    width: 17px;\n    height: 17px;\n    display: inline-block;\n    position: relative;\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='%23343a40' stroke='none' d='M3.5 12.5a.5.5 0 0 1-1 0V3.707L1.354 4.854a.5.5 0 1 1-.708-.708l2-1.999.007-.007a.498.498 0 0 1 .7.006l2 2a.5.5 0 1 1-.707.708L3.5 3.707V12.5zm3.5-9a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zM7.5 6a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zm0 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3zm0 3a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1z'/%3e%3c/svg%3e\");\n}\n.labelItem .icon-sort::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    background: #f1f1f1;\n    width: 12px;\n    height: 2px;\n    margin: auto;\n    transform: rotate(-45deg);\n    left: -2.5px;\n    display: none;\n}\n.fitergroup .show .accordion-body {\n    border-radius: 0 6px 6px 6px;\n}\n.fitergroup .accordion-body {\n    background: #f1f1f1;\n    border-radius: 6px;\n}\n.fitergroup .input-group .css-b62m3t-container {\n    height: 38px !important;\n}\n.fitergroup .input-group .css-b62m3t-container div[class*='-control'] {\n    height: 38px !important;\n}\n.fitergroup .input-group-text {\n    border-color: #848484;\n}\n.btn-grpfiter {\n    border: 0px solid #e1e1e1;\n    border-radius: 20px;\n    height: 40px;\n    padding: 0 25px;\n    font-size: 14px;\n    font-weight: 500;\n    background: #f1f1f1;\n    position: relative;\n}\n.btn-grpfiter[aria-expanded='true'] {\n    border-radius: 20px 20px 0 0;\n    transition: all 0.3s ease-in-out;\n}\n.btn-grpfiter::before {\n    content: '';\n    position: absolute;\n    bottom: -20px;\n    left: 0;\n    right: 0;\n    background: #f1f1f1;\n    height: 10px;\n    transition: all 0.3s ease-in-out;\n    opacity: 0;\n}\n.btn-grpfiter[aria-expanded='true']::before {\n    bottom: -10px;\n    opacity: 1;\n}\n.mailSetting {\n    position: relative;\n}\n.mailSetting .setting-dropdown {\n    position: absolute;\n    top: 30px;\n    right: 10px;\n    background: white;\n    padding: 15px 20px;\n    box-shadow: 0 0 3px 0px #ccc;\n    border-radius: 6px;\n    z-index: 1;\n    border: 1px solid #ccc;\n    text-align: right;\n    display: none;\n}\n.mailSetting .setting-dropdown.open {\n    display: block;\n}\n.mailSetting .setting-dropdown ul {\n    padding: 0;\n    margin: 0;\n    list-style: none;\n}\n.mailSetting .setting-dropdown ul a {\n    text-decoration: none;\n    color: #000;\n}\n.mailSetting .setting-dropdown ul li:not(:last-child) {\n    margin-bottom: 5px;\n}\n\ntd a {\n    color: #0b3454;\n    opacity: 1;\n    text-decoration: none;\n}\ntd a:hover {\n    color: #5cae48;\n    opacity: 1;\n}\n.btn-conview,\n.link {\n    color: #0d6efd;\n    text-decoration: underline;\n}\n.btn-conview:hover,\n.link:hover {\n    color: #5cae48;\n    opacity: 1;\n}\n.tooltip-setting .tooltip-inner {\n    background: #ffffff;\n    color: #515151;\n    border: 1px solid #cecfcf;\n    box-shadow: 0px 5px 10px #00000033;\n    padding: 15px 12px;\n}\n.tooltip.tooltip-setting .show {\n    opacity: 2;\n}\n.tooltip-setting .bs-tooltip-top .tooltip-arrow::before {\n    top: -1px;\n    border-width: 0.4rem 0.4rem 0;\n    border-top-color: #fff;\n}\n.tooltip-setting .bs-tooltip-bottom .tooltip-arrow::before {\n    bottom: -1px;\n    border-width: 0 0.4rem 0.4rem;\n    border-bottom-color: #fff;\n}\n.tooltip-setting .tooltip-inner ul {\n    padding: 0;\n    margin: 0;\n    text-align: left;\n    list-style: none;\n    line-height: 24px;\n}\n.tooltip-setting .tooltip-inner ul a {\n    font-size: 14px;\n    color: #000;\n    text-decoration: none;\n    padding: 0;\n    border: none;\n    font-weight: 500;\n}\n.bs-tooltip-auto.tooltip-setting[data-popper-placement^='top'] .tooltip-arrow::before,\n.bs-tooltip-top.tooltip-setting .tooltip-arrow::before {\n    border-top-color: #fff;\n}\n.tooltip-html {\n}\n.tooltip-html .tooltip-inner {\n    background: #ffffff !important;\n    color: #515151;\n    border: 1px solid #cecfcf;\n    box-shadow: 0px 5px 10px #00000033;\n    padding: 15px 15px;\n    max-width: 300px;\n    line-height: 20px;\n}\n.tooltip.tooltip-html .show {\n    opacity: 2;\n}\n.tooltip-html .bs-tooltip-top .tooltip-arrow::before {\n    top: -1px;\n    border-width: 0.4rem 0.4rem 0;\n    border-top-color: #fff;\n}\n.tooltip-html .bs-tooltip-bottom .tooltip-arrow::before {\n    bottom: -1px;\n    border-width: 0 0.4rem 0.4rem;\n    border-bottom-color: #fff;\n}\n.tooltip-html .tooltip-inner ul {\n    padding: 0;\n    margin: 0;\n    text-align: left;\n    list-style: none;\n    line-height: 24px;\n}\n.tooltip-html .tooltip-inner ul a {\n    font-size: 14px;\n    color: #000;\n    text-decoration: none;\n}\n.bs-tooltip-auto.tooltip-html[data-popper-placement^='top'] .tooltip-arrow::before,\n.bs-tooltip-top.tooltip-html .tooltip-arrow::before {\n    border-top-color: #fff;\n}\n.tooltip-html .tooltip-inner ul li {\n    white-space: wrap;\n}\n.tooltip-html .tooltip-inner ul li:not(:last-child) {\n    margin: 0 0 8px;\n}\n.tooltip-html .tooltip-inner ul li b {\n    margin-right: 5px;\n    font-weight: 500;\n    color: #000;\n}\n.tooltip-html .tooltip-inner ol,\n.tooltip-html .tooltip-inner p {\n    padding: 0 0 0 20px;\n    margin: 0;\n    text-align: left;\n    font-weight: 500;\n    color: #000;\n}\n.datewrap {\n    display: flex;\n    flex-wrap: wrap;\n    background: #ffffff 0% 0% no-repeat padding-box;\n    border: 1px solid #848484;\n    border-radius: 6px;\n    height: 40px;\n    position: relative;\n    overflow: hidden;\n}\n#config-demo,\n.singledaterangePickerList,\n.daterangePickerList {\n    width: 100%;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    top: 0;\n    right: 0;\n    margin: auto;\n    cursor: pointer;\n    opacity: 0;\n}\n.datewrap .arrow {\n    background: #f1f1f1 0% 0% no-repeat padding-box;\n    width: 45px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n/*.datewrap .arrow span {background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='1' d='M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z'/%3e%3c/svg%3e\");font-size: 0;width: 25px;height: 25px;}*/\n.datewrap .arrow span {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/arrow.svg) no-repeat center;\n    font-size: 0;\n    width: 25px;\n    height: 25px;\n}\n.datewrap .from,\n.datewrap .to {\n    flex: 1;\n}\n.datewrap .form-control {\n    height: 100% !important;\n    border: 0 !important;\n    background: #fff url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/calendar.svg) no-repeat 10px\n        center;\n    padding-left: 40px;\n}\n.fitergroup .accordion-body .form-select,\n.fitergroup .accordion-body .form-control,\n.tab-pane .fullViewMobile .form-select,\n.tab-pane .fullViewMobile .form-control {\n    height: 40px;\n    border: 1px solid #848484;\n}\n.fitergroup .accordion-body .form-select.selected,\n.fitergroup .accordion-body .form-control.selected {\n    background-color: #b6dbac;\n    border-color: #8baa83;\n}\n.form-control.form-search {\n    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/search.svg);\n    background-size: 14px;\n    background-repeat: no-repeat;\n    background-position: 13px center;\n    padding-left: 34px;\n}\n.search.alumniSearch {\n    max-width: 350px;\n    width: 100%;\n    background: #fff;\n    border: 1px solid #7d7d7d;\n    border-radius: 20px;\n}\n.search.alumniSearch .btn-search {\n    right: auto;\n    left: 7px;\n    top: 6px;\n}\n.search.alumniSearch .form-control {\n    padding-left: 40px;\n}\n.search.alumniSearch > div input:focus {\n    box-shadow: none;\n    background: transparent;\n}\n.search-100 .search.alumniSearch {\n    max-width: 280px;\n}\n.singlelinename {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    width: 125px;\n}\n.tablink img[width='30'] {\n    width: 30px;\n    min-width: 30px;\n}\n.icon-star.circle-img {\n    position: absolute;\n    bottom: -3px;\n    right: -3px;\n    background: #5cae48;\n    border-radius: 50%;\n    color: #fff;\n    font-size: 7px;\n    padding: 4px;\n}\n.table-responsive.attendee_dtl td a > i {\n    width: 30px;\n    height: 30px;\n    font-size: 30px;\n    background-position: center;\n}\n.table-responsive.attendee_dtl td a > i img {\n    vertical-align: top;\n}\n.course-list-row span {\n    vertical-align: top;\n    margin-right: 4px;\n}\n.course-list-row i {\n    margin-top: 0px;\n}\n.filterresult ul {\n    margin: 0;\n    padding: 10px 0 15px;\n    display: flex;\n    flex-wrap: wrap;\n    list-style: none;\n}\n.filterresult ul:empty {\n    display: none;\n}\n.filterresult ul li:not(:last-child) {\n    margin-right: 10px;\n}\n.filterresult ul li {\n    margin-bottom: 5px;\n}\n.filterresult ul li a {\n    background: #c8edff;\n    border-radius: 20px;\n    min-height: 32px;\n    padding: 5px 20px;\n    display: flex;\n    align-items: center;\n    font-size: 16px;\n    color: #000;\n    text-decoration: none;\n}\n.filterresult ul li a i {\n    margin-left: 8px;\n    font-size: 9px;\n}\n.filterresult ul li.clear a {\n    background: none;\n    color: #d42941;\n    text-decoration: underline;\n}\n.filterresult ul li.clear a:hover {\n    color: #0b3454;\n    text-decoration: none;\n}\n.filterresult {\n    padding: 0;\n    border-bottom: 1px solid #e5eaed;\n    margin-bottom: 20px;\n}\n.pagination_custom {\n    max-width: 751px;\n    margin: auto;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 15px;\n}\n.pagination_custom .pagination_custom_inner {\n    flex: 1;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin: 0 20px;\n}\n.pagination_custom .pagination_custom_inner ul {\n    padding: 0;\n    margin: 0 20px;\n    list-style: none;\n    display: flex;\n    flex-wrap: wrap;\n    flex: 1;\n    justify-content: center;\n    align-items: center;\n}\n.pagination_custom .pagination_custom_inner ul li:not(:last-child) {\n    margin-right: 0;\n}\n.pagination_custom .pagination_custom_inner ul li {\n    width: 30px;\n    text-align: center;\n    margin: 0 10px;\n}\n.pagination_custom a,\n.pagination_custom .pagination_custom_inner ul li a {\n    text-decoration: none;\n    font-size: 16px;\n    color: #0b3454;\n    font-weight: 500;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.pagination_custom .pagination_custom_inner ul li.current a {\n    background: #0b3454;\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: #fff;\n}\n.summary-blocks {\n    width: 1140px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    margin-bottom: 15px;\n}\n.summary-blocks .block {\n    width: calc(20.19% - 1%);\n    border-radius: 4px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    padding: 32px 20px;\n}\n.summary-blocks .block {\n    background: #fff;\n}\n.summary-blocks .block:not(:last-child) {\n    margin-right: 1%;\n}\n.summary-blocks .block .icon {\n    margin-right: 15px;\n}\n.summary-blocks .block .block-detail .number {\n    font-size: 26px;\n    line-height: 30px;\n    font-weight: 600;\n}\n.summary-blocks .block .block-detail .block-detail-title {\n    font-size: 15px;\n    line-height: 18px;\n    font-weight: 500;\n}\n.summary-blocks .block.totalAlumni .block-detail {\n    color: #d42941;\n}\n.summary-blocks .block.uptoDate .block-detail {\n    color: #0b3454;\n}\n.summary-blocks .block.due .block-detail {\n    color: #26a7df;\n}\n.summary-blocks .block.smartApplyLeads .block-detail {\n    color: #403a81;\n}\n.summary-blocks .block.smartApplyRegd .block-detail {\n    color: #6962a7;\n}\n.x-scroll {\n    overflow-x: auto;\n    scrollbar-width: thin;\n}\n.x-scroll::-webkit-scrollbar {\n    height: 4px;\n}\n.x-scroll::-webkit-scrollbar-track {\n    background: #f1f1f1;\n}\n.x-scroll::-webkit-scrollbar-thumb {\n    background: #888;\n}\n.x-scroll::-webkit-scrollbar-thumb:hover {\n    background: #555;\n}\n.blue-badge {\n    background: #68c2e9;\n    font-weight: 500;\n    border: 1px solid #68c2e9;\n    border-radius: 6px;\n    padding: 0 15px;\n    height: 26px;\n    display: inline-block;\n    line-height: 26px;\n    color: #fff !important;\n    margin-bottom: 5px;\n    font-size: 12px;\n    text-transform: uppercase;\n}\n.sticky_table_3_columns th:first-child {\n    position: sticky;\n    left: 0;\n    z-index: 3;\n}\n.sticky_table_3_columns th:nth-child(2) {\n    position: sticky;\n    left: 140px;\n    z-index: 3;\n}\n.sticky_table_3_columns th:nth-child(3) {\n    position: sticky;\n    left: calc(140px + 250px);\n    z-index: 3;\n}\n.sticky_table_3_columns td:first-child {\n    position: sticky;\n    left: 0;\n    z-index: 3;\n}\n.sticky_table_3_columns td:nth-child(2) {\n    position: sticky;\n    left: 140px;\n    z-index: 3;\n}\n.sticky_table_3_columns td:nth-child(3) {\n    position: sticky;\n    left: calc(140px + 250px);\n    z-index: 3;\n}\n.sticky_table_3_columns th:nth-child(3)::before,\n.sticky_table_3_columns td:nth-child(3)::before {\n    content: '';\n    width: 30px;\n    position: absolute;\n    right: 0px;\n    bottom: 0;\n    top: 0;\n    background: transparent linear-gradient(270deg, #000000 0%, #00000000 100%);\n    opacity: 0.05;\n}\n.sticky_table_3_columns td::after {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: -1px;\n    height: 0;\n    border-bottom: 1px solid #dee2e6;\n}\n.sticky_table_3_columns_noaction th:first-child {\n    position: sticky;\n    left: 0;\n    z-index: 3;\n}\n.sticky_table_3_columns_noaction th:nth-child(2) {\n    position: sticky;\n    left: 250px;\n    z-index: 3;\n}\n.sticky_table_3_columns_noaction th:nth-child(3) {\n    position: sticky;\n    left: calc(250px + 180px);\n    z-index: 3;\n}\n.sticky_table_3_columns_noaction td:first-child {\n    position: sticky;\n    left: 0;\n    z-index: 3;\n}\n.sticky_table_3_columns_noaction td:nth-child(2) {\n    position: sticky;\n    left: 250px;\n    z-index: 3;\n}\n.sticky_table_3_columns_noaction td:nth-child(3) {\n    position: sticky;\n    left: calc(250px + 180px);\n    z-index: 3;\n}\n.sticky_table_3_columns_noaction th:nth-child(3)::before,\n.sticky_table_3_columns_noaction td:nth-child(3)::before {\n    content: '';\n    width: 30px;\n    position: absolute;\n    right: 0px;\n    bottom: 0;\n    top: 0;\n    background: transparent linear-gradient(270deg, #000000 0%, #00000000 100%);\n    opacity: 0.05;\n}\n.sticky_table_3_columns_noaction td::after {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: -1px;\n    height: 0;\n    border-bottom: 1px solid #dee2e6;\n}\n.sticky_table_4_columns th:first-child {\n    position: sticky;\n    left: 0;\n    z-index: 3;\n}\n.sticky_table_4_columns th:nth-child(2) {\n    position: sticky;\n    left: 150px;\n    z-index: 3;\n}\n.sticky_table_4_columns th:nth-child(3) {\n    position: sticky;\n    left: calc(150px + 225px);\n    z-index: 3;\n}\n.sticky_table_4_columns th:nth-child(4) {\n    position: sticky;\n    left: calc(150px + 225px + 180px);\n    z-index: 3;\n}\n.sticky_table_4_columns td:first-child {\n    position: sticky;\n    left: 0;\n    z-index: 3;\n}\n.sticky_table_4_columns td:nth-child(2) {\n    position: sticky;\n    left: 150px;\n    z-index: 3;\n}\n.sticky_table_4_columns td:nth-child(3) {\n    position: sticky;\n    left: calc(150px + 225px);\n    z-index: 3;\n}\n.sticky_table_4_columns td:nth-child(4) {\n    position: sticky;\n    left: calc(150px + 225px + 180px);\n    z-index: 3;\n}\n.sticky_table_4_columns th:nth-child(4)::before,\n.sticky_table_4_columns td:nth-child(4)::before {\n    content: '';\n    width: 30px;\n    position: absolute;\n    right: 0px;\n    bottom: 0;\n    top: 0;\n    background: transparent linear-gradient(270deg, #000000 0%, #00000000 100%);\n    opacity: 0.05;\n}\n.sticky_table_4_columns td::after {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: -1px;\n    height: 0;\n    border-bottom: 1px solid #dee2e6;\n}\n.w-2300 {\n    width: 2300px;\n}\n.w-2000 {\n    width: 2000px;\n}\n.w-1780 {\n    width: 1780px;\n}\n.w-90 {\n    width: 90px;\n}\n.max-1140 {\n    max-width: 1140px;\n    width: 94%;\n}\n.max-1040 {\n    max-width: 1040px;\n    width: 94%;\n}\n.max-1010 {\n    max-width: 1010px;\n    width: 94%;\n}\n.max-950 {\n    max-width: 950px;\n}\n.max-940 {\n    max-width: 940px;\n    width: 94%;\n}\n.max-900 {\n    max-width: 900px;\n    width: 94%;\n}\n.max-850 {\n    max-width: 850px;\n    width: 94%;\n}\n.max-800 {\n    max-width: 800px;\n    width: 94%;\n}\n.max-740 {\n    max-width: 740px;\n    width: 90%;\n}\n.max-750 {\n    max-width: 750px;\n    width: 90%;\n}\n.max-780 {\n    max-width: 780px;\n    width: 90%;\n}\n.max-700 {\n    max-width: 700px !important;\n    width: 90%;\n}\n.max-600 {\n    max-width: 600px;\n    width: 90%;\n}\n.max-620 {\n    max-width: 620px;\n    width: 90%;\n}\n.max-630 {\n    max-width: 630px;\n    width: 90%;\n}\n.max-540 {\n    max-width: 540px;\n    width: 90%;\n}\n.bg-gray-f2 {\n    background: #f2f2f2;\n}\n.customselect_parnt > .form-select {\n    border-radius: 25px;\n    margin-right: 10px;\n    border: 2px solid #7d7d7d;\n    height: 36px;\n    display: flex;\n    align-items: center;\n    line-height: 18px;\n}\n.customselect_parnt button {\n    height: 36px;\n}\n.icon-download {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/download.svg) no-repeat 0 0 / 100%;\n    width: 17px;\n    height: 16px;\n    display: inline-block;\n}\n.mailSetting .icon-download {\n    filter: invert(16%) sepia(71%) saturate(697%) hue-rotate(167deg) brightness(92%) contrast(99%);\n    -webkit-filter: invert(16%) sepia(71%) saturate(697%) hue-rotate(167deg) brightness(92%) contrast(99%);\n}\n.mailSetting .icon-download:hover {\n    filter: invert(53%) sepia(75%) saturate(353%) hue-rotate(62deg) brightness(97%) contrast(89%);\n    -webkit-filter: invert(53%) sepia(75%) saturate(353%) hue-rotate(62deg) brightness(97%) contrast(89%);\n}\n.gray_badge .badge {\n    background: #f1f1f1;\n    border-radius: 100px;\n    height: 28px;\n    padding: 0 15px;\n    display: inline-block;\n    font-size: 14px;\n    color: #000;\n    font-weight: 400;\n    margin-bottom: 0px;\n    max-width: 108px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    width: 100%;\n    text-align: center;\n    line-height: 28px;\n}\n.custom-btn a {\n    margin: 0 2px;\n    text-decoration: none;\n    color: #212529;\n}\n.custom-btn a:hover {\n    color: #868686;\n}\n.modal .form-control {\n    min-height: 40px;\n    font-weight: 500;\n    color: #000;\n    font-size: 16px;\n}\n.modal .form-label {\n    font-weight: 500;\n    font-size: 16px;\n}\n::-webkit-input-placeholder {\n    color: #939ba2;\n}\n:-moz-placeholder {\n    color: #939ba2;\n    opacity: 1;\n}\n::-moz-placeholder {\n    color: #939ba2;\n    opacity: 1;\n}\n:-ms-input-placeholder {\n    color: #939ba2;\n}\n::-ms-input-placeholder {\n    color: #939ba2;\n}\n::placeholder {\n    color: #939ba2;\n}\n.btn-log {\n    background: #0b3454;\n    padding: 0 16px;\n    height: 40px;\n    display: inline-flex;\n    border-radius: 4px;\n    color: #fff;\n    text-decoration: none;\n    line-height: 35px;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    align-items: center;\n    font-size: 14px;\n}\n.btn-log:hover {\n    color: #fff;\n    background: #155282;\n}\n.btn-green {\n    background: #5cae48;\n    color: #fff;\n    border-color: #5cae48;\n    padding: 0 25px;\n    height: 40px;\n}\n.btn-green:hover {\n    color: #fff;\n    background: #367127;\n    border-color: #367127;\n}\n.btn-green {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: #fff;\n    text-decoration: none;\n    font-size: 16px;\n    line-height: 16px;\n    font-weight: 500;\n    position: relative;\n    overflow: hidden;\n    border: 0;\n}\n.btn-green span {\n    position: relative;\n}\n.btn-completed::before,\n.btn-green::before {\n    position: absolute;\n    content: '';\n    left: 0;\n    top: 0;\n    bottom: 0;\n    width: 0;\n    background: #398227;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n}\n.btn-completed:hover::before,\n.btn-green:hover::before,\n.btn-liteblue:hover::before,\n.btn-invite:hover::before {\n    width: 100%;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n}\n.form-last-sent {\n    height: 40px;\n    display: flex;\n    align-items: center;\n    background: #eef6ff;\n    border-radius: 5px;\n    padding: 5px 15px;\n}\n.form-last-sent a {\n    margin-right: 5px;\n    color: #007bff;\n}\n.filterSection .form-label {\n    font-weight: 500 !important;\n    margin: 0 0 3px;\n}\n.form-check .form-check-input {\n    width: 20px;\n    height: 20px;\n    vertical-align: top;\n    display: inline-block;\n    position: static;\n    margin-right: 8px;\n    margin-left: 0;\n    margin-top: 0;\n}\n.form-check {\n    display: flex;\n    align-items: center;\n    padding: 0;\n}\n.form-check .form-check-label {\n    display: flex;\n    align-items: center;\n    line-height: 16px;\n    margin: 0;\n}\n.form-check-input:checked {\n    background-color: #29a745;\n    border-color: #29a745;\n}\n.datepicker .datepicker-switch:hover,\n.datepicker .prev:hover,\n.datepicker .next:hover,\n.datepicker tfoot tr th:hover {\n    background: #eef5ff;\n}\n.datepicker {\n    padding: 0;\n    z-index: 9999;\n}\n.datepicker td,\n.datepicker th {\n    padding: 7px;\n}\n.datepicker-days thead {\n    background: #eef5ff;\n    font-weight: 500;\n}\n.datepicker-days thead th {\n    font-weight: 500;\n}\n.datepicker-days thead th:hover {\n    background: #007bff;\n    color: #fff;\n}\n.datepicker-months,\n.datepicker-days {\n    overflow: hidden;\n    background: #eef5ff;\n    border-radius: 3px;\n}\n.datepicker-months tbody,\n.datepicker-days tbody {\n    background: #fff;\n}\n.form-date {\n    background: #fff url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/calender.svg) no-repeat right\n        10px center;\n    padding-right: 40px;\n}\n.modal-backdrop {\n    z-index: 1090;\n}\n.modal {\n    z-index: 1091;\n}\n.modal-backdrop ~ .tooltip {\n    z-index: 1099;\n}\n.half-gray {\n    position: relative;\n}\n.half-gray:before {\n    content: '';\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    top: 0;\n    width: 50.5%;\n    background: #f3f3f3;\n    border-radius: 6px 0px 0px 6px;\n}\n.half-gray > div {\n    position: relative;\n}\n.messages {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n}\n.leftUser {\n    align-items: end;\n}\n.leftUser p {\n    background: #2296c9;\n    border-radius: 10px 10px 0px 10px;\n    padding: 7px 20px;\n    color: #fff;\n    margin-bottom: 10px;\n}\n.rightUser {\n    align-items: start;\n}\n.rightUser p {\n    background: #413a7d;\n    border-radius: 10px 10px 10px 0px;\n    opacity: 1;\n    padding: 7px 20px;\n    color: #fff;\n    margin-bottom: 10px;\n}\n.conversation .userimg {\n    display: flex;\n    align-items: start;\n    vertical-align: top;\n}\n.conversation {\n    height: 310px;\n    overflow-y: scroll;\n    overflow-x: hidden;\n    margin-right: -8px;\n}\n.conversation {\n    overflow-y: scroll;\n    scrollbar-width: thin;\n}\n.conversation::-webkit-scrollbar {\n    width: 1px;\n}\n.conversation::-webkit-scrollbar-track {\n    background: #f1f1f1;\n}\n.conversation::-webkit-scrollbar-thumb {\n    background: #888;\n}\n.conversation::-webkit-scrollbar-thumb:hover {\n    background: #555;\n}\n.conversation .row {\n    position: relative;\n}\n.messages.rightUser .form-check-input {\n    position: absolute;\n    left: 12px;\n    top: 9px;\n}\n.messages.leftUser .form-check-input {\n    position: absolute;\n    left: 12px;\n    top: 9px;\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n}\n.messages .form-check-input:focus {\n    box-shadow: none;\n}\n.conversation div[class*='col'] {\n    position: static;\n}\n.conversation.gap div[class*='col'] > div {\n    padding: 0 20px;\n}\n.half-gray .modal-footer {\n    background: #fff;\n    padding: 20px;\n}\n.modal-footer .btn-good-qa {\n    margin: auto;\n    color: #fff;\n    background-color: #28a745;\n    border-color: #28a745;\n    box-shadow: none;\n    padding: 10px 25px;\n    border-radius: 3px;\n    text-transform: uppercase;\n    font-weight: 500;\n}\n.modal-footer .btn-good-qa:hover {\n    background-color: #218838;\n    border-color: #1e7e34;\n}\n.fitergroup .form-label {\n    font-weight: 500;\n    margin: 0 0 3px;\n}\n.fitergroup .form-last-sent {\n    border: 1px solid #bfcfe1;\n}\n.custom_litezoom:before {\n    content: '';\n    position: absolute;\n    top: 100%;\n    left: 10px;\n    border-left: 5px solid transparent;\n    border-right: 5px solid transparent;\n    border-top: 6px solid #fff;\n}\n.album_imgvdo {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n}\n.image_tn:first-child {\n    margin-right: 5px;\n}\n.image_tn {\n    margin-bottom: 3px;\n}\n.table-responsive.attendee_dtl td .custom_litezoom a {\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 25px;\n    text-decoration: none !important;\n    color: #000;\n    font-weight: 500;\n    display: flex;\n    align-items: center;\n    border: 1px solid #cecece;\n    border-radius: 26px;\n    -webkit-border-radius: 26px;\n    -moz-border-radius: 26px;\n    -ms-border-radius: 26px;\n    -o-border-radius: 26px;\n    padding: 0 10px;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    width: auto;\n    background: none;\n}\n.custom_litezoom a:hover {\n    color: #0b3454;\n}\n.table-responsive.attendee_dtl td .custom_litezoom a .icon-phone {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/image.svg) no-repeat 0 0;\n    width: 16px;\n    height: 15px;\n    margin-right: 7px;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.table-responsive.attendee_dtl td .custom_litezoom a .icon-video {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/video-camera.svg) no-repeat 0 0;\n    width: 16px;\n    height: 9px;\n    margin-right: 7px;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.custom_litezoom a:hover {\n    background: #0c9ccc;\n    border-color: #0c9ccc;\n    color: #fff;\n}\n.custom_litezoom a:hover i {\n    filter: brightness(0) invert(1);\n    -webkit-filter: brightness(0) invert(1);\n}\n.table .view-list {\n    text-align: center;\n    font-size: 14px;\n    color: #0c9ccc;\n    font-weight: 500;\n}\n.table .view-list:hover {\n    color: #007bff;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.table td b {\n    font-weight: 500;\n}\n\n/* multi select start */\n.select2-container {\n    display: block;\n}\n.select2-container *:focus {\n    outline: 0;\n}\n.input-group .select2-container--bootstrap4 {\n    -webkit-box-flex: 1;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n}\n.input-group-prepend ~ .select2-container--bootstrap4 .select2-selection {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n}\n.input-group > .select2-container--bootstrap4:not(:last-child) .select2-selection {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n}\n.select2-container--bootstrap4 .select2-selection {\n    width: 100%;\n    background-color: #fff;\n    border: 1px solid #ced4da;\n    border-radius: 0.25rem;\n    -webkit-transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;\n    transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;\n    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;\n    -moz-transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;\n    -ms-transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;\n    -o-transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;\n}\n.btn-update {\n    background: #0b3454;\n    padding: 3px 20px;\n    border-radius: 25px;\n    color: #fff;\n    text-decoration: none !important;\n    font-weight: 500;\n    height: 32px;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.btn-update:hover {\n    color: #fff;\n    background: #0060aa;\n}\n.btn-create {\n    background: #28a745;\n    padding: 3px 20px;\n    border-radius: 25px;\n    color: #fff;\n    text-decoration: none !important;\n    font-weight: 500;\n    height: 32px;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.btn-create:hover {\n    color: #fff;\n    background: #10842a;\n}\n.alumni_profile_brife .btn-back .icon-left-arrow {\n    transform: scaleX(-1);\n    margin-left: 7px;\n    font-size: 12px;\n    -webkit-transform: scaleX(-1);\n    -moz-transform: scaleX(-1);\n    -ms-transform: scaleX(-1);\n    -o-transform: scaleX(-1);\n}\n.copylink > a {\n    width: 100px;\n    height: 40px;\n    display: inline-flex;\n    background: #5cae48;\n    justify-content: center;\n    align-items: center;\n    color: #fff;\n    border-radius: 3px;\n    margin-right: 5px;\n    text-decoration: none;\n}\n.copylink > a.invite:hover {\n    background: #408e2d;\n    color: #fff;\n}\n.icon.copy {\n    position: relative;\n    cursor: pointer;\n    width: 18px;\n    display: inline-block;\n    height: 18px;\n}\n.icon.copy:before {\n    content: '';\n    width: 12px;\n    height: 17px;\n    position: absolute;\n    top: 0;\n    left: 0;\n    border: 1px solid #a6a6a6;\n    border-radius: 2px;\n    background: #fff;\n}\n.icon.copy:after {\n    content: '';\n    width: 12px;\n    height: 17px;\n    position: absolute;\n    top: 3px;\n    left: 3px;\n    border: 1px solid #a6a6a6;\n    border-radius: 2px;\n    background: #fff;\n}\n.alumni_profile_image_wrap {\n    width: 110px;\n    height: 110px;\n    background: #f1f1f1;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-right: 20px;\n    position: relative;\n}\n.alumni_profile_image_wrap .alumni_profile_image {\n    margin: 0;\n}\n.alumni_profile_image_wrap .pencil-edit {\n    position: absolute;\n    top: 0;\n    right: 0;\n    background-color: #5cae48;\n    padding: 2px;\n    border-radius: 50%;\n    background-size: 12px auto;\n    width: 30px;\n    height: 30px;\n    transition: all 0.3s ease-in-out;\n}\n.alumni_profile_image_wrap .pencil-edit:hover {\n    background-color: #72bb60;\n}\n.modal .form-control[name*='countryCode'] {\n    width: 65px !important;\n}\n.modal .btn-verify {\n    display: block;\n    height: 25px;\n    line-height: 25px;\n    padding: 0 15px !important;\n    width: auto;\n    font-size: 12px;\n    text-transform: uppercase;\n    text-align: center;\n    font-weight: 500;\n}\n.modal .form-label a.icon.icon-cross {\n    background: red;\n    color: #fff;\n    font-size: 8px;\n    padding: 4px;\n    border-radius: 50%;\n    margin: 0;\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .select2-container--bootstrap4 .select2-selection {\n        -webkit-transition: none;\n        transition: none;\n    }\n}\n\n.select2-container {\n    width: 100%;\n}\n.select2-container .select2-search--inline .select2-search__field {\n    width: 100% !important;\n}\n.select2-container--bootstrap4.select2-container--focus .select2-selection {\n    border-color: #80bdff;\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n.select2-container--bootstrap4.select2-container--focus.select2-container--open .select2-selection {\n    border-bottom: none;\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0;\n}\n.select2-container--bootstrap4.select2-container--open.select2-container--above .select2-selection {\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n}\n.select2-container--bootstrap4.select2-container--open.select2-container--below .select2-selection {\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0;\n}\n.select2-container--bootstrap4.select2-container--disabled .select2-selection,\n.select2-container--bootstrap4.select2-container--disabled.select2-container--focus .select2-selection {\n    cursor: not-allowed;\n    background-color: #e9ecef;\n    border-color: #ced4da;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n}\n.select2-container--bootstrap4.select2-container--disabled .select2-search__field,\n.select2-container--bootstrap4.select2-container--disabled.select2-container--focus .select2-search__field {\n    background-color: transparent;\n}\nselect.is-invalid ~ .select2-container--bootstrap4 .select2-selection,\nform.was-validated select:invalid ~ .select2-container--bootstrap4 .select2-selection {\n    border-color: #dc3545;\n}\nselect.is-valid ~ .select2-container--bootstrap4 .select2-selection,\nform.was-validated select:valid ~ .select2-container--bootstrap4 .select2-selection {\n    border-color: #28a745;\n}\n.select2-container--bootstrap4 .select2-search {\n    width: 100%;\n}\n.select2-container--bootstrap4 .select2-dropdown {\n    border-color: #ced4da;\n    border-radius: 0;\n}\n.select2-container--bootstrap4 .select2-dropdown.select2-dropdown--below {\n    border-top: none;\n    border-bottom-right-radius: 0.25rem;\n    border-bottom-left-radius: 0.25rem;\n}\n.select2-container--bootstrap4 .select2-dropdown.select2-dropdown--above {\n    border-top: 1px solid #ced4da;\n    border-top-left-radius: 0.25rem;\n    border-top-right-radius: 0.25rem;\n}\n.select2-container--bootstrap4 .select2-dropdown .select2-results__option[aria-selected='true'] {\n    color: #212529;\n    background-color: #f2f2f2;\n}\n.select2-container--bootstrap4 .select2-results__option[role='group'] {\n    padding: 0;\n}\n.select2-container--bootstrap4 .select2-results__option[role='group'] .select2-results__options--nested .select2-results__option {\n    padding-left: 1em;\n}\n.select2-container--bootstrap4 .select2-results__option {\n    padding: 8px 15px 8px 35px;\n    position: relative;\n}\n.select2-container--bootstrap4 .select2-results__option:before {\n    content: '';\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 10px;\n    width: 15px;\n    height: 15px;\n    border: 1px solid #868686;\n    margin: auto;\n    border-radius: 3px;\n}\n.select2-container--bootstrap4 .select2-results__option--highlighted,\n.select2-container--bootstrap4 .select2-results__option--highlighted.select2-results__option[aria-selected='true'] {\n    color: #fff;\n    background-color: #007bff;\n}\n.select2-container--bootstrap4 .select2-results__option[aria-selected='true']::before {\n    border: 1px solid #868686;\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='%23343a40' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='1' d='M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z'/%3e%3c/svg%3e\");\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: 15px 15px;\n}\n.select2-container--bootstrap4 .select2-results__option--highlighted.select2-results__option[aria-selected='false']::before {\n    border: 1px solid #fff;\n}\n.select2-container--bootstrap4 .select2-results__option--highlighted.select2-results__option[aria-selected='true']::before {\n    border: 1px solid #fff;\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='white' stroke='white' stroke-linecap='round' stroke-linejoin='round' stroke-width='1' d='M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z'/%3e%3c/svg%3e\");\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: 15px 15px;\n}\n.select2-container--bootstrap4 .select2-results > .select2-results__options {\n    max-height: 15em;\n    overflow-y: auto;\n}\n.select2-container--bootstrap4 .select2-results__group {\n    display: list-item;\n    padding: 6px;\n    color: #6c757d;\n}\n.select2-container--bootstrap4 .select2-selection__clear {\n    float: right;\n    width: 0.9em;\n    height: 0.9em;\n    padding-left: 0.15em;\n    margin-top: 0.7em;\n    margin-right: 0.3em;\n    line-height: 0.75em;\n    color: #f8f9fa;\n    background-color: #c8c8c8;\n    border-radius: 100%;\n}\n.select2-container--bootstrap4 .select2-selection__clear:hover {\n    background-color: #afafaf;\n}\n.select2-container--bootstrap4 .select2-selection--single {\n    height: calc(1.5em + 0.75rem + 2px) !important;\n}\n.select2-container--bootstrap4 .select2-selection--single .select2-selection__placeholder {\n    line-height: calc(1.5em + 0.75rem);\n    color: #6c757d;\n}\n.select2-container--bootstrap4 .select2-selection--single .select2-selection__arrow {\n    position: absolute;\n    top: 50%;\n    right: 3px;\n    width: 20px;\n}\n.select2-container--bootstrap4 .select2-selection--single .select2-selection__arrow b {\n    position: absolute;\n    top: 60%;\n    left: 50%;\n    width: 0;\n    height: 0;\n    margin-top: -2px;\n    margin-left: -4px;\n    border-color: #343a40 transparent transparent transparent;\n    border-style: solid;\n    border-width: 5px 4px 0;\n}\n.select2-container--bootstrap4 .select2-selection--single .select2-selection__rendered {\n    padding-left: 0.75rem;\n    line-height: calc(1.5em + 0.75rem);\n    color: #495057;\n}\n.select2-search--dropdown .select2-search__field {\n    padding: 0.375rem 0.75rem;\n    border: 1px solid #ced4da;\n    border-radius: 0.25rem;\n}\n.select2-results__message {\n    color: #6c757d;\n}\n.select2-container--bootstrap4 .select2-selection--multiple {\n    min-height: calc(1.5em + 0.75rem + 2px) !important;\n}\n.select2-container--bootstrap4 .select2-selection--multiple .select2-selection__rendered {\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n    width: 100%;\n    padding: 0 0.375rem;\n    margin: 0;\n    list-style: none;\n}\n.select2-container--bootstrap4 .select2-selection--multiple .select2-selection__choice {\n    float: none;\n    padding: 0;\n    padding-right: 0.75rem;\n    margin-top: 7px;\n    margin-right: 0.375rem;\n    color: #495057;\n    cursor: pointer;\n    border: 1px solid #bdc6d0;\n    border-radius: 0.2rem;\n    display: inline-block;\n}\n.select2-container--bootstrap4 .select2-selection--multiple .select2-search__field {\n    color: #495057;\n}\n.select2-container--bootstrap4 .select2-selection--multiple .select2-selection__choice + .select2-search {\n    width: 0;\n    display: none;\n}\n.select2-container--bootstrap4 .select2-selection--multiple .select2-selection__choice__remove {\n    float: left;\n    padding-right: 3px;\n    padding-left: 3px;\n    margin-right: 1px;\n    margin-left: 3px;\n    font-weight: 700;\n    color: #bdc6d0;\n}\n.select2-container--bootstrap4 .select2-selection--multiple .select2-selection__choice__remove:hover {\n    color: #343a40;\n    display: none;\n}\n.select2-container--bootstrap4 .select2-selection--multiple .select2-selection__clear {\n    position: absolute !important;\n    top: 0;\n    right: 0.7em;\n    float: none;\n    margin-right: 0;\n}\n.select2-container--bootstrap4.select2-container--disabled .select2-selection--multiple .select2-selection__choice {\n    padding: 0 5px;\n    cursor: not-allowed;\n}\n.select2-container--bootstrap4.select2-container--disabled\n    .select2-selection--multiple\n    .select2-selection__choice\n    .select2-selection__choice__remove {\n    display: none;\n}\n.select-option .select2-container--bootstrap4 .select2-selection--multiple .select2-selection__rendered {\n    height: 42px;\n}\n.select-option .select2-container--bootstrap4 .select2-selection {\n    border: 1px solid #0b3454;\n    height: 42px;\n    border-radius: 6px;\n}\n.select-option .select2-container--bootstrap4.select2-container--focus .select2-selection {\n    border-color: #0b3454;\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n    box-shadow: 0 0 0 0 rgba(0, 123, 255, 0.25);\n}\n.select2-container .select2-search--inline .select2-search__field {\n    margin: 0 !important;\n    padding: 5px 10px !important;\n}\n.select2-container--bootstrap4 .select2-selection {\n    border: 1px solid #0b34544d !important;\n    border-radius: 6px !important;\n    height: 45px !important;\n    font-weight: 500 !important;\n    display: flex;\n    align-items: center;\n}\n.select2-container--bootstrap4 .select2-selection--multiple .select2-selection__clear {\n    margin: auto;\n    top: 0;\n    bottom: 0;\n}\n.select2-container--bootstrap4 .select2-selection {\n    display: flex !important;\n    align-items: center;\n}\n.select2-container--bootstrap4 .select2-selection--multiple .select2-search__field {\n    margin: 0;\n}\n.select2-container--bootstrap4 .select2-selection--multiple .select2-selection__choice {\n    margin: 2px 4px 2px 0 !important;\n}\n.select2-container--bootstrap4 .select2-selection--multiple .select2-search__field {\n    color: #495057;\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e\");\n    background-repeat: no-repeat;\n    background-position: right 0.75rem center;\n    background-size: 16px 12px;\n}\n.custom-select-multi .select2-container--bootstrap4 .select2-selection {\n    height: 45px;\n    border-color: #b5c2cb;\n    box-shadow: none;\n}\n.custom-select-multi .select2-container--bootstrap4 .select2-selection .select2-search__field {\n    margin: 0;\n    height: 43px;\n    width: 100% !important;\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e\");\n    background-repeat: no-repeat;\n    background-position: right 0.75rem center;\n    background-size: 16px 12px;\n}\n.section-edit .select2-container--bootstrap4 .select2-selection {\n    height: 55px !important;\n    border-radius: 3px !important;\n}\n/* multi select end*/\n\n.card_form .custom-border-84-20 {\n    border: 1px solid #0b345480;\n    border-radius: 5px;\n    width: 20px;\n    height: 20px;\n    margin: 0 10px 0 0;\n    position: static;\n}\n.card_form .custom-border-84-20:checked[type='radio'] {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/%3e%3c/svg%3e\") !important;\n    background-color: #5cae48 !important;\n    border-color: #5cae48 !important;\n    box-shadow: none;\n}\n.inputfile_parent label {\n    height: 80px;\n    line-height: 60px;\n}\n.action_btns {\n    background: #f5faff;\n    border-radius: 6px;\n    padding: 18px;\n    min-height: 80px;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n}\n.action_btns .btn-submit {\n    background: #29a745;\n    height: 45px;\n    border-radius: 25px;\n    min-width: 180px;\n    font-size: 16px;\n    font-weight: 500;\n    margin: 0 10px;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    text-decoration: none;\n}\n.action_btns .btn-submit:hover {\n    background: #1b9737;\n}\n.action_btns .btn-cancel {\n    width: auto;\n    height: auto;\n    background: none;\n    font-size: 12px;\n    text-transform: uppercase;\n    color: #00000098;\n    font-weight: 600;\n    margin: 0 10px;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.action_btns .btn-cancel:hover {\n    color: #000;\n}\n.action_btns .btn-viewsummary {\n    background: #0b3454;\n    height: 45px;\n    border-radius: 25px;\n    min-width: 180px;\n    font-size: 16px;\n    font-weight: 500;\n    margin: 0 10px;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    color: #fff;\n}\n.action_btns .btn-viewsummary:hover {\n    background: #0c8db6;\n}\n.form-switch .form-check-input {\n    width: 60px;\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%280, 0, 0, 0.25%29'/%3e%3c/svg%3e\");\n    background-position: left center;\n    border-radius: 2em;\n    transition: background-position 0.15s ease-in-out;\n    height: 28px;\n}\n.form-switch .form-check-input:checked {\n    background-position: right center;\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\");\n}\n.alumni_profile_brife_tab.student_profile_brife_tab {\n    margin-bottom: 5px;\n    overflow: auto;\n    padding-bottom: 20px;\n}\n.alumni_profile_brife_tab.student_profile_brife_tab {\n    margin-bottom: 5px;\n    overflow: auto;\n    padding-bottom: 20px;\n    scrollbar-width: thin;\n}\n.alumni_profile_brife_tab.student_profile_brife_tab .nav {\n    justify-content: center;\n    width: max-content;\n}\n.alumni_profile_brife_tab::-webkit-scrollbar {\n    height: 4px;\n}\n.alumni_profile_brife_tab::-webkit-scrollbar-track {\n    background: #ccc;\n}\n.alumni_profile_brife_tab::-webkit-scrollbar-thumb {\n    background-color: #eee;\n    border-radius: 2px;\n    border: 1px solid #ccc;\n}\n.tab-pane-tab {\n    border: 0;\n}\n.tab-pane-tab .nav-item .nav-link {\n    border: 1px solid #a9abae;\n    padding: 0 20px;\n    border-radius: 25px;\n    height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 130px;\n    color: #374050;\n}\n.tab-pane-tab .nav-item:not(:last-child) {\n    margin-right: 10px;\n}\n.tab-pane-tab .nav-item .nav-link.active,\n.tab-pane-tab .nav-item:hover .nav-link {\n    border: 1px solid #5cae48;\n    background: #5cae48;\n    color: #fff;\n}\n.modal .icon.icon-cross.btn-delete {\n    position: absolute;\n    right: 20px;\n    top: 20px;\n    border-radius: 50%;\n    background: #d42941;\n    font-size: 8px;\n    padding: 5px;\n    width: 20px;\n    height: 20px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: #fff;\n}\n.custom-switch {\n    padding: 0;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n}\n.custom-switch label {\n    background: #fff;\n    padding: 5px;\n    border-radius: 25px;\n    position: relative;\n    width: 100px;\n    height: 40px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    align-items: center;\n    cursor: pointer;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    border: 2px solid #f34e65;\n    color: #f34e65;\n}\n.custom-switch input + label::before {\n    width: 24px;\n    height: 24px;\n    display: inline-block;\n    background: #f34e65;\n    border-radius: 50%;\n    content: '';\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.custom-switch input + label::after {\n    content: 'NO';\n    color: #f34e65;\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    text-align: center;\n    font-weight: 500;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.custom-switch input:checked + label {\n    background: #5dae48;\n    border-color: #5dae48;\n}\n.custom-switch input:checked + label::before {\n    transform: translateX(62px);\n    -webkit-transform: translateX(62px);\n    -moz-transform: translateX(62px);\n    -ms-transform: translateX(62px);\n    -o-transform: translateX(62px);\n    background: #fff;\n}\n.custom-switch input:checked + label::after {\n    transform: translateX(-30px);\n    content: 'YES';\n    -webkit-transform: translateX(-30px);\n    -moz-transform: translateX(-30px);\n    -ms-transform: translateX(-30px);\n    -o-transform: translateX(-30px);\n    color: #fff;\n}\n\n@media (max-width: 991px) {\n    div.table-responsive table.sticky_table_3_columns td,\n    div.table-responsive table.sticky_table_3_columns th {\n        position: static;\n    }\n    div.table-responsive table.sticky_table_3_columns_noaction td,\n    div.table-responsive table.sticky_table_3_columns_noaction th {\n        position: static;\n    }\n    div.table-responsive table.sticky_table_4_columns td,\n    div.table-responsive table.sticky_table_4_columns th {\n        position: static;\n    }\n}\n\n@media (min-width: 767px) {\n    .table-responsive.attendee_dtl.sticky-table > table td:first-child,\n    .table-responsive.attendee_dtl.sticky-table > table th:first-child {\n        position: sticky;\n        left: 0;\n        z-index: 2;\n    }\n    .table-responsive.attendee_dtl.sticky-table > table td:nth-child(2),\n    .table-responsive.attendee_dtl.sticky-table > table th:nth-child(2) {\n        position: sticky;\n        left: 232px;\n        z-index: 2;\n    }\n    .table-responsive.attendee_dtl.sticky-table > table td:first-child:before,\n    .table-responsive.attendee_dtl.sticky-table > table td:nth-child(2):before {\n        content: '';\n        position: absolute;\n        top: 0;\n        left: 0;\n        bottom: 0;\n        right: 0;\n        margin: auto;\n        background: #fff;\n    }\n    .table-responsive.attendee_dtl.sticky-table > table td:first-child div,\n    .table-responsive.attendee_dtl.sticky-table > table td:nth-child(2) div {\n        z-index: 1;\n        position: relative;\n    }\n    .table-responsive.attendee_dtl.sticky-table > table th:nth-child(2)::after,\n    .table-responsive.attendee_dtl.sticky-table > table td:nth-child(2)::after {\n        content: '';\n        background: transparent linear-gradient(270deg, #ffffff 0%, #000000 100%) 0% 0% no-repeat padding-box;\n        opacity: 0.1;\n        width: 30px;\n        position: absolute;\n        right: -30px;\n        bottom: 0;\n        top: 0;\n    }\n    .table-responsive.attendee_dtl.sticky-table > table td:nth-child(3),\n    .table-responsive.attendee_dtl.sticky-table > table th:nth-child(3) {\n        padding-left: 30px;\n        width: 150px;\n    }\n    .table-responsive.sticky-table {\n        overflow-x: scroll;\n        scrollbar-width: thin;\n    }\n    .table-responsive.sticky-table::-webkit-scrollbar {\n        height: 4px;\n    }\n    .table-responsive.sticky-table::-webkit-scrollbar-track {\n        background: #f1f1f1;\n    }\n    .table-responsive.sticky-table::-webkit-scrollbar-thumb {\n        background: #888;\n    }\n    .table-responsive.sticky-table::-webkit-scrollbar-thumb:hover {\n        background: #555;\n    }\n}\n\n@media (max-width: 1138px) {\n    .alumni_statistics .horizontalScrol {\n        overflow-x: auto;\n        padding-bottom: 15px;\n    }\n    .alumni_statistics .horizontalScrol::-webkit-scrollbar {\n        height: 3px;\n    }\n    .alumni_statistics .horizontalScrol::-moz-scrollbar {\n        height: 3px;\n    }\n    .alumni_statistics .horizontalScrol::-webkit-scrollbar-track {\n        background: #eee;\n    }\n    .alumni_statistics .horizontalScrol::-webkit-scrollbar-thumb {\n        background-color: #666;\n        border-radius: 20px;\n        border: 2px solid #666;\n    }\n    .alumni_statistics .top-colleges .nav {\n        flex-wrap: nowrap;\n        justify-content: start !important;\n    }\n}\n\n@media (max-width: 800px) {\n    .alumni_statistics .top-colleges .slider {\n        padding: 0;\n    }\n    .half-gray:before {\n        display: none;\n    }\n}\n\n@media (max-width: 575px) {\n    .alumni_statistics .top-countries .caountryname,\n    .alumni_statistics .top-countries .career {\n        width: 100% !important;\n        margin-bottom: 5px;\n    }\n    .alumni_statistics .top-countries .flex-grow-1 {\n        width: calc(100% - 50px);\n    }\n    .alumni_statistics .top-countries .w-10 {\n        width: 50px;\n    }\n    .alumni_statistics .card_profiles .action_btns {\n        justify-content: start !important;\n        flex-wrap: wrap;\n    }\n    .alumni_statistics .card_profiles .action_btns .btn-outline-primary {\n        margin-bottom: 10px;\n    }\n    .alumni_statistics .card_profiles figure.student {\n        width: 50px;\n        height: 50px;\n        left: 20px;\n    }\n    .alumni_statistics .card_profiles .student_details h2 {\n        margin: 0 0 10px 60px;\n    }\n    .alumni_statistics .card_profiles .student_details .sub_details figure {\n        min-width: 50px;\n        height: 50px;\n        width: 50px;\n    }\n    .univarsity_logo .logo img {\n        max-width: 150px;\n    }\n}\n\n@media (max-width: 480px) {\n    .alumni_profile_college_name_other_detail_wrap .phone_number {\n        width: 100%;\n        margin-bottom: 10px;\n    }\n}\n\n.single-column ~ .btn-delete {\n    left: 50%;\n    right: auto;\n}\n.single-column + .col-sm-6 ~ .btn-delete {\n    left: 100%;\n}\n\n@media (max-width: 575px) {\n    .single-column ~ .btn-delete {\n        left: 100%;\n    }\n}\n\n.menu-label-child {\n    font-size: 18px;\n    font-weight: 500;\n    margin-bottom: 5px;\n    color: #26a7df;\n}\n\n.infinite-scroll-component {\n    overflow-y: auto !important;\n    overflow-x: hidden !important;\n}\n.form-select.assessment-select {\n    width: 100%;\n    max-width: 287px;\n    border-radius: 25px;\n    margin-right: 10px;\n}\n\n.mobile-select {\n    display: none;\n}\n\n@media (max-width: 800px) {\n    .headerRightSide .form-select.assessment-select {\n        display: none;\n    }\n    .mobile-select {\n        display: block;\n        padding: 15px 4% 15px;\n        background: #0b3454;\n    }\n    .mobile-select .form-select.assessment-select {\n        width: 100%;\n        max-width: 100%;\n    }\n}\n\n/* broadcast form */\n\n.responses_section {\n    margin-top: 10px;\n}\n.responses_list {\n    background: #f3f3f3 0% 0% no-repeat padding-box;\n    border-radius: 6px;\n    margin-bottom: 5px;\n    height: 56px;\n    display: flex;\n    align-items: center;\n    padding: 0 20px;\n}\n.responses_list .responses {\n    width: 255px;\n}\n.responses_section .btn {\n    margin-top: 20px;\n}\n.responses_section .btn:focus {\n    box-shadow: none;\n}\n.responses_section .btn:focus-visible {\n    outline: none;\n}\n.responses_list select {\n    border: 2px solid #7d7d7d;\n    border-radius: 18px;\n    width: 130px;\n    height: 36px;\n    -moz-appearance: none;\n    -o-appearance: none;\n    -ms-appearance: none;\n    -webkit-appearance: none;\n    appearance: none;\n    background-color: #fff;\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e\");\n    background-repeat: no-repeat;\n    background-position: right 0.75rem center;\n    background-size: 16px 12px;\n    padding: 0 12px;\n}\n.uploaded-list {\n    background: #ffffff 0% 0% no-repeat padding-box;\n    border: 1px solid #d1d1d1;\n    border-radius: 6px;\n    margin-bottom: 5px;\n    height: 50px;\n    display: flex;\n    align-items: center;\n    padding: 10px 20px;\n    position: relative;\n}\n.file-type {\n    width: 22px;\n    margin-right: 10px;\n}\n.file-type img {\n    width: 100%;\n}\n.uploaded-list label {\n    font-size: 16px;\n    font-weight: 400;\n}\n.uploaded-list .btn-close {\n    width: 8px;\n    height: 10px;\n    padding: 0;\n    position: absolute;\n    right: -20px;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    opacity: 0.4;\n}\n.customselect_parnt .custom-select {\n    position: relative;\n    width: max-content;\n    flex: unset;\n    min-width: 109px;\n}\n.customselect_parnt .custom-select select {\n    display: none; /*hide original SELECT element: */\n}\n.customselect_parnt .select-selected {\n    background-color: DodgerBlue;\n}\n.customselect_parnt .select-selected:after {\n    position: absolute;\n    content: '';\n    top: 14px;\n    right: 10px;\n    width: 0;\n    height: 0;\n    border: 6px solid transparent;\n    border-color: #fff transparent transparent transparent;\n}\n.customselect_parnt .select-selected.select-arrow-active:after {\n    border-color: transparent transparent #fff transparent;\n    top: 7px;\n}\n.customselect_parnt .select-selected {\n    color: #414141;\n    padding: 0px 40px 0 14px;\n    border: 2px solid #7d7d7d;\n    border-color: #7d7d7d;\n    cursor: pointer;\n    border-radius: 18px;\n    height: 32px;\n    width: max-content;\n    transition: all 0.3s ease-in-out;\n    background: #fff;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 32px;\n    min-width: 55px;\n    box-sizing: initial;\n    border-radius: 18px;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n    max-width: 55px;\n}\n.customselect_parnt .select-selected::after {\n    position: absolute;\n    content: '';\n    top: 12px;\n    right: 20px;\n    width: 8px;\n    height: 8px;\n    border: unset;\n    border-top: 2px solid #414141;\n    border-right: 2px solid #414141;\n    -moz-transform: rotate(135deg);\n    -webkit-transform: rotate(135deg);\n    -o-transform: rotate(135deg);\n    -ms-transform: rotate(135deg);\n    transform: rotate(135deg);\n    -webkit-transition: all 0.2s ease-in-out;\n    -moz-transition: all 0.2s ease-in-out;\n    -ms-transition: all 0.2s ease-in-out;\n    -o-transition: all 0.2s ease-in-out;\n    transition: all 0.2s ease-in-out;\n}\n.customselect_parnt .select-selected.select-arrow-active::after {\n    border: unset;\n    top: 15px;\n    border-top: 2px solid #7d7d7d;\n    border-right: 2px solid #7d7d7d;\n    transform: rotate(-45deg);\n    width: 10px;\n    height: 10px;\n    right: 12px;\n}\n.customselect_parnt .select-items div {\n    color: #000000;\n    padding: 3px 16px;\n    border: 0px solid transparent;\n    border-color: transparent transparent rgba(0, 0, 0, 0.1) transparent;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 500;\n}\n.customselect_parnt .select-items div:first-child {\n    margin-top: 10px;\n}\n.customselect_parnt .select-items div:last-child {\n    margin-bottom: 10px;\n}\n.customselect_parnt .select-items {\n    position: absolute;\n    background-color: #fff;\n    top: 100%;\n    left: 0;\n    right: 0;\n    z-index: 99;\n    border: 1px solid #dedede;\n    border-radius: 18px;\n    box-shadow: 0px 10px 20px #0000001a;\n    width: 145px;\n}\n.customselect_parnt .select-hide {\n    display: none;\n}\n.customselect_parnt .select-items div:hover,\n.customselect_parnt .same-as-selected {\n    background-color: rgba(0, 0, 0, 0.1);\n}\n.send_msg_text {\n    width: max-content;\n}\n.send_msg_text > a {\n    width: 150px;\n    height: 70px;\n    background: #5cae48;\n    border-radius: 10px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    color: #fff;\n    text-decoration: none;\n    font-size: 16px;\n    line-height: 23px;\n    font-weight: 500;\n}\n.send_msg_text > a:not(:last-child) {\n    margin-right: 10px;\n}\n.uniprof_btnmbl_align.paddings-67 {\n    padding-left: 20px;\n}\n.welcome_pg {\n    padding-left: 50px;\n    padding-right: 50px;\n}\n.cpw_bg {\n    padding: 40px;\n    background: #f8f8f8;\n    border-radius: 8px;\n    margin: 0 0 30px 0;\n}\n.cpw_bg > div {\n    width: 94%;\n    max-width: 385px;\n    margin: 0 auto;\n}\n.icon-green-right {\n    width: 48px;\n    height: 48px;\n    background: #3bb54a;\n    border-radius: 50%;\n    margin: auto auto 25px;\n    position: relative;\n}\n.icon-green-right:after {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    margin: auto;\n    width: 23px;\n    height: 13px;\n    border-left: 5px solid #fff;\n    border-bottom: 5px solid #fff;\n    content: '';\n    transform: rotate(-45deg);\n    top: -7px;\n}\n.searchrw {\n    position: relative;\n    background: #f1f1f1;\n    padding: 30px;\n    border-radius: 6px;\n}\n.searchrw .btn.icon-search {\n    position: absolute;\n    padding: 0;\n    left: 15px;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n}\nform.lstCustForm .searchrw input.form-control {\n    border: 1px solid #e1e1e1;\n    border-radius: 20px;\n    padding: 0 0 0 50px;\n}\n.search_sugg .chkboxal {\n    position: relative;\n    padding-right: 35px;\n}\n.search_sugg .chkboxal .form-check {\n    position: absolute;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    left: auto;\n    margin: auto;\n}\nform.lstCustForm .search_sugg .chkboxal .form-check .form-check-input {\n    width: 20px;\n    height: 20px;\n    margin-left: 0;\n}\nselect {\n    cursor: pointer;\n}\n\n@media (max-width: 575px) {\n    form.lstCustForm .inputfile_parent label span.uploadlabel {\n        line-height: 18px;\n        white-space: normal;\n    }\n    .uploaded-list label {\n        line-height: 16px;\n    }\n}\n\n.lstCustForm .ql-toolbar.ql-snow {\n    border-radius: 5px 5px 0 0;\n    -webkit-border-radius: 5px 5px 0 0;\n    -moz-border-radius: 5px 5px 0 0;\n    -ms-border-radius: 5px 5px 0 0;\n    -o-border-radius: 5px 5px 0 0;\n}\n.lstCustForm .ql-container.ql-snow {\n    border-radius: 0 0 5px 5px;\n    -webkit-border-radius: 0 0 5px 5px;\n    -moz-border-radius: 0 0 5px 5px;\n    -ms-border-radius: 0 0 5px 5px;\n    -o-border-radius: 0 0 5px 5px;\n    min-height: 250px;\n}\n.lstCustForm .ql-container.ql-snow .ql-editor {\n    min-height: 250px;\n}\n\nh2.title::after {\n    content: '';\n    width: 40px;\n    height: 2px;\n    background: #2680eb;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n}\nh2.title.text-center::after {\n    right: 0;\n    margin: auto;\n}\n\n.btn-takeTest {\n    border: 2px solid #0b3454;\n    height: 40px;\n    border-radius: 25px;\n    padding: 0 25px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    text-decoration: none;\n    font-weight: 500;\n    color: #0b3454;\n    background: #fff;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.btn-takeTest:hover {\n    background: #0b3454;\n    color: #fff;\n}\n\n.select-search-group .form-select {\n    border-top-left-radius: 25px !important;\n    border-bottom-left-radius: 25px !important;\n    padding-left: 20px;\n}\n\n.package-wrap {\n    margin: 20px auto 0px auto;\n    display: inline-flex;\n    flex-wrap: wrap;\n    width: 100%;\n}\n.package-list-type {\n    display: flex;\n    border-bottom: 1px solid #dfe1e4;\n    border-right: 1px solid #dfe1e4;\n    border-radius: 0 0 6px 0;\n    position: relative;\n    width: calc(100% - 300px);\n    overflow: auto;\n}\n.package-list-type {\n    overflow-x: auto;\n    scrollbar-width: thin;\n}\n.package-list-type::-webkit-scrollbar {\n    height: 5px;\n}\n.package-list-type::-webkit-scrollbar-track {\n    background: #ccc;\n}\n.package-list-type::-webkit-scrollbar-thumb {\n    background-color: #333;\n    border-radius: 2px;\n    border: 1px solid #ccc;\n}\n\n.package-list-title {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    font-size: 16px;\n    font-weight: 600;\n    height: 50px;\n}\n.package-list-title label {\n    margin-right: 10px;\n}\n.package-list .package-list-title + ul {\n    margin-top: 0;\n}\n.package-list ul {\n    list-style: none;\n    margin: 50px 0 0 0;\n    padding: 0px 0 10px;\n    background: #fff;\n    border-radius: 6px 0px 0px 6px;\n    border: 1px solid #dfe1e4;\n    border-right: none;\n}\n.package-list ul li {\n    padding: 0 40px;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 23px;\n    height: 60px;\n    display: flex;\n    align-items: center;\n}\n.package-list ul li span {\n    line-height: 20px;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n.package-list ul li:nth-child(even) {\n    background: #f6f8fa;\n}\n.package-type {\n    flex: 1;\n    min-width: 178px;\n    position: relative;\n}\n.package-type ul {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n}\n.package-list {\n    width: 300px;\n}\n.package-type ul li {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.package-type-header {\n    border-radius: 6px 6px 0px 0px;\n    opacity: 1;\n    height: 50px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #fff;\n    font-weight: 500;\n    font-size: 20px;\n}\n.package-type-header.starter {\n    background: transparent linear-gradient(270deg, #168abc 0%, #25a1d6 34%, #2596c7 66%, #228aaa 100%);\n}\n.package-type-header.bronze {\n    background: transparent linear-gradient(270deg, #a96b4d 0%, #d7a169 34%, #d7a068 66%, #8f4c2e 100%);\n}\n.package-type-header.sliver {\n    background: transparent linear-gradient(270deg, #858585 0%, #9598a0 34%, #b3b6bd 66%, #828280 100%);\n}\n.package-type-header.gold {\n    background: transparent linear-gradient(270deg, #d0b211 0%, #d9c246 34%, #d8c63d 66%, #c8993f 100%);\n}\n.package-type-header.defaultHeader {\n    border: 1px solid #dfe1e4;\n    height: 51px;\n    color: #000;\n    font-size: 16px;\n}\n.package-type-body {\n    border-left: 1px solid #dfe1e4;\n    border-right: 1px solid #dfe1e4;\n    padding: 1px 0 10px;\n    background-color: #fff;\n}\n.package-type:not(:last-child) {\n    margin-right: 10px;\n}\n.package-type ul li {\n    height: 60px;\n}\n.package-type ul li:nth-child(even) {\n    background: #f6f8fa;\n}\n.package-type-body .form-check-input {\n    position: static;\n    margin: 0;\n    width: 23px;\n    height: 23px;\n    border: 1px solid #0b345480;\n    border-radius: 4px;\n    opacity: 1;\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23CAD4DB' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/%3e%3c/svg%3e\");\n    background-size: 21px;\n}\n.package-type-body .form-check-input:checked {\n    background-color: #29a745;\n    border-color: #29a745;\n}\n\n.package-type:last-child {\n    border-radius: 0 0 10px 0;\n    overflow: hidden;\n}\n.package-list-type:before {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    border: 0;\n    height: calc(100% - 50px);\n    background: white;\n    border-radius: 0 0 6px;\n    top: 50px;\n}\n\n.package-wrap .slimScrollDiv {\n    flex: auto;\n    height: auto !important;\n    overflow: visible !important;\n}\n.package-wrap .slimScrollDiv .package-list-type {\n    width: 100% !important;\n    height: 100% !important;\n}\n.slimScrollWrapper {\n    position: sticky;\n    bottom: 20px;\n}\n\n@media (max-width: 575px) {\n    .package-list {\n        width: 150px;\n    }\n    .package-list ul li {\n        padding: 0 15px;\n    }\n    .package-list-type {\n        width: calc(100% - 150px);\n    }\n}\n\n.option ul {\n    list-style: none;\n    margin: 11px 0;\n    text-align: left;\n    border: 1px solid #ccc;\n    padding: 10px;\n    border-radius: 5px;\n    font-size: 14px;\n    line-height: 18px;\n    position: relative;\n}\n.option ul li:not(:last-child) {\n    margin-bottom: 7px;\n}\n.option ul:before {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    margin: auto;\n    top: -6px;\n    width: 0;\n    height: 0;\n    border-left: 5px solid transparent;\n    border-right: 5px solid transparent;\n    border-bottom: 5px solid #ccc;\n}\n.option ul a {\n    font-size: 14px;\n}\n\n.icon-reset {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/reset.svg);\n    width: 15px;\n    height: 15px;\n    display: inline-block;\n    transform: scaleX(-1);\n    -webkit-transform: scaleX(-1);\n    -moz-transform: scaleX(-1);\n    -ms-transform: scaleX(-1);\n    -o-transform: scaleX(-1);\n}\n.btn-reset {\n    display: flex;\n    align-items: center;\n    color: #0b3454;\n    opacity: 0.8;\n    padding-left: 0;\n    padding-right: 0;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.btn-reset .icon-reset {\n    margin-right: 5px;\n}\n.btn-reset:hover {\n    opacity: 1;\n}\n\n.match-list {\n    padding: 0;\n    margin: 0;\n    list-style: none;\n}\n.match-list li {\n    position: relative;\n    padding-left: 10px;\n}\n.match-list li::before {\n    content: '';\n    width: 6px;\n    height: 6px;\n    background: #0a3454;\n    border-radius: 50%;\n    position: absolute;\n    left: 0;\n    top: 7px;\n    opacity: 0.3;\n}\n.match-list li a {\n    color: #0b3454;\n}\n.match-list li a:hover {\n    color: #5cae48;\n}\n.show-more-btn {\n    border: none;\n    background: none;\n    color: #099af3;\n}\n.show-more-btn:hover {\n    color: #5cae48;\n}\nfieldset .form-check-inline {\n    min-height: 45px;\n    display: inline-flex;\n    align-items: center;\n    margin-top: 2px;\n}\nfieldset .form-check-inline input {\n    margin-right: 5px;\n    width: 20px;\n    height: 20px;\n    transition: all 0.3s ease-in-out;\n}\nfieldset .form-check-inline .form-check-label {\n    margin-top: 2px;\n}\n.swal2-container {\n    z-index: 99999;\n}\n\n.btn-modal {\n    position: absolute;\n    right: 20px;\n    top: 20px;\n    width: 13px;\n    height: 13px;\n    padding: 0;\n    background-size: 100%;\n    z-index: 9;\n}\n\n.green-tick {\n    padding: 0;\n    margin: 0 0 20px;\n    list-style: none;\n}\n.green-tick li {\n    position: relative;\n    padding: 0 0 0 20px;\n}\n.green-tick li:not(:last-child) {\n    margin-bottom: 10px;\n}\n.green-tick li:before {\n    content: '';\n    position: absolute;\n    width: 12px;\n    height: 7px;\n    border-left: 3px solid #5cae48;\n    border-bottom: 3px solid #5cae48;\n    top: 8px;\n    left: 0;\n    transform: rotate(-45deg);\n    -webkit-transform: rotate(-45deg);\n    -moz-transform: rotate(-45deg);\n    -ms-transform: rotate(-45deg);\n    -o-transform: rotate(-45deg);\n}\n\n/* new csss for uei */\n.alumni-networks-block {\n    border: 1px solid #c8c8c8;\n    border-radius: 10px;\n    background: white;\n    padding: 30px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    box-shadow: 0 10px 12px 0px #ccc;\n    height: 100%;\n    text-align: center;\n}\n\n.alumni-networks-form .alumni-networks-block {\n    background: #ffffff;\n    box-shadow: 0px 3px 6px #0000001a;\n    border: 1px solid #d2d2d2;\n    border-radius: 6px;\n    -webkit-border-radius: 6px;\n    -moz-border-radius: 6px;\n    -ms-border-radius: 6px;\n    -o-border-radius: 6px;\n}\n\n.alumni-networks-block img {\n    margin-bottom: 30px;\n}\n\n.alumni-networks-block h4 {\n    margin-bottom: 20px;\n    color: #0b3454;\n    font-size: 20px;\n    font-weight: 500;\n}\n\n.alumni-networks-block-wrap {\n    position: relative;\n}\n\n.alumni-networks-block-wrap:before {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    background: #51499c;\n    height: 170px;\n}\n\n.alumni-networks-block-wrap.alumni-networks-form:before {\n    height: 300px;\n}\n\n.alumni-networks-header h1 {\n    color: #fff;\n    font-size: 36px;\n    font-weight: 600;\n    line-height: 37px;\n    margin-bottom: 20px;\n}\n\n.alumni-networks-header p {\n    color: #fff;\n    font-size: 20px;\n}\n\n.alumni-networks-block .btn-green {\n    width: 180px;\n    height: 45px;\n    font-size: 16px;\n}\n.center-block {\n    margin-left: auto;\n    margin-right: auto;\n    display: block;\n}\n\nlabel[for='agreeToUnivariety'] {\n    order: 1;\n}\n\n/* new css 05022024 */\n\n/* milestone */\n.welcome-title h1 {\n    font-size: 35px;\n    font-weight: 600;\n    margin: 0 0 5px;\n}\n.welcome-title p {\n    font-size: 18px;\n    margin: 0;\n}\n\n.milestone {\n    background: #fff;\n    box-shadow: 0px 3px 6px #0000001a;\n    border: 1px solid #d2d2d2;\n    border-radius: 6px;\n    height: 100%;\n    position: relative;\n    padding: 20px 20px 30px;\n    text-align: center;\n}\n.milestone .icon {\n    position: absolute;\n    left: 0;\n    right: 0;\n    margin: auto;\n    top: -33px;\n    background: #d42941;\n    width: 60px;\n    height: 60px;\n    border-radius: 50%;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: #fff;\n}\n.milestone .icon span {\n    font-size: 25px;\n    color: #fff;\n    transition: all 0.3s ease-in-out;\n}\nspan.icon-gear-hat {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/knowledge-management.svg) no-repeat 0\n        0 / 100%;\n    width: 28px;\n    height: 28px;\n    filter: invert(1);\n    transform: scaleX(-1);\n    -webkit-transform: scaleX(-1);\n    -moz-transform: scaleX(-1);\n    -ms-transform: scaleX(-1);\n    -o-transform: scaleX(-1);\n    -webkit-filter: invert(1);\n}\n.milestone .icon span:before {\n    color: #fff;\n}\n.milestone .count {\n    font-size: 22px;\n    font-weight: 600;\n    text-align: left;\n}\n.milestone .btn {\n    height: 40px;\n    text-align: center;\n    margin: auto;\n    display: inline-block;\n    padding: 0 25px;\n    border-radius: 25px;\n    line-height: 36px;\n    overflow: hidden;\n    position: relative;\n}\n.milestone .btn span,\n.btn-green span,\n.btn-liteblue span,\n.btn-invite span {\n    position: relative;\n}\n\n.milestone h3 {\n    text-align: center;\n    max-width: 162px;\n    margin: auto;\n    font-size: 20px;\n    font-weight: 600;\n}\n.milestone .count {\n    font-size: 22px;\n    font-weight: 600;\n}\n.milestone h3 {\n    text-align: center;\n    max-width: 162px;\n    margin: auto;\n    font-size: 20px;\n    font-weight: 600;\n}\n.milestone .progress-status {\n    padding: 0;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    text-align: center;\n    list-style: none;\n    justify-content: center;\n    align-items: center;\n    margin: 20px 0 0;\n}\n.milestone .progress-status li {\n    width: 40px;\n    height: 3px;\n    background: #dedede;\n    display: inline-block;\n    margin: 0 3px;\n}\n.milestone .progress-status li.completed {\n    background: #5cae48;\n}\n.activities_status {\n    font-size: 16px;\n    font-weight: 600;\n    text-align: center;\n    margin-bottom: 20px;\n    cursor: pointer;\n    padding: 15px 0 0 0;\n}\n\n.activities_status_hovercont ol {\n    margin: 0 0 0 20px;\n    padding: 0 10px 0 0;\n    text-align: left;\n}\n.activities_status_hovercont ol li {\n    line-height: 18px;\n}\n.activities_status_hovercont ol li:not(:last-child) {\n    margin: 0 0 8px 0;\n}\n.activities_status_hovercont {\n    background: #fff;\n    border: 1px solid #d2d2d2;\n    border-radius: 6px;\n    padding: 20px;\n    width: 270px;\n    height: 165px;\n    position: absolute;\n    top: -30px;\n    left: 0;\n    right: 0;\n    margin: auto;\n    box-shadow: 0px 3px 6px #0000001a;\n    display: none;\n}\n.activities_status_hovercont::after {\n    position: absolute;\n    content: '';\n    width: 23px;\n    height: 18px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/hover_after.png) left top no-repeat;\n    bottom: -18px;\n}\n.activities_status_hovercont > div {\n    height: 125px;\n    max-height: 125px;\n    font-size: 14px;\n    font-weight: 400;\n}\n.activities_status:hover .activities_status_hovercont {\n    display: block;\n    color: #000;\n}\n.activities_status:hover {\n    color: #26a7df;\n}\n.slimScrollDiv .slimScrollBar {\n    width: 4px !important;\n    background: #dedede !important;\n    opacity: 1 !important;\n    right: 0 !important;\n}\n.slimScrollDiv .slimScrollRail {\n    display: block !important;\n    width: 1px !important;\n    right: 1px !important;\n    opacity: 1 !important;\n    background: #676767 !important;\n    left: auto !important;\n}\n\n.activities_status_hovercont > div::-webkit-scrollbar {\n    scrollbar-width: thin;\n}\n\n.btn-verify {\n    background: linear-gradient(to right, #185584 50%, #0d3453 50%);\n    color: #fff;\n    width: 140px;\n    height: 40px;\n    line-height: 38px;\n    padding: 0 25px;\n    text-decoration: none;\n    border-radius: 25px;\n    text-align: center;\n    background-size: 200% 100%;\n    transition: all 0.5s;\n    background-position: right bottom;\n    border: 1px solid #0d3453;\n    font-size: 16px;\n    font-weight: 500;\n}\n.btn-border {\n    background: linear-gradient(to right, #185584 50%, #0d3453 50%);\n    color: #fff;\n    width: max-content;\n    height: 40px;\n    line-height: 38px;\n    padding: 0 25px;\n    text-decoration: none;\n    border-radius: 25px;\n    text-align: center;\n    background-size: 200% 100%;\n    transition: all 0.5s;\n    background-position: right bottom;\n    border: 1px solid #0d3453;\n    font-size: 16px;\n    font-weight: 500;\n    display: block;\n    margin: 0 auto;\n}\n.btn-border:hover,\n.btn-verify:hover {\n    background-position: left bottom;\n    color: #fff;\n    background-size: 201% 100%;\n}\n\n.icn_details .btn-green {\n    width: 140px;\n}\n.icn_details .btn-green span {\n    font-weight: 500;\n    font-size: 16px;\n}\n.icn_details .btn-green span.icon-correct::before {\n    font-size: 13px;\n}\na.dashb_arr {\n    width: 40px;\n    height: 40px;\n    background: #f1f1f1;\n    border-radius: 50%;\n    position: relative;\n    display: inline-block;\n}\na.dashb_left::before {\n    content: '';\n    width: 8px;\n    height: 8px;\n    background: transparent;\n    display: inline-block;\n    position: absolute;\n    left: 17px;\n    top: 0;\n    bottom: 0;\n    right: auto;\n    margin: auto;\n    border-top: 1.5px solid #000;\n    border-right: 1.5px solid #000;\n    transform: rotate(-135deg);\n}\na.dashb_right::before {\n    content: '';\n    width: 8px;\n    height: 8px;\n    background: transparent;\n    display: inline-block;\n    position: absolute;\n    left: 15px;\n    top: 0;\n    bottom: 0;\n    right: auto;\n    margin: auto;\n    border-top: 1.5px solid #000;\n    border-right: 1.5px solid #000;\n    transform: rotate(45deg);\n}\n.iconsec {\n    height: 50px;\n    width: 50px;\n    background: #d42941;\n    border-radius: 50%;\n}\n.iconsec > b {\n    color: #fff;\n    font-size: 23px;\n}\n.icn_details {\n    background: #ffffff;\n    box-shadow: 0px 3px 6px #0000001a;\n    border: 1px solid #d2d2d2;\n    border-radius: 6px;\n    padding: 25px 30px;\n}\n.iconsec_title {\n    font-weight: 500;\n    font-size: 18px;\n    color: #000;\n    margin: 0;\n}\n.iconsec_cont {\n    font-weight: 400;\n    font-size: 16px;\n    color: #000;\n    display: none;\n    margin: 0 0 8px;\n}\n.iconsec_link {\n    text-decoration: underline;\n    color: #147ad6;\n    font-size: 14px;\n}\n.iconsec_link:hover {\n    text-decoration: none;\n}\n.iconsec_link .readmore {\n    display: block;\n}\n.iconsec_link .readless {\n    display: none;\n}\n.iconsec_link.active .readmore {\n    display: none;\n}\n.iconsec_link.active .readless {\n    display: block;\n}\n.profile_setup_cont .row > .profile_setup {\n    width: calc(100% - 330px);\n}\n.profile_setup_cont .row > .profile_setup_help {\n    width: 304px;\n    height: auto;\n    background: transparent linear-gradient(180deg, #ffffff 0%, #f8f8f8 100%);\n    border: 1px solid #e1e1e1;\n    border-radius: 6px;\n    padding: 30px;\n    text-align: center;\n}\n.profile_setup > div:not(:last-child) {\n    margin: 0 0 15px;\n}\n.container.profile_setup_cont {\n    max-width: 100%;\n}\n.profile_setup_help > p:first-child {\n    width: 190px;\n    margin: auto;\n    text-align: center;\n}\n.custom-nav > ul li.nav-item a.nav-link.dropdown-toggle::after {\n    margin-left: 17px;\n    vertical-align: middle;\n    border-top: 7px solid;\n    border-right: 5px solid transparent;\n    border-left: 5px solid transparent;\n}\n.activities_status_hovercont ol {\n    margin: 0 0 0 20px;\n    padding: 0 10px 0 0;\n    text-align: left;\n}\n.activities_status_hovercont ol li {\n    line-height: 18px;\n}\n.activities_status_hovercont ol li:not(:last-child) {\n    margin: 0 0 8px 0;\n}\n.activities_status_hovercont {\n    background: #fff;\n    border: 1px solid #d2d2d2;\n    border-radius: 6px;\n    padding: 20px;\n    width: 270px;\n    height: 165px;\n    position: absolute;\n    top: -30px;\n    left: 0;\n    right: 0;\n    margin: auto;\n    box-shadow: 0px 3px 6px #0000001a;\n    display: none;\n}\n/*.activities_status_hovercont::after { position: absolute; content: \"\"; width: 15px; height: 15px; background: #fff; border-right: 1px solid #d2d2d2; transform: rotate(45deg); bottom: -8px; border-bottom: 1px solid #d2d2d2; box-shadow: 0px 3px 6px #0000001A; }*/\n.activities_status_hovercont::after {\n    position: absolute;\n    content: '';\n    width: 23px;\n    height: 18px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/hover_after.png) left top no-repeat;\n    bottom: -18px;\n}\n.activities_status_hovercont > div {\n    height: 125px;\n    max-height: 125px;\n    font-size: 14px;\n    font-weight: 400;\n}\n.activities_status:hover .activities_status_hovercont {\n    display: block;\n    color: #000;\n}\n.activities_status:hover {\n    color: #26a7df;\n}\n.slimScrollDiv .slimScrollBar {\n    width: 4px !important;\n    background: #dedede !important;\n    opacity: 1 !important;\n    right: 0 !important;\n}\n.slimScrollDiv .slimScrollRail {\n    display: block !important;\n    width: 1px !important;\n    right: 1px !important;\n    opacity: 1 !important;\n    background: #676767 !important;\n    left: auto !important;\n}\n\n.activities_status_hovercont > div::-webkit-scrollbar {\n    scrollbar-width: thin;\n}\n\n.profile_setup > div.icn_details:first-child .iconsec_cont {\n    display: block;\n}\n#dashboard-pills-tabContent .accordion-item .accordion-button:hover {\n    box-shadow: 0px 0px 5px #0000001a;\n    background: #fafafa;\n    border-radius: 5px;\n}\n#dashboard-pills-tabContent .accordion-item .accordion-button[aria-expanded='true']:hover {\n    box-shadow: unset;\n    background: transparent;\n    border-radius: 5px;\n}\n.float_horizontal_animate {\n    transform: translatex(0px);\n    animation: float_horizontal 4s ease-in-out infinite;\n}\n\n.profilePicSection {\n    width: 200px;\n    height: 200px;\n    border: 1px dashed #707070;\n    border-radius: 50%;\n    margin: auto;\n    padding: 14px;\n}\n.profilePicSection .profileImg {\n    background: #e3e3e3;\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n}\n.profileImg.icon-user {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 145px;\n    color: #fff;\n}\n.editProfilePicSection {\n    overflow: hidden;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n}\n.editprofileImg::after {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    width: 172px;\n    height: 172px;\n    border: 2px solid #0b3454;\n    margin: auto;\n    border-radius: 50%;\n    box-shadow: 0 0 0 100px rgba(255, 255, 255, 0.5);\n}\n\n.slideRange {\n    -webkit-appearance: none;\n    width: 100%;\n    height: 5px;\n    border-radius: 5px;\n    background: #d3d3d3;\n    outline: none;\n    opacity: 0.7;\n    -webkit-transition: 0.2s;\n    transition: opacity 0.2s;\n}\n.slideRange::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    appearance: none;\n    width: 14px;\n    height: 14px;\n    border: 0;\n    background: #5cae48;\n    cursor: pointer;\n    border-radius: 50%;\n}\n.slideRange::-moz-range-thumb {\n    width: 14px;\n    height: 14px;\n    border: 0;\n    background: #5cae48;\n    cursor: pointer;\n}\n.slideRange::-ms-thumb {\n    width: 14px;\n    height: 14px;\n    border: 0;\n    background: #5cae48;\n    cursor: pointer;\n    border-radius: 50%;\n}\n/** Chrome*/\n.slideRange::-webkit-range-progress {\n    background-color: #5cae48;\n    height: 5px;\n    border-radius: 5px;\n}\n/** FF*/\ninput[type='range'].slideRange::-moz-range-progress {\n    background-color: #5cae48;\n    height: 5px;\n    border-radius: 5px;\n}\n/* IE*/\ninput[type='range'].slideRange::-ms-fill-lower {\n    background-color: #5cae48;\n    height: 5px;\n    border-radius: 5px;\n}\n\n@keyframes float_horizontal {\n    0% {\n        transform: translatex(0px);\n    }\n    50% {\n        transform: translatex(-10px);\n    }\n    100% {\n        transform: translatex(0px);\n    }\n}\n\n@media (max-width: 767px) {\n    .icn_details {\n        display: block !important;\n    }\n    .iconsec {\n        float: left;\n    }\n    .icn_details > .flex-1 {\n        float: left;\n        margin: 0 0 15px;\n        width: calc(100% - 70px);\n    }\n    .btn-verify,\n    .icn_details .btn-green {\n        display: flex;\n        clear: both;\n        margin: 0 auto 0 !important;\n        float: none;\n        text-align: center;\n        justify-content: center;\n    }\n    .profile_setup_cont .row > .profile_setup {\n        width: 100%;\n        margin: 0 0 30px 0;\n    }\n    .profile_setup_cont .row > .profile_setup_help {\n        width: 100%;\n        border-radius: 0;\n        border-left: 0 solid #fff;\n        border-right: 0 solid #fff;\n        border-bottom: 0 solid #fff;\n    }\n    .max-1140.profile_container {\n        width: 100%;\n    }\n    .profile_container .sideBar {\n        width: 94%;\n        margin: auto;\n    }\n    .profile_container .pageContent > div:first-child {\n        width: 94%;\n        margin: auto;\n        padding-top: 35px !important;\n    }\n    .profile_container .pageContent > div:first-child .welcome-title {\n        width: 100%;\n    }\n    .profile_container .container.profile_setup_cont {\n        width: 100%;\n        margin: 25px auto 25px !important;\n    }\n    .profile_setup_cont .row > .profile_setup {\n        width: 94%;\n        margin: 0 auto 30px auto;\n    }\n    .profile_container .footer {\n        margin: 0;\n    }\n    .dashboard .btn-green {\n        order: 1;\n        margin: 0 5px !important;\n    }\n    .dashboard .dashb_left {\n        order: 0;\n        margin: 0 !important;\n    }\n    .dashboard .dashb_right {\n        order: 2;\n    }\n    .profile_container .welcome-title h1 {\n        font-size: 30px;\n    }\n    .profile_setup_help > p:first-child {\n        width: 100%;\n    }\n}\n\n/* milestone */\n\n/* form start */\n\n/*form tab css*/\n/* .polartabsec {\n    padding: 18px 40px;\n    margin: 0;\n    background: #f2f9ff;\n    margin: 0 -40px;\n} */\n.xscroll {\n    width: 100%;\n    overflow-x: auto;\n    scrollbar-width: thin;\n    position: relative;\n    z-index: 8;\n}\n.polartabsec ul,\nul.horizontal-tab {\n    border-bottom: 0 solid #fff;\n    width: max-content;\n}\n.polartabsec ul li,\nul.horizontal-tab li {\n    background: transparent;\n    border: 0px solid #7d7d7d;\n    border-radius: 20px;\n    height: 40px;\n    padding: 0;\n}\n.polartabsec ul li:not(:last-child),\nul.horizontal-tab li:not(:last-child) {\n    margin: 0 10px 0 0;\n}\n.polartabsec ul li button.nav-link,\nul.horizontal-tab li button.nav-link {\n    color: #414141;\n    font-size: 16px;\n    font-weight: 500;\n    height: 40px;\n    line-height: 38px;\n    background: #fff;\n    border: 2px solid #7d7d7d;\n    padding: 0 23px;\n    border-radius: 20px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    -webkit-border-radius: 20px;\n    -moz-border-radius: 20px;\n    -ms-border-radius: 20px;\n    -o-border-radius: 20px;\n}\n.polartabsec ul li button.nav-link:focus-visible,\nul.horizontal-tab li button.nav-link:focus-visible {\n    outline: none;\n}\n.polartabsec ul li button.nav-link.active,\n.polartabsec ul li button.nav-link:hover,\nul.horizontal-tab li button.nav-link.active,\nul.horizontal-tab li button.nav-link:hover {\n    color: #fff;\n}\n.polartabsec ul li button.nav-link.active,\n.polartabsec ul li button.nav-link:hover,\nul.horizontal-tab li button.nav-link.active,\nul.horizontal-tab li button.nav-link:hover {\n    color: #fff;\n    border: 2px solid #5cae48;\n    background: #5cae48;\n}\n.polartabsec ul.social-integrations li button.nav-link.active,\n.polartabsec ul.social-integrations li button.nav-link:hover {\n    color: #fff;\n    border: 2px solid #0b3454;\n    background: #0b3454;\n}\n.polartabsec ul li button.nav-link i {\n    width: 20px;\n    height: 20px;\n    display: inline-block;\n    border-radius: 4px;\n    margin-right: 6px;\n}\n.polartabsec ul li button.nav-link i.facebook {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/tab-facebook.svg) no-repeat 0 0;\n}\n.polartabsec ul li button.nav-link i.linkedin {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/tab-linkedin.svg) no-repeat 0 0;\n}\n.polartabsec ul li button.nav-link i.instagram {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/tab-instagram.png) no-repeat 0 0;\n}\n\n.JobInternshipForm {\n    width: 94%;\n    max-width: 670px;\n    display: none;\n}\n.JobInternshipForm h2 {\n    border-bottom: 1px solid rgba(125, 125, 125, 0.3);\n    padding: 0 0 10px;\n    margin: 0 0 40px;\n}\nform.lstCustForm .form-select,\nform.lstCustForm input.form-control {\n    border: 1px solid #848484;\n    height: 45px;\n}\nform.lstCustForm textarea.form-control {\n    border: 1px solid #848484;\n}\nform.lstCustForm .form-check .form-check-input {\n    width: 24px;\n    height: 24px;\n    margin-left: 0px;\n    border: 2px solid #848484;\n}\nform.lstCustForm .form-check:not(:last-child) {\n    margin: 0 40px 5px 0;\n}\nform.lstCustForm .btn-greenm,\n.btn-greenm252 {\n    min-width: 252px;\n}\nform.lstCustForm label span {\n    font-size: 14px;\n    color: #848484;\n    font-weight: 400;\n    font-style: italic;\n    float: right;\n    display: inline-block;\n    padding: 0 0 0 20px;\n}\nform.lstCustForm .inputfile_parent label span.uploadlabel {\n    font-size: 16px;\n    color: #414141;\n    font-weight: 400;\n    float: right;\n    display: inline-block;\n    padding: 0 0 0 8px;\n    font-style: normal;\n}\nform.lstCustForm label span.icon {\n    font-style: unset;\n    color: #414141;\n}\n.fileclose {\n    height: 12px;\n    line-height: 10px;\n    width: 12px;\n    text-align: center;\n    background: #959595;\n    border-radius: 50%;\n    color: #fff;\n    font-size: 12px;\n    cursor: pointer;\n    display: none;\n    margin-left: 6px;\n    justify-content: center;\n    align-items: center;\n}\n.fileclose span {\n    font-size: 6px;\n    display: block;\n    margin: 0 0 0px 1px;\n}\n.fileicon {\n    display: none;\n    margin-right: 6px;\n}\n.docselect {\n    display: none;\n    align-items: center;\n    width: max-content;\n}\n.docselect.docseladdbg {\n    background: #f8f8f8;\n    display: flex;\n    padding: 7px 12px;\n    margin: 10px 0 0 0;\n    border-radius: 6px;\n}\n.inputfile::file-selector-button {\n    font: inherit;\n    display: none;\n}\n.inputfile_parent label {\n    color: #f1e5e6;\n    background-color: #f3f3f300;\n    border: 1px dashed #848484;\n    border-radius: 6px;\n    height: 60px;\n    line-height: 60px;\n    max-width: 100%;\n    font-size: 1.25rem;\n    font-weight: 500;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    cursor: pointer;\n    display: inline-block;\n    overflow: hidden;\n    padding: 0;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.albmform .inputfile_parent label {\n    height: 80px;\n    line-height: 80px;\n}\n.inputfile_parent label span {\n    font-size: 16px;\n    color: #414141;\n    font-weight: 500;\n    font-style: unset;\n    float: none;\n    padding: 0 0 0 10px;\n}\n.inputfile_parent {\n    position: relative;\n    height: auto;\n}\n.inputfile_parent.profile .docselect {\n    display: none;\n}\n.inputfile_parent.profile.select + p {\n    display: none;\n}\n.inputfile_parent.profile label {\n    background-color: #fff;\n    border: 1px dashed #a8c5dd;\n    border-radius: 6px;\n    height: 40px;\n    line-height: 40px;\n}\n.inputfile_parent.profile.select .docseladdbg {\n    display: flex;\n    background: #eaeaea;\n}\n.inputfile_parent.profile.pop-up label {\n    background: #f3f3f3;\n    border: 1px dashed #848484;\n    border-radius: 6px;\n    opacity: 1;\n    height: 45px;\n    line-height: 45px;\n}\n\nform.lstCustForm .form-select {\n    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/select-arrow.svg);\n    background-size: 12px;\n}\nform.lstCustForm .form-select,\nform.lstCustForm input.form-control {\n    border: 1px solid #0b34544d;\n    height: 45px;\n}\n.form-control[class*='_Link'] {\n    padding-left: 50px;\n}\n#youtubeLink {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='%23F61C0D' stroke='' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.007 2.007 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.007 2.007 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31.4 31.4 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.007 2.007 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A99.788 99.788 0 0 1 7.858 2h.193zM6.4 5.209v4.818l4.157-2.408L6.4 5.209z'/%3e%3c/svg%3e\");\n    background-repeat: no-repeat;\n    background-position: left 0.75rem center;\n    background-size: 20px 20px;\n}\n#facebookLink {\n    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/facebook_input.svg);\n    background-repeat: no-repeat;\n    background-position: left 0.75rem center;\n    background-size: 20px 20px;\n}\n#linkedinLink {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='%230077B5' stroke='' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z'/%3e%3c/svg%3e\");\n    background-repeat: no-repeat;\n    background-position: left 0.75rem center;\n    background-size: 20px 20px;\n}\n\n.uploaded-list-logo {\n    background: #ffffff;\n    border: 1px solid #b5c1cb;\n    border-radius: 6px;\n    padding: 14px 7px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n}\n.uploaded-list-logo img {\n    width: 100%;\n}\n.uploaded-list-logo .btn-close {\n    box-sizing: content-box;\n    width: 1em;\n    height: 1em;\n    padding: 0.25em 0.25em;\n    color: #000;\n    background: #0b3454\n        url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='white'%3e%3cpath d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/%3e%3c/svg%3e\")\n        center/ 10px auto no-repeat;\n    border: 0;\n    border-radius: 50%;\n    opacity: 1;\n    position: absolute;\n    top: -10px;\n    right: -10px;\n}\n\n.form-check-input + label.gap-switch {\n    background: #fff;\n    padding: 5px;\n    border-radius: 25px;\n    position: relative;\n    width: 100px;\n    height: 40px;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    cursor: pointer;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    border: 2px solid #f34e65;\n    color: #f34e65;\n}\n.form-check-input:checked + label.gap-switch {\n    background: #5dae48;\n    border-color: #5dae48;\n}\n.form-check-input + label.gap-switch:before {\n    width: 24px;\n    height: 24px;\n    display: inline-block;\n    background: #f34e65;\n    border-radius: 50%;\n    content: '';\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.form-check-input:checked + label.gap-switch::before {\n    transform: translateX(62px);\n    -webkit-transform: translateX(62px);\n    -moz-transform: translateX(62px);\n    -ms-transform: translateX(62px);\n    -o-transform: translateX(62px);\n    background: #fff;\n}\n.form-check-input + label.gap-switch:after {\n    content: 'NO';\n    color: #f34e65;\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    text-align: center;\n    font-weight: 500;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.form-check-input:checked + label.gap-switch::after {\n    transform: translateX(-30px);\n    content: 'YES';\n    -webkit-transform: translateX(-30px);\n    -moz-transform: translateX(-30px);\n    -ms-transform: translateX(-30px);\n    -o-transform: translateX(-30px);\n    color: #fff;\n}\n\n.action_btns {\n    max-width: 100%;\n    background: #f5faff;\n    padding: 20px;\n    border-radius: 5px;\n    margin: 35px 0 0 0px;\n    text-align: center;\n}\n.action_btns button.nextbtn {\n    padding: 0px 30px;\n    font-size: 1.5em;\n    width: 180px;\n    cursor: pointer;\n    border: 0px;\n    position: relative;\n    margin: auto;\n    transition: all 0.25s ease;\n    background: #0b3454;\n    color: #fff;\n    overflow: hidden;\n    border-radius: 25px;\n    height: 45px;\n    text-transform: uppercase;\n    font-size: 16px;\n    font-weight: 500;\n    letter-spacing: 1px;\n}\n.action_btns .btn-skip {\n    font-size: 16px;\n    display: inline-block;\n}\n.btn-skip {\n    margin: 15px;\n    font-size: 12px;\n    text-decoration: none;\n    font-weight: 500;\n    color: #00000070;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.btn-skip:hover {\n    color: #d42941;\n}\n\n.right-vertical-info {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: calc(100% + 10px);\n    margin: auto;\n    font-size: 20px;\n    height: 21px;\n    color: #27a7df;\n}\n\n.cta_add .btn-add {\n    color: #27a7df;\n    padding: 0 30px 0 0;\n    text-decoration: none;\n    display: flex;\n    align-items: center;\n}\n.cta_add .btn-add:hover {\n    color: #5cae48;\n}\n.cta_add .btn-add i {\n    margin-right: 10px;\n    margin-top: -4px;\n}\n.cta_add .btn-add i path {\n    fill: #5cae48;\n    color: #5cae48;\n}\n.cta_add .btn-add:focus {\n    box-shadow: none;\n}\n.cta_add .btn-add:focus-visible {\n    border: none;\n    outline: none;\n}\n.cta_add .btn-add:hover i img {\n    filter: invert(54%) sepia(94%) saturate(312%) hue-rotate(63deg) brightness(93%) contrast(83%);\n}\n\n.profilePicSection {\n    width: 200px;\n    height: 200px;\n    border: 1px dashed #707070;\n    border-radius: 50%;\n    margin: auto;\n    padding: 14px;\n}\n.profilePicSection .profileImg {\n    background: #e3e3e3;\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n}\n.profilePicSection.institute_logo {\n    max-width: 300px;\n    width: 100%;\n    border-radius: 10px;\n    height: 100%;\n    min-height: 100px;\n    border: 2px solid #0b3454;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    padding: 5px;\n}\n.profilePicSection.institute_logo .profileImg.add_new_logo {\n    border-radius: 5px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 30px;\n    color: #666;\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    height: auto;\n    cursor: pointer;\n}\n.profilePicSection .profileImg.added_new_logo {\n    border-radius: 0;\n    background: none;\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    height: auto;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.profileImg.icon-user {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 145px;\n    color: #fff;\n}\n.editProfilePicSection {\n    overflow: hidden;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n}\n.editprofileImg::after {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    width: 172px;\n    height: 172px;\n    border: 2px solid #0b3454;\n    margin: auto;\n    border-radius: 50%;\n    box-shadow: 0 0 0 100px rgba(255, 255, 255, 0.5);\n}\n\n.slideRange {\n    -webkit-appearance: none;\n    width: 100%;\n    height: 5px;\n    border-radius: 5px;\n    background: #d3d3d3;\n    outline: none;\n    opacity: 0.7;\n    -webkit-transition: 0.2s;\n    transition: opacity 0.2s;\n}\n.slideRange::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    appearance: none;\n    width: 14px;\n    height: 14px;\n    border: 0;\n    background: #5cae48;\n    cursor: pointer;\n    border-radius: 50%;\n}\n.slideRange::-moz-range-thumb {\n    width: 14px;\n    height: 14px;\n    border: 0;\n    background: #5cae48;\n    cursor: pointer;\n}\n.slideRange::-ms-thumb {\n    width: 14px;\n    height: 14px;\n    border: 0;\n    background: #5cae48;\n    cursor: pointer;\n    border-radius: 50%;\n}\n/** Chrome*/\n.slideRange::-webkit-range-progress {\n    background-color: #5cae48;\n    height: 5px;\n    border-radius: 5px;\n}\n/** FF*/\ninput[type='range'].slideRange::-moz-range-progress {\n    background-color: #5cae48;\n    height: 5px;\n    border-radius: 5px;\n}\n/* IE*/\ninput[type='range'].slideRange::-ms-fill-lower {\n    background-color: #5cae48;\n    height: 5px;\n    border-radius: 5px;\n}\n.emptyevent {\n    border: 1px solid #d2d2d2;\n    border-radius: 6px;\n}\n.radio-box * {\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.radio-box {\n    background: #ffffff;\n    border: 1px solid #0b34544d;\n    border-radius: 6px;\n    padding: 11px 15px;\n    min-width: 124px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    cursor: pointer;\n}\nform.lstCustForm .radio-box span {\n    padding: 0;\n    font-size: 16px;\n    font-style: normal;\n    color: #000;\n    font-weight: 500;\n    float: none;\n}\n.radio-box i {\n    margin-left: 8px;\n    background: #ffffff;\n    border: 1px solid #b5c1cb;\n    opacity: 1;\n    width: 18px;\n    height: 18px;\n    position: relative;\n    border-radius: 50%;\n    -webkit-border-radius: 50%;\n    -moz-border-radius: 50%;\n    -ms-border-radius: 50%;\n    -o-border-radius: 50%;\n}\n.radio-box i:before {\n    content: '';\n    position: absolute;\n    width: 9px;\n    height: 5px;\n    border-left: 2px solid #b5c1cb;\n    border-bottom: 2px solid #b5c1cb;\n    transform: rotate(-45deg);\n    left: 3px;\n    top: 5px;\n    -webkit-transform: rotate(-45deg);\n    -moz-transform: rotate(-45deg);\n    -ms-transform: rotate(-45deg);\n    -o-transform: rotate(-45deg);\n}\n.form-check-input:checked + .radio-box {\n    background: #5cae48;\n    border-color: #5cae48;\n}\n.form-check-input:checked + .radio-box span {\n    color: #fff;\n}\n.form-check-input:checked + .radio-box i {\n    border-color: #fff;\n    background: #5cae48;\n}\n.form-check-input:checked + .radio-box i:before {\n    border-color: #fff;\n}\n\n.form-check.custom-rectbox-radio .form-check-input + label {\n    width: 100%;\n    height: 45px;\n    font-weight: 500;\n    border: 1px solid #0b3454;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border-radius: 5px;\n    padding: 0 14px;\n    position: relative;\n    cursor: pointer;\n    transition: all 0.3s;\n    -webkit-transition: all 0.3s;\n    -moz-transition: all 0.3s;\n    -ms-transition: all 0.3s;\n    -o-transition: all 0.3s;\n}\n.form-check.custom-rectbox-radio .form-check-input + label span {\n    color: #000;\n    font-style: normal;\n    font-weight: 500;\n}\n.form-check.custom-rectbox-radio .form-check-input:checked + label {\n    background: #5dae48;\n    border: 1px solid #5dae48;\n    color: #fff;\n}\n.custom-rectbox-radio {\n    padding: 0;\n    margin: 0;\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n}\n.custom-rectbox-radio:not(:last-child) {\n    margin-right: 8px;\n}\n.radio_parent {\n    display: flex;\n    flex-wrap: wrap;\n}\n.form-check.custom-rectbox-radio .form-check-input + label:before {\n    content: '';\n    position: absolute;\n    right: 10px;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    width: 24px;\n    height: 24px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/male_icon.svg) no-repeat center;\n}\n.form-check.custom-rectbox-radio .form-check-input + label[for='female']:before {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/female_icon.svg) no-repeat center;\n}\n.form-check.custom-rectbox-radio .form-check-input:checked + label::before {\n    filter: invert(1) brightness(100);\n    -webkit-filter: invert(1) brightness(100);\n}\n.form-check.custom-rectbox-radio .form-check-input:checked + label span {\n    color: #fff;\n}\nform.lstCustForm hr {\n    border: 1px solid #7c8795;\n}\n.form-control.form-search {\n    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/search.svg);\n    background-size: 14px;\n    background-repeat: no-repeat;\n    background-position: 13px center;\n    padding-left: 34px;\n}\n\n.form-title {\n    border-bottom: 2px solid #dbdbdb;\n    padding-bottom: 10px;\n    font-size: 24px;\n    font-weight: 700;\n    margin: 10px 0 0;\n}\n.form-title span {\n    position: relative;\n}\n.form-title span:before {\n    content: '';\n    position: absolute;\n    bottom: -9px;\n    left: 0;\n    right: 0;\n    background: #5cae48;\n    height: 2px;\n}\n\n.datepicker .datepicker-switch:hover,\n.datepicker .prev:hover,\n.datepicker .next:hover,\n.datepicker tfoot tr th:hover {\n    background: #eef5ff;\n}\n.datepicker {\n    padding: 0;\n    z-index: 9999;\n}\n.datepicker td,\n.datepicker th {\n    padding: 7px;\n}\n.datepicker-days thead {\n    background: #eef5ff;\n    font-weight: 500;\n}\n.datepicker-days thead th {\n    font-weight: 500;\n}\n.datepicker-days thead th:hover {\n    background: #007bff;\n    color: #fff;\n}\n.datepicker-months,\n.datepicker-days {\n    overflow: hidden;\n    background: #eef5ff;\n    border-radius: 3px;\n}\n.datepicker-months tbody,\n.datepicker-days tbody {\n    background: #fff;\n}\n.form-date {\n    background: #fff url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/calender.svg) no-repeat right\n        10px center;\n    padding-right: 40px;\n}\n\n@media (max-width: 991px) {\n}\n\n@media (max-width: 575px) {\n    .polartabsec {\n        padding: 18px 20px;\n        margin: 0 -20px;\n    }\n}\n\n.tooltip-white .tooltip-inner {\n    background: #fff;\n    box-shadow: 0px 3px 6px #0000001a;\n    padding: 10px 15px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    max-width: 230px;\n    width: 100%;\n}\n.tooltip-white .tooltip-inner .badge {\n    background: #f1f1f1;\n    border-radius: 100px;\n    height: 28px;\n    padding: 0 15px;\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 14px;\n    color: #000;\n    font-weight: 400;\n}\n.tooltip-white .tooltip-inner .badge:not(:last-child) {\n    margin-bottom: 5px;\n}\n.tooltip-white .tooltip-arrow::before {\n    border-top-color: #fff;\n}\n.tooltip-white .tooltip-inner ol {\n    padding: 0;\n    margin: 0;\n    color: #000;\n    list-style: none;\n}\n\n/* form End */\n\n/* filter table */\n\n.attendee_dtl .table > thead th {\n    background: #f1f1f1;\n    font-size: 16px;\n    font-weight: 500;\n    height: 40px;\n    border: 0;\n}\n.attendee_dtl .table > thead tr:nth-child(2) th {\n    background: #e1e1e1;\n}\n.attendee_dtl .table > thead th:first-child {\n    border-radius: 6px 0 0 6px;\n}\n.attendee_dtl .table > thead th:last-child {\n    border-radius: 0 6px 6px 0;\n}\n\n.table-responsive::-webkit-scrollbar {\n    height: 4px;\n}\n.table-responsive::-webkit-scrollbar-track {\n    background: #ccc;\n}\n.table-responsive::-webkit-scrollbar-thumb {\n    background-color: #333;\n    border-radius: 2px;\n    border: 1px solid #ccc;\n}\n.table-responsive.attendee_dtl > table td:first-child,\n.table-responsive.attendee_dtl > table th:first-child {\n    padding-left: 20px;\n}\n.table-responsive.attendee_dtl > table td {\n    padding-top: 15px;\n    padding-bottom: 15px;\n    font-size: 16px;\n    vertical-align: middle;\n}\n.table-responsive.attendee_dtl > table td[valign='top'] {\n    vertical-align: top;\n}\n.table-responsive.attendee_dtl > table .btn {\n    line-height: 15px;\n    display: flex;\n    align-items: center;\n    padding: 0 20px !important;\n    margin: 0 5px 0 0;\n}\n.table-responsive.attendee_dtl > table td.active {\n    width: 315px;\n}\n.table-responsive.attendee_dtl > table td.engagement {\n    width: 245px;\n}\n.table-responsive.attendee_dtl > table .university-name {\n    width: 175px;\n}\n.table-responsive.attendee_dtl > table td.sentDeliveredOpened {\n    width: 365px;\n}\n.table-responsive.attendee_dtl a.tablink {\n    color: #0b3454;\n    display: flex;\n    align-items: center;\n    text-decoration: none;\n    line-height: 18px;\n}\n.table-responsive.attendee_dtl a.tablink:hover {\n    color: #4c4f51;\n}\n.table-responsive.attendee_dtl a.tablink.blue-link {\n    color: #27a7df  ;\n}\n.table-responsive.attendee_dtl a.tablink.blue-link:hover {\n    color: #000;\n    text-decoration: underline;\n}\n.table-responsive.attendee_dtl a.btn-gray-border:hover {\n    color: #fff;\n}\n.table-responsive.attendee_dtl > table td.deliveryStatus {\n    width: 205px;\n}\n.table-responsive td {\n    position: relative;\n}\n\n/* .table-responsive.attendee_dtl.withborder > table tr:not(:first-child) td {box-shadow: 4px 0px 1px 0px #B9B9B9;} */\n\n.input-group-select select.form-select {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n}\n.empty-notification .profile-selection-notification {\n    z-index: 9;\n    left: 0;\n    max-width: 1012px;\n    margin: auto;\n    width: 1012px;\n    right: 0;\n    position: absolute;\n    top: 50px;\n}\n.table-responsive .icon-like.dislike {\n    width: 15px;\n    height: 15px;\n    -moz-transform: scale(-1);\n    -webkit-transform: scale(-1);\n    -o-transform: scale(-1);\n    -ms-transform: scale(-1);\n    transform: scale(-1) translateY(-3px);\n    display: inline-block;\n}\n\n.table_cus_badge {\n    background: #fef7e8;\n    border-radius: 20px;\n    height: 36px;\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 14px;\n    color: #000;\n    font-weight: 500;\n    padding: 0 15px;\n    margin: 3px;\n    min-width: 65px;\n}\n.tab-ul {\n    padding: 0;\n    line-height: 22px;\n    list-style: none;\n    margin: 0 13px 0 0;\n}\n.tab-ul a {\n    color: #000;\n}\n.tab-ul a:hover {\n    color: #414141;\n}\n.custom-btn a {\n    margin: 0 2px;\n    text-decoration: none;\n    color: #000;\n    font-size: 12px;\n}\n.active-status {\n    background: #ffffff;\n    border: 1px solid #d2d2d2;\n    border-radius: 20px;\n    width: 120px;\n    height: 36px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.attendee_dtl a.icon-cross {\n    text-decoration: none;\n}\n.attendee_dtl a.icon-cross:hover {\n    color: #666 !important;\n}\n\n.attendee_dtl .form-check-input,\n.ActiveListings_present .form-check-input {\n    width: 20px;\n    height: 20px;\n    border-width: 2px;\n}\n.attendee_dtl .form-check-input:checked,\n.ActiveListings_present .form-check-input:checked {\n    background-color: #0b3454;\n    border-color: #0b3454;\n}\n\n.icon-sort-arrow {\n    font-size: 6px;\n    color: #7f7f7f;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n}\n.icon-sort-arrow .icon-invert-down-arrow {\n    transform: scaleY(-1);\n}\n\n.labelItem {\n    color: #000;\n    text-decoration: none;\n    display: flex;\n    align-items: center;\n}\n.text-center .labelItem {\n    justify-content: center;\n}\n.labelItem:hover {\n    color: #153d5b;\n}\n.labelItem .icon-sort {\n    margin-left: 5px;\n    width: 17px;\n    height: 17px;\n    display: inline-block;\n    position: relative;\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='%23343a40' stroke='none' d='M3.5 12.5a.5.5 0 0 1-1 0V3.707L1.354 4.854a.5.5 0 1 1-.708-.708l2-1.999.007-.007a.498.498 0 0 1 .7.006l2 2a.5.5 0 1 1-.707.708L3.5 3.707V12.5zm3.5-9a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zM7.5 6a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zm0 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3zm0 3a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1z'/%3e%3c/svg%3e\");\n}\n.labelItem .icon-sort::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    background: #f1f1f1;\n    width: 12px;\n    height: 2px;\n    margin: auto;\n    transform: rotate(-45deg);\n    left: -2.5px;\n    display: none;\n}\n\n.fitergroup .show .accordion-body {\n    border-radius: 0 6px 6px 6px;\n}\n.fitergroup .accordion-body {\n    background: #f1f1f1;\n    border-radius: 6px;\n}\n.btn-grpfiter {\n    border: 0px solid #e1e1e1;\n    border-radius: 20px;\n    height: 40px;\n    padding: 0 25px;\n    font-size: 14px;\n    font-weight: 500;\n    background: #f1f1f1;\n    position: relative;\n}\n.btn-grpfiter[aria-expanded='true'] {\n    border-radius: 20px 20px 0 0;\n    transition: all 0.3s ease-in-out;\n}\n.btn-grpfiter::before {\n    content: '';\n    position: absolute;\n    bottom: -20px;\n    left: 0;\n    right: 0;\n    background: #f1f1f1;\n    height: 10px;\n    transition: all 0.3s ease-in-out;\n    opacity: 0;\n}\n.btn-grpfiter[aria-expanded='true']::before {\n    bottom: -10px;\n    opacity: 1;\n}\n\n.mailSetting {\n    position: relative;\n}\n.mailSetting .setting-dropdown {\n    position: absolute;\n    top: 30px;\n    right: 10px;\n    background: white;\n    padding: 15px 20px;\n    box-shadow: 0 0 3px 0px #ccc;\n    border-radius: 6px;\n    z-index: 1;\n    border: 1px solid #ccc;\n    text-align: right;\n    display: none;\n}\n.mailSetting .setting-dropdown.open {\n    display: block;\n}\n.mailSetting .setting-dropdown ul {\n    padding: 0;\n    margin: 0;\n    list-style: none;\n}\n.mailSetting .setting-dropdown ul a {\n    text-decoration: none;\n    color: #000;\n}\n.mailSetting .setting-dropdown ul li:not(:last-child) {\n    margin-bottom: 5px;\n}\n\ntd a {\n    color: #0b3454;\n    opacity: 1;\n    text-decoration: none;\n}\ntd a:hover {\n    color: #5cae48;\n    opacity: 1;\n}\n\n.btn-conview,\n.link {\n    color: #0d6efd;\n    text-decoration: underline;\n}\n.btn-conview:hover,\n.link:hover {\n    color: #5cae48;\n    opacity: 1;\n}\n\n.tooltip-setting .tooltip-inner {\n    background: #ffffff;\n    color: #515151;\n    border: 1px solid #cecfcf;\n    box-shadow: 0px 5px 10px #00000033;\n    padding: 15px 12px;\n}\n.tooltip.tooltip-setting .show {\n    opacity: 2;\n}\n.tooltip-setting .bs-tooltip-top .tooltip-arrow::before {\n    top: -1px;\n    border-width: 0.4rem 0.4rem 0;\n    border-top-color: #fff;\n}\n.tooltip-setting .bs-tooltip-bottom .tooltip-arrow::before {\n    bottom: -1px;\n    border-width: 0 0.4rem 0.4rem;\n    border-bottom-color: #fff;\n}\n.tooltip-setting .tooltip-inner ul {\n    padding: 0;\n    margin: 0;\n    text-align: left;\n    list-style: none;\n    line-height: 24px;\n}\n.tooltip-setting .tooltip-inner ul a {\n    font-size: 14px;\n    color: #000;\n    text-decoration: none;\n    padding: 0;\n    border: none;\n    font-weight: 500;\n    background: none;\n    transition: none;\n    -webkit-transition: none;\n    -moz-transition: none;\n    -ms-transition: none;\n    -o-transition: none;\n}\n.bs-tooltip-auto.tooltip-setting[data-popper-placement^='top'] .tooltip-arrow::before,\n.bs-tooltip-top.tooltip-setting .tooltip-arrow::before {\n    border-top-color: #fff;\n}\n\n.tooltip-html {\n}\n.tooltip-html .tooltip-inner {\n    background: #ffffff;\n    color: #515151;\n    border: 1px solid #cecfcf;\n    box-shadow: 0px 5px 10px #00000033;\n    padding: 15px 15px;\n    max-width: 300px;\n    line-height: 20px;\n}\n.tooltip.tooltip-html .show {\n    opacity: 2;\n}\n.tooltip-html .bs-tooltip-top .tooltip-arrow::before {\n    top: -1px;\n    border-width: 0.4rem 0.4rem 0;\n    border-top-color: #fff;\n}\n.tooltip-html .bs-tooltip-bottom .tooltip-arrow::before {\n    bottom: -1px;\n    border-width: 0 0.4rem 0.4rem;\n    border-bottom-color: #fff;\n}\n.tooltip-html .tooltip-inner h6 {\n    text-align: left;\n}\n.tooltip-html .tooltip-inner ul {\n    padding: 0;\n    margin: 0;\n    text-align: left;\n    list-style: none;\n    line-height: 24px;\n}\n.tooltip-html .tooltip-inner ul a {\n    font-size: 14px;\n    color: #000;\n    text-decoration: none;\n}\n.bs-tooltip-auto.tooltip-html[data-popper-placement^='top'] .tooltip-arrow::before,\n.bs-tooltip-top.tooltip-html .tooltip-arrow::before {\n    border-top-color: #fff;\n}\n.tooltip-html .tooltip-inner ul li {\n    white-space: wrap;\n}\n.tooltip-html .tooltip-inner ul li:not(:last-child) {\n    margin: 0 0 8px;\n}\n.tooltip-html .tooltip-inner ul li b {\n    margin-right: 5px;\n    font-weight: 500;\n    color: #000;\n}\n.tooltip-html .tooltip-inner ol {\n    padding: 0 0 0 20px;\n    margin: 0 0 6px;\n    text-align: left;\n    font-weight: 500;\n    color: #000;\n}\n.tooltip-html .tooltip-inner ol li {\n    list-style: decimal;\n}\n.tooltip-html .tooltip-inner p {\n    padding: 0 0 0 20px;\n    margin: 0;\n    text-align: left;\n    font-weight: 500;\n    color: #000;\n}\n\n.datewrap {\n    display: flex;\n    flex-wrap: wrap;\n    background: #ffffff;\n    border: 1px solid #848484;\n    border-radius: 6px;\n    height: 40px;\n    position: relative;\n    overflow: hidden;\n}\n#config-demo,\n.singledaterangePickerList,\n.daterangePickerList {\n    width: 100%;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    top: 0;\n    right: 0;\n    margin: auto;\n    cursor: pointer;\n    opacity: 0;\n}\n.datewrap .arrow {\n    background: #f1f1f1;\n    width: 45px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n/*.datewrap .arrow span {background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='1' d='M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z'/%3e%3c/svg%3e\");font-size: 0;width: 25px;height: 25px;}*/\n.datewrap .arrow span {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/arrow.svg) no-repeat center;\n    font-size: 0;\n    width: 25px;\n    height: 25px;\n}\n.datewrap .from,\n.datewrap .to {\n    flex: 1;\n}\n.datewrap .form-control {\n    height: 100% !important;\n    border: 0 !important;\n    background: #fff url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/calendar.svg) no-repeat 10px\n        center;\n    padding-left: 40px;\n}\n.fitergroup .accordion-body .form-select,\n.fitergroup .accordion-body .form-control,\n.tab-pane .fullViewMobile .form-select,\n.tab-pane .fullViewMobile .form-control {\n    height: 40px;\n    border: 1px solid #848484;\n}\n.form-control.form-search {\n    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/search.svg);\n    background-size: 14px;\n    background-repeat: no-repeat;\n    background-position: 13px center;\n    padding-left: 34px;\n}\n\n.search.alumniSearch {\n    max-width: 350px;\n    width: 100%;\n    background: #fff;\n    border: 1px solid #7d7d7d;\n    border-radius: 20px;\n}\n.search.alumniSearch .btn-search {\n    right: auto;\n    left: 7px;\n    top: 6px;\n}\n.search.alumniSearch .form-control {\n    padding-left: 40px;\n}\n.search-100 .search.alumniSearch {\n    max-width: 280px;\n}\n\n.singlelinename {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    width: 125px;\n}\n.tablink img[width='30'] {\n    width: 30px;\n    min-width: 30px;\n}\n.tablink .icon-subtraction {\n    position: absolute;\n    bottom: -3px;\n    right: -3px;\n    width: 16px;\n    height: 15px;\n}\n.tablink .icon-subtraction::before {\n    content: '';\n    position: absolute;\n    width: 100%;\n    height: 15px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/subtraction-white-star.svg) no-repeat\n        0 0 / 100%;\n    z-index: 2;\n}\n.tablink .icon-subtraction::after {\n    content: '';\n    position: absolute;\n    width: 66%;\n    height: 65%;\n    background: #fff;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n}\n.icon-star.circle-img {\n    position: absolute;\n    bottom: -3px;\n    right: -3px;\n    background: #5cae48;\n    border-radius: 50%;\n    color: #fff;\n    font-size: 7px;\n    padding: 4px;\n}\n\n.table-responsive.attendee_dtl td a > i {\n    width: 40px;\n    height: 40px;\n    font-size: 30px;\n    background-position: center;\n}\n.table-responsive.attendee_dtl td a > i img {\n    vertical-align: top;\n}\n.course-list-row span {\n    vertical-align: top;\n    margin-right: 4px;\n}\n.course-list-row i {\n    margin-top: 0px;\n}\n\n.filterresult ul {\n    margin: 0;\n    padding: 0;\n    display: flex;\n    flex-wrap: wrap;\n    list-style: none;\n}\n.filterresult ul li:not(:last-child) {\n    margin-right: 10px;\n}\n.filterresult ul li {\n    margin-bottom: 5px;\n}\n.filterresult ul li a {\n    background: #e9f6fc;\n    border-radius: 20px;\n    min-height: 32px;\n    padding: 5px 20px;\n    display: flex;\n    align-items: center;\n    font-size: 16px;\n    color: #000;\n    text-decoration: none;\n}\n.filterresult ul li a i {\n    margin-left: 8px;\n    font-size: 9px;\n}\n.filterresult ul li.clear a {\n    background: none;\n    color: #d42941;\n    text-decoration: underline;\n}\n.filterresult ul li.clear a:hover {\n    color: #0b3454;\n    text-decoration: none;\n}\n.filterresult {\n    padding: 10px 0 15px;\n    border-bottom: 1px solid #e5eaed;\n    margin-bottom: 20px;\n}\n.pagination_custom {\n    max-width: 751px;\n    margin: auto;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 15px;\n}\n.pagination_custom .pagination_custom_inner {\n    flex: 1;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin: 0 20px;\n}\n.pagination_custom .pagination_custom_inner ul {\n    padding: 0;\n    margin: 0 20px;\n    list-style: none;\n    display: flex;\n    flex-wrap: wrap;\n    flex: 1;\n    justify-content: center;\n    align-items: center;\n}\n.pagination_custom .pagination_custom_inner ul li:not(:last-child) {\n    margin-right: 0;\n}\n.pagination_custom .pagination_custom_inner ul li {\n    width: 30px;\n    text-align: center;\n    margin: 0 10px;\n}\n.pagination_custom a,\n.pagination_custom .pagination_custom_inner ul li a {\n    text-decoration: none;\n    font-size: 16px;\n    color: #0b3454;\n    font-weight: 500;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.pagination_custom .pagination_custom_inner ul li.current a {\n    background: #0b3454;\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: #fff;\n}\n\n.summary-blocks {\n    width: 1140px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    margin-bottom: 15px;\n}\n.summary-blocks .block {\n    width: calc(20.19% - 1%);\n    border-radius: 4px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    padding: 32px 20px;\n}\n.summary-blocks .block {\n    background: #fff;\n}\n\n.summary-blocks .block:not(:last-child) {\n    margin-right: 1%;\n}\n.summary-blocks .block .icon {\n    margin-right: 15px;\n}\n.summary-blocks .block .block-detail .number {\n    font-size: 26px;\n    line-height: 30px;\n    font-weight: 600;\n}\n.summary-blocks .block .block-detail .block-detail-title {\n    font-size: 15px;\n    line-height: 18px;\n    font-weight: 500;\n}\n.summary-blocks .block.totalAlumni .block-detail {\n    color: #d42941;\n}\n.summary-blocks .block.uptoDate .block-detail {\n    color: #0b3454;\n}\n.summary-blocks .block.due .block-detail {\n    color: #26a7df;\n}\n.summary-blocks .block.smartApplyLeads .block-detail {\n    color: #403a81;\n}\n.summary-blocks .block.smartApplyRegd .block-detail {\n    color: #6962a7;\n}\n\n.x-scroll {\n    overflow-x: auto;\n    scrollbar-width: thin;\n}\n.x-scroll::-webkit-scrollbar {\n    height: 4px;\n}\n.x-scroll::-webkit-scrollbar-track {\n    background: #f1f1f1;\n}\n.x-scroll::-webkit-scrollbar-thumb {\n    background: #888;\n}\n.x-scroll::-webkit-scrollbar-thumb:hover {\n    background: #555;\n}\n\n.x-scroll-big {\n    overflow-x: auto;\n}\n.x-scroll-big::-webkit-scrollbar {\n    height: 15px;\n}\n.x-scroll-big::-webkit-scrollbar-track {\n    background: #ccc;\n}\n.x-scroll-big::-webkit-scrollbar-thumb {\n    background: #666;\n}\n.x-scroll-big::-webkit-scrollbar-thumb:hover {\n    background: #555;\n}\n\n.blue-badge {\n    background: #68c2e9;\n    font-weight: 500;\n    border: 1px solid #68c2e9;\n    border-radius: 6px;\n    padding: 0 15px;\n    height: 26px;\n    display: inline-block;\n    line-height: 26px;\n    color: #fff !important;\n    margin-bottom: 5px;\n    font-size: 12px;\n    text-transform: uppercase;\n}\n\n.sticky_table_3_columns th:first-child {\n    position: sticky;\n    left: 0;\n    z-index: 3;\n}\n.sticky_table_3_columns th:nth-child(2) {\n    position: sticky;\n    left: 140px;\n    z-index: 3;\n}\n.sticky_table_3_columns th:nth-child(3) {\n    position: sticky;\n    left: calc(140px + 250px);\n    z-index: 3;\n}\n\n.sticky_table_3_columns td:first-child {\n    position: sticky;\n    left: 0;\n    z-index: 3;\n}\n.sticky_table_3_columns td:nth-child(2) {\n    position: sticky;\n    left: 140px;\n    z-index: 3;\n}\n.sticky_table_3_columns td:nth-child(3) {\n    position: sticky;\n    left: calc(140px + 250px);\n    z-index: 3;\n}\n.sticky_table_3_columns th:nth-child(3)::before,\n.sticky_table_3_columns td:nth-child(3)::before {\n    content: '';\n    width: 30px;\n    position: absolute;\n    right: 0px;\n    bottom: 0;\n    top: 0;\n    background: transparent linear-gradient(270deg, #000000 0%, #00000000 100%);\n    opacity: 0.05;\n}\n.sticky_table_3_columns td::after {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: -1px;\n    height: 0;\n    border-bottom: 1px solid #dee2e6;\n}\n\n.sticky_table_3_columns_noaction th:first-child {\n    position: sticky;\n    left: 0;\n    z-index: 3;\n}\n.sticky_table_3_columns_noaction th:nth-child(2) {\n    position: sticky;\n    left: 250px;\n    z-index: 3;\n}\n.sticky_table_3_columns_noaction th:nth-child(3) {\n    position: sticky;\n    left: calc(250px + 180px);\n    z-index: 3;\n}\n\n.sticky_table_3_columns_noaction td:first-child {\n    position: sticky;\n    left: 0;\n    z-index: 3;\n}\n.sticky_table_3_columns_noaction td:nth-child(2) {\n    position: sticky;\n    left: 250px;\n    z-index: 3;\n}\n.sticky_table_3_columns_noaction td:nth-child(3) {\n    position: sticky;\n    left: calc(250px + 180px);\n    z-index: 3;\n}\n.sticky_table_3_columns_noaction th:nth-child(3)::before,\n.sticky_table_3_columns_noaction td:nth-child(3)::before {\n    content: '';\n    width: 30px;\n    position: absolute;\n    right: 0px;\n    bottom: 0;\n    top: 0;\n    background: transparent linear-gradient(270deg, #000000 0%, #00000000 100%);\n    opacity: 0.05;\n}\n.sticky_table_3_columns_noaction td::after {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: -1px;\n    height: 0;\n    border-bottom: 1px solid #dee2e6;\n}\n\n.sticky_table_4_columns th:first-child {\n    position: sticky;\n    left: 0;\n    z-index: 3;\n}\n.sticky_table_4_columns th:nth-child(2) {\n    position: sticky;\n    left: 150px;\n    z-index: 3;\n}\n.sticky_table_4_columns th:nth-child(3) {\n    position: sticky;\n    left: calc(150px + 225px);\n    z-index: 3;\n}\n.sticky_table_4_columns th:nth-child(4) {\n    position: sticky;\n    left: calc(150px + 225px + 180px);\n    z-index: 3;\n}\n\n.sticky_table_4_columns td:first-child {\n    position: sticky;\n    left: 0;\n    z-index: 3;\n}\n.sticky_table_4_columns td:nth-child(2) {\n    position: sticky;\n    left: 150px;\n    z-index: 3;\n}\n.sticky_table_4_columns td:nth-child(3) {\n    position: sticky;\n    left: calc(150px + 225px);\n    z-index: 3;\n}\n.sticky_table_4_columns td:nth-child(4) {\n    position: sticky;\n    left: calc(150px + 225px + 180px);\n    z-index: 3;\n}\n.sticky_table_4_columns th:nth-child(4)::before,\n.sticky_table_4_columns td:nth-child(4)::before {\n    content: '';\n    width: 30px;\n    position: absolute;\n    right: 0px;\n    bottom: 0;\n    top: 0;\n    background: transparent linear-gradient(270deg, #000000 0%, #00000000 100%);\n    opacity: 0.05;\n}\n.sticky_table_4_columns td::after {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: -1px;\n    height: 0;\n    border-bottom: 1px solid #dee2e6;\n}\n\n.customselect_parnt > .form-select {\n    border-radius: 25px;\n    margin-right: 10px;\n    border: 2px solid #7d7d7d;\n    height: 36px;\n    display: flex;\n    align-items: center;\n    line-height: 18px;\n}\n.customselect_parnt button {\n    height: 36px;\n}\n.icon-download {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/download.svg) no-repeat 0 0 / 100%;\n    width: 17px;\n    height: 16px;\n    display: inline-block;\n}\n.mailSetting .icon-download {\n    filter: invert(16%) sepia(71%) saturate(697%) hue-rotate(167deg) brightness(92%) contrast(99%);\n    -webkit-filter: invert(16%) sepia(71%) saturate(697%) hue-rotate(167deg) brightness(92%) contrast(99%);\n}\n.mailSetting .icon-download:hover {\n    filter: invert(53%) sepia(75%) saturate(353%) hue-rotate(62deg) brightness(97%) contrast(89%);\n    -webkit-filter: invert(53%) sepia(75%) saturate(353%) hue-rotate(62deg) brightness(97%) contrast(89%);\n}\n.gray_badge .badge {\n    background: #f1f1f1;\n    border-radius: 100px;\n    height: 28px;\n    padding: 0 15px;\n    display: inline-block;\n    font-size: 14px;\n    color: #000;\n    font-weight: 400;\n    margin-bottom: 5px;\n    max-width: 108px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    width: 100%;\n    text-align: center;\n    line-height: 28px;\n}\n\n.custom-btn a {\n    margin: 0 2px;\n    text-decoration: none;\n    color: #212529;\n}\n.custom-btn a:hover {\n    color: #868686;\n}\n\n@media (max-width: 991px) {\n    div.table-responsive table.sticky_table_3_columns td,\n    div.table-responsive table.sticky_table_3_columns th {\n        position: static;\n    }\n    div.table-responsive table.sticky_table_3_columns_noaction td,\n    div.table-responsive table.sticky_table_3_columns_noaction th {\n        position: static;\n    }\n    div.table-responsive table.sticky_table_4_columns td,\n    div.table-responsive table.sticky_table_4_columns th {\n        position: static;\n    }\n}\n\n@media (min-width: 767px) {\n    .table-responsive.attendee_dtl.sticky-table > table td:first-child,\n    .table-responsive.attendee_dtl.sticky-table > table th:first-child {\n        position: sticky;\n        left: 0;\n        z-index: 2;\n    }\n    .table-responsive.attendee_dtl.sticky-table > table td:nth-child(2),\n    .table-responsive.attendee_dtl.sticky-table > table th:nth-child(2) {\n        position: sticky;\n        left: 232px;\n        z-index: 2;\n    }\n    .table-responsive.attendee_dtl.sticky-table > table td:first-child:before,\n    .table-responsive.attendee_dtl.sticky-table > table td:nth-child(2):before {\n        content: '';\n        position: absolute;\n        top: 0;\n        left: 0;\n        bottom: 0;\n        right: 0;\n        margin: auto;\n        background: #fff;\n    }\n    .table-responsive.attendee_dtl.sticky-table > table td:first-child div,\n    .table-responsive.attendee_dtl.sticky-table > table td:nth-child(2) div {\n        z-index: 1;\n        position: relative;\n    }\n    .table-responsive.attendee_dtl.sticky-table > table th:nth-child(2)::after,\n    .table-responsive.attendee_dtl.sticky-table > table td:nth-child(2)::after {\n        content: '';\n        background: transparent linear-gradient(270deg, #ffffff 0%, #000000 100%);\n        opacity: 0.1;\n        width: 30px;\n        position: absolute;\n        right: -30px;\n        bottom: 0;\n        top: 0;\n    }\n    .table-responsive.attendee_dtl.sticky-table > table td:nth-child(3),\n    .table-responsive.attendee_dtl.sticky-table > table th:nth-child(3) {\n        padding-left: 30px;\n        width: 150px;\n    }\n\n    .table-responsive.sticky-table {\n        overflow-x: scroll;\n        scrollbar-width: thin;\n    }\n    .table-responsive.sticky-table::-webkit-scrollbar {\n        height: 4px;\n    }\n    .table-responsive.sticky-table::-webkit-scrollbar-track {\n        background: #f1f1f1;\n    }\n    .table-responsive.sticky-table::-webkit-scrollbar-thumb {\n        background: #888;\n    }\n    .table-responsive.sticky-table::-webkit-scrollbar-thumb:hover {\n        background: #555;\n    }\n}\n\n/* filter table end */\n\n.package-wrap {\n    margin: 20px auto 40px auto;\n    display: inline-flex;\n    flex-wrap: wrap;\n    width: 100%;\n    max-width: 800px;\n}\n.package-list-type {\n    display: flex;\n    flex: 1;\n    border-bottom: 1px solid #dfe1e4;\n    border-right: 1px solid #dfe1e4;\n    border-radius: 0 0 6px 0;\n    position: relative;\n}\n\n.package-list-title {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    font-size: 16px;\n    font-weight: 600;\n    height: 50px;\n}\n.package-list-title label {\n    margin-right: 10px;\n}\n.package-list .package-list-title + ul {\n    margin-top: 0;\n}\n.package-list ul {\n    list-style: none;\n    margin: 50px 0 0 0;\n    padding: 0px 0 10px;\n    background: #fff;\n    border-radius: 6px 0px 0px 6px;\n    border: 1px solid #dfe1e4;\n    border-right: none;\n}\n.package-list ul li {\n    padding: 0 40px;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 23px;\n    height: 60px;\n    display: flex;\n    align-items: center;\n}\n.package-list ul li span {\n    line-height: 20px;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n.package-list ul li:nth-child(even) {\n    background: #f6f8fa;\n}\n.package-type {\n    flex: 1;\n    min-width: 178px;\n    position: relative;\n}\n.package-type ul {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n}\n.package-list {\n    flex: 1;\n}\n.package-type ul li {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.package-type-header {\n    border-radius: 6px 6px 0px 0px;\n    opacity: 1;\n    height: 50px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #fff;\n    font-weight: 500;\n    font-size: 20px;\n}\n.package-type-header.starter {\n    background: transparent linear-gradient(270deg, #168abc 0%, #25a1d6 34%, #2596c7 66%, #228aaa 100%);\n}\n.package-type-header.bronze {\n    background: transparent linear-gradient(270deg, #a96b4d 0%, #d7a169 34%, #d7a068 66%, #8f4c2e 100%);\n}\n.package-type-header.sliver {\n    background: transparent linear-gradient(270deg, #858585 0%, #9598a0 34%, #b3b6bd 66%, #828280 100%);\n}\n.package-type-header.gold {\n    background: transparent linear-gradient(270deg, #d0b211 0%, #d9c246 34%, #d8c63d 66%, #c8993f 100%);\n}\n.package-type-header.defaultHeader {\n    border: 1px solid #dfe1e4;\n    height: 51px;\n    color: #000;\n    font-size: 16px;\n}\n.package-type-body {\n    border-left: 1px solid #dfe1e4;\n    border-right: 1px solid #dfe1e4;\n    padding: 1px 0 10px;\n    background-color: #fff;\n}\n.package-type:not(:last-child) {\n    margin-right: 10px;\n}\n.package-type ul li {\n    height: 60px;\n}\n.package-type ul li:nth-child(even) {\n    background: #f6f8fa;\n}\n.package-type-body .form-check-input {\n    position: static;\n    margin: 0;\n    width: 23px;\n    height: 23px;\n    border: 1px solid #0b345480;\n    border-radius: 4px;\n    opacity: 1;\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23CAD4DB' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/%3e%3c/svg%3e\");\n    background-size: 21px;\n}\n.package-type-body .form-check-input:checked {\n    background-color: #29a745;\n    border-color: #29a745;\n}\n\n.package-type:last-child {\n    border-radius: 0 0 10px 0;\n    overflow: hidden;\n}\n.package-list-type:before {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    border: 0;\n    height: calc(100% - 50px);\n    background: white;\n    border-radius: 0 0 6px;\n    top: 50px;\n}\n\n.package-wrap .slimScrollDiv {\n    flex: auto;\n    height: auto !important;\n    overflow: visible !important;\n}\n.package-wrap .slimScrollDiv .package-list-type {\n    width: 100% !important;\n    height: 100% !important;\n}\n.slimScrollWrapper {\n    position: sticky;\n    bottom: 20px;\n}\n\n/* Bulk Imports  */\n\n.bulk_imports_header {\n    border-bottom: 1px solid #c1ccd4;\n}\n.steps_flow {\n    margin: auto;\n    padding: 0;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    position: relative;\n}\n.polartabsec .steps_flow li {\n    height: auto;\n    position: relative;\n}\n.polartabsec .steps_flow li:not(:last-child) {\n    margin-right: 254px;\n}\n.polartabsec .steps_flow li a {\n    text-decoration: none;\n    color: #000;\n    font-size: 18px;\n}\n.polartabsec .steps_flow li.active a {\n    font-weight: 500;\n}\n.steps_flow:before {\n    content: '';\n    position: absolute;\n    left: 20px;\n    bottom: -20px;\n    right: 20px;\n    border-bottom: 3px solid #5cae48;\n    margin: auto;\n}\n.polartabsec .steps_flow li:before {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: -30px;\n    background: #ffffff;\n    border: 2px solid #0b345433;\n    opacity: 1;\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    margin: auto;\n    -webkit-border-radius: 50%;\n    -moz-border-radius: 50%;\n    -ms-border-radius: 50%;\n    -o-border-radius: 50%;\n}\n.polartabsec .steps_flow li.active:before {\n    background: #0db35c;\n    border: 1px solid #0db35c;\n    margin: auto;\n    box-shadow: 0 0 0 5px #fff inset;\n}\n.polartabsec .steps_flow li.completed::before {\n    background-color: #0db35c;\n    border: 1px solid #0db35c;\n    margin: auto;\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='' stroke-linejoin='' stroke-width='2' d='M6 10l3 3l6-6'/%3e%3c/svg%3e\");\n}\n\n.import-title {\n    text-align: center;\n    margin-top: 30px;\n}\n.import-title h3 {\n    font-size: 24px;\n    font-weight: 500;\n    margin: 0 0 5px;\n}\n.import-title p {\n    font-size: 16px;\n    margin-bottom: 5px;\n}\n\n.import-block * {\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.import-block {\n    background: #ffffff;\n    border: 1px solid #d2d2d2;\n    border-radius: 6px;\n    position: relative;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    overflow: hidden;\n}\n.import-block .icon {\n    position: absolute;\n    background: #0b3454;\n    border-radius: 0px 4px 0px 72px;\n    width: 78px;\n    height: 78px;\n    top: 0;\n    right: 0;\n}\n.import-block .icon::before {\n    filter: brightness(0) invert(1);\n    -webkit-filter: brightness(0) invert(1);\n}\n.import-block-detail {\n    padding: 20px 30px 30px;\n}\n.icon.icon_user::before {\n    content: '';\n    position: absolute;\n    right: 14px;\n    top: 14px;\n    width: 30px;\n    height: 30px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/selet-user.svg);\n}\n.icon.icon_display::before {\n    content: '';\n    position: absolute;\n    right: 14px;\n    top: 14px;\n    width: 30px;\n    height: 30px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/display-user.svg);\n}\n.import-block-detail h4 {\n    font-size: 24px;\n    font-weight: 500;\n    margin: 0 0 15px;\n}\n.import-block-detail ul {\n    margin: 0;\n    padding: 0;\n    max-width: 420px;\n}\n.import-block-detail ul li:not(:last-child) {\n    margin-bottom: 18px;\n}\n.import-block-detail ul li {\n    position: relative;\n    padding: 0 0 0 18px;\n    line-height: 20px;\n}\n.import-block-detail ul li:before {\n    content: '';\n    position: absolute;\n    top: 3px;\n    left: 0;\n    background: #27a7df;\n    width: 3px;\n    height: 85%;\n    border-radius: 5px;\n    -webkit-border-radius: 5px;\n    -moz-border-radius: 5px;\n    -ms-border-radius: 5px;\n    -o-border-radius: 5px;\n}\n.import-block-select {\n    background: #f2f9ff;\n    width: 100%;\n    height: 60px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 18px;\n    font-weight: 600;\n    color: #0b345490;\n    text-transform: uppercase;\n    cursor: pointer;\n}\n.import-block-select i {\n    width: 26px;\n    height: 26px;\n    border-radius: 5px;\n    border: 1px solid #d2d2d2;\n    background: #fff;\n    margin-right: 10px;\n    transition: all 0.5s ease-in-out;\n    -webkit-transition: all 0.5s ease-in-out;\n    -moz-transition: all 0.5s ease-in-out;\n    -ms-transition: all 0.5s ease-in-out;\n    -o-transition: all 0.5s ease-in-out;\n    position: relative;\n    -webkit-border-radius: 5px;\n    -moz-border-radius: 5px;\n    -ms-border-radius: 5px;\n    -o-border-radius: 5px;\n}\n\n.inputfile_parent label.height-80 {\n    height: 80px;\n}\n.inputfile_parent label.height-80 span {\n    font-weight: 400;\n}\n.inputfile_parent label .text-skyblue {\n    color: #27a7df;\n}\n\n.form-check-input:checked + div {\n    border: 2px solid #5cae48;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.form-check-input:checked + div .icon {\n    background: #f2f9ff;\n}\n.form-check-input:checked + div .icon:before {\n    filter: brightness(1) invert(0);\n    -webkit-filter: brightness(1) invert(0);\n}\n.form-check-input:checked + div .import-block-select {\n    background: #5cae48;\n    color: #fff;\n}\n.form-check-input:checked + div .import-block-select i {\n    border-color: #fff;\n    background-color: #fff;\n}\n.form-check-input:checked + div .import-block-select i::before {\n    content: '';\n    position: absolute;\n    border-width: 0px 0px 3px 3px;\n    border-style: solid;\n    border-color: #5cae48;\n    width: 14px;\n    height: 7px;\n    transform: rotate(-45deg);\n    left: 6px;\n    top: 7px;\n    -webkit-transform: rotate(-45deg);\n    -moz-transform: rotate(-45deg);\n    -ms-transform: rotate(-45deg);\n    -o-transform: rotate(-45deg);\n}\ntd .form-check-input:checked + div {\n    border: none;\n}\n\n.upload_disclaimer {\n    font-size: 14px;\n    line-height: 20px;\n    text-align: center;\n    color: #0b3454;\n    opacity: 0.8;\n    padding: 14px 0;\n}\n\n.form-check-tick .form-check-input {\n    width: 26px;\n    height: 26px;\n    margin-right: 8px;\n    margin-top: 0;\n}\n.form-check-tick {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n}\n.form-check-tick .form-check-input:checked {\n    background-color: #5cae48;\n    border-color: #5cae48;\n}\n\n.map-card-wrap {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-wrap: nowrap;\n    padding-bottom: 20px;\n}\n.map-card {\n    border: 1px solid #dbdcdd;\n    border-radius: 6px;\n    width: 257px;\n    min-width: 257px;\n    overflow: hidden;\n}\n.map-card:not(:last-child) {\n    margin-right: 10px;\n}\n.map-column {\n    background: #f2f9ff;\n    padding: 10px 15px 20px;\n}\n.map-title {\n    color: #68696a;\n    font-weight: 500;\n    font-size: 14px;\n}\n.skip_column {\n    height: 45px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.skip_column .skip-link {\n    color: #0b3454;\n}\n.column-list {\n    padding: 0;\n    margin: 0;\n}\n.column-list li {\n    min-height: 45px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    padding: 0 15px;\n}\n.column-list-title {\n    background: #f5f7f8;\n    font-weight: 500;\n}\n.column-list li ~ li:not(:last-child) {\n    border-bottom: 1px solid #ebebeb;\n}\n\n.modal-header .icon-correct {\n    width: 50px;\n    height: 50px;\n    background: #5cae48;\n    border-radius: 50%;\n    color: #fff;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 25px;\n    -webkit-border-radius: 50%;\n    -moz-border-radius: 50%;\n    -ms-border-radius: 50%;\n    -o-border-radius: 50%;\n}\n\n@media (max-width: 575px) {\n    .polartabsec .steps_flow li:not(:last-child) {\n        margin-right: 145px;\n    }\n    .inputfile_parent label.height-80 span.uploadlabel {\n        text-overflow: ellipsis;\n        width: calc(100% - 75px);\n        overflow: hidden;\n    }\n}\n/* Bulk Imports end */\n\n/* Manage Integrations */\n.twoColSection.tab-content > .active {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    width: 100%;\n}\n.tab-inner {\n    width: 100%;\n}\n.tab-inner > .row {\n    height: 100%;\n}\n.twoColSection .nav {\n    flex-direction: column;\n    padding-top: 5px;\n}\n.twoColSection .nav .nav-item {\n    padding-right: 5px;\n}\n.twoColSection .nav .nav-item .nav-link {\n    width: 100%;\n    border-radius: 0;\n    text-align: left;\n    color: #2b4e6a;\n    font-weight: 500;\n}\n.twoColSection .nav .nav-item .nav-link.active {\n    color: #5cae48;\n    background: #fff;\n}\n\n.api-host {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    margin-top: 24px;\n    background: #fffae5;\n    padding: 15px;\n    border-radius: 6px;\n    margin-bottom: 20px;\n    border: 2px dashed #f1ecd6;\n    align-items: center;\n}\n.api-host label {\n    background: #fff;\n    padding: 10px 15px;\n    border-radius: 6px 0px 0 6px;\n    font-weight: 500;\n    position: relative;\n    margin-right: 30px;\n}\n.api-host label:after {\n    content: '';\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 100%;\n    border-top: 22.5px solid transparent;\n    border-bottom: 22.5px solid transparent;\n    border-left: 15px solid #fff;\n    height: 0;\n    width: 0;\n}\n.api-url {\n    font-size: 18px;\n    font-weight: 500;\n    color: #0b3454;\n    width: calc(100% - 171px);\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n}\n.api-url .icon-copy {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/copy.svg) no-repeat 0 0 / 100%;\n    width: 26px;\n    height: 26px;\n    filter: invert(88%) sepia(7%) saturate(264%) hue-rotate(125deg) brightness(78%) contrast(91%);\n    cursor: pointer;\n    -webkit-filter: invert(88%) sepia(7%) saturate(264%) hue-rotate(125deg) brightness(78%) contrast(91%);\n}\n.api-url span {\n    width: calc(100% - 26px);\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n}\n.badge.enabled,\n.badge.success {\n    background: #caf3c1;\n    color: #000;\n    border-radius: 25px;\n    padding: 10px 30px;\n    font-weight: 500;\n    font-size: 16px;\n}\n.badge.unauthorized {\n    background: #fdebc5;\n    color: #000;\n    border-radius: 25px;\n    padding: 10px 30px;\n    font-weight: 500;\n    font-size: 16px;\n}\n.badge.serverError {\n    background: #fedddd;\n    color: #000;\n    border-radius: 25px;\n    padding: 10px 30px;\n    font-weight: 500;\n    font-size: 16px;\n}\n.access-key {\n    color: #4b6a81;\n    font-weight: 500;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    align-items: center;\n}\n.access-key .icon-copy {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/copy.svg) no-repeat 0 0 / 100%;\n    width: 26px;\n    height: 26px;\n    filter: invert(72%) sepia(25%) saturate(4663%) hue-rotate(167deg) brightness(94%) contrast(88%);\n    cursor: pointer;\n    -webkit-filter: invert(72%) sepia(25%) saturate(4663%) hue-rotate(167deg) brightness(94%) contrast(88%);\n}\n.client-ip {\n    color: #0b3454;\n    font-weight: 500;\n}\n.filterSearch .refresh-wrap {\n    margin-left: auto;\n}\n\n.data-preview-wrap {\n    border-radius: 6px;\n    border: 1px solid #e1e1e1;\n    overflow: hidden;\n}\n.data-preview-wrap .card_custom .alumni_presence {\n    padding: 0 30px 40px;\n}\n.data-preview-wrap .card_custom .card-header {\n    background: transparent;\n    border-bottom: none;\n    font-size: 22px;\n    text-transform: uppercase;\n    font-weight: 600;\n    padding: 25px;\n}\n.data-preview-wrap .card_custom .card-header select {\n    border-radius: 200px;\n    height: 40px;\n    border: 1px solid #8499a9;\n    font-weight: 500;\n    font-size: 16px;\n    width: auto;\n    max-width: 180px;\n    padding-left: 15px;\n    -webkit-border-radius: 200px;\n    -moz-border-radius: 200px;\n    -ms-border-radius: 200px;\n    -o-border-radius: 200px;\n}\n.data-preview-wrap .card_custom .card-header p span img {\n    margin-top: -7px !important;\n}\n.data-preview-wrap .top-countries .progress {\n    height: 40px;\n    background-color: rgba(0, 0, 0, 0.06);\n}\n.data-preview-wrap .top-countries .progress-bar.countries {\n    background-color: #26a7df;\n}\n.data-preview-wrap .top-countries .exclude_india {\n    font-size: 18px;\n    font-weight: 500;\n}\n.data-preview-wrap .top-countries .caountryname {\n    line-height: 15px;\n}\n.data-preview-wrap .top-careers .progress-bar.countries {\n    background-color: #51499c;\n}\n.data-preview-wrap .top-countries-title {\n    width: 100px;\n}\n.data-preview-wrap .top-countries-title + div {\n    width: calc(100% - 150px);\n}\n.data-preview-wrap .percent-progress {\n    width: 50px;\n}\n.switch_option label {\n    cursor: pointer;\n}\n.switch_option .form-switch .form-check-input {\n    width: 60px;\n    height: 30px;\n    margin: 0 10px 0 0;\n    background-color: #c1ccd4;\n    border-color: #c1ccd4;\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='white'/%3e%3c/svg%3e\");\n}\n.switch_option .form-switch {\n    padding: 0;\n    align-items: center;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n}\n.switch_option .form-switch .form-check-input:checked {\n    background-color: #5cae48;\n    border-color: #5cae48;\n}\n.switch_option .form-switch .form-check-input:focus {\n    box-shadow: none;\n    outline: none;\n}\n\n.override_setting {\n    border-top: 1px solid rgb(233, 246, 252);\n}\n.override_setting ul {\n    padding: 0;\n    margin: 0;\n    list-style: none;\n}\n.override_setting ul li:last-child {\n    padding-top: 15px;\n}\n.override_setting ul li:not(:last-child) {\n    border-bottom: 1px solid #ccc;\n    padding: 15px 0;\n}\n.override_setting .form-check .form-check-input {\n    width: 20px;\n    height: 20px;\n    margin: 0 7px 0 0;\n}\n.override_setting .form-check {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    padding: 0;\n}\n.override_setting .form-check-input:checked {\n    background-color: #fff;\n    border-color: #5cae48;\n}\n.override_setting .form-check-input:checked[type='radio'] {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='%235cae48'/%3e%3c/svg%3e\");\n}\n\n@media (max-width: 767px) {\n    .twoColSection .nav {\n        flex-direction: row;\n        flex-wrap: nowrap;\n        overflow: auto;\n        white-space: nowrap;\n        padding: 7px 0;\n        height: 100%;\n    }\n    .twoColSection .nav .nav-item {\n        padding-right: 0;\n        display: -webkit-box;\n        display: -moz-box;\n        display: -ms-flexbox;\n        display: -webkit-flex;\n        display: flex;\n        align-items: center;\n    }\n    .twoColSection .nav .nav-item .nav-link {\n        border-radius: 4px;\n    }\n    .tab-inner > .row {\n        height: auto;\n    }\n}\n\n@media (max-width: 575px) {\n    .filterSearch .refresh-wrap {\n        width: 100%;\n        order: -1;\n        margin-bottom: 15px;\n        text-align: right;\n        display: -webkit-box;\n        display: -moz-box;\n        display: -ms-flexbox;\n        display: -webkit-flex;\n        display: flex;\n        justify-content: end;\n    }\n}\n\n/* Manage Integrations */\n\n/* manage-widgets-wrap */\n.manage-widgets-wrap ul {\n    padding: 0;\n    margin: 0;\n    list-style: none;\n}\n.manage-widgets-wrap ul li {\n    background: #ffffff;\n    border: 1px solid #eaeaea;\n    border-radius: 4px;\n    padding: 10px;\n}\n.manage-widgets-wrap ul li:not(:last-child) {\n    margin-bottom: 5px;\n}\n.manage-widgets-wrap {\n    margin-top: 25px;\n}\n\n.manage-widgets-wrap .form-check-tick .form-check-input {\n    width: 22px;\n    height: 22px;\n}\n.manage-widgets-wrap span[role=\"log\"] ~ div{min-height: 45px;}\n.btn.btn-widgets-edit {\n    background: #ffffff;\n    border: 2px solid #0b3454;\n    border-radius: 15px;\n    height: 28px;\n    line-height: 25px;\n    padding: 0 20px;\n    text-decoration: none;\n    text-transform: uppercase;\n    font-weight: 600;\n    font-size: 12px;\n    color: #0b3454;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.btn.btn-widgets-edit:hover {\n    background: #0b3454;\n    color: #fff;\n}\n\n.btn.btn-priview {\n    background: #ffffff;\n    border: 2px solid #5cae48;\n    border-radius: 15px;\n    height: 28px;\n    line-height: 25px;\n    padding: 0 20px;\n    text-decoration: none;\n    text-transform: uppercase;\n    font-weight: 600;\n    font-size: 12px;\n    color: #5cae48;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.btn.btn-priview:hover {\n    background: #5cae48;\n    color: #fff;\n}\n\n.btn.btn-configure {\n    background: #0b3454;\n    border: 2px solid #0b3454;\n    border-radius: 15px;\n    height: 28px;\n    line-height: 25px;\n    padding: 0 20px;\n    text-decoration: none;\n    text-transform: uppercase;\n    font-weight: 600;\n    font-size: 12px;\n    color: #fff;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.btn.btn-configure:hover {\n    background: #5cae48;\n    border: 2px solid #5cae48;\n    color: #fff;\n}\n/* manage-widgets-wrap */\n\n/* authorized_accounts */\n.authorized_accounts {\n    margin-top: 35px;\n}\n.authorized_accounts_block {\n    background: #ffffff;\n    height: 100%;\n    border: 1px solid #d2d2d2;\n    border-radius: 6px;\n    opacity: 1;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    padding: 20px;\n}\n.authorized_accounts_status {\n    border-radius: 0px 5px 0px 6px;\n    opacity: 1;\n    width: 108px;\n    height: 24px;\n    position: absolute;\n    right: 0;\n    top: 0;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 14px;\n    font-weight: 500;\n}\n.authorized_accounts_status i {\n    width: 12px;\n    height: 12px;\n    border-radius: 50%;\n    margin-right: 5px;\n}\n.authorized_accounts_status.active {\n    background: #d6ffcc;\n    color: #136000;\n}\n.authorized_accounts_status.active i {\n    background: #5cae48;\n    border: 3px solid #f4fff2;\n}\n.authorized_accounts_status.deactive {\n    background: #f3f3f3;\n    color: #303030;\n}\n.authorized_accounts_status.deactive i {\n    background: #737373;\n    border: 3px solid #ffffff;\n}\n.authorized_accounts_profile_img {\n    width: 48px;\n    height: 48px;\n    border-radius: 50%;\n    overflow: hidden;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 5px;\n}\n.authorized_accounts_profile_img img {\n    width: auto;\n    height: 100%;\n}\n.authorized_accounts_profile_img.logo {\n    border: 1px solid #d5d5d5;\n    padding: 3px;\n}\n.authorized_accounts_detail h3 {\n    font-size: 20px;\n    color: #0b3454;\n    margin: 0;\n}\n.authorized_accounts_detail p {\n    font-size: 14px;\n}\n.authorized_accounts_block > a {\n    width: 110px;\n    border-radius: 23px;\n    height: 36px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-decoration: none;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.authorized_accounts_block a.btn-disconnect {\n    background: #ffffff;\n    border: 2px solid #e1697a;\n    color: #d42941;\n}\n.authorized_accounts_block a.btn-disconnect:hover {\n    background: #e1697a;\n    color: #fff;\n}\n.authorized_accounts_block a.btn-authorize {\n    background: #ffffff;\n    border: 2px solid #547187;\n    color: #0b3454;\n}\n.authorized_accounts_block a.btn-authorize:hover {\n    background: #547187;\n    color: #fff;\n}\n\n.authorized_accounts_block.new_account a {\n    background: #f2f9ff;\n    width: 100%;\n    height: 100%;\n    border-radius: 6px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n    padding: 20px;\n}\n.authorized_accounts_block.new_account {\n    position: relative;\n    border: none;\n    padding: 0;\n}\n.authorized_accounts_block.new_account a .plus {\n    background: #f2f9ff;\n    width: 70px;\n    height: 70px;\n    border: 1px solid #acb0b5;\n    border-radius: 50%;\n    margin-bottom: 15px;\n    position: relative;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.authorized_accounts_block.new_account a .plus:before {\n    content: '';\n    position: absolute;\n    width: 40px;\n    height: 2px;\n    background: #acb0b5;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.authorized_accounts_block.new_account a .plus:after {\n    content: '';\n    position: absolute;\n    width: 2px;\n    height: 40px;\n    background: #acb0b5;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.authorized_accounts_block.new_account a span {\n    width: 110px;\n    border-radius: 23px;\n    height: 36px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-decoration: none;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    background: #5cae48;\n    color: #fff;\n}\n\n.authorized_accounts_block.new_account a:hover {\n    background: #5cae48;\n}\n.authorized_accounts_block.new_account a:hover .plus {\n    background: none;\n    border-color: #fff;\n}\n.authorized_accounts_block.new_account a:hover .plus:before {\n    background: #fff;\n}\n.authorized_accounts_block.new_account a:hover .plus:after {\n    background: #fff;\n}\n.authorized_accounts_block.new_account a:hover span {\n    background: #fff;\n    color: #5cae48;\n}\n\n/* authorized_accounts */\n\n/* alumni directory */\n\n.aldir_scroll > .row > .aldir_box {\n    width: 212px;\n    height: 133px;\n    padding: 0;\n}\n.aldir_scroll > .row > .aldir_box:not(:last-child) {\n    margin-right: 20px;\n}\n.aldir_box .number {\n    padding: 10px 12px 0 20px;\n}\n.aldir_box .number + div > div.font-16 {\n    color: #0b3454;\n    line-height: 18px;\n    padding: 8px 0 0 18px;\n}\n.aldir_box .alumni-directory-img {\n    margin-right: 10px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: flex-end;\n}\n.aldir_box .alumni-directory-block {\n    justify-content: space-between;\n    flex-direction: row;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-wrap: wrap;\n    overflow: hidden;\n}\n.aldir_box .alumni-directory-block > div {\n    width: 100%;\n}\n.aldir_box .number + div > div.font-16.min94 {\n    min-width: 94px;\n}\n.aldir_scroll > .row {\n    width: max-content;\n    margin: 0;\n}\n\n.fiterItem {\n    padding: 0;\n    border: 1px solid rgba(0, 0, 0, 0.125);\n    border-radius: 6px;\n    overflow: hidden;\n    -webkit-border-radius: 6px;\n    -moz-border-radius: 6px;\n    -ms-border-radius: 6px;\n    -o-border-radius: 6px;\n}\n.filterHeader {\n    background: transparent;\n    border-radius: 0;\n    padding: 0;\n    border: 0px solid rgba(0, 0, 0, 0.125);\n}\n.filterHeader button span.toggle {\n    width: 10px;\n    height: 10px;\n    margin-left: 10px;\n    position: relative;\n}\n.filterHeader button span.toggle::before {\n    width: 10px;\n    height: 10px;\n    background: transparent;\n    border-left: 2px solid #000;\n    border-top: 2px solid #000;\n    transform: rotate(45deg);\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    margin: auto;\n    content: '';\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.filterHeader button.collapsed span.toggle::before {\n    transform: rotate(225deg);\n    -webkit-transform: rotate(225deg);\n    -moz-transform: rotate(225deg);\n    -ms-transform: rotate(225deg);\n    -o-transform: rotate(225deg);\n}\n\n.scrollMe {\n    max-height: 215px;\n    margin-bottom: 0px;\n    overflow-y: auto;\n    scrollbar-width: thin;\n}\n.scrollMe::-webkit-scrollbar {\n    width: 4px;\n}\n.scrollMe::-moz-scrollbar {\n    width: 4px;\n}\n.scrollMe::-webkit-scrollbar-track {\n    background: #eee;\n}\n.scrollMe::-webkit-scrollbar-thumb {\n    background-color: #ccc;\n    border-radius: 20px;\n    border: 2px solid #666;\n}\n\n.fiterItem .form-check:not(:last-child) {\n    margin-bottom: 10px;\n}\n.fiterItem .form-check .form-check-input {\n    width: 20px;\n    height: 20px; /* margin-left: -20px; */\n    border: 1px solid #bacfde;\n}\n.fiterItem label {\n    cursor: pointer;\n    padding-top: 3px !important;\n}\n.fiterItem .card {\n    border-radius: 0;\n    border: 0px solid #fff;\n    padding: 0px 20px 20px;\n}\n.filterHeader button {\n    background: #fff;\n    border-radius: 0;\n    padding: 0;\n    border: 0px solid rgba(0, 0, 0, 0.125);\n    padding: 15px 20px;\n}\n.filterHeader button.collapsed {\n    border-bottom: 0px solid rgba(0, 0, 0, 0.125);\n}\n.filterSearchblk {\n    margin: 0px;\n    padding: 0 18px;\n}\n.filterSearchblk .filterSearch input {\n    background: #f3f3f3;\n    border: 0 solid #fff;\n    border-radius: 6px;\n    color: #000;\n    height: 36px;\n    line-height: 36px;\n    margin: 0 4px 2px;\n}\n.filterSearchblk .filterSearch button {\n    position: absolute;\n    right: 14px;\n    width: 14px;\n    height: 14px;\n    font-size: 14px;\n    top: 9px;\n    padding: 0;\n    color: #414141;\n}\n.ji_filtersec {\n    width: 100%;\n    max-width: 320px;\n}\nform.minmaxlb .form-label {\n    color: #535353;\n    font-size: 14px;\n    font-weight: 500;\n    font-style: italic;\n}\nform.minmaxlb button {\n    max-width: 91px;\n    background: #0b3454;\n    padding: 0;\n    height: 36px;\n    line-height: 36px;\n    color: #fff;\n    border-radius: 18px;\n}\n.fiterItem .card .form-check-input:checked,\nform.lstCustForm .form-check-input:checked {\n    background-color: #5cae48;\n    border-color: #5cae48 !important;\n}\n.form-check-input:focus {\n    box-shadow: 0 0 0 0 rgba(13, 110, 253, 0.25);\n}\n\n.alumni-directory-header {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 20px;\n}\n.alumni-directory-header_search {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    align-items: center;\n}\n.alumni-directorySearch {\n    background: #ffffff;\n    width: 365px;\n    height: 40px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    border-radius: 25px;\n    overflow: hidden;\n    position: relative;\n}\n.alumni-directorySearch .form-control {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    border: 0;\n    padding-left: 0;\n}\n.alumni-directorySearch .btn.icon-search {\n    font-size: 12px;\n    padding: 0 10px 0 20px;\n}\n\n.alumni-directory-header .btn-white {\n    background: #ffffff;\n    border-radius: 20px;\n    padding: 0 20px;\n    line-height: 40px;\n    text-decoration: none;\n    color: #000000;\n    font-weight: 400;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.alumni-directory-header .btn-white:hover {\n    background: #882130;\n    color: #fff;\n}\n\n.alumni-directorySearch .btn-search-cross {\n    position: absolute;\n    right: 13px;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    color: #000;\n    font-weight: 100 !important;\n}\n.alumni-directorySearch .btn-cross {\n    width: 14px;\n    height: 14px;\n    position: absolute;\n    right: -15px;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    transform: rotate(0deg);\n    opacity: 0;\n    transition: all 0.5s ease-in-out;\n}\n.alumni-directorySearch .btn-cross:before {\n    content: '';\n    position: absolute;\n    width: 14px;\n    height: 2px;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    top: 0;\n    margin: auto;\n    background: #000;\n    border-radius: 5px;\n}\n.alumni-directorySearch .btn-cross:after {\n    content: '';\n    position: absolute;\n    width: 2px;\n    height: 14px;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    top: 0;\n    margin: auto;\n    background: #000;\n    border-radius: 5px;\n}\n.alumni-directorySearch .form-control:valid + .btn-cross {\n    opacity: 1;\n    right: 15px;\n    transform: rotate(135deg);\n}\n\n.alumni_directory_filter {\n    padding: 30px 0;\n    padding-right: var(--bs-gutter-x, 0.75rem);\n    padding-left: var(--bs-gutter-x, 0.75rem);\n}\n.alumni_directory_filter .ji_filtersec {\n    width: 100%;\n    max-width: 100%;\n}\n.alumni_directory_filter .fiterItem {\n    width: calc(33.3% - 10px);\n    margin: 0 5px;\n    box-shadow: 0px 10px 25px #00000008;\n}\n.alumni_directory_filter .fiterItem.w-20 {\n    width: calc(20% - 10px);\n}\n.alumni_directory_filter .fiterItem.width-25 {\n    width: calc(25% - 10px);\n}\n.alumni_directory_filter .fiterItem.w-40 {\n    width: calc(40% - 10px);\n}\n.alumni_directory_filter #additionalfilter .fiterItem {\n    width: 28%;\n}\n.alumni_directory_filter #additionalfilter .fiterItem.w-20 {\n    width: calc(20% - 10px);\n}\n.alumni_directory_filter #additionalfilter .fiterItem.width-25 {\n    width: calc(25% - 10px);\n}\n.alumni_directory_filter #additionalfilter .fiterItem.width-50 {\n    width: calc(50% - 10px);\n}\n.alumni_directory_filter #additionalfilter .fiterItem.w-40 {\n    width: calc(40% - 10px);\n}\n.alumni_directory_filter #additionalfilter .fiterItem.campus {\n    width: 41%;\n}\n.filterItemWrap .fiterItem {\n    width: 190px;\n}\n.alumni_directory_filter .fiterItem.key {\n    border-color: #5cae48;\n}\n.alumni_directory_filter .filterGroup {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    align-items: start;\n    margin: 0 -5px;\n}\n.alumni_directory_filter .filterSearchblk {\n    background: #fff;\n    padding: 0 14px 10px;\n}\n.alumni_directory_filter .filterSearchblk .filterSearch input {\n    margin: 0;\n}\n.filters-head {\n    position: relative;\n}\n.filterItemWrap {\n    position: absolute;\n    top: -10px;\n    left: 90px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    z-index: 1;\n    align-items: start;\n}\n.alumni_directory_filter .filterItemWrap .filterHeader button {\n    padding: 7px 15px;\n}\n.alumni_directory_filter .filterHeader button {\n    transition: all 0.3s ease-in-out;\n    padding: 15px 15px;\n}\n.alumni_directory_filter .filterHeader button:not([aria-expanded='false']) {\n    padding-bottom: 8px;\n}\n.alumni_directory_filter .fiterItem .card {\n    padding: 0px 15px 15px;\n}\n.alumni_directory_filter .scrollMe {\n    max-height: 122px;\n    min-height: 122px;\n    overflow-x: hidden;\n}\n.alumni_directory_filter .fiterItem .form-check {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n}\n.alumni_directory_filter .fiterItem .form-check:not(:last-child) {\n    margin-bottom: 4px;\n}\n.additionalfilter_count {\n    display: block;\n    letter-spacing: 2px;\n    flex: 1;\n    padding: 0 5px;\n}\n.additionalfilter_count:before {\n    content: '(';\n}\n.additionalfilter_count:after {\n    content: ')';\n}\n.btn-md-filter {\n    text-decoration: none;\n    transform: rotate(90deg);\n    color: #000;\n    font-size: 20px;\n    transition: all 0.3s ease-in-out;\n}\n.btn-md-filter:hover {\n    color: #000;\n}\n.btn-md-filter[aria-expanded='true'] {\n    transform: rotate(270deg);\n}\n.additionalfilter_wrap {\n    width: 100%;\n    padding: 0 5px;\n}\n.alumni_directory_filter .fiterItem.campus {\n    width: 450px;\n}\n\n.showProfiles_wrap {\n    background: #fff;\n    border: 1px solid #d2d2d2;\n    border-radius: 6px;\n    box-shadow: 0px 10px 25px #00000008;\n    width: calc(100% - 10px);\n    margin: 0 5px;\n    padding: 17px 30px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n.showProfiles_left {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    align-items: center;\n}\n.showProfiles_left h3 {\n    margin: 0 30px 0 0;\n    font-size: 18px;\n    line-height: 20px;\n    font-weight: 600;\n}\n.showProfiles_left .form-check-label {\n    font-size: 16px;\n}\n.showProfiles_left .form-check-input {\n    width: 20px;\n    height: 20px;\n    vertical-align: top;\n    margin-top: -2px;\n    margin-right: 10px;\n}\n.showProfiles_left .form-check.form-check-inline {\n    display: inline-flex;\n    align-items: center;\n}\n.showProfiles_left .check_list {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    align-items: center;\n}\n.showProfiles_left .form-check-input:checked {\n    background-color: #5cae48;\n    border-color: #5cae48;\n}\n.showProfiles_right .icon {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/subtraction.svg);\n    width: 16px;\n    height: 25px;\n    margin-right: 8px;\n}\n.showProfiles_right {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n}\n.showProfiles_right .title {\n    font-size: 14px;\n    letter-spacing: -0.35px;\n    height: auto;\n}\n\n.alumni-bucket {\n    background: #ffffff;\n    border: 1px solid #d2d2d2;\n    border-radius: 6px;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n}\n.alumni-bucket .form-check {\n    position: absolute;\n    left: 6px;\n    top: 6px;\n    cursor: pointer;\n    z-index: 1;\n}\n.alumni-bucket .block-link {\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    top: 0;\n    margin: auto;\n    z-index: 1;\n}\n.alumni_img {\n    width: 60px;\n    margin-right: 10px;\n    height: 60px;\n    background: #f1f1f1;\n    border-radius: 50%;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.alumni_img img {\n    width: auto;\n    height: 100%;\n}\n.alumni_img.no_pic {\n    align-items: end;\n}\n.alumni_img.no_pic img {\n    width: auto;\n    height: auto;\n}\n.alumni_name_brife h3 {\n    font-size: 18px;\n    margin: 0 0 3px;\n}\n.class_year {\n    color: #6a6868;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 18px;\n}\n.alumni_directory_details .btn-viewcompus {\n    font-size: 13px;\n    color: #1452ce;\n    font-weight: 500;\n    line-height: 18px;\n    position: relative;\n    z-index: 2;\n    text-decoration: none;\n}\n.alumni_directory_details .btn-viewcompus:hover {\n    color: #0b3454;\n    text-decoration: underline;\n}\n.alumni_directory_details a.btn-send {\n    padding: 0 20px;\n    line-height: 36px;\n    text-decoration: none;\n    background: #5cae48;\n    border-radius: 25px;\n    height: 36px;\n    display: inline-flex;\n    color: #fff;\n    align-items: center;\n    transition: all 0.3s ease-in-out;\n    position: relative;\n    z-index: 2;\n}\n.alumni_directory_details a.btn-send:hover {\n    background: #40862f;\n}\n.icon-alumni-send {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/send_alumni_profile.svg) no-repeat 0\n        0 / 100%;\n    width: 19px;\n    height: 19px;\n    margin-right: 8px;\n    margin-left: -3px;\n}\n.alumni_univarsity_details {\n    background: #f9f9f9;\n    border-radius: 0px 0px 5px 5px;\n    opacity: 1;\n    display: flex;\n    justify-content: center;\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    padding: 15px 20px;\n    position: relative;\n}\n.alumni_univarsity_details .alumni_univarsity_details_inner_cover {\n    width: 100%;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    align-items: start;\n}\n.alumni_univarsity_details .alumni_univarsity_details_inner_cover .alumni_univarsity_logo {\n    width: 64px;\n    margin-right: 10px;\n    padding: 6px;\n    background: #fff;\n    border-radius: 50%;\n    border: 1px solid #d2d2d2;\n    height: 64px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.alumni_univarsity_details .alumni_univarsity_details_inner_cover .alumni_univarsity_logo.icon-brife-case {\n    height: 64px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #dc3545;\n    border: 1px solid #dc3545;\n}\n.alumni_univarsity_details .alumni_univarsity_details_inner_cover .alumni_univarsity_logo img {\n    max-width: 100%;\n    max-height: 100%;\n    width: auto;\n    height: auto;\n}\n.alumni_univarsity_details .alumni_univarsity_details_inner_cover .alumni_univarsity_brife {\n    width: calc(100% - 75px);\n}\n.alumni_directory_details a.alumni_name_link {\n    color: #000;\n    text-decoration: none;\n    font-size: 18px;\n    line-height: 18px;\n}\n.alumni_directory_details a.alumni_name_link:hover {\n    color: #666;\n}\n.alumni_directory_details .alumni_campus {\n    color: #6a6868;\n    font-size: 14px;\n    font-weight: 500;\n}\n\n.btn-pushwebsite {\n    background: #5cae48;\n    border-radius: 20px;\n    margin-top: 15px;\n    display: inline-flex;\n    height: 40px;\n    padding: 0 20px;\n    align-items: center;\n    text-decoration: none;\n    color: #fff;\n    font-weight: 500;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.btn-pushwebsite i {\n    margin-right: 10px;\n    width: 20px;\n    height: 20px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/web.svg) no-repeat center;\n}\n.btn-pushwebsite:hover {\n    background: #3d842b;\n    color: #fff;\n}\n\n.alumni_directory_details .alumni_course {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    margin-top: 8px;\n}\n.alumni_directory_details .alumni_course i {\n    width: 24px;\n    height: 24px;\n    margin-right: 5px;\n}\n.alumni_directory_details .alumni_course i.study {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/student-book.svg) no-repeat center /\n        100%;\n}\n.alumni_directory_details .alumni_course span {\n    font-size: 16px;\n    font-weight: 600;\n}\n.alumni_class_link {\n    padding: 15px 20px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    align-items: center;\n}\n.alumni_name_detail {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n}\n.alumni_class_link .modal {background: rgba(0, 0, 0, 0.8);}\n.alumni_name_brife {\n    display: flex;\n    flex-direction: column;\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    justify-content: center;\n}\n.alumni_education {\n    color: #4d4d4d;\n    font-size: 13px;\n    font-weight: 500;\n    line-height: 18px;\n    margin-bottom: 3px;\n}\n.alumni_univarsity_name {\n    font-size: 19px;\n    font-weight: 600;\n    line-height: 20px;\n    margin-bottom: 4px;\n}\n.alumni_univarsity_name .icon-subtraction {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/subtraction.svg) no-repeat 0 0 / 100%;\n    width: 12px;\n    height: 20px;\n    margin-left: 3px;\n    display: inline-block;\n    vertical-align: top;\n}\n.alumni_univarsity_subject {\n    color: #0b3454;\n    font-size: 14px;\n    line-height: 16px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n}\n.alumni_univarsity_subject span {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n}\n.alumni_univarsity_subject i {\n    width: 16px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/subject_setting.svg) no-repeat 0 0 /\n        100%;\n    height: 16px;\n    margin-right: 7px;\n}\n.alumni_univarsity_subject i.icon-brifecase {\n    width: 16px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/briefcase.svg) no-repeat 0 0 / 100%;\n    height: 16px;\n    margin-right: 7px;\n}\n\n.alumni_name_brife h3 a {\n    color: #000;\n    text-decoration: none;\n    font-size: 18px;\n    line-height: 18px;\n    word-break: break-all;\n    overflow: hidden;\ntext-overflow: ellipsis;\ndisplay: -webkit-box;\n-webkit-line-clamp: 1;\n-webkit-box-orient: vertical;\n}\n.alumni_name_brife .alumni_campus {\n    color: #6a6868;\n    font-size: 14px;\n    font-weight: 500;\n}\n.alumni_name_brife .alumni_course {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    margin-top: 8px;\n}\n.alumni_name_brife .alumni_course i {\n    width: 24px;\n    height: 24px;\n    margin-right: 5px;\n}\n.alumni_name_brife .alumni_course i.study {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/student-book.svg) no-repeat center /\n        100%;\n}\n.alumni_name_brife .alumni_course span {\n    font-size: 16px;\n    font-weight: 600;\n}\n\n.filter_result ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n}\n.filter_result_title {\n    margin-bottom: 18px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    margin-top: 10px;\n}\n.filter_result_title .filter_result {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n}\n.filter_result ul li {\n    background: #e9f6fc;\n    border-radius: 25px;\n    padding: 9px 23px;\n    margin-top: 6px;\n    margin-bottom: 6px;\n}\n.filter_result ul li:not(:last-child) {\n    margin-right: 10px;\n}\n.filter_result ul li:last-child {\n    background: no-repeat;\n    padding: 9px 0;\n}\n.filter_result ul li span {\n    margin-right: 10px;\n}\n.filter_result ul li .btn-cross {\n    font-size: 10px;\n    color: #000;\n    text-decoration: none;\n}\n.filter_result ul li .btn-cross:hover {\n    color: #105271;\n}\n.alumni_count {\n    font-size: 18px;\n    font-weight: 500;\n    line-height: 20px;\n    margin: 18px 0 0;\n}\n\n.btn-additionalfilter {\n    text-decoration: none;\n    font-size: 14px;\n    color: #1452ce;\n    font-weight: 500;\n    display: inline-flex;\n    align-items: center;\n    transition: all 0.3s ease-in-out;\n}\n.btn-additionalfilter span {\n    text-decoration: underline;\n    margin-right: 10px;\n}\n.btn-additionalfilter .icon-right-arrow {\n    transform: rotate(90deg);\n    transition: all 0.3s ease-in-out;\n}\n.btn-additionalfilter[aria-expanded='true'] .icon-right-arrow {\n    transform: rotate(270deg);\n}\n.btn-additionalfilter:hover {\n    color: #0b3454;\n}\n.btn-additionalfilter:hover span {\n    text-decoration: none;\n}\n\n.alumni_directory_filter .filters-head h3 {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    margin: 0;\n    align-items: center;\n}\n.alumni_directory_filter .filters-head h3 .icon-filter + span {\n    flex: 1;\n}\n.alumni_directory_filter .filters-head h3[aria-expanded='true'] i {\n    transform: rotate(270deg);\n}\n\n.alumni_directory_details .load_more_btn {\n    text-decoration: none;\n    text-transform: uppercase;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.alumni_directory_details .load_more_btn:hover {\n    background: #0b3454;\n    color: #fff;\n    border-color: #0b3454;\n}\n\n.alumni_directory_details .load_more_btn img {\n    animation: none;\n    -webkit-animation: none;\n    margin-right: 10px;\n}\n.alumni_directory_details .load_more_btn:hover img {\n    filter: invert(1) brightness(100);\n}\n.tooltip-viewcompus .tooltip-arrow::before {\n    display: none;\n}\n.alumni_directory_details .load_more_btn {\n    text-decoration: none;\n    text-transform: uppercase;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border: 1px solid #cccc;\n    padding: 10px 25px;\n    border-radius: 25px;\n    transition: all 0.3s ease-in-out;\n    max-width: 250px;\n    width: 100%;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.alumni_directory_details .load_more_btn:hover {\n    background: #0b3454;\n    color: #fff;\n    border-color: #0b3454;\n}\n\n/* .alumni_profile_brife_wrap {border-bottom: 1px solid #E7E7E7;}\n.alumni_profile_brife {padding: 40px 0;}\n.alumni_profile_brife .btn-back {color: #000;font-size: 14px;line-height: 16px;font-weight: 500;text-decoration: none;}\n.alumni_profile_brife .btn-back .icon-right-arrow {transform: scaleX(-1);margin-right: 7px;font-size: 12px;}\n.alumni_profile_brife .btn-back:hover {color: #0b3454;}\n\n.alumni_profile_name_college_other_detail_wrap {display: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex;-webkit-box-wrap: wrap;-moz-box-wrap: wrap;-ms-flex-wrap: wrap;-webkit-wrap: wrap;flex-wrap: wrap;}\n.alumni_profile_image_name_other_detail {display: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex;-webkit-box-wrap: wrap;-moz-box-wrap: wrap;-ms-flex-wrap: wrap;-webkit-wrap: wrap;flex-wrap: wrap;padding: 0 45px 0 0;position: relative;width: 45%;}\n.alumni_profile_image_name_other_detail:after {content: '';width: 1px;height: 100%;background: #D4D4D4;position: absolute;right: 0;top: 0;}\n.alumni_profile_image {width: 110px;height: 110px;background: #F1F1F1;border-radius: 50%;display: flex;align-items: center;justify-content: center;overflow: hidden;margin-right: 20px;}\n.alumni_profile_image img {width: auto;height: 100%;}\n.alumni_profile_image.no_pic {align-items: end;}\n.alumni_profile_image.no_pic img {height: 80%;}\n\n.alumni_profile_name_other_detail {-webkit-box-flex: 1;-moz-box-flex: 1;-webkit-flex: 1;-ms-flex: 1;flex: 1;}\n.alumni_profile_name_other_detail h2 {font-size: 30px;line-height: 18px;font-weight: 600;word-break: break-all;line-height: 35px;}\n.alumni_profile_name_other_detail .alumni_profile_location {font-size: 14px;font-weight: 500;margin-bottom: 15px;}\n.alumni_profile_class_college {position: relative;padding: 0 0 0 20px;margin-bottom: 13px;}\n.alumni_profile_class_college:before {content: '';position: absolute;left: 6px;top: 0;bottom: 0;width: 3px;height: 100%;background: #D52941;border-radius: 5px;}\n.alumni_profile_class_college .alumni_profile_class {font-size: 16px;font-weight: 500;letter-spacing: 0.32px;line-height: 18px;margin-bottom: 5px;}\n.alumni_profile_class_college .alumni_profile_college {font-size: 16px;font-weight: 500;letter-spacing: 0.32px;line-height: 18px;}\n\n.alumni_profile_college_phone {display: flex;flex-wrap: wrap;justify-content: space-between;align-items: center;}\n.alumni_profile_college_phone .verifyLink {font-size: 16px;font-weight: 500;}\n.verifiedLink {color: #5cae48;text-decoration: none;display: flex;align-items: center;font-weight: 400;font-size: 16px;}\n\n.alumni_profile_name_other_detail .btn-send {width: 123px;height: 40px;display: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex;-webkit-box-wrap: wrap;-moz-box-wrap: wrap;-ms-flex-wrap: wrap;-webkit-wrap: wrap;flex-wrap: wrap;background: #5CAE48;border-radius: 25pc;color: #fff;text-decoration: none;align-items: center;padding: 0 25px;font-size: 16px;font-weight: 500;transition:all 0.3s ease-in-out;}\n.alumni_profile_name_other_detail .btn-send .icon-send {background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/send_alumni_profile.svg) no-repeat 0 0 / 100%;width: 19px;height: 19px;margin-right: 10px;position:relative;transition:all 0.3s ease-in-out;left:0;}\n.alumni_profile_name_other_detail .btn-send:hover{background:#2FA612}\n.alumni_profile_name_other_detail .btn-send:hover .icon-send {left:3px}\n\n.alumni_profile_college_name_other_detail_wrap {-webkit-box-flex: 1;-moz-box-flex: 1;-webkit-flex: 1;-ms-flex: 1;flex: 1;display: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex;-webkit-box-wrap: wrap;-moz-box-wrap: wrap;-ms-flex-wrap: wrap;-webkit-wrap: wrap;flex-wrap: wrap;padding: 0 0 0 80px;}\n.alumni_profile_college_name_other_detail_wrap .alumni_profile_college_logo {width: 100px;height: 100px;display: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex;align-items: center;justify-content: center;border-radius: 50%;border: 1px solid #D2D2D2;margin-right: 18px;}\n.alumni_profile_college_name_other_detail_wrap .alumni_profile_college_logo img {width: 70%;}\n.alumni_profile_college_name_other_detail_wrap .alumni_profile_college_logo img[src*=\"college_icon\"] {\twidth: 40px;\t}\n.alumni_profile_college_name_other_detail_wrap .alumni_profile_college_name_other_detail {-webkit-box-flex: 1;-moz-box-flex: 1;-webkit-flex: 1;-ms-flex: 1;flex: 1;display: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex;-webkit-box-wrap: wrap;-moz-box-wrap: wrap;-ms-flex-wrap: wrap;-webkit-wrap: wrap;flex-wrap: wrap;align-items: start;}\n\n.alumni_profile_brife_tab {margin-bottom: 20px;width: 100%;}\n.alumni_profile_status {list-style: none;margin: 0;padding: 0;}\n.alumni_profile_status li {margin-bottom: 16px;width: 176px;position: relative;padding-left: 16px;}\n.alumni_profile_status li .title {letter-spacing: 0.32px;color: #000000;font-size: 16px;}\n.alumni_profile_status li p {font-size: 16px;font-weight: 600;line-height: 20px;letter-spacing: 0.32px;}\n.alumni_profile_status li:before {content: '';width: 3px;height: 17px;position: absolute;left: 0;top: 4px;background: #d52941;border-radius: 5px;}\n\n.alumni_profile_college_joined {color: #5CAE48;font-size: 14px;font-weight: 500;line-height: 18px;margin-bottom: 5px;}\n.alumni_profile_college_name_detail {-webkit-box-flex: 1;-moz-box-flex: 1;-webkit-flex: 1;-ms-flex: 1;flex: 1;padding-right: 50px;}\n.alumni_profile_college_name_other_detail_wrap .alumni_profile_college_name_detail h3 {font-size: 20px;line-height: 26px;font-weight: 600;}\n.alumni_profile_college_subject {height: 30px;display: inline-flex;align-items: center;justify-content: center;padding: 0 15px;background: #E5F1FB;border-radius: 25px;font-size: 16px;line-height: 16px;font-weight: 600;color:#0B3454;max-width: 280px;width: auto;}\n.alumni_profile_college_subject .icon {background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/course_alumni_profile.svg);width: 15px;height: 15px;margin-right: 8px;}\n.alumni_profile_college_subject span{text-overflow: ellipsis;overflow: hidden;white-space: nowrap;width: calc(100% - 23px);}\n.alumni_profile_brife_links {width: 100%;padding-left: 129px;margin-top: 20px;display: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex;align-items: center;}\n.alumni_profile_brife_links > a { height: 40px; padding: 0 20px; border-radius: 25px; display: inline-flex; align-items: center; margin-right: 6px; text-decoration: none; transition:all 0.3s ease-in-out ; -webkit-transition:all 0.3s ease-in-out ; -moz-transition:all 0.3s ease-in-out ; -ms-transition:all 0.3s ease-in-out ; -o-transition:all 0.3s ease-in-out ; }\n.alumni_profile_brife_links > a i {margin-right: 5px;}\n.alumni_profile_brife_links > a.btn-send{background: #5CAE48;color: #fff;}\n.alumni_profile_brife_links > a.btn-send:hover{background: #2FA612;}\n.alumni_profile_brife_links > a.btn-send i.icon-send {background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/send_alumni_profile.svg) no-repeat 0 0 / 100%;width: 19px;height: 19px;margin-right: 10px;position: relative;transition: all 0.3s ease-in-out;left: 0;-webkit-transition: all 0.3s ease-in-out;-moz-transition: all 0.3s ease-in-out;-ms-transition: all 0.3s ease-in-out;-o-transition: all 0.3s ease-in-out;}\n.alumni_profile_brife_links .btn-send:hover .icon-send {left: 3px;}\n\n.alumni_profile_brife_links > a.btn-push-web {background: #27A7DF;color: #fff;}\n.alumni_profile_brife_links > a.btn-push-web:hover{background: #078DC8;}\n.alumni_profile_brife_links > a.btn-push-web i.icon-globe {background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/web.svg) no-repeat 0 0 / 100%;width: 19px;height: 19px;margin-right: 10px;position: relative;transition: all 0.3s ease-in-out;left: 0;-webkit-transition: all 0.3s ease-in-out;-moz-transition: all 0.3s ease-in-out;-ms-transition: all 0.3s ease-in-out;-o-transition: all 0.3s ease-in-out;}\n.alumni_profile_brife_links .btn-push-web:hover .icon-globe {left: 3px;}\n\n.alumni_profile_brife_links > a.btn-mark {background: #fff;border: 2px solid #0b3454;color: #0b3454;}\n.alumni_profile_brife_links > a.btn-mark:hover {background: #0b3454;color: #fff;}\n\n.alumni_profile_detail {padding: 30px 0;}\n.alumni_profile_brife_tab .nav {justify-content: center;}\n.alumni_profile_brife_tab .nav-item:not(:last-child) {margin-right: 10px;}\n.alumni_profile_brife_tab .nav-pills .nav-link {min-width: 100px;height: 40px;white-space: nowrap;border: 2px solid #7D7D7D;border-radius: 25px;background: #fff;color: #000;padding: 0 20px;}\n.alumni_profile_brife_tab .nav-pills .nav-link.active, .alumni_profile_brife_tab .nav-pills .nav-link:hover {background: #0B3454;border-color: #0B3454;color: #fff;} */\n\n.underGraduate-detail .main_title,\n.blockHeader {\n    font-size: 22px;\n    color: #000;\n    width: auto;\n    margin: -40px -40px 25px;\n    border-radius: 6px 6px 0px 0px;\n    padding: 20px 40px;\n    line-height: 22px;\n    border-bottom: 1px solid #f5f5f5;\n}\n.blockHeader .title span {\n    font-weight: 600;\n}\n.graduateRow .college_detail_wrap .college_detail h3 {\n    font-size: 20px;\n    font-weight: 600;\n    margin: 0 0 2px;\n    transition: all 0.3s ease-in-out;\n}\n.graduateRow .college_detail_wrap:hover h3 {\n    text-decoration: underline;\n    color: #1452ce;\n}\n.graduateRow .college_detail_wrap .college_detail h3 .icon-subtraction {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/subtraction.svg) no-repeat 0 0 / 100%;\n    width: 16px;\n    height: 25px;\n    margin-left: 3px;\n    display: inline-block;\n    vertical-align: top;\n}\n.graduateRow .college_detail_wrap .college_detail p {\n    font-size: 16px;\n    color: #414141;\n    margin: 0 0 5px;\n}\n.graduateRow {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    position: relative;\n}\n.graduateRow:not(:last-child) {\n    border-bottom: 2px solid #e5e5e5;\n    margin-bottom: 28px;\n    padding-bottom: 28px;\n}\n.underGraduate-detail,\n.postGraduate-detail {\n    box-shadow: 0px 10px 25px #00000008;\n    border-radius: 6px;\n    background: #fff;\n    padding: 40px;\n}\n.graduateRow .college_detail_wrap {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    width: calc(100% - 265px);\n    padding-right: 40px;\n    position: relative;\n    align-items: center;\n}\n.graduateRow .college_detail_wrap > a {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n}\n.graduateRow .college_detail_wrap:after {\n    content: '';\n    position: absolute;\n    top: 13px;\n    right: 0;\n    width: 2px;\n    height: 63px;\n    background: #d1d1d1;\n}\n.graduateRow .offer {\n    width: 265px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n    align-items: end;\n    justify-content: center;\n}\n.graduateRow .college_detail_wrap .college_detail {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n}\n.graduateRow .college_detail_wrap .college_detail .college_logo {\n    margin-right: 20px;\n    width: 150px;\n    height: 95px;\n    border: 1px solid #d5d5d5;\n    border-radius: 6px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.college_name_scholarship {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    align-items: center;\n}\n.college_name_scholarship .college_name {\n    width: calc(100% - 180px);\n}\n.graduateRow .college_detail_wrap .college_detail .college_logo .logo_link {\n    padding: 10px;\n    display: inline-flex;\n    width: 100%;\n    height: 100%;\n    align-items: center;\n    justify-content: center;\n}\n.graduateRow .college_detail_wrap .college_detail .college_logo .logo_link img {\n    width: auto;\n    height: auto;\n    max-width: 100%;\n}\n.graduateRow .college_detail_wrap .scholarship {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n    text-align: center;\n    line-height: 20px;\n}\n.graduateRow .college_detail_wrap .scholarship .scholarship_label {\n    font-weight: 500;\n    color: #8a8a8a;\n}\n.graduateRow .college_detail_wrap .scholarship .scholarship_amt {\n    font-weight: 600;\n    white-space: nowrap;\n}\n.graduateRow .offer > a,\n.graduateRow .offer a.joindeLink {\n    padding: 0 20px;\n    text-decoration: none;\n    height: 37px;\n    background: #5cae48;\n    color: #fff;\n    border-radius: 25px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 14px;\n    font-weight: 500;\n    margin-bottom: 10px;\n    transition: all 0.3s ease-in-out;\n}\n.graduateRow .offer > a:hover,\n.graduateRow .offer a.joindeLink:hover {\n    background: #3e9329;\n}\n.graduateRow .offer > a i,\n.graduateRow .offer a.joindeLink i {\n    margin-right: 10px;\n}\n.graduateRow .offer > a:hover {\n    background: #3b8d27;\n}\n.graduateRow .offer .got_offer {\n    font-weight: 500;\n    font-size: 16px;\n    margin-bottom: 5px;\n}\n.graduateRow .offer .got_offer i {\n    margin-right: 10px;\n    font-size: 20px;\n    color: #5cae48;\n}\n.graduateRow .offer .offerLink {\n    color: #1452ce;\n}\n.graduateRow .offer .offerLink:hover {\n    color: #0b3454;\n}\n.graduateRow .offer .offer_joined i {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/hat_alumni.svg);\n    width: 23px;\n    height: 17px;\n    margin-right: 10px;\n}\n.graduateRow .offer .offer_joined {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n}\n\n.graduateRow.edit .college_detail_wrap {\n    width: calc(100% - 350px);\n}\n.graduateRow .offer.offer_edit {\n    flex-direction: row;\n    align-items: center;\n    width: 350px;\n    justify-content: end;\n}\n.graduateRow .offer.offer_edit .edit_section,\n.edit_section {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    margin-left: 20px;\n    align-items: center;\n}\n.edit_section_inner {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n}\n.graduateRow .offer .edit_link,\n.edit_section .edit_link {\n    width: 52px;\n    height: 30px;\n    background: #eaf4fc;\n    border-radius: 20px;\n    transition: all 0.3s ease-in-out;\n    position: relative;\n}\n.graduateRow .offer .edit_link:hover,\n.edit_section .edit_link:hover {\n    background-color: #0b3454;\n}\n.graduateRow .offer .edit_link:before,\n.edit_section .edit_link::before {\n    content: '';\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    top: 0;\n    margin: auto;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/draw.svg) no-repeat center / 18px\n        auto;\n}\n.graduateRow .offer .edit_link:hover:before,\n.edit_section .edit_link:hover::before {\n    filter: invert(99%) sepia(1%) saturate(2%) hue-rotate(228deg) brightness(110%) contrast(100%);\n}\n.graduateRow .offer .del_link,\n.edit_section .del_link,\n.del_link {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/delete.svg);\n    width: 14px;\n    height: 16px;\n    margin-left: 10px;\n    opacity: 0.5;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.graduateRow .offer .del_link:hover,\n.edit_section .del_link:hover,\n.del_link:hover {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/delete_dark.svg);\n    opacity: 1;\n}\n.graduateRow .offer .offer_existing_links {\n    display: flex;\n    flex-direction: column;\n    align-items: end;\n}\n.form-group .del_link {\n    position: absolute;\n    top: 15px;\n    right: -20px;\n}\n\n.graduation-title {\n    font-size: 22px;\n    font-weight: 400;\n    margin: -15px 0 20px;\n}\n.graduation-title span {\n    font-weight: 600;\n}\n\n.graduation_carousel_wrap {\n    margin-top: 20px;\n    box-shadow: 0px 10px 25px #00000008;\n    border-radius: 6px;\n    background: #fff;\n    padding: 40px;\n}\n.graduation_carousel_wrap .card_profiles:first-child {\n    margin-bottom: 18px;\n}\n.graduation_carousel_wrap .seactionheader {\n    margin: -10px 0 27px;\n}\n.graduation_carousel_wrap .seactionheader h3 {\n    font-size: 22px;\n    font-weight: 400;\n}\n.graduation_carousel_wrap .seactionheader h3 span {\n    font-weight: 600;\n}\n.card_profiles {\n    border: 1px solid #d2d2d2;\n    padding: 20px;\n    border-radius: 6px;\n    flex-direction: column !important;\n    display: flex;\n    justify-content: space-between;\n    height: 100%;\n    position: relative;\n    background: #fff;\n    -webkit-border-radius: 6px;\n    -moz-border-radius: 6px;\n    -ms-border-radius: 6px;\n    -o-border-radius: 6px;\n    overflow-y: auto;\n}\n.card_profiles::-webkit-scrollbar {\n    width: 4px;\n}\n.card_profiles::-moz-scrollbar {\n    width: 4px;\n}\n.card_profiles::-webkit-scrollbar-track {\n    background: #ccc;\n}\n.card_profiles::-webkit-scrollbar-thumb {\n    background-color: #666;\n    border-radius: 20px;\n    border: 2px solid #666;\n}\n.card_profiles .alumni-Profile-button-rounded {\n    position: absolute;\n    right: 20px;\n    padding: 0 20px;\n}\n.card_profiles .alumni-Profile-button-rounded:hover,\n.card_profiles .alumni-Profile-button-rounded:focus {\n    background: #40952c;\n    color: #fff;\n    background-color: #40952c;\n    border-color: 0;\n    box-shadow: none;\n}\n.card_profiles figure.student {\n    width: 90px;\n    height: 90px;\n    overflow: hidden;\n    border-radius: 200px;\n    margin-right: 10px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.card_profiles figure.student img {\n    border-radius: 200px;\n}\n.student_details {\n    flex: 1;\n}\n.card_profiles .student_details figure img {\n}\n.card_profiles .student_details h2 {\n    font-size: 20px;\n    font-weight: 700;\n    margin-bottom: 15px;\n    width: 65%;\n    margin-top: 010px;\n}\n.card_profiles .student_details h2 a {\n    color: #000;\n    text-decoration: none;\n    white-space: nowrap;\n    width: 100%;\n    text-overflow: ellipsis;\n    display: inline-block;\n    overflow: hidden;\n}\n.card_profiles .student_details h2 a:hover {\n    text-decoration: underline;\n    color: #1452ce;\n}\n.card_profiles .student_details h2 span {\n    display: block;\n    font-size: 16px;\n    color: #6a6868;\n    font-weight: 500;\n}\n.card_profiles .student_details .sub_details {\n    display: flex;\n    flex-grow: 1 !important;\n}\n.card_profiles .student_details .sub_details_workExp {\n    align-items: center;\n    position: relative;\n    padding-bottom: 5px;\n}\n.card_profiles .student_details .sub_details_achivements figure {\n    background: #0b3454 !important;\n}\n.card_profiles .student_details .sub_details_workExp figure {\n    border: 0 !important;\n    border-radius: 100px !important;\n    min-width: 50px !important;\n    height: 50px !important;\n    width: 50px !important;\n    background-color: #d52941;\n}\n.card_profiles .student_details .sub_details_workExp figure img {\n    width: 45%;\n    height: auto;\n}\n.card_profiles .student_details .sub_details_workExp figure.bg_white {\n    background-color: #fff !important;\n    border: 1px solid #d2d2d2 !important;\n}\n.card_profiles .student_details .sub_details_workExp figure.bg_white img {\n    width: 80%;\n}\n.card_profiles .student_details .sub_details_workExp:after {\n    position: absolute;\n    width: 83%;\n    height: 1px;\n    content: '';\n    background: #c1c1c1;\n    bottom: 0;\n    right: 0; /* padding-bottom: 20px; */\n}\n.card_profiles .student_details .sub_details_workExp1:after {\n    display: none;\n}\n.card_profiles .student_details .sub_details h3 {\n    margin-bottom: 0;\n    min-width: 43px;\n    justify-content: center;\n}\n.card_profiles .student_details .sub_details figure {\n    border: 1px solid #d2d2d2;\n    border-radius: 100px;\n    min-width: 80px;\n    height: 80px;\n    overflow: hidden;\n    margin-right: 10px;\n    margin-bottom: 0;\n    width: 80px;\n    margin-top: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.card_profiles .student_details .sub_details p {\n    font-size: 18px;\n    font-weight: 500;\n    margin-bottom: 5px;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    max-height: 43px;\n    overflow: hidden;\n    line-height: 18px;\n}\n.card_profiles .student_details .sub_details a {\n    color: #000;\n    text-decoration: none;\n}\n.card_profiles .student_details .sub_details a:hover {\n    text-decoration: underline;\n    color: #1452ce;\n}\n.card_profiles .student_details .sub_details p.title,\n.card_profiles .student_details .sub_details p.green-title {\n    color: #5cae48;\n    font-size: 14px;\n    margin-bottom: 10px;\n}\n.card_profiles .student_details .sub_details span {\n    color: #333333;\n    font-size: 14px;\n    margin-bottom: 15px;\n    font-weight: 400;\n}\n.card_profiles .student_details .sub_details span.course {\n    color: #0b3454;\n    font-size: 16px;\n    font-weight: 400;\n    display: flex;\n    align-items: center;\n    margin-bottom: 0;\n}\n.card_profiles .student_details .sub_details span.course img {\n    margin-right: 6px;\n    width: 16px;\n}\n.card_profiles .action_btns {\n    margin-top: 20px;\n    border-top: 1px solid #d2d2d2;\n    padding-top: 20px;\n    display: flex;\n    justify-content: center !important;\n    width: 100%;\n}\n.card_profiles .action_btns .btn-outline-primary {\n    margin-right: 10px;\n    border: 2px solid #5bae47;\n    border-radius: 50px;\n    padding: 7px 20px;\n    color: #5bae47;\n}\n.card_profiles .action_btns .btn-outline-primary:hover img {\n    filter: brightness(0) invert(1);\n}\n.card_profiles .action_btns .btn-outline-primary:hover {\n    border: 2px solid #418d2e;\n    background-color: #418d2e;\n    color: #fff;\n}\n.card_profiles .action_btns .btn-secondary {\n    border-radius: 50px;\n    padding: 7px 20px;\n    color: #fff;\n    background: #0b3454;\n}\n.card_profiles .action_btns .btn-secondary:hover {\n    background: #26a7df;\n    border: 1px solid #26a7df;\n}\n.card_profiles .btn-send {\n    width: 123px;\n    height: 40px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    background: #5cae48;\n    border-radius: 25pc;\n    color: #fff;\n    text-decoration: none;\n    align-items: center;\n    padding: 0 25px;\n    font-size: 16px;\n    font-weight: 500;\n    transition: all 0.3s ease-in-out;\n}\n.card_profiles .btn-send {\n    color: #fff;\n    font-size: 16px;\n    font-weight: 500;\n    position: absolute;\n    top: 20px;\n    right: 20px;\n}\n.card_profiles .btn-send .icon-send {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/send_alumni_profile.svg) no-repeat 0\n        0 / 100%;\n    width: 19px;\n    height: 19px;\n    margin-right: 10px;\n    position: relative;\n    transition: all 0.3s ease-in-out;\n    left: 0;\n}\n.card_profiles .btn-send:hover .icon-send {\n    left: 3px;\n}\n.card_profiles .btn-send:hover {\n    background: #3b8d27;\n}\n\n.workExperience-detail {\n    box-shadow: 0px 10px 25px #00000008;\n    border-radius: 6px;\n    background: #fff;\n    padding: 40px;\n}\n.workExperience-detail .workExperience-title {\n    font-size: 22px;\n    font-weight: 400;\n    margin: -15px 0 30px;\n}\n.workExperience-detail .workExperience-title span {\n    font-weight: 600;\n}\n.work-block {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    align-items: center;\n    position: relative;\n}\n.work-block .work-detail {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n}\n.work-block .icon {\n    width: 55px;\n    height: 55px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 26px;\n    margin-right: 20px;\n    background: #d52941;\n    border-radius: 50%;\n    color: #fff;\n}\n.work-block .icon.workex-logo {\n    border-radius: 0;\n}\n.work-block .icon.workex-logo img {\n    max-width: 100%;\n    max-height: 100%;\n    width: auto;\n    height: auto;\n}\n.work-block .work-detail p {\n    font-size: 20px;\n    line-height: 24px;\n    margin: 0 0 5px;\n    font-weight: 500;\n}\n.work-block .work-detail span {\n    font-size: 16px;\n    color: #6d6b6b;\n    line-height: 16px;\n    font-weight: 500;\n}\n\n.achievements-block {\n    box-shadow: 0px 10px 25px #00000008;\n    border-radius: 6px;\n    background: #fff;\n    padding: 30px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-border-radius: 6px;\n    -moz-border-radius: 6px;\n    -ms-border-radius: 6px;\n    -o-border-radius: 6px;\n    position: relative;\n}\n.achievements-block:not(:last-child) {\n    border-bottom: 1px solid #f5f5f5;\n}\n.achievements-icon-block {\n    padding: 0 55px 0 30px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    min-width: 185px;\n    max-width: 185px;\n    align-items: center;\n    text-align: center;\n    border-right: 1px solid #cecece;\n    margin-right: 30px;\n}\n.achievements-icon-block .icon {\n    width: 60px;\n    height: 60px;\n    background: #0b3454;\n    border-radius: 50%;\n    margin-bottom: 8px;\n    position: relative;\n}\n.achievements-icon-block .icon.icon-medal:before {\n    content: '';\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/exam_ico.svg);\n    width: 26px;\n    height: 36px;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    top: 0;\n    margin: auto;\n}\n.achievements-icon-block .icon.icon-grade:before {\n    content: '';\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/exam_ico.svg);\n    width: 25px;\n    height: 31px;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    top: 0;\n    margin: auto;\n}\n.achievements-icon-block .icon.icon-publication:before, .achievements-icon-block .icon.icon-certificate:before {\n    content: '';\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/publication_ico.svg);\n    width: 29px;\n    height: 31px;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    top: 0;\n    margin: auto;\n}\n.achievements-icon-block .icon.icon-promotion:before {\n    content: '';\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/promotion_ico.svg);\n    width: 32px;\n    height: 37px;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    top: 0;\n    margin: auto;\n}\n.achievements-icon-block .icon.icon-course-completion:before {\n    content: '';\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/course_ico.svg);\n    width: 31px;\n    height: 37px;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    top: 0;\n    margin: auto;\n}\n.achievements-icon-block .icon.icon-social-service:before {\n    content: '';\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/social_ico.svg);\n    width: 36px;\n    height: 36px;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    top: 0;\n    margin: auto;\n}\n.achievements-icon-block .icon.icon-scholarship:before {\n    content: '';\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/scholarship_ico.svg);\n    width: 39px;\n    height: 28px;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    top: 0;\n    margin: auto;\n}\n.achievements-icon-block .icon.icon-others:before {\n    content: '';\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/others_ico.svg);\n    width: 32px;\n    height: 32px;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    top: 0;\n    margin: auto;\n}\n.achievements-icon-block .achievements-title {\n    font-size: 18px;\n    font-weight: 600;\n}\n.achievements-icon-block .achievements-year {\n    font-size: 18px;\n    line-height: 22px;\n    color: #414141;\n}\n.achievements-block-detail h3 {\n    font-size: 22px;\n    font-weight: 400;\n    margin-bottom: 0px;\n}\n.achievements-block-detail h3 span {\n    font-weight: 600;\n}\n.achievements-block-detail p {\n    font-size: 16px;\n    line-height: 24px;\n    margin: 0;\n}\n.achievements-block-detail {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    position: relative;\n}\n.hide {\n    display: none;\n}\n.achievements-block-detail p.show .hide {\n    display: inline;\n}\n.achievements-block-detail p.show .btn-readmore {\n    font-size: 0;\n}\n.achievements-block-detail p.show .btn-readmore:before {\n    content: 'Read Less';\n    font-size: 16px;\n}\n.achievements-block-detail p .btn-readmore {\n    color: #1452ce;\n    transition: all 0.3s ease-in-out;\n}\n.achievements-block-detail p .btn-readmore:hover {\n    color: #1046b3;\n}\n.achievements-block-detail .url-link {\n    color: #1452ce;\n    transition: all 0.3s ease-in-out;\n}\n.achievements-block-detail .url-link:hover {\n    color: #1046b3;\n}\n\n.achievements-list {\n    box-shadow: 0px 10px 25px #00000008;\n    border-radius: 6px;\n    background: #fff;\n}\n.achievements-block-title {\n    padding: 20px 40px;\n    border-bottom: 1px solid #f5f5f5;\n    border-radius: 6px 6px 0 0;\n}\n.achievements-block-title .title {\n    font-size: 22px;\n}\n.achievements-block-title .title span {\n    font-weight: 600;\n}\n\n.btn-add-section {\n    background: #ffffff;\n    border: 1px solid #0b3454;\n    border-radius: 19px;\n    height: 37px;\n    display: flex;\n    padding: 0 20px;\n    align-items: center;\n    text-decoration: none;\n    font-weight: 500;\n    font-size: 14px;\n    color: #0b3454;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.btn-add-section i {\n    position: relative;\n    width: 11px;\n    height: 110px;\n    margin-right: 10px;\n}\n.btn-add-section i:before {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    background: #0b3454;\n    width: 2px;\n    height: 10px;\n}\n.btn-add-section i:after {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    background: #0b3454;\n    width: 10px;\n    height: 2px;\n}\n.btn-add-section:hover {\n    background: #0b3454;\n    color: #fff;\n}\n.btn-add-section:hover i:before,\n.btn-add-section:hover i:after {\n    background: #fff;\n}\n\n.contributions-block {\n    box-shadow: 0px 10px 25px #00000008;\n    border-radius: 6px;\n    background: #fff;\n    padding: 40px;\n}\n.contributions-block:not(:last-child) {\n    margin-bottom: 20px;\n}\n.contributions-block .act_lst:not(:last-child) {\n    margin-bottom: 20px;\n}\n.contributions-block .seactionheader {\n    margin: -10px 0 20px;\n}\n.contributions-block h3 {\n    font-size: 22px;\n    font-weight: 600;\n}\n.contributions-block .circle-effect::before {\n    background: #6c8598;\n}\n.circle-effect::before {\n    position: absolute;\n    content: '';\n    left: 0;\n    top: 0;\n    bottom: 0;\n    width: 0;\n    background: #08273f;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n    right: 0;\n    width: 0;\n    height: 0;\n    margin: auto;\n    border-radius: 50%;\n}\n.circle-effect:hover::before {\n    width: 100%;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n    height: 100%;\n}\n.contributions-block .list_badge {\n    color: #d52941;\n    background: no-repeat;\n    position: static;\n    text-transform: uppercase;\n}\n.contributions-block .act_lst {\n    padding: 25px 25px 25px 25px;\n}\n.contributions-block .video_block_name label {\n    font-size: 16px;\n}\n\n.act_lst {\n    border: 1px solid #d2d2d2;\n    padding: 40px 25px 25px 25px;\n    border-radius: 6px;\n    -webkit-border-radius: 6px;\n    -moz-border-radius: 6px;\n    -ms-border-radius: 6px;\n    -o-border-radius: 6px;\n}\n.act_lst > .row > div:last-child {\n    width: 255px;\n}\n.act_lst > .row.postedrow > div:last-child,\n.act_lst.actlst_listed > .row > div:last-child {\n    width: 150px;\n}\n.list_badge {\n    position: absolute;\n    width: auto;\n    height: 25px;\n    line-height: 25px;\n    color: #fff;\n    background: #d42941;\n    text-align: center;\n    border-radius: 6px 0px 10px 0px;\n    left: 0;\n    top: 0;\n    -webkit-border-radius: 6px 0px 10px 0px;\n    -moz-border-radius: 6px 0px 10px 0px;\n    -ms-border-radius: 6px 0px 10px 0px;\n    -o-border-radius: 6px 0px 10px 0px;\n    padding: 0 10px;\n}\n.exp_loc > a.btn {\n    display: inline-block;\n    border: 1px solid #dedede;\n    height: 32px;\n    line-height: 32px;\n    padding: 0 16px;\n    border-radius: 18px;\n    font-size: 14px;\n    font-weight: 500;\n    color: #0b3454;\n    margin-bottom: 10px;\n    background: #fff;\n    overflow: hidden;\n    -webkit-border-radius: 18px;\n    -moz-border-radius: 18px;\n    -ms-border-radius: 18px;\n    -o-border-radius: 18px;\n}\n.exp_loc > a.btn:not(:last-child) {\n    margin-right: 5px;\n}\n.exp_loc > a .btn > img {\n    margin: -3px 8px 0 0;\n}\n.exp_loc > a.btn > span.icon,\n.exp_loc > a.btn > img {\n    margin: -3px 8px 0 0;\n}\n.person_detls {\n    margin-top: 10px;\n}\n\n.listblk_icon {\n    position: relative;\n    border: 1px solid #dedede;\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    overflow: hidden;\n}\n.listblk_icon > span.icon,\n.album_shareblk > a.btn.btnicon span.icon {\n    color: rgba(11, 52, 84, 0.4);\n    margin: 0;\n}\n.act_lst > .row > div:last-child .btn-green {\n    width: 150px;\n}\n.act_lst .btn-green {\n    padding: 0 20px;\n}\n\n.seactionheader {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 8px;\n    flex-wrap: wrap;\n}\n.countnbtn {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n.seactionheader h3 {\n    font-size: 24px;\n    margin: 0;\n}\n.countnbtn .count {\n    margin-right: 20px;\n    font-style: italic;\n    font-size: 14px;\n    color: #0b3454;\n}\n.custom-btns a {\n    display: inline-block;\n    color: #0b3454;\n    text-decoration: none;\n}\n.custom-btns a:hover {\n    color: #d42941;\n}\n\n.album_imgblk img {\n    width: 100%;\n    height: auto;\n}\n.album_blk {\n    border: 1px solid #d2d2d2;\n    border-radius: 6px;\n}\n.album_badge {\n    background: #d42941;\n    padding: 0 20px;\n    height: 32px;\n    line-height: 32px;\n    border-radius: 6px 0 15px 0;\n}\n.album_imgblk {\n    border-radius: 6px 6px 0 0;\n    overflow: hidden;\n}\n.album_contblk {\n    background: #fff;\n    border-radius: 6px;\n    width: calc(100% - 20px);\n    margin: -40px auto 0;\n    position: relative;\n    padding: 20px 20px 15px;\n}\n\n.album_shareblk > span,\n.album_shareblk > a.btn.btnicon {\n    width: 40px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    height: 40px;\n    line-height: 38px;\n    border: 1px solid #dedede;\n    border-radius: 50%;\n    justify-content: center;\n    align-items: center;\n    padding: 0;\n}\n.album_shareblk > span:not(:last-child),\n.album_shareblk > a.btn:not(:last-child) {\n    margin: 0 0 5px;\n}\n.albumblk_footer {\n    background: #f2f9ff;\n    padding: 13px 30px;\n    border-radius: 0 0 6px 6px;\n}\n.albumblk_footer img {\n    margin: 0 6px 0 0;\n}\n.album_blk_parent {\n    margin: 0 0 20px 0;\n}\n.album_imgvdo {\n    right: 10px;\n    top: 10px;\n}\n.image_tn {\n    margin: 0 0 5px 0;\n}\n.image_tn > a {\n    width: 63px;\n    height: 30px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: rgba(0, 0, 0, 0.5);\n    border-radius: 16px;\n    color: #e1e1e1;\n    font-size: 13px;\n    text-decoration: none;\n}\n.image_tn > a img.gallicon {\n    width: 14px;\n    height: auto;\n    margin: 0 3px 0 0;\n}\nimg.custimg {\n    width: auto;\n    display: block;\n    margin: 0 auto;\n}\n.custom_litezoom:before {\n    content: '';\n    position: absolute;\n    top: 100%;\n    left: 10px;\n    border-left: 5px solid transparent;\n    border-right: 5px solid transparent;\n    border-top: 6px solid #fff;\n}\n.album_imgvdo {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n}\n.image_tn:first-child {\n    margin-right: 5px;\n}\n.image_tn {\n    margin-bottom: 3px;\n}\n.table-responsive.attendee_dtl td .custom_litezoom a {\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 25px;\n    text-decoration: none !important;\n    color: #000;\n    font-weight: 500;\n    display: flex;\n    align-items: center;\n    border: 1px solid #cecece;\n    border-radius: 26px;\n    -webkit-border-radius: 26px;\n    -moz-border-radius: 26px;\n    -ms-border-radius: 26px;\n    -o-border-radius: 26px;\n    padding: 0 10px;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    width: auto;\n    background: none;\n}\n.custom_litezoom a:hover {\n    color: #0b3454;\n}\n.table-responsive.attendee_dtl td .custom_litezoom a .icon-phone {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/image.svg) no-repeat 0 0;\n    width: 16px;\n    height: 15px;\n    margin-right: 7px;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.table-responsive.attendee_dtl td .custom_litezoom a .icon-video {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/video-camera.svg) no-repeat 0 0;\n    width: 16px;\n    height: 9px;\n    margin-right: 7px;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.custom_litezoom a:hover {\n    background: #0c9ccc;\n    border-color: #0c9ccc;\n    color: #fff;\n}\n.custom_litezoom a:hover i {\n    filter: brightness(0) invert(1);\n    -webkit-filter: brightness(0) invert(1);\n}\n\n.skills-block {\n    box-shadow: 0px 10px 25px #00000008;\n    border-radius: 6px;\n    background: #fff;\n    padding: 40px;\n    position: relative;\n}\n.skills-block:first-child {\n    padding-bottom: 20px;\n}\n.skills-block.EntranceExam-skills-block {\n    padding-bottom: 33px;\n}\n.skills-block:not(:last-child) {\n    margin-bottom: 20px;\n}\n.skills-block h2 {\n    font-size: 22px;\n    font-weight: 400;\n    margin-bottom: 15px;\n    margin: -10px 0 25px;\n}\n.skills-block h2 span {\n    font-weight: 600;\n}\n.skills-block-detail {\n    display: flex;\n    flex-wrap: wrap;\n}\n.skills-block-detail .meter {\n    margin: 0 12px 20px 0;\n    border: 1px solid #c7c7c7;\n    padding: 10px 30px;\n    border-radius: 50px;\n    font-size: 20px;\n    font-weight: 500;\n    align-items: center;\n    height: 55px;\n}\n.skills-block-detail .meter img {\n    width: 50px;\n}\n.skills-block-title {\n    margin-top: -30px;\n    margin-bottom: 20px;\n}\n\n.preferences-block {\n    box-shadow: 0px 10px 25px #00000008;\n    border-radius: 6px;\n    background: #fff;\n    padding: 40px;\n}\n.preferences-block:not(:last-child) {\n    margin-bottom: 20px;\n}\n.preferences-block.EntranceExam-skills-block {\n    padding-bottom: 33px;\n}\n.preferences-block h2 {\n    font-size: 22px;\n    font-weight: 400;\n    margin-bottom: 15px;\n    margin: -10px 0 25px;\n}\n.preferences-block h2 span {\n    font-weight: 600;\n}\n.preferences-block-detail {\n    display: flex;\n    flex-wrap: wrap;\n}\n.preferences-block-detail .meter {\n    margin: 0 12px 20px 0;\n    border: 1px solid #c7c7c7;\n    padding: 10px 30px;\n    border-radius: 50px;\n    font-size: 20px;\n    font-weight: 500;\n    align-items: center;\n}\n.preferences-block-detail .meter img {\n    width: 50px;\n}\n.preferences-block-title {\n    margin-top: -30px;\n    margin-bottom: 20px;\n}\n\n.interested-block .icon {\n    width: 55px;\n    height: 55px;\n    border-radius: 50%;\n    background: #0b3454;\n    position: relative;\n    margin-right: 20px;\n}\n.interested-block .icon.icon-bulb::before {\n    content: '';\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/bulb.svg) no-repeat 0 0 / 34px auto;\n    width: 34px;\n    height: 36px;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    top: 0;\n    margin: auto;\n}\n.interested-block .icon.icon-note::before {\n    content: '';\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/publication_ico.svg);\n    width: 29px;\n    height: 31px;\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n}\n.interested-block {\n    display: flex;\n    align-items: center;\n}\n.interested-block .interested-topics {\n    font-size: 20px;\n    flex: 1;\n    line-height: 22px;\n}\n.interested-block .interested-topics span {\n    font-weight: 500;\n}\n.meter {\n    background: #ffffff;\n    border: 1px solid #dedede;\n    border-radius: 18px;\n    opacity: 1;\n    padding: 5px 15px;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n    margin-right: 5px;\n    letter-spacing: 0.32px;\n}\n.meter:hover {\n    box-shadow: 0px 0px 20px #00000033;\n}\n.meter:not(:last-child) {\n    margin-bottom: 5px;\n}\n.graduationslider .meter {\n    padding: 10px 30px;\n    display: inline-flex;\n    flex-wrap: wrap;\n    align-items: center;\n    border-radius: 50px;\n    font-size: 18px;\n    font-weight: 500;\n    margin-bottom: 10px;\n}\n\n.profile-item {\n    text-align: center;\n    width: 196px;\n    height: 210px;\n    display: flex;\n    flex-direction: column;\n    padding-top: 10px;\n}\n.owl-item:not(:last-child) .profile-item {\n    border-right: 1px solid #d2d2d2;\n}\n.profile-item-img {\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    margin-bottom: 11px;\n}\n.profile-item-name-class h3 {\n    font-size: 16px;\n    font-weight: 600;\n    margin: 0 0 4px;\n}\n.profile-item-name-class p {\n    margin: 0 0 11px;\n    font-size: 14px;\n    font-style: italic;\n    color: #535353;\n}\n.profile-item-name-class .subject {\n    color: #0b3454;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 20px;\n    position: relative;\n    padding-top: 10px;\n}\n.profile-item-name-class .subject:before {\n    content: '';\n    width: 30px;\n    height: 2px;\n    background: #5cae48;\n    position: absolute;\n    left: 0;\n    right: 0;\n    margin: auto;\n    top: 0;\n}\n.profile-item-name-class .btn-viewcompus {\n    font-size: 13px;\n    color: #1452ce;\n    font-weight: 500;\n    line-height: 18px;\n    position: relative;\n    z-index: 2;\n    text-decoration: none;\n}\n.profile-item-name-class .btn-viewcompus:hover {\n    color: #0b3454;\n    text-decoration: underline;\n}\n\n.psychology-item {\n    text-align: center;\n    width: 245px;\n    height: 196px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    padding-top: 10px;\n}\n.owl-item:not(:last-child) .psychology-item {\n    border-right: 1px solid #d2d2d2;\n}\n.popularCollegesslider .owl-item.active + .owl-item.active + .owl-item.active + .owl-item.active .psychology-item {\n    border-right: 0px solid #d2d2d2;\n}\n.psychology-item-img {\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    margin-bottom: 20px;\n    height: 90px;\n    align-items: center;\n}\n.psychology-item-name h3 {\n    font-size: 16px;\n    font-weight: 600;\n    margin: 0 0 5px;\n    line-height: 17px;\n}\n.psychology-item-name p {\n    font-size: 14px;\n    font-style: italic;\n    font-weight: 500;\n    line-height: 20px;\n}\n\n.alumni_directory_details .btn-working {\n    font-size: 13px;\n    color: #1452ce;\n    font-weight: 500;\n    line-height: 18px;\n    position: relative;\n    z-index: 2;\n    text-decoration: none;\n}\n.alumni_directory_details .btn-working:hover {\n    color: #0b3454;\n    text-decoration: underline;\n}\n\n.tooltip-viewcompus .tooltip-inner {\n    background: #3b3b3b;\n    border-color: #3b3b3b;\n}\n.tooltip-working .tooltip-inner {\n    display: flex;\n    flex-direction: column;\n    padding: 15px;\n    background: #3b3b3b;\n    border-color: #3b3b3b;\n}\n.tooltip-working .tooltip-inner .logo {\n    position: relative;\n    font-size: 20px;\n}\n.tooltip-working .tooltip-inner span.logo + span {\n    font-size: 16px;\n}\n.tooltip-working.bs-tooltip-top .tooltip-arrow::before {\n    border-top-color: #3b3b3b;\n}\n.tooltip-working.bs-tooltip-bottom .tooltip-arrow::before {\n    border-bottom-color: #3b3b3b;\n}\n.tooltip-working.bs-tooltip-end .tooltip-arrow::before {\n    border-right-color: #3b3b3b;\n}\n.tooltip-working.bs-tooltip-start .tooltip-arrow::before {\n    border-left-color: #3b3b3b;\n}\n\n.alumni_name_brife > div {\n    align-items: center;\n}\n.alumni_name_brife > div .sep {\n    margin: 0 6px;\n    color: #1452ce;\n}\n\n.custom_badge {\n    display: inline-block;\n    border: 1px solid #dedede;\n    height: 32px;\n    line-height: 32px;\n    padding: 0 16px;\n    border-radius: 18px;\n    font-size: 14px;\n    font-weight: 500;\n    color: #0b3454;\n    margin: 0 5px 10px 0;\n    background: #fff;\n    overflow: hidden;\n}\n.custom_badge .icon {\n    margin-right: 5px;\n}\n\n.delete_confirm .icon-cross {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    border: 1px solid red;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: #e94e58;\n}\n.delete_confirm .del_text {\n    margin: 20px 0 10px;\n    text-align: center;\n    max-width: 240px;\n    font-size: 28px;\n    line-height: 36px;\n    font-weight: 500;\n    width: 100%;\n}\n.delete_confirm .btn-delete {\n    background: #d52941;\n    border-radius: 31px;\n    border: 0;\n    height: 36px;\n    color: #fff;\n    padding: 0 20px;\n    font-weight: 600;\n    font-size: 14px;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.delete_confirm .btn-delete:hover {\n    background: #a0182b;\n}\n\n.selected_options ul {\n    display: flex;\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n.selected_options ul li {\n    background: #f7fbff;\n    border: 1px solid #0b34544d;\n    border-radius: 18px;\n    height: 35px;\n    display: flex;\n    align-items: center;\n    padding: 0 18px;\n    margin: 12px 12px 6px 0;\n    font-size: 16px;\n    font-weight: 500;\n}\n.selected_options ul li .icon-cross {\n    font-size: 9px;\n    margin: 2px 0 0 10px;\n    text-decoration: none;\n    color: #000;\n}\n.selected_options ul li .icon-cross:hover {\n    text-decoration: none;\n    color: #333;\n}\n\n.question .form-select.w-90 {\n    width: 90px !important;\n    max-width: 90px;\n}\n\n.custom_row_title {\n    margin-bottom: 10px;\n    font-weight: 400;\n    font-size: 20px;\n}\n.custom_row_title span {\n    font-weight: 600;\n}\n.custom_row_block .program {\n    font-size: 20px;\n}\n.custom_row_block .program span {\n    font-weight: 500;\n}\n.program-time-interest {\n    color: #414141;\n    font-size: 16px;\n    line-height: 20px;\n}\n.custom_row_block {\n    display: flex;\n    flex-wrap: wrap;\n    width: 100%;\n}\n.custom_row_block .icon {\n    width: 55px;\n    height: 55px;\n    border-radius: 50%;\n    background: #0b3454;\n    margin-right: 15px;\n    position: relative;\n}\n.custom_row_block .icon.icon-hat:before {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/hat_alumni.svg) no-repeat 0 0 /26px;\n    width: 26px;\n    height: 20px;\n    display: inline-block;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    position: absolute;\n    filter: invert(1);\n    -webkit-filter: invert(1);\n}\n.custom_row_block .icon + div {\n    width: calc(100% - 70px);\n}\n.custom_row {\n    width: 100%;\n    border-top: 1px solid #dbdbdb;\n    padding-top: 20px;\n}\n.custom_row:not(:last-child) {\n    padding-bottom: 20px;\n}\n\n.radius_block {\n    background: #ffffff;\n    border: 1px solid #c7c7c7;\n    border-radius: 30px;\n    height: 60px;\n    padding: 0 30px;\n    display: flex;\n    align-items: center;\n    font-size: 20px;\n    line-height: 20px;\n    font-weight: 500;\n}\n.radius_block span {\n    margin-right: 30px;\n}\n.radius_block i {\n    font-size: 24px;\n}\n.radius_block i.gray {\n    color: #8599a9;\n}\n.radius_block i.green {\n    color: #5dae48;\n}\n\n.radius_block.yes {\n    background: #5dae48;\n    border-color: #5dae48;\n    color: #fff;\n}\n.radius_block.yes span {\n    margin: 0 20px;\n}\n\n.radius_block.no {\n    background: #c7c7c7;\n    color: #333;\n}\n.radius_block.no span {\n    margin: 0 20px;\n}\n\n.universities_block {\n    background: #ffffff;\n    border: 1px solid #c7c7c7;\n    border-radius: 30px;\n    height: 60px;\n    padding: 0 8px;\n    display: flex;\n    align-items: center;\n    font-size: 20px;\n    line-height: 26px;\n    font-weight: 500;\n    -webkit-border-radius: 30px;\n    -moz-border-radius: 30px;\n    -ms-border-radius: 30px;\n    -o-border-radius: 30px;\n}\n.universities_block .logo {\n    width: 40px;\n    height: 40px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-right: 15px;\n    border-radius: 50%;\n    overflow: hidden;\n    -webkit-border-radius: 50%;\n    -moz-border-radius: 50%;\n    -ms-border-radius: 50%;\n    -o-border-radius: 50%;\n    border: 1px solid #ccc;\n}\n.universities_block .logo img {\n\twidth: auto;\n\theight: 100%;\n}\n.universities_block span {\n    font-size: 20px;\n    margin-right: 15px;\n    line-height: 20px;\n}\n.logo.no_logo {\n    width: 40px;\n    border: 1px solid #cad6df;\n}\n.edit_section {\n    font-size: 0;\n}\n.edit_section_toggle,\n.custom-btns a.edit_section_toggle {\n    display: none;\n    width: 20px;\n    height: 20px;\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='%23343a40' stroke='none' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z'/%3e%3c/svg%3e\");\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: 20px 20px;\n}\n\n.video_block {\n    background: #ffffff;\n    border: 1px solid #d2d2d2;\n    border-radius: 6px;\n    overflow: hidden;\n    text-decoration: none;\n    position: relative;\n    display: inline-block;\n    color: #000;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.icon-invert-play {\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.video_block:hover,\n.video_block:hover .icon-invert-play {\n    color: #5cae48;\n}\n.video_block_name {\n    background: #ffffff;\n    border-radius: 6px 6px 0px 0px;\n    opacity: 1;\n    display: flex;\n    justify-content: space-between;\n    padding: 0px 20px;\n    margin: -26px 11px 0;\n    position: relative;\n    align-items: center;\n    height: 78px;\n}\n.video_block:hover .video_block_img img {\n    transform: scale(1.1);\n}\n.video_block_img {\n    overflow: hidden;\n    display: inline-block;\n}\n.video_block_img img {\n    border-radius: 6px 6px 0 0;\n    transition: all 0.5s ease-in-out;\n}\n.video_block_name .icon-invert-play {\n    font-size: 30px;\n    color: #0b3454;\n}\n.video_block_name label {\n    font-size: 18px;\n    font-weight: 600;\n    margin-right: 15px;\n    line-height: 22px;\n}\n.video_block .video-btn {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n}\n#video_pop button.btn-close {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    background-color: #fff !important;\n    opacity: 1;\n    z-index: 999;\n    background-size: 40%;\n    width: 30px;\n    height: 30px;\n    border-radius: 50%;\n    padding: 0;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n#video_pop button.btn-close:hover {\n    background-color: #5cae48 !important;\n}\n#video_pop button.btn-close span {\n    display: none;\n}\n\n.half-gray {\n    position: relative;\n}\n.half-gray:before {\n    content: '';\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    top: 0;\n    width: 50.5%;\n    background: #f3f3f3;\n    border-radius: 6px 0px 0px 6px;\n}\n.half-gray > div {\n    position: relative;\n}\n\n.messages {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n}\n.leftUser {\n    align-items: end;\n}\n.leftUser p {\n    background: #2296c9;\n    border-radius: 10px 10px 0px 10px;\n    padding: 7px 20px;\n    color: #fff;\n    margin-bottom: 10px;\n}\n.rightUser {\n    align-items: start;\n}\n.rightUser p {\n    background: #413a7d;\n    border-radius: 10px 10px 10px 0px;\n    opacity: 1;\n    padding: 7px 20px;\n    color: #fff;\n    margin-bottom: 10px;\n}\n.conversation .userimg {\n    display: flex;\n    align-items: start;\n    vertical-align: top;\n}\n.conversation {\n    height: 310px;\n    overflow-y: scroll;\n    overflow-x: hidden;\n    margin-right: -8px;\n}\n\n.conversation {\n    overflow-y: scroll;\n    scrollbar-width: thin;\n}\n.conversation::-webkit-scrollbar {\n    width: 4px;\n}\n.conversation::-webkit-scrollbar-track {\n    background: #f1f1f1;\n}\n.conversation::-webkit-scrollbar-thumb {\n    background: #888;\n}\n.conversation::-webkit-scrollbar-thumb:hover {\n    background: #555;\n}\n\n@media (max-width: 1199px) {\n    .alumni_profile_name_college_other_detail_wrap.directory-detail .alumni_profile_image_name_other_detail {\n        padding-right: 30px;\n    }\n    .alumni_profile_name_college_other_detail_wrap.directory-detail .alumni_profile_college_name_other_detail_wrap {\n        padding-left: 30px;\n    }\n    .alumni_profile_name_college_other_detail_wrap.directory-detail\n        .alumni_profile_college_name_other_detail_wrap\n        .alumni_profile_college_name_other_detail {\n        flex-direction: column;\n    }\n    .alumni_profile_name_college_other_detail_wrap.directory-detail\n        .alumni_profile_college_name_other_detail_wrap\n        .alumni_profile_college_name_other_detail\n        .alumni_profile_college_name_detail {\n        padding: 0 0 20px;\n    }\n    .alumni_profile_name_college_other_detail_wrap.directory-detail\n        .alumni_profile_college_name_other_detail_wrap\n        .alumni_profile_college_name_other_detail\n        .alumni_profile_other_detail {\n        width: 100%;\n    }\n    .alumni_profile_name_college_other_detail_wrap.directory-detail\n        .alumni_profile_college_name_other_detail_wrap\n        .alumni_profile_college_name_other_detail\n        .alumni_profile_other_detail\n        .alumni_profile_status {\n        display: -webkit-box;\n        display: -moz-box;\n        display: -ms-flexbox;\n        display: -webkit-flex;\n        display: flex;\n        -webkit-box-wrap: wrap;\n        -moz-box-wrap: wrap;\n        -ms-flex-wrap: wrap;\n        -webkit-wrap: wrap;\n        flex-wrap: wrap;\n    }\n    .alumni_profile_name_college_other_detail_wrap.directory-detail\n        .alumni_profile_college_name_other_detail_wrap\n        .alumni_profile_college_name_other_detail\n        .alumni_profile_other_detail\n        .alumni_profile_status\n        li {\n        width: 100%;\n    }\n    .alumni_profile_name_college_other_detail_wrap.directory-detail\n        .alumni_profile_college_name_other_detail_wrap\n        .alumni_profile_college_name_other_detail\n        .alumni_profile_other_detail\n        .alumni_profile_status\n        li\n        p {\n        margin: 0;\n    }\n}\n\n@media (max-width: 1150px) {\n    .aldir_scroll {\n        width: 100%;\n        overflow-x: auto;\n        scrollbar-width: thin;\n    }\n    .aldir_scroll::-webkit-scrollbar {\n        height: 4px;\n    }\n    .aldir_scroll::-moz-scrollbar {\n        height: 4px;\n    }\n    .aldir_scroll::-webkit-scrollbar-track {\n        background: #e372848f;\n    }\n    .aldir_scroll::-webkit-scrollbar-thumb {\n        background-color: #ccc;\n        border-radius: 20px;\n        border: 2px solid #810d20;\n    }\n}\n\n@media (max-width: 1130px) {\n    .alumni_profile_brife_tab {\n        overflow: auto;\n        scrollbar-width: thin;\n        padding-bottom: 10px;\n        margin-bottom: 10px;\n    }\n    .alumni_profile_brife_tab::-webkit-scrollbar {\n        height: 4px;\n    }\n    .alumni_profile_brife_tab::-moz-scrollbar {\n        height: 4px;\n    }\n    .alumni_profile_brife_tab::-webkit-scrollbar-track {\n        background: #ccc;\n    }\n    .alumni_profile_brife_tab::-webkit-scrollbar-thumb {\n        background-color: #666;\n        border-radius: 20px;\n        border: 2px solid #666;\n    }\n    .alumni_profile_brife_tab .nav {\n        justify-content: start;\n        flex-wrap: nowrap;\n    }\n}\n\n@media (max-width: 991px) {\n    .alumni-directorySearch {\n        width: 230px;\n    }\n}\n\n@media (max-width: 875px) {\n    .graduateRow {\n        flex-direction: column;\n    }\n    .graduateRow .college_detail_wrap {\n        width: 100%;\n    }\n    .graduateRow .offer {\n        width: 100%;\n    }\n    .college_name_scholarship {\n        flex-direction: row;\n        align-items: start;\n    }\n    .graduateRow .college_detail_wrap {\n        width: 100%;\n        padding: 0 0 20px;\n        margin-bottom: 20px;\n    }\n    .graduateRow .college_detail_wrap::after {\n        top: auto;\n        right: 0;\n        width: 75px;\n        height: 2px;\n        bottom: 0;\n    }\n    .graduateRow .offer {\n        padding: 0;\n        align-items: start;\n    }\n    .graduateRow .college_detail_wrap::after {\n        right: auto;\n        bottom: 0;\n        left: 0;\n    }\n\n    .graduateRow.edit .college_detail_wrap {\n        width: 100%;\n    }\n    .graduateRow .offer.offer_edit {\n        flex-direction: row;\n        align-items: center;\n        width: 100%;\n        justify-content: start;\n    }\n    .graduateRow .offer .offer_existing_links {\n        align-items: start;\n    }\n}\n\n@media (max-width: 820px) {\n    .graduation_carousel_wrap {\n        padding: 20px;\n    }\n    .graduationslider .meter {\n        padding: 10px 15px;\n        margin: 15px 0 10px 0px;\n        font-size: 16px;\n    }\n    .postGraduate-detail {\n        padding: 0;\n        background: none;\n        box-shadow: none;\n        border: 1px solid #d2d2d2;\n        overflow: hidden;\n    }\n    .postGraduate-detail .graduateRow {\n        padding: 20px;\n        background: #fff;\n    }\n    .graduation-title {\n        margin: 0;\n        background: #eff8ff;\n        border-radius: 6px 6px 0px 0px;\n        padding: 20px;\n        text-align: center;\n        line-height: 22px;\n    }\n    .graduation_carousel_wrap .seactionheader {\n        margin: 0 0 15px;\n        flex-direction: column;\n        align-items: inherit;\n    }\n    .graduation_carousel_wrap .seactionheader .countnbtn {\n        width: 100%;\n        margin-top: 13px;\n        justify-content: space-between;\n    }\n    .graduation_carousel_wrap .seactionheader h3 {\n        width: auto;\n        margin: -20px -20px 0;\n        background: #eff8ff;\n        border-radius: 6px 6px 0px 0px;\n        padding: 20px;\n        text-align: center;\n        line-height: 22px;\n    }\n    .workExperience-detail .workExperience-title {\n        width: auto;\n        margin: 0;\n        background: #eff8ff;\n        border-radius: 6px 6px 0px 0px;\n        padding: 20px;\n        text-align: center;\n        line-height: 22px;\n    }\n    .workExperience-detail {\n        padding: 0px;\n        overflow: hidden;\n    }\n    .workExperienceRow {\n        padding: 25px;\n    }\n    .skills-block-title {\n        margin: 0 0 20px;\n        width: auto;\n        margin: -40px -40px 20px;\n        background: #eff8ff;\n        border-radius: 6px 6px 0px 0px;\n        padding: 20px;\n        text-align: center;\n        line-height: 22px;\n    }\n    .skills-block-title h2 {\n        background: no-repeat;\n        padding: 0;\n        text-align: left;\n    }\n    .preferences-block {\n        padding: 30px;\n    }\n    .preferences-block-title {\n        width: auto;\n        margin: -30px -30px 0px;\n        background: #eff8ff;\n        border-radius: 6px 6px 0px 0px;\n        padding: 20px;\n        line-height: 22px;\n    }\n    .custom_row:first-child {\n        border: 0;\n    }\n    .achievements-block-title {\n        background: #eff8ff;\n    }\n    .underGraduate-detail .main_title,\n    .blockHeader {\n        background: #eff8ff;\n    }\n    .graduateRow {\n        background: #fff;\n    }\n    .postGraduate-detail .blockHeader {\n        margin: 0;\n    }\n    .workExperience-detail .blockHeader {\n        margin: 0;\n    }\n}\n\n@media (min-width: 767px) and (max-width: 1099px) {\n    .alumni_directory_filter .fiterItem.w-20 {\n        width: calc(33.33% - 10px);\n    }\n    .alumni_directory_filter .fiterItem.w-40 {\n        width: calc(50% - 10px);\n    }\n    .alumni_directory_filter #additionalfilter .fiterItem.w-20 {\n        width: calc(33.3% - 10px);\n    }\n    .alumni_directory_filter .fiterItem.width-25 {\n        width: calc(33.3% - 10px);\n    }\n    .alumni_directory_filter .fiterItem.width-50 {\n        width: calc(50% - 10px);\n    }\n    .alumni_directory_filter #additionalfilter .fiterItem.w-40 {\n        width: calc(33.3% - 10px);\n    }\n}\n\n@media (max-width: 767px) {\n    .filters {\n        position: fixed;\n        left: 0;\n        right: 0;\n        top: 0;\n        width: 100%;\n        bottom: 0;\n        background: #fff;\n        z-index: 99;\n        max-width: 100%;\n        overflow-x: scroll;\n        padding: 40px 20px;\n        display: block !important;\n        -moz-transform: translate3d(0, 0, 0);\n        -webkit-transform: translate3d(0, 0, 0);\n        -o-transform: translate3d(0, 0, 0);\n        -ms-transform: translate3d(0, 0, 0);\n        transform: translate3d(0, 0, 0);\n        -webkit-transition: all 0.3s ease-in-out;\n        -moz-transition: all 0.3s ease-in-out;\n        -ms-transition: all 0.3s ease-in-out;\n        -o-transition: all 0.3s ease-in-out;\n        transition: all 0.3s ease-in-out;\n        height: 100%;\n    }\n    .filters.show {\n        -moz-transform: translate3d(0, -100%, 0);\n        -webkit-transform: translate3d(0, -100%, 0);\n        -o-transform: translate3d(0, -100%, 0);\n        -ms-transform: translate3d(0, -100%, 0);\n        transform: translate3d(0, -100%, 0);\n        -webkit-transition: all 0.3s ease-in-out;\n        -moz-transition: all 0.3s ease-in-out;\n        -ms-transition: all 0.3s ease-in-out;\n        -o-transition: all 0.3s ease-in-out;\n        transition: all 0.3s ease-in-out;\n    }\n    .filters .btn-filter {\n        position: absolute;\n        right: 25px;\n        font-size: 0;\n        background: none;\n        border: 0;\n        width: 20px;\n        height: 20px;\n        top: 25px;\n    }\n    .filters .btn-filter::before {\n        transform: translateY(10px) rotate(135deg);\n        -moz-transform: translateY(10px) rotate(135deg);\n        -webkit-transform: translateY(-5px) rotate(135deg);\n        -webkit-transition: all 0.3s ease-in-out;\n        -moz-transition: all 0.3s ease-in-out;\n        -ms-transition: all 0.3s ease-in-out;\n        -o-transition: all 0.3s ease-in-out;\n        transition: all 0.3s ease-in-out;\n        width: 18px;\n        height: 2px;\n        content: '';\n        background: #000;\n        position: absolute;\n        border-radius: 5px;\n    }\n    .filters .btn-filter::after {\n        transform: translateY(-5px) rotate(-135deg);\n        -moz-transform: translateY(-5px) rotate(-135deg);\n        -webkit-transform: translateY(-5px) rotate(-135deg);\n        -webkit-transition: all 0.3s ease-in-out;\n        -moz-transition: all 0.3s ease-in-out;\n        -ms-transition: all 0.3s ease-in-out;\n        -o-transition: all 0.3s ease-in-out;\n        transition: all 0.3s ease-in-out;\n        width: 18px;\n        height: 2px;\n        content: '';\n        background: #000;\n        position: absolute;\n        border-radius: 5px;\n    }\n    .filters #accordionFilters {\n        margin-bottom: 30px;\n    }\n    .filters > h3 {\n        display: flex !important;\n        align-items: center;\n        justify-content: space-between;\n    }\n    /* .mobileFilter .btn-filter {border: 0;background: url(../images/filter.svg) no-repeat center right;padding-right: 0px;padding-left: 0;cursor: pointer;} */\n    .mobileFilter .btn-filter {\n        border: 0;\n        padding-right: 0px;\n        padding-left: 0;\n        cursor: pointer;\n    }\n    .filters {\n        max-width: 100%;\n        width: 100%;\n    }\n    .ji_filtersec {\n        max-width: unset;\n    }\n    \n    .alumni_directory_filter {\n        padding: 18px 0;\n        padding-right: var(--bs-gutter-x, 0.75rem);\n        padding-left: var(--bs-gutter-x, 0.75rem);\n    }\n    body[style*='overflow: hidden'] .alumni_directory_filter{display: none;}\n    .alumni-directory-header_search {\n        flex-direction: column;\n        align-items: start;\n    }\n    .alumni-directory-header_search:has(.alumni-reset-wrap){\n        flex-direction: row;\n        align-items: center;\n        justify-content: space-between;\n    }\n    .alumni-directory-header_search h2 {\n        margin-bottom: 15px !important;\n    }\n    .alumni-directory-header {\n        align-items: end;\n    }\n    .filter_result_title {\n        flex-direction: column;\n    }\n    .filter_result_title .filter_result {\n        display: none;\n    }\n    .alumni_count {\n        text-align: right;\n        margin: 0;\n    }\n    .alumni_directory_filter .fiterItem {\n        width: 170px !important;\n        margin: 0 !important;\n        box-shadow: none;\n        border: 0;\n        border-radius: 0;\n        border-bottom: 1px solid #e6e6e6 !important;\n    }\n    .alumni_directory_filter .filters {\n        padding: 0;\n        display: flex !important;\n        flex-direction: column;\n    }\n    .alumni_directory_filter .filters > div:first-child {\n        padding: 15px 20px;\n        border-bottom: 1px solid #dbdbdb;\n    }\n    .alumni_directory_filter .filters-head {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        height: auto;\n        padding: 0 15px;\n        box-shadow: 0px 0px 3px 0px #ccc;\n        position: relative;\n        z-index: 1;\n    }\n    .alumni_directory_filter .filters-head + #accordionFilters {\n        /* flex: 1 1; */\n        height: calc(100% - 175px);\n        position: relative;\n        background: #f5f5f5;\n    }\n    .alumni_directory_filter .filters #accordionFilters {\n        -webkit-box-flex: 1;\n        -moz-box-flex: 1;\n        -webkit-flex: 1;\n        -ms-flex: 1;\n        flex: 1;\n        margin: 0;\n        position: relative;\n    }\n    .alumni_directory_filter .filters #accordionFilters::before {\n        content: '';\n        position: absolute;\n        left: 0;\n        top: 0;\n        bottom: 0;\n        margin: auto;\n        width: 170px;\n        background: #f5f5f5;\n    }\n    .alumni_directory_filter .filters > #accordionFilters > .filterGroup.mt-3 {\n        margin: 0 !important;\n        flex-direction: column;\n        height: 100%;\n        position: relative;\n    }\n    .filterItemWrap {\n        display: none;\n    }\n    .additionalfilter_count {\n        padding: 0;\n        flex: none;\n    }\n    .alumni_directory_filter .filterHeader button .font-16.font-600 {\n        font-size: 14px !important;\n    }\n    .alumni_directory_filter .fiterItem .filterHeader > div {\n        border-radius: 0;\n    }\n    .alumni_directory_filter .fiterItem .filterHeader > div button {\n        background: #f5f5f5;\n        border-radius: 0;\n        padding: 10px;\n        color: #000;\n    }\n    .alumni_directory_filter .fiterItem .filterHeader > div button .toggle {\n        display: none;\n    }\n    .alumni_directory_filter .fiterItem .filterHeader > div button .font-18.font-600 {\n        font-size: 16px !important;\n        font-weight: 500 !important;\n    }\n    .additionalfilter_wrap {\n        width: 170px;\n        padding: 0;\n        margin: 0 !important;\n    }\n    .btn-additionalfilter {\n        display: none;\n    }\n    .additionalfilter_wrap > #additionalfilter {\n        display: block !important;\n    }\n    .alumni_directory_filter #additionalfilter .fiterItem,\n    .alumni_directory_filter #additionalfilter .fiterItem.campus {\n        width: 100%;\n    }\n    .additionalfilter_wrap>#additionalfilter .filterGroup {\n        flex-wrap: nowrap;\n        flex-direction: column;\n    }\n    .alumni_directory_filter .fiterItem .filterHeader + div {\n        position: absolute;\n        right: 0;\n        top: 0;\n        padding: 0;\n        bottom: 0;\n        width: calc(100% - 170px);\n        padding: 15px;\n        overflow: auto;\n    }\n    .alumni_directory_filter .filterGroup {\n        margin: 0 !important;\n    }\n    .alumni_directory_filter .filterGroup.mt-3 {\n        margin: 0 !important;flex-wrap: nowrap;overflow-y: auto;width: 170px;\n    }\n    .filter_close_apply {\n        background: #ffffff;\n        border-top: 1px solid #e9e9e9;\n        padding: 15px 20px;\n        justify-content: center;\n        align-items: center;\n    }\n    .filter_close_apply > a.btn-filter-apply {\n        padding: 8px 30px;\n        background: #5cae48;\n        border-radius: 3px;\n        text-decoration: none;\n        color: #fff;\n        margin: 0 15px;\n        font-weight: 500;\n        text-transform: uppercase;\n        transition: all 0.3s ease-in-out;\n    }\n    .filter_close_apply > a.btn-filter-apply:hover {\n        background: #448e32;\n        color: #fff;\n    }\n    .filter_close_apply > a.btn-filter-close {\n        text-decoration: none;\n        text-transform: uppercase;\n        color: #979797;\n        font-weight: 500;\n        transition: all 0.3s ease-in-out;\n        margin: 0 15px;\n    }\n    .filter_close_apply > a.btn-filter-close:hover {\n        color: #666262;\n    }\n    .alumni_directory_filter .showProfiles_right {\n        margin-left: 12px;\n    }\n    .alumni_directory_filter .filterSearchblk {\n        background: #fff;\n        padding: 0 0 10px;\n    }\n    .alumni_directory_filter .fiterItem .card {\n        padding: 0px 0px 15px;\n    }\n    .alumni_directory_filter .fiterItem .filterHeader > div button[aria-expanded='true'] {\n        pointer-events: none;\n        color: #1452ce;\n    }\n    .alumni_directory_filter .scrollMe {\n        max-height: initial;\n        min-height: initial;\n    }\n\n    .alumni_directory_filter .mobileFilter .btn-filter .icon-filter + span {\n        -webkit-box-flex: 1;\n        -moz-box-flex: 1;\n        -webkit-flex: 1;\n        -ms-flex: 1;\n        flex: 1;\n        text-align: left;\n    }\n    .alumni_directory_filter .mobileFilter .btn-filter .icon-filter + span + span {\n        display: -webkit-box;\n        display: -moz-box;\n        display: -ms-flexbox;\n        display: -webkit-flex;\n        display: flex;\n        -webkit-box-wrap: wrap;\n        -moz-box-wrap: wrap;\n        -ms-flex-wrap: wrap;\n        -webkit-wrap: wrap;\n        flex-wrap: wrap;\n        align-items: center;\n        color: #b92940;\n        font-size: 14px;\n    }\n    .alumni_directory_filter .mobileFilter .btn-filter {\n        display: flex;\n        align-items: center;\n    }\n    .alumni_directory_filter .mobileFilter .btn-filter .icon-filter + span + span .icon-right-arrow {\n        font-size: 15px;\n        transform: rotate(270deg);\n        margin-left: 10px;\n        color: #000;\n        transition: all 0.3s ease-in-out;\n    }\n    .alumni_directory_filter .mobileFilter .btn-filter[aria-expanded='false'] .icon-right-arrow {\n        transform: rotate(90deg) !important;\n    }\n    #filter_collapse h3 {\n        pointer-events: none;\n        margin: 20px 0 0 0;\n    }\n    .alumni_directory_filter {\n        background: #f3f3f3;\n        position: fixed;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        z-index: 99;\n        box-shadow: 0 0 5px 0px #cacaca;\n    }\n    .alumni_directory_filter .filters.show {\n        -moz-transform: translate3d(0, 100%, 0);\n        -webkit-transform: translate3d(0, 100%, 0);\n        -o-transform: translate3d(0, 100%, 0);\n        -ms-transform: translate3d(0, 100%, 0);\n        transform: translate3d(0, 100%, 0);\n    }\n    .alumni_profile_image_name_other_detail {\n        width: 100%;\n        padding-bottom: 30px;\n        margin-bottom: 30px;\n    }\n    .alumni_profile_college_name_other_detail_wrap .alumni_profile_college_name_other_detail {\n        flex-direction: column;\n    }\n    .nolisting_wrap .nolisting {\n        border: 0;\n        padding: 20px 0 10px;\n    }\n    .nolisting_text {\n        text-align: center;\n        justify-content: center;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n    }\n\n    .edit_section {\n        position: absolute;\n        right: 20px;\n        top: 5px;\n    }\n    .countnbtn .edit_section {\n        position: relative;\n        left: auto;\n        right: auto;\n        top: 0;\n        margin-left: 5px;\n    }\n    .skills-block .edit_section {\n        top: 22px;\n    }\n    .edit_section .edit_section_toggle {\n        display: inline-block;\n    }\n    .custom-btns a.edit_section_toggle {\n        display: inline-block;\n    }\n    .edit_section .edit_section_inner {\n        position: absolute;\n        top: 50px;\n        right: 0;\n        background: #fff;\n        box-shadow: 0px 0px 5px #57555533;\n        display: flex;\n        flex-direction: column;\n        width: 100px;\n        border-radius: 6px;\n        overflow: hidden;\n        opacity: 0;\n        z-index: -1;\n        transition: all 0.3s ease-in-out;\n        -webkit-transition: all 0.3s ease-in-out;\n        -moz-transition: all 0.3s ease-in-out;\n        -ms-transition: all 0.3s ease-in-out;\n        -o-transition: all 0.3s ease-in-out;\n    }\n    .edit_section.open .edit_section_inner {\n        top: 30px;\n        opacity: 1;\n        z-index: 9;\n    }\n    .edit_section .edit_section_inner a {\n        width: 100% !important;\n        border-radius: 0 !important;\n        padding: 0 0 0 30px;\n        font-size: 14px;\n        text-decoration: none;\n        color: #000;\n        line-height: 33px;\n        height: 35px !important;\n        background: #fff !important;\n        position: relative;\n        opacity: 1;\n        margin: 0 !important;\n        -webkit-border-radius: 0 !important;\n        -moz-border-radius: 0 !important;\n        -ms-border-radius: 0 !important;\n        -o-border-radius: 0 !important;\n        opacity: 1 !important;\n    }\n    .edit_section .edit_section_inner a:hover {\n        color: #fff;\n        background-color: #0b3454 !important;\n    }\n    .edit_section .edit_section_inner a.edit_link:before {\n        width: 16px;\n        height: 16px;\n        margin: 0;\n        background-size: 14px;\n        left: 7px;\n        top: 8px;\n    }\n    .edit_section .edit_section_inner a:first-child {\n        border-bottom: 1px solid #eee;\n    }\n    .edit_section .edit_section_inner a.del_link:before {\n        content: '';\n        background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/delete.svg) no-repeat center /\n            14px auto;\n        width: 14px;\n        height: 16px;\n        position: absolute;\n        left: 8px;\n        top: 8px;\n    }\n    .edit_section .edit_section_inner a.del_link:hover {\n        background: #0b3454;\n        color: #fff;\n    }\n    .edit_section .edit_section_inner a.del_link:hover:before {\n        filter: invert(92%) sepia(100%) saturate(0%) hue-rotate(202deg) brightness(106%) contrast(106%);\n        -webkit-filter: invert(92%) sepia(100%) saturate(0%) hue-rotate(202deg) brightness(106%) contrast(106%);\n    }\n    .graduateRow .college_detail_wrap .scholarship {\n        margin-right: 60px;\n    }\n    .achievements-block-detail .edit_section {\n        top: 4px;\n        right: 0;\n    }\n    .achievements-block-detail {\n        padding-right: 25px;\n    }\n    .postGraduate-detail .graduateRow .offer.offer_edit .edit_section {\n        top: 20px;\n    }\n    .work-block .edit_section {\n        right: 0;\n    }\n    .work-block .work-detail {\n        padding-right: 24px;\n    }\n\n    .alumni_profile_name_college_other_detail_wrap.directory-detail .alumni_profile_image_name_other_detail {\n        padding: 0;\n        margin: 0;\n        order: 1;\n    }\n    .alumni_profile_name_college_other_detail_wrap.directory-detail .alumni_profile_image_name_other_detail:after {\n        opacity: 0;\n    }\n    .alumni_profile_name_college_other_detail_wrap.directory-detail .alumni_profile_college_name_other_detail_wrap {\n        padding: 0;\n        order: 3;\n    }\n    .alumni_profile_name_college_other_detail_wrap.directory-detail .alumni_profile_brife_links {\n        order: 2;\n        border-bottom: 1px solid #dbdbdbcc;\n        margin-bottom: 30px;\n        padding-bottom: 30px;\n        flex-wrap: wrap;\n    }\n    .alumni_profile_brife_links > a {\n        margin-bottom: 10px;\n    }\n}\n\n@media (min-width: 575px) and (max-width: 767px) {\n    .filter_result_title {\n        flex-direction: column;\n    }\n    .alumni_count {\n        text-align: right;\n    }\n    .alumni_class_link {\n        flex-direction: column;\n        align-items: start;\n    }\n    .alumni_class_link .send_link {\n        padding: 0px 0 0 70px;\n    }\n    .alumni_name_detail {\n        width: 100%;\n    }\n}\n\n.alumni-reset-wrap .btn-white-border{height:40px}\n\n@media (max-width: 575px) {\n    .alumni-directory-header {\n        flex-direction: column;\n    }\n    .alumni-directory-header_search {\n        flex-direction: row;\n        width: 100%;\n        margin-bottom: 20px;\n        justify-content: space-between;\n        overflow: hidden;\n        align-items: center;\n    }\n    .alumni-directory-header_search h2 {\n        margin-bottom: 0 !important;\n    }\n    .alumni-directorySearch-wrap {\n        position: relative;\n    }\n    .alumni-reset-wrap {display:none}\n    .alumni-reset-wrap.show {display: block;position: absolute;top: 66px;right: 29px;}\n    .alumni-reset-wrap .btn-white-border{height:auto}\n    .alumni-directorySearch-wrap .alumni-directorySearch {\n        position: absolute;\n        right: -230px;\n        transition: all 0.3s ease-in-out;\n    }\n    .alumni-directorySearch-wrap.show .alumni-directorySearch {\n        right: 0;\n    }\n    .btn-alumniSearchToggle.icon-search {\n        width: 40px;\n        height: 40px;\n        background: #fff;\n        border-radius: 50%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        text-decoration: none;\n        color: #000;\n        font-size: 12px;\n    }\n    .alumni-directorySearch .form-control + .btn-cross {\n        opacity: 1;\n        right: 15px;\n        transform: rotate(135deg);\n    }\n    .alumni-switch-container {\n        margin: auto;\n    }\n    .alumni-directorySearch .form-control {\n        padding-right: 40px;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        overflow: hidden;\n    }\n    .alumni_profile_image_name_other_detail {\n        padding: 0 0 20px;\n        margin-bottom: 20px;\n    }\n    .alumni_profile_college_name_other_detail .alumni_profile_other_detail {\n        margin: 0 0 0 -98px;\n    }\n    .alumni_profile_status li {\n        width: 47%;\n        margin-bottom: 0;\n    }\n    .alumni_profile_status li:last-child {\n        margin-right: 0;\n    }\n    .alumni_profile_image_wrap{\n        width: 80px;\n        height: 80px;\n    }\n    .alumni_profile_image_wrap .pencil-edit {\n        top: -5px;\n        right: -5px;\n    }\n    .alumni_profile_image {\n        width: 80px;\n        height: 80px;\n    }\n    .alumni_profile_name_other_detail h2 {\n        line-height: 30px;\n        font-size: 24px;\n        width: calc(100% - 50px);\n        overflow: hidden;\n        text-overflow: ellipsis;\n        display: -webkit-box;\n        -webkit-line-clamp: 1;\n        -webkit-box-orient: vertical;\n    }\n    .alumni_profile_college_name_other_detail_wrap .alumni_profile_college_logo {\n        width: 80px;\n        height: 80px;\n    }\n    .alumni_profile_brife {\n        padding: 20px 0 10px;\n    }\n    /*.graduateRow .college_detail_wrap .college_detail {  flex-direction: column;align-items: center;}*/\n    .graduateRow .college_detail_wrap .college_detail {\n        padding-right: 0px;\n        width: 100%;\n    }\n    .graduateRow {\n        margin-left: -20px;\n        margin-right: -20px;\n        width: auto;\n        padding: 5px 20px;\n    }\n    .graduateRow .college_detail_wrap .college_detail .college_logo {\n        margin: 0 10px 10px 0;\n        width: 70px;\n        height: 70px;\n        border-radius: 50%;\n    }\n    .graduateRow .college_name_scholarship {\n        flex-direction: column;\n        align-items: start;\n        justify-content: start;\n        text-align: left;\n        width: calc(100% - 80px);\n    }\n    .graduateRow .college_name_scholarship .college_name {\n        width: calc(100% - 20px);\n    }\n    .graduateRow .college_detail_wrap .college_detail h3 {\n        font-size: 19px;\n        line-height: 20px;\n        word-break: break-word;\n    }\n    .alumni_profile_college_subject {\n        padding: 0 15px;\n        font-size: 15px;\n    }\n    .graduateRow .college_detail_wrap .scholarship {\n        flex-direction: row;\n    }\n    .graduateRow .college_detail_wrap .scholarship .scholarship_label {\n        margin-right: 7px;\n    }\n    .graduateRow .college_detail_wrap::after {\n        right: 0;\n        bottom: 0;\n        left: 0;\n        margin: auto;\n        width: 100%;\n        height: 1px;\n    }\n    .graduateRow .offer {\n        align-items: center;\n        flex-direction: row;\n        justify-content: center;\n    }\n    .graduateRow:not(:last-child) {\n        margin-bottom: 15px;\n        padding-bottom: 20px;\n    }\n    .underGraduate-detail {\n        padding: 20px;\n        box-shadow: none;\n    }\n    .workExperience-detail {\n        padding: 0px;\n    }\n    .workExperienceRow {\n        padding: 20px 20px 30px;\n    }\n\n    .achievements-block {\n        flex-direction: column;\n        align-items: center;\n    }\n    .achievements-icon-block {\n        border-right: 0;\n        margin: 0 0 18px;\n        padding: 0 0 18px;\n        border-bottom: 1px solid #cecece;\n    }\n    .achievements-block-detail {\n        text-align: center;\n    }\n    .achievements-block-detail h3 {\n        margin: 0;\n    }\n    .contributions-block .seactionheader {\n        margin: 0px 0 20px;\n        flex-direction: column;\n        align-items: inherit;\n    }\n    .contributions-block .seactionheader > h3 {\n        width: auto;\n        margin: -20px -20px 0;\n        background: #eff8ff;\n        border-radius: 6px 6px 0px 0px;\n        padding: 20px;\n        text-align: center;\n        line-height: 22px;\n    }\n    .contributions-block .seactionheader .countnbtn {\n        width: 100%;\n        margin-top: 10px;\n        align-items: center;\n        justify-content: space-between;\n        position: relative;\n    }\n    .contributions-block .seactionheader .countnbtn .custom-btns {\n        padding-right: 0;\n    }\n    .contributions-block .seactionheader .countnbtn .custom-btns .edit_section {\n        right: 0;\n        top: 0px;\n    }\n    .contributions-block {\n        padding: 20px;\n    }\n    .skills-block {\n        padding: 20px;\n    }\n    .skills-block:first-child {\n        padding-bottom: 5px;\n    }\n    .skills-block.EntranceExam-skills-block {\n        padding-bottom: 25px;\n    }\n    .skills-block h2 {\n        margin: 0 0 20px;\n        width: auto;\n        margin: -20px -20px 20px;\n        background: #eff8ff;\n        border-radius: 6px 6px 0px 0px;\n        padding: 20px;\n        text-align: center;\n        line-height: 22px;\n    }\n    .skills-block-detail .meter {\n        font-size: 18px;\n        align-items: center;\n        padding: 10px 20px;\n        line-height: 18px;\n    }\n    .card_profiles figure.student {\n        position: absolute;\n        left: 15px;\n        top: 15px;\n    }\n    .card_profiles .student_details h2 {\n        margin: 0 0 10px 90px;\n    }\n    .card_profiles .btn-send {\n        position: static;\n        margin-left: 90px;\n    }\n    .card_profiles .student_details .sub_details {\n        margin-top: 15px;\n    }\n    .card_profiles .student_details .sub_details span.course {\n        line-height: 15px;\n    }\n    .contributions-block .act_lst {\n        padding: 15px;\n    }\n    .contributions-block .act_lst .postedtxt {\n        text-align: left;\n        position: absolute;\n        top: 15px;\n        white-space: nowrap;\n        right: 15px;\n    }\n    .graduateRow .offer > a {\n        margin: 0 10px 0 0;\n    }\n    .graduateRow .offer div.got_offer {\n        margin-right: 15px;\n        width: calc(100% - 173px);\n        align-items: center;\n        display: flex;\n        margin-bottom: 0 !important;\n        text-align: left;\n        flex: 1;\n        justify-content: center;\n        line-height: 18px;\n    }\n    .graduateRow .offer .offer_joined {\n        align-items: start;\n        width: 158px;\n        align-items: center;\n        display: flex;\n        margin-bottom: 0 !important;\n        line-height: 16px;\n    }\n    .graduateRow .offer .offer_joined i {\n        margin-right: 8px;\n    }\n    .contributions-block .act_lst > .row > div:last-child .btn-green {\n        width: 135px;\n    }\n    .contributions-block .act_lst .btn-dark-blue {\n        width: 135px;\n    }\n    /* .contributions-block  .listblk_icon {margin-bottom: 0;width: 34px;height: 34px;} */\n    .contributions-block .act_lst .postedrow > div:last-child {\n        width: 100% !important;\n        display: flex;\n        flex-direction: row-reverse;\n        align-items: center;\n        border-top: 1px solid #d1d1d1;\n        padding-top: 10px;\n        margin-top: 8px;\n    }\n    .act_lst > .row.postedrow > div:last-child > div:first-child {\n        width: calc(100% - 190px);\n        margin: 0 0 0 15px;\n        align-items: center;\n    }\n    .alumni_class_link {\n        align-items: center;\n    }\n    .filter_result_title {\n        margin-bottom: 12px;\n    }\n    .contributions-block .album_shareblk {\n        padding: 5px 0 0 0px;\n    }\n    .profile-item,\n    .psychology-item {\n        width: 100%;\n        border: 0 !important;\n    }\n    .skills-block-title {\n        margin: 0 0 20px;\n        width: auto;\n        margin: -20px -20px 20px;\n        background: #eff8ff;\n        border-radius: 6px 6px 0px 0px;\n        padding: 20px;\n        text-align: center;\n        line-height: 22px;\n    }\n    .skills-block-title h2 {\n        padding: 0;\n        text-align: left;\n    }\n    #edit_Higher_Education .question {\n        padding-right: 20px;\n    }\n    #job_Preferences .question {\n        padding-right: 20px;\n    }\n    .underGraduate-detail .main_title,\n    .blockHeader {\n        margin: -20px -20px 30px;\n        padding: 20px;\n    }\n    .graduateRow .offer .offer_existing_links {\n        width: 100%;\n        flex-direction: row;\n        align-items: center;\n        justify-content: center;\n    }\n    .graduateRow .offer .got_offer {\n        margin-right: 10px;\n    }\n    .graduateRow .offer a.joindeLink {\n        margin: 0 10px 0 0;\n    }\n    .powerby {\n        margin: auto;\n    }\n    .graduateRow .offer.offer_edit .edit_section {\n        top: 10px;\n    }\n    .postGraduate-detail .graduateRow {\n        margin: 0;\n    }\n    .alumni_profile_college_name_detail {\n        width: 100%;\n        min-height: 100px;\n    }\n    .alumni_profile_name_college_other_detail_wrap {\n        padding-bottom: 20px;\n    }\n    .alumni_profile_name_college_other_detail_wrap.directory-detail .alumni_profile_brife_links {\n        padding: 0 0 17px;\n        margin-top: 5px;\n    }\n    .alumni_profile_brife_links > a {\n        padding: 0 15px;\n    }\n    .alumni_profile_name_college_other_detail_wrap.directory-detail\n        .alumni_profile_college_name_other_detail_wrap\n        .alumni_profile_college_name_other_detail\n        .alumni_profile_other_detail {\n        width: calc(100% + 98px);\n    }\n    .alumni_profile_name_college_other_detail_wrap.directory-detail\n        .alumni_profile_college_name_other_detail_wrap\n        .alumni_profile_college_name_other_detail\n        .alumni_profile_other_detail\n        .alumni_profile_status\n        li {\n        margin-bottom: 15px;\n    }\n    .leftUser {\n        padding-left: 55px;\n    }\n    .rightUser {\n        padding-right: 55px;\n    }\n    .half-gray:before {\n        display: none;\n    }\n\n    .universities_block span, .radius_block span, .skills-block-detail span {\n        flex: 1;\n        font-size: 15px;\n        line-height: 16px;\n    }\n}\n/* alumni directory */\n\n/* alumni connect */\n\n.univariety_main_banner_container {\n    position: relative;\n}\n.univariety_main_banner_container img {\n    position: relative;\n    vertical-align: top;\n}\n.main_banner_text {\n    position: absolute;\n    top: 22%;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    margin: auto;\n    max-width: 48%;\n    text-align: center;\n    color: #fff;\n}\n.banner_title {\n    font-size: 3.3vw;\n    color: #fff;\n    font-weight: 600;\n    margin-bottom: 35px;\n    line-height: 3vw;\n}\n.banner_sub_title {\n    font-size: 1.33vw;\n    line-height: 30px;\n    margin-bottom: 40px;\n    color: #fac75d;\n}\n.btn-watch {\n    width: 180px;\n    height: 50px;\n    border: 1px solid #5cae48;\n    text-decoration: none;\n    border-radius: 5px;\n    background: #5cae48;\n    font-size: 16px;\n    font-weight: 600;\n    color: #fff;\n    text-transform: uppercase;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.btn-watch:hover {\n    background: #fff;\n    text-decoration: none;\n    border-color: #fff;\n    color: #5cae48;\n}\n.btn-watch i {\n    width: 22px;\n    height: 22px;\n    background: #fff;\n    border-radius: 50%;\n    margin-right: 10px;\n    position: relative;\n}\n.btn-watch i:before {\n    content: '';\n    position: absolute;\n    width: 0;\n    height: 0;\n    border-top: 5px solid transparent;\n    border-bottom: 5px solid transparent;\n    border-left: 7px solid #5cae48;\n    top: 5.7px;\n    left: 9px;\n}\n.btn-watch:hover i {\n    background: #5cae48;\n}\n.btn-watch:hover i:before {\n    border-left-color: #fff;\n}\n\n.univariety_alumni_members {\n    background: #fff;\n}\n.univariety_alumni_members_container {\n    padding: 80px 0;\n    max-width: 1140px;\n    width: 90%;\n    margin: auto;\n}\n.univariety_alumni_members_container_title {\n    font-size: 32px;\n    color: #003457;\n    font-weight: bold;\n    margin-bottom: 0;\n    line-height: 64px;\n    text-align: center;\n}\n.univariety_alumni_members_container_title b {\n    font-weight: 600;\n}\n.univariety_alumni_members_container_sub_title {\n    font-size: 20px;\n    color: #000;\n    font-weight: 100;\n    line-height: 26px;\n    text-align: center;\n    margin-bottom: 30px;\n}\n.alumni_members_callout {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: space-between;\n    text-align: center;\n    width: 1140px;\n}\n.alumni_members_callout .number {\n    font-size: 48px;\n    font-weight: 600;\n    color: #074da2;\n}\n.alumni_members_callout p {\n    font-size: 24px;\n    font-weight: 500;\n    color: #000;\n    margin: 0;\n}\n\n#video_pop button.close {\n    border: none;\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    background: #fff;\n    opacity: 1;\n    padding: 1px 5px;\n    border-radius: 1px;\n    z-index: 9;\n    height: 24px;\n    display: flex;\n    align-items: start;\n    justify-content: center;\n    font-size: 1.5rem;\n    font-weight: 700;\n    line-height: 1;\n    color: #000;\n    text-shadow: 0 1px 0 #fff;\n}\n#video_pop button.close span {\n    line-height: 20px;\n    vertical-align: top;\n    margin: -1px 0 0;\n}\n\n.univariety_message_spotlight_container div[class*='univariety_'] {\n    padding: 50px 60px;\n}\n.univariety_message_spotlight_container {\n    max-width: 1150px;\n    width: 100%;\n    margin: auto;\n    position: relative;\n}\n.univariety_message_spotlight {\n    background: #f5faff;\n    position: relative;\n}\n.univariety_message_spotlight:before {\n    content: '';\n    right: 0;\n    bottom: 0;\n    top: 0;\n    background: #e8f6fc;\n    position: absolute;\n    width: 42%;\n}\n.univariety_spotlight {\n    background: #e8f6fc;\n}\n.video_wrap {\n    background: #ffffff 0% 0% no-repeat padding-box;\n    box-shadow: 0px 5px 15px #0000000d;\n    border-radius: 10px;\n    padding: 20px;\n}\n.univariety_spotlight .spotlight_block {\n    background: #fff 0% 0% no-repeat padding-box;\n    box-shadow: 0px 5px 15px #0000000d;\n    border-radius: 10px;\n    padding: 20px;\n}\n.univariety_message_spotlight_container div[class*='univariety_'] h2 {\n    text-align: center;\n    margin-bottom: 40px;\n    position: relative;\n    font-size: 24px;\n    font-weight: 600;\n}\n.univariety_message_spotlight_container div[class*='univariety_'] h2:before {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: -13px;\n    width: 50px;\n    height: 3px;\n    margin: auto;\n}\n.univariety_message_spotlight_container div.univariety_message h2:before {\n    background: #5cae48;\n}\n.univariety_message_spotlight_container div.univariety_spotlight h2:before {\n    background: #d42941;\n}\n.univariety_message_spotlight_container .owl-theme .owl-dots .owl-dot span {\n    background: #fff;\n    width: 12px;\n    height: 12px;\n}\n.univariety_message_spotlight_container .owl-theme .owl-dots .owl-dot.active span,\n.owl-theme .owl-dots .owl-dot:hover span {\n    background: #003457;\n}\n\n.btn-play {\n    position: relative;\n    display: inline-block;\n}\n.btn-play:before {\n    content: '';\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    width: 62px;\n    height: 62px;\n    background-color: #5cae48;\n    margin: auto;\n    border-radius: 50%;\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='white' stroke='' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z'/%3e%3c/svg%3e\");\n    background-repeat: no-repeat;\n    background-position: 14px 12px;\n    background-size: 40px;\n}\n\n.alumni_network_count {\n    overflow-y: hidden;\n    overflow-x: auto;\n    scrollbar-width: thin;\n    padding-bottom: 8px;\n}\n.alumni_network_count::-webkit-scrollbar {\n    height: 4px;\n}\n.alumni_network_count::-moz-scrollbar {\n    height: 4px;\n}\n.alumni_network_count::-webkit-scrollbar-track {\n    background: #ccc;\n}\n.alumni_network_count::-webkit-scrollbar-thumb {\n    background-color: #666;\n    border-radius: 20px;\n    border: 2px solid #666;\n}\n.alumni_network_count ul {\n    padding: 0;\n    margin: 0;\n    list-style: none;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n}\n.alumni_network_count li {\n    background: #ffffff;\n    box-shadow: 0px 3px 6px #0000001a;\n    border: 1px solid #0034571a;\n    border-radius: 10px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 40px;\n    width: 220px;\n    min-width: 220px;\n    text-align: center;\n}\n.alumni_network_count li b {\n    color: #5cae48;\n    font-size: 45px;\n}\n.alumni_network_count li:not(:last-child) {\n    margin-right: 10px;\n}\n.alumni_network_count li p {\n    margin: 0 !important;\n    text-align: center;\n    font-size: 18px;\n    line-height: 20px;\n    font-weight: 500;\n}\n.alumni_network_count li .icon {\n    width: 42px;\n    height: 42px;\n    margin-bottom: 10px;\n}\n.alumni_network_count li .icon.hat {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/graduation-cap.svg) no-repeat 0 0;\n    width: 48px;\n}\n.alumni_network_count li .icon.brifecase {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/career.svg) no-repeat 0 0;\n    width: 42px;\n}\n.alumni_network_count li .icon.building {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/office-building.svg) no-repeat 0 0;\n    width: 42px;\n}\n.alumni_network_count li .icon.global {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/union.svg) no-repeat 0 0;\n    width: 42px;\n}\n.alumni_network_count li .icon.college {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/school.svg) no-repeat 0 0;\n    width: 42px;\n}\n\n@media (max-width: 991px) {\n    .univariety_message_spotlight::before {\n        display: none;\n    }\n}\n\n@media (max-width: 575px) {\n    .univariety_message_spotlight_container div[class*='univariety_'] {\n        padding: 40px 40px;\n    }\n}\n\n.view_pw .btn {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    right: 15px;\n    width: 20px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.view_pw .btn img {\n    width: 20px;\n}\n.form-control[type='password'] + .btn .fview_icn {\n    display: none;\n}\n.form-control[type='text'] + .btn .fview_strike_icn {\n    display: none;\n}\n\n.login_signup_tab .form-check-input.agree-check + .form-check-label {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    flex: 1;\n    align-items: center;\n}\n.login_signup_tab .form-check-input.agree-check + .form-check-label .social_whatapp {\n    width: 17px;\n    height: 17px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/whatsapp.svg) no-repeat center / 100%;\n    margin-right: 6px;\n}\n.login_signup_tab .form-check-input.agree-check + .form-check-label span {\n    flex: 1;\n    color: #fff;\n    font-size: 14px;\n    padding: 0;\n    line-height: 18px;\n}\n\n.login_signup_tab .nav .nav-item {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    text-align: center;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    border-bottom: 3px solid #3c5d76;\n}\n.login_signup_tab .nav .nav-item .nav-link {\n    width: 100%;\n    background: transparent;\n    font-size: 18px;\n    font-weight: 500;\n    padding: 0 0 15px;\n    position: relative;\n    color: #fff;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.login_signup_tab .nav .nav-item .nav-link.active {\n    font-weight: 600;\n}\n.login_signup_tab .nav .nav-item .nav-link:before {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: -4px;\n    margin: auto;\n    width: 0;\n    height: 5px;\n    background: #5cae48;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.login_signup_tab .nav .nav-item .nav-link.active:before {\n    width: 100%;\n}\n\n.email_icon .form-control {\n    padding-left: 50px;\n}\n.password_icon .form-control {\n    padding-left: 50px;\n}\n.email_icon:before {\n    content: '';\n    background-color: #fff0;\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='%23E57F8D' stroke='none' stroke-linecap='none' stroke-linejoin='none' stroke-width='1' d='M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z'/%3e%3c/svg%3e\");\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: 26px;\n    position: absolute;\n    left: 10px;\n    top: 0;\n    width: 26px;\n    height: 24px;\n    margin: auto;\n    bottom: 0;\n}\n.password_icon::before {\n    content: '';\n    background-color: #fff0;\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='%23E57F8D' stroke='none' stroke-linecap='none' stroke-linejoin='none' stroke-width='1' d='M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z'/%3e%3c/svg%3e\");\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: 30px;\n    position: absolute;\n    left: 12px;\n    top: 0;\n    width: 21px;\n    height: 30px;\n    margin: auto;\n    bottom: 0;\n}\n\n.filter-switch-wrap {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    right: 40px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n}\n.filter-switch .form-check-input {\n    cursor: pointer;\n    margin: 0 10px;\n    width: 60px !important;\n    height: 30px !important;\n    background-color: #5cae48;\n    border: none !important;\n    background-size: 24px;\n    background-position: right 4px center;\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\");\n}\n.filter-switch .form-check-input:checked {\n    background-position: left 4px center;\n}\n.filter-switch .form-check-input:focus {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\");\n}\n.filter-switch label {\n    font-weight: 500;\n    cursor: pointer;\n}\n.filter-switch .form-check-input + label {\n    color: #474747;\n    order: -1;\n    font-weight: 400;\n}\n.filter-switch .form-check-input + label + label {\n    color: #5cae48;\n    font-weight: 600;\n}\n.filter-switch .form-check-input:checked + label {\n    color: #5cae48;\n    font-weight: 600;\n}\n.filter-switch .form-check-input:checked + label + label {\n    color: #474747;\n    font-weight: 400;\n}\n\na.btn-clear {\n    color: #d42941;\n    font-weight: 500;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\na.btn-clear:hover {\n    color: #0b3454;\n}\n\n.alumni-bucket .alumni_education a {\n    color: #0a70be;\n    font-weight: 500;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.alumni-bucket .alumni_education a:hover {\n    color: #5cae48;\n    text-decoration: none;\n}\n\n.alumni_univarsity_details.working {\n    background: transparent linear-gradient(180deg, #eefaff 0%, #e5f7ff 100%) 0% 0% no-repeat padding-box;\n}\n.alumni_univarsity_details.pursuing {\n    background: transparent linear-gradient(180deg, #fff7e6 0%, #fff6e3 100%) 0% 0% no-repeat padding-box;\n}\n.alumni_univarsity_details.examtaken {\n    background: transparent linear-gradient(180deg, #fff0eb 0%, #fce1d8 100%) 0% 0% no-repeat padding-box;\n}\n.alumni_univarsity_details.homemaker {\n    background: transparent linear-gradient(180deg, #f6f6f6 0%, #f8f8f8 100%) 0% 0% no-repeat padding-box;\n}\n.alumni_univarsity_details.break {\n    background: transparent linear-gradient(180deg, #f1efff 0%, #f7f6ff 100%) 0% 0% no-repeat padding-box;\n}\n.tooltip.show.tooltip-white {\n    opacity: 1;\n}\n@media (max-width: 767px) {\n    .alumni_directory_filter .filters-head {\n        -webkit-box-wrap: wrap;\n        -moz-box-wrap: wrap;\n        -ms-flex-wrap: wrap;\n        -webkit-wrap: wrap;\n        flex-wrap: wrap;\n    }\n    .filters-head .filter-switch-wrap {\n        position: static;\n        margin: 15px -20px 0px -20px;\n        border-top: 1px solid #dbdbdb;\n        width: calc(100% + 40px);\n        padding: 12px 15px;\n        display: -webkit-box;\n        display: -moz-box;\n        display: -ms-flexbox;\n        display: -webkit-flex;\n        display: flex;\n        justify-content: center;\n    }\n}\n\n/* Setting button dropdown in admin menu */\ntd:last-child .dropdown-menu {\n    right: 0;\n    left: auto;\n}\n\n/* alumni marketing css */\n.offcanvas {\n    z-index: 10509;\n}\n\n.verticalScrol {\n    max-height: 360px;\n    overflow: auto;\n}\n.verticalScrol::-webkit-scrollbar {\n    width: 3px;\n}\n.verticalScrol::-webkit-scrollbar-track {\n    background: #ccc;\n}\n.verticalScrol::-webkit-scrollbar-thumb {\n    background: #666;\n}\n.verticalScrol::-webkit-scrollbar-thumb:hover {\n    background: #999;\n}\n.collegelist {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n}\n.collegelist li {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n}\n.collegelist li i {\n    margin-right: 15px;\n    width: 85px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.collegelist li:not(:last-child) {\n    border-bottom: 1px solid #e9e9e9;\n    padding-bottom: 15px;\n    margin-bottom: 15px;\n}\n.collegelist li p {\n    margin: 0;\n    font-size: 16px;\n    font-weight: 500;\n}\n\n.verticalScrol .accordion-item {\n    border: none;\n}\n.verticalScrol .accordion-item .accordion-button:not(.collapsed) {\n    background-color: transparent;\n}\n.verticalScrol .accordion-item .accordion-button {\n    font-size: 18px;\n    font-weight: 600;\n    color: #000;\n    padding-left: 0;\n    padding-right: 0;\n    box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.125);\n}\n.verticalScrol .accordion-item .accordion-button:focus {\n    box-shadow: none;\n    outline: none;\n}\n\n.horizontallist {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    padding: 0;\n    margin: 0;\n    list-style: none;\n}\n.horizontallist li {\n    position: relative;\n    margin: 0 15px 5px 0;\n    padding-left: 12px;\n}\n.horizontallist li:before {\n    content: '';\n    position: absolute;\n    width: 4px;\n    height: 4px;\n    border-radius: 50%;\n    background: black;\n    left: 0;\n    top: 11px;\n}\n.verticalScrol .accordion-body {\n    padding-left: 0;\n    padding-right: 0;\n}\n\n.option ul {\n    list-style: none;\n    margin: 11px 0;\n    text-align: left;\n    border: 1px solid #ccc;\n    padding: 10px;\n    border-radius: 5px;\n    font-size: 14px;\n    line-height: 18px;\n    position: relative;\n}\n.option ul li:not(:last-child) {\n    margin-bottom: 7px;\n}\n.option ul:before {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    margin: auto;\n    top: -6px;\n    width: 0;\n    height: 0;\n    border-left: 5px solid transparent;\n    border-right: 5px solid transparent;\n    border-bottom: 5px solid #ccc;\n}\n\n.view-all-wrap {\n    padding: 30px;\n    margin: 50px -30px -30px;\n    border-top: 1px solid #d4d4d4;\n}\n\n.btn-green[disabled] {\n    background: #e2e2e2;\n    border-radius: 20px;\n    color: #a29d9d;\n    text-decoration: none;\n    opacity: 1;\n}\n.btn-green img {\n    filter: brightness(0) invert(1);\n    -webkit-filter: brightness(0) invert(1);\n}\ntr:hover .btn-green[disabled] {\n    background: #333;\n    color: #fff;\n}\n.btn-green[disabled]:hover {\n    background: #333;\n    color: #fff;\n}\n\n.icon-sort-arrow .up-arrow {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='%23343a40' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='' stroke-width='1' d='M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z'/%3e%3c/svg%3e\");\n    width: 15px;\n    height: 15px;\n    margin-right: -3px;\n}\n.icon-sort-arrow .down-arrow {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='%23343a40' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='' stroke-width='1' d='M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z'/%3e%3c/svg%3e\");\n    width: 15px;\n    height: 15px;\n    margin-left: -3px;\n}\n\n.radio-box * {\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.radio-box {\n    background: #ffffff;\n    border: 1px solid #0b34544d;\n    border-radius: 6px;\n    padding: 11px 15px;\n    min-width: 124px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    cursor: pointer;\n}\n.radio-box span {\n    padding: 0;\n    font-size: 16px;\n    font-style: normal;\n    color: #000;\n    font-weight: 500;\n    float: none;\n}\n.radio-box i {\n    margin-left: 8px;\n    background: #ffffff;\n    border: 1px solid #b5c1cb;\n    opacity: 1;\n    width: 18px;\n    height: 18px;\n    position: relative;\n    border-radius: 50%;\n    -webkit-border-radius: 50%;\n    -moz-border-radius: 50%;\n    -ms-border-radius: 50%;\n    -o-border-radius: 50%;\n}\n.radio-box i:before {\n    content: '';\n    position: absolute;\n    width: 9px;\n    height: 5px;\n    border-left: 2px solid #b5c1cb;\n    border-bottom: 2px solid #b5c1cb;\n    transform: rotate(-45deg);\n    left: 3px;\n    top: 5px;\n    -webkit-transform: rotate(-45deg);\n    -moz-transform: rotate(-45deg);\n    -ms-transform: rotate(-45deg);\n    -o-transform: rotate(-45deg);\n}\n.form-check-input + .radio-box span {\n    flex: 1;\n}\n.form-check-input:checked + .radio-box {\n    background: #5cae48;\n    border-color: #5cae48;\n}\n.form-check-input:checked + .radio-box span {\n    color: #fff;\n}\n.form-check-input:checked + .radio-box i {\n    border-color: #fff;\n    background: #5cae48;\n}\n.form-check-input:checked + .radio-box i:before {\n    border-color: #fff;\n}\n\n.action_btns {\n    max-width: 100%;\n    background: #f5faff;\n    padding: 20px;\n    border-radius: 5px;\n    margin: 35px 0 0 0px;\n    text-align: center;\n}\n.action_btns button.nextbtn {\n    padding: 0px 30px;\n    font-size: 1.5em;\n    cursor: pointer;\n    border: 0px;\n    position: relative;\n    margin: auto;\n    transition: all 0.25s ease;\n    background: #0b3454;\n    color: #fff;\n    overflow: hidden;\n    border-radius: 25px;\n    height: 45px;\n    font-size: 16px;\n    font-weight: 500;\n    letter-spacing: 1px;\n}\n.action_btns .btn-skip {\n    font-size: 16px;\n    display: inline-block;\n}\n.btn-skip {\n    margin: 15px;\n    font-size: 12px;\n    text-decoration: none;\n    font-weight: 500;\n    color: #00000070;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n\n.btn-skip:hover {\n    color: #d42941;\n}\n.radius-6 {\n    border-radius: 6px;\n    -webkit-border-radius: 6px;\n    -moz-border-radius: 6px;\n    -ms-border-radius: 6px;\n    -o-border-radius: 6px;\n}\n\n.disableOpacity {\n    opacity: 0;\n    cursor: default !important;\n}\n\n.hrBg {\n    border-color: #e9e9e9;\n    background-color: #e9e9e9;\n    opacity: 1;\n}\n\n.max-568 {\n    max-width: 568px;\n}\n\n.new-btn-delete {\n    width: 125px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    font-size: 16px;\n    font-weight: 500;\n    color: #c30000;\n    align-items: center;\n}\n.new-btn-delete i {\n    margin-right: 7px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n}\n.new-btn-delete img {\n    opacity: 0.8;\n}\n.new-btn-delete:hover {\n    color: #890000;\n}\n.new-btn-delete:hover img {\n    opacity: 1;\n}\n\n.profile_section {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    align-items: center;\n    position: relative;\n}\n.profile_section::after {\n    content: '';\n    position: absolute;\n    background-color: #c4c4c4;\n    width: 1px;\n    height: 40px;\n    top: 0;\n    bottom: 0;\n    right: 10px;\n    margin: auto;\n}\n.profile_section .profile_section_img {\n    width: 60px;\n    margin-right: 15px;\n}\n.profile_section .profile_section_name {\n    font-size: 22px;\n    font-weight: 600;\n    color: #0b3454;\n    max-width: 150px;\n    line-height: 24px;\n    padding-right: 30px;\n    margin-right: 10px;\n}\n\n.contact_detail {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    height: 100%;\n}\n.contact_detail div {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n}\n.contact_detail div:not(:last-child) {\n    margin-bottom: 3px;\n}\n.contact_detail div i {\n    width: 20px;\n    height: 20px;\n    display: inline-block;\n    margin-right: 7px;\n    background-position: center;\n    background-size: 20px;\n}\n.contact_detail div a {\n    color: #0b3454;\n    text-decoration: none;\n    font-weight: 500;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.contact_detail div a:hover {\n    color: #1c5785;\n}\n.contact_detail div.phone i {\n    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/phone_icon.svg);\n}\n.contact_detail div.email i {\n    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/email_icon.svg);\n}\n\n.lead_items b {\n    font-weight: 500;\n    color: #0b3454;\n}\n.custom-bottom-liteblue {\n    border-bottom: 3px solid #f2f9ff;\n}\n.custom-bottom-litegray {\n    border-bottom: 3px solid #e5eaed;\n}\n\n@media (max-width: 523px) {\n    .profile_section {\n        padding-bottom: 30px;\n        margin-bottom: 10px;\n    }\n    .profile_section::after {\n        width: 80px;\n        height: 1px;\n        left: 0;\n        bottom: 3px;\n        top: auto;\n        right: auto;\n    }\n}\n\n/* Bulk Imports  */\n\n.bulk_imports_header {\n    border-bottom: 1px solid #c1ccd4;\n}\n.steps_flow {\n    margin: auto;\n    padding: 0;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    position: relative;\n    list-style: none;\n}\n.polartabsec .steps_flow li {\n    height: auto;\n    position: relative;\n}\n.polartabsec .steps_flow li:not(:last-child) {\n    margin-right: 254px;\n}\n.polartabsec .steps_flow li a {\n    text-decoration: none;\n    color: #000;\n    font-size: 18px;\n}\n.polartabsec .steps_flow li.active a {\n    font-weight: 500;\n}\n.steps_flow:before {\n    content: '';\n    position: absolute;\n    left: 20px;\n    bottom: -20px;\n    right: 20px;\n    border-bottom: 3px solid #5cae48;\n    margin: auto;\n}\n.polartabsec .steps_flow li:before {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: -30px;\n    background: #ffffff;\n    border: 2px solid #0b345433;\n    opacity: 1;\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    margin: auto;\n    -webkit-border-radius: 50%;\n    -moz-border-radius: 50%;\n    -ms-border-radius: 50%;\n    -o-border-radius: 50%;\n}\n.polartabsec .steps_flow li.active:before {\n    background: #0db35c;\n    border: 1px solid #0db35c;\n    margin: auto;\n    box-shadow: 0 0 0 5px #fff inset;\n}\n.polartabsec .steps_flow li.completed::before {\n    background-color: #0db35c;\n    border: 1px solid #0db35c;\n    margin: auto;\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='' stroke-linejoin='' stroke-width='2' d='M6 10l3 3l6-6'/%3e%3c/svg%3e\");\n}\n\n.import-title {\n    text-align: center;\n    margin-top: 30px;\n}\n.import-title h3 {\n    font-size: 24px;\n    font-weight: 500;\n    margin: 0 0 5px;\n}\n.import-title p {\n    font-size: 16px;\n    margin-bottom: 5px;\n}\n\n.import-block * {\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.import-block {\n    background: #ffffff;\n    border: 1px solid #d2d2d2;\n    border-radius: 6px;\n    position: relative;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    overflow: hidden;\n    height: 100%;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n}\n.import-block .icon {\n    position: absolute;\n    background: #0b3454;\n    border-radius: 0px 4px 0px 72px;\n    width: 78px;\n    height: 78px;\n    top: 0;\n    right: 0;\n}\n.import-block .icon::before {\n    filter: brightness(0) invert(1);\n    -webkit-filter: brightness(0) invert(1);\n}\n.import-block-detail {\n    padding: 20px 30px 30px;\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n}\n.icon.icon_user::before {\n    content: '';\n    position: absolute;\n    right: 14px;\n    top: 14px;\n    width: 30px;\n    height: 30px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/selet-user.svg);\n}\n.icon.icon_display::before {\n    content: '';\n    position: absolute;\n    right: 14px;\n    top: 14px;\n    width: 30px;\n    height: 30px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/display-user.svg);\n}\n.import-block-detail h4 {\n    font-size: 24px;\n    font-weight: 500;\n    margin: 0 0 15px;\n}\n.import-block-detail ul {\n    margin: 0;\n    padding: 0;\n    max-width: 420px;\n    list-style: none;\n}\n.import-block-detail ul li:not(:last-child) {\n    margin-bottom: 18px;\n}\n.import-block-detail ul li {\n    position: relative;\n    padding: 0 0 0 18px;\n    line-height: 20px;\n}\n.import-block-detail ul li:before {\n    content: '';\n    position: absolute;\n    top: 3px;\n    left: 0;\n    background: #27a7df;\n    width: 3px;\n    height: 85%;\n    border-radius: 5px;\n    -webkit-border-radius: 5px;\n    -moz-border-radius: 5px;\n    -ms-border-radius: 5px;\n    -o-border-radius: 5px;\n}\n.import-block-select {\n    background: #f2f9ff;\n    width: 100%;\n    height: 60px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 18px;\n    font-weight: 600;\n    color: #0b345490;\n    text-transform: uppercase;\n    cursor: pointer;\n}\n.import-block-select i {\n    width: 26px;\n    height: 26px;\n    border-radius: 5px;\n    border: 1px solid #d2d2d2;\n    background: #fff;\n    margin-right: 10px;\n    transition: all 0.5s ease-in-out;\n    -webkit-transition: all 0.5s ease-in-out;\n    -moz-transition: all 0.5s ease-in-out;\n    -ms-transition: all 0.5s ease-in-out;\n    -o-transition: all 0.5s ease-in-out;\n    position: relative;\n    -webkit-border-radius: 5px;\n    -moz-border-radius: 5px;\n    -ms-border-radius: 5px;\n    -o-border-radius: 5px;\n}\n\n.inputfile_parent label.height-80 {\n    height: 80px;\n}\n.inputfile_parent label.height-80 span {\n    font-weight: 400;\n}\n.inputfile_parent label .text-skyblue {\n    color: #27a7df;\n}\n\n.form-check-input:checked + div {\n    border: 1px solid #5cae48;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.form-check-input:checked + div .icon {\n    background: #f2f9ff;\n}\n.form-check-input:checked + div .icon:before {\n    filter: brightness(1) invert(0);\n    -webkit-filter: brightness(1) invert(0);\n}\n.form-check-input:checked + div .import-block-select {\n    background: #5cae48;\n    color: #fff;\n}\n.form-check-input:checked + div .import-block-select i {\n    border-color: #fff;\n    background-color: #fff;\n}\n.form-check-input:checked + div .import-block-select i::before {\n    content: '';\n    position: absolute;\n    border-width: 0px 0px 3px 3px;\n    border-style: solid;\n    border-color: #5cae48;\n    width: 14px;\n    height: 7px;\n    transform: rotate(-45deg);\n    left: 6px;\n    top: 7px;\n    -webkit-transform: rotate(-45deg);\n    -moz-transform: rotate(-45deg);\n    -ms-transform: rotate(-45deg);\n    -o-transform: rotate(-45deg);\n}\n\n.upload_disclaimer {\n    font-size: 14px;\n    line-height: 20px;\n    text-align: center;\n    color: #0b3454;\n    opacity: 0.8;\n    padding: 14px 0;\n}\n\n.form-check-tick .form-check-input {\n    width: 26px;\n    height: 26px;\n    margin-right: 8px;\n    margin-top: 0;\n}\n.form-check-tick {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n}\n.form-check-tick .form-check-input:checked {\n    background-color: #5cae48;\n    border-color: #5cae48;\n}\n\n.map-card-wrap {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-wrap: nowrap;\n    padding-bottom: 20px;\n}\n.map-card {\n    border: 1px solid #dbdcdd;\n    border-radius: 6px;\n    width: 257px;\n    min-width: 257px;\n    overflow: hidden;\n}\n.map-card:not(:last-child) {\n    margin-right: 10px;\n}\n.map-column {\n    background: #f2f9ff;\n    padding: 10px 15px 20px;\n}\n.map-title {\n    color: #68696a;\n    font-weight: 500;\n    font-size: 14px;\n}\n.skip_column {\n    height: 45px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.skip_column .skip-link {\n    color: #0b3454;\n}\n.column-list {\n    padding: 0;\n    margin: 0;\n}\n.column-list li {\n    min-height: 45px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    padding: 0 15px;\n}\n.column-list-title {\n    background: #f5f7f8;\n    font-weight: 500;\n}\n.column-list li ~ li:not(:last-child) {\n    border-bottom: 1px solid #ebebeb;\n}\n\n.modal-header .icon-correct {\n    width: 50px;\n    height: 50px;\n    background: #5cae48;\n    border-radius: 50%;\n    color: #fff;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 25px;\n    -webkit-border-radius: 50%;\n    -moz-border-radius: 50%;\n    -ms-border-radius: 50%;\n    -o-border-radius: 50%;\n}\n\n.x-scroll-big {\n    overflow-x: auto;\n}\n.x-scroll-big::-webkit-scrollbar {\n    height: 15px;\n}\n.x-scroll-big::-webkit-scrollbar-track {\n    background: #ccc;\n}\n.x-scroll-big::-webkit-scrollbar-thumb {\n    background: #666;\n}\n.x-scroll-big::-webkit-scrollbar-thumb:hover {\n    background: #555;\n}\n\n.p-40 {\n    padding: 40px;\n}\n\n.btn-disable {\n    background: #e2e2e2;\n    border-radius: 25px;\n    height: 35px;\n    color: #000;\n    font-weight: 400;\n    pointer-events: none;\n}\n.btn.btn-disable:hover {\n    background: #666;\n    color: #ffff;\n}\n\n.custom_step {\n    background: #ffffff;\n    border: 2px solid #5cae48;\n    opacity: 1;\n    border-radius: 5px 0px 0px 5px;\n    width: 90px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    height: 40px;\n    justify-content: center;\n    color: #5cae48;\n    font-weight: 500;\n    position: relative;\n    margin-right: 20px;\n}\n.custom_step:after {\n    position: absolute;\n    content: '';\n    width: 28.3px;\n    height: 28.3px;\n    border-top: 2px solid #5cae48;\n    border-right: 2px solid #5cae48;\n    transform: rotate(45deg);\n    right: -16px;\n    background: #fff;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n}\n\n.custom-tool {\n    position: absolute;\n    padding: 10px;\n    background: #d6ffcc;\n    font-size: 16px;\n    line-height: 16px;\n    font-weight: 400;\n    white-space: nowrap;\n    border-radius: 5px;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    height: 40px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    left: calc(100% + 20px);\n    padding: 0 20px;\n}\n.custom-tool:before {\n    content: '';\n    position: absolute;\n    border-top: 8px solid transparent;\n    border-bottom: 8px solid transparent;\n    border-right: 8px solid #d6ffcc;\n    right: 100%;\n}\n\n.upload_section {\n    background: #ffffff;\n    border: 1px dashed #0b345480;\n    border-radius: 6px;\n    padding: 20px;\n    position: relative;\n}\n.upload_section .cloud-wrap {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    align-items: center;\n}\n.upload_section .cloud-wrap .cloud-img {\n    margin-right: 15px;\n}\n.upload_section .btn-upload {\n    width: 170px;\n}\n.upload_section .cloud-wrap .cloud-text {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    line-height: 18px;\n}\n.form-check-input {\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.upload_section u {\n    color: #27a7df;\n}\n\ndiv.ck.ck-editor {\n    min-height: 200px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n}\ndiv.ck.ck-editor .ck-editor__main {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n}\ndiv.ck.ck-editor .ck-editor__main .ck-editor__editable_inline {\n    display: block;\n    width: 100%;\n    border-radius: 0px 0px 6px 6px;\n}\ndiv.ck.ck-editor .ck-editor__main .ck-editor__editable_inline a {\n    color: #0c4cbb;\n    text-decoration: none;\n}\ndiv.ck.ck-editor .ck-reset_all .ck-sticky-panel__content .ck-toolbar {\n    border-radius: 6px 6px 0 0;\n}\n.post-control ~ div.ck.ck-editor {\n    min-height: 300px;\n}\n\n.circle-tick {\n    width: 36px;\n    height: 36px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    background: #5cae48;\n    border-radius: 50%;\n    margin-right: 12px;\n    position: relative;\n}\n.circle-tick:before {\n    content: '';\n    position: absolute;\n    width: 16px;\n    height: 8px;\n    border-left: 3px solid #fff;\n    border-bottom: 3px solid #fff;\n    top: 12px;\n    left: 10px;\n    transform: rotate(-45deg);\n    -webkit-transform: rotate(-45deg);\n    -moz-transform: rotate(-45deg);\n    -ms-transform: rotate(-45deg);\n    -o-transform: rotate(-45deg);\n}\n\n@media (max-width: 575px) {\n    .polartabsec .steps_flow li:not(:last-child) {\n        margin-right: 145px;\n    }\n    .inputfile_parent label.height-80 span.uploadlabel {\n        text-overflow: ellipsis;\n        width: calc(100% - 75px);\n        overflow: hidden;\n    }\n    .custom-tool {\n        display: none;\n    }\n}\n/* Bulk Imports end */\n\n/* social media post start */\n\n.social_wrap ul {\n    padding: 0;\n    margin: 20px 0 0;\n    list-style: none;\n}\n.social_wrap ul li {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    padding: 20px 0;\n}\n.social_wrap ul li:not(:last-child) {\n    border-bottom: 1px solid #e5eaed;\n}\n.social_wrap ul li .post-view {\n    width: calc(100% - 450px);\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    align-items: center;\n    margin-right: 90px;\n}\n.social_wrap ul li .post-view .post-name {\n    width: 100%;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    margin-right: 90px;\n}\n.social_wrap ul li .post-view .post-name .social-logo {\n    margin-right: 15px;\n    width: 50px;\n    height: 50px;\n    overflow: hidden;\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.social_wrap ul li .post-view .post-name .social-logo img{\n    width: auto;\n    height: 100%;\n    max-width: inherit !important;\n}\n.social_wrap ul li .post-view .post-title {\n    font-weight: 500;\n    width: calc(100% - 65px);\n}\n.social_wrap ul li .post-view .post-title p{\n    display: inline;\n}\n.social_wrap ul li .post-detail {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    margin-left: auto;\n}\n.social_wrap ul li .post-detail .post-detail-date {\n    line-height: 16px;\n    text-align: right;\n    font-size: 14px;\n    font-weight: 600;\n    margin-right: 20px;\n}\n.social_wrap ul li .post-detail .post-detail-date span {\n    font-size: 16px;\n    font-weight: 400;\n    font-style: italic;\n}\n\n.postOption {\n    background: #fffae5;\n    border: 1px dashed #e3dec8;\n    border-radius: 6px;\n    padding: 25px;\n}\n.postOption ul {\n    margin: 0;\n    padding: 0;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    list-style: none;\n    justify-content: space-between;\n}\n.postOption ul li {\n    height: 50px;\n    width: 48%;\n    border-radius: 5px;\n}\n.postOption ul li label {\n    width: 100%;\n    height: 100%;\n    border-radius: 6px;\n    padding: 0 18px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    font-size: 18px;\n    font-weight: 500;\n    color: #fff;\n    cursor: pointer;\n    position: relative;\n}\n.postOption ul li label b {\n    position: absolute;\n    width: 25px;\n    height: 25px;\n    border-radius: 25px;\n    -webkit-border-radius: 25px;\n    -moz-border-radius: 25px;\n    -ms-border-radius: 25px;\n    -o-border-radius: 25px;\n    background: rgba(0, 0, 0, 0.5);\n    top: 0;\n    bottom: 0;\n    right: 15px;\n    margin: auto;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.postOption ul li label[for='facebook'] {\n    background-color: #3456a2;\n}\n.postOption ul li label[for='Twitter'] {\n    background-color: #01a1f9;\n}\n.postOption ul li label[for='linkedin'] {\n    background-color: #0077b7;\n}\n.postOption ul li label[for='instagram'] {\n    background: rgb(171,16,128);\n    background: linear-gradient(208deg, rgba(171,16,128,1) 0%, rgba(254,83,64,1) 70%, rgba(255,213,84,1) 100%);\n}\n.postOption ul li label i {\n    width: 25px;\n    height: 25px;\n    margin-right: 10px;\n    background-size: 100%;\n    background-position: center;\n}\n.postOption ul li label[for='facebook'] i {\n    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/facebook-white.svg);\n}\n.postOption ul li label[for='Twitter'] i {\n    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/x-twtter.svg);\n    background-size: 33px;\n}\n.postOption ul li label[for='linkedin'] i {\n    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/linkedin.svg);\n    background-size: 27px;\n    background-color: #fff;\n}\n.postOption ul li label[for='instagram'] i {\n    background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/instagram.svg);\n    background-size: 33px;\n}\n.postOption ul li input:checked ~ label b {\n    background-color: #ffffff;\n}\n.postOption ul li input:checked ~ label b::before {\n    content: '';\n    width: 14px;\n    height: 7px;\n    position: absolute;\n    border-left: 3px solid #5cae48;\n    border-bottom: 3px solid #5cae48;\n    left: 6px;\n    top: 8px;\n    transform: rotate(-45deg);\n    -webkit-transform: rotate(-45deg);\n    -moz-transform: rotate(-45deg);\n    -ms-transform: rotate(-45deg);\n    -o-transform: rotate(-45deg);\n}\n\n.post-preview {\n    background: #f2f4f7;\n    padding: 25px;\n    border-radius: 5px;\n    margin-top: 28px;\n    height: calc(100% - 28px);\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n}\n.post-preview h2 {\n    font-size: 22px;\n    text-align: center;\n    font-weight: 500;\n}\n.post-preview-data {\n    background: #ffff;\n    padding: 25px;\n    border-radius: 5px;\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n}\n.post-preview-data a {\n    color: #0c4cbb;\n}\n\n@media (max-width: 991px) {\n    .social_wrap ul li .post-view .post-name {\n        margin-right: 30px;\n    }\n    .social_wrap ul li .post-view {\n        margin-right: 30px;\n    }\n}\n\n@media (max-width: 767px) {\n    .social_wrap ul li .post-view {\n        margin-right: 0px;\n        width: 100%;\n    }\n    .social_wrap ul li .post-detail {\n        width: 100%;\n        margin-top: 10px;\n        justify-content: end;\n    }\n}\n\n@media (max-width: 575px) {\n    .postOption {\n        padding: 10px;\n    }\n    .postOption ul li {\n        width: 48.5%;\n    }\n    .postOption ul li label {\n        padding: 0 10px;\n        font-size: 15px;\n    }\n    .postOption ul li label i {\n        margin-right: 0;\n    }\n}\n\n@media (max-width: 480px) {\n    .social_wrap ul li .post-view {\n        flex-direction: column;\n        align-items: start;\n    }\n    .social_wrap ul li .post-view .post-name {\n        margin-right: 0;\n        margin-bottom: 10px;\n    }\n    .social_wrap ul li .post-detail {\n        justify-content: start;\n        flex-direction: row-reverse;\n    }\n    .social_wrap ul li .post-detail .post-detail-date {\n        margin: 0 0 0 10px;\n        text-align: left;\n    }\n}\n\n/* social media post End */\n\n/* manage-widgets-wrap */\n.manage-widgets-wrap ul {\n    padding: 0;\n    margin: 0;\n    list-style: none;\n}\n.manage-widgets-wrap ul li {\n    background: #ffffff;\n    border: 1px solid #eaeaea;\n    border-radius: 4px;\n    padding: 10px;\n}\n.manage-widgets-wrap ul li:not(:last-child) {\n    margin-bottom: 5px;\n}\n.manage-widgets-wrap {\n    margin-top: 25px;\n}\n\n.manage-widgets-wrap .form-check-tick .form-check-input {\n    width: 22px;\n    height: 22px;\n}\n\n.btn.btn-widgets-edit {\n    background: #ffffff;\n    border: 2px solid #0b3454;\n    border-radius: 15px;\n    height: 28px;\n    line-height: 25px;\n    padding: 0 20px;\n    text-decoration: none;\n    text-transform: uppercase;\n    font-weight: 600;\n    font-size: 12px;\n    color: #0b3454;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.btn.btn-widgets-edit:hover {\n    background: #0b3454;\n    color: #fff;\n}\n\n.btn.btn-priview {\n    background: #ffffff;\n    border: 2px solid #5cae48;\n    border-radius: 15px;\n    height: 28px;\n    line-height: 25px;\n    padding: 0 20px;\n    text-decoration: none;\n    text-transform: uppercase;\n    font-weight: 600;\n    font-size: 12px;\n    color: #5cae48;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.btn.btn-priview:hover {\n    background: #5cae48;\n    color: #fff;\n}\n\n.btn.btn-configure {\n    background: #0b3454;\n    border: 2px solid #0b3454;\n    border-radius: 15px;\n    height: 28px;\n    line-height: 25px;\n    padding: 0 20px;\n    text-decoration: none;\n    text-transform: uppercase;\n    font-weight: 600;\n    font-size: 12px;\n    color: #fff;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.btn.btn-configure:hover {\n    background: #5cae48;\n    border: 2px solid #5cae48;\n    color: #fff;\n}\n/* manage-widgets-wrap */\n\n.alumni-spotlight {\n    background: #f2f4f7;\n    border-radius: 5px;\n    overflow: hidden;\n    box-shadow: 0 0 8px 0px #aeaeae;\n}\n.alumni-spotlight a {\n    text-decoration: none;\n}\n.alumni-spotlight > .bg-white {\n    padding: 20px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n}\n.alumni-card-wrap {\n    padding: 50px 0 80px;\n}\n.alumni-card-wrap .alumni-card-slider {\n    max-width: 350px;\n    width: 90%;\n    margin: auto;\n    background: #ffffff;\n    box-shadow: 0px 5px 15px #0000000d;\n    border-radius: 10px;\n    position: relative;\n}\n.alumni-card-wrap .alumni-card-slider:before {\n    content: '';\n    position: absolute;\n    background: #d42941;\n    left: 0;\n    right: 0;\n    margin: auto;\n    height: 75px;\n    border-radius: 10px 10px 200px 200px / 10px 10px 40px 40px;\n}\n.alumni-card-wrap .alumni-card-slider .alumni-card {\n    padding: 25px 40px;\n}\n.alumni-card-wrap .alumni-card-slider .alumni-card .alumni-detail {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    border-bottom: 1px solid #0b345425;\n    padding-bottom: 15px;\n    margin-bottom: 15px;\n}\n.alumni-card-wrap .alumni-card-slider .alumni-card .alumni-logo {\n    width: 100%;\n    margin: auto;\n    text-align: center;\n}\n.alumni-card-wrap .alumni-card-slider .alumni-card .alumni-logo img {\n    max-width: 200px;\n    width: auto;\n    min-height: 40px;\n    max-height: 120px;\n}\n.alumni-img-wrap {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    width: 90px;\n    height: 90px;\n    border-radius: 50%;\n    position: relative;\n    margin-bottom: 18px;\n    -webkit-border-radius: 50%;\n    -moz-border-radius: 50%;\n    -ms-border-radius: 50%;\n    -o-border-radius: 50%;\n}\n.alumni-img-wrap .alumni-img {\n    width: 100%;\n    height: 100%;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    justify-content: center;\n    overflow: hidden;\n    border-radius: 50%;\n}\n.alumni-img-wrap .alumni-img img {\n    width: auto;\n    max-width: fit-content;\n    height: 100%;\n}\n.alumni-card-wrap .alumni-card-slider .owl-dots {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: calc(100% + 10px);\n}\n.alumni-card-wrap .alumni-card-slider .owl-dots .owl-dot span {\n    background: #ffffff;\n    border: 1px solid #00345767;\n    width: 14px;\n    height: 14px;\n    margin: 5px;\n}\n.alumni-card-wrap .alumni-card-slider .owl-dots .owl-dot.active span {\n    background: #003457;\n    border: 1px solid #003457;\n}\n\n.alumni-img-wrap label {\n    position: absolute;\n    top: 0;\n    right: 0;\n}\n.alumni-detail label {\n    background: #ffffff;\n    border: 1px solid #a8acaf;\n    opacity: 1;\n    width: 27px;\n    height: 27px;\n    border-radius: 50%;\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.alumni-detail label:hover {\n    background: #a8acaf;\n}\n.alumni-detail label .pencil-edit {\n    background-size: 13px;\n    filter: invert(61%) sepia(65%) saturate(7465%) hue-rotate(205deg) brightness(103%) contrast(101%);\n    -webkit-filter: invert(61%) sepia(65%) saturate(7465%) hue-rotate(205deg) brightness(103%) contrast(101%);\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.alumni-detail label:hover .pencil-edit {\n    background-size: 13px;\n    filter: invert(100%) sepia(100%) saturate(20%) hue-rotate(333deg) brightness(104%) contrast(107%);\n    -webkit-filter: invert(100%) sepia(100%) saturate(20%) hue-rotate(333deg) brightness(104%) contrast(107%);\n}\n.alumni-card-wrap .alumni-card-slider .alumni-card .alumni-detail h3 {\n    font-size: 24px;\n    font-weight: 600;\n}\n.alumni-card-wrap .alumni-card-slider .alumni-card .alumni-detail h4 {\n    font-size: 16px;\n}\n\n.template-block {\n    background: #f8f8f8;\n    border: 1px solid #d5d5d5;\n    border-radius: 6px;\n    opacity: 1;\n    padding: 10px;\n    position: relative;\n    overflow: hidden;\n    -webkit-border-radius: 6px;\n    -moz-border-radius: 6px;\n    -ms-border-radius: 6px;\n    -o-border-radius: 6px;\n    height: 100%;\n}\n.template-block-image {\n    position: relative;\n    overflow: hidden;\n    border-radius: 6px;\n}\n.template-block-name {\n    font-size: 16px;\n    font-weight: 500;\n    text-align: center;\n    line-height: 18px;\n    padding: 20px 20px 10px;\n}\n.overview-block {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    margin: auto;\n    background: rgba(0, 0, 0, 0.8);\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    overflow: hidden;\n}\n.template-block:hover .overview-block {\n    top: 0;\n}\n.overview-block .btn-choose {\n    background: #5cae48;\n    border-radius: 27px;\n    width: 170px;\n    height: 40px;\n    color: #fff;\n    text-decoration: none;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0 0 10px -200%;\n    font-weight: 500;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.dropdown-container {\n    position: relative;\n    width: 100%;\n    max-width: 400px;\n    margin: 0 auto;\n  }\n  \n  .suggestions-dropdown {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    width: 100%;\n    background-color: #ffffff;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    z-index: 1000;\n    max-height: 200px;\n    overflow-y: auto;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n  }\n  \n  .suggestion-item {\n    padding: 10px;\n    cursor: pointer;\n    transition: background-color 0.2s;\n  }\n  \n  .suggestion-item:hover {\n    background-color: #f0f0f0;\n  }\n  \n  .loading {\n    margin-top: 5px;\n    color: #fff;\n    font-size: 14px;\n  }\n  .dropdown-container {\n    position: relative;\n    width: 100%;\n    max-width: 400px;\n    margin: 20px auto;\n}\n\n.suggestions-dropdown {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    width: 100%;\n    background-color: #ffffff;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    z-index: 1000;\n    max-height: 200px;\n    overflow-y: auto;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n}\n\n.suggestion-item {\n    padding: 10px;\n    cursor: pointer;\n    transition: background-color 0.2s;\n}\n\n.suggestion-item:hover {\n    background-color: #f0f0f0; /* Optional: Add hover effect */\n}\n\n.loading {\n    margin-top: 5px;\n    color: #999;\n    font-size: 14px;\n}\n.overview-block .btn-choose:hover {\n    background: #3e892b;\n}\n.template-block .overview-block:hover .btn-choose {\n    margin-left: 0;\n}\n.overview-block .btn-preview {\n    background: #fff;\n    border-radius: 27px;\n    width: 170px;\n    height: 40px;\n    color: #000;\n    text-decoration: none;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0 -200% 0 0;\n    font-weight: 500;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.overview-block .btn-preview:hover {\n    background: #5cae48;\n    color: #fff;\n}\n.template-block .overview-block:hover .btn-preview {\n    margin-right: 0;\n}\n\n.gray-gradient {\n    background: transparent linear-gradient(180deg, #ffffff 0%, #f5f5f5 100%);\n}\n.border-d2d2d2 {\n    border: 1px solid #d2d2d2;\n}\n.alumni-card-wrap .alumni-card-slider i.curve {\n    content: '';\n    position: absolute;\n    background: #d42941;\n    left: 0;\n    right: 0;\n    margin: auto;\n    height: 75px;\n    border-radius: 10px 10px 200px 200px / 10px 10px 40px 40px;\n    top:0\n}\n.alumni_profile_name_other_detail .btn-send .icon-web {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/web.svg) no-repeat 0 0 / 100%;\n    width: 19px;\n    height: 19px;\n    margin-right: 8px;\n    position: relative;\n    left: 0;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.alumni_profile_brife_links {\n    width: 100%;\n    padding-left: 129px;\n    margin-top: 20px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n}\n.alumni_profile_brife_links a {\n    height: 40px;\n    padding: 0 20px;\n    border-radius: 25px;\n    display: inline-flex;\n    align-items: center;\n    margin-right: 6px;\n    text-decoration: none;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n\n.alumni_profile_brife_links a i {\n    margin-right: 5px;\n}\n.alumni_profile_brife_links a.btn-send {\n    background: #5cae48;\n    color: #fff;\n}\n.alumni_profile_brife_links a.btn-send:hover {\n    background: #2fa612;\n}\n.alumni_profile_brife_links a.btn-send i.icon-send {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/send_alumni_profile.svg) no-repeat 0\n        0 / 100%;\n    width: 19px;\n    height: 19px;\n    margin-right: 10px;\n    position: relative;\n    transition: all 0.3s ease-in-out;\n    left: 0;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.alumni_profile_brife_links a.btn-send i.icon-web {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/web.svg) no-repeat 0 0 / 100%;\n    width: 19px;\n    height: 19px;\n    margin-right: 10px;\n    position: relative;\n    transition: all 0.3s ease-in-out;\n    left: 0;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.alumni_profile_brife_links .btn-send:hover .icon-send {\n    left: 3px;\n}\n\n.alumni_profile_brife_links a.btn-push-web {\n    background: #27a7df;\n    color: #fff;\n}\n.alumni_profile_brife_links a.btn-push-web:hover {\n    background: #078dc8;\n}\n.alumni_profile_brife_links a.btn-push-web i.icon-globe {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/web.svg) no-repeat 0 0 / 100%;\n    width: 19px;\n    height: 19px;\n    margin-right: 10px;\n    position: relative;\n    transition: all 0.3s ease-in-out;\n    left: 0;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.alumni_profile_brife_links .btn-push-web:hover .icon-globe {\n    left: 3px;\n}\n\n.alumni_profile_brife_links a.btn-mark {\n    background: #fff;\n    border: 2px solid #0b3454;\n    color: #0b3454;\n}\n.alumni_profile_brife_links a.btn-mark:hover {\n    background: #0b3454;\n    color: #fff;\n}\n\n.listed-points {\n    padding: 0;\n    margin: 4px 0 0;\n    list-style: none;\n}\n.listed-points li {\n    margin-bottom: 0;\n    padding-left: 12px;\n    line-height: 20px;\n    font-weight: 500;\n}\n.listed-points li:before {\n    width: 5px;\n    height: 5px;\n    background: #000;\n    top: 8px;\n}\n\n.top-48 {\n    top: 48px;\n}\n.z-1 {\n    z-index: 1;\n}\n.z-0 {\n    z-index: 0;\n}\n\n.more_action {\n    padding: 0;\n    margin: 0;\n    list-style: none;\n    width: 150px;\n}\n.more_action a {\n    padding: 0;\n    color: #000;\n    margin: 0;\n    height: auto;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    text-decoration: none;\n}\n.more_action a:hover {\n    color: #5cae48;\n}\n.more_action li:not(:last-child) {\n    margin-bottom: 5px;\n}\n\n.btn-moreaction {\n    background: #ffffff;\n    border: 2px solid #7d7d7d;\n    color: #000;\n    height: 40px;\n    padding: 0 20px;\n    padding-right: 20px;\n    padding-left: 20px;\n    border-radius: 25px;\n    display: inline-flex;\n    align-items: center;\n    margin-right: 6px;\n    text-decoration: none;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.btn-moreaction:hover {\n    background: #7d7d7d;\n    color: #fff;\n}\n.alumni_profile_brife_links a[aria-expanded='true'] {\n    background-color: #7d7d7d;\n    color: #fff;\n}\n.btn-moreaction .dot {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    position: relative;\n    margin-left: 7px;\n}\n.btn-moreaction .dot:before,\n.btn-moreaction .dot:after,\n.btn-moreaction i {\n    content: '';\n    width: 3px;\n    height: 3px;\n    background: #333;\n    border-radius: 50%;\n    margin: 1px 0;\n}\n.btn-moreaction:hover .dot:before,\n.btn-moreaction:hover .dot:after,\n.btn-moreaction:hover i {\n    background: #fff;\n}\n.alumni_profile_brife_links a[aria-expanded='true'] .dot::before,\n.alumni_profile_brife_links a[aria-expanded='true'] .dot::after,\n.alumni_profile_brife_links a[aria-expanded='true'] i {\n    background: #fff;\n}\n\n.graduateRow .offer .got_offer i.icon-like.dislike {\n    -moz-transform: scale(-1) translateY(-5px);\n    -webkit-transform: scale(-1) translateY(-5px);\n    -o-transform: scale(-1) translateY(-5px);\n    -ms-transform: scale(-1) translateY(-5px);\n    transform: scale(-1) translateY(-5px);\n    display: inline-block;\n    color: #e10000;\n    vertical-align: top;\n}\n.workExperienceRow .offer {\n    border-left: 1px solid #d1d1d1;\n    min-height: 63px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    margin-left: 30px;\n    padding-left: 25px;\n}\n.workExperienceRow .offer i {\n    margin-right: 10px;\n}\n.workExperienceRow .offer i.icon-like {\n    color: #5cae48;\n}\n.workExperienceRow .offer i.icon-like.dislike {\n    -moz-transform: scale(-1) translateY(-8px);\n    -webkit-transform: scale(-1) translateY(-8px);\n    -o-transform: scale(-1) translateY(-8px);\n    -ms-transform: scale(-1) translateY(-8px);\n    transform: scale(-1) translateY(-8px);\n    display: inline-block;\n    vertical-align: top;\n    color: #919191;\n}\n\n.no-after:after,\n.no-before:before {\n    content: none;\n    display: none;\n}\n\n.card_profiles.auto_height {\n    max-height: inherit;\n    min-height: 0;\n}\n\n@media (max-width: 991px) {\n    .alumni_profile_name_college_other_detail_wrap.directory-detail .alumni_profile_image_name_other_detail {\n        padding: 0;\n        margin: 0;\n        order: 1;\n    }\n    .alumni_profile_name_college_other_detail_wrap.directory-detail .alumni_profile_image_name_other_detail:after {\n        opacity: 0;\n    }\n    .alumni_profile_name_college_other_detail_wrap.directory-detail .alumni_profile_college_name_other_detail_wrap {\n        padding: 0;\n        order: 3;\n    }\n    .alumni_profile_name_college_other_detail_wrap.directory-detail .alumni_profile_brife_links {\n        order: 2;\n        border-bottom: 1px solid #dbdbdbcc;\n        margin-bottom: 30px;\n        padding-bottom: 30px;\n        flex-wrap: wrap;\n    }\n    .alumni_profile_brife_links > a {\n        margin-bottom: 10px;\n    }\n}\n\n@media (max-width: 575px) {\n    .alumni_profile_name_college_other_detail_wrap.directory-detail .alumni_profile_brife_links {\n        padding-left: 0;\n    }\n    .workExperienceRow .offer {\n        border-left: 0px solid #d1d1d1;\n        min-height: 0;\n        margin-left: 50px;\n        padding-left: 25px;\n    }\n}\n\n.campus-activities-blue-section {\n    background: #f2f9ff;\n    border-radius: 6px;\n    padding: 25px 35px;\n}\n.campus-activities-detail {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n}\n.campus-activities-label {\n    margin-right: 10px;\n}\n.campus-activities-block {\n    background: #ffffff;\n    border: 1px solid #7cb0d8;\n    border-radius: 15px;\n    height: 30px;\n    padding: 0 20px;\n    font-weight: 500;\n    line-height: 28px;\n}\n\n.campus-activities-card {\n    background: #ffffff;\n    border: 1px solid #d5d5d5;\n    border-radius: 6px;\n    opacity: 1;\n    padding: 18px;\n    height: 100%;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n}\n.tag-wrap {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: auto;\n}\n.tag {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='%2326A7DF' stroke='none' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 1a1 1 0 0 0-1 1v4.586a1 1 0 0 0 .293.707l7 7a1 1 0 0 0 1.414 0l4.586-4.586a1 1 0 0 0 0-1.414l-7-7A1 1 0 0 0 6.586 1zm4 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0'/%3e%3c/svg%3e\");\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: 17px;\n    width: 17px;\n    height: 17px;\n    display: block;\n    margin-right: 5px;\n}\n.tag-wrap span {\n    color: #414141;\n}\n\n.activities-card-title {\n    font-size: 18px;\n    font-weight: 500;\n    border-bottom: 1px solid #e9e9e9;\n    padding-bottom: 7px;\n}\n\n.campus-activities-edit {\n    background: #f2f4f7;\n    padding: 30px;\n    border-radius: 6px;\n    margin-top: 34px;\n    height: calc(100% - 80px);\n}\n.campus-activities-edit .title {\n    text-align: center;\n    font-weight: 500;\n    margin-bottom: 20px;\n    font-size: 24px;\n}\n.campus-activities-edit .campus-activities-card {\n    height: auto;\n}\n\n.campus-activities-edit label {\n    margin-left: 5px;\n    background: #ffffff;\n    border: 1px solid #a8acaf;\n    opacity: 1;\n    width: 27px;\n    height: 27px;\n    border-radius: 50%;\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.campus-activities-edit label:hover {\n    background: #a8acaf;\n}\n.campus-activities-edit label .pencil-edit {\n    background-size: 13px;\n    filter: invert(61%) sepia(65%) saturate(7465%) hue-rotate(205deg) brightness(103%) contrast(101%);\n    -webkit-filter: invert(61%) sepia(65%) saturate(7465%) hue-rotate(205deg) brightness(103%) contrast(101%);\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.campus-activities-edit label:hover .pencil-edit {\n    background-size: 13px;\n    filter: invert(100%) sepia(100%) saturate(20%) hue-rotate(333deg) brightness(104%) contrast(107%);\n    -webkit-filter: invert(100%) sepia(100%) saturate(20%) hue-rotate(333deg) brightness(104%) contrast(107%);\n}\n.campus-activities-card-img {\n    position: relative;\n}\n.campus-activities-card-img label {\n    position: absolute;\n    right: 5px;\n    top: 5px;\n}\n\n.school_detail_left_pane {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n}\n.school_profile_img {\n    width: 80px;\n    height: 80px;\n    border-radius: 50%;\n    background: #f1f1f1;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: end;\n    margin-right: 15px;\n}\n.school_profile_img img {\n    width: auto;\n    height: 100%;\n}\n.school_profile_img.nopic img {\n    height: 80%;\n}\n\n.school_profile_name_other_detail {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    flex-direction: column;\n    width: calc(100% - 95px);\n    justify-content: center;\n}\n.school_profile_college {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    align-items: center;\n}\n.school_profile_college_logo {\n    width: 43px;\n    height: 43px;\n    padding: 5px;\n    border: 1px solid #d2d2d2;\n    border-radius: 50%;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n    margin-right: 5px;\n}\n.school_profile_college_logo img {\n    width: 100%;\n}\n.school_profile_college_name {\n    width: calc(100% - 48px);\n    line-height: 16px;\n    font-size: 14px;\n    font-weight: 500;\n}\n.school_profile_name_other_detail h5 {\n    font-size: 16px;\n    margin: 0 0 5px;\n}\n\n.student_profile_status {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n.student_profile_status li {\n    margin-bottom: 16px;\n    position: relative;\n    padding-left: 16px;\n}\n.student_profile_status li .title {\n    letter-spacing: 0.32px;\n    color: #000000;\n    font-size: 16px;\n    line-height: 20px;\n    display: inline-block;\n}\n.student_profile_status li p {\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 20px;\n    letter-spacing: 0.32px;\n}\n.student_profile_status li:before {\n    content: '';\n    width: 3px;\n    height: 17px;\n    position: absolute;\n    left: 0;\n    top: 4px;\n    background: #0b3454;\n    border-radius: 5px;\n}\n\n.student_profile_status li .listed-points {\n    padding: 0;\n    margin: 4px 0 0;\n    list-style: none;\n}\n.student_profile_status li .listed-points li {\n    margin-bottom: 0;\n    padding-left: 12px;\n    line-height: 20px;\n    font-weight: 500;\n}\n.student_profile_status li .listed-points li:before {\n    width: 5px;\n    height: 5px;\n    background: #000;\n    top: 8px;\n}\n.successful_journey * {\n    position: relative;\n}\n.successful_journey {\n    position: relative;\n}\n.successful_journey::before {\n    content: '';\n    background: transparent linear-gradient(180deg, #0b3454 0%, #ffffff 100%) 0% 0% no-repeat padding-box;\n    border-radius: 4px 4px 0px 0px;\n    opacity: 1;\n    height: 320px;\n    width: 100%;\n    position: absolute;\n    left: 0;\n    top: 0;\n    z-index: 0;\n}\n.successful_journey h3 {\n    margin: 30px 0 25px;\n    text-align: center;\n    font-size: 16px;\n    position: relative;\n}\n.successful_journey h3::before {\n    content: '';\n    position: absolute;\n    width: 50px;\n    height: 2px;\n    background-color: #f1ac18;\n    left: 0;\n    right: 0;\n    margin: auto;\n    top: calc(100% + 7px);\n}\n.successful_journey h4 {\n    color: #fff;\n    margin: 20px 0 5px;\n}\n.successful_journey p {\n    color: #fff;\n    margin: 0px 0 5px;\n    font-size: 16px;\n}\n\n@media (max-width: 991px) {\n    .campus-activities-edit {\n        height: auto;\n        margin: 0;\n    }\n    .campus-activities-edit .campus-activities-card {\n        max-width: 305px;\n        margin: auto;\n    }\n}\n@media (max-width: 575px) {\n    .campus-activities-blue-section {\n        padding: 20px 22px;\n    }\n}\n\n.share-social-media {\n    background: #fffae5;\n    border: 1px dashed #e3dec8;\n    border-radius: 6px;\n    opacity: 1;\n    margin-bottom: 20px;\n}\n.api-link {\n    padding: 20px;\n    border-bottom: 1px dashed #e3dec8;\n}\n.share-platform {\n    padding: 20px;\n}\n.api-link-title {\n    padding: 8px 10px 8px 20px;\n    background: white;\n    border-radius: 6px 0 0 6px;\n    position: relative;\n    margin-right: 15px;\n}\n.api-link-title:before {\n    content: '';\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 100%;\n    border-top: 20px solid transparent;\n    border-bottom: 20px solid transparent;\n    border-left: 10px solid white;\n    width: 0;\n    height: 0;\n    margin: auto;\n}\n.link-url span {\n    width: calc(100% - 29px);\n    display: inline-block;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n.link-url {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    width: 100%;\n    justify-content: start;\n    max-width: 368px;\n}\n.link-url i {\n    width: 21px;\n    height: 21px;\n    position: relative;\n    display: inline-block;\n    cursor: pointer;\n    margin-left: 8px;\n}\n.link-url i:before {\n    width: 13px;\n    height: 17px;\n    border-radius: 4px 0 0 0;\n    border-top: 2px solid #0b3454;\n    content: '';\n    position: absolute;\n    background: #fffae5;\n    border-left: 2px solid #0b3454;\n}\n.link-url i:after {\n    width: 16px;\n    height: 21px;\n    border-radius: 4px;\n    border: 2px solid #0b3454;\n    content: '';\n    position: absolute;\n    background: #fffae5;\n    top: 4px;\n    left: 4px;\n}\n.share-platform button {\n    border: 0;\n    background: transparent;\n    width: 150px;\n    height: 48px;\n    border-radius: 6px;\n    font-size: 18px;\n    font-weight: 500;\n    color: #fff;\n    display: flex;\n    align-items: center;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.share-platform button i img {\n    vertical-align: top;\n}\n.share-platform button.btn-facebook {\n    background-color: #3456a2;\n    padding: 0 0 0 10px;\n}\n.share-platform button.btn-facebook:hover {\n    background-color: #173371;\n}\n.share-platform button.btn-twitter {\n    background-color: #01a1f9;\n    padding: 0 0 0 6px;\n}\n.share-platform button.btn-twitter:hover {\n    background-color: #1ca7f3;\n}\n.share-platform button.btn-linkedin {\n    background-color: #0077b5;\n    padding: 0 0 0 14px;\n}\n.share-platform button.btn-linkedin:hover {\n    background-color: #004fb5;\n}\n.share-platform button.btn-linkedin i {\n    filter: brightness(0) invert(1);\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    margin-right: 8px;\n}\n\n.alumni-directory .btn-refresh {\n    border-radius: 25px;\n    padding: 0 25px;\n    background: #d82a2a;\n    border: 2px solid #ffffff;\n    height: 40px;\n    color: #fff;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.alumni-directory .btn-refresh i {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/refresh-page-option.svg) no-repeat\n        center / 16px;\n    width: 16px;\n    height: 16px;\n    margin-right: 8px;\n    filter: brightness(0) invert(1);\n    -webkit-filter: brightness(0) invert(1);\n}\n.alumni-directory .btn-refresh:hover {\n    background: #fff;\n    color: #d82a2a;\n}\n.alumni-directory .btn-refresh:hover i {\n    filter: invert(31%) sepia(19%) saturate(7466%) hue-rotate(343deg) brightness(87%) contrast(95%);\n    -webkit-filter: invert(31%) sepia(19%) saturate(7466%) hue-rotate(343deg) brightness(87%) contrast(95%);\n}\n.icon-down-arrow.left-arrow {\n    transform: rotate(90deg);\n    -webkit-transform: rotate(90deg);\n    -moz-transform: rotate(90deg);\n    -ms-transform: rotate(90deg);\n    -o-transform: rotate(90deg);\n}\n.icon-down-arrow.right-arrow {\n    transform: rotate(-90deg);\n    -webkit-transform: rotate(-90deg);\n    -moz-transform: rotate(-90deg);\n    -ms-transform: rotate(-90deg);\n    -o-transform: rotate(-90deg);\n}\n\n.academic_detail {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    align-items: center;\n}\n.academic_detail .academic_logo {\n    border: 1px solid #d2d2d2;\n    width: 60px;\n    height: 60px;\n    border-radius: 50%;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n    margin-right: 10px;\n}\n.academic_detail .academic_name {\n    font-size: 18px;\n    font-weight: 500;\n    line-height: 22px;\n    width: calc(100% - 70px);\n}\n\n.border-0B3454 {\n    border: 1px solid #0b3454;\n}\n\n.mail_alumni_wrap {\n    background: transparent linear-gradient(179deg, #0b3454 0%, #c4c4c8 100%) 0% 0% no-repeat padding-box;\n    box-shadow: 0px 3px 4px #0000000d;\n    border-radius: 4px 4px 0px 0px;\n    opacity: 1;\n    color: #fff;\n    margin-top: 20px;\n}\n.mail_alumni {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n}\n.mail_alumni .mail_alumni_profile_img {\n    width: 110px;\n    height: 110px;\n    border-radius: 50%;\n    border: 2px solid #fff;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-right: 20px;\n    -webkit-border-radius: 50%;\n    -moz-border-radius: 50%;\n    -ms-border-radius: 50%;\n    -o-border-radius: 50%;\n}\n.mail_alumni .mail_alumni_profile_img img {\n    width: 100%;\n}\n.mail_alumni .mail_alumni_profile_detail h2 {\n    font-size: 28px;\n    margin: 0;\n}\n.mail_alumni .mail_alumni_profile_detail p {\n    display: flex;\n    align-items: center;\n    margin-bottom: 5px;\n}\n.mail_alumni .mail_alumni_profile_detail .icon-location-pin {\n    margin-right: 3px;\n}\n.mail_alumni .mail_alumni_profile_detail ul {\n    padding: 0 0 0 10px;\n    list-style: none;\n    line-height: 18px;\n    position: relative;\n    margin: 0;\n}\n.mail_alumni .mail_alumni_profile_detail ul:before {\n    content: '';\n    position: absolute;\n    width: 3px;\n    height: 100%;\n    background: #fff;\n    border-radius: 5px;\n    top: 0;\n    left: 0;\n}\n.compose_message p:last-child {\n    margin: 0;\n}\n\n.alumni_univarsity_share {\n    padding: 15px 20px;\n}\n.view_link {\n    padding: 0 0 15px;\n    text-align: center;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    border-bottom: 1px solid #d2d2d2;\n    margin-bottom: 15px;\n}\n.alumni_univarsity_share .icon-mail {\n    font-size: 0;\n    width: 18px;\n    height: 16px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/email_icon.svg) no-repeat center /\n        100%;\n}\n.alumni_univarsity_share .icon-whatsapp {\n    font-size: 0;\n    width: 25px;\n    height: 25px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/whatsapp.svg) no-repeat 0 0 / 100%;\n}\n.alumni_univarsity_share .icon-link {\n    font-size: 0;\n    width: 20px;\n    height: 16px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/link.svg) no-repeat center / 100%;\n}\n.alumni_univarsity_share .icon-download {\n    font-size: 0;\n    width: 16px;\n    height: 17px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/download_2.svg) no-repeat center /\n        100%;\n}\n.alumni_univarsity_share a {\n    margin: 0 15px;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    position: relative;\n}\n.alumni_univarsity_share a:hover {\n    transform: translateY(-3px);\n    -webkit-transform: translateY(-3px);\n    -moz-transform: translateY(-3px);\n    -ms-transform: translateY(-3px);\n    -o-transform: translateY(-3px);\n}\n\n@media (max-width: 575px) {\n    .mail_alumni .mail_alumni_profile_img {\n        width: 70px;\n        height: 70px;\n    }\n    .mail_alumni_profile_detail {\n        width: calc(100% - 90px);\n    }\n    .mail_alumni .mail_alumni_profile_detail h2 {\n        font-size: 26px;\n        margin: 0 0 4px;\n        line-height: 26px;\n    }\n}\n\n.collateral-documents-wrap {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    margin-left: -10px;\n    margin-right: -10px;\n}\n.documents-block {\n    margin: 0 10px 20px;\n    border: 1px solid #d5d5d5;\n    border-radius: 6px;\n    width: calc(20% - 20px);\n    padding: 10px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n}\n.documents-block-image img {\n    width: 100%;\n}\n.documents-block .alumni_univarsity_share {\n    padding: 0;\n}\n\n.collateral-video-block {\n    border: 1px solid #d5d5d5;\n    border-radius: 6px;\n    padding: 10px;\n    height: 100%;\n}\n.video-block-image .video-btn {\n    display: inline-block;\n    width: 100%;\n    position: relative;\n    overflow: hidden;\n    border-radius: 6px;\n    vertical-align: top;\n}\n.video-block-image .video-btn .img-fluid {\n    width: 100%;\n}\n.video-block-image .video-btn i {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    margin: auto;\n    color: #fff;\n    font-size: 35px;\n    width: 35px;\n    height: 35px;\n}\n.video-block-image .video-btn .time-line {\n    position: absolute;\n    right: 10px;\n    bottom: 10px;\n    background: #000000 0% 0% no-repeat padding-box;\n    border-radius: 4px;\n    color: #fff;\n    font-size: 12px;\n    padding: 0px 10px;\n    height: 24px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n}\n.collateral-video-block .alumni_univarsity_share {\n    padding: 0;\n}\n\n.pt-38 {\n    padding-top: 38px;\n}\n.speaker-img-wrap {\n    position: absolute;\n    width: 60px;\n    height: 60px;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    margin: auto;\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.speaker-img {\n    position: absolute;\n    width: 60px;\n    height: 60px;\n    border: 3px solid #fff;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    margin: auto;\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    overflow: hidden;\n}\n.speaker-img img {\n    width: auto;\n    height: 100%;\n}\n.speaker-img-wrap label {\n    position: absolute;\n    top: -5px;\n    right: -5px;\n}\n.album_contblk h3 {\n    min-height: 49px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n}\n.album_blk label.img-edit {\n    position: absolute;\n    top: 15px;\n    right: 15px;\n}\n\n.btn-preview {\n    background: #ffffff;\n    border: 2px solid #7d7d7d;\n    border-radius: 27px;\n    height: 45px;\n    color: #7d7d7d;\n    font-weight: 500;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.btn-preview:hover {\n    background-color: #7d7d7d;\n    color: #fff;\n}\n\n.text-blue-0C4CBB {\n    color: #0c4cbb;\n}\n.text-blue-0C4CBB:hover {\n    color: #5cae48;\n}\n\n.upload_section input {\n    position: absolute;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    margin: auto;\n    width: 100%;\n    opacity: 0;\n    z-index: 1;\n    background: red;\n    cursor: pointer;\n}\n\n.alumni-img-wrap label {\n    position: absolute;\n    top: 0;\n    right: 0;\n}\n.album_blk label {\n    background: #ffffff;\n    border: 1px solid #a8acaf;\n    opacity: 1;\n    width: 27px;\n    height: 27px;\n    border-radius: 50%;\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.album_blk label:hover {\n    background: #a8acaf;\n}\n.album_blk label .pencil-edit {\n    background-size: 13px;\n    filter: invert(61%) sepia(65%) saturate(7465%) hue-rotate(205deg) brightness(103%) contrast(101%);\n    -webkit-filter: invert(61%) sepia(65%) saturate(7465%) hue-rotate(205deg) brightness(103%) contrast(101%);\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.album_blk label:hover .pencil-edit {\n    background-size: 13px;\n    filter: invert(100%) sepia(100%) saturate(20%) hue-rotate(333deg) brightness(104%) contrast(107%);\n    -webkit-filter: invert(100%) sepia(100%) saturate(20%) hue-rotate(333deg) brightness(104%) contrast(107%);\n}\n\n.line-height-21 {\n    line-height: 21px;\n}\n\n.promote-alumni-wrap {\n    background: #f2f4f7;\n    padding: 60px 0;\n    margin-bottom: 44px;\n}\n.promote-share-it ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    max-width: 234px;\n}\n.promote-share-it ul li:not(:last-child) {\n    margin-bottom: 10px;\n}\n.promote-share-it ul a {\n    background: #ffffff;\n    border: 1px solid #b6c8d8;\n    border-radius: 20px;\n    width: 100%;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    height: 40px;\n    align-items: center;\n    text-decoration: none;\n    color: #0b3454;\n    font-size: 16px;\n    font-weight: 500;\n    padding: 0 19px 0 25px;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.promote-share-it ul a:hover {\n    background: #b6c8d8;\n}\n\n.promote-share-it ul a i {\n    width: 20px;\n    height: 20px;\n    margin-right: 12px;\n}\n.promote-share-it ul a i.mail {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/email.svg) no-repeat center / 100%;\n    filter: invert(14%) sepia(69%) saturate(1363%) hue-rotate(182deg) brightness(90%) contrast(95%);\n    -webkit-filter: invert(14%) sepia(69%) saturate(1363%) hue-rotate(182deg) brightness(90%) contrast(95%);\n}\n.promote-share-it ul a i.whatsapp {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/whatsapp.svg) no-repeat center / 100%;\n}\n.promote-share-it ul a i.link {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/link.svg) no-repeat center / 100%;\n}\n.promote-share-it ul a i.calender {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/blue-calender.svg) no-repeat center /\n        100%;\n}\n.promote-share-it ul a span {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n}\n\n.promote-share-it ul a b.icon-double-arrow {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/double-right-arrows.svg) no-repeat\n        center / 100%;\n    width: 11px;\n    height: 11px;\n}\n.promote-share-it ul a b.icon-copy {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/green-copy.svg) no-repeat center /\n        100%;\n    width: 15px;\n    height: 15px;\n}\n.promote-share-it ul a b.icon-add {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/add-green.svg) no-repeat center /\n        100%;\n    width: 13px;\n    height: 13px;\n}\n\n.promote-share-it ul a:hover b {\n    filter: invert(0%) brightness(0%);\n    -webkit-filter: invert(0%) brightness(0%);\n}\n\n.connect-block {\n    background: #ffffff 0% 0% no-repeat padding-box;\n    border: 1px solid #d9d9d9;\n    border-radius: 6px;\n    height: 100%;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n}\n.connect-block-top {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    padding: 15px;\n    border-bottom: 1px solid #d9d9d9;\n    align-items: center;\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n}\n.connect-block-top .icon {\n    margin-right: 12px;\n}\n.connect-block-top .icon.calender {\n    width: 31px;\n    height: 30px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/google-calender.svg) no-repeat center /\n        100%;\n}\n.connect-block-top .icon.office {\n    width: 26px;\n    height: 32px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/office.svg) no-repeat center / 100%;\n}\n.connect-block-top .icon.outlook {\n    width: 33px;\n    height: 31px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/outlook.svg) no-repeat center / 100%;\n}\n.connect-block-top .icon.icloud {\n    width: 36px;\n    height: 24px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/icloud-black.svg) no-repeat center /\n        100%;\n}\n.connect-block-bottom {\n    padding: 15px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    justify-content: center;\n}\n.existing-calender h6 {\n    font-size: 16px;\n    margin: 0 0 3px;\n}\n.existing-calender span {\n    font-size: 12px;\n    line-height: 14px;\n}\n.existing-calender {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n}\n.connect-block-bottom a {\n    max-width: 120px;\n    text-decoration: none;\n}\n\n@media (max-width: 1099px) {\n    .documents-block {\n        width: calc(25% - 20px);\n    }\n    .alumni_univarsity_share a {\n        margin: 0 10px;\n    }\n}\n@media (min-width: 767px) {\n    .pt-md-38 {\n        padding-top: 38px;\n    }\n}\n@media (max-width: 767px) {\n    .documents-block {\n        width: calc(33.33% - 20px);\n    }\n}\n\n@media (max-width: 575px) {\n    .collateral-documents-wrap {\n        margin-left: -5px;\n        margin-right: -5px;\n    }\n    .documents-block {\n        width: calc(50% - 10px);\n        margin: 0 5px 10px;\n    }\n    .polartabsec + div.p-0 {\n        padding-bottom: 0px !important;\n    }\n    .alumni_univarsity_share a {\n        margin: 0 7px;\n    }\n}\n.student-pref .edit_section + .custom_row {\n    border-top: none;\n}\n\n.quill.editor {\n    min-height: 330px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n}\n.quill.editor .ql-toolbar.ql-snow {\n    border-radius: 6px 6px 0 0;\n}\n.quill.editor .ql-container.ql-snow {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    font-size: 16px;\n}\n.quill.editor .ql-container.ql-snow p {\n    margin-bottom: 15px;\n}\n\n.btn-clearBtn {\n    background: #cd0000;\n    height: 40px;\n    padding: 0 25px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: #fff;\n    text-decoration: none;\n    font-size: 16px;\n    line-height: 16px;\n    font-weight: 500;\n    position: relative;\n    overflow: hidden;\n    border: 0;\n    border-radius: 27px;\n    -webkit-border-radius: 27px;\n    -moz-border-radius: 27px;\n    -ms-border-radius: 27px;\n    -o-border-radius: 27px;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.btn-clearBtn:hover {\n    background: #a30000;\n    color: #fff;\n}\n.btn-clearBtn i {\n    padding: 0;\n    width: 18px;\n    height: 18px;\n    filter: invert(1);\n    -webkit-filter: invert(1);\n    margin-right: 5px;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    background: transparent\n        url('data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000%27%3e%3cpath d=%27M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z%27/%3e%3c/svg%3e')\n        0 0 / 18px auto no-repeat;\n}\n\n/* css30042024  */\n\n.circle-right {\n    position: relative;\n    width: 48px;\n    height: 48px;\n    margin: auto;\n    background: #5cae48;\n    border-radius: 50%;\n}\n.circle-right:before {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    width: 20px;\n    height: 12px;\n    border-left: 5px solid #fff;\n    border-bottom: 5px solid #fff;\n    transform: rotate(-45deg);\n}\n\n.college_blk {\n    background: #ffffff;\n    border: 1px solid #d2d2d2;\n    border-radius: 6px;\n    opacity: 1;\n    overflow: hidden;\n}\n.college_blk .collegeName {\n    padding: 18px 20px;\n    position: relative;\n}\n.college_blk .collegeName h3 {\n    font-size: 18px;\n    font-weight: 600;\n    line-height: 23px;\n    margin-bottom: 8px;\n}\n.college_blk .collegeName i {\n    color: #26a7df;\n    font-size: 16px;\n}\n.college_detail_price i.icon-book {\n    color: #f05a2a;\n}\n.college_blk .collegeName .tick {\n    font-style: italic;\n    color: #0b3454;\n}\n.college_blk .college_detail {\n    background: #0b3454;\n    padding: 20px;\n    color: #fff;\n}\n.college_blk:not(:last-child) {\n    margin-bottom: 23px;\n}\n.college_detail_price_deadline {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n}\n.college_detail_price_deadline > div {\n    width: 50%;\n    margin-bottom: 20px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n}\n.college_detail_price_deadline > div .icon {\n    width: 40px;\n    height: 40px;\n    background: #fff;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #db852b;\n    box-shadow: 0px 3px 6px #00000029;\n}\n/* .college_detail_price_deadline > div .icon .icon-dollor { width: 16px; height: 23px; background: url(../images/mask-group-133.svg) no-repeat 0 0; filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%); -webkit-filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%); } */\n\n.college_detail_price_deadline > div .icon .icon-dollor {\n    width: 11px;\n    height: 20px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/dolar.svg) no-repeat 0 0;\n    filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);\n    -webkit-filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);\n}\n.college_detail_price_deadline > div .icon .icon-canadian-dollar {\n    width: 18px;\n    height: 18px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/canadian-dollar.svg) no-repeat 0 0;\n    filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);\n    -webkit-filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);\n}\n.college_detail_price_deadline > div .icon .icon-yen-symbol {\n    width: 12px;\n    height: 16px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/yen-symbol.svg) no-repeat 0 0;\n    filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);\n    -webkit-filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);\n}\n.college_detail_price_deadline > div .icon .icon-australian-dollar {\n    width: 17px;\n    height: 15px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/australian-dollar.svg) no-repeat 0 0;\n    filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);\n    -webkit-filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);\n}\n.college_detail_price_deadline > div .icon .icon-euro {\n    width: 12px;\n    height: 15px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/euro.svg) no-repeat 0 0;\n    filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);\n    -webkit-filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);\n}\n.college_detail_price_deadline > div .icon .icon-franc {\n    width: 11px;\n    height: 13px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/franc.svg) no-repeat 0 0;\n    filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);\n    -webkit-filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);\n}\n.college_detail_price_deadline > div .icon .icon-great-britain-pound {\n    width: 10px;\n    height: 14px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/great-britain-pound.svg) no-repeat 0\n        0;\n    filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);\n    -webkit-filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);\n}\n.college_detail_price_deadline > div .icon .icon-hong-kong-dollar {\n    width: 20px;\n    height: 12px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/hong-kong-dollar.svg) no-repeat 0 0;\n    filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);\n    -webkit-filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);\n}\n.college_detail_price_deadline > div .icon .icon-malaysian-ringgit {\n    width: 15px;\n    height: 12px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/malaysian-ringgit.svg) no-repeat 0 0;\n    filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);\n    -webkit-filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);\n}\n.college_detail_price_deadline > div .icon .icon-new-zealand-dollar {\n    width: 21px;\n    height: 11px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/new-zealand-dollar.svg) no-repeat 0 0;\n    filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);\n    -webkit-filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);\n}\n.college_detail_price_deadline > div .icon .icon-rupee-indian {\n    width: 11px;\n    height: 17px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/rupee-indian.svg) no-repeat 0 0;\n    filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);\n    -webkit-filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);\n}\n.college_detail_price_deadline > div .icon .icon-singapore-dollar {\n    width: 18px;\n    height: 18px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/singapore-dollar.svg) no-repeat 0 0;\n    filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);\n    -webkit-filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);\n}\n.college_detail_price_deadline > div .icon .icon-united-arab-emirates-dirham {\n    width: 16px;\n    height: 9px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/united-arab-emirates-dirham.svg)\n        no-repeat 0 0;\n    filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);\n    -webkit-filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);\n}\n.college_detail_price_deadline > div .icon .icon-open-book,\n.icon-open-book {\n    width: 18px;\n    height: 15px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/open-book.svg) no-repeat 0 0;\n    filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);\n    -webkit-filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);\n    background-size: cover;\n}\n.college_detail_price_deadline > div .icon + div {\n    line-height: 19px;\n}\n\n.college_blk_left {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n}\n.college_blk_right {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: end;\n}\n.college_blk_right .icon-down-arrow {\n    display: none;\n}\n.college_blk_right .btn-green:after {\n    position: absolute;\n    left: 0;\n    right: 0;\n    margin: auto;\n    border: 0;\n}\n.college_blk .collegeName .college_blk_left .college_detail_price i.icon-book {\n    color: #d97d1d;\n}\n.college_blk .collegeName .college_blk_left .icon-hat {\n    filter: invert(57%) sepia(68%) saturate(1168%) hue-rotate(165deg) brightness(90%) contrast(92%);\n    -webkit-filter: invert(57%) sepia(68%) saturate(1168%) hue-rotate(165deg) brightness(90%) contrast(92%);\n    vertical-align: top;\n    margin-top: 2px;\n}\n.college_blk_right .toggle-link {\n    position: relative;\n}\n.college_blk_right .toggle-link a + i {\n    position: absolute;\n    border-left: 8px solid transparent;\n    border-right: 8px solid transparent;\n    border-top: 0px solid #368124;\n    left: 0;\n    right: 0;\n    margin: auto;\n    width: 0;\n    height: 0;\n    top: 100%;\n    transition: all 0.3s ease-in-out;\n}\n.college_blk_right .toggle-link a[aria-expanded='true'] + i {\n    border-top: 7px solid #368124;\n}\n\n.listed-subject {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n}\n.listed-subject ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n}\n.listed-subject ul li {\n    background: #ffffff;\n    border-radius: 20px;\n    padding: 7px 20px;\n    color: #000;\n    font-size: 15px;\n    font-weight: 500;\n    margin: 0 5px 5px 0;\n}\n.listed-subject .cut-off {\n    margin: 0 5px 5px 5px;\n    font-size: 14px;\n    font-style: italic;\n}\n\n.select-toggle {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n}\n.select-toggle > a {\n    width: 20px;\n    height: 20px;\n    background: #0d345333;\n    border-radius: 50%;\n    position: relative;\n}\n.select-toggle .btn-add-toggle {\n    margin-right: 10px;\n}\n.select-toggle .btn-add-toggle:before {\n    content: '';\n    position: absolute;\n    width: 10px;\n    height: 2px;\n    background: #fff;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    top: 0;\n    margin: auto;\n    border-radius: 10px;\n    -webkit-border-radius: 10px;\n    -moz-border-radius: 10px;\n    -ms-border-radius: 10px;\n    -o-border-radius: 10px;\n}\n.select-toggle .btn-add-toggle:after {\n    content: '';\n    position: absolute;\n    width: 2px;\n    height: 10px;\n    background: #fff;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    top: 0;\n    margin: auto;\n    border-radius: 10px;\n}\n.select-toggle > a.btn-select-toggle::before {\n    content: '';\n    position: absolute;\n    width: 10px;\n    height: 5px;\n    border-left: 2px solid #fff;\n    border-bottom: 2px solid #fff;\n    left: 5px;\n    top: 7px;\n    transform: rotate(-45deg);\n    -webkit-transform: rotate(-45deg);\n    -moz-transform: rotate(-45deg);\n    -ms-transform: rotate(-45deg);\n    -o-transform: rotate(-45deg);\n}\n\n.college_blk .college {\n    background: #fff;\n    padding: 10px 20px;\n    border-radius: 6px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n}\n.college_blk .college:hover {\n    box-shadow: 0px 0px 6px #0000001a;\n}\n.college_blk .college:not(:last-child) {\n    margin-bottom: 5px;\n}\n.college_blk .icon-anchor {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/maximize.svg);\n    width: 13px;\n    height: 13px;\n    display: inline-block;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n}\n.college_blk .college:hover .icon-anchor {\n    filter: invert(66%) sepia(20%) saturate(1333%) hue-rotate(63deg) brightness(87%) contrast(80%);\n    webkit-filter: invert(66%) sepia(20%) saturate(1333%) hue-rotate(63deg) brightness(87%) contrast(80%);\n}\n.college_blk .college .college-brife {\n    flex: 1;\n    margin-right: 20px;\n    color: #000;\n}\n.college_blk .collegeName i.icon-medal {\n    filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);\n    -webkit-filter: invert(44%) sepia(25%) saturate(6305%) hue-rotate(347deg) brightness(100%) contrast(89%);\n}\n\n.college_detail .btn-viewdetail {\n    max-width: 220px;\n    background: #fff;\n    width: 90%;\n    margin: 18px auto auto; /*border: 2px solid #7D7D7D;*/\n    border-radius: 20px;\n    height: 40px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.3s ease-in-out;\n}\n.college_detail .btn-viewdetail:hover {\n    background: #5cae48;\n    color: #fff;\n}\n\n.deadlines-list .college_detail {\n    background: #fff;\n    padding-top: 0;\n}\n.deadlines-list .college_blk .college {\n    background: #153d5b;\n}\n.deadlines-list .college_blk .college .college-brife {\n    color: #fff;\n}\n.deadlines-list .college_detail .btn-viewdetail {\n    background: #5cae48;\n    color: #fff;\n}\n.deadlines-list .college_detail .btn-viewdetail:hover {\n    background: #398227;\n}\n\n.toggle-link a.btn-green[aria-expanded='true']::before {\n    width: 100%;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n}\n.toggle-link a.btn-green[aria-expanded='true'] span.icon-down-arrow {\n    transform: rotate(180deg);\n}\n.toggle-link a.btn-green span.icon-down-arrow {\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n}\n\n.btn.btn-accordion[aria-expanded='true'] {\n    transform: rotate(180deg);\n}\n.btn.btn-accordion {\n    transition: all 0.3s ease-in-out;\n}\n.college_blk .collegeName > .toggle-link.round-toggle {\n    position: absolute;\n    top: 0;\n    right: 20px;\n    bottom: 0;\n    margin: auto !important;\n    width: 48px !important;\n    height: 48px;\n}\n.college_blk .collegeName > .toggle-link .btn.btn-accordion {\n    border: 2px solid #0b345433;\n    width: 48px;\n    height: 48px;\n    border-radius: 50%;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    position: static;\n}\n.colondetailRow {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-wrap: wrap;\n}\n.colondetailRowLabel {\n    width: 140px;\n    font-size: 14px;\n}\n.colondetailRow .colon {\n    margin: 0 20px;\n}\n.colondetailRowBrife {\n    font-weight: 600;\n}\n.colondetailRow:not(:last-child) {\n    margin-bottom: 15px;\n}\n.colondetail {\n    margin: 5px 0;\n}\n\n.college-brife a {\n    color: #0b3454;\n    text-decoration: none;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n}\n.college-brife a:hover {\n    color: #414141;\n}\n\n.btn-reset {\n    box-shadow: 0px 0px 0px #0b34541a;\n    border: 0px solid #b5c1cb;\n    border-radius: 25px;\n    width: 70px;\n    height: 32px;\n    line-height: 30px;\n    padding: 0;\n    font-size: 15px;\n    font-weight: 500;\n    background: none;\n}\n.btn-reset:hover {\n    background: none;\n    color: #0b3454;\n}\n.btn-reset i {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/arrow-circle.svg);\n    width: 12px;\n    height: 14px;\n    display: inline-block;\n    margin-right: 5px;\n}\n\n.compareCollegeswrap {\n    background: #fff;\n    border-radius: 5px;\n    padding: 40px 30px 10px 5%;\n}\n.tabular-data {\n    position: relative;\n}\n.heading {\n    height: 99px;\n}\n.collegeBlock {\n    background: #fff;\n    border-radius: 5px;\n    overflow: hidden;\n    border: 1px solid #ececec;\n}\n.tabular-data .content {\n    min-height: 60px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    width: 100%;\n    align-items: center;\n}\n.tabular-data .collegeBlock .content {\n    justify-content: center;\n}\n.tabular-data .mobile-scroll .content span {\n    padding: 0 25px;\n    font-family: 'Jost', sans-serif !important;\n    font-size: 16px;\n    text-align: center;\n}\n.tabular-data div:not(.mobile-scroll) .content span {\n    font-weight: 500;\n    font-family: 'Jost', sans-serif;\n    font-size: 16px;\n}\n.tabular-data .collegeBlock .content:nth-child(2n + 1) {\n    background: #f6f6f6;\n}\n.tabular-data .collegeBlock .content:not(:last-child) {\n    border-bottom: 1px solid #ececec;\n}\n.collegeBlock .heading {\n    border-bottom: 1px solid #ececec;\n    position: relative;\n    background: #0b3454;\n    color: #fff;\n    padding: 25px 12px 0;\n}\n.collegeBlock .heading .icon.icon-checked {\n    width: 15px;\n    height: 15px;\n    position: absolute;\n    background: #fff;\n    border-radius: 50%;\n    left: 12px;\n    top: 28px;\n    display: none;\n}\n.icon.icon-checked {\n    width: 15px;\n    height: 15px;\n    position: absolute;\n    background: #fff;\n    border-radius: 50%;\n    left: 12px;\n    top: 28px;\n    display: none;\n}\n.collegeBlock .heading .compare_add {\n    width: 15px;\n    height: 15px;\n    display: inline-block;\n    background: #fff;\n    border-radius: 50%;\n    margin-top: 3px;\n    position: relative;\n}\n.collegeBlock .heading .compare_add:before {\n    content: '';\n    position: absolute;\n    width: 9px;\n    height: 5px;\n    border-left: 2px solid #0b3454;\n    border-bottom: 2px solid #0b3454;\n    transform: rotate(-45deg);\n    top: 4px;\n    left: 3px;\n    -webkit-transform: rotate(-45deg);\n    -moz-transform: rotate(-45deg);\n    -ms-transform: rotate(-45deg);\n    -o-transform: rotate(-45deg);\n}\n.collegeBlock .heading .btn-close-small {\n    width: 10px;\n    height: 10px;\n    padding: 0 !important;\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    z-index: 9;\n    opacity: 1;\n}\n.collegeBlock .close.closetag {\n    position: absolute;\n    top: 0px;\n    right: 7px;\n}\n.collegeBlock .close.closetag i {\n    color: #fff;\n}\n.tabular-data .content.admChanceDiv[style*='block'] {\n    display: flex !important;\n}\n.tabular-data .content.ranking {\n    flex-direction: column;\n    align-items: self-start;\n    justify-content: center;\n}\n.tabular-data .collegeBlock .content.ranking {\n    align-items: center;\n}\n.tabular-data .collegeBlock .content a {\n    background: #e6e6e6;\n    padding: 8px 20px;\n    border-radius: 25px;\n    color: #185094;\n    text-decoration: none;\n    min-width: 110px;\n    width: 100%;\n    display: inline-block;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n    font-weight: 500;\n    font-family: 'Jost', sans-serif;\n}\n.tabular-data .collegeBlock .content a:hover {\n    background: #185094;\n    color: #fff;\n}\n.collegeBlock h6 span {\n    font-size: 20px;\n    font-weight: 500;\n}\n.collegeBlock .heading h6 i {\n    font-size: 16px;\n}\n.compare_add.added i {\n    color: #f4ad17;\n}\n#checkChanceBlockDiv {\n    display: none !important;\n}\n.btn-load {\n    border: 1px solid #e1e1e1;\n    background: #f8f8f8;\n    border-radius: 3px;\n    font-size: 16px;\n    color: #414141;\n}\n.blue-text {\n    color: #2680eb;\n}\n\n.btn-play {\n    color: #0b3454 !important;\n}\n.btn-play:hover {\n    color: #5cae48 !important;\n    opacity: 1 !important;\n}\n\n@media (max-width: 1199px) {\n    .mobile-scroll {\n        overflow: auto;\n    }\n    .mobile-scroll > .row {\n        width: 730px;\n    }\n    .college_blk .collegeName .toggle-link {\n        width: 100%;\n        margin-top: 15px;\n        order: 1;\n    }\n}\n\n@media (max-width: 575px) {\n    .tabular-data div:not(.mobile-scroll) .content span {\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        overflow: hidden;\n    }\n}\n\n/* .pagination_custom */\n\n.pagination-div .pagination {\n    list-style: none;\n    height: 31.5px;\n    /* width: 31.5px; */\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: 2px;\n    cursor: pointer;\n}\n\n.pagination-div .active div {\n    background-color: #5cae48;\n    color: #fff;\n    border-radius: 50%;\n}\n\n.pagination-div .page-item {\n    list-style: none;\n    padding: 0;\n    margin: 0 5px;\n}\n.pagination-div .page-item div {\n    height: 31.5px;\n    width: 31.5px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.pagination-div .previous button {\n    width: 32px;\n    height: 32px;\n    background: #a3a3a3;\n    border-radius: 50%;\n    margin: 0 5px;\n    position: relative;\n    border: none;\n    -webkit-border-radius: 50%;\n    -moz-border-radius: 50%;\n    -ms-border-radius: 50%;\n    -o-border-radius: 50%;\n}\n.pagination-div .previous button:before {\n    content: '';\n    position: absolute;\n    width: 8px;\n    height: 8px;\n    border-top: 3px solid #fff;\n    border-right: 3px solid #fff;\n    transform: rotate(-135deg);\n    top: 12px;\n    left: 13px;\n    -webkit-transform: rotate(-135deg);\n    -moz-transform: rotate(-135deg);\n    -ms-transform: rotate(-135deg);\n    -o-transform: rotate(-135deg);\n}\n.pagination-div .next button {\n    width: 32px !important;\n    height: 32px;\n    background: #a3a3a3;\n    border-radius: 50%;\n    margin: 0 5px;\n    position: relative;\n    border: none;\n}\n.pagination-div .next button:before {\n    content: '';\n    position: absolute;\n    width: 8px;\n    height: 8px;\n    border-top: 3px solid #fff;\n    border-right: 3px solid #fff;\n    transform: rotate(-135deg);\n    top: 12px;\n    left: 13px;\n    -webkit-transform: rotate(-135deg);\n    -moz-transform: rotate(-135deg);\n    -ms-transform: rotate(-135deg);\n    -o-transform: rotate(-135deg);\n}\n.heading-search .custom-select {\n    border: 1px solid #e6e6e6 !important;\n    border-radius: 4px;\n    height: 45px !important;\n}\n.heading-search .custom-select div[class*='singleValue'],\n.heading-search .custom-select div[id*='placeholder'] {\n    padding-left: 5px;\n}\n\n.search_college i {\n    position: absolute;\n    right: -22px;\n    top: 18px;\n    font-size: 12px;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    cursor: pointer;\n}\n.search_college {\n    overflow: hidden;\n}\n.search_college .form-control:valid ~ i {\n    right: 15px;\n}\n.search_college .form-search {\n    padding: 0 30px 0 35px !important;\n}\n.icon-loan {\n    width: 20px;\n    height: 24px;\n    display: inline-block;\n    background-image: url('https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/loan.svg');\n}\n\n.btn-holder {\n    width: 181px;\n}\n\n/* manage-widget css */\n\n.bg-blue-164F88 {\n    background-color: #164f88;\n}\n.bg-blue-083461 {\n    background-color: #083461;\n}\n.bg-gray-F2F4F7 {\n    background-color: #f2f4f7;\n}\n.bg-gray-EFEFEF {\n    background-color: #efefef;\n}\n.bg-yellow-FFFAE5 {\n    background-color: #fffae5;\n}\n.text-yellow {\n    color: #f5ae18 !important;\n}\n.cursor-pointer {\n    cursor: pointer;\n}\n.white-filter {\n    filter: brightness(0) invert(1);\n    -webkit-filter: brightness(0) invert(1);\n}\n\n.form-control.form-search.form-gray-search {\n    background-color: #f2f4f7;\n    border: none;\n    color: #000;\n}\n.form-control.form-search.form-gray-search::placeholder {\n    color: #000;\n}\n.opacity-7 {\n    opacity: 0.7;\n}\n\n.guiding_alumni_block {\n    background: #ffffff;\n    border: 1px solid #dcdcdc;\n    border-radius: 4px;\n    opacity: 1;\n    padding: 20px;\n    max-width: 270px;\n    transition: all 0.7s ease-in-out;\n    -webkit-transition: all 0.7s ease-in-out;\n    -moz-transition: all 0.7s ease-in-out;\n    -ms-transition: all 0.7s ease-in-out;\n    -o-transition: all 0.7s ease-in-out;\n}\n.active .guiding_alumni_block {\n    transform: translatey(0%);\n    -webkit-transform: translatey(0%);\n    -moz-transform: translatey(0%);\n    -ms-transform: translatey(0%);\n    -o-transform: translatey(0%);\n}\n.guiding_alumni_block .guiding_alumni_top {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    border-bottom: 1px solid #e2e2e2;\n    padding-bottom: 12px;\n}\n.guiding_alumni_profile_img_wrap {\n    position: relative;\n    width: 80px;\n    height: 80px;\n    margin-bottom: 8px;\n}\n.guiding_alumni_profile_img_wrap .guiding_alumni_profile_img {\n    margin: 0;\n}\n.guiding_alumni_profile_img_wrap label {\n    background: #27a7df;\n    border: 1px solid #fff;\n    opacity: 1;\n    width: 27px;\n    height: 27px;\n    border-radius: 50%;\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    position: absolute;\n    right: 0;\n    bottom: 0;\n}\n.guiding_alumni_profile_img_wrap label .pencil-edit {\n    filter: brightness(0) invert(1);\n    width: 13px;\n    height: 13px;\n    background-size: 100%;\n    -webkit-filter: brightness(0) invert(1);\n}\n.guiding_alumni_block .guiding_alumni_top .guiding_alumni_profile_img {\n    width: 80px;\n    height: 80px;\n    border-radius: 50%;\n    overflow: hidden;\n    margin-bottom: 8px;\n}\n.guiding_alumni_block .guiding_alumni_top .guiding_alumni_profile_name {\n    font-size: 20px;\n    line-height: 26px;\n    font-weight: 600;\n    color: #0b3454;\n    text-align: center;\n}\n\n.guiding_alumni_college_cource {\n    padding-top: 14px;\n}\n.guiding_alumni_college_cource ul {\n    padding: 0;\n    margin: 0;\n    list-style: none;\n    font-size: 14px;\n}\n.guiding_alumni_college_cource ul li:not(:last-child) {\n    margin-bottom: 12px;\n}\n.guiding_alumni_college_cource ul li {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    color: #000;\n    font-weight: 500;\n}\n.guiding_alumni_college_cource ul li i{width: 24px;height: 24px;margin-right: 8px;padding-top: 2px;}\n.guiding_alumni_college_cource ul li i.college {\n    width: 24px;\n    height: 24px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/small-school.svg) no-repeat center;\n    margin-right: 8px;\n}\n.guiding_alumni_college_cource ul li i.brifecase {\n    width: 24px;\n    height: 24px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/small-brifecase.svg) no-repeat center;\n    margin-right: 8px;\n}\n.guiding_alumni_college_cource ul li i.tool {\n    width: 24px;\n    height: 24px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/tool.svg) no-repeat center;\n    margin-right: 8px;\n}\n.guiding_alumni_college_cource ul li i.cap {\n    width: 24px;\n    height: 24px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/graduation-cap.svg) no-repeat center /\n        100% !important;\n    margin-right: 8px;\n}\n.guiding_alumni_college_cource ul li i.star {\n    width: 24px;\n    height: 24px;\n    background-color: #fff;\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23F5AE18' stroke-linecap='' stroke-linejoin='' stroke-width='1' d='M2.866 14.85c-.078.444.36.791.746.593l4.39-2.256 4.389 2.256c.386.198.824-.149.746-.592l-.83-4.73 3.522-3.356c.33-.314.16-.888-.282-.95l-4.898-.696L8.465.792a.513.513 0 0 0-.927 0L5.354 5.12l-4.898.696c-.441.062-.612.636-.283.95l3.523 3.356-.83 4.73zm4.905-2.767-3.686 1.894.694-3.957a.56.56 0 0 0-.163-.505L1.71 6.745l4.052-.576a.53.53 0 0 0 .393-.288L8 2.223l1.847 3.658a.53.53 0 0 0 .393.288l4.052.575-2.906 2.77a.56.56 0 0 0-.163.506l.694 3.957-3.686-1.894a.5.5 0 0 0-.461 0z'/%3e%3c/svg%3e\");\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: 18px 18px !important;\n    margin-right: 8px;\n}\n.guiding_alumni_college_cource ul li i.badge {\n    width: 24px;\n    height: 24px;\n    background-color: transparent;\n    background-image: url(\"https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/medal.svg\");\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: 21px !important;\n    margin-right: 8px;\n    display: block;\n}\n.guiding_alumni_college_cource ul li i {\n    font-size: 18px;\n    background-size: 20px !important;\n}\n.guiding_alumni_college_cource ul li span {\n    width: calc(100% - 32px);\n    text-align: left;\n    font-size: 14px;\n    line-height: 17px;\n    vertical-align: top;\n    margin: 4px 0 0;\n}\n.guiding_alumni_college_cource ul li span b {\n    display: block;\n    font-weight: 400;\n}\n\n#WidgetsAlumniCarousel .guiding_alumni_block {\n    transform: translatey(-150%);\n    -webkit-transform: translatey(-150%);\n    -moz-transform: translatey(-150%);\n    -ms-transform: translatey(-150%);\n    -o-transform: translatey(-150%);\n}\n#WidgetsAlumniCarousel .active .guiding_alumni_block {\n    transform: translatey(0%);\n    -webkit-transform: translatey(0%);\n    -moz-transform: translatey(0%);\n    -ms-transform: translatey(0%);\n    -o-transform: translatey(0%);\n}\n#WidgetsAlumniCarousel .bg-white {\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n#WidgetsAlumniCarousel .owl-nav {\n    width: 57.5%;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: space-around;\n    margin-top: 25px;\n    margin-left: auto;\n}\n#WidgetsAlumniCarousel.owl-carousel .owl-nav button {\n    border-radius: 25px;\n    padding: 0 25px !important;\n    line-height: 32px;\n    border: 2px solid #7d7d7d;\n    height: 40px;\n    display: inline-flex;\n    text-decoration: none;\n    color: #000;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n    position: relative;\n    overflow: hidden;\n    justify-content: center;\n    align-items: center;\n    background: #fff;\n}\n#WidgetsAlumniCarousel.owl-carousel .owl-nav button:hover {\n    background: #7d7d7d;\n    color: #fff;\n}\n#WidgetsAlumniCarousel.owl-carousel .owl-nav button span {\n    font-size: 28px;\n    display: inline-block;\n    line-height: 0;\n    vertical-align: top;\n    margin: -4px 0 0;\n}\n#WidgetsAlumniCarousel.owl-carousel .owl-nav button.owl-prev:after {\n    content: 'Previous Profile';\n    margin-left: 7px;\n}\n#WidgetsAlumniCarousel.owl-carousel .owl-nav button.owl-next:before {\n    content: 'Next Profile';\n    margin-right: 7px;\n}\n#WidgetsAlumniCarousel .owl-dots {\n    display: none;\n}\n\n.owl-carousel .owl-stage {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n}\n.owl-carousel .owl-stage .item {\n    height: 100%;\n}\n\n.embed-wrap hr {\n    border-bottom: 1px dashed #201a00;\n    background: none;\n}\n\n.fourcardslider .owl-nav,\n.twocardslider .owl-nav {\n    text-align: left;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n}\n.fourcardslider .owl-nav button,\n.twocardslider .owl-nav button {\n    width: 40px;\n    height: 40px;\n    background: #fff !important;\n    font-size: 20px !important;\n    display: -webkit-box !important;\n    display: -moz-box !important;\n    display: -ms-flexbox !important;\n    display: -webkit-flex !important;\n    display: flex !important;\n    align-items: center;\n    justify-content: center;\n}\n.fourcardslider .owl-nav button span,\n.twocardslider .owl-nav button span {\n    font-size: 40px !important;\n    margin: -7px 0 0;\n    vertical-align: top;\n}\n.owl-theme.fourcardslider .owl-nav,\n.owl-theme.twocardslider .owl-nav [class*='owl-']:hover {\n    color: #0b3454;\n}\n\n.icon-eye {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/eye.svg) no-repeat 0 0 / 100%;\n    width: 32px;\n    height: 20px;\n    display: block;\n}\n.icon-eye-black {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/eye.svg) no-repeat 0 0 / 100%;\n    width: 32px;\n    height: 20px;\n    display: block;\n    filter: brightness(0) invert(0);\n    -webkit-filter: brightness(0) invert(0);\n}\n\n.ratio20 {\n    width: 20px;\n    height: 20px;\n}\n\n.navdotnone .owl-nav,\n.navdotnone .owl-dots {\n    display: none !important;\n}\n.btn-border-add {\n    border-radius: 25px;\n    padding: 0 25px !important;\n    line-height: 32px;\n    border: 1px solid #c1c1c1;\n    height: 40px;\n    display: inline-flex;\n    text-decoration: none;\n    color: #27a7df;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n    position: relative;\n    overflow: hidden;\n    justify-content: center;\n    align-items: center;\n    background: #fff;\n}\n.btn-border-add i {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n}\n.btn-border-add:hover {\n    background-color: #27a7df;\n    border: 1px solid #27a7df;\n    color: #fff;\n}\n.btn-border-add:hover i {\n    filter: brightness(0) invert(1);\n    -webkit-filter: brightness(0) invert(1);\n}\na.text-skyblue {\n    color: #27a7df;\n}\na.text-skyblue:hover {\n    color: #0b3454;\n}\n\n.Vertical-graph-block {\n    background: #ffffff 0% 0% no-repeat padding-box;\n    border: 1px solid #dcdcdc;\n    border-radius: 6px;\n    padding: 30px;\n    width: 100%;\n    max-width: 400px;\n}\n.Vertical-graph-block.max-450 {\n    max-width: 450px;\n}\n.Vertical-graph-block h2 {\n    text-align: center;\n    font-size: 24px;\n    color: #000;\n    font-weight: 600;\n    margin-bottom: 20px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-content: center;\n    justify-content: center;\n}\n.Vertical-graph-block h2 .pencil-edit {\n    filter: invert(53%) sepia(95%) saturate(1016%) hue-rotate(165deg) brightness(94%) contrast(86%);\n    -webkit-filter: invert(53%) sepia(95%) saturate(1016%) hue-rotate(165deg) brightness(94%) contrast(86%);\n}\n.Vertical-graph-block h2 a {\n    margin-left: 8px;\n}\n.Vertical-graph-block .bigVerticalProgress {\n    justify-content: center;\n}\n.Vertical-graph-block .bigVerticalProgress .verticleProgress {\n    padding: 0 8px;\n    width: auto;\n    margin: 0;\n}\n.Vertical-graph-block .bigVerticalProgress .graphContainer .progress {\n    width: 40px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n    position: relative;\n    overflow: visible;\n    border-radius: 0;\n    -webkit-border-radius: 0;\n    -moz-border-radius: 0;\n    -ms-border-radius: 0;\n    -o-border-radius: 0;\n}\n.Vertical-graph-block .bigVerticalProgress .graphContainer .progress.lite-blue {\n    background-color: #def3fc;\n}\n.Vertical-graph-block .bigVerticalProgress .graphContainer .progress.lite-blue .progress-bar {\n    border-radius: 0;\n    -webkit-border-radius: 0;\n    -moz-border-radius: 0;\n    -ms-border-radius: 0;\n    -o-border-radius: 0;\n    background-color: #27a7df;\n}\n.Vertical-graph-block .bigVerticalProgress .graphContainer .progress.lite-red {\n    background-color: #fff2f4;\n}\n.Vertical-graph-block .bigVerticalProgress .graphContainer .progress.lite-red .progress-bar {\n    border-radius: 0;\n    -webkit-border-radius: 0;\n    -moz-border-radius: 0;\n    -ms-border-radius: 0;\n    -o-border-radius: 0;\n    background-color: #d42941;\n}\n.Vertical-graph-block .bigVerticalProgress .graphContainer .progress .progresstext {\n    position: absolute;\n    bottom: 100%;\n    left: 0;\n    right: 0;\n    margin: auto;\n    text-align: center;\n}\n\n.Vertical-graph-block .HorizontalProgress {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: row-reverse;\n    align-items: center;\n}\n.Vertical-graph-block .HorizontalProgress .graphContainer {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    padding-right: 30px;\n    position: relative;\n}\n.Vertical-graph-block .HorizontalProgress .caption {\n    width: 90px;\n    text-align: right;\n    margin-right: 10px;\n    line-height: 16px;\n}\n.Vertical-graph-block .HorizontalProgress:not(:last-child) {\n    margin-bottom: 10px;\n}\n.Vertical-graph-block .HorizontalProgress .graphContainer .progress {\n    height: 40px;\n    border-radius: 0;\n}\n.Vertical-graph-block .HorizontalProgress .graphContainer .progress.lite-orange {\n    background-color: #fff4dc;\n}\n.Vertical-graph-block .HorizontalProgress .graphContainer .progress.lite-orange .progress-bar {\n    background-color: #f5ae18;\n}\n.Vertical-graph-block .HorizontalProgress .graphContainer .progress .progresstext {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    right: -10px;\n    line-height: 40px;\n    font-weight: 500;\n    font-size: 16px;\n}\n\n.btn-trash-right {\n    position: absolute;\n    top: 13px;\n    right: -18px;\n    width: 15px;\n    height: 15px;\n    background-position: center;\n    background-size: 15px;\n}\n\n.top-college-wrap {\n    max-width: 850px;\n    width: 96%;\n    margin: auto;\n    text-align: center;\n}\n.top-college-wrap .nav {\n    background: #164f88;\n    border-radius: 6px;\n    max-width: 720px;\n    margin: auto;\n    justify-content: space-between;\n}\n.top-college-wrap .nav button {\n    height: 50px;\n    color: #fff;\n}\n.top-college-wrap .nav button.active {\n    background: #f5ae18;\n    color: #000;\n}\n.logo-block {\n    background: #ffffff 0% 0% no-repeat padding-box;\n    border: 1px solid #c8c8c8;\n    border-radius: 6px;\n    padding: 20px;\n    width: 158px;\n    height: 100%;\n}\n.logo-block .logo-img {\n    margin-bottom: 10px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: end;\n    justify-content: center;\n}\n.logo-block .logo-img img {\n    width: auto;\n}\n\n.top-college-wrap .top-colleges-slider .owl-nav {\n    margin-top: 0;\n}\n.top-college-wrap .top-colleges-slider .owl-nav button {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    background: #fff;\n    width: 40px;\n    height: 40px;\n    border-radius: 3px;\n    border: none;\n    margin: auto;\n    overflow: hidden;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.top-college-wrap .top-colleges-slider .owl-nav button:hover {\n    background-color: #000;\n}\n.top-college-wrap .top-colleges-slider .owl-nav button span {\n    font-size: 40px;\n    vertical-align: top;\n    height: 40px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    line-height: 34px;\n    margin: -5px 0 0;\n}\n.top-college-wrap .top-colleges-slider .owl-nav button.owl-prev {\n    left: -60px;\n}\n.top-college-wrap .top-colleges-slider .owl-nav button.owl-next {\n    right: -60px;\n}\n.top-college-wrap .top-colleges-slider .owl-nav button.disabled {\n    opacity: 0.3;\n}\n\n.max-500 {\n    width: 96%;\n    max-width: 500px;\n}\n\n.btn-skyblue {\n    height: 30px;\n    background: #27a7df;\n    margin: 0;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: #fff;\n    border-radius: 25px;\n    font-weight: 500 !important;\n    cursor: pointer;\n    border: 0;\n    padding: 5px 20px;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    text-decoration: none !important;\n}\n.btn-skyblue:hover {\n    background-color: #0b3454;\n    color: #fff;\n}\n\n.modal .colleges-list {\n    max-height: 340px;\n    overflow: auto;\n}\n.modal .colleges-list ul {\n    margin: 0;\n    padding: 0;\n}\n.modal .colleges-list ul li {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n}\n.modal .colleges-list ul li:not(:last-child) {\n    margin-bottom: 15px;\n    padding-bottom: 15px;\n    border-bottom: 1px solid #ccc;\n}\n.modal .colleges-list ul li .logoImg {\n    width: 90px;\n    margin-right: 15px;\n}\n.modal .colleges-list ul li .logoName {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    width: calc(100% - 105px);\n}\n.modal .colleges-list ul li .logoName p {\n    margin: 0;\n    font-size: 18px;\n    font-weight: 500;\n}\n.modal .colleges-list ul li .logoName span {\n    font-style: italic;\n}\n.modal .colleges-list ul li .logoImg.w-150 {\n    width: 150px;\n    text-align: center;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.modal .colleges-list ul li .logoImg + div {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n}\n.modal .colleges-list ul li .logoImg + div p {\n    margin: 0;\n}\n\n.leftPaneTab {\n    max-width: 280px;\n    text-align: left;\n}\n.leftPaneTab .nav-link {\n    text-align: left;\n    background: #164f88;\n    border-radius: 6px;\n    min-height: 76px;\n    color: #fff;\n    padding: 20px;\n    line-height: 18px;\n    position: relative;\n}\n.leftPaneTab .nav-link::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: calc(100% - 15px);\n    border-top: 15px solid transparent;\n    border-bottom: 15px solid transparent;\n    border-left: 13px solid transparent;\n    width: 0;\n    height: 0;\n    margin: auto;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.leftPaneTab .nav-link:not(:last-child) {\n    margin-bottom: 10px;\n}\n.leftPaneTab .nav-link.active {\n    background: #27a7df;\n}\n.leftPaneTab .nav-link.active::before {\n    border-left: 13px solid #27a7df;\n    left: 100%;\n}\n\n.testimonial_block {\n    background: #164f88;\n    border-radius: 6px;\n    padding: 30px;\n    color: #fff;\n}\n.testimonial_block .testimonial_img_brife {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    border-bottom: 1px solid #3a7ab9;\n    margin-bottom: 15px;\n}\n.testimonial_block .testimonial_img_brife .testimonial_img_wrap {\n    position: relative;\n    width: 80px;\n    height: 80px;\n    margin-right: 20px;\n}\n.testimonial_block .testimonial_img_brife .testimonial_img_wrap .testimonial_img {\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n    overflow: hidden;\n}\n.testimonial_block .testimonial_img_brife .testimonial_img_wrap label {\n    background: #27a7df;\n    border: 1px solid #fff;\n    opacity: 1;\n    width: 27px;\n    height: 27px;\n    border-radius: 50%;\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    position: absolute;\n    right: 0;\n    bottom: 0;\n}\n.testimonial_block .testimonial_img_brife .testimonial_img_wrap label .pencil-edit {\n    filter: brightness(0) invert(1);\n    width: 13px;\n    height: 13px;\n    background-size: 100%;\n    -webkit-filter: brightness(0) invert(1);\n}\n.testimonial_block .testimonial_img_brife .testimonial_brife {\n    width: calc(100% - 100px);\n}\n.testimonial_block label {\n    margin-left: 4px;\n    cursor: pointer;\n}\n.testimonial_block .pencil-edit {\n    filter: brightness(0) invert(1);\n    -webkit-filter: brightness(0) invert(1);\n}\n.testimonial_detail p:first-child::before {\n    content: '';\n    display: inline-block;\n    width: 27px;\n    height: 20px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/quote.svg) no-repeat 0 0;\n    margin-right: 10px;\n    position: relative;\n    top: 5px;\n}\n\n.directory-stats-wrap {\n    background: #fff;\n    width: 100%;\n    padding: 30px;\n    border-radius: 5px;\n}\n.directory-stats-wrap ul {\n    padding: 0;\n    margin: 0;\n    list-style: none;\n}\n.directory-stats-wrap ul li {\n    position: relative;\n    padding: 20px 20px 20px 41px;\n    background: #f2f4f7;\n    min-height: 50px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border-radius: 4px;\n}\n.directory-stats-wrap ul li:before {\n    content: '';\n    width: 10px;\n    height: 24px;\n    border-left: 4px dotted #bdbdbd;\n    border-right: 4px dotted #bdbdbd;\n    position: absolute;\n    left: 17px;\n    top: 0;\n    margin: auto;\n    bottom: 0;\n}\n.directory-stats-wrap ul li:not(:last-child) {\n    margin-bottom: 10px;\n}\n.directory-stats-wrap ul li .stats-name-detail span {\n    font-size: 18px;\n    color: #214764;\n    margin-right: 6px;\n    line-height: 22px;\n}\n.directory-stats-wrap ul li .stats-name-detail b {\n    color: #5cae48;\n    font-size: 22px;\n}\n.directory-stats-wrap ul li .stats-name-detail {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n}\n.del-directory-item {\n    background: #ffdfe4;\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    margin-left: 15px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.del-directory-item i {\n    width: 14px;\n    height: 14px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/trash.svg) no-repeat center / 100%;\n    opacity: 0.8;\n}\n\n.alumni_network {\n    background: #fff;\n}\n.alumni_network .sub-title {\n    font-size: 40px;\n    font-weight: 500;\n    color: #2d2d2d;\n    text-align: center;\n    line-height: 50px;\n    margin: 0;\n}\n.alumni_network_count {\n    overflow-y: hidden;\n    overflow-x: auto;\n    scrollbar-width: thin;\n    padding-bottom: 8px;\n}\n.alumni_network_count::-webkit-scrollbar {\n    height: 4px;\n}\n.alumni_network_count::-moz-scrollbar {\n    height: 4px;\n}\n.alumni_network_count::-webkit-scrollbar-track {\n    background: #ccc;\n}\n.alumni_network_count::-webkit-scrollbar-thumb {\n    background-color: #666;\n    border-radius: 20px;\n    border: 2px solid #666;\n}\n.alumni_network_count ul {\n    padding: 0;\n    margin: 0;\n    list-style: none;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: start;\n}\n.alumni_network_count li {\n    background: #ffffff;\n    box-shadow: 0px 3px 6px #0000001a;\n    border: 1px solid #0034571a;\n    border-radius: 10px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 40px 20px;\n    width: 220px;\n    min-width: 220px;\n    text-align: center;\n}\n.alumni_network_count li b {\n    color: #5cae48;\n    font-size: 45px;\n    line-height: 60px;\n}\n.alumni_network_count li:not(:last-child) {\n    margin-right: 10px;\n}\n.alumni_network_count li p {\n    margin: 7px 0 0 !important;\n    text-align: center;\n    font-size: 18px;\n    line-height: 20px;\n    font-weight: 500;\n    opacity: 1;\n    color: #0b3454;\n    padding: 0;\n}\n\n.btn-video-del {\n    background: #fff;\n    width: auto;\n    height: auto;\n    border-radius: 25px;\n    margin-left: 15px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: absolute;\n    z-index: 1;\n    padding: 6px 15px;\n    top: 10px;\n    right: 10px;\n    color: #000;\n    text-decoration: none !important;\n    border: 2px solid transparent;\n}\n.btn-video-del i {\n    width: 14px;\n    height: 14px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/trash.svg) no-repeat center / 100%;\n    margin-right: 4px;\n}\n.btn-video-del:hover {\n    background: #c90000;\n    border: 2px solid #fff;\n    color: #fff;\n}\n.btn-video-del:hover i {\n    filter: brightness(0) invert(1);\n    -webkit-filter: brightness(0) invert(1);\n}\n.nav-pills.slider-tab {\n    width: max-content;\n}\n.nav-pills.slider-tab .nav-item:not(:last-child) {\n    margin-right: 10px;\n}\n.nav-pills.slider-tab .nav-link {\n    padding: 7px 20px;\n    border: 1px solid #a4b3be;\n    border-radius: 25px;\n    -webkit-border-radius: 25px;\n    -moz-border-radius: 25px;\n    -ms-border-radius: 25px;\n    -o-border-radius: 25px;\n    color: #0b3454;\n    position: relative;\n}\n.nav-pills.slider-tab .nav-link:before {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: calc(100% - 8px);\n    margin: auto;\n    border-left: 8px solid transparent;\n    border-right: 8px solid transparent;\n    border-bottom: 8px solid transparent;\n    width: 0;\n    height: 0;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.nav-pills.slider-tab .nav-link.active {\n    background: #0b3454;\n    border-color: #0b3454;\n    color: #fff;\n}\n.nav-pills.slider-tab .nav-link.active:before {\n    bottom: 100%;\n    border-bottom-color: #0b3454;\n}\n.slider-tab .btn-add {\n    padding: 7px 15px 7px 10px;\n    border: 1px solid #a4b3be;\n    border-radius: 25px;\n    -webkit-border-radius: 25px;\n    -moz-border-radius: 25px;\n    -ms-border-radius: 25px;\n    -o-border-radius: 25px;\n    color: #0b3454;\n    background: #fff;\n}\n.slider-tab .btn-add i {\n    filter: invert(13%) sepia(330%) saturate(6748%) hue-rotate(188deg) brightness(50%) contrast(91%);\n    -webkit-filter: invert(13%) sepia(330%) saturate(6748%) hue-rotate(188deg) brightness(50%) contrast(91%);\n}\n.slider-tab .btn-add:hover {\n    background: #0b3454;\n    border: 1px solid #0b3454;\n    color: #fff;\n}\n.slider-tab .btn-add:hover i {\n    filter: brightness(0) invert(1);\n    -webkit-filter: brightness(0) invert(1);\n}\n.univariety_main_banner {\n    padding: 0;\n}\n.univariety_main_banner_container {\n    position: relative;\n}\n.univariety_main_banner_container img {\n    position: relative;\n    vertical-align: top;\n}\n.main_banner_text {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    margin: auto;\n    max-width: 48%;\n    text-align: center;\n    color: #fff;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n.banner_title {\n    font-size: 60px;\n    color: #fff;\n    font-weight: 600;\n    line-height: 70px;\n    max-width: 760px;\n    margin: 0 0 20px;\n}\n.max-1140 .banner_title {\n    font-size: 46px;\n    line-height: 50px;\n}\n.banner_sub_title {\n    font-size: 24px;\n    line-height: 30px;\n    margin-bottom: 40px;\n    color: #fff;\n}\n.btn-watch {\n    width: 175px;\n    height: 50px;\n    border: 1px solid #5cae48;\n    text-decoration: none !important;\n    border-radius: 5px;\n    background: #5cae48;\n    font-size: 16px;\n    font-weight: 500;\n    color: #fff;\n    text-transform: uppercase;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.btn-watch:hover {\n    background: #fff;\n    border-color: #fff;\n    color: #27377b;\n}\n.btn-watch i {\n    width: 22px;\n    height: 22px;\n    background: #fff;\n    border-radius: 50%;\n    margin-right: 10px;\n    position: relative;\n}\n.btn-watch i::before {\n    content: '';\n    position: absolute;\n    width: 0;\n    height: 0;\n    border-top: 5px solid transparent;\n    border-bottom: 5px solid transparent;\n    border-left: 7px solid #5cae48;\n    top: 6px;\n    left: 9px;\n}\n.btn-watch:hover i {\n    background: #28377c;\n}\n.btn-watch:hover i:before {\n    border-left-color: #fff;\n}\n\n.preview-slider#alumni-card-slider .owl-dots {\n    display: none;\n}\n.preview-slider#alumni-card-slider .owl-nav {\n    display: block !important;\n}\n.preview-slider#alumni-card-slider .owl-nav button {\n    background: #fff;\n    width: 40px;\n    height: 50px;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    margin: auto !important;\n    border-radius: 0 6px 6px 0;\n    font-size: 0;\n}\n.preview-slider#alumni-card-slider .owl-nav button::before {\n    content: '';\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='black' stroke='black' stroke-linecap='round' stroke-linejoin='round' stroke-width='1' d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e\");\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    background-size: 24px;\n    background-repeat: no-repeat;\n    background-position: left 5px center;\n}\n.preview-slider#alumni-card-slider .owl-nav button.owl-prev {\n    left: 0;\n}\n.preview-slider#alumni-card-slider .owl-nav button.owl-next {\n    right: 0;\n    transform: scaleX(-1);\n}\n\n@media (max-width: 991px) {\n    .Vertical-graph-block .bigVerticalProgress {\n        max-width: max-content;\n        width: max-content;\n    }\n    .top-college-wrap .top-colleges-slider .owl-nav {\n        margin-top: 10px;\n        display: -webkit-box;\n        display: -moz-box;\n        display: -ms-flexbox;\n        display: -webkit-flex;\n        display: flex;\n        justify-content: center;\n    }\n    .top-college-wrap .top-colleges-slider .owl-nav button {\n        position: static;\n        margin: 5px;\n    }\n    .banner_title {\n        font-size: 34px;\n        line-height: 36px;\n    }\n    .banner_sub_title {\n        font-size: 20px;\n        line-height: 22px;\n        margin-bottom: 20px;\n    }\n}\n\n@media (max-width: 767px) {\n    #WidgetsAlumniCarousel .owl-nav {\n        width: 100%;\n        justify-content: center;\n    }\n    .guiding_alumni_block {\n        transform: translatey(0%);\n        -webkit-transform: translatey(0%);\n        -moz-transform: translatey(0%);\n        -ms-transform: translatey(0%);\n        -o-transform: translatey(0%);\n    }\n    .top-college-wrap .nav {\n        width: max-content;\n    }\n    .leftPaneTab {\n        max-width: 100%;\n        overflow-x: auto;\n        overflow-y: hidden;\n        padding-bottom: 20px;\n    }\n    .leftPaneTab .nav-link {\n        max-width: 280px;\n    }\n    .leftPaneTab .nav {\n        width: max-content;\n    }\n    .leftPaneTab .nav-link:not(:last-child) {\n        margin: 0 10px 0 0;\n    }\n    .leftPaneTab .nav-link::before {\n        position: absolute;\n        top: calc(100% - 0px);\n        bottom: auto;\n        border-top: 15px solid transparent;\n        border-bottom: 15px solid transparent;\n        border-left: 15px solid transparent;\n        width: 0;\n        height: 0;\n        margin: auto;\n        left: 0;\n        right: 0;\n        border-right: 15px solid transparent;\n    }\n    .leftPaneTab .nav-link.active::before {\n        border-left: 13px solid transparent;\n        top: 100%;\n        border-top: 13px solid #27a7df;\n        left: 0;\n    }\n    .banner_title {\n        font-size: 50px;\n        line-height: 59px;\n    }\n    .banner_sub_title {\n        font-size: 24px;\n        line-height: 30px;\n        margin-bottom: 20px;\n    }\n}\n\n@media (max-width: 575px) {\n    #WidgetsAlumniCarousel.owl-carousel .owl-nav button {\n        padding: 0 15px !important;\n    }\n    #WidgetsAlumniCarousel.owl-carousel .owl-nav button span {\n        display: none;\n    }\n    .position-static-for-mobile {\n        position: static !important;\n    }\n    .directory-stats-wrap {\n        padding: 10px;\n    }\n    .main_banner_text {\n        max-width: 90%;\n    }\n    .banner_title {\n        font-size: 50px;\n        line-height: 59px;\n    }\n    .banner_sub_title {\n        font-size: 24px;\n        line-height: 30px;\n        margin-bottom: 20px;\n    }\n}\n\n.lstCustForm .custom-input-wrap .select__value-container {\n    flex-wrap: wrap;\n    height: auto;\n    max-height: 141px;\n    overflow: auto;\n}\n\ninput[type='date']::-webkit-calendar-picker-indicator {\n    background: transparent;\n    bottom: 0;\n    color: transparent;\n    cursor: pointer;\n    height: auto;\n    left: 0;\n    position: absolute;\n    right: 0;\n    top: 0;\n    width: auto;\n}\n\n/* Alumni QA */\n\n.bg-liteblue-F2F9FF {\n    background-color: #f2f9ff;\n}\n\n.chat-tab .nav-link {\n    background: #ffffff;\n    border: 1px solid #0b345459;\n    border-radius: 25px;\n    opacity: 1;\n    padding: 10px 30px;\n    color: #0b3454;\n}\n.chat-tab .nav-item:not(:last-child) {\n    margin-right: 10px;\n}\n.chat-tab .nav-link.active {\n    background: #0b3454;\n    color: #fff;\n}\n\n.alumni-chat-img {\n    position: absolute;\n    bottom: -114px;\n    right: 0;\n    max-width: 240px;\n}\n\n.header-title .icon_message {\n    width: 35px;\n    height: 35px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/chat.svg) no-repeat 0 0 / 35px;\n    margin-right: 10px;\n}\n\n.alumni_chat_profile_list {\n    min-width: 300px;\n    width: 100%;\n}\n.alumni_chat_profile_list .heading {\n    font-size: 18px;\n    font-weight: 500;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    align-items: center;\n    padding: 18px 0;\n    border-bottom: 1px solid #d6d6d6;\n    height: auto;\n}\n.alumni_chat_profile_list .heading .icon_message {\n    width: 30px;\n    height: 30px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/chat.svg) no-repeat 0 0 / 30px;\n    margin-right: 10px;\n}\n.alumni_chat_profile_list ul {\n    padding: 0;\n    margin: 0;\n    list-style: none;\n    overflow-x: hidden;\n    overflow-y: auto;\n    max-height: 500px;\n}\n.alumni_chat_profile_list ul::-webkit-scrollbar {\n    width: 4px;\n}\n.alumni_chat_profile_list ul::-webkit-scrollbar-track {\n    background: #f1f1f1;\n}\n.alumni_chat_profile_list ul::-webkit-scrollbar-thumb {\n    background: #888;\n}\n.alumni_chat_profile_list ul::-webkit-scrollbar-thumb:hover {\n    background: #555;\n}\n.alumni_chat_profile_list ul li {\n    padding: 15px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n.alumni_chat_profile_list ul li.unread {\n    background: #f3f9ff;\n}\n.alumni_chat_profile_list ul li:not(:last-child) {\n    border-bottom: 1px solid #d6d6d6;\n}\n.alumni_chat_profile_list ul li a {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    text-decoration: none;\n    color: #000000;\n    font-size: 18px;\n    font-weight: 500;\n    line-height: 22px;\n}\n.alumni_chat_profile_list ul li a .img-alumni {\n    border-radius: 50%;\n    margin-right: 10px;\n    overflow: hidden;\n    width: 60px;\n}\n.alumni_chat_profile_list ul li a .alumni-name-batch {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n}\n.alumni_chat_profile_list ul li a .alumni-name-batch .alumni-batch {\n    color: #6a6868;\n    font-size: 14px;\n}\n.alumni_chat_profile_list ul li a .alumni-name-batch .alumni-message {\n    font-size: 14px;\n    font-weight: 500;\n    color: #6a6868;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical;\n    width: 100%;\n    max-width: 165px;\n}\n.alumni_chat_profile_list ul li a.del-alumni {\n    background: #ffdfe4;\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    margin-left: 15px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.alumni_chat_profile_list ul li a.del-alumni i {\n    width: 18px;\n    height: 18px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/trash.svg) no-repeat center / 100%;\n    opacity: 0.8;\n}\n.text-student {\n    color: #c38400;\n}\n.text-school {\n    color: #26a7df;\n}\n.text-alumni {\n    color: #d42941;\n}\n\n.alumni_chat_block {\n    background: #f2f9ff\n        url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/question_marks_background.png);\n    padding: 0px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    min-height: 565px;\n}\n.alumni_chat_to {\n    padding: 30px 30px 0;\n}\n.alumni_chat_to label {\n    font-weight: 500;\n    font-size: 18px;\n}\n/* .sent_too_wrap .sent_too {background: #FFFFFF;border: 1px solid #0B345459;border-radius: 25px;opacity: 1;padding: 0 18px;height: 35px;display: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex;align-items: center;} */\n.sent_too_wrap .sent_too {\n    background: #ffffff;\n    border: 1px solid #0b345459;\n    border-radius: 25px;\n    opacity: 1;\n    padding: 0 18px;\n    height: 35px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n}\n.count-unread {\n    width: 25px;\n    height: 25px;\n    border-radius: 50%;\n    background: #5cae48;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: #fff;\n    font-size: 12px;\n    font-weight: 500;\n}\n.blue-block {\n    background: transparent linear-gradient(104deg, #0062af 0%, #175381 100%) 0% 0% no-repeat padding-box;\n    padding: 24px 30px;\n    color: #fff;\n    font-size: 18px;\n    line-height: 22px;\n    position: relative;\n}\n.blue-block:after {\n    content: '';\n    position: absolute;\n    width: 0;\n    height: 0;\n}\n.blue-block p:last-child {\n    margin: 0;\n}\n.blue-block ol {\n    padding: 0 0 0 21px;\n}\n.blue-block ol:last-child {\n    margin: 0;\n}\n.justify-content-end .blue-block {\n    margin-right: 8px;\n    border-radius: 6px 6px 0px 6px;\n    -webkit-border-radius: 6px 6px 0px 6px;\n    -moz-border-radius: 6px 6px 0px 6px;\n    -ms-border-radius: 6px 6px 0px 6px;\n    -o-border-radius: 6px 6px 0px 6px;\n}\n.justify-content-end .blue-block:after {\n    right: -8px;\n    bottom: 0px;\n    border-left: 5px solid #175381;\n    border-bottom: 5px solid #175381;\n    border-top: 5px solid transparent;\n    border-right: 5px solid transparent;\n}\n.justify-content-start .blue-block {\n    margin-left: 8px;\n    border-radius: 6px 6px 6px 0px;\n    -webkit-border-radius: 6px 6px 6px 0px;\n    -moz-border-radius: 6px 6px 6px 0px;\n    -ms-border-radius: 6px 6px 6px 0px;\n    -o-border-radius: 6px 6px 6px 0px;\n}\n.justify-content-start .blue-block:after {\n    left: -8px;\n    bottom: 0px;\n    border-left: 5px solid transparent;\n    border-bottom: 5px solid #0161ac;\n    border-top: 5px solid transparent;\n    border-right: 5px solid #0161ad;\n}\n.blue-block:has(.univarietyAI) {\n    background: linear-gradient(90deg, #e9102e 16%, #043254 100%);\n    color: #ffffff;\n    color:#fff;\n}\n.blue-block:has(.univarietyAI):after {\n    border-bottom: 5px solid #e9102e;\n    border-right: 5px solid #e9102e;\n}\n.justify-content-end .blue-block:has(.univarietyAI):after {\n    border-left: 5px solid #063254;\n    border-bottom: 5px solid #063254;\n    border-top: 5px solid transparent;\n    border-right: 5px solid transparent;\n}\n.univarietyAI {\n    margin-top: 10px;\n    font-size: 13px;\n    color: #fff;\n    font-style: italic;\n}\n.univarietyAI b{\n    font-weight: 500;\n}\n\n.messages:has(.univarietyAI) > div {\n    background: linear-gradient(90deg, #e9102e 16%, #043254 100%);\n    color: #ffffff;\n    color:#fff;\n    border-radius: 10px 10px 10px 0px;\n    padding: 10px 20px;\n    margin-bottom: 10px;\n}\n\n.messages:has(.univarietyAI) p{\n    background-color: transparent;\n    border-radius: 0;\n    padding: 0;\n}\n\n.alumni_chat_conversation_send .form-control {\n    background: #ffffff 0% 0% no-repeat padding-box;\n    border: 1px solid #0b345459;\n    border-radius: 10px;\n    opacity: 1;\n}\n.alumni_chat_conversation_block {\n    max-height: 395px;\n    overflow-y: auto;\n    overflow-x: hidden;\n    min-height: 395px;\n    padding: 0 30px;\n}\n.alumni_chat_conversation_send {\n    padding: 0px 30px 30px 30px;\n}\n.get_started {\n    text-align: center;\n}\n.get_started .get_started_like {\n    width: 54px;\n    height: 62px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/star-like.svg) no-repeat 0 0;\n    margin-bottom: 20px;\n}\n.get_started h3 {\n    font-size: 28px;\n    font-weight: 600;\n}\n\n.liteblue-border-block {\n    background: #fff;\n    padding: 24px 30px;\n    color: #000;\n    font-size: 18px;\n    line-height: 22px;\n    position: relative;\n    border: 1px solid #afdafb;\n}\n.liteblue-border-block::after {\n    content: '';\n    position: absolute;\n    width: 15px;\n    height: 15px;\n    background: #fff;\n}\n.justify-content-end .liteblue-border-block {\n    margin-right: 8px;\n    border-radius: 6px 6px 0px 6px;\n    -webkit-border-radius: 6px 6px 0px 6px;\n    -moz-border-radius: 6px 6px 0px 6px;\n    -ms-border-radius: 6px 6px 0px 6px;\n    -o-border-radius: 6px 6px 0px 6px;\n}\n.justify-content-end .liteblue-border-block::after {\n    right: -8px;\n    bottom: -1px;\n    border-left: 1px solid #fff;\n    border-bottom: 1px solid #afdafb;\n    border-top: 1px solid #fff;\n    border-right: 1px solid #afdafb;\n    transform: skew(44deg);\n    -webkit-transform: skew(44deg);\n    -moz-transform: skew(44deg);\n    -ms-transform: skew(44deg);\n    -o-transform: skew(44deg);\n}\n.justify-content-start .liteblue-border-block {\n    margin-left: 8px;\n    border-radius: 6px 6px 6px 0px;\n    -webkit-border-radius: 6px 6px 6px 0px;\n    -moz-border-radius: 6px 6px 6px 0px;\n    -ms-border-radius: 6px 6px 6px 0px;\n    -o-border-radius: 6px 6px 6px 0px;\n}\n.justify-content-start .liteblue-border-block::after {\n    left: -8px;\n    bottom: -1px;\n    border-left: 1px solid #afdafb;\n    border-bottom: 1px solid #afdafb;\n    border-top: 1px solid #fff;\n    border-right: 1px solid #fff;\n    transform: skew(44deg);\n    -webkit-transform: skew(-44deg);\n    -moz-transform: skew(44deg);\n    -ms-transform: skew(44deg);\n    -o-transform: skew(44deg);\n}\n.liteblue-border-block p:last-child {\n    margin: 0;\n}\n.liteblue-border-block ol {\n    padding: 0 0 0 21px;\n}\n.liteblue-border-block ol:last-child {\n    margin: 0;\n}\n\n.get_started_prompt a, .get_started_prompt button { display: inline-block; background: #f1feff; border: 1px solid #9dc3e9; border-radius: 25px; opacity: 1; padding: 8px 30px; text-decoration: none; font-size: 18px; color: #0B3454; transition:all 0.3s ease-in-out ; -webkit-transition:all 0.3s ease-in-out ; -moz-transition:all 0.3s ease-in-out ; -ms-transition:all 0.3s ease-in-out ; -o-transition:all 0.3s ease-in-out ; -webkit-border-radius:; -moz-border-radius:; -ms-border-radius:; -o-border-radius:; }\n.get_started_prompt a:hover,.get_started_prompt button:hover {background: #bae8ff;color: #000;}\n\n.get_started_prompt a.highlight, .get_started_prompt button.highlight {background: #fff1d1;border-color: #ffbf00;color: #895900;}\n.get_started_prompt a.highlight:hover, .get_started_prompt button.highlight:hover{background: #ffbf00;border-color: #ffbf00;color: #000;}\n\n.chat_now {\n    background: url(../images/bg-chat-now.png) no-repeat center / cover;\n    padding: 15px;\n    border-radius: 5px;\n    margin: 20px 30px 0 30px;\n}\n.chat_now + .alumni_chat_conversation_block {\n    max-height: 285px;\n    min-height: 285px;\n}\n\n.alumni_chat_conversation_header {\n    padding: 16px 30px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-bottom: 1px solid #d4e1ee;\n    position: relative;\n}\n.alumni_chat_conversation_header > i {\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    top: 0;\n    height: 17px;\n    margin: auto;\n    width: 30px;\n    text-align: center;\n    cursor: pointer;\n}\n.alumni-user-leftpane {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n}\n.alumni-user-leftpane .img-alumni {\n    margin-right: 10px;\n}\n.alumni-user-leftpane .alumni-name-batch {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n}\n.alumni-user-leftpane img {\n    width: 50px;\n    height: 50px;\n}\n.alumni-user-leftpane .alumni-name-batch .alumni-name {\n    font-size: 18px;\n    line-height: 22px;\n    color: #000;\n    font-weight: 500;\n}\n.alumni-message {\n    color: #6a6868;\n    font-size: 14px;\n}\n.mark-star label {\n    background: #f3ac19;\n    width: 25px;\n    height: 25px;\n    border-radius: 50%;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: #fff;\n    cursor: pointer;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.mark-star label .icon-star {\n    font-size: 13px;\n}\n.mark-star input:checked ~ label,\n.mark-star.selected input ~ label {\n    background: #5cae48;\n}\n\n.btn-alumni-guidance {\n    background: #d52941;\n    box-shadow: 0px 3px 14px #ab162b96;\n    border-radius: 32px;\n    position: fixed;\n    right: 25px;\n    bottom: 25px;\n    color: #fff;\n    text-decoration: none;\n    width: 163px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    align-items: center;\n    padding: 12px 20px;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.btn-alumni-guidance i {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/light-bulb.svg) no-repeat 0 0;\n    width: 35px;\n    height: 39px;\n    margin-right: 5px;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.btn-alumni-guidance span {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    line-height: 16px;\n}\n.btn-alumni-guidance:hover {\n    background: #fec458;\n}\n.btn-alumni-guidance:hover i {\n    filter: invert(24%) sepia(29%) saturate(5786%) hue-rotate(333deg) brightness(93%) contrast(95%);\n    -webkit-filter: invert(24%) sepia(29%) saturate(5786%) hue-rotate(333deg) brightness(93%) contrast(95%);\n}\n\n.post-block {\n    background: #ffffff;\n    border: 1px solid #d2d2d2;\n    border-radius: 6px;\n    opacity: 1;\n    padding: 30px;\n}\n.post-block:not(:last-child) {\n    margin-bottom: 20px;\n}\n.post-block .post-img {\n    margin-top: 20px;\n    border-radius: 50%;\n    width: 60px;\n    height: 60px;\n    overflow: hidden;\n}\n.post-block .post-img img {\n    width: auto;\n    height: 100%;\n}\n.post-block .brife {\n    margin: 0;\n    max-width: 700px;\n} /*overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;*/\n.post-head {\n    background: #ffecc5 0% 0% no-repeat padding-box;\n    border-radius: 4px;\n    display: inline-block;\n    font-size: 12px;\n    padding: 4px 10px;\n    font-weight: 500;\n    margin-bottom: 5px;\n}\n.post-alumni-name {\n    font-size: 18px;\n    font-weight: 600;\n}\n.post-alumni-batch {\n    color: #6a6868;\n    font-size: 14px;\n    font-weight: 500;\n}\n\n.answered_wrap .post-head {\n    background: #bdf6af;\n}\n.answered_wrap .post-img {\n    margin: 0;\n    width: 40px;\n    height: 40px;\n}\n.answered_wrap p {\n    margin: 0;\n}\n\n.more-answer {\n    margin-left: 55px;\n    color: #26a7df;\n}\n.more-answer:hover {\n    margin-left: 55px;\n    color: #0b8ac2;\n}\n.tags-wrap {\n    max-width: 745px;\n}\n.tags-wrap span {\n    background: #fee9bd;\n    border-radius: 15px;\n    padding: 5px 18px;\n    font-size: 14px;\n    margin-bottom: 5px;\n    font-weight: 500;\n}\n.tags-wrap span:not(:last-child) {\n    margin-right: 5px;\n}\n.tags-wrap span + span {\n    background: #c2e9fe;\n}\n.tags-wrap span + span + span {\n    background: #fed7dc;\n}\n.tags-wrap span + span + span + span {\n    background: #f8bef6;\n}\n.tags-wrap span + span + span + span + span {\n    background: #e5d8ff;\n}\n\n.video_block_img .icon-invert-play {\n    position: absolute;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    font-size: 50px;\n    color: white;\n    z-index: 9;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    opacity: 0.9;\n}\n\n.btn-gray-edit {\n    background: #ffffff;\n    border: 1px solid #d1d1d1;\n    border-radius: 18px;\n    padding: 8px 18px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    color: #26a7df;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.btn-gray-edit:hover {\n    background: #0b3454;\n    border-color: #0b3454;\n}\n.btn-gray-edit i {\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.btn-gray-edit:hover .pencil-edit {\n    filter: brightness(0) invert(1);\n    -webkit-filter: brightness(0) invert(1);\n}\n\n.mark-flag .icon-flag {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/black-flag.svg) no-repeat 0 0 / 20px;\n    width: 20px;\n    height: 20px;\n    margin-right: 5px;\n}\n.mark-flag label {\n    cursor: pointer;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n}\n.mark-flag input:checked ~ label .icon-flag {\n    filter: invert(50%) sepia(99%) saturate(3201%) hue-rotate(71deg) brightness(96%) contrast(103%);\n    -webkit-filter: invert(50%) sepia(99%) saturate(3201%) hue-rotate(71deg) brightness(96%) contrast(103%);\n}\n.mark-flag input:checked ~ label span {\n    font-weight: 500;\n    color: #5cae48;\n}\n.horizontal-divider {\n    border-left: 1px solid #d2d2d2;\n    margin: 0 3px;\n}\n\n.conversation-badge {\n    background: #ffffff;\n    border: 1px solid #c5c5c5f2;\n    opacity: 1;\n    width: 40px;\n    height: 40px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    color: #4a7394;\n    font-size: 22px;\n}\n\n@media (max-width: 767px) {\n    .alumni_chat_block {\n        position: fixed;\n        left: 0;\n        right: 0;\n        top: 0;\n        bottom: 0;\n        z-index: 99;\n        min-height: 0;\n    }\n    .alumni_chat_conversation_block {\n        flex: 0;\n        flex-basis: calc(100% - 183px);\n        min-height: initial;\n        max-height: initial;\n    }\n    .get_started h3{\n        font-size: 20px;\n    }\n    .get_started_prompt a, .get_started_prompt button{\n        font-size: 15px;\n    }\n}\n\n@media (max-width: 575px) {\n    .alumni-chat-img {\n        position: absolute;\n        bottom: -28px;\n        right: 0;\n        max-width: 130px;\n    }\n    .post-block {\n        padding: 20px;\n    }\n}\n\n@media (max-width: 480px) {\n    .post-brife-answer {\n        margin-left: -77px;\n    }\n}\n\n/* widget 13062024 css */\n\n.filter-white {\n    filter: brightness(0) invert(1);\n    -webkit-filter: brightness(0) invert(1);\n}\n\n.left-100 {\n    left: 100%;\n}\nnav .new {\n    font-size: 14px;\n    background: #5cae48;\n    padding: 0 10px;\n    border-radius: 25px;\n    color: #fff;\n    margin-left: 5px;\n}\n\n.filter-toggle-wrap {\n    position: absolute;\n    top: -10px;\n    right: 30px;\n}\n.filter-toggle-wrap a {\n    background: #ffffff;\n    border: 1px solid #b4b4b4;\n    border-radius: 20px;\n    padding: 7px 25px;\n    text-decoration: none;\n    display: inline-block;\n    color: #474747;\n    margin: 0 2px;\n}\n.filter-toggle-wrap a.active {\n    background: #5cae48;\n    color: #fff;\n    border-color: #5cae48;\n}\n\n.filter-sort {\n    position: absolute;\n    right: 40px;\n    top: 13px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    font-size: 14px;\n}\n.filter-sort .double-arrow {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n    margin-left: 10px;\n}\n.filter-sort .double-arrow:before {\n    content: '';\n    width: 0;\n    height: 0;\n    border-left: 4px solid transparent;\n    border-right: 4px solid transparent;\n    border-bottom: 4px solid #949494;\n    margin-bottom: 1px;\n}\n.filter-sort .double-arrow:after {\n    content: '';\n    width: 0;\n    height: 0;\n    border-left: 4px solid transparent;\n    border-right: 4px solid transparent;\n    border-top: 4px solid #949494;\n}\n\n.verify_massrecruiter {\n    margin: -6px 0 0 70px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    width: calc(100% - 70px);\n}\n.verify_massrecruiter ul {\n    padding: 0;\n    margin: 0;\n    list-style: none;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    color: #0b3454;\n}\n.verify_massrecruiter ul li {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    align-items: center;\n}\n.verify_massrecruiter ul li i {\n    margin-right: 5px;\n}\n.verify_massrecruiter ul .verify {\n    width: 19px;\n    height: 24px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/green-verified.svg) no-repeat 0 0 /\n        100%;\n    display: inline-block;\n}\n.verify_massrecruiter ul .massrecruiter {\n    width: 23px;\n    height: 23px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/search-user.svg) no-repeat 0 0 / 100%;\n    display: inline-block;\n}\n.verify_massrecruiter ul li:not(:last-child) {\n    border-right: 1px solid #dedcdc;\n    padding-right: 10px;\n    margin-right: 10px;\n}\n.confirmRecruiter {\n    background: #ffffff;\n    border: 2px solid #474747;\n    border-radius: 18px;\n    padding: 3px 15px;\n}\n\n.alumni_univarsity_subject i.icon-brifecase {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/small-brifecase.svg) no-repeat 0 0 /\n        100%;\n    filter: brightness(0) invert(0);\n    -webkit-filter: brightness(0) invert(0);\n}\n\n.report-block-list ul.verticleListDesktop li {\n    width: 100%;\n    padding: 0;\n}\n.report-block-list ul li:not(:last-child) {\n    margin-bottom: 5px;\n}\n.report-block-list ul li span {\n    width: calc(100% - 22px);\n    line-height: 18px;\n}\n.report-block-list ul li i.lite-dark-blue {\n    background: #256298;\n}\n\n.queriesStatsVerticleReport-col.single-progress .progress {\n    width: 100%;\n    background-color: #f1f1f160;\n}\n.queriesStatsVerticleReport-col.single-progress .progress .progress-bar::before {\n    bottom: calc(100% + 2px);\n    color: black;\n    font-size: 20px;\n    font-weight: 500;\n}\n.mint-green {\n    background-color: #4bc0c0;\n}\n.lite-dark-blue {\n    background-color: #256298;\n}\n.dark-yellow {\n    background-color: #efd17d;\n}\n.queriesStatsVerticleReport-col .dark-blue {\n    background-color: #0b3454;\n}\n.queriesStatsVerticleReport-col .lite-blue {\n    background-color: #26a7df;\n}\n.queriesStatsVerticleReport-col.single-progress.w-78 {\n    width: 78px;\n}\n.queriesStatsVerticleReport .queriesStatsVerticleReport-col.single-progress.w-78 .progress-wrap {\n    height: 275px;\n}\n.queriesStatsVerticleReport-col.single-progress.w-78:not(:last-child) {\n    margin-right: 12px;\n}\n\n.verticalslant {\n    padding: 40px 0 0 12px;\n    margin: 0;\n    text-orientation: mixed;\n    transform: rotate(180deg);\n    -webkit-transform: rotate(180deg);\n    -moz-transform: rotate(180deg);\n    -ms-transform: rotate(180deg);\n    -o-transform: rotate(180deg);\n    white-space: nowrap;\n    writing-mode: vertical-rl;\n    -webkit-writing-mode: vertical-rl;\n    -ms-writing-mode: vertical-rl;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    text-align: center;\n    justify-content: center;\n    font-weight: 500;\n}\n\n.message_spotlight h2 {\n    text-align: center;\n    position: relative;\n    margin: 0 0 50px;\n    font-size: 26px;\n}\n.message_spotlight h2:before {\n    content: '';\n    position: absolute;\n    top: calc(100% + 12px);\n    left: 0;\n    right: 0;\n    margin: auto;\n    width: 60px;\n    height: 3px;\n    background: #d42941;\n}\n.message_spotlight .message_university_block h2:before {\n    background: #5cae48;\n}\n.alumni_spotlight_block .alumni-card-wrap .alumni-card-slider .alumni-card {\n    padding-top: 0;\n}\n\n.x-scroll {\n    overflow-y: hidden;\n    overflow-x: auto;\n    scrollbar-width: thin;\n    padding-bottom: 10px;\n    margin-bottom: 10px;\n}\n.x-scroll::-webkit-scrollbar {\n    height: 4px;\n}\n.x-scroll::-moz-scrollbar {\n    height: 4px;\n}\n.x-scroll::-webkit-scrollbar-track {\n    background: #ccc;\n}\n.x-scroll::-webkit-scrollbar-thumb {\n    background-color: #666;\n    border-radius: 20px;\n    border: 2px solid #666;\n}\n.welcome .custom_tab .nav {\n    margin: 0;\n    min-width: 950px;\n    border-bottom: 2px solid #e4edf4;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: space-between;\n}\n.welcome .custom_tab .nav .nav-item {\n    border: 0;\n    margin: 0;\n}\n.welcome .custom_tab .nav .nav-item .nav-link {\n    box-shadow: none;\n    border: 0 !important;\n    margin: 0;\n    overflow: visible;\n    background: none;\n    font-size: 20px;\n    font-weight: 600;\n    padding: 23px;\n    position: relative;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    cursor: pointer;\n    white-space: nowrap;\n    color: #000;\n}\n.welcome .custom_tab .nav .nav-item .nav-link.active {\n    color: #5cae48;\n}\n.welcome .custom_tab .nav .nav-item .nav-link:hover {\n    color: #000;\n}\n.welcome .custom_tab .nav .nav-item .nav-link::before {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: -4px;\n    width: 0;\n    background: #5cae48;\n    height: 5px;\n    border-radius: 0;\n    margin: auto;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.welcome .custom_tab .nav .nav-item .nav-link::after {\n    display: none;\n}\n.welcome .custom_tab .nav .nav-item .nav-link.active:before {\n    width: 100%;\n}\n.welcome .custom_tab .tab-content {\n    background: none;\n    padding: 40px 0 0;\n    border: none;\n}\n.welcome .custom_tab .nav-tabs > li.active > a:focus,\n.welcome .nav-tabs > li > a:hover {\n    background: none;\n}\n.custom_tab .row {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n}\n.custom_tab .vc_row {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n}\n.flex-row-reverse {\n    flex-direction: row-reverse;\n}\n.custom_tab {\n    margin-top: 30px;\n}\n.custom_tab h3 {\n    font-size: 32px;\n    line-height: 32px;\n    font-weight: 500;\n    color: #000 !important;\n    margin: 0 0 28px;\n    text-transform: capitalize;\n    position: relative;\n    padding-bottom: 0;\n}\n.checked-list {\n    padding: 0;\n    margin: 0 0 30px;\n    list-style: none;\n    font-size: 18px;\n    line-height: 26px;\n}\n.checked-list li:not(:last-child) {\n    margin-bottom: 24px;\n}\n.checked-list li {\n    padding: 0 0 0 26px;\n    position: relative;\n    color: #000;\n    font-size: 18px;\n    line-height: 26px;\n}\n.checked-list li:before {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 5px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/check.svg) no-repeat 0 0;\n    width: 16px;\n    height: 16px;\n}\n.btn-signUp {\n    background: #5cae48;\n    opacity: 1;\n    width: 140px;\n    height: 40px;\n    line-height: 40px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #fff;\n    font-size: 18px;\n    font-weight: 500;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    position: relative;\n    border-radius: 25px;\n    overflow: hidden;\n    border: 2px solid #5cae48;\n    text-transform: capitalize;\n    -webkit-border-radius: 25px;\n    -moz-border-radius: 25px;\n    -ms-border-radius: 25px;\n    -o-border-radius: 25px;\n    text-decoration: none;\n}\n.btn-signUp:hover {\n    background: #fff;\n    color: #0b3454;\n    text-decoration: none !important;\n    border-color: #0b3454;\n}\n\n.threecardslider .item {\n    padding: 4px;\n}\n.gray-box {\n    box-shadow: 0px 2px 3px #0000001a;\n    border: 1px solid #0034571a;\n    border-radius: 10px;\n    padding: 30px;\n    overflow: hidden;\n    position: relative;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n.gray-box > div {\n    position: relative;\n}\n.gray-box:before {\n    content: '';\n    height: 80px;\n    background: #f0f0f0;\n    position: absolute;\n    left: -10px;\n    right: -10px;\n    top: -10px;\n    transform: skewY(1deg);\n    -webkit-transform: skewY(1deg);\n    -moz-transform: skewY(1deg);\n    -ms-transform: skewY(1deg);\n    -o-transform: skewY(1deg);\n}\n.gray-box-img-wrap {\n    width: 80px;\n    height: 80px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/star-graph.svg) no-repeat center /\n        100%;\n    margin-bottom: 20px;\n    padding: 10px;\n}\n.gray-box-img-wrap .gray-box-img {\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n    border: 2px solid #fff;\n    border-radius: 50%;\n    -webkit-border-radius: 50%;\n    -moz-border-radius: 50%;\n    -ms-border-radius: 50%;\n    -o-border-radius: 50%;\n}\n.gray-box .brife {\n    text-align: center;\n    line-height: 20px;\n    position: relative;\n}\n.gray-box-post-date {\n    position: relative;\n    margin-top: 15px;\n    padding-top: 15px;\n    text-align: center;\n    font-size: 14px;\n}\n.gray-box-post-date:before {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: -1px;\n    width: 50px;\n    height: 3px;\n    background: #53a132;\n    margin: auto;\n}\n\n.threecardslider.owl-theme .owl-dots {\n    display: none;\n}\n/* .threecardslider.owl-theme .owl-nav {display: block !important;margin: 0;} */\n.threecardslider.owl-theme .owl-nav button {\n    background: #fff;\n    width: 36px;\n    height: 36px;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    margin: auto !important;\n    border: 1px solid #0b34544d;\n    border-radius: 10px;\n    font-size: 0;\n}\n.threecardslider.owl-theme .owl-nav button::before {\n    content: '';\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='black' stroke='black' stroke-linecap='round' stroke-linejoin='round' stroke-width='1' d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e\");\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    background-size: 18px;\n    background-repeat: no-repeat;\n    background-position: left 7px center;\n}\n.threecardslider.owl-theme .owl-nav button.owl-prev {\n    left: -50px;\n}\n.threecardslider.owl-theme .owl-nav button.owl-next {\n    right: -50px;\n    transform: scaleX(-1);\n}\n\n.btn-blue .icon-play {\n    width: 18px;\n    height: 18px;\n    background: #fff;\n    border-radius: 50%;\n    margin-right: 5px;\n    position: relative;\n}\n.btn-blue .icon-play:before {\n    content: '';\n    width: 0;\n    height: 0;\n    border-top: 4px solid transparent;\n    border-bottom: 5px solid transparent;\n    border-left: 5px solid #26a7df;\n    margin: auto;\n    position: absolute;\n    left: 8px;\n    top: 5px;\n}\n\n.job-box {\n    border: 1px solid #c3d4e2;\n    border-radius: 6px;\n    overflow: hidden;\n    height: 100%;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n}\n.btn-border-gray:hover img[src*='icon'] {\n    filter: brightness(0) invert(1);\n}\n\n.merchandise-block {\n    width: 100%;\n    height: 350px;\n    border-radius: 6px;\n    overflow: hidden;\n    position: relative;\n    background: #d0cecf;\n}\n.merchandise-block.gold {\n    background-color: #ffcd56;\n}\n.product-name-price {\n    position: absolute;\n    left: 3px;\n    right: 3px;\n    bottom: 3px;\n    margin: auto;\n    background: #fff;\n    padding: 15px;\n    border-radius: 6px;\n    text-align: center;\n}\n\n.offer-block {\n    background: #ffffff;\n    border: 1px solid #d2d2d2;\n    border-radius: 6px;\n    overflow: hidden;\n    margin-left: 2px;\n}\n.offer-block .brand-logo {\n    height: 118px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0 20px;\n}\n.coupon_offer {\n    padding: 20px;\n    background: #f4faff;\n}\n.givingBackSchool {\n    background-color: #f4f4f4;\n}\n.alumni-block {\n    box-shadow: 0px 20px 40px #88949b29;\n    border-radius: 4px;\n    padding: 50px;\n}\n.alumni-block:not(:last-child) {\n    margin-bottom: 40px;\n}\n.alumni-block.monitor {\n    background: #fff;\n}\n.alumni-block.careerTalk {\n    background: #fff;\n}\n.alumni-block h3 {\n    font-size: 32px;\n    font-weight: 600;\n    line-height: 50px;\n    color: #2d2d2d;\n    margin: 0 0 5px;\n}\n.givingBackSchool .alumni-block p {\n    font-size: 18px;\n    line-height: 28px;\n    color: #000;\n    margin: 0 0 20px !important;\n    text-align: left;\n    opacity: 1;\n    margin-bottom: 20px;\n}\n.btn-interested {\n    background: #5cae48;\n    opacity: 1;\n    width: auto;\n    height: 40px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #fff;\n    font-size: 18px;\n    font-weight: 500;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    position: relative;\n    overflow: hidden;\n    border: 2px solid #5cae48;\n    text-transform: capitalize;\n    border-radius: 4px;\n    -webkit-border-radius: 4px;\n    -moz-border-radius: 4px;\n    -ms-border-radius: 4px;\n    -o-border-radius: 4px;\n    padding: 0 28px;\n    text-decoration: none;\n}\n.btn-interested:hover {\n    background: #fff;\n    color: #0b3454;\n    text-decoration: none !important;\n    border-color: #0b3454;\n}\n\n.icon-selected-user {\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/selected-user.svg) no-repeat 0 0;\n    width: 31px;\n    height: 27px;\n    display: inline-block;\n}\n.block-header {\n    width: 100%;\n    display: inline-block;\n    padding: 17px 30px;\n    border-bottom: 1px solid #d5d3d3;\n}\n.block-custom-tab {\n    margin-top: 50px;\n    margin-left: 40px;\n}\n.btn-border-lite-blue {\n    border: 1px solid #26a7df;\n    border-radius: 6px;\n    opacity: 1;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    height: 40px;\n    color: #26a7df;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.btn-border-lite-blue .icon-note {\n    filter: invert(72%) sepia(36.1%) saturate(530%) hue-rotate(165deg) brightness(93%) contrast(87%);\n    -webkit-filter: invert(72%) sepia(36.1%) saturate(530%) hue-rotate(165deg) brightness(93%) contrast(87%);\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.btn-border-lite-blue i img {\n    filter: invert(51%) sepia(93%) saturate(720%) hue-rotate(165deg) brightness(94%) contrast(85%);\n}\n.btn.btn-border-lite-blue:hover {\n    background: #26a7df;\n    color: #fff;\n}\n.btn-border-lite-blue:hover .icon-note,\n.btn-border-lite-blue:hover i img {\n    filter: brightness(0) invert(1);\n    -webkit-filter: brightness(0) invert(1);\n}\n.block-custom-tab .nav-item:not(:last-child) {\n    margin-right: 20px;\n}\n.block-custom-tab .nav-item .nav-link {\n    padding: 0 0 6px;\n    background: none;\n    color: #000000;\n    font-weight: 500;\n    position: relative;\n}\n.block-custom-tab .nav-item .nav-link.active {\n    color: #5cae48;\n    font-weight: 600;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.block-custom-tab .nav {\n    justify-content: center;\n}\n.block-custom-tab .nav.custom-sub-tab {\n    justify-content: start;\n}\n\n.block-custom-tab .nav-item .nav-link:before {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    margin: auto;\n    border-bottom: 2px solid #5cae48;\n    width: 0;\n    opacity: 0;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.block-custom-tab .nav-item .nav-link.active:before {\n    width: 100%;\n    opacity: 1;\n}\n\n.custom-sub-tab .nav-link {\n    width: 175px;\n    border-radius: 0;\n    font-size: 16px;\n    font-weight: 500;\n    text-align: left;\n    color: #000;\n    border-left: 4px solid #fff;\n    border-radius: 6px 0 0 6px;\n    padding: 15px 20px;\n}\n.custom-sub-tab .nav-link.active {\n    background: #f2f4f7;\n    color: #000;\n    border-color: #5cae48;\n}\n\n.btn-green .icon-question.circle {\n    border-radius: 50%;\n    border: 2px solid #fff;\n    padding: 2px;\n    font-size: 12px;\n    width: 22px;\n    height: 22px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-right: 4px;\n}\n\n.listed-border {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    align-items: center;\n    background: #ffffff;\n    border: 1px solid #dde4ee;\n    border-radius: 6px;\n    min-height: 50px;\n    padding: 10px 20px;\n}\n.listed-border:not(.disabled) {\n    background-color: #26a7df;\n    border-color: #26a7df;\n    color: #fff;\n}\n.listed-border:not(.disabled) .tick:before {\n    border-color: #fff;\n}\n.listed-border.disabled {\n    opacity: 0.4;\n}\n.listed-border.disabled .note-wrap {\n    display: none;\n}\n.listed-border .tick:before {\n    content: '';\n    position: absolute;\n    width: 15px;\n    height: 7px;\n    border-left: 3px solid #000;\n    border-bottom: 3px solid #000;\n    transform: rotate(-40deg);\n    -webkit-transform: rotate(-40deg);\n    -moz-transform: rotate(-40deg);\n    -ms-transform: rotate(-40deg);\n    -o-transform: rotate(-40deg);\n}\n.listed-border .tick {\n    position: relative;\n    width: 15px;\n    height: 11px;\n}\n.listed-border p {\n    margin: 0 16px;\n    width: calc(100% - 78px);\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n}\n.listed-border.red {\n    background-color: #c10101;\n    border-color: #c10101;\n    color: #fff;\n}\n.listed-border.red .tick:before {\n    border-color: #fff;\n}\n.listed-border.red .note-wrap {\n    background: #9b0e0e;\n}\n.note-wrap {\n    width: 30px;\n    height: 30px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: #0a6e9a;\n    border-radius: 50%;\n}\n.note-wrap .icon-note {\n    width: 12px;\n    height: 15px;\n    background-size: 100%;\n    filter: brightness(0) invert(1);\n    -webkit-filter: brightness(0) invert(1);\n}\n.blue-link {\n    color: #1664bc;\n}\n.blue-link:hover {\n    color: #5cae48;\n}\n\n.meter-wrap {\n    width: 40px;\n    height: 40px;\n    padding: 3px;\n    background: #fff;\n    border-radius: 50%;\n    position: relative;\n}\n.meter-icon {\n    border-top: 10px solid #f2c32f;\n    border-left: 10px solid #e03f4f;\n    border-right: 10px solid #1ea56b;\n    border-radius: 50%;\n    position: absolute;\n    left: 2px;\n    right: 2px;\n    top: 2px;\n    bottom: 2px;\n    border-bottom: 10px solid transparent;\n}\n.meter-icon:before {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    width: 7px;\n    height: 7px;\n    background: #000;\n    border-radius: 50%;\n}\n.pointer-pin {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n}\n.meter-icon .pointer-pin:after {\n    content: '';\n    position: absolute;\n    width: 0;\n    height: 0;\n    border-top: 2px solid transparent;\n    border-bottom: 2px solid transparent;\n    border-right: 13px solid #000;\n    left: -7px;\n    top: 5.7px;\n}\n\n.meter-title{font-size: 10px;font-weight: 600;text-align: center; margin-top: 1px;width:35px;text-align: center;}\n\n.meter-wrap.positive .meter-icon .pointer-pin {\n    transform: rotate(175deg);\n    -webkit-transform: rotate(175deg);\n    -moz-transform: rotate(175deg);\n    -ms-transform: rotate(175deg);\n    -o-transform: rotate(175deg);\n}\n.meter-wrap.neutral .meter-icon .pointer-pin {\n    transform: rotate(90deg);\n    -webkit-transform: rotate(90deg);\n    -moz-transform: rotate(90deg);\n    -ms-transform: rotate(90deg);\n    -o-transform: rotate(90deg);\n}\n.icon-open-folder {\n    width: 17px;\n    height: 17px;\n    display: inline-block;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/open-folder.svg) no-repeat center /\n        100%;\n}\n\n.disabled-text {\n    color: #000;\n    opacity: 0.4;\n    font-weight: 500;\n}\n\n@media (min-width: 575px) and (max-width: 1150px) {\n    .verify_massrecruiter {\n        margin: 0px 0 0 70px;\n    }\n    .verify_massrecruiter .confirmRecruiter {\n        margin-top: 10px;\n    }\n    .verify_massrecruiter ul li {\n        margin-top: 5px;\n        margin-bottom: 5px;\n    }\n}\n\n@media (max-width: 1139px) {\n    .threecardslider.owl-theme .owl-nav button {\n        position: relative;\n        margin: 0 4px !important;\n        left: auto !important;\n        top: auto;\n        bottom: auto;\n        right: auto !important;\n    }\n}\n\n@media (min-width: 991px) {\n    .half-pink::after {\n        position: absolute;\n        content: '';\n        top: 0;\n        bottom: 0;\n        right: 0;\n        background: #ffeff1;\n        width: 40%;\n    }\n}\n\n@media (max-width: 991px) {\n    .report-block-list ul.verticleListDesktop li {\n        width: auto;\n        padding-right: 15px;\n    }\n    .report-block-list ul li span {\n        white-space: nowrap;\n    }\n}\n\n@media (min-width: 768px) {\n    .alumni_directory_filter #additionalfilter .fiterItem.col4 {\n        width: 24.1%;\n    }\n}\n@media (max-width: 767px) {\n    .filter-toggle-wrap {\n        top: 10px;\n    }\n    .filter-toggle-wrap a {\n        padding: 4px 15px;\n    }\n    .report-block-list ul.verticleListTabMobile li {\n        width: 100%;\n    }\n    .block-custom-tab {\n        margin-left: 0;\n    }\n    .block-custom-tab .nav.custom-sub-tab {\n        justify-content: center;\n        margin-top: 30px;\n    }\n    .custom-sub-tab .nav-link {\n        border-top: 4px solid white;\n        border-radius: 6px 6px 0px 0;\n        border-left: none;\n        text-align: center;\n        width: auto;\n        white-space: nowrap;\n    }\n}\n\n@media (max-width: 575px) {\n    .verify_massrecruiter {\n        width: 100%;\n    }\n    .block-header {\n        padding: 17px 17px;\n    }\n    .block-custom-tab .nav.custom-sub-tab {\n        justify-content: start;\n        overflow: auto;\n        flex-wrap: nowrap;\n        width: 100%;\n        padding: 0 5px;\n    }\n}\n\n.message_date label {\n    color: #919191;\n    cursor: pointer;\n}\n.message_date label.dislike {\n    -moz-transform: scale(-1) translateY(0px);\n    -webkit-transform: scale(-1) translateY(0px);\n    -o-transform: scale(-1) translateY(0px);\n    -ms-transform: scale(-1) translateY(0px);\n    transform: scale(-1) translateY(0px);\n    display: inline-block;\n    vertical-align: top;\n    color: #919191;\n}\n.message_date input:checked + label[for='like'],\n.message_date input:checked + label.like {\n    color: #5cae48;\n}\n.message_date input:checked + label[for='dislike'],\n.message_date input:checked + label.dislike {\n    color: #333;\n}\n.updateadditionalinformation .custom-multi-select {\n    border: 1px solid #e5e5e5 !important;\n    border-radius: 6px;\n    -webkit-border-radius: 6px;\n    -moz-border-radius: 6px;\n    -ms-border-radius: 6px;\n    -o-border-radius: 6px;\n    height: auto !important;\n}\n.updateadditionalinformation .custom-multi-select > div{\n    height: auto !important;\n}\n.updateadditionalinformation .custom-multi-select div.css-3w2yfm-ValueContainer {\n    overflow: visible;\n    white-space: normal;\n    overflow-x: visible;\n}\n.updateadditionalinformation .custom-multi-select .css-b62m3t-container .css-t3ipsp-control,\n.updateadditionalinformation .custom-multi-select .select__control,\n.updateadditionalinformation .custom-multi-select .css-13cymwt-control {\n    height: auto !important;\n}\n.updateadditionalinformation .custom-multi-select .css-b62m3t-container div[data-value] {\n    display: inline-flex !important ;\n  }\n.logoImg.cls_top_companies img {\n    max-height: 58px;\n}\n.logoImg img[src*='building.svg'] {\n    width: 40px;\n    height: auto;\n}\n\n.iframe-preview {\n    max-width: 1366px;\n    margin: 0 auto;\n    padding: 0;\n    height: 100%;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.iframe-preview.iframe-mobile {\n    max-width: 400px;\n}\n\n/* Custom Scrollbar using CSS */\n.iframe-preview {\n    overflow-y: scroll;\n}\n\n/* scrollbar width */\n.iframe-preview::-webkit-scrollbar {\n    width: 5px;\n}\n\n/* scrollbar track */\n.iframe-preview::-webkit-scrollbar-track {\n    background: #eee;\n}\n\n/* scrollbar handle */\n.iframe-preview::-webkit-scrollbar-thumb {\n    border-radius: 1rem;\n    background-color: #333;\n}\n\n.togglelinks {\n    margin: auto;\n    background: #ffffff 0% 0% no-repeat padding-box;\n    border-radius: 4px;\n    max-width: 320px;\n    width: 100%;\n    height: 50px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    overflow: hidden;\n    border: 1px solid #0b3454;\n}\n.togglelinks a {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-decoration: none;\n    color: #0b3454;\n    font-size: 16px;\n    font-weight: 600;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.togglelinks a.btn-desktop i {\n    width: 24px;\n    height: 21px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/desktop-monitor.svg);\n    margin-right: 10px;\n}\n.togglelinks a.btn-mobile i {\n    width: 14px;\n    height: 24px;\n    background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/dark-smartphone.svg);\n    margin-right: 10px;\n}\n.togglelinks a.active {\n    background: #0b3454;\n    color: #fff;\n}\n.togglelinks a.active i,\n.togglelinks a:hover i {\n    filter: invert(1) brightness(170%);\n}\n.togglelinks a:hover {\n    background: #294a64;\n    color: #fff;\n}\n.tooltip-inner {\n    background: #0b3454 !important;\n    border: 1px solid #0b3454;\n    font-size: 14px !important;\n}\n.bs-tooltip-top .tooltip-arrow::before {\n    border-top-color: #0b3454;\n}\n.eventslink_willingness {\n    color: white !important;\n}\n.form-select[disabled] {\n    pointer-events: none;\n    background-image: none !important;\n}\n.icon-yellow {\n    filter: invert(62%) sepia(61%) saturate(610%) hue-rotate(0deg) brightness(104%) contrast(92%);\n    -webkit-filter: invert(62%) sepia(61%) saturate(610%) hue-rotate(0deg) brightness(104%) contrast(92%);\n}\n\n.form-grid-section+.form-grid-section {\n    margin-top: 30px;\n}\n\n.form-grid-section {\n    padding: 25px;\n    background: #f1f1f1;\n    border-radius: 18px;\n}\n\n.form-grid-section .btn-delete {\n    top: 0;\n    bottom: 0;\n    margin: auto;\n}\n\n.shake-err {\n    animation: shake 0.2s ease-in-out 0s 2;\n    color: #FF0000;\n}\n\n@keyframes shake {\n    0% {\n        transform: translateX(0.2rem);\n    }\n\n    25% {\n        transform: translateX(0.5rem);\n    }\n\n    75% {\n        transform: translateX(-0.5rem);\n    }\n\n    100% {\n        transform: translateX(0rem);\n    }\n}\n\n.upload_section.drag-over {\n    border: 2px dashed #007bff;\n    /* Blue border to indicate drag over */\n    background-color: #f0f8ff;\n    /* Light blue background color */\n    cursor: default;\n    /* Cursor set to default or as needed */\n}\n\n.cloud-text span {\n    font-weight: bold;\n    /* Make the \"Drop here\" text bold for emphasis */\n}\n.sd_formsec label:empty {\n\tdisplay: none;\n}\n\nbody:not(.modal-open) .modal-backdrop.show{display: none !important;}\n\n\n.college-type ~ div.college-type-option {\n    display: none;\n}\n\n.college-type:checked ~ div.college-type-option {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n}\n.card.linkedin .card-header img {\n    filter: brightness(00) invert(1);\n    border-radius: 0 !important;\n    width: 22px;\n    margin-right: 10px;\n    vertical-align: top;\n}\n.form-select{border: 1px solid #b5c2cb;height: 45px;}\n\n\n.referred-college-logo img {max-height: 90px;max-width: 200px;}\n.referral-progress-card {  }\n.profileimg-name { padding: 20px; background: #0B3454; border-radius: 8px 8px 0 0; -webkit-border-radius: 8px 8px 0 0; -moz-border-radius: 8px 8px 0 0; -ms-border-radius: 8px 8px 0 0; -o-border-radius: 8px 8px 0 0; display: -webkit-box; display: -moz-box; display: -ms-flexbox; display: -webkit-flex; display: flex; flex-direction: column; align-items: center;}\n.referral-profile-detail {background: #FFFFFF;border: 1px solid #A8ACAF;border-radius: 0 0 8px 8px;-webkit-border-radius: 0 0 8px 8px;-moz-border-radius: 0 0 8px 8px;-ms-border-radius: 0 0 8px 8px;-o-border-radius: 0 0 8px 8px;padding:25px ;}\n.referral-profile-detail ul{padding: 0;margin: 0;list-style: none;}\n.referral-profile-detail ul li:not(:last-child){margin-bottom: 15px;}\n.referral-profile-detail ul li{display: -webkit-box; display: -moz-box; display: -ms-flexbox; display: -webkit-flex; display: flex;}\n.referral-profile-detail ul li i {width: 25px;height: 25px;display: -webkit-box; display: -moz-box; display: -ms-flexbox; display: -webkit-flex; display: flex;margin-right: 15px;margin-top: 2px;}\n.referral-profile-detail ul li i.hand-share{background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/deal.svg) no-repeat top center;}\n.referral-profile-detail ul li i.mobile{background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/mobile.svg) no-repeat top center;}\n.referral-profile-detail ul li i.email{background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/mail.svg) no-repeat top center;}\n.referral-profile-detail ul li i.referred {background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/referred-on.svg) no-repeat top center;}\n.referral-profile-detail ul li div{width: calc(100% - 40px);line-height: 18px;word-wrap: anywhere;}\n.referral-profile-detail ul li a{color: #358CEF; text-decoration: none;}\n.referral-profile-detail ul li a:hover{color: #0B3454;}\n.profileimg-name .img { display: -webkit-box; display: -moz-box; display: -ms-flexbox; display: -webkit-flex; display: flex; justify-content: center; align-items: center; border-radius: 50%; overflow: hidden; margin-top: -60px; width: 90px; height: 90px; box-shadow: 0 0 1px 0px #6f6f6f; -webkit-border-radius: 50%; -moz-border-radius: 50%; -ms-border-radius: 50%; -o-border-radius: 50%;}\n.profileimg-name .img img {width: auto;height: 100%;}\n.profileimg-name .profile-name {color: #fff;margin-top: 8px;font-size: 20px;font-weight: 600;}\n\n.referral-progress-track {background: #F9FCFF;border: 2px solid #0B345436;border-radius: 20px;opacity: 1;}\n.referral-progress-track ul{padding: 0;margin: 0;list-style: none;}\n.referral-progress-track ul li{display: -webkit-box; display: -moz-box; display: -ms-flexbox; display: -webkit-flex; display: flex;align-items: center;}\n.referral-progress-track ul li:not(:last-child){margin-bottom: 50px;}\n.referral-progress-track ul li .icon{width: 37px;min-width: 37px;display: -webkit-box; display: -moz-box; display: -ms-flexbox; display: -webkit-flex; display: flex;align-items: center;justify-content: center;}\n.referral-progress-track ul li .dot{ width: 26px; height: 26px;margin: 0 20px; position: relative;display: -webkit-box; display: -moz-box; display: -ms-flexbox; display: -webkit-flex; display: flex;align-items: center;justify-content: center;}\n.referral-progress-track ul li .dot i{width: 20px; height: 20px;border: 2px solid #6B6868; border-radius:50% ; -webkit-border-radius:50% ; -moz-border-radius:50% ; -ms-border-radius:50% ; -o-border-radius:50% ;background-color: #fff;}\n.referral-progress-track ul li:not(:last-child) .dot::after {content: '';position: absolute;left: 0;right: 0;margin: auto;border-right: 2px dashed #6B6868;height: calc(100% + 50px);top: 100%;width: 0;}\n.referral-progress-track ul li:not(.completed) img {filter: invert(46%) sepia(0%) saturate(14%) hue-rotate(6deg) brightness(91%) contrast(96%);-webkit-filter: invert(46%) sepia(0%) saturate(14%) hue-rotate(6deg) brightness(91%) contrast(96%);}\n.referral-progress-track ul li.completed .dot i{background: #5CAE48;border-color:#5CAE48;width: 26px;height: 26px;}\n.referral-progress-track ul li.completed .dot i::before { content: ''; position: absolute; border-left: 3px solid #fff; border-bottom: 3px solid #fff; width: 13px; height: 7px; top: 8px; left: 6px; transform: rotate(-45deg); -webkit-transform: rotate(-45deg); -moz-transform: rotate(-45deg); -ms-transform: rotate(-45deg); -o-transform: rotate(-45deg);}\n.referral-progress-track ul li.completed .dot::after{border-right: 2px solid #5CAE48;}\n.referral-progress-track ul li.completed .track-label .font-16{font-weight: 600;}\n.icon.workex-logo {border: 1px solid #ccc;padding: 10px;background: none;}\n\n\ntable.row, div[contenteditable] table {    margin: auto;}\n\ntable.row>*  {padding:inherit}\n\ntable.row tr, table.row td, div[contenteditable] table tr, div[contenteditable] table td{display: block;}\n\n.edit-controls i{font-size: 24px;cursor: pointer;}\n\n.edit-controls .icon-disable {\n    position: relative;\n    border: 1px solid #ccc;\n    border-radius: 50%;\n    padding: 5px;\n    width: 35px;\n    height: 35px;\n}\n\n.edit-controls button{\n    border: none;padding: 0;background-color: transparent;\n}\n\n.edit-controls .icon-disable:before {\n    content: '';\n    position: absolute;\n    width: 24px;\n    height: 2px;\n    background: #585555;\n    position: absolute;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    margin: auto;\n    transform: rotate(45deg);\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n}\n\ndiv.custom-multi-select div[class*=\"css\"] {\n    height: auto !important;\n    white-space: normal;\n}\n\n.lstCustForm div.custom-multi-select div[class*=\"-control\"] {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n    border: 1px solid #b5c2cb !important;\n}\n\n.dual-search{display: -webkit-box; display: -moz-box; display: -ms-flexbox; display: -webkit-flex; display: flex;-webkit-box-flex: 1;-moz-box-flex: 1;-webkit-flex: 1;-ms-flex: 1;flex: 1;}\n\n@media (max-width: 575px) {\n    .dual-search{order: -1;flex-basis: 100%; margin-bottom: 10px;} \n}\n\n.icon-plus.circle {border: 2px solid #fff;border-radius: 50%;margin-right: 7px;width: 18px;height: 18px;}\n.icon-plus.circle::before, .icon-plus.circle::after  {height: 8px;}\n\n\ndiv.owl-carousel.cardslider .owl-nav {\n  margin: 5px 0 0 45px;\n  text-align: left;display: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex;\n  \n}\n\ndiv.owl-carousel.cardslider .owl-nav button {\n  background: #0b3454;\n  padding: 2px 15px !important;\n  border-radius: 25px;\n  margin: 2px;\n  line-height: 17px;\n  display: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n}\ndiv.owl-carousel.cardslider .owl-nav button span {\n\tdisplay: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex;\n\tmargin: -2px 0 0;\n}\n\n.nav-item.disabled{\n    cursor: not-allowed !important\n}\n/* new contribution tab design */\n.block-custom-tab .video_block {background: #ffffff;border: 1px solid #d2d2d2;border-radius: 6px;overflow: hidden;text-decoration: none;position: relative;display: inline-block;color: #000;transition: all 0.3s ease-in-out;-webkit-transition: all 0.3s ease-in-out;-moz-transition: all 0.3s ease-in-out;-ms-transition: all 0.3s ease-in-out;-o-transition: all 0.3s ease-in-out;padding: 0;}\n\n.block-custom-tab  .video_block:hover{background-color: #fff;}\n.block-custom-tab  .video_block:hover,\n.block-custom-tab  .video_block:hover .icon-invert-play {\ncolor: #5cae48;\n}\n/* end contribution tab new*/\n.custom-alret {\n    padding: 10px 25px;\n    box-shadow: 0 0 4px 3px #ccc;\n    border-radius: 45px;\n    margin-bottom: 25px;\n}\n\nbutton.btn-close.w-20 {\n    width: 14px;\n    padding: 0;\n}\n\n.loaderNew {width: 50px;aspect-ratio: 1;display: grid;border: 4px solid #0000;border-radius: 50%;border-right-color: #25b09b;animation: l15 1s infinite linear;}\n.loaderNew::before,.loaderNew::after {content: \"\";grid-area: 1/1;margin: 2px;border: inherit;border-radius: 50%;animation: l15 2s infinite;}\n.loaderNew::after {margin: 8px;animation-duration: 3s;}\n\n@keyframes l15 {\n    100% {\n        transform: rotate(1turn)\n    }\n}\n\n.widget-list:not(:last-child) {border-bottom: 1px solid #e5e5e5;}\n.manage-widgets-wrap .icon-down-arrow{transition: all 0.3s ease-in-out;}\n.manage-widgets-wrap .icon-down-arrow[aria-expanded=\"true\"]{transform: rotate(180deg);}\n\n\n/* New css add 03022025 */\n\n.social-platform-wrap {width: max-content;min-width: 100%;}\n.social-platform-wrap ul {list-style: none;padding: 0;margin: 0;display: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex;}\n.social-platform-wrap ul li {background: #FFFFFF;border: 1px solid #D2D2D2;border-radius: 6px;width: 275px;height: 156px;position: relative;padding: 20px;display: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex;flex-direction: column;align-items: center;}\n.social-platform-wrap ul li:not(:last-child){margin-right: 13px;}\n.social-platform-wrap ul li .form-input-check { position: absolute; top: 20px; left: 20px; width: 20px; height: 20px; border: 1px solid #888F95; appearance: none; border-radius: 4px; transition: all 0.3s ease-in-out; -webkit-transition: all 0.3s ease-in-out; -moz-transition: all 0.3s ease-in-out; -ms-transition: all 0.3s ease-in-out; -o-transition: all 0.3s ease-in-out; -webkit-border-radius: 4px; -moz-border-radius: 4px; -ms-border-radius: 4px; -o-border-radius: 4px;cursor: pointer;}\n.social-platform-wrap ul li .form-input-check:checked{background-color: #5CAE48;border-color: #5CAE48;background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/%3e%3c/svg%3e\");}\n\n.social-platform-wrap ul li label {font-size: 18px;font-weight: 600;margin-bottom: 7px;}\n.share-copy {position: absolute;bottom: 20px;right: 20px;display: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex;}\n.share-link {background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/share-icon.svg) no-repeat 0 0;width: 22px;height: 24px;margin-right: 20px;}\n.copy-link{background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/copy-icon.svg) no-repeat 0 0;width: 22px;height: 24px;}\n.share-copy a:hover{ filter: invert(54%) sepia(40%) saturate(590%) hue-rotate(62deg) brightness(101%) contrast(94%); -webkit-filter: invert(54%) sepia(40%) saturate(590%) hue-rotate(62deg) brightness(101%) contrast(94%); }\n\n.form-check .form-check-input[disabled]:checked {\tbackground-color: #606060;\tborder-color: #626262;}\n.form-captcha {width: 100%;height: 45px;border: 1px solid #D2D2D2;display: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex;align-items: center;justify-content: center;border-radius: 4px;-webkit-border-radius: 4px;-moz-border-radius: 4px;-ms-border-radius: 4px;-o-border-radius: 4px;}\n\n/* ai chat */\n\n.btn-chat-ai { background: #5cae48; position: fixed; bottom: 40px; right: 40px; padding: 10px 20px; border-radius: 25px; text-decoration: none; color: #fff; display: -webkit-box; display: -moz-box; display: -ms-flexbox; display: -webkit-flex; display: flex; align-items: center; font-size: 18px; text-decoration: none; transition:all 0.3s ease-in-out ; -webkit-transition:all 0.3s ease-in-out ; -moz-transition:all 0.3s ease-in-out ; -ms-transition:all 0.3s ease-in-out ; -o-transition:all 0.3s ease-in-out ; }\n.btn-chat-ai i {  margin-right: 7px;}\n.btn-chat-ai:hover{color: #fff;background-color: #0b3454;}\n\n.ai-chat-wrap {height: 100vh;padding: 0;}\n.ai-chat-wrap .ai-chat {height: 100%;max-width: 1140px;width: 96%;margin: auto;border-radius: 10px;}\n.ai-chat-wrap .ai-chat .alumni_chat_block {background: none;min-height: inherit;}\n.ai-chat-wrap .ai-chat .alumni_chat_block_header {padding: 20px 0;background: transparent;border-radius: 10px 10px 0px 0px;border-bottom: 1px solid #efefef;-webkit-border-radius: 10px 10px 0px 0px;-moz-border-radius: 10px 10px 0px 0px;-ms-border-radius: 10px 10px 0px 0px;-o-border-radius: 10px 10px 0px 0px;position: relative;overflow: hidden;}\n.ai-chat-wrap .ai-chat .alumni_chat_conversation_send {padding: 30px 0;background: transparent;border-radius: 0px 0 10px 10px;border-top: 1px solid #efefef;-webkit-border-radius: 0px 0 10px 10px;-moz-border-radius: 0px 0 10px 10px;-ms-border-radius: 0px 0 10px 10px;-o-border-radius: 0px 0 10px 10px;}\n.alumni_chat_block_header i.icon-chat-invert {position: absolute;top: 0;right: 20px;font-size: 140px;width: 140px;color: #e1e1e1;}\n.ai-img { width: 70px; height: 70px; display: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex; align-items: end; background: #ededed; justify-content: center; border-radius: 50%; overflow: hidden; -webkit-border-radius: 50%; -moz-border-radius: 50%; -ms-border-radius: 50%; -o-border-radius: 50%;}\ni.icon-compose-mail {background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/message-compose.svg) no-repeat 0 0;width: 40px;height: 40px;display: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex;margin: 0;padding: 0;}\n\n.ai-chat .get_started {flex-direction: column-reverse;overflow: auto;}\n.coversation-block{flex-direction: column-reverse;overflow: auto;}\n.ai-chat .icon-turn-off {width: 15px;height: 15px;border-left: 2px solid #555;border-bottom: 2px solid #555;border-right: 2px solid #555;border-radius: 50%;border-top: 3px solid transparent;position: relative;top: -20px;right: 5px;text-decoration: none;transition: all 0.3s ease-in-out;-webkit-transition: all 0.3s ease-in-out;-moz-transition: all 0.3s ease-in-out;-ms-transition: all 0.3s ease-in-out;-o-transition: all 0.3s ease-in-out;}\n.ai-chat .icon-turn-off:before {content: '';position: absolute;left: 0;right: 0;top: auto;width: 2px;height: 8px;bottom: 5px;background: #555;margin: auto;transition: all 0.3s ease-in-out;-webkit-transition: all 0.3s ease-in-out;-moz-transition: all 0.3s ease-in-out;-ms-transition: all 0.3s ease-in-out;-o-transition: all 0.3s ease-in-out;}\n\n.ai-chat .icon-turn-off:hover{border-left: 2px solid #f0555f;border-bottom: 2px solid #f0555f;border-right: 2px solid #f0555f;}\n.ai-chat .icon-turn-off:hover:before {background: #f0555f;}\n\n.justify-content-end .date {text-align: right;}\n.user-chat .ai-img {  width: 60px; height: 60px;font-size: 48px;  color: #979797;}\n\n.rating-emoji label { background-repeat: no-repeat; background-position: center; background-size: 30px; margin-right: 10px; width: 30px; height: 30px; cursor: pointer; transition:all 0.3s ease-in-out ; -webkit-transition:all 0.3s ease-in-out ; -moz-transition:all 0.3s ease-in-out ; -ms-transition:all 0.3s ease-in-out ; -o-transition:all 0.3s ease-in-out ; background-color: #000; border: 1px solid #af8d09; border-radius: 50%; -webkit-border-radius: 50%; -moz-border-radius: 50%; -ms-border-radius: 50%; -o-border-radius: 50%; }\n.rating-emoji .sad{background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='%23ffd21f' stroke='%23343a40' stroke-linecap='' stroke-linejoin='' stroke-width='0' d='M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16M7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5m-2.715 5.933a.5.5 0 0 1-.183-.683A4.5 4.5 0 0 1 8 9.5a4.5 4.5 0 0 1 3.898 2.25.5.5 0 0 1-.866.5A3.5 3.5 0 0 0 8 10.5a3.5 3.5 0 0 0-3.032 1.75.5.5 0 0 1-.683.183M10 8c-.552 0-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5S10.552 8 10 8'/%3e%3c/svg%3e\");}\ninput[name=\"rating\"]:checked + .sad{background-color: #fff;border: 1px solid #ae000b;background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='%23ae000b' stroke='%23343a40' stroke-linecap='' stroke-linejoin='' stroke-width='0' d='M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16M7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5m-2.715 5.933a.5.5 0 0 1-.183-.683A4.5 4.5 0 0 1 8 9.5a4.5 4.5 0 0 1 3.898 2.25.5.5 0 0 1-.866.5A3.5 3.5 0 0 0 8 10.5a3.5 3.5 0 0 0-3.032 1.75.5.5 0 0 1-.683.183M10 8c-.552 0-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5S10.552 8 10 8'/%3e%3c/svg%3e\");}\n\n.rating-emoji .neutral{background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='%23ffd21f' stroke='%23343a40' stroke-linecap='' stroke-linejoin='' stroke-width='0' d='M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16M7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5m-3 4a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5M10 8c-.552 0-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5S10.552 8 10 8'/%3e%3c/svg%3e\");}\ninput[name=\"rating\"]:checked + .neutral{background-color: #fff;border: 1px solid #f1a200;background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='%23f1a200' stroke='%23343a40' stroke-linecap='' stroke-linejoin='' stroke-width='0' d='M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16M7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5m-3 4a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5M10 8c-.552 0-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5S10.552 8 10 8'/%3e%3c/svg%3e\");}\n\n.rating-emoji .happy{background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='%23ffd21f' stroke='%23343a40' stroke-linecap='' stroke-linejoin='' stroke-width='0' d='M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16M7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5M4.285 9.567a.5.5 0 0 1 .683.183A3.5 3.5 0 0 0 8 11.5a3.5 3.5 0 0 0 3.032-1.75.5.5 0 1 1 .866.5A4.5 4.5 0 0 1 8 12.5a4.5 4.5 0 0 1-3.898-2.25.5.5 0 0 1 .183-.683M10 8c-.552 0-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5S10.552 8 10 8'/%3e%3c/svg%3e\");}\ninput[name=\"rating\"]:checked + .happy{background-color: #fff;border: 1px solid #5bae47;background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='%235bae47' stroke='%23343a40' stroke-linecap='' stroke-linejoin='' stroke-width='0' d='M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16M7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5M4.285 9.567a.5.5 0 0 1 .683.183A3.5 3.5 0 0 0 8 11.5a3.5 3.5 0 0 0 3.032-1.75.5.5 0 1 1 .866.5A4.5 4.5 0 0 1 8 12.5a4.5 4.5 0 0 1-3.898-2.25.5.5 0 0 1 .183-.683M10 8c-.552 0-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5S10.552 8 10 8'/%3e%3c/svg%3e\");}\n\nul.feed-back-list {padding: 5px 0 0;margin: 0;list-style: none;max-width: 500px;}\nul.feed-back-list li:not(:last-child) {margin-bottom: 10px;}\nul.feed-back-list li{background: #f7f7f7;border-radius: 50px;-webkit-border-radius: 50px;-moz-border-radius: 50px;-ms-border-radius: 50px;-o-border-radius: 50px;padding: 12px 25px;border: 1px solid #ccc;line-height: 18px;font-size: 16px;}\n\n@media (max-width:767px){\n.ai-chat-wrap{padding: 0;}\n.ai-chat-wrap .ai-chat{ width: 100%; border-radius:0 ; -webkit-border-radius:0 ; -moz-border-radius:0 ; -ms-border-radius:0 ; -o-border-radius:0 ; }\n.ai-chat-wrap .ai-chat .alumni_chat_block_header {padding: 15px;border-radius: 0;-webkit-border-radius: 0;-moz-border-radius: 0;-ms-border-radius: 0;-o-border-radius: 0;}\n.ai-img {width: 55px;height: 55px;}\n.ai-chat-wrap .ai-chat .alumni_chat_conversation_send {padding: 30px 15px 15px;border-radius: 0;-webkit-border-radius: 0;-moz-border-radius: 0;-ms-border-radius: 0;-o-border-radius: 0;}\n.get_started_prompt a {\tpadding: 6px 20px;\tfont-size: 16px;}\nul.feed-back-list li{ border-radius: 5px; -webkit-border-radius: 5px; -moz-border-radius: 5px; -ms-border-radius: 5px; -o-border-radius: 5px; padding: 10px; }\n}\n\n.college-type ~ div.college-type-option {display: none;}\n.college-type:checked ~ div.college-type-option {display: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex;}\n\n/* .max-min-250{min-width: 250px;max-width: 250px;} */\n\n.TopperSlider .nav {justify-content: center;}\n.TopperSlider .nav .nav-item:not(:last-child){margin-right: 20px;}\n.TopperSlider .nav .nav-link {background: transparent;border: 1px solid #206EAA;position: relative;color: #fff;white-space: nowrap;}\n.TopperSlider .nav .nav-link::before { content: ''; position: absolute; bottom: 0; left: 0; right: 0; border-left: 7px solid transparent; border-right: 7px solid transparent; border-top: 7px solid #4096d9; width: 0; height: 0; margin: auto; opacity: 0; transition:all 0.3s ease-in-out ; -webkit-transition:all 0.3s ease-in-out ; -moz-transition:all 0.3s ease-in-out ; -ms-transition:all 0.3s ease-in-out ; -o-transition:all 0.3s ease-in-out ; }\n.TopperSlider .nav .nav-link.active{background-color: #4096D9;border: 1px solid #4096D9;}\n.TopperSlider .nav .nav-link.active:before{bottom: -8px;opacity: 1;}\n\n.TopperSlider .scroll{overflow-x: auto;overflow-y: hidden;}\n.TopperSlider .scroll::-webkit-scrollbar {width: 4px;}\n.TopperSlider .scroll::-webkit-scrollbar-track {background: #f1f1f1;}\n.TopperSlider .scroll::-webkit-scrollbar-thumb {background: #888;}\n.TopperSlider .scroll::-webkit-scrollbar-thumb:hover {background: #555;} \n\n\n@media (min-width:768px){\n.TopperSlider.vertical-style {display: -webkit-box; display: -moz-box; display: -ms-flexbox; display: -webkit-flex; display: flex;-webkit-box-wrap: wrap;-moz-box-wrap: wrap;-ms-flex-wrap: wrap;-webkit-wrap: wrap;flex-wrap: wrap;}\n.TopperSlider.vertical-style .scroll {width: 160px;margin-right: 20px;}\n.TopperSlider.vertical-style .tab-content {width: calc(100% - 180px);}\n.TopperSlider.vertical-style .nav{margin-top: 10px;width: 100%;}\n.TopperSlider.vertical-style .nav .nav-item{width: 100%;}\n.TopperSlider.vertical-style .nav .nav-item:not(:last-child) {\tmargin: 0 0 20px;}\n.TopperSlider.vertical-style .nav .nav-link{width: calc(100% - 15px);padding: 14px 25px;}\n.TopperSlider.vertical-style .nav .nav-link::before {bottom: 0;left: auto;right: -15px;top: 0;border-left: 7px solid #4096d9;border-right: 7px solid transparent;border-top: 7px solid transparent;border-bottom: 7px solid transparent;}\n.TopperSlider.vertical-style .threecardslider.owl-theme .owl-nav button{position: relative;margin: 0 5px !important;left: auto;right: auto;}\n}\n\n@media (max-width:767px){\n.TopperSlider .nav {justify-content: start;flex-wrap: nowrap;}\n}\n\n.card-wrap{display: -webkit-box; display: -moz-box; display: -ms-flexbox; display: -webkit-flex; display: flex;flex-direction: column;height: 100%;}\n.card-wrap .card-title {font-size: 18px;font-weight: 500;text-align: center;}\n.card-wrap .card-detail {background: #F5F5F5 ;border-radius: 12px;padding: 14px;-webkit-box-flex: 1;-moz-box-flex: 1;-webkit-flex: 1;-ms-flex: 1;flex: 1;}\n.card-wrap .card-detail .post-img{margin-bottom: 7px;}\n.noScrollBarScroll {max-height: 315px;overflow-y: auto;min-height: 315px;scrollbar-width: none;}\n.noScrollBarScroll .scroll::-webkit-scrollbar {width: 0px;}\n\n.canvas {display: -webkit-box; display: -moz-box; display: -ms-flexbox; display: -webkit-flex; display: flex;-webkit-box-wrap: wrap;-moz-box-wrap: wrap;-ms-flex-wrap: wrap;-webkit-wrap: wrap;flex-wrap: wrap;}\n.canvas-edit-tools {background: #0B3454;display: -webkit-box; display: -moz-box; display: -ms-flexbox; display: -webkit-flex; display: flex;-webkit-box-wrap: wrap;-moz-box-wrap: wrap;-ms-flex-wrap: wrap;-webkit-wrap: wrap;}\n\n.canvas-edit-tools ul {padding: 0;margin: 0;list-style: none;width: 75px;}\n.canvas-edit-tools ul li {display: -webkit-box; display: -moz-box; display: -ms-flexbox; display: -webkit-flex; display: flex;justify-content: center;align-items: center;color: #fff;border-bottom: 1px solid #236CA5;}\n.canvas-edit-tools ul li a{ padding: 20px; display: -webkit-box; display: -moz-box; display: -ms-flexbox; display: -webkit-flex; display: flex; -webkit-box-wrap: wrap; -moz-box-wrap: wrap; -ms-flex-wrap: wrap; -webkit-wrap: wrap; flex-wrap: wrap; justify-content: center; align-items: center; text-decoration: none; color: #85C5F8; min-height: 75px; width: 100%; transition:all 0.3s ease-in-out ; -webkit-transition:all 0.3s ease-in-out ; -moz-transition:all 0.3s ease-in-out ; -ms-transition:all 0.3s ease-in-out ; -o-transition:all 0.3s ease-in-out ; }\n.canvas-edit-tools ul li a i{ transition:all 0.3s ease-in-out ; -webkit-transition:all 0.3s ease-in-out ; -moz-transition:all 0.3s ease-in-out ; -ms-transition:all 0.3s ease-in-out ; -o-transition:all 0.3s ease-in-out ; }\n.canvas-edit-tools ul li a:hover, .canvas-edit-tools ul li a.active{background-color: #236CA5;color: #fff;}\n.canvas-edit-tools ul li a:hover i, .canvas-edit-tools ul li a.active i{ filter:brightness(0) invert(1) ; -webkit-filter:brightness(0) invert(1) ; }\n.canvas-main {-webkit-box-flex: 1;-moz-box-flex: 1;-webkit-flex: 1;-ms-flex: 1;flex: 1;background: #F5F5F5;display: -webkit-box; display: -moz-box; display: -ms-flexbox; display: -webkit-flex; display: flex;flex-direction: column;}\n\n.icon-resize {width: 22px;height: 22px;background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/maximize.svg) no-repeat center;}\n.icon-picture {width: 22px;height: 22px;background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/gallery.svg) no-repeat center;}\n.icon-text {width: 22px;height: 22px;background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/text.svg) no-repeat center;}\n\n.icon-original{width: 48px;height: 61px;background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/orginal.svg) no-repeat center;}\n.icon-instagram-story{width: 37px;height: 69px;background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/instagramstory.svg) no-repeat center;}\n.icon-youtube-thumbnail{width: 87px;height: 50px;background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/outubethumbnail.svg) no-repeat center;}\n.icon-facebook-profile{width: 62px;height: 62px;background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/facebookprofile.svg) no-repeat center;}\n.icon-banner{width: 87px;height: 17px;background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/banner.svg) no-repeat center;}\n.icon-large-rectangle{width: 92px;height: 36px;background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/largerectangle.svg) no-repeat center;}\n\n.canvas-edit-tools-options {border-left: 1px solid #236CA5;height: 100%;width: 0;transition: all 0.3s ease-in-out;-webkit-transition: all 0.3s ease-in-out;-moz-transition: all 0.3s ease-in-out;-ms-transition: all 0.3s ease-in-out;-o-transition: all 0.3s ease-in-out;overflow: hidden;}\n.canvas-edit-tools-options ul {display: none;-webkit-box-wrap: wrap;-moz-box-wrap: wrap;-ms-flex-wrap: wrap;-webkit-wrap: wrap;flex-wrap: wrap;width: auto;width: 300px;padding: 10px 5px;justify-content: center;}\n.canvas-edit-tools-options ul li {margin: 5px;border: none;}\n.canvas-edit-tools-options ul li a {width: 130px;height: 100%;min-height: 130px; flex-direction: column;border-radius: 5px;background: #0D3E64;padding: 10px;flex-wrap: nowrap;  text-align: center;}\n.canvas-edit-tools-options ul li a:hover{background-color: #fff;color: #0B3454;}\n.canvas-edit-tools-options ul li a:hover i{ filter:none; -webkit-filter:none; }\n.canvas-edit {background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/border-graph.svg) no-repeat 0 0 / 100%;padding: 10px;max-width: 360px;width: 100%;display: -webkit-box; display: -moz-box; display: -ms-flexbox; display: -webkit-flex; display: flex;justify-content: center;align-items: center;height: 357px;}\n.open  .canvas-edit-tools-options {width: 300px;}\n.open .canvas-edit-tools-options ul {display: -webkit-box; display: -moz-box; display: -ms-flexbox; display: -webkit-flex; display: flex;}\n\n.icon-wrap {display: -webkit-box; display: -moz-box; display: -ms-flexbox; display: -webkit-flex; display: flex;justify-content: center;align-items: center;height: 70px;margin-bottom: 5px;}\n\n.scale {background: #0B3454;display: -webkit-box; display: -moz-box; display: -ms-flexbox; display: -webkit-flex; display: flex;justify-content: center;align-items: center;height: 40px;}\n.scale a { border: 1px solid #408AC2; width: 20px; height: 20px; position: relative; margin: 0 10px; border-radius: 50%; -webkit-border-radius: 50%; -moz-border-radius: 50%; -ms-border-radius: 50%; -o-border-radius: 50%; transition:all 0.3s ease-in-out ; -webkit-transition:all 0.3s ease-in-out ; -moz-transition:all 0.3s ease-in-out ; -ms-transition:all 0.3s ease-in-out ; -o-transition:all 0.3s ease-in-out ; }\n.scale a::before{ content: ''; position: absolute; width: 10px; height: 2px; background: #408AC2; left: 0; right: 0; top: 0; bottom: 0; margin: auto; transition:all 0.3s ease-in-out ; -webkit-transition:all 0.3s ease-in-out ; -moz-transition:all 0.3s ease-in-out ; -ms-transition:all 0.3s ease-in-out ; -o-transition:all 0.3s ease-in-out ; }\n.scale a::after{ content: ''; position: absolute; width: 10px; height: 2px; background: #408AC2; left: 0; right: 0; top: 0; bottom: 0; margin: auto; transition:all 0.3s ease-in-out ; -webkit-transition:all 0.3s ease-in-out ; -moz-transition:all 0.3s ease-in-out ; -ms-transition:all 0.3s ease-in-out ; -o-transition:all 0.3s ease-in-out ; }\n.scale a.btn-plus::after{ transform:rotate(90deg) ; -webkit-transform:rotate(90deg) ; -moz-transform:rotate(90deg) ; -ms-transform:rotate(90deg) ; -o-transform:rotate(90deg) ; }\n.scale a:hover{background: #408AC2;}\n.scale a:hover::before, .scale a:hover::after{background: #fff;}\n\n.scale .range {width: 180px;}\n.scale .range .progress {height: 2px;border-radius: 5px;background: #074D83;overflow: visible;}\n.scale .range .progress .progress-bar {background: #fff;position: relative;overflow: visible;}\n.scale .range .progress .progress-bar:after {content: '';position: absolute;background: #0b3454;width: 12px;height: 12px;border: 2px solid #fff;right: -6px;border-radius: 50%;}\n\n.canvas-main .icon-picture {width: 90px;height: 90px;background-size: 100%;filter: brightness(0) invert(0);opacity: 0.5;margin-bottom: 15px;}\n\n.btn.btn-open {background: #F5F5F5;border: 1px solid #6B6868;padding: 3px 30px 5px;border-radius: 25px;font-weight: 500;transition:all 0.3s ease-in-out ;-webkit-transition:all 0.3s ease-in-out ;-moz-transition:all 0.3s ease-in-out ;-ms-transition:all 0.3s ease-in-out ;-o-transition:all 0.3s ease-in-out ;}\n.btn.btn-open:hover{background: #6B6868;color: #fff;}\n\n.canvas-photos-library {\twidth: 300px;}\n.canvas-photos-library > div{padding: 12px;}\n.canvas-photos-library > div:first-child{border-bottom: 1px solid #236CA5;}\n.search-photos .form-control {\tborder: none;\theight: 40px;}\n.canvas-photos-library .link{color: #6AABDD;text-decoration: none;}\n.canvas-photos-library .link:hover{color: #fff;}\n.canvas-text {padding: 15px;height: 100%;width: 300px;} \n.text-block {background: #fff;border-radius: 8px;padding: 15px;}\n.height-90 {height: 90px;}\n.color-wrap {background: #FFFFFF;border-radius: 4px;padding: 10px;display: -webkit-box; display: -moz-box; display: -ms-flexbox; display: -webkit-flex; display: flex;}\n.color-wrap label {margin-right: 8px;font-weight: 600;}\n.color-wrap input {border: none;width: 22px;height: 22px;border-radius: 5px;}\n\n.text-color-236CA5{color: #236CA5;}\n.btn-back-text {background: transparent;border: 2px solid #fff;border-radius: 25px;height: 40px;color: #fff;transition:all 0.3s ease-in-out ;-webkit-transition:all 0.3s ease-in-out ;-moz-transition:all 0.3s ease-in-out ;-ms-transition:all 0.3s ease-in-out ;-o-transition:all 0.3s ease-in-out ;}\n.btn-back-text:hover{background: #fff;color: #000;}\n\n.color-field { display: -webkit-box; display: -moz-box; display: -ms-flexbox; display: -webkit-flex; display: flex; -webkit-box-wrap: wrap; -moz-box-wrap: wrap; -ms-flex-wrap: wrap; -webkit-wrap: wrap; flex-wrap: wrap; background: #FFFFFF 0% 0% no-repeat padding-box; border: 1px solid #D2D2D2; border-radius: 4px; padding: 6px; -webkit-border-radius: 4px; -moz-border-radius: 4px; -ms-border-radius: 4px; -o-border-radius: 4px; }\n.color-field label {margin-right: 8px;margin-left: 5px;}\n.color-field input { border: none; outline: none; appearance: none; box-shadow: none; border-radius: 4px; -webkit-border-radius: 4px; -moz-border-radius: 4px; -ms-border-radius: 4px; -o-border-radius: 4px;}\n\n.profile-poster-wrapper {background: transparent linear-gradient(117deg, #00805F 0%, #FDB813 60%, #A6CE3A 100%) 0% 0% no-repeat padding-box;padding: 30px 30px;min-width: 1092px;max-width: 1200px;}\n.profile-poster {background: #FFFFFF;border-radius: 40px 40px 0 0;padding: 2%;display: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex;-webkit-box-wrap: wrap;-moz-box-wrap: wrap;-ms-flex-wrap: wrap;-webkit-wrap: wrap;flex-wrap: wrap;position: relative;overflow: hidden;min-height: 605px;}\n\n.profile-poster-curve {content: '';background: #00805f;position: absolute;bottom: 0;top: 394px;left: -123px;width: 537px;height: 537px;border-radius: 50%;}\n.profile-poster-left {width: 25%;display: -webkit-box; display: -moz-box; display: -ms-flexbox; display: -webkit-flex; display: flex;flex-direction: column;align-items: center;padding-top: 20px;position: relative;}\n.alumni-cards-curve-first {position: absolute;background: #00805f;border-radius: 50%;width: 190%;height: 28%;left: -44%;right: 0;margin: auto;top: -3%;z-index: 1;}\n.alumni-cards-curve-second {position: absolute;background: #c8c32a;border-radius: 50%;width: 190%;height: 28%;left: -43%;right: 0;margin: auto;top: -2%;z-index: 0;transform: rotate(2deg);}\n.profile-poster-left .powerby {flex-direction: revert;margin-top: 15px;color: #fff;}\n.profile-poster-left .powerby span {margin-right: 5px;}\n.college-logo {margin-bottom: 20px;}\n.community-title {margin-bottom: 20px;font-size: 32px;font-weight: 600;color: #008060;width: 90%;text-align: center;line-height: 35px;}\n.scan-wrap {background: #fff;padding: 18px;max-width: 185px;text-align: center;}\n.scan-heading {font-size: 12px;line-height: 17px;letter-spacing: 6.01px;color: #000000;margin-bottom: 12px;}\n.profile-poster-right {width: 75%;padding: 50px 0 0;}\n.profile-poster-right h3{font-size: 20px;font-weight: 600;margin-bottom: 0px;text-align: center;}\n\n.profile-poster-alumni {display: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex;flex-wrap: wrap;-webkit-box-wrap: wrap;-moz-box-wrap: wrap;-ms-flex-wrap: wrap;-webkit-wrap: wrap;margin-bottom: 50px;justify-content: center;}\n\n.profile-poster-right h3[contenteditable] {border: 2px dashed #000;position: relative;padding: 3px 7px;}\n.profile-poster-right h3:focus-visible {outline: none;}\n.profile-poster-right h3[contenteditable]::before {content: \"\\e912\";font-family: \"icomoon\" !important;font-style: normal;font-weight: normal;font-variant: normal;text-transform: none;line-height: 1;position: absolute;top: -23px;right: -23px;}\n.alumni-cards {width: 23.4%;border: 1px solid rgba(195, 195, 195, 0.35);border-radius: 12px;opacity: 1;display: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex;flex-direction: column;align-items: center;padding: 2% 10px;position: relative;min-height: 275px;background-color: #ffffff; }\n.alumni-cards .alumni-img {width: 80px;height: 80px;display: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex;justify-content: center;overflow: hidden;border-radius: 50%;background-color: #f0f0f0; z-index: 2;position: relative;}\n.alumni-cards .alumni-img img {min-width: 100%;min-height: 100%;max-height: 100%;object-fit: cover; }\n.alumni-cards h4 {color: #FDB813;font-size: 15px;margin: 10px 0 0;min-height: 20px; text-align: center;}\n.alumni-cards .batch {font-size: 13px;min-height: 16px;}\n.alumni-cards .batch + i {width: 59px;height: 1px;background: linear-gradient(90deg, #A6CE3A 0%, #00805F 57%, #FDB813 100%);margin: 10px 0;}\n.alumni-cards > div {min-height: 20px;}\n.alumni-cards:not(:last-child) {margin-right: 14px;}\n.alumni-cards {width: 23.4%;background: #FFF;border: 1px solid #C3C3C359;border-radius: 12px;opacity: 1;display: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex;flex-wrap: wrap;-webkit-box-wrap: wrap;-moz-box-wrap: wrap;-ms-flex-wrap: wrap;-webkit-wrap: wrap;flex-direction: column;align-items: center;padding: 2% 10px;position: relative;}\n.alumni-cards > div{position: relative;}\n.alumni-cards h4 {color: #FDB813;font-size: 15px;margin: 10px 0 0;}\n.alumni-cards > div.batch {font-size: 13px;}\n\n.alumni-cards .divider {width: 59px;height: 0.720733642578125px;background: transparent linear-gradient(90deg, #A6CE3A 0%, #00805F 57%, #FDB813 100%) 0% 0% no-repeat padding-box;margin: 10px 0;}\n.alumni-University-list {text-align: center;font-size: 14px;}\n.alumni-University-list .heading {color: #000;}\n.alumni-University-list .brife {color: #A6CE3A;font-size: 14px;font-weight: 600;}\n.alumni-University-list:not(:last-child) {margin-bottom: 10px;}\n.alumni-companies-list {display: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex;justify-content: center;}\n.company-block { border: 1px solid #00805F5C; border-radius: 6px; opacity: 1; overflow: hidden; display: -webkit-box; display: -moz-box; display: -ms-flexbox; display: -webkit-flex; display: flex; align-items: center; justify-content: center; height: 65px; padding: 0 10px; -webkit-border-radius: 6px; -moz-border-radius: 6px; -ms-border-radius: 6px; -o-border-radius: 6px;}\n.company-block:not(:last-child) {margin-right: 7px;}\n.company-block img {max-width: 90px;height: auto;}\n\n.leaders-poster {max-width: 1080px;background: #0164A7 ;position: relative;overflow: hidden;}\n.leaders-poster-container{background-color: #fff;border-radius: 98px 0px 0px 0px;}\n\n.leaders-poster .college-logo {position: absolute;top: 7%;left: 9%;z-index: 2;margin: 0;width: 18.5%;}\n.leaders-poster .college-logo img{max-height: 80px;}\n.leaders-poster-alumni {position: absolute;left: 13.5%;top: 29%;z-index: 1;background: #C79757;padding: 10.8%;border-radius: 50%;overflow: hidden;display: flex;justify-content: center;align-items: center;}\n.leaders-poster-alumni img {position: absolute;top: 0;bottom: 0;margin: auto;width: auto;height: 100%;}\n.leaders-poster-alumni-detail {position: absolute;left: 40%;top: 35%;width: 49%;}\n.leaders-poster-alumni-name {color: #0064A7;font-size: 50px;font-weight: 700;line-height: 55px;padding-left: 3%;}\n.leaders-poster-alumni-batch-school {font-size: 30px;font-weight: 500;padding-left: 3%;}\n.curve-line {margin: 10px 0 40px;}\n.pursuing {padding-left:3%;position: relative;}\n.pursuing:not(.alumni_univarsity_details) i {position: absolute;width: 6px;height: 40px;background: #C79757;left: 0%;top: 4%;}\n.pursuing-logo{width: 30px;height: 30px;display: flex;align-items: center;justify-content: center;}\n.pursuing-logo img{max-width: 30px;max-height: 30px;}\n.pursuing-title {font-size: 35px;margin-bottom: 20px;}\n.pursuing-title span {font-weight: 600;}\n.expertise {position: absolute;top: 79%;left: 12%;font-size: 1.6vw;width: 60%;line-height: 2.1vw;}\n.expertise strong {display: block;}\n.expertise i {position: absolute;width: 6px;height: 40px;background: #C79757;left: -4%;top: -34%;}\n.max-540{max-width: 540px;}\n.max-540 .leaders-poster-alumni-name{font-size: 24px;line-height: 26px;}\n.max-540 .leaders-poster-alumni-batch-school {\tfont-size: 16px;}\n.max-540 .pursuing-title {font-size: 20px;margin-bottom: 5px;}\n.max-540 .pursuing i {width: 2px;height: 20px;left: 0%;top: 4%;}\n.max-540 .expertise i {width: 3px;height: 30px;left: -6%;top: -34%;}\n.max-540 .expertise {font-size: 20px;line-height: 24px;}\n.max-540 .curve-line {\tmargin: 0px 0 20px;}\n\n.max-430{max-width: 430px;}\n.min-430{min-width: 430px;}\n.max-430 .leaders-poster-alumni {\tleft: 12.5%;}\n.max-430 .leaders-poster-alumni-detail {left: 37%;top: 32%;}\n.max-430 .leaders-poster-alumni-name{font-size: 20px;  line-height: 22px;}\n.max-430 .leaders-poster-alumni-batch-school {\tfont-size: 13px;}\n.max-430 .pursuing-title {font-size: 18px;margin-bottom: 5px;}\n.max-430 .pursuing-title.font-13{line-height: 14px;}\n.max-430 .pursuing i {width: 2px;height: 20px;left: 0%;top: 4%;}\n.max-430 .expertise i {width: 3px;height: 30px;left: -6%;top: -34%;}\n.max-430 .expertise {font-size: 17px;line-height: 20px;}\n.max-430 .curve-line {\tmargin: 0px 0 5px;}\n\n.new_facebook .leaders-poster-alumni {top: 25%;}\n.new_facebook .leaders-poster-alumni-detail {left: 37%;top: 29%;}\n.new_facebook .pursuingWrap {position: absolute;top: 45.5%;left: 13%;width: 75%;}\n.new_facebook .expertise {background: #f5f5f5;left: 4.8%;width: calc(100% - 9.4%);padding: 4% 5%;text-align: center;top: auto;bottom: 15%;}\n.new_facebook .powerby {display: -webkit-box; display: -moz-box; display: -ms-flexbox; display: -webkit-flex; display: flex;align-items: center;flex-direction: row;width: auto;bottom: 7%;position: absolute;justify-content: center;width: 100%;}\n\n.new_facebook.poster-3 .leaders-poster-alumni{left: 6%;padding: 15%;}\n.new_facebook.poster-3 .powerby {bottom: 4%;}\n.max-430 .leaders-poster.poster-3.new_facebook .leaders-poster-alumni-detail {left: 40%;top: 34%;}\n.max-430 .leaders-poster.poster-3.new_facebook .leaders-poster-alumni-detail .leaders-poster-alumni-name{font-weight: 600;}\n.max-430 .leaders-poster.poster-3.new_facebook .leaders-poster-alumni-detail .leaders-poster-alumni-batch-school i {background: #bbbbbb;height: 2px;margin: 10px 0 0 0;}\n.max-430 .leaders-poster.poster-3.new_facebook .pursuingWrap {top: 50%;left: 32%;width: 62%;}\n.max-430 .leaders-poster.poster-3.new_facebook .pursuing i {width: 2px;height: 17px;left: 2%;border-radius: 0;}\n.max-430 .leaders-poster.poster-3.new_facebook .expertise{    background: transparent;text-align: left;max-width: 50%;padding: 0;}\n\n.alumni-card-wrap .alumni-card-slider.new_facebook {max-width: 430px;min-height: 537px;overflow: hidden;}\n.alumni-card-wrap .alumni-card-slider.new_facebook i.curve {height: 195px;border-radius: 50%;width: 130%;left: -15%;right: 0;margin: auto;top: -45px;}\n.alumni-card-wrap .alumni-card-slider.new_facebook .alumni-img-wrap {margin: 30px 0;max-width: 180px;width: 100%;height: 180px;}\n\n.leaders-poster.preview {max-width: 710px;margin: 0 auto;}\n.leaders-poster.preview .college-logo {top: 10%;left: 10%;width: 20%;}\n.leaders-poster.preview .college-logo img {max-height: 100px;}\n.leaders-poster.preview .leaders-poster-alumni{top:26%}\n.leaders-poster.preview .leaders-poster-alumni-name {font-size: 36px;line-height: 40px;}\n.leaders-poster.preview .curve-line {margin: 10px 0 20px;}\n.leaders-poster.preview .pursuing-title.font-13{font-size: 18px !important;line-height: 20px;}\n.leaders-poster.preview .leaders-poster-alumni-detail {top: 28%;}\n.leaders-poster.preview .leaders-poster-alumni-batch-school {font-size: 20px;}\n.leaders-poster.preview  .expertise {font-size: 1.3vw;line-height: 1.8vw;}\n\n.social-post-tab {overflow: auto;padding: 15px;flex-wrap: nowrap;}\n.social-post-tab::-webkit-scrollbar {height: 3px;}\n.social-post-tab::-webkit-scrollbar-track {background: #ccc;}\n.social-post-tab::-webkit-scrollbar-thumb {background: #666;}\n.social-post-tab::-webkit-scrollbar-thumb:hover {background: #999;} \n.social-post-tab .nav-item:not(:last-child){margin-right:10px}\n.social-post-tab .nav-item .nav-link{border-radius:25px;padding:12px 25px;background-color: transparent;color: #000;display: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex; align-items: center;}\n.social-post-tab .nav-item .nav-link i{margin-right: 10px;}\n\n.social-post-tab .nav-item .nav-link.popular{border: 1px solid #F1AC18;}\n.social-post-tab .nav-item .nav-link.popular i{background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/tab-effect.svg);width: 17px;height: 17px; }\n.social-post-tab .nav-item .nav-link.facebook{border: 1px solid #1877F2;}\n.social-post-tab .nav-item .nav-link.facebook i{background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/tab-facebook.svg);width: 22px;height: 22px;}\n.social-post-tab .nav-item .nav-link.instagram{border: 1px solid #E30085;}\n.social-post-tab .nav-item .nav-link.instagram i{background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/tab-instagram.svg);width: 20px;height: 20px;}\n.social-post-tab .nav-item .nav-link.youtube{border: 1px solid #FF0000;}\n.social-post-tab .nav-item .nav-link.youtube i{background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/tab-youtube.svg);width: 27px;height: 19px;}\n.social-post-tab .nav-item .nav-link.twitter{border: 1px solid #000000;}\n.social-post-tab .nav-item .nav-link.twitter i{background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/tab-twitter.svg);width: 17px;height: 17px;}\n.social-post-tab .nav-item .nav-link.email{border: 1px solid #D82A2A;}\n.social-post-tab .nav-item .nav-link.email i{background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/tab-email.svg);width: 26px;height: 15px;}\n\n.social-post-tab .nav-item .nav-link:not(.active, :hover) {background: #0B3454;color:#fff;border-color: #0B3454;}\n.social-post-tab .nav-item .nav-link:not(.active, :hover) i {filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(288deg) brightness(102%) contrast(150%);-webkit-filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(288deg) brightness(102%) contrast(150%);}\n.social-post-tab .nav-item .nav-link.popular:not(.active, :hover) i, .social-post-tab .nav-item .nav-link.instagram:not(.active, :hover) i {filter: brightness(0)invert(1);-webkit-filter: brightness(0)invert(1);}\n\n.social-post-template-block {background: #E8E8E8;border-radius: 12px;padding: 30px 40px;height: 100%;text-align: center;position: relative;overflow: hidden;}\n.social-post-template-block::before{ content: ''; position: absolute; left: 0; right:0; top: 0; width: 100%; height: 0; margin: auto; transition:all 0.3s ease-in-out ; -webkit-transition:all 0.3s ease-in-out ; -moz-transition:all 0.3s ease-in-out ; -ms-transition:all 0.3s ease-in-out ; -o-transition:all 0.3s ease-in-out ;background: rgba(0, 0, 0, .6); }\n.social-post-template-block:hover::before{height: 100%;}\n.social-post-template-block .template-block-icon {height: 125px;display: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex;justify-content: center;align-items: end;margin: 0 0 20px;}\n.social-post-template-block h3 {font-size: 18px;margin: 0 0 5px;}\n.social-post-template-block p {margin: 0;}\n.social-post-template-block a {position: absolute;left: 0;right: 0;top: 100%;bottom: auto;margin: auto;width: 150px;height: 40px;background: #fff;display: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex;justify-content: center;align-items: center;text-decoration: none;border-radius: 25px;color: #000;transition:all 0.3s ease-in-out ;-webkit-transition:all 0.3s ease-in-out ;-moz-transition:all 0.3s ease-in-out ;-ms-transition:all 0.3s ease-in-out ;-o-transition:all 0.3s ease-in-out ;opacity: 0;}\n.social-post-template-block a:hover{background: #5cae48;color: #fff;}\n.social-post-template-block:hover a{opacity: 1;top: 0;  bottom: 0;}\n\n.btn-verticle-popup {position: fixed;z-index: 9;top: 270px;width: 40px;right: 0;display: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex;flex-direction: column;padding: 20px 0px;border-radius: 0 10px 10px 0;-webkit-border-radius: 0 10px 10px 0;-moz-border-radius: 0 10px 10px 0;-ms-border-radius: 0 10px 10px 0;-o-border-radius: 0 10px 10px 0;text-decoration: none;margin: 2px 0px;writing-mode: vertical-rl;text-orientation: mixed;transform: rotate(180deg);-webkit-transform: rotate(180deg);-moz-transform: rotate(180deg);-ms-transform: rotate(180deg);-o-transform: rotate(180deg);white-space: nowrap;writing-mode: vertical-rl;\talign-items: center;border: 0;background-color: #0B3454;color: #ffffff;line-height: 40px;font-weight: 600;transition: all 0.3s ease-in-out;-webkit-transition: all 0.3s ease-in-out;-moz-transition: all 0.3s ease-in-out;-ms-transition: all 0.3s ease-in-out;-o-transition: all 0.3s ease-in-out;}\n.btn-verticle-popup:hover{background-color: #398227;}\n\n.btn-horizontal-popup { position: fixed; bottom: 0; right: 30px; padding: 8px 20px; font-weight: 600; border: 0; border-radius: 7px 7px 0 0px; background: #0B3454; color: #fff; -webkit-border-radius: 7px 7px 0 0px; -moz-border-radius: 7px 7px 0 0px; -ms-border-radius: 7px 7px 0 0px; -o-border-radius: 7px 7px 0 0px;}\n.btn-horizontal-popup:hover{background-color: #398227;}\n\n.blue-filter{ filter: invert(26%) sepia(99%) saturate(7494%) hue-rotate(215deg) brightness(84%) contrast(91%); -webkit-filter: invert(26%) sepia(99%) saturate(7494%) hue-rotate(215deg) brightness(84%) contrast(91%); }\n.offer_joined i {background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/hat_alumni.svg);width: 23px;height: 17px;margin-right: 0;}\n\n.qr-wrap {background: #0B3454;border-radius: 12px;padding: 35px;margin-bottom: 25px;}\n.icon-write-review {background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/write-review.svg);width: 36px;height: 36px;display: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex;}\n\n.review {display: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex;flex-wrap: wrap;-webkit-box-wrap: wrap;-moz-box-wrap: wrap;-ms-flex-wrap: wrap;-webkit-wrap: wrap;flex-direction: row-reverse;}\n.review label {background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='%23707070' stroke='%23707070' stroke-linecap='' stroke-linejoin='' stroke-width='1' d='M2.866 14.85c-.078.444.36.791.746.593l4.39-2.256 4.389 2.256c.386.198.824-.149.746-.592l-.83-4.73 3.522-3.356c.33-.314.16-.888-.282-.95l-4.898-.696L8.465.792a.513.513 0 0 0-.927 0L5.354 5.12l-4.898.696c-.441.062-.612.636-.283.95l3.523 3.356-.83 4.73zm4.905-2.767-3.686 1.894.694-3.957a.56.56 0 0 0-.163-.505L1.71 6.745l4.052-.576a.53.53 0 0 0 .393-.288L8 2.223l1.847 3.658a.53.53 0 0 0 .393.288l4.052.575-2.906 2.77a.56.56 0 0 0-.163.506l.694 3.957-3.686-1.894a.5.5 0 0 0-.461 0z'/%3e%3c/svg%3e\");background-repeat: no-repeat;background-position: center;background-size: 100%;width: 16px;height: 16px;margin-right: 3px;cursor: pointer;position: relative;} \n\n.review input:checked ~ label {background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='%23FFC107' stroke='%23FFC107' stroke-linecap='' stroke-linejoin='' stroke-width='1' d='M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z'/%3e%3c/svg%3e\");}\n.google-review-ui *{font-family: \"Open Sans\", sans-serif;}\n.google-review-ui h2 {border-bottom: 1px solid #E4E4E4;padding-bottom: 20px;font-weight: 700;}\n.google-review-ui .review label {width: 60px;height: 60px;margin-right: 30px;background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='%23707070' stroke='%23707070' stroke-linecap='' stroke-linejoin='' stroke-width='0' d='M2.866 14.85c-.078.444.36.791.746.593l4.39-2.256 4.389 2.256c.386.198.824-.149.746-.592l-.83-4.73 3.522-3.356c.33-.314.16-.888-.282-.95l-4.898-.696L8.465.792a.513.513 0 0 0-.927 0L5.354 5.12l-4.898.696c-.441.062-.612.636-.283.95l3.523 3.356-.83 4.73zm4.905-2.767-3.686 1.894.694-3.957a.56.56 0 0 0-.163-.505L1.71 6.745l4.052-.576a.53.53 0 0 0 .393-.288L8 2.223l1.847 3.658a.53.53 0 0 0 .393.288l4.052.575-2.906 2.77a.56.56 0 0 0-.163.506l.694 3.957-3.686-1.894a.5.5 0 0 0-.461 0z'/%3e%3c/svg%3e\");}\n.google-review-ui .review input:checked ~ label {background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='%23FFC107' stroke='%23FFC107' stroke-linecap='' stroke-linejoin='' stroke-width='0' d='M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z'/%3e%3c/svg%3e\");}\n.profile-section-detail{line-height: 28px;}\n.icon-camera {background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/icon-camera.svg) no-repeat 0 0;width: 20px;height: 20px;display: block;}\n.google-review-ui .btn-border-gray{color: #0C4CBB;}\n.google-review-ui .btn-border-gray:hover{color: #fff;}\n.google-review-ui .btn-border-gray:hover i{ filter: brightness(0) invert(1) ; -webkit-filter: brightness(0) invert(1) ; }\n\ntd .review{flex-direction: row;}\n.review i {background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='%23707070' stroke='%23707070' stroke-linecap='' stroke-linejoin='' stroke-width='1' d='M2.866 14.85c-.078.444.36.791.746.593l4.39-2.256 4.389 2.256c.386.198.824-.149.746-.592l-.83-4.73 3.522-3.356c.33-.314.16-.888-.282-.95l-4.898-.696L8.465.792a.513.513 0 0 0-.927 0L5.354 5.12l-4.898.696c-.441.062-.612.636-.283.95l3.523 3.356-.83 4.73zm4.905-2.767-3.686 1.894.694-3.957a.56.56 0 0 0-.163-.505L1.71 6.745l4.052-.576a.53.53 0 0 0 .393-.288L8 2.223l1.847 3.658a.53.53 0 0 0 .393.288l4.052.575-2.906 2.77a.56.56 0 0 0-.163.506l.694 3.957-3.686-1.894a.5.5 0 0 0-.461 0z'/%3e%3c/svg%3e\");background-repeat: no-repeat;background-position: center;background-size: 100%;width: 16px;height: 16px;margin-right: 3px;cursor: pointer;position: relative;} \n.review i:before {content: '';position: absolute;width: 18px;height: 18px;left: 0;top: 0;bottom: 0;background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='%23FFC107' stroke='%23FFC107' stroke-linecap='' stroke-linejoin='' stroke-width='0' d='M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z'/%3e%3c/svg%3e\");background-repeat: no-repeat;background-size: 16px;opacity: 0;}\n\n.review.poor i:first-child{background: none;}\n.review.poor i:first-child::before {opacity: 1;}\n.review.poor.half i:nth-child(2)::before{width: 8px;opacity: 1;}\n.review.average i:first-child, .review.average i:nth-child(2){background: none;}\n.review.average i:first-child::before, .review.average i:nth-child(2)::before {opacity: 1;}\n.review.average.half i:nth-child(3)::before {width: 8px;opacity: 1;}\n.review.good i:first-child, .review.good i:nth-child(2), .review.good i:nth-child(3){background: none;}\n.review.good i:first-child::before, .review.good i:nth-child(2)::before, .review.good i:nth-child(3)::before {opacity: 1;}\n.review.good.half i:nth-child(4)::before {width: 8px;opacity: 1;}\n.review.very-good i:first-child, .review.very-good i:nth-child(2), .review.very-good i:nth-child(3), .review.very-good i:nth-child(4){background: none;}\n.review.very-good i:first-child::before, .review.very-good i:nth-child(2)::before, .review.very-good i:nth-child(3)::before, .review.very-good i:nth-child(4)::before {opacity: 1;}\n.review.very-good.half i:nth-child(5)::before {width: 8px;opacity: 1;}\n\n.review.excellent i:first-child, .review.excellent i:nth-child(2), .review.excellent i:nth-child(3), .review.excellent i:nth-child(4), .review.excellent i:nth-child(5){background: none;}\n.review.excellent i:first-child::before, .review.excellent i:nth-child(2)::before, .review.excellent i:nth-child(3)::before, .review.excellent i:nth-child(4)::before, .review.excellent i:nth-child(5)::before {opacity: 1;}\n\n@media (max-width:767px){\n.google-review-ui .review label {width: 40px;height: 40px;margin-right: 10px;}\n}\n\n@media (max-width:480px){\n.leaders-poster .college-logo {width: 14.5%;}\n.leaders-poster-alumni {padding: 9%;}\n.max-430 .leaders-poster-alumni-name {font-size: 16px;line-height: 18px;}\n.max-430 .leaders-poster-alumni-batch-school {font-size: 11px;}\n.max-430 .pursuing-title {font-size: 14px;margin-bottom: 5px;}\n.max-430 .expertise {font-size: 13px;line-height: 16px;}\n}\n\n@media (max-width: 400px) {\n.max-430 .leaders-poster-alumni {top: 27%;}\n.leaders-poster-alumni {padding: 8%;}\n.max-430 .leaders-poster-alumni-detail {left: 32%;top: 28%;width: 52%;}\n.max-430 .leaders-poster-alumni-name {font-size: 14px;line-height: 16px;}\n.max-430 .leaders-poster-alumni-batch-school {font-size: 11px;line-height: 13px;}\n.max-430 .expertise {font-size: 9px;line-height: 13px;}\n.max-430 .curve-line {margin: 0;}\n.max-430 .pursuing-title {font-size: 14px;margin-bottom: 0;}\n}\n\n.w-300{width: 300px;}\n\n\n.poster-3 *{z-index: 3;}\ni.slant {position: absolute;background: #2c256a;width: 210%;height: 240%;left: 0;top: 0;z-index: 1;transform: rotate(22deg);}\ni.bottom-strip {background: #1c1555;height: 16%;position: absolute;left: 0;bottom: 0;width: 100%;z-index: 2;}\n.leaders-poster.poster-3 .college-logo {top: 7%;left: 4%;width: 34%;}\n.badge-template {position: absolute;top: 0;right: 40px;max-width: 100px;}\n.max-430 .leaders-poster.poster-3 .expertise {font-size: 15px;line-height: 16px;position: absolute;bottom: 17px;left: 20px;width: 100%;max-width: 280px;top: auto;}\n.max-430 .leaders-poster.poster-3 .leaders-poster-alumni-batch-school {margin-bottom: 5%;}\n.poster-powerby{bottom: 13px;right: 15px;}\n.max-430 .leaders-poster.poster-3 .leaders-poster-alumni-detail {left: 36%;top: 30%;width: 60%;}\n.max-430 .leaders-poster.poster-3 .pursuing i {width: 7px;height: 7px;left: 0%;top: 8%;border-radius: 50%;background: #ffc221;}\n.max-430 .leaders-poster.poster-3 .pursuing{padding-left: 6%;position: relative;}\n.max-430 .leaders-poster.poster-3 .leaders-poster-alumni-batch-school i {display: inline-block;background: rgb(255,255,255);background: linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(46,36,101,1) 100%);height: 1px;width: 55px;vertical-align: top;margin: 10px 0 0 10px;}\n\n.web-sertificate{min-width: 484px;margin:0 auto;position: relative;}\n.web-sertificate > div{position: absolute;}\n.web-sertificate .certificate-holder-name {top: 44%;left: 0;right: 0;text-align: center;font-size: 28px;font-weight: 600;}\n.web-sertificate .certificate-holder-school {top: 56%;left: 0;right: 0;text-align: center;font-size: 12px;font-weight: 500;}\n.web-sertificate .presenting {top: 63%;left: 0;right: 0;text-align: center;font-size: 16px;font-weight: 500;}\n.web-sertificate .presenting .title {color: #828080;font-size: 13px;}\n.web-sertificate .presenting .incontext {font-size: 13px;font-weight: 600;}\n.web-sertificate .presenting .date {font-size: 13px;}\n\n.web-sertificate.preview {max-width: 710px;margin:0 auto;position: relative;}\n.web-sertificate > div{position: absolute;}\n.web-sertificate.preview .certificate-holder-name {top: 44%;left: 0;right: 0;text-align: center;font-size: 42px;font-weight: 600;}\n.web-sertificate.preview .certificate-holder-school {top: 56%;left: 0;right: 0;text-align: center;font-size: 16px;font-weight: 500;}\n.web-sertificate.preview .presenting {top: 63%;left: 0;right: 0;text-align: center;font-size: 16px;font-weight: 500;}\n.web-sertificate.preview .presenting .title {color: #828080;}\n.web-sertificate.preview .presenting .incontext {font-size: 17px;font-weight: 600;}\n.web-sertificate.preview .presenting .date {font-size: 14px;}\n\n.alumniMembershipCardWrap {width: 484px;background: #FFFFFF 0% 0% no-repeat padding-box;border-radius: 17px;padding: 10px;}\n.alumniMembershipCard{display: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex;flex-wrap: wrap;-webkit-box-wrap: wrap;-moz-box-wrap: wrap;-ms-flex-wrap: wrap;-webkit-wrap: wrap; position: relative;border-radius: 17px;overflow: hidden;}\n.alumniMembershipCard i{width: 100%;position: absolute;height: 100%;left: 0;top: 0;z-index: 0;}\n.alumniMembershipCard i.white-strip {width: 0;left: auto;right: -2px;border-width: 0 27px 350px 0px;border-color: transparent #fff transparent transparent;top: 0;bottom: 0;border-style: solid;}\n.alumniMembershipCard-leftPane {width: 70%;position: relative;background: #053E6C;}\n.alumniMembershipCardWrap .card-title-wrap {padding: 5% 8%;}\n.alumniMembershipCardWrap .cardTitle .title {font-size: 45px;color: #fff;line-height: 45px;}\n.alumniMembershipCardWrap .cardTitle .sub {font-size: 14px;color: #fff;font-weight: 600;letter-spacing: 10px;border-bottom: 2px solid #fff;margin-bottom: 20px;padding-bottom: 10px;}\n.alumniMembershipCardWrap .card-title-wrap .school {font-size: 18px;font-weight: 600;color: #fff;}\n\n.alumniMembershipCard-rightPane {width: 30%;position: relative;display: flex;flex-direction: column;justify-content: space-between;align-items: center;}\n.alumniMembershipCardWrap .blueshade-strip {background: #1166A8;padding: 4% 8%;}\n.alumniMembershipCardWrap .blueshade-strip .cardUser {font-size: 18px;font-weight: 600;color: #fff;}\n.alumniMembershipCardWrap .blueshade-strip .cardUserBatch {font-size: 14px;font-weight: 600;color: #fff;}\n.alumniMembershipCardWrap .validityWrap{padding: 4% 8%;}\n.alumniMembershipCardWrap .validityWrap .cardNumber {font-size: 20px;color: #fff;letter-spacing: 5px;}\n.alumniMembershipCardWrap .validity {font-size: 14px;color: #fff;font-weight: 600;}\n\n.alumniMembershipCardWrap.preview {width: 637px;}\n.alumniMembershipCardWrap.preview .cardTitle .title {font-size: 70px;color: #fff;line-height: 75px;}\n.alumniMembershipCardWrap.preview .cardTitle .sub {font-size: 30px;color: #fff;font-weight: 600;letter-spacing: 10px;border-bottom: 2px solid #fff;margin-bottom: 20px;padding-bottom: 10px;}\n.alumniMembershipCardWrap.preview .card-title-wrap .school {font-size: 30px;font-weight: 600;color: #fff;}\n.alumniMembershipCardWrap.preview .blueshade-strip .cardUser {font-size: 22px;font-weight: 600;color: #fff;}\n.alumniMembershipCardWrap.preview .blueshade-strip .cardUserBatch {font-size: 18px;font-weight: 600;color: #fff;}\n.alumniMembershipCardWrap.preview .validityWrap .cardNumber {font-size: 30px;color: #fff;letter-spacing: 5px;}\n.alumniMembershipCardWrap.preview .validity {font-size: 16px;color: #fff;font-weight: 600;}\n\n\n.journey-poster{min-width: 484px;max-width: 484px;}\n.journey-poster .top-title{font-size: 18px;}\n.journey-poster .img-placehlder{position: relative;z-index: 0;}\n.journey-poster .blue-wrap{background-color: #354b9c;padding: 15px;position: relative;z-index: 2;}\n.journey-poster .profileWrap {  display: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex;align-items: end;max-width: 385px;margin: auto;margin-top: -35px;}\n.journey-poster .profileWrap .pro-picture {width: 100px;height: 100px;display: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex;align-items: center;justify-content: center;border-radius: 50%;overflow: hidden;border: 2px solid #fff;margin-right: 30px;}\n.journey-poster .profileWrap h2 {font-size: 24px;font-weight: 700;width: calc(100% - 200px);color: #fff;}\n.journey-poster ul.journey li .content-wrap {flex: 1;display: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex;flex-wrap: wrap;-webkit-box-wrap: wrap;-moz-box-wrap: wrap;-ms-flex-wrap: wrap;-webkit-wrap: wrap;flex-direction: column;padding: 12px;font-weight: 500;word-break: break-word;}\n.journey-poster:not(.preview) ul.journey li .content-wrap {font-size: 14px;}\n.journey-poster .white-content-wrap .white-wrap {z-index: 2;  background: #fff;max-width: 600px;width: 90%;margin: 0 auto;padding: 15px;border: 1px solid #e3e3e3;}\n.journey-poster .white-content-wrap h3 {color: #3aae6f;font-weight: 600;font-size: 20px;margin-bottom: 15px;}\n.journey-poster .white-content-wrap .white-wrap ul.dots li{display: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex;flex-wrap: wrap;-webkit-box-wrap: wrap;-moz-box-wrap: wrap;-ms-flex-wrap: wrap;-webkit-wrap: wrap;font-size: 14px;}\n.journey-poster .white-content-wrap .white-wrap ul.dots li:not(:last-child){margin-bottom: 10px;}\n.journey-poster .white-content-wrap .white-wrap ul.dots li .dot{width: 8px;background-color: #3aae6f;height: 8px;border-radius: 50%;margin-right: 11px;margin-top: 7px;vertical-align: top;}\n.journey-poster .white-content-wrap .white-wrap ul.dots li span{flex:1}\n.journey-poster .white-content-wrap {position: relative;padding-bottom: 30px;}\n\n.journey-poster.preview{min-width: 730px;max-width: 730px;margin: 0 auto;}\n.journey-poster.preview .top-title{font-size: 24px;}\n.journey-poster.preview  .blue-wrap{padding: 30px;}\n.journey-poster.preview .profileWrap {  display: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex;align-items: end;max-width: 450px;margin: auto;margin-top: -71px;}\n.journey-poster.preview .profileWrap .pro-picture {width: 170px;height: 170px;display: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex;align-items: center;justify-content: center;border-radius: 50%;overflow: hidden;border: 2px solid #fff;margin-right: 30px;}\n.journey-poster.preview .profileWrap h2 {font-size: 37px;font-weight: 700;width: calc(100% - 200px);color: #fff;}\n.journey-poster.preview .white-content-wrap {padding-bottom: 60px;}\n.journey-poster .white-content-wrap > i{position: absolute;left: 0;right: 0;top: 0;height: 80px;background-color: #354b9c;z-index: 0;}\n.journey-poster.preview .white-content-wrap .white-wrap{padding: 40px;}\n.journey-poster .white-content-wrap .white-wrap:not(:last-child){margin-bottom: 15px;}\n.journey-poster .white-content-wrap .white-wrap ul {padding: 0;margin: 0;list-style: none;}\n.journey-poster .white-content-wrap .white-wrap ul.journey {display: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex;flex-wrap: wrap;-webkit-box-wrap: wrap;-moz-box-wrap: wrap;-ms-flex-wrap: wrap;-webkit-wrap: wrap;}\n.journey-poster .white-content-wrap .white-wrap ul.journey li {  display: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex;  flex-direction: column;  text-align: center;flex:1}\n.journey-poster ul.journey li .number {  color: #3aae6f;  font-weight: 500;  padding: 8px;}\n.journey-poster ul.journey li .line {width: 100%;height: 3px;background: #3aae6f;position: relative;}\n.journey-poster ul.journey li .dot{position: absolute;left: 0;right: 0;margin: auto;width: 14px;height: 14px;background-color: #fff;border: 2px solid #3aae6f;border-radius: 50%;top: 0;bottom: 0;margin: auto;}\n.journey-poster.preview ul.journey li .content-wrap {padding: 15px 5px;}\n.journey-poster ul.journey li .logo {  margin-top: auto;}\n.journey-poster ul.journey li .logo img{max-width: 100%;}\n.journey-poster.preview .white-content-wrap h3 {font-size: 24px;}\n.journey-poster.preview .white-content-wrap .white-wrap ul.dots li{font-size: 16px;}\n\n.ratio-16{width: 16px;height: 16px;}\n.icon-down-arrow{transition: all 0.3s ease-in-out;}\n.icon-down-arrow[aria-expanded=\"true\"]{transform: rotate(180deg);}\n.border-d52941{border: 1px solid #d52941;}\n\n.height-20 {height: 20px !important;}\n.bg-blue-0d3453{background-color: #0d3453;}\n.bg-gray-f5f5f5{background-color: #f5f5f5;}\n.bg-gray-E6E6E6{background-color: #E6E6E6;}\n.dash-border{border-bottom: 2px dashed #ccc;opacity: 1;background-color: transparent;}\n.min-h-80{min-height: 80px;}\n.min-h-0{min-height: 0px !important;}\n.btn-gray-de { background: #D2D2D2 ; border: 1px solid #D2D2D2; border-radius: 25px; padding: 8px 18px; display: -webkit-box; display: -moz-box; display: -ms-flexbox; display: -webkit-flex; display: flex; align-items: center; color: #000; transition:all 0.3s ease-in-out ; -webkit-transition:all 0.3s ease-in-out ; -moz-transition:all 0.3s ease-in-out ; -ms-transition:all 0.3s ease-in-out ; -o-transition:all 0.3s ease-in-out ;}\n.btn-gray-de:hover {background: #0b3454;border-color: #0b3454;color: #fff;}\n\n.lastTRLineRemove tr:last-child{border-color: transparent !important;} \n.work-block .work-detail .icon-hat{background: url(https://ags-images-bucket.s3.ap-south-1.amazonaws.com/images/hat.svg);background-size: auto;width: 24px;height: 23px;background-size: 100%;display: flex;}\n.alumni_img_link .icon-star.circle-img {bottom: 0px;right: 3px;}\n.alumni_univarsity_name .icon-hat{background: url(https://ags-images-bucket.s3.ap-south-1.amazonaws.com/images/hat.svg);background-size: auto;width: 24px;height: 23px;background-size: 100%;display: flex;}\n.fiterItem .form-check .form-check-input[name='Passout_Name'] + label {overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 1;-webkit-box-orient: vertical;}\n\n\n.bg-green{background-color: #5cae48;}\ntd:first-child .mailSetting .setting-dropdown{left: 0; right: auto;}\n\ntr:nth-last-child(-n + 4) .mailSetting .setting-dropdown {top: auto;bottom: calc(100% + 10px);white-space: nowrap;right: 0;}\ntr:nth-child(-n + 4) .mailSetting .setting-dropdown {top:100%;bottom:auto;}\n\n.width-cal-191{width: calc(100% - 191px);}\n.personalisedBookingLink .singleline-ellipsis { text-overflow: ellipsis;white-space: nowrap;overflow: hidden;width: calc(100% - 30px);display: inline-block;max-width: 515px;}\n\nul.message_counselling_wrap {padding: 0;margin: 0;list-style: none;}\nul.message_counselling_wrap li{padding: 13px 0;}\nul.message_counselling_wrap li:not(:last-child) {border-bottom: 1px solid #ccc;}\nul.message_counselling_wrap li .icon-user-invert{font-size: 50px;}\n.message_counselling{position: relative;}\n.message_counselling > div {max-height: 220px;overflow-y: auto;scrollbar-width: 6px;}\n.message_counselling > div::-webkit-scrollbar {width: 6px;}\n.message_counselling > div::-moz-scrollbar {width: 6px;}\n.message_counselling > div::-webkit-scrollbar-track {background: #eee;}\n.message_counselling > div::-webkit-scrollbar-thumb {background-color: #666;border-radius: 20px;border: 2px solid #eee;}\n\n\n.message_counselling:before {content: '';position: absolute;border-top: 10px solid transparent;border-bottom: 10px solid transparent;border-right: 15px solid #f2f2f2;top: 47px;right: 100%;}\n.test-status {top: 0;right: 0;padding: 5px 15px;border-radius: 0 5px 0 15px;font-weight: 500;}\n@media (max-width: 767px) {\n.width-cal-191{width: 100%;}\n.message_counselling:before {    top: auto;    right: auto;    bottom: 99%;    transform: rotate(90deg);    left: 20px;}\n}\n\n.messagewrap .ql-toolbar {border-radius: 5px 5px  0 0;}\n.messagewrap .ql-container {border-radius: 0 0 5px 5px;height: 180px;}\n.messagewrap.textarea-cnt .ql-container {height: auto;min-height: 180px;}\n.table .disabled {color: #666 !important;pointer-events: none;} \n.nl-container table {margin: auto;}\n\n.blue-block:has(.univarietyAI) {\n    background: linear-gradient(90deg, #e9102e 16%, #043254 100%);\n    color: #ffffff;\n    color:#fff;\n}\n.blue-block:has(.univarietyAI):after {\n    border-bottom: 5px solid #e9102e;\n    border-right: 5px solid #e9102e;\n}\n.univarietyAI {\n    margin-top: 10px;\n    font-size: 13px;\n    color: #fff;\n    font-style: italic;\n}\n.univarietyAI b{\n    font-weight: 500;\n}\n\n.counsellor-img-placeholder{width: 70px;height: 70px;background-color: #eee;border-radius: 50%;overflow: hidden;}\n.counsellor-img-placeholder img{width: auto;height: 100%;}\n.calendly-inline-widget iframe{position: absolute;}\n.session-not-found{min-height: 500px;}\n.session-not-found i{font-size: 4rem;color: #ab0000;line-height: 4rem;margin-bottom: 20px;}\n.copy-line {width: calc(100% - 15px);text-overflow: ellipsis; overflow: hidden;}\n\n.messages:has(.univarietyAI) > div {\n    background: linear-gradient(90deg, #e9102e 16%, #043254 100%);\n    color: #ffffff;\n    color:#fff;\n    border-radius: 10px 10px 10px 0px;\n    padding: 10px 20px;\n    margin-bottom: 10px;\n}\n.justify-content-end .blue-block:has(.univarietyAI):after {\n    border-left: 5px solid #063254;\n    border-bottom: 5px solid #063254;\n    border-top: 5px solid transparent;\n    border-right: 5px solid transparent;\n}\n\n.messages.leftUser:has(.univarietyAI) > div{\n    border-radius: 10px 10px 0px 10px;\n}\n\n/* ========================================\n   LOADER STYLES - Full Screen Overlay\n   ======================================== */\n\n   .loader-container {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 9999;\n    backdrop-filter: blur(2px);\n    -webkit-backdrop-filter: blur(2px);\n}\n\n.loader-container .text-center {\n    background-color: #ffffff;\n    padding: 40px;\n    border-radius: 8px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n    animation: slideUp 0.3s ease-out;\n}\n\n.loader-container .spinner-border {\n    width: 3rem;\n    height: 3rem;\n    border-width: 0.3em;\n    animation: spin 1s linear infinite;\n}\n\n.loader-container .spinner-border-sm {\n    width: 1.5rem;\n    height: 1.5rem;\n    border-width: 0.2em;\n}\n\n.loader-container p {\n    color: #333333;\n    font-weight: 500;\n    font-size: 14px;\n    margin-top: 15px;\n    margin-bottom: 0;\n}\n\n/* Animations */\n@keyframes spin {\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n@keyframes slideUp {\n    from {\n        opacity: 0;\n        transform: translateY(20px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n/* Disabled state styles */\nbutton:disabled,\ninput:disabled {\n    opacity: 0.6 !important;\n    cursor: not-allowed !important;\n}\n\n.filter-disabled,\n[style*=\"pointerEvents: none\"] {\n    pointer-events: none;\n    opacity: 0.6;\n}\n\n\n.messages:has(.univarietyAI) p{\n    background-color: transparent;\n    border-radius: 0;\n    padding: 0;\n}\n\n/* 21072025 */\n\n.bg-blue-e5f1fb{\n  background-color: #E5F1FB;\n}\n\n.ratio-112{\n  width: 112px;\n  height: 112px;\n}\n\n.no-after::after{\n  content: none;\n}\n.new-meter-wrap{\n    position: relative;\n    width: 110px;\n    margin: auto;\n    background: #E8ECF180;\n    height: 110px;\n    border-radius: 50%;\n    padding: 10px;\n}\n.new-meter {\n    position: relative;\n    width: 100%;\n    margin: auto;\n}\n\n/* .new-meter > img{\n  transform: scaleX(-1);\n} */\n\n.new-meter-pointer {\n    position: absolute;\n    width: 12px;\n    height: 12px;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    top: 0;\n    margin: auto auto 0;\n    transition: all 0.3s ease-in-out;\n}\n\n.new-meter-pointer img {\n    position: absolute;\n    width: 100%;\n    left: 0;\n    right: 0;\n    bottom: 0;\n}\n\n.circle-graph {\n    position: relative;\n    width: 110px;\n    margin: auto;\n}\n\n.circle-graph span.text {\n    position: absolute;\n    left: 0;\n    right: 0;\n    height: 20px;\n    width: 35px;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    font-weight: 600;\n}\n\n.circle-graph span.text-green{color: #5BAE47;}\n.circle-graph span.text-yellow{color: #F8B018;}\n.circle-graph span.text-blue{color: #0D3453;}\n\n.persona-grd {background: transparent linear-gradient(51deg, #6F0010 0%, #052C4A 100%) 0% 0% no-repeat padding-box;border-radius: 16px;opacity: 1;height: 205px;}\n.persona-grd-text{-webkit-box-flex: 1;-moz-box-flex: 1;-webkit-flex: 1;-ms-flex: 1;flex: 1;}\n.persona-grd-text h5{font-size: 28px;}\n.persona-grd-text p{font-size: 18px;}\n\n.bg-green-e8ffe2{background-color: #E8FFE2;}\n.bg-green-5bae47{background-color: #5bae47;}\n.bg-pink-ffeef0{background-color: #FFEEF0;}\n.bg-red-d42941{background-color: #D42941;}\n.bg-gray-e5e6e5{background-color: #E5E6E5 ;}\n.bg-gray-919191{background-color: #919191;}\n.bg-yellow-f8b018{background-color: #f8b018;}\n.bg-orange{background-color: #f05a2a;}\n\n\n.text-green-5bae47{color: #5bae47;}\n.text-yellow-f8b018{color: #F8B018;}\n\n.max-150{max-width: 150px;}\n.height-20{height: 20px;}\n.progress-bar{overflow: visible;}\n.progress-bar b{padding-left: 10px;position: absolute;left: 100%;color: #000;font-weight: 500;}\n\n\n.bg-green-5CAE4814 {background-color: #5CAE4814;}\n\n.line {position: relative;}\n.line:before {content: '';position: absolute;left: 0;right: 0;top: 0;bottom: 0;background: #D4D4D4;width: 1px;margin: auto;}\n.bg-gray-E6E6E6.text-gray-41 img {filter: brightness(0.4) invert(0);}\n.fade.modal.show{background-color: #0008;}\n\n.notenoughdata ~ div, .notenoughdata ~ h5, .notenoughdata ~ p {opacity: 0.3;}\n\n.group-login .react-select__option{color: #000;}\n.group-login .react-select__option.react-select__option--is-focused{color: #003b68;}\n.group-login .react-select__menu .css-1n6sfyn-MenuList{scrollbar-width: 10px;}\n.group-login .react-select__menu .css-1n6sfyn-MenuList::-webkit-scrollbar {width: 6px;}\n.group-login .react-select__menu .css-1n6sfyn-MenuList::-moz-scrollbar {width: 6px;}\n.group-login .react-select__menu .css-1n6sfyn-MenuList::-webkit-scrollbar-track {background: #eee;}\n.group-login .react-select__menu .css-1n6sfyn-MenuList::-webkit-scrollbar-thumb {background-color: #666;border-radius: 20px;border: 2px solid #eee;}\nimg.img-fluid[src*='vishwakarma-university-vu-logo'] {\n    width: 150px;\n}\n\n\n.skill-wrap {\n\n}\n\n.skill-wrap .skill-range {\n    margin-bottom: 30px;\n}\n\n.select-skill input {\n    display: none;\n}\n\n.skill {\n    background: #FFFFFF ;\n    border: 1px solid #C1DDFD;\n    border-radius: 10px;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n    height: 100%;\n    position: relative;\n    text-decoration: none;\n    cursor: pointer;\n}\n\n.skill .icon {\n    display: flex;\n    align-items: center;\n}\n\n.select-skill input:checked+label.skill {\n    background: #2680EB;\n    border-color: #2680EB;\n    color: #fff;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n}\n\n.select-skill input:checked+label.skill .icon {\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    border: 2px solid #fff;\n    position: relative;\n}\n\n.select-skill input:checked+label.skill .icon::before {\n    content: '';\n    width: 13px;\n    height: 7px;\n    border-left: 2px solid #fff;\n    border-bottom: 2px solid #fff;\n    display: inline-block;\n    transform: rotate(-40deg);\n    margin: 7px 3px 0 0;\n    left: 7px;\n    top: 2px;\n    right: 0;\n    position: absolute;\n    background: none\n}\n\n.select-skill-container .select {\n    margin: 0 1% 2%;\n    width: 23%;\n    text-align: left;\n    min-height: 100px;\n}\n\n.select-skill-container .select.completed label.skill {\n    background: #fff;\n    border-color: #E5E5E5;\n    pointer-events: none;\n}\n\n.status {\n    background: #B2DB56 ;\n    border-radius: 10px 0px;\n    padding: 0 15px;\n    position: absolute;\n    top: -1px;\n    left: -1px;\n    height: 23px;\n    line-height: 23px;\n    display: none;\n    text-transform: capitalize;\n}\n\n.select-skill-container .select.completed label.skill .status {\n    display: block;\n}\n\n.select-skill-container .select .icon {\n    width: 36px;\n    height: 36px;\n}\n\n\n.skill-range .progress {\n    height: 20px;\n    max-width: 800px;\n    width: 90%;\n    border-radius: 25px;\n}\n\n.skill-range .progress .progress-bar {\n    border-radius: 25px;\n    height: 100%;\n    border: 0;\n}\n\n.skillBlock {\n    padding: 40px;\n}\n\n.sticky-select-skill-result {\n    padding: 36px 50px;\n    background: #ffffff;\n    margin-bottom: 50px;\n    position: sticky;\n    bottom: 0;\n    z-index: 1;\n    border-radius: 6px;\n    box-shadow: 0 0 10px 0px #99999947;\n}\n\n.sticky-select-skill-result .interested {\n    justify-content: center;\n    align-items: end;\n}\n\n.sticky-select-skill-result .interested .skill {\n    background: #0d3453;\n    color: #fff;\n    border: 0;\n    height: 54px;\n    padding: 0 15px;\n}\n\n.sticky-select-skill-result .interested .plus {\n    width: 10px;\n    height: 10px;\n    position: relative;\n    font-size: 0;\n    margin: 21px 20px;\n}\n\n.sticky-select-skill-result .interested .plus::before {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    width: 10px;\n    height: 2px;\n    background: #000;\n}\n\n.sticky-select-skill-result .interested .plus::after {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    width: 2px;\n    height: 10px;\n    background: #000;\n}\n\n.sticky-select-skill-result .interested .equalto::before,\n.sticky-select-skill-result .interested .equalto::after {\n  content: \"\";\n  width: 10px;\n  height: 2px;\n  background: #414141;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  margin: 1px 0;\n  display: inline-block;\n}\n.sticky-select-skill-result .interested .equalto {\n  width: 10px;\n  height: 10px;\n  position: relative;\n  font-size: 0;\n  display: flex;\n  flex-wrap: wrap;\n  margin: 21px 20px;\n}\n\n.sticky-select-skill-result .interested .icon-checked {\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    border: 2px solid #fff;\n    position: relative;\n    margin-left: 20px;\n}\n\n.sticky-select-skill-result .interested .icon-checked::before {\n    top: 8px;\n    left: 6px;\n    width: 15px;\n    height: 8px;\n    border-left: 3px solid #fff;\n    border-bottom: 3px solid #fff;\n}\n\n.sticky-select-skill-result .interested .icon-checked::after {\n   display: none;\n}\n/* for recruiter directory program list */\ni.plus-minus-toggle {\n    width: 20px;\n    height: 20px;\n    margin-right: 8px;\n    position: relative;\n    border: 1px solid #bacfde;\n    border-radius: 5px;\n}\n\ni.plus-minus-toggle::before, i.plus-minus-toggle::after{\n  content: '';\n  position: absolute;\n  width: 12px;\n  height: 2px;\n  background-color: #bacfde;\n  left: 0;right: 0;\n  top: 0;bottom: 0;\n  margin: auto;\n  transition: all 0.3s ease-in-out;\n\n}\n\ni.plus-minus-toggle::after{\n  transform: rotate(90deg);\n}\n\n[aria-expanded=\"true\"] i.plus-minus-toggle::after{\n  transform: rotate(180deg);\n}\n\n/* for recruiter directory program list */\ni.plus-minus-toggle {\n    width: 20px;\n    height: 20px;\n    margin-right: 8px;\n    position: relative;\n    border: 1px solid #bacfde;\n    border-radius: 5px;\n}\n\ni.plus-minus-toggle::before, i.plus-minus-toggle::after{\n  content: '';\n  position: absolute;\n  width: 12px;\n  height: 2px;\n  background-color: #bacfde;\n  left: 0;right: 0;\n  top: 0;bottom: 0;\n  margin: auto;\n  transition: all 0.3s ease-in-out;\n\n}\n\ni.plus-minus-toggle::after{\n  transform: rotate(90deg);\n}\n\n[aria-expanded=\"true\"] i.plus-minus-toggle::after{\n  transform: rotate(180deg);\n}\n.verify_massrecruiter {margin: -6px 0 0 70px;display: -webkit-box; display: -moz-box; display: -ms-flexbox; display: -webkit-flex; display: flex;width: calc(100% - 70px);}\n.verify_massrecruiter ul {padding: 0;margin: 0;list-style: none;display: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex;-webkit-box-wrap: wrap;-moz-box-wrap: wrap;-ms-flex-wrap: wrap;-webkit-wrap: wrap;flex-wrap: wrap;color: #0B3454;}\n.verify_massrecruiter ul li {display: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex;-webkit-box-wrap: wrap;-moz-box-wrap: wrap;-ms-flex-wrap: wrap;-webkit-wrap: wrap;flex-wrap: wrap;align-items: center;}\n.verify_massrecruiter ul li i{margin-right: 5px;}\n.verify_massrecruiter ul .verify {width: 19px;height: 24px;background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/green-verified.svg) no-repeat 0 0 / 100%;display: inline-block;}\n.verify_massrecruiter ul .massrecruiter {width: 23px;height: 23px;background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/style-images/search-user.svg) no-repeat 0 0 / 100%;display: inline-block;}\n.verify_massrecruiter ul .hand {width: 13px;height: 24px;background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/hand.svg) no-repeat 0 0 / 11px 24px;display: inline-block;}\n.verify_massrecruiter ul li:not(:last-child) {border-right: 1px solid #DEDCDC;padding-right: 10px;margin-right: 10px;}\n.form-check .form-check-input {width: 20px;height: 20px;vertical-align: top;display: inline-block;position: static;margin-right: 8px;margin-left: 0;margin-top: 0;border: 1px solid #0B34544D;}\n.form-check .form-check-input:checked {background-color: #5CAE48;\tborder-color: #5CAE48;}\n\n.form-check {display: flex;align-items: center;padding: 0;}\n.form-check .form-check-label {display: flex;align-items: center;line-height: 16px;margin: 0;}\n.form-check-input:checked {background-color: #29A745;border-color: #29A745;}\n\n.leaders-poster-templete-3.ratio-484{min-width: 484px;max-width: 484px;}\n.leaders-poster-templete-3 .background-color {position: absolute;left: 3%;right: 3%;margin: auto;bottom: 0;top: 3%;border-radius: 10% 5% 0 0 / 10% 5% 0 0;}\n.leaders-poster-templete-3 .background-color div{border-radius: 0 0 0 10% / 0 0 0 45%;font-size: 1rem;}\n.leaders-poster-templete-3 .college-logo {top: 7%;left: 7%;width: 55%;max-height: 60px;}\n.leaders-poster-templete-3 .college-logo img {height: 100%;width: auto;max-height: 80px;}\n.leaders-poster-templete-3 .leaders-poster-title {top: 25%;font-size: 2.1rem;font-weight: 700;}\n.leaders-poster-templete-3 .leaders-poster-title div {border-bottom: 1px solid #EE7936;padding: 0 1%;}\n.leaders-poster-templete-3 .leaders-poster-templete-3-alumni {position: absolute;left: 7%;top: 34%;width: 33.5%;}\n.leaders-poster-templete-3 .leaders-poster-alumni-detail {position: absolute;left: 45%;top: 46%;width: 49%;}\n.leaders-poster-templete-3 .leaders-poster-alumni-name {color: #EE7936;font-size: 2rem;font-weight: 700;line-height: 2rem;padding-left: 3%;}\n.leaders-poster-templete-3 .leaders-poster-alumni-batch-school {font-size: 1rem;font-weight: 700;padding-left: 3%;line-height: 1.2rem;padding-top: 2%;}\n.leaders-poster-templete-3 .footer-text {padding: 0% 10% 10%;font-size: 1rem;}\n.leaders-poster-templete-3 .powerby {width: 15%;bottom: 15%;right: 5%;position: absolute;font-size: 0.6rem;}\n.leaders-poster-templete-3 .footer-text .powerby img {max-width: 100%;}\n.leaders-poster-templete-3 span.slant-line {position: absolute;left: 0;top: -11%;background: #ee7936;width: 49%;height: 4%;transform: rotate(-5deg);}\n\n.btn-gold-f1ac18 {background-color: #F1AC18;color: #fff;transition: all 0.3s ease-in-out;}\n.btn-gold-f1ac18:hover {background-color: #c78800;}\n.icon-hand-rupee {  background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/hand-rupee.svg);  width: 20px;  height: 20px;  display: inline-block;  background-size: 100%;}\n.icon-alumni {  background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/icon-alumni.svg);  width: 30px;  height: 30px;  display: inline-block;  background-size: 100%;}\n.icon-listed-search {  background-image: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/list-search.svg);  width: 30px;  height: 30px;  display: inline-block;  background-size: 100%;}\n.icon-black-bulb {background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/green-blub.svg) no-repeat 0 0 / 28px auto;width: 28px;height: 28px;filter: brightness(0) invert(0);}\n.listed-insights {display: -webkit-box; display: -moz-box; display: -ms-flexbox; display: -webkit-flex; display: flex;flex-wrap: wrap;-webkit-box-wrap: wrap;-moz-box-wrap: wrap;-ms-flex-wrap: wrap;-webkit-wrap: wrap;width: 729px;}\n.listed-insights .icon-holder {height: 35px;width: 100%;display: -webkit-box; display: -moz-box; display: -ms-flexbox; display: -webkit-flex; display: flex;align-items: end;justify-content: end;}\n.listed-insights-block {background: #0B3454;border-radius: 6px;padding: 10px;-webkit-box-flex: 1;-moz-box-flex: 1;-webkit-flex: 1;-ms-flex: 1;flex: 1;color: #fff;}\n.listed-insights-block:not(:last-child) {margin-right: 13px;}\n\n@media (min-width: 768px) {\n.rightPaneOfFilter{flex: none;width: calc(100% - 361px);}\n}\n\n.interestedCandidates { max-height: 530px; padding-right: 10px;}\n.interestedCandidate-block:not(:last-child){margin-bottom: 10px;}\n.interestedCandidate-img{width: 90px;height: 90px;border-radius: 50%;overflow: hidden;display: -webkit-box; display: -moz-box; display: -ms-flexbox; display: -webkit-flex; display: flex;justify-items: center;align-items: center;  }\n.interestedCandidate-img img{width: 100%;height: 100%;object-fit: cover;}\n\n.leaders-poster-templete-4.ratio-484{min-width: 484px;max-width: 484px;}\n.leaders-poster-templete-4 .college-logo {margin: 0;width: 100%;text-align: center;position: absolute;top: 5%;height: 12%;}\n.leaders-poster-templete-4 .college-logo img {max-width: 260px;height: 100%;}\n.leaders-poster-templete-4  .background-color {position: absolute;width: 100%;height: calc(100% - 17.6%);top: 17.6%;border-radius: 30% 0% 0 0 / 30% 0% 0 0;}\n.leaders-poster-templete-4 .leaders-poster-title {top: 21%;font-size: 1.5rem;font-weight: 700;}\n.leaders-poster-templete-4 .leaders-poster-title div {border-bottom: 2px solid #B94EB9;padding: 0 13%;color: #fff;}\n.leaders-poster-templete-4-alumni {position: absolute;top: 32%;width: 28%;left: 5%;height: 28%;border-radius: 50%;overflow: hidden;}\n.leaders-poster-templete-4-alumni img {width: 100%;height: 100%;object-fit: cover;}\n.leaders-poster-templete-4 .leaders-poster-alumni-detail {position: absolute;left: 37%;top: 37.5%;width: 60%;}\n.leaders-poster-templete-4 .leaders-poster-alumni-name {color: #ffffff;font-size: 1.5rem;font-weight: 600;line-height: 2rem;padding-left: 0;}\n.leaders-poster-templete-4 .leaders-poster-alumni-batch-school {font-size: 1rem;font-weight: 500;padding-left: 0;line-height: 1.5rem;padding-top: 0;color: #ffffff;}\n.leaders-poster-templete-4 .leaders-poster-alumni-detail i.line {width: 18%;height: 3px;background: #fff;display: block;margin-top: 5%;}\n.leaders-poster-templete-4 .job-list {display: flex;flex-wrap: wrap;position: absolute;left: 24%;top: 62%;width: calc(100% - 24%);align-items: center;}\n.leaders-poster-templete-4 .logo-job-list {width: 50px;background: #fff;border-radius: 50%;position: relative;margin-right: 4%;height: 50px;display: flex;flex-wrap: wrap;justify-content: center;align-items: center;overflow: hidden;}\n.leaders-poster-templete-4 .logo-job-list img {width: 90%;height: auto;}\n.leaders-poster-templete-4 .job-list-name {color: #fff;line-height: 1.4rem;font-weight: 500;font-size: 1.1rem;}\n.leaders-poster-templete-4 .footer-text {border-radius: 0 14% 0 0 / 0 25% 0 0;padding: 4% 0 0 6%;height: 20%;}\n.leaders-poster-templete-4 .footer-text .left-text{width: 66%;}\n.leaders-poster-templete-4 .footer-text .left-text h6{color: #fff;font-size: 1.1rem;}\n.leaders-poster-templete-4 .footer-text .left-text p{color: #fff;font-size: 1rem;line-height: 1.2rem;}\n.leaders-poster-templete-4 .powerby {position: absolute;bottom: 0;right: 0;background: #953795;border-radius: 50% 0 0 0 / 100% 0 0 0;padding: 5% 3% 3% 10%;width: 33%;font-size: 0.8rem;}\n.leaders-poster-templete-4 .powerby img {width: 100%;}\n\n.leaders-poster-templete-5.ratio-484{min-width: 484px;max-width: 484px;}\n.leaders-poster-templete-5 .college-logo {margin: 0;text-align: center;position: absolute;top: 2%;max-width: 200px;left: 3%;height: 13%;}\n.leaders-poster-templete-5 .college-logo img {max-width: 100%;height: 100%;object-fit: contain;}\n.leaders-poster-templete-5 .leaders-poster-title {right: 0;top: 0;width: 55%;height: 20.8%;border-radius: 0px 0px 0px 541px;padding: 4% 8% 0 15%;color: #fff;font-size: 2rem;font-weight: 600;text-align: right;line-height: 2rem;}\n.leaders-poster-templete-5 .leaders-poster-alumni-detail {position: absolute;right: 0;top: 18%;width: 83%;height: 26.5%;mix-blend-mode: multiply;border-radius: 483px 0px 0px 0px;padding: 8.5% 7% 5% 34%;left: auto;}\n.leaders-poster-templete-5 .leaders-poster-alumni-name {color: #ffffff;font-size: 2rem;font-weight: 600;line-height: 2rem;padding-left: 0;}\n.leaders-poster-templete-5 .leaders-poster-alumni-batch-school {font-size: 1.2rem;font-weight: 400;padding-left: 0;color: #fff;margin-top: 2%;}\n.leaders-poster-templete-5-alumni {position: absolute;left: 0;bottom: 55.5%;width: 45%;}\n.leaders-poster-templete-5 .listed-points {position: absolute;top: 44.5%;margin: 0;padding: 5% 4% 6% 6%;}\n.leaders-poster-templete-5 .listed-points ul {list-style: none;padding: 0;margin: 0;}\n.leaders-poster-templete-5 .listed-points li {display: -webkit-box; display: -moz-box; display: -ms-flexbox; display: -webkit-flex; display: flex;flex-wrap: wrap;-webkit-box-wrap: wrap;-moz-box-wrap: wrap;-ms-flex-wrap: wrap;-webkit-wrap: wrap;padding: 1px 0 0 3%;}\n.leaders-poster-templete-5 .listed-points li:not(:last-child) {margin-bottom: 4.5%;}\n.leaders-poster-templete-5 .listed-points li .college{-webkit-box-flex: 1;-moz-box-flex: 1;-webkit-flex: 1;-ms-flex: 1;flex: 1;margin-right: 7%;}\n.leaders-poster-templete-5 .listed-points li .college-name-logo {width: 11.6%;display: -webkit-box; display: -moz-box; display: -ms-flexbox; display: -webkit-flex; display: flex;justify-content: center;}\n.leaders-poster-templete-5 .footer-text .powerby {flex-direction: row;justify-content: center;font-size: 0.8rem;align-items: center;margin: 2%;}\n.leaders-poster-templete-5 .footer-text .powerby span {margin-right: 10px;}\n.leaders-poster-templete-5 .footer-text hr {width: 80%;margin: 1% auto 2%;}\n.leaders-poster-templete-5 .footer-text .powerby img {width: 94px;margin: 0;}\n.leaders-poster-templete-5 .left-text {text-align: center;margin-top: 2%;}\n.leaders-poster-templete-5 .left-text p{margin: 0;}\n\n.leaders-poster-templete-6.ratio-484{min-width: 484px;max-width: 484px;}\n.leaders-poster-templete-6 .college-logo {margin: 0;text-align: center;position: absolute;top: 2%;max-width: 200px;left: 3%;}\n.leaders-poster-templete-6 .college-logo img {max-width: 100%;}\n.leaders-poster-templete-6 .leaders-poster-title {right: 0;top: 0;width: 72.5%;height: 16.2%;border-radius: 0px 0px 0px 541px;padding: 4% 4% 0 4%;color: #fff;font-size: 1.4rem;font-weight: 600;text-align: right;line-height: 2rem;}\n.leaders-poster-templete-6 .leaders-poster-alumni-detail {position: absolute;left: auto;top: 11%;width: 67%;right: 3%;}\n.leaders-poster-templete-6 .leaders-poster-alumni-name {color: #ffffff;font-size: 1.5rem;font-weight: 600;line-height: 1.8rem;padding-left: 0;margin-bottom: 1%;}\n.leaders-poster-templete-6 .leaders-poster-alumni-batch-school {font-size: 0.9rem;font-weight: 400;padding-left: 0;line-height: 1.1rem;}\n.leaders-poster-templete-6 .listed-points {position: absolute;top: 30%;margin: 0;padding: 6% 4% 6% 6%;width: 75.5%;right: 0;height: calc(100% - 30%);border-radius: 10% 0px 0px 0px;}\n.leaders-poster-templete-6 .listed-points ul {list-style: none;padding: 0;margin: 0;}\n.leaders-poster-templete-6 .listed-points li {display: -webkit-box; display: -moz-box; display: -ms-flexbox; display: -webkit-flex; display: flex;flex-wrap: wrap;-webkit-box-wrap: wrap;-moz-box-wrap: wrap;-ms-flex-wrap: wrap;-webkit-wrap: wrap;padding: 1px 0 0 3%;align-items: start;}\n.leaders-poster-templete-6 .listed-points li:not(:last-child) {margin-bottom: 5%;}\n.leaders-poster-templete-6 .listed-points li .college{-webkit-box-flex: 1;-moz-box-flex: 1;-webkit-flex: 1;-ms-flex: 1;flex: 1;margin-right: 7%;}\n.leaders-poster-templete-6 .listed-points li .college-name-logo {width: 28%;display: -webkit-box; display: -moz-box; display: -ms-flexbox; display: -webkit-flex; display: flex;justify-content: center;}\n.leaders-poster-templete-6  .background-color {position: absolute;width: 83%;height: calc(100% - 13.5%);top: 13.5%;mix-blend-mode: multiply;border-radius: 48% 0px 0px 0px;right: 0;}\n.leaders-poster-templete-6-alumni {position: absolute;left: 0;bottom: 20%;width: 40.5%;}\n.leaders-poster-templete-6 .footer-text {height: 17.7%;}\n.leaders-poster-templete-6 .footer-text .slant-line {position: absolute;left: -2%;right: 0;height: 100%;width: 150%;transform: rotate(4deg);bottom: 10%;}\n.leaders-poster-templete-6 h6{color: #fff;font-size: 1rem;font-weight: 500;margin-bottom: 4%;}\n.leaders-poster-templete-6 p{color: #fff;font-size: 1rem;margin-bottom: 2%;}\n.leaders-poster-templete-6 .footer-text .powerby {width: 19%;font-size: 0.7rem;position: absolute;bottom: 12%;right: 2%;}\n.leaders-poster-templete-6 .footer-text .powerby img {max-width: 100%;}\n.top-left-sticker {left: -42px;top: 2px;padding: 1px 45px;transform: rotate(-26deg);color: #fff;font-weight: 500;}\n.y-scroll {overflow-x: hidden;overflow-y: auto;}\n\n.bg-grd-blue-619ECE-0B3454{background: #619ECE;background: linear-gradient(134deg,rgba(97, 158, 206, 1) 0%, rgba(11, 52, 84, 1) 43%, rgba(11, 52, 84, 1) 100%);}\n\n.vertical-progress-list {width: max-content;min-width: 100%;}\n.vertical-progress-list ul {padding: 0;margin: 0;list-style: none;display: -webkit-box; display: -moz-box; display: -ms-flexbox; display: -webkit-flex; display: flex;flex-wrap: wrap;-webkit-box-wrap: wrap;-moz-box-wrap: wrap;-ms-flex-wrap: wrap;-webkit-wrap: wrap;}\n.vertical-progress-list ul li {width: 34px;}\n.vertical-progress-list ul li:not(:last-child) {margin-right: 11px;}\n.vertical-progress-list ul li .progress {height: 223px;align-items: end;border-radius: 4px 4px 0 0;overflow: visible;}\n.vertical-progress-list ul li .progress div {border-radius: 4px 4px 0 0;position: relative;}\n.vertical-progress-list ul li .progress div::before {content: attr(aria-valuenow);position: absolute;bottom: 100%;color: #0b3454;text-align: center;  width: 100%;  font-weight: 500;}\n.blue-color-filter{filter: brightness(0) saturate(100%) invert(16%) sepia(92%) saturate(584%) hue-rotate(167deg) brightness(94%) contrast(98%);}\n\n.ratio-32{width: 32px !important;height: 32px !important;}\n.recentActivitySummaryInsight{list-style: none;margin: 0;padding: 0;display: flex;flex-wrap: wrap;text-align: center;min-width: 100%;width: max-content;}\n.recentActivitySummaryInsight li {-webkit-box-flex: 1;-moz-box-flex: 1;-webkit-flex: 1;-ms-flex: 1;flex: 1;position: relative;}\n.recentActivitySummaryInsight li:not(:last-child){margin-right: 15px;padding-right: 15px;}\n.recentActivitySummaryInsight li:not(:last-child)::before{content: '';position: absolute;right: 0;bottom: 0;width: 1px;height: 65%;background: #E8E8E8;}\n\n.impersonate-login{width: 50px;height: 50px;left: 20px;}\n.impersonate-login > div{max-width: 220px;width: 220px;opacity: 0;transition: opacity 0.3s ease-in-out;position: absolute;bottom: 0px;left: 0;background: #fff;border: 1px solid #ccc;padding: 10px;border-radius: 6px;box-shadow: 0 0 10px 0px #99999947;}\n.impersonate-login:hover > div{opacity: 1;left: 0;bottom: 100%;}\n.impersonate-action-disabled{cursor: not-allowed !important; opacity: 0.4 !important;}\nbutton[disabled] {cursor: not-allowed !important; opacity: 0.4 !important;}\n\n.ratio-90{width: 90px !important;height: 90px !important;}\n\n.btn-profile-toggle{right: 23px;top:17px}\n.btn-profile-toggle[aria-expanded='true'] + .listed-border {  border-radius: 6px 6px 0 0;}\n.listed-body{border-radius: 0 0 6px 6px;}\n.listed-body.yellow{background-color: #ffff00;}\n.listed-body.orange{background-color: #eba500;}\n.listed-body.orange p{color: #fff;}\n\n.custom-radio-0B34544D{display: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex;align-items: center;}\n.custom-radio-0B34544D input {width: 20px;height: 20px;margin-right: 8px;}\n.custom-radio-0B34544D label{margin-top: 3px;}\n.custom-radio-0B34544D input:checked {background-color: #5CAE48;border-color: #5CAE48;}\n\n.tooltip.tooltip-white{opacity: 1;}\n.tooltip-white .tooltip-inner {background: #fff;box-shadow: none;padding: 20px;display: flex;flex-direction: column;justify-content: center;align-items: center;max-width: 230px;width: 100%;border: none;color: #000;border: 1px solid #d4d4d4;opacity: 1;}\n\n.tooltip.tooltip-white .tooltip-arrow::before {width: 10px;height: 10px;background: #ffffff;transform: rotate(45deg);left: 2px;border-left: 1px solid #d4d4d4;border-right: 1px solid #d4d4d4;border-top: 1px solid #d4d4d4;border-bottom: 1px solid #d4d4d4;}\n.tooltip.tooltip-white.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before{border-left: 1px solid #d4d4d4;border-right: 0px solid #d4d4d4;border-top: 0px solid #d4d4d4;border-bottom: 1px solid #d4d4d4;}\n.tooltip.tooltip-white.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {border-left: 0px solid #d4d4d4;border-right: 1px solid #d4d4d4;border-top: 0px solid #d4d4d4;border-bottom: 1px solid #d4d4d4;left: auto;transform: translatey(-5px) rotate(45deg);}\n.tooltip.tooltip-white.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {border-left: 0px solid #d4d4d4;border-right: 1px solid #d4d4d4;border-top: 1px solid #d4d4d4;border-bottom: 0px solid #d4d4d4;transform: translateX(-8px) rotate(45deg);}\n\n.profile_picture_qr_display {display: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex;-webkit-box-wrap: wrap;-moz-box-wrap: wrap;-ms-flex-wrap: wrap;-webkit-wrap: wrap;flex-wrap: wrap;justify-content: space-between;}\n.profile_picture_qr_display .qr_section {\tmax-width: 300px;\twidth: 100%;display: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex;}\n.profile_picture_qr_display .profile_picture_edit {border: 2px dashed #bbb;box-shadow: none;width: 120px;height: 120px;}\n.profile_picture_qr_display .profile_picture_edit .image-edit {position: absolute;top: auto;right: 0;bottom: 0;background-color: #27A7DF;}\n.profile_picture_qr_display .profile_picture_edit .image-edit:hover{background-color: #1C95CA;}\n.profile_picture_qr_display .profile_picture_edit::before {content: '';position: absolute;left: 0;right: 0;top: 0;bottom: 0;margin: auto;width: 100%;background: #f6faff;border-radius: 50%;z-index: 0;}\n.profile_picture_qr_display .profile_picture_edit img {width: 60px;position: relative;}\n.profile_picture_qr_display .or {width: 1px;position: relative;display: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex;align-items: center;justify-content: center;position: relative;background-color: #99999999;height: auto;z-index: 0;}\n.profile_picture_qr_display .or span{background-color: #fff;color: #A2A2A2;padding: 5px;}\n.profile_picture_qr_display .qr_section .whatapp_text {display: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex;flex-direction: column;margin-left: 5px;align-items: center;justify-content: center;text-align: center;color: #fff;font-weight: 400;}\n\n@media only screen and (min-width: 768px) and (max-width: 1138px)  {\n.profile_picture_qr_display {flex-direction: column;align-items: center;}\n.profile_picture_qr_display .or {\tmargin: 10px auto;}\n.profile_picture_qr_display .or {  margin: 25px auto;  height: 1px;  width: 120px;  border: none;}\n.profile_picture_qr_display .or::after{display: none;}\n}\n\n@media only screen and (max-width: 497px)  {\n.profile_picture_qr_display {flex-direction: column;align-items: center;}\n.profile_picture_qr_display .or {\tmargin: 10px auto;}\n.profile_picture_qr_display .or {  margin: 25px auto;  height: 1px;  width: 120px;  border: none;}\n.profile_picture_qr_display .or::after{display: none;}\n}\n\n.step_img .alumni-bucket{max-width: 268px;}\n.step_img .font-style{font-family: \"Waterfall\", cursive;}\n.step_img .missing .alumni-bucket .font-style {position: absolute;font-size: 38px;font-weight: 600;top: 40%;left: 89%;line-height: 32px;transform: rotate(-20deg);}\n.step_img .missing .alumni-bucket::after {content: '';position: absolute;width: 70px;height: 70px;background: url('https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/u-turn-arrow.svg') no-repeat 0 0 / contain;top: 83%;left: calc(100% + 10px);}\n.step_img .full-info .alumni-bucket {margin-left: 23%;}\n.step_img .full-info .alumni-bucket .font-style {position: absolute;font-size: 38px;font-weight: 600;top: 97%;left: 15%;line-height: 32px;transform: rotate(-10deg);}\n.header-highlight {background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/gray-hightlight.svg) no-repeat 0 0 / cover;white-space: nowrap;padding: 16px 38px;display: inline-block;}\n\n@media only screen and (max-width: 991px)  {\n.step_img .missing .alumni-bucket .font-style {top: -31%;left: 51%;line-height: 32px;transform: rotate(-13deg);}\n.step_img .full-info .alumni-bucket .font-style {position: absolute;font-size: 33px;font-weight: 600;top: -15%;left: -31%;line-height: 32px;transform: rotate(-10deg);}\n.step_img .missing .alumni-bucket::after {content: '';position: absolute;width: 40px;height: 70px;top: 90%;left: calc(90%);transform: rotate(3deg);}\n}\n\n.impact-flow{padding: 0;margin: 0;}\n.impact-flow li{list-style: none;position: relative;display: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex;-webkit-box-wrap: wrap;-moz-box-wrap: wrap;-ms-flex-wrap: wrap;-webkit-wrap: wrap;flex-wrap: wrap;}\n.impact-flow li:not(:last-child){margin-bottom: 20px;}\n.impact-flow .icon-wrapper{margin-right: 20px;position: relative;}\n.impact-flow .icon-wrapper:before, .impact-flow .icon-wrapper:after {  content: '';  width: 2px;  background: #0B345447;  position: absolute;  left: 0;  right: 0;  margin: auto;  z-index: 0;}\n.impact-flow .icon-wrapper:before{height: 24px;top: 0;}\n.impact-flow .icon-wrapper:after{height: calc(100% - 80px + 20px);top: 80px;}\n.impact-flow li:first-child .icon-wrapper:before {display: none;}\n.impact-flow li:last-child .icon-wrapper:after {display: none;}\n.impact-flow .icon{width: 50px;height: 50px;border: 2px solid #0B345447;border-radius: 50%;display: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex;justify-content: center;align-items: center;font-size: 24px;margin-top: 24px;box-shadow: 0 0 0px 5px #fff;position: relative;z-index: 1;background-color: #fff;}\n.impact-flow .impact-flow-detail {  width: calc(100% - 70px);  border: 1px solid #0B34544D;  border-radius: 6px;}\n.impact-flow .impact-flow-detail.border-success {border-color: rgb(92 174 72) !important;}\n\n.min-mt-1 {margin-top: -8px;display: inline-block;}\n\n@media only screen and (max-width: 600px)  {\n.impact-flow .icon-wrapper {margin-right: 10px;margin-left: 5px;}\n.impact-flow .icon {width: 40px;height: 40px;font-size: 22px;}\n.impact-flow .impact-flow-detail {  width: calc(100% - 55px); }\n}\n\n.icon-blue-copy{background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/blue-copy.svg) no-repeat center / 100%;width: 20px;height: 24px;}\n.bg_congratulations {background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/bg-graph-congrats.png) repeat-x top left / cover;}\n.bg-lite-purple-e8e6fd{background-color: #E8E6FD;}\n.border-color-0B34541A{border-color: #0B34541A !important;}\n\n.btn-send {display: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex;-webkit-box-wrap: wrap;-moz-box-wrap: wrap;-ms-flex-wrap: wrap;-webkit-wrap: wrap;flex-wrap: wrap;background: #5CAE48;border-radius: 25pc;color: #fff;text-decoration: none;align-items: center;font-size: 16px;font-weight: 500;transition: all 0.3s ease-in-out;}\n.btn-send {color: #fff;font-size: 16px;font-weight: 500;}\n.btn-send .icon-send {background: url(https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/send_alumni_profile.svg) no-repeat 0 0 / 100%;width: 19px;height: 19px;position: relative;transition: all 0.3s ease-in-out;left: 0;}\n.btn-send:hover .icon-send {left: 3px;}\n.btn-send:hover {\tbackground: #3B8D27;}\n\n.btn-warning-f1ac18 {background-color: #F1E0BA;transition: all 0.3s ease-in-out;}\n.btn-warning-f1ac18:hover {background-color: #c78800;color: #fff;}\n\n.filter-b-0{filter: brightness(0);}\n.filter-8c630c{filter: brightness(0) saturate(100%) invert(32%) sepia(73%) saturate(866%) hue-rotate(13deg) brightness(101%) contrast(91%);}\n.filter-51499c{filter: brightness(0) saturate(100%) invert(26%) sepia(53%) saturate(1275%) hue-rotate(217deg) brightness(94%) contrast(84%);}\n.ratio-40{width: 40px !important;height: 40px !important;}\ni.icon-tick {width: 16px;height: 8px;border-left: 3px solid #5cae48;border-bottom: 3px solid #5cae48;transform: rotate(-50deg) translate(4px, 0);}\n\n.form.needs-validation:has(.alumni-social-links) div[class*='col']{position: relative;}\n.form.needs-validation:has(.alumni-social-links) .text-danger{position: absolute;top:calc(100% - 7px);left: 0;z-index: 1;left: 8px;}\n.form.needs-validation:has(.alumni-social-links) .agree-to-univariety{position: relative;}\n.form.needs-validation:has(.alumni-social-links) .agree-to-univariety .text-danger{left: 8px;}\n\n.text-linkedin{color:#0b63bd}\n.text-facebook{color:#0862f7}\n.text-instagram{background: #833AB4;background: linear-gradient(45deg, #405de6, #5851db, #833ab4, #c13584, #e1306c, #fd1d1d);-webkit-background-clip: text;-webkit-text-fill-color: transparent;}\n.text-twiter{color:#1DA1F2}\n\n@media only screen and (max-width: 600px)  {\n.joined_offer_wrap .joined_label{height: auto;border-radius: 25px;padding: 7px 20px 7px 10px;}\n.joined_label i {}\n}\n\n.bg-gray-f5 {\n    background: #f5f5f5;\n}\n\n.sticky-actions {\n    position: sticky;\n    bottom: 0;\n    background: #fff;\n    padding: 10px 0;\n    display: flex;\n    justify-content: center;\n    gap: 20px;\n}\n.rich-text-content img {\n  max-width: 100%;\n  height: auto;\n  display: block;\n}\n\n/* ============================================\n   Outreach Dashboard Styles\n   ============================================ */\n\n.outreach-stat-card {\n    background: #fff;\n    border: 1px solid #D2D2D2;\n    border-radius: 6px;\n    padding: 16px;\n    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.06);\n    transition: box-shadow 0.2s ease;\n}\n\n.outreach-stat-card:hover {\n    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.outreach-panel {\n    background: #fff;\n    border: 1px solid #DCDCDC;\n    border-radius: 6px;\n    padding: 20px;\n}\n\n.outreach-purpose-item {\n    background: #F9F9F9;\n    border-radius: 4px;\n    padding: 8px 12px;\n}\n\n.outreach-progress-bar {\n    display: flex;\n    border-radius: 4px;\n    overflow: hidden;\n}\n\n.outreach-table thead th {\n    border-bottom: 2px solid #ECECEC;\n    padding: 10px 12px;\n    white-space: nowrap;\n}\n\n.outreach-table tbody td {\n    padding: 10px 12px;\n    border-bottom: 1px solid #F3F3F3;\n    vertical-align: middle;\n}\n\n.outreach-table tbody tr:hover {\n    background-color: #F9FBFC;\n}\n\n.outreach-table-scroll {\n    max-height: 380px;\n    overflow-y: auto;\n}\n\n.outreach-upload-zone {\n    border: 2px dashed #D2D2D2;\n    border-radius: 8px;\n    padding: 40px 20px;\n    transition: border-color 0.2s ease, background 0.2s ease;\n    cursor: pointer;\n}\n\n.outreach-upload-zone.active,\n.outreach-upload-zone:hover {\n    border-color: #26A7DF;\n    background: #F0F9FF;\n}\n\n.modal-backdrop-custom {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.5);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1050;\n}\n\n.modal-content-custom {\n    background: #fff;\n    border-radius: 8px;\n    padding: 24px;\n    width: 100%;\n    max-width: 560px;\n    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);\n}\n\n.text-gray-64 {\n    color: #646464 !important;\n}\n.custom-shadow {box-shadow: 0 0 4px 2px #cccccc82;}\n.w-1140{width: 1140px}\n.w-1070{width: 1070px}\n.hover-item {transition: all 0.3s ease-in-out;}\n.hover-item:hover {background-color: #f1f5f9;}\n.alumni-table th, .alumni-table td {padding: 16px 30px;}\n.alumni-table tbody tr:hover td {background-color: #f3f7f3;cursor: pointer;}\n.upload-zone {border: 2px dashed #c8d6e5;border-radius: 12px;background: #fafcff;padding: 2.5rem 1.5rem;text-align: center;cursor: pointer;transition: border-color 0.2s, background 0.2s;}\n.upload-zone:hover {border-color: #90aac8;background: #f3f7fb;}\n.upload-icon-wrap {width: 56px;height: 56px;background: #eef2f7;border-radius: 50%;display: flex;align-items: center;justify-content: center;margin: 0 auto 1rem;}\n.upload-icon-wrap i {font-size: 1.6rem;color: #8fa8c8;}\n.upload-zone .upload-title {font-size: 0.95rem;font-weight: 600;color: #1a1a2e;margin-bottom: 0.25rem;}\n.upload-zone .upload-sub {font-size: 0.8rem;color: #90a4ae;margin-bottom: 1.25rem;}\n.btn-browse {font-size: 0.85rem;font-weight: 500;color: #37474f;background: #fff;border: 1.5px solid #c8d6e5;border-radius: 8px;padding: 0.4rem 1.25rem;transition: background 0.15s, border-color 0.15s;}\n.btn-browse:hover {background: #f0f4f8;border-color: #90aac8;color: #1a1a2e;}\n.link-gray{color: #90a4ae;text-decoration: none;transition: color 0.2s;}\n.link-gray:hover {color: #2e8a59;}\n.bg-lite-purple-faf5ff{background-color: #faf5ff;}\n.border-purple-9812fa{border:1px solid #9812fa ;}\n.outreach-wrap ul{padding: 0;margin: 0;list-style: none;position: relative;}\n.outreach-wrap ul::before{content: '';position: absolute;left: 7px;top: 0;width: 4px;height: 100%;background: #e5e7eb;}\n.outreach-wrap ul li{position: relative;padding-left: 40px;}\n.outreach-wrap ul li:not(:last-child){margin-bottom: 30px;}\n.outreach-wrap ul li .dot {position: absolute;left: 0;top: 35px;width: 16px;height: 16px;background: #ffffff;border-radius: 50%;box-shadow: 0px 0 4px 0px #d7d7d7;border: 4px solid #ffffff;}\n.outreach-wrap ul li .dot.green-dot{background-color: #1d6b4f;}\n.outreach-wrap ul li .dot.purple-dot{background-color: #9333ea;}\n.outreach-wrap ul li .dot.orange-dot{background-color: #d97706;}\n.outreach-wrap ul li .dot.red-dot{background-color: #dc2626;}\n.outreach-wrap ul li .dot.blue-dot{background-color: #2563eb;}\n.alumniinformation .nav-link {background: none;padding: 0 0 3px;border-bottom: 1px solid #0d6efd;border-radius: 0;}\n.alumniinformation .nav-link.active {display: none;}\n.business-directory-tab .nav-item:not(:last-child) {margin-right: 30px;}\n.business-directory-tab .nav-link {background: none;padding: 0 0 3px;border-bottom: 4px solid transparent;border-radius: 0;font-size: 20px;font-weight: 400;color: #4D4D4D;}\n.business-directory-tab .nav-link.active {background-color: transparent;font-weight: 500;color: #0C4CBB;border-bottom: 4px solid #0d6efd;}\n.tablink .bi-check-circle-fill{top:-7px;right: -5px;}\n.alumniDetailPic {width: 100px;height: 100px;}\n.alumniDetailPic.ratio-60{width: 60px;height: 60px;}\n.alumniDetailPic img {width: auto;height: 100%;}\n\n.list-switch-tab .nav-item:not(:last-child) {margin-right: 8px;}\n.list-switch-tab .nav-item .nav-link {background: #f5f5f5;border-radius: 25px;font-size: 16px;font-weight: 400;color: #0B3454;height: 40px;padding: 5px 15px;}\n.list-switch-tab .nav-item .nav-link.active {background: #0b3454;color: #fff;}\n\n.bg-blue-eff8ff{background-color: #EFF8FF;}\n\n.job-tab{border: none;}\n.job-tab .nav-item:not(:last-child) {margin-right: 5px;}\n.job-tab .nav-link {background: none;border-width: 1px 1px 0;border-color: #707070;color: #5F5C5C;transition: all 0.3s ease-in-out;}\n.job-tab .nav-link.active {background-color: #5CAE48;color: #fff;border-color: #5CAE48;}\n\n\n.onhoverautoheight:not(:hover) div[class*='-MultiValueGeneric']{white-space: nowrap;  overflow: hidden;  text-overflow: ellipsis;width: 70px;}\n.onhoverautoheight:not(:hover) div[class*='-multiValue']:nth-child(2) ~ div[class*='-multiValue']{display: none;} \n\n/* ========================================\n   LOADER STYLES - Full Screen Overlay\n   ======================================== */\n\n.loader-container {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 9999;\n    backdrop-filter: blur(2px);\n    -webkit-backdrop-filter: blur(2px);\n}\n\n.loader-container .text-center {\n    background-color: #ffffff;\n    padding: 40px;\n    border-radius: 8px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n    animation: slideUp 0.3s ease-out;\n}\n\n.loader-container .spinner-border {\n    width: 3rem;\n    height: 3rem;\n    border-width: 0.3em;\n    animation: spin 1s linear infinite;\n}\n\n.loader-container .spinner-border-sm {\n    width: 1.5rem;\n    height: 1.5rem;\n    border-width: 0.2em;\n}\n\n.loader-container p {\n    color: #333333;\n    font-weight: 500;\n    font-size: 14px;\n    margin-top: 15px;\n    margin-bottom: 0;\n}\n\n/* Animations */\n@keyframes spin {\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n@keyframes slideUp {\n    from {\n        opacity: 0;\n        transform: translateY(20px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n/* Disabled state styles */\nbutton:disabled,\ninput:disabled {\n    opacity: 0.6 !important;\n    cursor: not-allowed !important;\n}\n\n.filter-disabled,\n[style*=\"pointerEvents: none\"] {\n    pointer-events: none;\n    opacity: 0.6;\n}\n\n.live-dot { width: 8px; height: 8px; border-radius: 99px; background: #5CAE48; box-shadow: 0 0 8px #5CAE48; display: inline-block; animation: pulse 1.5s infinite; }\n@keyframes pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.4; } }\n@keyframes fadeIn { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: translateY(0); } }\n\n.lasttr-noborder tr:last-child td {border: 0;}\n.qa-card{background: white;border: 1px solid var(--bs-secondary-border-subtle);border-radius: 6px;padding: 20px;display: flex;align-items: center;gap: 16px;cursor: pointer;transition: all 0.2s;text-decoration: none;color: inherit;}\n.qa-card:hover {border-color: var(--bs-primary-border-subtle) ;background-color: var(--bs-primary-bg-subtle) ;transform: translateY(-2px);box-shadow: var(--shadow-md);}\n.border-tab .nav-link{border: 1px solid #E5E7EB;background-color: #fff;color: #374151;}\n\n.min-wd-767{min-width: 767px;}\n.timeline-dot li{position: relative;}\n.timeline-dot li:not(:last-child)::before {content: '';position: absolute;left: 12px;top: 24px;background-color: #bfdbfe;width: 1px;height: 100%;}\n\n.timeline-dot-circle {background: #eff6ff;border: 1px solid #bfdbfe;width: 26px;height: 26px;font-size: 12px;position: relative;}\n.demographics-body .form-control {border: 1px solid #b5c2cb !important;min-height: 45px;}\n\n.border-bs-purple { border-color: rgba(var(--bs-purple-rgb), var(--bs-border-opacity)) !important;}\n.bg-purple-f5f3ff {background-color: #f5f3ff;}\n.bg-bs-purple {background: rgba(124, 58, 237, var(--bs-bg-opacity)) !important;}\ntbody tr:nth-last-child(-n + 4) .smart-actions{top:auto;bottom:100%;}\ntable tr:nth-child(-n + 4) .smart-actions{top:100%;bottom:auto;}\n\n#vibrancyDashboardAccordion {}\n#vibrancyDashboardAccordion .accordion-item {border: 1px solid #c5d0e6;border-radius: 10px;box-shadow: 0px 0 3px 1px #3333331a;}\n\n#vibrancyDashboardAccordion .accordion-item .accordion-button[aria-expanded=\"true\"]{background-color:transparent;border-bottom: 1px solid #ececec;}\n#vibrancyDashboardAccordion .accordion-item .accordion-button span{background-color: #d6d6d6 !important;color: #443636 !important;padding: 6px 10px;}\n#vibrancyDashboardAccordion .accordion-item .accordion-button::after {background-color: transparent;}\n/* .accordion-item:has(#vibrancyPointsHeading .accordion-button[aria-expanded=\"true\"]){background-color: #fff6f0 !important;} */\n.accordion-item:has(#vibrancyPointsHeading .accordion-button[aria-expanded=\"true\"]) .accordion-button{color: #ea580c !important;border-color: #ffd9cf;}\n.accordion-item:has(#vibrancyPointsHeading .accordion-button[aria-expanded=\"true\"]) .accordion-button span{background-color: #ea580c !important;color: #fff !important;}\n\n/* .accordion-item:has(#dataCoverageHeading .accordion-button[aria-expanded=\"true\"]){background-color: rgba(14,165,233,0.09) !important;} */\n.accordion-item:has(#dataCoverageHeading .accordion-button[aria-expanded=\"true\"]) .accordion-button{color: #0284c7 !important;border-color: #a8e1ff;}\n.accordion-item:has(#dataCoverageHeading .accordion-button[aria-expanded=\"true\"]) .accordion-button span{background-color: #0284c7 !important;color: #ffffff !important;}\n\n/* .accordion-item:has(#outreachStatsHeading .accordion-button[aria-expanded=\"true\"]){background-color: rgb(209, 250, 229) !important;} */\n.accordion-item:has(#outreachStatsHeading .accordion-button[aria-expanded=\"true\"]) .accordion-button{color: #0f9d58 !important;border-color: #aadfc5;}\n.accordion-item:has(#outreachStatsHeading .accordion-button[aria-expanded=\"true\"]) .accordion-button span{background-color: #0f9d58 !important;color: #fff !important;}\n\n/* .accordion-item:has(#activityStatsHeading .accordion-button[aria-expanded=\"true\"]) {background-color: rgba(124,58,237,0.08) !important;} */\n.accordion-item:has(#activityStatsHeading .accordion-button[aria-expanded=\"true\"]) .accordion-button{color: #7c3aed !important;border-color: #dfccff;}\n.accordion-item:has(#activityStatsHeading .accordion-button[aria-expanded=\"true\"]) .accordion-button span{background-color: #7c3aed !important;color: #fff !important;}\n\n@media (min-width: 768px) {\n.right-md-border{border-right: 1px solid #e5e7eb !important;}\n}\n@media (max-width: 768px) {\n.right-md-border{border-bottom: 1px solid #e5e7eb !important;}\n}\n\n\n/* Adaptive org/company logos: square JPEG vs circular/transparent-corner logos */\n.alumni_univarsity_logo.logo-shape-pending,\n.alumni_profile_college_logo.logo-shape-pending,\n.work-block .icon.workex-logo.logo-shape-pending {\n    border-radius: 8px;\n    border: 1px solid #e5e5e5;\n    background: #fff;\n    overflow: hidden;\n}\n\n.alumni_univarsity_logo.logo-shape-square,\n.alumni_profile_college_logo.logo-shape-square,\n.work-block .icon.workex-logo.logo-shape-square {\n    border-radius: 8px !important;\n    border: 1px solid #e5e5e5 !important;\n    background: #fff !important;\n    overflow: hidden;\n    padding: 4px !important;\n}\n\n.alumni_univarsity_logo.logo-shape-square img,\n.alumni_profile_college_logo.logo-shape-square img,\n.work-block .icon.workex-logo.logo-shape-square img {\n    border-radius: 0 !important;\n    width: 100% !important;\n    height: 100% !important;\n    max-width: 100% !important;\n    max-height: 100% !important;\n    object-fit: contain !important;\n}\n\n.alumni_univarsity_logo.logo-shape-circle,\n.alumni_profile_college_logo.logo-shape-circle,\n.work-block .icon.workex-logo.logo-shape-circle {\n    border-radius: 50% !important;\n    border: 1px solid #d2d2d2 !important;\n    background: #fff !important;\n    overflow: hidden;\n    padding: 4px !important;\n}\n\n.alumni_univarsity_logo.logo-shape-circle img,\n.alumni_profile_college_logo.logo-shape-circle img,\n.work-block .icon.workex-logo.logo-shape-circle img {\n    border-radius: 50% !important;\n    width: 100% !important;\n    height: 100% !important;\n    max-width: 100% !important;\n    max-height: 100% !important;\n    object-fit: contain !important;\n}\n/* ========================================\n   FACT LOADER - directory search overlay\n   ======================================== */\n   .uv-loader-overlay {\n    position: fixed;\n    inset: 0;\n    z-index: 9999;\n    backdrop-filter: blur(2px);\n    -webkit-backdrop-filter: blur(2px);\n}\n\n.uv-loader-card {\n    --uv-navy: #51499c;\n    --uv-ink: #1f2430;\n    --uv-ink-soft: #6b7280;\n    box-shadow: 0 20px 50px rgba(15, 30, 45, .25);\n    width: min(480px, calc(100vw - 40px));\n    animation: slideUp 0.3s ease-out;\n}\n\n.uv-logo-loader {\n    width: 56px;\n    height: 74px;\n    margin: 0 auto 16px;\n}\n.uv-logo-loader svg {\n    width: 56px;\n    height: 74px;\n    max-width: 56px;\n    max-height: 74px;\n    display: block;\n    overflow: visible;\n}\n.uv-logo-stripe {\n    opacity: 0;\n    animation: uv-logo-in 2.4s cubic-bezier(.4,0,.2,1) infinite;\n    animation-delay: calc(var(--i) * 0.13s);\n}\n@keyframes uv-logo-in {\n    0%   { opacity: 0; transform: translate(-16px, 11px); }\n    16%  { opacity: 1; transform: translate(0, 0); }\n    70%  { opacity: 1; transform: translate(0, 0); }\n    85%  { opacity: 0; transform: translate(0, 0); }\n    100% { opacity: 0; transform: translate(-16px, 11px); }\n}\n@media (prefers-reduced-motion: reduce) {\n    .uv-logo-stripe {\n        animation: uv-logo-pulse 2.4s ease-in-out infinite;\n        transform: none;\n    }\n    @keyframes uv-logo-pulse {\n        0%, 100% { opacity: 1; } 50% { opacity: .45; }\n    }\n}\n\n.uv-loader-status {\n    font-size: 14px;\n    color: var(--uv-ink-soft);\n}\n\n.uv-fact-icon {\n    width: 34px;\n    height: 34px;\n    margin: 0 auto 14px;\n    color: var(--uv-navy);\n    opacity: .85;\n    transition: opacity .4s ease, transform .4s ease;\n}\n.uv-fact-icon.is-fading { opacity: 0; transform: translateY(4px); }\n.uv-fact-icon svg { width: 100%; height: 100%; display: block; }\n\n.uv-fact { min-height: 72px; }\n.uv-fact-text {\n    font-size: 15.5px;\n    line-height: 1.55;\n    color: var(--uv-ink);\n    opacity: 1;\n    transition: opacity .4s ease;\n}\n.uv-fact-text.is-fading { opacity: 0; }\n.uv-fact-text .uv-punch { color: var(--uv-navy); font-weight: 600; }\n\n.uv-fact-dots span {\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background: #d4dbe3;\n    transition: background .3s;\n}\n.uv-fact-dots span.is-active { background: var(--uv-navy); }\n\n@media (prefers-reduced-motion: reduce) {\n    .uv-fact-text, .uv-fact-icon { transition: none; }\n}\n\n/* ===== Directory filters head: result count + layout ===== */\n.filters-head {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    gap: 8px 12px;\n}\n\n.filters-head-left {\n    display: inline-flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 12px;\n    min-width: 0;\n}\n\n.filters-head-left h3 {\n    display: inline-flex !important;\n    align-items: center;\n    margin: 0;\n    width: auto !important;\n    flex: 0 0 auto !important;\n}\n\n.filters-head-left h3 .icon-filter + span {\n    flex: 0 0 auto !important;\n}\n\n.filters-head-right {\n    display: inline-flex;\n    align-items: center;\n    gap: 12px;\n    margin-left: auto;\n}\n\n.filters-head-toggle {\n    cursor: pointer;\n    transition: transform 0.3s ease-in-out;\n}\n\n.filters-head-toggle[aria-expanded='true'] {\n    transform: rotate(270deg);\n}\n\n.filters-head-toggle[aria-expanded='false'] {\n    transform: rotate(90deg);\n}\n\n/* Result count chip — green accent (not red/alert) */\n.directory-result-count {\n    --drc-green: #1a9f5c;\n    --drc-green-soft: #eefaf3;\n    --drc-ink: #1a2332;\n    --drc-muted: #5c6570;\n\n    position: relative;\n    display: inline-flex;\n    align-items: center;\n    gap: 10px;\n    margin: 0;\n    padding: 7px 16px 7px 10px;\n    min-height: 38px;\n    border-radius: 12px;\n    background: linear-gradient(135deg, #ffffff 0%, var(--drc-green-soft) 100%);\n    border: 1px solid rgba(26, 159, 92, 0.2);\n    box-shadow:\n        0 1px 2px rgba(26, 35, 50, 0.04),\n        0 4px 12px rgba(26, 159, 92, 0.08);\n    color: var(--drc-ink);\n    white-space: nowrap;\n    line-height: 1.15;\n    animation: directory-result-count-in 0.35s ease-out;\n}\n\n.directory-result-count::before {\n    content: '';\n    width: 3px;\n    align-self: stretch;\n    min-height: 22px;\n    border-radius: 3px;\n    background: linear-gradient(180deg, #3ecf8e 0%, var(--drc-green) 100%);\n    flex-shrink: 0;\n}\n\n.directory-result-count__body {\n    display: inline-flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 1px;\n    min-width: 0;\n}\n\n.directory-result-count__row {\n    display: inline-flex;\n    align-items: baseline;\n    gap: 6px;\n}\n\n.directory-result-count__num {\n    font-size: 20px;\n    font-weight: 700;\n    letter-spacing: -0.03em;\n    color: var(--drc-green);\n    font-variant-numeric: tabular-nums;\n    transition: color 0.2s ease;\n}\n\n.directory-result-count__label {\n    font-size: 12px;\n    font-weight: 600;\n    color: var(--drc-muted);\n    letter-spacing: 0.02em;\n    text-transform: lowercase;\n}\n\n.directory-result-count.is-loading {\n    background: linear-gradient(90deg, #f7f8fa 0%, #eefaf3 50%, #f7f8fa 100%);\n    background-size: 200% 100%;\n    animation: directory-result-count-shimmer 1.2s ease-in-out infinite;\n    box-shadow: none;\n}\n\n.directory-result-count.is-loading::before {\n    opacity: 0.35;\n}\n\n.directory-result-count.is-loading .directory-result-count__label {\n    color: #8a939e;\n    font-size: 12px;\n    font-weight: 500;\n    text-transform: none;\n}\n\n@keyframes directory-result-count-in {\n    from {\n        opacity: 0;\n        transform: translateY(4px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n@keyframes directory-result-count-shimmer {\n    0% {\n        background-position: 100% 0;\n    }\n    100% {\n        background-position: -100% 0;\n    }\n}\n\n@media (max-width: 767px) {\n    .directory-result-count {\n        padding: 5px 12px 5px 8px;\n        min-height: 32px;\n        border-radius: 10px;\n        gap: 8px;\n    }\n\n    .directory-result-count__num {\n        font-size: 16px;\n    }\n\n    .directory-result-count__label {\n        font-size: 11px;\n    }\n}\n\n/* Country filter — same Top Countries / divider structure as form SelectControl optgroups */\n.alumni_directory_filter .directory-filter-optgroup-label {\n    font-size: 14px;\n    font-weight: 600;\n    color: #212529;\n    padding: 6px 0 4px;\n    margin-bottom: 2px;\n    line-height: 1.2;\n}\n.alumni_directory_filter .directory-filter-optgroup-divider {\n    font-weight: 400;\n    font-size: 12px;\n    color: #6c757d;\n    letter-spacing: 1px;\n    padding-top: 8px;\n    margin-top: 4px;\n    border-top: 1px solid #dee2e6;\n    overflow: hidden;\n    white-space: nowrap;\n}\n.alumni_directory_filter .directory-filter-country-groups .form-check:first-of-type {\n    margin-top: 0;\n}\n.alumni_directory_filter .fiterItem .form-check:not(:last-child) {\n    margin-bottom: 4px;\n}\n/* Show Profiles — keep boolean filters on one row (desktop) */\n@media (min-width: 951px) {\n    .showProfiles_left {\n        flex-wrap: nowrap;\n        flex: 1;\n        min-width: 0;\n    }\n\n    .showProfiles_left .check_list-single-row {\n        flex-wrap: nowrap;\n        flex: 1;\n        min-width: 0;\n        overflow-x: auto;\n        scrollbar-width: thin;\n        gap: 4px 12px;\n    }\n\n    .showProfiles_left .check_list-single-row .form-check.form-check-inline {\n        flex-shrink: 0;\n        margin-right: 0;\n    }\n\n    .showProfiles_left .check_list-single-row .form-check-label {\n        white-space: nowrap;\n    }\n}\n\n.form-switch .form-check-input {width: 60px;background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%280, 0, 0, 0.25%29'/%3e%3c/svg%3e\");background-position: left center;border-radius: 2em;transition: background-position .15s ease-in-out;height: 28px;border: 1px solid #ccc;}\n.form-switch .form-check-input:checked {background-position: right center;background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\");}\n\n/* Entrepreneur Directory cards — prototype HTML layout in revamp_style */\n.ent-dir-revenue-filter {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    margin: 0;\n}\n\n.ent-dir-revenue-filter__label {\n    font-size: 14px;\n    font-weight: 500;\n    color: #1a2332;\n    white-space: nowrap;\n}\n\n.ent-dir-revenue-filter .form-select {\n    min-width: 140px;\n    width: auto;\n    height: 38px;\n    padding: 6px 32px 6px 12px;\n    font-size: 14px;\n    font-weight: 500;\n    border-radius: 8px;\n}\n\n.ent-dir-card {\n    overflow: hidden;\n    box-shadow: 0 1px 4px rgba(18, 38, 58, 0.06);\n    border-color: #d9e3ec !important;\n}\n\n.ent-dir-card__head {\n    padding: 16px 16px 14px;\n    background: #fff;\n}\n\n.ent-dir-card__photo {\n    width: 48px;\n    height: 48px;\n    border-radius: 50%;\n    overflow: hidden;\n    display: block;\n    background: #cdeafc;\n}\n\n.ent-dir-card__photo img,\n.ent-dir-card__photo > div {\n    width: 48px !important;\n    height: 48px !important;\n    object-fit: cover;\n    border-radius: 50%;\n    font-size: 0.9rem !important;\n}\n\n.ent-dir-card__name {\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 1.3;\n    margin: 0;\n}\n\n.ent-dir-card__name a {\n    color: #12263a;\n    text-decoration: none;\n}\n\n.ent-dir-card__name a:hover {\n    color: #0b5ed7;\n}\n\n.ent-dir-card__program {\n    font-size: 13px;\n    color: #5b6b7a;\n    line-height: 1.35;\n}\n\n.ent-dir-card__location {\n    font-size: 13px;\n    color: #5b6b7a;\n    margin-top: 2px;\n}\n\n.ent-dir-pill {\n    position: absolute;\n    top: 0;\n    right: 0;\n    font: 700 10px Nunito, sans-serif;\n    letter-spacing: 0.03em;\n    line-height: 1;\n    padding: 4px 10px;\n    border-radius: 14px;\n    white-space: nowrap;\n}\n\n.ent-dir-pill--first-gen {\n    background: rgb(240, 180, 41);\n    color: rgb(92, 61, 0);\n}\n\n.ent-dir-pill--family {\n    background: rgb(219, 228, 236);\n    color: rgb(61, 82, 102);\n}\n\n.ent-dir-card__company {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    padding: 14px 16px;\n    background: #e8f4fc;\n    min-height: 84px;\n}\n\n.ent-dir-card__logo,\n.ent-dir-card__logo img {\n    width: 48px;\n    height: 48px;\n    object-fit: contain;\n    flex-shrink: 0;\n}\n\n.ent-dir-card__logo.logo-shape-icon {\n    padding: 8px !important;\n}\n\n.ent-dir-card__company-name {\n    font-size: 15px;\n    font-weight: 600;\n    color: #12263a;\n    line-height: 1.3;\n}\n\n.ent-dir-card__meta {\n    font-size: 13px;\n    color: #5b6b7a;\n    margin-top: 4px;\n    line-height: 1.4;\n}\n\n.ent-dir-card__revenue {\n    padding: 10px 16px 14px;\n    background: #e8f4fc;\n}\n\n.ent-dir-revenue-badge {\n    display: inline-block;\n    font-size: 12px;\n    font-weight: 600;\n    color: #0b5ed7;\n    background: #d6ebfa;\n    border-radius: 999px;\n    padding: 4px 10px;\n}\n\n.ent-dir-revenue-badge--empty {\n    color: #6c757d;\n    background: #e9ecef;\n    font-weight: 500;\n}\n\n/* ==========================================================================\n   Custom Reports (internal admin) — Ability Markers shell\n   Prefix: .cr-*  |  Do not add a separate CSS file for this module\n   ========================================================================== */\n.cr-page {\n    --cr-navy: #1a2744;\n    --cr-navy-2: #243356;\n    --cr-gold: #b8860b;\n    --cr-orange: #e77817;\n    --cr-red: #c0392b;\n    --cr-green: #1e7e34;\n    --cr-bg: #f6f7fb;\n    --cr-border: #e6e8ef;\n    --cr-muted: #6b7280;\n    --cr-text: #2b3247;\n    background: var(--cr-bg);\n    color: var(--cr-text);\n    padding: 22px 20px 60px;\n    min-height: calc(100vh - 140px);\n}\n\n.cr-page-head {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 12px;\n    margin-bottom: 18px;\n}\n\n.cr-page-head h1 {\n    font-size: 24px;\n    font-weight: 600;\n    margin: 0;\n    color: var(--cr-navy);\n}\n\n.cr-page-head p {\n    color: var(--cr-muted);\n    font-size: 13px;\n    margin: 4px 0 0;\n}\n\n.cr-page-actions {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex-shrink: 0;\n}\n\n.cr-layout {\n    display: grid;\n    grid-template-columns: 240px 1fr;\n    gap: 20px;\n    align-items: start;\n}\n\n.cr-side-nav {\n    background: #fff;\n    border: 1px solid var(--cr-border);\n    border-radius: 8px;\n    padding: 8px 0;\n    position: sticky;\n    top: 12px;\n}\n\n.cr-side-grp {\n    padding: 10px 16px 6px;\n    font-size: 11px;\n    color: var(--cr-muted);\n    font-weight: 700;\n    letter-spacing: 0.6px;\n    text-transform: uppercase;\n}\n\n.cr-side-link {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 10px 16px;\n    color: var(--cr-text);\n    text-decoration: none;\n    font-weight: 500;\n    font-size: 13.5px;\n    border-left: 3px solid transparent;\n}\n\n.cr-side-link i {\n    color: var(--cr-muted);\n    font-size: 15px;\n    width: 18px;\n    text-align: center;\n}\n\n.cr-side-link:hover {\n    background: #f2f4f9;\n    color: var(--cr-navy);\n}\n\n.cr-side-link.active {\n    background: #eef2fb;\n    border-left-color: var(--cr-navy);\n    color: var(--cr-navy);\n    font-weight: 600;\n}\n\n.cr-side-link.active i {\n    color: var(--cr-navy);\n}\n\n.cr-side-count {\n    margin-left: auto;\n    background: #eef2fb;\n    color: var(--cr-navy);\n    border-radius: 10px;\n    padding: 1px 8px;\n    font-size: 11px;\n    font-weight: 600;\n}\n\n.cr-rpt {\n    background: #fff;\n    border: 1px solid var(--cr-border);\n    border-radius: 8px;\n    overflow: hidden;\n}\n\n.cr-rpt-head {\n    padding: 18px 20px;\n    border-bottom: 1px solid var(--cr-border);\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 14px;\n    flex-wrap: wrap;\n}\n\n.cr-rpt-head h2 {\n    font-size: 19px;\n    font-weight: 600;\n    margin: 0;\n    color: var(--cr-navy);\n}\n\n.cr-rpt-head h2 i {\n    color: var(--cr-muted);\n}\n\n.cr-rpt-desc {\n    color: var(--cr-muted);\n    font-size: 12.5px;\n    margin: 4px 0 0;\n    max-width: 720px;\n}\n\n.cr-rpt-actions {\n    display: flex;\n    gap: 8px;\n    flex-wrap: wrap;\n}\n\n.cr-btn {\n    border-radius: 6px;\n    padding: 7px 14px;\n    font-weight: 500;\n    font-size: 13.5px;\n    display: inline-flex;\n    align-items: center;\n    line-height: 1.3;\n    cursor: pointer;\n}\n\n.cr-btn-sm {\n    padding: 6px 12px;\n    font-size: 13px;\n}\n\n.cr-icon-btn {\n    padding: 6px 8px;\n}\n\n.cr-btn-navy {\n    background: var(--cr-navy);\n    color: #fff;\n    border: 1px solid var(--cr-navy);\n}\n\n.cr-btn-navy:hover {\n    background: var(--cr-navy-2);\n    color: #fff;\n}\n\n.cr-btn:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n}\n\n.cr-btn-navy:disabled:hover {\n    background: var(--cr-navy);\n    color: #fff;\n}\n\n.cr-btn-outline {\n    background: #fff;\n    color: var(--cr-navy);\n    border: 1px solid var(--cr-navy);\n}\n\n.cr-btn-outline:hover {\n    background: var(--cr-navy);\n    color: #fff;\n}\n\n.cr-btn-ghost {\n    background: #fff;\n    border: 1px solid var(--cr-border);\n    color: var(--cr-text);\n}\n\n.cr-btn-ghost:hover {\n    background: #f2f4f9;\n}\n\n.cr-filter-bar {\n    padding: 14px 20px;\n    background: #fbfbfd;\n    border-bottom: 1px solid var(--cr-border);\n}\n\n.cr-filter-row {\n    display: flex;\n    gap: 10px;\n    flex-wrap: wrap;\n    align-items: center;\n}\n\n.cr-search {\n    position: relative;\n    flex: 1;\n    min-width: 240px;\n    max-width: 360px;\n}\n\n.cr-search i {\n    position: absolute;\n    left: 12px;\n    top: 50%;\n    transform: translateY(-50%);\n    color: var(--cr-muted);\n}\n\n.cr-search input {\n    padding: 0 12px 0 34px;\n    height: 36px;\n    font-size: 13px;\n    border: 1px solid var(--cr-border);\n    border-radius: 6px;\n    width: 100%;\n    background: #fff;\n}\n\n.cr-pill {\n    background: #fff;\n    border: 1px solid var(--cr-border);\n    border-radius: 20px;\n    padding: 6px 12px;\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 12.5px;\n    font-weight: 500;\n    color: var(--cr-text);\n    cursor: pointer;\n}\n\n.cr-pill i {\n    font-size: 10px;\n    color: var(--cr-muted);\n}\n\n.cr-more {\n    background: none;\n    border: none;\n    color: var(--cr-navy);\n    font-weight: 600;\n    font-size: 12.5px;\n    padding: 6px 4px;\n    cursor: pointer;\n}\n\n.cr-more:hover {\n    text-decoration: underline;\n}\n\n.cr-more-wrap {\n    position: relative;\n}\n\n.cr-more-menu {\n    position: absolute;\n    z-index: 6;\n    top: calc(100% + 6px);\n    left: 0;\n    min-width: 200px;\n    padding: 8px;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    background: #fff;\n    border: 1px solid var(--cr-border);\n    border-radius: 8px;\n    box-shadow: 0 8px 24px rgba(16, 24, 40, 0.08);\n}\n\n.cr-chip button,\n.cr-pill button {\n    border: 0;\n    background: transparent;\n    padding: 0;\n    color: inherit;\n    line-height: 1;\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    font: inherit;\n    cursor: pointer;\n}\n\n.cr-pill.has-value,\n.cr-chip.has-value {\n    border-color: var(--cr-navy);\n    background: #eef3fb;\n}\n\n.cr-filter-menu {\n    position: relative;\n}\n\n.cr-filter-drop {\n    position: absolute;\n    z-index: 8;\n    top: calc(100% + 6px);\n    left: 0;\n    min-width: 220px;\n    max-height: 240px;\n    overflow: auto;\n    padding: 6px;\n    background: #fff;\n    border: 1px solid var(--cr-border);\n    border-radius: 8px;\n    box-shadow: 0 8px 24px rgba(16, 24, 40, 0.08);\n}\n\n.cr-filter-drop .cr-filter-search {\n    position: sticky;\n    top: -6px;\n    z-index: 1;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    margin: -6px -6px 6px;\n    padding: 8px;\n    background: #fff;\n    border-bottom: 1px solid var(--cr-border);\n    cursor: default;\n}\n\n.cr-filter-drop .cr-filter-search:hover {\n    background: #fff;\n}\n\n.cr-filter-drop .cr-filter-search input {\n    width: 100%;\n    border: 1px solid var(--cr-border);\n    border-radius: 6px;\n    padding: 4px 8px;\n    font-size: 12.5px;\n    font-weight: 500;\n}\n\n.cr-filter-drop label {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 6px 8px;\n    font-size: 12.5px;\n    font-weight: 500;\n    cursor: pointer;\n}\n\n.cr-filter-drop label:hover {\n    background: #f4f6fb;\n}\n\n.cr-marker-strip {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n    padding: 10px 20px;\n    background: #fbfbfd;\n    border-bottom: 1px solid var(--cr-border);\n    align-items: center;\n}\n\n.cr-strip-label {\n    font-size: 11.5px;\n    color: var(--cr-muted);\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    font-weight: 700;\n    margin-right: 4px;\n}\n\n.cr-chip {\n    background: #fff;\n    border: 1px solid var(--cr-border);\n    border-radius: 16px;\n    padding: 5px 12px;\n    font-size: 12px;\n    font-weight: 500;\n    cursor: pointer;\n    color: var(--cr-text);\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.cr-chip:hover {\n    border-color: var(--cr-navy);\n}\n\n.cr-chip.on {\n    background: var(--cr-navy);\n    color: #fff;\n    border-color: var(--cr-navy);\n}\n\n.cr-chip-add {\n    border-style: dashed;\n    color: var(--cr-navy);\n}\n\n.cr-rpt-body {\n    padding: 14px 20px 20px;\n}\n\n.cr-toolbar {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 6px 0 12px;\n    flex-wrap: wrap;\n    gap: 10px;\n}\n\n.cr-count {\n    font-size: 13px;\n    color: var(--cr-muted);\n}\n\n.cr-count strong {\n    color: var(--cr-text);\n}\n\n.cr-static-note {\n    font-size: 11.5px;\n    color: var(--cr-muted);\n}\n\n.cr-sort {\n    display: flex;\n    gap: 8px;\n    align-items: center;\n    font-size: 12.5px;\n    color: var(--cr-muted);\n}\n\n.cr-sort select {\n    border: 1px solid var(--cr-border);\n    border-radius: 6px;\n    padding: 5px 8px;\n    font-size: 12.5px;\n    background: #fff;\n}\n\n.cr-table {\n    width: 100%;\n    font-size: 13px;\n    border-collapse: separate;\n    border-spacing: 0;\n}\n\n.cr-table thead th {\n    background: #f5f6fa;\n    color: var(--cr-navy);\n    font-weight: 600;\n    font-size: 12px;\n    text-transform: uppercase;\n    letter-spacing: 0.4px;\n    padding: 11px 12px;\n    border-bottom: 1px solid var(--cr-border);\n    text-align: left;\n    white-space: nowrap;\n}\n\n.cr-table tbody td {\n    padding: 14px 12px;\n    border-bottom: 1px solid #f0f2f7;\n    vertical-align: middle;\n}\n\n.cr-table tbody tr:hover {\n    background: #fafbfe;\n}\n\n.cr-alum {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.cr-avatar {\n    width: 38px;\n    height: 38px;\n    border-radius: 50%;\n    color: var(--cr-navy);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: 600;\n    font-size: 14px;\n    flex-shrink: 0;\n}\n\n.cr-alum-name {\n    font-weight: 600;\n    color: var(--cr-navy);\n    font-size: 13.5px;\n}\n\n.cr-alum-sub {\n    color: var(--cr-muted);\n    font-size: 12px;\n    font-style: italic;\n}\n\n.cr-tags {\n    display: flex;\n    flex-wrap: wrap;\n    max-width: 280px;\n    gap: 4px;\n}\n\n.cr-tag {\n    display: inline-block;\n    padding: 2px 8px;\n    border-radius: 4px;\n    font-size: 11px;\n    font-weight: 600;\n    line-height: 1.5;\n    background: #eef2fb;\n    color: var(--cr-navy);\n    border: 1px solid #d5deef;\n}\n\n.cr-tag-more {\n    position: relative;\n    cursor: help;\n    background: #f3f4f6;\n    color: #374151;\n    border-color: #e5e7eb;\n}\n\n.cr-tag-tip {\n    display: none;\n    position: absolute;\n    z-index: 6;\n    left: 0;\n    top: calc(100% + 6px);\n    width: max-content;\n    max-width: 280px;\n    padding: 8px 10px;\n    border-radius: 6px;\n    background: #1f2937;\n    color: #fff;\n    font-weight: 500;\n    line-height: 1.4;\n    white-space: normal;\n}\n\n.cr-tag-more:hover .cr-tag-tip,\n.cr-tag-more:focus .cr-tag-tip {\n    display: block;\n}\n\n.cr-tag-navy {\n    background: #eef2fb;\n    color: var(--cr-navy);\n}\n\n.cr-tag-custom {\n    background: #f1eafd;\n    color: #6a3fbf;\n    border-color: #d9c8f5;\n    font-size: 9.5px;\n    margin-left: 4px;\n}\n\n.cr-action {\n    background: transparent;\n    border: none;\n    color: var(--cr-muted);\n    font-size: 18px;\n    padding: 2px 6px;\n    cursor: pointer;\n}\n\n.cr-action:hover {\n    color: var(--cr-navy);\n}\n\n.cr-action-wrap {\n    position: relative;\n    display: inline-block;\n}\n\n.cr-action-menu {\n    position: absolute;\n    right: 0;\n    top: calc(100% + 4px);\n    background: #fff;\n    border: 1px solid var(--cr-border);\n    border-radius: 8px;\n    width: 248px;\n    z-index: 40;\n    padding: 6px 0;\n    text-align: left;\n}\n\n.cr-action-sect {\n    padding: 5px 14px 2px;\n    font-size: 10px;\n    color: var(--cr-muted);\n    text-transform: uppercase;\n    letter-spacing: 0.6px;\n    font-weight: 700;\n}\n\n.cr-action-div {\n    border-top: 1px solid var(--cr-border);\n    margin: 5px 0;\n}\n\n.cr-action-item {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    padding: 8px 14px;\n    background: none;\n    border: none;\n    color: var(--cr-text);\n    font-size: 12.5px;\n    text-align: left;\n    cursor: pointer;\n}\n\n.cr-action-item i {\n    color: var(--cr-muted);\n    width: 18px;\n    margin-right: 8px;\n    font-size: 14px;\n}\n\n.cr-action-item:hover {\n    background: #f4f6fb;\n    color: var(--cr-navy);\n}\n\n.cr-action-item:hover i {\n    color: var(--cr-navy);\n}\n\n.cr-rpt-body .table-responsive {\n    overflow: visible;\n}\n\n.cr-soon {\n    text-align: center;\n    padding: 56px 24px;\n    color: var(--cr-muted);\n}\n\n.cr-soon i {\n    font-size: 28px;\n    color: var(--cr-navy);\n    display: block;\n    margin-bottom: 10px;\n}\n\n.cr-soon h3 {\n    color: var(--cr-navy);\n    font-size: 18px;\n    font-weight: 600;\n    margin: 0 0 8px;\n}\n\n.cr-soon p {\n    max-width: 460px;\n    margin: 0 auto 16px;\n    font-size: 13px;\n}\n\n.cr-pill.active {\n    background: #eef2fb;\n    border-color: var(--cr-navy);\n    color: var(--cr-navy);\n}\n\n.cr-badge {\n    background: var(--cr-navy);\n    color: #fff;\n    border-radius: 10px;\n    padding: 0 6px;\n    font-size: 10.5px;\n    margin-left: 2px;\n}\n\n.cr-filter-row-sub {\n    margin-top: 10px;\n}\n\n.cr-tag-gold {\n    background: #fdf6e3;\n    color: #b8860b;\n    border-color: #f2e2b0;\n}\n\n.cr-tag-green {\n    background: #e7f5ec;\n    color: #1e7e34;\n    border-color: #c3e2ce;\n}\n\n.cr-tag-orange {\n    background: #fff1e3;\n    color: #e77817;\n    border-color: #fbd6b0;\n}\n\n.cr-tag-purple {\n    background: #f1eafd;\n    color: #6a3fbf;\n    border-color: #d9c8f5;\n}\n\n.cr-tag-grey {\n    background: #eef0f4;\n    color: #2b3247;\n    border-color: #dde0e8;\n}\n\n.cr-tag-red {\n    background: #fbe9e7;\n    color: #c0392b;\n    border-color: #f2c2bc;\n}\n\n.cr-lapsed {\n    display: inline-block;\n    background: #fbe9e7;\n    color: #c0392b;\n    border: 1px solid #f2c2bc;\n    padding: 1px 6px;\n    border-radius: 3px;\n    font-size: 10px;\n    font-weight: 600;\n    margin-left: 6px;\n    vertical-align: middle;\n}\n\n.cr-prev {\n    color: var(--cr-muted);\n    font-size: 11.5px;\n    font-style: italic;\n    margin-top: 2px;\n}\n\n.cr-blank {\n    color: #c0c4cf;\n    font-size: 14px;\n    padding-left: 6px;\n}\n\n.cr-footnote {\n    padding: 10px 0 4px;\n    margin-top: 8px;\n    background: #fefaf1;\n    border: 1px solid #f2e2b0;\n    border-radius: 6px;\n    font-size: 11.5px;\n    color: #7a5a10;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    padding: 10px 14px;\n}\n\n.cr-pager {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 6px;\n    padding: 14px 0 4px;\n}\n\n.cr-pager span {\n    padding: 5px 10px;\n    border: 1px solid var(--cr-border);\n    border-radius: 4px;\n    color: var(--cr-text);\n    font-size: 12.5px;\n}\n\n.cr-pager span.current {\n    background: var(--cr-navy);\n    color: #fff;\n    border-color: var(--cr-navy);\n    font-weight: 600;\n}\n\n.cr-scroll-status {\n    text-align: center;\n    color: var(--cr-muted);\n    font-size: 12.5px;\n    padding: 8px 0 2px;\n    min-height: 28px;\n}\n\n.cr-campus-search {\n    min-width: 280px;\n    max-width: 420px;\n    flex: 1 1 280px;\n}\n\n.cr-campus-search .cr-campus__container {\n    height: auto !important;\n    border: 0 !important;\n    flex: 1 1 280px !important;\n    min-width: 280px;\n    max-width: 420px;\n}\n\n.cr-campus-search .cr-campus__control {\n    min-height: 36px !important;\n    height: 36px !important;\n    border: 1px solid #98a2b3 !important;\n    border-radius: 6px !important;\n    background: #fff !important;\n    box-shadow: none !important;\n}\n\n.cr-campus-search .cr-campus__control--is-focused {\n    border-color: var(--cr-navy) !important;\n    box-shadow: 0 0 0 3px rgba(26, 39, 68, 0.12) !important;\n}\n\n.cr-campus-search .cr-campus__placeholder,\n.cr-campus-search .cr-campus__single-value {\n    color: #2b3247;\n    font-size: 13px;\n}\n\n.cr-campus-search .cr-campus__placeholder {\n    color: #667085;\n}\n\n.cr-suggest-item {\n    display: block;\n    width: 100%;\n    text-align: left;\n    border: 0;\n    background: transparent;\n    padding: 6px 8px;\n    font-size: 12.5px;\n    font-weight: 500;\n    color: var(--cr-text);\n    cursor: pointer;\n    border-radius: 4px;\n}\n\n.cr-suggest-item:hover {\n    background: #f4f6fb;\n}\n\n.cr-suggest {\n    min-width: 260px;\n}\n\n.cr-status-dot {\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    display: inline-block;\n    margin-right: 6px;\n    vertical-align: middle;\n}\n\n.cr-status-dot.ok {\n    background: var(--cr-green);\n}\n\n.cr-status-dot.warn {\n    background: var(--cr-orange);\n}\n\n.cr-status-dot.err {\n    background: var(--cr-red);\n}\n\n.cr-drawer-backdrop,\n.cr-modal-backdrop {\n    position: fixed;\n    inset: 0;\n    background: rgba(20, 25, 40, 0.35);\n    z-index: 1050;\n}\n\n.cr-modal-backdrop {\n    z-index: 1070;\n}\n\n.cr-drawer {\n    position: fixed;\n    top: 0;\n    right: 0;\n    width: 520px;\n    max-width: 95vw;\n    height: 100vh;\n    background: #fff;\n    box-shadow: -8px 0 24px rgba(0, 0, 0, 0.08);\n    z-index: 1060;\n    display: flex;\n    flex-direction: column;\n}\n\n.cr-drawer-head,\n.cr-modal-head {\n    padding: 16px 20px;\n    border-bottom: 1px solid var(--cr-border);\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 12px;\n}\n\n.cr-drawer-head h5,\n.cr-modal-head h5 {\n    margin: 0;\n    font-size: 17px;\n    font-weight: 600;\n    color: var(--cr-navy);\n}\n\n.cr-drawer-head p {\n    margin: 2px 0 0;\n    font-size: 12px;\n    color: var(--cr-muted);\n}\n\n.cr-drawer-tabs {\n    display: flex;\n    border-bottom: 1px solid var(--cr-border);\n    padding: 0 12px;\n    background: #fafbfe;\n}\n\n.cr-drawer-tabs button {\n    background: none;\n    border: none;\n    padding: 12px 14px;\n    font-size: 13px;\n    font-weight: 600;\n    color: var(--cr-muted);\n    border-bottom: 2px solid transparent;\n}\n\n.cr-drawer-tabs button.active {\n    color: var(--cr-navy);\n    border-bottom-color: var(--cr-navy);\n}\n\n.cr-drawer-body {\n    padding: 16px 20px;\n    overflow-y: auto;\n    flex: 1;\n}\n\n.cr-drawer-foot,\n.cr-modal-foot {\n    padding: 12px 20px;\n    border-top: 1px solid var(--cr-border);\n    background: #fafbfe;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.cr-link {\n    background: none;\n    border: none;\n    color: var(--cr-navy);\n    font-weight: 600;\n    font-size: 13px;\n    padding: 0;\n}\n\n.cr-picker {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 14px;\n}\n\n.cr-picker-col {\n    border: 1px solid var(--cr-border);\n    border-radius: 6px;\n    background: #fff;\n    display: flex;\n    flex-direction: column;\n    min-height: 340px;\n}\n\n.cr-picker-col h6 {\n    margin: 0;\n    padding: 10px 12px;\n    font-size: 12px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    color: var(--cr-muted);\n    border-bottom: 1px solid var(--cr-border);\n    background: #fbfbfd;\n}\n\n.cr-picker-search {\n    padding: 8px 12px;\n    border-bottom: 1px solid var(--cr-border);\n}\n\n.cr-picker-search input {\n    border: 1px solid var(--cr-border);\n    border-radius: 5px;\n    padding: 6px 8px;\n    font-size: 12.5px;\n    width: 100%;\n}\n\n.cr-picker-list {\n    overflow-y: auto;\n    padding: 4px 0;\n    max-height: 360px;\n}\n\n.cr-picker-group {\n    padding: 6px 12px 2px;\n    font-size: 10.5px;\n    color: var(--cr-muted);\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    font-weight: 700;\n}\n\n.cr-picker-item,\nbutton.cr-picker-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 8px 12px;\n    font-size: 12.5px;\n    cursor: pointer;\n    margin: 0 6px;\n    border-radius: 4px;\n}\n\nbutton.cr-picker-item {\n    width: calc(100% - 12px);\n    border: 0;\n    background: transparent;\n    text-align: left;\n    font: inherit;\n    color: inherit;\n}\n\n.cr-picker-item:hover {\n    background: #f2f4f9;\n}\n\n.cr-picker-item i {\n    color: var(--cr-navy);\n}\n\n.cr-chosen {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 8px 10px;\n    font-size: 12.5px;\n    border: 1px solid var(--cr-border);\n    border-radius: 5px;\n    margin: 4px 8px;\n    background: #fff;\n}\n\n.cr-chosen-name {\n    flex: 1;\n    font-weight: 500;\n}\n\n.cr-chosen i {\n    color: var(--cr-muted);\n}\n\n.cr-drawer .cr-pill-switch {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    min-height: auto;\n    padding-left: 2.4em;\n    margin: 0;\n}\n\n.cr-drawer .cr-pill-switch .form-check-input {\n    width: 1.85em;\n    height: 1em;\n    margin-top: 0;\n    margin-left: -2.4em;\n    background-color: #d1d5db;\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\");\n    background-position: left center;\n    border: none;\n    cursor: pointer;\n    flex-shrink: 0;\n    box-shadow: none;\n}\n\n.cr-drawer .cr-pill-switch .form-check-input:checked {\n    background-color: #2f6bff;\n    background-position: right center;\n    border-color: #2f6bff;\n}\n\n.cr-drawer .cr-pill-switch .form-check-input:focus {\n    box-shadow: none;\n    border-color: transparent;\n}\n\n.cr-drawer .cr-pill-switch span {\n    font-size: 10.5px;\n    color: var(--cr-muted);\n    font-weight: 500;\n    flex: none;\n    line-height: 1;\n}\n\n.cr-hint {\n    font-size: 11.5px;\n    color: var(--cr-muted);\n    margin-top: 10px;\n}\n\n.cr-cf-head {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 12px;\n    margin-bottom: 14px;\n}\n\n.cr-cf-title {\n    font-weight: 600;\n    font-size: 14px;\n    color: var(--cr-navy);\n}\n\n.cr-empty {\n    text-align: center;\n    padding: 26px 12px;\n    color: var(--cr-muted);\n    border: 1px dashed var(--cr-border);\n    border-radius: 6px;\n    font-size: 13px;\n}\n\n.cr-empty i {\n    display: block;\n    font-size: 22px;\n    margin-bottom: 8px;\n}\n\n.cr-cf-row {\n    border: 1px solid var(--cr-border);\n    border-radius: 6px;\n    padding: 10px 12px;\n    margin-bottom: 8px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background: #fff;\n}\n\n.cr-cf-name {\n    font-weight: 500;\n}\n\n.cr-type {\n    font-size: 11px;\n    color: var(--cr-muted);\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    background: #eef2fb;\n    padding: 2px 8px;\n    border-radius: 10px;\n    font-weight: 600;\n}\n\n.cr-modal {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 560px;\n    max-width: calc(100vw - 32px);\n    max-height: calc(100vh - 40px);\n    overflow: auto;\n    background: #fff;\n    border-radius: 8px;\n    z-index: 1080;\n    box-shadow: 0 16px 40px rgba(20, 25, 40, 0.18);\n}\n\n.cr-modal-body {\n    padding: 16px 20px;\n}\n\n.cr-label {\n    font-size: 12.5px;\n    font-weight: 600;\n    color: var(--cr-text);\n    margin-bottom: 4px;\n    display: block;\n}\n\n.cr-req {\n    color: var(--cr-red);\n}\n\n.cr-purpose {\n    border: 1px solid var(--cr-border);\n    border-radius: 6px;\n    padding: 12px 14px;\n    margin-bottom: 8px;\n    cursor: pointer;\n    background: #fff;\n    display: flex;\n    gap: 10px;\n    align-items: flex-start;\n}\n\n.cr-purpose:hover {\n    border-color: var(--cr-navy);\n}\n\n.cr-purpose.selected {\n    border-color: var(--cr-navy);\n    background: #eef2fb;\n    box-shadow: inset 3px 0 0 var(--cr-navy);\n}\n\n.cr-purpose input {\n    margin-top: 3px;\n    flex-shrink: 0;\n}\n\n.cr-purpose strong {\n    display: block;\n    color: var(--cr-navy);\n    font-size: 13.5px;\n}\n\n.cr-purpose small {\n    display: block;\n    font-size: 12px;\n    color: var(--cr-muted);\n    margin-top: 2px;\n}\n\n.cr-scores {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 8px;\n    padding: 12px 14px;\n    background: #fafbfe;\n    border: 1px solid var(--cr-border);\n    border-radius: 6px;\n}\n\n.cr-scores label {\n    display: flex;\n    align-items: flex-start;\n    gap: 8px;\n    font-size: 12.5px;\n    cursor: pointer;\n    padding: 6px 8px;\n    border-radius: 4px;\n    margin: 0;\n}\n\n.cr-scores label:hover {\n    background: #eef2fb;\n}\n\n.cr-score-name {\n    font-weight: 500;\n    display: block;\n}\n\n.cr-score-hint {\n    font-size: 10.5px;\n    color: var(--cr-muted);\n    display: block;\n}\n\n.cr-upload-note {\n    margin: 0 0 12px;\n    border: 1px solid #f3d19c;\n    background: #fff8eb;\n    border-radius: 8px;\n    padding: 12px 14px;\n    font-size: 13px;\n    color: var(--cr-text);\n}\n\n.cr-upload-note.ok {\n    border-color: #b7e0c2;\n    background: #f3fbf5;\n}\n\n.cr-upload-note.error {\n    border-color: #f3c1c1;\n    background: #fff5f5;\n}\n\n.cr-upload-note-head {\n    display: flex;\n    justify-content: space-between;\n    gap: 12px;\n    align-items: flex-start;\n}\n\n.cr-upload-note-head button {\n    border: 0;\n    background: transparent;\n    color: var(--cr-navy);\n    font-weight: 600;\n    cursor: pointer;\n    padding: 0;\n}\n\n.cr-upload-note ul {\n    margin: 8px 0 0;\n    padding-left: 18px;\n}\n\n.cr-upload-note li {\n    margin: 4px 0;\n}\n\n.cr-error {\n    color: var(--cr-red);\n    font-size: 11.5px;\n    margin-top: 8px;\n}\n\n.cr-callout {\n    background: #fefaf1;\n    border: 1px solid #f2e2b0;\n    border-left: 3px solid var(--cr-gold);\n    color: #7a5a10;\n    padding: 10px 12px;\n    border-radius: 6px;\n    font-size: 12.5px;\n}\n\n@media (max-width: 900px) {\n    .cr-layout {\n        grid-template-columns: 1fr;\n    }\n\n    .cr-side-nav {\n        position: static;\n        display: flex;\n        overflow-x: auto;\n        padding: 6px;\n    }\n\n    .cr-side-grp {\n        display: none;\n    }\n\n    .cr-side-link {\n        border-left: none;\n        border-bottom: 3px solid transparent;\n        white-space: nowrap;\n    }\n\n    .cr-side-link.active {\n        border-left: none;\n        border-bottom-color: var(--cr-navy);\n    }\n\n    .cr-picker,\n    .cr-scores {\n        grid-template-columns: 1fr;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
